import Vue from 'vue';
import { Checkbox, Popover, Submenu, Alert, CheckboxButton, CheckboxGroup, Collapse, CollapseItem, Dialog, Dropdown, DropdownItem, DropdownMenu, Form, FormItem, Input, Loading, Menu, MenuItem, MenuItemGroup, Option, OptionGroup, Progress, Radio, RadioButton, RadioGroup, Scrollbar, Select, Spinner, Step, Switch, TabPane, Tabs, Table, TableColumn, Tooltip, Upload, Message } from 'element-ui';
import moment from 'moment';
import { debounce as debounce$1, isEqual } from 'lodash';
import 'core-js/modules/es7.symbol.async-iterator';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/es6.object.define-property';
import 'core-js/modules/es6.number.constructor';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode:  'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var _functionToString = _shared('native-function-to-string', Function.toString);

var _redefine = createCommonjsModule(function (module) {
var SRC = _uid('src');

var TO_STRING = 'toString';
var TPL = ('' + _functionToString).split(TO_STRING);

_core.inspectSource = function (it) {
  return _functionToString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === _global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    _hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    _hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || _functionToString.call(this);
});
});

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // extend global
    if (target) _redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) _hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
_global.core = _core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

var en = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      // week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    }
  }
};
});

var lang = unwrapExports(en);

var zhCN = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择'
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择'
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    }
  }
};
});

unwrapExports(zhCN);

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function(key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function(key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument)
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

var util = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;
exports.noop = noop;
exports.hasOwn = hasOwn;
exports.toObject = toObject;
exports.getPropByPath = getPropByPath;



var _vue2 = _interopRequireDefault(Vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasOwnProperty = Object.prototype.hasOwnProperty;

function noop() {}
function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}
function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
}
function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
}
var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  var keyArr = path.split('.');
  var i = 0;
  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
}
var generateId = exports.generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};

var valueEquals = exports.valueEquals = function valueEquals(a, b) {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};

// TODO: use native Array.find, Array.findIndex when IE support is dropped
var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
  for (var i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
  var idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
};

// coerce truthy value to array
var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};

var isIE = exports.isIE = function isIE() {
  return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
};

var isEdge = exports.isEdge = function isEdge() {
  return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
};
});

unwrapExports(util);
var util_1 = util.isEdge;
var util_2 = util.isIE;
var util_3 = util.coerceTruthyValueToArray;
var util_4 = util.arrayFind;
var util_5 = util.arrayFindIndex;
var util_6 = util.escapeRegexpString;
var util_7 = util.valueEquals;
var util_8 = util.generateId;
var util_9 = util.getValueByPath;
var util_10 = util.noop;
var util_11 = util.hasOwn;
var util_12 = util.toObject;
var util_13 = util.getPropByPath;

var format = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (Vue) {

  /**
   * template
   *
   * @param {String} string
   * @param {Array} ...args
   * @return {String}
   */

  function template(string) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length === 1 && _typeof(args[0]) === 'object') {
      args = args[0];
    }

    if (!args || !args.hasOwnProperty) {
      args = {};
    }

    return string.replace(RE_NARGS, function (match, prefix, i, index) {
      var result = void 0;

      if (string[index - 1] === '{' && string[index + match.length] === '}') {
        return i;
      } else {
        result = (0, util.hasOwn)(args, i) ? args[i] : null;
        if (result === null || result === undefined) {
          return '';
        }

        return result;
      }
    });
  }

  return template;
};



var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
/**
 *  String format template
 *  - Inspired:
 *    https://github.com/Matt-Esch/string-template/index.js
 */
});

unwrapExports(format);

var locale = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.i18n = exports.use = exports.t = undefined;



var _zhCN2 = _interopRequireDefault(zhCN);



var _vue2 = _interopRequireDefault(Vue);



var _deepmerge2 = _interopRequireDefault(cjs);



var _format2 = _interopRequireDefault(format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var format$1 = (0, _format2.default)(_vue2.default);
var lang = _zhCN2.default;
var merged = false;
var i18nHandler = function i18nHandler() {
  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
  if (typeof vuei18n === 'function' && !!_vue2.default.locale) {
    if (!merged) {
      merged = true;
      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
    }
    return vuei18n.apply(this, arguments);
  }
};

var t = exports.t = function t(path, options) {
  var value = i18nHandler.apply(this, arguments);
  if (value !== null && value !== undefined) return value;

  var array = path.split('.');
  var current = lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value = current[property];
    if (i === j - 1) return format$1(value, options);
    if (!value) return '';
    current = value;
  }
  return '';
};

var use = exports.use = function use(l) {
  lang = l || lang;
};

var i18n = exports.i18n = function i18n(fn) {
  i18nHandler = fn || i18nHandler;
};

exports.default = { use: use, t: t, i18n: i18n };
});

var locale$1 = unwrapExports(locale);
var locale_1 = locale.i18n;
var locale_2 = locale.use;
var locale_3 = locale.t;

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrastundefined.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrastundefined.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

var vuePopper_min = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t(Popper);}(commonjsGlobal,function(e){function t(e,t,o){e&&t&&o&&(document.addEventListener?e.addEventListener(t,o,!1):e.attachEvent("on"+t,o));}function o(e,t,o){e&&t&&(document.removeEventListener?e.removeEventListener(t,o,!1):e.detachEvent("on"+t,o));}e=e&&e.hasOwnProperty("default")?e.default:e;var n={props:{tagName:{type:String,default:"span"},trigger:{type:String,default:"hover",validator:function(e){return ["clickToOpen","click","clickToToggle","hover","focus"].indexOf(e)>-1}},delayOnMouseOver:{type:Number,default:10},delayOnMouseOut:{type:Number,default:10},disabled:{type:Boolean,default:!1},content:String,enterActiveClass:String,leaveActiveClass:String,boundariesSelector:String,reference:{},forceShow:{type:Boolean,default:!1},dataValue:{default:null},appendToBody:{type:Boolean,default:!1},visibleArrow:{type:Boolean,default:!0},transition:{type:String,default:""},stopPropagation:{type:Boolean,default:!1},preventDefault:{type:Boolean,default:!1},options:{type:Object,default:function(){return {}}},rootClass:{type:String,default:""}},data:function(){return {referenceElm:null,popperJS:null,showPopper:!1,currentPlacement:"",popperOptions:{placement:"bottom",computeStyle:{gpuAcceleration:!1}}}},watch:{showPopper:function(e){e?(this.$emit("show",this),this.popperJS&&this.popperJS.enableEventListeners(),this.updatePopper()):(this.popperJS&&this.popperJS.disableEventListeners(),this.$emit("hide",this));},forceShow:{handler:function(e){this[e?"doShow":"doClose"]();},immediate:!0},disabled:function(e){e&&(this.showPopper=!1);}},created:function(){this.appendedArrow=!1,this.appendedToBody=!1,this.popperOptions=Object.assign(this.popperOptions,this.options);},mounted:function(){switch(this.referenceElm=this.reference||this.$slots.reference[0].elm,this.popper=this.$slots.default[0].elm,this.trigger){case"clickToOpen":t(this.referenceElm,"click",this.doShow),t(document,"click",this.handleDocumentClick);break;case"click":case"clickToToggle":t(this.referenceElm,"click",this.doToggle),t(document,"click",this.handleDocumentClick);break;case"hover":t(this.referenceElm,"mouseover",this.onMouseOver),t(this.popper,"mouseover",this.onMouseOver),t(this.referenceElm,"mouseout",this.onMouseOut),t(this.popper,"mouseout",this.onMouseOut);break;case"focus":t(this.referenceElm,"focus",this.onMouseOver),t(this.popper,"focus",this.onMouseOver),t(this.referenceElm,"blur",this.onMouseOut),t(this.popper,"blur",this.onMouseOut);}},methods:{doToggle:function(e){this.stopPropagation&&e.stopPropagation(),this.preventDefault&&e.preventDefault(),this.forceShow||(this.showPopper=!this.showPopper);},doShow:function(){this.showPopper=!0;},doClose:function(){this.showPopper=!1;},doDestroy:function(){this.showPopper||(this.popperJS&&(this.popperJS.destroy(),this.popperJS=null),this.appendedToBody&&(this.appendedToBody=!1,document.body.removeChild(this.popper.parentElement)));},createPopper:function(){var t=this;this.$nextTick(function(){if(t.visibleArrow&&t.appendArrow(t.popper),t.appendToBody&&!t.appendedToBody&&(t.appendedToBody=!0,document.body.appendChild(t.popper.parentElement)),t.popperJS&&t.popperJS.destroy&&t.popperJS.destroy(),t.boundariesSelector){var o=document.querySelector(t.boundariesSelector);o&&(t.popperOptions.modifiers=Object.assign({},t.popperOptions.modifiers),t.popperOptions.modifiers.preventOverflow=Object.assign({},t.popperOptions.modifiers.preventOverflow),t.popperOptions.modifiers.preventOverflow.boundariesElement=o);}t.popperOptions.onCreate=function(){t.$emit("created",t),t.$nextTick(t.updatePopper);},t.popperJS=new e(t.referenceElm,t.popper,t.popperOptions);});},destroyPopper:function(){o(this.referenceElm,"click",this.doToggle),o(this.referenceElm,"mouseup",this.doClose),o(this.referenceElm,"mousedown",this.doShow),o(this.referenceElm,"focus",this.doShow),o(this.referenceElm,"blur",this.doClose),o(this.referenceElm,"mouseout",this.onMouseOut),o(this.referenceElm,"mouseover",this.onMouseOver),o(document,"click",this.handleDocumentClick),this.showPopper=!1,this.doDestroy();},appendArrow:function(e){if(!this.appendedArrow){this.appendedArrow=!0;var t=document.createElement("div");t.setAttribute("x-arrow",""),t.className="popper__arrow",e.appendChild(t);}},updatePopper:function(){this.popperJS?this.popperJS.scheduleUpdate():this.createPopper();},onMouseOver:function(){var e=this;clearTimeout(this._timer),this._timer=setTimeout(function(){e.showPopper=!0;},this.delayOnMouseOver);},onMouseOut:function(){var e=this;clearTimeout(this._timer),this._timer=setTimeout(function(){e.showPopper=!1;},this.delayOnMouseOut);},handleDocumentClick:function(e){this.$el&&this.referenceElm&&!this.elementContains(this.$el,e.target)&&!this.elementContains(this.referenceElm,e.target)&&this.popper&&!this.elementContains(this.popper,e.target)&&(this.$emit("documentClick",this),this.forceShow||(this.showPopper=!1));},elementContains:function(e,t){return "function"==typeof e.contains&&e.contains(t)}},destroyed:function(){this.destroyPopper();}};const r=n;n.__file="popper.js.vue";return function(e,t,o,n,r,s,i,p,c,a){"function"==typeof i&&(c=p,p=i,i=!1);const d="function"==typeof o?o.options:o;let l;if(e&&e.render&&(d.render=e.render,d.staticRenderFns=e.staticRenderFns,d._compiled=!0,r&&(d.functional=!0)),n&&(d._scopeId=n),s?(l=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),t&&t.call(this,c(e)),e&&e._registeredComponents&&e._registeredComponents.add(s);},d._ssrRegister=l):t&&(l=i?function(){t.call(this,a(this.$root.$options.shadowRoot));}:function(e){t.call(this,p(e));}),l)if(d.functional){const e=d.render;d.render=function(t,o){return l.call(o),e(t,o)};}else{const e=d.beforeCreate;d.beforeCreate=e?[].concat(e,l):[l];}return o}({render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o(e.tagName,{tag:"component"},[o("transition",{attrs:{name:e.transition,"enter-active-class":e.enterActiveClass,"leave-active-class":e.leaveActiveClass},on:{"after-leave":e.doDestroy}},[o("span",{directives:[{name:"show",rawName:"v-show",value:!e.disabled&&e.showPopper,expression:"!disabled && showPopper"}],ref:"popper",class:e.rootClass},[e._t("default",[e._v(e._s(e.content))])],2)]),e._v(" "),e._t("reference")],2)},staticRenderFns:[]},void 0,r,void 0,!1,void 0,void 0,void 0)});
});

/*!
 * vuejs-datepicker v1.5.3
 * (c) 2016-2018 Charlie Kassel
 * Released under the MIT License.
 */
var Language = function Language (language, months, monthsAbbr, days) {
  this.language = language;
  this.months = months;
  this.monthsAbbr = monthsAbbr;
  this.days = days;
  this.rtl = false;
  this.ymd = false;
  this.yearSuffix = '';
};

var prototypeAccessors = { language: { configurable: true },months: { configurable: true },monthsAbbr: { configurable: true },days: { configurable: true } };

prototypeAccessors.language.get = function () {
  return this._language
};

prototypeAccessors.language.set = function (language) {
  if (typeof language !== 'string') {
    throw new TypeError('Language must be a string')
  }
  this._language = language;
};

prototypeAccessors.months.get = function () {
  return this._months
};

prototypeAccessors.months.set = function (months) {
  if (months.length !== 12) {
    throw new RangeError(("There must be 12 months for " + (this.language) + " language"))
  }
  this._months = months;
};

prototypeAccessors.monthsAbbr.get = function () {
  return this._monthsAbbr
};

prototypeAccessors.monthsAbbr.set = function (monthsAbbr) {
  if (monthsAbbr.length !== 12) {
    throw new RangeError(("There must be 12 abbreviated months for " + (this.language) + " language"))
  }
  this._monthsAbbr = monthsAbbr;
};

prototypeAccessors.days.get = function () {
  return this._days
};

prototypeAccessors.days.set = function (days) {
  if (days.length !== 7) {
    throw new RangeError(("There must be 7 days for " + (this.language) + " language"))
  }
  this._days = days;
};

Object.defineProperties( Language.prototype, prototypeAccessors );

var en$1 = new Language(
  'English',
  ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
)
// eslint-disable-next-line
;

var utils = {
  /**
   * @type {Boolean}
   */
  useUtc: false,
  /**
   * Returns the full year, using UTC or not
   * @param {Date} date
   */
  getFullYear: function getFullYear (date) {
    return this.useUtc ? date.getUTCFullYear() : date.getFullYear()
  },

  /**
   * Returns the month, using UTC or not
   * @param {Date} date
   */
  getMonth: function getMonth (date) {
    return this.useUtc ? date.getUTCMonth() : date.getMonth()
  },

  /**
   * Returns the date, using UTC or not
   * @param {Date} date
   */
  getDate: function getDate (date) {
    return this.useUtc ? date.getUTCDate() : date.getDate()
  },

  /**
   * Returns the day, using UTC or not
   * @param {Date} date
   */
  getDay: function getDay (date) {
    return this.useUtc ? date.getUTCDay() : date.getDay()
  },

  /**
   * Returns the hours, using UTC or not
   * @param {Date} date
   */
  getHours: function getHours (date) {
    return this.useUtc ? date.getUTCHours() : date.getHours()
  },

  /**
   * Returns the minutes, using UTC or not
   * @param {Date} date
   */
  getMinutes: function getMinutes (date) {
    return this.useUtc ? date.getUTCMinutes() : date.getMinutes()
  },

  /**
   * Sets the full year, using UTC or not
   * @param {Date} date
   */
  setFullYear: function setFullYear (date, value, useUtc) {
    return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value)
  },

  /**
   * Sets the month, using UTC or not
   * @param {Date} date
   */
  setMonth: function setMonth (date, value, useUtc) {
    return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value)
  },

  /**
   * Sets the date, using UTC or not
   * @param {Date} date
   * @param {Number} value
   */
  setDate: function setDate (date, value, useUtc) {
    return this.useUtc ? date.setUTCDate(value) : date.setDate(value)
  },

  /**
   * Check if date1 is equivalent to date2, without comparing the time
   * @see https://stackoverflow.com/a/6202196/4455925
   * @param {Date} date1
   * @param {Date} date2
   */
  compareDates: function compareDates (date1, date2) {
    var d1 = new Date(date1.getTime());
    var d2 = new Date(date2.getTime());

    if (this.useUtc) {
      d1.setUTCHours(0, 0, 0, 0);
      d2.setUTCHours(0, 0, 0, 0);
    } else {
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);
    }
    return d1.getTime() === d2.getTime()
  },

  /**
   * Validates a date object
   * @param {Date} date - an object instantiated with the new Date constructor
   * @return {Boolean}
   */
  isValidDate: function isValidDate (date) {
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      return false
    }
    return !isNaN(date.getTime())
  },

  /**
   * Return abbreviated week day name
   * @param {Date}
   * @param {Array}
   * @return {String}
   */
  getDayNameAbbr: function getDayNameAbbr (date, days) {
    if (typeof date !== 'object') {
      throw TypeError('Invalid Type')
    }
    return days[this.getDay(date)]
  },

  /**
   * Return name of the month
   * @param {Number|Date}
   * @param {Array}
   * @return {String}
   */
  getMonthName: function getMonthName (month, months) {
    if (!months) {
      throw Error('missing 2nd parameter Months array')
    }
    if (typeof month === 'object') {
      return months[this.getMonth(month)]
    }
    if (typeof month === 'number') {
      return months[month]
    }
    throw TypeError('Invalid type')
  },

  /**
   * Return an abbreviated version of the month
   * @param {Number|Date}
   * @return {String}
   */
  getMonthNameAbbr: function getMonthNameAbbr (month, monthsAbbr) {
    if (!monthsAbbr) {
      throw Error('missing 2nd paramter Months array')
    }
    if (typeof month === 'object') {
      return monthsAbbr[this.getMonth(month)]
    }
    if (typeof month === 'number') {
      return monthsAbbr[month]
    }
    throw TypeError('Invalid type')
  },

  /**
   * Alternative get total number of days in month
   * @param {Number} year
   * @param {Number} m
   * @return {Number}
   */
  daysInMonth: function daysInMonth (year, month) {
    return /8|3|5|10/.test(month) ? 30 : month === 1 ? (!(year % 4) && year % 100) || !(year % 400) ? 29 : 28 : 31
  },

  /**
   * Get nth suffix for date
   * @param {Number} day
   * @return {String}
   */
  getNthSuffix: function getNthSuffix (day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st'
      case 2:
      case 22:
        return 'nd'
      case 3:
      case 23:
        return 'rd'
      default:
        return 'th'
    }
  },

  /**
   * Formats date object
   * @param {Date}
   * @param {String}
   * @param {Object}
   * @return {String}
   */
  formatDate: function formatDate (date, format, translation) {
    translation = (!translation) ? en$1 : translation;
    var year = this.getFullYear(date);
    var month = this.getMonth(date) + 1;
    var day = this.getDate(date);
    var str = format
      .replace(/dd/, ('0' + day).slice(-2))
      .replace(/d/, day)
      .replace(/yyyy/, year)
      .replace(/yy/, String(year).slice(2))
      .replace(/MMMM/, this.getMonthName(this.getMonth(date), translation.months))
      .replace(/MMM/, this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr))
      .replace(/MM/, ('0' + month).slice(-2))
      .replace(/M(?!a|ä|e)/, month)
      .replace(/su/, this.getNthSuffix(this.getDate(date)))
      .replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
    return str
  },

  /**
   * Creates an array of dates for each day in between two dates.
   * @param {Date} start
   * @param {Date} end
   * @return {Array}
   */
  createDateArray: function createDateArray (start, end) {
    var this$1 = this;

    var dates = [];
    while (start <= end) {
      dates.push(new Date(start));
      start = this$1.setDate(new Date(start), this$1.getDate(new Date(start)) + 1);
    }
    return dates
  }
};

var makeDateUtils = function (useUtc) { return (Object.assign({}, utils, {useUtc: useUtc})); };

Object.assign({}, utils)
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var DateInput = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'input-group' : _vm.bootstrapStyling}},[(_vm.calendarButton)?_c('span',{staticClass:"vdp-datepicker__calendar-button",class:{'input-group-prepend' : _vm.bootstrapStyling},style:({'cursor:not-allowed;' : _vm.disabled}),on:{"click":_vm.showCalendar}},[_c('span',{class:{'input-group-text' : _vm.bootstrapStyling}},[_c('i',{class:_vm.calendarButtonIcon},[_vm._v(" "+_vm._s(_vm.calendarButtonIconContent)+" "),(!_vm.calendarButtonIcon)?_c('span',[_vm._v("…")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('input',{ref:_vm.refName,class:_vm.computedInputClass,attrs:{"type":_vm.inline ? 'hidden' : 'text',"name":_vm.name,"id":_vm.id,"open-date":_vm.openDate,"placeholder":_vm.placeholder,"clear-button":_vm.clearButton,"disabled":_vm.disabled,"required":_vm.required,"readonly":!_vm.typeable,"autocomplete":"off"},domProps:{"value":_vm.formattedValue},on:{"click":_vm.showCalendar,"keyup":_vm.parseTypedDate,"blur":_vm.inputBlurred}}),_vm._v(" "),(_vm.clearButton && _vm.selectedDate)?_c('span',{staticClass:"vdp-datepicker__clear-button",class:{'input-group-append' : _vm.bootstrapStyling},on:{"click":function($event){_vm.clearDate();}}},[_c('span',{class:{'input-group-text' : _vm.bootstrapStyling}},[_c('i',{class:_vm.clearButtonIcon},[(!_vm.clearButtonIcon)?_c('span',[_vm._v("×")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_vm._t("afterDateInput")],2)},staticRenderFns: [],
  props: {
    selectedDate: Date,
    resetTypedDate: [Date],
    format: [String, Function],
    translation: Object,
    inline: Boolean,
    id: String,
    name: String,
    refName: String,
    openDate: Date,
    placeholder: String,
    inputClass: [String, Object, Array],
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    bootstrapStyling: Boolean,
    useUtc: Boolean
  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      input: null,
      typedDate: false,
      utils: constructedDateUtils
    }
  },
  computed: {
    formattedValue: function formattedValue () {
      if (!this.selectedDate) {
        return null
      }
      if (this.typedDate) {
        return this.typedDate
      }
      return typeof this.format === 'function'
        ? this.format(this.selectedDate)
        : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation)
    },

    computedInputClass: function computedInputClass () {
      if (this.bootstrapStyling) {
        if (typeof this.inputClass === 'string') {
          return [this.inputClass, 'form-control'].join(' ')
        }
        return Object.assign({}, {'form-control': true}, this.inputClass)
      }
      return this.inputClass
    }
  },
  watch: {
    resetTypedDate: function resetTypedDate () {
      this.typedDate = false;
    }
  },
  methods: {
    showCalendar: function showCalendar () {
      this.$emit('showCalendar');
    },
    /**
     * Attempt to parse a typed date
     * @param {Event} event
     */
    parseTypedDate: function parseTypedDate (event) {
      // close calendar if escape or enter are pressed
      if ([
        27, // escape
        13 // enter
      ].includes(event.keyCode)) {
        this.input.blur();
      }

      if (this.typeable) {
        var typedDate = Date.parse(this.input.value);
        if (!isNaN(typedDate)) {
          this.typedDate = this.input.value;
          this.$emit('typedDate', new Date(this.typedDate));
        }
      }
    },
    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred: function inputBlurred () {
      if (this.typeable && isNaN(Date.parse(this.input.value))) {
        this.clearDate();
        this.input.value = null;
        this.typedDate = null;
      }

      this.$emit('closeCalendar');
    },
    /**
     * emit a clearDate event
     */
    clearDate: function clearDate () {
      this.$emit('clearDate');
    }
  },
  mounted: function mounted () {
    this.input = this.$el.querySelector('input');
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var PickerDay = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDayView),expression:"showDayView"}],class:[_vm.calendarClass, 'vdp-datepicker__calendar'],style:(_vm.calendarStyle),on:{"mousedown":function($event){$event.preventDefault();}}},[_vm._t("beforeCalendarHeader"),_vm._v(" "),_c('header',[_c('span',{staticClass:"prev",class:{'disabled': _vm.isLeftNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.nextMonth() : _vm.previousMonth();}}},[_vm._v("<")]),_vm._v(" "),_c('span',{staticClass:"day__month_btn",class:_vm.allowedToShowView('month') ? 'up' : '',on:{"click":_vm.showMonthCalendar}},[_vm._v(_vm._s(_vm.isYmd ? _vm.currYearName : _vm.currMonthName)+" "+_vm._s(_vm.isYmd ? _vm.currMonthName : _vm.currYearName))]),_vm._v(" "),_c('span',{staticClass:"next",class:{'disabled': _vm.isRightNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.previousMonth() : _vm.nextMonth();}}},[_vm._v(">")])]),_vm._v(" "),_c('div',{class:_vm.isRtl ? 'flex-rtl' : ''},[_vm._l((_vm.daysOfWeek),function(d){return _c('span',{key:d.timestamp,staticClass:"cell day-header"},[_vm._v(_vm._s(d))])}),_vm._v(" "),(_vm.blankDays > 0)?_vm._l((_vm.blankDays),function(d){return _c('span',{key:d.timestamp,staticClass:"cell day blank"})}):_vm._e(),_vm._l((_vm.days),function(day){return _c('span',{key:day.timestamp,staticClass:"cell day",class:_vm.dayClasses(day),domProps:{"innerHTML":_vm._s(_vm.dayCellContent(day))},on:{"click":function($event){_vm.selectDate(day);}}})})],2)],2)},staticRenderFns: [],
  props: {
    showDayView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    fullMonthName: Boolean,
    allowedToShowView: Function,
    dayCellContent: {
      type: Function,
      default: function (day) { return day.date; }
    },
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    mondayFirst: Boolean,
    useUtc: Boolean
  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    }
  },
  computed: {
    /**
     * Returns an array of day names
     * @return {String[]}
     */
    daysOfWeek: function daysOfWeek () {
      if (this.mondayFirst) {
        var tempDays = this.translation.days.slice();
        tempDays.push(tempDays.shift());
        return tempDays
      }
      return this.translation.days
    },
    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays: function blankDays () {
      var d = this.pageDate;
      var dObj = this.useUtc
        ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1))
        : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      if (this.mondayFirst) {
        return this.utils.getDay(dObj) > 0 ? this.utils.getDay(dObj) - 1 : 6
      }
      return this.utils.getDay(dObj)
    },
    /**
     * @return {Object[]}
     */
    days: function days () {
      var this$1 = this;

      var d = this.pageDate;
      var days = [];
      // set up a new date object to the beginning of the current 'page'
      var dObj = this.useUtc
        ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1))
        : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      var daysInMonth = this.utils.daysInMonth(this.utils.getFullYear(dObj), this.utils.getMonth(dObj));
      for (var i = 0; i < daysInMonth; i++) {
        days.push({
          date: this$1.utils.getDate(dObj),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedDate(dObj),
          isDisabled: this$1.isDisabledDate(dObj),
          isHighlighted: this$1.isHighlightedDate(dObj),
          isHighlightStart: this$1.isHighlightStart(dObj),
          isHighlightEnd: this$1.isHighlightEnd(dObj),
          isToday: this$1.utils.compareDates(dObj, new Date()),
          isWeekend: this$1.utils.getDay(dObj) === 0 || this$1.utils.getDay(dObj) === 6,
          isSaturday: this$1.utils.getDay(dObj) === 6,
          isSunday: this$1.utils.getDay(dObj) === 0
        });
        this$1.utils.setDate(dObj, this$1.utils.getDate(dObj) + 1);
      }
      return days
    },
    /**
     * Gets the name of the month the current page is on
     * @return {String}
     */
    currMonthName: function currMonthName () {
      var monthName = this.fullMonthName ? this.translation.months : this.translation.monthsAbbr;
      return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate), monthName)
    },
    /**
     * Gets the name of the year that current page is on
     * @return {Number}
     */
    currYearName: function currYearName () {
      var yearSuffix = this.translation.yearSuffix;
      return ("" + (this.utils.getFullYear(this.pageDate)) + yearSuffix)
    },
    /**
     * Is this translation using year/month/day format?
     * @return {Boolean}
     */
    isYmd: function isYmd () {
      return this.translation.ymd && this.translation.ymd === true
    },
    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled () {
      return this.isRtl
        ? this.isNextMonthDisabled(this.pageTimestamp)
        : this.isPreviousMonthDisabled(this.pageTimestamp)
    },
    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled () {
      return this.isRtl
        ? this.isPreviousMonthDisabled(this.pageTimestamp)
        : this.isNextMonthDisabled(this.pageTimestamp)
    }
  },
  methods: {
    selectDate: function selectDate (date) {
      if (date.isDisabled) {
        this.$emit('selectedDisabled', date);
        return false
      }
      this.$emit('selectDate', date);
    },
    /**
     * @return {Number}
     */
    getPageMonth: function getPageMonth () {
      return this.utils.getMonth(this.pageDate)
    },
    /**
     * Emit an event to show the month picker
     */
    showMonthCalendar: function showMonthCalendar () {
      this.$emit('showMonthCalendar');
    },
    /**
     * Change the page month
     * @param {Number} incrementBy
     */
    changeMonth: function changeMonth (incrementBy) {
      var date = this.pageDate;
      this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
      this.$emit('changedMonth', date);
    },
    /**
     * Decrement the page month
     */
    previousMonth: function previousMonth () {
      if (!this.isPreviousMonthDisabled()) {
        this.changeMonth(-1);
      }
    },
    /**
     * Is the previous month disabled?
     * @return {Boolean}
     */
    isPreviousMonthDisabled: function isPreviousMonthDisabled () {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false
      }
      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.to) >= this.utils.getMonth(d) &&
        this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(d)
    },
    /**
     * Increment the current page month
     */
    nextMonth: function nextMonth () {
      if (!this.isNextMonthDisabled()) {
        this.changeMonth(+1);
      }
    },
    /**
     * Is the next month disabled?
     * @return {Boolean}
     */
    isNextMonthDisabled: function isNextMonthDisabled () {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false
      }
      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.from) <= this.utils.getMonth(d) &&
        this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(d)
    },
    /**
     * Whether a day is selected
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedDate: function isSelectedDate (dObj) {
      return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj)
    },
    /**
     * Whether a day is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledDate: function isDisabledDate (date) {
      var this$1 = this;

      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false
      }

      if (typeof this.disabledDates.dates !== 'undefined') {
        this.disabledDates.dates.forEach(function (d) {
          if (this$1.utils.compareDates(date, d)) {
            disabledDates = true;
            return true
          }
        });
      }
      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to && date < this.disabledDates.to) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from && date > this.disabledDates.from) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.ranges !== 'undefined') {
        this.disabledDates.ranges.forEach(function (range) {
          if (typeof range.from !== 'undefined' && range.from && typeof range.to !== 'undefined' && range.to) {
            if (date < range.to && date > range.from) {
              disabledDates = true;
              return true
            }
          }
        });
      }
      if (typeof this.disabledDates.days !== 'undefined' && this.disabledDates.days.indexOf(this.utils.getDay(date)) !== -1) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.daysOfMonth !== 'undefined' && this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }
      return disabledDates
    },
    /**
     * Whether a day is highlighted (only if it is not disabled already except when highlighted.includeDisabled is true)
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightedDate: function isHighlightedDate (date) {
      var this$1 = this;

      if (!(this.highlighted && this.highlighted.includeDisabled) && this.isDisabledDate(date)) {
        return false
      }

      var highlighted = false;

      if (typeof this.highlighted === 'undefined') {
        return false
      }

      if (typeof this.highlighted.dates !== 'undefined') {
        this.highlighted.dates.forEach(function (d) {
          if (this$1.utils.compareDates(date, d)) {
            highlighted = true;
            return true
          }
        });
      }

      if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
        highlighted = date >= this.highlighted.from && date <= this.highlighted.to;
      }

      if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(this.utils.getDay(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.daysOfMonth !== 'undefined' && this.highlighted.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.customPredictor === 'function' && this.highlighted.customPredictor(date)) {
        highlighted = true;
      }

      return highlighted
    },
    dayClasses: function dayClasses (day) {
      return {
        'selected': day.isSelected,
        'disabled': day.isDisabled,
        'highlighted': day.isHighlighted,
        'today': day.isToday,
        'weekend': day.isWeekend,
        'sat': day.isSaturday,
        'sun': day.isSunday,
        'highlight-start': day.isHighlightStart,
        'highlight-end': day.isHighlightEnd
      }
    },
    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightStart: function isHighlightStart (date) {
      return this.isHighlightedDate(date) &&
        (this.highlighted.from instanceof Date) &&
        (this.utils.getFullYear(this.highlighted.from) === this.utils.getFullYear(date)) &&
        (this.utils.getMonth(this.highlighted.from) === this.utils.getMonth(date)) &&
        (this.utils.getDate(this.highlighted.from) === this.utils.getDate(date))
    },
    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightEnd: function isHighlightEnd (date) {
      return this.isHighlightedDate(date) &&
        (this.highlighted.to instanceof Date) &&
        (this.utils.getFullYear(this.highlighted.to) === this.utils.getFullYear(date)) &&
        (this.utils.getMonth(this.highlighted.to) === this.utils.getMonth(date)) &&
        (this.utils.getDate(this.highlighted.to) === this.utils.getDate(date))
    },
    /**
     * Helper
     * @param  {mixed}  prop
     * @return {Boolean}
     */
    isDefined: function isDefined (prop) {
      return typeof prop !== 'undefined' && prop
    }
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var PickerMonth = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMonthView),expression:"showMonthView"}],class:[_vm.calendarClass, 'vdp-datepicker__calendar'],style:(_vm.calendarStyle),on:{"mousedown":function($event){$event.preventDefault();}}},[_vm._t("beforeCalendarHeader"),_vm._v(" "),_c('header',[_c('span',{staticClass:"prev",class:{'disabled': _vm.isLeftNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.nextYear() : _vm.previousYear();}}},[_vm._v("<")]),_vm._v(" "),_c('span',{staticClass:"month__year_btn",class:_vm.allowedToShowView('year') ? 'up' : '',on:{"click":_vm.showYearCalendar}},[_vm._v(_vm._s(_vm.pageYearName))]),_vm._v(" "),_c('span',{staticClass:"next",class:{'disabled': _vm.isRightNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.previousYear() : _vm.nextYear();}}},[_vm._v(">")])]),_vm._v(" "),_vm._l((_vm.months),function(month){return _c('span',{key:month.timestamp,staticClass:"cell month",class:{'selected': month.isSelected, 'disabled': month.isDisabled},on:{"click":function($event){$event.stopPropagation();_vm.selectMonth(month);}}},[_vm._v(_vm._s(month.month))])})],2)},staticRenderFns: [],
  props: {
    showMonthView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    }
  },
  computed: {
    months: function months () {
      var this$1 = this;

      var d = this.pageDate;
      var months = [];
      // set up a new date object to the beginning of the current 'page'
      var dObj = this.useUtc
        ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate()))
        : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 12; i++) {
        months.push({
          month: this$1.utils.getMonthName(i, this$1.translation.months),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedMonth(dObj),
          isDisabled: this$1.isDisabledMonth(dObj)
        });
        this$1.utils.setMonth(dObj, this$1.utils.getMonth(dObj) + 1);
      }
      return months
    },
    /**
     * Get year name on current page.
     * @return {String}
     */
    pageYearName: function pageYearName () {
      var yearSuffix = this.translation.yearSuffix;
      return ("" + (this.utils.getFullYear(this.pageDate)) + yearSuffix)
    },
    /**
     * Is the left hand navigation disabled
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled () {
      return this.isRtl
        ? this.isNextYearDisabled(this.pageTimestamp)
        : this.isPreviousYearDisabled(this.pageTimestamp)
    },
    /**
     * Is the right hand navigation disabled
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled () {
      return this.isRtl
        ? this.isPreviousYearDisabled(this.pageTimestamp)
        : this.isNextYearDisabled(this.pageTimestamp)
    }
  },
  methods: {
    /**
     * Emits a selectMonth event
     * @param {Object} month
     */
    selectMonth: function selectMonth (month) {
      if (month.isDisabled) {
        return false
      }
      this.$emit('selectMonth', month);
    },
    /**
     * Changes the year up or down
     * @param {Number} incrementBy
     */
    changeYear: function changeYear (incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedYear', date);
    },
    /**
     * Decrements the year
     */
    previousYear: function previousYear () {
      if (!this.isPreviousYearDisabled()) {
        this.changeYear(-1);
      }
    },
    /**
     * Checks if the previous year is disabled or not
     * @return {Boolean}
     */
    isPreviousYearDisabled: function isPreviousYearDisabled () {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false
      }
      return this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(this.pageDate)
    },
    /**
     * Increments the year
     */
    nextYear: function nextYear () {
      if (!this.isNextYearDisabled()) {
        this.changeYear(1);
      }
    },
    /**
     * Checks if the next year is disabled or not
     * @return {Boolean}
     */
    isNextYearDisabled: function isNextYearDisabled () {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false
      }
      return this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(this.pageDate)
    },
    /**
     * Emits an event that shows the year calendar
     */
    showYearCalendar: function showYearCalendar () {
      this.$emit('showYearCalendar');
    },
    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth: function isSelectedMonth (date) {
      return (this.selectedDate &&
        this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date) &&
        this.utils.getMonth(this.selectedDate) === this.utils.getMonth(date))
    },
    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth: function isDisabledMonth (date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (
          (this.utils.getMonth(date) < this.utils.getMonth(this.disabledDates.to) && this.utils.getFullYear(date) <= this.utils.getFullYear(this.disabledDates.to)) ||
          this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)
        ) {
          disabledDates = true;
        }
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (
          (this.utils.getMonth(date) > this.utils.getMonth(this.disabledDates.from) && this.utils.getFullYear(date) >= this.utils.getFullYear(this.disabledDates.from)) ||
          this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)
        ) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }
      return disabledDates
    }
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var PickerYear = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showYearView),expression:"showYearView"}],class:[_vm.calendarClass, 'vdp-datepicker__calendar'],style:(_vm.calendarStyle),on:{"mousedown":function($event){$event.preventDefault();}}},[_vm._t("beforeCalendarHeader"),_vm._v(" "),_c('header',[_c('span',{staticClass:"prev",class:{'disabled': _vm.isLeftNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.nextDecade() : _vm.previousDecade();}}},[_vm._v("<")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getPageDecade))]),_vm._v(" "),_c('span',{staticClass:"next",class:{'disabled': _vm.isRightNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.previousDecade() : _vm.nextDecade();}}},[_vm._v(">")])]),_vm._v(" "),_vm._l((_vm.years),function(year){return _c('span',{key:year.timestamp,staticClass:"cell year",class:{ 'selected': year.isSelected, 'disabled': year.isDisabled },on:{"click":function($event){$event.stopPropagation();_vm.selectYear(year);}}},[_vm._v(_vm._s(year.year))])})],2)},staticRenderFns: [],
  props: {
    showYearView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  computed: {
    years: function years () {
      var this$1 = this;

      var d = this.pageDate;
      var years = [];
      // set up a new date object to the beginning of the current 'page'7
      var dObj = this.useUtc
        ? new Date(Date.UTC(Math.floor(d.getUTCFullYear() / 10) * 10, d.getUTCMonth(), d.getUTCDate()))
        : new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 10; i++) {
        years.push({
          year: this$1.utils.getFullYear(dObj),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedYear(dObj),
          isDisabled: this$1.isDisabledYear(dObj)
        });
        this$1.utils.setFullYear(dObj, this$1.utils.getFullYear(dObj) + 1);
      }
      return years
    },
    /**
     * @return {String}
     */
    getPageDecade: function getPageDecade () {
      var decadeStart = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10;
      var decadeEnd = decadeStart + 9;
      var yearSuffix = this.translation.yearSuffix;
      return (decadeStart + " - " + decadeEnd + yearSuffix)
    },
    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled () {
      return this.isRtl
        ? this.isNextDecadeDisabled(this.pageTimestamp)
        : this.isPreviousDecadeDisabled(this.pageTimestamp)
    },
    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled () {
      return this.isRtl
        ? this.isPreviousDecadeDisabled(this.pageTimestamp)
        : this.isNextDecadeDisabled(this.pageTimestamp)
    }
  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    }
  },
  methods: {
    selectYear: function selectYear (year) {
      if (year.isDisabled) {
        return false
      }
      this.$emit('selectYear', year);
    },
    changeYear: function changeYear (incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedDecade', date);
    },
    previousDecade: function previousDecade () {
      if (this.isPreviousDecadeDisabled()) {
        return false
      }
      this.changeYear(-10);
    },
    isPreviousDecadeDisabled: function isPreviousDecadeDisabled () {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false
      }
      return Math.floor(this.utils.getFullYear(this.disabledDates.to) / 10) * 10 >= Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10
    },
    nextDecade: function nextDecade () {
      if (this.isNextDecadeDisabled()) {
        return false
      }
      this.changeYear(10);
    },
    isNextDecadeDisabled: function isNextDecadeDisabled () {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false
      }
      return Math.ceil(this.utils.getFullYear(this.disabledDates.from) / 10) * 10 <= Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10
    },

    /**
     * Whether the selected date is in this year
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedYear: function isSelectedYear (date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date)
    },
    /**
     * Whether a year is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledYear: function isDisabledYear (date) {
      var disabledDates = false;
      if (typeof this.disabledDates === 'undefined' || !this.disabledDates) {
        return false
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates
    }
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=".rtl { direction: rtl; } .vdp-datepicker { position: relative; text-align: left; } .vdp-datepicker * { box-sizing: border-box; } .vdp-datepicker__calendar { position: absolute; z-index: 100; background: #fff; width: 300px; border: 1px solid #ccc; } .vdp-datepicker__calendar header { display: block; line-height: 40px; } .vdp-datepicker__calendar header span { display: inline-block; text-align: center; width: 71.42857142857143%; float: left; } .vdp-datepicker__calendar header .prev, .vdp-datepicker__calendar header .next { width: 14.285714285714286%; float: left; text-indent: -10000px; position: relative; } .vdp-datepicker__calendar header .prev:after, .vdp-datepicker__calendar header .next:after { content: ''; position: absolute; left: 50%; top: 50%; -webkit-transform: translateX(-50%) translateY(-50%); transform: translateX(-50%) translateY(-50%); border: 6px solid transparent; } .vdp-datepicker__calendar header .prev:after { border-right: 10px solid #000; margin-left: -5px; } .vdp-datepicker__calendar header .prev.disabled:after { border-right: 10px solid #ddd; } .vdp-datepicker__calendar header .next:after { border-left: 10px solid #000; margin-left: 5px; } .vdp-datepicker__calendar header .next.disabled:after { border-left: 10px solid #ddd; } .vdp-datepicker__calendar header .prev:not(.disabled), .vdp-datepicker__calendar header .next:not(.disabled), .vdp-datepicker__calendar header .up:not(.disabled) { cursor: pointer; } .vdp-datepicker__calendar header .prev:not(.disabled):hover, .vdp-datepicker__calendar header .next:not(.disabled):hover, .vdp-datepicker__calendar header .up:not(.disabled):hover { background: #eee; } .vdp-datepicker__calendar .disabled { color: #ddd; cursor: default; } .vdp-datepicker__calendar .flex-rtl { display: flex; width: inherit; flex-wrap: wrap; } .vdp-datepicker__calendar .cell { display: inline-block; padding: 0 5px; width: 14.285714285714286%; height: 40px; line-height: 40px; text-align: center; vertical-align: middle; border: 1px solid transparent; } .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year { cursor: pointer; } .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover { border: 1px solid #4bd; } .vdp-datepicker__calendar .cell.selected { background: #4bd; } .vdp-datepicker__calendar .cell.selected:hover { background: #4bd; } .vdp-datepicker__calendar .cell.selected.highlighted { background: #4bd; } .vdp-datepicker__calendar .cell.highlighted { background: #cae5ed; } .vdp-datepicker__calendar .cell.highlighted.disabled { color: #a3a3a3; } .vdp-datepicker__calendar .cell.grey { color: #888; } .vdp-datepicker__calendar .cell.grey:hover { background: inherit; } .vdp-datepicker__calendar .cell.day-header { font-size: 75%; white-space: nowrap; cursor: inherit; } .vdp-datepicker__calendar .cell.day-header:hover { background: inherit; } .vdp-datepicker__calendar .month, .vdp-datepicker__calendar .year { width: 33.333%; } .vdp-datepicker__clear-button, .vdp-datepicker__calendar-button { cursor: pointer; font-style: normal; } .vdp-datepicker__clear-button.disabled, .vdp-datepicker__calendar-button.disabled { color: #999; cursor: default; } "; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var Datepicker = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vdp-datepicker",class:[_vm.wrapperClass, _vm.isRtl ? 'rtl' : '']},[_c('date-input',{attrs:{"selectedDate":_vm.selectedDate,"resetTypedDate":_vm.resetTypedDate,"format":_vm.format,"translation":_vm.translation,"inline":_vm.inline,"id":_vm.id,"name":_vm.name,"refName":_vm.refName,"openDate":_vm.openDate,"placeholder":_vm.placeholder,"inputClass":_vm.inputClass,"typeable":_vm.typeable,"clearButton":_vm.clearButton,"clearButtonIcon":_vm.clearButtonIcon,"calendarButton":_vm.calendarButton,"calendarButtonIcon":_vm.calendarButtonIcon,"calendarButtonIconContent":_vm.calendarButtonIconContent,"disabled":_vm.disabled,"required":_vm.required,"bootstrapStyling":_vm.bootstrapStyling,"use-utc":_vm.useUtc},on:{"showCalendar":_vm.showCalendar,"closeCalendar":_vm.close,"typedDate":_vm.setTypedDate,"clearDate":_vm.clearDate}},[_vm._t("afterDateInput",null,{slot:"afterDateInput"})],2),_vm._v(" "),(_vm.allowedToShowView('day'))?_c('picker-day',{attrs:{"pageDate":_vm.pageDate,"selectedDate":_vm.selectedDate,"showDayView":_vm.showDayView,"fullMonthName":_vm.fullMonthName,"allowedToShowView":_vm.allowedToShowView,"disabledDates":_vm.disabledDates,"highlighted":_vm.highlighted,"calendarClass":_vm.calendarClass,"calendarStyle":_vm.calendarStyle,"translation":_vm.translation,"pageTimestamp":_vm.pageTimestamp,"isRtl":_vm.isRtl,"mondayFirst":_vm.mondayFirst,"dayCellContent":_vm.dayCellContent,"use-utc":_vm.useUtc},on:{"changedMonth":_vm.handleChangedMonthFromDayPicker,"selectDate":_vm.selectDate,"showMonthCalendar":_vm.showMonthCalendar,"selectedDisabled":_vm.selectDisabledDate}},[_vm._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):_vm._e(),_vm._v(" "),(_vm.allowedToShowView('month'))?_c('picker-month',{attrs:{"pageDate":_vm.pageDate,"selectedDate":_vm.selectedDate,"showMonthView":_vm.showMonthView,"allowedToShowView":_vm.allowedToShowView,"disabledDates":_vm.disabledDates,"calendarClass":_vm.calendarClass,"calendarStyle":_vm.calendarStyle,"translation":_vm.translation,"isRtl":_vm.isRtl,"use-utc":_vm.useUtc},on:{"selectMonth":_vm.selectMonth,"showYearCalendar":_vm.showYearCalendar,"changedYear":_vm.setPageDate}},[_vm._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):_vm._e(),_vm._v(" "),(_vm.allowedToShowView('year'))?_c('picker-year',{attrs:{"pageDate":_vm.pageDate,"selectedDate":_vm.selectedDate,"showYearView":_vm.showYearView,"allowedToShowView":_vm.allowedToShowView,"disabledDates":_vm.disabledDates,"calendarClass":_vm.calendarClass,"calendarStyle":_vm.calendarStyle,"translation":_vm.translation,"isRtl":_vm.isRtl,"use-utc":_vm.useUtc},on:{"selectYear":_vm.selectYear,"changedDecade":_vm.setPageDate}},[_vm._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):_vm._e()],1)},staticRenderFns: [],
  components: {
    DateInput: DateInput,
    PickerDay: PickerDay,
    PickerMonth: PickerMonth,
    PickerYear: PickerYear
  },
  props: {
    value: {
      validator: function (val) {
        return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number'
      }
    },
    name: String,
    refName: String,
    id: String,
    format: {
      type: [String, Function],
      default: 'dd MMM yyyy'
    },
    language: {
      type: Object,
      default: function () { return en$1; }
    },
    openDate: {
      validator: function (val) {
        return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number'
      }
    },
    dayCellContent: Function,
    fullMonthName: Boolean,
    disabledDates: Object,
    highlighted: Object,
    placeholder: String,
    inline: Boolean,
    calendarClass: [String, Object, Array],
    inputClass: [String, Object, Array],
    wrapperClass: [String, Object, Array],
    mondayFirst: Boolean,
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    bootstrapStyling: Boolean,
    initialView: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    useUtc: Boolean,
    minimumView: {
      type: String,
      default: 'day'
    },
    maximumView: {
      type: String,
      default: 'year'
    }
  },
  data: function data () {
    var startDate = this.openDate ? new Date(this.openDate) : new Date();
    var constructedDateUtils = makeDateUtils(this.useUtc);
    var pageTimestamp = constructedDateUtils.setDate(startDate, 1);
    return {
      /*
       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
       * This represents the first day of the current viewing month
       * {Number}
       */
      pageTimestamp: pageTimestamp,
      /*
       * Selected Date
       * {Date}
       */
      selectedDate: null,
      /*
       * Flags to show calendar views
       * {Boolean}
       */
      showDayView: false,
      showMonthView: false,
      showYearView: false,
      /*
       * Positioning
       */
      calendarHeight: 0,
      resetTypedDate: new Date(),
      utils: constructedDateUtils
    }
  },
  watch: {
    value: function value (value$1) {
      this.setValue(value$1);
    },
    openDate: function openDate () {
      this.setPageDate();
    },
    initialView: function initialView () {
      this.setInitialView();
    }
  },
  computed: {
    computedInitialView: function computedInitialView () {
      if (!this.initialView) {
        return this.minimumView
      }

      return this.initialView
    },
    pageDate: function pageDate () {
      return new Date(this.pageTimestamp)
    },

    translation: function translation () {
      return this.language
    },

    calendarStyle: function calendarStyle () {
      return {
        position: this.isInline ? 'static' : undefined
      }
    },
    isOpen: function isOpen () {
      return this.showDayView || this.showMonthView || this.showYearView
    },
    isInline: function isInline () {
      return !!this.inline
    },
    isRtl: function isRtl () {
      return this.translation.rtl === true
    }
  },
  methods: {
    /**
     * Called in the event that the user navigates to date pages and
     * closes the picker without selecting a date.
     */
    resetDefaultPageDate: function resetDefaultPageDate () {
      if (this.selectedDate === null) {
        this.setPageDate();
        return
      }
      this.setPageDate(this.selectedDate);
    },
    /**
     * Effectively a toggle to show/hide the calendar
     * @return {mixed}
     */
    showCalendar: function showCalendar () {
      if (this.disabled || this.isInline) {
        return false
      }
      if (this.isOpen) {
        return this.close(true)
      }
      this.setInitialView();
      if (!this.isInline) {
        this.$emit('opened');
      }
    },
    /**
     * Sets the initial picker page view: day, month or year
     */
    setInitialView: function setInitialView () {
      var initialView = this.computedInitialView;
      if (!this.allowedToShowView(initialView)) {
        throw new Error(("initialView '" + (this.initialView) + "' cannot be rendered based on minimum '" + (this.minimumView) + "' and maximum '" + (this.maximumView) + "'"))
      }
      switch (initialView) {
        case 'year':
          this.showYearCalendar();
          break
        case 'month':
          this.showMonthCalendar();
          break
        default:
          this.showDayCalendar();
          break
      }
    },
    /**
     * Are we allowed to show a specific picker view?
     * @param {String} view
     * @return {Boolean}
     */
    allowedToShowView: function allowedToShowView (view) {
      var views = ['day', 'month', 'year'];
      var minimumViewIndex = views.indexOf(this.minimumView);
      var maximumViewIndex = views.indexOf(this.maximumView);
      var viewIndex = views.indexOf(view);

      return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex
    },
    /**
     * Show the day picker
     * @return {Boolean}
     */
    showDayCalendar: function showDayCalendar () {
      if (!this.allowedToShowView('day')) {
        return false
      }
      this.close();
      this.showDayView = true;
      return true
    },
    /**
     * Show the month picker
     * @return {Boolean}
     */
    showMonthCalendar: function showMonthCalendar () {
      if (!this.allowedToShowView('month')) {
        return false
      }
      this.close();
      this.showMonthView = true;
      return true
    },
    /**
     * Show the year picker
     * @return {Boolean}
     */
    showYearCalendar: function showYearCalendar () {
      if (!this.allowedToShowView('year')) {
        return false
      }
      this.close();
      this.showYearView = true;
      return true
    },
    /**
     * Set the selected date
     * @param {Number} timestamp
     */
    setDate: function setDate (timestamp) {
      var date = new Date(timestamp);
      this.selectedDate = date;
      this.setPageDate(date);
      this.$emit('selected', date);
      this.$emit('input', date);
    },
    /**
     * Clear the selected date
     */
    clearDate: function clearDate () {
      this.selectedDate = null;
      this.setPageDate();
      this.$emit('selected', null);
      this.$emit('input', null);
      this.$emit('cleared');
    },
    /**
     * @param {Object} date
     */
    selectDate: function selectDate (date) {
      this.setDate(date.timestamp);
      if (!this.isInline) {
        this.close(true);
      }
      this.resetTypedDate = new Date();
    },
    /**
     * @param {Object} date
     */
    selectDisabledDate: function selectDisabledDate (date) {
      this.$emit('selectedDisabled', date);
    },
    /**
     * @param {Object} month
     */
    selectMonth: function selectMonth (month) {
      var date = new Date(month.timestamp);
      if (this.allowedToShowView('day')) {
        this.setPageDate(date);
        this.$emit('changedMonth', month);
        this.showDayCalendar();
      } else {
        this.selectDate(month);
      }
    },
    /**
     * @param {Object} year
     */
    selectYear: function selectYear (year) {
      var date = new Date(year.timestamp);
      if (this.allowedToShowView('month')) {
        this.setPageDate(date);
        this.$emit('changedYear', year);
        this.showMonthCalendar();
      } else {
        this.selectDate(year);
      }
    },
    /**
     * Set the datepicker value
     * @param {Date|String|Number|null} date
     */
    setValue: function setValue (date) {
      if (typeof date === 'string' || typeof date === 'number') {
        var parsed = new Date(date);
        date = isNaN(parsed.valueOf()) ? null : parsed;
      }
      if (!date) {
        this.setPageDate();
        this.selectedDate = null;
        return
      }
      this.selectedDate = date;
      this.setPageDate(date);
    },
    /**
     * Sets the date that the calendar should open on
     */
    setPageDate: function setPageDate (date) {
      if (!date) {
        if (this.openDate) {
          date = new Date(this.openDate);
        } else {
          date = new Date();
        }
      }
      this.pageTimestamp = this.utils.setDate(new Date(date), 1);
    },
    /**
     * Handles a month change from the day picker
     */
    handleChangedMonthFromDayPicker: function handleChangedMonthFromDayPicker (date) {
      this.setPageDate(date);
      this.$emit('changedMonth', date);
    },
    /**
     * Set the date from a typedDate event
     */
    setTypedDate: function setTypedDate (date) {
      this.setDate(date.getTime());
    },
    /**
     * Close all calendar layers
     * @param {Boolean} full - emit close event
     */
    close: function close (full) {
      this.showDayView = this.showMonthView = this.showYearView = false;
      if (!this.isInline) {
        if (full) {
          this.$emit('closed');
        }
        document.removeEventListener('click', this.clickOutside, false);
      }
    },
    /**
     * Initiate the component
     */
    init: function init () {
      if (this.value) {
        this.setValue(this.value);
      }
      if (this.isInline) {
        this.setInitialView();
      }
    }
  },
  mounted: function mounted () {
    this.init();
  }
}
// eslint-disable-next-line
;

var vCalendar_umd_min = createCommonjsModule(function (module, exports) {
(function(e,t){module.exports=t(Vue);})("undefined"!==typeof self?self:commonjsGlobal,(function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var a=t[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r});},n.r=function(e){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"===typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var a in e)n.d(r,a,function(t){return e[t]}.bind(null,a));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e["default"]}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s="fb15")}({"00fd":function(e,t,n){var r=n("9e69"),a=Object.prototype,o=a.hasOwnProperty,i=a.toString,s=r?r.toStringTag:void 0;function c(e){var t=o.call(e,s),n=e[s];try{e[s]=void 0;var r=!0;}catch(c){}var a=i.call(e);return r&&(t?e[s]=n:delete e[s]),a}e.exports=c;},"03dd":function(e,t,n){var r=n("eac5"),a=n("57a5"),o=Object.prototype,i=o.hasOwnProperty;function s(e){if(!r(e))return a(e);var t=[];for(var n in Object(e))i.call(e,n)&&"constructor"!=n&&t.push(n);return t}e.exports=s;},"0621":function(e,t,n){var r=n("9e69"),a=n("d370"),o=n("6747"),i=r?r.isConcatSpreadable:void 0;function s(e){return o(e)||a(e)||!!(i&&e&&e[i])}e.exports=s;},"06cf":function(e,t,n){var r=n("83ab"),a=n("d1e7"),o=n("5c6c"),i=n("fc6a"),s=n("c04e"),c=n("5135"),u=n("0cfb"),l=Object.getOwnPropertyDescriptor;t.f=r?l:function(e,t){if(e=i(e),t=s(t,!0),u)try{return l(e,t)}catch(n){}if(c(e,t))return o(!a.f.call(e,t),e[t])};},"0733":function(e,t,n){n.d(t,"a",(function(){return o}));var r=n("2fa3"),a=n("9404");const o=function(e,t,{maxSwipeTime:n,minHorizontalSwipeDistance:o,maxVerticalSwipeDistance:i}){if(!e||!e.addEventListener||!Object(a["k"])(t))return null;let s=0,c=0,u=null,l=!1;function d(e){const t=e.changedTouches[0];s=t.screenX,c=t.screenY,u=(new Date).getTime(),l=!0;}function f(e){if(!l)return;l=!1;const r=e.changedTouches[0],a=r.screenX-s,d=r.screenY-c,f=(new Date).getTime()-u;if(f<n&&Math.abs(a)>=o&&Math.abs(d)<=i){const e={toLeft:!1,toRight:!1};a<0?e.toLeft=!0:e.toRight=!0,t(e);}}return Object(r["k"])(e,"touchstart",d,{passive:!0}),Object(r["k"])(e,"touchend",f,{passive:!0}),function(){Object(r["j"])(e,"touchstart",d),Object(r["j"])(e,"touchend",f);}};},"07c7":function(e,t){function n(){return !1}e.exports=n;},"087d":function(e,t){function n(e,t){var n=-1,r=t.length,a=e.length;while(++n<r)e[a+n]=t[n];return e}e.exports=n;},"08cc":function(e,t,n){var r=n("1a8c");function a(e){return e===e&&!r(e)}e.exports=a;},"0b07":function(e,t,n){var r=n("34ac"),a=n("3698");function o(e,t){var n=a(e,t);return r(n)?n:void 0}e.exports=o;},"0cb2":function(e,t,n){var r=n("7b0b"),a=Math.floor,o="".replace,i=/\$([$&'`]|\d{1,2}|<[^>]*>)/g,s=/\$([$&'`]|\d{1,2})/g;e.exports=function(e,t,n,c,u,l){var d=n+e.length,f=c.length,p=s;return void 0!==u&&(u=r(u),p=i),o.call(l,p,(function(r,o){var i;switch(o.charAt(0)){case"$":return "$";case"&":return e;case"`":return t.slice(0,n);case"'":return t.slice(d);case"<":i=u[o.slice(1,-1)];break;default:var s=+o;if(0===s)return r;if(s>f){var l=a(s/10);return 0===l?r:l<=f?void 0===c[l-1]?o.charAt(1):c[l-1]+o.charAt(1):r}i=c[s-1];}return void 0===i?"":i}))};},"0cfb":function(e,t,n){var r=n("83ab"),a=n("d039"),o=n("cc12");e.exports=!r&&!a((function(){return 7!=Object.defineProperty(o("div"),"a",{get:function(){return 7}}).a}));},"0d24":function(e,t,n){(function(e){var r=n("2b3e"),a=n("07c7"),o=t&&!t.nodeType&&t,i=o&&"object"==typeof e&&e&&!e.nodeType&&e,s=i&&i.exports===o,c=s?r.Buffer:void 0,u=c?c.isBuffer:void 0,l=u||a;e.exports=l;}).call(this,n("62e4")(e));},"0da5":function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,".vc-nav-header{display:flex;justify-content:space-between}.vc-nav-arrow{display:flex;justify-content:center;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none;line-height:var(--leading-snug);border-width:2px;border-style:solid;border-color:transparent;border-radius:var(--rounded)}.vc-nav-arrow.is-left{margin-right:auto}.vc-nav-arrow.is-right{margin-left:auto}.vc-nav-arrow.is-disabled{opacity:.25;pointer-events:none;cursor:not-allowed}.vc-nav-arrow:hover{background-color:var(--gray-900)}.vc-nav-arrow:focus{border-color:var(--accent-600)}.vc-nav-title{color:var(--accent-100);font-weight:var(--font-bold);line-height:var(--leading-snug);padding:4px 8px;border-radius:var(--rounded);border-width:2px;border-style:solid;border-color:transparent;-webkit-user-select:none;user-select:none}.vc-nav-title:hover{background-color:var(--gray-900)}.vc-nav-title:focus{border-color:var(--accent-600)}.vc-nav-items{display:grid;grid-template-columns:repeat(3,1fr);grid-row-gap:2px;grid-column-gap:5px}.vc-nav-item{width:48px;text-align:center;line-height:var(--leading-snug);font-weight:var(--font-semibold);padding:4px 0;cursor:pointer;border-color:transparent;border-width:2px;border-style:solid;border-radius:var(--rounded);-webkit-user-select:none;user-select:none}.vc-nav-item:hover{color:var(--white);background-color:var(--gray-900);box-shadow:var(--shadow-inner)}.vc-nav-item.is-active{color:var(--accent-900);background:var(--accent-100);font-weight:var(--font-bold);box-shadow:var(--shadow)}.vc-nav-item.is-current{color:var(--accent-100);font-weight:var(--bold);border-color:var(--accent-100)}.vc-nav-item:focus{border-color:var(--accent-600)}.vc-nav-item.is-disabled{opacity:.25;pointer-events:none}.vc-is-dark .vc-nav-title{color:var(--gray-900)}.vc-is-dark .vc-nav-title:hover{background-color:var(--gray-200)}.vc-is-dark .vc-nav-title:focus{border-color:var(--accent-400)}.vc-is-dark .vc-nav-arrow:hover{background-color:var(--gray-200)}.vc-is-dark .vc-nav-arrow:focus{border-color:var(--accent-400)}.vc-is-dark .vc-nav-item:hover{color:var(--gray-900);background-color:var(--gray-200);box-shadow:none}.vc-is-dark .vc-nav-item.is-active{color:var(--white);background:var(--accent-500)}.vc-is-dark .vc-nav-item.is-current{color:var(--accent-600);border-color:var(--accent-500)}.vc-is-dark .vc-nav-item:focus{border-color:var(--accent-400)}",""]),e.exports=t;},"0f0f":function(e,t,n){var r=n("8eeb"),a=n("9934");function o(e,t){return e&&r(t,a(t),e)}e.exports=o;},"0f5c":function(e,t,n){var r=n("159a");function a(e,t,n){return null==e?e:r(e,t,n)}e.exports=a;},"0fb2":function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,'.vc-popover-content-wrapper[data-v-39b30300]{--popover-horizontal-content-offset:8px;--popover-vertical-content-offset:10px;--popover-slide-translation:15px;--popover-transition-time:0.14s ease-in-out;--popover-caret-horizontal-offset:18px;--popover-caret-vertical-offset:8px;position:absolute;display:block;outline:none;z-index:10}.vc-popover-content-wrapper[data-v-39b30300]:not(.is-interactive){pointer-events:none}.vc-popover-content[data-v-39b30300]{position:relative;outline:none;z-index:10;box-shadow:var(--shadow-lg)}.vc-popover-content.direction-bottom[data-v-39b30300]{margin-top:var(--popover-vertical-content-offset)}.vc-popover-content.direction-top[data-v-39b30300]{margin-bottom:var(--popover-vertical-content-offset)}.vc-popover-content.direction-left[data-v-39b30300]{margin-right:var(--popover-horizontal-content-offset)}.vc-popover-content.direction-right[data-v-39b30300]{margin-left:var(--popover-horizontal-content-offset)}.vc-popover-caret[data-v-39b30300]{content:"";position:absolute;display:block;width:12px;height:12px;border-top:inherit;border-left:inherit;background-color:inherit;-webkit-user-select:none;user-select:none;z-index:-1}.vc-popover-caret.direction-bottom[data-v-39b30300]{top:0}.vc-popover-caret.direction-bottom.align-left[data-v-39b30300]{transform:translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-bottom.align-center[data-v-39b30300]{transform:translateX(-50%) translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-bottom.align-right[data-v-39b30300]{transform:translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-top[data-v-39b30300]{top:100%}.vc-popover-caret.direction-top.align-left[data-v-39b30300]{transform:translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-top.align-center[data-v-39b30300]{transform:translateX(-50%) translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-top.align-right[data-v-39b30300]{transform:translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-left[data-v-39b30300]{left:100%}.vc-popover-caret.direction-left.align-top[data-v-39b30300]{transform:translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-left.align-middle[data-v-39b30300]{transform:translateY(-50%) translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-left.align-bottom[data-v-39b30300]{transform:translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-right[data-v-39b30300]{left:0}.vc-popover-caret.direction-right.align-top[data-v-39b30300]{transform:translateX(-50%) rotate(-45deg)}.vc-popover-caret.direction-right.align-middle[data-v-39b30300]{transform:translateY(-50%) translateX(-50%) rotate(-45deg)}.vc-popover-caret.direction-right.align-bottom[data-v-39b30300]{transform:translateX(-50%) rotate(-45deg)}.vc-popover-caret.align-left[data-v-39b30300]{left:var(--popover-caret-horizontal-offset)}.vc-popover-caret.align-center[data-v-39b30300]{left:50%}.vc-popover-caret.align-right[data-v-39b30300]{right:var(--popover-caret-horizontal-offset)}.vc-popover-caret.align-top[data-v-39b30300]{top:var(--popover-caret-vertical-offset)}.vc-popover-caret.align-middle[data-v-39b30300]{top:50%}.vc-popover-caret.align-bottom[data-v-39b30300]{bottom:var(--popover-caret-vertical-offset)}.fade-enter-active[data-v-39b30300],.fade-leave-active[data-v-39b30300],.slide-fade-enter-active[data-v-39b30300],.slide-fade-leave-active[data-v-39b30300]{transition:all var(--popover-transition-time);pointer-events:none}.fade-enter[data-v-39b30300],.fade-leave-to[data-v-39b30300],.slide-fade-enter[data-v-39b30300],.slide-fade-leave-to[data-v-39b30300]{opacity:0}.slide-fade-enter.direction-bottom[data-v-39b30300],.slide-fade-leave-to.direction-bottom[data-v-39b30300]{transform:translateY(calc(var(--popover-slide-translation)*-1))}.slide-fade-enter.direction-top[data-v-39b30300],.slide-fade-leave-to.direction-top[data-v-39b30300]{transform:translateY(var(--popover-slide-translation))}.slide-fade-enter.direction-left[data-v-39b30300],.slide-fade-leave-to.direction-left[data-v-39b30300]{transform:translateX(var(--popover-slide-translation))}.slide-fade-enter.direction-right[data-v-39b30300],.slide-fade-leave-to.direction-right[data-v-39b30300]{transform:translateX(calc(var(--popover-slide-translation)*-1))}',""]),e.exports=t;},"100e":function(e,t,n){var r=n("cd9d"),a=n("2286"),o=n("c1c9");function i(e,t){return o(a(e,t,r),e+"")}e.exports=i;},1041:function(e,t,n){var r=n("8eeb"),a=n("a029");function o(e,t){return r(e,a(e),t)}e.exports=o;},"107c":function(e,t,n){var r=n("d039");e.exports=r((function(){var e=RegExp("(?<a>b)","string".charAt(5));return "b"!==e.exec("b").groups.a||"bc"!=="b".replace(e,"$<a>c")}));},1290:function(e,t){function n(e){var t=typeof e;return "string"==t||"number"==t||"symbol"==t||"boolean"==t?"__proto__"!==e:null===e}e.exports=n;},1310:function(e,t){function n(e){return null!=e&&"object"==typeof e}e.exports=n;},1315:function(e,t,n){n.d(t,"a",(function(){return d}));var r=n("8bbf"),a=n.n(r),o=n("9404");function i(e){return Object(o["n"])(e)&&(e={min:e}),Object(o["h"])(e)||(e=[e]),e.map((function(e){return Object(o["e"])(e,"raw")?e.raw:Object(o["q"])(e,(function(e,t){return t=Object(o["d"])({min:"min-width",max:"max-width"},t,t),`(${t}: ${e})`})).join(" and ")})).join(", ")}var s=n("85a9");let c=!1,u=!1,l=null;function d(e=s,t){l&&!t||c||(c=!0,u=!0,l=new a.a({data(){return {matches:[],queries:[]}},methods:{refreshQueries(){var t=this;window&&window.matchMedia&&(this.queries=Object(o["r"])(e,(function(e){const n=window.matchMedia(i(e));return Object(o["k"])(n.addEventListener)?n.addEventListener("change",t.refreshMatches):n.addListener(t.refreshMatches),n})),this.refreshMatches());},refreshMatches(){this.matches=Object(o["w"])(this.queries).filter((function(e){return e[1].matches})).map((function(e){return e[0]}));}}}),c=!1);}a.a.mixin({beforeCreate(){c||d();},mounted(){u&&l&&(l.refreshQueries(),u=!1);},computed:{$screens(){return function(e,t){return l.matches.reduce((function(t,n){return Object(o["e"])(e,n)?e[n]:t}),Object(o["o"])(t)?e.default:t)}}}});},1368:function(e,t,n){var r=n("da03"),a=function(){var e=/[^.]+$/.exec(r&&r.keys&&r.keys.IE_PROTO||"");return e?"Symbol(src)_1."+e:""}();function o(e){return !!a&&a in e}e.exports=o;},"14c3":function(e,t,n){var r=n("c6b6"),a=n("9263");e.exports=function(e,t){var n=e.exec;if("function"===typeof n){var o=n.call(e,t);if("object"!==typeof o)throw TypeError("RegExp exec method returned something other than an Object or null");return o}if("RegExp"!==r(e))throw TypeError("RegExp#exec called on incompatible receiver");return a.call(e,t)};},"159a":function(e,t,n){var r=n("32b3"),a=n("e2e4"),o=n("c098"),i=n("1a8c"),s=n("f4d6");function c(e,t,n,c){if(!i(e))return e;t=a(t,e);var u=-1,l=t.length,d=l-1,f=e;while(null!=f&&++u<l){var p=s(t[u]),h=n;if("__proto__"===p||"constructor"===p||"prototype"===p)return e;if(u!=d){var v=f[p];h=c?c(v,p,f):void 0,void 0===h&&(h=i(v)?v:o(t[u+1])?[]:{});}r(f,p,h),f=f[p];}return e}e.exports=c;},"15f3":function(e,t,n){var r=n("89d9"),a=n("8604");function o(e,t){return r(e,t,(function(t,n){return a(e,n)}))}e.exports=o;},1838:function(e,t,n){var r=n("c05f"),a=n("9b02"),o=n("8604"),i=n("f608"),s=n("08cc"),c=n("20ec"),u=n("f4d6"),l=1,d=2;function f(e,t){return i(e)&&s(t)?c(u(e),t):function(n){var i=a(n,e);return void 0===i&&i===t?o(n,e):r(t,i,l|d)}}e.exports=f;},"18d8":function(e,t,n){var r=n("234d"),a=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,o=/\\(\\)?/g,i=r((function(e){var t=[];return 46===e.charCodeAt(0)&&t.push(""),e.replace(a,(function(e,n,r,a){t.push(r?a.replace(o,"$1"):n||e);})),t}));e.exports=i;},"1a2d":function(e,t,n){var r=n("42a2"),a=n("1310"),o="[object Map]";function i(e){return a(e)&&r(e)==o}e.exports=i;},"1a8c":function(e,t){function n(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}e.exports=n;},"1bac":function(e,t,n){var r=n("7d1f"),a=n("a029"),o=n("9934");function i(e){return r(e,o,a)}e.exports=i;},"1be4":function(e,t,n){var r=n("d066");e.exports=r("document","documentElement");},"1c3c":function(e,t,n){var r=n("9e69"),a=n("2474"),o=n("9638"),i=n("a2be"),s=n("edfa"),c=n("ac41"),u=1,l=2,d="[object Boolean]",f="[object Date]",p="[object Error]",h="[object Map]",v="[object Number]",b="[object RegExp]",m="[object Set]",g="[object String]",y="[object Symbol]",w="[object ArrayBuffer]",x="[object DataView]",D=r?r.prototype:void 0,O=D?D.valueOf:void 0;function j(e,t,n,r,D,j,k){switch(n){case x:if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return !1;e=e.buffer,t=t.buffer;case w:return !(e.byteLength!=t.byteLength||!j(new a(e),new a(t)));case d:case f:case v:return o(+e,+t);case p:return e.name==t.name&&e.message==t.message;case b:case g:return e==t+"";case h:var M=s;case m:var P=r&u;if(M||(M=c),e.size!=t.size&&!P)return !1;var Y=k.get(e);if(Y)return Y==t;r|=l,k.set(e,t);var S=i(M(e),M(t),r,D,j,k);return k["delete"](e),S;case y:if(O)return O.call(e)==O.call(t)}return !1}e.exports=j;},"1cec":function(e,t,n){var r=n("0b07"),a=n("2b3e"),o=r(a,"Promise");e.exports=o;},"1d80":function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on "+e);return e};},"1efc":function(e,t){function n(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t}e.exports=n;},"1f64":function(e,t,n){var r=n("6a43"),a=n.n(r);a.a;},"1fc8":function(e,t,n){var r=n("4245");function a(e,t){var n=r(this,e),a=n.size;return n.set(e,t),this.size+=n.size==a?0:1,this}e.exports=a;},"20ec":function(e,t){function n(e,t){return function(n){return null!=n&&(n[e]===t&&(void 0!==t||e in Object(n)))}}e.exports=n;},2202:function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,".vc-select[data-v-7b2eaf0a]{position:relative}.vc-select select[data-v-7b2eaf0a]{flex-grow:1;display:block;-webkit-appearance:none;appearance:none;width:52px;height:30px;font-size:var(--text-base);font-weight:var(--font-medium);text-align:left;background-color:var(--gray-200);border:2px solid;border-color:var(--gray-200);color:var(--gray-900);padding:0 20px 0 8px;border-radius:var(--rounded);line-height:var(--leading-tight);text-indent:0;cursor:pointer;-moz-padding-start:3px;background-image:none}.vc-select select[data-v-7b2eaf0a]:hover{color:var(--gray-600)}.vc-select select[data-v-7b2eaf0a]:focus{outline:0;border-color:var(--accent-400);background-color:var(--white)}.vc-select-arrow[data-v-7b2eaf0a]{display:flex;align-items:center;pointer-events:none;position:absolute;top:0;bottom:0;right:0;padding:0 4px 0 0;color:var(--gray-500)}.vc-select-arrow svg[data-v-7b2eaf0a]{width:16px;height:16px;fill:currentColor}.vc-is-dark select[data-v-7b2eaf0a]{background:var(--gray-700);color:var(--gray-100);border-color:var(--gray-700)}.vc-is-dark select[data-v-7b2eaf0a]:hover{color:var(--gray-400)}.vc-is-dark select[data-v-7b2eaf0a]:focus{border-color:var(--accent-500);background-color:var(--gray-800)}",""]),e.exports=t;},2285:function(e,t,n){var r=n("2a4d"),a=n.n(r);a.a;},2286:function(e,t,n){var r=n("85e3"),a=Math.max;function o(e,t,n){return t=a(void 0===t?e.length-1:t,0),function(){var o=arguments,i=-1,s=a(o.length-t,0),c=Array(s);while(++i<s)c[i]=o[t+i];i=-1;var u=Array(t+1);while(++i<t)u[i]=o[i];return u[t]=n(c),r(e,this,u)}}e.exports=o;},"22f3":function(e,t,n){n.d(t,"a",(function(){return i}));var r=n("cfe5"),a=n("2fa3"),o=n("9404");class i{constructor({key:e,hashcode:t,highlight:n,content:i,dot:s,bar:c,popover:u,dates:l,excludeDates:d,excludeMode:f,customData:p,order:h,pinPage:v},b,m){this.key=Object(o["o"])(e)?Object(a["c"])():e,this.hashcode=t,this.customData=p,this.order=h||0,this.dateOpts={order:h,locale:m},this.pinPage=v,n&&(this.highlight=b.normalizeHighlight(n)),i&&(this.content=b.normalizeContent(i)),s&&(this.dot=b.normalizeDot(s)),c&&(this.bar=b.normalizeBar(c)),u&&(this.popover=u),this.dates=m.normalizeDates(l,this.dateOpts),this.hasDates=!!Object(a["b"])(this.dates),this.excludeDates=m.normalizeDates(d,this.dateOpts),this.hasExcludeDates=!!Object(a["b"])(this.excludeDates),this.excludeMode=f||"intersects",this.hasExcludeDates&&!this.hasDates&&(this.dates.push(new r["a"]({},this.dateOpts)),this.hasDates=!0),this.isComplex=Object(o["v"])(this.dates,(function(e){return e.isComplex}));}intersectsDate(e){return e=e instanceof r["a"]?e:new r["a"](e,this.dateOpts),!this.excludesDate(e)&&(this.dates.find((function(t){return t.intersectsDate(e)}))||!1)}includesDate(e){return e=e instanceof r["a"]?e:new r["a"](e,this.dateOpts),!this.excludesDate(e)&&(this.dates.find((function(t){return t.includesDate(e)}))||!1)}excludesDate(e){var t=this;return e=e instanceof r["a"]?e:new r["a"](e,this.dateOpts),this.hasExcludeDates&&this.excludeDates.find((function(n){return "intersects"===t.excludeMode&&n.intersectsDate(e)||"includes"===t.excludeMode&&n.includesDate(e)}))}intersectsDay(e){return !this.excludesDay(e)&&(this.dates.find((function(t){return t.intersectsDay(e)}))||!1)}excludesDay(e){return this.hasExcludeDates&&this.excludeDates.find((function(t){return t.intersectsDay(e)}))}}},"234d":function(e,t,n){var r=n("e380"),a=500;function o(e){var t=r(e,(function(e){return n.size===a&&n.clear(),e})),n=t.cache;return t}e.exports=o;},"23a5":function(e){e.exports=JSON.parse('{"maxSwipeTime":300,"minHorizontalSwipeDistance":60,"maxVerticalSwipeDistance":80}');},"23cb":function(e,t,n){var r=n("a691"),a=Math.max,o=Math.min;e.exports=function(e,t){var n=r(e);return n<0?a(n+t,0):o(n,t)};},"23e7":function(e,t,n){var r=n("da84"),a=n("06cf").f,o=n("9112"),i=n("6eeb"),s=n("ce4e"),c=n("e893"),u=n("94ca");e.exports=function(e,t){var n,l,d,f,p,h,v=e.target,b=e.global,m=e.stat;if(l=b?r:m?r[v]||s(v,{}):(r[v]||{}).prototype,l)for(d in t){if(p=t[d],e.noTargetGet?(h=a(l,d),f=h&&h.value):f=l[d],n=u(b?d:v+(m?".":"#")+d,e.forced),!n&&void 0!==f){if(typeof p===typeof f)continue;c(p,f);}(e.sham||f&&f.sham)&&o(p,"sham",!0),i(l,d,p,e);}};},2411:function(e,t,n){var r=n("f909"),a=n("2ec1"),o=a((function(e,t,n,a){r(e,t,n,a);}));e.exports=o;},"241c":function(e,t,n){var r=n("ca84"),a=n("7839"),o=a.concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,o)};},"242e":function(e,t,n){var r=n("72af"),a=n("ec69");function o(e,t){return e&&r(e,t,a)}e.exports=o;},2474:function(e,t,n){var r=n("2b3e"),a=r.Uint8Array;e.exports=a;},2478:function(e,t,n){var r=n("4245");function a(e){return r(this,e).get(e)}e.exports=a;},"24fb":function(e,t,n){function r(e,t){var n=e[1]||"",r=e[3];if(!r)return n;if(t&&"function"===typeof btoa){var o=a(r),i=r.sources.map((function(e){return "/*# sourceURL=".concat(r.sourceRoot||"").concat(e," */")}));return [n].concat(i).concat([o]).join("\n")}return [n].join("\n")}function a(e){var t=btoa(unescape(encodeURIComponent(JSON.stringify(e)))),n="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(t);return "/*# ".concat(n," */")}e.exports=function(e){var t=[];return t.toString=function(){return this.map((function(t){var n=r(t,e);return t[2]?"@media ".concat(t[2]," {").concat(n,"}"):n})).join("")},t.i=function(e,n,r){"string"===typeof e&&(e=[[null,e,""]]);var a={};if(r)for(var o=0;o<this.length;o++){var i=this[o][0];null!=i&&(a[i]=!0);}for(var s=0;s<e.length;s++){var c=[].concat(e[s]);r&&a[c[0]]||(n&&(c[2]?c[2]="".concat(n," and ").concat(c[2]):c[2]=n),t.push(c));}},t};},2524:function(e,t,n){var r=n("6044"),a="__lodash_hash_undefined__";function o(e,t){var n=this.__data__;return this.size+=this.has(e)?0:1,n[e]=r&&void 0===t?a:t,this}e.exports=o;},"253c":function(e,t,n){var r=n("3729"),a=n("1310"),o="[object Arguments]";function i(e){return a(e)&&r(e)==o}e.exports=i;},2593:function(e,t,n){var r=n("15f3"),a=n("c6cf"),o=a((function(e,t){return null==e?{}:r(e,t)}));e.exports=o;},"26e8":function(e,t){function n(e,t){return null!=e&&t in Object(e)}e.exports=n;},"27e3":function(e,t,n){var r=n("8a64"),a=n.n(r);a.a;},"28c9":function(e,t){function n(){this.__data__=[],this.size=0;}e.exports=n;},"29ae":function(e,t,n){n.d(t,"a",(function(){return ae})),n.d(t,"b",(function(){return xe}));n("5319");var r=n("fe1f");function a(e){var t=new Date(Date.UTC(e.getFullYear(),e.getMonth(),e.getDate(),e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds()));return t.setUTCFullYear(e.getFullYear()),e.getTime()-t.getTime()}function o(e,t){var n=l(t);return n.formatToParts?s(n,e):c(n,e)}var i={year:0,month:1,day:2,hour:3,minute:4,second:5};function s(e,t){for(var n=e.formatToParts(t),r=[],a=0;a<n.length;a++){var o=i[n[a].type];o>=0&&(r[o]=parseInt(n[a].value,10));}return r}function c(e,t){var n=e.format(t).replace(/\u200E/g,""),r=/(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);return [r[3],r[1],r[2],r[4],r[5],r[6]]}var u={};function l(e){if(!u[e]){var t=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:"America/New_York",year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit"}).format(new Date("2014-06-25T04:00:00.123Z")),n="06/25/2014, 00:00:00"===t||"‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00"===t;u[e]=n?new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:e,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit"}):new Intl.DateTimeFormat("en-US",{hourCycle:"h23",timeZone:e,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit"});}return u[e]}var d=36e5,f=6e4,p={timezone:/([Z+-].*)$/,timezoneZ:/^(Z)$/,timezoneHH:/^([+-])(\d{2})$/,timezoneHHMM:/^([+-])(\d{2}):?(\d{2})$/,timezoneIANA:/(UTC|(?:[a-zA-Z]+\/[a-zA-Z_-]+(?:\/[a-zA-Z_]+)?))$/};function h(e,t,n){var r,a,o;if(r=p.timezoneZ.exec(e),r)return 0;if(r=p.timezoneHH.exec(e),r)return o=parseInt(r[2],10),g()?(a=o*d,"+"===r[1]?-a:a):NaN;if(r=p.timezoneHHMM.exec(e),r){o=parseInt(r[2],10);var i=parseInt(r[3],10);return g(o,i)?(a=o*d+i*f,"+"===r[1]?-a:a):NaN}if(r=p.timezoneIANA.exec(e),r){t=new Date(t||Date.now());var s=n?t:v(t),c=b(s,e),u=n?c:m(t,c,e);return -u}return 0}function v(e){return new Date(Date.UTC(e.getFullYear(),e.getMonth(),e.getDate(),e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds()))}function b(e,t){var n=o(e,t),r=Date.UTC(n[0],n[1]-1,n[2],n[3]%24,n[4],n[5]),a=e.getTime(),i=a%1e3;return a-=i>=0?i:1e3+i,r-a}function m(e,t,n){var r=e.getTime(),a=r-t,o=b(new Date(a),n);if(t===o)return t;a-=o-t;var i=b(new Date(a),n);return o===i?o:Math.max(o,i)}function g(e,t){return null==t||!(t<0||t>59)}var y=36e5,w=6e4,x=2,D={dateTimeDelimeter:/[T ]/,plainTime:/:/,timeZoneDelimeter:/[Z ]/i,YY:/^(\d{2})$/,YYY:[/^([+-]\d{2})$/,/^([+-]\d{3})$/,/^([+-]\d{4})$/],YYYY:/^(\d{4})/,YYYYY:[/^([+-]\d{4})/,/^([+-]\d{5})/,/^([+-]\d{6})/],MM:/^-(\d{2})$/,DDD:/^-?(\d{3})$/,MMDD:/^-?(\d{2})-?(\d{2})$/,Www:/^-?W(\d{2})$/,WwwD:/^-?W(\d{2})-?(\d{1})$/,HH:/^(\d{2}([.,]\d*)?)$/,HHMM:/^(\d{2}):?(\d{2}([.,]\d*)?)$/,HHMMSS:/^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,timezone:/([Z+-].*| UTC|(?:[a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?))$/};function O(e,t){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");if(null===e)return new Date(NaN);var n=t||{},o=null==n.additionalDigits?x:Object(r["a"])(n.additionalDigits);if(2!==o&&1!==o&&0!==o)throw new RangeError("additionalDigits must be 0, 1 or 2");if(e instanceof Date||"object"===typeof e&&"[object Date]"===Object.prototype.toString.call(e))return new Date(e.getTime());if("number"===typeof e||"[object Number]"===Object.prototype.toString.call(e))return new Date(e);if("string"!==typeof e&&"[object String]"!==Object.prototype.toString.call(e))return new Date(NaN);var i=j(e),s=k(i.date,o),c=s.year,u=s.restDateString,l=M(u,c);if(isNaN(l))return new Date(NaN);if(l){var d,f=l.getTime(),p=0;if(i.time&&(p=P(i.time),isNaN(p)))return new Date(NaN);if(i.timezone||n.timeZone){if(d=h(i.timezone||n.timeZone,new Date(f+p)),isNaN(d))return new Date(NaN)}else d=a(new Date(f+p)),d=a(new Date(f+p+d));return new Date(f+p+d)}return new Date(NaN)}function j(e){var t,n={},r=e.split(D.dateTimeDelimeter);if(D.plainTime.test(r[0])?(n.date=null,t=r[0]):(n.date=r[0],t=r[1],n.timezone=r[2],D.timeZoneDelimeter.test(n.date)&&(n.date=e.split(D.timeZoneDelimeter)[0],t=e.substr(n.date.length,e.length))),t){var a=D.timezone.exec(t);a?(n.time=t.replace(a[1],""),n.timezone=a[1]):n.time=t;}return n}function k(e,t){var n,r=D.YYY[t],a=D.YYYYY[t];if(n=D.YYYY.exec(e)||a.exec(e),n){var o=n[1];return {year:parseInt(o,10),restDateString:e.slice(o.length)}}if(n=D.YY.exec(e)||r.exec(e),n){var i=n[1];return {year:100*parseInt(i,10),restDateString:e.slice(i.length)}}return {year:null}}function M(e,t){if(null===t)return null;var n,r,a,o;if(0===e.length)return r=new Date(0),r.setUTCFullYear(t),r;if(n=D.MM.exec(e),n)return r=new Date(0),a=parseInt(n[1],10)-1,I(t,a)?(r.setUTCFullYear(t,a),r):new Date(NaN);if(n=D.DDD.exec(e),n){r=new Date(0);var i=parseInt(n[1],10);return T(t,i)?(r.setUTCFullYear(t,0,i),r):new Date(NaN)}if(n=D.MMDD.exec(e),n){r=new Date(0),a=parseInt(n[1],10)-1;var s=parseInt(n[2],10);return I(t,a,s)?(r.setUTCFullYear(t,a,s),r):new Date(NaN)}if(n=D.Www.exec(e),n)return o=parseInt(n[1],10)-1,C(t,o)?Y(t,o):new Date(NaN);if(n=D.WwwD.exec(e),n){o=parseInt(n[1],10)-1;var c=parseInt(n[2],10)-1;return C(t,o,c)?Y(t,o,c):new Date(NaN)}return null}function P(e){var t,n,r;if(t=D.HH.exec(e),t)return n=parseFloat(t[1].replace(",",".")),$(n)?n%24*y:NaN;if(t=D.HHMM.exec(e),t)return n=parseInt(t[1],10),r=parseFloat(t[2].replace(",",".")),$(n,r)?n%24*y+r*w:NaN;if(t=D.HHMMSS.exec(e),t){n=parseInt(t[1],10),r=parseInt(t[2],10);var a=parseFloat(t[3].replace(",","."));return $(n,r,a)?n%24*y+r*w+1e3*a:NaN}return null}function Y(e,t,n){t=t||0,n=n||0;var r=new Date(0);r.setUTCFullYear(e,0,4);var a=r.getUTCDay()||7,o=7*t+n+1-a;return r.setUTCDate(r.getUTCDate()+o),r}var S=[31,28,31,30,31,30,31,31,30,31,30,31],_=[31,29,31,30,31,30,31,31,30,31,30,31];function E(e){return e%400===0||e%4===0&&e%100!==0}function I(e,t,n){if(t<0||t>11)return !1;if(null!=n){if(n<1)return !1;var r=E(e);if(r&&n>_[t])return !1;if(!r&&n>S[t])return !1}return !0}function T(e,t){if(t<1)return !1;var n=E(e);return !(n&&t>366)&&!(!n&&t>365)}function C(e,t,n){return !(t<0||t>52)&&(null==n||!(n<0||n>6))}function $(e,t,n){return (null==e||!(e<0||e>=25))&&((null==t||!(t<0||t>=60))&&(null==n||!(n<0||n>=60)))}var A=n("fd3a"),N=n("8c86");function F(e,t){Object(N["a"])(1,arguments);var n=t||{},a=n.locale,o=a&&a.options&&a.options.weekStartsOn,i=null==o?0:Object(r["a"])(o),s=null==n.weekStartsOn?i:Object(r["a"])(n.weekStartsOn);if(!(s>=0&&s<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");var c=Object(A["a"])(e),u=c.getDay(),l=(u<s?7:0)+u-s;return c.setDate(c.getDate()-l),c.setHours(0,0,0,0),c}function z(e){return Object(N["a"])(1,arguments),F(e,{weekStartsOn:1})}function L(e){Object(N["a"])(1,arguments);var t=Object(A["a"])(e),n=t.getFullYear(),r=new Date(0);r.setFullYear(n+1,0,4),r.setHours(0,0,0,0);var a=z(r),o=new Date(0);o.setFullYear(n,0,4),o.setHours(0,0,0,0);var i=z(o);return t.getTime()>=a.getTime()?n+1:t.getTime()>=i.getTime()?n:n-1}function H(e){Object(N["a"])(1,arguments);var t=L(e),n=new Date(0);n.setFullYear(t,0,4),n.setHours(0,0,0,0);var r=z(n);return r}var R=6048e5;function W(e){Object(N["a"])(1,arguments);var t=Object(A["a"])(e),n=z(t).getTime()-H(t).getTime();return Math.round(n/R)+1}function V(e,t){var n,a;Object(N["a"])(1,arguments);var o=Object(A["a"])(e),i=o.getFullYear(),s=null===t||void 0===t||null===(n=t.locale)||void 0===n||null===(a=n.options)||void 0===a?void 0:a.firstWeekContainsDate,c=null==s?1:Object(r["a"])(s),u=null==(null===t||void 0===t?void 0:t.firstWeekContainsDate)?c:Object(r["a"])(t.firstWeekContainsDate);if(!(u>=1&&u<=7))throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var l=new Date(0);l.setFullYear(i+1,0,u),l.setHours(0,0,0,0);var d=F(l,t),f=new Date(0);f.setFullYear(i,0,u),f.setHours(0,0,0,0);var p=F(f,t);return o.getTime()>=d.getTime()?i+1:o.getTime()>=p.getTime()?i:i-1}function U(e,t){Object(N["a"])(1,arguments);var n=t||{},a=n.locale,o=a&&a.options&&a.options.firstWeekContainsDate,i=null==o?1:Object(r["a"])(o),s=null==n.firstWeekContainsDate?i:Object(r["a"])(n.firstWeekContainsDate),c=V(e,t),u=new Date(0);u.setFullYear(c,0,s),u.setHours(0,0,0,0);var l=F(u,t);return l}var B=6048e5;function Z(e,t){Object(N["a"])(1,arguments);var n=Object(A["a"])(e),r=F(n,t).getTime()-U(n,t).getTime();return Math.round(r/B)+1}var q=6048e5;function G(e,t,n){Object(N["a"])(2,arguments);var r=F(e,n),o=F(t,n),i=r.getTime()-a(r),s=o.getTime()-a(o);return Math.round((i-s)/q)}function K(e){Object(N["a"])(1,arguments);var t=Object(A["a"])(e),n=t.getMonth();return t.setFullYear(t.getFullYear(),n+1,0),t.setHours(0,0,0,0),t}function X(e){Object(N["a"])(1,arguments);var t=Object(A["a"])(e);return t.setDate(1),t.setHours(0,0,0,0),t}function J(e,t){return Object(N["a"])(1,arguments),G(K(e),X(e),t)+1}var Q=n("f7f1"),ee=n("cfe5"),te=n("f15d"),ne=n("2fa3"),re=n("9404");const ae={DATE_TIME:1,DATE:2,TIME:3},oe={1:["year","month","day","hours","minutes","seconds","milliseconds"],2:["year","month","day"],3:["hours","minutes","seconds","milliseconds"]},ie=/d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g,se=/\d\d?/,ce=/\d{3}/,ue=/\d{4}/,le=/[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i,de=/\[([^]*?)\]/gm,fe=function(){},pe=function(e){return function(t,n,r){const a=r[e].indexOf(n.charAt(0).toUpperCase()+n.substr(1).toLowerCase());~a&&(t.month=a);}},he=["L","iso"],ve=7,be=[31,28,31,30,31,30,31,31,30,31,30,31],me=[{value:0,label:"00"},{value:1,label:"01"},{value:2,label:"02"},{value:3,label:"03"},{value:4,label:"04"},{value:5,label:"05"},{value:6,label:"06"},{value:7,label:"07"},{value:8,label:"08"},{value:9,label:"09"},{value:10,label:"10"},{value:11,label:"11"},{value:12,label:"12"},{value:13,label:"13"},{value:14,label:"14"},{value:15,label:"15"},{value:16,label:"16"},{value:17,label:"17"},{value:18,label:"18"},{value:19,label:"19"},{value:20,label:"20"},{value:21,label:"21"},{value:22,label:"22"},{value:23,label:"23"}],ge={D(e){return e.day},DD(e){return Object(ne["m"])(e.day)},Do(e,t){return t.DoFn(e.day)},d(e){return e.weekday-1},dd(e){return Object(ne["m"])(e.weekday-1)},W(e,t){return t.dayNamesNarrow[e.weekday-1]},WW(e,t){return t.dayNamesShorter[e.weekday-1]},WWW(e,t){return t.dayNamesShort[e.weekday-1]},WWWW(e,t){return t.dayNames[e.weekday-1]},M(e){return e.month},MM(e){return Object(ne["m"])(e.month)},MMM(e,t){return t.monthNamesShort[e.month-1]},MMMM(e,t){return t.monthNames[e.month-1]},YY(e){return String(e.year).substr(2)},YYYY(e){return Object(ne["m"])(e.year,4)},h(e){return e.hours%12||12},hh(e){return Object(ne["m"])(e.hours%12||12)},H(e){return e.hours},HH(e){return Object(ne["m"])(e.hours)},m(e){return e.minutes},mm(e){return Object(ne["m"])(e.minutes)},s(e){return e.seconds},ss(e){return Object(ne["m"])(e.seconds)},S(e){return Math.round(e.milliseconds/100)},SS(e){return Object(ne["m"])(Math.round(e.milliseconds/10),2)},SSS(e){return Object(ne["m"])(e.milliseconds,3)},a(e,t){return e.hours<12?t.amPm[0]:t.amPm[1]},A(e,t){return e.hours<12?t.amPm[0].toUpperCase():t.amPm[1].toUpperCase()},Z(){return "Z"},ZZ(e){const t=e.timezoneOffset;return `${t>0?"-":"+"}${Object(ne["m"])(Math.floor(Math.abs(t)/60),2)}`},ZZZ(e){const t=e.timezoneOffset;return `${t>0?"-":"+"}${Object(ne["m"])(100*Math.floor(Math.abs(t)/60)+Math.abs(t)%60,4)}`},ZZZZ(e){const t=e.timezoneOffset;return `${t>0?"-":"+"}${Object(ne["m"])(Math.floor(Math.abs(t)/60),2)}:${Object(ne["m"])(Math.abs(t)%60,2)}`}},ye={D:[se,function(e,t){e.day=t;}],Do:[new RegExp(se.source+le.source),function(e,t){e.day=parseInt(t,10);}],d:[se,fe],W:[le,fe],M:[se,function(e,t){e.month=t-1;}],MMM:[le,pe("monthNamesShort")],MMMM:[le,pe("monthNames")],YY:[se,function(e,t){const n=new Date,r=+n.getFullYear().toString().substr(0,2);e.year=`${t>68?r-1:r}${t}`;}],YYYY:[ue,function(e,t){e.year=t;}],S:[/\d/,function(e,t){e.millisecond=100*t;}],SS:[/\d{2}/,function(e,t){e.millisecond=10*t;}],SSS:[ce,function(e,t){e.millisecond=t;}],h:[se,function(e,t){e.hour=t;}],m:[se,function(e,t){e.minute=t;}],s:[se,function(e,t){e.second=t;}],a:[le,function(e,t,n){const r=t.toLowerCase();r===n.amPm[0]?e.isPm=!1:r===n.amPm[1]&&(e.isPm=!0);}],Z:[/[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,function(e,t){"Z"===t&&(t="+00:00");const n=(""+t).match(/([+-]|\d\d)/gi);if(n){const t=60*n[1]+parseInt(n[2],10);e.timezoneOffset="+"===n[0]?t:-t;}}]};function we(e,t){const n=(new Intl.DateTimeFormat).resolvedOptions().locale;let r;Object(re["n"])(e)?r=e:Object(re["e"])(e,"id")&&(r=e.id),r=(r||n).toLowerCase();const a=Object.keys(t),o=function(e){return a.find((function(t){return t.toLowerCase()===e}))};r=o(r)||o(r.substring(0,2))||n;const i={...t["en-IE"],...t[r],id:r};return e=Object(re["m"])(e)?Object(re["c"])(e,i):i,e}ye.DD=ye.D,ye.dd=ye.d,ye.WWWW=ye.WWW=ye.WW=ye.W,ye.MM=ye.M,ye.mm=ye.m,ye.hh=ye.H=ye.HH=ye.h,ye.ss=ye.s,ye.A=ye.a,ye.ZZZZ=ye.ZZZ=ye.ZZ=ye.Z;class xe{constructor(e,{locales:t=te["a"],timezone:n}={}){const{id:r,firstDayOfWeek:a,masks:o}=we(e,t);this.id=r,this.daysInWeek=ve,this.firstDayOfWeek=Object(re["a"])(a,1,ve),this.masks=o,this.timezone=n||void 0,this.dayNames=this.getDayNames("long"),this.dayNamesShort=this.getDayNames("short"),this.dayNamesShorter=this.dayNamesShort.map((function(e){return e.substring(0,2)})),this.dayNamesNarrow=this.getDayNames("narrow"),this.monthNames=this.getMonthNames("long"),this.monthNamesShort=this.getMonthNames("short"),this.amPm=["am","pm"],this.monthData={},this.getMonthComps=this.getMonthComps.bind(this),this.parse=this.parse.bind(this),this.format=this.format.bind(this),this.toPage=this.toPage.bind(this);}format(e,t){var n=this;if(e=this.normalizeDate(e),!e)return "";t=this.normalizeMasks(t)[0];const r=[];t=t.replace(de,(function(e,t){return r.push(t),"??"}));const a=/Z$/.test(t)?"utc":this.timezone,o=this.getDateParts(e,a);return t=t.replace(ie,(function(e){return e in ge?ge[e](o,n):e.slice(1,e.length-1)})),t.replace(/\?\?/g,(function(){return r.shift()}))}parse(e,t){var n=this;const r=this.normalizeMasks(t);return r.map((function(t){if("string"!==typeof t)throw new Error("Invalid mask in fecha.parse");let r=e;if(r.length>1e3)return !1;let a=!0;const o={};if(t.replace(ie,(function(e){if(ye[e]){const t=ye[e],i=r.search(t[0]);~i?r.replace(t[0],(function(e){return t[1](o,e,n),r=r.substr(i+e.length),e})):a=!1;}return ye[e]?"":e.slice(1,e.length-1)})),!a)return !1;const i=new Date;let s;return !0===o.isPm&&null!=o.hour&&12!==+o.hour?o.hour=+o.hour+12:!1===o.isPm&&12===+o.hour&&(o.hour=0),null!=o.timezoneOffset?(o.minute=+(o.minute||0)-+o.timezoneOffset,s=new Date(Date.UTC(o.year||i.getFullYear(),o.month||0,o.day||1,o.hour||0,o.minute||0,o.second||0,o.millisecond||0))):s=n.getDateFromParts({year:o.year||i.getFullYear(),month:(o.month||0)+1,day:o.day||1,hours:o.hour||0,minutes:o.minute||0,seconds:o.second||0,milliseconds:o.millisecond||0}),s})).find((function(e){return e}))||new Date(e)}normalizeMasks(e){var t=this;return (Object(ne["b"])(e)&&e||[Object(re["n"])(e)&&e||"YYYY-MM-DD"]).map((function(e){return he.reduce((function(e,n){return e.replace(n,t.masks[n]||"")}),e)}))}normalizeDate(e,t={}){let n=null,{type:r,fillDate:a}=t;const{mask:o,patch:i,time:s}=t,c="auto"===r||!r;if(Object(re["l"])(e)?(r="number",n=new Date(+e)):Object(re["n"])(e)?(r="string",n=e?this.parse(e,o||"iso"):null):Object(re["m"])(e)?(r="object",n=this.getDateFromParts(e)):(r="date",n=Object(re["j"])(e)?new Date(e.getTime()):null),n&&i){a=null==a?new Date:this.normalizeDate(a);const e={...this.getDateParts(a),...Object(re["t"])(this.getDateParts(n),oe[i])};n=this.getDateFromParts(e);}return c&&(t.type=r),n&&!isNaN(n.getTime())?(s&&(n=this.adjustTimeForDate(n,{timeAdjust:s})),n):null}denormalizeDate(e,{type:t,mask:n}={}){switch(t){case"number":return e?e.getTime():NaN;case"string":return e?this.format(e,n||"iso"):"";default:return e?new Date(e):null}}hourIsValid(e,t,n){if(!t)return !0;if(Object(re["h"])(t))return t.includes(e);if(Object(re["m"])(t)){const n=t.min||0,r=t.max||24;return n<=e&&r>=e}return t(e,n)}getHourOptions(e,t){var n=this;return me.filter((function(r){return n.hourIsValid(r.value,e,t)}))}getMinuteOptions(e){const t=[];e=e>0?e:1;for(let n=0;n<=59;n+=e)t.push({value:n,label:Object(ne["m"])(n,2)});return t}nearestOptionValue(e,t){if(null==e)return e;const n=t.reduce((function(t,n){if(n.disabled)return t;if(isNaN(t))return n.value;const r=Math.abs(t-e),a=Math.abs(n.value-e);return a<r?n.value:t}),NaN);return isNaN(n)?e:n}adjustTimeForDate(e,{timeAdjust:t,validHours:n,minuteIncrement:r}){if(!t&&!n&&!r)return e;const a=this.getDateParts(e);if(t)if("now"===t){const e=this.getDateParts(new Date);a.hours=e.hours,a.minutes=e.minutes,a.seconds=e.seconds,a.milliseconds=e.milliseconds;}else{const e=new Date(`2000-01-01T${t}Z`);a.hours=e.getUTCHours(),a.minutes=e.getUTCMinutes(),a.seconds=e.getUTCSeconds(),a.milliseconds=e.getUTCMilliseconds();}if(n){const e=this.getHourOptions(n,a);a.hours=this.nearestOptionValue(a.hours,e);}if(r){const e=this.getMinuteOptions(r);a.minutes=this.nearestOptionValue(a.minutes,e);}return e=this.getDateFromParts(a),e}normalizeDates(e,t){return t=t||{},t.locale=this,(Object(re["h"])(e)?e:[e]).map((function(e){return e&&(e instanceof ee["a"]?e:new ee["a"](e,t))})).filter((function(e){return e}))}getDateParts(e,t=this.timezone){if(!e)return null;let n=e;if(t){const r=new Date(e.toLocaleString("en-US",{timeZone:t}));r.setMilliseconds(e.getMilliseconds());const a=r.getTime()-e.getTime();n=new Date(e.getTime()+a);}const r=n.getMilliseconds(),a=n.getSeconds(),o=n.getMinutes(),i=n.getHours(),s=n.getMonth()+1,c=n.getFullYear(),u=this.getMonthComps(s,c),l=n.getDate(),d=u.days-l+1,f=n.getDay()+1,p=Math.floor((l-1)/7+1),h=Math.floor((u.days-l)/7+1),v=Math.ceil((l+Math.abs(u.firstWeekday-u.firstDayOfWeek))/7),b=u.weeks-v+1,m={milliseconds:r,seconds:a,minutes:o,hours:i,day:l,dayFromEnd:d,weekday:f,weekdayOrdinal:p,weekdayOrdinalFromEnd:h,week:v,weekFromEnd:b,month:s,year:c,date:e,isValid:!0};return m.timezoneOffset=this.getTimezoneOffset(m),m}getDateFromParts(e){if(!e)return null;const t=new Date,{year:n=t.getFullYear(),month:r=t.getMonth()+1,day:a=t.getDate(),hours:o=0,minutes:i=0,seconds:s=0,milliseconds:c=0}=e;if(this.timezone){const e=`${Object(ne["m"])(n,4)}-${Object(ne["m"])(r,2)}-${Object(ne["m"])(a,2)}T${Object(ne["m"])(o,2)}:${Object(ne["m"])(i,2)}:${Object(ne["m"])(s,2)}.${Object(ne["m"])(c,3)}`;return O(e,{timeZone:this.timezone})}return new Date(n,r-1,a,o,i,s,c)}getTimezoneOffset(e){const{year:t,month:n,day:r,hours:a=0,minutes:o=0,seconds:i=0,milliseconds:s=0}=e;let c;const u=new Date(Date.UTC(t,n-1,r,a,o,i,s));if(this.timezone){const e=`${Object(ne["m"])(t,4)}-${Object(ne["m"])(n,2)}-${Object(ne["m"])(r,2)}T${Object(ne["m"])(a,2)}:${Object(ne["m"])(o,2)}:${Object(ne["m"])(i,2)}.${Object(ne["m"])(s,3)}`;c=O(e,{timeZone:this.timezone});}else c=new Date(t,n-1,r,a,o,i,s);return (c-u)/6e4}toPage(e,t){return Object(re["l"])(e)?Object(ne["a"])(t,e):Object(re["n"])(e)?this.getDateParts(this.normalizeDate(e)):Object(re["j"])(e)?this.getDateParts(e):Object(re["m"])(e)?e:null}getMonthDates(e=2e3){const t=[];for(let n=0;n<12;n++)t.push(new Date(e,n,15));return t}getMonthNames(e){const t=new Intl.DateTimeFormat(this.id,{month:e,timezome:"UTC"});return this.getMonthDates().map((function(e){return t.format(e)}))}getWeekdayDates(e=this.firstDayOfWeek){const t=[],n=2020,r=1,a=5+e-1;for(let o=0;o<ve;o++)t.push(this.getDateFromParts({year:n,month:r,day:a+o,hours:12}));return t}getDayNames(e){const t=new Intl.DateTimeFormat(this.id,{weekday:e,timeZone:this.timezone});return this.getWeekdayDates(1).map((function(e){return t.format(e)}))}getMonthComps(e,t){const n=`${e}-${t}`;let r=this.monthData[n];if(!r){const a=t%4===0&&t%100!==0||t%400===0,o=new Date(t,e-1,1),i=o.getDay()+1,s=2===e&&a?29:be[e-1],c=this.firstDayOfWeek-1,u=J(o,{weekStartsOn:c}),l=[],d=[];for(let e=0;e<u;e++){const t=Object(Q["a"])(o,7*e);l.push(Z(t,{weekStartsOn:c})),d.push(W(t));}r={firstDayOfWeek:this.firstDayOfWeek,inLeapYear:a,firstWeekday:i,days:s,weeks:u,month:e,year:t,weeknumbers:l,isoWeeknumbers:d},this.monthData[n]=r;}return r}getThisMonthComps(){const{month:e,year:t}=this.getDateParts(new Date);return this.getMonthComps(e,t)}getPrevMonthComps(e,t){return 1===e?this.getMonthComps(12,t-1):this.getMonthComps(e-1,t)}getNextMonthComps(e,t){return 12===e?this.getMonthComps(1,t+1):this.getMonthComps(e+1,t)}getDayId(e){return this.format(e,"YYYY-MM-DD")}getCalendarDays({weeks:e,monthComps:t,prevMonthComps:n,nextMonthComps:r}){var a=this;const o=[],{firstDayOfWeek:i,firstWeekday:s,isoWeeknumbers:c,weeknumbers:u}=t,l=s+(s<i?ve:0)-i;let d=!0,f=!1,p=!1;const h=new Intl.DateTimeFormat(this.id,{weekday:"long",year:"numeric",month:"long",day:"numeric"});let v=n.days-l+1,b=n.days-v+1,m=Math.floor((v-1)/ve+1),g=1,y=n.weeks,w=1,x=n.month,D=n.year;const O=new Date,j=O.getDate(),k=O.getMonth()+1,M=O.getFullYear(),P=function(e,t,n){return function(r,o,i,s){return a.normalizeDate({year:e,month:t,day:n,hours:r,minutes:o,seconds:i,milliseconds:s})}};for(let Y=1;Y<=e;Y++){for(let n=1,a=i;n<=ve;n++,a+=a===ve?1-ve:1){d&&a===s&&(v=1,b=t.days,m=Math.floor((v-1)/ve+1),g=Math.floor((t.days-v)/ve+1),y=1,w=t.weeks,x=t.month,D=t.year,d=!1,f=!0);const i=P(D,x,v),l={start:i(0,0,0),end:i(23,59,59,999)},O=l.start,S=`${Object(ne["m"])(D,4)}-${Object(ne["m"])(x,2)}-${Object(ne["m"])(v,2)}`,_=n,E=ve-n,I=u[Y-1],T=c[Y-1],C=v===j&&x===k&&D===M,$=f&&1===v,A=f&&v===t.days,N=1===Y,F=Y===e,z=1===n,L=n===ve;o.push({id:S,label:v.toString(),ariaLabel:h.format(new Date(D,x-1,v)),day:v,dayFromEnd:b,weekday:a,weekdayPosition:_,weekdayPositionFromEnd:E,weekdayOrdinal:m,weekdayOrdinalFromEnd:g,week:y,weekFromEnd:w,weeknumber:I,isoWeeknumber:T,month:x,year:D,dateFromTime:i,date:O,range:l,isToday:C,isFirstDay:$,isLastDay:A,inMonth:f,inPrevMonth:d,inNextMonth:p,onTop:N,onBottom:F,onLeft:z,onRight:L,classes:["id-"+S,"day-"+v,"day-from-end-"+b,"weekday-"+a,"weekday-position-"+_,"weekday-ordinal-"+m,"weekday-ordinal-from-end-"+g,"week-"+y,"week-from-end-"+w,{"is-today":C,"is-first-day":$,"is-last-day":A,"in-month":f,"in-prev-month":d,"in-next-month":p,"on-top":N,"on-bottom":F,"on-left":z,"on-right":L}]}),f&&A?(f=!1,p=!0,v=1,b=r.days,m=1,g=Math.floor((r.days-v)/ve+1),y=1,w=r.weeks,x=r.month,D=r.year):(v++,b--,m=Math.floor((v-1)/ve+1),g=Math.floor((t.days-v)/ve+1));}y++,w--;}return o}}},"29f3":function(e,t){var n=Object.prototype,r=n.toString;function a(e){return r.call(e)}e.exports=a;},"2a4d":function(e,t,n){var r=n("7dfe");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("99a6e87a",r,!0,{sourceMap:!1,shadowMode:!1});},"2af9":function(e,t,n){n.r(t),n.d(t,"Calendar",(function(){return Sn})),n.d(t,"CalendarNav",(function(){return Xt})),n.d(t,"DatePicker",(function(){return Qn})),n.d(t,"Popover",(function(){return vt}));n("ddb0");var r=n("f7f1"),a=n("fe1f"),o=n("fd3a"),i=n("8c86");function s(e,t){Object(i["a"])(2,arguments);var n=Object(o["a"])(e),r=Object(a["a"])(t);if(isNaN(r))return new Date(NaN);if(!r)return n;var s=n.getDate(),c=new Date(n.getTime());c.setMonth(n.getMonth()+r+1,0);var u=c.getDate();return s>=u?c:(n.setFullYear(c.getFullYear(),c.getMonth(),s),n)}function c(e,t){Object(i["a"])(2,arguments);var n=Object(a["a"])(t);return s(e,12*n)}function u(e){var t=e.getBoundingClientRect();return {width:t.width,height:t.height,top:t.top,right:t.right,bottom:t.bottom,left:t.left,x:t.left,y:t.top}}function l(e){if("[object Window]"!==e.toString()){var t=e.ownerDocument;return t&&t.defaultView||window}return e}function d(e){var t=l(e),n=t.pageXOffset,r=t.pageYOffset;return {scrollLeft:n,scrollTop:r}}function f(e){var t=l(e).Element;return e instanceof t||e instanceof Element}function p(e){var t=l(e).HTMLElement;return e instanceof t||e instanceof HTMLElement}function h(e){var t=l(e).ShadowRoot;return e instanceof t||e instanceof ShadowRoot}function v(e){return {scrollLeft:e.scrollLeft,scrollTop:e.scrollTop}}function b(e){return e!==l(e)&&p(e)?v(e):d(e)}function m(e){return e?(e.nodeName||"").toLowerCase():null}function g(e){return ((f(e)?e.ownerDocument:e.document)||window.document).documentElement}function y(e){return u(g(e)).left+d(e).scrollLeft}function w(e){return l(e).getComputedStyle(e)}function x(e){var t=w(e),n=t.overflow,r=t.overflowX,a=t.overflowY;return /auto|scroll|overlay|hidden/.test(n+a+r)}function D(e,t,n){void 0===n&&(n=!1);var r=g(t),a=u(e),o=p(t),i={scrollLeft:0,scrollTop:0},s={x:0,y:0};return (o||!o&&!n)&&(("body"!==m(t)||x(r))&&(i=b(t)),p(t)?(s=u(t),s.x+=t.clientLeft,s.y+=t.clientTop):r&&(s.x=y(r))),{x:a.left+i.scrollLeft-s.x,y:a.top+i.scrollTop-s.y,width:a.width,height:a.height}}function O(e){return {x:e.offsetLeft,y:e.offsetTop,width:e.offsetWidth,height:e.offsetHeight}}function j(e){return "html"===m(e)?e:e.assignedSlot||e.parentNode||e.host||g(e)}function k(e){return ["html","body","#document"].indexOf(m(e))>=0?e.ownerDocument.body:p(e)&&x(e)?e:k(j(e))}function M(e,t){void 0===t&&(t=[]);var n=k(e),r="body"===m(n),a=l(n),o=r?[a].concat(a.visualViewport||[],x(n)?n:[]):n,i=t.concat(o);return r?i:i.concat(M(j(o)))}function P(e){return ["table","td","th"].indexOf(m(e))>=0}function Y(e){if(!p(e)||"fixed"===w(e).position)return null;var t=e.offsetParent;if(t){var n=g(t);if("body"===m(t)&&"static"===w(t).position&&"static"!==w(n).position)return n}return t}function S(e){var t=j(e);while(p(t)&&["html","body"].indexOf(m(t))<0){var n=w(t);if("none"!==n.transform||"none"!==n.perspective||n.willChange&&"auto"!==n.willChange)return t;t=t.parentNode;}return null}function _(e){var t=l(e),n=Y(e);while(n&&P(n)&&"static"===w(n).position)n=Y(n);return n&&"body"===m(n)&&"static"===w(n).position?t:n||S(e)||t}var E="top",I="bottom",T="right",C="left",$="auto",A=[E,I,T,C],N="start",F="end",z="clippingParents",L="viewport",H="popper",R="reference",W=A.reduce((function(e,t){return e.concat([t+"-"+N,t+"-"+F])}),[]),V=[].concat(A,[$]).reduce((function(e,t){return e.concat([t,t+"-"+N,t+"-"+F])}),[]),U="beforeRead",B="read",Z="afterRead",q="beforeMain",G="main",K="afterMain",X="beforeWrite",J="write",Q="afterWrite",ee=[U,B,Z,q,G,K,X,J,Q];function te(e){var t=new Map,n=new Set,r=[];function a(e){n.add(e.name);var o=[].concat(e.requires||[],e.requiresIfExists||[]);o.forEach((function(e){if(!n.has(e)){var r=t.get(e);r&&a(r);}})),r.push(e);}return e.forEach((function(e){t.set(e.name,e);})),e.forEach((function(e){n.has(e.name)||a(e);})),r}function ne(e){var t=te(e);return ee.reduce((function(e,n){return e.concat(t.filter((function(e){return e.phase===n})))}),[])}function re(e){var t;return function(){return t||(t=new Promise((function(n){Promise.resolve().then((function(){t=void 0,n(e());}));}))),t}}function ae(e){var t=e.reduce((function(e,t){var n=e[t.name];return e[t.name]=n?Object.assign(Object.assign(Object.assign({},n),t),{},{options:Object.assign(Object.assign({},n.options),t.options),data:Object.assign(Object.assign({},n.data),t.data)}):t,e}),{});return Object.keys(t).map((function(e){return t[e]}))}var oe={placement:"bottom",modifiers:[],strategy:"absolute"};function ie(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return !t.some((function(e){return !(e&&"function"===typeof e.getBoundingClientRect)}))}function se(e){void 0===e&&(e={});var t=e,n=t.defaultModifiers,r=void 0===n?[]:n,a=t.defaultOptions,o=void 0===a?oe:a;return function(e,t,n){void 0===n&&(n=o);var a={placement:"bottom",orderedModifiers:[],options:Object.assign(Object.assign({},oe),o),modifiersData:{},elements:{reference:e,popper:t},attributes:{},styles:{}},i=[],s=!1,c={state:a,setOptions:function(n){l(),a.options=Object.assign(Object.assign(Object.assign({},o),a.options),n),a.scrollParents={reference:f(e)?M(e):e.contextElement?M(e.contextElement):[],popper:M(t)};var i=ne(ae([].concat(r,a.options.modifiers)));return a.orderedModifiers=i.filter((function(e){return e.enabled})),u(),c.update()},forceUpdate:function(){if(!s){var e=a.elements,t=e.reference,n=e.popper;if(ie(t,n)){a.rects={reference:D(t,_(n),"fixed"===a.options.strategy),popper:O(n)},a.reset=!1,a.placement=a.options.placement,a.orderedModifiers.forEach((function(e){return a.modifiersData[e.name]=Object.assign({},e.data)}));for(var r=0;r<a.orderedModifiers.length;r++)if(!0!==a.reset){var o=a.orderedModifiers[r],i=o.fn,u=o.options,l=void 0===u?{}:u,d=o.name;"function"===typeof i&&(a=i({state:a,options:l,name:d,instance:c})||a);}else a.reset=!1,r=-1;}}},update:re((function(){return new Promise((function(e){c.forceUpdate(),e(a);}))})),destroy:function(){l(),s=!0;}};if(!ie(e,t))return c;function u(){a.orderedModifiers.forEach((function(e){var t=e.name,n=e.options,r=void 0===n?{}:n,o=e.effect;if("function"===typeof o){var s=o({state:a,name:t,instance:c,options:r}),u=function(){};i.push(s||u);}}));}function l(){i.forEach((function(e){return e()})),i=[];}return c.setOptions(n).then((function(e){!s&&n.onFirstUpdate&&n.onFirstUpdate(e);})),c}}var ce={passive:!0};function ue(e){var t=e.state,n=e.instance,r=e.options,a=r.scroll,o=void 0===a||a,i=r.resize,s=void 0===i||i,c=l(t.elements.popper),u=[].concat(t.scrollParents.reference,t.scrollParents.popper);return o&&u.forEach((function(e){e.addEventListener("scroll",n.update,ce);})),s&&c.addEventListener("resize",n.update,ce),function(){o&&u.forEach((function(e){e.removeEventListener("scroll",n.update,ce);})),s&&c.removeEventListener("resize",n.update,ce);}}var le={name:"eventListeners",enabled:!0,phase:"write",fn:function(){},effect:ue,data:{}};function de(e){return e.split("-")[0]}function fe(e){return e.split("-")[1]}function pe(e){return ["top","bottom"].indexOf(e)>=0?"x":"y"}function he(e){var t,n=e.reference,r=e.element,a=e.placement,o=a?de(a):null,i=a?fe(a):null,s=n.x+n.width/2-r.width/2,c=n.y+n.height/2-r.height/2;switch(o){case E:t={x:s,y:n.y-r.height};break;case I:t={x:s,y:n.y+n.height};break;case T:t={x:n.x+n.width,y:c};break;case C:t={x:n.x-r.width,y:c};break;default:t={x:n.x,y:n.y};}var u=o?pe(o):null;if(null!=u){var l="y"===u?"height":"width";switch(i){case N:t[u]=Math.floor(t[u])-Math.floor(n[l]/2-r[l]/2);break;case F:t[u]=Math.floor(t[u])+Math.ceil(n[l]/2-r[l]/2);break;default:}}return t}function ve(e){var t=e.state,n=e.name;t.modifiersData[n]=he({reference:t.rects.reference,element:t.rects.popper,strategy:"absolute",placement:t.placement});}var be={name:"popperOffsets",enabled:!0,phase:"read",fn:ve,data:{}},me={top:"auto",right:"auto",bottom:"auto",left:"auto"};function ge(e){var t=e.x,n=e.y,r=window,a=r.devicePixelRatio||1;return {x:Math.round(t*a)/a||0,y:Math.round(n*a)/a||0}}function ye(e){var t,n=e.popper,r=e.popperRect,a=e.placement,o=e.offsets,i=e.position,s=e.gpuAcceleration,c=e.adaptive,u=ge(o),d=u.x,f=u.y,p=o.hasOwnProperty("x"),h=o.hasOwnProperty("y"),v=C,b=E,m=window;if(c){var y=_(n);y===l(n)&&(y=g(n)),a===E&&(b=I,f-=y.clientHeight-r.height,f*=s?1:-1),a===C&&(v=T,d-=y.clientWidth-r.width,d*=s?1:-1);}var w,x=Object.assign({position:i},c&&me);return s?Object.assign(Object.assign({},x),{},(w={},w[b]=h?"0":"",w[v]=p?"0":"",w.transform=(m.devicePixelRatio||1)<2?"translate("+d+"px, "+f+"px)":"translate3d("+d+"px, "+f+"px, 0)",w)):Object.assign(Object.assign({},x),{},(t={},t[b]=h?f+"px":"",t[v]=p?d+"px":"",t.transform="",t))}function we(e){var t=e.state,n=e.options,r=n.gpuAcceleration,a=void 0===r||r,o=n.adaptive,i=void 0===o||o,s={placement:de(t.placement),popper:t.elements.popper,popperRect:t.rects.popper,gpuAcceleration:a};null!=t.modifiersData.popperOffsets&&(t.styles.popper=Object.assign(Object.assign({},t.styles.popper),ye(Object.assign(Object.assign({},s),{},{offsets:t.modifiersData.popperOffsets,position:t.options.strategy,adaptive:i})))),null!=t.modifiersData.arrow&&(t.styles.arrow=Object.assign(Object.assign({},t.styles.arrow),ye(Object.assign(Object.assign({},s),{},{offsets:t.modifiersData.arrow,position:"absolute",adaptive:!1})))),t.attributes.popper=Object.assign(Object.assign({},t.attributes.popper),{},{"data-popper-placement":t.placement});}var xe={name:"computeStyles",enabled:!0,phase:"beforeWrite",fn:we,data:{}};function De(e){var t=e.state;Object.keys(t.elements).forEach((function(e){var n=t.styles[e]||{},r=t.attributes[e]||{},a=t.elements[e];p(a)&&m(a)&&(Object.assign(a.style,n),Object.keys(r).forEach((function(e){var t=r[e];!1===t?a.removeAttribute(e):a.setAttribute(e,!0===t?"":t);})));}));}function Oe(e){var t=e.state,n={popper:{position:t.options.strategy,left:"0",top:"0",margin:"0"},arrow:{position:"absolute"},reference:{}};return Object.assign(t.elements.popper.style,n.popper),t.elements.arrow&&Object.assign(t.elements.arrow.style,n.arrow),function(){Object.keys(t.elements).forEach((function(e){var r=t.elements[e],a=t.attributes[e]||{},o=Object.keys(t.styles.hasOwnProperty(e)?t.styles[e]:n[e]),i=o.reduce((function(e,t){return e[t]="",e}),{});p(r)&&m(r)&&(Object.assign(r.style,i),Object.keys(a).forEach((function(e){r.removeAttribute(e);})));}));}}var je={name:"applyStyles",enabled:!0,phase:"write",fn:De,effect:Oe,requires:["computeStyles"]};function ke(e,t,n){var r=de(e),a=[C,E].indexOf(r)>=0?-1:1,o="function"===typeof n?n(Object.assign(Object.assign({},t),{},{placement:e})):n,i=o[0],s=o[1];return i=i||0,s=(s||0)*a,[C,T].indexOf(r)>=0?{x:s,y:i}:{x:i,y:s}}function Me(e){var t=e.state,n=e.options,r=e.name,a=n.offset,o=void 0===a?[0,0]:a,i=V.reduce((function(e,n){return e[n]=ke(n,t.rects,o),e}),{}),s=i[t.placement],c=s.x,u=s.y;null!=t.modifiersData.popperOffsets&&(t.modifiersData.popperOffsets.x+=c,t.modifiersData.popperOffsets.y+=u),t.modifiersData[r]=i;}var Pe={name:"offset",enabled:!0,phase:"main",requires:["popperOffsets"],fn:Me},Ye={left:"right",right:"left",bottom:"top",top:"bottom"};function Se(e){return e.replace(/left|right|bottom|top/g,(function(e){return Ye[e]}))}var _e={start:"end",end:"start"};function Ee(e){return e.replace(/start|end/g,(function(e){return _e[e]}))}function Ie(e){var t=l(e),n=g(e),r=t.visualViewport,a=n.clientWidth,o=n.clientHeight,i=0,s=0;return r&&(a=r.width,o=r.height,/^((?!chrome|android).)*safari/i.test(navigator.userAgent)||(i=r.offsetLeft,s=r.offsetTop)),{width:a,height:o,x:i+y(e),y:s}}function Te(e){var t=g(e),n=d(e),r=e.ownerDocument.body,a=Math.max(t.scrollWidth,t.clientWidth,r?r.scrollWidth:0,r?r.clientWidth:0),o=Math.max(t.scrollHeight,t.clientHeight,r?r.scrollHeight:0,r?r.clientHeight:0),i=-n.scrollLeft+y(e),s=-n.scrollTop;return "rtl"===w(r||t).direction&&(i+=Math.max(t.clientWidth,r?r.clientWidth:0)-a),{width:a,height:o,x:i,y:s}}function Ce(e,t){var n=t.getRootNode&&t.getRootNode();if(e.contains(t))return !0;if(h(n)){var r=t;do{if(r&&e.isSameNode(r))return !0;r=r.parentNode||r.host;}while(r)}return !1}function $e(e){return Object.assign(Object.assign({},e),{},{left:e.x,top:e.y,right:e.x+e.width,bottom:e.y+e.height})}function Ae(e){var t=u(e);return t.top=t.top+e.clientTop,t.left=t.left+e.clientLeft,t.bottom=t.top+e.clientHeight,t.right=t.left+e.clientWidth,t.width=e.clientWidth,t.height=e.clientHeight,t.x=t.left,t.y=t.top,t}function Ne(e,t){return t===L?$e(Ie(e)):p(t)?Ae(t):$e(Te(g(e)))}function Fe(e){var t=M(j(e)),n=["absolute","fixed"].indexOf(w(e).position)>=0,r=n&&p(e)?_(e):e;return f(r)?t.filter((function(e){return f(e)&&Ce(e,r)&&"body"!==m(e)})):[]}function ze(e,t,n){var r="clippingParents"===t?Fe(e):[].concat(t),a=[].concat(r,[n]),o=a[0],i=a.reduce((function(t,n){var r=Ne(e,n);return t.top=Math.max(r.top,t.top),t.right=Math.min(r.right,t.right),t.bottom=Math.min(r.bottom,t.bottom),t.left=Math.max(r.left,t.left),t}),Ne(e,o));return i.width=i.right-i.left,i.height=i.bottom-i.top,i.x=i.left,i.y=i.top,i}function Le(){return {top:0,right:0,bottom:0,left:0}}function He(e){return Object.assign(Object.assign({},Le()),e)}function Re(e,t){return t.reduce((function(t,n){return t[n]=e,t}),{})}function We(e,t){void 0===t&&(t={});var n=t,r=n.placement,a=void 0===r?e.placement:r,o=n.boundary,i=void 0===o?z:o,s=n.rootBoundary,c=void 0===s?L:s,l=n.elementContext,d=void 0===l?H:l,p=n.altBoundary,h=void 0!==p&&p,v=n.padding,b=void 0===v?0:v,m=He("number"!==typeof b?b:Re(b,A)),y=d===H?R:H,w=e.elements.reference,x=e.rects.popper,D=e.elements[h?y:d],O=ze(f(D)?D:D.contextElement||g(e.elements.popper),i,c),j=u(w),k=he({reference:j,element:x,strategy:"absolute",placement:a}),M=$e(Object.assign(Object.assign({},x),k)),P=d===H?M:j,Y={top:O.top-P.top+m.top,bottom:P.bottom-O.bottom+m.bottom,left:O.left-P.left+m.left,right:P.right-O.right+m.right},S=e.modifiersData.offset;if(d===H&&S){var _=S[a];Object.keys(Y).forEach((function(e){var t=[T,I].indexOf(e)>=0?1:-1,n=[E,I].indexOf(e)>=0?"y":"x";Y[e]+=_[n]*t;}));}return Y}function Ve(e,t){void 0===t&&(t={});var n=t,r=n.placement,a=n.boundary,o=n.rootBoundary,i=n.padding,s=n.flipVariations,c=n.allowedAutoPlacements,u=void 0===c?V:c,l=fe(r),d=l?s?W:W.filter((function(e){return fe(e)===l})):A,f=d.filter((function(e){return u.indexOf(e)>=0}));0===f.length&&(f=d);var p=f.reduce((function(t,n){return t[n]=We(e,{placement:n,boundary:a,rootBoundary:o,padding:i})[de(n)],t}),{});return Object.keys(p).sort((function(e,t){return p[e]-p[t]}))}function Ue(e){if(de(e)===$)return [];var t=Se(e);return [Ee(e),t,Ee(t)]}function Be(e){var t=e.state,n=e.options,r=e.name;if(!t.modifiersData[r]._skip){for(var a=n.mainAxis,o=void 0===a||a,i=n.altAxis,s=void 0===i||i,c=n.fallbackPlacements,u=n.padding,l=n.boundary,d=n.rootBoundary,f=n.altBoundary,p=n.flipVariations,h=void 0===p||p,v=n.allowedAutoPlacements,b=t.options.placement,m=de(b),g=m===b,y=c||(g||!h?[Se(b)]:Ue(b)),w=[b].concat(y).reduce((function(e,n){return e.concat(de(n)===$?Ve(t,{placement:n,boundary:l,rootBoundary:d,padding:u,flipVariations:h,allowedAutoPlacements:v}):n)}),[]),x=t.rects.reference,D=t.rects.popper,O=new Map,j=!0,k=w[0],M=0;M<w.length;M++){var P=w[M],Y=de(P),S=fe(P)===N,_=[E,I].indexOf(Y)>=0,A=_?"width":"height",F=We(t,{placement:P,boundary:l,rootBoundary:d,altBoundary:f,padding:u}),z=_?S?T:C:S?I:E;x[A]>D[A]&&(z=Se(z));var L=Se(z),H=[];if(o&&H.push(F[Y]<=0),s&&H.push(F[z]<=0,F[L]<=0),H.every((function(e){return e}))){k=P,j=!1;break}O.set(P,H);}if(j)for(var R=h?3:1,W=function(e){var t=w.find((function(t){var n=O.get(t);if(n)return n.slice(0,e).every((function(e){return e}))}));if(t)return k=t,"break"},V=R;V>0;V--){var U=W(V);if("break"===U)break}t.placement!==k&&(t.modifiersData[r]._skip=!0,t.placement=k,t.reset=!0);}}var Ze={name:"flip",enabled:!0,phase:"main",fn:Be,requiresIfExists:["offset"],data:{_skip:!1}};function qe(e){return "x"===e?"y":"x"}function Ge(e,t,n){return Math.max(e,Math.min(t,n))}function Ke(e){var t=e.state,n=e.options,r=e.name,a=n.mainAxis,o=void 0===a||a,i=n.altAxis,s=void 0!==i&&i,c=n.boundary,u=n.rootBoundary,l=n.altBoundary,d=n.padding,f=n.tether,p=void 0===f||f,h=n.tetherOffset,v=void 0===h?0:h,b=We(t,{boundary:c,rootBoundary:u,padding:d,altBoundary:l}),m=de(t.placement),g=fe(t.placement),y=!g,w=pe(m),x=qe(w),D=t.modifiersData.popperOffsets,j=t.rects.reference,k=t.rects.popper,M="function"===typeof v?v(Object.assign(Object.assign({},t.rects),{},{placement:t.placement})):v,P={x:0,y:0};if(D){if(o){var Y="y"===w?E:C,S="y"===w?I:T,$="y"===w?"height":"width",A=D[w],F=D[w]+b[Y],z=D[w]-b[S],L=p?-k[$]/2:0,H=g===N?j[$]:k[$],R=g===N?-k[$]:-j[$],W=t.elements.arrow,V=p&&W?O(W):{width:0,height:0},U=t.modifiersData["arrow#persistent"]?t.modifiersData["arrow#persistent"].padding:Le(),B=U[Y],Z=U[S],q=Ge(0,j[$],V[$]),G=y?j[$]/2-L-q-B-M:H-q-B-M,K=y?-j[$]/2+L+q+Z+M:R+q+Z+M,X=t.elements.arrow&&_(t.elements.arrow),J=X?"y"===w?X.clientTop||0:X.clientLeft||0:0,Q=t.modifiersData.offset?t.modifiersData.offset[t.placement][w]:0,ee=D[w]+G-Q-J,te=D[w]+K-Q,ne=Ge(p?Math.min(F,ee):F,A,p?Math.max(z,te):z);D[w]=ne,P[w]=ne-A;}if(s){var re="x"===w?E:C,ae="x"===w?I:T,oe=D[x],ie=oe+b[re],se=oe-b[ae],ce=Ge(ie,oe,se);D[x]=ce,P[x]=ce-oe;}t.modifiersData[r]=P;}}var Xe={name:"preventOverflow",enabled:!0,phase:"main",fn:Ke,requiresIfExists:["offset"]};function Je(e){var t,n=e.state,r=e.name,a=n.elements.arrow,o=n.modifiersData.popperOffsets,i=de(n.placement),s=pe(i),c=[C,T].indexOf(i)>=0,u=c?"height":"width";if(a&&o){var l=n.modifiersData[r+"#persistent"].padding,d=O(a),f="y"===s?E:C,p="y"===s?I:T,h=n.rects.reference[u]+n.rects.reference[s]-o[s]-n.rects.popper[u],v=o[s]-n.rects.reference[s],b=_(a),m=b?"y"===s?b.clientHeight||0:b.clientWidth||0:0,g=h/2-v/2,y=l[f],w=m-d[u]-l[p],x=m/2-d[u]/2+g,D=Ge(y,x,w),j=s;n.modifiersData[r]=(t={},t[j]=D,t.centerOffset=D-x,t);}}function Qe(e){var t=e.state,n=e.options,r=e.name,a=n.element,o=void 0===a?"[data-popper-arrow]":a,i=n.padding,s=void 0===i?0:i;null!=o&&("string"!==typeof o||(o=t.elements.popper.querySelector(o),o))&&Ce(t.elements.popper,o)&&(t.elements.arrow=o,t.modifiersData[r+"#persistent"]={padding:He("number"!==typeof s?s:Re(s,A))});}var et={name:"arrow",enabled:!0,phase:"main",fn:Je,effect:Qe,requires:["popperOffsets"],requiresIfExists:["preventOverflow"]};function tt(e,t,n){return void 0===n&&(n={x:0,y:0}),{top:e.top-t.height-n.y,right:e.right-t.width+n.x,bottom:e.bottom-t.height+n.y,left:e.left-t.width-n.x}}function nt(e){return [E,T,I,C].some((function(t){return e[t]>=0}))}function rt(e){var t=e.state,n=e.name,r=t.rects.reference,a=t.rects.popper,o=t.modifiersData.preventOverflow,i=We(t,{elementContext:"reference"}),s=We(t,{altBoundary:!0}),c=tt(i,r),u=tt(s,a,o),l=nt(c),d=nt(u);t.modifiersData[n]={referenceClippingOffsets:c,popperEscapeOffsets:u,isReferenceHidden:l,hasPopperEscaped:d},t.attributes.popper=Object.assign(Object.assign({},t.attributes.popper),{},{"data-popper-reference-hidden":l,"data-popper-escaped":d});}var at,ot,it={name:"hide",enabled:!0,phase:"main",requiresIfExists:["preventOverflow"],fn:rt},st=[le,be,xe,je,Pe,Ze,Xe,et,it],ct=se({defaultModifiers:st}),ut=n("2fa3"),lt=n("9404"),dt={name:"Popover",render(e){return e("div",{class:["vc-popover-content-wrapper",{"is-interactive":this.isInteractive}],ref:"popover"},[e("transition",{props:{name:this.transition,appear:!0},on:{beforeEnter:this.beforeEnter,afterEnter:this.afterEnter,beforeLeave:this.beforeLeave,afterLeave:this.afterLeave}},[this.isVisible&&e("div",{attrs:{tabindex:-1},class:["vc-popover-content","direction-"+this.direction,this.contentClass]},[this.content,e("span",{class:["vc-popover-caret","direction-"+this.direction,"align-"+this.alignment]})])])])},props:{id:{type:String,required:!0},contentClass:String},data(){return {ref:null,opts:null,data:null,transition:"slide-fade",placement:"bottom",positionFixed:!1,modifiers:[],isInteractive:!1,isHovered:!1,isFocused:!1,showDelay:0,hideDelay:110,autoHide:!1,popperEl:null}},computed:{content(){var e=this;return Object(lt["k"])(this.$scopedSlots.default)&&this.$scopedSlots.default({direction:this.direction,alignment:this.alignment,data:this.data,updateLayout:this.setupPopper,hide:function(t){return e.hide(t)}})||this.$slots.default},popperOptions(){return {placement:this.placement,strategy:this.positionFixed?"fixed":"absolute",modifiers:[{name:"onUpdate",enabled:!0,phase:"afterWrite",fn:this.onPopperUpdate},...this.modifiers||[]],onFirstUpdate:this.onPopperUpdate}},isVisible(){return !(!this.ref||!this.content)},direction(){return this.placement&&this.placement.split("-")[0]||"bottom"},alignment(){const e="left"===this.direction||"right"===this.direction;let t=this.placement.split("-");return t=t.length>1?t[1]:"",["start","top","left"].includes(t)?e?"top":"left":["end","bottom","right"].includes(t)?e?"bottom":"right":e?"middle":"center"},state(){return this.$popovers[this.id]}},watch:{opts(e,t){t&&t.callback&&t.callback({...t,completed:!e,reason:e?"Overridden by action":null});}},mounted(){this.popoverEl=this.$refs.popover,this.addEvents();},beforeDestroy(){this.destroyPopper(),this.removeEvents(),this.popoverEl=null;},methods:{addEvents(){Object(ut["k"])(this.popoverEl,"click",this.onClick),Object(ut["k"])(this.popoverEl,"mouseover",this.onMouseOver),Object(ut["k"])(this.popoverEl,"mouseleave",this.onMouseLeave),Object(ut["k"])(this.popoverEl,"focusin",this.onFocusIn),Object(ut["k"])(this.popoverEl,"focusout",this.onFocusOut),Object(ut["k"])(document,"keydown",this.onDocumentKeydown),Object(ut["k"])(document,"click",this.onDocumentClick),Object(ut["k"])(document,"show-popover",this.onDocumentShowPopover),Object(ut["k"])(document,"hide-popover",this.onDocumentHidePopover),Object(ut["k"])(document,"toggle-popover",this.onDocumentTogglePopover),Object(ut["k"])(document,"update-popover",this.onDocumentUpdatePopover);},removeEvents(){Object(ut["j"])(this.popoverEl,"click",this.onClick),Object(ut["j"])(this.popoverEl,"mouseover",this.onMouseOver),Object(ut["j"])(this.popoverEl,"mouseleave",this.onMouseLeave),Object(ut["j"])(this.popoverEl,"focusin",this.onFocusIn),Object(ut["j"])(this.popoverEl,"focusout",this.onFocusOut),Object(ut["j"])(document,"keydown",this.onDocumentKeydown),Object(ut["j"])(document,"click",this.onDocumentClick),Object(ut["j"])(document,"show-popover",this.onDocumentShowPopover),Object(ut["j"])(document,"hide-popover",this.onDocumentHidePopover),Object(ut["j"])(document,"toggle-popover",this.onDocumentTogglePopover),Object(ut["j"])(document,"update-popover",this.onDocumentUpdatePopover);},onClick(e){e.stopPropagation();},onMouseOver(){this.isHovered=!0,this.isInteractive&&this.show();},onMouseLeave(){this.isHovered=!1,!this.autoHide||this.isFocused||this.ref&&this.ref===document.activeElement||this.hide();},onFocusIn(){this.isFocused=!0,this.isInteractive&&this.show();},onFocusOut(e){e.relatedTarget&&Object(ut["e"])(this.popoverEl,e.relatedTarget)||(this.isFocused=!1,!this.isHovered&&this.autoHide&&this.hide());},onDocumentClick(e){this.$refs.popover&&this.ref&&(Object(ut["e"])(this.popoverEl,e.target)||Object(ut["e"])(this.ref,e.target)||this.hide());},onDocumentKeydown(e){"Esc"!==e.key&&"Escape"!==e.key||this.hide();},onDocumentShowPopover({detail:e}){e.id&&e.id===this.id&&this.show(e);},onDocumentHidePopover({detail:e}){e.id&&e.id===this.id&&this.hide(e);},onDocumentTogglePopover({detail:e}){e.id&&e.id===this.id&&this.toggle(e);},onDocumentUpdatePopover({detail:e}){e.id&&e.id===this.id&&this.update(e);},show(e={}){var t=this;e.action="show";const n=e.ref||this.ref,r=e.showDelay>=0?e.showDelay:this.showDelay;if(!n)return void(e.callback&&e.callback({completed:!1,reason:"Invalid reference element provided"}));clearTimeout(this.timeout),this.opts=e;const a=function(){Object.assign(t,e),t.setupPopper(),t.opts=null;};r>0?this.timeout=setTimeout((function(){return a()}),r):a();},hide(e={}){var t=this;e.action="hide";const n=e.ref||this.ref,r=e.hideDelay>=0?e.hideDelay:this.hideDelay;if(!this.ref||n!==this.ref)return void(e.callback&&e.callback({...e,completed:!1,reason:this.ref?"Invalid reference element provided":"Popover already hidden"}));const a=function(){t.ref=null,t.opts=null;};clearTimeout(this.timeout),this.opts=e,r>0?this.timeout=setTimeout(a,r):a();},toggle(e={}){this.isVisible&&e.ref===this.ref?this.hide(e):this.show(e);},update(e={}){Object.assign(this,e),this.setupPopper();},setupPopper(){var e=this;this.$nextTick((function(){e.ref&&e.$refs.popover&&(e.popper&&e.popper.reference!==e.ref&&e.destroyPopper(),e.popper?e.popper.update():e.popper=ct(e.ref,e.popoverEl,e.popperOptions));}));},onPopperUpdate(e){e.placement?this.placement=e.placement:e.state&&(this.placement=e.state.placement);},beforeEnter(e){this.$emit("beforeShow",e);},afterEnter(e){this.$emit("afterShow",e);},beforeLeave(e){this.$emit("beforeHide",e);},afterLeave(e){this.destroyPopper(),this.$emit("afterHide",e);},destroyPopper(){this.popper&&(this.popper.destroy(),this.popper=null);}}},ft=dt;n("bdb3");function pt(e,t,n,r,a,o,i,s){var c,u="function"===typeof e?e.options:e;if(t&&(u.render=t,u.staticRenderFns=n,u._compiled=!0),r&&(u.functional=!0),o&&(u._scopeId="data-v-"+o),i?(c=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"===typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),a&&a.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(i);},u._ssrRegister=c):a&&(c=s?function(){a.call(this,(u.functional?this.parent:this).$root.$options.shadowRoot);}:a),c)if(u.functional){u._injectStyles=c;var l=u.render;u.render=function(e,t){return c.call(t),l(e,t)};}else{var d=u.beforeCreate;u.beforeCreate=d?[].concat(d,c):[c];}return {exports:e,options:u}}var ht=pt(ft,at,ot,!1,null,"39b30300",null),vt=ht.exports,bt=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-day-popover-row"},[e.indicator?n("div",{staticClass:"vc-day-popover-row-indicator"},[n("span",{class:e.indicator.class,style:e.indicator.style})]):e._e(),n("div",{staticClass:"vc-day-popover-row-content"},[e._t("default",[e._v(e._s(e.attribute.popover?e.attribute.popover.label:"No content provided"))])],2)])},mt=[],gt=n("51ec");const yt={inject:["sharedState"],mixins:[gt["a"]],computed:{masks(){return this.sharedState.masks},theme(){return this.sharedState.theme},locale(){return this.sharedState.locale},dayPopoverId(){return this.sharedState.dayPopoverId}},methods:{format(e,t){return this.locale.format(e,t)},pageForDate(e){return this.locale.getDateParts(this.locale.normalizeDate(e))}}},wt=["base","start","end","startEnd"],xt=["class","contentClass","style","contentStyle","color","fillMode"],Dt={color:"blue",isDark:!1,highlight:{base:{fillMode:"light"},start:{fillMode:"solid"},end:{fillMode:"solid"}},dot:{base:{fillMode:"solid"},start:{fillMode:"solid"},end:{fillMode:"solid"}},bar:{base:{fillMode:"solid"},start:{fillMode:"solid"},end:{fillMode:"solid"}},content:{base:{},start:{},end:{}}};class Ot{constructor(e){Object.assign(this,Dt,e);}normalizeAttr({config:e,type:t}){let n=this.color,r={};const a=this[t];if(!0===e||Object(lt["n"])(e))n=Object(lt["n"])(e)?e:n,r={...a};else{if(!Object(lt["m"])(e))return null;r=Object(lt["f"])(e,wt)?{...e}:{base:{...e},start:{...e},end:{...e}};}return Object(lt["b"])(r,{start:r.startEnd,end:r.startEnd},a),Object(lt["w"])(r).forEach((function([e,t]){let a=n;!0===t||Object(lt["n"])(t)?(a=Object(lt["n"])(t)?t:a,r[e]={color:a}):Object(lt["m"])(t)&&(Object(lt["f"])(t,xt)?r[e]={...t}:r[e]={}),Object(lt["e"])(r,e+".color")||Object(lt["u"])(r,e+".color",a);})),r}normalizeHighlight(e){var t=this;const n=this.normalizeAttr({config:e,type:"highlight"});return Object(lt["w"])(n).forEach((function([e,n]){const r=Object(lt["b"])(n,{isDark:t.isDark,color:t.color});n.style={...t.getHighlightBgStyle(r),...n.style},n.contentStyle={...t.getHighlightContentStyle(r),...n.contentStyle};})),n}getHighlightBgStyle({fillMode:e,color:t,isDark:n}){switch(e){case"outline":case"none":return {backgroundColor:n?"var(--gray-900)":"var(--white)",border:"2px solid",borderColor:n?`var(--${t}-200)`:`var(--${t}-700)`,borderRadius:"var(--rounded-full)"};case"light":return {backgroundColor:n?`var(--${t}-800)`:`var(--${t}-200)`,opacity:n?.75:1,borderRadius:"var(--rounded-full)"};case"solid":return {backgroundColor:n?`var(--${t}-500)`:`var(--${t}-600)`,borderRadius:"var(--rounded-full)"};default:return {borderRadius:"var(--rounded-full)"}}}getHighlightContentStyle({fillMode:e,color:t,isDark:n}){switch(e){case"outline":case"none":return {fontWeight:"var(--font-bold)",color:n?`var(--${t}-100)`:`var(--${t}-900)`};case"light":return {fontWeight:"var(--font-bold)",color:n?`var(--${t}-100)`:`var(--${t}-900)`};case"solid":return {fontWeight:"var(--font-bold)",color:"var(--white)"};default:return ""}}bgAccentHigh({color:e,isDark:t}){return {backgroundColor:t?`var(--${e}-500)`:`var(--${e}-600)`}}contentAccent({color:e,isDark:t}){return e?{fontWeight:"var(--font-bold)",color:t?`var(--${e}-100)`:`var(--${e}-900)`}:null}normalizeDot(e){return this.normalizeNonHighlight("dot",e,this.bgAccentHigh)}normalizeBar(e){return this.normalizeNonHighlight("bar",e,this.bgAccentHigh)}normalizeContent(e){return this.normalizeNonHighlight("content",e,this.contentAccent)}normalizeNonHighlight(e,t,n){var r=this;const a=this.normalizeAttr({type:e,config:t});return Object(lt["w"])(a).forEach((function([e,t]){Object(lt["b"])(t,{isDark:r.isDark,color:r.color}),t.style={...n(t),...t.style};})),a}}var jt=n("29ae"),kt=n("1315"),Mt=n("22f3");const Pt={mixins:[gt["a"]],props:{color:String,isDark:Boolean,firstDayOfWeek:Number,masks:Object,locale:[String,Object],timezone:String,minDate:null,maxDate:null,minDateExact:null,maxDateExact:null,disabledDates:null,availableDates:null,theme:null},computed:{$theme(){return this.theme instanceof Ot?this.theme:new Ot({color:this.passedProp("color","blue"),isDark:this.passedProp("isDark",!1)})},$locale(){if(this.locale instanceof jt["b"])return this.locale;const e=Object(lt["m"])(this.locale)?this.locale:{id:this.locale,firstDayOfWeek:this.firstDayOfWeek,masks:this.masks};return new jt["b"](e,{locales:this.$locales,timezone:this.timezone})},disabledDates_(){const e=this.normalizeDates(this.disabledDates),{minDate:t,minDateExact:n,maxDate:r,maxDateExact:a}=this;if(n||t){const r=n?this.normalizeDate(n):this.normalizeDate(t,{time:"00:00:00"});e.push({start:null,end:new Date(r.getTime()-1e3)});}if(a||r){const t=a?this.normalizeDate(a):this.normalizeDate(r,{time:"23:59:59"});e.push({start:new Date(t.getTime()+1e3),end:null});}return e},availableDates_(){return this.normalizeDates(this.availableDates)},disabledAttribute(){return new Mt["a"]({key:"disabled",dates:this.disabledDates_,excludeDates:this.availableDates_,excludeMode:"includes",order:100},this.$theme,this.$locale)}},created(){Object(kt["a"])(this.$defaults.screens);},methods:{formatDate(e,t){return this.$locale?this.$locale.format(e,t):""},parseDate(e,t){if(!this.$locale)return null;const n=this.$locale.parse(e,t);return Object(lt["j"])(n)?n:null},normalizeDate(e,t){return this.$locale?this.$locale.normalizeDate(e,t):e},normalizeDates(e){return this.$locale.normalizeDates(e,{isFullDay:!0})},pageForDate(e){return this.$locale.getDateParts(this.normalizeDate(e))},pageForThisMonth(){return this.pageForDate(new Date)}}},Yt={methods:{safeScopedSlot(e,t,n=null){return Object(lt["k"])(this.$scopedSlots[e])?this.$scopedSlots[e](t):n}}},St=yt,_t=Pt,Et=Yt;var It={name:"PopoverRow",mixins:[St],props:{attribute:Object},computed:{indicator(){const{highlight:e,dot:t,bar:n,popover:r}=this.attribute;if(r&&r.hideIndicator)return null;if(e){const{color:t,isDark:n}=e.start;return {style:{...this.theme.bgAccentHigh({color:t,isDark:!n}),width:"10px",height:"5px",borderRadius:"3px"}}}if(t){const{color:e,isDark:n}=t.start;return {style:{...this.theme.bgAccentHigh({color:e,isDark:!n}),width:"5px",height:"5px",borderRadius:"50%"}}}if(n){const{color:e,isDark:t}=n.start;return {style:{...this.theme.bgAccentHigh({color:e,isDark:!t}),width:"10px",height:"3px"}}}return null}}},Tt=It,Ct=(n("d438"),pt(Tt,bt,mt,!1,null,"eb5afd1a",null)),$t=Ct.exports,At=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-nav-container"},[n("div",{staticClass:"vc-nav-header"},[n("span",{staticClass:"vc-nav-arrow is-left",class:{"is-disabled":!e.prevItemsEnabled},attrs:{role:"button",tabindex:e.prevItemsEnabled?0:void 0},on:{click:e.movePrev,keydown:function(t){return e.onSpaceOrEnter(t,e.movePrev)}}},[e._t("nav-left-button",[n("svg-icon",{attrs:{name:"left-arrow",width:"20px",height:"24px"}})])],2),n("span",{staticClass:"vc-nav-title vc-grid-focus",style:{whiteSpace:"nowrap"},attrs:{role:"button",tabindex:"0"},on:{click:e.toggleMode,keydown:function(t){return e.onSpaceOrEnter(t,e.toggleMode)}}},[e._v(" "+e._s(e.title)+" ")]),n("span",{staticClass:"vc-nav-arrow is-right",class:{"is-disabled":!e.nextItemsEnabled},attrs:{role:"button",tabindex:e.nextItemsEnabled?0:void 0},on:{click:e.moveNext,keydown:function(t){return e.onSpaceOrEnter(t,e.moveNext)}}},[e._t("nav-right-button",[n("svg-icon",{attrs:{name:"right-arrow",width:"20px",height:"24px"}})])],2)]),n("div",{staticClass:"vc-nav-items"},e._l(e.activeItems,(function(t){return n("span",{key:t.label,class:e.getItemClasses(t),attrs:{role:"button","data-id":t.id,"aria-label":t.ariaLabel,tabindex:t.isDisabled?void 0:0},on:{click:t.click,keydown:function(n){return e.onSpaceOrEnter(n,t.click)}}},[e._v(" "+e._s(t.label)+" ")])})),0)])},Nt=[],Ft=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("svg",e._g({staticClass:"vc-svg-icon",attrs:{width:e.width,height:e.height,viewBox:e.viewBox}},e.$listeners),[n("path",{attrs:{d:e.path}})])},zt=[];const Lt="26px",Ht="0 0 32 32",Rt={"left-arrow":{viewBox:"0 -1 16 34",path:"M11.196 10c0 0.143-0.071 0.304-0.179 0.411l-7.018 7.018 7.018 7.018c0.107 0.107 0.179 0.268 0.179 0.411s-0.071 0.304-0.179 0.411l-0.893 0.893c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-8.321-8.321c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l8.321-8.321c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l0.893 0.893c0.107 0.107 0.179 0.25 0.179 0.411z"},"right-arrow":{viewBox:"-5 -1 16 34",path:"M10.625 17.429c0 0.143-0.071 0.304-0.179 0.411l-8.321 8.321c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-0.893-0.893c-0.107-0.107-0.179-0.25-0.179-0.411 0-0.143 0.071-0.304 0.179-0.411l7.018-7.018-7.018-7.018c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l0.893-0.893c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l8.321 8.321c0.107 0.107 0.179 0.268 0.179 0.411z"}};var Wt={props:["name"],data(){return {width:Lt,height:Lt,viewBox:Ht,path:"",isBaseline:!1}},mounted(){this.updateIcon();},watch:{name(){this.updateIcon();}},methods:{updateIcon(){const e=Rt[this.name];e&&(this.width=e.width||Lt,this.height=e.height||Lt,this.viewBox=e.viewBox,this.path=e.path);}}},Vt=Wt,Ut=(n("9010"),pt(Vt,Ft,zt,!1,null,"63f7b5ec",null)),Bt=Ut.exports;const Zt=12;var qt={name:"CalendarNav",components:{SvgIcon:Bt},mixins:[St],props:{value:{type:Object,default:function(){return {month:0,year:0}}},validator:{type:Function,default:function(){return function(){return !0}}}},data(){return {monthMode:!0,yearIndex:0,yearGroupIndex:0,onSpaceOrEnter:ut["l"]}},computed:{month(){return this.value&&this.value.month||0},year(){return this.value&&this.value.year||0},title(){return this.monthMode?this.yearIndex:`${this.firstYear} - ${this.lastYear}`},monthItems(){return this.getMonthItems(this.yearIndex)},yearItems(){return this.getYearItems(this.yearGroupIndex)},prevItemsEnabled(){return this.monthMode?this.prevMonthItemsEnabled:this.prevYearItemsEnabled},nextItemsEnabled(){return this.monthMode?this.nextMonthItemsEnabled:this.nextYearItemsEnabled},prevMonthItemsEnabled(){return this.getMonthItems(this.yearIndex-1).some((function(e){return !e.isDisabled}))},nextMonthItemsEnabled(){return this.getMonthItems(this.yearIndex+1).some((function(e){return !e.isDisabled}))},prevYearItemsEnabled(){return this.getYearItems(this.yearGroupIndex-1).some((function(e){return !e.isDisabled}))},nextYearItemsEnabled(){return this.getYearItems(this.yearGroupIndex+1).some((function(e){return !e.isDisabled}))},activeItems(){return this.monthMode?this.monthItems:this.yearItems},firstYear(){return Object(lt["g"])(this.yearItems.map((function(e){return e.year})))},lastYear(){return Object(lt["p"])(this.yearItems.map((function(e){return e.year})))}},watch:{year(){this.yearIndex=this.year;},yearIndex(e){this.yearGroupIndex=this.getYearGroupIndex(e);},value(){this.focusFirstItem();}},created(){this.yearIndex=this.year;},mounted(){this.focusFirstItem();},methods:{focusFirstItem(){var e=this;this.$nextTick((function(){const t=e.$el.querySelector(".vc-nav-item:not(.is-disabled)");t&&t.focus();}));},getItemClasses({isActive:e,isCurrent:t,isDisabled:n}){const r=["vc-nav-item"];return e?r.push("is-active"):t&&r.push("is-current"),n&&r.push("is-disabled"),r},getYearGroupIndex(e){return Math.floor(e/Zt)},getMonthItems(e){var t=this;const{month:n,year:r}=this.pageForDate(new Date);return this.locale.getMonthDates().map((function(a,o){const i=o+1;return {month:i,year:e,id:`${e}.${Object(ut["m"])(i,2)}`,label:t.locale.format(a,t.masks.navMonths),ariaLabel:t.locale.format(a,"MMMM YYYY"),isActive:i===t.month&&e===t.year,isCurrent:i===n&&e===r,isDisabled:!t.validator({month:i,year:e}),click:function(){return t.monthClick(i,e)}}}))},getYearItems(e){var t=this;const{_:n,year:r}=this.pageForDate(new Date),a=e*Zt,o=a+Zt,i=[];for(let s=a;s<o;s+=1){let e=!1;for(let t=1;t<12;t++)if(e=this.validator({month:t,year:s}),e)break;i.push({year:s,id:s,label:s,ariaLabel:s,isActive:s===this.year,isCurrent:s===r,isDisabled:!e,click:function(){return t.yearClick(s)}});}return i},monthClick(e,t){this.validator({month:e,year:t})&&this.$emit("input",{month:e,year:t});},yearClick(e){this.yearIndex=e,this.monthMode=!0,this.focusFirstItem();},toggleMode(){this.monthMode=!this.monthMode;},movePrev(){this.prevItemsEnabled&&(this.monthMode&&this.movePrevYear(),this.movePrevYearGroup());},moveNext(){this.nextItemsEnabled&&(this.monthMode&&this.moveNextYear(),this.moveNextYearGroup());},movePrevYear(){this.yearIndex--;},moveNextYear(){this.yearIndex++;},movePrevYearGroup(){this.yearGroupIndex--;},moveNextYearGroup(){this.yearGroupIndex++;}}},Gt=qt,Kt=(n("3c55"),pt(Gt,At,Nt,!1,null,null,null)),Xt=Kt.exports;function Jt(e){document&&document.dispatchEvent(new CustomEvent("show-popover",{detail:e}));}function Qt(e){document&&document.dispatchEvent(new CustomEvent("hide-popover",{detail:e}));}function en(e){document&&document.dispatchEvent(new CustomEvent("toggle-popover",{detail:e}));}function tn(e){document&&document.dispatchEvent(new CustomEvent("update-popover",{detail:e}));}function nn(e){const{visibility:t}=e,n="click"===t,r="hover"===t,a="hover-focus"===t,o="focus"===t;e.autoHide=!n;let i=!1,s=!1;return {click(t){n&&(e.ref=t.target,en(e),t.stopPropagation());},mousemove(t){e.ref=t.currentTarget,i||(i=!0,(r||a)&&Jt(e));},mouseleave(t){e.ref=t.target,i&&(i=!1,(r||a&&!s)&&Qt(e));},focusin(t){e.ref=t.currentTarget,s||(s=!0,(o||a)&&Jt(e));},focusout(t){e.ref=t.currentTarget,s&&!Object(ut["e"])(e.ref,t.relatedTarget)&&(s=!1,(o||a&&!i)&&Qt(e));}}}var rn,an,on,sn,cn,un,ln,dn,fn={name:"CalendarDay",mixins:[St,Et],render(e){var t=this;const n=function(){return t.hasBackgrounds&&e("div",{class:"vc-highlights vc-day-layer"},t.backgrounds.map((function({key:t,wrapperClass:n,class:r,style:a}){return e("div",{key:t,class:n},[e("div",{class:r,style:a})])})))},r=function(){return t.safeScopedSlot("day-content",{day:t.day,attributes:t.day.attributes,attributesMap:t.day.attributesMap,dayProps:t.dayContentProps,dayEvents:t.dayContentEvents})||e("span",{class:t.dayContentClass,style:t.dayContentStyle,attrs:{...t.dayContentProps},on:t.dayContentEvents,ref:"content"},[t.day.label])},a=function(){return t.hasDots&&e("div",{class:"vc-day-layer vc-day-box-center-bottom"},[e("div",{class:"vc-dots"},t.dots.map((function({key:t,class:n,style:r}){return e("span",{key:t,class:n,style:r})})))])},o=function(){return t.hasBars&&e("div",{class:"vc-day-layer vc-day-box-center-bottom"},[e("div",{class:"vc-bars"},t.bars.map((function({key:t,class:n,style:r}){return e("span",{key:t,class:n,style:r})})))])};return e("div",{class:["vc-day",...this.day.classes,{"vc-day-box-center-center":!this.$scopedSlots["day-content"]},{"is-not-in-month":!this.inMonth}]},[n(),r(),a(),o()])},inject:["sharedState"],props:{day:{type:Object,required:!0}},data(){return {glyphs:{},dayContentEvents:{}}},computed:{label(){return this.day.label},startTime(){return this.day.range.start.getTime()},endTime(){return this.day.range.end.getTime()},inMonth(){return this.day.inMonth},isDisabled(){return this.day.isDisabled},backgrounds(){return this.glyphs.backgrounds},hasBackgrounds(){return !!Object(ut["b"])(this.backgrounds)},content(){return this.glyphs.content},dots(){return this.glyphs.dots},hasDots(){return !!Object(ut["b"])(this.dots)},bars(){return this.glyphs.bars},hasBars(){return !!Object(ut["b"])(this.bars)},popovers(){return this.glyphs.popovers},hasPopovers(){return !!Object(ut["b"])(this.popovers)},dayContentClass(){return ["vc-day-content vc-focusable",{"is-disabled":this.isDisabled},Object(lt["d"])(Object(lt["p"])(this.content),"class")||""]},dayContentStyle(){return Object(lt["d"])(Object(lt["p"])(this.content),"style")},dayContentProps(){let e;return this.day.isFocusable?e="0":this.day.inMonth&&(e="-1"),{tabindex:e,"aria-label":this.day.ariaLabel,"aria-disabled":this.day.isDisabled?"true":"false",role:"button"}},dayEvent(){return {...this.day,el:this.$refs.content,popovers:this.popovers}}},watch:{theme(){this.refresh();},popovers(){this.refreshPopovers();}},mounted(){this.refreshPopovers();},methods:{getDayEvent(e){return {...this.dayEvent,event:e}},click(e){this.$emit("dayclick",this.getDayEvent(e));},mouseenter(e){this.$emit("daymouseenter",this.getDayEvent(e));},mouseleave(e){this.$emit("daymouseleave",this.getDayEvent(e));},focusin(e){this.$emit("dayfocusin",this.getDayEvent(e));},focusout(e){this.$emit("dayfocusout",this.getDayEvent(e));},keydown(e){this.$emit("daykeydown",this.getDayEvent(e));},refresh(){var e=this;if(!this.day.refresh)return;this.day.refresh=!1;const t={backgrounds:[],dots:[],bars:[],popovers:[],content:[]};this.$set(this.day,"attributes",Object.values(this.day.attributesMap||{}).sort((function(e,t){return e.order-t.order}))),this.day.attributes.forEach((function(n){const{targetDate:r}=n,{isDate:a,isComplex:o,startTime:i,endTime:s}=r,c=e.startTime<=i,u=e.endTime>=s,l=c&&u,d=c||u,f={isDate:a,isComplex:o,onStart:c,onEnd:u,onStartAndEnd:l,onStartOrEnd:d};e.processHighlight(n,f,t),e.processNonHighlight(n,"content",f,t.content),e.processNonHighlight(n,"dot",f,t.dots),e.processNonHighlight(n,"bar",f,t.bars),e.processPopover(n,t);})),this.glyphs=t;},processHighlight({key:e,highlight:t},{isDate:n,isComplex:r,onStart:a,onEnd:o,onStartAndEnd:i},{backgrounds:s,content:c}){if(!t)return;const{base:u,start:l,end:d}=t;n||r||i?(s.push({key:e,wrapperClass:"vc-day-layer vc-day-box-center-center",class:["vc-highlight",l.class],style:l.style}),c.push({key:e+"-content",class:l.contentClass,style:l.contentStyle})):a?(s.push({key:e+"-base",wrapperClass:"vc-day-layer vc-day-box-right-center",class:["vc-highlight vc-highlight-base-start",u.class],style:u.style}),s.push({key:e,wrapperClass:"vc-day-layer vc-day-box-center-center",class:["vc-highlight",l.class],style:l.style}),c.push({key:e+"-content",class:l.contentClass,style:l.contentStyle})):o?(s.push({key:e+"-base",wrapperClass:"vc-day-layer vc-day-box-left-center",class:["vc-highlight vc-highlight-base-end",u.class],style:u.style}),s.push({key:e,wrapperClass:"vc-day-layer vc-day-box-center-center",class:["vc-highlight",d.class],style:d.style}),c.push({key:e+"-content",class:d.contentClass,style:d.contentStyle})):(s.push({key:e+"-middle",wrapperClass:"vc-day-layer vc-day-box-center-center",class:["vc-highlight vc-highlight-base-middle",u.class],style:u.style}),c.push({key:e+"-content",class:u.contentClass,style:u.contentStyle}));},processNonHighlight(e,t,{isDate:n,onStart:r,onEnd:a},o){if(!e[t])return;const{key:i}=e,s="vc-"+t,{base:c,start:u,end:l}=e[t];n||r?o.push({key:i,class:[s,u.class],style:u.style}):a?o.push({key:i,class:[s,l.class],style:l.style}):o.push({key:i,class:[s,c.class],style:c.style});},processPopover(e,{popovers:t}){const{key:n,customData:r,popover:a}=e;if(!a)return;const o=Object(lt["b"])({key:n,customData:r,attribute:e},{...a},{visibility:a.label?"hover":"click",placement:"bottom",isInteractive:!a.label});t.splice(0,0,o);},refreshPopovers(){let e={};Object(ut["b"])(this.popovers)&&(e=nn(Object(lt["b"])({id:this.dayPopoverId,data:this.day},...this.popovers))),this.dayContentEvents=Object(ut["h"])({click:this.click,mouseenter:this.mouseenter,mouseleave:this.mouseleave,focusin:this.focusin,focusout:this.focusout,keydown:this.keydown},e),tn({id:this.dayPopoverId,data:this.day});}}},pn=fn,hn=(n("1f64"),pt(pn,rn,an,!1,null,"4420d078",null)),vn=hn.exports,bn={name:"CalendarPane",mixins:[St,Et],render(e){var t=this;const n=this.safeScopedSlot("header",this.page)||e("div",{class:"vc-header align-"+this.titlePosition},[e("div",{class:"vc-title",on:this.navPopoverEvents},[this.safeScopedSlot("header-title",this.page,this.page.title)])]),r=this.weekdayLabels.map((function(t,n){return e("div",{key:n+1,class:"vc-weekday"},[t])})),a=this.showWeeknumbers_.startsWith("left"),o=this.showWeeknumbers_.startsWith("right");a?r.unshift(e("div",{class:"vc-weekday"})):o&&r.push(e("div",{class:"vc-weekday"}));const i=function(n){return e("div",{class:["vc-weeknumber"]},[e("span",{class:["vc-weeknumber-content","is-"+t.showWeeknumbers_],on:{click:function(e){t.$emit("weeknumberclick",{weeknumber:n,days:t.page.days.filter((function(e){return e[t.weeknumberKey]===n})),event:e});}}},[n])])},s=[],{daysInWeek:c}=this.locale;this.page.days.forEach((function(n,r){const u=r%c;(a&&0===u||o&&u===c)&&s.push(i(n[t.weeknumberKey])),s.push(e(vn,{attrs:{day:n},on:{...t.$listeners},scopedSlots:t.$scopedSlots,key:n.id,ref:"days",refInFor:!0})),o&&u===c-1&&s.push(i(n[t.weeknumberKey]));}));const u=e("div",{class:{"vc-weeks":!0,"vc-show-weeknumbers":this.showWeeknumbers_,"is-left":a,"is-right":o}},[r,s]);return e("div",{class:["vc-pane","row-from-end-"+this.rowFromEnd,"column-from-end-"+this.columnFromEnd],ref:"pane"},[n,u])},inheritAttrs:!1,props:{page:Object,position:Number,row:Number,rowFromEnd:Number,column:Number,columnFromEnd:Number,titlePosition:String,navVisibility:String,showWeeknumbers:[Boolean,String],showIsoWeeknumbers:[Boolean,String]},computed:{weeknumberKey(){return this.showWeeknumbers?"weeknumber":"isoWeeknumber"},showWeeknumbers_(){const e=this.showWeeknumbers||this.showIsoWeeknumbers;return null==e?"":Object(lt["i"])(e)?e?"left":"":e.startsWith("right")?this.columnFromEnd>1?"right":e:this.column>1?"left":e},navVisibility_(){return this.propOrDefault("navVisibility","navVisibility")},navPlacement(){switch(this.titlePosition){case"left":return "bottom-start";case"right":return "bottom-end";default:return "bottom"}},navPopoverEvents(){const{sharedState:e,navVisibility_:t,navPlacement:n,page:r,position:a}=this;return nn({id:e.navPopoverId,visibility:t,placement:n,modifiers:[{name:"flip",options:{fallbackPlacements:["bottom"]}}],data:{page:r,position:a},isInteractive:!0})},weekdayLabels(){var e=this;return this.locale.getWeekdayDates().map((function(t){return e.format(t,e.masks.weekdays)}))}},methods:{refresh(){this.$refs.days.forEach((function(e){return e.refresh()}));}}},mn=bn,gn=(n("fccf"),n("4889"),pt(mn,on,sn,!1,null,"74ad501d",null)),yn=gn.exports,wn={name:"CustomTransition",render(e){return e("transition",{props:{name:this.name_,appear:this.appear},on:{beforeEnter:this.beforeEnter,afterEnter:this.afterEnter}},[this.$slots.default])},props:{name:String,appear:Boolean},computed:{name_(){return this.name||"none"}},methods:{beforeEnter(e){this.$emit("beforeEnter",e),this.$emit("beforeTransition",e);},afterEnter(e){this.$emit("afterEnter",e),this.$emit("afterTransition",e);}}},xn=wn,Dn=(n("2285"),pt(xn,cn,un,!1,null,"5be4b00c",null)),On=Dn.exports,jn=n("9349"),kn=n("0733"),Mn=(n("3ee2"),{name:"Calendar",render(e){var t=this;const n=this.pages.map((function(n,r){const a=r+1,o=Math.ceil((r+1)/t.columns),i=t.rows-o+1,s=a%t.columns||t.columns,c=t.columns-s+1;return e(yn,{attrs:{...t.$attrs,attributes:t.store},props:{page:n,position:a,row:o,rowFromEnd:i,column:s,columnFromEnd:c,titlePosition:t.titlePosition_},on:{...t.$listeners,dayfocusin:function(e){t.lastFocusedDay=e,t.$emit("dayfocusin",e);},dayfocusout:function(e){t.lastFocusedDay=null,t.$emit("dayfocusout",e);}},scopedSlots:t.$scopedSlots,key:n.key,ref:"pages",refInFor:!0})})),r=function(n){const r=function(){return t.move(n?-t.step_:t.step_)},a=function(e){return Object(ut["l"])(e,r)},o=n?!t.canMovePrev:!t.canMoveNext;return e("div",{class:["vc-arrow","is-"+(n?"left":"right"),{"is-disabled":o}],attrs:{role:"button"},on:{click:r,keydown:a}},[(n?t.safeScopedSlot("header-left-button",{click:r}):t.safeScopedSlot("header-right-button",{click:r}))||e(Bt,{props:{name:n?"left-arrow":"right-arrow"}})])},a=function(){return e(vt,{props:{id:t.sharedState.navPopoverId,contentClass:"vc-nav-popover-container"},ref:"navPopover",scopedSlots:{default:function({data:n}){const{position:r,page:a}=n;return e(Xt,{props:{value:a,position:r,validator:function(e){return t.canMove(e,{position:r})}},on:{input:function(e){return t.move(e,{position:r})}},scopedSlots:t.$scopedSlots})}}})},o=function(){return e(vt,{props:{id:t.sharedState.dayPopoverId,contentClass:"vc-day-popover-container"},scopedSlots:{default:function({data:n,updateLayout:r,hide:a}){const o=Object.values(n.attributes).filter((function(e){return e.popover})),i=t.$locale.masks,s=t.formatDate,c=s(n.date,i.dayPopover);return t.safeScopedSlot("day-popover",{day:n,attributes:o,masks:i,format:s,dayTitle:c,updateLayout:r,hide:a})||e("div",[i.dayPopover&&e("div",{class:["vc-day-popover-header"]},[c]),o.map((function(t){return e($t,{key:t.key,props:{attribute:t}})}))])}}})};return e("div",{attrs:{"data-helptext":"Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year"},class:["vc-container","vc-"+this.$theme.color,{"vc-is-expanded":this.isExpanded,"vc-is-dark":this.$theme.isDark}],on:{keydown:this.handleKeydown,mouseup:function(e){return e.preventDefault()}},ref:"container"},[a(),e("div",{class:["vc-pane-container",{"in-transition":this.inTransition}]},[e(On,{props:{name:this.transitionName},on:{beforeEnter:function(){t.inTransition=!0;},afterEnter:function(){t.inTransition=!1;}}},[e("div",{class:"vc-pane-layout",style:{gridTemplateColumns:`repeat(${this.columns}, 1fr)`},attrs:{...this.$attrs},key:Object(ut["b"])(this.pages)?this.pages[0].key:""},n)]),e("div",{class:["vc-arrows-container title-"+this.titlePosition_]},[r(!0),r(!1)]),this.$scopedSlots.footer&&this.$scopedSlots.footer()]),o()])},mixins:[_t,Et],provide(){return {sharedState:this.sharedState}},props:{rows:{type:Number,default:1},columns:{type:Number,default:1},step:Number,titlePosition:String,isExpanded:Boolean,fromDate:Date,toDate:Date,fromPage:Object,toPage:Object,minPage:Object,maxPage:Object,transition:String,attributes:[Object,Array],trimWeeks:Boolean,disablePageSwipe:Boolean},data(){return {pages:[],store:null,lastFocusedDay:null,focusableDay:(new Date).getDate(),transitionName:"",inTransition:!1,sharedState:{navPopoverId:Object(ut["c"])(),dayPopoverId:Object(ut["c"])(),theme:{},masks:{},locale:{}}}},computed:{titlePosition_(){return this.propOrDefault("titlePosition","titlePosition")},firstPage(){return Object(lt["g"])(this.pages)},lastPage(){return Object(lt["p"])(this.pages)},minPage_(){return this.minPage||this.pageForDate(this.minDate)},maxPage_(){return this.maxPage||this.pageForDate(this.maxDate)},count(){return this.rows*this.columns},step_(){return this.step||this.count},canMovePrev(){return this.canMove(-this.step_)},canMoveNext(){return this.canMove(this.step_)}},watch:{$locale(){this.refreshLocale(),this.refreshPages({page:this.firstPage,ignoreCache:!0}),this.initStore();},$theme(){this.refreshTheme(),this.initStore();},fromDate(){this.refreshPages();},fromPage(e){const t=this.pages&&this.pages[0];Object(ut["q"])(e,t)||this.refreshPages();},toPage(e){const t=this.pages&&this.pages[this.pages.length-1];Object(ut["q"])(e,t)||this.refreshPages();},count(){this.refreshPages();},attributes:{handler(e){const{adds:t,deletes:n}=this.store.refresh(e);this.refreshAttrs(this.pages,t,n);},deep:!0},pages(e){this.refreshAttrs(e,this.store.list,null,!0);},disabledAttribute(){this.refreshDisabledDays();},lastFocusedDay(e){e&&(this.focusableDay=e.day,this.refreshFocusableDays());},inTransition(e){e?this.$emit("transition-start"):(this.$emit("transition-end"),this.transitionPromise&&(this.transitionPromise.resolve(!0),this.transitionPromise=null));}},created(){this.refreshLocale(),this.refreshTheme(),this.initStore(),this.refreshPages();},mounted(){var e=this;this.disablePageSwipe||(this.removeHandlers=Object(kn["a"])(this.$refs.container,(function({toLeft:t,toRight:n}){t?e.moveNext():n&&e.movePrev();}),this.$defaults.touch));},destroyed(){this.pages=[],this.store.destroy(),this.store=null,this.sharedState=null,this.removeHandlers&&this.removeHandlers();},methods:{refreshLocale(){this.sharedState.locale=this.$locale,this.sharedState.masks=this.$locale.masks;},refreshTheme(){this.sharedState.theme=this.$theme;},canMove(e,t={}){var n=this;const r=this.$locale.toPage(e,this.firstPage);let{position:a}=t;if(Object(lt["l"])(e)&&(a=1),!r)return Promise.reject(new Error("Invalid argument provided: "+e));if(!a)if(Object(ut["o"])(r,this.firstPage))a=-1;else{if(!Object(ut["n"])(r,this.lastPage))return Promise.resolve(!0);a=1;}return Object.assign(t,this.getTargetPageRange(r,{position:a,force:!0})),Object(ut["s"])(t.fromPage,t.toPage).some((function(e){return Object(ut["p"])(e,n.minPage_,n.maxPage_)}))},movePrev(e){return this.move(-this.step_,e)},moveNext(e){return this.move(this.step_,e)},move(e,t={}){const n=this.canMove(e,t);return t.force||n?(this.$refs.navPopover.hide({hideDelay:0}),t.fromPage&&!Object(ut["q"])(t.fromPage,this.firstPage)?this.refreshPages({...t,page:t.fromPage,position:1,force:!0}):Promise.resolve(!0)):Promise.reject(new Error("Move target is disabled: "+JSON.stringify(t)))},focusDate(e,t={}){var n=this;return this.move(e,t).then((function(){const t=n.$el.querySelector(`.id-${n.$locale.getDayId(e)}.in-month .vc-focusable`);return t?(t.focus(),Promise.resolve(!0)):Promise.resolve(!1)}))},showPageRange(e,t){let n,r;if(Object(lt["j"])(e))n=this.pageForDate(e);else{if(!Object(lt["m"])(e))return Promise.reject(new Error("Invalid page range provided."));{const{month:t,year:a}=e,{from:o,to:i}=e;Object(lt["l"])(t)&&Object(lt["l"])(a)?n=e:(o||i)&&(n=Object(lt["j"])(o)?this.pageForDate(o):o,r=Object(lt["j"])(i)?this.pageForDate(i):i);}}const a=this.lastPage;let o=n;return Object(ut["n"])(r,a)&&(o=Object(ut["a"])(r,-(this.pages.length-1))),Object(ut["o"])(o,n)&&(o=n),this.refreshPages({...t,page:o})},getTargetPageRange(e,{position:t,force:n}={}){let r=null,a=null;if(Object(ut["r"])(e)){let n=0;t=+t,isNaN(t)||(n=t>0?1-t:-(this.count+t)),r=Object(ut["a"])(e,n);}else r=this.getDefaultInitialPage();return a=Object(ut["a"])(r,this.count-1),n||(Object(ut["o"])(r,this.minPage_)?r=this.minPage_:Object(ut["n"])(a,this.maxPage_)&&(r=Object(ut["a"])(this.maxPage_,1-this.count)),a=Object(ut["a"])(r,this.count-1)),{fromPage:r,toPage:a}},getDefaultInitialPage(){let e=this.fromPage||this.pageForDate(this.fromDate);if(!Object(ut["r"])(e)){const t=this.toPage||this.pageForDate(this.toPage);Object(ut["r"])(t)&&(e=Object(ut["a"])(t,1-this.count));}return Object(ut["r"])(e)||(e=this.getPageForAttributes()),Object(ut["r"])(e)||(e=this.pageForThisMonth()),e},refreshPages({page:e,position:t=1,force:n,transition:r,ignoreCache:a}={}){var o=this;return new Promise((function(i,s){const{fromPage:c,toPage:u}=o.getTargetPageRange(e,{position:t,force:n}),l=[];for(let e=0;e<o.count;e++)l.push(o.buildPage(Object(ut["a"])(c,e),a));o.refreshDisabledDays(l),o.refreshFocusableDays(l),o.transitionName=o.getPageTransition(o.pages[0],l[0],r),o.pages=l,o.$emit("update:from-page",c),o.$emit("update:to-page",u),o.transitionName&&"none"!==o.transitionName?o.transitionPromise={resolve:i,reject:s}:i(!0);}))},refreshDisabledDays(e){var t=this;this.getPageDays(e).forEach((function(e){e.isDisabled=!!t.disabledAttribute&&t.disabledAttribute.intersectsDay(e);}));},refreshFocusableDays(e){var t=this;this.getPageDays(e).forEach((function(e){e.isFocusable=e.inMonth&&e.day===t.focusableDay;}));},getPageDays(e=this.pages){return e.reduce((function(e,t){return e.concat(t.days)}),[])},getPageTransition(e,t,n=this.transition){if("none"===n)return n;if("fade"===n||!n&&this.count>1||!Object(ut["r"])(e)||!Object(ut["r"])(t))return "fade";const r=Object(ut["o"])(t,e);return "slide-v"===n?r?"slide-down":"slide-up":r?"slide-right":"slide-left"},getPageForAttributes(){let e=null;const t=this.store.pinAttr;if(t&&t.hasDates){let[n]=t.dates;n=n.start||n.date,e=this.pageForDate(n);}return e},buildPage({month:e,year:t},n){var r=this;const a=`${t.toString()}-${e.toString()}`;let o=this.pages.find((function(e){return e.key===a}));if(!o||n){const n=new Date(t,e-1,15),i=this.$locale.getMonthComps(e,t),s=this.$locale.getPrevMonthComps(e,t),c=this.$locale.getNextMonthComps(e,t);o={key:a,month:e,year:t,weeks:this.trimWeeks?i.weeks:6,title:this.$locale.format(n,this.$locale.masks.title),shortMonthLabel:this.$locale.format(n,"MMM"),monthLabel:this.$locale.format(n,"MMMM"),shortYearLabel:t.toString().substring(2),yearLabel:t.toString(),monthComps:i,prevMonthComps:s,nextMonthComps:c,canMove:function(e){return r.canMove(e)},move:function(e){return r.move(e)},moveThisMonth:function(){return r.moveThisMonth()},movePrevMonth:function(){return r.move(s)},moveNextMonth:function(){return r.move(c)},refresh:!0},o.days=this.$locale.getCalendarDays(o);}return o},initStore(){this.store=new jn["a"](this.$theme,this.$locale,this.attributes),this.refreshAttrs(this.pages,this.store.list,[],!0);},refreshAttrs(e=[],t=[],n=[],r){var a=this;Object(ut["b"])(e)&&(e.forEach((function(e){e.days.forEach((function(e){let a={};r?e.refresh=!0:Object(lt["f"])(e.attributesMap,n)?(a=Object(lt["s"])(e.attributesMap,n),e.refresh=!0):a=e.attributesMap||{},t.forEach((function(t){const n=t.intersectsDay(e);if(n){const r={...t,targetDate:n};a[t.key]=r,e.refresh=!0;}})),e.refresh&&(e.attributesMap=a);}));})),this.$nextTick((function(){a.$refs.pages.forEach((function(e){return e.refresh()}));})));},handleKeydown(e){const t=this.lastFocusedDay;null!=t&&(t.event=e,this.handleDayKeydown(t));},handleDayKeydown(e){const{dateFromTime:t,event:n}=e,a=t(12);let o=null;switch(n.key){case"ArrowLeft":o=Object(r["a"])(a,-1);break;case"ArrowRight":o=Object(r["a"])(a,1);break;case"ArrowUp":o=Object(r["a"])(a,-7);break;case"ArrowDown":o=Object(r["a"])(a,7);break;case"Home":o=Object(r["a"])(a,1-e.weekdayPosition);break;case"End":o=Object(r["a"])(a,e.weekdayPositionFromEnd);break;case"PageUp":o=n.altKey?c(a,-1):s(a,-1);break;case"PageDown":o=n.altKey?c(a,1):s(a,1);break}o&&(n.preventDefault(),this.focusDate(o).catch((function(){})));}}}),Pn=Mn,Yn=(n("de5e"),pt(Pn,ln,dn,!1,null,null,null)),Sn=Yn.exports,_n=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-time-picker",class:[{"vc-disabled":e.isDisabled,"vc-bordered":e.showBorder}]},[n("div",[n("svg",{staticClass:"vc-time-icon",attrs:{fill:"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2",viewBox:"0 0 24 24",stroke:"currentColor"}},[n("path",{attrs:{d:"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"}})])]),n("div",{staticClass:"vc-date-time"},[e.date?n("div",{staticClass:"vc-date"},[n("span",{staticClass:"vc-weekday"},[e._v(" "+e._s(e.locale.format(e.date,"WWW"))+" ")]),n("span",{staticClass:"vc-month"},[e._v(" "+e._s(e.locale.format(e.date,"MMM"))+" ")]),n("span",{staticClass:"vc-day"},[e._v(" "+e._s(e.locale.format(e.date,"D"))+" ")]),n("span",{staticClass:"vc-year"},[e._v(" "+e._s(e.locale.format(e.date,"YYYY"))+" ")])]):e._e(),n("div",{staticClass:"vc-time"},[n("time-select",{attrs:{options:e.hourOptions_},model:{value:e.hours,callback:function(t){e.hours=e._n(t);},expression:"hours"}}),n("span",{staticStyle:{margin:"0 4px"}},[e._v(":")]),n("time-select",{attrs:{options:e.minuteOptions},model:{value:e.minutes,callback:function(t){e.minutes=e._n(t);},expression:"minutes"}}),e.is24hr?e._e():n("div",{staticClass:"vc-am-pm",class:{"vc-disabled":!(e.hours>=0)}},[n("button",{class:{active:e.isAM,"vc-disabled":e.amDisabled},attrs:{type:"button"},on:{click:function(t){t.preventDefault(),e.isAM=!0;}}},[e._v(" AM ")]),n("button",{class:{active:!e.isAM,"vc-disabled":e.pmDisabled},attrs:{type:"button"},on:{click:function(t){t.preventDefault(),e.isAM=!1;}}},[e._v(" PM ")])])],1)])])},En=[],In=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-select"},[n("select",e._b({directives:[{name:"model",rawName:"v-model",value:e.model,expression:"model"}],on:{change:function(t){var n=Array.prototype.filter.call(t.target.options,(function(e){return e.selected})).map((function(e){var t="_value"in e?e._value:e.value;return t}));e.model=t.target.multiple?n:n[0];}}},"select",e.$attrs,!1),e._l(e.options,(function(t){return n("option",{key:t.value,attrs:{disabled:t.disabled},domProps:{value:t.value}},[e._v(" "+e._s(t.label)+" ")])})),0),n("div",{staticClass:"vc-select-arrow"},[n("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 20"}},[n("path",{attrs:{d:"M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"}})])])])},Tn=[],Cn={inheritAttrs:!1,props:{options:Array,value:Number},computed:{model:{get(){return this.value},set(e){this.$emit("input",e);}}}},$n=Cn,An=(n("87a9"),pt($n,In,Tn,!1,null,"7b2eaf0a",null)),Nn=An.exports;const Fn=[{value:0,label:"12"},{value:1,label:"1"},{value:2,label:"2"},{value:3,label:"3"},{value:4,label:"4"},{value:5,label:"5"},{value:6,label:"6"},{value:7,label:"7"},{value:8,label:"8"},{value:9,label:"9"},{value:10,label:"10"},{value:11,label:"11"}],zn=[{value:12,label:"12"},{value:13,label:"1"},{value:14,label:"2"},{value:15,label:"3"},{value:16,label:"4"},{value:17,label:"5"},{value:18,label:"6"},{value:19,label:"7"},{value:20,label:"8"},{value:21,label:"9"},{value:22,label:"10"},{value:23,label:"11"}];var Ln={name:"TimePicker",components:{TimeSelect:Nn},props:{value:{type:Object,required:!0},locale:{type:Object,required:!0},theme:{type:Object,required:!0},is24hr:{type:Boolean,default:!0},showBorder:Boolean,isDisabled:Boolean,hourOptions:Array,minuteOptions:Array},computed:{date(){let e=this.locale.normalizeDate(this.value);return 24===this.value.hours&&(e=new Date(e.getTime()-1)),e},hours:{get(){return this.value.hours},set(e){this.updateValue(e,this.minutes);}},minutes:{get(){return this.value.minutes},set(e){this.updateValue(this.hours,e);}},isAM:{get(){return this.value.hours<12},set(e){let t=this.hours;e&&t>=12?t-=12:!e&&t<12&&(t+=12),this.updateValue(t,this.minutes);}},amHourOptions(){var e=this;return Fn.filter((function(t){return e.hourOptions.some((function(e){return e.value===t.value}))}))},pmHourOptions(){var e=this;return zn.filter((function(t){return e.hourOptions.some((function(e){return e.value===t.value}))}))},hourOptions_(){return this.is24hr?this.hourOptions:this.isAM?this.amHourOptions:this.pmHourOptions},amDisabled(){return !Object(ut["b"])(this.amHourOptions)},pmDisabled(){return !Object(ut["b"])(this.pmHourOptions)}},methods:{updateValue(e,t){e===this.hours&&t===this.minutes||this.$emit("input",{...this.value,hours:e,minutes:t,seconds:0,milliseconds:0});}}},Hn=Ln,Rn=(n("27e3"),pt(Hn,_n,En,!1,null,"f4e11af8",null)),Wn=Rn.exports;const Vn={type:"auto",mask:"iso",timeAdjust:""},Un=[Vn,Vn],Bn={DATE:"date",DATE_TIME:"datetime",TIME:"time"},Zn={NONE:0,START:1,END:2,BOTH:3};var qn,Gn,Kn={name:"DatePicker",render(e){var t=this;const n=function(){if(!t.dateParts)return null;const n=t.isRange?t.dateParts:[t.dateParts[0]];return e("div",[...n.map((function(n,r){const a=t.$locale.getHourOptions(t.modelConfig_[r].validHours,n),o=t.$locale.getMinuteOptions(t.modelConfig_[r].minuteIncrement,n);return e(Wn,{props:{value:n,locale:t.$locale,theme:t.$theme,is24hr:t.is24hr,minuteIncrement:t.minuteIncrement,showBorder:!t.isTime,isDisabled:t.isDateTime&&!n.isValid||t.isDragging,hourOptions:a,minuteOptions:o},on:{input:function(e){return t.onTimeInput(e,0===r)}}})})),t.$scopedSlots.footer&&t.$scopedSlots.footer()])},r=function(){return e(Sn,{attrs:{...t.$attrs,attributes:t.attributes_,theme:t.$theme,locale:t.$locale},props:{minDate:t.minDateExact||t.minDate,maxDate:t.maxDateExact||t.maxDate,disabledDates:t.disabledDates,availableDates:t.availableDates},on:{...t.$listeners,dayclick:t.onDayClick,daykeydown:t.onDayKeydown,daymouseenter:t.onDayMouseEnter},scopedSlots:{...t.$scopedSlots,footer:t.isDateTime?n:t.$scopedSlots.footer},ref:"calendar"})},a=function(){return t.isTime?e("div",{class:["vc-container","vc-"+t.$theme.color,{"vc-is-dark":t.$theme.isDark}]},[n()]):r()};return this.$scopedSlots.default&&e("span",[this.$scopedSlots.default(this.slotArgs),e(vt,{props:{id:this.datePickerPopoverId,placement:"bottom-start",contentClass:"vc-container"+(this.isDark?" vc-is-dark":"")},on:{beforeShow:function(e){return t.$emit("popoverWillShow",e)},afterShow:function(e){return t.$emit("popoverDidShow",e)},beforeHide:function(e){return t.$emit("popoverWillHide",e)},afterHide:function(e){return t.$emit("popoverDidHide",e)}},scopedSlots:{default(){return a()}},ref:"popover"})])||a()},mixins:[_t],props:{mode:{type:String,default:Bn.DATE},value:{type:null,required:!0},modelConfig:{type:Object,default:function(){return {}}},is24hr:Boolean,minuteIncrement:Number,isRequired:Boolean,isRange:Boolean,updateOnInput:Boolean,inputDebounce:Number,popover:{type:Object,default:function(){return {}}},dragAttribute:Object,selectAttribute:Object,attributes:Array,validHours:[Object,Array,Function]},data(){return {value_:null,dateParts:null,activeDate:"",dragValue:null,inputValues:["",""],updateTimeout:null,watchValue:!0,datePickerPopoverId:Object(ut["c"])()}},computed:{updateOnInput_(){return this.propOrDefault("updateOnInput","datePicker.updateOnInput")},inputDebounce_(){return this.propOrDefault("inputDebounce","datePicker.inputDebounce")},isDate(){return this.mode.toLowerCase()===Bn.DATE},isDateTime(){return this.mode.toLowerCase()===Bn.DATE_TIME},isTime(){return this.mode.toLowerCase()===Bn.TIME},isDragging(){return !!this.dragValue&&this.isRange},modelConfig_(){return this.normalizeConfig(this.modelConfig,Un)},inputMask(){const e=this.$locale.masks;return this.isTime?this.is24hr?e.inputTime24hr:e.inputTime:this.isDateTime?this.is24hr?e.inputDateTime24hr:e.inputDateTime:this.$locale.masks.input},inputMaskHasTime(){return /[Hh]/g.test(this.inputMask)},inputMaskHasDate(){return /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(this.inputMask)},inputMaskPatch(){return this.inputMaskHasTime&&this.inputMaskHasDate?jt["a"].DATE_TIME:this.inputMaskHasDate?jt["a"].DATE:this.inputMaskHasTime?jt["a"].TIME:void 0},slotArgs(){var e=this;const{isRange:t,isDragging:n,updateValue:r,showPopover:a,hidePopover:o,togglePopover:i}=this,s=t?{start:this.inputValues[0],end:this.inputValues[1]}:this.inputValues[0],c=[!0,!1].map((function(t){return {input:e.onInputInput(t),change:e.onInputChange(t),keyup:e.onInputKeyup,...nn({...e.popover_,id:e.datePickerPopoverId,callback:function(n){"show"===n.action&&n.completed&&e.onInputShow(t);}})}})),u=t?{start:c[0],end:c[1]}:c[0];return {inputValue:s,inputEvents:u,isDragging:n,updateValue:r,showPopover:a,hidePopover:o,togglePopover:i,getPopoverTriggerEvents:nn}},popover_(){return this.propOrDefault("popover","datePicker.popover","merge")},selectAttribute_(){if(!this.hasValue(this.value_))return null;const e={key:"select-drag",...this.selectAttribute,dates:this.value_,pinPage:!0},{dot:t,bar:n,highlight:r,content:a}=e;return t||n||r||a||(e.highlight=!0),e},dragAttribute_(){if(!this.isRange||!this.hasValue(this.dragValue))return null;const e={key:"select-drag",...this.dragAttribute,dates:this.dragValue},{dot:t,bar:n,highlight:r,content:a}=e;return t||n||r||a||(e.highlight={startEnd:{fillMode:"outline"}}),e},attributes_(){const e=Object(lt["h"])(this.attributes)?[...this.attributes]:[];return this.dragAttribute_?e.push(this.dragAttribute_):this.selectAttribute_&&e.push(this.selectAttribute_),e}},watch:{inputMask(){this.formatInput();},value(e){this.watchValue&&this.forceUpdateValue(e,{config:this.modelConfig_,notify:!1,formatInput:!0,hidePopover:!1});},value_(){this.refreshDateParts();},dragValue(){this.refreshDateParts();},timezone(){this.refreshDateParts(),this.forceUpdateValue(this.value_,{formatInput:!0});}},created(){this.value_=this.normalizeValue(this.value,this.modelConfig_,jt["a"].DATE_TIME,Zn.BOTH),this.forceUpdateValue(this.value,{config:this.modelConfig_,formatInput:!0,hidePopover:!1}),this.refreshDateParts();},mounted(){Object(ut["k"])(document,"keydown",this.onDocumentKeyDown),Object(ut["k"])(document,"click",this.onDocumentClick);},destroyed(){Object(ut["j"])(document,"keydown",this.onDocumentKeyDown),Object(ut["j"])(document,"click",this.onDocumentClick);},methods:{getDateParts(e){return this.$locale.getDateParts(e)},getDateFromParts(e){return this.$locale.getDateFromParts(e)},refreshDateParts(){var e=this;const t=this.dragValue||this.value_,n=[];this.isRange?(t&&t.start?n.push(this.getDateParts(t.start)):n.push({}),t&&t.end?n.push(this.getDateParts(t.end)):n.push({})):t?t&&t.start?n.push(this.getDateParts(t.start)):n.push(this.getDateParts(t)):n.push({}),this.$nextTick((function(){return e.dateParts=n}));},onDocumentKeyDown(e){this.dragValue&&"Escape"===e.key&&(this.dragValue=null);},onDocumentClick(e){document.body.contains(e.target)&&!Object(ut["e"])(this.$el,e.target)&&(this.dragValue=null,this.formatInput());},onDayClick(e){this.handleDayClick(e),this.$emit("dayclick",e);},onDayKeydown(e){switch(e.event.key){case" ":case"Enter":this.handleDayClick(e),e.event.preventDefault();break;case"Escape":this.hidePopover();}this.$emit("daykeydown",e);},handleDayClick(e){const{keepVisibleOnInput:t,visibility:n}=this.popover_,r={patch:jt["a"].DATE,adjustTime:!0,formatInput:!0,hidePopover:this.isDate&&!t&&"visible"!==n};this.isRange?(this.isDragging?this.dragTrackingValue.end=e.date:this.dragTrackingValue={...e.range},r.isDragging=!this.isDragging,r.rangePriority=r.isDragging?Zn.NONE:Zn.BOTH,r.hidePopover=r.hidePopover&&!r.isDragging,this.updateValue(this.dragTrackingValue,r)):(r.clearIfEqual=!this.isRequired,this.updateValue(e.date,r));},onDayMouseEnter(e){this.isDragging&&(this.dragTrackingValue.end=e.date,this.updateValue(this.dragTrackingValue,{patch:jt["a"].DATE,adjustTime:!0,formatInput:!0,hidePopover:!1,rangePriority:Zn.NONE}));},onTimeInput(e,t){var n=this;let r=null;if(this.isRange){const n=t?e:this.dateParts[0],a=t?this.dateParts[1]:e;r={start:n,end:a};}else r=e;this.updateValue(r,{patch:jt["a"].TIME,rangePriority:t?Zn.START:Zn.END}).then((function(){return n.adjustPageRange(t)}));},onInputInput(e){var t=this;return function(n){t.updateOnInput_&&t.onInputUpdate(n.target.value,e,{formatInput:!1,hidePopover:!1,debounce:t.inputDebounce_});}},onInputChange(e){var t=this;return function(n){t.onInputUpdate(n.target.value,e,{formatInput:!0,hidePopover:!1});}},onInputUpdate(e,t,n){var r=this;this.inputValues.splice(t?0:1,1,e);const a=this.isRange?{start:this.inputValues[0],end:this.inputValues[1]||this.inputValues[0]}:e,o={type:"string",mask:this.inputMask};this.updateValue(a,{...n,config:o,patch:this.inputMaskPatch,rangePriority:t?Zn.START:Zn.END}).then((function(){return r.adjustPageRange(t)}));},onInputShow(e){this.adjustPageRange(e);},onInputKeyup(e){"Escape"===e.key&&this.updateValue(this.value_,{formatInput:!0,hidePopover:!0});},normalizeConfig(e,t=this.modelConfig_){var n=this;return e=Object(lt["h"])(e)?e:[e.start||e,e.end||e],t.map((function(t,r){return {validHours:n.validHours,minuteIncrement:n.minuteIncrement,...t,...e[r]}}))},updateValue(e,t={}){var n=this;return clearTimeout(this.updateTimeout),new Promise((function(r){const{debounce:a,...o}=t;a>0?n.updateTimeout=setTimeout((function(){n.forceUpdateValue(e,o),r(n.value_);}),a):(n.forceUpdateValue(e,o),r(n.value_));}))},forceUpdateValue(e,{config:t=this.modelConfig_,patch:n=jt["a"].DATE_TIME,clearIfEqual:r=!1,formatInput:a=!0,hidePopover:o=!1,isDragging:i=this.isDragging,rangePriority:s=Zn.BOTH}={}){var c=this;t=this.normalizeConfig(t);let u=this.normalizeValue(e,t,n,s);!u&&this.isRequired&&(u=this.value_),u=this.adjustTimeForValue(u,t);const l=this.valueIsDisabled(u);if(l){if(i)return;u=this.value_,o=!1;}const d=i?"dragValue":"value_";let f=!this.valuesAreEqual(this[d],u);if(l||f||!r||(u=null,f=!0),f){this.$set(this,d,u),i||(this.dragValue=null);const e=this.denormalizeValue(u),t=this.isDragging?"drag":"input";this.watchValue=!1,this.$emit(t,e),this.$nextTick((function(){return c.watchValue=!0}));}o&&this.hidePopover(),a&&this.formatInput();},hasValue(e){return this.isRange?Object(lt["m"])(e)&&!!e.start&&!!e.end:!!e},normalizeValue(e,t,n,r){if(!this.hasValue(e))return null;if(this.isRange){const a={},o=e.start>e.end?e.end:e.start;a.start=this.normalizeDate(o,{...t[0],fillDate:this.value_&&this.value_.start||t[0].fillDate,patch:n});const i=e.start>e.end?e.start:e.end;return a.end=this.normalizeDate(i,{...t[1],fillDate:this.value_&&this.value_.end||t[1].fillDate,patch:n}),this.sortRange(a,r)}return this.normalizeDate(e,{...t[0],fillDate:this.value_||t[0].fillDate,patch:n})},adjustTimeForValue(e,t){return this.hasValue(e)?this.isRange?{start:this.$locale.adjustTimeForDate(e.start,t[0]),end:this.$locale.adjustTimeForDate(e.end,t[1])}:this.$locale.adjustTimeForDate(e,t[0]):null},sortRange(e,t=Zn.NONE){const{start:n,end:r}=e;if(n>r)switch(t){case Zn.START:return {start:n,end:n};case Zn.END:return {start:r,end:r};case Zn.BOTH:return {start:r,end:n}}return {start:n,end:r}},denormalizeValue(e,t=this.modelConfig_){return this.isRange?this.hasValue(e)?{start:this.$locale.denormalizeDate(e.start,t[0]),end:this.$locale.denormalizeDate(e.end,t[1])}:null:this.$locale.denormalizeDate(e,t[0])},valuesAreEqual(e,t){if(this.isRange){const n=this.hasValue(e),r=this.hasValue(t);return !n&&!r||n===r&&(Object(ut["d"])(e.start,t.start)&&Object(ut["d"])(e.end,t.end))}return Object(ut["d"])(e,t)},valueIsDisabled(e){return this.hasValue(e)&&this.disabledAttribute&&this.disabledAttribute.intersectsDate(e)},formatInput(){var e=this;this.$nextTick((function(){const t=e.normalizeConfig({type:"string",mask:e.inputMask}),n=e.denormalizeValue(e.dragValue||e.value_,t);e.isRange?e.inputValues=[n&&n.start,n&&n.end]:e.inputValues=[n,""];}));},showPopover(e={}){Jt({ref:this.$el,...this.popover_,...e,isInteractive:!0,id:this.datePickerPopoverId});},hidePopover(e={}){Qt({hideDelay:10,...this.popover_,...e,id:this.datePickerPopoverId});},togglePopover(e){en({ref:this.$el,...this.popover_,...e,isInteractive:!0,id:this.datePickerPopoverId});},adjustPageRange(e){var t=this;this.$nextTick((function(){const n=t.$refs.calendar,r=t.getPageForValue(e),a=e?1:-1;r&&n&&!Object(ut["p"])(r,n.firstPage,n.lastPage)&&n.move(r,{position:a,transition:"fade"});}));},getPageForValue(e){return this.hasValue(this.value_)?this.pageForDate(this.isRange?this.value_[e?"start":"end"]:this.value_):null},move(e,t){return this.$refs.calendar?this.$refs.calendar.move(e,t):Promise.reject(new Error("Navigation disabled while calendar is not yet displayed"))},focusDate(e,t){return this.$refs.calendar?this.$refs.calendar.focusDate(e,t):Promise.reject(new Error("Navigation disabled while calendar is not yet displayed"))}}},Xn=Kn,Jn=pt(Xn,qn,Gn,!1,null,null,null),Qn=Jn.exports;},"2b10":function(e,t){function n(e,t,n){var r=-1,a=e.length;t<0&&(t=-t>a?0:a+t),n=n>a?a:n,n<0&&(n+=a),a=t>n?0:n-t>>>0,t>>>=0;var o=Array(a);while(++r<a)o[r]=e[r+t];return o}e.exports=n;},"2b3e":function(e,t,n){var r=n("585a"),a="object"==typeof self&&self&&self.Object===Object&&self,o=r||a||Function("return this")();e.exports=o;},"2d00":function(e,t,n){var r,a,o=n("da84"),i=n("342f"),s=o.process,c=s&&s.versions,u=c&&c.v8;u?(r=u.split("."),a=r[0]<4?1:r[0]+r[1]):i&&(r=i.match(/Edge\/(\d+)/),(!r||r[1]>=74)&&(r=i.match(/Chrome\/(\d+)/),r&&(a=r[1]))),e.exports=a&&+a;},"2d7c":function(e,t){function n(e,t){var n=-1,r=null==e?0:e.length,a=0,o=[];while(++n<r){var i=e[n];t(i,n,e)&&(o[a++]=i);}return o}e.exports=n;},"2dcb":function(e,t,n){var r=n("91e9"),a=r(Object.getPrototypeOf,Object);e.exports=a;},"2ec1":function(e,t,n){var r=n("100e"),a=n("9aff");function o(e){return r((function(t,n){var r=-1,o=n.length,i=o>1?n[o-1]:void 0,s=o>2?n[2]:void 0;i=e.length>3&&"function"==typeof i?(o--,i):void 0,s&&a(n[0],n[1],s)&&(i=o<3?void 0:i,o=1),t=Object(t);while(++r<o){var c=n[r];c&&e(t,c,r,i);}return t}))}e.exports=o;},"2fa3":function(e,t,n){n.d(t,"m",(function(){return a})),n.d(t,"f",(function(){return o})),n.d(t,"h",(function(){return i})),n.d(t,"r",(function(){return s})),n.d(t,"o",(function(){return c})),n.d(t,"n",(function(){return u})),n.d(t,"p",(function(){return l})),n.d(t,"q",(function(){return d})),n.d(t,"a",(function(){return f})),n.d(t,"s",(function(){return p})),n.d(t,"d",(function(){return h})),n.d(t,"b",(function(){return v})),n.d(t,"i",(function(){return b})),n.d(t,"k",(function(){return m})),n.d(t,"j",(function(){return g})),n.d(t,"e",(function(){return y})),n.d(t,"l",(function(){return w})),n.d(t,"c",(function(){return x})),n.d(t,"g",(function(){return D}));n("ddb0");var r=n("9404");const a=function(e,t,n="0"){e=null!==e&&void 0!==e?String(e):"",t=t||2;while(e.length<t)e=`${n}${e}`;return e},o=function(e,t){return Object(r["k"])(e)?e(t):e},i=function(...e){const t={};return e.forEach((function(e){return Object.entries(e).forEach((function([e,n]){t[e]?Object(r["h"])(t[e])?t[e].push(n):t[e]=[t[e],n]:t[e]=n;}))})),t},s=function(e){return !!(e&&e.month&&e.year)},c=function(e,t){return !(!s(e)||!s(t))&&(e.year===t.year?e.month<t.month:e.year<t.year)},u=function(e,t){return !(!s(e)||!s(t))&&(e.year===t.year?e.month>t.month:e.year>t.year)},l=function(e,t,n){return !!e&&!c(e,t)&&!u(e,n)},d=function(e,t){return !(!e&&t)&&(!(e&&!t)&&(!e&&!t||e.month===t.month&&e.year===t.year))},f=function({month:e,year:t},n){const r=n>0?1:-1;for(let a=0;a<Math.abs(n);a++)e+=r,e>12?(e=1,t++):e<1&&(e=12,t--);return {month:e,year:t}},p=function(e,t){if(!s(e)||!s(t))return [];const n=[];while(!u(e,t))n.push(e),e=f(e,1);return n};function h(e,t){const n=Object(r["j"])(e),a=Object(r["j"])(t);return !n&&!a||n===a&&e.getTime()===t.getTime()}const v=function(e){return Object(r["h"])(e)&&e.length},b=function(e,t,n){const a=[];return n.forEach((function(n){const o=n.name||n.toString(),i=n.mixin,s=n.validate;if(Object.prototype.hasOwnProperty.call(e,o)){const n=s?s(e[o]):e[o];t[o]=i&&Object(r["m"])(n)?{...i,...n}:n,a.push(o);}})),{target:t,assigned:a.length?a:null}},m=function(e,t,n,r){e&&t&&n&&e.addEventListener(t,n,r);},g=function(e,t,n,r){e&&t&&e.removeEventListener(t,n,r);},y=function(e,t){return !!e&&!!t&&(e===t||e.contains(t))},w=function(e,t){" "!==e.key&&"Enter"!==e.key||(t(e),e.preventDefault());},x=function(){function e(){return (65536*(1+Math.random())|0).toString(16).substring(1)}return `${e()+e()}-${e()}-${e()}-${e()}-${e()}${e()}${e()}`};function D(e){let t,n=0,r=0;if(0===e.length)return n;for(r=0;r<e.length;r++)t=e.charCodeAt(r),n=(n<<5)-n+t,n|=0;return n}},"2fcc":function(e,t){function n(e){var t=this.__data__,n=t["delete"](e);return this.size=t.size,n}e.exports=n;},3092:function(e,t,n){var r=n("4284"),a=n("badf"),o=n("361d"),i=n("6747"),s=n("9aff");function c(e,t,n){var c=i(e)?r:o;return n&&s(e,t,n)&&(t=void 0),c(e,a(t,3))}e.exports=c;},"30c9":function(e,t,n){var r=n("9520"),a=n("b218");function o(e){return null!=e&&a(e.length)&&!r(e)}e.exports=o;},"32b3":function(e,t,n){var r=n("872a"),a=n("9638"),o=Object.prototype,i=o.hasOwnProperty;function s(e,t,n){var o=e[t];i.call(e,t)&&a(o,n)&&(void 0!==n||t in e)||r(e,t,n);}e.exports=s;},"32f4":function(e,t,n){var r=n("2d7c"),a=n("d327"),o=Object.prototype,i=o.propertyIsEnumerable,s=Object.getOwnPropertySymbols,c=s?function(e){return null==e?[]:(e=Object(e),r(s(e),(function(t){return i.call(e,t)})))}:a;e.exports=c;},"342f":function(e,t,n){var r=n("d066");e.exports=r("navigator","userAgent")||"";},"34ac":function(e,t,n){var r=n("9520"),a=n("1368"),o=n("1a8c"),i=n("dc57"),s=/[\\^$.*+?()[\]{}|]/g,c=/^\[object .+?Constructor\]$/,u=Function.prototype,l=Object.prototype,d=u.toString,f=l.hasOwnProperty,p=RegExp("^"+d.call(f).replace(s,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");function h(e){if(!o(e)||a(e))return !1;var t=r(e)?p:c;return t.test(i(e))}e.exports=h;},"34e9":function(e,t,n){(function(e){n("ddb0");var r=n("2af9"),a=n("ed08");function o(e,t){if(o.installed)return;o.installed=!0;const n=a["setupCalendar"](t);Object.entries(r).forEach((function([t,r]){e.component(`${n.componentPrefix}${t}`,r);}));}n.d(t,"c",(function(){return r["Calendar"]})),n.d(t,"d",(function(){return r["CalendarNav"]})),n.d(t,"f",(function(){return r["DatePicker"]})),n.d(t,"h",(function(){return r["Popover"]})),n.d(t,"a",(function(){return a["Attribute"]})),n.d(t,"b",(function(){return a["AttributeStore"]})),n.d(t,"e",(function(){return a["DateInfo"]})),n.d(t,"g",(function(){return a["Locale"]})),n.d(t,"i",(function(){return a["addHorizontalSwipeHandler"]})),n.d(t,"j",(function(){return a["addPages"]})),n.d(t,"k",(function(){return a["arrayHasItems"]})),n.d(t,"l",(function(){return a["createGuid"]})),n.d(t,"m",(function(){return a["datesAreEqual"]})),n.d(t,"o",(function(){return a["elementContains"]})),n.d(t,"p",(function(){return a["evalFn"]})),n.d(t,"q",(function(){return a["hash"]})),n.d(t,"r",(function(){return a["mergeEvents"]})),n.d(t,"s",(function(){return a["mixinOptionalProps"]})),n.d(t,"t",(function(){return a["off"]})),n.d(t,"u",(function(){return a["on"]})),n.d(t,"v",(function(){return a["onSpaceOrEnter"]})),n.d(t,"w",(function(){return a["pad"]})),n.d(t,"x",(function(){return a["pageIsAfterPage"]})),n.d(t,"y",(function(){return a["pageIsBeforePage"]})),n.d(t,"z",(function(){return a["pageIsBetweenPages"]})),n.d(t,"A",(function(){return a["pageIsEqualToPage"]})),n.d(t,"B",(function(){return a["pageIsValid"]})),n.d(t,"C",(function(){return a["pageRangeToArray"]})),n.d(t,"D",(function(){return a["setupCalendar"]}));const i={install:o,...r,...a};let s=null;"undefined"!==typeof window?s=window.Vue:"undefined"!==typeof e&&(s=e.Vue),s&&s.use(i),t["n"]=i;}).call(this,n("c8ba"));},"361d":function(e,t,n){var r=n("48a0");function a(e,t){var n;return r(e,(function(e,r,a){return n=t(e,r,a),!n})),!!n}e.exports=a;},3698:function(e,t){function n(e,t){return null==e?void 0:e[t]}e.exports=n;},3729:function(e,t,n){var r=n("9e69"),a=n("00fd"),o=n("29f3"),i="[object Null]",s="[object Undefined]",c=r?r.toStringTag:void 0;function u(e){return null==e?void 0===e?s:i:c&&c in Object(e)?a(e):o(e)}e.exports=u;},"37e8":function(e,t,n){var r=n("83ab"),a=n("9bf2"),o=n("825a"),i=n("df75");e.exports=r?Object.defineProperties:function(e,t){o(e);var n,r=i(t),s=r.length,c=0;while(s>c)a.f(e,n=r[c++],t[n]);return e};},3818:function(e,t,n){var r=n("7e64"),a=n("8057"),o=n("32b3"),i=n("5b01"),s=n("0f0f"),c=n("e538"),u=n("4359"),l=n("54eb"),d=n("1041"),f=n("a994"),p=n("1bac"),h=n("42a2"),v=n("c87c"),b=n("c2b6"),m=n("fa21"),g=n("6747"),y=n("0d24"),w=n("cc45"),x=n("1a8c"),D=n("d7ee"),O=n("ec69"),j=n("9934"),k=1,M=2,P=4,Y="[object Arguments]",S="[object Array]",_="[object Boolean]",E="[object Date]",I="[object Error]",T="[object Function]",C="[object GeneratorFunction]",$="[object Map]",A="[object Number]",N="[object Object]",F="[object RegExp]",z="[object Set]",L="[object String]",H="[object Symbol]",R="[object WeakMap]",W="[object ArrayBuffer]",V="[object DataView]",U="[object Float32Array]",B="[object Float64Array]",Z="[object Int8Array]",q="[object Int16Array]",G="[object Int32Array]",K="[object Uint8Array]",X="[object Uint8ClampedArray]",J="[object Uint16Array]",Q="[object Uint32Array]",ee={};function te(e,t,n,S,_,E){var I,$=t&k,A=t&M,F=t&P;if(n&&(I=_?n(e,S,_,E):n(e)),void 0!==I)return I;if(!x(e))return e;var z=g(e);if(z){if(I=v(e),!$)return u(e,I)}else{var L=h(e),H=L==T||L==C;if(y(e))return c(e,$);if(L==N||L==Y||H&&!_){if(I=A||H?{}:m(e),!$)return A?d(e,s(I,e)):l(e,i(I,e))}else{if(!ee[L])return _?e:{};I=b(e,L,$);}}E||(E=new r);var R=E.get(e);if(R)return R;E.set(e,I),D(e)?e.forEach((function(r){I.add(te(r,t,n,r,e,E));})):w(e)&&e.forEach((function(r,a){I.set(a,te(r,t,n,a,e,E));}));var W=F?A?p:f:A?j:O,V=z?void 0:W(e);return a(V||e,(function(r,a){V&&(a=r,r=e[a]),o(I,a,te(r,t,n,a,e,E));})),I}ee[Y]=ee[S]=ee[W]=ee[V]=ee[_]=ee[E]=ee[U]=ee[B]=ee[Z]=ee[q]=ee[G]=ee[$]=ee[A]=ee[N]=ee[F]=ee[z]=ee[L]=ee[H]=ee[K]=ee[X]=ee[J]=ee[Q]=!0,ee[I]=ee[T]=ee[R]=!1,e.exports=te;},3852:function(e,t,n){var r=n("96f3"),a=n("e2c0");function o(e,t){return null!=e&&a(e,t,r)}e.exports=o;},"39ff":function(e,t,n){var r=n("0b07"),a=n("2b3e"),o=r(a,"WeakMap");e.exports=o;},"3b4a":function(e,t,n){var r=n("0b07"),a=function(){try{var e=r(Object,"defineProperty");return e({},"",{}),e}catch(t){}}();e.exports=a;},"3bb4":function(e,t,n){var r=n("08cc"),a=n("ec69");function o(e){var t=a(e),n=t.length;while(n--){var o=t[n],i=e[o];t[n]=[o,i,r(i)];}return t}e.exports=o;},"3bbe":function(e,t,n){var r=n("861d");e.exports=function(e){if(!r(e)&&null!==e)throw TypeError("Can't set "+String(e)+" as a prototype");return e};},"3c55":function(e,t,n){var r=n("e969"),a=n.n(r);a.a;},"3db9":function(e,t,n){var r=n("adc8");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("2b7f9a9d",r,!0,{sourceMap:!1,shadowMode:!1});},"3ee2":function(e,t,n){var r=n("dc8c");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("13d41af5",r,!0,{sourceMap:!1,shadowMode:!1});},"3eea":function(e,t,n){var r=n("7948"),a=n("3818"),o=n("4bb5"),i=n("e2e4"),s=n("8eeb"),c=n("e0e7"),u=n("c6cf"),l=n("1bac"),d=1,f=2,p=4,h=u((function(e,t){var n={};if(null==e)return n;var u=!1;t=r(t,(function(t){return t=i(t,e),u||(u=t.length>1),t})),s(e,l(e),n),u&&(n=a(n,d|f|p,c));var h=t.length;while(h--)o(n,t[h]);return n}));e.exports=h;},"3f84":function(e,t,n){var r=n("85e3"),a=n("100e"),o=n("e031"),i=n("2411"),s=a((function(e){return e.push(void 0,o),r(i,void 0,e)}));e.exports=s;},"3f8c":function(e,t){e.exports={};},"41c3":function(e,t,n){var r=n("1a8c"),a=n("eac5"),o=n("ec8c"),i=Object.prototype,s=i.hasOwnProperty;function c(e){if(!r(e))return o(e);var t=a(e),n=[];for(var i in e)("constructor"!=i||!t&&s.call(e,i))&&n.push(i);return n}e.exports=c;},4245:function(e,t,n){var r=n("1290");function a(e,t){var n=e.__data__;return r(t)?n["string"==typeof t?"string":"hash"]:n.map}e.exports=a;},4284:function(e,t){function n(e,t){var n=-1,r=null==e?0:e.length;while(++n<r)if(t(e[n],n,e))return !0;return !1}e.exports=n;},"428f":function(e,t,n){var r=n("da84");e.exports=r;},"42a2":function(e,t,n){var r=n("b5a7"),a=n("79bc"),o=n("1cec"),i=n("c869"),s=n("39ff"),c=n("3729"),u=n("dc57"),l="[object Map]",d="[object Object]",f="[object Promise]",p="[object Set]",h="[object WeakMap]",v="[object DataView]",b=u(r),m=u(a),g=u(o),y=u(i),w=u(s),x=c;(r&&x(new r(new ArrayBuffer(1)))!=v||a&&x(new a)!=l||o&&x(o.resolve())!=f||i&&x(new i)!=p||s&&x(new s)!=h)&&(x=function(e){var t=c(e),n=t==d?e.constructor:void 0,r=n?u(n):"";if(r)switch(r){case b:return v;case m:return l;case g:return f;case y:return p;case w:return h}return t}),e.exports=x;},4359:function(e,t){function n(e,t){var n=-1,r=e.length;t||(t=Array(r));while(++n<r)t[n]=e[n];return t}e.exports=n;},4416:function(e,t){function n(e){var t=null==e?0:e.length;return t?e[t-1]:void 0}e.exports=n;},"44ad":function(e,t,n){var r=n("d039"),a=n("c6b6"),o="".split;e.exports=r((function(){return !Object("z").propertyIsEnumerable(0)}))?function(e){return "String"==a(e)?o.call(e,""):Object(e)}:Object;},"44d2":function(e,t,n){var r=n("b622"),a=n("7c73"),o=n("9bf2"),i=r("unscopables"),s=Array.prototype;void 0==s[i]&&o.f(s,i,{configurable:!0,value:a(null)}),e.exports=function(e){s[i][e]=!0;};},4889:function(e,t,n){var r=n("df9e"),a=n.n(r);a.a;},"48a0":function(e,t,n){var r=n("242e"),a=n("950a"),o=a(r);e.exports=o;},4930:function(e,t,n){var r=n("2d00"),a=n("d039");e.exports=!!Object.getOwnPropertySymbols&&!a((function(){var e=Symbol();return !String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&r&&r<41}));},"495a":function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,".vc-pane[data-v-74ad501d]{min-width:250px}.vc-header[data-v-74ad501d]{display:flex;justify-content:center;align-items:center;padding:10px 18px 0 18px}.vc-header.align-left[data-v-74ad501d]{justify-content:flex-start}.vc-header.align-right[data-v-74ad501d]{justify-content:flex-end}.vc-title[data-v-74ad501d]{font-size:var(--text-lg);color:var(--gray-800);font-weight:var(--font-semibold);line-height:28px;cursor:pointer;-webkit-user-select:none;user-select:none;white-space:nowrap}.vc-title[data-v-74ad501d]:hover{opacity:.75}.vc-weeknumber[data-v-74ad501d]{position:relative}.vc-weeknumber[data-v-74ad501d],.vc-weeknumber-content[data-v-74ad501d]{display:flex;justify-content:center;align-items:center}.vc-weeknumber-content[data-v-74ad501d]{font-size:var(--text-xs);font-weight:var(--font-medium);font-style:italic;width:28px;height:28px;margin-top:2px;color:var(--gray-500);-webkit-user-select:none;user-select:none}.vc-weeknumber-content.is-left-outside[data-v-74ad501d]{position:absolute;left:var(--weeknumber-offset)}.vc-weeknumber-content.is-right-outside[data-v-74ad501d]{position:absolute;right:var(--weeknumber-offset)}.vc-weeks[data-v-74ad501d]{display:grid;grid-template-columns:repeat(7,1fr);position:relative;-webkit-overflow-scrolling:touch;padding:5px;min-width:250px}.vc-weeks.vc-show-weeknumbers[data-v-74ad501d]{grid-template-columns:auto repeat(7,1fr)}.vc-weeks.vc-show-weeknumbers.is-right[data-v-74ad501d]{grid-template-columns:repeat(7,1fr) auto}.vc-weekday[data-v-74ad501d]{text-align:center;color:var(--gray-500);font-size:var(--text-sm);font-weight:var(--font-bold);line-height:14px;padding-top:4px;padding-bottom:8px;cursor:default;-webkit-user-select:none;user-select:none}.vc-is-dark .vc-header[data-v-74ad501d]{color:var(--gray-200)}.vc-is-dark .vc-title[data-v-74ad501d]{color:var(--gray-100)}.vc-is-dark .vc-weekday[data-v-74ad501d]{color:var(--accent-200)}",""]),e.exports=t;},"499e":function(e,t,n){function r(e,t){for(var n=[],r={},a=0;a<t.length;a++){var o=t[a],i=o[0],s=o[1],c=o[2],u=o[3],l={id:e+":"+a,css:s,media:c,sourceMap:u};r[i]?r[i].parts.push(l):n.push(r[i]={id:i,parts:[l]});}return n}n.r(t),n.d(t,"default",(function(){return h}));var a="undefined"!==typeof document;if("undefined"!==typeof DEBUG&&DEBUG&&!a)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var o={},i=a&&(document.head||document.getElementsByTagName("head")[0]),s=null,c=0,u=!1,l=function(){},d=null,f="data-vue-ssr-id",p="undefined"!==typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function h(e,t,n,a){u=n,d=a||{};var i=r(e,t);return v(i),function(t){for(var n=[],a=0;a<i.length;a++){var s=i[a],c=o[s.id];c.refs--,n.push(c);}t?(i=r(e,t),v(i)):i=[];for(a=0;a<n.length;a++){c=n[a];if(0===c.refs){for(var u=0;u<c.parts.length;u++)c.parts[u]();delete o[c.id];}}}}function v(e){for(var t=0;t<e.length;t++){var n=e[t],r=o[n.id];if(r){r.refs++;for(var a=0;a<r.parts.length;a++)r.parts[a](n.parts[a]);for(;a<n.parts.length;a++)r.parts.push(m(n.parts[a]));r.parts.length>n.parts.length&&(r.parts.length=n.parts.length);}else{var i=[];for(a=0;a<n.parts.length;a++)i.push(m(n.parts[a]));o[n.id]={id:n.id,refs:1,parts:i};}}}function b(){var e=document.createElement("style");return e.type="text/css",i.appendChild(e),e}function m(e){var t,n,r=document.querySelector("style["+f+'~="'+e.id+'"]');if(r){if(u)return l;r.parentNode.removeChild(r);}if(p){var a=c++;r=s||(s=b()),t=y.bind(null,r,a,!1),n=y.bind(null,r,a,!0);}else r=b(),t=w.bind(null,r),n=function(){r.parentNode.removeChild(r);};return t(e),function(r){if(r){if(r.css===e.css&&r.media===e.media&&r.sourceMap===e.sourceMap)return;t(e=r);}else n();}}var g=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}();function y(e,t,n,r){var a=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=g(t,a);else{var o=document.createTextNode(a),i=e.childNodes;i[t]&&e.removeChild(i[t]),i.length?e.insertBefore(o,i[t]):e.appendChild(o);}}function w(e,t){var n=t.css,r=t.media,a=t.sourceMap;if(r&&e.setAttribute("media",r),d.ssrId&&e.setAttribute(f,t.id),a&&(n+="\n/*# sourceURL="+a.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),e.styleSheet)e.styleSheet.cssText=n;else{while(e.firstChild)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n));}}},"49f4":function(e,t,n){var r=n("6044");function a(){this.__data__=r?r(null):{},this.size=0;}e.exports=a;},"4bb5":function(e,t,n){var r=n("e2e4"),a=n("4416"),o=n("8296"),i=n("f4d6");function s(e,t){return t=r(t,e),e=o(e,t),null==e||delete e[i(a(t))]}e.exports=s;},"4cef":function(e,t){var n=/\s/;function r(e){var t=e.length;while(t--&&n.test(e.charAt(t)));return t}e.exports=r;},"4cfe":function(e,t){function n(e){return void 0===e}e.exports=n;},"4d64":function(e,t,n){var r=n("fc6a"),a=n("50c4"),o=n("23cb"),i=function(e){return function(t,n,i){var s,c=r(t),u=a(c.length),l=o(i,u);if(e&&n!=n){while(u>l)if(s=c[l++],s!=s)return !0}else for(;u>l;l++)if((e||l in c)&&c[l]===n)return e||l||0;return !e&&-1}};e.exports={includes:i(!0),indexOf:i(!1)};},"4d8c":function(e,t,n){var r=n("5c69");function a(e){var t=null==e?0:e.length;return t?r(e,1):[]}e.exports=a;},"4f50":function(e,t,n){var r=n("b760"),a=n("e538"),o=n("c8fe"),i=n("4359"),s=n("fa21"),c=n("d370"),u=n("6747"),l=n("dcbe"),d=n("0d24"),f=n("9520"),p=n("1a8c"),h=n("60ed"),v=n("73ac"),b=n("8adb"),m=n("8de2");function g(e,t,n,g,y,w,x){var D=b(e,n),O=b(t,n),j=x.get(O);if(j)r(e,n,j);else{var k=w?w(D,O,n+"",e,t,x):void 0,M=void 0===k;if(M){var P=u(O),Y=!P&&d(O),S=!P&&!Y&&v(O);k=O,P||Y||S?u(D)?k=D:l(D)?k=i(D):Y?(M=!1,k=a(O,!0)):S?(M=!1,k=o(O,!0)):k=[]:h(O)||c(O)?(k=D,c(D)?k=m(D):p(D)&&!f(D)||(k=s(O))):M=!1;}M&&(x.set(O,k),y(k,O,g,w,x),x["delete"](O)),r(e,n,k);}}e.exports=g;},"501e":function(e,t,n){var r=n("3729"),a=n("1310"),o="[object Number]";function i(e){return "number"==typeof e||a(e)&&r(e)==o}e.exports=i;},"50c4":function(e,t,n){var r=n("a691"),a=Math.min;e.exports=function(e){return e>0?a(r(e),9007199254740991):0};},"50d8":function(e,t){function n(e,t){var n=-1,r=Array(e);while(++n<e)r[n]=t(n);return r}e.exports=n;},5135:function(e,t,n){var r=n("7b0b"),a={}.hasOwnProperty;e.exports=Object.hasOwn||function(e,t){return a.call(r(e),t)};},"51ec":function(e,t,n){n.d(t,"b",(function(){return f})),n.d(t,"a",(function(){return p}));var r=n("8bbf"),a=n.n(r),o=n("9404"),i=n("23a5"),s=n("7efe"),c=n("85a9"),u=n("f15d");const l={componentPrefix:"v",navVisibility:"click",titlePosition:"center",transition:"slide-h",touch:i,masks:s,screens:c,locales:u["a"],datePicker:{updateOnInput:!0,inputDebounce:1e3,popover:{visibility:"hover-focus",placement:"bottom-start",keepVisibleOnInput:!1,isInteractive:!0}}};let d=null;const f=function(e){return d||(d=new a.a({data(){return {defaults:Object(o["c"])(e,l)}},computed:{locales(){var e=this;return Object(o["r"])(this.defaults.locales,(function(t){return t.masks=Object(o["c"])(t.masks,e.defaults.masks),t}))}}})),d.defaults},p={beforeCreate(){f();},computed:{$defaults(){return d.defaults},$locales(){return d.locales}},methods:{propOrDefault(e,t,n){return this.passedProp(e,Object(o["d"])(this.$defaults,t),n)},passedProp(e,t,n){if(Object(o["e"])(this.$options.propsData,e)){const r=this[e];return Object(o["m"])(r)&&"merge"===n?Object(o["c"])(r,t):r}return t}}};},5319:function(e,t,n){var r=n("d784"),a=n("d039"),o=n("825a"),i=n("50c4"),s=n("a691"),c=n("1d80"),u=n("8aa5"),l=n("0cb2"),d=n("14c3"),f=n("b622"),p=f("replace"),h=Math.max,v=Math.min,b=function(e){return void 0===e?e:String(e)},m=function(){return "$0"==="a".replace(/./,"$0")}(),g=function(){return !!/./[p]&&""===/./[p]("a","$0")}(),y=!a((function(){var e=/./;return e.exec=function(){var e=[];return e.groups={a:"7"},e},"7"!=="".replace(e,"$<a>")}));r("replace",(function(e,t,n){var r=g?"$":"$0";return [function(e,n){var r=c(this),a=void 0==e?void 0:e[p];return void 0!==a?a.call(e,r,n):t.call(String(r),e,n)},function(e,a){if("string"===typeof a&&-1===a.indexOf(r)&&-1===a.indexOf("$<")){var c=n(t,this,e,a);if(c.done)return c.value}var f=o(this),p=String(e),m="function"===typeof a;m||(a=String(a));var g=f.global;if(g){var y=f.unicode;f.lastIndex=0;}var w=[];while(1){var x=d(f,p);if(null===x)break;if(w.push(x),!g)break;var D=String(x[0]);""===D&&(f.lastIndex=u(p,i(f.lastIndex),y));}for(var O="",j=0,k=0;k<w.length;k++){x=w[k];for(var M=String(x[0]),P=h(v(s(x.index),p.length),0),Y=[],S=1;S<x.length;S++)Y.push(b(x[S]));var _=x.groups;if(m){var E=[M].concat(Y,P,p);void 0!==_&&E.push(_);var I=String(a.apply(void 0,E));}else I=l(M,p,P,Y,_,a);P>=j&&(O+=p.slice(j,P)+I,j=P+M.length);}return O+p.slice(j)}]}),!y||!m||g);},"53b1":function(e,t,n){var r=n("495a");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("2a6e04f4",r,!0,{sourceMap:!1,shadowMode:!1});},"54eb":function(e,t,n){var r=n("8eeb"),a=n("32f4");function o(e,t){return r(e,a(e),t)}e.exports=o;},"55a3":function(e,t){function n(e){return this.__data__.has(e)}e.exports=n;},5692:function(e,t,n){var r=n("c430"),a=n("c6cd");(e.exports=function(e,t){return a[e]||(a[e]=void 0!==t?t:{})})("versions",[]).push({version:"3.15.2",mode:r?"pure":"global",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"});},"56ef":function(e,t,n){var r=n("d066"),a=n("241c"),o=n("7418"),i=n("825a");e.exports=r("Reflect","ownKeys")||function(e){var t=a.f(i(e)),n=o.f;return n?t.concat(n(e)):t};},"57a5":function(e,t,n){var r=n("91e9"),a=r(Object.keys,Object);e.exports=a;},"585a":function(e,t,n){(function(t){var n="object"==typeof t&&t&&t.Object===Object&&t;e.exports=n;}).call(this,n("c8ba"));},"5b01":function(e,t,n){var r=n("8eeb"),a=n("ec69");function o(e,t){return e&&r(t,a(t),e)}e.exports=o;},"5c69":function(e,t,n){var r=n("087d"),a=n("0621");function o(e,t,n,i,s){var c=-1,u=e.length;n||(n=a),s||(s=[]);while(++c<u){var l=e[c];t>0&&n(l)?t>1?o(l,t-1,n,i,s):r(s,l):i||(s[s.length]=l);}return s}e.exports=o;},"5c6c":function(e,t){e.exports=function(e,t){return {enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}};},"5d89":function(e,t,n){var r=n("f8af");function a(e,t){var n=t?r(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.byteLength)}e.exports=a;},"5e2e":function(e,t,n){var r=n("28c9"),a=n("69d5"),o=n("b4c0"),i=n("fba5"),s=n("67ca");function c(e){var t=-1,n=null==e?0:e.length;this.clear();while(++t<n){var r=e[t];this.set(r[0],r[1]);}}c.prototype.clear=r,c.prototype["delete"]=a,c.prototype.get=o,c.prototype.has=i,c.prototype.set=s,e.exports=c;},6044:function(e,t,n){var r=n("0b07"),a=r(Object,"create");e.exports=a;},"60ed":function(e,t,n){var r=n("3729"),a=n("2dcb"),o=n("1310"),i="[object Object]",s=Function.prototype,c=Object.prototype,u=s.toString,l=c.hasOwnProperty,d=u.call(Object);function f(e){if(!o(e)||r(e)!=i)return !1;var t=a(e);if(null===t)return !0;var n=l.call(t,"constructor")&&t.constructor;return "function"==typeof n&&n instanceof n&&u.call(n)==d}e.exports=f;},6220:function(e,t,n){var r=n("b1d2"),a=n("b047"),o=n("99d3"),i=o&&o.isDate,s=i?a(i):r;e.exports=s;},"62e4":function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e};},"642a":function(e,t,n){var r=n("966f"),a=n("3bb4"),o=n("20ec");function i(e){var t=a(e);return 1==t.length&&t[0][2]?o(t[0][0],t[0][1]):function(n){return n===e||r(n,e,t)}}e.exports=i;},6547:function(e,t,n){var r=n("a691"),a=n("1d80"),o=function(e){return function(t,n){var o,i,s=String(a(t)),c=r(n),u=s.length;return c<0||c>=u?e?"":void 0:(o=s.charCodeAt(c),o<55296||o>56319||c+1===u||(i=s.charCodeAt(c+1))<56320||i>57343?e?s.charAt(c):o:e?s.slice(c,c+2):i-56320+(o-55296<<10)+65536)}};e.exports={codeAt:o(!1),charAt:o(!0)};},"656b":function(e,t,n){var r=n("e2e4"),a=n("f4d6");function o(e,t){t=r(t,e);var n=0,o=t.length;while(null!=e&&n<o)e=e[a(t[n++])];return n&&n==o?e:void 0}e.exports=o;},6679:function(e,t,n){var r=n("3729"),a=n("1310"),o="[object Boolean]";function i(e){return !0===e||!1===e||a(e)&&r(e)==o}e.exports=i;},6747:function(e,t){var n=Array.isArray;e.exports=n;},"67ca":function(e,t,n){var r=n("cb5a");function a(e,t){var n=this.__data__,a=r(n,e);return a<0?(++this.size,n.push([e,t])):n[a][1]=t,this}e.exports=a;},"69d5":function(e,t,n){var r=n("cb5a"),a=Array.prototype,o=a.splice;function i(e){var t=this.__data__,n=r(t,e);if(n<0)return !1;var a=t.length-1;return n==a?t.pop():o.call(t,n,1),--this.size,!0}e.exports=i;},"69f3":function(e,t,n){var r,a,o,i=n("7f9a"),s=n("da84"),c=n("861d"),u=n("9112"),l=n("5135"),d=n("c6cd"),f=n("f772"),p=n("d012"),h="Object already initialized",v=s.WeakMap,b=function(e){return o(e)?a(e):r(e,{})},m=function(e){return function(t){var n;if(!c(t)||(n=a(t)).type!==e)throw TypeError("Incompatible receiver, "+e+" required");return n}};if(i||d.state){var g=d.state||(d.state=new v),y=g.get,w=g.has,x=g.set;r=function(e,t){if(w.call(g,e))throw new TypeError(h);return t.facade=e,x.call(g,e,t),t},a=function(e){return y.call(g,e)||{}},o=function(e){return w.call(g,e)};}else{var D=f("state");p[D]=!0,r=function(e,t){if(l(e,D))throw new TypeError(h);return t.facade=e,u(e,D,t),t},a=function(e){return l(e,D)?e[D]:{}},o=function(e){return l(e,D)};}e.exports={set:r,get:a,has:o,enforce:b,getterFor:m};},"6a43":function(e,t,n){var r=n("a10d");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("79e769b1",r,!0,{sourceMap:!1,shadowMode:!1});},"6eeb":function(e,t,n){var r=n("da84"),a=n("9112"),o=n("5135"),i=n("ce4e"),s=n("8925"),c=n("69f3"),u=c.get,l=c.enforce,d=String(String).split("String");(e.exports=function(e,t,n,s){var c,u=!!s&&!!s.unsafe,f=!!s&&!!s.enumerable,p=!!s&&!!s.noTargetGet;"function"==typeof n&&("string"!=typeof t||o(n,"name")||a(n,"name",t),c=l(n),c.source||(c.source=d.join("string"==typeof t?t:""))),e!==r?(u?!p&&e[t]&&(f=!0):delete e[t],f?e[t]=n:a(e,t,n)):f?e[t]=n:i(t,n);})(Function.prototype,"toString",(function(){return "function"==typeof this&&u(this).source||s(this)}));},"6f6c":function(e,t){var n=/\w*$/;function r(e){var t=new e.constructor(e.source,n.exec(e));return t.lastIndex=e.lastIndex,t}e.exports=r;},"6fcd":function(e,t,n){var r=n("50d8"),a=n("d370"),o=n("6747"),i=n("0d24"),s=n("c098"),c=n("73ac"),u=Object.prototype,l=u.hasOwnProperty;function d(e,t){var n=o(e),u=!n&&a(e),d=!n&&!u&&i(e),f=!n&&!u&&!d&&c(e),p=n||u||d||f,h=p?r(e.length,String):[],v=h.length;for(var b in e)!t&&!l.call(e,b)||p&&("length"==b||d&&("offset"==b||"parent"==b)||f&&("buffer"==b||"byteLength"==b||"byteOffset"==b)||s(b,v))||h.push(b);return h}e.exports=d;},"70b8":function(e,t,n){var r=n("fcff");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("407d10db",r,!0,{sourceMap:!1,shadowMode:!1});},"72af":function(e,t,n){var r=n("99cd"),a=r();e.exports=a;},"72f0":function(e,t){function n(e){return function(){return e}}e.exports=n;},"72f5":function(e,t,n){var r=n("9e2e");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("2997fbdf",r,!0,{sourceMap:!1,shadowMode:!1});},"73ac":function(e,t,n){var r=n("743f"),a=n("b047"),o=n("99d3"),i=o&&o.isTypedArray,s=i?a(i):r;e.exports=s;},7418:function(e,t){t.f=Object.getOwnPropertySymbols;},"743f":function(e,t,n){var r=n("3729"),a=n("b218"),o=n("1310"),i="[object Arguments]",s="[object Array]",c="[object Boolean]",u="[object Date]",l="[object Error]",d="[object Function]",f="[object Map]",p="[object Number]",h="[object Object]",v="[object RegExp]",b="[object Set]",m="[object String]",g="[object WeakMap]",y="[object ArrayBuffer]",w="[object DataView]",x="[object Float32Array]",D="[object Float64Array]",O="[object Int8Array]",j="[object Int16Array]",k="[object Int32Array]",M="[object Uint8Array]",P="[object Uint8ClampedArray]",Y="[object Uint16Array]",S="[object Uint32Array]",_={};function E(e){return o(e)&&a(e.length)&&!!_[r(e)]}_[x]=_[D]=_[O]=_[j]=_[k]=_[M]=_[P]=_[Y]=_[S]=!0,_[i]=_[s]=_[y]=_[c]=_[w]=_[u]=_[l]=_[d]=_[f]=_[p]=_[h]=_[v]=_[b]=_[m]=_[g]=!1,e.exports=E;},7530:function(e,t,n){var r=n("1a8c"),a=Object.create,o=function(){function e(){}return function(t){if(!r(t))return {};if(a)return a(t);e.prototype=t;var n=new e;return e.prototype=void 0,n}}();e.exports=o;},"76dd":function(e,t,n){var r=n("ce86");function a(e){return null==e?"":r(e)}e.exports=a;},7839:function(e,t){e.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"];},7948:function(e,t){function n(e,t){var n=-1,r=null==e?0:e.length,a=Array(r);while(++n<r)a[n]=t(e[n],n,e);return a}e.exports=n;},"79bc":function(e,t,n){var r=n("0b07"),a=n("2b3e"),o=r(a,"Map");e.exports=o;},"7a48":function(e,t,n){var r=n("6044"),a=Object.prototype,o=a.hasOwnProperty;function i(e){var t=this.__data__;return r?void 0!==t[e]:o.call(t,e)}e.exports=i;},"7b0b":function(e,t,n){var r=n("1d80");e.exports=function(e){return Object(r(e))};},"7b83":function(e,t,n){var r=n("7c64"),a=n("93ed"),o=n("2478"),i=n("a524"),s=n("1fc8");function c(e){var t=-1,n=null==e?0:e.length;this.clear();while(++t<n){var r=e[t];this.set(r[0],r[1]);}}c.prototype.clear=r,c.prototype["delete"]=a,c.prototype.get=o,c.prototype.has=i,c.prototype.set=s,e.exports=c;},"7b97":function(e,t,n){var r=n("7e64"),a=n("a2be"),o=n("1c3c"),i=n("b1e5"),s=n("42a2"),c=n("6747"),u=n("0d24"),l=n("73ac"),d=1,f="[object Arguments]",p="[object Array]",h="[object Object]",v=Object.prototype,b=v.hasOwnProperty;function m(e,t,n,v,m,g){var y=c(e),w=c(t),x=y?p:s(e),D=w?p:s(t);x=x==f?h:x,D=D==f?h:D;var O=x==h,j=D==h,k=x==D;if(k&&u(e)){if(!u(t))return !1;y=!0,O=!1;}if(k&&!O)return g||(g=new r),y||l(e)?a(e,t,n,v,m,g):o(e,t,x,n,v,m,g);if(!(n&d)){var M=O&&b.call(e,"__wrapped__"),P=j&&b.call(t,"__wrapped__");if(M||P){var Y=M?e.value():e,S=P?t.value():t;return g||(g=new r),m(Y,S,n,v,g)}}return !!k&&(g||(g=new r),i(e,t,n,v,m,g))}e.exports=m;},"7c64":function(e,t,n){var r=n("e24b"),a=n("5e2e"),o=n("79bc");function i(){this.size=0,this.__data__={hash:new r,map:new(o||a),string:new r};}e.exports=i;},"7c73":function(e,t,n){var r,a=n("825a"),o=n("37e8"),i=n("7839"),s=n("d012"),c=n("1be4"),u=n("cc12"),l=n("f772"),d=">",f="<",p="prototype",h="script",v=l("IE_PROTO"),b=function(){},m=function(e){return f+h+d+e+f+"/"+h+d},g=function(e){e.write(m("")),e.close();var t=e.parentWindow.Object;return e=null,t},y=function(){var e,t=u("iframe"),n="java"+h+":";return t.style.display="none",c.appendChild(t),t.src=String(n),e=t.contentWindow.document,e.open(),e.write(m("document.F=Object")),e.close(),e.F},w=function(){try{r=document.domain&&new ActiveXObject("htmlfile");}catch(t){}w=r?g(r):y();var e=i.length;while(e--)delete w[p][i[e]];return w()};s[v]=!0,e.exports=Object.create||function(e,t){var n;return null!==e?(b[p]=a(e),n=new b,b[p]=null,n[v]=e):n=w(),void 0===t?n:o(n,t)};},"7d1f":function(e,t,n){var r=n("087d"),a=n("6747");function o(e,t,n){var o=t(e);return a(e)?o:r(o,n(e))}e.exports=o;},"7dd0":function(e,t,n){var r=n("23e7"),a=n("9ed3"),o=n("e163"),i=n("d2bb"),s=n("d44e"),c=n("9112"),u=n("6eeb"),l=n("b622"),d=n("c430"),f=n("3f8c"),p=n("ae93"),h=p.IteratorPrototype,v=p.BUGGY_SAFARI_ITERATORS,b=l("iterator"),m="keys",g="values",y="entries",w=function(){return this};e.exports=function(e,t,n,l,p,x,D){a(n,t,l);var O,j,k,M=function(e){if(e===p&&E)return E;if(!v&&e in S)return S[e];switch(e){case m:return function(){return new n(this,e)};case g:return function(){return new n(this,e)};case y:return function(){return new n(this,e)}}return function(){return new n(this)}},P=t+" Iterator",Y=!1,S=e.prototype,_=S[b]||S["@@iterator"]||p&&S[p],E=!v&&_||M(p),I="Array"==t&&S.entries||_;if(I&&(O=o(I.call(new e)),h!==Object.prototype&&O.next&&(d||o(O)===h||(i?i(O,h):"function"!=typeof O[b]&&c(O,b,w)),s(O,P,!0,!0),d&&(f[P]=w))),p==g&&_&&_.name!==g&&(Y=!0,E=function(){return _.call(this)}),d&&!D||S[b]===E||c(S,b,E),f[t]=E,p)if(j={values:M(g),keys:x?E:M(m),entries:M(y)},D)for(k in j)(v||Y||!(k in S))&&u(S,k,j[k]);else r({target:t,proto:!0,forced:v||Y},j);return j};},"7dfe":function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,".none-enter-active[data-v-5be4b00c],.none-leave-active[data-v-5be4b00c]{transition-duration:0s}.fade-enter-active[data-v-5be4b00c],.fade-leave-active[data-v-5be4b00c],.slide-down-enter-active[data-v-5be4b00c],.slide-down-leave-active[data-v-5be4b00c],.slide-left-enter-active[data-v-5be4b00c],.slide-left-leave-active[data-v-5be4b00c],.slide-right-enter-active[data-v-5be4b00c],.slide-right-leave-active[data-v-5be4b00c],.slide-up-enter-active[data-v-5be4b00c],.slide-up-leave-active[data-v-5be4b00c]{transition:transform var(--slide-duration) var(--slide-timing),opacity var(--slide-duration) var(--slide-timing);-webkit-backface-visibility:hidden;backface-visibility:hidden}.fade-leave-active[data-v-5be4b00c],.none-leave-active[data-v-5be4b00c],.slide-down-leave-active[data-v-5be4b00c],.slide-left-leave-active[data-v-5be4b00c],.slide-right-leave-active[data-v-5be4b00c],.slide-up-leave-active[data-v-5be4b00c]{position:absolute;width:100%}.fade-enter[data-v-5be4b00c],.fade-leave-to[data-v-5be4b00c],.none-enter[data-v-5be4b00c],.none-leave-to[data-v-5be4b00c],.slide-down-enter[data-v-5be4b00c],.slide-down-leave-to[data-v-5be4b00c],.slide-left-enter[data-v-5be4b00c],.slide-left-leave-to[data-v-5be4b00c],.slide-right-enter[data-v-5be4b00c],.slide-right-leave-to[data-v-5be4b00c],.slide-up-enter[data-v-5be4b00c],.slide-up-leave-to[data-v-5be4b00c]{opacity:0}.slide-left-enter[data-v-5be4b00c],.slide-right-leave-to[data-v-5be4b00c]{transform:translateX(var(--slide-translate))}.slide-left-leave-to[data-v-5be4b00c],.slide-right-enter[data-v-5be4b00c]{transform:translateX(calc(var(--slide-translate)*-1))}.slide-down-leave-to[data-v-5be4b00c],.slide-up-enter[data-v-5be4b00c]{transform:translateY(var(--slide-translate))}.slide-down-enter[data-v-5be4b00c],.slide-up-leave-to[data-v-5be4b00c]{transform:translateY(calc(var(--slide-translate)*-1))}",""]),e.exports=t;},"7e64":function(e,t,n){var r=n("5e2e"),a=n("efb6"),o=n("2fcc"),i=n("802a"),s=n("55a3"),c=n("d02c");function u(e){var t=this.__data__=new r(e);this.size=t.size;}u.prototype.clear=a,u.prototype["delete"]=o,u.prototype.get=i,u.prototype.has=s,u.prototype.set=c,e.exports=u;},"7ed2":function(e,t){var n="__lodash_hash_undefined__";function r(e){return this.__data__.set(e,n),this}e.exports=r;},"7efe":function(e){e.exports=JSON.parse('{"title":"MMMM YYYY","weekdays":"W","navMonths":"MMM","input":["L","YYYY-MM-DD","YYYY/MM/DD"],"inputDateTime":["L h:mm A","YYYY-MM-DD h:mm A","YYYY/MM/DD h:mm A"],"inputDateTime24hr":["L HH:mm","YYYY-MM-DD HH:mm","YYYY/MM/DD HH:mm"],"inputTime":["h:mm A"],"inputTime24hr":["HH:mm"],"dayPopover":"WWW, MMM D, YYYY","data":["L","YYYY-MM-DD","YYYY/MM/DD"],"iso":"YYYY-MM-DDTHH:mm:ss.SSSZ"}');},"7f9a":function(e,t,n){var r=n("da84"),a=n("8925"),o=r.WeakMap;e.exports="function"===typeof o&&/native code/.test(a(o));},"802a":function(e,t){function n(e){return this.__data__.get(e)}e.exports=n;},8057:function(e,t){function n(e,t){var n=-1,r=null==e?0:e.length;while(++n<r)if(!1===t(e[n],n,e))break;return e}e.exports=n;},"825a":function(e,t,n){var r=n("861d");e.exports=function(e){if(!r(e))throw TypeError(String(e)+" is not an object");return e};},8296:function(e,t,n){var r=n("656b"),a=n("2b10");function o(e,t){return t.length<2?e:r(e,a(t,0,-1))}e.exports=o;},8384:function(e,t){function n(e,t,n){return e===e&&(void 0!==n&&(e=e<=n?e:n),void 0!==t&&(e=e>=t?e:t)),e}e.exports=n;},"83ab":function(e,t,n){var r=n("d039");e.exports=!r((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]}));},"85a9":function(e){e.exports=JSON.parse('{"sm":"640px","md":"768px","lg":"1024px","xl":"1280px"}');},"85e3":function(e,t){function n(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}e.exports=n;},8604:function(e,t,n){var r=n("26e8"),a=n("e2c0");function o(e,t){return null!=e&&a(e,t,r)}e.exports=o;},"861d":function(e,t){e.exports=function(e){return "object"===typeof e?null!==e:"function"===typeof e};},"872a":function(e,t,n){var r=n("3b4a");function a(e,t,n){"__proto__"==t&&r?r(e,t,{configurable:!0,enumerable:!0,value:n,writable:!0}):e[t]=n;}e.exports=a;},"87a9":function(e,t,n){var r=n("cecd"),a=n.n(r);a.a;},8925:function(e,t,n){var r=n("c6cd"),a=Function.toString;"function"!=typeof r.inspectSource&&(r.inspectSource=function(e){return a.call(e)}),e.exports=r.inspectSource;},"89d9":function(e,t,n){var r=n("656b"),a=n("159a"),o=n("e2e4");function i(e,t,n){var i=-1,s=t.length,c={};while(++i<s){var u=t[i],l=r(e,u);n(l,u)&&a(c,o(u,e),l);}return c}e.exports=i;},"8a64":function(e,t,n){var r=n("ad82");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("5fdd58c2",r,!0,{sourceMap:!1,shadowMode:!1});},"8aa5":function(e,t,n){var r=n("6547").charAt;e.exports=function(e,t,n){return t+(n?r(e,t).length:1)};},"8adb":function(e,t){function n(e,t){if(("constructor"!==t||"function"!==typeof e[t])&&"__proto__"!=t)return e[t]}e.exports=n;},"8bbf":function(t,n){t.exports=e;},"8c86":function(e,t,n){function r(e,t){if(t.length<e)throw new TypeError(e+" argument"+(e>1?"s":"")+" required, but only "+t.length+" present")}n.d(t,"a",(function(){return r}));},"8d74":function(e,t,n){var r=n("4cef"),a=/^\s+/;function o(e){return e?e.slice(0,r(e)+1).replace(a,""):e}e.exports=o;},"8de2":function(e,t,n){var r=n("8eeb"),a=n("9934");function o(e){return r(e,a(e))}e.exports=o;},"8eeb":function(e,t,n){var r=n("32b3"),a=n("872a");function o(e,t,n,o){var i=!n;n||(n={});var s=-1,c=t.length;while(++s<c){var u=t[s],l=o?o(n[u],e[u],u,n,e):void 0;void 0===l&&(l=e[u]),i?a(n,u,l):r(n,u,l);}return n}e.exports=o;},9010:function(e,t,n){var r=n("70b8"),a=n.n(r);a.a;},"90e3":function(e,t){var n=0,r=Math.random();e.exports=function(e){return "Symbol("+String(void 0===e?"":e)+")_"+(++n+r).toString(36)};},9112:function(e,t,n){var r=n("83ab"),a=n("9bf2"),o=n("5c6c");e.exports=r?function(e,t,n){return a.f(e,t,o(1,n))}:function(e,t,n){return e[t]=n,e};},"91e9":function(e,t){function n(e,t){return function(n){return e(t(n))}}e.exports=n;},9263:function(e,t,n){var r=n("ad6d"),a=n("9f7f"),o=n("5692"),i=n("7c73"),s=n("69f3").get,c=n("fce3"),u=n("107c"),l=RegExp.prototype.exec,d=o("native-string-replace",String.prototype.replace),f=l,p=function(){var e=/a/,t=/b*/g;return l.call(e,"a"),l.call(t,"a"),0!==e.lastIndex||0!==t.lastIndex}(),h=a.UNSUPPORTED_Y||a.BROKEN_CARET,v=void 0!==/()??/.exec("")[1],b=p||v||h||c||u;b&&(f=function(e){var t,n,a,o,c,u,b,m=this,g=s(m),y=g.raw;if(y)return y.lastIndex=m.lastIndex,t=f.call(y,e),m.lastIndex=y.lastIndex,t;var w=g.groups,x=h&&m.sticky,D=r.call(m),O=m.source,j=0,k=e;if(x&&(D=D.replace("y",""),-1===D.indexOf("g")&&(D+="g"),k=String(e).slice(m.lastIndex),m.lastIndex>0&&(!m.multiline||m.multiline&&"\n"!==e[m.lastIndex-1])&&(O="(?: "+O+")",k=" "+k,j++),n=new RegExp("^(?:"+O+")",D)),v&&(n=new RegExp("^"+O+"$(?!\\s)",D)),p&&(a=m.lastIndex),o=l.call(x?n:m,k),x?o?(o.input=o.input.slice(j),o[0]=o[0].slice(j),o.index=m.lastIndex,m.lastIndex+=o[0].length):m.lastIndex=0:p&&o&&(m.lastIndex=m.global?o.index+o[0].length:a),v&&o&&o.length>1&&d.call(o[0],n,(function(){for(c=1;c<arguments.length-2;c++)void 0===arguments[c]&&(o[c]=void 0);})),o&&w)for(o.groups=u=i(null),c=0;c<w.length;c++)b=w[c],u[b[0]]=o[b[1]];return o}),e.exports=f;},9349:function(e,t,n){n.d(t,"a",(function(){return o}));n("ddb0");var r=n("22f3"),a=n("2fa3");class o{constructor(e,t,n){this.theme=e,this.locale=t,this.map={},this.refresh(n,!0);}destroy(){this.theme=null,this.locale=null,this.map={},this.list=[],this.pinAttr=null;}refresh(e,t){var n=this;const o={},i=[];let s=null;const c=[],u=t?new Set:new Set(Object.keys(this.map));return Object(a["b"])(e)&&e.forEach((function(e,l){if(!e||!e.dates)return;const d=e.key?e.key.toString():l.toString(),f=e.order||0,p=Object(a["g"])(JSON.stringify(e));let h=n.map[d];!t&&h&&h.hashcode===p?u.delete(d):(h=new r["a"]({key:d,order:f,hashcode:p,...e},n.theme,n.locale),c.push(h)),h&&h.pinPage&&(s=h),o[d]=h,i.push(h);})),this.map=o,this.list=i,this.pinAttr=s,{adds:c,deletes:Array.from(u)}}}},"93ed":function(e,t,n){var r=n("4245");function a(e){var t=r(this,e)["delete"](e);return this.size-=t?1:0,t}e.exports=a;},9404:function(e,t,n){n.d(t,"j",(function(){return B})),n.d(t,"m",(function(){return Z})),n.d(t,"e",(function(){return q})),n.d(t,"f",(function(){return G})),n.d(t,"v",(function(){return K}));var r=n("6679"),a=n.n(r);n.d(t,"i",(function(){return a.a}));var o=n("501e"),i=n.n(o);n.d(t,"l",(function(){return i.a}));var s=n("e2a0"),c=n.n(s);n.d(t,"n",(function(){return c.a}));var u=n("dcbe"),l=n.n(u);n.d(t,"h",(function(){return l.a}));var d=n("9520"),f=n.n(d);n.d(t,"k",(function(){return f.a}));var p=n("4cfe"),h=n.n(p);n.d(t,"o",(function(){return h.a}));var v=n("6220"),b=n.n(v),m=n("f678"),g=n.n(m);n.d(t,"a",(function(){return g.a}));var y=n("9b02"),w=n.n(y);n.d(t,"d",(function(){return w.a}));var x=n("0f5c"),D=n.n(x);n.d(t,"u",(function(){return D.a}));var O=n("9e86"),j=n.n(O);n.d(t,"r",(function(){return j.a}));var k=n("f542"),M=n.n(k);n.d(t,"w",(function(){return M.a}));var P=n("95ae"),Y=n.n(P);n.d(t,"b",(function(){return Y.a}));var S=n("3f84"),_=n.n(S);n.d(t,"c",(function(){return _.a}));var E=n("2593"),I=n.n(E);n.d(t,"t",(function(){return I.a}));var T=n("3eea"),C=n.n(T);n.d(t,"s",(function(){return C.a}));var $=n("3852"),A=n.n($),N=n("dd61"),F=n.n(N);n.d(t,"q",(function(){return F.a}));var z=n("a59b"),L=n.n(z);n.d(t,"g",(function(){return L.a}));var H=n("4416"),R=n.n(H);n.d(t,"p",(function(){return R.a}));var W=n("3092"),V=n.n(W);const U=function(e){return Object.prototype.toString.call(e).slice(8,-1)},B=function(e){return b()(e)&&!isNaN(e.getTime())},Z=function(e){return "Object"===U(e)},q=A.a,G=function(e,t){return V()(t,(function(t){return A()(e,t)}))},K=V.a;},"94ca":function(e,t,n){var r=n("d039"),a=/#|\.prototype\./,o=function(e,t){var n=s[i(e)];return n==u||n!=c&&("function"==typeof t?r(t):!!t)},i=o.normalize=function(e){return String(e).replace(a,".").toLowerCase()},s=o.data={},c=o.NATIVE="N",u=o.POLYFILL="P";e.exports=o;},"950a":function(e,t,n){var r=n("30c9");function a(e,t){return function(n,a){if(null==n)return n;if(!r(n))return e(n,a);var o=n.length,i=t?o:-1,s=Object(n);while(t?i--:++i<o)if(!1===a(s[i],i,s))break;return n}}e.exports=a;},9520:function(e,t,n){var r=n("3729"),a=n("1a8c"),o="[object AsyncFunction]",i="[object Function]",s="[object GeneratorFunction]",c="[object Proxy]";function u(e){if(!a(e))return !1;var t=r(e);return t==i||t==s||t==o||t==c}e.exports=u;},"95ae":function(e,t,n){var r=n("100e"),a=n("9638"),o=n("9aff"),i=n("9934"),s=Object.prototype,c=s.hasOwnProperty,u=r((function(e,t){e=Object(e);var n=-1,r=t.length,u=r>2?t[2]:void 0;u&&o(t[0],t[1],u)&&(r=1);while(++n<r){var l=t[n],d=i(l),f=-1,p=d.length;while(++f<p){var h=d[f],v=e[h];(void 0===v||a(v,s[h])&&!c.call(e,h))&&(e[h]=l[h]);}}return e}));e.exports=u;},9638:function(e,t){function n(e,t){return e===t||e!==e&&t!==t}e.exports=n;},"966f":function(e,t,n){var r=n("7e64"),a=n("c05f"),o=1,i=2;function s(e,t,n,s){var c=n.length,u=c,l=!s;if(null==e)return !u;e=Object(e);while(c--){var d=n[c];if(l&&d[2]?d[1]!==e[d[0]]:!(d[0]in e))return !1}while(++c<u){d=n[c];var f=d[0],p=e[f],h=d[1];if(l&&d[2]){if(void 0===p&&!(f in e))return !1}else{var v=new r;if(s)var b=s(p,h,f,e,t,v);if(!(void 0===b?a(h,p,o|i,s,v):b))return !1}}return !0}e.exports=s;},"96f3":function(e,t){var n=Object.prototype,r=n.hasOwnProperty;function a(e,t){return null!=e&&r.call(e,t)}e.exports=a;},"97d3":function(e,t,n){var r=n("48a0"),a=n("30c9");function o(e,t){var n=-1,o=a(e)?Array(e.length):[];return r(e,(function(e,r,a){o[++n]=t(e,r,a);})),o}e.exports=o;},9934:function(e,t,n){var r=n("6fcd"),a=n("41c3"),o=n("30c9");function i(e){return o(e)?r(e,!0):a(e)}e.exports=i;},"99cd":function(e,t){function n(e){return function(t,n,r){var a=-1,o=Object(t),i=r(t),s=i.length;while(s--){var c=i[e?s:++a];if(!1===n(o[c],c,o))break}return t}}e.exports=n;},"99d3":function(e,t,n){(function(e){var r=n("585a"),a=t&&!t.nodeType&&t,o=a&&"object"==typeof e&&e&&!e.nodeType&&e,i=o&&o.exports===a,s=i&&r.process,c=function(){try{var e=o&&o.require&&o.require("util").types;return e||s&&s.binding&&s.binding("util")}catch(t){}}();e.exports=c;}).call(this,n("62e4")(e));},"9aff":function(e,t,n){var r=n("9638"),a=n("30c9"),o=n("c098"),i=n("1a8c");function s(e,t,n){if(!i(n))return !1;var s=typeof t;return !!("number"==s?a(n)&&o(t,n.length):"string"==s&&t in n)&&r(n[t],e)}e.exports=s;},"9b02":function(e,t,n){var r=n("656b");function a(e,t,n){var a=null==e?void 0:r(e,t);return void 0===a?n:a}e.exports=a;},"9bf2":function(e,t,n){var r=n("83ab"),a=n("0cfb"),o=n("825a"),i=n("c04e"),s=Object.defineProperty;t.f=r?s:function(e,t,n){if(o(e),t=i(t,!0),o(n),a)try{return s(e,t,n)}catch(r){}if("get"in n||"set"in n)throw TypeError("Accessors not supported");return "value"in n&&(e[t]=n.value),e};},"9e2e":function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,".vc-pane-container{width:100%;position:relative}.vc-pane-container.in-transition{overflow:hidden}.vc-pane-layout{display:grid}.vc-arrow{display:flex;justify-content:center;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none;pointer-events:auto;color:var(--gray-600);border-width:2px;border-style:solid;border-radius:var(--rounded);border-color:transparent}.vc-arrow:hover{background:var(--gray-200)}.vc-arrow:focus{border-color:var(--gray-300)}.vc-arrow.is-disabled{opacity:.25;pointer-events:none;cursor:not-allowed}.vc-day-popover-container{color:var(--white);background-color:var(--gray-800);border:1px solid;border-color:var(--gray-700);border-radius:var(--rounded);font-size:var(--text-xs);font-weight:var(--font-medium);padding:4px 8px;box-shadow:var(--shadow)}.vc-day-popover-header{font-size:var(--text-xs);color:var(--gray-300);font-weight:var(--font-semibold);text-align:center}.vc-arrows-container{width:100%;position:absolute;top:0;display:flex;justify-content:space-between;padding:8px 10px;pointer-events:none}.vc-arrows-container.title-left{justify-content:flex-end}.vc-arrows-container.title-right{justify-content:flex-start}.vc-is-dark .vc-arrow{color:var(--white)}.vc-is-dark .vc-arrow:hover{background:var(--gray-800)}.vc-is-dark .vc-arrow:focus{border-color:var(--gray-700)}.vc-is-dark .vc-day-popover-container{color:var(--gray-800);background-color:var(--white);border-color:var(--gray-100)}.vc-is-dark .vc-day-popover-header{color:var(--gray-700)}",""]),e.exports=t;},"9e69":function(e,t,n){var r=n("2b3e"),a=r.Symbol;e.exports=a;},"9e83":function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,".vc-nav-popover-container{color:var(--white);font-size:var(--text-sm);font-weight:var(--font-semibold);background-color:var(--gray-800);border:1px solid;border-color:var(--gray-700);border-radius:var(--rounded-lg);padding:4px;box-shadow:var(--shadow)}.vc-is-dark .vc-nav-popover-container{color:var(--gray-800);background-color:var(--white);border-color:var(--gray-100)}",""]),e.exports=t;},"9e86":function(e,t,n){var r=n("872a"),a=n("242e"),o=n("badf");function i(e,t){var n={};return t=o(t,3),a(e,(function(e,a,o){r(n,a,t(e,a,o));})),n}e.exports=i;},"9ed3":function(e,t,n){var r=n("ae93").IteratorPrototype,a=n("7c73"),o=n("5c6c"),i=n("d44e"),s=n("3f8c"),c=function(){return this};e.exports=function(e,t,n){var u=t+" Iterator";return e.prototype=a(r,{next:o(1,n)}),i(e,u,!1,!0),s[u]=c,e};},"9f7f":function(e,t,n){var r=n("d039"),a=function(e,t){return RegExp(e,t)};t.UNSUPPORTED_Y=r((function(){var e=a("a","y");return e.lastIndex=2,null!=e.exec("abcd")})),t.BROKEN_CARET=r((function(){var e=a("^r","gy");return e.lastIndex=2,null!=e.exec("str")}));},a029:function(e,t,n){var r=n("087d"),a=n("2dcb"),o=n("32f4"),i=n("d327"),s=Object.getOwnPropertySymbols,c=s?function(e){var t=[];while(e)r(t,o(e)),e=a(e);return t}:i;e.exports=c;},a10d:function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,".vc-day[data-v-4420d078]{position:relative;min-height:32px;z-index:1}.vc-day.is-not-in-month *[data-v-4420d078]{opacity:0;pointer-events:none}.vc-day-layer[data-v-4420d078]{position:absolute;left:0;right:0;top:0;bottom:0;pointer-events:none}.vc-day-box-center-center[data-v-4420d078]{display:flex;justify-content:center;align-items:center;transform-origin:50% 50%}.vc-day-box-left-center[data-v-4420d078]{display:flex;justify-content:flex-start;align-items:center;transform-origin:0 50%}.vc-day-box-right-center[data-v-4420d078]{display:flex;justify-content:flex-end;align-items:center;transform-origin:100% 50%}.vc-day-box-center-bottom[data-v-4420d078]{display:flex;justify-content:center;align-items:flex-end}.vc-day-content[data-v-4420d078]{display:flex;justify-content:center;align-items:center;font-size:var(--text-sm);font-weight:var(--font-medium);width:28px;height:28px;line-height:28px;border-radius:var(--rounded-full);-webkit-user-select:none;user-select:none;cursor:pointer}.vc-day-content[data-v-4420d078]:hover{background-color:rgba(204,214,224,.3)}.vc-day-content[data-v-4420d078]:focus{font-weight:var(--font-bold);background-color:rgba(204,214,224,.4)}.vc-day-content.is-disabled[data-v-4420d078]{color:var(--gray-400)}.vc-is-dark .vc-day-content[data-v-4420d078]:hover{background-color:rgba(114,129,151,.3)}.vc-is-dark .vc-day-content[data-v-4420d078]:focus{background-color:rgba(114,129,151,.4)}.vc-is-dark .vc-day-content.is-disabled[data-v-4420d078]{color:var(--gray-600)}.vc-highlights[data-v-4420d078]{overflow:hidden;pointer-events:none;z-index:-1}.vc-highlight[data-v-4420d078]{width:28px;height:28px}.vc-highlight.vc-highlight-base-start[data-v-4420d078]{width:50%!important;border-radius:0!important;border-right-width:0!important}.vc-highlight.vc-highlight-base-end[data-v-4420d078]{width:50%!important;border-radius:0!important;border-left-width:0!important}.vc-highlight.vc-highlight-base-middle[data-v-4420d078]{width:100%;border-radius:0!important;border-left-width:0!important;border-right-width:0!important;margin:0 -1px}.vc-dots[data-v-4420d078]{display:flex;justify-content:center;align-items:center}.vc-dot[data-v-4420d078]{width:5px;height:5px;border-radius:50%;transition:all var(--day-content-transition-time)}.vc-dot[data-v-4420d078]:not(:last-child){margin-right:3px}.vc-bars[data-v-4420d078]{display:flex;justify-content:flex-start;align-items:center;width:75%}.vc-bar[data-v-4420d078]{flex-grow:1;height:3px;transition:all var(--day-content-transition-time)}",""]),e.exports=t;},a2be:function(e,t,n){var r=n("d612"),a=n("4284"),o=n("c584"),i=1,s=2;function c(e,t,n,c,u,l){var d=n&i,f=e.length,p=t.length;if(f!=p&&!(d&&p>f))return !1;var h=l.get(e),v=l.get(t);if(h&&v)return h==t&&v==e;var b=-1,m=!0,g=n&s?new r:void 0;l.set(e,t),l.set(t,e);while(++b<f){var y=e[b],w=t[b];if(c)var x=d?c(w,y,b,t,e,l):c(y,w,b,e,t,l);if(void 0!==x){if(x)continue;m=!1;break}if(g){if(!a(t,(function(e,t){if(!o(g,t)&&(y===e||u(y,e,n,c,l)))return g.push(t)}))){m=!1;break}}else if(y!==w&&!u(y,w,n,c,l)){m=!1;break}}return l["delete"](e),l["delete"](t),m}e.exports=c;},a2db:function(e,t,n){var r=n("9e69"),a=r?r.prototype:void 0,o=a?a.valueOf:void 0;function i(e){return o?Object(o.call(e)):{}}e.exports=i;},a3fd:function(e,t,n){var r=n("7948");function a(e,t){return r(t,(function(t){return [t,e[t]]}))}e.exports=a;},a454:function(e,t,n){var r=n("72f0"),a=n("3b4a"),o=n("cd9d"),i=a?function(e,t){return a(e,"toString",{configurable:!0,enumerable:!1,value:r(t),writable:!0})}:o;e.exports=i;},a524:function(e,t,n){var r=n("4245");function a(e){return r(this,e).has(e)}e.exports=a;},a59b:function(e,t){function n(e){return e&&e.length?e[0]:void 0}e.exports=n;},a691:function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)};},a994:function(e,t,n){var r=n("7d1f"),a=n("32f4"),o=n("ec69");function i(e){return r(e,o,a)}e.exports=i;},ac1f:function(e,t,n){var r=n("23e7"),a=n("9263");r({target:"RegExp",proto:!0,forced:/./.exec!==a},{exec:a});},ac41:function(e,t){function n(e){var t=-1,n=Array(e.size);return e.forEach((function(e){n[++t]=e;})),n}e.exports=n;},ad6d:function(e,t,n){var r=n("825a");e.exports=function(){var e=r(this),t="";return e.global&&(t+="g"),e.ignoreCase&&(t+="i"),e.multiline&&(t+="m"),e.dotAll&&(t+="s"),e.unicode&&(t+="u"),e.sticky&&(t+="y"),t};},ad82:function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,".vc-time-picker[data-v-f4e11af8]{display:flex;align-items:center;padding:8px}.vc-time-picker.vc-invalid[data-v-f4e11af8]{pointer-events:none;opacity:.5}.vc-time-picker.vc-bordered[data-v-f4e11af8]{border-top:1px solid var(--gray-400)}.vc-date-time[data-v-f4e11af8]{margin-left:8px}.vc-disabled[data-v-f4e11af8]{pointer-events:none;opacity:.5}.vc-time-icon[data-v-f4e11af8]{width:16px;height:16px;color:var(--gray-600)}.vc-date[data-v-f4e11af8]{display:flex;align-items:center;font-size:var(--text-sm);font-weight:var(--font-semibold);text-transform:uppercase;padding:0 0 4px 4px;margin-top:-4px}.vc-date .vc-weekday[data-v-f4e11af8]{color:var(--gray-700);letter-spacing:var(--tracking-wide)}.vc-date .vc-month[data-v-f4e11af8]{color:var(--accent-600);margin-left:8px}.vc-date .vc-day[data-v-f4e11af8]{color:var(--accent-600);margin-left:4px}.vc-date .vc-year[data-v-f4e11af8]{color:var(--gray-500);margin-left:8px}.vc-am-pm[data-v-f4e11af8],.vc-time[data-v-f4e11af8]{display:flex;align-items:center}.vc-am-pm[data-v-f4e11af8]{background:var(--gray-200);margin-left:8px;padding:4px;border-radius:var(--rounded);height:30px}.vc-am-pm button[data-v-f4e11af8]{color:var(--gray-900);font-size:var(--text-sm);font-weight:var(--font-medium);padding:0 4px;background:transparent;border:2px solid transparent;border-radius:var(--rounded);line-height:var(--leading-snug)}.vc-am-pm button[data-v-f4e11af8]:hover{color:var(--gray-600)}.vc-am-pm button[data-v-f4e11af8]:focus{border-color:var(--accent-400)}.vc-am-pm button.active[data-v-f4e11af8]{background:var(--accent-600);color:var(--white)}.vc-am-pm button.active[data-v-f4e11af8]:hover{background:var(--accent-500)}.vc-am-pm button.active[data-v-f4e11af8]:focus{border-color:var(--accent-400)}.vc-is-dark .vc-time-picker[data-v-f4e11af8]{border-color:var(--gray-700)}.vc-is-dark .vc-time-icon[data-v-f4e11af8],.vc-is-dark .vc-weekday[data-v-f4e11af8]{color:var(--gray-400)}.vc-is-dark .vc-day[data-v-f4e11af8],.vc-is-dark .vc-month[data-v-f4e11af8]{color:var(--accent-400)}.vc-is-dark .vc-year[data-v-f4e11af8]{color:var(--gray-500)}.vc-is-dark .vc-am-pm[data-v-f4e11af8]{background:var(--gray-700)}.vc-is-dark .vc-am-pm[data-v-f4e11af8]:focus{border-color:var(--accent-500)}.vc-is-dark .vc-am-pm button[data-v-f4e11af8]{color:var(--gray-100)}.vc-is-dark .vc-am-pm button[data-v-f4e11af8]:hover{color:var(--gray-400)}.vc-is-dark .vc-am-pm button[data-v-f4e11af8]:focus{border-color:var(--accent-500)}.vc-is-dark .vc-am-pm button.active[data-v-f4e11af8]{background:var(--accent-500);color:var(--white)}.vc-is-dark .vc-am-pm button.active[data-v-f4e11af8]:hover{background:var(--accent-600)}.vc-is-dark .vc-am-pm button.active[data-v-f4e11af8]:focus{border-color:var(--accent-500)}",""]),e.exports=t;},adc8:function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,".vc-day-popover-row[data-v-eb5afd1a]{--day-content-transition-time:0.13s ease-in;display:flex;align-items:center;transition:all var(--day-content-transition-time)}.vc-day-popover-row[data-v-eb5afd1a]:not(:first-child){margin-top:3px}.vc-day-popover-row-indicator[data-v-eb5afd1a]{display:flex;justify-content:center;align-items:center;flex-grow:0;width:15px;margin-right:3px}.vc-day-popover-row-indicator span[data-v-eb5afd1a]{transition:all var(--day-content-transition-time)}.vc-day-popover-row-content[data-v-eb5afd1a]{display:flex;align-items:center;flex-wrap:none;flex-grow:1;width:max-content}",""]),e.exports=t;},ae93:function(e,t,n){var r,a,o,i=n("d039"),s=n("e163"),c=n("9112"),u=n("5135"),l=n("b622"),d=n("c430"),f=l("iterator"),p=!1,h=function(){return this};[].keys&&(o=[].keys(),"next"in o?(a=s(s(o)),a!==Object.prototype&&(r=a)):p=!0);var v=void 0==r||i((function(){var e={};return r[f].call(e)!==e}));v&&(r={}),d&&!v||u(r,f)||c(r,f,h),e.exports={IteratorPrototype:r,BUGGY_SAFARI_ITERATORS:p};},b047:function(e,t){function n(e){return function(t){return e(t)}}e.exports=n;},b1d2:function(e,t,n){var r=n("3729"),a=n("1310"),o="[object Date]";function i(e){return a(e)&&r(e)==o}e.exports=i;},b1e5:function(e,t,n){var r=n("a994"),a=1,o=Object.prototype,i=o.hasOwnProperty;function s(e,t,n,o,s,c){var u=n&a,l=r(e),d=l.length,f=r(t),p=f.length;if(d!=p&&!u)return !1;var h=d;while(h--){var v=l[h];if(!(u?v in t:i.call(t,v)))return !1}var b=c.get(e),m=c.get(t);if(b&&m)return b==t&&m==e;var g=!0;c.set(e,t),c.set(t,e);var y=u;while(++h<d){v=l[h];var w=e[v],x=t[v];if(o)var D=u?o(x,w,v,t,e,c):o(w,x,v,e,t,c);if(!(void 0===D?w===x||s(w,x,n,o,c):D)){g=!1;break}y||(y="constructor"==v);}if(g&&!y){var O=e.constructor,j=t.constructor;O==j||!("constructor"in e)||!("constructor"in t)||"function"==typeof O&&O instanceof O&&"function"==typeof j&&j instanceof j||(g=!1);}return c["delete"](e),c["delete"](t),g}e.exports=s;},b218:function(e,t){var n=9007199254740991;function r(e){return "number"==typeof e&&e>-1&&e%1==0&&e<=n}e.exports=r;},b4b0:function(e,t,n){var r=n("8d74"),a=n("1a8c"),o=n("ffd6"),i=NaN,s=/^[-+]0x[0-9a-f]+$/i,c=/^0b[01]+$/i,u=/^0o[0-7]+$/i,l=parseInt;function d(e){if("number"==typeof e)return e;if(o(e))return i;if(a(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=a(t)?t+"":t;}if("string"!=typeof e)return 0===e?e:+e;e=r(e);var n=c.test(e);return n||u.test(e)?l(e.slice(2),n?2:8):s.test(e)?i:+e}e.exports=d;},b4c0:function(e,t,n){var r=n("cb5a");function a(e){var t=this.__data__,n=r(t,e);return n<0?void 0:t[n][1]}e.exports=a;},b5a7:function(e,t,n){var r=n("0b07"),a=n("2b3e"),o=r(a,"DataView");e.exports=o;},b622:function(e,t,n){var r=n("da84"),a=n("5692"),o=n("5135"),i=n("90e3"),s=n("4930"),c=n("fdbf"),u=a("wks"),l=r.Symbol,d=c?l:l&&l.withoutSetter||i;e.exports=function(e){return o(u,e)&&(s||"string"==typeof u[e])||(s&&o(l,e)?u[e]=l[e]:u[e]=d("Symbol."+e)),u[e]};},b760:function(e,t,n){var r=n("872a"),a=n("9638");function o(e,t,n){(void 0!==n&&!a(e[t],n)||void 0===n&&!(t in e))&&r(e,t,n);}e.exports=o;},badf:function(e,t,n){var r=n("642a"),a=n("1838"),o=n("cd9d"),i=n("6747"),s=n("f9ce");function c(e){return "function"==typeof e?e:null==e?o:"object"==typeof e?i(e)?a(e[0],e[1]):r(e):s(e)}e.exports=c;},bbc0:function(e,t,n){var r=n("6044"),a="__lodash_hash_undefined__",o=Object.prototype,i=o.hasOwnProperty;function s(e){var t=this.__data__;if(r){var n=t[e];return n===a?void 0:n}return i.call(t,e)?t[e]:void 0}e.exports=s;},bdb3:function(e,t,n){var r=n("e052"),a=n.n(r);a.a;},c04e:function(e,t,n){var r=n("861d");e.exports=function(e,t){if(!r(e))return e;var n,a;if(t&&"function"==typeof(n=e.toString)&&!r(a=n.call(e)))return a;if("function"==typeof(n=e.valueOf)&&!r(a=n.call(e)))return a;if(!t&&"function"==typeof(n=e.toString)&&!r(a=n.call(e)))return a;throw TypeError("Can't convert object to primitive value")};},c05f:function(e,t,n){var r=n("7b97"),a=n("1310");function o(e,t,n,i,s){return e===t||(null==e||null==t||!a(e)&&!a(t)?e!==e&&t!==t:r(e,t,n,i,o,s))}e.exports=o;},c098:function(e,t){var n=9007199254740991,r=/^(?:0|[1-9]\d*)$/;function a(e,t){var a=typeof e;return t=null==t?n:t,!!t&&("number"==a||"symbol"!=a&&r.test(e))&&e>-1&&e%1==0&&e<t}e.exports=a;},c1c9:function(e,t,n){var r=n("a454"),a=n("f3c1"),o=a(r);e.exports=o;},c2b6:function(e,t,n){var r=n("f8af"),a=n("5d89"),o=n("6f6c"),i=n("a2db"),s=n("c8fe"),c="[object Boolean]",u="[object Date]",l="[object Map]",d="[object Number]",f="[object RegExp]",p="[object Set]",h="[object String]",v="[object Symbol]",b="[object ArrayBuffer]",m="[object DataView]",g="[object Float32Array]",y="[object Float64Array]",w="[object Int8Array]",x="[object Int16Array]",D="[object Int32Array]",O="[object Uint8Array]",j="[object Uint8ClampedArray]",k="[object Uint16Array]",M="[object Uint32Array]";function P(e,t,n){var P=e.constructor;switch(t){case b:return r(e);case c:case u:return new P(+e);case m:return a(e,n);case g:case y:case w:case x:case D:case O:case j:case k:case M:return s(e,n);case l:return new P;case d:case h:return new P(e);case f:return o(e);case p:return new P;case v:return i(e)}}e.exports=P;},c3fc:function(e,t,n){var r=n("42a2"),a=n("1310"),o="[object Set]";function i(e){return a(e)&&r(e)==o}e.exports=i;},c430:function(e,t){e.exports=!1;},c584:function(e,t){function n(e,t){return e.has(t)}e.exports=n;},c6b6:function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)};},c6cd:function(e,t,n){var r=n("da84"),a=n("ce4e"),o="__core-js_shared__",i=r[o]||a(o,{});e.exports=i;},c6cf:function(e,t,n){var r=n("4d8c"),a=n("2286"),o=n("c1c9");function i(e){return o(a(e,void 0,r),e+"")}e.exports=i;},c869:function(e,t,n){var r=n("0b07"),a=n("2b3e"),o=r(a,"Set");e.exports=o;},c87c:function(e,t){var n=Object.prototype,r=n.hasOwnProperty;function a(e){var t=e.length,n=new e.constructor(t);return t&&"string"==typeof e[0]&&r.call(e,"index")&&(n.index=e.index,n.input=e.input),n}e.exports=a;},c8ba:function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")();}catch(r){"object"===typeof window&&(n=window);}e.exports=n;},c8fe:function(e,t,n){var r=n("f8af");function a(e,t){var n=t?r(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.length)}e.exports=a;},ca84:function(e,t,n){var r=n("5135"),a=n("fc6a"),o=n("4d64").indexOf,i=n("d012");e.exports=function(e,t){var n,s=a(e),c=0,u=[];for(n in s)!r(i,n)&&r(s,n)&&u.push(n);while(t.length>c)r(s,n=t[c++])&&(~o(u,n)||u.push(n));return u};},cb5a:function(e,t,n){var r=n("9638");function a(e,t){var n=e.length;while(n--)if(r(e[n][0],t))return n;return -1}e.exports=a;},cc12:function(e,t,n){var r=n("da84"),a=n("861d"),o=r.document,i=a(o)&&a(o.createElement);e.exports=function(e){return i?o.createElement(e):{}};},cc45:function(e,t,n){var r=n("1a2d"),a=n("b047"),o=n("99d3"),i=o&&o.isMap,s=i?a(i):r;e.exports=s;},cd9d:function(e,t){function n(e){return e}e.exports=n;},ce4e:function(e,t,n){var r=n("da84"),a=n("9112");e.exports=function(e,t){try{a(r,e,t);}catch(n){r[e]=t;}return t};},ce86:function(e,t,n){var r=n("9e69"),a=n("7948"),o=n("6747"),i=n("ffd6"),s=1/0,c=r?r.prototype:void 0,u=c?c.toString:void 0;function l(e){if("string"==typeof e)return e;if(o(e))return a(e,l)+"";if(i(e))return u?u.call(e):"";var t=e+"";return "0"==t&&1/e==-s?"-0":t}e.exports=l;},cebd:function(e,t){function n(e){var t=-1,n=Array(e.size);return e.forEach((function(e){n[++t]=[e,e];})),n}e.exports=n;},cecd:function(e,t,n){var r=n("2202");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("8c0a5c0c",r,!0,{sourceMap:!1,shadowMode:!1});},cfe5:function(e,t,n){n.d(t,"a",(function(){return c}));var r=n("f7f1"),a=n("2fa3"),o=n("9404"),i=n("29ae");const s=864e5;class c{constructor(e,{order:t=0,locale:n,isFullDay:s}={}){if(this.isDateInfo=!0,this.order=t,this.locale=n instanceof i["b"]?n:new i["b"](n),this.firstDayOfWeek=this.locale.firstDayOfWeek,!Object(o["m"])(e)){const t=this.locale.normalizeDate(e);e=s?{start:t,end:t}:{startOn:t,endOn:t};}let u=null,l=null;if(e.start?u=this.locale.normalizeDate(e.start,{...this.opts,time:"00:00:00"}):e.startOn&&(u=this.locale.normalizeDate(e.startOn,this.opts)),e.end?l=this.locale.normalizeDate(e.end,{...this.opts,time:"23:59:59"}):e.endOn&&(l=this.locale.normalizeDate(e.endOn,this.opts)),u&&l&&u>l){const e=u;u=l,l=e;}else u&&e.span>=1&&(l=Object(r["a"])(u,e.span-1));this.start=u,this.startTime=u?u.getTime():NaN,this.end=l,this.endTime=l?l.getTime():NaN,this.isDate=this.startTime&&this.startTime===this.endTime,this.isRange=!this.isDate;const d=Object(a["i"])(e,{},c.patternProps);if(d.assigned&&(this.on={and:d.target}),e.on){const t=(Object(o["h"])(e.on)?e.on:[e.on]).map((function(e){if(Object(o["k"])(e))return e;const t=Object(a["i"])(e,{},c.patternProps);return t.assigned?t.target:null})).filter((function(e){return e}));t.length&&(this.on={...this.on,or:t});}this.isComplex=!!this.on;}get opts(){return {order:this.order,locale:this.locale}}toDateInfo(e){return e.isDateInfo?e:new c(e,this.opts)}startOfWeek(e){const t=e.getDay()+1,n=t>=this.firstDayOfWeek?this.firstDayOfWeek-t:-(7-(this.firstDayOfWeek-t));return Object(r["a"])(e,n)}diffInDays(e,t){return Math.round((t-e)/s)}diffInWeeks(e,t){return this.diffInDays(this.startOfWeek(e),this.startOfWeek(t))}diffInYears(e,t){return t.getUTCFullYear()-e.getUTCFullYear()}diffInMonths(e,t){return 12*this.diffInYears(e,t)+(t.getMonth()-e.getMonth())}static get patterns(){return {dailyInterval:{test:function(e,t,n){return n.diffInDays(n.start||new Date,e.date)%t===0}},weeklyInterval:{test:function(e,t,n){return n.diffInWeeks(n.start||new Date,e.date)%t===0}},monthlyInterval:{test:function(e,t,n){return n.diffInMonths(n.start||new Date,e.date)%t===0}},yearlyInterval:{test:function(){return function(e,t,n){return n.diffInYears(n.start||new Date,e.date)%t===0}}},days:{validate:function(e){return Object(o["h"])(e)?e:[parseInt(e,10)]},test:function(e,t){return t.includes(e.day)||t.includes(-e.dayFromEnd)}},weekdays:{validate:function(e){return Object(o["h"])(e)?e:[parseInt(e,10)]},test:function(e,t){return t.includes(e.weekday)}},ordinalWeekdays:{validate:function(e){return Object.keys(e).reduce((function(t,n){const r=e[n];return r?(t[n]=Object(o["h"])(r)?r:[parseInt(r,10)],t):t}),{})},test:function(e,t){return Object.keys(t).map((function(e){return parseInt(e,10)})).find((function(n){return t[n].includes(e.weekday)&&(n===e.weekdayOrdinal||n===-e.weekdayOrdinalFromEnd)}))}},weekends:{validate:function(e){return e},test:function(e){return 1===e.weekday||7===e.weekday}},workweek:{validate:function(e){return e},test:function(e){return e.weekday>=2&&e.weekday<=6}},weeks:{validate:function(e){return Object(o["h"])(e)?e:[parseInt(e,10)]},test:function(e,t){return t.includes(e.week)||t.includes(-e.weekFromEnd)}},months:{validate:function(e){return Object(o["h"])(e)?e:[parseInt(e,10)]},test:function(e,t){return t.includes(e.month)}},years:{validate:function(e){return Object(o["h"])(e)?e:[parseInt(e,10)]},test:function(e,t){return t.includes(e.year)}}}}static get patternProps(){return Object.keys(c.patterns).map((function(e){return {name:e,validate:c.patterns[e].validate}}))}static testConfig(e,t,n){return Object(o["k"])(e)?e(t):Object(o["m"])(e)?Object.keys(e).every((function(r){return c.patterns[r].test(t,e[r],n)})):null}iterateDatesInRange({start:e,end:t},n){if(!e||!t||!Object(o["k"])(n))return null;e=this.locale.normalizeDate(e,{...this.opts,time:"00:00:00"});const a={i:0,date:e,day:this.locale.getDateParts(e),finished:!1};let i=null;for(;!a.finished&&a.date<=t;a.i++)i=n(a),a.date=Object(r["a"])(a.date,1),a.day=this.locale.getDateParts(a.date);return i}shallowIntersectingRange(e){return this.rangeShallowIntersectingRange(this,this.toDateInfo(e))}rangeShallowIntersectingRange(e,t){if(!this.dateShallowIntersectsDate(e,t))return null;const n=e.toRange(),r=t.toRange();let a=null,o=null;return n.start?a=r.start?n.start>r.start?n.start:r.start:n.start:r.start&&(a=r.start),n.end?o=r.end?n.end<r.end?n.end:r.end:n.end:r.end&&(o=r.end),{start:a,end:o}}intersectsDate(e){var t=this;const n=this.toDateInfo(e);if(!this.shallowIntersectsDate(n))return null;if(!this.on)return this;const r=this.rangeShallowIntersectingRange(this,n);let a=!1;return this.iterateDatesInRange(r,(function(e){t.matchesDay(e.day)&&(a=a||n.matchesDay(e.day),e.finished=a);})),a}shallowIntersectsDate(e){return this.dateShallowIntersectsDate(this,this.toDateInfo(e))}dateShallowIntersectsDate(e,t){return e.isDate?t.isDate?e.startTime===t.startTime:this.dateShallowIncludesDate(t,e):t.isDate?this.dateShallowIncludesDate(e,t):!(e.start&&t.end&&e.start>t.end)&&!(e.end&&t.start&&e.end<t.start)}includesDate(e){var t=this;const n=this.toDateInfo(e);if(!this.shallowIncludesDate(n))return !1;if(!this.on)return !0;const r=this.rangeShallowIntersectingRange(this,n);let a=!0;return this.iterateDatesInRange(r,(function(e){t.matchesDay(e.day)&&(a=a&&n.matchesDay(e.day),e.finished=!a);})),a}shallowIncludesDate(e){return this.dateShallowIncludesDate(this,e.isDate?e:new c(e,this.opts))}dateShallowIncludesDate(e,t){return e.isDate?t.isDate?e.startTime===t.startTime:!(!t.startTime||!t.endTime)&&(e.startTime===t.startTime&&e.startTime===t.endTime):t.isDate?!(e.start&&t.start<e.start)&&!(e.end&&t.start>e.end):!(e.start&&(!t.start||t.start<e.start))&&!(e.end&&(!t.end||t.end>e.end))}intersectsDay(e){return this.shallowIntersectsDate(e.range)&&this.matchesDay(e)?this:null}matchesDay(e){var t=this;return !this.on||!(this.on.and&&!c.testConfig(this.on.and,e,this))&&!(this.on.or&&!this.on.or.some((function(n){return c.testConfig(n,e,t)})))}toRange(){return new c({start:this.start,end:this.end},this.opts)}compare(e){if(this.order!==e.order)return this.order-e.order;if(this.isDate!==e.isDate)return this.isDate?1:-1;if(this.isDate)return 0;const t=this.start-e.start;return 0!==t?t:this.end-e.end}}},d012:function(e,t){e.exports={};},d02c:function(e,t,n){var r=n("5e2e"),a=n("79bc"),o=n("7b83"),i=200;function s(e,t){var n=this.__data__;if(n instanceof r){var s=n.__data__;if(!a||s.length<i-1)return s.push([e,t]),this.size=++n.size,this;n=this.__data__=new o(s);}return n.set(e,t),this.size=n.size,this}e.exports=s;},d039:function(e,t){e.exports=function(e){try{return !!e()}catch(t){return !0}};},d066:function(e,t,n){var r=n("428f"),a=n("da84"),o=function(e){return "function"==typeof e?e:void 0};e.exports=function(e,t){return arguments.length<2?o(r[e])||o(a[e]):r[e]&&r[e][t]||a[e]&&a[e][t]};},d1e7:function(e,t,n){var r={}.propertyIsEnumerable,a=Object.getOwnPropertyDescriptor,o=a&&!r.call({1:2},1);t.f=o?function(e){var t=a(this,e);return !!t&&t.enumerable}:r;},d2bb:function(e,t,n){var r=n("825a"),a=n("3bbe");e.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var e,t=!1,n={};try{e=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set,e.call(n,[]),t=n instanceof Array;}catch(o){}return function(n,o){return r(n),a(o),t?e.call(n,o):n.__proto__=o,n}}():void 0);},d327:function(e,t){function n(){return []}e.exports=n;},d370:function(e,t,n){var r=n("253c"),a=n("1310"),o=Object.prototype,i=o.hasOwnProperty,s=o.propertyIsEnumerable,c=r(function(){return arguments}())?r:function(e){return a(e)&&i.call(e,"callee")&&!s.call(e,"callee")};e.exports=c;},d438:function(e,t,n){var r=n("3db9"),a=n.n(r);a.a;},d44e:function(e,t,n){var r=n("9bf2").f,a=n("5135"),o=n("b622"),i=o("toStringTag");e.exports=function(e,t,n){e&&!a(e=n?e:e.prototype,i)&&r(e,i,{configurable:!0,value:t});};},d612:function(e,t,n){var r=n("7b83"),a=n("7ed2"),o=n("dc0f");function i(e){var t=-1,n=null==e?0:e.length;this.__data__=new r;while(++t<n)this.add(e[t]);}i.prototype.add=i.prototype.push=a,i.prototype.has=o,e.exports=i;},d784:function(e,t,n){n("ac1f");var r=n("6eeb"),a=n("9263"),o=n("d039"),i=n("b622"),s=n("9112"),c=i("species"),u=RegExp.prototype;e.exports=function(e,t,n,l){var d=i(e),f=!o((function(){var t={};return t[d]=function(){return 7},7!=""[e](t)})),p=f&&!o((function(){var t=!1,n=/a/;return "split"===e&&(n={},n.constructor={},n.constructor[c]=function(){return n},n.flags="",n[d]=/./[d]),n.exec=function(){return t=!0,null},n[d](""),!t}));if(!f||!p||n){var h=/./[d],v=t(d,""[e],(function(e,t,n,r,o){var i=t.exec;return i===a||i===u.exec?f&&!o?{done:!0,value:h.call(t,n,r)}:{done:!0,value:e.call(n,t,r)}:{done:!1}}));r(String.prototype,e,v[0]),r(u,d,v[1]);}l&&s(u[d],"sham",!0);};},d7ee:function(e,t,n){var r=n("c3fc"),a=n("b047"),o=n("99d3"),i=o&&o.isSet,s=i?a(i):r;e.exports=s;},da03:function(e,t,n){var r=n("2b3e"),a=r["__core-js_shared__"];e.exports=a;},da84:function(e,t,n){(function(t){var n=function(e){return e&&e.Math==Math&&e};e.exports=n("object"==typeof globalThis&&globalThis)||n("object"==typeof window&&window)||n("object"==typeof self&&self)||n("object"==typeof t&&t)||function(){return this}()||Function("return this")();}).call(this,n("c8ba"));},dc0f:function(e,t){function n(e){return this.__data__.has(e)}e.exports=n;},dc57:function(e,t){var n=Function.prototype,r=n.toString;function a(e){if(null!=e){try{return r.call(e)}catch(t){}try{return e+""}catch(t){}}return ""}e.exports=a;},dc8c:function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,".vc-container{--white:#fff;--black:#000;--gray-100:#f7fafc;--gray-200:#edf2f7;--gray-300:#e2e8f0;--gray-400:#cbd5e0;--gray-500:#a0aec0;--gray-600:#718096;--gray-700:#4a5568;--gray-800:#2d3748;--gray-900:#1a202c;--red-100:#fff5f5;--red-200:#fed7d7;--red-300:#feb2b2;--red-400:#fc8181;--red-500:#f56565;--red-600:#e53e3e;--red-700:#c53030;--red-800:#9b2c2c;--red-900:#742a2a;--orange-100:#fffaf0;--orange-200:#feebc8;--orange-300:#fbd38d;--orange-400:#f6ad55;--orange-500:#ed8936;--orange-600:#dd6b20;--orange-700:#c05621;--orange-800:#9c4221;--orange-900:#7b341e;--yellow-100:ivory;--yellow-200:#fefcbf;--yellow-300:#faf089;--yellow-400:#f6e05e;--yellow-500:#ecc94b;--yellow-600:#d69e2e;--yellow-700:#b7791f;--yellow-800:#975a16;--yellow-900:#744210;--green-100:#f0fff4;--green-200:#c6f6d5;--green-300:#9ae6b4;--green-400:#68d391;--green-500:#48bb78;--green-600:#38a169;--green-700:#2f855a;--green-800:#276749;--green-900:#22543d;--teal-100:#e6fffa;--teal-200:#b2f5ea;--teal-300:#81e6d9;--teal-400:#4fd1c5;--teal-500:#38b2ac;--teal-600:#319795;--teal-700:#2c7a7b;--teal-800:#285e61;--teal-900:#234e52;--blue-100:#ebf8ff;--blue-200:#bee3f8;--blue-300:#90cdf4;--blue-400:#63b3ed;--blue-500:#4299e1;--blue-600:#3182ce;--blue-700:#2b6cb0;--blue-800:#2c5282;--blue-900:#2a4365;--indigo-100:#ebf4ff;--indigo-200:#c3dafe;--indigo-300:#a3bffa;--indigo-400:#7f9cf5;--indigo-500:#667eea;--indigo-600:#5a67d8;--indigo-700:#4c51bf;--indigo-800:#434190;--indigo-900:#3c366b;--purple-100:#faf5ff;--purple-200:#e9d8fd;--purple-300:#d6bcfa;--purple-400:#b794f4;--purple-500:#9f7aea;--purple-600:#805ad5;--purple-700:#6b46c1;--purple-800:#553c9a;--purple-900:#44337a;--pink-100:#fff5f7;--pink-200:#fed7e2;--pink-300:#fbb6ce;--pink-400:#f687b3;--pink-500:#ed64a6;--pink-600:#d53f8c;--pink-700:#b83280;--pink-800:#97266d;--pink-900:#702459}.vc-container.vc-red{--accent-100:var(--red-100);--accent-200:var(--red-200);--accent-300:var(--red-300);--accent-400:var(--red-400);--accent-500:var(--red-500);--accent-600:var(--red-600);--accent-700:var(--red-700);--accent-800:var(--red-800);--accent-900:var(--red-900)}.vc-container.vc-orange{--accent-100:var(--orange-100);--accent-200:var(--orange-200);--accent-300:var(--orange-300);--accent-400:var(--orange-400);--accent-500:var(--orange-500);--accent-600:var(--orange-600);--accent-700:var(--orange-700);--accent-800:var(--orange-800);--accent-900:var(--orange-900)}.vc-container.vc-yellow{--accent-100:var(--yellow-100);--accent-200:var(--yellow-200);--accent-300:var(--yellow-300);--accent-400:var(--yellow-400);--accent-500:var(--yellow-500);--accent-600:var(--yellow-600);--accent-700:var(--yellow-700);--accent-800:var(--yellow-800);--accent-900:var(--yellow-900)}.vc-container.vc-green{--accent-100:var(--green-100);--accent-200:var(--green-200);--accent-300:var(--green-300);--accent-400:var(--green-400);--accent-500:var(--green-500);--accent-600:var(--green-600);--accent-700:var(--green-700);--accent-800:var(--green-800);--accent-900:var(--green-900)}.vc-container.vc-teal{--accent-100:var(--teal-100);--accent-200:var(--teal-200);--accent-300:var(--teal-300);--accent-400:var(--teal-400);--accent-500:var(--teal-500);--accent-600:var(--teal-600);--accent-700:var(--teal-700);--accent-800:var(--teal-800);--accent-900:var(--teal-900)}.vc-container.vc-blue{--accent-100:var(--blue-100);--accent-200:var(--blue-200);--accent-300:var(--blue-300);--accent-400:var(--blue-400);--accent-500:var(--blue-500);--accent-600:var(--blue-600);--accent-700:var(--blue-700);--accent-800:var(--blue-800);--accent-900:var(--blue-900)}.vc-container.vc-indigo{--accent-100:var(--indigo-100);--accent-200:var(--indigo-200);--accent-300:var(--indigo-300);--accent-400:var(--indigo-400);--accent-500:var(--indigo-500);--accent-600:var(--indigo-600);--accent-700:var(--indigo-700);--accent-800:var(--indigo-800);--accent-900:var(--indigo-900)}.vc-container.vc-purple{--accent-100:var(--purple-100);--accent-200:var(--purple-200);--accent-300:var(--purple-300);--accent-400:var(--purple-400);--accent-500:var(--purple-500);--accent-600:var(--purple-600);--accent-700:var(--purple-700);--accent-800:var(--purple-800);--accent-900:var(--purple-900)}.vc-container.vc-pink{--accent-100:var(--pink-100);--accent-200:var(--pink-200);--accent-300:var(--pink-300);--accent-400:var(--pink-400);--accent-500:var(--pink-500);--accent-600:var(--pink-600);--accent-700:var(--pink-700);--accent-800:var(--pink-800);--accent-900:var(--pink-900)}.vc-container{--font-normal:400;--font-medium:500;--font-semibold:600;--font-bold:700;--text-xs:12px;--text-sm:14px;--text-base:16px;--text-lg:18px;--leading-snug:1.375;--rounded:0.25rem;--rounded-lg:0.5rem;--rounded-full:9999px;--shadow:0 1px 3px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.06);--shadow-lg:0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05);--shadow-inner:inset 0 2px 4px 0 rgba(0,0,0,0.06);--slide-translate:22px;--slide-duration:0.15s;--slide-timing:ease;--day-content-transition-time:0.13s ease-in;--weeknumber-offset:-34px;position:relative;display:inline-flex;width:max-content;height:max-content;font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif;color:var(--gray-900);background-color:var(--white);border:1px solid;border-color:var(--gray-400);border-radius:var(--rounded-lg);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:transparent}.vc-container,.vc-container *{box-sizing:border-box}.vc-container:focus,.vc-container :focus{outline:none}.vc-container [role=button],.vc-container button{cursor:pointer}.vc-container.vc-is-expanded{min-width:100%}.vc-container .vc-container{border:none}.vc-container.vc-is-dark{color:var(--gray-100);background-color:var(--gray-900);border-color:var(--gray-700)}",""]),e.exports=t;},dcbe:function(e,t,n){var r=n("30c9"),a=n("1310");function o(e){return a(e)&&r(e)}e.exports=o;},dd61:function(e,t,n){var r=n("7948"),a=n("badf"),o=n("97d3"),i=n("6747");function s(e,t){var n=i(e)?r:o;return n(e,a(t,3))}e.exports=s;},ddb0:function(e,t,n){var r=n("da84"),a=n("fdbc"),o=n("e260"),i=n("9112"),s=n("b622"),c=s("iterator"),u=s("toStringTag"),l=o.values;for(var d in a){var f=r[d],p=f&&f.prototype;if(p){if(p[c]!==l)try{i(p,c,l);}catch(v){p[c]=l;}if(p[u]||i(p,u,d),a[d])for(var h in o)if(p[h]!==o[h])try{i(p,h,o[h]);}catch(v){p[h]=o[h];}}}},de5e:function(e,t,n){var r=n("72f5"),a=n.n(r);a.a;},df75:function(e,t,n){var r=n("ca84"),a=n("7839");e.exports=Object.keys||function(e){return r(e,a)};},df9e:function(e,t,n){var r=n("9e83");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("29f48e5f",r,!0,{sourceMap:!1,shadowMode:!1});},e031:function(e,t,n){var r=n("f909"),a=n("1a8c");function o(e,t,n,i,s,c){return a(e)&&a(t)&&(c.set(t,e),r(e,t,void 0,o,c),c["delete"](t)),e}e.exports=o;},e052:function(e,t,n){var r=n("0fb2");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("54fe3190",r,!0,{sourceMap:!1,shadowMode:!1});},e0e7:function(e,t,n){var r=n("60ed");function a(e){return r(e)?void 0:e}e.exports=a;},e163:function(e,t,n){var r=n("5135"),a=n("7b0b"),o=n("f772"),i=n("e177"),s=o("IE_PROTO"),c=Object.prototype;e.exports=i?Object.getPrototypeOf:function(e){return e=a(e),r(e,s)?e[s]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?c:null};},e177:function(e,t,n){var r=n("d039");e.exports=!r((function(){function e(){}return e.prototype.constructor=null,Object.getPrototypeOf(new e)!==e.prototype}));},e24b:function(e,t,n){var r=n("49f4"),a=n("1efc"),o=n("bbc0"),i=n("7a48"),s=n("2524");function c(e){var t=-1,n=null==e?0:e.length;this.clear();while(++t<n){var r=e[t];this.set(r[0],r[1]);}}c.prototype.clear=r,c.prototype["delete"]=a,c.prototype.get=o,c.prototype.has=i,c.prototype.set=s,e.exports=c;},e260:function(e,t,n){var r=n("fc6a"),a=n("44d2"),o=n("3f8c"),i=n("69f3"),s=n("7dd0"),c="Array Iterator",u=i.set,l=i.getterFor(c);e.exports=s(Array,"Array",(function(e,t){u(this,{type:c,target:r(e),index:0,kind:t});}),(function(){var e=l(this),t=e.target,n=e.kind,r=e.index++;return !t||r>=t.length?(e.target=void 0,{value:void 0,done:!0}):"keys"==n?{value:r,done:!1}:"values"==n?{value:t[r],done:!1}:{value:[r,t[r]],done:!1}}),"values"),o.Arguments=o.Array,a("keys"),a("values"),a("entries");},e2a0:function(e,t,n){var r=n("3729"),a=n("6747"),o=n("1310"),i="[object String]";function s(e){return "string"==typeof e||!a(e)&&o(e)&&r(e)==i}e.exports=s;},e2c0:function(e,t,n){var r=n("e2e4"),a=n("d370"),o=n("6747"),i=n("c098"),s=n("b218"),c=n("f4d6");function u(e,t,n){t=r(t,e);var u=-1,l=t.length,d=!1;while(++u<l){var f=c(t[u]);if(!(d=null!=e&&n(e,f)))break;e=e[f];}return d||++u!=l?d:(l=null==e?0:e.length,!!l&&s(l)&&i(f,l)&&(o(e)||a(e)))}e.exports=u;},e2e4:function(e,t,n){var r=n("6747"),a=n("f608"),o=n("18d8"),i=n("76dd");function s(e,t){return r(e)?e:a(e,t)?[e]:o(i(e))}e.exports=s;},e380:function(e,t,n){var r=n("7b83"),a="Expected a function";function o(e,t){if("function"!=typeof e||null!=t&&"function"!=typeof t)throw new TypeError(a);var n=function(){var r=arguments,a=t?t.apply(this,r):r[0],o=n.cache;if(o.has(a))return o.get(a);var i=e.apply(this,r);return n.cache=o.set(a,i)||o,i};return n.cache=new(o.Cache||r),n}o.Cache=r,e.exports=o;},e3f8:function(e,t,n){var r=n("656b");function a(e){return function(t){return r(t,e)}}e.exports=a;},e538:function(e,t,n){(function(e){var r=n("2b3e"),a=t&&!t.nodeType&&t,o=a&&"object"==typeof e&&e&&!e.nodeType&&e,i=o&&o.exports===a,s=i?r.Buffer:void 0,c=s?s.allocUnsafe:void 0;function u(e,t){if(t)return e.slice();var n=e.length,r=c?c(n):new e.constructor(n);return e.copy(r),r}e.exports=u;}).call(this,n("62e4")(e));},e893:function(e,t,n){var r=n("5135"),a=n("56ef"),o=n("06cf"),i=n("9bf2");e.exports=function(e,t){for(var n=a(t),s=i.f,c=o.f,u=0;u<n.length;u++){var l=n[u];r(e,l)||s(e,l,c(t,l));}};},e969:function(e,t,n){var r=n("0da5");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var a=n("499e").default;a("61c2bd5e",r,!0,{sourceMap:!1,shadowMode:!1});},eac5:function(e,t){var n=Object.prototype;function r(e){var t=e&&e.constructor,r="function"==typeof t&&t.prototype||n;return e===r}e.exports=r;},ec47:function(e,t,n){var r=n("a3fd"),a=n("42a2"),o=n("edfa"),i=n("cebd"),s="[object Map]",c="[object Set]";function u(e){return function(t){var n=a(t);return n==s?o(t):n==c?i(t):r(t,e(t))}}e.exports=u;},ec69:function(e,t,n){var r=n("6fcd"),a=n("03dd"),o=n("30c9");function i(e){return o(e)?r(e):a(e)}e.exports=i;},ec8c:function(e,t){function n(e){var t=[];if(null!=e)for(var n in Object(e))t.push(n);return t}e.exports=n;},ed08:function(e,t,n){n.r(t),n.d(t,"Locale",(function(){return r["b"]})),n.d(t,"DateInfo",(function(){return a["a"]})),n.d(t,"Attribute",(function(){return o["a"]})),n.d(t,"AttributeStore",(function(){return i["a"]})),n.d(t,"setupCalendar",(function(){return u})),n.d(t,"pad",(function(){return l["m"]})),n.d(t,"evalFn",(function(){return l["f"]})),n.d(t,"mergeEvents",(function(){return l["h"]})),n.d(t,"pageIsValid",(function(){return l["r"]})),n.d(t,"pageIsBeforePage",(function(){return l["o"]})),n.d(t,"pageIsAfterPage",(function(){return l["n"]})),n.d(t,"pageIsBetweenPages",(function(){return l["p"]})),n.d(t,"pageIsEqualToPage",(function(){return l["q"]})),n.d(t,"addPages",(function(){return l["a"]})),n.d(t,"pageRangeToArray",(function(){return l["s"]})),n.d(t,"datesAreEqual",(function(){return l["d"]})),n.d(t,"arrayHasItems",(function(){return l["b"]})),n.d(t,"mixinOptionalProps",(function(){return l["i"]})),n.d(t,"on",(function(){return l["k"]})),n.d(t,"off",(function(){return l["j"]})),n.d(t,"elementContains",(function(){return l["e"]})),n.d(t,"onSpaceOrEnter",(function(){return l["l"]})),n.d(t,"createGuid",(function(){return l["c"]})),n.d(t,"hash",(function(){return l["g"]})),n.d(t,"addHorizontalSwipeHandler",(function(){return d["a"]}));var r=n("29ae"),a=n("cfe5"),o=n("22f3"),i=n("9349"),s=n("51ec"),c=n("1315"),u=function(e){const t=Object(s["b"])(e);return Object(c["a"])(t.screens,!0),t},l=n("2fa3"),d=n("0733");},edfa:function(e,t){function n(e){var t=-1,n=Array(e.size);return e.forEach((function(e,r){n[++t]=[r,e];})),n}e.exports=n;},ef5d:function(e,t){function n(e){return function(t){return null==t?void 0:t[e]}}e.exports=n;},efb6:function(e,t,n){var r=n("5e2e");function a(){this.__data__=new r,this.size=0;}e.exports=a;},f15d:function(e,t,n){n("ddb0");var r=n("9404");const a={ar:{dow:7,L:"D/‏M/‏YYYY"},bg:{dow:2,L:"D.MM.YYYY"},ca:{dow:2,L:"DD/MM/YYYY"},"zh-CN":{dow:2,L:"YYYY/MM/DD"},"zh-TW":{dow:1,L:"YYYY/MM/DD"},hr:{dow:2,L:"DD.MM.YYYY"},cs:{dow:2,L:"DD.MM.YYYY"},da:{dow:2,L:"DD.MM.YYYY"},nl:{dow:2,L:"DD-MM-YYYY"},"en-US":{dow:1,L:"MM/DD/YYYY"},"en-AU":{dow:2,L:"DD/MM/YYYY"},"en-CA":{dow:1,L:"YYYY-MM-DD"},"en-GB":{dow:2,L:"DD/MM/YYYY"},"en-IE":{dow:2,L:"DD-MM-YYYY"},"en-NZ":{dow:2,L:"DD/MM/YYYY"},"en-ZA":{dow:1,L:"YYYY/MM/DD"},eo:{dow:2,L:"YYYY-MM-DD"},et:{dow:2,L:"DD.MM.YYYY"},fi:{dow:2,L:"DD.MM.YYYY"},fr:{dow:2,L:"DD/MM/YYYY"},"fr-CA":{dow:1,L:"YYYY-MM-DD"},"fr-CH":{dow:2,L:"DD.MM.YYYY"},de:{dow:2,L:"DD.MM.YYYY"},he:{dow:1,L:"DD.MM.YYYY"},id:{dow:2,L:"DD/MM/YYYY"},it:{dow:2,L:"DD/MM/YYYY"},ja:{dow:1,L:"YYYY年M月D日"},ko:{dow:1,L:"YYYY.MM.DD"},lv:{dow:2,L:"DD.MM.YYYY"},lt:{dow:2,L:"DD.MM.YYYY"},mk:{dow:2,L:"D.MM.YYYY"},nb:{dow:2,L:"D. MMMM YYYY"},nn:{dow:2,L:"D. MMMM YYYY"},pl:{dow:2,L:"DD.MM.YYYY"},pt:{dow:2,L:"DD/MM/YYYY"},ro:{dow:2,L:"DD.MM.YYYY"},ru:{dow:2,L:"DD.MM.YYYY"},sk:{dow:2,L:"DD.MM.YYYY"},"es-ES":{dow:2,L:"DD/MM/YYYY"},"es-MX":{dow:2,L:"DD/MM/YYYY"},sv:{dow:2,L:"YYYY-MM-DD"},th:{dow:1,L:"DD/MM/YYYY"},tr:{dow:2,L:"DD.MM.YYYY"},uk:{dow:2,L:"DD.MM.YYYY"},vi:{dow:2,L:"DD/MM/YYYY"}};a.en=a["en-US"],a.es=a["es-ES"],a.no=a.nb,a.zh=a["zh-CN"],Object(r["w"])(a).forEach((function([e,{dow:t,L:n}]){a[e]={id:e,firstDayOfWeek:t,masks:{L:n}};})),t["a"]=a;},f3c1:function(e,t){var n=800,r=16,a=Date.now;function o(e){var t=0,o=0;return function(){var i=a(),s=r-(i-o);if(o=i,s>0){if(++t>=n)return arguments[0]}else t=0;return e.apply(void 0,arguments)}}e.exports=o;},f4d6:function(e,t,n){var r=n("ffd6"),a=1/0;function o(e){if("string"==typeof e||r(e))return e;var t=e+"";return "0"==t&&1/e==-a?"-0":t}e.exports=o;},f542:function(e,t,n){var r=n("ec47"),a=n("ec69"),o=r(a);e.exports=o;},f608:function(e,t,n){var r=n("6747"),a=n("ffd6"),o=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,i=/^\w*$/;function s(e,t){if(r(e))return !1;var n=typeof e;return !("number"!=n&&"symbol"!=n&&"boolean"!=n&&null!=e&&!a(e))||(i.test(e)||!o.test(e)||null!=t&&e in Object(t))}e.exports=s;},f678:function(e,t,n){var r=n("8384"),a=n("b4b0");function o(e,t,n){return void 0===n&&(n=t,t=void 0),void 0!==n&&(n=a(n),n=n===n?n:0),void 0!==t&&(t=a(t),t=t===t?t:0),r(a(e),t,n)}e.exports=o;},f772:function(e,t,n){var r=n("5692"),a=n("90e3"),o=r("keys");e.exports=function(e){return o[e]||(o[e]=a(e))};},f7f1:function(e,t,n){n.d(t,"a",(function(){return i}));var r=n("fe1f"),a=n("fd3a"),o=n("8c86");function i(e,t){Object(o["a"])(2,arguments);var n=Object(a["a"])(e),i=Object(r["a"])(t);return isNaN(i)?new Date(NaN):i?(n.setDate(n.getDate()+i),n):n}},f8af:function(e,t,n){var r=n("2474");function a(e){var t=new e.constructor(e.byteLength);return new r(t).set(new r(e)),t}e.exports=a;},f909:function(e,t,n){var r=n("7e64"),a=n("b760"),o=n("72af"),i=n("4f50"),s=n("1a8c"),c=n("9934"),u=n("8adb");function l(e,t,n,d,f){e!==t&&o(t,(function(o,c){if(f||(f=new r),s(o))i(e,t,c,n,l,d,f);else{var p=d?d(u(e,c),o,c+"",e,t,f):void 0;void 0===p&&(p=o),a(e,c,p);}}),c);}e.exports=l;},f9ce:function(e,t,n){var r=n("ef5d"),a=n("e3f8"),o=n("f608"),i=n("f4d6");function s(e){return o(e)?r(i(e)):a(e)}e.exports=s;},fa21:function(e,t,n){var r=n("7530"),a=n("2dcb"),o=n("eac5");function i(e){return "function"!=typeof e.constructor||o(e)?{}:r(a(e))}e.exports=i;},fb15:function(e,t,n){if(n.r(t),n.d(t,"Calendar",(function(){return o["c"]})),n.d(t,"CalendarNav",(function(){return o["d"]})),n.d(t,"DatePicker",(function(){return o["f"]})),n.d(t,"Popover",(function(){return o["h"]})),n.d(t,"Locale",(function(){return o["g"]})),n.d(t,"DateInfo",(function(){return o["e"]})),n.d(t,"Attribute",(function(){return o["a"]})),n.d(t,"AttributeStore",(function(){return o["b"]})),n.d(t,"setupCalendar",(function(){return o["D"]})),n.d(t,"pad",(function(){return o["w"]})),n.d(t,"evalFn",(function(){return o["p"]})),n.d(t,"mergeEvents",(function(){return o["r"]})),n.d(t,"pageIsValid",(function(){return o["B"]})),n.d(t,"pageIsBeforePage",(function(){return o["y"]})),n.d(t,"pageIsAfterPage",(function(){return o["x"]})),n.d(t,"pageIsBetweenPages",(function(){return o["z"]})),n.d(t,"pageIsEqualToPage",(function(){return o["A"]})),n.d(t,"addPages",(function(){return o["j"]})),n.d(t,"pageRangeToArray",(function(){return o["C"]})),n.d(t,"datesAreEqual",(function(){return o["m"]})),n.d(t,"arrayHasItems",(function(){return o["k"]})),n.d(t,"mixinOptionalProps",(function(){return o["s"]})),n.d(t,"on",(function(){return o["u"]})),n.d(t,"off",(function(){return o["t"]})),n.d(t,"elementContains",(function(){return o["o"]})),n.d(t,"onSpaceOrEnter",(function(){return o["v"]})),n.d(t,"createGuid",(function(){return o["l"]})),n.d(t,"hash",(function(){return o["q"]})),n.d(t,"addHorizontalSwipeHandler",(function(){return o["i"]})),"undefined"!==typeof window){var r=window.document.currentScript,a=r&&r.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);a&&(n.p=a[1]);}var o=n("34e9");t["default"]=o["n"];},fba5:function(e,t,n){var r=n("cb5a");function a(e){return r(this.__data__,e)>-1}e.exports=a;},fc6a:function(e,t,n){var r=n("44ad"),a=n("1d80");e.exports=function(e){return r(a(e))};},fccf:function(e,t,n){var r=n("53b1"),a=n.n(r);a.a;},fce3:function(e,t,n){var r=n("d039");e.exports=r((function(){var e=RegExp(".","string".charAt(0));return !(e.dotAll&&e.exec("\n")&&"s"===e.flags)}));},fcff:function(e,t,n){var r=n("24fb");t=r(!1),t.push([e.i,".vc-svg-icon[data-v-63f7b5ec]{display:inline-block;stroke:currentColor;stroke-width:0}.vc-svg-icon path[data-v-63f7b5ec]{fill:currentColor}",""]),e.exports=t;},fd3a:function(e,t,n){n.d(t,"a",(function(){return a}));var r=n("8c86");function a(e){Object(r["a"])(1,arguments);var t=Object.prototype.toString.call(e);return e instanceof Date||"object"===typeof e&&"[object Date]"===t?new Date(e.getTime()):"number"===typeof e||"[object Number]"===t?new Date(e):("string"!==typeof e&&"[object String]"!==t||"undefined"===typeof console||(console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"),console.warn((new Error).stack)),new Date(NaN))}},fdbc:function(e,t){e.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0};},fdbf:function(e,t,n){var r=n("4930");e.exports=r&&!Symbol.sham&&"symbol"==typeof Symbol.iterator;},fe1f:function(e,t,n){function r(e){if(null===e||!0===e||!1===e)return NaN;var t=Number(e);return isNaN(t)?t:t<0?Math.ceil(t):Math.floor(t)}n.d(t,"a",(function(){return r}));},ffd6:function(e,t,n){var r=n("3729"),a=n("1310"),o="[object Symbol]";function i(e){return "symbol"==typeof e||a(e)&&r(e)==o}e.exports=i;}})}));

});

var VCalendar = unwrapExports(vCalendar_umd_min);

var vClickOutside_umd = createCommonjsModule(function (module, exports) {
!function(e,n){module.exports=n();}(commonjsGlobal,function(){var e="__v-click-outside",n="undefined"!=typeof window,t="undefined"!=typeof navigator,i=n&&("ontouchstart"in window||t&&navigator.msMaxTouchPoints>0)?["touchstart"]:["click"];function o(n,t){var o=function(e){var n="function"==typeof e;if(!n&&"object"!=typeof e)throw new Error("v-click-outside: Binding value must be a function or an object");return {handler:n?e:e.handler,middleware:e.middleware||function(e){return e},events:e.events||i,isActive:!(!1===e.isActive)}}(t.value),r=o.handler,d=o.middleware;o.isActive&&(n[e]=o.events.map(function(e){return {event:e,handler:function(e){return function(e){var n=e.el,t=e.event,i=e.handler,o=e.middleware,r=t.path||t.composedPath&&t.composedPath(),d=r?r.indexOf(n)<0:!n.contains(t.target);t.target!==n&&d&&o(t)&&i(t);}({event:e,el:n,handler:r,middleware:d})}}}),n[e].forEach(function(t){var i=t.event,o=t.handler;return setTimeout(function(){n[e]&&document.documentElement.addEventListener(i,o,!1);},0)}));}function r(n){(n[e]||[]).forEach(function(e){return document.documentElement.removeEventListener(e.event,e.handler,!1)}),delete n[e];}var d=n?{bind:o,update:function(e,n){var t=n.value,i=n.oldValue;JSON.stringify(t)!==JSON.stringify(i)&&(r(e),o(e,{value:t}));},unbind:r}:{};return {install:function(e){e.directive("click-outside",d);},directive:d}});

});

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = _wks('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
var _addToUnscopables = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

// https://github.com/tc39/Array.prototype.includes

var $includes = _arrayIncludes(true);

_export(_export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_addToUnscopables('includes');

// 7.2.8 IsRegExp(argument)


var MATCH = _wks('match');
var _isRegexp = function (it) {
  var isRegExp;
  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
};

// helper for String#{startsWith, endsWith, includes}



var _stringContext = function (that, searchString, NAME) {
  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(_defined(that));
};

var MATCH$1 = _wks('match');
var _failsIsRegexp = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH$1] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

var INCLUDES = 'includes';

_export(_export.P + _export.F * _failsIsRegexp(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~_stringContext(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * A standalone global alert that supports branded, danger, success, warning, and info types.
 * Allows for custom icons, description, and title.
 * Can also optionally center, make closable and show icons.
 *
 * @vuedoc
 * @exports AppAlert
 * @category Components
 */
var script = {
  name: 'AppAlert',
  props: {
    /**
     * Used to horizontally align the text in the center.
     */
    center: {
      type: Boolean,
      default: false
    },
    /**
     * Use to display the icon to close the alert. Not compatible with a true "isRounded" prop.
     */
    closable: {
      type: Boolean,
      default: false
    },
    /**
     * Use to display a custom icon instead of the default.
     */
    customIcon: {
      type: String,
      default: ''
    },
    /**
     * Used to render the data-test for close button.
     */
    dataTestClose: {
      type: String,
      default: 'close alert'
    },
    /**
     * Used to render the alert copy. This is also the default slot.
     */
    description: {
      type: String,
      default: ''
    },
    /**
     * Used to control size of icon.
     */
    iconSize: {
      type: String,
      default: 'xl',
      validator: function validator(value) {
        return [
        // relative sizes
        '2xs', 'xs', 'sm', 'lg', 'xl', '2xl',
        // literal sizes
        '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x'].includes(value);
      }
    },
    /**
     * Used to icon associated with the alert type.
     */
    showIcon: {
      type: Boolean,
      default: false
    },
    /**
     * Convert the alert to a rounded shape.
     */
    isRounded: {
      type: Boolean,
      default: false
    },
    /**
     * Used to render the alert title above the description.
     * This is also the `title` named slot.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Used to style the alert with themes.
     */
    type: {
      type: String,
      default: 'info',
      validator: function validator(value) {
        return ['danger', 'success', 'info', 'warning', 'neutral'].includes(value);
      }
    }
  },
  computed: {
    /**
     * Determine default icon based on alert type.
     *
     * @returns {string}
     */
    defaultIcon: function defaultIcon() {
      switch (this.type) {
        case 'success':
          return {
            icon: 'fa-solid fa-check-circle',
            closeType: 'affirm'
          };
        case 'danger':
          return {
            icon: 'fa-solid fa-circle-exclamation',
            closeType: 'decline'
          };
        case 'warning':
          return {
            icon: 'fa-solid fa-triangle-exclamation',
            closeType: null
          };
        default:
          return {
            icon: 'fa-regular fa-circle-info',
            closeType: null
          };
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (this.$refs.closeButton) {
      this.$nextTick(function () {
        _this.$refs.closeButton.$el.focus();
      });
    }
  },
  methods: {
    /**
     * Close alert.
     */
    close: function close() {
      this.$emit('close');
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: [
        "app-alert is-" + _vm.type,
        {
          "is-center": _vm.center,
          "is-closable": _vm.closable && !_vm.isRounded,
          "is-rounded": _vm.isRounded,
        },
      ],
      attrs: { "aria-live": "polite" },
      on: { close: _vm.close },
    },
    [
      _vm.showIcon || _vm.$slots.icon || _vm.customIcon
        ? _c(
            "div",
            { staticClass: "app-alert-icon" },
            [
              _vm._t("icon", function () {
                return [
                  _c("app-icon", {
                    attrs: {
                      icon: _vm.customIcon || _vm.defaultIcon.icon,
                      size: _vm.iconSize,
                    },
                  }),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "app-alert-content" }, [
        _vm.$slots.title || _vm.title
          ? _c(
              "p",
              { staticClass: "title" },
              [
                _vm._t("title", function () {
                  return [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$slots.default || _vm.description
          ? _c(
              "p",
              [
                _vm._t("default", function () {
                  return [
                    _vm._v("\n        " + _vm._s(_vm.description) + "\n      "),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.closable && !_vm.isRounded
        ? _c(
            "AppButton",
            {
              ref: "closeButton",
              staticClass: "close-alert",
              attrs: {
                "data-test": _vm.dataTestClose,
                type: _vm.defaultIcon.closeType,
                icon: "fa-solid fa-xmark",
                size: "icon",
                text: "close",
              },
              on: { click: _vm.close },
            },
            [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.dataTestClose)),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-27e4a65c_0", { source: ".app-alert[data-v-27e4a65c] {\n  position: relative;\n  border: 1px solid var(--tf-info);\n  background: var(--tf-info-light);\n  color: var(--tf-info);\n  padding: 10px;\n  margin: 0 auto;\n  max-width: 100%;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  text-align: left;\n}\n.app-alert-content[data-v-27e4a65c] {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.app-alert-icon[data-v-27e4a65c] {\n  padding-right: 10px;\n}\n.app-alert.is-center[data-v-27e4a65c] {\n  text-align: center;\n}\n.app-alert.is-closable[data-v-27e4a65c] {\n  padding-right: 30px;\n}\n.app-alert.is-rounded[data-v-27e4a65c] {\n  border: none;\n  border-radius: 100px;\n}\n.app-alert.is-warning[data-v-27e4a65c] {\n  border-color: var(--tf-warning-border-color);\n  color: var(--tf-warning-font-color);\n  background: var(--tf-warning-light);\n}\n.app-alert.is-success[data-v-27e4a65c] {\n  border-color: var(--tf-success-border-color);\n  color: var(--tf-success-font-color);\n  background: var(--tf-success-light);\n}\n.app-alert.is-danger[data-v-27e4a65c] {\n  border-color: var(--tf-danger-border-color);\n  color: var(--tf-danger-font-color);\n  background: var(--tf-danger-light);\n}\n.app-alert.is-neutral[data-v-27e4a65c] {\n  border-color: var(--tf-gray-dark);\n  color: var(--tf-gray-dark);\n  background: var(--tf-disabled-light);\n}\n.close-alert[data-v-27e4a65c] {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.title[data-v-27e4a65c] {\n  font-weight: 600;\n}\np[data-v-27e4a65c] {\n  margin: 3px 0;\n}\n\n/*# sourceMappingURL=AppAlert.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AppAlert.vue","AppAlert.vue"],"names":[],"mappings":"AAuNA;EACA,kBAAA;EACA,gCAAA;EACA,gCAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;ACtNA;ADwNA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;ACtNA;ADyNA;EACA,mBAAA;ACvNA;AD0NA;EACA,kBAAA;ACxNA;AD2NA;EACA,mBAAA;ACzNA;AD4NA;EACA,YAAA;EACA,oBAAA;AC1NA;AD6NA;EACA,4CAAA;EACA,mCAAA;EACA,mCAAA;AC3NA;AD8NA;EACA,4CAAA;EACA,mCAAA;EACA,mCAAA;AC5NA;AD+NA;EACA,2CAAA;EACA,kCAAA;EACA,kCAAA;AC7NA;ADgOA;EACA,iCAAA;EACA,0BAAA;EACA,oCAAA;AC9NA;ADkOA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;AC/NA;ADkOA;EACA,gBAAA;AC/NA;ADkOA;EACA,aAAA;AC/NA;;AAEA,uCAAuC","file":"AppAlert.vue","sourcesContent":["<template>\n  <div\n    aria-live=\"polite\"\n    :class=\"[\n      `app-alert is-${type}`,\n      {\n        'is-center': center,\n        'is-closable': closable && !isRounded,\n        'is-rounded': isRounded,\n      },\n    ]\"\n    @close=\"close\"\n  >\n    <div\n      v-if=\"showIcon || $slots.icon || customIcon\"\n      class=\"app-alert-icon\"\n    >\n      <slot name=\"icon\">\n        <app-icon\n          :icon=\"customIcon || defaultIcon.icon\"\n          :size=\"iconSize\"\n        />\n      </slot>\n    </div>\n    <div class=\"app-alert-content\">\n      <p\n        v-if=\"$slots.title || title\"\n        class=\"title\"\n      >\n        <slot name=\"title\">\n          {{ title }}\n        </slot>\n      </p>\n      <p v-if=\"$slots.default || description\">\n        <slot>\n          {{ description }}\n        </slot>\n      </p>\n    </div>\n    <AppButton\n      v-if=\"closable && !isRounded\"\n      ref=\"closeButton\"\n      :data-test=\"dataTestClose\"\n      :type=\"defaultIcon.closeType\"\n      icon=\"fa-solid fa-xmark\"\n      size=\"icon\"\n      class=\"close-alert\"\n      text=\"close\"\n      @click=\"close\"\n    >\n      <span class=\"sr-only\">{{ dataTestClose }}</span>\n    </AppButton>\n  </div>\n</template>\n\n<script>\n  /**\n   * A standalone global alert that supports branded, danger, success, warning, and info types.\n   * Allows for custom icons, description, and title.\n   * Can also optionally center, make closable and show icons.\n   *\n   * @vuedoc\n   * @exports AppAlert\n   * @category Components\n   */\n  export default {\n    name: 'AppAlert',\n    props: {\n      /**\n       * Used to horizontally align the text in the center.\n       */\n      center: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Use to display the icon to close the alert. Not compatible with a true \"isRounded\" prop.\n       */\n      closable: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Use to display a custom icon instead of the default.\n       */\n      customIcon: {\n        type: String,\n        default: '',\n      },\n      /**\n       * Used to render the data-test for close button.\n       */\n      dataTestClose: {\n        type: String,\n        default: 'close alert',\n      },\n      /**\n       * Used to render the alert copy. This is also the default slot.\n       */\n      description: {\n        type: String,\n        default: '',\n      },\n      /**\n       * Used to control size of icon.\n       */\n      iconSize: {\n        type: String,\n        default: 'xl',\n        validator: (value) => (\n          [\n            // relative sizes\n            '2xs',\n            'xs',\n            'sm',\n            'lg',\n            'xl',\n            '2xl',\n            // literal sizes\n            '1x',\n            '2x',\n            '3x',\n            '4x',\n            '5x',\n            '6x',\n            '7x',\n            '8x',\n            '9x',\n            '10x',\n          ].includes(value)\n        ),\n      },\n      /**\n       * Used to icon associated with the alert type.\n       */\n      showIcon: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Convert the alert to a rounded shape.\n       */\n      isRounded: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Used to render the alert title above the description.\n       * This is also the `title` named slot.\n       */\n      title: {\n        type: String,\n        default: '',\n      },\n      /**\n       * Used to style the alert with themes.\n       */\n      type: {\n        type: String,\n        default: 'info',\n        validator: (value) => (\n          ['danger', 'success', 'info', 'warning', 'neutral'].includes(value)\n        ),\n      },\n    },\n    computed: {\n      /**\n       * Determine default icon based on alert type.\n       *\n       * @returns {string}\n       */\n      defaultIcon() {\n        switch (this.type) {\n        case 'success':\n          return {\n            icon: 'fa-solid fa-check-circle',\n            closeType: 'affirm',\n          };\n        case 'danger':\n          return {\n            icon: 'fa-solid fa-circle-exclamation',\n            closeType: 'decline',\n          };\n        case 'warning':\n          return {\n            icon: 'fa-solid fa-triangle-exclamation',\n            closeType: null,\n          };\n        default:\n          return {\n            icon: 'fa-regular fa-circle-info',\n            closeType: null,\n          };\n        }\n      },\n    },\n    mounted() {\n      if (this.$refs.closeButton) {\n        this.$nextTick(() => {\n          this.$refs.closeButton.$el.focus();\n        });\n      }\n    },\n    methods: {\n      /**\n       * Close alert.\n       */\n      close() {\n        this.$emit('close');\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .app-alert {\n    position: relative;\n    border: 1px solid var(--tf-info);\n    background: var(--tf-info-light);\n    color: var(--tf-info);\n    padding: 10px;\n    margin: 0 auto;\n    max-width: 100%;\n    width: fit-content;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    text-align: left;\n\n    &-content {\n      display: flex;\n      flex-direction: column;\n      flex: 1;\n    }\n\n    &-icon {\n      padding-right: 10px;\n    }\n\n    &.is-center {\n      text-align: center;\n    }\n\n    &.is-closable {\n      padding-right: 30px;\n    }\n\n    &.is-rounded {\n      border: none;\n      border-radius: 100px;\n    }\n\n    &.is-warning {\n      border-color: var(--tf-warning-border-color);\n      color: var(--tf-warning-font-color);\n      background: var(--tf-warning-light);\n    }\n\n    &.is-success {\n      border-color: var(--tf-success-border-color);\n      color: var(--tf-success-font-color);\n      background: var(--tf-success-light);\n    }\n\n    &.is-danger {\n      border-color: var(--tf-danger-border-color);\n      color: var(--tf-danger-font-color);\n      background: var(--tf-danger-light);\n    }\n\n    &.is-neutral {\n      border-color: var(--tf-gray-dark);\n      color: var(--tf-gray-dark);\n      background: var(--tf-disabled-light);\n    }\n  }\n\n  .close-alert {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n\n  .title {\n    font-weight: 600;\n  }\n\n  p {\n    margin: 3px 0;\n  }\n</style>\n\n<style lang=\"scss\">\n// Left unscoped until move to vue3\n// and can use https://vuejs.org/api/sfc-css-features.html#global-selectors\n\n// Links inside alerts should be underlined and inherit certain styles.\n// stylelint-disable-next-line\n.app-alert {\n  .app-button:not(.is-icon) {\n    color: inherit !important; // stylelint-disable-line\n    text-decoration: underline;\n  }\n\n  // Eliminates left and right margins when there are multiple AppButtons so that they can\n  // flow normally inline with text inside of alerts.\n  .app-button + .app-button {\n    margin: 0 !important; // stylelint-disable-line\n  }\n}\n</style>\n",".app-alert {\n  position: relative;\n  border: 1px solid var(--tf-info);\n  background: var(--tf-info-light);\n  color: var(--tf-info);\n  padding: 10px;\n  margin: 0 auto;\n  max-width: 100%;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  text-align: left;\n}\n.app-alert-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.app-alert-icon {\n  padding-right: 10px;\n}\n.app-alert.is-center {\n  text-align: center;\n}\n.app-alert.is-closable {\n  padding-right: 30px;\n}\n.app-alert.is-rounded {\n  border: none;\n  border-radius: 100px;\n}\n.app-alert.is-warning {\n  border-color: var(--tf-warning-border-color);\n  color: var(--tf-warning-font-color);\n  background: var(--tf-warning-light);\n}\n.app-alert.is-success {\n  border-color: var(--tf-success-border-color);\n  color: var(--tf-success-font-color);\n  background: var(--tf-success-light);\n}\n.app-alert.is-danger {\n  border-color: var(--tf-danger-border-color);\n  color: var(--tf-danger-font-color);\n  background: var(--tf-danger-light);\n}\n.app-alert.is-neutral {\n  border-color: var(--tf-gray-dark);\n  color: var(--tf-gray-dark);\n  background: var(--tf-disabled-light);\n}\n\n.close-alert {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.title {\n  font-weight: 600;\n}\n\np {\n  margin: 3px 0;\n}\n\n/*# sourceMappingURL=AppAlert.vue.map */"]}, media: undefined })
,inject("data-v-27e4a65c_1", { source: ".app-alert .app-button:not(.is-icon) {\n  color: inherit !important;\n  text-decoration: underline;\n}\n.app-alert .app-button + .app-button {\n  margin: 0 !important;\n}\n\n/*# sourceMappingURL=AppAlert.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AppAlert.vue","AppAlert.vue"],"names":[],"mappings":"AA2SA;EACA,yBAAA;EACA,0BAAA;AC1SA;AD+SA;EACA,oBAAA;AC7SA;;AAEA,uCAAuC","file":"AppAlert.vue","sourcesContent":["<template>\n  <div\n    aria-live=\"polite\"\n    :class=\"[\n      `app-alert is-${type}`,\n      {\n        'is-center': center,\n        'is-closable': closable && !isRounded,\n        'is-rounded': isRounded,\n      },\n    ]\"\n    @close=\"close\"\n  >\n    <div\n      v-if=\"showIcon || $slots.icon || customIcon\"\n      class=\"app-alert-icon\"\n    >\n      <slot name=\"icon\">\n        <app-icon\n          :icon=\"customIcon || defaultIcon.icon\"\n          :size=\"iconSize\"\n        />\n      </slot>\n    </div>\n    <div class=\"app-alert-content\">\n      <p\n        v-if=\"$slots.title || title\"\n        class=\"title\"\n      >\n        <slot name=\"title\">\n          {{ title }}\n        </slot>\n      </p>\n      <p v-if=\"$slots.default || description\">\n        <slot>\n          {{ description }}\n        </slot>\n      </p>\n    </div>\n    <AppButton\n      v-if=\"closable && !isRounded\"\n      ref=\"closeButton\"\n      :data-test=\"dataTestClose\"\n      :type=\"defaultIcon.closeType\"\n      icon=\"fa-solid fa-xmark\"\n      size=\"icon\"\n      class=\"close-alert\"\n      text=\"close\"\n      @click=\"close\"\n    >\n      <span class=\"sr-only\">{{ dataTestClose }}</span>\n    </AppButton>\n  </div>\n</template>\n\n<script>\n  /**\n   * A standalone global alert that supports branded, danger, success, warning, and info types.\n   * Allows for custom icons, description, and title.\n   * Can also optionally center, make closable and show icons.\n   *\n   * @vuedoc\n   * @exports AppAlert\n   * @category Components\n   */\n  export default {\n    name: 'AppAlert',\n    props: {\n      /**\n       * Used to horizontally align the text in the center.\n       */\n      center: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Use to display the icon to close the alert. Not compatible with a true \"isRounded\" prop.\n       */\n      closable: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Use to display a custom icon instead of the default.\n       */\n      customIcon: {\n        type: String,\n        default: '',\n      },\n      /**\n       * Used to render the data-test for close button.\n       */\n      dataTestClose: {\n        type: String,\n        default: 'close alert',\n      },\n      /**\n       * Used to render the alert copy. This is also the default slot.\n       */\n      description: {\n        type: String,\n        default: '',\n      },\n      /**\n       * Used to control size of icon.\n       */\n      iconSize: {\n        type: String,\n        default: 'xl',\n        validator: (value) => (\n          [\n            // relative sizes\n            '2xs',\n            'xs',\n            'sm',\n            'lg',\n            'xl',\n            '2xl',\n            // literal sizes\n            '1x',\n            '2x',\n            '3x',\n            '4x',\n            '5x',\n            '6x',\n            '7x',\n            '8x',\n            '9x',\n            '10x',\n          ].includes(value)\n        ),\n      },\n      /**\n       * Used to icon associated with the alert type.\n       */\n      showIcon: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Convert the alert to a rounded shape.\n       */\n      isRounded: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Used to render the alert title above the description.\n       * This is also the `title` named slot.\n       */\n      title: {\n        type: String,\n        default: '',\n      },\n      /**\n       * Used to style the alert with themes.\n       */\n      type: {\n        type: String,\n        default: 'info',\n        validator: (value) => (\n          ['danger', 'success', 'info', 'warning', 'neutral'].includes(value)\n        ),\n      },\n    },\n    computed: {\n      /**\n       * Determine default icon based on alert type.\n       *\n       * @returns {string}\n       */\n      defaultIcon() {\n        switch (this.type) {\n        case 'success':\n          return {\n            icon: 'fa-solid fa-check-circle',\n            closeType: 'affirm',\n          };\n        case 'danger':\n          return {\n            icon: 'fa-solid fa-circle-exclamation',\n            closeType: 'decline',\n          };\n        case 'warning':\n          return {\n            icon: 'fa-solid fa-triangle-exclamation',\n            closeType: null,\n          };\n        default:\n          return {\n            icon: 'fa-regular fa-circle-info',\n            closeType: null,\n          };\n        }\n      },\n    },\n    mounted() {\n      if (this.$refs.closeButton) {\n        this.$nextTick(() => {\n          this.$refs.closeButton.$el.focus();\n        });\n      }\n    },\n    methods: {\n      /**\n       * Close alert.\n       */\n      close() {\n        this.$emit('close');\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .app-alert {\n    position: relative;\n    border: 1px solid var(--tf-info);\n    background: var(--tf-info-light);\n    color: var(--tf-info);\n    padding: 10px;\n    margin: 0 auto;\n    max-width: 100%;\n    width: fit-content;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    text-align: left;\n\n    &-content {\n      display: flex;\n      flex-direction: column;\n      flex: 1;\n    }\n\n    &-icon {\n      padding-right: 10px;\n    }\n\n    &.is-center {\n      text-align: center;\n    }\n\n    &.is-closable {\n      padding-right: 30px;\n    }\n\n    &.is-rounded {\n      border: none;\n      border-radius: 100px;\n    }\n\n    &.is-warning {\n      border-color: var(--tf-warning-border-color);\n      color: var(--tf-warning-font-color);\n      background: var(--tf-warning-light);\n    }\n\n    &.is-success {\n      border-color: var(--tf-success-border-color);\n      color: var(--tf-success-font-color);\n      background: var(--tf-success-light);\n    }\n\n    &.is-danger {\n      border-color: var(--tf-danger-border-color);\n      color: var(--tf-danger-font-color);\n      background: var(--tf-danger-light);\n    }\n\n    &.is-neutral {\n      border-color: var(--tf-gray-dark);\n      color: var(--tf-gray-dark);\n      background: var(--tf-disabled-light);\n    }\n  }\n\n  .close-alert {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n\n  .title {\n    font-weight: 600;\n  }\n\n  p {\n    margin: 3px 0;\n  }\n</style>\n\n<style lang=\"scss\">\n// Left unscoped until move to vue3\n// and can use https://vuejs.org/api/sfc-css-features.html#global-selectors\n\n// Links inside alerts should be underlined and inherit certain styles.\n// stylelint-disable-next-line\n.app-alert {\n  .app-button:not(.is-icon) {\n    color: inherit !important; // stylelint-disable-line\n    text-decoration: underline;\n  }\n\n  // Eliminates left and right margins when there are multiple AppButtons so that they can\n  // flow normally inline with text inside of alerts.\n  .app-button + .app-button {\n    margin: 0 !important; // stylelint-disable-line\n  }\n}\n</style>\n",".app-alert .app-button:not(.is-icon) {\n  color: inherit !important;\n  text-decoration: underline;\n}\n.app-alert .app-button + .app-button {\n  margin: 0 !important;\n}\n\n/*# sourceMappingURL=AppAlert.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-27e4a65c";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * A standalone customizable themeable global button.
 *
 * @vuedoc
 * @exports AppAlert
 * @category Components
 */
var script$1 = {
  name: 'AppButton',
  props: {
    /**
     * Prop used to pass the {@href https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-href} attribute used for an anchor tag.
     */
    href: {
      type: String,
      default: null
    },
    /**
     * Prop used to select the name of the icon to be used in the template. See the {@docs https://fontawesome.com/docs/web/use-with/vue/add-icons} for more information.
     */
    icon: {
      type: String,
      default: ''
    },
    /**
     * Prop used to set the width to 100% and center the text.
     */
    isBlock: {
      type: Boolean,
      default: false
    },
    /**
     * Prop used to disable the element in the template.
     */
    isDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Prop used to disable the element in the template and render a spinning icon if an icon is present.
     */
    isLoading: {
      type: Boolean,
      default: false
    },
    /**
     * Prop used to pass the {@type https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-type} attribute used for an anchor tag.
     */
    nativeType: {
      type: String,
      default: 'button'
    },
    /**
     * Prop used to render the "primary" and "secondary" type buttons with ThreeFlow blue instead of branding colors.
     */
    noBranding: {
      type: Boolean,
      default: false
    },
    /**
     * Prop used to update the css to reverse the css flex-direction.
     */
    prepend: {
      type: Boolean,
      default: false
    },
    /**
     * Prop used the render an icon, button size, or text size version of the button.
     */
    size: {
      type: String,
      default: 'medium',
      validator: function validator(v) {
        return ['icon', 'icon-small', 'small', 'medium', 'large', 'text', 'text-small'].includes(v);
      }
    },
    /**
     * Prop used to render the element either as a `<button />` or `<a />` tag.
     */
    tag: {
      type: String,
      default: 'button',
      validator: function validator(v) {
        return ['a', 'button'].includes(v);
      }
    },
    /**
     * Prop used to pass the {@target https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target} attribute used for an anchor tag.
     */
    target: {
      type: String,
      default: null
    },
    /**
     * Prop used to override the default slot content.
     */
    text: {
      type: String,
      default: null
    },
    /**
     * Prop used to render the green, red, or branded (or ThreeFlow blue) style.
     */
    type: {
      type: String,
      default: 'primary',
      validator: function validator(v) {
        return ['affirm',
        // deprecated: use 'success'
        'success', 'decline',
        // deprecated: use 'danger'
        'danger', 'primary', 'secondary'].includes(v);
      }
    }
  },
  computed: {
    /**
     * Evaluate the disabled and isLoading props to determine if the button should be disabled.
     *
     * @returns {boolean}
     */
    disabled: function disabled() {
      return this.isDisabled || this.isLoading;
    },
    /**
     * Evaluate the icon and size props to determine the icon size.
     *
     * @returns {string|null}
     */
    iconSize: function iconSize() {
      if (!this.icon) {
        return null;
      }
      return ['small', 'text-small', 'icon-small'].includes(this.size) ? 'sm' : 'lg';
    },
    /**
     * Evaluate the size prop to determine if the button should render as an icon.
     *
     * @returns {boolean}
     */
    isIcon: function isIcon() {
      return ['icon', 'icon-small'].includes(this.size);
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.tag,
    {
      tag: "component",
      staticClass: "app-button",
      class: [
        "is-" + _vm.size,
        // `is-${type}`, uncomment when we remove the deprecated types
        {
          "has-icon": _vm.icon,
          "prepend-icon": _vm.icon && _vm.prepend,
          "is-block": _vm.isBlock,
          "is-disabled": _vm.disabled,
          "no-branding": _vm.noBranding,
          // remove type checks when we remove the deprecated types
          "is-success": ["affirm", "success"].includes(_vm.type),
          "is-danger": ["decline", "danger"].includes(_vm.type),
          "is-primary": _vm.type === "primary",
          "is-secondary": _vm.type === "secondary",
        },
      ],
      attrs: {
        "aria-label": _vm.$slots.default
          ? _vm.$slots.default[0].text
          : _vm.text,
        disabled: _vm.disabled,
        type: _vm.nativeType,
        href: _vm.href,
        target: _vm.target,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      !_vm.isIcon && (_vm.$slots.default || _vm.text)
        ? _c("span", { staticClass: "button-text" }, [
            _vm._v(_vm._s(_vm.text || _vm.$slots.default[0].text)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.icon || _vm.isIcon
        ? [
            _c("AppIcon", {
              staticClass: "app-button-icon",
              attrs: {
                icon: _vm.isLoading ? "fa-solid fa-spinner fa-spin" : _vm.icon,
                size: _vm.iconSize,
                "data-test": "app button icon",
              },
            }),
            _vm._v(" "),
            _vm.isIcon
              ? _c("span", {
                  staticClass: "sr-only",
                  domProps: { textContent: _vm._s(_vm.text) },
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-c7dcfef4_0", { source: ".app-button[data-v-c7dcfef4] {\n  white-space: nowrap;\n  box-shadow: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 7px 14px;\n  border-radius: 0;\n  border-style: solid;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n}\n.app-button + .app-button[data-v-c7dcfef4] {\n  margin-left: var(--tf-btn-margin-medium);\n}\n.app-button.is-disabled[data-v-c7dcfef4] {\n  cursor: not-allowed;\n}\n.is-block[data-v-c7dcfef4] {\n  width: 100%;\n  justify-content: center;\n}\n.button-text[data-v-c7dcfef4] {\n  font-size: 16px;\n  font-weight: 600;\n}\n.is-small[data-v-c7dcfef4] {\n  padding: 1px 13px;\n}\n.is-small .button-text[data-v-c7dcfef4] {\n  font-size: var(--tf-body-font-size);\n}\n.is-medium[data-v-c7dcfef4],\n.is-small[data-v-c7dcfef4] {\n  border-radius: 3px;\n}\n.is-medium[data-v-c7dcfef4] {\n  padding: 3px 18px;\n}\n.is-large[data-v-c7dcfef4] {\n  padding: 8px 18px;\n  border-radius: 25px;\n}\n.is-large .button-text[data-v-c7dcfef4] {\n  font-size: var(--tf-body-large-font-size);\n}\n.is-icon.is-primary[data-v-c7dcfef4], .is-icon.is-secondary[data-v-c7dcfef4],\n.is-icon-small.is-primary[data-v-c7dcfef4],\n.is-icon-small.is-secondary[data-v-c7dcfef4],\n.is-text.is-primary[data-v-c7dcfef4],\n.is-text.is-secondary[data-v-c7dcfef4],\n.is-text-small.is-primary[data-v-c7dcfef4],\n.is-text-small.is-secondary[data-v-c7dcfef4] {\n  color: var(--primary, var(--tf-primary));\n}\n.is-icon.is-primary.no-branding[data-v-c7dcfef4]:not(.is-disabled), .is-icon.is-secondary.no-branding[data-v-c7dcfef4]:not(.is-disabled),\n.is-icon-small.is-primary.no-branding[data-v-c7dcfef4]:not(.is-disabled),\n.is-icon-small.is-secondary.no-branding[data-v-c7dcfef4]:not(.is-disabled),\n.is-text.is-primary.no-branding[data-v-c7dcfef4]:not(.is-disabled),\n.is-text.is-secondary.no-branding[data-v-c7dcfef4]:not(.is-disabled),\n.is-text-small.is-primary.no-branding[data-v-c7dcfef4]:not(.is-disabled),\n.is-text-small.is-secondary.no-branding[data-v-c7dcfef4]:not(.is-disabled) {\n  color: var(--tf-primary);\n}\n.is-text[data-v-c7dcfef4],\n.is-text-small[data-v-c7dcfef4] {\n  padding: 0;\n  background: transparent !important;\n  border: none !important;\n  vertical-align: inherit;\n}\n.is-text.is-success[data-v-c7dcfef4],\n.is-text-small.is-success[data-v-c7dcfef4] {\n  color: var(--tf-success-font-color);\n}\n.is-text.is-danger[data-v-c7dcfef4],\n.is-text-small.is-danger[data-v-c7dcfef4] {\n  color: var(--tf-danger-font-color);\n}\n.is-text.is-disabled[data-v-c7dcfef4],\n.is-text-small.is-disabled[data-v-c7dcfef4] {\n  color: var(--tf-disabled-font-color);\n}\n.app-alert .is-text[data-v-c7dcfef4],\n.app-alert .is-text-small[data-v-c7dcfef4] {\n  color: inherit !important;\n  text-decoration: underline;\n}\n.is-text .button-text[data-v-c7dcfef4] {\n  font-size: var(--tf-body-font-size);\n}\n.is-text-small .button-text[data-v-c7dcfef4] {\n  font-size: var(--tf-small-font-size);\n}\n.is-primary[data-v-c7dcfef4],\n.is-secondary[data-v-c7dcfef4] {\n  border-color: var(--primary, var(--tf-primary));\n}\n.is-primary.no-branding[data-v-c7dcfef4]:not(.is-disabled),\n.is-secondary.no-branding[data-v-c7dcfef4]:not(.is-disabled) {\n  border-color: var(--tf-primary);\n}\n.is-success[data-v-c7dcfef4],\n.is-danger[data-v-c7dcfef4],\n.is-primary[data-v-c7dcfef4],\n.is-secondary[data-v-c7dcfef4] {\n  color: var(--tf-white);\n}\n.is-primary[data-v-c7dcfef4] {\n  background-color: var(--primary, var(--tf-primary));\n}\n.is-primary.no-branding[data-v-c7dcfef4] {\n  background-color: var(--tf-primary);\n}\n.is-secondary[data-v-c7dcfef4] {\n  background-color: transparent;\n  color: var(--primary, var(--tf-primary));\n}\n.is-secondary.no-branding[data-v-c7dcfef4] {\n  color: var(--tf-primary);\n  border-color: var(--tf-primary);\n}\n.is-secondary.is-disabled[data-v-c7dcfef4] {\n  border-color: var(--tf-disabled);\n  color: var(--tf-disabled);\n}\n.is-success[data-v-c7dcfef4] {\n  background-color: var(--tf-success);\n  border-color: var(--tf-success-border-color);\n}\n.is-danger[data-v-c7dcfef4] {\n  background-color: var(--tf-danger);\n  border-color: var(--tf-danger-border-color);\n}\n.is-success.is-disabled[data-v-c7dcfef4],\n.is-danger.is-disabled[data-v-c7dcfef4],\n.is-primary.is-disabled[data-v-c7dcfef4] {\n  border-color: var(--tf-disabled-light);\n  background-color: var(--tf-disabled-light);\n  color: var(--tf-disabled);\n}\n.app-button-icon[data-v-c7dcfef4] {\n  line-height: inherit;\n}\n.is-icon[data-v-c7dcfef4],\n.is-icon-small[data-v-c7dcfef4] {\n  background: none !important;\n  border: none;\n}\n.is-icon.is-success[data-v-c7dcfef4],\n.is-icon-small.is-success[data-v-c7dcfef4] {\n  color: var(--tf-success-font-color);\n}\n.is-icon.is-danger[data-v-c7dcfef4],\n.is-icon-small.is-danger[data-v-c7dcfef4] {\n  color: var(--tf-danger-font-color);\n}\n.is-icon.is-disabled[data-v-c7dcfef4],\n.is-icon-small.is-disabled[data-v-c7dcfef4] {\n  color: var(--tf-disabled-font-color) !important;\n}\n.is-icon[data-v-c7dcfef4] {\n  padding: 7px;\n}\n.is-icon-small[data-v-c7dcfef4] {\n  padding: 9px;\n}\n.prepend-icon[data-v-c7dcfef4] {\n  flex-direction: row-reverse;\n}\n.has-icon .button-text[data-v-c7dcfef4] {\n  padding-left: 0;\n  padding-right: 6px;\n}\n.has-icon.prepend-icon .button-text[data-v-c7dcfef4] {\n  padding-left: 6px;\n  padding-right: 0;\n}\n\n/*# sourceMappingURL=AppButton.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AppButton.vue","AppButton.vue"],"names":[],"mappings":"AA2MA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EAEA,gBAAA;EACA,mBAAA;EAEA,oBAAA;EACA,mBAAA;EACA,eAAA;AC5MA;AD8MA;EACA,wCAAA;AC5MA;AD+MA;EACA,mBAAA;AC7MA;ADiNA;EACA,WAAA;EACA,uBAAA;AC9MA;ADiNA;EAEA,eAAA;EACA,gBAAA;AC/MA;ADoNA;EACA,iBAAA;ACjNA;ADmNA;EACA,mCAAA;ACjNA;ADqNA;;EAEA,kBAAA;AClNA;ADqNA;EACA,iBAAA;AClNA;ADqNA;EACA,iBAAA;EACA,mBAAA;AClNA;ADoNA;EACA,yCAAA;AClNA;AD0NA;;;;;;;EAEA,wCAAA;AClNA;ADoNA;;;;;;;EACA,wBAAA;AC5MA;ADiNA;;EAEA,UAAA;EACA,kCAAA;EACA,uBAAA;EACA,uBAAA;AC9MA;ADgNA;;EACA,mCAAA;AC7MA;ADgNA;;EACA,kCAAA;AC7MA;ADgNA;;EACA,oCAAA;AC7MA;ADgNA;;EACA,yBAAA;EACA,0BAAA;AC7MA;ADkNA;EACA,mCAAA;AC/MA;ADoNA;EACA,oCAAA;ACjNA;ADsNA;;EAEA,+CAAA;ACnNA;ADqNA;;EACA,+BAAA;AClNA;ADsNA;;;;EAIA,sBAAA;ACnNA;ADsNA;EACA,mDAAA;ACnNA;ADqNA;EACA,mCAAA;ACnNA;ADuNA;EACA,6BAAA;EACA,wCAAA;ACpNA;ADsNA;EACA,wBAAA;EACA,+BAAA;ACpNA;ADuNA;EACA,gCAAA;EACA,yBAAA;ACrNA;ADyNA;EACA,mCAAA;EACA,4CAAA;ACtNA;ADyNA;EACA,kCAAA;EACA,2CAAA;ACtNA;AD4NA;;;EACA,sCAAA;EACA,0CAAA;EACA,yBAAA;ACvNA;AD4NA;EACA,oBAAA;ACzNA;AD4NA;;EAEA,2BAAA;EACA,YAAA;ACzNA;AD2NA;;EACA,mCAAA;ACxNA;AD2NA;;EACA,kCAAA;ACxNA;AD2NA;;EACA,+CAAA;ACxNA;AD4NA;EACA,YAAA;ACzNA;AD4NA;EACA,YAAA;ACzNA;AD4NA;EACA,2BAAA;ACzNA;AD6NA;EAEA,eAAA;EACA,kBAAA;AC3NA;ADgOA;EAEA,iBAAA;EACA,gBAAA;AC/NA;;AAEA,wCAAwC","file":"AppButton.vue","sourcesContent":["<template>\n  <component\n    :is=\"tag\"\n    :aria-label=\"$slots.default ? $slots.default[0].text : text\"\n    :disabled=\"disabled\"\n    :type=\"nativeType\"\n    :href=\"href\"\n    :target=\"target\"\n    :class=\"[\n      `is-${size}`,\n      // `is-${type}`, uncomment when we remove the deprecated types\n      {\n        'has-icon': icon,\n        'prepend-icon': icon && prepend,\n        'is-block': isBlock,\n        'is-disabled': disabled,\n        'no-branding': noBranding,\n        // remove type checks when we remove the deprecated types\n        'is-success': ['affirm', 'success'].includes(type),\n        'is-danger': ['decline', 'danger'].includes(type),\n        'is-primary': type === 'primary',\n        'is-secondary': type === 'secondary',\n      },\n    ]\"\n    class=\"app-button\"\n    @click=\"$emit('click', $event);\"\n  >\n    <span\n      v-if=\"!isIcon && ($slots.default || text)\"\n      class=\"button-text\"\n    >{{ text || $slots.default[0].text }}</span>\n    <template v-if=\"icon || isIcon\">\n      <AppIcon\n        :icon=\"isLoading ? 'fa-solid fa-spinner fa-spin' : icon\"\n        :size=\"iconSize\"\n        class=\"app-button-icon\"\n        data-test=\"app button icon\"\n      />\n      <span\n        v-if=\"isIcon\"\n        class=\"sr-only\"\n        v-text=\"text\"\n      />\n    </template>\n  </component>\n</template>\n<script>\n  /**\n   * A standalone customizable themeable global button.\n   *\n   * @vuedoc\n   * @exports AppAlert\n   * @category Components\n   */\n  export default {\n    name: 'AppButton',\n    props: {\n      /**\n       * Prop used to pass the {@href https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-href} attribute used for an anchor tag.\n       */\n      href: {\n        type: String,\n        default: null,\n      },\n      /**\n       * Prop used to select the name of the icon to be used in the template. See the {@docs https://fontawesome.com/docs/web/use-with/vue/add-icons} for more information.\n       */\n      icon: {\n        type: String,\n        default: '',\n      },\n      /**\n       * Prop used to set the width to 100% and center the text.\n       */\n      isBlock: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Prop used to disable the element in the template.\n       */\n      isDisabled: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Prop used to disable the element in the template and render a spinning icon if an icon is present.\n       */\n      isLoading: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Prop used to pass the {@type https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-type} attribute used for an anchor tag.\n       */\n      nativeType: {\n        type: String,\n        default: 'button',\n      },\n      /**\n       * Prop used to render the \"primary\" and \"secondary\" type buttons with ThreeFlow blue instead of branding colors.\n       */\n      noBranding: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Prop used to update the css to reverse the css flex-direction.\n       */\n      prepend: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Prop used the render an icon, button size, or text size version of the button.\n       */\n      size: {\n        type: String,\n        default: 'medium',\n        validator: (v) => [\n          'icon',\n          'icon-small',\n          'small',\n          'medium',\n          'large',\n          'text',\n          'text-small',\n        ].includes(v),\n      },\n      /**\n       * Prop used to render the element either as a `<button />` or `<a />` tag.\n       */\n      tag: {\n        type: String,\n        default: 'button',\n        validator: (v) => ['a', 'button'].includes(v),\n      },\n      /**\n       * Prop used to pass the {@target https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target} attribute used for an anchor tag.\n       */\n      target: {\n        type: String,\n        default: null,\n      },\n      /**\n       * Prop used to override the default slot content.\n       */\n      text: {\n        type: String,\n        default: null,\n      },\n      /**\n       * Prop used to render the green, red, or branded (or ThreeFlow blue) style.\n       */\n      type: {\n        type: String,\n        default: 'primary',\n        validator: (v) => [\n          'affirm', // deprecated: use 'success'\n          'success',\n          'decline', // deprecated: use 'danger'\n          'danger',\n          'primary',\n          'secondary',\n        ].includes(v),\n      },\n    },\n    computed: {\n      /**\n       * Evaluate the disabled and isLoading props to determine if the button should be disabled.\n       *\n       * @returns {boolean}\n       */\n      disabled() {\n        return this.isDisabled || this.isLoading;\n      },\n      /**\n       * Evaluate the icon and size props to determine the icon size.\n       *\n       * @returns {string|null}\n       */\n      iconSize() {\n        if (!this.icon) {\n          return null;\n        }\n\n        return ['small', 'text-small', 'icon-small'].includes(this.size)\n          ? 'sm'\n          : 'lg';\n      },\n      /**\n       * Evaluate the size prop to determine if the button should render as an icon.\n       *\n       * @returns {boolean}\n       */\n      isIcon() {\n        return ['icon', 'icon-small'].includes(this.size);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .app-button {\n    white-space: nowrap;\n    box-shadow: none;\n    box-sizing: border-box;\n    margin: 0;\n    padding: 7px 14px;\n    border: {\n      radius: 0;\n      style: solid;\n    }\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n\n    + .app-button {\n      margin-left: var(--tf-btn-margin-medium);\n    }\n\n    &.is-disabled {\n      cursor: not-allowed;\n    }\n  }\n\n  .is-block {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .button-text {\n    font: {\n      size: 16px;\n      weight: 600;\n    }\n  }\n\n  // size\n  .is-small {\n    padding: 1px 13px;\n\n    .button-text {\n      font-size: var(--tf-body-font-size);\n    }\n  }\n\n  .is-medium,\n  .is-small {\n    border-radius: 3px;\n  }\n\n  .is-medium {\n    padding: 3px 18px;\n  }\n\n  .is-large {\n    padding: 8px 18px;\n    border-radius: 25px;\n\n    .button-text {\n      font-size: var(--tf-body-large-font-size);\n    }\n  }\n\n  .is-icon,\n  .is-icon-small,\n  .is-text,\n  .is-text-small {\n    &.is-primary,\n    &.is-secondary {\n      color: var(--primary, var(--tf-primary));\n\n      &.no-branding:not(.is-disabled) {\n        color: var(--tf-primary);\n      }\n    }\n  }\n\n  .is-text,\n  .is-text-small {\n    padding: 0;\n    background: transparent !important; // stylelint-disable-line\n    border: none !important; // stylelint-disable-line\n    vertical-align: inherit;\n\n    &.is-success {\n      color: var(--tf-success-font-color);\n    }\n\n    &.is-danger {\n      color: var(--tf-danger-font-color);\n    }\n\n    &.is-disabled {\n      color: var(--tf-disabled-font-color);\n    }\n\n    .app-alert & {\n      color: inherit !important; // stylelint-disable-line\n      text-decoration: underline;\n    }\n  }\n\n  .is-text {\n    .button-text {\n      font-size: var(--tf-body-font-size);\n    }\n  }\n\n  .is-text-small {\n    .button-text {\n      font-size: var(--tf-small-font-size);\n    }\n  }\n\n  // Types\n  .is-primary,\n  .is-secondary {\n    border-color: var(--primary, var(--tf-primary));\n\n    &.no-branding:not(.is-disabled) {\n      border-color: var(--tf-primary);\n    }\n  }\n\n  .is-success,\n  .is-danger,\n  .is-primary,\n  .is-secondary {\n    color: var(--tf-white);\n  }\n\n  .is-primary {\n    background-color: var(--primary, var(--tf-primary));\n\n    &.no-branding {\n      background-color: var(--tf-primary);\n    }\n  }\n\n  .is-secondary {\n    background-color: transparent;\n    color: var(--primary, var(--tf-primary));\n\n    &.no-branding {\n      color: var(--tf-primary);\n      border-color: var(--tf-primary);\n    }\n\n    &.is-disabled {\n      border-color: var(--tf-disabled);\n      color: var(--tf-disabled);\n    }\n  }\n\n  .is-success {\n    background-color: var(--tf-success);\n    border-color: var(--tf-success-border-color);\n  }\n\n  .is-danger {\n    background-color: var(--tf-danger);\n    border-color: var(--tf-danger-border-color);\n  }\n\n  .is-success,\n  .is-danger,\n  .is-primary {\n    &.is-disabled {\n      border-color: var(--tf-disabled-light);\n      background-color: var(--tf-disabled-light);\n      color: var(--tf-disabled);\n    }\n  }\n\n  // Icons\n  .app-button-icon {\n    line-height: inherit;\n  }\n\n  .is-icon,\n  .is-icon-small {\n    background: none !important; // stylelint-disable-line\n    border: none;\n\n    &.is-success {\n      color: var(--tf-success-font-color);\n    }\n\n    &.is-danger {\n      color: var(--tf-danger-font-color);\n    }\n\n    &.is-disabled {\n      color: var(--tf-disabled-font-color) !important; // stylelint-disable-line\n    }\n  }\n\n  .is-icon {\n    padding: 7px;\n  }\n\n  .is-icon-small {\n    padding: 9px;\n  }\n\n  .prepend-icon {\n    flex-direction: row-reverse;\n  }\n\n  .has-icon {\n    .button-text {\n      padding: {\n        left: 0;\n        right: 6px;\n      }\n    }\n\n    &.prepend-icon {\n      .button-text {\n        padding: {\n          left: 6px;\n          right: 0;\n        }\n      }\n    }\n  }\n</style>\n",".app-button {\n  white-space: nowrap;\n  box-shadow: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 7px 14px;\n  border-radius: 0;\n  border-style: solid;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n}\n.app-button + .app-button {\n  margin-left: var(--tf-btn-margin-medium);\n}\n.app-button.is-disabled {\n  cursor: not-allowed;\n}\n\n.is-block {\n  width: 100%;\n  justify-content: center;\n}\n\n.button-text {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.is-small {\n  padding: 1px 13px;\n}\n.is-small .button-text {\n  font-size: var(--tf-body-font-size);\n}\n\n.is-medium,\n.is-small {\n  border-radius: 3px;\n}\n\n.is-medium {\n  padding: 3px 18px;\n}\n\n.is-large {\n  padding: 8px 18px;\n  border-radius: 25px;\n}\n.is-large .button-text {\n  font-size: var(--tf-body-large-font-size);\n}\n\n.is-icon.is-primary, .is-icon.is-secondary,\n.is-icon-small.is-primary,\n.is-icon-small.is-secondary,\n.is-text.is-primary,\n.is-text.is-secondary,\n.is-text-small.is-primary,\n.is-text-small.is-secondary {\n  color: var(--primary, var(--tf-primary));\n}\n.is-icon.is-primary.no-branding:not(.is-disabled), .is-icon.is-secondary.no-branding:not(.is-disabled),\n.is-icon-small.is-primary.no-branding:not(.is-disabled),\n.is-icon-small.is-secondary.no-branding:not(.is-disabled),\n.is-text.is-primary.no-branding:not(.is-disabled),\n.is-text.is-secondary.no-branding:not(.is-disabled),\n.is-text-small.is-primary.no-branding:not(.is-disabled),\n.is-text-small.is-secondary.no-branding:not(.is-disabled) {\n  color: var(--tf-primary);\n}\n\n.is-text,\n.is-text-small {\n  padding: 0;\n  background: transparent !important;\n  border: none !important;\n  vertical-align: inherit;\n}\n.is-text.is-success,\n.is-text-small.is-success {\n  color: var(--tf-success-font-color);\n}\n.is-text.is-danger,\n.is-text-small.is-danger {\n  color: var(--tf-danger-font-color);\n}\n.is-text.is-disabled,\n.is-text-small.is-disabled {\n  color: var(--tf-disabled-font-color);\n}\n.app-alert .is-text,\n.app-alert .is-text-small {\n  color: inherit !important;\n  text-decoration: underline;\n}\n\n.is-text .button-text {\n  font-size: var(--tf-body-font-size);\n}\n\n.is-text-small .button-text {\n  font-size: var(--tf-small-font-size);\n}\n\n.is-primary,\n.is-secondary {\n  border-color: var(--primary, var(--tf-primary));\n}\n.is-primary.no-branding:not(.is-disabled),\n.is-secondary.no-branding:not(.is-disabled) {\n  border-color: var(--tf-primary);\n}\n\n.is-success,\n.is-danger,\n.is-primary,\n.is-secondary {\n  color: var(--tf-white);\n}\n\n.is-primary {\n  background-color: var(--primary, var(--tf-primary));\n}\n.is-primary.no-branding {\n  background-color: var(--tf-primary);\n}\n\n.is-secondary {\n  background-color: transparent;\n  color: var(--primary, var(--tf-primary));\n}\n.is-secondary.no-branding {\n  color: var(--tf-primary);\n  border-color: var(--tf-primary);\n}\n.is-secondary.is-disabled {\n  border-color: var(--tf-disabled);\n  color: var(--tf-disabled);\n}\n\n.is-success {\n  background-color: var(--tf-success);\n  border-color: var(--tf-success-border-color);\n}\n\n.is-danger {\n  background-color: var(--tf-danger);\n  border-color: var(--tf-danger-border-color);\n}\n\n.is-success.is-disabled,\n.is-danger.is-disabled,\n.is-primary.is-disabled {\n  border-color: var(--tf-disabled-light);\n  background-color: var(--tf-disabled-light);\n  color: var(--tf-disabled);\n}\n\n.app-button-icon {\n  line-height: inherit;\n}\n\n.is-icon,\n.is-icon-small {\n  background: none !important;\n  border: none;\n}\n.is-icon.is-success,\n.is-icon-small.is-success {\n  color: var(--tf-success-font-color);\n}\n.is-icon.is-danger,\n.is-icon-small.is-danger {\n  color: var(--tf-danger-font-color);\n}\n.is-icon.is-disabled,\n.is-icon-small.is-disabled {\n  color: var(--tf-disabled-font-color) !important;\n}\n\n.is-icon {\n  padding: 7px;\n}\n\n.is-icon-small {\n  padding: 9px;\n}\n\n.prepend-icon {\n  flex-direction: row-reverse;\n}\n\n.has-icon .button-text {\n  padding-left: 0;\n  padding-right: 6px;\n}\n.has-icon.prepend-icon .button-text {\n  padding-left: 6px;\n  padding-right: 0;\n}\n\n/*# sourceMappingURL=AppButton.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = "data-v-c7dcfef4";
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$2 = {
  name: 'AppConfirmEmail',
  props: {
    confirmEmailLink: {
      type: String,
      default: ''
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    { staticClass: "auth-form" },
    [
      _c("AuthPageHeader", { attrs: { title: "Confirm Email Address" } }),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Click below to confirm your email address and activate your ThreeFlow account."
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-group" },
        [
          _c("AppButton", {
            attrs: {
              type: "primary",
              text: "Confirm email",
              "no-branding": "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("AuthPageFooter"),
    ],
    1
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = function (inject) {
    if (!inject) return
    inject("data-v-6ec2b9bc_0", { source: ".btn-group[data-v-6ec2b9bc] {\n  justify-content: center;\n}\n\n/*# sourceMappingURL=AppConfirmEmail.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AuthPages/AppConfirmEmail.vue","AppConfirmEmail.vue"],"names":[],"mappings":"AA4BA;EACA,uBAAA;AC3BA;;AAEA,8CAA8C","file":"AppConfirmEmail.vue","sourcesContent":["<template>\n  <section class=\"auth-form\">\n    <AuthPageHeader title=\"Confirm Email Address\" />\n    <p>Click below to confirm your email address and activate your ThreeFlow account.</p>\n    <div class=\"btn-group\">\n      <AppButton\n        type=\"primary\"\n        text=\"Confirm email\"\n        no-branding\n      />\n    </div>\n    <AuthPageFooter />\n  </section>\n</template>\n\n<script>\n  export default {\n    name: 'AppConfirmEmail',\n    props: {\n      confirmEmailLink: {\n        type: String,\n        default: '',\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .btn-group {\n    justify-content: center;\n  }\n</style>\n",".btn-group {\n  justify-content: center;\n}\n\n/*# sourceMappingURL=AppConfirmEmail.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$2 = "data-v-6ec2b9bc";
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    browser,
    undefined,
    undefined
  );

var f$1 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$1
};

var gOPD = Object.getOwnPropertyDescriptor;

var f$2 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};

var _objectGopd = {
	f: f$2
};

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */


var check = function (O, proto) {
  _anObject(O);
  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

var setPrototypeOf = _setProto.set;
var _inheritIfRequired = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && _isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
	f: f$3
};

var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var space = '[' + _stringWs + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = _fails(function () {
    return !!_stringWs[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  _export(_export.P + _export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(_defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

var _stringTrim = exporter;

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$2 = _global.document;
var _html = document$2 && document$2.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

var gOPN = _objectGopn.f;
var gOPD$1 = _objectGopd.f;
var dP$1 = _objectDp.f;
var $trim = _stringTrim.trim;
var NUMBER = 'Number';
var $Number = _global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = _cof(_objectCreate(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = _toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? _fails(function () { proto.valueOf.call(that); }) : _cof(that) != NUMBER)
        ? _inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = _descriptors ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (_has(Base, key = keys[j]) && !_has($Number, key)) {
      dP$1($Number, key, gOPD$1(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  _redefine(_global, NUMBER, $Number);
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$3 = {
  name: 'AppForgotPasswordForm',
  props: {
    accountService: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    checkInvited: {
      type: Boolean,
      default: false
    },
    documentId: {
      type: String,
      default: null
    },
    linkLogin: {
      type: [String, Object],
      required: true
    },
    projectId: {
      type: [String, Number],
      default: null
    },
    userInfo: {
      type: Object,
      required: true
    }
  },
  data: function data(vm) {
    return {
      btnDisable: false,
      forgotPasswordForm: {
        email: ''
      },
      notInvited: false,
      rules: {
        email: [{
          required: true,
          type: 'email',
          message: 'Please enter your company email.',
          trigger: 'blur'
        }, {
          validator: vm.validateEmail,
          trigger: 'none'
        }, {
          validator: vm.clearError,
          trigger: 'change'
        }]
      }
    };
  },
  watch: {
    /**
     * Watching the email field - and updating the vuex store with the new email
     *
     * @param {string} email
     */
    'forgotPasswordForm.email': function forgotPasswordFormEmail(email) {
      this.$emit('setUserEmail', email);
      this.$emit('update:email', email);
      this.notInvited = false;
    }
  },
  created: function created() {
    // We want the email address to persist across all login/forgotPW/registration forms
    this.forgotPasswordForm.email = this.userInfo.email;
  },
  methods: {
    /* eslint-disable-next-line jsdoc/require-param */
    /**
     * Clear out any displayed errors
     */
    clearError: function clearError(rule, value, callback) {
      callback();
    },
    /* eslint-disable-next-line jsdoc/require-param */
    /**
     * Method to validate the email address and see if this user was invited to the project
     */
    validateEmail: function validateEmail(rule, value, callback) {
      var _this = this;
      if (!this.forgotPasswordForm.email || !this.checkInvited) {
        callback();
        return;
      }
      this.accountService.checkInvitedToProject(this.forgotPasswordForm.email, this.projectId).then(function () {
        callback();
      }).catch(function (error) {
        _this.notInvited = true;
        _this.btnDisable = false;
        var errorMessage = error.response && error.response.status === 404 ? 'Sorry, this email doesn\'t exist in our system. Ensure you\'re using the company email you registered with, or contact support@threeflow.com.' : 'This email is not invited. Ensure you’re using your company email and that it has been invited, or contact support@threeflow.com.';
        callback(new Error(errorMessage));
      });
    },
    /**
     * On form submission we should validate and call the service to update the password (if valid).
     */
    submitForgotPassword: function submitForgotPassword() {
      var _this2 = this;
      this.btnDisable = true;
      this.$refs.forgotPasswordForm.validate(function (valid) {
        if (!_this2.accountService.passwordReset) {
          return valid;
        }
        if (valid) {
          var data = {
            email: _this2.forgotPasswordForm.email,
            projectId: _this2.projectId
          };

          // Attach documentId if present
          if (_this2.documentId) {
            data.documentId = _this2.documentId;
          }
          _this2.accountService.passwordReset(data).then(function () {
            /* We should set a flag to show the success message on
            the login screen and then redirect to the login form */
            _this2.$emit('setTempPasswordStatus', true);
            var redirectURL = _this2.$route.query.redirect || _this2.linkLogin;
            _this2.btnDisable = false;
            _this2.$router.push(redirectURL);
          });
        }
        _this2.btnDisable = false;
        return valid;
      });
    }
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ElForm",
    {
      ref: "forgotPasswordForm",
      staticClass: "auth-form forgot-password",
      attrs: {
        model: _vm.forgotPasswordForm,
        rules: _vm.rules,
        "label-position": "top",
      },
      nativeOn: {
        submit: function ($event) {
          $event.preventDefault();
          return _vm.submitForgotPassword.apply(null, arguments)
        },
      },
    },
    [
      _c("AuthPageHeader", { attrs: { title: "Forgot Password" } }),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Enter your email address below to be sent a temporary password."
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inputs-container" },
        [
          _c(
            "ElFormItem",
            {
              staticClass: "email-container",
              class: { "not-invited-error": _vm.notInvited },
              attrs: {
                for: "email-input",
                prop: "email",
                label: "Company email",
                size: "medium",
              },
            },
            [
              _c("ElInput", {
                attrs: {
                  name: "email-input",
                  placeholder: "Enter email",
                  "data-test": "enter email",
                },
                model: {
                  value: _vm.forgotPasswordForm.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.forgotPasswordForm, "email", $$v);
                  },
                  expression: "forgotPasswordForm.email",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _vm._t("ctaSubmit", function () {
                return [
                  _c("AppButton", {
                    attrs: {
                      "is-disabled":
                        !_vm.forgotPasswordForm.email || _vm.btnDisable,
                      name: "submit-button",
                      type: "primary",
                      "native-type": "submit",
                      text: "Email temporary password",
                      "no-branding": "",
                      "data-test": "submit form",
                    },
                  }),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "links-container" },
            [
              _c(
                "RouterLink",
                { attrs: { tag: "li", to: _vm.linkLogin } },
                [
                  _c("AppButton", {
                    attrs: {
                      type: "primary",
                      size: "text",
                      text: "Sign in",
                      "no-branding": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AuthPageFooter"),
    ],
    1
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = function (inject) {
    if (!inject) return
    inject("data-v-afd33776_0", { source: ".btn-group[data-v-afd33776] {\n  justify-content: center;\n}\n\n/*# sourceMappingURL=AppForgotPasswordForm.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AuthPages/AppForgotPasswordForm.vue","AppForgotPasswordForm.vue"],"names":[],"mappings":"AA6MA;EACA,uBAAA;AC5MA;;AAEA,oDAAoD","file":"AppForgotPasswordForm.vue","sourcesContent":["<template>\n  <ElForm\n    ref=\"forgotPasswordForm\"\n    :model=\"forgotPasswordForm\"\n    :rules=\"rules\"\n    label-position=\"top\"\n    class=\"auth-form forgot-password\"\n    @submit.native.prevent=\"submitForgotPassword\"\n  >\n    <AuthPageHeader title=\"Forgot Password\" />\n    <p>Enter your email address below to be sent a temporary password.</p>\n    <div class=\"inputs-container\">\n      <ElFormItem\n        :class=\"{'not-invited-error' : notInvited }\"\n        for=\"email-input\"\n        prop=\"email\"\n        class=\"email-container\"\n        label=\"Company email\"\n        size=\"medium\"\n      >\n        <ElInput\n          v-model=\"forgotPasswordForm.email\"\n          name=\"email-input\"\n          placeholder=\"Enter email\"\n          data-test=\"enter email\"\n        />\n      </ElFormItem>\n      <div class=\"btn-group\">\n        <slot name=\"ctaSubmit\">\n          <AppButton\n            :is-disabled=\"!forgotPasswordForm.email || btnDisable\"\n            name=\"submit-button\"\n            type=\"primary\"\n            native-type=\"submit\"\n            text=\"Email temporary password\"\n            no-branding\n            data-test=\"submit form\"\n          />\n        </slot>\n      </div>\n      <ul class=\"links-container\">\n        <RouterLink\n          tag=\"li\"\n          :to=\"linkLogin\"\n        >\n          <AppButton\n            type=\"primary\"\n            size=\"text\"\n            text=\"Sign in\"\n            no-branding\n          />\n        </RouterLink>\n      </ul>\n    </div>\n    <AuthPageFooter />\n  </ElForm>\n</template>\n\n<script>\n  export default {\n    name: 'AppForgotPasswordForm',\n    props: {\n      accountService: {\n        type: Object,\n        default: () => ({}),\n      },\n      checkInvited: {\n        type: Boolean,\n        default: false,\n      },\n      documentId: {\n        type: String,\n        default: null,\n      },\n      linkLogin: {\n        type: [String, Object],\n        required: true,\n      },\n      projectId: {\n        type: [String, Number],\n        default: null,\n      },\n      userInfo: {\n        type: Object,\n        required: true,\n      },\n    },\n    data: (vm) => ({\n      btnDisable: false,\n      forgotPasswordForm: {\n        email: '',\n      },\n      notInvited: false,\n      rules: {\n        email: [\n          {\n            required: true,\n            type: 'email',\n            message: 'Please enter your company email.',\n            trigger: 'blur',\n          },\n          {\n            validator: vm.validateEmail,\n            trigger: 'none',\n          },\n          {\n            validator: vm.clearError,\n            trigger: 'change',\n          },\n        ],\n      },\n    }),\n    watch: {\n      /**\n       * Watching the email field - and updating the vuex store with the new email\n       *\n       * @param {string} email\n       */\n      'forgotPasswordForm.email': function (email) {\n        this.$emit('setUserEmail', email);\n        this.$emit('update:email', email);\n        this.notInvited = false;\n      },\n    },\n    created() {\n      // We want the email address to persist across all login/forgotPW/registration forms\n      this.forgotPasswordForm.email = this.userInfo.email;\n    },\n    methods: {\n      /* eslint-disable-next-line jsdoc/require-param */\n      /**\n       * Clear out any displayed errors\n       */\n      clearError(rule, value, callback) {\n        callback();\n      },\n\n      /* eslint-disable-next-line jsdoc/require-param */\n      /**\n       * Method to validate the email address and see if this user was invited to the project\n       */\n      validateEmail(rule, value, callback) {\n        if (!this.forgotPasswordForm.email || !this.checkInvited) {\n          callback();\n\n          return;\n        }\n\n        this.accountService\n          .checkInvitedToProject(this.forgotPasswordForm.email, this.projectId)\n          .then(() => {\n            callback();\n          })\n          .catch((error) => {\n            this.notInvited = true;\n            this.btnDisable = false;\n            const errorMessage = error.response && error.response.status === 404\n              ? 'Sorry, this email doesn\\'t exist in our system. Ensure you\\'re using the company email you registered with, or contact support@threeflow.com.'\n              : 'This email is not invited. Ensure you’re using your company email and that it has been invited, or contact support@threeflow.com.';\n            callback(new Error(errorMessage));\n          });\n      },\n\n      /**\n       * On form submission we should validate and call the service to update the password (if valid).\n       */\n      submitForgotPassword() {\n        this.btnDisable = true;\n\n        this.$refs.forgotPasswordForm.validate((valid) => {\n          if (!this.accountService.passwordReset) {\n            return valid;\n          }\n\n          if (valid) {\n            const data = {\n              email: this.forgotPasswordForm.email,\n              projectId: this.projectId,\n            };\n\n            // Attach documentId if present\n            if (this.documentId) {\n              data.documentId = this.documentId;\n            }\n\n            this.accountService.passwordReset(data).then(() => {\n              /* We should set a flag to show the success message on\n             the login screen and then redirect to the login form */\n              this.$emit('setTempPasswordStatus', true);\n              const redirectURL = this.$route.query.redirect || this.linkLogin;\n              this.btnDisable = false;\n              this.$router.push(redirectURL);\n            });\n          }\n\n          this.btnDisable = false;\n\n          return valid;\n        });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .btn-group {\n    justify-content: center;\n  }\n</style>\n",".btn-group {\n  justify-content: center;\n}\n\n/*# sourceMappingURL=AppForgotPasswordForm.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$3 = "data-v-afd33776";
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * A customized wrapper around the `<i>` tag that uses the `fontawesome` library.
 *
 * @vuedoc
 * @exports AppIcon
 * @category Components
 */
var script$4 = {
  name: 'AppIcon',
  props: {
    /**
     * A string which includes the icon type (fa-solid, fa-regular, etc) and icon name (fa-trash-can, fa-circle-info, etc) to render.
     */
    icon: {
      type: String,
      required: true
    },
    /**
     * Prop used to render the "primary" and "secondary" type buttons with ThreeFlow blue instead of branding colors.
     */
    noBranding: {
      type: Boolean,
      default: false
    },
    /**
     * The fontawesome [icon size property](https://fontawesome.com/v6/docs/web/style/size) without the `fa-` prefix, which is added to the class automatically.
     */
    size: {
      type: String,
      default: 'lg',
      validator: function validator(value) {
        return [
        // relative sizes
        '2xs', 'xs', 'sm', 'lg', 'xl', '2xl',
        // literal sizes
        '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x'].includes(value);
      }
    },
    /**
     * The prop used to render themed colors (danger, success, etc).
     */
    type: {
      type: String,
      default: '',
      validator: function validator(value) {
        return ['', 'danger', 'info', 'primary', 'success', 'warning'].includes(value);
      }
    }
  }
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("i", {
    class: [
      _vm.icon,
      "app-icon",
      "fa-" + _vm.size,
      ((_obj = {}),
      (_obj["is-" + _vm.type] = _vm.type),
      (_obj["no-branding"] = _vm.noBranding),
      _obj),
    ],
  })
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = function (inject) {
    if (!inject) return
    inject("data-v-c25511c8_0", { source: ".is-danger[data-v-c25511c8] {\n  color: var(--tf-danger-font-color);\n}\n.is-info[data-v-c25511c8] {\n  color: var(--tf-info-font-color);\n}\n.is-primary[data-v-c25511c8] {\n  color: var(--primary);\n}\n.is-primary.no-branding[data-v-c25511c8] {\n  color: var(--tf-primary);\n}\n.is-success[data-v-c25511c8] {\n  color: var(--tf-success-font-color);\n}\n.is-warning[data-v-c25511c8] {\n  color: var(--tf-warning-font-color);\n}\n\n/*# sourceMappingURL=AppIcon.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AppIcon.vue","AppIcon.vue"],"names":[],"mappings":"AA2FA;EACA,kCAAA;AC1FA;AD6FA;EACA,gCAAA;AC3FA;AD8FA;EACA,qBAAA;AC5FA;AD8FA;EACA,wBAAA;AC5FA;ADgGA;EACA,mCAAA;AC9FA;ADiGA;EACA,mCAAA;AC/FA;;AAEA,sCAAsC","file":"AppIcon.vue","sourcesContent":["<template>\n  <i\n    :class=\"[\n      icon,\n      'app-icon',\n      `fa-${size}`,\n      {\n        [`is-${type}`]: type,\n        'no-branding': noBranding,\n      },\n    ]\"\n  />\n</template>\n\n<script>\n  /**\n   * A customized wrapper around the `<i>` tag that uses the `fontawesome` library.\n   *\n   * @vuedoc\n   * @exports AppIcon\n   * @category Components\n   */\n  export default {\n    name: 'AppIcon',\n    props: {\n      /**\n       * A string which includes the icon type (fa-solid, fa-regular, etc) and icon name (fa-trash-can, fa-circle-info, etc) to render.\n       */\n      icon: {\n        type: String,\n        required: true,\n      },\n      /**\n       * Prop used to render the \"primary\" and \"secondary\" type buttons with ThreeFlow blue instead of branding colors.\n       */\n      noBranding: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * The fontawesome [icon size property](https://fontawesome.com/v6/docs/web/style/size) without the `fa-` prefix, which is added to the class automatically.\n       */\n      size: {\n        type: String,\n        default: 'lg',\n        validator: (value) => (\n          [\n            // relative sizes\n            '2xs',\n            'xs',\n            'sm',\n            'lg',\n            'xl',\n            '2xl',\n            // literal sizes\n            '1x',\n            '2x',\n            '3x',\n            '4x',\n            '5x',\n            '6x',\n            '7x',\n            '8x',\n            '9x',\n            '10x',\n          ].includes(value)\n        ),\n      },\n      /**\n       * The prop used to render themed colors (danger, success, etc).\n       */\n      type: {\n        type: String,\n        default: '',\n        validator: (value) => (\n          [\n            '',\n            'danger',\n            'info',\n            'primary',\n            'success',\n            'warning',\n          ].includes(value)\n        ),\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .is {\n    &-danger {\n      color: var(--tf-danger-font-color);\n    }\n\n    &-info {\n      color: var(--tf-info-font-color);\n    }\n\n    &-primary {\n      color: var(--primary);\n\n      &.no-branding {\n        color: var(--tf-primary);\n      }\n    }\n\n    &-success {\n      color: var(--tf-success-font-color);\n    }\n\n    &-warning {\n      color: var(--tf-warning-font-color);\n    }\n  }\n</style>\n",".is-danger {\n  color: var(--tf-danger-font-color);\n}\n.is-info {\n  color: var(--tf-info-font-color);\n}\n.is-primary {\n  color: var(--primary);\n}\n.is-primary.no-branding {\n  color: var(--tf-primary);\n}\n.is-success {\n  color: var(--tf-success-font-color);\n}\n.is-warning {\n  color: var(--tf-warning-font-color);\n}\n\n/*# sourceMappingURL=AppIcon.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$4 = "data-v-c25511c8";
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$5 = {
  name: 'AppLanding'
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("section", { staticClass: "auth-form" }, [
    _c("div", { staticClass: "small-tf-logo" }, [
      _vm._v("\n    WatchTower Technologies\n  "),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._t("title")], 2),
    _vm._v(" "),
    _c("p", [_vm._t("description")], 2),
    _vm._v(" "),
    _c("a", {
      attrs: { href: "mailto:support@watchtowerbenefits.com" },
      domProps: { textContent: _vm._s("support@watchtowerbenefits.com") },
    }),
  ])
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  const __vue_inject_styles__$5 = function (inject) {
    if (!inject) return
    inject("data-v-13ca309e_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\na[data-v-13ca309e] {\n  font-size: 14px;\n}\n\n/*# sourceMappingURL=AppLanding.vue.map */", map: {"version":3,"sources":["AppLanding.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AuthPages/AppLanding.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACqBlC;EACA,eAAA;ADnBA;;AAEA,yCAAyC","file":"AppLanding.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\na {\n  font-size: 14px;\n}\n\n/*# sourceMappingURL=AppLanding.vue.map */","<template>\n  <section class=\"auth-form\">\n    <div class=\"small-tf-logo\">\n      WatchTower Technologies\n    </div>\n    <h2><slot name=\"title\" /></h2>\n    <p><slot name=\"description\" /></p>\n    <a\n      href=\"mailto:support@watchtowerbenefits.com\"\n      v-text=\"'support@watchtowerbenefits.com'\"\n    />\n  </section>\n</template>\n\n<script>\n  export default {\n    name: 'AppLanding',\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/mixins';\n\n  a {\n    font-size: 14px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$5 = "data-v-13ca309e";
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    browser,
    undefined,
    undefined
  );

var dP$2 = _objectDp.f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || _descriptors && dP$2(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * A component used to display individual changes to a quote, including what the change was, who made it, and when.
 */
var script$6 = {
  name: 'AppQuoteEditItem',
  props: {
    /**
     * what element this should appear as
     */
    tag: {
      type: String,
      default: 'li'
    },
    /**
     * overrides if we should show new badge or not
     */
    showNewBadge: {
      type: Boolean,
      default: true
    },
    /**
     * the history item to display
     */
    item: {
      type: Object,
      required: true
    },
    /**
     * route string to the page where the change was made
     */
    attributeLink: {
      type: String,
      default: ''
    },
    /**
     * Modifies the layout to by showing the carrier name and the editor instead of just the 'userName, carrierName'.
     */
    showEditor: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Combine the first/last name and prepend the carrier name if it exists.
     *
     * @returns {string}
     */
    responsibleParty: function responsibleParty() {
      var _this$item$history_de = this.item.history_details.responsible_user,
        broker = _this$item$history_de.broker,
        carrier = _this$item$history_de.carrier,
        firstName = _this$item$history_de.first_name,
        lastName = _this$item$history_de.last_name;
      var userName = "".concat(firstName, " ").concat(lastName);
      var responsibleCompany;
      if (broker && broker.name) {
        responsibleCompany = broker.name;
      }
      if (carrier && carrier.name) {
        responsibleCompany = carrier.name;
      }
      return "".concat(userName, ", ").concat(responsibleCompany);
    },
    /**
     * Display product type if there's a label
     *
     * @returns {string}
     */
    productTypeName: function productTypeName() {
      return this.item.product_type_name !== this.item.project_product_label ? "".concat(this.item.product_type_name, ", ").concat(this.item.project_product_label) : this.item.product_type_name;
    },
    /**
     * Display the attribute info including what product it belonged to
     * as well as container/value/subtype info.
     *
     * @returns {string}
     */
    attributeInfo: function attributeInfo() {
      var details = this.item.history_details;
      var attributeInfo = details.attribute_name;
      if (details.tier_subtype_name) {
        attributeInfo += ", ".concat(details.tier_subtype_name);
      }
      if (this.item.attributable_id !== 77) {
        attributeInfo += ', ';
        if (details.container_type.toLowerCase() === 'class') {
          attributeInfo += 'Class ';
        }
        attributeInfo += "".concat(details.container_name);
      }
      if (this.item.label && this.item.label !== 'composite') {
        attributeInfo += ", ".concat(this.item.label);
      }
      return attributeInfo;
    },
    /**
     * The text to be displayed for what the item was changed from
     * If this is a Rate Attribute: Float to 3 decimal points and add $
     *
     * @returns {string}
     */
    fromValue: function fromValue() {
      var valueText = this.item.before_value || 'n/a';
      return this.isRateAttribute && this.item.before_value ? "$".concat(parseFloat(valueText).toFixed(3)) : valueText;
    },
    /**
     * Test to see if this is a attribute type of 'Rate Attribute'
     *
     * @returns {boolean}
     */
    isRateAttribute: function isRateAttribute() {
      return this.item.attributable_type.toLowerCase() === 'rateattribute';
    },
    /**
     * The text to be displayed for what the item was changed to
     * If this is a Rate Attribute: Float to 3 decimal points and add $
     *
     * @returns {string}
     */
    toValue: function toValue() {
      var valueText = this.item.after_value || 'n/a';
      return this.isRateAttribute && this.item.after_value ? "$".concat(parseFloat(valueText).toFixed(3)) : valueText;
    }
  }
};

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.tag,
    { tag: "component", staticClass: "quote-edit-item" },
    [
      _vm.showNewBadge && _vm.item.is_new
        ? _c("TfBadge", { attrs: { value: "New", status: "success" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditor
        ? _c("p", { attrs: { "data-test": "carrier name" } }, [
            _c("strong", [_vm._v(_vm._s(_vm.item.carrier_name))]),
          ])
        : _c("p", { attrs: { "data-test": "responsible party for edit" } }, [
            _c("strong", [_vm._v(_vm._s(_vm.responsibleParty))]),
          ]),
      _vm._v(" "),
      _c("p", { attrs: { "data-test": "history product type name" } }, [
        _vm._v("\n    " + _vm._s(_vm.productTypeName) + "\n  "),
      ]),
      _vm._v(" "),
      _c("p", { attrs: { "data-test": "history attribute info" } }, [
        _vm._v("\n    " + _vm._s(_vm.attributeInfo) + "\n  "),
      ]),
      _vm._v(" "),
      _c("p", { attrs: { "data-test": "history from" } }, [
        _vm._v("\n    From: " + _vm._s(_vm.fromValue) + "\n  "),
      ]),
      _vm._v(" "),
      _vm.attributeLink
        ? [
            _c(
              "p",
              [
                _c("RouterLink", {
                  attrs: {
                    to: _vm.attributeLink,
                    "data-test": "to history update",
                  },
                  domProps: { textContent: _vm._s("To: " + _vm.toValue) },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _c("RouterLink", {
                  staticClass: "view-change-link",
                  attrs: {
                    to: _vm.attributeLink,
                    "data-test": "history change",
                  },
                  domProps: { textContent: _vm._s("View Change") },
                }),
              ],
              1
            ),
          ]
        : _c("p", [
            _c("strong", { attrs: { "data-test": "history to" } }, [
              _vm._v("To: " + _vm._s(_vm.toValue)),
            ]),
          ]),
      _vm._v(" "),
      _vm.showEditor
        ? _c("p", { attrs: { "data-test": "responsible party for edit" } }, [
            _vm._v("\n    Editor: " + _vm._s(_vm.responsibleParty) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", [
        _c("span", { staticClass: "time" }, [
          _vm._v(
            _vm._s(
              _vm.$TF.DatesUtils.formatDateAndTime(_vm.item.last_created_at)
            )
          ),
        ]),
      ]),
    ],
    2
  )
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

  /* style */
  const __vue_inject_styles__$6 = function (inject) {
    if (!inject) return
    inject("data-v-b564cdea_0", { source: "\n.quote-edit-item[data-v-b564cdea] {\n  list-style: none;\n  font-size: 14px;\n  padding: 25px 16px;\n  border-bottom: solid 1px var(--tf-gray-light-medium);\n}\n.time[data-v-b564cdea] {\n  color: var(--tf-gray);\n}\n.view-change-link[data-v-b564cdea] {\n  font-weight: normal;\n}\np[data-v-b564cdea] {\n  margin: 0;\n  padding: 2px 0;\n}\n", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AppQuoteEditItem.vue"],"names":[],"mappings":";AAoNA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,oDAAA;AACA;AAEA;EACA,qBAAA;AACA;AAEA;EACA,mBAAA;AACA;AAEA;EACA,SAAA;EACA,cAAA;AACA","file":"AppQuoteEditItem.vue","sourcesContent":["<template>\n  <component\n    :is=\"tag\"\n    class=\"quote-edit-item\"\n  >\n    <TfBadge\n      v-if=\"showNewBadge && item.is_new\"\n      value=\"New\"\n      status=\"success\"\n    />\n    <p\n      v-if=\"showEditor\"\n      data-test=\"carrier name\"\n    >\n      <strong>{{ item.carrier_name }}</strong>\n    </p>\n    <p\n      v-else\n      data-test=\"responsible party for edit\"\n    >\n      <strong>{{ responsibleParty }}</strong>\n    </p>\n    <p data-test=\"history product type name\">\n      {{ productTypeName }}\n    </p>\n    <p data-test=\"history attribute info\">\n      {{ attributeInfo }}\n    </p>\n    <p data-test=\"history from\">\n      From: {{ fromValue }}\n    </p>\n    <template v-if=\"attributeLink\">\n      <p>\n        <RouterLink\n          :to=\"attributeLink\"\n          data-test=\"to history update\"\n          v-text=\"`To: ${toValue}`\"\n        />\n      </p>\n      <p>\n        <RouterLink\n          :to=\"attributeLink\"\n          class=\"view-change-link\"\n          data-test=\"history change\"\n          v-text=\"'View Change'\"\n        />\n      </p>\n    </template>\n    <p v-else>\n      <strong data-test=\"history to\">To: {{ toValue }}</strong>\n    </p>\n    <p\n      v-if=\"showEditor\"\n      data-test=\"responsible party for edit\"\n    >\n      Editor: {{ responsibleParty }}\n    </p>\n    <p>\n      <span class=\"time\">{{ $TF.DatesUtils.formatDateAndTime(item.last_created_at) }}</span>\n    </p>\n  </component>\n</template>\n\n<script>\n  /**\n   * A component used to display individual changes to a quote, including what the change was, who made it, and when.\n   */\n  export default {\n    name: 'AppQuoteEditItem',\n    props: {\n      /**\n       * what element this should appear as\n       */\n      tag: {\n        type: String,\n        default: 'li',\n      },\n      /**\n       * overrides if we should show new badge or not\n       */\n      showNewBadge: {\n        type: Boolean,\n        default: true,\n      },\n      /**\n       * the history item to display\n       */\n      item: {\n        type: Object,\n        required: true,\n      },\n      /**\n       * route string to the page where the change was made\n       */\n      attributeLink: {\n        type: String,\n        default: '',\n      },\n      /**\n       * Modifies the layout to by showing the carrier name and the editor instead of just the 'userName, carrierName'.\n       */\n      showEditor: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    computed: {\n      /**\n       * Combine the first/last name and prepend the carrier name if it exists.\n       *\n       * @returns {string}\n       */\n      responsibleParty() {\n        const {\n          broker,\n          carrier,\n          first_name: firstName,\n          last_name: lastName,\n        } = this.item.history_details.responsible_user;\n\n        const userName = `${firstName} ${lastName}`;\n        let responsibleCompany;\n\n        if (broker && broker.name) {\n          responsibleCompany = broker.name;\n        }\n\n        if (carrier && carrier.name) {\n          responsibleCompany = carrier.name;\n        }\n\n        return `${userName}, ${responsibleCompany}`;\n      },\n      /**\n       * Display product type if there's a label\n       *\n       * @returns {string}\n       */\n      productTypeName() {\n        return this.item.product_type_name !== this.item.project_product_label\n          ? `${this.item.product_type_name}, ${this.item.project_product_label}`\n          : this.item.product_type_name;\n      },\n      /**\n       * Display the attribute info including what product it belonged to\n       * as well as container/value/subtype info.\n       *\n       * @returns {string}\n       */\n      attributeInfo() {\n        const details = this.item.history_details;\n        let attributeInfo = details.attribute_name;\n\n        if (details.tier_subtype_name) {\n          attributeInfo += `, ${details.tier_subtype_name}`;\n        }\n\n        if (this.item.attributable_id !== 77) {\n          attributeInfo += ', ';\n\n          if (details.container_type.toLowerCase() === 'class') {\n            attributeInfo += 'Class ';\n          }\n\n          attributeInfo += `${details.container_name}`;\n        }\n\n        if (this.item.label && this.item.label !== 'composite') {\n          attributeInfo += `, ${this.item.label}`;\n        }\n\n        return attributeInfo;\n      },\n      /**\n       * The text to be displayed for what the item was changed from\n       * If this is a Rate Attribute: Float to 3 decimal points and add $\n       *\n       * @returns {string}\n       */\n      fromValue() {\n        const valueText = this.item.before_value || 'n/a';\n\n        return this.isRateAttribute && this.item.before_value\n          ? `$${parseFloat(valueText).toFixed(3)}`\n          : valueText;\n      },\n      /**\n       * Test to see if this is a attribute type of 'Rate Attribute'\n       *\n       * @returns {boolean}\n       */\n      isRateAttribute() {\n        return this.item.attributable_type.toLowerCase() === 'rateattribute';\n      },\n      /**\n       * The text to be displayed for what the item was changed to\n       * If this is a Rate Attribute: Float to 3 decimal points and add $\n       *\n       * @returns {string}\n       */\n      toValue() {\n        const valueText = this.item.after_value || 'n/a';\n\n        return this.isRateAttribute && this.item.after_value\n          ? `$${parseFloat(valueText).toFixed(3)}`\n          : valueText;\n      },\n    },\n  };\n</script>\n\n<style scoped>\n.quote-edit-item {\n  list-style: none;\n  font-size: 14px;\n  padding: 25px 16px;\n  border-bottom: solid 1px var(--tf-gray-light-medium);\n}\n\n.time {\n  color: var(--tf-gray);\n}\n\n.view-change-link {\n  font-weight: normal;\n}\n\np {\n  margin: 0;\n  padding: 2px 0;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$6 = "data-v-b564cdea";
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    browser,
    undefined,
    undefined
  );

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var at = _stringAt(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var _advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG = _wks('toStringTag');
// ES3 wrong here
var ARG = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var _regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (_classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};

// 21.2.5.3 get RegExp.prototype.flags

var _flags = function () {
  var that = _anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', _flags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var _regexpExec = patchedExec;

_export({
  target: 'RegExp',
  proto: true,
  forced: _regexpExec !== /./.exec
}, {
  exec: _regexpExec
});

var SPECIES = _wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !_fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

var _fixReWks = function (KEY, length, exec) {
  var SYMBOL = _wks(KEY);

  var DELEGATES_TO_SYMBOL = !_fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !_fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      _defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === _regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    _redefine(String.prototype, KEY, strfn);
    _hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

var max$1 = Math.max;
var min$2 = Math.min;
var floor$1 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
_fixReWks('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = _anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = _regexpExecAbstract(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max$1(min$2(_toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = _toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor$1(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$7 = {
  name: 'AppRegisterConfirmation',
  props: {
    linkLogin: {
      type: [String, Object],
      default: ''
    },
    linkResend: {
      type: [String, Object],
      default: ''
    },
    linkRegister: {
      type: [String, Object],
      default: ''
    },
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    // We want the email address to persist across all login/forgotPW/registration forms
    if (!this.userInfo.email) {
      // If we don't know your email address then you obviously don't know your info and will redirect to the login screen)
      var redirectURL = this.$route.query.redirect || this.linkLogin;
      this.$router.replace(redirectURL);
    }
  }
};

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    { staticClass: "auth-form" },
    [
      _c("AuthPageHeader", { attrs: { title: "Almost Done!" } }),
      _vm._v(" "),
      _c("p", [
        _vm._v("Please check "),
        _c("strong", [_vm._v(_vm._s(_vm.userInfo.email))]),
        _vm._v(" to confirm your account."),
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "links-container" },
        [
          _c(
            "RouterLink",
            { attrs: { tag: "li", to: _vm.linkResend } },
            [
              _c("AppButton", {
                attrs: {
                  id: "link-register",
                  type: "primary",
                  size: "text",
                  text: "Didn’t receive the email?",
                  "no-branding": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AuthPageFooter"),
    ],
    1
  )
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  const __vue_inject_styles__$7 = function (inject) {
    if (!inject) return
    inject("data-v-b2ca82c6_0", { source: ".auth-form[data-v-b2ca82c6] {\n  max-width: 500px;\n}\n.links-container[data-v-b2ca82c6] {\n  justify-content: space-around;\n  margin-top: 60px;\n}\n\n/*# sourceMappingURL=AppRegisterConfirmation.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AuthPages/AppRegisterConfirmation.vue","AppRegisterConfirmation.vue"],"names":[],"mappings":"AAwDA;EACA,gBAAA;ACvDA;AD0DA;EACA,6BAAA;EACA,gBAAA;ACvDA;;AAEA,sDAAsD","file":"AppRegisterConfirmation.vue","sourcesContent":["<template>\n  <section class=\"auth-form\">\n    <AuthPageHeader title=\"Almost Done!\" />\n    <p>Please check <strong>{{ userInfo.email }}</strong> to confirm your account.</p>\n    <ul class=\"links-container\">\n      <RouterLink\n        tag=\"li\"\n        :to=\"linkResend\"\n      >\n        <AppButton\n          id=\"link-register\"\n          type=\"primary\"\n          size=\"text\"\n          text=\"Didn’t receive the email?\"\n          no-branding\n        />\n      </RouterLink>\n    </ul>\n    <AuthPageFooter />\n  </section>\n</template>\n\n<script>\n  export default {\n    name: 'AppRegisterConfirmation',\n    props: {\n      linkLogin: {\n        type: [String, Object],\n        default: '',\n      },\n      linkResend: {\n        type: [String, Object],\n        default: '',\n      },\n      linkRegister: {\n        type: [String, Object],\n        default: '',\n      },\n      userInfo: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n    created() {\n      // We want the email address to persist across all login/forgotPW/registration forms\n      if (!this.userInfo.email) {\n        // If we don't know your email address then you obviously don't know your info and will redirect to the login screen)\n        const redirectURL = this.$route.query.redirect || this.linkLogin;\n\n        this.$router.replace(redirectURL);\n      }\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .auth-form {\n    max-width: 500px;\n  }\n\n  .links-container {\n    justify-content: space-around;\n    margin-top: 60px;\n  }\n</style>\n",".auth-form {\n  max-width: 500px;\n}\n\n.links-container {\n  justify-content: space-around;\n  margin-top: 60px;\n}\n\n/*# sourceMappingURL=AppRegisterConfirmation.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$7 = "data-v-b2ca82c6";
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    browser,
    undefined,
    undefined
  );

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

var _iterators = {};

var def = _objectDp.f;

var TAG$1 = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG$1)) def(it, TAG$1, { configurable: true, value: tag });
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if ( typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ( (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }
  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators.Arguments = _iterators.Array;

_addToUnscopables('keys');
_addToUnscopables('values');
_addToUnscopables('entries');

var ITERATOR$1 = _wks('iterator');
var TO_STRING_TAG = _wks('toStringTag');
var ArrayValues = _iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = _objectKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME$1 = collections[i];
  var explicit = DOMIterables[NAME$1];
  var Collection = _global[NAME$1];
  var proto$1 = Collection && Collection.prototype;
  var key$1;
  if (proto$1) {
    if (!proto$1[ITERATOR$1]) _hide(proto$1, ITERATOR$1, ArrayValues);
    if (!proto$1[TO_STRING_TAG]) _hide(proto$1, TO_STRING_TAG, NAME$1);
    _iterators[NAME$1] = ArrayValues;
    if (explicit) for (key$1 in es6_array_iterator) if (!proto$1[key$1]) _redefine(proto$1, key$1, es6_array_iterator[key$1], true);
  }
}

var isEnum = _objectPie.f;
var _objectToArray = function (isEntries) {
  return function (it) {
    var O = _toIobject(it);
    var keys = _objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!_descriptors || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

// https://github.com/tc39/proposal-object-values-entries

var $values = _objectToArray(false);

_export(_export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

var SPECIES$1 = _wks('species');

var _arraySpeciesConstructor = function (original) {
  var C;
  if (_isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
    if (_isObject(C)) {
      C = C[SPECIES$1];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate = function (original, length) {
  return new (_arraySpeciesConstructor(original))(length);
};

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex





var _arrayMethods = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = _toObject($this);
    var self = _iobject(O);
    var f = _ctx(callbackfn, that, 3);
    var length = _toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

var _strictMethod = function (method, arg) {
  return !!method && _fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

var $some = _arrayMethods(3);

_export(_export.P + _export.F * !_strictMethod([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$8 = {
  name: 'AppRegisterForm',
  props: {
    accountService: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    checkInvited: {
      type: Boolean,
      default: false
    },
    documentId: {
      type: String,
      default: null
    },
    employerName: {
      type: String,
      default: ''
    },
    invitedCarriers: {
      type: Number,
      default: 0
    },
    linkForgot: {
      type: [String, Object],
      required: true
    },
    linkLogin: {
      type: [String, Object],
      required: true
    },
    linkRegisterConfirmation: {
      type: [String, Object],
      required: true
    },
    projectId: {
      type: [String, Number],
      default: null
    },
    showProjectInfo: {
      type: Boolean,
      default: true
    },
    submittedCarriers: {
      type: Number,
      default: 0
    },
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data(vm) {
    return {
      customError: null,
      // 'emailTaken' || 'notValid' || 'generic'
      formErrorMessage: null,
      notInvited: false,
      registrationForm: {
        firstName: vm.userInfo.firstName,
        lastName: vm.userInfo.lastName,
        role: vm.userInfo.role,
        email: '',
        password: ''
      },
      rules: {
        firstName: [{
          required: true,
          message: 'Please enter your first name.',
          trigger: 'blur'
        }],
        lastName: [{
          required: true,
          message: 'Please enter your last name.',
          trigger: 'blur'
        }],
        role: [{
          required: true,
          message: 'Please enter your role.',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Please enter your company email.',
          trigger: 'blur'
        }, {
          validator: vm.clearError,
          trigger: 'change'
        }, {
          validator: vm.validateEmail,
          trigger: 'blur'
        }]
      },
      roles: ['Executive or Corporate Sponsor', 'Regional Leader', 'Sales Executive', 'Sales Coordinator', 'Underwriter', 'Account Manager'],
      isValidPassword: false
    };
  },
  computed: {
    /**
     * Evaluate the registration form values to determine if the Create button is disabled.
     *
     * @returns {boolean}
     */
    btnCreateDisabled: function btnCreateDisabled() {
      return Object.values(this.registrationForm).some(function (value) {
        return !value;
      }) || !this.isValidPassword;
    }
  },
  watch: {
    /**
     * Watching the email field - and updating the vuex store with the new email
     *
     * @param {string} email
     */
    'registrationForm.email': function registrationFormEmail(email) {
      this.$emit('setUserEmail', email);
      this.$emit('update:email', email);
      this.notInvited = false;
      if (this.customError) {
        this.customError = null;
      }
    },
    /**
     * Watch the "firstName" field to sync with parent component.
     *
     * @param {string} value
     */
    'registrationForm.firstName': function registrationFormFirstName(value) {
      this.$emit('update:firstName', value);
    },
    /**
     * Watch the "lastName" field to sync with parent component.
     *
     * @param {string} value
     */
    'registrationForm.lastName': function registrationFormLastName(value) {
      this.$emit('update:lastName', value);
    },
    /**
     * Watch the "role" field to sync with parent component.
     *
     * @param {string} value
     */
    'registrationForm.role': function registrationFormRole(value) {
      this.$emit('update:role', value);
    },
    /**
     * Watch the "password" field to sync with parent component.
     *
     * @param {string} value
     */
    'registrationForm.password': function registrationFormPassword(value) {
      this.$emit('update:password', value);
    }
  },
  created: function created() {
    // We want the email address to persist across all login/forgotPW/registration forms
    this.registrationForm.email = this.$route.query.email || this.userInfo.email;
  },
  /* When the component is destroyed we need to remove the event listener we manually added for the error message */beforeDestroy: function beforeDestroy() {
    if (this.formErrorMessage) {
      this.formErrorMessage.close();
    }
  },
  methods: {
    /* eslint-disable-next-line jsdoc/require-param */
    /**
     * Clear out any displayed errors
     */
    clearError: function clearError(rule, value, callback) {
      callback();
    },
    /* eslint-disable-next-line jsdoc/require-param */
    /**
     * Method to validate the email address and see if this user was invited to the project
     */
    validateEmail: function validateEmail(rule, value, callback) {
      var _this = this;
      if (!this.registrationForm.email || !this.checkInvited) {
        callback();
        return;
      }
      this.accountService.checkInvitedToProject(this.registrationForm.email, this.projectId).then(function () {
        callback();
      }).catch(function () {
        _this.notInvited = true;
        callback(new Error('This email is not invited. Ensure you’re using your company email and that it has been invited. Or contact support@threeflow.com.'));
      });
    },
    /**
     * Validate the registrationForm and call the accountService/registerUser method.
     */
    submitRegistration: function submitRegistration() {
      var _this2 = this;
      this.$refs.registrationForm.validate(function (valid) {
        if (valid) {
          if (!_this2.accountService.registerUser) {
            return valid;
          }
          var data = {
            firstName: _this2.registrationForm.firstName,
            lastName: _this2.registrationForm.lastName,
            department: _this2.registrationForm.role,
            email: _this2.registrationForm.email,
            password: _this2.registrationForm.password,
            projectId: _this2.projectId
          };
          if (_this2.documentId) {
            data.documentId = _this2.documentId;
          }
          _this2.accountService.registerUser(data).then(function () {
            _this2.$router.push(_this2.linkRegisterConfirmation);
          }).catch(function (_ref) {
            var response = _ref.response;
            var _response$data = response.data,
              code = _response$data.code,
              message = _response$data.message;
            var customError = 'generic';

            // 'emailTaken' || 'notValid' || 'generic'
            if (code === 'INVALID_PARAMS') {
              if (message === 'Email has already been taken') {
                customError = 'emailTaken';
              } else if (message === 'Email is invalid') {
                customError = 'notValid';
              }
            }
            _this2.customError = customError;
          });
        }
        return valid;
      });
    }
  }
};

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ElForm",
    {
      ref: "registrationForm",
      staticClass: "auth-form register",
      attrs: {
        model: _vm.registrationForm,
        rules: _vm.rules,
        name: "register-form",
        "label-position": "top",
      },
      nativeOn: {
        submit: function ($event) {
          $event.preventDefault();
          return _vm.submitRegistration.apply(null, arguments)
        },
      },
    },
    [
      _c("AuthPageHeader", {
        attrs: { title: "Let’s get started by creating an account." },
      }),
      _vm._v(" "),
      _vm.showProjectInfo
        ? _c("p", [
            _c("span", { attrs: { id: "employer-info" } }, [
              _vm._v(
                "\n      When your " +
                  _vm._s(_vm.employerName) +
                  " proposal is underwritten, you’ll submit your quote here\n    "
              ),
            ]),
            _c("br"),
            _vm._v(" "),
            _c("span", { attrs: { id: "carrier-info" } }, [
              _c("strong", [_vm._v("Heads up:")]),
              _vm._v(" "),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.submittedCarriers) +
                  " out of " +
                  _vm._s(_vm.invitedCarriers) +
                  " carriers invited have submitted their quotes.\n    "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inputs-container" },
        [
          _c(
            "ElFormItem",
            {
              staticClass: "first-name-container",
              attrs: {
                for: "first-name-input",
                prop: "firstName",
                label: "First name",
                size: "medium",
                "data-test": "first name form item",
              },
            },
            [
              _c("ElInput", {
                attrs: {
                  name: "first-name-input",
                  "data-test": "edit first name",
                  placeholder: "Enter First Name",
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("setUserInfo", { first_name: $event })
                  },
                },
                model: {
                  value: _vm.registrationForm.firstName,
                  callback: function ($$v) {
                    _vm.$set(_vm.registrationForm, "firstName", $$v);
                  },
                  expression: "registrationForm.firstName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ElFormItem",
            {
              staticClass: "last-name-container",
              attrs: {
                for: "last-name-input",
                prop: "lastName",
                label: "Last name",
                size: "medium",
                "data-test": "last name form item",
              },
            },
            [
              _c("ElInput", {
                attrs: {
                  name: "last-name-input",
                  "data-test": "edit last name",
                  placeholder: "Enter Last Name",
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("setUserInfo", { last_name: $event })
                  },
                },
                model: {
                  value: _vm.registrationForm.lastName,
                  callback: function ($$v) {
                    _vm.$set(_vm.registrationForm, "lastName", $$v);
                  },
                  expression: "registrationForm.lastName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ElFormItem",
            {
              staticClass: "role-container",
              attrs: {
                prop: "role",
                label: "Role",
                "data-test": "role form item",
              },
            },
            [
              _c(
                "ElSelect",
                {
                  attrs: {
                    placeholder: "Select a Role",
                    name: "role input",
                    "data-test": "edit role",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$emit("setUserInfo", { role: $event })
                    },
                  },
                  model: {
                    value: _vm.registrationForm.role,
                    callback: function ($$v) {
                      _vm.$set(_vm.registrationForm, "role", $$v);
                    },
                    expression: "registrationForm.role",
                  },
                },
                _vm._l(_vm.roles, function (role) {
                  return _c("ElOption", {
                    key: role,
                    staticClass: "role-input-option",
                    attrs: {
                      "data-test": "select role",
                      label: role,
                      value: role,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ElFormItem",
            {
              staticClass: "email-container",
              class: { "is-error": _vm.customError },
              attrs: {
                for: "email-input",
                prop: "email",
                label: "Company email",
                size: "medium",
                "data-test": "email form item",
              },
            },
            [
              _c("ElInput", {
                attrs: {
                  name: "email-input",
                  placeholder: "Enter email",
                  "data-test": "edit email",
                },
                model: {
                  value: _vm.registrationForm.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.registrationForm, "email", $$v);
                  },
                  expression: "registrationForm.email",
                },
              }),
              _vm._v(" "),
              _vm.customError
                ? _c(
                    "div",
                    {
                      staticClass: "el-form-item__error",
                      attrs: { "data-test": "error " + _vm.customError },
                    },
                    [
                      _vm.customError === "emailTaken"
                        ? [
                            _vm._v(
                              "\n          Email has already been taken.\n          "
                            ),
                            _c("RouterLink", {
                              attrs: { to: _vm.linkForgot },
                              domProps: {
                                textContent: _vm._s("Reset your password"),
                              },
                            }),
                            _vm._v(".\n        "),
                          ]
                        : _vm.customError === "notValid"
                        ? [
                            _vm._v(
                              "\n          Your company domain isn’t in our system. Make sure you typed your email address correctly.\n        "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n          There was a problem processing your request.\n        "
                            ),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ElFormItem",
            {
              staticClass: "password-container",
              attrs: {
                for: "password-input",
                prop: "password",
                size: "medium",
              },
            },
            [
              _c("TfPasswordField", {
                attrs: {
                  label: "Create password",
                  "is-valid-password": _vm.isValidPassword,
                },
                on: {
                  "update:isValidPassword": function ($event) {
                    _vm.isValidPassword = $event;
                  },
                  "update:is-valid-password": function ($event) {
                    _vm.isValidPassword = $event;
                  },
                },
                model: {
                  value: _vm.registrationForm.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.registrationForm, "password", $$v);
                  },
                  expression: "registrationForm.password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _vm._t("ctaSubmit", function () {
                return [
                  _c("AppButton", {
                    attrs: {
                      "is-disabled": _vm.btnCreateDisabled,
                      name: "submit-button",
                      type: "primary",
                      "native-type": "submit",
                      text: "Create account",
                      "data-test": "submit account",
                      "no-branding": "",
                    },
                  }),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "links-container" },
            [
              _c(
                "RouterLink",
                { attrs: { tag: "li", to: _vm.linkLogin } },
                [
                  _c("AppButton", {
                    attrs: {
                      id: "link-account",
                      type: "primary",
                      size: "text",
                      text: "I already have an account.",
                      "data-test": "link account",
                      "no-branding": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AuthPageFooter"),
    ],
    1
  )
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;

  /* style */
  const __vue_inject_styles__$8 = undefined;
  /* scoped */
  const __vue_scope_id__$8 = undefined;
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$9 = {
  name: 'AppResendConfirmation',
  props: {
    documentId: {
      type: String,
      default: null
    },
    accountService: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    linkConfirmation: {
      type: [String, Object],
      required: true
    },
    linkLogin: {
      type: [String, Object],
      required: true
    },
    linkRegister: {
      type: [String, Object],
      required: true
    },
    projectId: {
      type: [String, Number],
      default: null
    },
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  /**
   * If the email address isn't passed, redirect to the linkLogin.
   */
  created: function created() {
    if (!this.userInfo.email) {
      this.$router.replace(this.$route.query.redirect || this.linkLogin);
    }
  },
  methods: {
    /**
     * call the AccountService to send a new confirmation email
     */
    resendConfirmation: function resendConfirmation() {
      var _this = this;
      if (!this.accountService.resendConfirmation) {
        return;
      }
      this.accountService.resendConfirmation({
        documentId: this.documentId,
        email: this.userInfo.email,
        projectId: this.projectId
      }).then(function () {
        var redirectURL = _this.$route.query.redirect || _this.linkConfirmation;
        _this.$router.replace(redirectURL);
      }).catch(function () {});
    }
  }
};

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    {
      staticClass: "auth-form",
      attrs: { id: "resend-confirmation-container" },
    },
    [
      _c("AuthPageHeader", {
        attrs: { title: "I didn’t receive the temporary password email." },
      }),
      _vm._v(" "),
      _c("ol", [
        _c(
          "li",
          [
            _vm._v(
              "\n      Is the " +
                _vm._s(_vm.userInfo.email) +
                " your correct email without typos? If not, you can\n      "
            ),
            _c("RouterLink", {
              attrs: { to: _vm.linkRegister },
              domProps: {
                textContent: _vm._s("restart the account creation process"),
              },
            }),
            _vm._v(".\n    "),
          ],
          1
        ),
        _vm._v(" "),
        _c("li", [_vm._v("Check your spam folder")]),
        _vm._v(" "),
        _c("li", [_vm._v("Add email@threeflow.com to your contacts")]),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.userInfo.email))]),
      _vm._v(" "),
      _c(
        "p",
        [
          _vm._t("ctaSubmit", function () {
            return [
              _c("AppButton", {
                attrs: { text: "Resend confirmation email", "no-branding": "" },
                on: { click: _vm.resendConfirmation },
              }),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("AuthPageFooter"),
    ],
    1
  )
};
var __vue_staticRenderFns__$9 = [
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("p", [_c("strong", [_vm._v("Or we can try again:")])])
  },
];
__vue_render__$9._withStripped = true;

  /* style */
  const __vue_inject_styles__$9 = function (inject) {
    if (!inject) return
    inject("data-v-9ac2c848_0", { source: ".auth-form[data-v-9ac2c848] {\n  max-width: 570px;\n  text-align: left;\n}\nol[data-v-9ac2c848] {\n  margin-bottom: 25px;\n  padding-left: 20px;\n  list-style: decimal;\n}\nli[data-v-9ac2c848] {\n  font-size: 14px;\n  line-height: 1.86;\n}\np[data-v-9ac2c848] {\n  margin: 0 0 15px;\n}\n\n/*# sourceMappingURL=AppResendConfirmation.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AuthPages/AppResendConfirmation.vue","AppResendConfirmation.vue"],"names":[],"mappings":"AAqGA;EACA,gBAAA;EACA,gBAAA;ACpGA;ADuGA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;ACpGA;ADuGA;EACA,eAAA;EACA,iBAAA;ACpGA;ADuGA;EACA,gBAAA;ACpGA;;AAEA,oDAAoD","file":"AppResendConfirmation.vue","sourcesContent":["<template>\n  <section\n    id=\"resend-confirmation-container\"\n    class=\"auth-form\"\n  >\n    <AuthPageHeader title=\"I didn’t receive the temporary password email.\" />\n    <ol>\n      <li>\n        Is the {{ userInfo.email }} your correct email without typos? If not, you can\n        <RouterLink\n          :to=\"linkRegister\"\n          v-text=\"'restart the account creation process'\"\n        />.\n      </li>\n      <li>Check your spam folder</li>\n      <li>Add email@threeflow.com to your contacts</li>\n    </ol>\n    <p><strong>Or we can try again:</strong></p>\n    <p>{{ userInfo.email }}</p>\n    <p>\n      <slot name=\"ctaSubmit\">\n        <AppButton\n          text=\"Resend confirmation email\"\n          no-branding\n          @click=\"resendConfirmation\"\n        />\n      </slot>\n    </p>\n    <AuthPageFooter />\n  </section>\n</template>\n\n<script>\n  export default {\n    name: 'AppResendConfirmation',\n    props: {\n      documentId: {\n        type: String,\n        default: null,\n      },\n      accountService: {\n        type: Object,\n        default: () => ({}),\n      },\n      linkConfirmation: {\n        type: [String, Object],\n        required: true,\n      },\n      linkLogin: {\n        type: [String, Object],\n        required: true,\n      },\n      linkRegister: {\n        type: [String, Object],\n        required: true,\n      },\n      projectId: {\n        type: [String, Number],\n        default: null,\n      },\n      userInfo: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n    /**\n     * If the email address isn't passed, redirect to the linkLogin.\n     */\n    created() {\n      if (!this.userInfo.email) {\n        this.$router.replace(this.$route.query.redirect || this.linkLogin);\n      }\n    },\n    methods: {\n      /**\n       * call the AccountService to send a new confirmation email\n       */\n      resendConfirmation() {\n        if (!this.accountService.resendConfirmation) {\n          return;\n        }\n\n        this\n          .accountService\n          .resendConfirmation({\n            documentId: this.documentId,\n            email: this.userInfo.email,\n            projectId: this.projectId,\n          })\n          .then(() => {\n            const redirectURL = this.$route.query.redirect || this.linkConfirmation;\n\n            this.$router.replace(redirectURL);\n          })\n          .catch(() => {});\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  .auth-form {\n    max-width: 570px;\n    text-align: left;\n  }\n\n  ol {\n    margin-bottom: 25px;\n    padding-left: 20px;\n    list-style: decimal;\n  }\n\n  li {\n    font-size: 14px;\n    line-height: 1.86;\n  }\n\n  p {\n    margin: 0 0 15px;\n  }\n</style>\n",".auth-form {\n  max-width: 570px;\n  text-align: left;\n}\n\nol {\n  margin-bottom: 25px;\n  padding-left: 20px;\n  list-style: decimal;\n}\n\nli {\n  font-size: 14px;\n  line-height: 1.86;\n}\n\np {\n  margin: 0 0 15px;\n}\n\n/*# sourceMappingURL=AppResendConfirmation.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$9 = "data-v-9ac2c848";
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$a = {
  name: 'AppResetPasswordForm',
  props: {
    accountService: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* Adding the following two props for completeness' sake (we are
       passing it as a :sync prop on the component when it is used);
       the value is not consumed by the component, but this way the
       fact that it IS to be passed as a :sync prop if the
       accountService isn't passed is documented. */
    password: {
      type: String,
      default: ''
    },
    isValidPassword: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      resetPasswordForm: {
        password: '',
        showPassword: false
      },
      rules: {
        password: [{
          required: true,
          message: 'Please choose a password.',
          trigger: 'none'
        }, {
          min: 6,
          message: 'Your password must be at least 6 characters.',
          trigger: 'none'
        }]
      },
      passwordType: 'password',
      submitting: false,
      isValid: false
    };
  },
  watch: {
    /**
     * Watch the "password" field to emit synced password values.
     *
     * @param {string} password
     */
    'resetPasswordForm.password': function resetPasswordFormPassword(password) {
      this.$emit('update:password', password);
    },
    /**
     * Watch the "isValid" value to emit validation state, so that it can be used by a slotted button.
     *
     * @param {boolean} isValid
     */
    isValid: function isValid(_isValid) {
      this.$emit('update:isValidPassword', _isValid);
    }
  },
  mounted: function mounted() {
    var _this = this;
    window.setTimeout(function () {
      _this.resetPasswordForm.password = '';
    }, 100);
  },
  methods: {
    /**
     * Validate the resetPasswordForm
     * Then call the accountService/changePassword method and emit an event if successful
     */
    submitResetPassword: function submitResetPassword() {
      var _this2 = this;
      this.$refs.resetPasswordForm.validate(function (valid) {
        if (!_this2.accountService.changePassword) {
          return valid;
        }
        _this2.submitting = true;
        if (valid) {
          var data = {
            password: _this2.resetPasswordForm.password
          };
          _this2.accountService.changePassword(data).then(function () {
            _this2.submitting = false;
            _this2.$emit('passwordUpdated');
          });
        } else {
          _this2.submitting = false;
        }
        return valid;
      });
    }
  }
};

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    { staticClass: "reset-password-container" },
    [
      _c("h4", [_vm._v("Please choose a new password for your account.")]),
      _vm._v(" "),
      _c(
        "ElForm",
        {
          ref: "resetPasswordForm",
          staticClass: "reset-password",
          attrs: {
            model: _vm.resetPasswordForm,
            rules: _vm.rules,
            "label-position": "top",
            "data-test": "reset password",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault();
              return _vm.submitResetPassword.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "ElFormItem",
            {
              staticClass: "password-container",
              attrs: {
                for: "password-input",
                prop: "password",
                size: "medium",
              },
            },
            [
              _c("TfPasswordField", {
                attrs: {
                  label: "New password",
                  "is-valid-password": _vm.isValid,
                  "data-test": "password reset",
                },
                on: {
                  "update:isValidPassword": function ($event) {
                    _vm.isValid = $event;
                  },
                  "update:is-valid-password": function ($event) {
                    _vm.isValid = $event;
                  },
                },
                model: {
                  value: _vm.resetPasswordForm.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.resetPasswordForm, "password", $$v);
                  },
                  expression: "resetPasswordForm.password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _vm._t("ctaSubmit", function () {
                return [
                  _c("AppButton", {
                    attrs: {
                      "is-disabled":
                        !_vm.resetPasswordForm.password ||
                        !_vm.isValid ||
                        _vm.submitting,
                      type: "primary",
                      "native-type": "submit",
                      text: "Update Password",
                      "no-branding": "",
                    },
                  }),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;

  /* style */
  const __vue_inject_styles__$a = function (inject) {
    if (!inject) return
    inject("data-v-0c6bd3e0_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.el-form-item[data-v-0c6bd3e0] {\n  margin-bottom: 5px;\n}\n.btn-group[data-v-0c6bd3e0] {\n  display: flex;\n  margin-top: 25px;\n}\n.el-input[data-v-0c6bd3e0] {\n  max-width: 300px;\n}\nh4[data-v-0c6bd3e0] {\n  margin-bottom: 20px;\n  font-weight: 400;\n  font-size: 16px;\n}\np[data-v-0c6bd3e0] {\n  margin-bottom: 5px;\n}\n\n/*# sourceMappingURL=AppResetPasswordForm.vue.map */", map: {"version":3,"sources":["AppResetPasswordForm.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AuthPages/AppResetPasswordForm.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACqIlC;EACA,kBAAA;ADnIA;ACsIA;EACA,aAAA;EACA,gBAAA;ADnIA;ACsIA;EACA,gBAAA;ADnIA;ACsIA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;ADnIA;ACsIA;EACA,kBAAA;ADnIA;;AAEA,mDAAmD","file":"AppResetPasswordForm.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.el-form-item {\n  margin-bottom: 5px;\n}\n\n.btn-group {\n  display: flex;\n  margin-top: 25px;\n}\n\n.el-input {\n  max-width: 300px;\n}\n\nh4 {\n  margin-bottom: 20px;\n  font-weight: 400;\n  font-size: 16px;\n}\n\np {\n  margin-bottom: 5px;\n}\n\n/*# sourceMappingURL=AppResetPasswordForm.vue.map */","<template>\n  <section class=\"reset-password-container\">\n    <h4>Please choose a new password for your&nbsp;account.</h4>\n    <ElForm\n      ref=\"resetPasswordForm\"\n      :model=\"resetPasswordForm\"\n      :rules=\"rules\"\n      label-position=\"top\"\n      class=\"reset-password\"\n      data-test=\"reset password\"\n      @submit.native.prevent=\"submitResetPassword\"\n    >\n      <ElFormItem\n        for=\"password-input\"\n        prop=\"password\"\n        class=\"password-container\"\n        size=\"medium\"\n      >\n        <TfPasswordField\n          v-model=\"resetPasswordForm.password\"\n          label=\"New password\"\n          :is-valid-password.sync=\"isValid\"\n          data-test=\"password reset\"\n        />\n      </ElFormItem>\n      <div class=\"btn-group\">\n        <slot name=\"ctaSubmit\">\n          <AppButton\n            :is-disabled=\"!resetPasswordForm.password || !isValid || submitting\"\n            type=\"primary\"\n            native-type=\"submit\"\n            text=\"Update Password\"\n            no-branding\n          />\n        </slot>\n      </div>\n    </ElForm>\n  </section>\n</template>\n\n<script>\n  export default {\n    name: 'AppResetPasswordForm',\n    props: {\n      accountService: {\n        type: Object,\n        default: () => ({}),\n      },\n      /* Adding the following two props for completeness' sake (we are\n         passing it as a :sync prop on the component when it is used);\n         the value is not consumed by the component, but this way the\n         fact that it IS to be passed as a :sync prop if the\n         accountService isn't passed is documented. */\n      password: {\n        type: String,\n        default: '',\n      },\n      isValidPassword: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: () => ({\n      resetPasswordForm: {\n        password: '',\n        showPassword: false,\n      },\n      rules: {\n        password: [\n          { required: true, message: 'Please choose a password.', trigger: 'none' },\n          { min: 6, message: 'Your password must be at least 6 characters.', trigger: 'none' },\n        ],\n      },\n      passwordType: 'password',\n      submitting: false,\n      isValid: false,\n    }),\n    watch: {\n      /**\n       * Watch the \"password\" field to emit synced password values.\n       *\n       * @param {string} password\n       */\n      'resetPasswordForm.password': function (password) {\n        this.$emit('update:password', password);\n      },\n      /**\n       * Watch the \"isValid\" value to emit validation state, so that it can be used by a slotted button.\n       *\n       * @param {boolean} isValid\n       */\n      isValid(isValid) {\n        this.$emit('update:isValidPassword', isValid);\n      },\n    },\n    mounted() {\n      window.setTimeout(() => {\n        this.resetPasswordForm.password = '';\n      }, 100);\n    },\n    methods: {\n      /**\n       * Validate the resetPasswordForm\n       * Then call the accountService/changePassword method and emit an event if successful\n       */\n      submitResetPassword() {\n        this.$refs.resetPasswordForm.validate((valid) => {\n          if (!this.accountService.changePassword) {\n            return valid;\n          }\n\n          this.submitting = true;\n\n          if (valid) {\n            const data = {\n              password: this.resetPasswordForm.password,\n            };\n            this.accountService.changePassword(data).then(() => {\n              this.submitting = false;\n              this.$emit('passwordUpdated');\n            });\n          } else {\n            this.submitting = false;\n          }\n\n          return valid;\n        });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/mixins';\n\n  .el-form-item {\n    margin-bottom: 5px;\n  }\n\n  .btn-group {\n    display: flex;\n    margin-top: 25px;\n  }\n\n  .el-input {\n    max-width: 300px;\n  }\n\n  h4 {\n    margin-bottom: 20px;\n    font-weight: 400;\n    font-size: 16px;\n  }\n\n  p {\n    margin-bottom: 5px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$a = "data-v-0c6bd3e0";
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$a = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Shared sign in component with functionality to slot in secondary sign-in methods.
 *
 * @exports AppSignIn
 * @category Components
 */
var script$b = {
  name: 'AppSignIn',
  props: {
    /**
     * URL for the forgot password link
     */
    linkForgot: {
      type: [String, Object],
      default: ''
    },
    /**
     * URL for the account registration link
     */
    linkRegister: {
      type: [String, Object],
      default: ''
    },
    /**
     * URL for the terms & conditions link
     */
    linkTerms: {
      type: [String, Object],
      default: ''
    },
    /**
     * userInfo object from a store to show current email (if needed)
     */
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /**
     * Determine whether or not to hide the password field and show the SSO method slot
     */
    showSsoMethod: {
      type: Boolean,
      default: false
    },
    /**
     * Determine if email field is hidden or not (this is used for use cases where the SSO method is the only sign in method allowed.)
     */
    hideEmail: {
      type: Boolean,
      default: false
    }
  },
  data: function data(vm) {
    return {
      autofilledPassword: false,
      signInForm: {
        email: '',
        password: '',
        rememberMe: false,
        showPassword: false
      },
      rules: {
        email: [{
          required: true,
          type: 'email',
          message: 'Please enter your company email.',
          trigger: 'blur'
        }, {
          validator: vm.clearError,
          trigger: 'change'
        }],
        password: [{
          required: true,
          message: 'Please input your password.',
          trigger: 'none'
        }]
      }
    };
  },
  computed: {
    /**
     * If the user has provided both their email and password
     *
     * @returns {boolean}
     */
    validFields: function validFields() {
      return Boolean(this.signInForm.email && this.signInForm.password);
    }
  },
  watch: {
    /**
     * Watching to see if we need show the inactivity message
     *
     * @param {boolean} inactivity
     */
    /**
     * Watch the "email" field to emit synced values,
     *
     * @param {string} email
     */
    'signInForm.email': function signInFormEmail(email) {
      this.$emit('update:email', email);
    },
    /**
     * Watch the "password" field to emit synced values,
     *
     * @param {string} password
     */
    'signInForm.password': function signInFormPassword(password) {
      this.$emit('update:password', password);
    },
    /**
     * Watch the "remember me" checkbox to emit synced values.
     *
     * @param {string} value
     */
    'signInForm.rememberMe': function signInFormRememberMe(value) {
      this.$emit('update:rememberMe', value);
    }
  },
  created: function created() {
    var _this$$route$query = this.$route.query,
      email = _this$$route$query.email,
      pw = _this$$route$query.pw;
    if (email && pw) {
      this.signInForm.email = email;
      this.signInForm.password = pw;
      this.signInForm.showPassword = true;
      return;
    }

    // We want the email address to persist across all sign in/forgotPW/registration forms
    this.signInForm.email = this.userInfo.email;
    var savedEmail = window.localStorage.getItem('email');
    if (savedEmail) {
      this.signInForm.rememberMe = true;
    }
    // if we don't have an email already check if we "remembered one"
    if (!this.signInForm.email && savedEmail) {
      this.signInForm.email = savedEmail;
    }
  },
  methods: {
    /**
     * there is a chrome bug that doesn't fire a change event when a field is auto filled
     * we can however check the animation change from being auto filled
     * however we still can't access the value of the password field
     * but since we know it was autofilled lets just enable the button
     *
     * @param {event} e
     */
    checkAnimation: function checkAnimation(e) {
      if (e.animationName === 'onAutoFillStart') {
        this.autofilledPassword = true;
      }
    },
    /* eslint-disable-next-line jsdoc/require-param */
    /**
     * Clear out any displayed errors
     */
    clearError: function clearError(rule, value, callback) {
      callback();
    }
  }
};

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ElForm",
    {
      ref: "signInForm",
      staticClass: "auth-form sign-in",
      attrs: {
        model: _vm.signInForm,
        rules: _vm.rules,
        name: "auth-form",
        "label-position": "top",
        "data-test": "sign-in form",
      },
      nativeOn: {
        submit: function ($event) {
          $event.preventDefault();
        },
      },
    },
    [
      _c("AuthPageHeader", { attrs: { title: "Sign In to ThreeFlow" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inputs-container" },
        [
          !_vm.hideEmail
            ? _c(
                "ElFormItem",
                {
                  staticClass: "email-container",
                  attrs: {
                    for: "app-sign-in-email",
                    prop: "email",
                    label: "Company email",
                    size: "medium",
                  },
                },
                [
                  _c("ElInput", {
                    attrs: {
                      id: "app-sign-in-email",
                      "data-test": "edit sign in email",
                      name: "email-input",
                      placeholder: "Enter email",
                    },
                    nativeOn: {
                      keydown: function ($event) {
                        _vm.autofilledPassword = false;
                      },
                    },
                    model: {
                      value: _vm.signInForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.signInForm, "email", $$v);
                      },
                      expression: "signInForm.email",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.showSsoMethod
            ? [
                _c(
                  "ElFormItem",
                  {
                    staticClass: "password-container",
                    attrs: {
                      for: "app-sign-in-password",
                      prop: "password",
                      label: "Password",
                      size: "medium",
                    },
                  },
                  [
                    _c(
                      "ElInput",
                      {
                        attrs: {
                          id: "app-sign-in-password",
                          "data-test": "edit sign in password",
                          type: _vm.signInForm.showPassword
                            ? "text"
                            : "password",
                          name: "password-input",
                          placeholder: "Enter password",
                        },
                        nativeOn: {
                          animationstart: function ($event) {
                            return _vm.checkAnimation($event)
                          },
                          keydown: function ($event) {
                            _vm.autofilledPassword = false;
                          },
                        },
                        model: {
                          value: _vm.signInForm.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.signInForm, "password", $$v);
                          },
                          expression: "signInForm.password",
                        },
                      },
                      [
                        _c("AppButton", {
                          staticClass: "toggle-password",
                          attrs: {
                            slot: "append",
                            icon: "fa-solid fa-eye",
                            size: "icon-small",
                            "no-branding": "",
                            "data-test":
                              (_vm.signInForm.showPassword ? "hide" : "show") +
                              " password",
                          },
                          on: {
                            click: function ($event) {
                              _vm.signInForm.showPassword =
                                !_vm.signInForm.showPassword;
                            },
                          },
                          slot: "append",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "remember-me" },
                  [
                    _c("TfCheckbox", {
                      attrs: {
                        name: "remember-user",
                        label: "Remember me",
                        "data-test": "toggle remember me",
                      },
                      model: {
                        value: _vm.signInForm.rememberMe,
                        callback: function ($$v) {
                          _vm.$set(_vm.signInForm, "rememberMe", $$v);
                        },
                        expression: "signInForm.rememberMe",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._t("ctaSubmit", function () {
                  return [
                    _c("AppButton", {
                      attrs: {
                        "is-disabled":
                          !_vm.validFields && !_vm.autofilledPassword,
                        "data-test": "submit sign in",
                        name: "submit-button",
                        type: "primary",
                        "native-type": "submit",
                        text: "Sign in",
                        "no-branding": "",
                        "is-block": "",
                      },
                    }),
                  ]
                }),
                _vm._v(" "),
                _vm.linkTerms
                  ? _c(
                      "p",
                      { staticClass: "terms-of-use" },
                      [
                        _vm._v(
                          "\n        By signing in, you agree to\n        "
                        ),
                        _c("RouterLink", {
                          attrs: {
                            to: _vm.linkTerms,
                            target: "_blank",
                            "data-test": "to terms of use",
                          },
                          domProps: { textContent: _vm._s("Terms of use") },
                        }),
                        _vm._v(".\n      "),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.linkForgot
                  ? _c(
                      "RouterLink",
                      { attrs: { to: _vm.linkForgot } },
                      [
                        _c("AppButton", {
                          attrs: {
                            id: "link-forgot-password",
                            type: "secondary",
                            "data-test": "to forgot password form",
                            text: "Forgot password?",
                            "no-branding": "",
                            "is-block": "",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.linkRegister
                  ? _c(
                      "RouterLink",
                      { attrs: { to: _vm.linkRegister } },
                      [
                        _c("AppButton", {
                          attrs: {
                            type: "secondary",
                            "data-test": "to create account form",
                            text: "Create an account",
                            "no-branding": "",
                            "is-block": "",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showSsoMethod && _vm.$slots.ctaSsoSubmit
            ? _c("div", [_vm._t("ctaSsoSubmit")], 2)
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("AuthPageFooter"),
    ],
    1
  )
};
var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;

  /* style */
  const __vue_inject_styles__$b = function (inject) {
    if (!inject) return
    inject("data-v-0de5a4fe_0", { source: ".auth-form .el-form-item[data-v-0de5a4fe] {\n  margin-bottom: 16px;\n}\n#link-forgot-password[data-v-0de5a4fe] {\n  margin-bottom: 30px;\n}\n.remember-me[data-v-0de5a4fe] {\n  display: flex;\n  margin: 8px 0 24px;\n}\n.terms-of-use[data-v-0de5a4fe] {\n  margin: 24px 0;\n}\n.toggle-password[data-v-0de5a4fe] {\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n}\n\n/*# sourceMappingURL=AppSignIn.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AuthPages/AppSignIn.vue","AppSignIn.vue"],"names":[],"mappings":"AAmTA;EACA,mBAAA;AClTA;ADsTA;EACA,mBAAA;ACnTA;ADsTA;EACA,aAAA;EACA,kBAAA;ACnTA;ADsTA;EACA,cAAA;ACnTA;ADsTA;EAEA,2BAAA;EACA,8BAAA;ACpTA;;AAEA,wCAAwC","file":"AppSignIn.vue","sourcesContent":["<template>\n  <ElForm\n    ref=\"signInForm\"\n    :model=\"signInForm\"\n    :rules=\"rules\"\n    name=\"auth-form\"\n    label-position=\"top\"\n    class=\"auth-form sign-in\"\n    data-test=\"sign-in form\"\n    @submit.native.prevent\n  >\n    <AuthPageHeader title=\"Sign In to ThreeFlow\" />\n    <div class=\"inputs-container\">\n      <ElFormItem\n        v-if=\"!hideEmail\"\n        for=\"app-sign-in-email\"\n        prop=\"email\"\n        class=\"email-container\"\n        label=\"Company email\"\n        size=\"medium\"\n      >\n        <!-- Changing `autofilledPassword` for both inputs is required for disabling the button -->\n        <ElInput\n          id=\"app-sign-in-email\"\n          v-model=\"signInForm.email\"\n          data-test=\"edit sign in email\"\n          name=\"email-input\"\n          placeholder=\"Enter email\"\n          @keydown.native=\"autofilledPassword = false\"\n        />\n      </ElFormItem>\n      <template v-if=\"!showSsoMethod\">\n        <ElFormItem\n          for=\"app-sign-in-password\"\n          prop=\"password\"\n          class=\"password-container\"\n          label=\"Password\"\n          size=\"medium\"\n        >\n          <ElInput\n            id=\"app-sign-in-password\"\n            v-model=\"signInForm.password\"\n            data-test=\"edit sign in password\"\n            :type=\"signInForm.showPassword ? 'text' : 'password'\"\n            name=\"password-input\"\n            placeholder=\"Enter password\"\n            @animationstart.native=\"checkAnimation($event)\"\n            @keydown.native=\"autofilledPassword = false\"\n          >\n            <AppButton\n              slot=\"append\"\n              icon=\"fa-solid fa-eye\"\n              size=\"icon-small\"\n              class=\"toggle-password\"\n              no-branding\n              :data-test=\"`${signInForm.showPassword ? 'hide' : 'show'} password`\"\n              @click=\"signInForm.showPassword = !signInForm.showPassword\"\n            />\n          </ElInput>\n        </ElFormItem>\n        <!-- Checkbox row -->\n        <div class=\"remember-me\">\n          <TfCheckbox\n            v-model=\"signInForm.rememberMe\"\n            name=\"remember-user\"\n            label=\"Remember me\"\n            data-test=\"toggle remember me\"\n          />\n        </div>\n        <!-- Submit Btn -->\n        <slot name=\"ctaSubmit\">\n          <AppButton\n            :is-disabled=\"!validFields && !autofilledPassword\"\n            data-test=\"submit sign in\"\n            name=\"submit-button\"\n            type=\"primary\"\n            native-type=\"submit\"\n            text=\"Sign in\"\n            no-branding\n            is-block\n          />\n        </slot>\n        <!-- terms -->\n        <p\n          v-if=\"linkTerms\"\n          class=\"terms-of-use\"\n        >\n          By signing in, you agree to\n          <RouterLink\n            :to=\"linkTerms\"\n            target=\"_blank\"\n            data-test=\"to terms of use\"\n            v-text=\"'Terms of use'\"\n          />.\n        </p>\n        <!-- Extra CTAs -->\n        <RouterLink\n          v-if=\"linkForgot\"\n          :to=\"linkForgot\"\n        >\n          <AppButton\n            id=\"link-forgot-password\"\n            type=\"secondary\"\n            data-test=\"to forgot password form\"\n            text=\"Forgot password?\"\n            no-branding\n            is-block\n          />\n        </RouterLink>\n        <RouterLink\n          v-if=\"linkRegister\"\n          :to=\"linkRegister\"\n        >\n          <AppButton\n            type=\"secondary\"\n            data-test=\"to create account form\"\n            text=\"Create an account\"\n            no-branding\n            is-block\n          />\n        </RouterLink>\n      </template>\n      <div\n        v-if=\"showSsoMethod && $slots.ctaSsoSubmit\"\n      >\n        <slot name=\"ctaSsoSubmit\" />\n      </div>\n    </div>\n    <AuthPageFooter />\n  </ElForm>\n</template>\n\n<script>\n  /**\n   * Shared sign in component with functionality to slot in secondary sign-in methods.\n   *\n   * @exports AppSignIn\n   * @category Components\n   */\n  export default {\n    name: 'AppSignIn',\n    props: {\n      /**\n       * URL for the forgot password link\n       */\n      linkForgot: {\n        type: [String, Object],\n        default: '',\n      },\n      /**\n       * URL for the account registration link\n       */\n      linkRegister: {\n        type: [String, Object],\n        default: '',\n      },\n      /**\n       * URL for the terms & conditions link\n       */\n      linkTerms: {\n        type: [String, Object],\n        default: '',\n      },\n      /**\n       * userInfo object from a store to show current email (if needed)\n       */\n      userInfo: {\n        type: Object,\n        default: () => ({}),\n      },\n      /**\n       * Determine whether or not to hide the password field and show the SSO method slot\n       */\n      showSsoMethod: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Determine if email field is hidden or not (this is used for use cases where the SSO method is the only sign in method allowed.)\n       */\n      hideEmail: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: (vm) => ({\n      autofilledPassword: false,\n      signInForm: {\n        email: '',\n        password: '',\n        rememberMe: false,\n        showPassword: false,\n      },\n      rules: {\n        email: [\n          {\n            required: true,\n            type: 'email',\n            message: 'Please enter your company email.',\n            trigger: 'blur',\n          },\n          {\n            validator: vm.clearError,\n            trigger: 'change',\n          },\n        ],\n        password: [\n          {\n            required: true,\n            message: 'Please input your password.',\n            trigger: 'none',\n          },\n        ],\n      },\n    }),\n    computed: {\n      /**\n       * If the user has provided both their email and password\n       *\n       * @returns {boolean}\n       */\n      validFields() {\n        return Boolean(this.signInForm.email && this.signInForm.password);\n      },\n    },\n    watch: {\n      /**\n       * Watching to see if we need show the inactivity message\n       *\n       * @param {boolean} inactivity\n       */\n      /**\n       * Watch the \"email\" field to emit synced values,\n       *\n       * @param {string} email\n       */\n      'signInForm.email': function (email) {\n        this.$emit('update:email', email);\n      },\n      /**\n       * Watch the \"password\" field to emit synced values,\n       *\n       * @param {string} password\n       */\n      'signInForm.password': function (password) {\n        this.$emit('update:password', password);\n      },\n      /**\n       * Watch the \"remember me\" checkbox to emit synced values.\n       *\n       * @param {string} value\n       */\n      'signInForm.rememberMe': function (value) {\n        this.$emit('update:rememberMe', value);\n      },\n    },\n    created() {\n      const { email, pw } = this.$route.query;\n\n      if (email && pw) {\n        this.signInForm.email = email;\n        this.signInForm.password = pw;\n        this.signInForm.showPassword = true;\n\n        return;\n      }\n\n      // We want the email address to persist across all sign in/forgotPW/registration forms\n      this.signInForm.email = this.userInfo.email;\n      const savedEmail = window.localStorage.getItem('email');\n\n      if (savedEmail) {\n        this.signInForm.rememberMe = true;\n      }\n      // if we don't have an email already check if we \"remembered one\"\n      if (!this.signInForm.email && savedEmail) {\n        this.signInForm.email = savedEmail;\n      }\n    },\n    methods: {\n      /**\n       * there is a chrome bug that doesn't fire a change event when a field is auto filled\n       * we can however check the animation change from being auto filled\n       * however we still can't access the value of the password field\n       * but since we know it was autofilled lets just enable the button\n       *\n       * @param {event} e\n       */\n      checkAnimation(e) {\n        if (e.animationName === 'onAutoFillStart') {\n          this.autofilledPassword = true;\n        }\n      },\n\n      /* eslint-disable-next-line jsdoc/require-param */\n      /**\n       * Clear out any displayed errors\n       */\n      clearError(rule, value, callback) {\n        callback();\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .auth-form {\n    .el-form-item {\n      margin-bottom: 16px;\n    }\n  }\n\n  #link-forgot-password {\n    margin-bottom: 30px;\n  }\n\n  .remember-me {\n    display: flex;\n    margin: 8px 0 24px;\n  }\n\n  .terms-of-use {\n    margin: 24px 0;\n  }\n\n  .toggle-password {\n    padding: {\n      top: 5px !important; // stylelint-disable-line\n      bottom: 5px !important; // stylelint-disable-line\n    }\n  }\n</style>\n\n<style>\n  .forgot-pw-message {\n    max-width: 690px;\n  }\n\n  :-webkit-autofill {\n    animation-name: onAutoFillStart;\n  }\n\n  :not(:-webkit-autofill) {\n    animation-name: onAutoFillCancel;\n  }\n\n  /* stylelint-disable block-no-empty  */\n  @keyframes onAutoFillStart {\n  }\n  @keyframes onAutoFillCancel {\n  }\n  /* stylelint-enable block-no-empty  */\n</style>\n",".auth-form .el-form-item {\n  margin-bottom: 16px;\n}\n\n#link-forgot-password {\n  margin-bottom: 30px;\n}\n\n.remember-me {\n  display: flex;\n  margin: 8px 0 24px;\n}\n\n.terms-of-use {\n  margin: 24px 0;\n}\n\n.toggle-password {\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n}\n\n/*# sourceMappingURL=AppSignIn.vue.map */"]}, media: undefined })
,inject("data-v-0de5a4fe_1", { source: "\n.forgot-pw-message {\n  max-width: 690px;\n}\n:-webkit-autofill {\n  animation-name: onAutoFillStart;\n}\n:not(:-webkit-autofill) {\n  animation-name: onAutoFillCancel;\n}\n\n/* stylelint-disable block-no-empty  */\n@keyframes onAutoFillStart {\n}\n@keyframes onAutoFillCancel {\n}\n/* stylelint-enable block-no-empty  */\n", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AuthPages/AppSignIn.vue"],"names":[],"mappings":";AA8UA;EACA,gBAAA;AACA;AAEA;EACA,+BAAA;AACA;AAEA;EACA,gCAAA;AACA;;AAEA,sCAAA;AACA;AACA;AACA;AACA;AACA,qCAAA","file":"AppSignIn.vue","sourcesContent":["<template>\n  <ElForm\n    ref=\"signInForm\"\n    :model=\"signInForm\"\n    :rules=\"rules\"\n    name=\"auth-form\"\n    label-position=\"top\"\n    class=\"auth-form sign-in\"\n    data-test=\"sign-in form\"\n    @submit.native.prevent\n  >\n    <AuthPageHeader title=\"Sign In to ThreeFlow\" />\n    <div class=\"inputs-container\">\n      <ElFormItem\n        v-if=\"!hideEmail\"\n        for=\"app-sign-in-email\"\n        prop=\"email\"\n        class=\"email-container\"\n        label=\"Company email\"\n        size=\"medium\"\n      >\n        <!-- Changing `autofilledPassword` for both inputs is required for disabling the button -->\n        <ElInput\n          id=\"app-sign-in-email\"\n          v-model=\"signInForm.email\"\n          data-test=\"edit sign in email\"\n          name=\"email-input\"\n          placeholder=\"Enter email\"\n          @keydown.native=\"autofilledPassword = false\"\n        />\n      </ElFormItem>\n      <template v-if=\"!showSsoMethod\">\n        <ElFormItem\n          for=\"app-sign-in-password\"\n          prop=\"password\"\n          class=\"password-container\"\n          label=\"Password\"\n          size=\"medium\"\n        >\n          <ElInput\n            id=\"app-sign-in-password\"\n            v-model=\"signInForm.password\"\n            data-test=\"edit sign in password\"\n            :type=\"signInForm.showPassword ? 'text' : 'password'\"\n            name=\"password-input\"\n            placeholder=\"Enter password\"\n            @animationstart.native=\"checkAnimation($event)\"\n            @keydown.native=\"autofilledPassword = false\"\n          >\n            <AppButton\n              slot=\"append\"\n              icon=\"fa-solid fa-eye\"\n              size=\"icon-small\"\n              class=\"toggle-password\"\n              no-branding\n              :data-test=\"`${signInForm.showPassword ? 'hide' : 'show'} password`\"\n              @click=\"signInForm.showPassword = !signInForm.showPassword\"\n            />\n          </ElInput>\n        </ElFormItem>\n        <!-- Checkbox row -->\n        <div class=\"remember-me\">\n          <TfCheckbox\n            v-model=\"signInForm.rememberMe\"\n            name=\"remember-user\"\n            label=\"Remember me\"\n            data-test=\"toggle remember me\"\n          />\n        </div>\n        <!-- Submit Btn -->\n        <slot name=\"ctaSubmit\">\n          <AppButton\n            :is-disabled=\"!validFields && !autofilledPassword\"\n            data-test=\"submit sign in\"\n            name=\"submit-button\"\n            type=\"primary\"\n            native-type=\"submit\"\n            text=\"Sign in\"\n            no-branding\n            is-block\n          />\n        </slot>\n        <!-- terms -->\n        <p\n          v-if=\"linkTerms\"\n          class=\"terms-of-use\"\n        >\n          By signing in, you agree to\n          <RouterLink\n            :to=\"linkTerms\"\n            target=\"_blank\"\n            data-test=\"to terms of use\"\n            v-text=\"'Terms of use'\"\n          />.\n        </p>\n        <!-- Extra CTAs -->\n        <RouterLink\n          v-if=\"linkForgot\"\n          :to=\"linkForgot\"\n        >\n          <AppButton\n            id=\"link-forgot-password\"\n            type=\"secondary\"\n            data-test=\"to forgot password form\"\n            text=\"Forgot password?\"\n            no-branding\n            is-block\n          />\n        </RouterLink>\n        <RouterLink\n          v-if=\"linkRegister\"\n          :to=\"linkRegister\"\n        >\n          <AppButton\n            type=\"secondary\"\n            data-test=\"to create account form\"\n            text=\"Create an account\"\n            no-branding\n            is-block\n          />\n        </RouterLink>\n      </template>\n      <div\n        v-if=\"showSsoMethod && $slots.ctaSsoSubmit\"\n      >\n        <slot name=\"ctaSsoSubmit\" />\n      </div>\n    </div>\n    <AuthPageFooter />\n  </ElForm>\n</template>\n\n<script>\n  /**\n   * Shared sign in component with functionality to slot in secondary sign-in methods.\n   *\n   * @exports AppSignIn\n   * @category Components\n   */\n  export default {\n    name: 'AppSignIn',\n    props: {\n      /**\n       * URL for the forgot password link\n       */\n      linkForgot: {\n        type: [String, Object],\n        default: '',\n      },\n      /**\n       * URL for the account registration link\n       */\n      linkRegister: {\n        type: [String, Object],\n        default: '',\n      },\n      /**\n       * URL for the terms & conditions link\n       */\n      linkTerms: {\n        type: [String, Object],\n        default: '',\n      },\n      /**\n       * userInfo object from a store to show current email (if needed)\n       */\n      userInfo: {\n        type: Object,\n        default: () => ({}),\n      },\n      /**\n       * Determine whether or not to hide the password field and show the SSO method slot\n       */\n      showSsoMethod: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Determine if email field is hidden or not (this is used for use cases where the SSO method is the only sign in method allowed.)\n       */\n      hideEmail: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: (vm) => ({\n      autofilledPassword: false,\n      signInForm: {\n        email: '',\n        password: '',\n        rememberMe: false,\n        showPassword: false,\n      },\n      rules: {\n        email: [\n          {\n            required: true,\n            type: 'email',\n            message: 'Please enter your company email.',\n            trigger: 'blur',\n          },\n          {\n            validator: vm.clearError,\n            trigger: 'change',\n          },\n        ],\n        password: [\n          {\n            required: true,\n            message: 'Please input your password.',\n            trigger: 'none',\n          },\n        ],\n      },\n    }),\n    computed: {\n      /**\n       * If the user has provided both their email and password\n       *\n       * @returns {boolean}\n       */\n      validFields() {\n        return Boolean(this.signInForm.email && this.signInForm.password);\n      },\n    },\n    watch: {\n      /**\n       * Watching to see if we need show the inactivity message\n       *\n       * @param {boolean} inactivity\n       */\n      /**\n       * Watch the \"email\" field to emit synced values,\n       *\n       * @param {string} email\n       */\n      'signInForm.email': function (email) {\n        this.$emit('update:email', email);\n      },\n      /**\n       * Watch the \"password\" field to emit synced values,\n       *\n       * @param {string} password\n       */\n      'signInForm.password': function (password) {\n        this.$emit('update:password', password);\n      },\n      /**\n       * Watch the \"remember me\" checkbox to emit synced values.\n       *\n       * @param {string} value\n       */\n      'signInForm.rememberMe': function (value) {\n        this.$emit('update:rememberMe', value);\n      },\n    },\n    created() {\n      const { email, pw } = this.$route.query;\n\n      if (email && pw) {\n        this.signInForm.email = email;\n        this.signInForm.password = pw;\n        this.signInForm.showPassword = true;\n\n        return;\n      }\n\n      // We want the email address to persist across all sign in/forgotPW/registration forms\n      this.signInForm.email = this.userInfo.email;\n      const savedEmail = window.localStorage.getItem('email');\n\n      if (savedEmail) {\n        this.signInForm.rememberMe = true;\n      }\n      // if we don't have an email already check if we \"remembered one\"\n      if (!this.signInForm.email && savedEmail) {\n        this.signInForm.email = savedEmail;\n      }\n    },\n    methods: {\n      /**\n       * there is a chrome bug that doesn't fire a change event when a field is auto filled\n       * we can however check the animation change from being auto filled\n       * however we still can't access the value of the password field\n       * but since we know it was autofilled lets just enable the button\n       *\n       * @param {event} e\n       */\n      checkAnimation(e) {\n        if (e.animationName === 'onAutoFillStart') {\n          this.autofilledPassword = true;\n        }\n      },\n\n      /* eslint-disable-next-line jsdoc/require-param */\n      /**\n       * Clear out any displayed errors\n       */\n      clearError(rule, value, callback) {\n        callback();\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .auth-form {\n    .el-form-item {\n      margin-bottom: 16px;\n    }\n  }\n\n  #link-forgot-password {\n    margin-bottom: 30px;\n  }\n\n  .remember-me {\n    display: flex;\n    margin: 8px 0 24px;\n  }\n\n  .terms-of-use {\n    margin: 24px 0;\n  }\n\n  .toggle-password {\n    padding: {\n      top: 5px !important; // stylelint-disable-line\n      bottom: 5px !important; // stylelint-disable-line\n    }\n  }\n</style>\n\n<style>\n  .forgot-pw-message {\n    max-width: 690px;\n  }\n\n  :-webkit-autofill {\n    animation-name: onAutoFillStart;\n  }\n\n  :not(:-webkit-autofill) {\n    animation-name: onAutoFillCancel;\n  }\n\n  /* stylelint-disable block-no-empty  */\n  @keyframes onAutoFillStart {\n  }\n  @keyframes onAutoFillCancel {\n  }\n  /* stylelint-enable block-no-empty  */\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$b = "data-v-0de5a4fe";
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$b = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    browser,
    undefined,
    undefined
  );

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

// utils is a library of generic helper functions non-specific to axios

var toString$1 = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString$1.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction$1(val) {
  return toString$1.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction$1(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString$1.call(thing) === pattern ||
    (isFunction$1(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim$1(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

var utils$1 = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction$1,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim$1,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$1.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$1.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$1.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$1.forEach(val, function parseValue(v) {
        if (utils$1.isDate(v)) {
          v = v.toISOString();
        } else if (utils$1.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils$1.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils$1.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils$1.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

var AxiosError_1 = AxiosError;

var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils$1.isDate(value)) {
      return value.toISOString();
    }

    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils$1.isPlainObject(data) || utils$1.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils$1.forEach(data, function each(value, key) {
        if (utils$1.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils$1.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils$1.endsWith(key, '[]') && (arr = utils$1.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils$1.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

var toFormData_1 = toFormData;

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError_1(
      'Request failed with status code ' + response.status,
      [AxiosError_1.ERR_BAD_REQUEST, AxiosError_1.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};

var cookies = (
  utils$1.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$1.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$1.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$1.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$1.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$1.trim(line.substr(0, i)).toLowerCase();
    val = utils$1.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var isURLSameOrigin = (
  utils$1.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$1.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError_1.call(this, message == null ? 'canceled' : message, AxiosError_1.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils$1.inherits(CanceledError, AxiosError_1, {
  __CANCEL__: true
});

var CanceledError_1 = CanceledError;

var parseProtocol = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils$1.isFormData(requestData) && utils$1.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError_1('Request aborted', AxiosError_1.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError_1('Network Error', AxiosError_1.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional$1 = config.transitional || transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError_1(
        timeoutErrorMessage,
        transitional$1.clarifyTimeoutError ? AxiosError_1.ETIMEDOUT : AxiosError_1.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$1.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError_1() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError_1('Unsupported protocol ' + protocol + ':', AxiosError_1.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};

// eslint-disable-next-line strict
var _null = null;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$1.isUndefined(headers) && utils$1.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitional,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$1.isFormData(data) ||
      utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils$1.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils$1.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData_1(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$1.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError_1.from(e, AxiosError_1.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: _null
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils$1.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils$1.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData = function transformData(data, headers, fns) {
  var context = this || defaults_1;
  /*eslint no-param-reassign:0*/
  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError_1();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$1.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$1.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults_1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge(target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$1.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils$1.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils$1.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils$1.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};

var data = {
  "version": "0.27.2"
};

var VERSION = data.version;


var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError_1(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError_1.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError_1('options must be an object', AxiosError_1.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError_1('option ' + opt + ' must be ' + result, AxiosError_1.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError_1('Unknown option ' + opt, AxiosError_1.ERR_BAD_OPTION);
    }
  }
}

var validator = {
  assertOptions: assertOptions,
  validators: validators
};

var validators$1 = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators$1.transitional(validators$1.boolean),
      forcedJSONParsing: validators$1.transitional(validators$1.boolean),
      clarifyTimeoutError: validators$1.transitional(validators$1.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

var Axios_1 = Axios;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError_1(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
};

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios_1.prototype, context);

  // Copy context to instance
  utils$1.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults_1);

// Expose Axios class to allow class inheritance
axios.Axios = Axios_1;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError_1;
axios.CancelToken = CancelToken_1;
axios.isCancel = isCancel;
axios.VERSION = data.version;
axios.toFormData = toFormData_1;

// Expose AxiosError class
axios.AxiosError = AxiosError_1;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

var axios_1 = axios;

// Allow use of default import syntax in TypeScript
var default_1 = axios;
axios_1.default = default_1;

var axios$1 = axios_1;

//

/**
 * Terms of Use
 *
 * @vuedoc
 * @exports AppTermsOfUse
 * @category Components
 */
var script$c = {
  name: 'AppTermsOfUse',
  props: {
    termsId: {
      type: String,
      default: '11825817'
    }
  },
  data: function data() {
    return {
      hasError: false,
      isLoading: true,
      termsOfUseContent: ''
    };
  },
  // On create we hit the iubenda api and grab the terms from there.
  // We can pass in an id incase we need different calls for different sites.
  created: function created() {
    var _this = this;
    axios$1.get("https://www.iubenda.com/api/terms-and-conditions/".concat(this.termsId)).then(function (response) {
      _this.termsOfUseContent = response.data.content;
      _this.isLoading = false;
    }).catch(function () {
      _this.isLoading = false;
      _this.hasError = true;
    });
  }
};

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading",
        },
      ],
      staticClass: "terms-container",
      class: { "has-error": _vm.hasError },
    },
    [
      _vm.hasError
        ? _c("ElAlert", {
            attrs: {
              closable: false,
              title: "There was a problem retrieving the terms of use.",
              type: "error",
            },
          })
        : _c("span", {
            domProps: { innerHTML: _vm._s(_vm.termsOfUseContent) },
          }),
    ],
    1
  )
};
var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;

  /* style */
  const __vue_inject_styles__$c = function (inject) {
    if (!inject) return
    inject("data-v-35adc8ce_0", { source: ".terms-container[data-v-35adc8ce] {\n  width: 100%;\n  max-width: 725px;\n  padding: 30px 20px;\n}\n.terms-container.has-error[data-v-35adc8ce] {\n  max-width: none;\n}\n\n/*# sourceMappingURL=AppTermsOfUse.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AuthPages/AppTermsOfUse.vue","AppTermsOfUse.vue"],"names":[],"mappings":"AA6DA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AC5DA;AD8DA;EACA,eAAA;AC5DA;;AAEA,4CAA4C","file":"AppTermsOfUse.vue","sourcesContent":["<template>\n  <section\n    v-loading=\"isLoading\"\n    class=\"terms-container\"\n    :class=\"{ 'has-error' : hasError }\"\n  >\n    <ElAlert\n      v-if=\"hasError\"\n      :closable=\"false\"\n      title=\"There was a problem retrieving the terms of use.\"\n      type=\"error\"\n    />\n    <!-- eslint-disable vue/no-v-html -->\n    <span\n      v-else\n      v-html=\"termsOfUseContent\"\n    />\n    <!-- eslint-enable vue/no-v-html -->\n  </section>\n</template>\n\n<script>\n  import axios from 'axios';\n\n  /**\n   * Terms of Use\n   *\n   * @vuedoc\n   * @exports AppTermsOfUse\n   * @category Components\n   */\n  export default {\n    name: 'AppTermsOfUse',\n    props: {\n      termsId: {\n        type: String,\n        default: '11825817',\n      },\n    },\n    data: () => ({\n      hasError: false,\n      isLoading: true,\n      termsOfUseContent: '',\n    }),\n    // On create we hit the iubenda api and grab the terms from there.\n    // We can pass in an id incase we need different calls for different sites.\n    created() {\n      axios.get(`https://www.iubenda.com/api/terms-and-conditions/${this.termsId}`)\n        .then((response) => {\n          this.termsOfUseContent = response.data.content;\n          this.isLoading = false;\n        })\n        .catch(() => {\n          this.isLoading = false;\n          this.hasError = true;\n        });\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .terms-container {\n    width: 100%;\n    max-width: 725px;\n    padding: 30px 20px;\n\n    &.has-error {\n      max-width: none;\n    }\n  }\n</style>\n",".terms-container {\n  width: 100%;\n  max-width: 725px;\n  padding: 30px 20px;\n}\n.terms-container.has-error {\n  max-width: none;\n}\n\n/*# sourceMappingURL=AppTermsOfUse.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$c = "data-v-35adc8ce";
  /* module identifier */
  const __vue_module_identifier__$c = undefined;
  /* functional template */
  const __vue_is_functional_template__$c = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$c = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * WatchTower Auth Flow Footer
 *
 * @vuedoc
 * @exports AuthenticationFooter
 * @category Components
 */
var script$d = {
  name: 'AuthenticationFooter'
};

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("footer", [
    _c(
      "p",
      [
        _vm._v("\n    Need help?\n    "),
        _c("br"),
        _vm._v(" "),
        _c(
          "TfCtaEmailSupport",
          { attrs: { type: "primary", "data-test": "contact support" } },
          [_vm._v("\n      Contact support\n    ")]
        ),
        _vm._v(".\n  "),
      ],
      1
    ),
  ])
};
var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;

  /* style */
  const __vue_inject_styles__$d = function (inject) {
    if (!inject) return
    inject("data-v-29dcf782_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nfooter[data-v-29dcf782] {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  padding: 20px 0 40px;\n  text-align: center;\n  background: #fff;\n}\n.auth-form p[data-v-29dcf782],\n.auth-form p .tf-button--text[data-v-29dcf782],\n.auth-form p .wt-button--text[data-v-29dcf782] {\n  font-size: 14px;\n}\n.auth-form p .tf-button--text[data-v-29dcf782],\n.auth-form p .wt-button--text[data-v-29dcf782] {\n  display: inline-block;\n}\n\n/*# sourceMappingURL=Footer.vue.map */", map: {"version":3,"sources":["Footer.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AuthPages/Footer.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC6BlC;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAGA;AD9BA;AC+BA;;;EAGA,eAAA;AD5BA;AC+BA;;EAEA,qBAAA;AD7BA;;AAEA,qCAAqC","file":"Footer.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nfooter {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  padding: 20px 0 40px;\n  text-align: center;\n  background: #fff;\n}\n\n.auth-form p,\n.auth-form p .tf-button--text,\n.auth-form p .wt-button--text {\n  font-size: 14px;\n}\n.auth-form p .tf-button--text,\n.auth-form p .wt-button--text {\n  display: inline-block;\n}\n\n/*# sourceMappingURL=Footer.vue.map */","<template>\n  <footer>\n    <p>\n      Need help?\n      <br>\n      <TfCtaEmailSupport\n        type=\"primary\"\n        data-test=\"contact support\"\n      >\n        Contact support\n      </TfCtaEmailSupport>.\n    </p>\n  </footer>\n</template>\n\n<script>\n/**\n * WatchTower Auth Flow Footer\n *\n * @vuedoc\n * @exports AuthenticationFooter\n * @category Components\n */\n  export default {\n    name: 'AuthenticationFooter',\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  footer {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    padding: 20px 0 40px;\n    text-align: center;\n    background: $tf-white;\n  }\n\n  .auth-form p {\n    &,\n    .tf-button--text,\n    .wt-button--text {\n      font-size: 14px;\n    }\n\n    .tf-button--text,\n    .wt-button--text {\n      display: inline-block;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$d = "data-v-29dcf782";
  /* module identifier */
  const __vue_module_identifier__$d = undefined;
  /* functional template */
  const __vue_is_functional_template__$d = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$d = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//

/**
 * WatchTower Auth Flow Header
 *
 * @vuedoc
 * @exports AuthenticationHeader
 * @category Components
 */

var script$e = {
  name: 'AuthenticationHeader',
  props: {
    title: {
      type: String,
      default: null
    }
  }
};

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("header", [
    _c("div", { staticClass: "logo" }, [_c("ThreeflowWordmark")], 1),
    _vm._v(" "),
    _vm.title
      ? _c("h2", { domProps: { textContent: _vm._s(_vm.title) } })
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;

  /* style */
  const __vue_inject_styles__$e = function (inject) {
    if (!inject) return
    inject("data-v-036b6daa_0", { source: ".logo[data-v-036b6daa] {\n  display: block;\n  margin: 0 auto 45px;\n}\n\n/*# sourceMappingURL=Header.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/AuthPages/Header.vue","Header.vue"],"names":[],"mappings":"AAiCA;EACA,cAAA;EACA,mBAAA;AChCA;;AAEA,qCAAqC","file":"Header.vue","sourcesContent":["<template>\n  <header>\n    <div class=\"logo\">\n      <ThreeflowWordmark />\n    </div>\n    <h2\n      v-if=\"title\"\n      v-text=\"title\"\n    />\n  </header>\n</template>\n\n<script>\n/**\n * WatchTower Auth Flow Header\n *\n * @vuedoc\n * @exports AuthenticationHeader\n * @category Components\n */\n\n  export default {\n    name: 'AuthenticationHeader',\n    props: {\n      title: {\n        type: String,\n        default: null,\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  .logo {\n    display: block;\n    margin: 0 auto 45px;\n  }\n</style>\n",".logo {\n  display: block;\n  margin: 0 auto 45px;\n}\n\n/*# sourceMappingURL=Header.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$e = "data-v-036b6daa";
  /* module identifier */
  const __vue_module_identifier__$e = undefined;
  /* functional template */
  const __vue_is_functional_template__$e = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$e = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    browser,
    undefined,
    undefined
  );

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $find = _arrayMethods(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
_export(_export.P + _export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY);

// 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES$2 = _wks('species');
var _speciesConstructor = function (O, D) {
  var C = _anObject(O).constructor;
  var S;
  return C === undefined || (S = _anObject(C)[SPECIES$2]) == undefined ? D : _aFunction(S);
};

var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX$1 = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !_fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
_fixReWks('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!_isRegexp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = _regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX$1];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX$1] === match.index) separatorCopy[LAST_INDEX$1]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = _anObject(regexp);
      var S = String(this);
      var C = _speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return _regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = _regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(_toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = _advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});

var $map = _arrayMethods(1);

_export(_export.P + _export.F * !_strictMethod([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The Comments component that includes the readonly and edit state of a comment.
 *
 * @vuedoc
 * @exports Comments/index
 * @category Components
 */
var script$f = {
  name: 'Comment',
  props: {
    applicationNamespace: {
      type: String,
      required: true,
      default: ''
    },
    broker: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    comment: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    documents: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    inlineSuccess: {
      type: Boolean,
      default: true
    },
    isReply: {
      type: Boolean,
      default: false
    },
    isPdfRender: {
      type: Boolean,
      default: false
    },
    parentId: {
      type: Number,
      default: null
    },
    projectId: {
      type: [Number, String],
      default: '',
      required: true
    },
    proposalDocumentId: {
      type: Number,
      default: null
    },
    showNewBadge: {
      type: Boolean,
      default: true
    },
    showReplyButton: {
      type: Boolean,
      default: true
    },
    userInfo: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          firstName: '',
          lastName: '',
          organization: '',
          type: 'broker'
        };
      }
    }
  },
  data: function data() {
    return {
      autoSaveTimestamp: '',
      commentText: '',
      showSuccessMessage: false,
      showCommentBox: false
    };
  },
  computed: {
    /**
     * Splits the comment content by `\n\n` into an array to use in the template.
     *
     * @returns {Array}
     */
    commentParagraphs: function commentParagraphs() {
      return this.comment.content.split('\n\n').map(function (p) {
        return p.split('\n');
      });
    },
    /**
     * If this is a top level comment, we should reply to this comment.
     * If this is a reply, we should take the parentId prop
     *
     * @returns {string}
     */
    commentParentId: function commentParentId() {
      return this.isReply ? this.parentId : this.comment.id;
    },
    /**
     * Evaluates recipient, userInfo and broker data to decide what to return in this.fullName.
     *
     * @returns {string}
     */
    commentRecipient: function commentRecipient() {
      var _this = this;
      var recipient = this.documents.find(function (document) {
        return document.id === _this.comment.commentable_id;
      });
      var commentRecipient = null;
      if (recipient) {
        commentRecipient = this.broker.name;

        // IF: this.comment originated from a broker we know it's to the carrier of a document => the recipient's (carrier's) name
        // ELSE IF: this comment came from a carrier => assign broker name from this.userInfo.organization
        if (this.comment.user.broker.name) {
          commentRecipient = recipient.carrier.name;
        } else if (this.isBrokerUser) {
          commentRecipient = this.userInfo.organization;
        }
      }
      return commentRecipient;
    },
    /**
     * Determines if the user is a broker based on this.userInfo type.
     *
     * @returns {boolean}
     */
    isBrokerUser: function isBrokerUser() {
      return this.userInfo.type === 'broker';
    },
    /**
     * Determines if the user is a carrier based on this.userInfo type.
     *
     * @returns {boolean}
     */
    isCarrierUser: function isCarrierUser() {
      return this.userInfo.type === 'carrier';
    },
    /**
     * Evaluates broker and carrier data to decide what to return in this.fullName.
     *
     * @returns {boolean}
     */
    isSameOrganization: function isSameOrganization() {
      var isBroker = this.isBrokerUser && this.userInfo.organization === this.comment.user.broker.name;
      var isCarrier = this.isCarrierUser && this.userInfo.organization === this.comment.user.carrier.name;
      return isCarrier || isBroker;
    },
    /**
     * Return organization name, if set, regardless of user type
     *
     * @returns {string}
     */
    organizationName: function organizationName() {
      var isBroker = this.comment.user.broker && this.comment.user.broker.name;
      var isCarrier = this.comment.user.carrier && this.comment.user.carrier.name;
      var organizationName = null;
      if (isCarrier) {
        organizationName = this.comment.user.carrier.name;
      }
      if (isBroker) {
        organizationName = this.comment.user.broker.name;
      }
      return organizationName;
    },
    /**
     * Return organization name, if set, regardless of user type
     *
     * @returns {Array}
     */
    orderedReplies: function orderedReplies() {
      return this.comment.replies
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      ? this.$TF.Formatting.sortObjects(this.comment.replies, 'created_at', 'desc') : [];
    },
    /**
     * Evaluates the comment and showNewBadge prop to decide to show the "new" badge.
     *
     * @returns {boolean}
     */
    showLocalNewBadge: function showLocalNewBadge() {
      return this.comment.is_new && this.showNewBadge;
    },
    /**
     * Returns the success message based on user type.
     *
     * @returns {string}
     */
    successMessage: function successMessage() {
      return this.isBrokerUser ? 'Your comment has been sent to the carrier(s)' : 'Your comment has been sent to your broker.';
    },
    /**
     * Return organization name, if set, regardless of user type
     *
     * @returns {string}
     */
    userName: function userName() {
      var user = this.comment.user;
      var userName = "".concat(user.first_name, " ").concat(user.last_name);
      if (!this.isSameOrganization) {
        userName = "".concat(userName, " at ").concat(this.organizationName);
      }
      return userName;
    }
  },
  /*
  }
  * Check if we saved a comment in session storage that wasn't submitted and also sort any replies.
  * If this is a newly added comment, show the alert for 5 seconds.
  */
  created: function created() {
    var _this2 = this;
    var savedComment = window.sessionStorage.getItem("comment-".concat(this.comment.id));
    if (savedComment) {
      var commentObject = JSON.parse(savedComment);
      this.autoSaveTimestamp = commentObject.timestamp;
      this.commentText = commentObject.message;
      this.showCommentBox = true;
    }
    if (this.comment.showSuccess) {
      this.showSuccessMessage = true;
      this.interval = setInterval(function () {
        _this2.showSuccessMessage = false;
      }, 5000);
    }
  },
  methods: {
    /**
     * Clear out the comment
     */
    clearData: function clearData() {
      this.autoSaveTimestamp = '';
      this.commentText = '';
    },
    /**
     * Toggle the reply box for this comment
     */
    onCancel: function onCancel() {
      this.showCommentBox = false;
      this.clearData();
    },
    /**
     * Toggle the reply box for this comment and emit the reply to the parent
     *
     * @param {event} $event
     */
    onCommentAdded: function onCommentAdded($event) {
      this.$emit('commentAdded', $event);
      this.showCommentBox = false;
      this.clearData();
    }
  }
};

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: [
        { "pdf-export-container": _vm.isPdfRender },
        { "is-reply": _vm.isReply },
        "tf-comment-container",
        "wt-comment-container",
      ],
    },
    [
      _vm.showSuccessMessage
        ? _c("ElAlert", {
            attrs: {
              "data-test": "comment success notification",
              "show-icon": "",
              closable: false,
              title: _vm.successMessage,
              type: "success",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLocalNewBadge
        ? _c("TfBadge", {
            class: { indent: _vm.isReply },
            attrs: { size: "small", status: "success", value: "new" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        {
          class: [
            "sender-recipient",
            {
              "pdf-export-block": _vm.isPdfRender,
              indent: _vm.isReply,
            },
          ],
        },
        [
          _c("strong", [_vm._v(_vm._s(_vm.userName))]),
          _vm._v(" "),
          _vm.commentRecipient
            ? [
                _vm._v("\n      to "),
                _c("strong", [_vm._v(_vm._s(_vm.commentRecipient))]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("p", {
        class: [
          "date",
          {
            "pdf-export-block": _vm.isPdfRender,
            indent: _vm.isReply,
          },
        ],
        domProps: {
          textContent: _vm._s(
            _vm.$TF.DatesUtils.formatDateAndTime(_vm.comment.created_at)
          ),
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "comment" },
        [
          _vm._l(_vm.commentParagraphs, function (paragraphs, index) {
            return _vm._l(paragraphs, function (p, pIndex) {
              return _c("p", {
                key: index + "-" + pIndex,
                class: {
                  "no-break":
                    paragraphs.length > 1 && pIndex !== paragraphs.length - 1,
                  "pdf-export-block": _vm.isPdfRender,
                  indent: _vm.isReply,
                  "is-last":
                    index === _vm.commentParagraphs.length - 1 &&
                    pIndex === paragraphs.length - 1,
                },
                domProps: { textContent: _vm._s(p.trim()) },
              })
            })
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "TfButton",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showCommentBox && _vm.showReplyButton,
              expression: "!showCommentBox && showReplyButton",
            },
          ],
          class: { indent: _vm.isReply },
          attrs: { type: "primary", icon: "reply", size: "text-icon" },
          on: {
            click: function ($event) {
              _vm.showCommentBox = true;
            },
          },
        },
        [_vm._v("\n    Reply\n  ")]
      ),
      _vm._v(" "),
      _c("CommentInput", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showCommentBox && !_vm.isPdfRender,
            expression: "showCommentBox && !isPdfRender",
          },
        ],
        attrs: {
          "application-namespace": _vm.applicationNamespace,
          "auto-save-timestamp": _vm.autoSaveTimestamp,
          comment: _vm.comment,
          "inline-success": _vm.inlineSuccess,
          "parent-id": _vm.commentParentId,
          "project-id": _vm.projectId,
          "proposal-document-id": _vm.proposalDocumentId,
          "user-info": _vm.userInfo,
        },
        on: { cancel: _vm.onCancel, commentAdded: _vm.onCommentAdded },
        model: {
          value: _vm.commentText,
          callback: function ($$v) {
            _vm.commentText = $$v;
          },
          expression: "commentText",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.orderedReplies.length,
              expression: "orderedReplies.length",
            },
          ],
        },
        _vm._l(_vm.orderedReplies, function (commentReply, index) {
          return _c("comment", {
            key: commentReply.id,
            attrs: {
              "application-namespace": _vm.applicationNamespace,
              broker: _vm.broker,
              comment: commentReply,
              documents: _vm.documents,
              "is-reply": true,
              "is-pdf-render": _vm.isPdfRender,
              "parent-id": _vm.commentParentId,
              "proposal-document-id": _vm.proposalDocumentId,
              "project-id": _vm.projectId,
              "show-reply-button": !index,
              "user-info": _vm.userInfo,
            },
            on: { commentAdded: _vm.onCommentAdded },
          })
        }),
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;

  /* style */
  const __vue_inject_styles__$f = function (inject) {
    if (!inject) return
    inject("data-v-8e4fd778_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.pdf-export-container .tf-button.icon-reply[data-v-8e4fd778],\n.pdf-export-container .wt-button.icon-reply[data-v-8e4fd778], .pdf-export-container .alert-new.alert-simple[data-v-8e4fd778], .pdf-export-container .el-alert[data-v-8e4fd778] {\n  display: none;\n}\n.tf-comment-container[data-v-8e4fd778],\n.wt-comment-container[data-v-8e4fd778] {\n  padding: 15px 15px 15px 0;\n  font-size: 14px;\n  line-height: 20px;\n  border-top: solid 1px #efefef;\n}\n.tf-comment-container[data-v-8e4fd778]:first-child,\n.wt-comment-container[data-v-8e4fd778]:first-child {\n  border-top: 0;\n}\n.tf-comment-container.is-reply:first-child .el-alert + .name[data-v-8e4fd778],\n.wt-comment-container.is-reply:first-child .el-alert + .name[data-v-8e4fd778] {\n  padding-top: 14px;\n}\n.tf-comment-container > .tf-badge[data-v-8e4fd778],\n.wt-comment-container > .tf-badge[data-v-8e4fd778] {\n  margin-bottom: 10px;\n}\n.date[data-v-8e4fd778] {\n  color: #999;\n  font-style: italic;\n}\n.el-alert[data-v-8e4fd778] {\n  margin: 0 0 15px;\n}\n.alert-new.alert-simple[data-v-8e4fd778] {\n  margin: 0;\n  padding: 5px 10px;\n}\n.tf-button.icon-reply[data-v-8e4fd778],\n.wt-button.icon-reply[data-v-8e4fd778] {\n  margin-top: 12px;\n}\n.indent[data-v-8e4fd778],\n.alert-new.alert-simple.indent[data-v-8e4fd778],\n.tf-button.indent[data-v-8e4fd778],\n.wt-button.indent[data-v-8e4fd778] {\n  margin-left: 35px;\n}\np[data-v-8e4fd778] {\n  margin: 0;\n  line-height: 20px;\n}\n.comment p[data-v-8e4fd778] {\n  margin-bottom: 20px;\n}\n.comment p.no-break[data-v-8e4fd778] {\n  margin-bottom: 0;\n}\n.comment p[data-v-8e4fd778]:last-child {\n  margin-bottom: 0;\n}\np.pdf-export-block[data-v-8e4fd778] {\n  width: 530px;\n  font-size: 12px;\n  line-height: 16px;\n}\np.pdf-export-block.indent[data-v-8e4fd778] {\n  width: 495px;\n}\np.pdf-export-block.is-last[data-v-8e4fd778] {\n  margin-bottom: 16px;\n}\np.pdf-export-block.sender-recipient[data-v-8e4fd778] {\n  padding-top: 16px;\n  border-top: 1px solid #c1c1c1;\n}\n.pdf-export-header + p.pdf-export-block.sender-recipient[data-v-8e4fd778] {\n  padding-top: 0;\n  border-top: 0;\n}\n\n/*# sourceMappingURL=index.vue.map */", map: {"version":3,"sources":["index.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/Comment/index.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC+YlC;;EACA,aAAA;AD5YA;ACgZA;;EAEA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AD7YA;AC+YA;;EACA,aAAA;AD5YA;ACgZA;;EACA,iBAAA;AD7YA;ACiZA;;EACA,mBAAA;AD9YA;ACkZA;EACA,WAAA;EACA,kBAAA;AD/YA;ACkZA;EACA,gBAAA;AD/YA;ACoZA;EACA,SAAA;EACA,iBAAA;ADjZA;ACsZA;;EAEA,gBAAA;ADnZA;ACyZA;;;;EAIA,iBAAA;ADtZA;ACyZA;EACA,SAAA;EACA,iBAAA;ADtZA;ACwZA;EACA,mBAAA;ADtZA;ACwZA;EACA,gBAAA;ADtZA;ACyZA;EACA,gBAAA;ADvZA;AC2ZA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;ADzZA;AC2ZA;EACA,YAAA;ADzZA;AC4ZA;EACA,mBAAA;AD1ZA;AC6ZA;EACA,iBAAA;EAGA,6BAAA;AD7ZA;AC+ZA;EACA,cAAA;EACA,aAAA;AD7ZA;;AAEA,oCAAoC","file":"index.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.pdf-export-container .tf-button.icon-reply,\n.pdf-export-container .wt-button.icon-reply, .pdf-export-container .alert-new.alert-simple, .pdf-export-container .el-alert {\n  display: none;\n}\n\n.tf-comment-container,\n.wt-comment-container {\n  padding: 15px 15px 15px 0;\n  font-size: 14px;\n  line-height: 20px;\n  border-top: solid 1px #efefef;\n}\n.tf-comment-container:first-child,\n.wt-comment-container:first-child {\n  border-top: 0;\n}\n.tf-comment-container.is-reply:first-child .el-alert + .name,\n.wt-comment-container.is-reply:first-child .el-alert + .name {\n  padding-top: 14px;\n}\n.tf-comment-container > .tf-badge,\n.wt-comment-container > .tf-badge {\n  margin-bottom: 10px;\n}\n\n.date {\n  color: #999;\n  font-style: italic;\n}\n\n.el-alert {\n  margin: 0 0 15px;\n}\n\n.alert-new.alert-simple {\n  margin: 0;\n  padding: 5px 10px;\n}\n\n.tf-button.icon-reply,\n.wt-button.icon-reply {\n  margin-top: 12px;\n}\n\n.indent,\n.alert-new.alert-simple.indent,\n.tf-button.indent,\n.wt-button.indent {\n  margin-left: 35px;\n}\n\np {\n  margin: 0;\n  line-height: 20px;\n}\n.comment p {\n  margin-bottom: 20px;\n}\n.comment p.no-break {\n  margin-bottom: 0;\n}\n.comment p:last-child {\n  margin-bottom: 0;\n}\np.pdf-export-block {\n  width: 530px;\n  font-size: 12px;\n  line-height: 16px;\n}\np.pdf-export-block.indent {\n  width: 495px;\n}\np.pdf-export-block.is-last {\n  margin-bottom: 16px;\n}\np.pdf-export-block.sender-recipient {\n  padding-top: 16px;\n  border-top: 1px solid #c1c1c1;\n}\n.pdf-export-header + p.pdf-export-block.sender-recipient {\n  padding-top: 0;\n  border-top: 0;\n}\n\n/*# sourceMappingURL=index.vue.map */","<template>\n  <div\n    :class=\"[\n      { 'pdf-export-container': isPdfRender },\n      { 'is-reply': isReply },\n      'tf-comment-container',\n      'wt-comment-container'\n    ]\"\n  >\n    <ElAlert\n      v-if=\"showSuccessMessage\"\n      data-test=\"comment success notification\"\n      show-icon\n      :closable=\"false\"\n      :title=\"successMessage\"\n      type=\"success\"\n    />\n    <TfBadge\n      v-if=\"showLocalNewBadge\"\n      :class=\"{ 'indent': isReply }\"\n      size=\"small\"\n      status=\"success\"\n      value=\"new\"\n    />\n    <p\n      :class=\"[\n        'sender-recipient',\n        {\n          'pdf-export-block': isPdfRender,\n          'indent': isReply,\n        }\n      ]\"\n    >\n      <strong>{{ userName }}</strong>\n      <template v-if=\"commentRecipient\">\n        to <strong>{{ commentRecipient }}</strong>\n      </template>\n    </p>\n    <p\n      :class=\"[\n        'date',\n        {\n          'pdf-export-block': isPdfRender,\n          'indent': isReply\n        }\n      ]\"\n      v-text=\"$TF.DatesUtils.formatDateAndTime(comment.created_at)\"\n    />\n    <div class=\"comment\">\n      <template v-for=\"(paragraphs, index) in commentParagraphs\">\n        <p\n          v-for=\"(p, pIndex) in paragraphs\"\n          :key=\"`${index}-${pIndex}`\"\n          :class=\"{\n            'no-break': paragraphs.length > 1 && pIndex !== paragraphs.length -1,\n            'pdf-export-block': isPdfRender,\n            'indent': isReply,\n            'is-last': index === commentParagraphs.length -1 && pIndex === paragraphs.length -1\n          }\"\n          v-text=\"p.trim()\"\n        />\n      </template>\n    </div>\n    <TfButton\n      v-show=\"!showCommentBox && showReplyButton\"\n      type=\"primary\"\n      icon=\"reply\"\n      size=\"text-icon\"\n      :class=\"{'indent': isReply}\"\n      @click=\"showCommentBox = true\"\n    >\n      Reply\n    </TfButton>\n    <CommentInput\n      v-show=\"showCommentBox && !isPdfRender\"\n      v-model=\"commentText\"\n      :application-namespace=\"applicationNamespace\"\n      :auto-save-timestamp=\"autoSaveTimestamp\"\n      :comment=\"comment\"\n      :inline-success=\"inlineSuccess\"\n      :parent-id=\"commentParentId\"\n      :project-id=\"projectId\"\n      :proposal-document-id=\"proposalDocumentId\"\n      :user-info=\"userInfo\"\n      @cancel=\"onCancel\"\n      @commentAdded=\"onCommentAdded\"\n    />\n    <div v-show=\"orderedReplies.length\">\n      <comment\n        v-for=\"(commentReply, index) in orderedReplies\"\n        :key=\"commentReply.id\"\n        :application-namespace=\"applicationNamespace\"\n        :broker=\"broker\"\n        :comment=\"commentReply\"\n        :documents=\"documents\"\n        :is-reply=\"true\"\n        :is-pdf-render=\"isPdfRender\"\n        :parent-id=\"commentParentId\"\n        :proposal-document-id=\"proposalDocumentId\"\n        :project-id=\"projectId\"\n        :show-reply-button=\"!index\"\n        :user-info=\"userInfo\"\n        @commentAdded=\"onCommentAdded\"\n      />\n    </div>\n  </div>\n</template>\n\n<script>\n/**\n * The Comments component that includes the readonly and edit state of a comment.\n *\n * @vuedoc\n * @exports Comments/index\n * @category Components\n */\n  export default {\n    name: 'Comment',\n    props: {\n      applicationNamespace: {\n        type: String,\n        required: true,\n        default: '',\n      },\n      broker: {\n        type: Object,\n        required: true,\n        default: () => ({}),\n      },\n      comment: {\n        type: Object,\n        default: () => ({}),\n      },\n      documents: {\n        type: Array,\n        default: () => [],\n      },\n      inlineSuccess: {\n        type: Boolean,\n        default: true,\n      },\n      isReply: {\n        type: Boolean,\n        default: false,\n      },\n      isPdfRender: {\n        type: Boolean,\n        default: false,\n      },\n      parentId: {\n        type: Number,\n        default: null,\n      },\n      projectId: {\n        type: [Number, String],\n        default: '',\n        required: true,\n      },\n      proposalDocumentId: {\n        type: Number,\n        default: null,\n      },\n      showNewBadge: {\n        type: Boolean,\n        default: true,\n      },\n      showReplyButton: {\n        type: Boolean,\n        default: true,\n      },\n      userInfo: {\n        type: Object,\n        required: true,\n        default: () => ({\n          firstName: '',\n          lastName: '',\n          organization: '',\n          type: 'broker',\n        }),\n      },\n    },\n\n    data: () => ({\n      autoSaveTimestamp: '',\n      commentText: '',\n      showSuccessMessage: false,\n      showCommentBox: false,\n    }),\n\n    computed: {\n      /**\n       * Splits the comment content by `\\n\\n` into an array to use in the template.\n       *\n       * @returns {Array}\n       */\n      commentParagraphs() {\n        return this.comment.content\n          .split('\\n\\n')\n          .map((p) => p.split('\\n'));\n      },\n\n      /**\n       * If this is a top level comment, we should reply to this comment.\n       * If this is a reply, we should take the parentId prop\n       *\n       * @returns {string}\n       */\n      commentParentId() {\n        return this.isReply ? this.parentId : this.comment.id;\n      },\n\n      /**\n       * Evaluates recipient, userInfo and broker data to decide what to return in this.fullName.\n       *\n       * @returns {string}\n       */\n      commentRecipient() {\n        const recipient = this.documents.find(\n          (document) => document.id === this.comment.commentable_id,\n        );\n        let commentRecipient = null;\n\n        if (recipient) {\n          commentRecipient = this.broker.name;\n\n          // IF: this.comment originated from a broker we know it's to the carrier of a document => the recipient's (carrier's) name\n          // ELSE IF: this comment came from a carrier => assign broker name from this.userInfo.organization\n          if (this.comment.user.broker.name) {\n            commentRecipient = recipient.carrier.name;\n          } else if (this.isBrokerUser) {\n            commentRecipient = this.userInfo.organization;\n          }\n        }\n\n        return commentRecipient;\n      },\n\n      /**\n       * Determines if the user is a broker based on this.userInfo type.\n       *\n       * @returns {boolean}\n       */\n      isBrokerUser() {\n        return this.userInfo.type === 'broker';\n      },\n\n      /**\n       * Determines if the user is a carrier based on this.userInfo type.\n       *\n       * @returns {boolean}\n       */\n      isCarrierUser() {\n        return this.userInfo.type === 'carrier';\n      },\n\n      /**\n       * Evaluates broker and carrier data to decide what to return in this.fullName.\n       *\n       * @returns {boolean}\n       */\n      isSameOrganization() {\n        const isBroker = this.isBrokerUser\n          && this.userInfo.organization === this.comment.user.broker.name;\n        const isCarrier = this.isCarrierUser\n          && this.userInfo.organization === this.comment.user.carrier.name;\n\n        return isCarrier || isBroker;\n      },\n\n      /**\n       * Return organization name, if set, regardless of user type\n       *\n       * @returns {string}\n       */\n      organizationName() {\n        const isBroker = this.comment.user.broker\n          && this.comment.user.broker.name;\n        const isCarrier = this.comment.user.carrier\n          && this.comment.user.carrier.name;\n        let organizationName = null;\n\n        if (isCarrier) {\n          organizationName = this.comment.user.carrier.name;\n        }\n\n        if (isBroker) {\n          organizationName = this.comment.user.broker.name;\n        }\n\n        return organizationName;\n      },\n      /**\n       * Return organization name, if set, regardless of user type\n       *\n       * @returns {Array}\n       */\n      orderedReplies() {\n        return this.comment.replies\n          // eslint-disable-next-line vue/no-side-effects-in-computed-properties\n          ? this.$TF.Formatting.sortObjects(\n            this.comment.replies,\n            'created_at',\n            'desc',\n          )\n          : [];\n      },\n      /**\n       * Evaluates the comment and showNewBadge prop to decide to show the \"new\" badge.\n       *\n       * @returns {boolean}\n       */\n      showLocalNewBadge() {\n        return this.comment.is_new && this.showNewBadge;\n      },\n\n      /**\n       * Returns the success message based on user type.\n       *\n       * @returns {string}\n       */\n      successMessage() {\n        return this.isBrokerUser\n          ? 'Your comment has been sent to the carrier(s)'\n          : 'Your comment has been sent to your broker.';\n      },\n\n      /**\n       * Return organization name, if set, regardless of user type\n       *\n       * @returns {string}\n       */\n      userName() {\n        const { user } = this.comment;\n        let userName = `${user.first_name} ${user.last_name}`;\n\n        if (!this.isSameOrganization) {\n          userName = `${userName} at ${this.organizationName}`;\n        }\n\n        return userName;\n      },\n    },\n\n    /*\n  }\n  * Check if we saved a comment in session storage that wasn't submitted and also sort any replies.\n  * If this is a newly added comment, show the alert for 5 seconds.\n  */\n    created() {\n      const savedComment = window.sessionStorage.getItem(`comment-${this.comment.id}`);\n\n      if (savedComment) {\n        const commentObject = JSON.parse(savedComment);\n        this.autoSaveTimestamp = commentObject.timestamp;\n        this.commentText = commentObject.message;\n        this.showCommentBox = true;\n      }\n\n      if (this.comment.showSuccess) {\n        this.showSuccessMessage = true;\n        this.interval = setInterval(() => {\n          this.showSuccessMessage = false;\n        }, 5000);\n      }\n    },\n\n    methods: {\n      /**\n       * Clear out the comment\n       */\n      clearData() {\n        this.autoSaveTimestamp = '';\n        this.commentText = '';\n      },\n\n      /**\n       * Toggle the reply box for this comment\n       */\n      onCancel() {\n        this.showCommentBox = false;\n        this.clearData();\n      },\n\n      /**\n       * Toggle the reply box for this comment and emit the reply to the parent\n       *\n       * @param {event} $event\n       */\n      onCommentAdded($event) {\n        this.$emit('commentAdded', $event);\n        this.showCommentBox = false;\n        this.clearData();\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  %hideOnPdf {\n    .pdf-export-container & {\n      display: none;\n    }\n  }\n\n  .tf-comment-container,\n  .wt-comment-container {\n    padding: 15px 15px 15px 0;\n    font-size: 14px;\n    line-height: 20px;\n    border-top: solid 1px $tf-extra-light-gray-1;\n\n    &:first-child {\n      border-top: 0;\n    }\n\n    &.is-reply:first-child {\n      .el-alert + .name {\n        padding-top: 14px;\n      }\n    }\n\n    > .tf-badge {\n      margin-bottom: 10px;\n    }\n  }\n\n  .date {\n    color: $tf-medium-gray;\n    font-style: italic;\n  }\n\n  .el-alert {\n    margin: 0 0 15px;\n\n    @extend %hideOnPdf;\n  }\n\n  .alert-new.alert-simple {\n    margin: 0;\n    padding: 5px 10px;\n\n    @extend %hideOnPdf;\n  }\n\n  .tf-button.icon-reply,\n  .wt-button.icon-reply {\n    margin-top: 12px;\n\n    @extend %hideOnPdf;\n  }\n\n  // frustrating amount of specifity needed for these\n  .indent,\n  .alert-new.alert-simple.indent,\n  .tf-button.indent,\n  .wt-button.indent {\n    margin-left: 35px;\n  }\n\n  p {\n    margin: 0;\n    line-height: 20px;\n\n    .comment & {\n      margin-bottom: 20px;\n\n      &.no-break {\n        margin-bottom: 0;\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    &.pdf-export-block {\n      width: 530px;\n      font-size: 12px;\n      line-height: 16px;\n\n      &.indent {\n        width: 495px;\n      }\n\n      &.is-last {\n        margin-bottom: 16px;\n      }\n\n      &.sender-recipient {\n        padding-top: 16px;\n        // Dashed lines currently break the UI (https://watchtower.atlassian.net/browse/BA-1563)\n        // border-top: 2px $tf-light-gray dashed;\n        border-top: 1px solid $tf-light-gray;\n\n        .pdf-export-header + & {\n          padding-top: 0;\n          border-top: 0;\n        }\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$f = "data-v-8e4fd778";
  /* module identifier */
  const __vue_module_identifier__$f = undefined;
  /* functional template */
  const __vue_is_functional_template__$f = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$f = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    browser,
    undefined,
    undefined
  );

// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperties: _objectDps });

var f$4 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$4
};

// all object keys, includes non-enumerable and symbols



var Reflect$1 = _global.Reflect;
var _ownKeys = Reflect$1 && Reflect$1.ownKeys || function ownKeys(it) {
  var keys = _objectGopn.f(_anObject(it));
  var getSymbols = _objectGops.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

var _createProperty = function (object, index, value) {
  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
  else object[index] = value;
};

// https://github.com/tc39/proposal-object-getownpropertydescriptors






_export(_export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = _toIobject(object);
    var getDesc = _objectGopd.f;
    var keys = _ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) _createProperty(result, key, desc);
    }
    return result;
  }
});

var $filter = _arrayMethods(2);

_export(_export.P + _export.F * !_strictMethod([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.14 Object.keys(O)



_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

var $forEach = _arrayMethods(0);
var STRICT = _strictMethod([].forEach, true);

_export(_export.P + _export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

var _global$1 = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core$1 = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1$1 = _core$1.version;

var _aFunction$1 = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx$1 = function (fn, that, length) {
  _aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject$1 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject$1 = function (it) {
  if (!_isObject$1(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails$1 = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors$1 = !_fails$1(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$3 = _global$1.document;
// typeof document.createElement is 'object' in old IE
var is$1 = _isObject$1(document$3) && _isObject$1(document$3.createElement);
var _domCreate$1 = function (it) {
  return is$1 ? document$3.createElement(it) : {};
};

var _ie8DomDefine$1 = !_descriptors$1 && !_fails$1(function () {
  return Object.defineProperty(_domCreate$1('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive$1 = function (it, S) {
  if (!_isObject$1(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP$3 = Object.defineProperty;

var f$5 = _descriptors$1 ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject$1(O);
  P = _toPrimitive$1(P, true);
  _anObject$1(Attributes);
  if (_ie8DomDefine$1) try {
    return dP$3(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp$1 = {
	f: f$5
};

var _propertyDesc$1 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide$1 = _descriptors$1 ? function (object, key, value) {
  return _objectDp$1.f(object, key, _propertyDesc$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$1 = {}.hasOwnProperty;
var _has$1 = function (it, key) {
  return hasOwnProperty$1.call(it, key);
};

var PROTOTYPE$2 = 'prototype';

var $export$1 = function (type, name, source) {
  var IS_FORCED = type & $export$1.F;
  var IS_GLOBAL = type & $export$1.G;
  var IS_STATIC = type & $export$1.S;
  var IS_PROTO = type & $export$1.P;
  var IS_BIND = type & $export$1.B;
  var IS_WRAP = type & $export$1.W;
  var exports = IS_GLOBAL ? _core$1 : _core$1[name] || (_core$1[name] = {});
  var expProto = exports[PROTOTYPE$2];
  var target = IS_GLOBAL ? _global$1 : IS_STATIC ? _global$1[name] : (_global$1[name] || {})[PROTOTYPE$2];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has$1(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx$1(out, _global$1)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE$2] = C[PROTOTYPE$2];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx$1(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export$1.R && expProto && !expProto[key]) _hide$1(expProto, key, out);
    }
  }
};
// type bitmap
$export$1.F = 1;   // forced
$export$1.G = 2;   // global
$export$1.S = 4;   // static
$export$1.P = 8;   // proto
$export$1.B = 16;  // bind
$export$1.W = 32;  // wrap
$export$1.U = 64;  // safe
$export$1.R = 128; // real proto method for `library`
var _export$1 = $export$1;

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export$1(_export$1.S + _export$1.F * !_descriptors$1, 'Object', { defineProperty: _objectDp$1.f });

var $Object = _core$1.Object;
var defineProperty$1 = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

var defineProperty$2 = defineProperty$1;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    defineProperty$2(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)


_export(_export.S, 'Array', { isArray: _isArray });

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
var _dateToIsoString = (_fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !_fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()



// PhantomJS / old WebKit has a broken implementations
_export(_export.P + _export.F * (Date.prototype.toISOString !== _dateToIsoString), 'Date', {
  toISOString: _dateToIsoString
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The Comments input component.
 *
 * @vuedoc
 * @exports Comments/Input
 * @category Components
 */
var script$g = {
  name: 'CommentInput',
  props: {
    apiConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    applicationNamespace: {
      type: String,
      default: '',
      required: true
    },
    autoSaveTimestamp: {
      type: String,
      default: null
    },
    comment: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    commentableIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    customSessionName: {
      type: String,
      default: null
    },
    disableSubmit: {
      type: Boolean,
      default: false
    },
    inlineSuccess: {
      type: Boolean,
      default: true
    },
    parentId: {
      type: Number,
      default: null
    },
    projectId: {
      type: [Number, String],
      default: '',
      required: true
    },
    proposalDocumentId: {
      type: Number,
      default: null
    },
    saveSession: {
      type: Boolean,
      default: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    userInfo: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          firstName: '',
          lastName: '',
          organization: '',
          type: 'broker'
        };
      }
    },
    value: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: function data() {
    return {
      errorOnSubmit: null,
      timestamp: '',
      isSaving: false,
      timer: 0
    };
  },
  computed: {
    /**
     * get(): returns the v-model from the parent
     * set(): emits to the parent new model.
     *
     * @returns {string}
     */
    commentValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
        if (this.saveSession) {
          this.updateSession(value);
        }
      }
    },
    /**
     * Formats this.autoSaveTimestamp to use in the template.
     *
     * @returns {string}
     */
    formattedTimestamp: function formattedTimestamp() {
      return this.$TF.DatesUtils.formatDateAndTime(this.timestamp);
    },
    /**
     * Formats a default label based on user info.
     *
     * @returns {string}
     */
    label: function label() {
      var _this$userInfo = this.userInfo,
        firstName = _this$userInfo.firstName,
        lastName = _this$userInfo.lastName,
        organization = _this$userInfo.organization;
      return "".concat(firstName, " ").concat(lastName, " at ").concat(organization);
    },
    /**
     * Formats this.autoSaveTimestamp to use in the template.
     *
     * @returns {string}
     */
    sessionName: function sessionName() {
      return this.customSessionName || "comment-".concat(this.comment.id);
    }
  },
  /**
   * The parent controls if there is an inital timestamp from session
   * so we should pass it as a prop there and set it on create here.
   */
  created: function created() {
    if (this.autoSaveTimestamp) {
      this.timestamp = this.autoSaveTimestamp;
    }
  },
  methods: {
    /**
     * Debounce on value change and update the session storage every 3 second unless the user is typing.
     *
     * @param {string} message
     */
    updateSession: function updateSession(message) {
      var _this = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        if (_this.isSaving) {
          return;
        }
        _this.timestamp = new Date(new Date().getTime()).toISOString();
        var commentObject = JSON.stringify({
          message: message,
          projectId: _this.projectId,
          timestamp: _this.timestamp
        });
        window.sessionStorage.setItem(_this.sessionName, commentObject);
      }, 3000);
    },
    /**
     * Removes the session and emits 'cancel' to the parent.
     */
    onClickCancel: function onClickCancel() {
      if (this.saveSession) {
        window.sessionStorage.removeItem(this.sessionName);
        clearTimeout(this.timer);
      }
      this.$emit('cancel');
    },
    /**
     * Submits the comment and emits 'commentAdded' to the parent.
     */
    onClickSubmit: function onClickSubmit() {
      var _this2 = this;
      var commentableIds = this.proposalDocumentId || this.comment.commentable_id;
      this.isSaving = true;
      this.errorOnSubmit = null;
      if (this.commentableIds.length) {
        commentableIds = this.commentableIds;
      }
      this.$TF.CommentService.postComment({
        applicationNamespace: this.applicationNamespace,
        content: this.commentValue,
        commentableIds: commentableIds,
        parentId: this.parentId
      }, this.apiConfig).then(function (data) {
        var newComments = Array.isArray(data.comments) ? data.comments : [data.comment];
        var orderedComments = newComments.map(function (comment) {
          return _objectSpread(_objectSpread({}, comment), {}, {
            showSuccess: _this2.inlineSuccess
          });
        });
        if (!_this2.inlineSuccess) {
          _this2.$message({
            showClose: true,
            message: 'Your comment has been sent to your broker.',
            type: 'success',
            duration: 5000
          });
        }
        orderedComments.forEach(function () {
          window.sessionStorage.removeItem(_this2.sessionName);
        });
        _this2.$emit('commentAdded', orderedComments);
      }).catch(function () {
        _this2.errorOnSubmit = 'There was an error submitting the comment.';
      }).finally(function () {
        _this2.isSaving = false;
        _this2.errorOnSubmit = null;
        if (_this2.saveSession) {
          clearTimeout(_this2.timer);
        }
      });
    }
  },
  destroy: function destroy() {
    if (this.saveSession) {
      clearTimeout(this.timer);
    }
  }
};

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: [{ "has-label": _vm.showLabel }, "comment-input-container"] },
    [
      _vm.showLabel
        ? _c("p", [_c("strong", [_vm._v(_vm._s(_vm.label))])])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "autosave-fade" } }, [
        _vm.timestamp
          ? _c("p", {
              staticClass: "timestamp",
              domProps: {
                textContent: _vm._s("Autosaved at " + _vm.formattedTimestamp),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("ElForm", [
        _c("div", { staticClass: "el-textarea" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.commentValue,
                expression: "commentValue",
              },
            ],
            staticClass: "el-textarea__inner",
            attrs: {
              disabled: _vm.isSaving,
              "data-test": "edit comment",
              placeholder: "Enter your comment",
              rows: "6",
            },
            domProps: { value: _vm.commentValue },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.commentValue = $event.target.value;
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-group align-end" },
        [
          _c(
            "TfButton",
            {
              attrs: {
                type: "secondary",
                size: "medium",
                "data-test": "cancel comment",
              },
              on: { click: _vm.onClickCancel },
            },
            [_vm._v("\n      Cancel\n    ")]
          ),
          _vm._v(" "),
          _c(
            "TfButton",
            {
              attrs: {
                disabled: !_vm.commentValue || _vm.disableSubmit,
                loading: _vm.isSaving,
                "data-test": "send comment",
                type: "primary",
                size: "medium",
              },
              on: { click: _vm.onClickSubmit },
            },
            [_vm._v("\n      Send\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.errorOnSubmit
        ? _c("p", {
            staticClass: "text-error",
            domProps: { textContent: _vm._s(_vm.errorOnSubmit) },
          })
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;

  /* style */
  const __vue_inject_styles__$g = function (inject) {
    if (!inject) return
    inject("data-v-357dafe0_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\np[data-v-357dafe0] {\n  margin-bottom: 0;\n}\n.autosave-fade-enter-active[data-v-357dafe0], .autosave-fade-leave-active[data-v-357dafe0] {\n  transition: all 0.75s;\n  max-height: 50px;\n}\n.autosave-fade-enter[data-v-357dafe0], .autosave-fade-leave-to[data-v-357dafe0] {\n  opacity: 0;\n  max-height: 0;\n}\n.timestamp[data-v-357dafe0] {\n  color: #999;\n  text-align: right;\n}\n.comment-input-container.has-label[data-v-357dafe0] {\n  margin-top: 12px;\n}\n.el-textarea[data-v-357dafe0] {\n  margin: 10px 0 15px;\n}\n.text-error[data-v-357dafe0] {\n  text-align: right;\n}\n\n/*# sourceMappingURL=Input.vue.map */", map: {"version":3,"sources":["Input.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/Comment/Input.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;kCAEkC;AC+SlC;EACA,gBAAA;AD7SA;ACiTA;EAEA,qBAAA;EACA,gBAAA;AD/SA;ACkTA;EAEA,UAAA;EACA,aAAA;ADjTA;ACqTA;EACA,WAAA;EACA,iBAAA;ADlTA;ACqTA;EACA,gBAAA;ADlTA;ACqTA;EACA,mBAAA;ADlTA;ACqTA;EACA,iBAAA;ADlTA;;AAEA,oCAAoC","file":"Input.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\np {\n  margin-bottom: 0;\n}\n\n.autosave-fade-enter-active, .autosave-fade-leave-active {\n  transition: all 0.75s;\n  max-height: 50px;\n}\n.autosave-fade-enter, .autosave-fade-leave-to {\n  opacity: 0;\n  max-height: 0;\n}\n\n.timestamp {\n  color: #999;\n  text-align: right;\n}\n\n.comment-input-container.has-label {\n  margin-top: 12px;\n}\n\n.el-textarea {\n  margin: 10px 0 15px;\n}\n\n.text-error {\n  text-align: right;\n}\n\n/*# sourceMappingURL=Input.vue.map */","<template>\n  <div :class=\"[{ 'has-label': showLabel }, 'comment-input-container']\">\n    <p v-if=\"showLabel\">\n      <strong>{{ label }}</strong>\n    </p>\n    <transition name=\"autosave-fade\">\n      <p\n        v-if=\"timestamp\"\n        class=\"timestamp\"\n        v-text=\"`Autosaved at ${formattedTimestamp}`\"\n      />\n    </transition>\n    <ElForm>\n      <div class=\"el-textarea\">\n        <!--\n          We're using a textarea here to \"solve\" https://watchtower.atlassian.net/browse/SUP-166\n        -->\n        <textarea\n          v-model=\"commentValue\"\n          :disabled=\"isSaving\"\n          data-test=\"edit comment\"\n          class=\"el-textarea__inner\"\n          placeholder=\"Enter your comment\"\n          rows=\"6\"\n        />\n      </div>\n    </ElForm>\n    <div class=\"btn-group align-end\">\n      <TfButton\n        type=\"secondary\"\n        size=\"medium\"\n        data-test=\"cancel comment\"\n        @click=\"onClickCancel\"\n      >\n        Cancel\n      </TfButton>\n      <TfButton\n        :disabled=\"!commentValue || disableSubmit\"\n        :loading=\"isSaving\"\n        data-test=\"send comment\"\n        type=\"primary\"\n        size=\"medium\"\n        @click=\"onClickSubmit\"\n      >\n        Send\n      </TfButton>\n    </div>\n    <p\n      v-if=\"errorOnSubmit\"\n      class=\"text-error\"\n      v-text=\"errorOnSubmit\"\n    />\n  </div>\n</template>\n<script>\n/**\n * The Comments input component.\n *\n * @vuedoc\n * @exports Comments/Input\n * @category Components\n */\n  export default {\n    name: 'CommentInput',\n    props: {\n      apiConfig: {\n        type: Object,\n        default: () => ({}),\n      },\n      applicationNamespace: {\n        type: String,\n        default: '',\n        required: true,\n      },\n      autoSaveTimestamp: {\n        type: String,\n        default: null,\n      },\n      comment: {\n        type: Object,\n        default: () => ({}),\n      },\n      commentableIds: {\n        type: Array,\n        default: () => [],\n      },\n      customSessionName: {\n        type: String,\n        default: null,\n      },\n      disableSubmit: {\n        type: Boolean,\n        default: false,\n      },\n      inlineSuccess: {\n        type: Boolean,\n        default: true,\n      },\n      parentId: {\n        type: Number,\n        default: null,\n      },\n      projectId: {\n        type: [Number, String],\n        default: '',\n        required: true,\n      },\n      proposalDocumentId: {\n        type: Number,\n        default: null,\n      },\n      saveSession: {\n        type: Boolean,\n        default: true,\n      },\n      showLabel: {\n        type: Boolean,\n        default: true,\n      },\n      userInfo: {\n        type: Object,\n        required: true,\n        default: () => ({\n          firstName: '',\n          lastName: '',\n          organization: '',\n          type: 'broker',\n        }),\n      },\n      value: {\n        type: String,\n        required: true,\n        default: '',\n      },\n    },\n\n    data: () => ({\n      errorOnSubmit: null,\n      timestamp: '',\n      isSaving: false,\n      timer: 0,\n    }),\n\n    computed: {\n      /**\n       * get(): returns the v-model from the parent\n       * set(): emits to the parent new model.\n       *\n       * @returns {string}\n       */\n      commentValue: {\n        get() {\n          return this.value;\n        },\n        set(value) {\n          this.$emit('input', value);\n\n          if (this.saveSession) {\n            this.updateSession(value);\n          }\n        },\n      },\n\n      /**\n       * Formats this.autoSaveTimestamp to use in the template.\n       *\n       * @returns {string}\n       */\n      formattedTimestamp() {\n        return this.$TF.DatesUtils.formatDateAndTime(this.timestamp);\n      },\n\n      /**\n       * Formats a default label based on user info.\n       *\n       * @returns {string}\n       */\n      label() {\n        const { firstName, lastName, organization } = this.userInfo;\n\n        return `${firstName} ${lastName} at ${organization}`;\n      },\n\n      /**\n       * Formats this.autoSaveTimestamp to use in the template.\n       *\n       * @returns {string}\n       */\n      sessionName() {\n        return this.customSessionName || `comment-${this.comment.id}`;\n      },\n    },\n\n    /**\n     * The parent controls if there is an inital timestamp from session\n     * so we should pass it as a prop there and set it on create here.\n     */\n    created() {\n      if (this.autoSaveTimestamp) {\n        this.timestamp = this.autoSaveTimestamp;\n      }\n    },\n\n    methods: {\n      /**\n       * Debounce on value change and update the session storage every 3 second unless the user is typing.\n       *\n       * @param {string} message\n       */\n      updateSession(message) {\n        clearTimeout(this.timer);\n\n        this.timer = setTimeout(() => {\n          if (this.isSaving) {\n            return;\n          }\n\n          this.timestamp = new Date(new Date().getTime()).toISOString();\n\n          const commentObject = JSON.stringify({\n            message,\n            projectId: this.projectId,\n            timestamp: this.timestamp,\n          });\n\n          window.sessionStorage.setItem(this.sessionName, commentObject);\n        }, 3000);\n      },\n\n      /**\n       * Removes the session and emits 'cancel' to the parent.\n       */\n      onClickCancel() {\n        if (this.saveSession) {\n          window.sessionStorage.removeItem(this.sessionName);\n          clearTimeout(this.timer);\n        }\n\n        this.$emit('cancel');\n      },\n\n      /**\n       * Submits the comment and emits 'commentAdded' to the parent.\n       */\n      onClickSubmit() {\n        let commentableIds = this.proposalDocumentId || this.comment.commentable_id;\n\n        this.isSaving = true;\n        this.errorOnSubmit = null;\n\n        if (this.commentableIds.length) {\n          commentableIds = this.commentableIds;\n        }\n\n        this.$TF.CommentService\n          .postComment({\n            applicationNamespace: this.applicationNamespace,\n            content: this.commentValue,\n            commentableIds,\n            parentId: this.parentId,\n          }, this.apiConfig)\n          .then((data) => {\n            const newComments = Array.isArray(data.comments)\n              ? data.comments\n              : [data.comment];\n            const orderedComments = newComments.map((comment) => ({\n              ...comment,\n              showSuccess: this.inlineSuccess,\n            }));\n            if (!this.inlineSuccess) {\n              this.$message({\n                showClose: true,\n                message: 'Your comment has been sent to your broker.',\n                type: 'success',\n                duration: 5000,\n              });\n            }\n            orderedComments.forEach(() => {\n              window.sessionStorage.removeItem(this.sessionName);\n            });\n            this.$emit('commentAdded', orderedComments);\n          })\n          .catch(() => {\n            this.errorOnSubmit = 'There was an error submitting the comment.';\n          })\n          .finally(() => {\n            this.isSaving = false;\n            this.errorOnSubmit = null;\n\n            if (this.saveSession) {\n              clearTimeout(this.timer);\n            }\n          });\n      },\n    },\n\n    destroy() {\n      if (this.saveSession) {\n        clearTimeout(this.timer);\n      }\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n  @import 'src/assets/styles/mixins';\n\n  p {\n    margin-bottom: 0;\n  }\n\n  .autosave-fade {\n    &-enter-active,\n    &-leave-active {\n      transition: all .75s;\n      max-height: 50px;\n    }\n\n    &-enter,\n    &-leave-to /* .fade-leave-active below version 2.1.8 */ {\n      opacity: 0;\n      max-height: 0;\n    }\n  }\n\n  .timestamp {\n    color: $tf-medium-gray;\n    text-align: right;\n  }\n\n  .comment-input-container.has-label {\n    margin-top: 12px;\n  }\n\n  .el-textarea {\n    margin: 10px 0 15px;\n  }\n\n  .text-error {\n    text-align: right;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$g = "data-v-357dafe0";
  /* module identifier */
  const __vue_module_identifier__$g = undefined;
  /* functional template */
  const __vue_is_functional_template__$g = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$g = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The callout component is essentially a comment box that is to be attached to a plan design value.
 * Currently, callouts should only be made for values that are deviated from the in-force value.
 * With the benefit callout comments feature, we are removing the need for the plan design value to be deviated.
 *
 * @vuedoc
 * @exports components/CpCallout
 * @category Components
 */
var script$h = {
  name: 'CpCallout',
  props: {
    /**
     * Whether or not the callout should be appended to the body.
     */
    appendToBody: {
      type: Boolean,
      default: true
    },
    /**
     * An array of callouts to be displayed in the component.
     */
    callouts: {
      type: Array,
      default: null
    },
    /**
     * The character limit for the callout.
     */
    charLimit: {
      type: Number,
      default: 256
    },
    /**
     * @deprecated
     * The text to display in the callout.
     */
    note: {
      type: String,
      default: ''
    },
    /**
     * @deprecated
     * Whether or not the callout is readonly.
     */
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Whether or not the callout is open.
     */
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * @deprecated
     * Whether or not the callout has been read.
     */
    isRead: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      localNote: null,
      replyOpen: false
    };
  },
  computed: {
    /**
     * Compute the remaining characters to be used for validation and template text.
     *
     * @returns {number} charLimit value
     */
    charsLeft: function charsLeft() {
      return this.charLimit - this.inputModel.length;
    },
    /**
     * Format the character count to be used within the template.
     *
     * @returns {string} formatted string
     */
    charsCountText: function charsCountText() {
      var count = Math.abs(this.charsLeft);
      var text = "".concat(count, " character");
      if (count !== 1) {
        text += 's';
      }
      if (this.limitExceeded) {
        text += ' over limit';
      }
      return text;
    },
    /**
     * Validate the input model against the note param for logic and style purposes.
     *
     * @returns {boolean} chars under charLimit
     */
    hasChanges: function hasChanges() {
      return this.inputModel && this.inputModel !== this.note;
    },
    /**
     * Character count validation used for logic and style purposes.
     *
     * @returns {boolean}
     */
    limitExceeded: function limitExceeded() {
      return this.charsLeft < 0;
    },
    inputModel: {
      /**
       * use localNote if exists otherwise grab from prop
       *
       * @returns {string}
       */
      get: function get() {
        return this.localNote === null ? this.note : this.localNote;
      },
      /**
       * set localNote data prop to new value
       *
       * @param {string} newValue
       */
      set: function set(newValue) {
        this.localNote = newValue;
      }
    }
  },
  watch: {
    /**
     * whenever visible becomes true, auto focus to the input text area.
     *
     * @param {boolean} isVisible
     */
    visible: function visible(isVisible) {
      if (isVisible && !this.readonly) {
        if (this.callouts && !this.callouts.length) {
          this.replyOpen = true;
        }
        this.focusOnInput();
      }
      if (!isVisible) {
        this.replyOpen = false;
      }
    },
    /**
     * Whenever a callout is added to the list, thus resizing the tooltip,
     * adjust the position of the tooltip by faking a scroll event so that
     * it continues to point its arrow at the correct element.
     */
    callouts: function callouts() {
      window.dispatchEvent(new Event('scroll'));
    }
  },
  methods: {
    /**
     * click x closes call out and clears text
     */
    closeCallOut: function closeCallOut() {
      this.localNote = null;
      this.$emit('update:visible', false);
    },
    /**
     * clears local text in popover
     */
    clearLocalNote: function clearLocalNote() {
      this.localNote = null;
    },
    /**
     * Forces focus on the callout input.
     */
    focusOnInput: function focusOnInput() {
      var _this = this;
      this.$nextTick(function () {
        setTimeout(function () {
          if (!_this.$refs.calloutInput) {
            return;
          }

          // we have to grab the textarea ref in order to do the next line
          var textarea = _this.$refs.calloutInput.$refs.textarea;
          // the next two lines ensure the text cursor starts at the end of the text value
          textarea.selectionEnd = textarea.value.length;
          textarea.selectionStart = textarea.selectionEnd;
          textarea.focus();
        }, 100);
      });
    },
    /**
     * Toggles the replyOpen state. Without the timeout, the callout
     * closes whenever the user clicks anything that would change the replyOpen state.
     */
    toggleReply: function toggleReply() {
      var _this2 = this;
      setTimeout(function () {
        _this2.replyOpen = !_this2.replyOpen;
        if (_this2.replyOpen) {
          _this2.focusOnInput();
        }

        // Fire a fake scroll event in order to force the tooltip to reposition itself after tooltip resize.
        window.dispatchEvent(new Event('scroll'));
      }, 100);
    },
    /**
     * Deletes a comment
     */
    removeCallOut: function removeCallOut() {
      this.localNote = null;
      this.$emit('removeCallout');
    },
    /**
     * Saves or edits the callout note. If we have an array of callouts,
     * we are using the new benefit comments feature flow.
     *
     */
    saveCallout: function saveCallout() {
      if (this.callouts) {
        this.$emit('addCallout', this.localNote);
        this.toggleReply();
        this.clearLocalNote();
        return;
      }
      if (this.hasChanges && !this.limitExceeded) {
        if (this.note) {
          this.$emit('editCallout', this.localNote);
        } else {
          this.$emit('addCallout', this.localNote);
        }
      }
    }
  }
};

/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "TfTooltip",
    {
      attrs: {
        "force-show": _vm.visible,
        "show-close": _vm.visible,
        options: { placement: "top-start" },
        trigger: "clickToOpen",
        "append-to-body": _vm.appendToBody,
        "custom-class": {
          "callout-tooltip": true,
          "is-read": _vm.isRead,
        },
      },
      on: { documentClick: _vm.closeCallOut, hide: _vm.closeCallOut },
    },
    [
      _c("template", { slot: "reference" }, [_vm._t("reference")], 2),
      _vm._v(" "),
      _c(
        "section",
        { attrs: { "data-test": "callout tooltip" } },
        [
          _vm.callouts
            ? [
                _c("header", [_c("h5", [_vm._v("Benefit call-out")])]),
                _vm._v(" "),
                _vm.callouts.length
                  ? [
                      _c(
                        "div",
                        { staticClass: "callout-list" },
                        _vm._l(_vm.callouts, function (ref, index) {
                          var id = ref.id;
                          var user = ref.user;
                          var calloutNote = ref.note;
                          var created_at = ref.created_at;
                          return _c(
                            "article",
                            {
                              key: id,
                              attrs: { "data-test": "callout comment" },
                            },
                            [
                              _c(
                                "h6",
                                {
                                  attrs: {
                                    "data-test": "callout." + index + " sender",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "user-name" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          user
                                            ? user.first_name +
                                                " " +
                                                user.last_name
                                            : "Unknown"
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "date-sent" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$TF.DatesUtils.formatSimpleDate(
                                            created_at,
                                            "MM/DD/YYYY"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  attrs: {
                                    "data-test": "callout." + index + " reason",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(calloutNote) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      !_vm.replyOpen
                        ? _c(
                            "AppButton",
                            {
                              staticClass: "reply-button",
                              attrs: {
                                "data-test": "reply to callout",
                                type: "primary",
                                size: "text",
                              },
                              on: { click: _vm.toggleReply },
                            },
                            [_vm._v("\n          Reply\n        ")]
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.replyOpen
                  ? [
                      _c("ElInput", {
                        ref: "calloutInput",
                        class: { error: _vm.limitExceeded },
                        attrs: {
                          type: "textarea",
                          rows: "6",
                          "data-test": "enter callout note",
                        },
                        model: {
                          value: _vm.inputModel,
                          callback: function ($$v) {
                            _vm.inputModel = $$v;
                          },
                          expression: "inputModel",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "footer" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "small-text",
                              attrs: { "data-test": "callout word count" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "word-count",
                                  class: { error: _vm.limitExceeded },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.charsCountText) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("AppButton", {
                            attrs: {
                              "data-test": "save callout",
                              icon: "fa-solid fa-check",
                              size: "icon",
                              type: "success",
                              text: "save callout",
                              "is-disabled":
                                _vm.limitExceeded || !_vm.hasChanges,
                            },
                            on: { click: _vm.saveCallout },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ]
            : [
                _c("header", [
                  _c("h5", { attrs: { "data-test": "callout title" } }, [
                    _vm._v("\n          Benefit call-out\n          "),
                    _vm.isRead ? _c("span", [_vm._v(" - read")]) : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _vm.readonly
                  ? _c("p", {
                      attrs: { "data-test": "callout reason" },
                      domProps: { textContent: _vm._s(_vm.note) },
                    })
                  : [
                      _c("ElInput", {
                        ref: "calloutInput",
                        class: { error: _vm.limitExceeded },
                        attrs: { type: "textarea", rows: "6" },
                        model: {
                          value: _vm.inputModel,
                          callback: function ($$v) {
                            _vm.inputModel = $$v;
                          },
                          expression: "inputModel",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "footer" }, [
                        _c(
                          "div",
                          {
                            staticClass: "small-text",
                            attrs: { "data-test": "callout word count" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "word-count",
                                class: { error: _vm.limitExceeded },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.charsCountText) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-group" },
                          [
                            _vm.note
                              ? _c("AppButton", {
                                  attrs: {
                                    "data-test": "delete callout",
                                    icon: "fa-solid fa-trash",
                                    size: "icon",
                                    type: "danger",
                                    text: "delete callout",
                                  },
                                  on: { click: _vm.removeCallOut },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("AppButton", {
                              attrs: {
                                "data-test": "save callout",
                                icon: "fa-solid fa-check",
                                size: "icon",
                                type: "success",
                                text: "save callout",
                                "is-disabled":
                                  _vm.limitExceeded || !_vm.hasChanges,
                              },
                              on: { click: _vm.saveCallout },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
              ],
        ],
        2
      ),
    ],
    2
  )
};
var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;

  /* style */
  const __vue_inject_styles__$h = function (inject) {
    if (!inject) return
    inject("data-v-1a6c37d9_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nsection[data-v-1a6c37d9] {\n  text-align: left;\n  color: var(--tf-gray-dark);\n  width: 273px;\n}\nheader[data-v-1a6c37d9] {\n  margin-bottom: 10px;\n}\n.callout-list[data-v-1a6c37d9] {\n  max-height: 300px;\n  overflow-y: auto;\n  margin-bottom: 10px;\n}\narticle .user-name[data-v-1a6c37d9] {\n  font-weight: 500;\n  font-size: 14px;\n  margin-bottom: 5px;\n}\narticle .date-sent[data-v-1a6c37d9] {\n  color: var(--tf-gray);\n  font-size: 12px;\n}\narticle p[data-v-1a6c37d9] {\n  color: var(--tf-gray-dark);\n  margin: 0 0 10px;\n}\n[data-v-1a6c37d9] .el-textarea textarea {\n  resize: none;\n}\n[data-v-1a6c37d9] .el-textarea__inner {\n  width: 273px;\n}\n.is-read[data-v-1a6c37d9]  .tf-popper {\n  border: 1px var(--tf-success) solid;\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-enable selector-max-compound-selectors */\n}\n.is-read[data-v-1a6c37d9]  .tf-popper[x-placement^=top] .popper__arrow {\n  border-color: var(--tf-success) transparent transparent;\n}\n.is-read[data-v-1a6c37d9]  .tf-popper[x-placement^=bottom] .popper__arrow {\n  border-color: transparent transparent var(--tf-success);\n}\n.is-read[data-v-1a6c37d9]  .tf-popper[x-placement^=right] .popper__arrow {\n  border-color: transparent var(--tf-success) transparent transparent;\n}\n.is-read[data-v-1a6c37d9]  .tf-popper[x-placement^=left] .popper__arrow {\n  border-color: transparent transparent transparent var(--tf-success);\n}\n.is-read h5[data-v-1a6c37d9] {\n  color: var(--tf-success);\n}\n.error.word-count[data-v-1a6c37d9] {\n  color: var(--tf-red);\n}\n.error[data-v-1a6c37d9]  .el-textarea__inner {\n  border-color: var(--tf-red);\n}\np[data-v-1a6c37d9] {\n  color: var(--tf-black);\n}\n.footer[data-v-1a6c37d9] {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n/*# sourceMappingURL=CpCallout.vue.map */", map: {"version":3,"sources":["CpCallout.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/CpCallout.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACgZlC;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;AD9YA;ACiZA;EACA,mBAAA;AD9YA;ACiZA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AD9YA;ACkZA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AD/YA;ACkZA;EACA,qBAAA;EACA,eAAA;ADhZA;ACmZA;EACA,0BAAA;EACA,gBAAA;ADjZA;ACsZA;EACA,YAAA;ADnZA;ACsZA;EACA,YAAA;ADpZA;ACyZA;EACA,mCAAA;EAEA,sDAAA;EAwBA,qDAAA;AD9aA;ACwZA;EACA,uDAAA;ADtZA;AC2ZA;EACA,uDAAA;ADzZA;AC8ZA;EACA,mEAAA;AD5ZA;ACiaA;EACA,mEAAA;AD/ZA;ACqaA;EACA,wBAAA;ADnaA;ACwaA;EACA,oBAAA;ADraA;ACwaA;EACA,2BAAA;ADtaA;AC0aA;EACA,sBAAA;ADvaA;AC0aA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;ADvaA;;AAEA,wCAAwC","file":"CpCallout.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nsection {\n  text-align: left;\n  color: var(--tf-gray-dark);\n  width: 273px;\n}\n\nheader {\n  margin-bottom: 10px;\n}\n\n.callout-list {\n  max-height: 300px;\n  overflow-y: auto;\n  margin-bottom: 10px;\n}\n\narticle .user-name {\n  font-weight: 500;\n  font-size: 14px;\n  margin-bottom: 5px;\n}\narticle .date-sent {\n  color: var(--tf-gray);\n  font-size: 12px;\n}\narticle p {\n  color: var(--tf-gray-dark);\n  margin: 0 0 10px;\n}\n\n::v-deep .el-textarea textarea {\n  resize: none;\n}\n::v-deep .el-textarea__inner {\n  width: 273px;\n}\n\n.is-read ::v-deep .tf-popper {\n  border: 1px var(--tf-success) solid;\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-enable selector-max-compound-selectors */\n}\n.is-read ::v-deep .tf-popper[x-placement^=top] .popper__arrow {\n  border-color: var(--tf-success) transparent transparent;\n}\n.is-read ::v-deep .tf-popper[x-placement^=bottom] .popper__arrow {\n  border-color: transparent transparent var(--tf-success);\n}\n.is-read ::v-deep .tf-popper[x-placement^=right] .popper__arrow {\n  border-color: transparent var(--tf-success) transparent transparent;\n}\n.is-read ::v-deep .tf-popper[x-placement^=left] .popper__arrow {\n  border-color: transparent transparent transparent var(--tf-success);\n}\n.is-read h5 {\n  color: var(--tf-success);\n}\n\n.error.word-count {\n  color: var(--tf-red);\n}\n.error ::v-deep .el-textarea__inner {\n  border-color: var(--tf-red);\n}\n\np {\n  color: var(--tf-black);\n}\n\n.footer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n/*# sourceMappingURL=CpCallout.vue.map */","<template>\n  <TfTooltip\n    :force-show=\"visible\"\n    :show-close=\"visible\"\n    :options=\"{ placement: 'top-start' }\"\n    trigger=\"clickToOpen\"\n    :append-to-body=\"appendToBody\"\n    :custom-class=\"{\n      'callout-tooltip': true,\n      'is-read': isRead,\n    }\"\n    @documentClick=\"closeCallOut\"\n    @hide=\"closeCallOut\"\n  >\n    <template slot=\"reference\">\n      <slot name=\"reference\" />\n    </template>\n    <section data-test=\"callout tooltip\">\n      <template v-if=\"callouts\">\n        <header>\n          <h5>Benefit call-out</h5>\n        </header>\n        <template v-if=\"callouts.length\">\n          <div class=\"callout-list\">\n            <article\n              v-for=\"({\n                id,\n                user,\n                note: calloutNote,\n                created_at,\n              }, index) in callouts\"\n              :key=\"id\"\n              data-test=\"callout comment\"\n            >\n              <h6 :data-test=\"`callout.${index} sender`\">\n                <span class=\"user-name\">\n                  {{ user ? `${user.first_name} ${user.last_name}` : 'Unknown' }}\n                </span>\n                <span class=\"date-sent\">\n                  {{ $TF.DatesUtils.formatSimpleDate(created_at, 'MM/DD/YYYY') }}\n                </span>\n              </h6>\n              <p :data-test=\"`callout.${index} reason`\">\n                {{ calloutNote }}\n              </p>\n            </article>\n          </div>\n          <AppButton\n            v-if=\"!replyOpen\"\n            data-test=\"reply to callout\"\n            class=\"reply-button\"\n            type=\"primary\"\n            size=\"text\"\n            @click=\"toggleReply\"\n          >\n            Reply\n          </AppButton>\n        </template>\n        <template v-if=\"replyOpen\">\n          <!--\n            TW opportunity, we should either create a new component for\n            this input with a character counter and limit or add this feature\n            to the existing ElInput component. kc 2023-09-26\n          -->\n          <ElInput\n            ref=\"calloutInput\"\n            v-model=\"inputModel\"\n            :class=\"{ error: limitExceeded }\"\n            type=\"textarea\"\n            rows=\"6\"\n            data-test=\"enter callout note\"\n          />\n          <div class=\"footer\">\n            <div\n              class=\"small-text\"\n              data-test=\"callout word count\"\n            >\n              <div\n                class=\"word-count\"\n                :class=\"{ error: limitExceeded }\"\n              >\n                {{ charsCountText }}\n              </div>\n            </div>\n            <AppButton\n              data-test=\"save callout\"\n              icon=\"fa-solid fa-check\"\n              size=\"icon\"\n              type=\"success\"\n              text=\"save callout\"\n              :is-disabled=\"limitExceeded || !hasChanges\"\n              @click=\"saveCallout\"\n            />\n          </div>\n        </template>\n      </template>\n      <!-- old version of callout with no benefit comments -->\n      <template v-else>\n        <header>\n          <h5 data-test=\"callout title\">\n            Benefit call-out\n            <span v-if=\"isRead\"> - read</span>\n          </h5>\n        </header>\n        <p\n          v-if=\"readonly\"\n          data-test=\"callout reason\"\n          v-text=\"note\"\n        />\n        <template v-else>\n          <ElInput\n            ref=\"calloutInput\"\n            v-model=\"inputModel\"\n            :class=\"{ error: limitExceeded }\"\n            type=\"textarea\"\n            rows=\"6\"\n          />\n          <div class=\"footer\">\n            <div\n              class=\"small-text\"\n              data-test=\"callout word count\"\n            >\n              <div\n                class=\"word-count\"\n                :class=\"{ error: limitExceeded }\"\n              >\n                {{ charsCountText }}\n              </div>\n            </div>\n            <div class=\"btn-group\">\n              <AppButton\n                v-if=\"note\"\n                data-test=\"delete callout\"\n                icon=\"fa-solid fa-trash\"\n                size=\"icon\"\n                type=\"danger\"\n                text=\"delete callout\"\n                @click=\"removeCallOut\"\n              />\n              <AppButton\n                data-test=\"save callout\"\n                icon=\"fa-solid fa-check\"\n                size=\"icon\"\n                type=\"success\"\n                text=\"save callout\"\n                :is-disabled=\"limitExceeded || !hasChanges\"\n                @click=\"saveCallout\"\n              />\n            </div>\n          </div>\n        </template>\n      </template>\n    </section>\n  </TfTooltip>\n</template>\n\n<script>\n  /**\n   * The callout component is essentially a comment box that is to be attached to a plan design value.\n   * Currently, callouts should only be made for values that are deviated from the in-force value.\n   * With the benefit callout comments feature, we are removing the need for the plan design value to be deviated.\n   *\n   * @vuedoc\n   * @exports components/CpCallout\n   * @category Components\n   */\n  export default {\n    name: 'CpCallout',\n    props: {\n      /**\n       * Whether or not the callout should be appended to the body.\n       */\n      appendToBody: {\n        type: Boolean,\n        default: true,\n      },\n      /**\n       * An array of callouts to be displayed in the component.\n       */\n      callouts: {\n        type: Array,\n        default: null,\n      },\n      /**\n       * The character limit for the callout.\n       */\n      charLimit: {\n        type: Number,\n        default: 256,\n      },\n      /**\n       * @deprecated\n       * The text to display in the callout.\n       */\n      note: {\n        type: String,\n        default: '',\n      },\n      /**\n       * @deprecated\n       * Whether or not the callout is readonly.\n       */\n      readonly: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Whether or not the callout is open.\n       */\n      visible: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * @deprecated\n       * Whether or not the callout has been read.\n       */\n      isRead: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: () => ({\n      localNote: null,\n      replyOpen: false,\n    }),\n    computed: {\n      /**\n       * Compute the remaining characters to be used for validation and template text.\n       *\n       * @returns {number} charLimit value\n       */\n      charsLeft() {\n        return this.charLimit - this.inputModel.length;\n      },\n      /**\n       * Format the character count to be used within the template.\n       *\n       * @returns {string} formatted string\n       */\n      charsCountText() {\n        const count = Math.abs(this.charsLeft);\n        let text = `${count} character`;\n\n        if (count !== 1) {\n          text += 's';\n        }\n\n        if (this.limitExceeded) {\n          text += ' over limit';\n        }\n\n        return text;\n      },\n      /**\n       * Validate the input model against the note param for logic and style purposes.\n       *\n       * @returns {boolean} chars under charLimit\n       */\n      hasChanges() {\n        return this.inputModel && this.inputModel !== this.note;\n      },\n      /**\n       * Character count validation used for logic and style purposes.\n       *\n       * @returns {boolean}\n       */\n      limitExceeded() {\n        return this.charsLeft < 0;\n      },\n      inputModel: {\n        /**\n         * use localNote if exists otherwise grab from prop\n         *\n         * @returns {string}\n         */\n        get() {\n          return this.localNote === null ? this.note : this.localNote;\n        },\n        /**\n         * set localNote data prop to new value\n         *\n         * @param {string} newValue\n         */\n        set(newValue) {\n          this.localNote = newValue;\n        },\n      },\n    },\n    watch: {\n      /**\n       * whenever visible becomes true, auto focus to the input text area.\n       *\n       * @param {boolean} isVisible\n       */\n      visible(isVisible) {\n        if (isVisible && !this.readonly) {\n          if (this.callouts && !this.callouts.length) {\n            this.replyOpen = true;\n          }\n\n          this.focusOnInput();\n        }\n\n        if (!isVisible) {\n          this.replyOpen = false;\n        }\n      },\n      /**\n       * Whenever a callout is added to the list, thus resizing the tooltip,\n       * adjust the position of the tooltip by faking a scroll event so that\n       * it continues to point its arrow at the correct element.\n       */\n      callouts() {\n        window.dispatchEvent(new Event('scroll'));\n      },\n    },\n    methods: {\n      /**\n       * click x closes call out and clears text\n       */\n      closeCallOut() {\n        this.localNote = null;\n        this.$emit('update:visible', false);\n      },\n      /**\n       * clears local text in popover\n       */\n      clearLocalNote() {\n        this.localNote = null;\n      },\n      /**\n       * Forces focus on the callout input.\n       */\n      focusOnInput() {\n        this.$nextTick(() => {\n          setTimeout(() => {\n            if (!this.$refs.calloutInput) {\n              return;\n            }\n\n            // we have to grab the textarea ref in order to do the next line\n            const { textarea } = this.$refs.calloutInput.$refs;\n            // the next two lines ensure the text cursor starts at the end of the text value\n            textarea.selectionEnd = textarea.value.length;\n            textarea.selectionStart = textarea.selectionEnd;\n            textarea.focus();\n          }, 100);\n        });\n      },\n      /**\n       * Toggles the replyOpen state. Without the timeout, the callout\n       * closes whenever the user clicks anything that would change the replyOpen state.\n       */\n      toggleReply() {\n        setTimeout(() => {\n          this.replyOpen = !this.replyOpen;\n\n          if (this.replyOpen) {\n            this.focusOnInput();\n          }\n\n          // Fire a fake scroll event in order to force the tooltip to reposition itself after tooltip resize.\n          window.dispatchEvent(new Event('scroll'));\n        }, 100);\n      },\n      /**\n       * Deletes a comment\n       */\n      removeCallOut() {\n        this.localNote = null;\n        this.$emit('removeCallout');\n      },\n      /**\n       * Saves or edits the callout note. If we have an array of callouts,\n       * we are using the new benefit comments feature flow.\n       *\n       */\n      saveCallout() {\n        if (this.callouts) {\n          this.$emit('addCallout', this.localNote);\n          this.toggleReply();\n          this.clearLocalNote();\n\n          return;\n        }\n\n        if (this.hasChanges && !this.limitExceeded) {\n          if (this.note) {\n            this.$emit('editCallout', this.localNote);\n          } else {\n            this.$emit('addCallout', this.localNote);\n          }\n        }\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  section {\n    text-align: left;\n    color: var(--tf-gray-dark);\n    width: 273px;\n  }\n\n  header {\n    margin-bottom: 10px;\n  }\n\n  .callout-list {\n    max-height: 300px;\n    overflow-y: auto;\n    margin-bottom: 10px;\n  }\n\n  article {\n    .user-name {\n      font-weight: 500;\n      font-size: 14px;\n      margin-bottom: 5px;\n    }\n\n    .date-sent {\n      color: var(--tf-gray);\n      font-size: 12px;\n    }\n\n    p {\n      color: var(--tf-gray-dark);\n      margin: 0 0 10px;\n    }\n  }\n\n  ::v-deep {\n    .el-textarea textarea {\n      resize: none;\n    }\n\n    .el-textarea__inner {\n      width: 273px;\n    }\n  }\n\n  .is-read {\n    ::v-deep .tf-popper {\n      border: 1px var(--tf-success) solid;\n\n      /* stylelint-disable selector-max-compound-selectors */\n      &[x-placement^='top'] {\n        .popper__arrow {\n          border-color: var(--tf-success) transparent transparent;\n        }\n      }\n\n      &[x-placement^='bottom'] {\n        .popper__arrow {\n          border-color: transparent transparent var(--tf-success);\n        }\n      }\n\n      &[x-placement^='right'] {\n        .popper__arrow {\n          border-color: transparent var(--tf-success) transparent transparent;\n        }\n      }\n\n      &[x-placement^='left'] {\n        .popper__arrow {\n          border-color: transparent transparent transparent var(--tf-success);\n        }\n      }\n      /* stylelint-enable selector-max-compound-selectors */\n    }\n\n    h5 {\n      color: var(--tf-success);\n    }\n  }\n\n  .error {\n    &.word-count {\n      color: var(--tf-red);\n    }\n\n    & ::v-deep .el-textarea__inner {\n      border-color: var(--tf-red);\n    }\n  }\n\n  p {\n    color: var(--tf-black);\n  }\n\n  .footer {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 10px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$h = "data-v-1a6c37d9";
  /* module identifier */
  const __vue_module_identifier__$h = undefined;
  /* functional template */
  const __vue_is_functional_template__$h = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$h = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$i = {
  name: 'CopyLinkContainer',
  props: {
    text: {
      type: String,
      default: null
    },
    link: {
      type: String,
      default: null
    },
    linkType: {
      type: String,
      default: 'secondary'
    }
  },
  data: function data() {
    return {
      tooltipOpacity: 0
    };
  },
  methods: {
    /**
     * Copy the "Share Link" to the users clipboard
     */
    copyLink: function copyLink() {
      var _this = this;
      this.tooltipOpacity = 1;
      this.$refs.shareLink.select();
      document.execCommand('copy');
      clearTimeout(this.timeout);
      this.timeout = window.setTimeout(function () {
        _this.tooltipOpacity = 0;
      }, 3000);
    }
  }
};

/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "copy-link-container" }, [
    _c("div", { staticClass: "copy-link-body" }, [
      _vm._v("\n    " + _vm._s(_vm.text) + "\n    "),
      _c("input", {
        ref: "shareLink",
        attrs: { "data-test": "share link", readonly: "" },
        domProps: { value: _vm.link },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "button-container" },
      [
        _c(
          "TfButton",
          {
            attrs: {
              type: "secondary",
              size: "medium",
              "data-test": "copy link",
            },
            on: { click: _vm.copyLink },
          },
          [_vm._v("\n      Copy link\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tooltip__popper is-dark copied-popper",
            style: "opacity: " + _vm.tooltipOpacity,
            attrs: { "x-placement": "top", "data-test": "copied popper" },
          },
          [
            _vm._v("\n      Copied!\n      "),
            _c("div", {
              staticClass: "popper__arrow",
              attrs: { "x-arrow": "" },
            }),
          ]
        ),
      ],
      1
    ),
  ])
};
var __vue_staticRenderFns__$i = [];
__vue_render__$i._withStripped = true;

  /* style */
  const __vue_inject_styles__$i = function (inject) {
    if (!inject) return
    inject("data-v-f3ab101c_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.copy-link-container[data-v-f3ab101c] {\n  background: #fff;\n  border: 1px #efefef solid;\n  box-sizing: border-box;\n  padding: 25px 20px 25px 15px;\n  position: relative;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n}\n.copy-link-container .el-tooltip__popper[data-v-f3ab101c] {\n  width: auto;\n  color: #fff;\n  position: absolute;\n  right: 39px;\n  top: -15px;\n  transition: opacity 300ms;\n}\n.copy-link-container .el-tooltip__popper.copied-popper .popper__arrow[data-v-f3ab101c] {\n  left: 24.5px;\n}\n.copy-link-body[data-v-f3ab101c] {\n  font-size: 14px;\n  display: inline-block;\n  color: #42474c;\n  flex-grow: 1;\n  margin-right: 15px;\n}\n.copy-link-body input[data-v-f3ab101c] {\n  color: #009;\n  font-weight: bold;\n  background: transparent;\n  border: 0;\n  display: block;\n  width: 100%;\n  height: 15px;\n  margin-top: 2px;\n  text-overflow: ellipsis;\n}\n.button-container[data-v-f3ab101c] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n/*# sourceMappingURL=CopyLinkContainer.vue.map */", map: {"version":3,"sources":["CopyLinkContainer.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/CopyLinkContainer.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;kCAEkC;ACwElC;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;ADtEA;ACwEA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;ADtEA;ACyEA;EACA,YAAA;ADvEA;AC2EA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;ADxEA;AC0EA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;ADxEA;AC4EA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;ADzEA;;AAEA,gDAAgD","file":"CopyLinkContainer.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.copy-link-container {\n  background: #fff;\n  border: 1px #efefef solid;\n  box-sizing: border-box;\n  padding: 25px 20px 25px 15px;\n  position: relative;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n}\n.copy-link-container .el-tooltip__popper {\n  width: auto;\n  color: #fff;\n  position: absolute;\n  right: 39px;\n  top: -15px;\n  transition: opacity 300ms;\n}\n.copy-link-container .el-tooltip__popper.copied-popper .popper__arrow {\n  left: 24.5px;\n}\n\n.copy-link-body {\n  font-size: 14px;\n  display: inline-block;\n  color: #42474c;\n  flex-grow: 1;\n  margin-right: 15px;\n}\n.copy-link-body input {\n  color: #009;\n  font-weight: bold;\n  background: transparent;\n  border: 0;\n  display: block;\n  width: 100%;\n  height: 15px;\n  margin-top: 2px;\n  text-overflow: ellipsis;\n}\n\n.button-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n/*# sourceMappingURL=CopyLinkContainer.vue.map */","<template>\n  <div class=\"copy-link-container\">\n    <div class=\"copy-link-body\">\n      {{ text }}\n      <input\n        ref=\"shareLink\"\n        :value=\"link\"\n        data-test=\"share link\"\n        readonly\n      >\n    </div>\n    <div class=\"button-container\">\n      <TfButton\n        type=\"secondary\"\n        size=\"medium\"\n        data-test=\"copy link\"\n        @click=\"copyLink\"\n      >\n        Copy link\n      </TfButton>\n      <div\n        :style=\"`opacity: ${tooltipOpacity}`\"\n        class=\"el-tooltip__popper is-dark copied-popper\"\n        x-placement=\"top\"\n        data-test=\"copied popper\"\n      >\n        Copied!\n        <div\n          x-arrow=\"\"\n          class=\"popper__arrow\"\n        />\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\n  export default {\n    name: 'CopyLinkContainer',\n    props: {\n      text: {\n        type: String,\n        default: null,\n      },\n      link: {\n        type: String,\n        default: null,\n      },\n      linkType: {\n        type: String,\n        default: 'secondary',\n      },\n    },\n    data: () => ({\n      tooltipOpacity: 0,\n    }),\n    methods: {\n      /**\n       * Copy the \"Share Link\" to the users clipboard\n       */\n      copyLink() {\n        this.tooltipOpacity = 1;\n        this.$refs.shareLink.select();\n        document.execCommand('copy');\n        clearTimeout(this.timeout);\n        this.timeout = window.setTimeout(() => {\n          this.tooltipOpacity = 0;\n        }, 3000);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n  @import 'src/assets/styles/mixins';\n\n  .copy-link-container {\n    background: $tf-white;\n    border: 1px $tf-extra-light-gray-1 solid;\n    box-sizing: border-box;\n    padding: 25px 20px 25px 15px;\n    position: relative;\n    text-align: left;\n    display: flex;\n    justify-content: space-between;\n\n    .el-tooltip__popper {\n      width: auto;\n      color: $tf-white;\n      position: absolute;\n      right: 39px;\n      top: -15px;\n      transition: opacity 300ms;\n    }\n\n    .el-tooltip__popper.copied-popper .popper__arrow {\n      left: 24.5px;\n    }\n  }\n\n  .copy-link-body {\n    font-size: 14px;\n    display: inline-block;\n    color: $tf-dark-gray;\n    flex-grow: 1;\n    margin-right: 15px;\n\n    input {\n      color: $tf-blue;\n      font-weight: bold;\n      background: transparent;\n      border: 0;\n      display: block;\n      width: 100%;\n      height: 15px;\n      margin-top: 2px;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .button-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$i = "data-v-f3ab101c";
  /* module identifier */
  const __vue_module_identifier__$i = undefined;
  /* functional template */
  const __vue_is_functional_template__$i = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$i = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    false,
    browser,
    undefined,
    undefined
  );

var toString$2 = {}.toString;

var _cof$1 = function (it) {
  return toString$2.call(it).slice(8, -1);
};

// 7.2.2 IsArray(argument)

var _isArray$1 = Array.isArray || function isArray(arg) {
  return _cof$1(arg) == 'Array';
};

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)


_export$1(_export$1.S, 'Array', { isArray: _isArray$1 });

var isArray$1 = _core$1.Array.isArray;

var isArray$2 = isArray$1;

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (isArray$2(arr)) return _arrayLikeToArray(arr);
}

var _redefine$1 = _hide$1;

var id$1 = 0;
var px$1 = Math.random();
var _uid$1 = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id$1 + px$1).toString(36));
};

var _meta = createCommonjsModule(function (module) {
var META = _uid$1('meta');


var setDesc = _objectDp$1.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails$1(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject$1(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has$1(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has$1(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has$1(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;

var _library = true;

var _shared$1 = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global$1[SHARED] || (_global$1[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core$1.version,
  mode:  'pure' ,
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var _wks$1 = createCommonjsModule(function (module) {
var store = _shared$1('wks');

var Symbol = _global$1.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid$1)('Symbol.' + name));
};

$exports.store = store;
});

var def$1 = _objectDp$1.f;

var TAG$2 = _wks$1('toStringTag');

var _setToStringTag$1 = function (it, tag, stat) {
  if (it && !_has$1(it = stat ? it : it.prototype, TAG$2)) def$1(it, TAG$2, { configurable: true, value: tag });
};

var f$6 = _wks$1;

var _wksExt = {
	f: f$6
};

var defineProperty$3 = _objectDp$1.f;
var _wksDefine = function (name) {
  var $Symbol = _core$1.Symbol || (_core$1.Symbol =  {} );
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty$3($Symbol, name, { value: _wksExt.f(name) });
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject$1 = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof$1(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined$1 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject$1 = function (it) {
  return _iobject$1(_defined$1(it));
};

// 7.1.4 ToInteger
var ceil$1 = Math.ceil;
var floor$2 = Math.floor;
var _toInteger$1 = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor$2 : ceil$1)(it);
};

// 7.1.15 ToLength

var min$3 = Math.min;
var _toLength$1 = function (it) {
  return it > 0 ? min$3(_toInteger$1(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max$2 = Math.max;
var min$4 = Math.min;
var _toAbsoluteIndex$1 = function (index, length) {
  index = _toInteger$1(index);
  return index < 0 ? max$2(index + length, 0) : min$4(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject$1($this);
    var length = _toLength$1(O.length);
    var index = _toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var shared$1 = _shared$1('keys');

var _sharedKey$1 = function (key) {
  return shared$1[key] || (shared$1[key] = _uid$1(key));
};

var arrayIndexOf$1 = _arrayIncludes$1(false);
var IE_PROTO$3 = _sharedKey$1('IE_PROTO');

var _objectKeysInternal$1 = function (object, names) {
  var O = _toIobject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO$3) _has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has$1(O, key = names[i++])) {
    ~arrayIndexOf$1(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys$1 = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys$1 = Object.keys || function keys(O) {
  return _objectKeysInternal$1(O, _enumBugKeys$1);
};

var f$7 = Object.getOwnPropertySymbols;

var _objectGops$1 = {
	f: f$7
};

var f$8 = {}.propertyIsEnumerable;

var _objectPie$1 = {
	f: f$8
};

// all enumerable object keys, includes symbols



var _enumKeys = function (it) {
  var result = _objectKeys$1(it);
  var getSymbols = _objectGops$1.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie$1.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

// 7.1.13 ToObject(argument)

var _toObject$1 = function (it) {
  return Object(_defined$1(it));
};

var _objectDps$1 = _descriptors$1 ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject$1(O);
  var keys = _objectKeys$1(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp$1.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$4 = _global$1.document;
var _html$1 = document$4 && document$4.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$4 = _sharedKey$1('IE_PROTO');
var Empty$1 = function () { /* empty */ };
var PROTOTYPE$3 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict$1 = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate$1('iframe');
  var i = _enumBugKeys$1.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html$1.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict$1 = iframeDocument.F;
  while (i--) delete createDict$1[PROTOTYPE$3][_enumBugKeys$1[i]];
  return createDict$1();
};

var _objectCreate$1 = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty$1[PROTOTYPE$3] = _anObject$1(O);
    result = new Empty$1();
    Empty$1[PROTOTYPE$3] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$4] = O;
  } else result = createDict$1();
  return Properties === undefined ? result : _objectDps$1(result, Properties);
};

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys$1 = _enumBugKeys$1.concat('length', 'prototype');

var f$9 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal$1(O, hiddenKeys$1);
};

var _objectGopn$1 = {
	f: f$9
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN$1 = _objectGopn$1.f;
var toString$3 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN$1(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$a = function getOwnPropertyNames(it) {
  return windowNames && toString$3.call(it) == '[object Window]' ? getWindowNames(it) : gOPN$1(_toIobject$1(it));
};

var _objectGopnExt = {
	f: f$a
};

var gOPD$2 = Object.getOwnPropertyDescriptor;

var f$b = _descriptors$1 ? gOPD$2 : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject$1(O);
  P = _toPrimitive$1(P, true);
  if (_ie8DomDefine$1) try {
    return gOPD$2(O, P);
  } catch (e) { /* empty */ }
  if (_has$1(O, P)) return _propertyDesc$1(!_objectPie$1.f.call(O, P), O[P]);
};

var _objectGopd$1 = {
	f: f$b
};

// ECMAScript 6 symbols shim





var META = _meta.KEY;





















var gOPD$3 = _objectGopd$1.f;
var dP$4 = _objectDp$1.f;
var gOPN$2 = _objectGopnExt.f;
var $Symbol = _global$1.Symbol;
var $JSON = _global$1.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE$4 = 'prototype';
var HIDDEN = _wks$1('_hidden');
var TO_PRIMITIVE = _wks$1('toPrimitive');
var isEnum$1 = {}.propertyIsEnumerable;
var SymbolRegistry = _shared$1('symbol-registry');
var AllSymbols = _shared$1('symbols');
var OPSymbols = _shared$1('op-symbols');
var ObjectProto$1 = Object[PROTOTYPE$4];
var USE_NATIVE = typeof $Symbol == 'function' && !!_objectGops$1.f;
var QObject = _global$1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE$4] || !QObject[PROTOTYPE$4].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = _descriptors$1 && _fails$1(function () {
  return _objectCreate$1(dP$4({}, 'a', {
    get: function () { return dP$4(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$3(ObjectProto$1, key);
  if (protoDesc) delete ObjectProto$1[key];
  dP$4(it, key, D);
  if (protoDesc && it !== ObjectProto$1) dP$4(ObjectProto$1, key, protoDesc);
} : dP$4;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _objectCreate$1($Symbol[PROTOTYPE$4]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto$1) $defineProperty(OPSymbols, key, D);
  _anObject$1(it);
  key = _toPrimitive$1(key, true);
  _anObject$1(D);
  if (_has$1(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has$1(it, HIDDEN)) dP$4(it, HIDDEN, _propertyDesc$1(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has$1(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate$1(D, { enumerable: _propertyDesc$1(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP$4(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  _anObject$1(it);
  var keys = _enumKeys(P = _toIobject$1(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _objectCreate$1(it) : $defineProperties(_objectCreate$1(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum$1.call(this, key = _toPrimitive$1(key, true));
  if (this === ObjectProto$1 && _has$1(AllSymbols, key) && !_has$1(OPSymbols, key)) return false;
  return E || !_has$1(this, key) || !_has$1(AllSymbols, key) || _has$1(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject$1(it);
  key = _toPrimitive$1(key, true);
  if (it === ObjectProto$1 && _has$1(AllSymbols, key) && !_has$1(OPSymbols, key)) return;
  var D = gOPD$3(it, key);
  if (D && _has$1(AllSymbols, key) && !(_has$1(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$2(_toIobject$1(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!_has$1(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto$1;
  var names = gOPN$2(IS_OP ? OPSymbols : _toIobject$1(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (_has$1(AllSymbols, key = names[i++]) && (IS_OP ? _has$1(ObjectProto$1, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = _uid$1(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto$1) $set.call(OPSymbols, value);
      if (_has$1(this, HIDDEN) && _has$1(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc$1(1, value));
    };
    if (_descriptors$1 && setter) setSymbolDesc(ObjectProto$1, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  _redefine$1($Symbol[PROTOTYPE$4], 'toString', function toString() {
    return this._k;
  });

  _objectGopd$1.f = $getOwnPropertyDescriptor;
  _objectDp$1.f = $defineProperty;
  _objectGopn$1.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie$1.f = $propertyIsEnumerable;
  _objectGops$1.f = $getOwnPropertySymbols;

  if (_descriptors$1 && !_library) {
    _redefine$1(ObjectProto$1, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  _wksExt.f = function (name) {
    return wrap(_wks$1(name));
  };
}

_export$1(_export$1.G + _export$1.W + _export$1.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j$1 = 0; es6Symbols.length > j$1;)_wks$1(es6Symbols[j$1++]);

for (var wellKnownSymbols = _objectKeys$1(_wks$1.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

_export$1(_export$1.S + _export$1.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return _has$1(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

_export$1(_export$1.S + _export$1.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = _fails$1(function () { _objectGops$1.f(1); });

_export$1(_export$1.S + _export$1.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return _objectGops$1.f(_toObject$1(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && _export$1(_export$1.S + _export$1.F * (!USE_NATIVE || _fails$1(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!_isObject$1(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!_isArray$1(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE$4][TO_PRIMITIVE] || _hide$1($Symbol[PROTOTYPE$4], TO_PRIMITIVE, $Symbol[PROTOTYPE$4].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
_setToStringTag$1($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
_setToStringTag$1(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
_setToStringTag$1(_global$1.JSON, 'JSON', true);

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol = _core$1.Symbol;

var symbol$1 = symbol;

// true  -> String#at
// false -> String#codePointAt
var _stringAt$1 = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined$1(that));
    var i = _toInteger$1(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _iterators$1 = {};

var IteratorPrototype$1 = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide$1(IteratorPrototype$1, _wks$1('iterator'), function () { return this; });

var _iterCreate$1 = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate$1(IteratorPrototype$1, { next: _propertyDesc$1(1, next) });
  _setToStringTag$1(Constructor, NAME + ' Iterator');
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$5 = _sharedKey$1('IE_PROTO');
var ObjectProto$2 = Object.prototype;

var _objectGpo$1 = Object.getPrototypeOf || function (O) {
  O = _toObject$1(O);
  if (_has$1(O, IE_PROTO$5)) return O[IE_PROTO$5];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto$2 : null;
};

var ITERATOR$2 = _wks$1('iterator');
var BUGGY$1 = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR$1 = '@@iterator';
var KEYS$1 = 'keys';
var VALUES$1 = 'values';

var returnThis$1 = function () { return this; };

var _iterDefine$1 = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate$1(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY$1 && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS$1: return function keys() { return new Constructor(this, kind); };
      case VALUES$1: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES$1;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR$2] || proto[FF_ITERATOR$1] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo$1($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag$1(IteratorPrototype, TAG, true);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES$1) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if (( FORCED) && (BUGGY$1 || VALUES_BUG || !proto[ITERATOR$2])) {
    _hide$1(proto, ITERATOR$2, $default);
  }
  // Plug for library
  _iterators$1[NAME] = $default;
  _iterators$1[TAG] = returnThis$1;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES$1),
      keys: IS_SET ? $default : getMethod(KEYS$1),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine$1(proto, key, methods[key]);
    } else _export$1(_export$1.P + _export$1.F * (BUGGY$1 || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt$1(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine$1(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _iterStep$1 = function (done, value) {
  return { value: value, done: !!done };
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator$1 = _iterDefine$1(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject$1(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep$1(1);
  }
  if (kind == 'keys') return _iterStep$1(0, index);
  if (kind == 'values') return _iterStep$1(0, O[index]);
  return _iterStep$1(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators$1.Arguments = _iterators$1.Array;

var TO_STRING_TAG$1 = _wks$1('toStringTag');

var DOMIterables$1 = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i$1 = 0; i$1 < DOMIterables$1.length; i$1++) {
  var NAME$2 = DOMIterables$1[i$1];
  var Collection$1 = _global$1[NAME$2];
  var proto$2 = Collection$1 && Collection$1.prototype;
  if (proto$2 && !proto$2[TO_STRING_TAG$1]) _hide$1(proto$2, TO_STRING_TAG$1, NAME$2);
  _iterators$1[NAME$2] = _iterators$1.Array;
}

var iterator = _wksExt.f('iterator');

var iterator$1 = iterator;

// call something on iterator step with safe closing on error

var _iterCall = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject$1(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject$1(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$3 = _wks$1('iterator');
var ArrayProto$1 = Array.prototype;

var _isArrayIter = function (it) {
  return it !== undefined && (_iterators$1.Array === it || ArrayProto$1[ITERATOR$3] === it);
};

var _createProperty$1 = function (object, index, value) {
  if (index in object) _objectDp$1.f(object, index, _propertyDesc$1(0, value));
  else object[index] = value;
};

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$3 = _wks$1('toStringTag');
// ES3 wrong here
var ARG$1 = _cof$1(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet$1 = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof$1 = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet$1(O = Object(it), TAG$3)) == 'string' ? T
    // builtinTag case
    : ARG$1 ? _cof$1(O)
    // ES3 arguments fallback
    : (B = _cof$1(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var ITERATOR$4 = _wks$1('iterator');

var core_getIteratorMethod = _core$1.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$4]
    || it['@@iterator']
    || _iterators$1[_classof$1(it)];
};

var ITERATOR$5 = _wks$1('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR$5]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

var _iterDetect = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$5]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$5] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

_export$1(_export$1.S + _export$1.F * !_iterDetect(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = _toObject$1(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx$1(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty$1(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength$1(O.length);
      for (result = new C(length); length > index; index++) {
        _createProperty$1(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

var from_1 = _core$1.Array.from;

var from_1$1 = from_1;

function _iterableToArray(iter) {
  if (typeof symbol$1 !== "undefined" && iter[iterator$1] != null || iter["@@iterator"] != null) return from_1$1(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return from_1$1(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

// @@match logic
_fixReWks('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = _anObject(regexp);
      var S = String(this);
      if (!rx.global) return _regexpExecAbstract(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = _regexpExecAbstract(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component used for displaying the meta data information regarding an RFP throughout our applications.
 *
 * @vuedoc
 * @exports RfpTable
 * @category components
 */
var script$j = {
  name: 'RfpTable',
  props: {
    documentManagerLink: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editLink: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hasStopLoss: {
      type: Boolean,
      default: false
    },
    /**
     * Array of parameters to not render in the table.
     */
    hideParams: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    labelCellWidth: {
      type: Number,
      default: 172
    },
    projectType: {
      type: String,
      required: true
    },
    showDocuments: {
      type: Boolean,
      default: false
    }
  },
  data: function data(vm) {
    return {
      noValueText: 'Not provided',
      tableData: [{
        type: 'employer_name',
        text: 'Employer'
      }, {
        type: 'employer_location',
        text: 'Employer location'
      }, {
        type: 'employer_website',
        text: 'Employer website'
      }, {
        type: 'employer_total_lives',
        text: 'Lives'
      }, {
        type: 'employer_sic',
        text: 'SIC'
      }, {
        type: 'products',
        text: 'Products & broker commissions'
      }, {
        type: 'incumbent_carriers',
        text: 'Incumbents'
      }, {
        type: 'broker_of_record_label',
        text: 'Broker of record'
      }, {
        type: 'broker_contacts',
        // Backwards compatible fix. Until Broker team features are
        // added to Core API, this row should remain "Primary contacts"
        // can see "Broker team contacts" on Features 2 until then
        // TODO: [SHARED-156] remove Primary in favor for Broker team after feature is merged to staging -kc
        text: vm.info.event_contacts ? 'Broker team contacts' : 'Primary contacts'
      }, {
        type: 'event_contacts',
        text: 'Placement event contacts'
      }, {
        type: 'stop_loss_tpa_company',
        text: 'Medical claim administrator'
      }, {
        type: 'stop_loss_rx_vendor',
        text: 'Prescription drug administrator'
      }, {
        type: 'stop_loss_transplant_carrier',
        text: 'Fully insured transplant carrier'
      }, {
        type: 'reason_for_rfp',
        text: 'Reason for marketing'
      }, {
        type: 'benefit_administrator',
        text: 'Benefit admin'
      }, {
        type: 'open_enrollment_this_year',
        text: 'Open enrollment'
      }, {
        type: 'hdhp',
        text: 'High deductible health plan'
      }, {
        type: 'market_activity',
        text: 'Market activity'
      }, {
        type: 'effective_date',
        text: 'Coverage effective date'
      }, {
        type: 'project_due_date',
        text: 'Due date'
      }, {
        type: 'rfp_cover_memo',
        text: 'Cover memo'
      }]
    };
  },
  computed: {
    /**
     * If this project has a Stop Loss Product, we filter out certain rows if there was no data when the RFP was created.
     *
     * @returns {Array}
     */
    ignoreRows: function ignoreRows() {
      var _this = this;
      var generalData = ['rfp_cover_memo'];
      var stopLossData = ['stop_loss_tpa_company', 'stop_loss_rx_vendor', 'stop_loss_transplant_carrier'];
      if (this.hasStopLoss) {
        generalData.push.apply(generalData, stopLossData);
      }
      var rowsToIgnore = generalData.filter(function (type) {
        return _this.info[type] && _this.info[type].match(/not provided/i);
      });

      // if project is Initial Employer Build, we don't want to show broker_contacts row at all.
      /**
       * the second condition is meant to make event_contacts backwards compatible with the current core_api as
       * it does not have this particular property in rfp_info yet. so we hide it regardless of project type.
       * We can remove the second condition at any time after the work in features 2 for the new broker team
       * feature is added to staging. -kc
       * TODO: remove second condition once broker team feature is merged into staging -kc
       */
      if (this.$TF.ReusableData.projectTypes.isBuildType(this.projectType) || !this.info.event_contacts) {
        rowsToIgnore.push('event_contacts');
      }
      if (this.hideParams.length) {
        rowsToIgnore.push.apply(rowsToIgnore, _toConsumableArray(this.hideParams));
      }
      return rowsToIgnore;
    },
    /**
     * Identify if this project is in Open Enrollment and surround Enrollment Strategy in parenthesis if it exists
     *
     * @returns {object}
     */
    formatOpenEnrollment: function formatOpenEnrollment() {
      return {
        // Ensure that the open enrollment year is 'yes' and not empty as an extra check to accomodate Cover Memo e2e test
        thisYear: this.info.open_enrollment_this_year && this.info.open_enrollment_this_year.toLowerCase() === 'yes',
        enrollmentStrategy: this.info.open_enrollment_strategy ? "(".concat(this.info.open_enrollment_strategy, ")") : ''
      };
    }
  }
};

/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "table",
    { staticClass: "rfp-table" },
    [
      _vm._l(_vm.tableData, function (dataInfo) {
        return [
          !_vm.ignoreRows.includes(dataInfo.type)
            ? _c(
                "tr",
                {
                  key: dataInfo.text,
                  attrs: {
                    "data-test": "rfp " + dataInfo.type + " information",
                  },
                },
                [
                  _c("td", {
                    style: { width: _vm.labelCellWidth + "px" },
                    domProps: { textContent: _vm._s(dataInfo.text) },
                  }),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      dataInfo.type === "project_due_date"
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.info[dataInfo.type] !==
                                    "Due Date Not Specified"
                                    ? _vm.$TF.DatesUtils.formatSimpleDate(
                                        _vm.info.project_due_date
                                      )
                                    : _vm.noValueText
                                ) +
                                "\n          "
                            ),
                            _vm.editLink.name
                              ? _c("RouterLink", {
                                  staticClass: "link-edit",
                                  attrs: { to: _vm.editLink },
                                  domProps: { textContent: _vm._s("Edit") },
                                })
                              : _vm._e(),
                          ]
                        : dataInfo.type === "rfp_cover_memo" &&
                          _vm.info.rfp_cover_memo
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.info.rfp_cover_memo.replace(
                                  /(?:\r\n|\r|\n)/g,
                                  "<br>"
                                )
                              ),
                            },
                          })
                        : dataInfo.type === "employer_website" &&
                          _vm.info.employer_website
                        ? _c("a", {
                            attrs: {
                              target: "_blank",
                              href: _vm.info.employer_website,
                            },
                            domProps: {
                              textContent: _vm._s(
                                _vm.info.employer_website
                                  .replace(/^https?:\/\//, "")
                                  .replace(/\/+$/, "")
                              ),
                            },
                          })
                        : dataInfo.type === "effective_date" &&
                          _vm.info.effective_date
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$TF.DatesUtils.formatSimpleDate(
                                    _vm.info.effective_date
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        : dataInfo.type === "open_enrollment_this_year" &&
                          _vm.formatOpenEnrollment.thisYear
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.info.open_enrollment_this_year) +
                                "\n          " +
                                _vm._s(
                                  _vm.formatOpenEnrollment.enrollmentStrategy
                                ) +
                                "\n        "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.info[dataInfo.type] || _vm.noValueText
                                ) +
                                "\n        "
                            ),
                          ],
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm.showDocuments
        ? _c("tr", [
            _c("td", [_vm._v("Documents")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.info.inforce_sources_message) +
                  "\n      "
              ),
              _vm.documentManagerLink.name
                ? _c(
                    "p",
                    [
                      _c("RouterLink", {
                        attrs: { to: _vm.documentManagerLink },
                        domProps: { textContent: _vm._s("Document manager") },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$j = [];
__vue_render__$j._withStripped = true;

  /* style */
  const __vue_inject_styles__$j = function (inject) {
    if (!inject) return
    inject("data-v-5a434056_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.rfp-table[data-v-5a434056] {\n  width: 100%;\n  margin-bottom: 28px;\n}\ntd[data-v-5a434056] {\n  padding: 13px;\n  border: 1px #c1c1c1 solid;\n  background: #fff;\n  vertical-align: top;\n}\n.link-edit[data-v-5a434056] {\n  margin-left: 15px;\n}\n\n/*# sourceMappingURL=RfpTable.vue.map */", map: {"version":3,"sources":["RfpTable.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/RfpTable.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;kCAEkC;ACyNlC;EACA,WAAA;EACA,mBAAA;ADvNA;AC0NA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;ADvNA;AC0NA;EACA,iBAAA;ADvNA;;AAEA,uCAAuC","file":"RfpTable.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.rfp-table {\n  width: 100%;\n  margin-bottom: 28px;\n}\n\ntd {\n  padding: 13px;\n  border: 1px #c1c1c1 solid;\n  background: #fff;\n  vertical-align: top;\n}\n\n.link-edit {\n  margin-left: 15px;\n}\n\n/*# sourceMappingURL=RfpTable.vue.map */","<template>\n  <table class=\"rfp-table\">\n    <template v-for=\"dataInfo in tableData\">\n      <tr\n        v-if=\"!ignoreRows.includes(dataInfo.type)\"\n        :key=\"dataInfo.text\"\n        :data-test=\"`rfp ${dataInfo.type} information`\"\n      >\n        <td\n          :style=\"{ width: `${labelCellWidth}px` }\"\n          v-text=\"dataInfo.text\"\n        />\n        <td>\n          <!-- Format Due date && Edit link -->\n          <template v-if=\"dataInfo.type === 'project_due_date'\">\n            {{ info[dataInfo.type] !== 'Due Date Not Specified'\n              ? $TF.DatesUtils.formatSimpleDate(info.project_due_date)\n              : noValueText\n            }}\n            <RouterLink\n              v-if=\"editLink.name\"\n              :to=\"editLink\"\n              class=\"link-edit\"\n              v-text=\"'Edit'\"\n            />\n          </template>\n          <!--\n            Formatted Cover Memo\n            Disable no-html since these are paragraphs\n          -->\n          <!-- eslint-disable vue/no-v-html -->\n          <span\n            v-else-if=\"dataInfo.type === 'rfp_cover_memo' && info.rfp_cover_memo\"\n            v-html=\"info.rfp_cover_memo.replace(/(?:\\r\\n|\\r|\\n)/g, '<br>')\"\n          />\n          <!-- eslint-enable vue/no-v-html -->\n          <!-- Employer Website -->\n          <a\n            v-else-if=\"dataInfo.type === 'employer_website' && info.employer_website\"\n            target=\"_blank\"\n            :href=\"info.employer_website\"\n            v-text=\"info.employer_website.replace(/^https?:\\/\\//, '').replace(/\\/+$/, '')\"\n          />\n          <!-- Formatted Effective Date -->\n          <template v-else-if=\"dataInfo.type === 'effective_date' && info.effective_date\">\n            {{ $TF.DatesUtils.formatSimpleDate(info.effective_date) }}\n          </template>\n          <!-- Also display Open Enrollment Strategy if Open Enrollment is Yes -->\n          <template\n            v-else-if=\"dataInfo.type === 'open_enrollment_this_year'\n              && formatOpenEnrollment.thisYear\n            \"\n          >\n            {{ info.open_enrollment_this_year }}\n            {{ formatOpenEnrollment.enrollmentStrategy }}\n          </template>\n          <!-- Show the value of row or noValueText  -->\n          <template v-else>\n            {{ info[dataInfo.type] || noValueText }}\n          </template>\n        </td>\n      </tr>\n    </template>\n    <tr v-if=\"showDocuments\">\n      <td>Documents</td>\n      <td>\n        {{ info.inforce_sources_message }}\n        <p v-if=\"documentManagerLink.name\">\n          <RouterLink\n            :to=\"documentManagerLink\"\n            v-text=\"'Document manager'\"\n          />\n        </p>\n      </td>\n    </tr>\n  </table>\n</template>\n\n<script>\n  /**\n   * Component used for displaying the meta data information regarding an RFP throughout our applications.\n   *\n   * @vuedoc\n   * @exports RfpTable\n   * @category components\n   */\n  export default {\n    name: 'RfpTable',\n    props: {\n      documentManagerLink: {\n        type: Object,\n        default: () => ({}),\n      },\n      editLink: {\n        type: Object,\n        default: () => ({}),\n      },\n      info: {\n        type: Object,\n        default: () => ({}),\n      },\n      hasStopLoss: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Array of parameters to not render in the table.\n       */\n      hideParams: {\n        type: Array,\n        default: () => [],\n      },\n      labelCellWidth: {\n        type: Number,\n        default: 172,\n      },\n      projectType: {\n        type: String,\n        required: true,\n      },\n      showDocuments: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: (vm) => ({\n      noValueText: 'Not provided',\n      tableData: [\n        { type: 'employer_name', text: 'Employer' },\n        { type: 'employer_location', text: 'Employer location' },\n        { type: 'employer_website', text: 'Employer website' },\n        { type: 'employer_total_lives', text: 'Lives' },\n        { type: 'employer_sic', text: 'SIC' },\n        { type: 'products', text: 'Products & broker commissions' },\n        { type: 'incumbent_carriers', text: 'Incumbents' },\n        { type: 'broker_of_record_label', text: 'Broker of record' },\n        {\n          type: 'broker_contacts',\n          // Backwards compatible fix. Until Broker team features are\n          // added to Core API, this row should remain \"Primary contacts\"\n          // can see \"Broker team contacts\" on Features 2 until then\n          // TODO: [SHARED-156] remove Primary in favor for Broker team after feature is merged to staging -kc\n          text: vm.info.event_contacts\n            ? 'Broker team contacts'\n            : 'Primary contacts',\n        },\n        { type: 'event_contacts', text: 'Placement event contacts' },\n        { type: 'stop_loss_tpa_company', text: 'Medical claim administrator' },\n        { type: 'stop_loss_rx_vendor', text: 'Prescription drug administrator' },\n        { type: 'stop_loss_transplant_carrier', text: 'Fully insured transplant carrier' },\n        { type: 'reason_for_rfp', text: 'Reason for marketing' },\n        { type: 'benefit_administrator', text: 'Benefit admin' },\n        { type: 'open_enrollment_this_year', text: 'Open enrollment' },\n        { type: 'hdhp', text: 'High deductible health plan' },\n        { type: 'market_activity', text: 'Market activity' },\n        { type: 'effective_date', text: 'Coverage effective date' },\n        { type: 'project_due_date', text: 'Due date' },\n        { type: 'rfp_cover_memo', text: 'Cover memo' },\n      ],\n    }),\n    computed: {\n      /**\n       * If this project has a Stop Loss Product, we filter out certain rows if there was no data when the RFP was created.\n       *\n       * @returns {Array}\n       */\n      ignoreRows() {\n        const generalData = ['rfp_cover_memo'];\n        const stopLossData = ['stop_loss_tpa_company', 'stop_loss_rx_vendor', 'stop_loss_transplant_carrier'];\n\n        if (this.hasStopLoss) {\n          generalData.push(...stopLossData);\n        }\n\n        const rowsToIgnore = generalData.filter((type) => (\n          this.info[type] && this.info[type].match(/not provided/i)\n        ));\n\n        // if project is Initial Employer Build, we don't want to show broker_contacts row at all.\n        /**\n         * the second condition is meant to make event_contacts backwards compatible with the current core_api as\n         * it does not have this particular property in rfp_info yet. so we hide it regardless of project type.\n         * We can remove the second condition at any time after the work in features 2 for the new broker team\n         * feature is added to staging. -kc\n         * TODO: remove second condition once broker team feature is merged into staging -kc\n         */\n        if (\n          this.$TF.ReusableData.projectTypes.isBuildType(this.projectType)\n          || !this.info.event_contacts\n        ) {\n          rowsToIgnore.push('event_contacts');\n        }\n\n        if (this.hideParams.length) {\n          rowsToIgnore.push(...this.hideParams);\n        }\n\n        return rowsToIgnore;\n      },\n      /**\n       * Identify if this project is in Open Enrollment and surround Enrollment Strategy in parenthesis if it exists\n       *\n       * @returns {object}\n       */\n      formatOpenEnrollment() {\n        return {\n          // Ensure that the open enrollment year is 'yes' and not empty as an extra check to accomodate Cover Memo e2e test\n          thisYear: this.info.open_enrollment_this_year\n            && this.info.open_enrollment_this_year.toLowerCase() === 'yes',\n          enrollmentStrategy: this.info.open_enrollment_strategy\n            ? `(${this.info.open_enrollment_strategy})` : '',\n        };\n      },\n\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n  @import 'src/assets/styles/mixins';\n\n  .rfp-table {\n    width: 100%;\n    margin-bottom: 28px;\n  }\n\n  td {\n    padding: 13px;\n    border: 1px $tf-light-gray solid;\n    background: $tf-white;\n    vertical-align: top;\n  }\n\n  .link-edit {\n    margin-left: 15px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$j = "data-v-5a434056";
  /* module identifier */
  const __vue_module_identifier__$j = undefined;
  /* functional template */
  const __vue_is_functional_template__$j = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$j = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
    __vue_inject_styles__$j,
    __vue_script__$j,
    __vue_scope_id__$j,
    __vue_is_functional_template__$j,
    __vue_module_identifier__$j,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * "TfBadge" is a component used for displaying a variety of badges throughout our applications.
 *
 * @vuedoc
 * @exports TfBadge
 * @category components
 */
var script$k = {
  name: 'TfBadge',
  props: {
    /**
     * Boolean used to determine if the badge should be used as a counter, which is a unique style when showing notifications.
     */
    isCounter: {
      type: Boolean,
      default: false
    },
    /**
     * Boolean used to determine if the badge should be pill shaped with completely rounded corners.
     */
    isPill: {
      type: Boolean,
      default: false
    },
    /**
     * Boolean used to determine if the badge should have a background color identical to its border.
     */
    isSolid: {
      type: Boolean,
      default: false
    },
    /**
     * String used to determine the various padding and font styles.
     */
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return ['small', 'medium', 'large'].includes(value);
      }
    },
    /**
     * String used to determine the status of the badge.
     */
    status: {
      type: String,
      default: 'notify',
      validator: function validator(value) {
        return ['error', 'notify', 'success', 'warn', 'info'].includes(value);
      }
    },
    /**
     * String or number used as text for the badge.
     */
    value: {
      type: [String, Number],
      required: true
    }
  }
};

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("span", {
    staticClass: "tf-badge",
    class: [
      { "is-solid": _vm.isSolid },
      { "is-pill": _vm.isPill },
      { "is-counter": _vm.isCounter },
      "is-" + _vm.size + " is-" + _vm.status,
    ],
    domProps: { textContent: _vm._s(_vm.value) },
  })
};
var __vue_staticRenderFns__$k = [];
__vue_render__$k._withStripped = true;

  /* style */
  const __vue_inject_styles__$k = function (inject) {
    if (!inject) return
    inject("data-v-189678ce_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nspan[data-v-189678ce] {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  border: 1px solid;\n  border-radius: 5px;\n}\nspan.is-small[data-v-189678ce] {\n  padding: 2px 5px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 12px;\n  letter-spacing: inherit;\n}\nspan.is-small.is-pill[data-v-189678ce]:not(.is-counter) {\n  padding-right: 8px;\n  padding-left: 8px;\n}\nspan.is-medium[data-v-189678ce] {\n  padding: 3px 5px;\n}\nspan.is-medium.is-pill[data-v-189678ce]:not(.is-counter) {\n  padding-right: 8px;\n  padding-left: 8px;\n}\nspan.is-large[data-v-189678ce] {\n  padding: 3px 16px;\n}\nspan.is-error[data-v-189678ce] {\n  color: #f92f37;\n  background: #ffece9;\n  border-color: #f92f37;\n}\nspan.is-error.is-solid[data-v-189678ce], span.is-error.is-counter[data-v-189678ce] {\n  background: #f92f37;\n}\nspan.is-notify[data-v-189678ce] {\n  color: #42474c;\n  border-color: #42474c;\n}\nspan.is-notify.is-solid[data-v-189678ce], span.is-notify.is-counter[data-v-189678ce] {\n  background: #42474c;\n}\nspan.is-success[data-v-189678ce] {\n  color: #00b980;\n  background: #e3f8f2;\n  border-color: #00b980;\n}\nspan.is-success.is-solid[data-v-189678ce], span.is-success.is-counter[data-v-189678ce] {\n  background: #00b980;\n}\nspan.is-warn[data-v-189678ce] {\n  color: #f7912a;\n  background: #fff4ea;\n  border-color: #f7912a;\n}\nspan.is-warn.is-solid[data-v-189678ce], span.is-warn.is-counter[data-v-189678ce] {\n  background: #f7912a;\n}\nspan.is-info[data-v-189678ce] {\n  color: var(--tf-info);\n  background: var(--tf-info-light);\n  border-color: var(--tf-info);\n}\nspan.is-info.is-solid[data-v-189678ce], span.is-info.is-counter[data-v-189678ce] {\n  background: var(--tf-info);\n}\nspan.is-counter[data-v-189678ce] {\n  box-sizing: border-box;\n  height: 20px;\n  min-width: 20px;\n  padding: 2px 5px;\n  border: 1px solid #fff;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: inherit;\n  line-height: 12px;\n  color: #fff;\n}\nspan.is-pill[data-v-189678ce] {\n  border-radius: 100px;\n}\nspan.is-solid[data-v-189678ce] {\n  color: #fff;\n}\n\n/*# sourceMappingURL=TfBadge.vue.map */", map: {"version":3,"sources":["TfBadge.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfBadge.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACyElC;EACA,qBAAA;EAEA,eAAA;EACA,gBAAA;EAGA,kBAAA;EACA,yBAAA;EAEA,mBAAA;EACA,iBAAA;EACA,kBAAA;AD3EA;AC+EA;EACA,gBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,iBAAA;EACA,uBAAA;AD/EA;ACiFA;EAEA,kBAAA;EACA,iBAAA;ADhFA;ACqFA;EACA,gBAAA;ADnFA;ACqFA;EAEA,kBAAA;EACA,iBAAA;ADpFA;ACyFA;EACA,iBAAA;ADvFA;AC2FA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;ADzFA;AC2FA;EAEA,mBAAA;AD1FA;AC8FA;EACA,cAAA;EACA,qBAAA;AD5FA;AC8FA;EAEA,mBAAA;AD7FA;ACiGA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AD/FA;ACiGA;EAEA,mBAAA;ADhGA;ACoGA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;ADlGA;ACoGA;EAEA,mBAAA;ADnGA;ACuGA;EACA,qBAAA;EACA,gCAAA;EACA,4BAAA;ADrGA;ACuGA;EAEA,0BAAA;ADtGA;AC2GA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,uBAAA;EACA,iBAAA;EACA,WAAA;AD3GA;AC8GA;EACA,oBAAA;AD5GA;AC+GA;EACA,WAAA;AD7GA;;AAEA,sCAAsC","file":"TfBadge.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nspan {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  border: 1px solid;\n  border-radius: 5px;\n}\nspan.is-small {\n  padding: 2px 5px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 12px;\n  letter-spacing: inherit;\n}\nspan.is-small.is-pill:not(.is-counter) {\n  padding-right: 8px;\n  padding-left: 8px;\n}\nspan.is-medium {\n  padding: 3px 5px;\n}\nspan.is-medium.is-pill:not(.is-counter) {\n  padding-right: 8px;\n  padding-left: 8px;\n}\nspan.is-large {\n  padding: 3px 16px;\n}\nspan.is-error {\n  color: #f92f37;\n  background: #ffece9;\n  border-color: #f92f37;\n}\nspan.is-error.is-solid, span.is-error.is-counter {\n  background: #f92f37;\n}\nspan.is-notify {\n  color: #42474c;\n  border-color: #42474c;\n}\nspan.is-notify.is-solid, span.is-notify.is-counter {\n  background: #42474c;\n}\nspan.is-success {\n  color: #00b980;\n  background: #e3f8f2;\n  border-color: #00b980;\n}\nspan.is-success.is-solid, span.is-success.is-counter {\n  background: #00b980;\n}\nspan.is-warn {\n  color: #f7912a;\n  background: #fff4ea;\n  border-color: #f7912a;\n}\nspan.is-warn.is-solid, span.is-warn.is-counter {\n  background: #f7912a;\n}\nspan.is-info {\n  color: var(--tf-info);\n  background: var(--tf-info-light);\n  border-color: var(--tf-info);\n}\nspan.is-info.is-solid, span.is-info.is-counter {\n  background: var(--tf-info);\n}\nspan.is-counter {\n  box-sizing: border-box;\n  height: 20px;\n  min-width: 20px;\n  padding: 2px 5px;\n  border: 1px solid #fff;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: inherit;\n  line-height: 12px;\n  color: #fff;\n}\nspan.is-pill {\n  border-radius: 100px;\n}\nspan.is-solid {\n  color: #fff;\n}\n\n/*# sourceMappingURL=TfBadge.vue.map */","<template>\n  <span\n    class=\"tf-badge\"\n    :class=\"[\n      { 'is-solid': isSolid },\n      { 'is-pill': isPill },\n      { 'is-counter': isCounter },\n      `is-${size} is-${status}`,\n    ]\"\n    v-text=\"value\"\n  />\n</template>\n\n<script>\n  /**\n   * \"TfBadge\" is a component used for displaying a variety of badges throughout our applications.\n   *\n   * @vuedoc\n   * @exports TfBadge\n   * @category components\n   */\n  export default {\n    name: 'TfBadge',\n    props: {\n      /**\n       * Boolean used to determine if the badge should be used as a counter, which is a unique style when showing notifications.\n       */\n      isCounter: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Boolean used to determine if the badge should be pill shaped with completely rounded corners.\n       */\n      isPill: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Boolean used to determine if the badge should have a background color identical to its border.\n       */\n      isSolid: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * String used to determine the various padding and font styles.\n       */\n      size: {\n        type: String,\n        default: 'medium',\n        validator: (value) => ['small', 'medium', 'large'].includes(value),\n      },\n      /**\n       * String used to determine the status of the badge.\n       */\n      status: {\n        type: String,\n        default: 'notify',\n        validator: (value) => ['error', 'notify', 'success', 'warn', 'info'].includes(value),\n      },\n      /**\n       * String or number used as text for the badge.\n       */\n      value: {\n        type: [String, Number],\n        required: true,\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  span {\n    display: inline-block;\n    font: {\n      size: 12px;\n      weight: 700;\n    }\n    text: {\n      align: center;\n      transform: uppercase;\n    }\n    letter-spacing: 1px;\n    border: 1px solid;\n    border-radius: 5px;\n\n    &.is {\n      // Sizes\n      &-small {\n        padding: 2px 5px;\n        font: {\n          size: 10px;\n          weight: 600;\n        }\n        line-height: 12px;\n        letter-spacing: inherit;\n\n        &.is-pill:not(.is-counter) {\n          padding: {\n            right: 8px;\n            left: 8px;\n          }\n        }\n      }\n\n      &-medium {\n        padding: 3px 5px;\n\n        &.is-pill:not(.is-counter) {\n          padding: {\n            right: 8px;\n            left: 8px;\n          }\n        }\n      }\n\n      &-large {\n        padding: 3px 16px;\n      }\n\n      // Statuses\n      &-error {\n        color: $tf-danger;\n        background: $tf-danger-light;\n        border-color: $tf-danger;\n\n        &.is-solid,\n        &.is-counter {\n          background: $tf-danger;\n        }\n      }\n\n      &-notify {\n        color: $tf-dark-gray;\n        border-color: $tf-dark-gray;\n\n        &.is-solid,\n        &.is-counter {\n          background: $tf-dark-gray;\n        }\n      }\n\n      &-success {\n        color: $tf-success;\n        background: $tf-success-light;\n        border-color: $tf-success;\n\n        &.is-solid,\n        &.is-counter {\n          background: $tf-success;\n        }\n      }\n\n      &-warn {\n        color: $tf-warning;\n        background: $tf-warning-light;\n        border-color: $tf-warning;\n\n        &.is-solid,\n        &.is-counter {\n          background: $tf-warning;\n        }\n      }\n\n      &-info {\n        color: var(--tf-info);\n        background: var(--tf-info-light);\n        border-color: var(--tf-info);\n\n        &.is-solid,\n        &.is-counter {\n          background: var(--tf-info);\n        }\n      }\n\n      // Misc styles\n      &-counter {\n        box-sizing: border-box;\n        height: 20px;\n        min-width: 20px;\n        padding: 2px 5px;\n        border: 1px solid $tf-white;\n        border-radius: 10px;\n        font: {\n          size: 12px;\n          weight: 700;\n        }\n        letter-spacing: inherit;\n        line-height: 12px;\n        color: $tf-white;\n      }\n\n      &-pill {\n        border-radius: 100px;\n      }\n\n      &-solid {\n        color: $tf-white;\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$k = "data-v-189678ce";
  /* module identifier */
  const __vue_module_identifier__$k = undefined;
  /* functional template */
  const __vue_is_functional_template__$k = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$k = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
    __vue_inject_styles__$k,
    __vue_script__$k,
    __vue_scope_id__$k,
    __vue_is_functional_template__$k,
    __vue_module_identifier__$k,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$l = {
  name: 'TfButton',
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    },
    $themePrimaryButtonColor: {
      default: function _default() {
        return null;
      }
    },
    $themeSecondaryButtonColor: {
      default: function _default() {
        return null;
      }
    }
  },
  props: {
    tag: {
      type: String,
      default: 'button'
    },
    href: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    noBranding: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'asc'
    },
    svgHeight: {
      type: Number,
      default: function _default() {
        return 15;
      }
    },
    svgWidth: {
      type: Number,
      default: function _default() {
        return 12;
      }
    },
    prepend: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hover: false
    };
  },
  computed: {
    /**
     * Return color value as reactive value
     *
     * @returns {string}
     */
    themePrimaryButtonColor: function themePrimaryButtonColor() {
      return this.$themePrimaryButtonColor ? this.$themePrimaryButtonColor() : null;
    },
    /**
     * Return color value as reactive value
     *
     * @returns {string}
     */
    themeSecondaryButtonColor: function themeSecondaryButtonColor() {
      return this.$themeSecondaryButtonColor ? this.$themeSecondaryButtonColor() : null;
    },
    /**
     * inline styles to match primaryColor
     *
     * @returns {object}
     */
    colorStyle: function colorStyle() {
      var style = {};
      if (this.buttonDisabled || this.noBranding) {
        return style;
      }
      if (this.themePrimaryButtonColor) {
        if (this.type === 'primary') {
          if (['text-icon', 'text-icon-small', 'text', 'text-small', 'icon-no-fill'].includes(this.size)) {
            // all text button styles and default icon style (no-fill)
            style.color = this.themePrimaryButtonColor;
            if (!this.noBorder && !this.noPadding && this.size === 'icon-no-fill' && this.hover) {
              style.borderColor = this.themePrimaryButtonColor;
            }
          } else {
            // default primary button (large, medium, icon)
            style.backgroundColor = this.themePrimaryButtonColor;
            style.borderColor = this.themePrimaryButtonColor;
          }
        }
      }
      if (this.themeSecondaryButtonColor) {
        if (this.type === 'secondary') {
          style.color = this.themeSecondaryButtonColor;
          style.borderColor = this.themeSecondaryButtonColor;
        }
      }
      return style;
    },
    /**
     * get formItemSize (from Element)
     *
     * @returns {string}
     */
    elFormItemSize: function elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    /**
     * get button size and if size is the deprecated 'icon-small', convert to new 'icon-no-fill'
     *
     * @returns {string}
     */
    buttonSize: function buttonSize() {
      var updatedSize = this.size === 'icon-small' ? 'icon-no-fill' : this.size;
      return updatedSize || this.elFormItemSize || (this.$ELEMENT || {}).size;
    },
    /**
     * Is button disabled
     *
     * @returns {boolean}
     */
    buttonDisabled: function buttonDisabled() {
      var disabledForm = (this.elForm || {}).disabled;
      return this.disabled || disabledForm || this.loading;
    }
  },
  methods: {
    /**
     * Emit click
     *
     * @param {event} evt
     */
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
};

/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$l = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.tag,
    {
      tag: "component",
      staticClass: "tf-button wt-button",
      class: [
        _vm.type ? "tf-button--" + _vm.type + " wt-button--" + _vm.type : "",
        _vm.buttonSize
          ? "tf-button--" + _vm.buttonSize + " wt-button--" + _vm.buttonSize
          : "",
        {
          "is-disabled": _vm.buttonDisabled,
        },
        _vm.icon ? "has-icon icon-" + _vm.icon : "",
        ((_obj = {}), (_obj["has-icon icon-spinner"] = _vm.loading), _obj),
        { "no-padding": _vm.noPadding },
        { "no-border": _vm.noBorder },
      ],
      style: _vm.colorStyle,
      attrs: {
        disabled: _vm.buttonDisabled,
        autofocus: _vm.autofocus,
        type: _vm.nativeType,
        href: _vm.href,
        target: _vm.target,
      },
      on: {
        mousedown: function ($event) {
          return _vm.$emit("mousedown", $event)
        },
        mouseover: function ($event) {
          _vm.hover = true;
        },
        mouseout: function ($event) {
          _vm.hover = false;
        },
        click: _vm.handleClick,
      },
    },
    [
      _vm.icon && _vm.prepend
        ? [
            _c("icon", {
              class: { "is-rotating": _vm.loading },
              attrs: { name: !_vm.loading ? _vm.icon : "spinner" },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.default
        ? _c("span", { staticClass: "button-text" }, [_vm._t("default")], 2)
        : _vm._e(),
      _vm._v(" "),
      !_vm.icon && _vm.loading
        ? _c("icon", {
            staticClass: "icon-loading is-rotating",
            attrs: { name: "spinner" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.icon && !_vm.prepend
        ? [
            _c("icon", {
              class: { "is-rotating": _vm.loading },
              attrs: { name: !_vm.loading ? _vm.icon : "spinner" },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "table-sort"
        ? _c(
            "div",
            {
              class:
                "table-sort table-sort-" +
                _vm.direction +
                " " +
                (_vm.selected ? "table-sort-selected" : ""),
            },
            [
              _c("icon", { attrs: { name: "angle-up" } }),
              _vm._v(" "),
              _c("icon", { attrs: { name: "angle-up" } }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$l = [];
__vue_render__$l._withStripped = true;

  /* style */
  const __vue_inject_styles__$l = function (inject) {
    if (!inject) return
    inject("data-v-d10d919e_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tf-button[data-v-d10d919e],\n.wt-button[data-v-d10d919e] {\n  white-space: nowrap;\n  -webkit-appearance: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  text-align: center;\n  box-sizing: border-box;\n  outline: 0;\n  margin: 0;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  background-color: #009;\n  border-color: #009;\n  color: #fff;\n  font-size: 16px;\n  padding: 7px 14px;\n  border-radius: 0;\n  text-transform: none;\n  border: 2px #009 solid;\n  display: inline-flex;\n  align-items: center;\n  font-weight: 600;\n  line-height: 1;\n}\n.tf-button[data-v-d10d919e]:not(.is-disabled),\n.wt-button[data-v-d10d919e]:not(.is-disabled) {\n  cursor: pointer;\n}\n.tf-button .button-text[data-v-d10d919e],\n.tf-button svg[data-v-d10d919e],\n.wt-button .button-text[data-v-d10d919e],\n.wt-button svg[data-v-d10d919e] {\n  transform: translate(0, 0);\n}\n.tf-button + .tf-button[data-v-d10d919e],\n.wt-button + .wt-button[data-v-d10d919e] {\n  margin-left: 14px;\n}\n.tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill[data-v-d10d919e],\n.wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill[data-v-d10d919e] {\n  margin-left: 10px;\n}\n.tf-button--large[data-v-d10d919e],\n.wt-button--large[data-v-d10d919e] {\n  font-size: 18px;\n  padding: 12px 18px;\n  border-radius: 25px;\n}\n.tf-button--medium[data-v-d10d919e],\n.tf-button--small[data-v-d10d919e],\n.wt-button--medium[data-v-d10d919e],\n.wt-button--small[data-v-d10d919e] {\n  border-radius: 3px;\n}\n.tf-button--medium[data-v-d10d919e],\n.wt-button--medium[data-v-d10d919e] {\n  font-size: 16px;\n  padding: 7px 18px;\n}\n.tf-button--small[data-v-d10d919e],\n.wt-button--small[data-v-d10d919e] {\n  font-size: 14px;\n  padding: 5px 13px;\n}\n.tf-button--large.has-icon svg[data-v-d10d919e],\n.tf-button--medium.has-icon svg[data-v-d10d919e],\n.wt-button--large.has-icon svg[data-v-d10d919e],\n.wt-button--medium.has-icon svg[data-v-d10d919e] {\n  height: 15px;\n}\n.tf-button--small.has-icon svg[data-v-d10d919e],\n.wt-button--small.has-icon svg[data-v-d10d919e] {\n  height: 13px;\n}\n.tf-button--icon[data-v-d10d919e],\n.tf-button--icon-no-fill[data-v-d10d919e],\n.wt-button--icon[data-v-d10d919e],\n.wt-button--icon-no-fill[data-v-d10d919e] {\n  padding: 5px 4px;\n}\n.tf-button--icon span[data-v-d10d919e],\n.tf-button--icon-no-fill span[data-v-d10d919e],\n.wt-button--icon span[data-v-d10d919e],\n.wt-button--icon-no-fill span[data-v-d10d919e] {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n}\n.tf-button--icon span + svg[data-v-d10d919e],\n.tf-button--icon-no-fill span + svg[data-v-d10d919e],\n.wt-button--icon span + svg[data-v-d10d919e],\n.wt-button--icon-no-fill span + svg[data-v-d10d919e] {\n  margin-left: 0;\n}\n.tf-button--icon.has-icon svg[data-v-d10d919e],\n.tf-button--icon-no-fill.has-icon svg[data-v-d10d919e],\n.wt-button--icon.has-icon svg[data-v-d10d919e],\n.wt-button--icon-no-fill.has-icon svg[data-v-d10d919e] {\n  width: 14px;\n  height: 14px;\n}\n.tf-button--primary[data-v-d10d919e],\n.wt-button--primary[data-v-d10d919e] {\n  background-color: #009;\n  border-color: #009;\n  color: #fff;\n}\n.tf-button--secondary[data-v-d10d919e],\n.wt-button--secondary[data-v-d10d919e] {\n  background-color: transparent;\n  border-color: #009;\n  color: #009;\n}\n.tf-button--affirm[data-v-d10d919e],\n.wt-button--affirm[data-v-d10d919e] {\n  color: #fff;\n  background: #00b980;\n  border-color: #00b980;\n}\n.tf-button--decline[data-v-d10d919e],\n.wt-button--decline[data-v-d10d919e] {\n  color: #fff;\n  background: #f92f37;\n  border-color: #f92f37;\n}\n.tf-button.is-disabled[data-v-d10d919e],\n.wt-button.is-disabled[data-v-d10d919e] {\n  background: #efefef;\n  color: #c1c1c1;\n}\n.tf-button.is-disabled[data-v-d10d919e]:not(.tf-button--icon-no-fill), .tf-button.is-disabled[data-v-d10d919e]:not(.wt-button--icon-no-fill),\n.wt-button.is-disabled[data-v-d10d919e]:not(.tf-button--icon-no-fill),\n.wt-button.is-disabled[data-v-d10d919e]:not(.wt-button--icon-no-fill) {\n  border-color: #efefef;\n}\n.tf-button--no-fill[data-v-d10d919e],\n.wt-button--no-fill[data-v-d10d919e] {\n  background-color: transparent;\n  border-color: transparent;\n  color: #009;\n}\n.tf-button--text[data-v-d10d919e],\n.tf-button--text-small[data-v-d10d919e],\n.tf-button--text-icon.has-icon[data-v-d10d919e],\n.tf-button--text-icon-small.has-icon[data-v-d10d919e],\n.tf-button--icon-no-fill.has-icon[data-v-d10d919e],\n.wt-button--text[data-v-d10d919e],\n.wt-button--text-small[data-v-d10d919e],\n.wt-button--text-icon.has-icon[data-v-d10d919e],\n.wt-button--text-icon-small.has-icon[data-v-d10d919e],\n.wt-button--icon-no-fill.has-icon[data-v-d10d919e] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  text-transform: none;\n  font-size: 14px;\n}\n.tf-button--text svg[data-v-d10d919e],\n.tf-button--text-small svg[data-v-d10d919e],\n.tf-button--text-icon.has-icon svg[data-v-d10d919e],\n.tf-button--text-icon-small.has-icon svg[data-v-d10d919e],\n.tf-button--icon-no-fill.has-icon svg[data-v-d10d919e],\n.wt-button--text svg[data-v-d10d919e],\n.wt-button--text-small svg[data-v-d10d919e],\n.wt-button--text-icon.has-icon svg[data-v-d10d919e],\n.wt-button--text-icon-small.has-icon svg[data-v-d10d919e],\n.wt-button--icon-no-fill.has-icon svg[data-v-d10d919e] {\n  flex-grow: 0;\n  position: static;\n}\n.tf-button--text[data-v-d10d919e],\n.tf-button--text-small[data-v-d10d919e],\n.tf-button--text-icon.has-icon[data-v-d10d919e],\n.tf-button--text-icon-small.has-icon[data-v-d10d919e],\n.wt-button--text[data-v-d10d919e],\n.wt-button--text-small[data-v-d10d919e],\n.wt-button--text-icon.has-icon[data-v-d10d919e],\n.wt-button--text-icon-small.has-icon[data-v-d10d919e] {\n  border: 0;\n  padding: 0;\n}\n.tf-button--icon-no-fill[data-v-d10d919e],\n.wt-button--icon-no-fill[data-v-d10d919e] {\n  padding: 6px;\n  border: 2px transparent solid;\n  border-radius: 3px;\n}\n.tf-button--icon-no-fill.no-padding[data-v-d10d919e],\n.wt-button--icon-no-fill.no-padding[data-v-d10d919e] {\n  padding: 0;\n}\n.tf-button--icon-no-fill span[data-v-d10d919e],\n.wt-button--icon-no-fill span[data-v-d10d919e] {\n  position: absolute;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--primary[data-v-d10d919e], .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--primary[data-v-d10d919e],\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--primary[data-v-d10d919e],\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--primary[data-v-d10d919e] {\n  border: 2px #009 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--affirm[data-v-d10d919e], .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--affirm[data-v-d10d919e],\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--affirm[data-v-d10d919e],\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--affirm[data-v-d10d919e] {\n  border: 2px #00b980 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--decline[data-v-d10d919e], .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--decline[data-v-d10d919e],\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--decline[data-v-d10d919e],\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--decline[data-v-d10d919e] {\n  border: 2px #f92f37 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).no-border[data-v-d10d919e], .tf-button--icon-no-fill:hover:not(.is-disabled).no-padding[data-v-d10d919e],\n.wt-button--icon-no-fill:hover:not(.is-disabled).no-border[data-v-d10d919e],\n.wt-button--icon-no-fill:hover:not(.is-disabled).no-padding[data-v-d10d919e] {\n  border: 2px transparent solid;\n}\n.tf-button--text-icon-small.has-icon[data-v-d10d919e],\n.tf-button--text-small[data-v-d10d919e],\n.wt-button--text-icon-small.has-icon[data-v-d10d919e],\n.wt-button--text-small[data-v-d10d919e] {\n  font-size: 12px;\n  font-weight: 400;\n}\n.tf-button--text-icon-small.has-icon .button-text[data-v-d10d919e],\n.tf-button--text-small .button-text[data-v-d10d919e],\n.wt-button--text-icon-small.has-icon .button-text[data-v-d10d919e],\n.wt-button--text-small .button-text[data-v-d10d919e] {\n  line-height: 21px;\n}\n.tf-button--text-icon.has-icon svg[data-v-d10d919e],\n.tf-button--icon-no-fill.has-icon svg[data-v-d10d919e],\n.wt-button--text-icon.has-icon svg[data-v-d10d919e],\n.wt-button--icon-no-fill.has-icon svg[data-v-d10d919e] {\n  width: 15px;\n  height: 15px;\n}\n.tf-button--text-icon-small.has-icon svg[data-v-d10d919e],\n.wt-button--text-icon-small.has-icon svg[data-v-d10d919e] {\n  width: 11px;\n  height: 11px;\n}\n.tf-button--text.tf-button--primary[data-v-d10d919e],\n.tf-button--text-small.tf-button--primary[data-v-d10d919e],\n.tf-button--text-icon.tf-button--primary[data-v-d10d919e],\n.tf-button--text-icon-small.tf-button--primary[data-v-d10d919e],\n.tf-button--icon-no-fill.tf-button--primary[data-v-d10d919e],\n.wt-button--text.wt-button--primary[data-v-d10d919e],\n.wt-button--text-small.wt-button--primary[data-v-d10d919e],\n.wt-button--text-icon.wt-button--primary[data-v-d10d919e],\n.wt-button--text-icon-small.wt-button--primary[data-v-d10d919e],\n.wt-button--icon-no-fill.wt-button--primary[data-v-d10d919e] {\n  color: #009;\n}\n.tf-button--text.tf-button--affirm[data-v-d10d919e],\n.tf-button--text-small.tf-button--affirm[data-v-d10d919e],\n.tf-button--text-icon.tf-button--affirm[data-v-d10d919e],\n.tf-button--text-icon-small.tf-button--affirm[data-v-d10d919e],\n.tf-button--icon-no-fill.tf-button--affirm[data-v-d10d919e],\n.wt-button--text.wt-button--affirm[data-v-d10d919e],\n.wt-button--text-small.wt-button--affirm[data-v-d10d919e],\n.wt-button--text-icon.wt-button--affirm[data-v-d10d919e],\n.wt-button--text-icon-small.wt-button--affirm[data-v-d10d919e],\n.wt-button--icon-no-fill.wt-button--affirm[data-v-d10d919e] {\n  color: #00b980;\n}\n.tf-button--text.tf-button--decline[data-v-d10d919e],\n.tf-button--text-small.tf-button--decline[data-v-d10d919e],\n.tf-button--text-icon.tf-button--decline[data-v-d10d919e],\n.tf-button--text-icon-small.tf-button--decline[data-v-d10d919e],\n.tf-button--icon-no-fill.tf-button--decline[data-v-d10d919e],\n.wt-button--text.wt-button--decline[data-v-d10d919e],\n.wt-button--text-small.wt-button--decline[data-v-d10d919e],\n.wt-button--text-icon.wt-button--decline[data-v-d10d919e],\n.wt-button--text-icon-small.wt-button--decline[data-v-d10d919e],\n.wt-button--icon-no-fill.wt-button--decline[data-v-d10d919e] {\n  color: #f92f37;\n}\n.tf-button--text[disabled][data-v-d10d919e],\n.tf-button--text-small[disabled][data-v-d10d919e],\n.tf-button--text-icon[disabled][data-v-d10d919e],\n.tf-button--text-icon-small[disabled][data-v-d10d919e],\n.tf-button--icon-no-fill[disabled][data-v-d10d919e],\n.wt-button--text[disabled][data-v-d10d919e],\n.wt-button--text-small[disabled][data-v-d10d919e],\n.wt-button--text-icon[disabled][data-v-d10d919e],\n.wt-button--text-icon-small[disabled][data-v-d10d919e],\n.wt-button--icon-no-fill[disabled][data-v-d10d919e] {\n  background: transparent;\n  color: #c1c1c1;\n}\n\n/* table buttons */\n.tf-button--table-sort[data-v-d10d919e],\n.wt-button--table-sort[data-v-d10d919e] {\n  position: relative;\n  background: transparent;\n  border: 0;\n  text-transform: none;\n  padding: 0;\n  color: #42474c;\n  padding-right: 16px;\n  top: -2px;\n}\n.table-sort[data-v-d10d919e] {\n  position: absolute;\n  right: 0;\n  top: -4px;\n  width: 8px;\n}\n.table-sort svg[data-v-d10d919e] {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 8px;\n  fill: #42474c;\n}\n.table-sort svg + svg[data-v-d10d919e] {\n  top: 9px;\n  transform: rotateZ(180deg);\n}\n.table-sort.table-sort-selected.table-sort-asc svg[data-v-d10d919e]:first-of-type {\n  fill: #00b980;\n}\n.table-sort.table-sort-selected.table-sort-desc svg + svg[data-v-d10d919e] {\n  fill: #00b980;\n}\nsvg + .button-text[data-v-d10d919e],\n.button-text + svg[data-v-d10d919e] {\n  margin-left: 6px;\n}\n\n/*# sourceMappingURL=TfButton.vue.map */", map: {"version":3,"sources":["TfButton.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfButton.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;kCAEkC;ACmQlC;;EAEA,mBAAA;EACA,wBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;ADjQA;ACmQA;;EACA,eAAA;ADhQA;ACoQA;;;;EAEA,0BAAA;ADhQA;ACoQA;;EAEA,iBAAA;ADjQA;ACoQA;;EAEA,iBAAA;ADjQA;ACoQA;;EAEA,eAAA;EACA,kBAAA;EACA,mBAAA;ADjQA;ACoQA;;;;EAIA,kBAAA;ADjQA;ACoQA;;EAEA,eAAA;EACA,iBAAA;ADjQA;ACoQA;;EAEA,eAAA;EACA,iBAAA;ADjQA;ACwQA;;;;EACA,YAAA;ADlQA;ACwQA;;EACA,YAAA;ADpQA;ACwQA;;;;EAIA,gBAAA;ADrQA;ACuQA;;;;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;ADlQA;ACoQA;;;;EACA,cAAA;AD/PA;ACwQA;;;;EACA,WAAA;EACA,YAAA;ADlQA;ACsQA;;EAEA,sBAAA;EACA,kBAAA;EACA,WAAA;ADnQA;ACsQA;;EAEA,6BAAA;EACA,kBAAA;EACA,WAAA;ADnQA;ACsQA;;EAEA,WAAA;EACA,mBAAA;EACA,qBAAA;ADnQA;ACsQA;;EAEA,WAAA;EACA,mBAAA;EACA,qBAAA;ADnQA;ACsQA;;EAEA,mBAAA;EACA,cAAA;ADnQA;ACqQA;;;EAEA,qBAAA;ADlQA;ACsQA;;EAEA,6BAAA;EACA,yBAAA;EACA,WAAA;ADnQA;ACsQA;;;;;;;;;;EAUA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;ADnQA;ACqQA;;;;;;;;;;EACA,YAAA;EACA,gBAAA;AD1PA;AC8PA;;;;;;;;EAQA,SAAA;EACA,UAAA;AD3PA;AC8PA;;EAEA,YAAA;EACA,6BAAA;EACA,kBAAA;AD3PA;AC6PA;;EACA,UAAA;AD1PA;AC6PA;;EACA,kBAAA;AD1PA;AC8PA;;;EAEA,sBAAA;AD3PA;AC8PA;;;EAEA,yBAAA;AD3PA;AC8PA;;;EAEA,yBAAA;AD3PA;AC8PA;;;EACA,6BAAA;AD1PA;AC+PA;;;;EAKA,eAAA;EACA,gBAAA;AD7PA;ACgQA;;;;EACA,iBAAA;AD3PA;ACmQA;;;;EACA,WAAA;EACA,YAAA;AD7PA;ACiQA;;EAEA,WAAA;EACA,YAAA;AD9PA;ACiQA;;;;;;;;;;EAUA,WAAA;AD9PA;ACiQA;;;;;;;;;;EAUA,cAAA;AD9PA;ACiQA;;;;;;;;;;EAUA,cAAA;AD9PA;ACiQA;;;;;;;;;;EAUA,uBAAA;EACA,cAAA;AD9PA;;ACiQA,kBAAA;AACA;;EAEA,kBAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;AD9PA;ACiQA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AD9PA;ACgQA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;AD9PA;ACiQA;EACA,QAAA;EACA,0BAAA;AD/PA;ACmQA;EACA,aAAA;ADjQA;ACsQA;EACA,aAAA;ADpQA;AC0QA;;EAEA,gBAAA;ADvQA;;AAEA,uCAAuC","file":"TfButton.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tf-button,\n.wt-button {\n  white-space: nowrap;\n  -webkit-appearance: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  text-align: center;\n  box-sizing: border-box;\n  outline: 0;\n  margin: 0;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  background-color: #009;\n  border-color: #009;\n  color: #fff;\n  font-size: 16px;\n  padding: 7px 14px;\n  border-radius: 0;\n  text-transform: none;\n  border: 2px #009 solid;\n  display: inline-flex;\n  align-items: center;\n  font-weight: 600;\n  line-height: 1;\n}\n.tf-button:not(.is-disabled),\n.wt-button:not(.is-disabled) {\n  cursor: pointer;\n}\n.tf-button .button-text,\n.tf-button svg,\n.wt-button .button-text,\n.wt-button svg {\n  transform: translate(0, 0);\n}\n\n.tf-button + .tf-button,\n.wt-button + .wt-button {\n  margin-left: 14px;\n}\n\n.tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill,\n.wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill {\n  margin-left: 10px;\n}\n\n.tf-button--large,\n.wt-button--large {\n  font-size: 18px;\n  padding: 12px 18px;\n  border-radius: 25px;\n}\n\n.tf-button--medium,\n.tf-button--small,\n.wt-button--medium,\n.wt-button--small {\n  border-radius: 3px;\n}\n\n.tf-button--medium,\n.wt-button--medium {\n  font-size: 16px;\n  padding: 7px 18px;\n}\n\n.tf-button--small,\n.wt-button--small {\n  font-size: 14px;\n  padding: 5px 13px;\n}\n\n.tf-button--large.has-icon svg,\n.tf-button--medium.has-icon svg,\n.wt-button--large.has-icon svg,\n.wt-button--medium.has-icon svg {\n  height: 15px;\n}\n\n.tf-button--small.has-icon svg,\n.wt-button--small.has-icon svg {\n  height: 13px;\n}\n\n.tf-button--icon,\n.tf-button--icon-no-fill,\n.wt-button--icon,\n.wt-button--icon-no-fill {\n  padding: 5px 4px;\n}\n.tf-button--icon span,\n.tf-button--icon-no-fill span,\n.wt-button--icon span,\n.wt-button--icon-no-fill span {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n}\n.tf-button--icon span + svg,\n.tf-button--icon-no-fill span + svg,\n.wt-button--icon span + svg,\n.wt-button--icon-no-fill span + svg {\n  margin-left: 0;\n}\n\n.tf-button--icon.has-icon svg,\n.tf-button--icon-no-fill.has-icon svg,\n.wt-button--icon.has-icon svg,\n.wt-button--icon-no-fill.has-icon svg {\n  width: 14px;\n  height: 14px;\n}\n\n.tf-button--primary,\n.wt-button--primary {\n  background-color: #009;\n  border-color: #009;\n  color: #fff;\n}\n\n.tf-button--secondary,\n.wt-button--secondary {\n  background-color: transparent;\n  border-color: #009;\n  color: #009;\n}\n\n.tf-button--affirm,\n.wt-button--affirm {\n  color: #fff;\n  background: #00b980;\n  border-color: #00b980;\n}\n\n.tf-button--decline,\n.wt-button--decline {\n  color: #fff;\n  background: #f92f37;\n  border-color: #f92f37;\n}\n\n.tf-button.is-disabled,\n.wt-button.is-disabled {\n  background: #efefef;\n  color: #c1c1c1;\n}\n.tf-button.is-disabled:not(.tf-button--icon-no-fill), .tf-button.is-disabled:not(.wt-button--icon-no-fill),\n.wt-button.is-disabled:not(.tf-button--icon-no-fill),\n.wt-button.is-disabled:not(.wt-button--icon-no-fill) {\n  border-color: #efefef;\n}\n\n.tf-button--no-fill,\n.wt-button--no-fill {\n  background-color: transparent;\n  border-color: transparent;\n  color: #009;\n}\n\n.tf-button--text,\n.tf-button--text-small,\n.tf-button--text-icon.has-icon,\n.tf-button--text-icon-small.has-icon,\n.tf-button--icon-no-fill.has-icon,\n.wt-button--text,\n.wt-button--text-small,\n.wt-button--text-icon.has-icon,\n.wt-button--text-icon-small.has-icon,\n.wt-button--icon-no-fill.has-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  text-transform: none;\n  font-size: 14px;\n}\n.tf-button--text svg,\n.tf-button--text-small svg,\n.tf-button--text-icon.has-icon svg,\n.tf-button--text-icon-small.has-icon svg,\n.tf-button--icon-no-fill.has-icon svg,\n.wt-button--text svg,\n.wt-button--text-small svg,\n.wt-button--text-icon.has-icon svg,\n.wt-button--text-icon-small.has-icon svg,\n.wt-button--icon-no-fill.has-icon svg {\n  flex-grow: 0;\n  position: static;\n}\n\n.tf-button--text,\n.tf-button--text-small,\n.tf-button--text-icon.has-icon,\n.tf-button--text-icon-small.has-icon,\n.wt-button--text,\n.wt-button--text-small,\n.wt-button--text-icon.has-icon,\n.wt-button--text-icon-small.has-icon {\n  border: 0;\n  padding: 0;\n}\n\n.tf-button--icon-no-fill,\n.wt-button--icon-no-fill {\n  padding: 6px;\n  border: 2px transparent solid;\n  border-radius: 3px;\n}\n.tf-button--icon-no-fill.no-padding,\n.wt-button--icon-no-fill.no-padding {\n  padding: 0;\n}\n.tf-button--icon-no-fill span,\n.wt-button--icon-no-fill span {\n  position: absolute;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--primary, .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--primary,\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--primary,\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--primary {\n  border: 2px #009 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--affirm, .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--affirm,\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--affirm,\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--affirm {\n  border: 2px #00b980 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--decline, .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--decline,\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--decline,\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--decline {\n  border: 2px #f92f37 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).no-border, .tf-button--icon-no-fill:hover:not(.is-disabled).no-padding,\n.wt-button--icon-no-fill:hover:not(.is-disabled).no-border,\n.wt-button--icon-no-fill:hover:not(.is-disabled).no-padding {\n  border: 2px transparent solid;\n}\n\n.tf-button--text-icon-small.has-icon,\n.tf-button--text-small,\n.wt-button--text-icon-small.has-icon,\n.wt-button--text-small {\n  font-size: 12px;\n  font-weight: 400;\n}\n.tf-button--text-icon-small.has-icon .button-text,\n.tf-button--text-small .button-text,\n.wt-button--text-icon-small.has-icon .button-text,\n.wt-button--text-small .button-text {\n  line-height: 21px;\n}\n\n.tf-button--text-icon.has-icon svg,\n.tf-button--icon-no-fill.has-icon svg,\n.wt-button--text-icon.has-icon svg,\n.wt-button--icon-no-fill.has-icon svg {\n  width: 15px;\n  height: 15px;\n}\n\n.tf-button--text-icon-small.has-icon svg,\n.wt-button--text-icon-small.has-icon svg {\n  width: 11px;\n  height: 11px;\n}\n\n.tf-button--text.tf-button--primary,\n.tf-button--text-small.tf-button--primary,\n.tf-button--text-icon.tf-button--primary,\n.tf-button--text-icon-small.tf-button--primary,\n.tf-button--icon-no-fill.tf-button--primary,\n.wt-button--text.wt-button--primary,\n.wt-button--text-small.wt-button--primary,\n.wt-button--text-icon.wt-button--primary,\n.wt-button--text-icon-small.wt-button--primary,\n.wt-button--icon-no-fill.wt-button--primary {\n  color: #009;\n}\n\n.tf-button--text.tf-button--affirm,\n.tf-button--text-small.tf-button--affirm,\n.tf-button--text-icon.tf-button--affirm,\n.tf-button--text-icon-small.tf-button--affirm,\n.tf-button--icon-no-fill.tf-button--affirm,\n.wt-button--text.wt-button--affirm,\n.wt-button--text-small.wt-button--affirm,\n.wt-button--text-icon.wt-button--affirm,\n.wt-button--text-icon-small.wt-button--affirm,\n.wt-button--icon-no-fill.wt-button--affirm {\n  color: #00b980;\n}\n\n.tf-button--text.tf-button--decline,\n.tf-button--text-small.tf-button--decline,\n.tf-button--text-icon.tf-button--decline,\n.tf-button--text-icon-small.tf-button--decline,\n.tf-button--icon-no-fill.tf-button--decline,\n.wt-button--text.wt-button--decline,\n.wt-button--text-small.wt-button--decline,\n.wt-button--text-icon.wt-button--decline,\n.wt-button--text-icon-small.wt-button--decline,\n.wt-button--icon-no-fill.wt-button--decline {\n  color: #f92f37;\n}\n\n.tf-button--text[disabled],\n.tf-button--text-small[disabled],\n.tf-button--text-icon[disabled],\n.tf-button--text-icon-small[disabled],\n.tf-button--icon-no-fill[disabled],\n.wt-button--text[disabled],\n.wt-button--text-small[disabled],\n.wt-button--text-icon[disabled],\n.wt-button--text-icon-small[disabled],\n.wt-button--icon-no-fill[disabled] {\n  background: transparent;\n  color: #c1c1c1;\n}\n\n/* table buttons */\n.tf-button--table-sort,\n.wt-button--table-sort {\n  position: relative;\n  background: transparent;\n  border: 0;\n  text-transform: none;\n  padding: 0;\n  color: #42474c;\n  padding-right: 16px;\n  top: -2px;\n}\n\n.table-sort {\n  position: absolute;\n  right: 0;\n  top: -4px;\n  width: 8px;\n}\n.table-sort svg {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 8px;\n  fill: #42474c;\n}\n.table-sort svg + svg {\n  top: 9px;\n  transform: rotateZ(180deg);\n}\n.table-sort.table-sort-selected.table-sort-asc svg:first-of-type {\n  fill: #00b980;\n}\n.table-sort.table-sort-selected.table-sort-desc svg + svg {\n  fill: #00b980;\n}\n\nsvg + .button-text,\n.button-text + svg {\n  margin-left: 6px;\n}\n\n/*# sourceMappingURL=TfButton.vue.map */","<template>\n  <component\n    :is=\"tag\"\n    :disabled=\"buttonDisabled\"\n    :autofocus=\"autofocus\"\n    :type=\"nativeType\"\n    :href=\"href\"\n    :target=\"target\"\n    :class=\"[\n      type ? `tf-button--${type} wt-button--${type}` : '',\n      buttonSize ? `tf-button--${buttonSize} wt-button--${buttonSize}` : '',\n      {\n        'is-disabled': buttonDisabled\n      },\n      icon ? `has-icon icon-${icon}` : '',\n      { [`has-icon icon-spinner`] : loading },\n      { 'no-padding': noPadding },\n      { 'no-border': noBorder }\n    ]\"\n    :style=\"colorStyle\"\n    class=\"tf-button wt-button\"\n    @mousedown=\"$emit('mousedown', $event)\"\n    @mouseover=\"hover = true\"\n    @mouseout=\"hover = false\"\n    @click=\"handleClick\"\n  >\n    <!-- Prepend icons to text -->\n    <template v-if=\"icon && prepend\">\n      <icon\n        :class=\"{ 'is-rotating': loading }\"\n        :name=\"!loading ? icon : 'spinner'\"\n      />\n    </template>\n    <span\n      v-if=\"$slots.default\"\n      class=\"button-text\"\n    >\n      <slot />\n    </span>\n    <!-- Add loading icon when there is no prefixed/affixed icon -->\n    <icon\n      v-if=\"!icon && loading\"\n      class=\"icon-loading is-rotating\"\n      name=\"spinner\"\n    />\n    <!-- Append icons to text -->\n    <template v-if=\"icon && !prepend\">\n      <icon\n        :class=\"{ 'is-rotating': loading }\"\n        :name=\"!loading ? icon : 'spinner'\"\n      />\n    </template>\n    <div\n      v-if=\"type === 'table-sort'\"\n      :class=\"`table-sort table-sort-${direction} ${selected ? 'table-sort-selected' : ''}`\"\n    >\n      <icon name=\"angle-up\" />\n      <icon name=\"angle-up\" />\n    </div>\n  </component>\n</template>\n<script>\n  export default {\n    name: 'TfButton',\n    inject: {\n      elForm: {\n        default: '',\n      },\n      elFormItem: {\n        default: '',\n      },\n      $themePrimaryButtonColor: { default: () => null },\n      $themeSecondaryButtonColor: { default: () => null },\n    },\n    props: {\n      tag: {\n        type: String,\n        default: 'button',\n      },\n      href: {\n        type: String,\n        default: null,\n      },\n      target: {\n        type: String,\n        default: null,\n      },\n      type: {\n        type: String,\n        default: 'default',\n      },\n      size: {\n        type: String,\n        default: null,\n      },\n      icon: {\n        type: String,\n        default: '',\n      },\n      nativeType: {\n        type: String,\n        default: 'button',\n      },\n      disabled: {\n        type: Boolean,\n        default: false,\n      },\n      loading: {\n        type: Boolean,\n        default: false,\n      },\n      noPadding: {\n        type: Boolean,\n        default: false,\n      },\n      noBorder: {\n        type: Boolean,\n        default: false,\n      },\n      noBranding: {\n        type: Boolean,\n        default: false,\n      },\n      autofocus: {\n        type: Boolean,\n        default: false,\n      },\n      selected: {\n        type: Boolean,\n        default: false,\n      },\n      direction: {\n        type: String,\n        default: 'asc',\n      },\n      svgHeight: {\n        type: Number,\n        default: () => 15,\n      },\n      svgWidth: {\n        type: Number,\n        default: () => 12,\n      },\n      prepend: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: () => ({\n      hover: false,\n    }),\n    computed: {\n      /**\n       * Return color value as reactive value\n       *\n       * @returns {string}\n       */\n      themePrimaryButtonColor() {\n        return this.$themePrimaryButtonColor ? this.$themePrimaryButtonColor() : null;\n      },\n      /**\n       * Return color value as reactive value\n       *\n       * @returns {string}\n       */\n      themeSecondaryButtonColor() {\n        return this.$themeSecondaryButtonColor ? this.$themeSecondaryButtonColor() : null;\n      },\n      /**\n       * inline styles to match primaryColor\n       *\n       * @returns {object}\n       */\n      colorStyle() {\n        const style = {};\n\n        if (this.buttonDisabled || this.noBranding) {\n          return style;\n        }\n\n        if (this.themePrimaryButtonColor) {\n          if (this.type === 'primary') {\n            if ([\n              'text-icon',\n              'text-icon-small',\n              'text',\n              'text-small',\n              'icon-no-fill',\n            ].includes(this.size)) {\n              // all text button styles and default icon style (no-fill)\n              style.color = this.themePrimaryButtonColor;\n\n              if (\n                !this.noBorder\n                && !this.noPadding\n                && this.size === 'icon-no-fill'\n                && this.hover\n              ) {\n                style.borderColor = this.themePrimaryButtonColor;\n              }\n            } else {\n              // default primary button (large, medium, icon)\n              style.backgroundColor = this.themePrimaryButtonColor;\n              style.borderColor = this.themePrimaryButtonColor;\n            }\n          }\n        }\n\n        if (this.themeSecondaryButtonColor) {\n          if (this.type === 'secondary') {\n            style.color = this.themeSecondaryButtonColor;\n            style.borderColor = this.themeSecondaryButtonColor;\n          }\n        }\n\n        return style;\n      },\n      /**\n       * get formItemSize (from Element)\n       *\n       * @returns {string}\n       */\n      elFormItemSize() {\n        return (this.elFormItem || {}).elFormItemSize;\n      },\n      /**\n       * get button size and if size is the deprecated 'icon-small', convert to new 'icon-no-fill'\n       *\n       * @returns {string}\n       */\n      buttonSize() {\n        const updatedSize = this.size === 'icon-small' ? 'icon-no-fill' : this.size;\n        return updatedSize\n          || this.elFormItemSize\n          || (this.$ELEMENT || {}).size;\n      },\n      /**\n       * Is button disabled\n       *\n       * @returns {boolean}\n       */\n      buttonDisabled() {\n        const disabledForm = (this.elForm || {}).disabled;\n\n        return this.disabled || disabledForm || this.loading;\n      },\n    },\n    methods: {\n      /**\n       * Emit click\n       *\n       * @param {event} evt\n       */\n      handleClick(evt) {\n        this.$emit('click', evt);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n  @import 'src/assets/styles/mixins';\n\n  .tf-button,\n  .wt-button {\n    white-space: nowrap;\n    -webkit-appearance: none;\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none;\n    text-align: center;\n    box-sizing: border-box;\n    outline: 0;\n    margin: 0;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    background-color: $tf-blue;\n    border-color: $tf-blue;\n    color: $tf-white;\n    font-size: 16px;\n    padding: 7px 14px;\n    border-radius: 0;\n    text-transform: none;\n    border: 2px $tf-blue solid;\n    display: inline-flex;\n    align-items: center;\n    font-weight: 600;\n    line-height: 1;\n\n    &:not(.is-disabled) {\n      cursor: pointer;\n    }\n\n    // 2-12-21 RLH - styles added to span to stop button text/icon from jumping when clicked in IE\n    .button-text,\n    svg {\n      transform: translate(0, 0);\n    }\n  }\n\n  .tf-button + .tf-button,\n  .wt-button + .wt-button {\n    margin-left: 14px;\n  }\n\n  .tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill,\n  .wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill {\n    margin-left: 10px;\n  }\n\n  .tf-button--large,\n  .wt-button--large {\n    font-size: 18px;\n    padding: 12px 18px;\n    border-radius: 25px;\n  }\n\n  .tf-button--medium,\n  .tf-button--small,\n  .wt-button--medium,\n  .wt-button--small {\n    border-radius: 3px;\n  }\n\n  .tf-button--medium,\n  .wt-button--medium {\n    font-size: 16px;\n    padding: 7px 18px;\n  }\n\n  .tf-button--small,\n  .wt-button--small {\n    font-size: 14px;\n    padding: 5px 13px;\n  }\n\n  .tf-button--large.has-icon,\n  .tf-button--medium.has-icon,\n  .wt-button--large.has-icon,\n  .wt-button--medium.has-icon {\n    svg {\n      height: 15px;\n    }\n  }\n\n  .tf-button--small.has-icon,\n  .wt-button--small.has-icon {\n    svg {\n      height: 13px;\n    }\n  }\n\n  .tf-button--icon,\n  .tf-button--icon-no-fill,\n  .wt-button--icon,\n  .wt-button--icon-no-fill {\n    padding: 5px 4px;\n\n    span {\n      display: inline-block;\n      width: 0;\n      height: 0;\n      overflow: hidden;\n\n      + svg {\n        margin-left: 0;\n      }\n    }\n  }\n\n  .tf-button--icon.has-icon,\n  .tf-button--icon-no-fill.has-icon,\n  .wt-button--icon.has-icon,\n  .wt-button--icon-no-fill.has-icon {\n    svg {\n      width: 14px;\n      height: 14px;\n    }\n  }\n\n  .tf-button--primary,\n  .wt-button--primary {\n    background-color: $tf-blue;\n    border-color: $tf-blue;\n    color: $tf-white;\n  }\n\n  .tf-button--secondary,\n  .wt-button--secondary {\n    background-color: transparent;\n    border-color: $tf-blue;\n    color: $tf-blue;\n  }\n\n  .tf-button--affirm,\n  .wt-button--affirm {\n    color: $tf-white;\n    background: $tf-green;\n    border-color: $tf-green;\n  }\n\n  .tf-button--decline,\n  .wt-button--decline {\n    color: $tf-white;\n    background: $tf-red;\n    border-color: $tf-red;\n  }\n\n  .tf-button.is-disabled,\n  .wt-button.is-disabled {\n    background: $tf-extra-light-gray-1;\n    color: $tf-light-gray;\n\n    &:not(.tf-button--icon-no-fill),\n    &:not(.wt-button--icon-no-fill) {\n      border-color: $tf-extra-light-gray-1;\n    }\n  }\n\n  .tf-button--no-fill,\n  .wt-button--no-fill {\n    background-color: transparent;\n    border-color: transparent;\n    color: $tf-blue;\n  }\n\n  .tf-button--text,\n  .tf-button--text-small,\n  .tf-button--text-icon.has-icon,\n  .tf-button--text-icon-small.has-icon,\n  .tf-button--icon-no-fill.has-icon,\n  .wt-button--text,\n  .wt-button--text-small,\n  .wt-button--text-icon.has-icon,\n  .wt-button--text-icon-small.has-icon,\n  .wt-button--icon-no-fill.has-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    text-transform: none;\n    font-size: 14px;\n\n    svg {\n      flex-grow: 0;\n      position: static;\n    }\n  }\n\n  .tf-button--text,\n  .tf-button--text-small,\n  .tf-button--text-icon.has-icon,\n  .tf-button--text-icon-small.has-icon,\n  .wt-button--text,\n  .wt-button--text-small,\n  .wt-button--text-icon.has-icon,\n  .wt-button--text-icon-small.has-icon {\n    border: 0;\n    padding: 0;\n  }\n\n  .tf-button--icon-no-fill,\n  .wt-button--icon-no-fill {\n    padding: 6px;\n    border: 2px transparent solid;\n    border-radius: 3px;\n\n    &.no-padding {\n      padding: 0;\n    }\n\n    span {\n      position: absolute;\n    }\n\n    &:hover:not(.is-disabled) {\n      &.tf-button--primary,\n      &.wt-button--primary {\n        border: 2px $tf-blue solid;\n      }\n\n      &.tf-button--affirm,\n      &.wt-button--affirm {\n        border: 2px $tf-green solid;\n      }\n\n      &.tf-button--decline,\n      &.wt-button--decline {\n        border: 2px $tf-red solid;\n      }\n\n      &.no-border, &.no-padding {\n        border: 2px transparent solid;\n      }\n    }\n  }\n\n  .tf-button--text-icon-small.has-icon,\n  .tf-button--text-small,\n  .wt-button--text-icon-small.has-icon,\n  .wt-button--text-small {\n    font: {\n      size: 12px;\n      weight: 400;\n    }\n\n    .button-text {\n      line-height: 21px;\n    }\n  }\n\n  .tf-button--text-icon.has-icon,\n  .tf-button--icon-no-fill.has-icon,\n  .wt-button--text-icon.has-icon,\n  .wt-button--icon-no-fill.has-icon {\n    svg {\n      width: 15px;\n      height: 15px;\n    }\n  }\n\n  .tf-button--text-icon-small.has-icon svg,\n  .wt-button--text-icon-small.has-icon svg {\n    width: 11px;\n    height: 11px;\n  }\n\n  .tf-button--text.tf-button--primary,\n  .tf-button--text-small.tf-button--primary,\n  .tf-button--text-icon.tf-button--primary,\n  .tf-button--text-icon-small.tf-button--primary,\n  .tf-button--icon-no-fill.tf-button--primary,\n  .wt-button--text.wt-button--primary,\n  .wt-button--text-small.wt-button--primary,\n  .wt-button--text-icon.wt-button--primary,\n  .wt-button--text-icon-small.wt-button--primary,\n  .wt-button--icon-no-fill.wt-button--primary {\n    color: $tf-blue;\n  }\n\n  .tf-button--text.tf-button--affirm,\n  .tf-button--text-small.tf-button--affirm,\n  .tf-button--text-icon.tf-button--affirm,\n  .tf-button--text-icon-small.tf-button--affirm,\n  .tf-button--icon-no-fill.tf-button--affirm,\n  .wt-button--text.wt-button--affirm,\n  .wt-button--text-small.wt-button--affirm,\n  .wt-button--text-icon.wt-button--affirm,\n  .wt-button--text-icon-small.wt-button--affirm,\n  .wt-button--icon-no-fill.wt-button--affirm {\n    color: $tf-green;\n  }\n\n  .tf-button--text.tf-button--decline,\n  .tf-button--text-small.tf-button--decline,\n  .tf-button--text-icon.tf-button--decline,\n  .tf-button--text-icon-small.tf-button--decline,\n  .tf-button--icon-no-fill.tf-button--decline,\n  .wt-button--text.wt-button--decline,\n  .wt-button--text-small.wt-button--decline,\n  .wt-button--text-icon.wt-button--decline,\n  .wt-button--text-icon-small.wt-button--decline,\n  .wt-button--icon-no-fill.wt-button--decline {\n    color: $tf-red;\n  }\n\n  .tf-button--text[disabled],\n  .tf-button--text-small[disabled],\n  .tf-button--text-icon[disabled],\n  .tf-button--text-icon-small[disabled],\n  .tf-button--icon-no-fill[disabled],\n  .wt-button--text[disabled],\n  .wt-button--text-small[disabled],\n  .wt-button--text-icon[disabled],\n  .wt-button--text-icon-small[disabled],\n  .wt-button--icon-no-fill[disabled] {\n    background: transparent;\n    color: $tf-light-gray;\n  }\n\n  /* table buttons */\n  .tf-button--table-sort,\n  .wt-button--table-sort {\n    position: relative;\n    background: transparent;\n    border: 0;\n    text-transform: none;\n    padding: 0;\n    color: $tf-dark-gray;\n    padding-right: 16px;\n    top: -2px;\n  }\n\n  .table-sort {\n    position: absolute;\n    right: 0;\n    top: -4px;\n    width: 8px;\n\n    svg {\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 8px;\n      fill: $tf-dark-gray;\n    }\n\n    svg + svg {\n      top: 9px;\n      transform: rotateZ(180deg);\n    }\n\n    &.table-sort-selected.table-sort-asc {\n      svg:first-of-type {\n        fill: $tf-green;\n      }\n    }\n\n    &.table-sort-selected.table-sort-desc {\n      svg + svg {\n        fill: $tf-green;\n      }\n    }\n  }\n\n  // Add margin to span for appended icons\n  svg + .button-text,\n  .button-text + svg {\n    margin-left: 6px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$l = "data-v-d10d919e";
  /* module identifier */
  const __vue_module_identifier__$l = undefined;
  /* functional template */
  const __vue_is_functional_template__$l = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$l = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
    __vue_inject_styles__$l,
    __vue_script__$l,
    __vue_scope_id__$l,
    __vue_is_functional_template__$l,
    __vue_module_identifier__$l,
    false,
    browser,
    undefined,
    undefined
  );

var script$m = {
  name: 'TfCheckbox',
  extends: Checkbox,
  inject: {
    $themeCheckboxColor: {
      default: function _default() {
        return null;
      }
    }
  },
  props: {
    noBranding: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Return color value as reactive value
     *
     * @returns {string | null}
     */
    themeCheckboxColor: function themeCheckboxColor() {
      return !this.noBranding && this.$themeCheckboxColor ? this.$themeCheckboxColor() : null;
    }
  },
  watch: {
    /**
     * when the user focus we need to emit up an event and possibly update our colors
     */
    focus: function focus() {
      this.$emit(this.focus ? 'focus' : 'blur');
      this.toggleColors();
    },
    /**
     * when the user checks the box we need to check if we need to update the colors
     */
    isChecked: function isChecked() {
      this.toggleColors();
    },
    /**
     * When we get the users branded colors we need to update the color of this checkbox
     */
    themeCheckboxColor: function themeCheckboxColor() {
      this.toggleColors();
    },
    /**
     * if the checkbox is disabled we might need to update the checkboxes colors
     */
    disabled: function disabled() {
      var _this = this;
      this.$nextTick(function () {
        _this.toggleColors();
      });
    }
  },
  mounted: function mounted() {
    if (this.themeCheckboxColor) {
      this.toggleColors();
    }
  },
  methods: {
    /**
     * Update all the colors, with inline styles if needed.
     */
    toggleColors: function toggleColors() {
      var innerEl = this.$el.querySelector('.el-checkbox__inner');
      var colorLabel = this.$el.querySelector('.color-label');
      if (this.disabled) {
        innerEl.removeAttribute('style');
        return;
      }
      if (this.isChecked) {
        innerEl.style.backgroundColor = this.themeCheckboxColor;
        if (colorLabel) {
          colorLabel.style.color = this.themeCheckboxColor;
        }
      } else {
        innerEl.removeAttribute('style');
        if (colorLabel) {
          colorLabel.removeAttribute('style');
        }
      }
      if (!this.focus) {
        innerEl.style.borderColor = this.themeCheckboxColor;
      } else {
        innerEl.style.removeProperty('border-color');
      }
    }
  }
};

/* script */
const __vue_script__$m = script$m;

/* template */

  /* style */
  const __vue_inject_styles__$m = undefined;
  /* scoped */
  const __vue_scope_id__$m = undefined;
  /* module identifier */
  const __vue_module_identifier__$m = undefined;
  /* functional template */
  const __vue_is_functional_template__$m = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$m = /*#__PURE__*/normalizeComponent_1(
    {},
    __vue_inject_styles__$m,
    __vue_script__$m,
    __vue_scope_id__$m,
    __vue_is_functional_template__$m,
    __vue_module_identifier__$m,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * "CtaEmailSupport" is a simple call-to-action component used for opening a user's email client (if set) with the appropriate support email address.
 *
 * @vuedoc
 * @exports TfCtaEmailSupport
 * @category components
 */
var script$n = {
  name: 'TfCtaEmailSupport',
  props: {
    /**
     * Boolean used to tell the TfButton component to bypass branding styles.
     */
    noBranding: {
      type: Boolean,
      default: false
    },
    /**
     * String used to tell the TfButton component what button type/color to display.
     */
    type: {
      type: String,
      default: 'primary'
    }
  }
};

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "TfButton",
    {
      staticClass: "cta-email-support",
      attrs: {
        href: "mailto:support@threeflow.com",
        size: "text",
        tag: "a",
        target: "_blank",
        type: _vm.type,
        "no-branding": _vm.noBranding,
      },
    },
    [
      _vm._t("default", function () {
        return [_vm._v("\n    contact support\n  ")]
      }),
    ],
    2
  )
};
var __vue_staticRenderFns__$m = [];
__vue_render__$m._withStripped = true;

  /* style */
  const __vue_inject_styles__$n = function (inject) {
    if (!inject) return
    inject("data-v-20ce82ce_0", { source: "\n.cta-email-support[data-v-20ce82ce] {\n  display: inline-block;\n  font-size: inherit;\n}\n", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfCtaEmailSupport.vue"],"names":[],"mappings":";AA6CA;EACA,qBAAA;EACA,kBAAA;AACA","file":"TfCtaEmailSupport.vue","sourcesContent":["<template>\n  <TfButton\n    class=\"cta-email-support\"\n    href=\"mailto:support@threeflow.com\"\n    size=\"text\"\n    tag=\"a\"\n    target=\"_blank\"\n    :type=\"type\"\n    :no-branding=\"noBranding\"\n  >\n    <slot>\n      contact support\n    </slot>\n  </TfButton>\n</template>\n<script>\n  /**\n   * \"CtaEmailSupport\" is a simple call-to-action component used for opening a user's email client (if set) with the appropriate support email address.\n   *\n   * @vuedoc\n   * @exports TfCtaEmailSupport\n   * @category components\n   */\n  export default {\n    name: 'TfCtaEmailSupport',\n    props: {\n      /**\n       * Boolean used to tell the TfButton component to bypass branding styles.\n       */\n      noBranding: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * String used to tell the TfButton component what button type/color to display.\n       */\n      type: {\n        type: String,\n        default: 'primary',\n      },\n    },\n  };\n</script>\n\n<style scoped>\n  .cta-email-support {\n    display: inline-block;\n    font-size: inherit;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$n = "data-v-20ce82ce";
  /* module identifier */
  const __vue_module_identifier__$n = undefined;
  /* functional template */
  const __vue_is_functional_template__$n = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$n = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
    __vue_inject_styles__$n,
    __vue_script__$n,
    __vue_scope_id__$n,
    __vue_is_functional_template__$n,
    __vue_module_identifier__$n,
    false,
    browser,
    undefined,
    undefined
  );

var _arrayReduce = function (that, callbackfn, aLen, memo, isRight) {
  _aFunction(callbackfn);
  var O = _toObject(that);
  var self = _iobject(O);
  var length = _toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

_export(_export.P + _export.F * !_strictMethod([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return _arrayReduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

/**
 * PdfExportHeader
 *
 * @vuedoc
 * @exports components/TfPdfExport/Header
 * @category Components
 */
var script$o = {
  name: 'TfPdfExportHeader',
  props: {
    employerName: {
      type: String,
      required: true,
      default: null
    },
    filters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    title: {
      type: String,
      required: true,
      default: null
    }
  },
  computed: {
    /**
     * Generates today's date for template.
     *
     * @returns {string}
     */
    today: function today() {
      return moment().format('MM/DD/YYYY');
    },
    /**
     * Converts the filter object to array of objects with { type, values }.
     *
     * @returns {Array}
     */
    renderedFilters: function renderedFilters() {
      var _this = this;
      return Object.keys(this.filters).map(function (type) {
        return {
          type: type,
          values: _this.filters[type]
        };
      });
    },
    /**
     * Looks for any of the filters in renderedFilters to see if they have length.
     *
     * @returns {boolean}
     */
    showFilters: function showFilters() {
      return this.renderedFilters.length && this.renderedFilters.some(function (filter) {
        return filter.values.length;
      });
    }
  }
};

/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("header", { class: ["pdf-export-block", "pdf-export-header"] }, [
    _c("h1", [_vm._v(_vm._s(_vm.employerName))]),
    _vm._v(" "),
    _c("h2", [_vm._v(_vm._s(_vm.title) + " as of " + _vm._s(_vm.today))]),
    _vm._v(" "),
    _vm.showFilters
      ? _c(
          "div",
          { staticClass: "applied-filters" },
          [
            _vm._l(_vm.renderedFilters, function (filter) {
              return [
                filter.values.length
                  ? _c("p", { key: filter.type }, [
                      _c("strong", [_vm._v(_vm._s(filter.type))]),
                      _vm._v(
                        ": " + _vm._s(filter.values.join("; ")) + "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            }),
          ],
          2
        )
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__$n = [];
__vue_render__$n._withStripped = true;

  /* style */
  const __vue_inject_styles__$o = function (inject) {
    if (!inject) return
    inject("data-v-c310e4d6_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nheader[data-v-c310e4d6] {\n  border-bottom: 2px tf-light-gray solid;\n  padding-bottom: 20px;\n  text-align: left;\n  width: calc(100% - 80px);\n}\nh1[data-v-c310e4d6],\nh2[data-v-c310e4d6] {\n  font-weight: bold;\n  color: #000;\n}\nh1[data-v-c310e4d6] {\n  font-size: 20px;\n}\nh2[data-v-c310e4d6] {\n  font-size: 16px;\n}\n.applied-filters[data-v-c310e4d6] {\n  background: #efefef;\n  color: #000;\n  padding: 9px 12px;\n  font-size: 12px;\n  line-height: 18px;\n}\n.applied-filters strong[data-v-c310e4d6] {\n  text-transform: capitalize;\n}\n\n/*# sourceMappingURL=Header.vue.map */", map: {"version":3,"sources":["Header.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfPdfExport/Header.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC0FlC;EACA,sCAAA;EACA,oBAAA;EACA,gBAAA;EACA,wBAAA;ADxFA;AC2FA;;EAEA,iBAAA;EACA,WAAA;ADxFA;AC2FA;EACA,eAAA;ADxFA;AC2FA;EACA,eAAA;ADxFA;AC2FA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;ADxFA;AC0FA;EACA,0BAAA;ADxFA;;AAEA,qCAAqC","file":"Header.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nheader {\n  border-bottom: 2px tf-light-gray solid;\n  padding-bottom: 20px;\n  text-align: left;\n  width: calc(100% - 80px);\n}\n\nh1,\nh2 {\n  font-weight: bold;\n  color: #000;\n}\n\nh1 {\n  font-size: 20px;\n}\n\nh2 {\n  font-size: 16px;\n}\n\n.applied-filters {\n  background: #efefef;\n  color: #000;\n  padding: 9px 12px;\n  font-size: 12px;\n  line-height: 18px;\n}\n.applied-filters strong {\n  text-transform: capitalize;\n}\n\n/*# sourceMappingURL=Header.vue.map */","<template>\n  <header\n    :class=\"[\n      'pdf-export-block',\n      'pdf-export-header'\n    ]\"\n  >\n    <h1>{{ employerName }}</h1>\n    <h2>{{ title }} as of {{ today }}</h2>\n    <div\n      v-if=\"showFilters\"\n      class=\"applied-filters\"\n    >\n      <template v-for=\"filter in renderedFilters\">\n        <p\n          v-if=\"filter.values.length\"\n          :key=\"filter.type\"\n        >\n          <strong>{{ filter.type }}</strong>: {{ filter.values.join('; ') }}\n        </p>\n      </template>\n    </div>\n  </header>\n</template>\n\n<script>\n  import moment from 'moment';\n\n  /**\n   * PdfExportHeader\n   *\n   * @vuedoc\n   * @exports components/TfPdfExport/Header\n   * @category Components\n   */\n  export default {\n    name: 'TfPdfExportHeader',\n    props: {\n      employerName: {\n        type: String,\n        required: true,\n        default: null,\n      },\n      filters: {\n        type: Object,\n        default: () => ({}),\n      },\n      title: {\n        type: String,\n        required: true,\n        default: null,\n      },\n    },\n\n    computed: {\n      /**\n       * Generates today's date for template.\n       *\n       * @returns {string}\n       */\n      today() {\n        return moment().format('MM/DD/YYYY');\n      },\n\n      /**\n       * Converts the filter object to array of objects with { type, values }.\n       *\n       * @returns {Array}\n       */\n      renderedFilters() {\n        return Object.keys(this.filters).map((type) => ({\n          type,\n          values: this.filters[type],\n        }));\n      },\n\n      /**\n       * Looks for any of the filters in renderedFilters to see if they have length.\n       *\n       * @returns {boolean}\n       */\n      showFilters() {\n        return this.renderedFilters.length\n          && this.renderedFilters.some((filter) => filter.values.length);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n@import 'src/assets/styles/variables';\n\nheader {\n  border-bottom: 2px tf-light-gray solid;\n  padding-bottom: 20px;\n  text-align: left;\n  width: calc(100% - 80px);\n}\n\nh1,\nh2 {\n  font-weight: bold;\n  color: $tf-black;\n}\n\nh1 {\n  font-size: 20px;\n}\n\nh2 {\n  font-size: 16px;\n}\n\n.applied-filters {\n  background: $tf-extra-light-gray-1;\n  color: $tf-black;\n  padding: 9px 12px;\n  font-size: 12px;\n  line-height: 18px;\n\n  strong {\n    text-transform: capitalize;\n  }\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$o = "data-v-c310e4d6";
  /* module identifier */
  const __vue_module_identifier__$o = undefined;
  /* functional template */
  const __vue_is_functional_template__$o = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$o = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
    __vue_inject_styles__$o,
    __vue_script__$o,
    __vue_scope_id__$o,
    __vue_is_functional_template__$o,
    __vue_module_identifier__$o,
    false,
    browser,
    undefined,
    undefined
  );

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * PDF Exporter for Comments
 *
 * @vuedoc
 * @exports TfPdfExport/Comments
 * @category Components
 */
var script$p = {
  name: 'TfCommentsExport',
  components: {
    ExportHeader: __vue_component__$o
  },
  props: {
    broker: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    buttonSize: {
      type: String,
      default: 'text-icon'
    },
    buttonTitle: {
      type: String,
      default: 'export'
    },
    comments: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    documents: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    employerName: {
      type: String,
      default: null
    },
    filters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: Number,
      default: null
    },
    userInfo: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          firstName: '',
          lastName: '',
          organization: '',
          type: 'broker'
        };
      }
    }
  },
  computed: {
    /**
     * Sorts the comment replies in descending order and adds `topComment` to the top comments.
     * Then we return a flattened array of all comments.
     *
     * @returns {Array}
     */
    sortedComments: function sortedComments() {
      var _this = this;
      return this.comments.reduce(function (comments, comment) {
        var newComment = _objectSpread$1(_objectSpread$1({}, comment), {}, {
          replies: [],
          topComment: true
        });
        var sortedReplies = comment.replies ? _this.$TF.Formatting.sortObjects(comment.replies, 'created_at', 'desc') : [];
        return comments.concat([newComment], sortedReplies);
      }, []);
    }
  }
};

/* script */
const __vue_script__$p = script$p;

/* template */
var __vue_render__$o = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    [
      _c(
        "TfPdfExport",
        {
          attrs: {
            "button-size": _vm.buttonSize,
            "button-title": _vm.buttonTitle,
            filename: "comments_" + _vm.projectId + ".pdf",
            "is-disabled": !_vm.sortedComments.length,
          },
        },
        [
          _c("ExportHeader", {
            attrs: {
              "employer-name": _vm.employerName,
              filters: _vm.filters,
              title: "Comment History",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.sortedComments, function (comment) {
            return _c("Comment", {
              key: comment.id,
              attrs: {
                broker: _vm.broker,
                comment: comment,
                documents: _vm.documents,
                "project-id": _vm.projectId,
                "is-pdf-render": true,
                "is-reply": !comment.topComment,
                "user-info": _vm.userInfo,
                "application-namespace": "export",
              },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$o = [];
__vue_render__$o._withStripped = true;

  /* style */
  const __vue_inject_styles__$p = undefined;
  /* scoped */
  const __vue_scope_id__$p = undefined;
  /* module identifier */
  const __vue_module_identifier__$p = undefined;
  /* functional template */
  const __vue_is_functional_template__$p = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$p = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$o, staticRenderFns: __vue_staticRenderFns__$o },
    __vue_inject_styles__$p,
    __vue_script__$p,
    __vue_scope_id__$p,
    __vue_is_functional_template__$p,
    __vue_module_identifier__$p,
    false,
    undefined,
    undefined,
    undefined
  );

var Datepicker$1 = createCommonjsModule(function (module, exports) {
/*
* @sum.cumo/vue-datepicker v3.2.3
* (c) 2018-2021 sum.cumo GmbH
* Released under the Apache-2.0 License.
*/
(function (global, factory) {
	 module.exports = factory() ;
}(commonjsGlobal, (function () {
	var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};

	var check = function (it) {
	  return it && it.Math == Math && it;
	}; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


	var global$d = // eslint-disable-next-line es/no-global-this -- safe
	check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
	check(typeof self == 'object' && self) || check(typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1) || // eslint-disable-next-line no-new-func -- fallback
	function () {
	  return this;
	}() || Function('return this')();

	var objectGetOwnPropertyDescriptor = {};

	var fails$c = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};

	var fails$b = fails$c; // Detect IE8's incomplete defineProperty implementation

	var descriptors = !fails$b(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, {
	    get: function () {
	      return 7;
	    }
	  })[1] != 7;
	});

	var objectPropertyIsEnumerable = {};

	var $propertyIsEnumerable = {}.propertyIsEnumerable; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

	var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

	var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({
	  1: 2
	}, 1); // `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

	objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor$2(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;

	var createPropertyDescriptor$3 = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var toString$1 = {}.toString;

	var classofRaw$1 = function (it) {
	  return toString$1.call(it).slice(8, -1);
	};

	var fails$a = fails$c;
	var classof$6 = classofRaw$1;
	var split = ''.split; // fallback for non-array-like ES3 and non-enumerable old V8 strings

	var indexedObject = fails$a(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof$6(it) == 'String' ? split.call(it, '') : Object(it);
	} : Object;

	// https://tc39.es/ecma262/#sec-requireobjectcoercible

	var requireObjectCoercible$7 = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on " + it);
	  return it;
	};

	var IndexedObject$2 = indexedObject;
	var requireObjectCoercible$6 = requireObjectCoercible$7;

	var toIndexedObject$5 = function (it) {
	  return IndexedObject$2(requireObjectCoercible$6(it));
	};

	var isObject$a = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

	var isObject$9 = isObject$a; // `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string

	var toPrimitive$4 = function (input, PREFERRED_STRING) {
	  if (!isObject$9(input)) return input;
	  var fn, val;
	  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$9(val = fn.call(input))) return val;
	  if (typeof (fn = input.valueOf) == 'function' && !isObject$9(val = fn.call(input))) return val;
	  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$9(val = fn.call(input))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};

	var requireObjectCoercible$5 = requireObjectCoercible$7; // `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject

	var toObject$5 = function (argument) {
	  return Object(requireObjectCoercible$5(argument));
	};

	var toObject$4 = toObject$5;
	var hasOwnProperty = {}.hasOwnProperty;

	var has$7 = function hasOwn(it, key) {
	  return hasOwnProperty.call(toObject$4(it), key);
	};

	var global$c = global$d;
	var isObject$8 = isObject$a;
	var document$1 = global$c.document; // typeof document.createElement is 'object' in old IE

	var EXISTS = isObject$8(document$1) && isObject$8(document$1.createElement);

	var documentCreateElement$1 = function (it) {
	  return EXISTS ? document$1.createElement(it) : {};
	};

	var DESCRIPTORS$5 = descriptors;
	var fails$9 = fails$c;
	var createElement = documentCreateElement$1; // Thank's IE8 for his funny defineProperty

	var ie8DomDefine = !DESCRIPTORS$5 && !fails$9(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
	  return Object.defineProperty(createElement('div'), 'a', {
	    get: function () {
	      return 7;
	    }
	  }).a != 7;
	});

	var DESCRIPTORS$4 = descriptors;
	var propertyIsEnumerableModule = objectPropertyIsEnumerable;
	var createPropertyDescriptor$2 = createPropertyDescriptor$3;
	var toIndexedObject$4 = toIndexedObject$5;
	var toPrimitive$3 = toPrimitive$4;
	var has$6 = has$7;
	var IE8_DOM_DEFINE$1 = ie8DomDefine; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

	objectGetOwnPropertyDescriptor.f = DESCRIPTORS$4 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject$4(O);
	  P = toPrimitive$3(P, true);
	  if (IE8_DOM_DEFINE$1) try {
	    return $getOwnPropertyDescriptor(O, P);
	  } catch (error) {
	    /* empty */
	  }
	  if (has$6(O, P)) return createPropertyDescriptor$2(!propertyIsEnumerableModule.f.call(O, P), O[P]);
	};

	var objectDefineProperty = {};

	var isObject$7 = isObject$a;

	var anObject$a = function (it) {
	  if (!isObject$7(it)) {
	    throw TypeError(String(it) + ' is not an object');
	  }

	  return it;
	};

	var DESCRIPTORS$3 = descriptors;
	var IE8_DOM_DEFINE = ie8DomDefine;
	var anObject$9 = anObject$a;
	var toPrimitive$2 = toPrimitive$4; // eslint-disable-next-line es/no-object-defineproperty -- safe

	var $defineProperty = Object.defineProperty; // `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty

	objectDefineProperty.f = DESCRIPTORS$3 ? $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject$9(O);
	  P = toPrimitive$2(P, true);
	  anObject$9(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) {
	    /* empty */
	  }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

	var DESCRIPTORS$2 = descriptors;
	var definePropertyModule$4 = objectDefineProperty;
	var createPropertyDescriptor$1 = createPropertyDescriptor$3;
	var createNonEnumerableProperty$5 = DESCRIPTORS$2 ? function (object, key, value) {
	  return definePropertyModule$4.f(object, key, createPropertyDescriptor$1(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var redefine$4 = {exports: {}};

	var global$b = global$d;
	var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;

	var setGlobal$3 = function (key, value) {
	  try {
	    createNonEnumerableProperty$4(global$b, key, value);
	  } catch (error) {
	    global$b[key] = value;
	  }

	  return value;
	};

	var global$a = global$d;
	var setGlobal$2 = setGlobal$3;
	var SHARED = '__core-js_shared__';
	var store$3 = global$a[SHARED] || setGlobal$2(SHARED, {});
	var sharedStore = store$3;

	var store$2 = sharedStore;
	var functionToString = Function.toString; // this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper

	if (typeof store$2.inspectSource != 'function') {
	  store$2.inspectSource = function (it) {
	    return functionToString.call(it);
	  };
	}

	var inspectSource$2 = store$2.inspectSource;

	var global$9 = global$d;
	var inspectSource$1 = inspectSource$2;
	var WeakMap$1 = global$9.WeakMap;
	var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$1(WeakMap$1));

	var shared$4 = {exports: {}};

	var store$1 = sharedStore;
	(shared$4.exports = function (key, value) {
	  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.12.1',
	  mode: 'global',
	  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
	});

	var id = 0;
	var postfix = Math.random();

	var uid$2 = function (key) {
	  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
	};

	var shared$3 = shared$4.exports;
	var uid$1 = uid$2;
	var keys$1 = shared$3('keys');

	var sharedKey$2 = function (key) {
	  return keys$1[key] || (keys$1[key] = uid$1(key));
	};

	var hiddenKeys$4 = {};

	var NATIVE_WEAK_MAP = nativeWeakMap;
	var global$8 = global$d;
	var isObject$6 = isObject$a;
	var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
	var objectHas = has$7;
	var shared$2 = sharedStore;
	var sharedKey$1 = sharedKey$2;
	var hiddenKeys$3 = hiddenKeys$4;
	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var WeakMap = global$8.WeakMap;
	var set, get, has$5;

	var enforce = function (it) {
	  return has$5(it) ? get(it) : set(it, {});
	};

	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;

	    if (!isObject$6(it) || (state = get(it)).type !== TYPE) {
	      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
	    }

	    return state;
	  };
	};

	if (NATIVE_WEAK_MAP || shared$2.state) {
	  var store = shared$2.state || (shared$2.state = new WeakMap());
	  var wmget = store.get;
	  var wmhas = store.has;
	  var wmset = store.set;

	  set = function (it, metadata) {
	    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    wmset.call(store, it, metadata);
	    return metadata;
	  };

	  get = function (it) {
	    return wmget.call(store, it) || {};
	  };

	  has$5 = function (it) {
	    return wmhas.call(store, it);
	  };
	} else {
	  var STATE = sharedKey$1('state');
	  hiddenKeys$3[STATE] = true;

	  set = function (it, metadata) {
	    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty$3(it, STATE, metadata);
	    return metadata;
	  };

	  get = function (it) {
	    return objectHas(it, STATE) ? it[STATE] : {};
	  };

	  has$5 = function (it) {
	    return objectHas(it, STATE);
	  };
	}

	var internalState = {
	  set: set,
	  get: get,
	  has: has$5,
	  enforce: enforce,
	  getterFor: getterFor
	};

	var global$7 = global$d;
	var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
	var has$4 = has$7;
	var setGlobal$1 = setGlobal$3;
	var inspectSource = inspectSource$2;
	var InternalStateModule = internalState;
	var getInternalState = InternalStateModule.get;
	var enforceInternalState = InternalStateModule.enforce;
	var TEMPLATE = String(String).split('String');
	(redefine$4.exports = function (O, key, value, options) {
	  var unsafe = options ? !!options.unsafe : false;
	  var simple = options ? !!options.enumerable : false;
	  var noTargetGet = options ? !!options.noTargetGet : false;
	  var state;

	  if (typeof value == 'function') {
	    if (typeof key == 'string' && !has$4(value, 'name')) {
	      createNonEnumerableProperty$2(value, 'name', key);
	    }

	    state = enforceInternalState(value);

	    if (!state.source) {
	      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
	    }
	  }

	  if (O === global$7) {
	    if (simple) O[key] = value;else setGlobal$1(key, value);
	    return;
	  } else if (!unsafe) {
	    delete O[key];
	  } else if (!noTargetGet && O[key]) {
	    simple = true;
	  }

	  if (simple) O[key] = value;else createNonEnumerableProperty$2(O, key, value); // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, 'toString', function toString() {
	  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
	});

	var global$6 = global$d;
	var path$1 = global$6;

	var path = path$1;
	var global$5 = global$d;

	var aFunction$3 = function (variable) {
	  return typeof variable == 'function' ? variable : undefined;
	};

	var getBuiltIn$3 = function (namespace, method) {
	  return arguments.length < 2 ? aFunction$3(path[namespace]) || aFunction$3(global$5[namespace]) : path[namespace] && path[namespace][method] || global$5[namespace] && global$5[namespace][method];
	};

	var objectGetOwnPropertyNames = {};

	var ceil = Math.ceil;
	var floor$1 = Math.floor; // `ToInteger` abstract operation
	// https://tc39.es/ecma262/#sec-tointeger

	var toInteger$4 = function (argument) {
	  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$1 : ceil)(argument);
	};

	var toInteger$3 = toInteger$4;
	var min$3 = Math.min; // `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength

	var toLength$7 = function (argument) {
	  return argument > 0 ? min$3(toInteger$3(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};

	var toInteger$2 = toInteger$4;
	var max$2 = Math.max;
	var min$2 = Math.min; // Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

	var toAbsoluteIndex$2 = function (index, length) {
	  var integer = toInteger$2(index);
	  return integer < 0 ? max$2(integer + length, 0) : min$2(integer, length);
	};

	var toIndexedObject$3 = toIndexedObject$5;
	var toLength$6 = toLength$7;
	var toAbsoluteIndex$1 = toAbsoluteIndex$2; // `Array.prototype.{ indexOf, includes }` methods implementation

	var createMethod$3 = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject$3($this);
	    var length = toLength$6(O.length);
	    var index = toAbsoluteIndex$1(fromIndex, length);
	    var value; // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check

	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

	      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
	    } else for (; length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    }
	    return !IS_INCLUDES && -1;
	  };
	};

	var arrayIncludes = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod$3(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod$3(false)
	};

	var has$3 = has$7;
	var toIndexedObject$2 = toIndexedObject$5;
	var indexOf = arrayIncludes.indexOf;
	var hiddenKeys$2 = hiddenKeys$4;

	var objectKeysInternal = function (object, names) {
	  var O = toIndexedObject$2(object);
	  var i = 0;
	  var result = [];
	  var key;

	  for (key in O) !has$3(hiddenKeys$2, key) && has$3(O, key) && result.push(key); // Don't enum bug & hidden keys


	  while (names.length > i) if (has$3(O, key = names[i++])) {
	    ~indexOf(result, key) || result.push(key);
	  }

	  return result;
	};

	var enumBugKeys$3 = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

	var internalObjectKeys$1 = objectKeysInternal;
	var enumBugKeys$2 = enumBugKeys$3;
	var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe

	objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys$1(O, hiddenKeys$1);
	};

	var objectGetOwnPropertySymbols = {};

	objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

	var getBuiltIn$2 = getBuiltIn$3;
	var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
	var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
	var anObject$8 = anObject$a; // all object keys, includes non-enumerable and symbols

	var ownKeys$2 = getBuiltIn$2('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject$8(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
	};

	var has$2 = has$7;
	var ownKeys$1 = ownKeys$2;
	var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
	var definePropertyModule$3 = objectDefineProperty;

	var copyConstructorProperties$1 = function (target, source) {
	  var keys = ownKeys$1(source);
	  var defineProperty = definePropertyModule$3.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;

	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!has$2(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	  }
	};

	var fails$8 = fails$c;
	var replacement = /#|\.prototype\./;

	var isForced$2 = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails$8(detection) : !!detection;
	};

	var normalize = isForced$2.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};

	var data = isForced$2.data = {};
	var NATIVE = isForced$2.NATIVE = 'N';
	var POLYFILL = isForced$2.POLYFILL = 'P';
	var isForced_1 = isForced$2;

	var global$4 = global$d;
	var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
	var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
	var redefine$3 = redefine$4.exports;
	var setGlobal = setGlobal$3;
	var copyConstructorProperties = copyConstructorProperties$1;
	var isForced$1 = isForced_1;
	/*
	  options.target      - name of the target object
	  options.global      - target is the global object
	  options.stat        - export as static methods of target
	  options.proto       - export as prototype methods of target
	  options.real        - real prototype method for the `pure` version
	  options.forced      - export even if the native feature is available
	  options.bind        - bind methods to the target, required for the `pure` version
	  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
	  options.sham        - add a flag to not completely full polyfills
	  options.enumerable  - export as enumerable property
	  options.noTargetGet - prevent calling a getter on target
	*/

	var _export = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;

	  if (GLOBAL) {
	    target = global$4;
	  } else if (STATIC) {
	    target = global$4[TARGET] || setGlobal(TARGET, {});
	  } else {
	    target = (global$4[TARGET] || {}).prototype;
	  }

	  if (target) for (key in source) {
	    sourceProperty = source[key];

	    if (options.noTargetGet) {
	      descriptor = getOwnPropertyDescriptor$1(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];

	    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty === typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    } // add a flag to not completely full polyfills


	    if (options.sham || targetProperty && targetProperty.sham) {
	      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
	    } // extend global


	    redefine$3(target, key, sourceProperty, options);
	  }
	};

	var getBuiltIn$1 = getBuiltIn$3;
	var engineUserAgent = getBuiltIn$1('navigator', 'userAgent') || '';

	var global$3 = global$d;
	var userAgent = engineUserAgent;
	var process = global$3.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8;
	var match, version;

	if (v8) {
	  match = v8.split('.');
	  version = match[0] < 4 ? 1 : match[0] + match[1];
	} else if (userAgent) {
	  match = userAgent.match(/Edge\/(\d+)/);

	  if (!match || match[1] >= 74) {
	    match = userAgent.match(/Chrome\/(\d+)/);
	    if (match) version = match[1];
	  }
	}

	var engineV8Version = version && +version;

	/* eslint-disable es/no-symbol -- required for testing */
	var V8_VERSION$2 = engineV8Version;
	var fails$7 = fails$c; // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing

	var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$7(function () {
	  return !String(Symbol()) || // Chrome 38 Symbol has incorrect toString conversion
	  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	  !Symbol.sham && V8_VERSION$2 && V8_VERSION$2 < 41;
	});

	/* eslint-disable es/no-symbol -- required for testing */
	var NATIVE_SYMBOL$1 = nativeSymbol;
	var useSymbolAsUid = NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == 'symbol';

	var global$2 = global$d;
	var shared$1 = shared$4.exports;
	var has$1 = has$7;
	var uid = uid$2;
	var NATIVE_SYMBOL = nativeSymbol;
	var USE_SYMBOL_AS_UID = useSymbolAsUid;
	var WellKnownSymbolsStore = shared$1('wks');
	var Symbol$1 = global$2.Symbol;
	var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

	var wellKnownSymbol$a = function (name) {
	  if (!has$1(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
	    if (NATIVE_SYMBOL && has$1(Symbol$1, name)) {
	      WellKnownSymbolsStore[name] = Symbol$1[name];
	    } else {
	      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
	    }
	  }

	  return WellKnownSymbolsStore[name];
	};

	var internalObjectKeys = objectKeysInternal;
	var enumBugKeys$1 = enumBugKeys$3; // `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe

	var objectKeys$1 = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys$1);
	};

	var DESCRIPTORS$1 = descriptors;
	var definePropertyModule$2 = objectDefineProperty;
	var anObject$7 = anObject$a;
	var objectKeys = objectKeys$1; // `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe

	var objectDefineProperties = DESCRIPTORS$1 ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject$7(O);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;

	  while (length > index) definePropertyModule$2.f(O, key = keys[index++], Properties[key]);

	  return O;
	};

	var getBuiltIn = getBuiltIn$3;
	var html$1 = getBuiltIn('document', 'documentElement');

	var anObject$6 = anObject$a;
	var defineProperties = objectDefineProperties;
	var enumBugKeys = enumBugKeys$3;
	var hiddenKeys = hiddenKeys$4;
	var html = html$1;
	var documentCreateElement = documentCreateElement$1;
	var sharedKey = sharedKey$2;
	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');

	var EmptyConstructor = function () {
	  /* empty */
	};

	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	}; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak

	  return temp;
	}; // Create object with fake `null` prototype: use iframe Object with cleared prototype


	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	}; // Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug


	var activeXDocument;

	var NullProtoObject = function () {
	  try {
	    /* global ActiveXObject -- old IE */
	    activeXDocument = document.domain && new ActiveXObject('htmlfile');
	  } catch (error) {
	    /* ignore */
	  }

	  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
	  var length = enumBugKeys.length;

	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];

	  return NullProtoObject();
	};

	hiddenKeys[IE_PROTO] = true; // `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create

	var objectCreate = Object.create || function create(O, Properties) {
	  var result;

	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject$6(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();

	  return Properties === undefined ? result : defineProperties(result, Properties);
	};

	var wellKnownSymbol$9 = wellKnownSymbol$a;
	var create$1 = objectCreate;
	var definePropertyModule$1 = objectDefineProperty;
	var UNSCOPABLES = wellKnownSymbol$9('unscopables');
	var ArrayPrototype = Array.prototype; // Array.prototype[@@unscopables]
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	if (ArrayPrototype[UNSCOPABLES] == undefined) {
	  definePropertyModule$1.f(ArrayPrototype, UNSCOPABLES, {
	    configurable: true,
	    value: create$1(null)
	  });
	} // add a key to Array.prototype[@@unscopables]


	var addToUnscopables$2 = function (key) {
	  ArrayPrototype[UNSCOPABLES][key] = true;
	};

	var $$8 = _export;
	var $includes = arrayIncludes.includes;
	var addToUnscopables$1 = addToUnscopables$2; // `Array.prototype.includes` method
	// https://tc39.es/ecma262/#sec-array.prototype.includes

	$$8({
	  target: 'Array',
	  proto: true
	}, {
	  includes: function includes(el
	  /* , fromIndex = 0 */
	  ) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	addToUnscopables$1('includes');

	var isObject$5 = isObject$a;

	var aPossiblePrototype$1 = function (it) {
	  if (!isObject$5(it) && it !== null) {
	    throw TypeError("Can't set " + String(it) + ' as a prototype');
	  }

	  return it;
	};

	/* eslint-disable no-proto -- safe */
	var anObject$5 = anObject$a;
	var aPossiblePrototype = aPossiblePrototype$1; // `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	// eslint-disable-next-line es/no-object-setprototypeof -- safe

	var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;

	  try {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
	    setter.call(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) {
	    /* empty */
	  }

	  return function setPrototypeOf(O, proto) {
	    anObject$5(O);
	    aPossiblePrototype(proto);
	    if (CORRECT_SETTER) setter.call(O, proto);else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);

	var isObject$4 = isObject$a;
	var setPrototypeOf = objectSetPrototypeOf; // makes subclassing work correct for wrapped built-ins

	var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
	  var NewTarget, NewTargetPrototype;
	  if ( // it can work only with native `setPrototypeOf`
	  setPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
	  typeof (NewTarget = dummy.constructor) == 'function' && NewTarget !== Wrapper && isObject$4(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
	  return $this;
	};

	var whitespaces$1 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' + '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

	var requireObjectCoercible$4 = requireObjectCoercible$7;
	var whitespaces = whitespaces$1;
	var whitespace = '[' + whitespaces + ']';
	var ltrim = RegExp('^' + whitespace + whitespace + '*');
	var rtrim = RegExp(whitespace + whitespace + '*$'); // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation

	var createMethod$2 = function (TYPE) {
	  return function ($this) {
	    var string = String(requireObjectCoercible$4($this));
	    if (TYPE & 1) string = string.replace(ltrim, '');
	    if (TYPE & 2) string = string.replace(rtrim, '');
	    return string;
	  };
	};

	var stringTrim = {
	  // `String.prototype.{ trimLeft, trimStart }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
	  start: createMethod$2(1),
	  // `String.prototype.{ trimRight, trimEnd }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimend
	  end: createMethod$2(2),
	  // `String.prototype.trim` method
	  // https://tc39.es/ecma262/#sec-string.prototype.trim
	  trim: createMethod$2(3)
	};

	var DESCRIPTORS = descriptors;
	var global$1 = global$d;
	var isForced = isForced_1;
	var redefine$2 = redefine$4.exports;
	var has = has$7;
	var classof$5 = classofRaw$1;
	var inheritIfRequired = inheritIfRequired$1;
	var toPrimitive$1 = toPrimitive$4;
	var fails$6 = fails$c;
	var create = objectCreate;
	var getOwnPropertyNames = objectGetOwnPropertyNames.f;
	var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
	var defineProperty = objectDefineProperty.f;
	var trim = stringTrim.trim;
	var NUMBER = 'Number';
	var NativeNumber = global$1[NUMBER];
	var NumberPrototype = NativeNumber.prototype; // Opera ~12 has broken Object#toString

	var BROKEN_CLASSOF = classof$5(create(NumberPrototype)) == NUMBER; // `ToNumber` abstract operation
	// https://tc39.es/ecma262/#sec-tonumber

	var toNumber = function (argument) {
	  var it = toPrimitive$1(argument, false);
	  var first, third, radix, maxCode, digits, length, index, code;

	  if (typeof it == 'string' && it.length > 2) {
	    it = trim(it);
	    first = it.charCodeAt(0);

	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66:
	        case 98:
	          radix = 2;
	          maxCode = 49;
	          break;
	        // fast equal of /^0b[01]+$/i

	        case 79:
	        case 111:
	          radix = 8;
	          maxCode = 55;
	          break;
	        // fast equal of /^0o[0-7]+$/i

	        default:
	          return +it;
	      }

	      digits = it.slice(2);
	      length = digits.length;

	      for (index = 0; index < length; index++) {
	        code = digits.charCodeAt(index); // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols

	        if (code < 48 || code > maxCode) return NaN;
	      }

	      return parseInt(digits, radix);
	    }
	  }

	  return +it;
	}; // `Number` constructor
	// https://tc39.es/ecma262/#sec-number-constructor


	if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
	  var NumberWrapper = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var dummy = this;
	    return dummy instanceof NumberWrapper // check on 1..constructor(foo) case
	    && (BROKEN_CLASSOF ? fails$6(function () {
	      NumberPrototype.valueOf.call(dummy);
	    }) : classof$5(dummy) != NUMBER) ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
	  };

	  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : ( // ES3:
	  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES2015 (in case, if modules with ES2015 Number statics required before):
	  'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' + // ESNext
	  'fromString,range').split(','), j = 0, key; keys.length > j; j++) {
	    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
	      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
	    }
	  }

	  NumberWrapper.prototype = NumberPrototype;
	  NumberPrototype.constructor = NumberWrapper;
	  redefine$2(global$1, NUMBER, NumberWrapper);
	}

	var aFunction$2 = function (it) {
	  if (typeof it != 'function') {
	    throw TypeError(String(it) + ' is not a function');
	  }

	  return it;
	};

	var aFunction$1 = aFunction$2; // optional / simple context binding

	var functionBindContext = function (fn, that, length) {
	  aFunction$1(fn);
	  if (that === undefined) return fn;

	  switch (length) {
	    case 0:
	      return function () {
	        return fn.call(that);
	      };

	    case 1:
	      return function (a) {
	        return fn.call(that, a);
	      };

	    case 2:
	      return function (a, b) {
	        return fn.call(that, a, b);
	      };

	    case 3:
	      return function (a, b, c) {
	        return fn.call(that, a, b, c);
	      };
	  }

	  return function ()
	  /* ...args */
	  {
	    return fn.apply(that, arguments);
	  };
	};

	var classof$4 = classofRaw$1; // `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe

	var isArray$3 = Array.isArray || function isArray(arg) {
	  return classof$4(arg) == 'Array';
	};

	var isObject$3 = isObject$a;
	var isArray$2 = isArray$3;
	var wellKnownSymbol$8 = wellKnownSymbol$a;
	var SPECIES$4 = wellKnownSymbol$8('species'); // `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate

	var arraySpeciesCreate$2 = function (originalArray, length) {
	  var C;

	  if (isArray$2(originalArray)) {
	    C = originalArray.constructor; // cross-realm fallback

	    if (typeof C == 'function' && (C === Array || isArray$2(C.prototype))) C = undefined;else if (isObject$3(C)) {
	      C = C[SPECIES$4];
	      if (C === null) C = undefined;
	    }
	  }

	  return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
	};

	var bind = functionBindContext;
	var IndexedObject$1 = indexedObject;
	var toObject$3 = toObject$5;
	var toLength$5 = toLength$7;
	var arraySpeciesCreate$1 = arraySpeciesCreate$2;
	var push = [].push; // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation

	var createMethod$1 = function (TYPE) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var IS_FILTER_OUT = TYPE == 7;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject$3($this);
	    var self = IndexedObject$1(O);
	    var boundFunction = bind(callbackfn, that, 3);
	    var length = toLength$5(self.length);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate$1;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
	    var value, result;

	    for (; length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);

	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	            case 3:
	              return true;
	            // some

	            case 5:
	              return value;
	            // find

	            case 6:
	              return index;
	            // findIndex

	            case 2:
	              push.call(target, value);
	            // filter
	          } else switch (TYPE) {
	            case 4:
	              return false;
	            // every

	            case 7:
	              push.call(target, value);
	            // filterOut
	          }
	      }
	    }

	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};

	var arrayIteration = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod$1(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod$1(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod$1(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod$1(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod$1(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod$1(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod$1(6),
	  // `Array.prototype.filterOut` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterOut: createMethod$1(7)
	};

	var fails$5 = fails$c;
	var wellKnownSymbol$7 = wellKnownSymbol$a;
	var V8_VERSION$1 = engineV8Version;
	var SPECIES$3 = wellKnownSymbol$7('species');

	var arrayMethodHasSpeciesSupport$3 = function (METHOD_NAME) {
	  // We can't use this feature detection in V8 since it causes
	  // deoptimization and serious performance degradation
	  // https://github.com/zloirock/core-js/issues/677
	  return V8_VERSION$1 >= 51 || !fails$5(function () {
	    var array = [];
	    var constructor = array.constructor = {};

	    constructor[SPECIES$3] = function () {
	      return {
	        foo: 1
	      };
	    };

	    return array[METHOD_NAME](Boolean).foo !== 1;
	  });
	};

	var $$7 = _export;
	var $filter = arrayIteration.filter;
	var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$3;
	var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$2('filter'); // `Array.prototype.filter` method
	// https://tc39.es/ecma262/#sec-array.prototype.filter
	// with adding support of @@species

	$$7({
	  target: 'Array',
	  proto: true,
	  forced: !HAS_SPECIES_SUPPORT$1
	}, {
	  filter: function filter(callbackfn
	  /* , thisArg */
	  ) {
	    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var $$6 = _export;
	var $findIndex = arrayIteration.findIndex;
	var addToUnscopables = addToUnscopables$2;
	var FIND_INDEX = 'findIndex';
	var SKIPS_HOLES = true; // Shouldn't skip holes

	if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () {
	  SKIPS_HOLES = false;
	}); // `Array.prototype.findIndex` method
	// https://tc39.es/ecma262/#sec-array.prototype.findindex

	$$6({
	  target: 'Array',
	  proto: true,
	  forced: SKIPS_HOLES
	}, {
	  findIndex: function findIndex(callbackfn
	  /* , that = undefined */
	  ) {
	    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	addToUnscopables(FIND_INDEX);

	var $$5 = _export; // `Number.isNaN` method
	// https://tc39.es/ecma262/#sec-number.isnan

	$$5({
	  target: 'Number',
	  stat: true
	}, {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare -- NaN check
	    return number != number;
	  }
	});

	var toPrimitive = toPrimitive$4;
	var definePropertyModule = objectDefineProperty;
	var createPropertyDescriptor = createPropertyDescriptor$3;

	var createProperty$2 = function (object, key, value) {
	  var propertyKey = toPrimitive(key);
	  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
	};

	var $$4 = _export;
	var fails$4 = fails$c;
	var isArray$1 = isArray$3;
	var isObject$2 = isObject$a;
	var toObject$2 = toObject$5;
	var toLength$4 = toLength$7;
	var createProperty$1 = createProperty$2;
	var arraySpeciesCreate = arraySpeciesCreate$2;
	var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$3;
	var wellKnownSymbol$6 = wellKnownSymbol$a;
	var V8_VERSION = engineV8Version;
	var IS_CONCAT_SPREADABLE = wellKnownSymbol$6('isConcatSpreadable');
	var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
	var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded'; // We can't use this feature detection in V8 since it causes
	// deoptimization and serious performance degradation
	// https://github.com/zloirock/core-js/issues/679

	var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails$4(function () {
	  var array = [];
	  array[IS_CONCAT_SPREADABLE] = false;
	  return array.concat()[0] !== array;
	});
	var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport$1('concat');

	var isConcatSpreadable = function (O) {
	  if (!isObject$2(O)) return false;
	  var spreadable = O[IS_CONCAT_SPREADABLE];
	  return spreadable !== undefined ? !!spreadable : isArray$1(O);
	};

	var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
	// https://tc39.es/ecma262/#sec-array.prototype.concat
	// with adding support of @@isConcatSpreadable and @@species

	$$4({
	  target: 'Array',
	  proto: true,
	  forced: FORCED
	}, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  concat: function concat(arg) {
	    var O = toObject$2(this);
	    var A = arraySpeciesCreate(O, 0);
	    var n = 0;
	    var i, k, length, len, E;

	    for (i = -1, length = arguments.length; i < length; i++) {
	      E = i === -1 ? O : arguments[i];

	      if (isConcatSpreadable(E)) {
	        len = toLength$4(E.length);
	        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);

	        for (k = 0; k < len; k++, n++) if (k in E) createProperty$1(A, n, E[k]);
	      } else {
	        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
	        createProperty$1(A, n++, E);
	      }
	    }

	    A.length = n;
	    return A;
	  }
	});

	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);

	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }

	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof(obj);
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	var $$3 = _export;
	var isObject$1 = isObject$a;
	var isArray = isArray$3;
	var toAbsoluteIndex = toAbsoluteIndex$2;
	var toLength$3 = toLength$7;
	var toIndexedObject$1 = toIndexedObject$5;
	var createProperty = createProperty$2;
	var wellKnownSymbol$5 = wellKnownSymbol$a;
	var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$3;
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
	var SPECIES$2 = wellKnownSymbol$5('species');
	var nativeSlice = [].slice;
	var max$1 = Math.max; // `Array.prototype.slice` method
	// https://tc39.es/ecma262/#sec-array.prototype.slice
	// fallback for not array-like ES3 strings and DOM objects

	$$3({
	  target: 'Array',
	  proto: true,
	  forced: !HAS_SPECIES_SUPPORT
	}, {
	  slice: function slice(start, end) {
	    var O = toIndexedObject$1(this);
	    var length = toLength$3(O.length);
	    var k = toAbsoluteIndex(start, length);
	    var fin = toAbsoluteIndex(end === undefined ? length : end, length); // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible

	    var Constructor, result, n;

	    if (isArray(O)) {
	      Constructor = O.constructor; // cross-realm fallback

	      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
	        Constructor = undefined;
	      } else if (isObject$1(Constructor)) {
	        Constructor = Constructor[SPECIES$2];
	        if (Constructor === null) Constructor = undefined;
	      }

	      if (Constructor === Array || Constructor === undefined) {
	        return nativeSlice.call(O, k, fin);
	      }
	    }

	    result = new (Constructor === undefined ? Array : Constructor)(max$1(fin - k, 0));

	    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);

	    result.length = n;
	    return result;
	  }
	});

	var Language = /*#__PURE__*/function () {
	  // eslint-disable-next-line max-params
	  function Language(language, months, monthsAbbr, days) {
	    var rtl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	    var ymd = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	    var yearSuffix = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';

	    _classCallCheck(this, Language);

	    this.language = language;
	    this.months = months;
	    this.monthsAbbr = monthsAbbr;
	    this.days = days;
	    this.rtl = rtl;
	    this.ymd = ymd;
	    this.yearSuffix = yearSuffix;
	  }
	  /* eslint-disable no-underscore-dangle */


	  _createClass(Language, [{
	    key: "language",
	    get: function get() {
	      return this._language;
	    },
	    set: function set(language) {
	      if (typeof language !== 'string') {
	        throw new TypeError('Language must be a string');
	      }

	      this._language = language;
	    }
	  }, {
	    key: "months",
	    get: function get() {
	      return this._months;
	    },
	    set: function set(months) {
	      if (months.length !== 12) {
	        throw new RangeError("There must be 12 months for ".concat(this.language, " language"));
	      }

	      this._months = months;
	    }
	  }, {
	    key: "monthsAbbr",
	    get: function get() {
	      return this._monthsAbbr;
	    },
	    set: function set(monthsAbbr) {
	      if (monthsAbbr.length !== 12) {
	        throw new RangeError("There must be 12 abbreviated months for ".concat(this.language, " language"));
	      }

	      this._monthsAbbr = monthsAbbr;
	    }
	  }, {
	    key: "days",
	    get: function get() {
	      return this._days;
	    },
	    set: function set(days) {
	      if (days.length !== 7) {
	        throw new RangeError("There must be 7 days for ".concat(this.language, " language"));
	      }

	      this._days = days;
	    }
	  }, {
	    key: "getDaysStartingOn",
	    value: function getDaysStartingOn(firstDayOfWeek) {
	      var firstDays = this._days.slice(firstDayOfWeek);

	      var lastDays = this._days.slice(0, firstDayOfWeek);

	      return firstDays.concat(lastDays);
	    }
	  }, {
	    key: "getMonthByAbbrName",
	    value: function getMonthByAbbrName(name) {
	      var monthValue = this._monthsAbbr.findIndex(function (month) {
	        return month === name;
	      }) + 1;
	      return monthValue < 10 ? "0".concat(monthValue) : "".concat(monthValue);
	    }
	  }, {
	    key: "getMonthByName",
	    value: function getMonthByName(name) {
	      var monthValue = this._months.findIndex(function (month) {
	        return month === name;
	      }) + 1;
	      return monthValue < 10 ? "0".concat(monthValue) : "".concat(monthValue);
	    }
	  }]);

	  return Language;
	}();

	var en = new Language('English', ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']);

	var calendarSlots = ['beforeCalendarHeaderDay', 'calendarFooterDay', 'beforeCalendarHeaderMonth', 'calendarFooterMonth', 'beforeCalendarHeaderYear', 'calendarFooterYear', 'nextIntervalBtn', 'prevIntervalBtn'];

	var fails$3 = fails$c;

	var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
	  var method = [][METHOD_NAME];
	  return !!method && fails$3(function () {
	    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
	    method.call(null, argument || function () {
	      throw 1;
	    }, 1);
	  });
	};

	var $$2 = _export;
	var IndexedObject = indexedObject;
	var toIndexedObject = toIndexedObject$5;
	var arrayMethodIsStrict = arrayMethodIsStrict$1;
	var nativeJoin = [].join;
	var ES3_STRINGS = IndexedObject != Object;
	var STRICT_METHOD = arrayMethodIsStrict('join', ','); // `Array.prototype.join` method
	// https://tc39.es/ecma262/#sec-array.prototype.join

	$$2({
	  target: 'Array',
	  proto: true,
	  forced: ES3_STRINGS || !STRICT_METHOD
	}, {
	  join: function join(separator) {
	    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
	  }
	});

	var anObject$4 = anObject$a; // `RegExp.prototype.flags` getter implementation
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags

	var regexpFlags$1 = function () {
	  var that = anObject$4(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.dotAll) result += 's';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};

	var regexpStickyHelpers = {};

	var fails$2 = fails$c; // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
	// so we use an intermediate function.

	function RE(s, f) {
	  return RegExp(s, f);
	}

	regexpStickyHelpers.UNSUPPORTED_Y = fails$2(function () {
	  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
	  var re = RE('a', 'y');
	  re.lastIndex = 2;
	  return re.exec('abcd') != null;
	});
	regexpStickyHelpers.BROKEN_CARET = fails$2(function () {
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
	  var re = RE('^r', 'gy');
	  re.lastIndex = 2;
	  return re.exec('str') != null;
	});

	/* eslint-disable regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */

	/* eslint-disable regexp/no-useless-quantifier -- testing */


	var regexpFlags = regexpFlags$1;
	var stickyHelpers$1 = regexpStickyHelpers;
	var shared = shared$4.exports;
	var nativeExec = RegExp.prototype.exec;
	var nativeReplace = shared('native-string-replace', String.prototype.replace);
	var patchedExec = nativeExec;

	var UPDATES_LAST_INDEX_WRONG = function () {
	  var re1 = /a/;
	  var re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
	}();

	var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y || stickyHelpers$1.BROKEN_CARET; // nonparticipating capturing group, copied from es5-shim's String#split patch.

	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1;

	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	    var sticky = UNSUPPORTED_Y$1 && re.sticky;
	    var flags = regexpFlags.call(re);
	    var source = re.source;
	    var charsAdded = 0;
	    var strCopy = str;

	    if (sticky) {
	      flags = flags.replace('y', '');

	      if (flags.indexOf('g') === -1) {
	        flags += 'g';
	      }

	      strCopy = String(str).slice(re.lastIndex); // Support anchored sticky behavior.

	      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
	        source = '(?: ' + source + ')';
	        strCopy = ' ' + strCopy;
	        charsAdded++;
	      } // ^(? + rx + ) is needed, in combination with some str slicing, to
	      // simulate the 'y' flag.


	      reCopy = new RegExp('^(?:' + source + ')', flags);
	    }

	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
	    }

	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
	    match = nativeExec.call(sticky ? reCopy : re, strCopy);

	    if (sticky) {
	      if (match) {
	        match.input = match.input.slice(charsAdded);
	        match[0] = match[0].slice(charsAdded);
	        match.index = re.lastIndex;
	        re.lastIndex += match[0].length;
	      } else re.lastIndex = 0;
	    } else if (UPDATES_LAST_INDEX_WRONG && match) {
	      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
	    }

	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }

	    return match;
	  };
	}

	var regexpExec$3 = patchedExec;

	var $$1 = _export;
	var exec = regexpExec$3; // `RegExp.prototype.exec` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.exec

	$$1({
	  target: 'RegExp',
	  proto: true,
	  forced: /./.exec !== exec
	}, {
	  exec: exec
	});

	var redefine$1 = redefine$4.exports;
	var regexpExec$2 = regexpExec$3;
	var fails$1 = fails$c;
	var wellKnownSymbol$4 = wellKnownSymbol$a;
	var createNonEnumerableProperty = createNonEnumerableProperty$5;
	var SPECIES$1 = wellKnownSymbol$4('species');
	var RegExpPrototype = RegExp.prototype;
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$1(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;

	  re.exec = function () {
	    var result = [];
	    result.groups = {
	      a: '7'
	    };
	    return result;
	  };

	  return ''.replace(re, '$<a>') !== '7';
	}); // IE <= 11 replaces $0 with the whole match, as if it was $&
	// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0

	var REPLACE_KEEPS_$0 = function () {
	  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
	  return 'a'.replace(/./, '$0') === '$0';
	}();

	var REPLACE = wellKnownSymbol$4('replace'); // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string

	var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function () {
	  if (/./[REPLACE]) {
	    return /./[REPLACE]('a', '$0') === '';
	  }

	  return false;
	}(); // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	// Weex JS has frozen built-in prototypes, so use try / catch wrapper


	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$1(function () {
	  // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  var re = /(?:)/;
	  var originalExec = re.exec;

	  re.exec = function () {
	    return originalExec.apply(this, arguments);
	  };

	  var result = 'ab'.split(re);
	  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
	});

	var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
	  var SYMBOL = wellKnownSymbol$4(KEY);
	  var DELEGATES_TO_SYMBOL = !fails$1(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};

	    O[SYMBOL] = function () {
	      return 7;
	    };

	    return ''[KEY](O) != 7;
	  });
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$1(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;

	    if (KEY === 'split') {
	      // We can't use real regex here since it causes deoptimization
	      // and serious performance degradation in V8
	      // https://github.com/zloirock/core-js/issues/306
	      re = {}; // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.

	      re.constructor = {};

	      re.constructor[SPECIES$1] = function () {
	        return re;
	      };

	      re.flags = '';
	      re[SYMBOL] = /./[SYMBOL];
	    }

	    re.exec = function () {
	      execCalled = true;
	      return null;
	    };

	    re[SYMBOL]('');
	    return !execCalled;
	  });

	  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !(REPLACE_SUPPORTS_NAMED_GROUPS && REPLACE_KEEPS_$0 && !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE) || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
	      var $exec = regexp.exec;

	      if ($exec === regexpExec$2 || $exec === RegExpPrototype.exec) {
	        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	          // The native String method already delegates to @@method (this
	          // polyfilled function), leasing to infinite recursion.
	          // We avoid it by directly calling the native @@method method.
	          return {
	            done: true,
	            value: nativeRegExpMethod.call(regexp, str, arg2)
	          };
	        }

	        return {
	          done: true,
	          value: nativeMethod.call(str, regexp, arg2)
	        };
	      }

	      return {
	        done: false
	      };
	    }, {
	      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
	      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
	    });
	    var stringMethod = methods[0];
	    var regexMethod = methods[1];
	    redefine$1(String.prototype, KEY, stringMethod);
	    redefine$1(RegExpPrototype, SYMBOL, length == 2 // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	    // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	    ? function (string, arg) {
	      return regexMethod.call(string, this, arg);
	    } // 21.2.5.6 RegExp.prototype[@@match](string)
	    // 21.2.5.9 RegExp.prototype[@@search](string)
	    : function (string) {
	      return regexMethod.call(string, this);
	    });
	  }

	  if (sham) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
	};

	var toInteger$1 = toInteger$4;
	var requireObjectCoercible$3 = requireObjectCoercible$7; // `String.prototype.{ codePointAt, at }` methods implementation

	var createMethod = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = String(requireObjectCoercible$3($this));
	    var position = toInteger$1(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = S.charCodeAt(position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};

	var stringMultibyte = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod(true)
	};

	var charAt = stringMultibyte.charAt; // `AdvanceStringIndex` abstract operation
	// https://tc39.es/ecma262/#sec-advancestringindex

	var advanceStringIndex$3 = function (S, index, unicode) {
	  return index + (unicode ? charAt(S, index).length : 1);
	};

	var classof$3 = classofRaw$1;
	var regexpExec$1 = regexpExec$3; // `RegExpExec` abstract operation
	// https://tc39.es/ecma262/#sec-regexpexec

	var regexpExecAbstract = function (R, S) {
	  var exec = R.exec;

	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);

	    if (typeof result !== 'object') {
	      throw TypeError('RegExp exec method returned something other than an Object or null');
	    }

	    return result;
	  }

	  if (classof$3(R) !== 'RegExp') {
	    throw TypeError('RegExp#exec called on incompatible receiver');
	  }

	  return regexpExec$1.call(R, S);
	};

	var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
	var anObject$3 = anObject$a;
	var toLength$2 = toLength$7;
	var requireObjectCoercible$2 = requireObjectCoercible$7;
	var advanceStringIndex$2 = advanceStringIndex$3;
	var regExpExec$1 = regexpExecAbstract; // @@match logic

	fixRegExpWellKnownSymbolLogic$2('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
	  return [// `String.prototype.match` method
	  // https://tc39.es/ecma262/#sec-string.prototype.match
	  function match(regexp) {
	    var O = requireObjectCoercible$2(this);
	    var matcher = regexp == undefined ? undefined : regexp[MATCH];
	    return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, // `RegExp.prototype[@@match]` method
	  // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
	  function (regexp) {
	    var res = maybeCallNative(nativeMatch, regexp, this);
	    if (res.done) return res.value;
	    var rx = anObject$3(regexp);
	    var S = String(this);
	    if (!rx.global) return regExpExec$1(rx, S);
	    var fullUnicode = rx.unicode;
	    rx.lastIndex = 0;
	    var A = [];
	    var n = 0;
	    var result;

	    while ((result = regExpExec$1(rx, S)) !== null) {
	      var matchStr = String(result[0]);
	      A[n] = matchStr;
	      if (matchStr === '') rx.lastIndex = advanceStringIndex$2(S, toLength$2(rx.lastIndex), fullUnicode);
	      n++;
	    }

	    return n === 0 ? null : A;
	  }];
	});

	var isObject = isObject$a;
	var classof$2 = classofRaw$1;
	var wellKnownSymbol$3 = wellKnownSymbol$a;
	var MATCH = wellKnownSymbol$3('match'); // `IsRegExp` abstract operation
	// https://tc39.es/ecma262/#sec-isregexp

	var isRegexp = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof$2(it) == 'RegExp');
	};

	var anObject$2 = anObject$a;
	var aFunction = aFunction$2;
	var wellKnownSymbol$2 = wellKnownSymbol$a;
	var SPECIES = wellKnownSymbol$2('species'); // `SpeciesConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-speciesconstructor

	var speciesConstructor$1 = function (O, defaultConstructor) {
	  var C = anObject$2(O).constructor;
	  var S;
	  return C === undefined || (S = anObject$2(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
	};

	var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
	var isRegExp = isRegexp;
	var anObject$1 = anObject$a;
	var requireObjectCoercible$1 = requireObjectCoercible$7;
	var speciesConstructor = speciesConstructor$1;
	var advanceStringIndex$1 = advanceStringIndex$3;
	var toLength$1 = toLength$7;
	var callRegExpExec = regexpExecAbstract;
	var regexpExec = regexpExec$3;
	var stickyHelpers = regexpStickyHelpers;
	var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
	var arrayPush = [].push;
	var min$1 = Math.min;
	var MAX_UINT32 = 0xFFFFFFFF; // @@split logic

	fixRegExpWellKnownSymbolLogic$1('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
	  var internalSplit;

	  if ('abbc'.split(/(b)*/)[1] == 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  'test'.split(/(?:)/, -1).length != 4 || 'ab'.split(/(?:ab)*/).length != 2 || '.'.split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
	  '.'.split(/()()/).length > 1 || ''.split(/.?/).length) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(requireObjectCoercible$1(this));
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (separator === undefined) return [string]; // If `separator` is not a regex, use native split

	      if (!isRegExp(separator)) {
	        return nativeSplit.call(string, separator, lim);
	      }

	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0; // Make `global` and avoid `lastIndex` issues by working with a copy

	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;

	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy.lastIndex;

	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
	          lastLength = match[0].length;
	          lastLastIndex = lastIndex;
	          if (output.length >= lim) break;
	        }

	        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
	      }

	      if (lastLastIndex === string.length) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));

	      return output.length > lim ? output.slice(0, lim) : output;
	    }; // Chakra, V8

	  } else if ('0'.split(undefined, 0).length) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
	    };
	  } else internalSplit = nativeSplit;

	  return [// `String.prototype.split` method
	  // https://tc39.es/ecma262/#sec-string.prototype.split
	  function split(separator, limit) {
	    var O = requireObjectCoercible$1(this);
	    var splitter = separator == undefined ? undefined : separator[SPLIT];
	    return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
	  }, // `RegExp.prototype[@@split]` method
	  // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
	  //
	  // NOTE: This cannot be properly polyfilled in engines that don't support
	  // the 'y' flag.
	  function (regexp, limit) {
	    var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
	    if (res.done) return res.value;
	    var rx = anObject$1(regexp);
	    var S = String(this);
	    var C = speciesConstructor(rx, RegExp);
	    var unicodeMatching = rx.unicode;
	    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (UNSUPPORTED_Y ? 'g' : 'y'); // ^(? + rx + ) is needed, in combination with some S slicing, to
	    // simulate the 'y' flag.

	    var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
	    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	    if (lim === 0) return [];
	    if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	    var p = 0;
	    var q = 0;
	    var A = [];

	    while (q < S.length) {
	      splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
	      var z = callRegExpExec(splitter, UNSUPPORTED_Y ? S.slice(q) : S);
	      var e;

	      if (z === null || (e = min$1(toLength$1(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) {
	        q = advanceStringIndex$1(S, q, unicodeMatching);
	      } else {
	        A.push(S.slice(p, q));
	        if (A.length === lim) return A;

	        for (var i = 1; i <= z.length - 1; i++) {
	          A.push(z[i]);
	          if (A.length === lim) return A;
	        }

	        q = p = e;
	      }
	    }

	    A.push(S.slice(p));
	    return A;
	  }];
	}, UNSUPPORTED_Y);

	var toObject$1 = toObject$5;
	var floor = Math.floor;
	var replace = ''.replace;
	var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g; // https://tc39.es/ecma262/#sec-getsubstitution

	var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
	  var tailPos = position + matched.length;
	  var m = captures.length;
	  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;

	  if (namedCaptures !== undefined) {
	    namedCaptures = toObject$1(namedCaptures);
	    symbols = SUBSTITUTION_SYMBOLS;
	  }

	  return replace.call(replacement, symbols, function (match, ch) {
	    var capture;

	    switch (ch.charAt(0)) {
	      case '$':
	        return '$';

	      case '&':
	        return matched;

	      case '`':
	        return str.slice(0, position);

	      case "'":
	        return str.slice(tailPos);

	      case '<':
	        capture = namedCaptures[ch.slice(1, -1)];
	        break;

	      default:
	        // \d\d?
	        var n = +ch;
	        if (n === 0) return match;

	        if (n > m) {
	          var f = floor(n / 10);
	          if (f === 0) return match;
	          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	          return match;
	        }

	        capture = captures[n - 1];
	    }

	    return capture === undefined ? '' : capture;
	  });
	};

	var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
	var anObject = anObject$a;
	var toLength = toLength$7;
	var toInteger = toInteger$4;
	var requireObjectCoercible = requireObjectCoercible$7;
	var advanceStringIndex = advanceStringIndex$3;
	var getSubstitution = getSubstitution$1;
	var regExpExec = regexpExecAbstract;
	var max = Math.max;
	var min = Math.min;

	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	}; // @@replace logic


	fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
	  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
	  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
	  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
	  return [// `String.prototype.replace` method
	  // https://tc39.es/ecma262/#sec-string.prototype.replace
	  function replace(searchValue, replaceValue) {
	    var O = requireObjectCoercible(this);
	    var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return replacer !== undefined ? replacer.call(searchValue, O, replaceValue) : nativeReplace.call(String(O), searchValue, replaceValue);
	  }, // `RegExp.prototype[@@replace]` method
	  // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
	  function (regexp, replaceValue) {
	    if (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0 || typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1) {
	      var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	    }

	    var rx = anObject(regexp);
	    var S = String(this);
	    var functionalReplace = typeof replaceValue === 'function';
	    if (!functionalReplace) replaceValue = String(replaceValue);
	    var global = rx.global;

	    if (global) {
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	    }

	    var results = [];

	    while (true) {
	      var result = regExpExec(rx, S);
	      if (result === null) break;
	      results.push(result);
	      if (!global) break;
	      var matchStr = String(result[0]);
	      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	    }

	    var accumulatedResult = '';
	    var nextSourcePosition = 0;

	    for (var i = 0; i < results.length; i++) {
	      result = results[i];
	      var matched = String(result[0]);
	      var position = max(min(toInteger(result.index), S.length), 0);
	      var captures = []; // NOTE: This is equivalent to
	      //   captures = result.slice(1).map(maybeToString)
	      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.

	      for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));

	      var namedCaptures = result.groups;

	      if (functionalReplace) {
	        var replacerArgs = [matched].concat(captures, position, S);
	        if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	        var replacement = String(replaceValue.apply(undefined, replacerArgs));
	      } else {
	        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	      }

	      if (position >= nextSourcePosition) {
	        accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	        nextSourcePosition = position + matched.length;
	      }
	    }

	    return accumulatedResult + S.slice(nextSourcePosition);
	  }];
	});

	var wellKnownSymbol$1 = wellKnownSymbol$a;
	var TO_STRING_TAG$1 = wellKnownSymbol$1('toStringTag');
	var test = {};
	test[TO_STRING_TAG$1] = 'z';
	var toStringTagSupport = String(test) === '[object z]';

	var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
	var classofRaw = classofRaw$1;
	var wellKnownSymbol = wellKnownSymbol$a;
	var TO_STRING_TAG = wellKnownSymbol('toStringTag'); // ES3 wrong here

	var CORRECT_ARGUMENTS = classofRaw(function () {
	  return arguments;
	}()) == 'Arguments'; // fallback for IE11 Script Access Denied error

	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) {
	    /* empty */
	  }
	}; // getting tag from ES6+ `Object.prototype.toString`


	var classof$1 = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
	  : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag // builtinTag case
	  : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
	  : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
	};

	var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
	var classof = classof$1; // `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring

	var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
	  return '[object ' + classof(this) + ']';
	};

	var TO_STRING_TAG_SUPPORT = toStringTagSupport;
	var redefine = redefine$4.exports;
	var toString = objectToString; // `Object.prototype.toString` method
	// https://tc39.es/ecma262/#sec-object.prototype.tostring

	if (!TO_STRING_TAG_SUPPORT) {
	  redefine(Object.prototype, 'toString', toString, {
	    unsafe: true
	  });
	}

	var getParsedDate = function getParsedDate(_ref) {
	  var formatStr = _ref.formatStr,
	      dateStr = _ref.dateStr,
	      translation = _ref.translation;
	  var splitter = formatStr.match(/-|\/|\s|\./) || ['-'];
	  var df = formatStr.split(splitter[0]);
	  var ds = dateStr.split(splitter[0]);
	  var ymd = [new Date().getFullYear(), '01', '01'];

	  for (var i = 0; i < df.length; i += 1) {
	    if (/yyyy/i.test(df[i])) {
	      ymd[0] = ds[i];
	    } else if (/mmmm/i.test(df[i])) {
	      ymd[1] = translation.getMonthByName(ds[i]);
	    } else if (/mmm/i.test(df[i])) {
	      ymd[1] = translation.getMonthByAbbrName(ds[i]);
	    } else if (/mm/i.test(df[i])) {
	      ymd[1] = ds[i];
	    } else if (/m/i.test(df[i])) {
	      ymd[1] = ds[i];
	    } else if (/dd/i.test(df[i])) {
	      ymd[2] = ds[i];
	    } else if (/d/i.test(df[i])) {
	      var tmp = ds[i].replace(/st|rd|nd|th/g, '');
	      ymd[2] = tmp < 10 ? "0".concat(tmp) : "".concat(tmp);
	    }
	  }

	  return ymd;
	};

	var utils = {
	  /**
	   * @type {Boolean}
	   */
	  useUtc: false,

	  /**
	   * Returns the full year, using UTC or not
	   * @param {Date} date
	   */
	  getFullYear: function getFullYear(date) {
	    return this.useUtc ? date.getUTCFullYear() : date.getFullYear();
	  },

	  /**
	   * Returns the month, using UTC or not
	   * @param {Date} date
	   */
	  getMonth: function getMonth(date) {
	    return this.useUtc ? date.getUTCMonth() : date.getMonth();
	  },

	  /**
	   * Returns the number of days in the month, using UTC or not
	   * @param {Date} date
	   */
	  getDaysInMonth: function getDaysInMonth(date) {
	    return this.daysInMonth(this.getFullYear(date), this.getMonth(date));
	  },

	  /**
	   * Returns the date, using UTC or not
	   * @param {Date} date
	   */
	  getDate: function getDate(date) {
	    return this.useUtc ? date.getUTCDate() : date.getDate();
	  },

	  /**
	   * Returns the day, using UTC or not
	   * @param {Date} date
	   */
	  getDay: function getDay(date) {
	    return this.useUtc ? date.getUTCDay() : date.getDay();
	  },

	  /**
	   * Returns the hours, using UTC or not
	   * @param {Date} date
	   */
	  getHours: function getHours(date) {
	    return this.useUtc ? date.getUTCHours() : date.getHours();
	  },

	  /**
	   * Returns the minutes, using UTC or not
	   * @param {Date} date
	   */
	  getMinutes: function getMinutes(date) {
	    return this.useUtc ? date.getUTCMinutes() : date.getMinutes();
	  },

	  /**
	   * Sets the full year, using UTC or not
	   * @param {Date} date
	   * @param {String, Number} value
	   */
	  setFullYear: function setFullYear(date, value) {
	    return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value);
	  },

	  /**
	   * Sets the month, using UTC or not
	   * @param {Date} date
	   * @param {String, Number} value
	   */
	  setMonth: function setMonth(date, value) {
	    return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value);
	  },

	  /**
	   * Sets the date, using UTC or not
	   * @param {Date} date
	   * @param {String, Number} value
	   */
	  setDate: function setDate(date, value) {
	    return this.useUtc ? date.setUTCDate(value) : date.setDate(value);
	  },

	  /**
	   * Check if date1 is equivalent to date2, without comparing the time
	   * @see https://stackoverflow.com/a/6202196/4455925
	   * @param {Date} date1
	   * @param {Date} date2
	   */
	  compareDates: function compareDates(date1, date2) {
	    var d1 = new Date(date1.valueOf());
	    var d2 = new Date(date2.valueOf());
	    this.resetDateTime(d1);
	    this.resetDateTime(d2);
	    return d1.valueOf() === d2.valueOf();
	  },

	  /**
	   * Validates a date object
	   * @param {Date} date - an object instantiated with the new Date constructor
	   * @return {Boolean}
	   */
	  isValidDate: function isValidDate(date) {
	    if (Object.prototype.toString.call(date) !== '[object Date]') {
	      return false;
	    }

	    return !Number.isNaN(date.valueOf());
	  },

	  /**
	   * Return abbreviated week day name
	   * @param {Date} date
	   * @param {Array} days
	   * @return {String}
	   */
	  getDayNameAbbr: function getDayNameAbbr(date, days) {
	    if (_typeof(date) !== 'object') {
	      throw TypeError('Invalid Type');
	    }

	    return days[this.getDay(date)];
	  },

	  /**
	   * Return day number from abbreviated week day name
	   * @param {String} abbr
	   * @return {Number}
	   */
	  getDayFromAbbr: function getDayFromAbbr(abbr) {
	    for (var i = 0; i < en.days.length; i += 1) {
	      if (abbr.toLowerCase() === en.days[i].toLowerCase()) {
	        return i;
	      }
	    }

	    throw TypeError('Invalid week day');
	  },

	  /**
	   * Return name of the month
	   * @param {Number|Date} month
	   * @param {Array} months
	   * @return {String}
	   */
	  getMonthName: function getMonthName(month, months) {
	    if (!months) {
	      throw Error('missing 2nd parameter Months array');
	    }

	    if (_typeof(month) === 'object') {
	      return months[this.getMonth(month)];
	    }

	    if (typeof month === 'number') {
	      return months[month];
	    }

	    throw TypeError('Invalid type');
	  },

	  /**
	   * Return an abbreviated version of the month
	   * @param {Number|Date} month
	   * @param {Array} monthsAbbr
	   * @return {String}
	   */
	  getMonthNameAbbr: function getMonthNameAbbr(month, monthsAbbr) {
	    if (!monthsAbbr) {
	      throw Error('missing 2nd paramter Months array');
	    }

	    if (_typeof(month) === 'object') {
	      return monthsAbbr[this.getMonth(month)];
	    }

	    if (typeof month === 'number') {
	      return monthsAbbr[month];
	    }

	    throw TypeError('Invalid type');
	  },

	  /**
	   * Alternative get total number of days in month
	   * @param {Number} year
	   * @param {Number} month
	   * @return {Number}
	   */
	  // eslint-disable-next-line complexity
	  daysInMonth: function daysInMonth(year, month) {
	    if (/8|3|5|10/.test(month)) {
	      return 30;
	    }

	    if (month === 1) {
	      return !(year % 4) && year % 100 || !(year % 400) ? 29 : 28;
	    }

	    return 31;
	  },

	  /**
	   * Get nth suffix for date
	   * @param {Number} day
	   * @return {String}
	   */
	  // eslint-disable-next-line complexity
	  getNthSuffix: function getNthSuffix(day) {
	    switch (day) {
	      case 1:
	      case 21:
	      case 31:
	        return 'st';

	      case 2:
	      case 22:
	        return 'nd';

	      case 3:
	      case 23:
	        return 'rd';

	      default:
	        return 'th';
	    }
	  },

	  /**
	   * Formats date object
	   * @param {Date} date
	   * @param {String} formatStr
	   * @param {Object} translation
	   * @return {String}
	   */
	  formatDate: function formatDate(date, formatStr) {
	    var translation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : en;
	    var year = this.getFullYear(date);
	    var month = this.getMonth(date) + 1;
	    var day = this.getDate(date);
	    var matches = {
	      dd: "0".concat(day).slice(-2),
	      d: day,
	      yyyy: year,
	      yy: String(year).slice(2),
	      MMMM: this.getMonthName(this.getMonth(date), translation.months),
	      MMM: this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr),
	      MM: "0".concat(month).slice(-2),
	      M: month,
	      o: this.getNthSuffix(this.getDate(date)),
	      E: this.getDayNameAbbr(date, translation.days)
	    };
	    var REGEX_FORMAT = /y{4}|y{2}|M{1,4}(?![aäe])|d{1,2}|o{1}|E{1}(?![eéi])/g;
	    return formatStr.replace(REGEX_FORMAT, function (match) {
	      return matches[match] || match;
	    });
	  },

	  /**
	   * makes date parseable
	   * to use with international dates
	   * @param {String} dateStr
	   * @param {String|Function} formatStr
	   * @param {Object} translation
	   * @param {Function} parser
	   * @return {Date | String}
	   */
	  // eslint-disable-next-line max-params,complexity,max-statements
	  parseDate: function parseDate(dateStr, formatStr) {
	    var translation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : en;
	    var parser = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	    if (!(dateStr && formatStr)) {
	      return dateStr;
	    }

	    if (typeof formatStr === 'function') {
	      if (!parser || typeof parser !== 'function') {
	        throw new Error('Parser need to be a function if you are using a custom formatter');
	      }

	      return parser(dateStr);
	    }

	    var ymd = getParsedDate({
	      formatStr: formatStr,
	      dateStr: dateStr,
	      translation: translation
	    });
	    var dat = "".concat(ymd.join('-')).concat(this.getTime());

	    if (Number.isNaN(Date.parse(dat))) {
	      return dateStr;
	    }

	    return dat;
	  },
	  getTime: function getTime() {
	    var time = 'T00:00:00';

	    if (this.useUtc) {
	      return "".concat(time, "Z");
	    }

	    return time;
	  },

	  /**
	   * Creates an array of dates for each day in between two dates.
	   * @param {Date} start
	   * @param {Date} end
	   * @return {Array}
	   */
	  createDateArray: function createDateArray(start, end) {
	    var dates = [];
	    var startTemp = start;

	    while (startTemp <= end) {
	      dates.push(new Date(startTemp));
	      startTemp = this.setDate(new Date(startTemp), this.getDate(new Date(startTemp)) + 1);
	    }

	    return dates;
	  },

	  /**
	   * Remove hours/minutes/seconds/milliseconds from a date object
	   * @param {Date} date
	   * @return {Date}
	   */
	  resetDateTime: function resetDateTime(date) {
	    return new Date(this.useUtc ? date.setUTCHours(0, 0, 0, 0) : date.setHours(0, 0, 0, 0));
	  },

	  /**
	   * Return a new date object with hours/minutes/seconds/milliseconds removed
	   * @return {Date}
	   */
	  getNewDateObject: function getNewDateObject(date) {
	    return date ? this.resetDateTime(new Date(date)) : this.resetDateTime(new Date());
	  }
	};
	var makeDateUtils = (function (useUtc) {
	  return _objectSpread2(_objectSpread2({}, utils), {}, {
	    useUtc: useUtc
	  });
	});

	var script$8 = {
	  props: {
	    autofocus: {
	      type: Boolean,
	      default: false
	    },
	    bootstrapStyling: {
	      type: Boolean,
	      default: false
	    },
	    clearButton: {
	      type: Boolean,
	      default: false
	    },
	    clearButtonIcon: {
	      type: String,
	      default: ''
	    },
	    calendarButton: {
	      type: Boolean,
	      default: false
	    },
	    calendarButtonIcon: {
	      type: String,
	      default: ''
	    },
	    calendarButtonIconContent: {
	      type: String,
	      default: ''
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    format: {
	      type: [String, Function],
	      default: 'dd MMM yyyy'
	    },
	    id: {
	      type: String,
	      default: null
	    },
	    inline: {
	      type: Boolean,
	      default: false
	    },
	    inputClass: {
	      type: [String, Object, Array],
	      default: null
	    },
	    maxlength: {
	      type: [Number, String],
	      default: null
	    },
	    name: {
	      type: String,
	      default: null
	    },
	    openDate: {
	      type: [String, Date, Number],
	      default: null,
	      validator: function validator(val) {
	        return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number';
	      }
	    },
	    parser: {
	      type: Function,
	      default: null
	    },
	    pattern: {
	      type: String,
	      default: null
	    },
	    placeholder: {
	      type: String,
	      default: null
	    },
	    refName: {
	      type: String,
	      default: ''
	    },
	    required: {
	      type: Boolean,
	      default: false
	    },
	    showCalendarOnButtonClick: {
	      type: Boolean,
	      default: false
	    },
	    showCalendarOnFocus: {
	      type: Boolean,
	      default: false
	    },
	    tabindex: {
	      type: [Number, String],
	      default: null
	    },
	    typeable: {
	      type: Boolean,
	      default: false
	    },
	    useUtc: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

	function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
	    if (typeof shadowMode !== 'boolean') {
	        createInjectorSSR = createInjector;
	        createInjector = shadowMode;
	        shadowMode = false;
	    }
	    // Vue.extend constructor export interop.
	    const options = typeof script === 'function' ? script.options : script;
	    // render functions
	    if (template && template.render) {
	        options.render = template.render;
	        options.staticRenderFns = template.staticRenderFns;
	        options._compiled = true;
	        // functional template
	        if (isFunctionalTemplate) {
	            options.functional = true;
	        }
	    }
	    // scopedId
	    if (scopeId) {
	        options._scopeId = scopeId;
	    }
	    let hook;
	    if (moduleIdentifier) {
	        // server build
	        hook = function (context) {
	            // 2.3 injection
	            context =
	                context || // cached call
	                    (this.$vnode && this.$vnode.ssrContext) || // stateful
	                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
	            // 2.2 with runInNewContext: true
	            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	                context = __VUE_SSR_CONTEXT__;
	            }
	            // inject component styles
	            if (style) {
	                style.call(this, createInjectorSSR(context));
	            }
	            // register component module identifier for async chunk inference
	            if (context && context._registeredComponents) {
	                context._registeredComponents.add(moduleIdentifier);
	            }
	        };
	        // used by ssr in case component is cached and beforeCreate
	        // never gets called
	        options._ssrRegister = hook;
	    }
	    else if (style) {
	        hook = shadowMode
	            ? function (context) {
	                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
	            }
	            : function (context) {
	                style.call(this, createInjector(context));
	            };
	    }
	    if (hook) {
	        if (options.functional) {
	            // register for functional component in vue file
	            const originalRender = options.render;
	            options.render = function renderWithStyleInjection(h, context) {
	                hook.call(context);
	                return originalRender(h, context);
	            };
	        }
	        else {
	            // inject component registration as beforeCreate hook
	            const existing = options.beforeCreate;
	            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
	        }
	    }
	    return script;
	}

	/* script */
	const __vue_script__$8 = script$8;

	/* template */

	  /* style */
	  const __vue_inject_styles__$8 = undefined;
	  /* scoped */
	  const __vue_scope_id__$8 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$8 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$8 = undefined;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
	    {},
	    __vue_inject_styles__$8,
	    __vue_script__$8,
	    __vue_scope_id__$8,
	    __vue_is_functional_template__$8,
	    __vue_module_identifier__$8,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var script$7 = {
	  name: 'DateInput',
	  mixins: [__vue_component__$8],
	  props: {
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    resetTypedDate: {
	      type: [Date],
	      default: null
	    },
	    selectedDate: {
	      type: Date,
	      default: null
	    },
	    translation: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    return {
	      input: null,
	      isFocusedUsed: false,
	      isBlurred: false,
	      typedDate: '',
	      utils: makeDateUtils(this.useUtc)
	    };
	  },
	  computed: {
	    computedInputClass: function computedInputClass() {
	      if (this.bootstrapStyling) {
	        if (typeof this.inputClass === 'string') {
	          return [this.inputClass, 'form-control'].join(' ');
	        }

	        return _objectSpread2({
	          'form-control': true
	        }, this.inputClass);
	      }

	      return this.inputClass;
	    },
	    formattedDate: function formattedDate() {
	      return typeof this.format === 'function' ? this.format(new Date(this.selectedDate)) : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation);
	    },
	    formattedValue: function formattedValue() {
	      if (!this.selectedDate) {
	        return null;
	      }

	      if (this.typedDate.length) {
	        return this.typedDate;
	      }

	      return this.formattedDate;
	    }
	  },
	  watch: {
	    resetTypedDate: function resetTypedDate() {
	      this.typedDate = '';
	    }
	  },
	  mounted: function mounted() {
	    this.input = this.$el.querySelector('input');
	  },
	  methods: {
	    /**
	     * emit a clearDate event
	     */
	    clearDate: function clearDate() {
	      this.$emit('clear-date');
	    },

	    /**
	     * submit typedDate and emit a blur event
	     */
	    handleInputBlur: function handleInputBlur() {
	      this.isBlurred = this.isOpen;

	      if (this.typeable) {
	        this.submitTypedDate();
	      }

	      this.$emit('blur');
	      this.$emit('close');
	      this.isFocusedUsed = false;
	    },
	    handleInputClick: function handleInputClick() {
	      var isFocusedUsed = this.showCalendarOnFocus && !this.isFocusedUsed;

	      if (!this.showCalendarOnButtonClick && !isFocusedUsed) {
	        this.toggle();
	      }

	      if (this.showCalendarOnFocus) {
	        this.isFocusedUsed = true;
	      }
	    },
	    handleInputFocus: function handleInputFocus() {
	      if (this.showCalendarOnFocus) {
	        this.$emit('open');
	      }

	      this.isBlurred = false;
	      this.$emit('focus');
	    },
	    handleKeydownEnter: function handleKeydownEnter() {
	      if (this.typeable) {
	        this.submitTypedDate();
	      }

	      this.$emit('close');
	    },
	    parseDate: function parseDate(value) {
	      return this.utils.parseDate(value, this.format, this.translation, this.parser);
	    },

	    /**
	     * Attempt to parse a typed date
	     */
	    parseTypedDate: function parseTypedDate() {
	      if (this.typeable) {
	        var parsableDate = this.parseDate(this.input.value);
	        var parsedDate = Date.parse(parsableDate);

	        if (!Number.isNaN(parsedDate)) {
	          this.typedDate = this.input.value;
	          this.$emit('typed-date', new Date(parsedDate));
	        }
	      }
	    },

	    /**
	     * Submits a typed date if it's valid
	     */
	    submitTypedDate: function submitTypedDate() {
	      var parsableDate = this.parseDate(this.input.value);
	      var parsedDate = Date.parse(parsableDate);

	      if (Number.isNaN(parsedDate)) {
	        this.clearDate();
	      } else {
	        this.input.value = this.formattedDate;
	        this.typedDate = '';
	        this.$emit('typed-date', parsedDate);
	      }
	    },
	    toggle: function toggle() {
	      if (!this.isOpen && this.isBlurred) {
	        this.isBlurred = false;
	        return;
	      }

	      this.$emit(this.isOpen ? 'close' : 'open');
	    }
	  }
	};

	/* script */
	const __vue_script__$7 = script$7;

	/* template */
	var __vue_render__$5 = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    { class: { "input-group": _vm.bootstrapStyling } },
	    [
	      _vm._t("beforeDateInput"),
	      _vm._v(" "),
	      _vm.calendarButton
	        ? _c(
	            "span",
	            {
	              staticClass: "vdp-datepicker__calendar-button",
	              class: {
	                "input-group-prepend": _vm.bootstrapStyling,
	                "calendar-btn-disabled": _vm.disabled
	              },
	              on: { click: _vm.toggle }
	            },
	            [
	              _c(
	                "span",
	                { class: { "input-group-text": _vm.bootstrapStyling } },
	                [
	                  _vm._t("calendarBtn", [
	                    _c("i", { class: _vm.calendarButtonIcon }, [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.calendarButtonIconContent) +
	                          "\n          "
	                      ),
	                      !_vm.calendarButtonIcon
	                        ? _c("span", [_vm._v("…")])
	                        : _vm._e()
	                    ])
	                  ])
	                ],
	                2
	              )
	            ]
	          )
	        : _vm._e(),
	      _vm._v(" "),
	      _c("input", {
	        ref: _vm.refName,
	        class: _vm.computedInputClass,
	        attrs: {
	          id: _vm.id,
	          autocomplete: "off",
	          autofocus: _vm.autofocus,
	          "clear-button": _vm.clearButton,
	          disabled: _vm.disabled,
	          maxlength: _vm.maxlength,
	          name: _vm.name,
	          pattern: _vm.pattern,
	          placeholder: _vm.placeholder,
	          readonly: !_vm.typeable,
	          required: _vm.required,
	          tabindex: _vm.tabindex,
	          type: _vm.inline ? "hidden" : null
	        },
	        domProps: { value: _vm.formattedValue },
	        on: {
	          blur: _vm.handleInputBlur,
	          click: _vm.handleInputClick,
	          focus: _vm.handleInputFocus,
	          keydown: [
	            function($event) {
	              if (
	                !$event.type.indexOf("key") &&
	                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	              ) {
	                return null
	              }
	              $event.preventDefault();
	              return _vm.handleKeydownEnter($event)
	            },
	            function($event) {
	              if (
	                !$event.type.indexOf("key") &&
	                _vm._k(
	                  $event.keyCode,
	                  "escape",
	                  undefined,
	                  $event.key,
	                  undefined
	                )
	              ) {
	                return null
	              }
	              $event.preventDefault();
	              return _vm.$emit("close")
	            }
	          ],
	          keyup: _vm.parseTypedDate
	        }
	      }),
	      _vm._v(" "),
	      _vm.clearButton && _vm.selectedDate
	        ? _c(
	            "span",
	            {
	              staticClass: "vdp-datepicker__clear-button",
	              class: { "input-group-append": _vm.bootstrapStyling },
	              on: {
	                click: function($event) {
	                  return _vm.clearDate()
	                }
	              }
	            },
	            [
	              _c(
	                "span",
	                { class: { "input-group-text": _vm.bootstrapStyling } },
	                [
	                  _vm._t("clearBtn", [
	                    _c("i", { class: _vm.clearButtonIcon }, [
	                      !_vm.clearButtonIcon
	                        ? _c("span", [_vm._v("×")])
	                        : _vm._e()
	                    ])
	                  ])
	                ],
	                2
	              )
	            ]
	          )
	        : _vm._e(),
	      _vm._v(" "),
	      _vm._t("afterDateInput")
	    ],
	    2
	  )
	};
	var __vue_staticRenderFns__$5 = [];
	__vue_render__$5._withStripped = true;

	  /* style */
	  const __vue_inject_styles__$7 = undefined;
	  /* scoped */
	  const __vue_scope_id__$7 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$7 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$7 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
	    __vue_inject_styles__$7,
	    __vue_script__$7,
	    __vue_scope_id__$7,
	    __vue_is_functional_template__$7,
	    __vue_module_identifier__$7,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var $ = _export;
	var toObject = toObject$5;
	var nativeKeys = objectKeys$1;
	var fails = fails$c;
	var FAILS_ON_PRIMITIVES = fails(function () {
	  nativeKeys(1);
	}); // `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys

	$({
	  target: 'Object',
	  stat: true,
	  forced: FAILS_ON_PRIMITIVES
	}, {
	  keys: function keys(it) {
	    return nativeKeys(toObject(it));
	  }
	});

	var cellUtils = {
	  configExists: function configExists(obj) {
	    return typeof obj !== 'undefined' && Object.keys(obj).length > 0;
	  },
	  isDefined: function isDefined(obj, prop) {
	    return this.configExists(obj) && typeof obj[prop] !== 'undefined';
	  },
	  hasArray: function hasArray(obj, prop) {
	    return this.isDefined(obj, prop) && obj[prop].length > 0;
	  },
	  hasDate: function hasDate(obj, prop) {
	    return this.isDefined(obj, prop) && this.utils.isValidDate(obj[prop]);
	  },
	  dayMonthYear: function dayMonthYear(obj, prop) {
	    var utils = this.utils;
	    var hasDate = this.hasDate(obj, prop);

	    if (!hasDate) {
	      return {
	        day: undefined,
	        month: undefined,
	        year: undefined
	      };
	    }

	    var d = obj[prop];
	    return {
	      day: utils.getDate(d),
	      month: utils.getMonth(d),
	      year: utils.getFullYear(d)
	    };
	  }
	};
	var makeCellUtils = (function (utils) {
	  return _objectSpread2(_objectSpread2({}, cellUtils), {}, {
	    utils: utils
	  });
	});

	var DisabledDate = /*#__PURE__*/function () {
	  function DisabledDate(utils, disabledDates) {
	    _classCallCheck(this, DisabledDate);

	    this._utils = utils;
	    this._disabledDates = disabledDates;
	  }

	  _createClass(DisabledDate, [{
	    key: "config",
	    get: function get() {
	      var disabledDates = this._disabledDates;
	      var utils = makeCellUtils(this._utils);
	      return {
	        exists: utils.configExists(disabledDates),
	        to: utils.dayMonthYear(disabledDates, 'to'),
	        from: utils.dayMonthYear(disabledDates, 'from'),
	        has: {
	          customPredictor: utils.isDefined(disabledDates, 'customPredictor'),
	          daysOfMonth: utils.hasArray(disabledDates, 'daysOfMonth'),
	          daysOfWeek: utils.hasArray(disabledDates, 'days'),
	          from: utils.hasDate(disabledDates, 'from'),
	          ranges: utils.hasArray(disabledDates, 'ranges'),
	          specificDates: utils.hasArray(disabledDates, 'dates'),
	          to: utils.hasDate(disabledDates, 'to')
	        }
	      };
	    }
	  }, {
	    key: "daysInMonth",
	    value: function daysInMonth(date) {
	      var utils = this._utils;
	      var month = utils.getMonth(date);
	      var year = utils.getFullYear(date);
	      return utils.daysInMonth(year, month);
	    }
	  }, {
	    key: "isDateDisabledVia",
	    value: function isDateDisabledVia(date) {
	      var _this = this;

	      var disabledDates = this._disabledDates;
	      var has = this.config.has;
	      return {
	        to: function to() {
	          return has.to && date < disabledDates.to;
	        },
	        from: function from() {
	          return has.from && date > disabledDates.from;
	        },
	        range: function range() {
	          if (!has.ranges) return false;
	          var ranges = disabledDates.ranges;
	          var u = makeCellUtils(_this._utils);
	          return ranges.some(function (thisRange) {
	            var hasFrom = u.isDefined(thisRange, 'from');
	            var hasTo = u.isDefined(thisRange, 'to');
	            return hasFrom && hasTo && date < thisRange.to && date > thisRange.from;
	          });
	        },
	        customPredictor: function customPredictor() {
	          return has.customPredictor && disabledDates.customPredictor(date);
	        },
	        specificDate: function specificDate() {
	          if (!has.specificDates) return false;
	          return disabledDates.dates.some(function (d) {
	            return _this._utils.compareDates(date, d);
	          });
	        },
	        daysOfWeek: function daysOfWeek() {
	          if (!has.daysOfWeek) return false;
	          return disabledDates.days.indexOf(_this._utils.getDay(date)) !== -1;
	        },
	        daysOfMonth: function daysOfMonth() {
	          if (!has.daysOfMonth) return false;
	          return disabledDates.daysOfMonth.indexOf(_this._utils.getDate(date)) !== -1;
	        }
	      };
	    }
	  }, {
	    key: "isMonthDisabledVia",
	    value: function isMonthDisabledVia(date) {
	      var _this$config = this.config,
	          _from = _this$config.from,
	          has = _this$config.has,
	          _to = _this$config.to;

	      var month = this._utils.getMonth(date);

	      var year = this._utils.getFullYear(date);

	      return {
	        to: function to() {
	          var isYearInPast = has.to && year < _to.year;

	          if (isYearInPast) {
	            return true;
	          }

	          return has.to && month < _to.month && year <= _to.year;
	        },
	        from: function from() {
	          var isYearInFuture = has.from && year > _from.year;

	          if (isYearInFuture) {
	            return true;
	          }

	          return has.from && month > _from.month && year >= _from.year;
	        }
	      };
	    }
	  }, {
	    key: "isYearDisabledVia",
	    value: function isYearDisabledVia(date) {
	      var _this$config2 = this.config,
	          _from2 = _this$config2.from,
	          has = _this$config2.has,
	          _to2 = _this$config2.to;

	      var year = this._utils.getFullYear(date);

	      return {
	        to: function to() {
	          return has.to && year < _to2.year;
	        },
	        from: function from() {
	          return has.from && year > _from2.year;
	        }
	      };
	    }
	    /**
	     * Checks if the given date should be disabled
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    // eslint-disable-next-line complexity,max-statements

	  }, {
	    key: "isDateDisabled",
	    value: function isDateDisabled(date) {
	      if (!this.config.exists) return false;
	      var isDisabledVia = this.isDateDisabledVia(date);
	      return isDisabledVia.to() || isDisabledVia.from() || isDisabledVia.range() || isDisabledVia.specificDate() || isDisabledVia.daysOfWeek() || isDisabledVia.daysOfMonth() || isDisabledVia.customPredictor();
	    }
	    /**
	     * Checks if the given month should be disabled
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    // eslint-disable-next-line complexity,max-statements

	  }, {
	    key: "isMonthDisabled",
	    value: function isMonthDisabled(date) {
	      var config = this.config;
	      var isDisabledVia = this.isMonthDisabledVia(date);

	      if (!config.exists) {
	        return false;
	      }

	      if (isDisabledVia.to() || isDisabledVia.from()) {
	        return true;
	      } // now we have to check each day of the month


	      for (var i = 1; i <= this.daysInMonth(date); i += 1) {
	        var dayDate = new Date(date);
	        dayDate.setDate(i); // if at least one day of this month is NOT disabled,
	        // we can conclude that this month SHOULD be selectable

	        if (!this.isDateDisabled(dayDate)) {
	          return false;
	        }
	      }

	      return true;
	    }
	    /**
	     * Checks if the given year should be disabled
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    // eslint-disable-next-line complexity,max-statements

	  }, {
	    key: "isYearDisabled",
	    value: function isYearDisabled(date) {
	      var config = this.config;
	      var isDisabledVia = this.isYearDisabledVia(date);

	      if (!config.exists) {
	        return false;
	      }

	      if (isDisabledVia.to() || isDisabledVia.from()) {
	        return true;
	      } // now we have to check each month of the year


	      for (var i = 0; i < 12; i += 1) {
	        var monthDate = new Date(date);
	        monthDate.setMonth(i); // if at least one month of this year is NOT disabled,
	        // we can conclude that this year SHOULD be selectable

	        if (!this.isMonthDisabled(monthDate)) {
	          return false;
	        }
	      }

	      return true;
	    }
	  }]);

	  return DisabledDate;
	}();

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	var script$6 = {
	  name: 'PickerHeader',
	  props: {
	    isNextDisabled: {
	      type: Boolean,
	      required: true
	    },
	    isPreviousDisabled: {
	      type: Boolean,
	      required: true
	    },
	    isRtl: {
	      type: Boolean,
	      required: true
	    }
	  },
	  computed: {
	    /**
	     * Is the left hand navigation button disabled?
	     * @return {Boolean}
	     */
	    isLeftNavDisabled: function isLeftNavDisabled() {
	      return this.isRtl ? this.isNextDisabled : this.isPreviousDisabled;
	    },

	    /**
	     * Is the right hand navigation button disabled?
	     * @return {Boolean}
	     */
	    isRightNavDisabled: function isRightNavDisabled() {
	      return this.isRtl ? this.isPreviousDisabled : this.isNextDisabled;
	    }
	  }
	};

	/* script */
	const __vue_script__$6 = script$6;

	/* template */
	var __vue_render__$4 = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "header",
	    [
	      _c(
	        "span",
	        {
	          staticClass: "prev",
	          class: { disabled: _vm.isLeftNavDisabled },
	          on: {
	            click: function($event) {
	              return _vm.$emit(_vm.isRtl ? "next" : "previous")
	            }
	          }
	        },
	        [
	          _vm._t("prevIntervalBtn", [
	            _c("span", { staticClass: "default" }, [_vm._v("<")])
	          ])
	        ],
	        2
	      ),
	      _vm._v(" "),
	      _vm._t("default"),
	      _vm._v(" "),
	      _c(
	        "span",
	        {
	          staticClass: "next",
	          class: { disabled: _vm.isRightNavDisabled },
	          on: {
	            click: function($event) {
	              return _vm.$emit(_vm.isRtl ? "previous" : "next")
	            }
	          }
	        },
	        [
	          _vm._t("nextIntervalBtn", [
	            _c("span", { staticClass: "default" }, [_vm._v(">")])
	          ])
	        ],
	        2
	      )
	    ],
	    2
	  )
	};
	var __vue_staticRenderFns__$4 = [];
	__vue_render__$4._withStripped = true;

	  /* style */
	  const __vue_inject_styles__$6 = undefined;
	  /* scoped */
	  const __vue_scope_id__$6 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$6 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$6 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
	    __vue_inject_styles__$6,
	    __vue_script__$6,
	    __vue_scope_id__$6,
	    __vue_is_functional_template__$6,
	    __vue_module_identifier__$6,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var script$5 = {
	  components: {
	    PickerHeader: __vue_component__$6
	  },
	  inheritAttrs: false,
	  props: {
	    disabledDates: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    isRtl: {
	      type: Boolean,
	      default: false
	    },
	    isUpDisabled: {
	      type: Boolean,
	      default: false
	    },
	    pageDate: {
	      type: Date,
	      default: null
	    },
	    selectedDate: {
	      type: Date,
	      default: null
	    },
	    showHeader: {
	      type: Boolean,
	      default: true
	    },
	    translation: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    useUtc: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      utils: makeDateUtils(this.useUtc)
	    };
	  },
	  computed: {
	    /**
	     * A look-up object created from 'disabledDates' prop
	     * @return {Object}
	     */
	    disabledConfig: function disabledConfig() {
	      return new DisabledDate(this.utils, this.disabledDates).config;
	    },

	    /**
	     * Returns the current page's full year as an integer.
	     * @return {Number}
	     */
	    pageYear: function pageYear() {
	      return this.utils.getFullYear(this.pageDate);
	    }
	  },
	  methods: {
	    /**
	     * Changes the page up or down
	     * @param {Number} incrementBy
	     */
	    changePage: function changePage(incrementBy) {
	      var date = this.pageDate;
	      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
	      this.$emit('page-change', date);
	    },

	    /**
	     * Emits a 'select' or 'select-disabled' event
	     * @param {Object} cell
	     */
	    select: function select(cell) {
	      if (cell.isDisabled) {
	        this.$emit('select-disabled', cell);
	      } else {
	        this.$emit('select', cell);
	      }
	    },

	    /**
	     * Increment the current page
	     */
	    nextPage: function nextPage() {
	      if (!this.isNextDisabled) {
	        this.changePage(+1);
	      }
	    },

	    /**
	     * Decrement the page
	     */
	    previousPage: function previousPage() {
	      if (!this.isPreviousDisabled) {
	        this.changePage(-1);
	      }
	    }
	  }
	};

	/* script */
	const __vue_script__$5 = script$5;

	/* template */

	  /* style */
	  const __vue_inject_styles__$5 = undefined;
	  /* scoped */
	  const __vue_scope_id__$5 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$5 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$5 = undefined;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
	    {},
	    __vue_inject_styles__$5,
	    __vue_script__$5,
	    __vue_scope_id__$5,
	    __vue_is_functional_template__$5,
	    __vue_module_identifier__$5,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var HighlightedDate = /*#__PURE__*/function () {
	  function HighlightedDate(utils, disabledDates, highlighted) {
	    _classCallCheck(this, HighlightedDate);

	    this._utils = utils;
	    this._disabledDates = disabledDates;
	    this._highlighted = highlighted;
	  }

	  _createClass(HighlightedDate, [{
	    key: "config",
	    get: function get() {
	      var highlightedDates = this._highlighted;
	      var utils = makeCellUtils(this._utils);
	      return {
	        exists: utils.configExists(highlightedDates),
	        to: utils.dayMonthYear(highlightedDates, 'to'),
	        from: utils.dayMonthYear(highlightedDates, 'from'),
	        has: {
	          customPredictor: utils.isDefined(highlightedDates, 'customPredictor'),
	          daysOfMonth: utils.hasArray(highlightedDates, 'daysOfMonth'),
	          daysOfWeek: utils.hasArray(highlightedDates, 'days'),
	          from: utils.hasDate(highlightedDates, 'from'),
	          specificDates: utils.hasArray(highlightedDates, 'dates'),
	          to: utils.hasDate(highlightedDates, 'to'),
	          includeDisabled: utils.isDefined(highlightedDates, 'includeDisabled') && highlightedDates.includeDisabled
	        }
	      };
	    }
	  }, {
	    key: "isDateDisabled",
	    value: function isDateDisabled(date) {
	      var utils = this._utils;
	      var disabledDates = this._disabledDates;
	      return new DisabledDate(utils, disabledDates).isDateDisabled(date);
	    }
	  }, {
	    key: "isHighlightingNotPossible",
	    value: function isHighlightingNotPossible(date) {
	      var config = this.config;
	      if (!config.exists) return false;
	      return !config.has.includeDisabled && this.isDateDisabled(date);
	    }
	  }, {
	    key: "isDateHighlightedVia",
	    value: function isDateHighlightedVia(date) {
	      var _this = this;

	      var highlightedDates = this._highlighted;
	      var has = this.config.has;
	      return {
	        to: function to() {
	          return has.to && date <= highlightedDates.to;
	        },
	        from: function from() {
	          return has.from && date >= highlightedDates.from;
	        },
	        customPredictor: function customPredictor() {
	          return has.customPredictor && highlightedDates.customPredictor(date);
	        },
	        specificDate: function specificDate() {
	          if (!has.specificDates) return false;
	          return highlightedDates.dates.some(function (d) {
	            return _this._utils.compareDates(date, d);
	          });
	        },
	        daysOfWeek: function daysOfWeek() {
	          if (!has.daysOfWeek) return false;
	          return highlightedDates.days.indexOf(_this._utils.getDay(date)) !== -1;
	        },
	        daysOfMonth: function daysOfMonth() {
	          if (!has.daysOfMonth) return false;
	          return highlightedDates.daysOfMonth.indexOf(_this._utils.getDate(date)) !== -1;
	        }
	      };
	    } // eslint-disable-next-line complexity,max-statements

	  }, {
	    key: "isDateHighlighted",
	    value: function isDateHighlighted(date) {
	      if (this.isHighlightingNotPossible(date)) return false;
	      var isHighlightedVia = this.isDateHighlightedVia(date);
	      return isHighlightedVia.to() && isHighlightedVia.from() || isHighlightedVia.specificDate() || isHighlightedVia.daysOfWeek() || isHighlightedVia.daysOfMonth() || isHighlightedVia.customPredictor();
	    }
	  }]);

	  return HighlightedDate;
	}();

	var script$4 = {
	  name: 'PickerDay',
	  mixins: [__vue_component__$5],
	  props: {
	    dayCellContent: {
	      type: Function,
	      default: function _default(day) {
	        return day.date;
	      }
	    },
	    highlighted: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    firstDayOfWeek: {
	      type: String,
	      default: 'sun'
	    },
	    showFullMonthName: {
	      type: Boolean,
	      default: false
	    },
	    showEdgeDates: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    /**
	     * Sets an array with all days to show this month
	     * @return {Array}
	     */
	    cells: function cells() {
	      var days = [];
	      var daysInCalendar = this.daysFromPrevMonth + this.daysInMonth + this.daysFromNextMonth;
	      var dObj = this.firstCellDate();

	      for (var i = 0; i < daysInCalendar; i += 1) {
	        days.push(this.makeDay(i, dObj));
	        this.utils.setDate(dObj, this.utils.getDate(dObj) + 1);
	      }

	      return days;
	    },

	    /**
	     * Gets the name of the month the current page is on
	     * @return {String}
	     */
	    currMonthName: function currMonthName() {
	      var monthName = this.showFullMonthName ? this.translation.months : this.translation.monthsAbbr;
	      return this.utils.getMonthNameAbbr(this.pageMonth, monthName);
	    },

	    /**
	     * Gets the name of the year that current page is on
	     * @return {String}
	     */
	    currYearName: function currYearName() {
	      var yearSuffix = this.translation.yearSuffix;
	      return "".concat(this.pageYear).concat(yearSuffix);
	    },

	    /**
	     * Returns an array of day names
	     * @return {String[]}
	     */
	    daysOfWeek: function daysOfWeek() {
	      return this.translation.getDaysStartingOn(this.firstDayOfWeekNumber);
	    },

	    /**
	     * Returns the number of days in this month
	     * @return {String[]}
	     */
	    daysInMonth: function daysInMonth() {
	      return this.utils.getDaysInMonth(this.pageDate);
	    },

	    /**
	     * Calculates how many days to show from the previous month
	     * @return {number}
	     */
	    daysFromPrevMonth: function daysFromPrevMonth() {
	      var firstOfMonthDayNumber = this.utils.getDay(this.pageDate);
	      return (7 - this.firstDayOfWeekNumber + firstOfMonthDayNumber) % 7;
	    },

	    /**
	     * Calculates how many days to show from the next month
	     * @return {number}
	     */
	    daysFromNextMonth: function daysFromNextMonth() {
	      var daysThisAndPrevMonth = this.daysFromPrevMonth + this.daysInMonth;
	      return Math.ceil(daysThisAndPrevMonth / 7) * 7 - daysThisAndPrevMonth;
	    },

	    /**
	     * Returns first-day-of-week as a number (Sunday is 0)
	     * @return {Number}
	     */
	    firstDayOfWeekNumber: function firstDayOfWeekNumber() {
	      return this.utils.getDayFromAbbr(this.firstDayOfWeek);
	    },

	    /**
	     * A look-up object created from 'highlighted' prop
	     * @return {Object}
	     */
	    highlightedConfig: function highlightedConfig() {
	      return new HighlightedDate(this.utils, this.disabledDates, this.highlighted).config;
	    },

	    /**
	     * Is the next month disabled?
	     * @return {Boolean}
	     */
	    isNextDisabled: function isNextDisabled() {
	      if (!this.disabledConfig.has.from) {
	        return false;
	      }

	      return this.disabledConfig.from.month <= this.pageMonth && this.disabledConfig.from.year <= this.pageYear;
	    },

	    /**
	     * Is the previous month disabled?
	     * @return {Boolean}
	     */
	    isPreviousDisabled: function isPreviousDisabled() {
	      if (!this.disabledConfig.has.to) {
	        return false;
	      }

	      return this.disabledConfig.to.month >= this.pageMonth && this.disabledConfig.to.year >= this.pageYear;
	    },

	    /**
	     * Returns the current page's month as an integer.
	     * @return {Number}
	     */
	    pageMonth: function pageMonth() {
	      return this.utils.getMonth(this.pageDate);
	    },

	    /**
	     * Display the current page's month & year as the title.
	     * @return {String}
	     */
	    pageTitleDay: function pageTitleDay() {
	      return this.translation.ymd ? "".concat(this.currYearName, " ").concat(this.currMonthName) : "".concat(this.currMonthName, " ").concat(this.currYearName);
	    },

	    /**
	     * The first day of the next page's month.
	     * @return {Date}
	     */
	    firstOfNextMonth: function firstOfNextMonth() {
	      var d = new Date(this.pageDate);
	      return new Date(this.utils.setMonth(d, this.utils.getMonth(d) + 1));
	    }
	  },
	  methods: {
	    /**
	     * Changes the page up or down (overrides changePage in pickerMixin)
	     * @param {Number} incrementBy
	     */
	    changePage: function changePage(incrementBy) {
	      var date = this.pageDate;
	      this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
	      this.$emit('page-change', date);
	    },

	    /**
	     * Set the class for a specific day
	     * @param {Object} day
	     * @return {Object}
	     */
	    dayClasses: function dayClasses(day) {
	      return {
	        'selected': day.isSelected,
	        'disabled': day.isDisabled,
	        'highlighted': day.isHighlighted,
	        'muted': day.isPreviousMonth || day.isNextMonth,
	        'today': day.isToday,
	        'weekend': day.isWeekend,
	        'sat': day.isSaturday,
	        'sun': day.isSunday,
	        'highlight-start': day.isHighlightStart,
	        'highlight-end': day.isHighlightEnd
	      };
	    },

	    /**
	     * Whether a day is disabled
	     * @param {Date} date to check if disabled
	     * @return {Boolean}
	     */
	    isDisabledDate: function isDisabledDate(date) {
	      return new DisabledDate(this.utils, this.disabledDates).isDateDisabled(date);
	    },

	    /**
	     * Whether a day is highlighted
	     * (only if it is not disabled already except when highlighted.includeDisabled is true)
	     * @param {Date} date to check if highlighted
	     * @return {Boolean}
	     */
	    isHighlightedDate: function isHighlightedDate(date) {
	      var dateWithoutTime = this.utils.resetDateTime(date);
	      return new HighlightedDate(this.utils, this.disabledDates, this.highlighted).isDateHighlighted(dateWithoutTime);
	    },

	    /**
	     * Whether a day is highlighted and it is the last date
	     * in the highlighted range of dates
	     * @param {Date} date end highlight
	     * @return {Boolean}
	     */
	    isHighlightEnd: function isHighlightEnd(date) {
	      var config = this.highlightedConfig;
	      return this.isHighlightedDate(date) && config.to.year === this.utils.getFullYear(date) && config.to.month === this.utils.getMonth(date) && config.to.day === this.utils.getDate(date);
	    },

	    /**
	     * Whether a day is highlighted and it is the first date
	     * in the highlighted range of dates
	     * @param {Date} date start highlight
	     * @return {Boolean}
	     */
	    isHighlightStart: function isHighlightStart(date) {
	      var config = this.highlightedConfig;
	      return this.isHighlightedDate(date) && config.from.year === this.utils.getFullYear(date) && config.from.month === this.utils.getMonth(date) && config.from.day === this.utils.getDate(date);
	    },

	    /**
	     * Whether a day is selected
	     * @param {Date} dObj to check if selected
	     * @return {Boolean}
	     */
	    isSelectedDate: function isSelectedDate(dObj) {
	      return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj);
	    },

	    /**
	     * Defines the objects within the days array
	     * @param  {id}  id
	     * @param  {Date}  dObj
	     * @return {Object}
	     */
	    // eslint-disable-next-line complexity
	    makeDay: function makeDay(id, dObj) {
	      var isNextMonth = dObj >= this.firstOfNextMonth;
	      var isPreviousMonth = dObj < this.pageDate;
	      var isSaturday = this.utils.getDay(dObj) === 6;
	      var isSunday = this.utils.getDay(dObj) === 0;
	      var showDate = this.showEdgeDates || !(isPreviousMonth || isNextMonth);
	      return {
	        date: showDate ? this.utils.getDate(dObj) : '',
	        timestamp: dObj.valueOf(),
	        isSelected: this.isSelectedDate(dObj),
	        isDisabled: showDate ? this.isDisabledDate(dObj) : true,
	        isHighlighted: this.isHighlightedDate(dObj),
	        isHighlightStart: this.isHighlightStart(dObj),
	        isHighlightEnd: this.isHighlightEnd(dObj),
	        isToday: this.utils.compareDates(dObj, new Date()),
	        isWeekend: isSaturday || isSunday,
	        isSaturday: isSaturday,
	        isSunday: isSunday,
	        isPreviousMonth: isPreviousMonth,
	        isNextMonth: isNextMonth
	      };
	    },

	    /**
	     * Set up a new date object to the first day of the current 'page'
	     * @return Date
	     */
	    firstCellDate: function firstCellDate() {
	      var d = this.pageDate;
	      var firstOfMonth = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
	      return new Date(firstOfMonth.setDate(firstOfMonth.getDate() - this.daysFromPrevMonth));
	    }
	  }
	};

	/* script */
	const __vue_script__$4 = script$4;

	/* template */
	var __vue_render__$3 = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    { staticClass: "picker-view" },
	    [
	      _vm._t("beforeCalendarHeaderDay"),
	      _vm._v(" "),
	      _vm.showHeader
	        ? _c(
	            "PickerHeader",
	            {
	              attrs: {
	                "is-next-disabled": _vm.isNextDisabled,
	                "is-previous-disabled": _vm.isPreviousDisabled,
	                "is-rtl": _vm.isRtl
	              },
	              on: { next: _vm.nextPage, previous: _vm.previousPage }
	            },
	            [
	              _c(
	                "span",
	                {
	                  staticClass: "day__month_btn",
	                  class: { up: !_vm.isUpDisabled },
	                  on: {
	                    click: function($event) {
	                      return _vm.$emit("set-view", "month")
	                    }
	                  }
	                },
	                [_vm._v("\n      " + _vm._s(_vm.pageTitleDay) + "\n    ")]
	              ),
	              _vm._v(" "),
	              _vm._t("nextIntervalBtn", null, { slot: "nextIntervalBtn" }),
	              _vm._v(" "),
	              _vm._t("prevIntervalBtn", null, { slot: "prevIntervalBtn" })
	            ],
	            2
	          )
	        : _vm._e(),
	      _vm._v(" "),
	      _c(
	        "div",
	        { class: { "flex-rtl": _vm.isRtl } },
	        [
	          _vm._l(_vm.daysOfWeek, function(day) {
	            return _c("span", { key: day, staticClass: "day-header" }, [
	              _vm._v("\n      " + _vm._s(day) + "\n    ")
	            ])
	          }),
	          _vm._v(" "),
	          _c(
	            "div",
	            { ref: "cells" },
	            _vm._l(_vm.cells, function(cell) {
	              return _c(
	                "span",
	                {
	                  key: cell.timestamp,
	                  staticClass: "cell day",
	                  class: _vm.dayClasses(cell),
	                  on: {
	                    click: function($event) {
	                      return _vm.select(cell)
	                    }
	                  }
	                },
	                [
	                  _vm._t(
	                    "dayCellContent",
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.dayCellContent(cell)) +
	                          "\n        "
	                      )
	                    ],
	                    { cell: cell }
	                  )
	                ],
	                2
	              )
	            }),
	            0
	          )
	        ],
	        2
	      ),
	      _vm._v(" "),
	      _vm._t("calendarFooterDay")
	    ],
	    2
	  )
	};
	var __vue_staticRenderFns__$3 = [];
	__vue_render__$3._withStripped = true;

	  /* style */
	  const __vue_inject_styles__$4 = undefined;
	  /* scoped */
	  const __vue_scope_id__$4 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$4 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$4 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
	    __vue_inject_styles__$4,
	    __vue_script__$4,
	    __vue_scope_id__$4,
	    __vue_is_functional_template__$4,
	    __vue_module_identifier__$4,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var script$3 = {
	  name: 'PickerMonth',
	  mixins: [__vue_component__$5],
	  computed: {
	    /**
	     * Sets an array with all months to show this year
	     * @return {Array}
	     */
	    cells: function cells() {
	      var d = this.pageDate;
	      var months = []; // set up a new date object to the beginning of the current 'page'

	      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate())) : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());

	      for (var i = 0; i < 12; i += 1) {
	        months.push({
	          month: this.utils.getMonthName(i, this.translation.months),
	          timestamp: dObj.valueOf(),
	          isSelected: this.isSelectedMonth(dObj),
	          isDisabled: this.isDisabledMonth(dObj)
	        });
	        this.utils.setMonth(dObj, this.utils.getMonth(dObj) + 1);
	      }

	      return months;
	    },

	    /**
	     * Is the next year disabled?
	     * @return {Boolean}
	     */
	    isNextDisabled: function isNextDisabled() {
	      if (!this.disabledConfig.has.from) {
	        return false;
	      }

	      return this.disabledConfig.from.year <= this.pageYear;
	    },

	    /**
	     * Is the previous year disabled?
	     * @return {Boolean}
	     */
	    isPreviousDisabled: function isPreviousDisabled() {
	      if (!this.disabledConfig.has.to) {
	        return false;
	      }

	      return this.disabledConfig.to.year >= this.pageYear;
	    },

	    /**
	     * Display the current page's year as the title.
	     * @return {String}
	     */
	    pageTitleMonth: function pageTitleMonth() {
	      var yearSuffix = this.translation.yearSuffix;
	      return "".concat(this.pageYear).concat(yearSuffix);
	    }
	  },
	  methods: {
	    /**
	     * Whether a month is disabled
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    isDisabledMonth: function isDisabledMonth(date) {
	      return new DisabledDate(this.utils, this.disabledDates).isMonthDisabled(date);
	    },

	    /**
	     * Whether the selected date is in this month
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    isSelectedMonth: function isSelectedMonth(date) {
	      var month = this.utils.getMonth(date);
	      var year = this.utils.getFullYear(date);
	      return this.selectedDate && year === this.utils.getFullYear(this.selectedDate) && month === this.utils.getMonth(this.selectedDate);
	    }
	  }
	};

	/* script */
	const __vue_script__$3 = script$3;

	/* template */
	var __vue_render__$2 = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    { staticClass: "picker-view" },
	    [
	      _vm._t("beforeCalendarHeaderMonth"),
	      _vm._v(" "),
	      _vm.showHeader
	        ? _c(
	            "PickerHeader",
	            {
	              attrs: {
	                "is-next-disabled": _vm.isNextDisabled,
	                "is-previous-disabled": _vm.isPreviousDisabled,
	                "is-rtl": _vm.isRtl
	              },
	              on: { next: _vm.nextPage, previous: _vm.previousPage }
	            },
	            [
	              _c(
	                "span",
	                {
	                  staticClass: "month__year_btn",
	                  class: { up: !_vm.isUpDisabled },
	                  on: {
	                    click: function($event) {
	                      return _vm.$emit("set-view", "year")
	                    }
	                  }
	                },
	                [_vm._v("\n      " + _vm._s(_vm.pageTitleMonth) + "\n    ")]
	              ),
	              _vm._v(" "),
	              _vm._t("nextIntervalBtn", null, { slot: "nextIntervalBtn" }),
	              _vm._v(" "),
	              _vm._t("prevIntervalBtn", null, { slot: "prevIntervalBtn" })
	            ],
	            2
	          )
	        : _vm._e(),
	      _vm._v(" "),
	      _c(
	        "div",
	        { ref: "cells" },
	        _vm._l(_vm.cells, function(cell) {
	          return _c(
	            "span",
	            {
	              key: cell.timestamp,
	              staticClass: "cell month",
	              class: { selected: cell.isSelected, disabled: cell.isDisabled },
	              on: {
	                click: function($event) {
	                  return _vm.select(cell)
	                }
	              }
	            },
	            [_vm._v("\n      " + _vm._s(cell.month) + "\n    ")]
	          )
	        }),
	        0
	      ),
	      _vm._v(" "),
	      _vm._t("calendarFooterMonth")
	    ],
	    2
	  )
	};
	var __vue_staticRenderFns__$2 = [];
	__vue_render__$2._withStripped = true;

	  /* style */
	  const __vue_inject_styles__$3 = undefined;
	  /* scoped */
	  const __vue_scope_id__$3 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$3 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$3 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
	    __vue_inject_styles__$3,
	    __vue_script__$3,
	    __vue_scope_id__$3,
	    __vue_is_functional_template__$3,
	    __vue_module_identifier__$3,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var script$2 = {
	  name: 'PickerYear',
	  mixins: [__vue_component__$5],
	  props: {
	    yearRange: {
	      type: Number,
	      default: 10
	    }
	  },
	  computed: {
	    /**
	     * Sets an array with all years to show this decade (or yearRange)
	     * @return {Array}
	     */
	    cells: function cells() {
	      var d = this.pageDate;
	      var years = [];
	      var year = this.useUtc ? Math.floor(d.getUTCFullYear() / this.yearRange) * this.yearRange : Math.floor(d.getFullYear() / this.yearRange) * this.yearRange; // set up a new date object to the beginning of the current 'page'7

	      var dObj = this.useUtc ? new Date(Date.UTC(year, d.getUTCMonth(), d.getUTCDate())) : new Date(year, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());

	      for (var i = 0; i < this.yearRange; i += 1) {
	        years.push({
	          year: this.utils.getFullYear(dObj),
	          timestamp: dObj.valueOf(),
	          isSelected: this.isSelectedYear(dObj),
	          isDisabled: this.isDisabledYear(dObj)
	        });
	        this.utils.setFullYear(dObj, this.utils.getFullYear(dObj) + 1);
	      }

	      return years;
	    },

	    /**
	     * Is the next decade disabled?
	     * @return {Boolean}
	     */
	    isNextDisabled: function isNextDisabled() {
	      if (!this.disabledConfig.has.from) {
	        return false;
	      }

	      return this.disabledConfig.from.year <= this.pageDecadeEnd;
	    },

	    /**
	     * Is the previous decade disabled?
	     * @return {Boolean}
	     */
	    isPreviousDisabled: function isPreviousDisabled() {
	      if (!this.disabledConfig.has.to) {
	        return false;
	      }

	      return this.disabledConfig.to.year >= this.pageDecadeStart;
	    },

	    /**
	     * The year at which the current yearRange starts
	     * @return {Number}
	     */
	    pageDecadeStart: function pageDecadeStart() {
	      return Math.floor(this.pageYear / this.yearRange) * this.yearRange;
	    },

	    /**
	     * The year at which the current yearRange ends
	     * @return {Number}
	     */
	    pageDecadeEnd: function pageDecadeEnd() {
	      return this.pageDecadeStart + this.yearRange - 1;
	    },

	    /**
	     * Display the current page's decade (or year range) as the title.
	     * @return {String}
	     */
	    pageTitleYear: function pageTitleYear() {
	      var yearSuffix = this.translation.yearSuffix;
	      return "".concat(this.pageDecadeStart, " - ").concat(this.pageDecadeEnd).concat(yearSuffix);
	    }
	  },
	  methods: {
	    /**
	     * Whether a year is disabled
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    isDisabledYear: function isDisabledYear(date) {
	      return new DisabledDate(this.utils, this.disabledDates).isYearDisabled(date);
	    },

	    /**
	     * Whether the selected date is in this year
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    isSelectedYear: function isSelectedYear(date) {
	      var year = this.utils.getFullYear(date);
	      return this.selectedDate && year === this.utils.getFullYear(this.selectedDate);
	    },

	    /**
	     * Increments the page (overrides nextPage in pickerMixin)
	     */
	    nextPage: function nextPage() {
	      if (!this.isNextDisabled) {
	        this.changePage(this.yearRange);
	      }
	    },

	    /**
	     * Decrements the page (overrides previousPage in pickerMixin)
	     */
	    previousPage: function previousPage() {
	      if (!this.isPreviousDisabled) {
	        this.changePage(-this.yearRange);
	      }
	    }
	  }
	};

	/* script */
	const __vue_script__$2 = script$2;

	/* template */
	var __vue_render__$1 = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    { staticClass: "picker-view" },
	    [
	      _vm._t("beforeCalendarHeaderYear"),
	      _vm._v(" "),
	      _vm.showHeader
	        ? _c(
	            "PickerHeader",
	            {
	              attrs: {
	                "is-next-disabled": _vm.isNextDisabled,
	                "is-previous-disabled": _vm.isPreviousDisabled,
	                "is-rtl": _vm.isRtl
	              },
	              on: { next: _vm.nextPage, previous: _vm.previousPage }
	            },
	            [
	              _c("span", [
	                _vm._v("\n      " + _vm._s(_vm.pageTitleYear) + "\n    ")
	              ]),
	              _vm._v(" "),
	              _vm._t("nextIntervalBtn", null, { slot: "nextIntervalBtn" }),
	              _vm._v(" "),
	              _vm._t("prevIntervalBtn", null, { slot: "prevIntervalBtn" })
	            ],
	            2
	          )
	        : _vm._e(),
	      _vm._v(" "),
	      _c(
	        "div",
	        { ref: "cells" },
	        _vm._l(_vm.cells, function(cell) {
	          return _c(
	            "span",
	            {
	              key: cell.timestamp,
	              staticClass: "cell year",
	              class: { selected: cell.isSelected, disabled: cell.isDisabled },
	              on: {
	                click: function($event) {
	                  return _vm.select(cell)
	                }
	              }
	            },
	            [_vm._v("\n      " + _vm._s(cell.year) + "\n    ")]
	          )
	        }),
	        0
	      ),
	      _vm._v(" "),
	      _vm._t("calendarFooterYear")
	    ],
	    2
	  )
	};
	var __vue_staticRenderFns__$1 = [];
	__vue_render__$1._withStripped = true;

	  /* style */
	  const __vue_inject_styles__$2 = undefined;
	  /* scoped */
	  const __vue_scope_id__$2 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$2 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$2 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
	    __vue_inject_styles__$2,
	    __vue_script__$2,
	    __vue_scope_id__$2,
	    __vue_is_functional_template__$2,
	    __vue_module_identifier__$2,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	/* eslint no-param-reassign: 0 */

	/**
	 * get the hidden element width, height
	 * @param {HTMLElement} element dom
	 */
	function getPopupElementSize(element) {
	  var originalDisplay = element.style.display;
	  var originalVisibility = element.style.visibility;
	  element.style.display = 'block';
	  element.style.visibility = 'hidden';
	  var styles = window.getComputedStyle(element);
	  var width = element.offsetWidth + parseInt(styles.marginLeft, 10) + parseInt(styles.marginRight, 10);
	  var height = element.offsetHeight + parseInt(styles.marginTop, 10) + parseInt(styles.marginBottom, 10);
	  element.style.display = originalDisplay;
	  element.style.visibility = originalVisibility;
	  return {
	    width: width,
	    height: height
	  };
	}
	/**
	 * get the popup position
	 * @param {Element} el element
	 * @param {Element} elRelative relative element
	 * @param {Number} targetWidth target element's width
	 * @param {Number} targetHeight target element's height
	 * @param {Boolean} appendToBody
	 * @param {String} fixedPosition
	 * @param {Boolean} rtl
	 */
	// eslint-disable-next-line complexity,max-statements

	function getRelativePosition(_ref) {
	  var el = _ref.el,
	      elRelative = _ref.elRelative,
	      targetWidth = _ref.targetWidth,
	      targetHeight = _ref.targetHeight,
	      appendToBody = _ref.appendToBody,
	      fixedPosition = _ref.fixedPosition,
	      rtl = _ref.rtl;
	  var left = 0;
	  var top = 0;
	  var offsetX = 0;
	  var offsetY = 0;
	  var relativeRect = elRelative.getBoundingClientRect();
	  var documentWidth = document.documentElement.clientWidth;
	  var documentHeight = document.documentElement.clientHeight;

	  if (appendToBody) {
	    offsetX = window.pageXOffset + relativeRect.left;
	    offsetY = window.pageYOffset + relativeRect.top;
	  }

	  var calendarBounding = el.getBoundingClientRect();
	  var outOfBoundsRight = calendarBounding.right > window.innerWidth;
	  var outOfBoundsBottom = calendarBounding.bottom > window.innerHeight;
	  var fixedPositionRight = fixedPosition && fixedPosition.indexOf('right') !== -1;
	  var fixedPositionTop = fixedPosition && fixedPosition.indexOf('top') !== -1;

	  var setLeft = function setLeft() {
	    left = offsetX;
	  };

	  var setRight = function setRight() {
	    left = offsetX + relativeRect.width - targetWidth;
	  };

	  var setBottom = function setBottom() {
	    top = offsetY + relativeRect.height;
	  };

	  var setTop = function setTop() {
	    top = offsetY - targetHeight;
	  };

	  if (fixedPosition === '') {
	    if (outOfBoundsRight || rtl) {
	      setRight();
	    } else {
	      setLeft();
	    }

	    if (outOfBoundsBottom) {
	      setTop();
	    } else {
	      setBottom();
	    }

	    var hasRelativWidth = documentWidth - relativeRect.left < targetWidth && relativeRect.right < targetWidth;
	    var hasRelativHeight = relativeRect.top <= targetHeight && documentHeight - relativeRect.bottom <= targetHeight;

	    if (hasRelativWidth) {
	      left = offsetX - relativeRect.left + 1;
	    }

	    if (hasRelativHeight) {
	      top = offsetY + documentHeight - relativeRect.top - targetHeight;
	    }
	  } else {
	    if (fixedPositionRight) {
	      setRight();
	    } else {
	      setLeft();
	    }

	    if (fixedPositionTop) {
	      setTop();
	    } else {
	      setBottom();
	    }
	  }

	  return {
	    left: "".concat(left, "px"),
	    top: "".concat(top, "px")
	  };
	}

	var script$1 = {
	  name: 'Popup',
	  props: {
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    fixedPosition: {
	      type: String,
	      default: ''
	    },
	    inline: {
	      type: Boolean,
	      default: false
	    },
	    rtl: {
	      type: Boolean,
	      default: false
	    },
	    visible: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      popupRect: null
	    };
	  },
	  watch: {
	    visible: {
	      immediate: true,
	      handler: function handler(val) {
	        var _this = this;

	        this.$nextTick(function () {
	          if (val) {
	            _this.displayPopup();
	          }
	        });
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.inline) {
	      return;
	    }

	    if (this.appendToBody) {
	      document.body.appendChild(this.$el);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.inline) {
	      return;
	    }

	    if (this.appendToBody && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  },
	  methods: {
	    setTopStyle: function setTopStyle() {
	      if (this.appendToBody) {
	        var relativeRect = this.$parent.$el.getBoundingClientRect();
	        this.$el.style.top = "".concat(relativeRect.bottom + window.scrollY, "px");
	      }
	    },
	    displayPopup: function displayPopup() {
	      if (this.inline || !this.visible) return;
	      this.setTopStyle();
	      var popup = this.$el;
	      var relativeElement = this.$parent.$el;

	      if (!this.popupRect) {
	        this.popupRect = getPopupElementSize(popup);
	      }

	      var _this$popupRect = this.popupRect,
	          width = _this$popupRect.width,
	          height = _this$popupRect.height;

	      var _getRelativePosition = getRelativePosition({
	        el: popup,
	        elRelative: relativeElement,
	        targetWidth: width,
	        targetHeight: height,
	        appendToBody: this.appendToBody,
	        fixedPosition: this.fixedPosition,
	        rtl: this.rtl
	      }),
	          left = _getRelativePosition.left,
	          top = _getRelativePosition.top;

	      this.$el.style.left = left;
	      this.$el.style.top = top;
	    }
	  },
	  render: function render() {
	    return this.$slots.default;
	  }
	};

	/* script */
	const __vue_script__$1 = script$1;

	/* template */

	  /* style */
	  const __vue_inject_styles__$1 = undefined;
	  /* scoped */
	  const __vue_scope_id__$1 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$1 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$1 = undefined;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
	    {},
	    __vue_inject_styles__$1,
	    __vue_script__$1,
	    __vue_scope_id__$1,
	    __vue_is_functional_template__$1,
	    __vue_module_identifier__$1,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var script = {
	  name: 'Datepicker',
	  components: {
	    DateInput: __vue_component__$7,
	    PickerDay: __vue_component__$4,
	    PickerMonth: __vue_component__$3,
	    PickerYear: __vue_component__$2,
	    Popup: __vue_component__$1
	  },
	  mixins: [__vue_component__$8],
	  props: {
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	    calendarClass: {
	      type: [String, Object, Array],
	      default: ''
	    },
	    dayCellContent: {
	      type: Function,
	      default: function _default(day) {
	        return day.date;
	      }
	    },
	    disabledDates: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    firstDayOfWeek: {
	      type: String,
	      default: 'sun'
	    },
	    fixedPosition: {
	      type: String,
	      default: '',
	      validator: function validator(val) {
	        var possibleValues = ['', 'bottom', 'bottom-left', 'bottom-right', 'top', 'top-left', 'top-right'];
	        return possibleValues.includes(val);
	      }
	    },
	    fullMonthName: {
	      type: Boolean,
	      default: false
	    },
	    highlighted: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    initialView: {
	      type: String,
	      default: ''
	    },
	    language: {
	      type: Object,
	      default: function _default() {
	        return en;
	      }
	    },
	    maximumView: {
	      type: String,
	      default: 'year'
	    },
	    minimumView: {
	      type: String,
	      default: 'day'
	    },
	    showEdgeDates: {
	      type: Boolean,
	      default: true
	    },
	    showHeader: {
	      type: Boolean,
	      default: true
	    },
	    value: {
	      type: [String, Date, Number],
	      default: '',
	      validator: function validator(val) {
	        return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number';
	      }
	    },
	    wrapperClass: {
	      type: [String, Object, Array],
	      default: ''
	    },
	    yearPickerRange: {
	      type: Number,
	      default: 10
	    }
	  },
	  data: function data() {
	    var utils = makeDateUtils(this.useUtc);
	    var startDate = utils.getNewDateObject(this.openDate || null);
	    var pageTimestamp = utils.setDate(startDate, 1);
	    return {
	      calendarHeight: 0,
	      calendarSlots: calendarSlots,

	      /*
	       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
	       * This represents the first day of the current viewing month
	       * {Number}
	       */
	      pageTimestamp: pageTimestamp,
	      resetTypedDate: utils.getNewDateObject(),

	      /*
	       * Selected Date
	       * {Date}
	       */
	      selectedDate: null,
	      utils: utils,
	      view: ''
	    };
	  },
	  computed: {
	    allowedViews: function allowedViews() {
	      var _this = this;

	      var views = ['day', 'month', 'year'];
	      return views.filter(function (view) {
	        return _this.allowedToShowView(view);
	      });
	    },
	    computedInitialView: function computedInitialView() {
	      return this.initialView || this.minimumView;
	    },
	    isInline: function isInline() {
	      return !!this.inline;
	    },
	    isOpen: function isOpen() {
	      return this.view !== '';
	    },
	    isRtl: function isRtl() {
	      return this.translation.rtl;
	    },
	    isUpDisabled: function isUpDisabled() {
	      return !this.allowedToShowView(this.nextView.up);
	    },
	    nextView: function nextView() {
	      var _this2 = this;

	      var isCurrentView = function isCurrentView(view) {
	        return view === _this2.view;
	      };

	      var viewIndex = this.allowedViews.findIndex(isCurrentView);

	      var nextViewDown = function nextViewDown(index) {
	        return index <= 0 ? undefined : _this2.allowedViews[index - 1];
	      };

	      var nextViewUp = function nextViewUp(index) {
	        if (index < 0) {
	          return undefined;
	        }

	        if (index === _this2.allowedViews.length - 1) {
	          return 'decade';
	        }

	        return _this2.allowedViews[index + 1];
	      };

	      return {
	        up: nextViewUp(viewIndex),
	        down: nextViewDown(viewIndex)
	      };
	    },
	    pageDate: function pageDate() {
	      return new Date(this.pageTimestamp);
	    },
	    picker: function picker() {
	      var view = this.view || this.computedInitialView;
	      return "Picker".concat(this.ucFirst(view));
	    },
	    pickerClasses: function pickerClasses() {
	      return [this.calendarClass, this.isInline && 'inline', this.isRtl && this.appendToBody && 'rtl'];
	    },
	    translation: function translation() {
	      return this.language;
	    }
	  },
	  watch: {
	    initialView: function initialView() {
	      this.setInitialView();
	    },
	    openDate: function openDate() {
	      this.setPageDate();
	    },
	    value: function value(_value) {
	      var parsedValue = this.parseValue(_value);
	      this.setValue(parsedValue);
	    }
	  },
	  mounted: function mounted() {
	    this.init();
	  },
	  methods: {
	    /**
	     * Are we allowed to show a specific picker view?
	     * @param {String} view
	     * @return {Boolean}
	     */
	    allowedToShowView: function allowedToShowView(view) {
	      var views = ['day', 'month', 'year'];
	      var minimumViewIndex = views.indexOf(this.minimumView);
	      var maximumViewIndex = views.indexOf(this.maximumView);
	      var viewIndex = views.indexOf(view);
	      return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
	    },

	    /**
	     * Clear the selected date
	     */
	    clearDate: function clearDate() {
	      this.selectedDate = null;
	      this.setPageDate();
	      this.$emit('selected', null);
	      this.$emit('input', null);
	      this.$emit('cleared');
	    },

	    /**
	     * Close the calendar views
	     */
	    close: function close() {
	      if (!this.isInline) {
	        this.view = '';
	        this.$emit('closed');
	      }
	    },

	    /**
	     * Set the new pageDate and emit `changed-<view>` event
	     */
	    handlePageChange: function handlePageChange(pageDate) {
	      this.setPageDate(pageDate);
	      this.$emit("changed-".concat(this.nextView.up), pageDate);
	    },

	    /**
	     * Emits a 'blur' event
	     */
	    handleInputBlur: function handleInputBlur() {
	      this.$emit('blur');
	    },

	    /**
	     * Emits a 'focus' event
	     */
	    handleInputFocus: function handleInputFocus() {
	      this.$emit('focus');
	    },

	    /**
	     * Set the date, or go to the next view down
	     */
	    handleSelect: function handleSelect(cell) {
	      if (this.allowedToShowView(this.nextView.down)) {
	        this.setPageDate(new Date(cell.timestamp));
	        this.$emit("changed-".concat(this.view), cell);
	        this.setView(this.nextView.down);
	        return;
	      }

	      this.resetTypedDate = this.utils.getNewDateObject();
	      this.selectDate(cell.timestamp);
	      this.close();
	    },

	    /**
	     * Emit a 'selected-disabled' event
	     */
	    handleSelectDisabled: function handleSelectDisabled(cell) {
	      this.$emit('selected-disabled', cell);
	    },

	    /**
	     * Set the date from a 'typed-date' event
	     */
	    handleTypedDate: function handleTypedDate(date) {
	      this.selectDate(date.valueOf());
	    },

	    /**
	     * Initiate the component
	     */
	    init: function init() {
	      if (this.value) {
	        var parsedValue = this.parseValue(this.value);
	        var isDateDisabled = parsedValue && this.isDateDisabled(parsedValue);

	        if (isDateDisabled) {
	          parsedValue = null;
	          this.$emit('input', parsedValue);
	        }

	        this.setValue(parsedValue);
	      }

	      if (this.isInline) {
	        this.setInitialView();
	      }
	    },

	    /**
	     * Returns true if a date is disabled
	     * @param {Date} date
	     */
	    isDateDisabled: function isDateDisabled(date) {
	      return new DisabledDate(this.utils, this.disabledDates).isDateDisabled(date);
	    },

	    /**
	     * Opens the calendar with the relevant view: 'day', 'month', or 'year'
	     */
	    open: function open() {
	      if (this.disabled || this.isInline) {
	        return;
	      }

	      this.setInitialView();
	      this.$emit('opened');
	    },

	    /**
	     * Parse a datepicker value from string/number to date
	     * @param {Date|String|Number|null} date
	     */
	    parseValue: function parseValue(date) {
	      var dateTemp = date;

	      if (typeof dateTemp === 'string' || typeof dateTemp === 'number') {
	        var parsed = new Date(dateTemp);
	        dateTemp = Number.isNaN(parsed.valueOf()) ? null : parsed;
	      }

	      return dateTemp;
	    },

	    /**
	     * Called in the event that the user navigates to date pages and
	     * closes the picker without selecting a date.
	     */
	    resetDefaultPageDate: function resetDefaultPageDate() {
	      if (this.selectedDate === null) {
	        this.setPageDate();
	        return;
	      }

	      this.setPageDate(this.selectedDate);
	    },

	    /**
	     * Select the date
	     * @param {Number} timestamp
	     */
	    selectDate: function selectDate(timestamp) {
	      var date = new Date(timestamp);
	      this.selectedDate = date;
	      this.setPageDate(date);
	      this.$emit('selected', date);
	      this.$emit('input', date);
	    },

	    /**
	     * Sets the initial picker page view: day, month or year
	     */
	    setInitialView: function setInitialView() {
	      var initialView = this.computedInitialView;

	      if (!this.allowedToShowView(initialView)) {
	        throw new Error("initialView '".concat(this.initialView, "' cannot be rendered based on minimum '").concat(this.minimumView, "' and maximum '").concat(this.maximumView, "'"));
	      }

	      this.setView(initialView);
	    },

	    /**
	     * Sets the date that the calendar should open on
	     */
	    setPageDate: function setPageDate(date) {
	      var dateTemp = date;

	      if (!dateTemp) {
	        if (this.openDate) {
	          dateTemp = new Date(this.openDate);
	        } else {
	          dateTemp = new Date();
	        }

	        dateTemp = this.utils.resetDateTime(dateTemp);
	      }

	      this.pageTimestamp = this.utils.setDate(new Date(dateTemp), 1);
	    },

	    /**
	     * Set the datepicker value
	     * @param {Date|String|Number|null} date
	     */
	    setValue: function setValue(date) {
	      if (!date) {
	        this.setPageDate();
	        this.selectedDate = null;
	        return;
	      }

	      this.selectedDate = date;
	      this.setPageDate(date);
	    },

	    /**
	     * Set the picker view
	     */
	    setView: function setView(view) {
	      if (this.allowedToShowView(view)) {
	        this.view = view;
	      }
	    },

	    /**
	     * Capitalizes the first letter
	     */
	    ucFirst: function ucFirst(str) {
	      return str[0].toUpperCase() + str.substring(1);
	    }
	  }
	};

	/* script */
	const __vue_script__ = script;
	/* template */
	var __vue_render__ = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    {
	      staticClass: "vdp-datepicker",
	      class: [_vm.wrapperClass, { rtl: _vm.isRtl }]
	    },
	    [
	      _c(
	        "DateInput",
	        {
	          attrs: {
	            id: _vm.id,
	            autofocus: _vm.autofocus,
	            "bootstrap-styling": _vm.bootstrapStyling,
	            "calendar-button": _vm.calendarButton,
	            "calendar-button-icon": _vm.calendarButtonIcon,
	            "calendar-button-icon-content": _vm.calendarButtonIconContent,
	            "clear-button": _vm.clearButton,
	            "clear-button-icon": _vm.clearButtonIcon,
	            disabled: _vm.disabled,
	            format: _vm.format,
	            inline: _vm.inline,
	            "is-open": _vm.isOpen,
	            "input-class": _vm.inputClass,
	            maxlength: _vm.maxlength,
	            name: _vm.name,
	            parser: _vm.parser,
	            pattern: _vm.pattern,
	            placeholder: _vm.placeholder,
	            "ref-name": _vm.refName,
	            required: _vm.required,
	            "reset-typed-date": _vm.resetTypedDate,
	            "selected-date": _vm.selectedDate,
	            "show-calendar-on-button-click": _vm.showCalendarOnButtonClick,
	            "show-calendar-on-focus": _vm.showCalendarOnFocus,
	            tabindex: _vm.tabindex,
	            translation: _vm.translation,
	            typeable: _vm.typeable,
	            "use-utc": _vm.useUtc
	          },
	          on: {
	            blur: _vm.handleInputBlur,
	            "clear-date": _vm.clearDate,
	            close: _vm.close,
	            focus: _vm.handleInputFocus,
	            open: _vm.open,
	            "typed-date": _vm.handleTypedDate
	          }
	        },
	        [
	          _vm._t("beforeDateInput", null, { slot: "beforeDateInput" }),
	          _vm._v(" "),
	          _vm._t("afterDateInput", null, { slot: "afterDateInput" }),
	          _vm._v(" "),
	          _vm._t("clearBtn", null, { slot: "clearBtn" }),
	          _vm._v(" "),
	          _vm._t("calendarBtn", null, { slot: "calendarBtn" })
	        ],
	        2
	      ),
	      _vm._v(" "),
	      _c(
	        "Popup",
	        {
	          ref: "popup",
	          attrs: {
	            "append-to-body": _vm.appendToBody,
	            "fixed-position": _vm.fixedPosition,
	            inline: _vm.inline,
	            rtl: _vm.isRtl,
	            visible: _vm.isOpen
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.isOpen,
	                  expression: "isOpen"
	                }
	              ],
	              ref: "datepicker",
	              staticClass: "vdp-datepicker__calendar",
	              class: _vm.pickerClasses,
	              on: {
	                mousedown: function($event) {
	                  $event.preventDefault();
	                }
	              }
	            },
	            [
	              _vm._t("beforeCalendarHeader"),
	              _vm._v(" "),
	              _c(
	                _vm.picker,
	                {
	                  tag: "Component",
	                  attrs: {
	                    "day-cell-content": _vm.dayCellContent,
	                    "disabled-dates": _vm.disabledDates,
	                    "first-day-of-week": _vm.firstDayOfWeek,
	                    highlighted: _vm.highlighted,
	                    "is-rtl": _vm.isRtl,
	                    "is-up-disabled": _vm.isUpDisabled,
	                    "page-date": _vm.pageDate,
	                    "selected-date": _vm.selectedDate,
	                    "show-edge-dates": _vm.showEdgeDates,
	                    "show-full-month-name": _vm.fullMonthName,
	                    "show-header": _vm.showHeader,
	                    translation: _vm.translation,
	                    "use-utc": _vm.useUtc,
	                    "year-range": _vm.yearPickerRange
	                  },
	                  on: {
	                    "page-change": _vm.handlePageChange,
	                    select: _vm.handleSelect,
	                    "select-disabled": _vm.handleSelectDisabled,
	                    "set-view": _vm.setView
	                  },
	                  scopedSlots: _vm._u(
	                    [
	                      {
	                        key: "dayCellContent",
	                        fn: function(ref) {
	                          var cell = ref.cell;
	                          return [
	                            cell
	                              ? _vm._t("dayCellContent", null, { cell: cell })
	                              : _vm._e()
	                          ]
	                        }
	                      }
	                    ],
	                    null,
	                    true
	                  )
	                },
	                [
	                  _vm._l(_vm.calendarSlots, function(slotKey) {
	                    return [_vm._t(slotKey, null, { slot: slotKey })]
	                  })
	                ],
	                2
	              ),
	              _vm._v(" "),
	              _vm._t("calendarFooter")
	            ],
	            2
	          )
	        ]
	      )
	    ],
	    1
	  )
	};
	var __vue_staticRenderFns__ = [];
	__vue_render__._withStripped = true;

	  /* style */
	  const __vue_inject_styles__ = undefined;
	  /* scoped */
	  const __vue_scope_id__ = undefined;
	  /* module identifier */
	  const __vue_module_identifier__ = undefined;
	  /* functional template */
	  const __vue_is_functional_template__ = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__ = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
	    __vue_inject_styles__,
	    __vue_script__,
	    __vue_scope_id__,
	    __vue_is_functional_template__,
	    __vue_module_identifier__,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	return __vue_component__;

})));

});

var script$q = {
  name: 'TfDatepicker',
  components: {
    Datepicker: Datepicker$1
  },
  inheritAttrs: false,
  props: {
    format: {
      type: String,
      default: 'MM/dd/yy'
    },
    value: {
      type: [String, Date],
      default: ''
    },
    viewType: {
      type: String,
      default: 'day',
      validator: function validator(value) {
        return ['day', 'month'].includes(value);
      }
    }
  },
  computed: {
    /**
     * Set individual class names for styling purposes.
     *
     * @returns {object}
     */
    wrapperClass: function wrapperClass() {
      return {
        'tf-datepicker': true,
        'is-month-only': this.viewType === 'month',
        'is-day-only': this.viewType === 'day'
      };
    }
  }
};

/* script */
const __vue_script__$q = script$q;

/* template */
var __vue_render__$p = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "datepicker",
    _vm._g(
      _vm._b(
        {
          attrs: { "calendar-class": "tf-datepicker-container" },
          scopedSlots: _vm._u([
            {
              key: "dayCellContent",
              fn: function (ref) {
                var cell = ref.cell;
                return _c("span", {
                  staticClass: "custom-day",
                  attrs: { "data-test": "datepicker day " + cell.date },
                  domProps: { textContent: _vm._s(cell.date || "") },
                })
              },
            },
          ]),
        },
        "datepicker",
        Object.assign({}, _vm.$attrs, _vm.$props, {
          minimumView: _vm.viewType,
          maximumView: _vm.viewType,
          wrapperClass: _vm.wrapperClass,
        }),
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._v(" "),
      _c("TfButton", {
        attrs: {
          slot: "prevIntervalBtn",
          "data-test": "datepicker previous",
          icon: "angle-left",
          size: "icon-no-fill",
          type: "primary",
          "no-border": "",
        },
        slot: "prevIntervalBtn",
      }),
      _vm._v(" "),
      _c("TfButton", {
        attrs: {
          slot: "nextIntervalBtn",
          "data-test": "datepicker next",
          icon: "angle-right",
          size: "icon-no-fill",
          type: "primary",
          "no-border": "",
        },
        slot: "nextIntervalBtn",
      }),
    ],
    1
  )
};
var __vue_staticRenderFns__$p = [];
__vue_render__$p._withStripped = true;

  /* style */
  const __vue_inject_styles__$q = function (inject) {
    if (!inject) return
    inject("data-v-52556c65_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n[data-v-52556c65] input {\n  height: 30px;\n  border: 1px solid #c1c1c1;\n  border-radius: 2px;\n  color: #42474c;\n  padding: 0 10px;\n}\n\n/*# sourceMappingURL=TfDatepicker.vue.map */", map: {"version":3,"sources":["TfDatepicker.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfDatepicker.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC8ElC;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AD5EA;;AAEA,2CAA2C","file":"TfDatepicker.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n::v-deep input {\n  height: 30px;\n  border: 1px solid #c1c1c1;\n  border-radius: 2px;\n  color: #42474c;\n  padding: 0 10px;\n}\n\n/*# sourceMappingURL=TfDatepicker.vue.map */","<template>\n  <datepicker\n    v-bind=\"{\n      ...$attrs,\n      ...$props,\n      minimumView: viewType,\n      maximumView: viewType,\n      wrapperClass,\n    }\"\n    calendar-class=\"tf-datepicker-container\"\n    v-on=\"$listeners\"\n  >\n    <span\n      slot=\"dayCellContent\"\n      slot-scope=\"{ cell }\"\n      :data-test=\"`datepicker day ${cell.date}`\"\n      class=\"custom-day\"\n      v-text=\"cell.date || ''\"\n    />\n    <TfButton\n      slot=\"prevIntervalBtn\"\n      data-test=\"datepicker previous\"\n      icon=\"angle-left\"\n      size=\"icon-no-fill\"\n      type=\"primary\"\n      no-border\n    />\n    <TfButton\n      slot=\"nextIntervalBtn\"\n      data-test=\"datepicker next\"\n      icon=\"angle-right\"\n      size=\"icon-no-fill\"\n      type=\"primary\"\n      no-border\n    />\n  </datepicker>\n</template>\n<script>\n  import Datepicker from '@sum.cumo/vue-datepicker/dist/Datepicker';\n\n  export default {\n    name: 'TfDatepicker',\n    components: { Datepicker },\n    inheritAttrs: false,\n    props: {\n      format: {\n        type: String,\n        default: 'MM/dd/yy',\n      },\n      value: {\n        type: [String, Date],\n        default: '',\n      },\n      viewType: {\n        type: String,\n        default: 'day',\n        validator: (value) => ['day', 'month'].includes(value),\n      },\n    },\n    computed: {\n      /**\n       * Set individual class names for styling purposes.\n       *\n       * @returns {object}\n       */\n      wrapperClass() {\n        return {\n          'tf-datepicker': true,\n          'is-month-only': this.viewType === 'month',\n          'is-day-only': this.viewType === 'day',\n        };\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  ::v-deep {\n    input {\n      height: 30px;\n      border: 1px solid $tf-light-gray;\n      border-radius: 2px;\n      color: $tf-dark-gray;\n      padding: 0 10px;\n    }\n  }\n</style>\n\n<style lang=\"scss\">\n  // This is an unscoped style block to account for appendToBody:true for <TfDatepicker />\n  @import 'src/assets/styles/variables';\n\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-disable max-nesting-depth  */\n  .tf-datepicker-container.vdp-datepicker__calendar {\n    flex-direction: row;\n    justify-content: center;\n    box-shadow: none;\n    border-color: $tf-light-gray;\n    z-index: 2001;\n\n    .custom-day {\n      position: relative;\n      z-index: 2;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 31px;\n      height: 31px;\n      border: 1px solid transparent;\n      border-radius: 100%;\n\n      &:hover {\n        border-color: $tf-blue;\n        background: $tf-white;\n      }\n    }\n\n    div {\n      // Override all the cell data styles\n      .cell {\n        position: relative;\n        font-size: 12px;\n\n        &.day-header {\n          color: $tf-light-gray;\n        }\n\n        &.disabled {\n          color: $tf-light-gray;\n\n          >.custom-day:hover {\n            border: transparent;\n          }\n        }\n\n        &.selected,\n        &.selected:hover,\n        &.selected.highlighted,\n        &.highlight-start,\n        &.highlight-end {\n          background-color: transparent;\n\n          &.month,\n          .custom-day {\n            /* stylelint-disable declaration-no-important */\n            background-color: $tf-blue !important;\n            color: $tf-white !important;\n            /* stylelint-enable declaration-no-important */\n          }\n        }\n\n        &.highlighted {\n          background-color: transparent;\n\n          &:after {\n            position: absolute;\n            height: 27px;\n            top: calc(50% - 18px);\n            left: -1px;\n            right: -1px;\n            background-color: $tf-light-blue;\n            content: '';\n          }\n\n          &.highlight-end:after {\n            right: 50%;\n          }\n\n          &.highlight-start:after {\n            left: 50%;\n          }\n        }\n\n        &.month {\n          display: flex;\n          align-content: center;\n          justify-content: center;\n          width: 166px;\n          height: inherit;\n          margin: 6px 10px;\n          padding: 4px 0;\n\n          font: {\n            size: 14px;\n            weight: 700;\n          }\n\n          color: $tf-blue;\n          line-height: inherit;\n          border-color: $tf-blue;\n        }\n\n        &.muted:not(.disabled):hover {\n          border-color: transparent;\n        }\n      }\n\n      .day:not(.muted):not(.disabled):hover {\n        border-color: transparent;\n      }\n\n      &:not(.muted):not(.disabled) {\n        .month:hover,\n        .year:hover {\n          /* stylelint-disable declaration-no-important  */\n          border-color: $tf-dark-blue !important;\n          /* stylelint-enable declaration-no-important  */\n        }\n      }\n    }\n\n    .picker-view {\n      > div {\n        display: flex;\n        flex-flow: row wrap;\n        justify-content: space-between;\n        width: 100%;\n      }\n\n      header {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding: 10px 0;\n        line-height: 1;\n        color: $tf-dark-blue;\n\n        span {\n          display: flex;\n          float: none;\n          width: auto;\n        }\n\n        .is-month-only &,\n        .month__year_btn {\n          justify-content: center;\n        }\n\n        .day__month_btn {\n          flex: 2;\n          margin: auto;\n          justify-content: center;\n          font-weight: 700;\n          color: $tf-blue;\n        }\n\n        .is-day-only & {\n          justify-content: space-between;\n        }\n\n        .month__year_btn {\n          margin: 0 10px;\n        }\n\n        .next,\n        .prev {\n          &:not(.disabled):hover {\n            background: transparent;\n          }\n\n          &:after {\n            display: none;\n          }\n        }\n\n        .next .tf-button {\n          margin-left: auto;\n        }\n\n        .prev .tf-button {\n          margin-right: auto;\n        }\n      }\n    }\n\n    .is-month-only & {\n      width: 380px;\n    }\n\n    &,\n    header {\n      display: flex;\n    }\n\n    span.today {\n      background: transparent;\n      font-weight: 700;\n    }\n  }\n</style>\n"]}, media: undefined })
,inject("data-v-52556c65_1", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/* stylelint-disable selector-max-compound-selectors */\n/* stylelint-disable max-nesting-depth  */\n.tf-datepicker-container.vdp-datepicker__calendar {\n  flex-direction: row;\n  justify-content: center;\n  box-shadow: none;\n  border-color: #c1c1c1;\n  z-index: 2001;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .custom-day {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  border: 1px solid transparent;\n  border-radius: 100%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .custom-day:hover {\n  border-color: #009;\n  background: #fff;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell {\n  position: relative;\n  font-size: 12px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.day-header {\n  color: #c1c1c1;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.disabled {\n  color: #c1c1c1;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.disabled > .custom-day:hover {\n  border: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end {\n  background-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end .custom-day {\n  /* stylelint-disable declaration-no-important */\n  background-color: #009 !important;\n  color: #fff !important;\n  /* stylelint-enable declaration-no-important */\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted {\n  background-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted:after {\n  position: absolute;\n  height: 27px;\n  top: calc(50% - 18px);\n  left: -1px;\n  right: -1px;\n  background-color: #eff3fd;\n  content: \"\";\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted.highlight-end:after {\n  right: 50%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted.highlight-start:after {\n  left: 50%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.month {\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  width: 166px;\n  height: inherit;\n  margin: 6px 10px;\n  padding: 4px 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #009;\n  line-height: inherit;\n  border-color: #009;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.muted:not(.disabled):hover {\n  border-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .day:not(.muted):not(.disabled):hover {\n  border-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div:not(.muted):not(.disabled) .month:hover,\n.tf-datepicker-container.vdp-datepicker__calendar div:not(.muted):not(.disabled) .year:hover {\n  /* stylelint-disable declaration-no-important  */\n  border-color: #006 !important;\n  /* stylelint-enable declaration-no-important  */\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view > div {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  width: 100%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 10px 0;\n  line-height: 1;\n  color: #006;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header span {\n  display: flex;\n  float: none;\n  width: auto;\n}\n.is-month-only .tf-datepicker-container.vdp-datepicker__calendar .picker-view header,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .month__year_btn {\n  justify-content: center;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .day__month_btn {\n  flex: 2;\n  margin: auto;\n  justify-content: center;\n  font-weight: 700;\n  color: #009;\n}\n.is-day-only .tf-datepicker-container.vdp-datepicker__calendar .picker-view header {\n  justify-content: space-between;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .month__year_btn {\n  margin: 0 10px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next:not(.disabled):hover,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev:not(.disabled):hover {\n  background: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next:after,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev:after {\n  display: none;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next .tf-button {\n  margin-left: auto;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev .tf-button {\n  margin-right: auto;\n}\n.is-month-only .tf-datepicker-container.vdp-datepicker__calendar {\n  width: 380px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar,\n.tf-datepicker-container.vdp-datepicker__calendar header {\n  display: flex;\n}\n.tf-datepicker-container.vdp-datepicker__calendar span.today {\n  background: transparent;\n  font-weight: 700;\n}\n\n/*# sourceMappingURL=TfDatepicker.vue.map */", map: {"version":3,"sources":["TfDatepicker.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfDatepicker.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC4FlC,sDAAA;AACA,yCAAA;AACA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;AD1FA;AC4FA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;AD1FA;AC4FA;EACA,kBAAA;EACA,gBAAA;AD1FA;ACgGA;EACA,kBAAA;EACA,eAAA;AD9FA;ACgGA;EACA,cAAA;AD9FA;ACiGA;EACA,cAAA;AD/FA;ACiGA;EACA,mBAAA;AD/FA;ACmGA;EAKA,6BAAA;ADrGA;ACuGA;;;;;;EAEA,+CAAA;EACA,iCAAA;EACA,sBAAA;EACA,8CAAA;ADjGA;ACqGA;EACA,6BAAA;ADnGA;ACqGA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;ADnGA;ACsGA;EACA,UAAA;ADpGA;ACuGA;EACA,SAAA;ADrGA;ACyGA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAGA,eAAA;EACA,gBAAA;EAGA,WAAA;EACA,oBAAA;EACA,kBAAA;AD3GA;AC8GA;EACA,yBAAA;AD5GA;ACgHA;EACA,yBAAA;AD9GA;ACkHA;;EAEA,gDAAA;EACA,6BAAA;EACA,+CAAA;ADhHA;ACsHA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;ADpHA;ACuHA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;ADrHA;ACuHA;EACA,aAAA;EACA,WAAA;EACA,WAAA;ADrHA;ACwHA;;EAEA,uBAAA;ADtHA;ACyHA;EACA,OAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;ADvHA;AC0HA;EACA,8BAAA;ADxHA;AC2HA;EACA,cAAA;ADzHA;AC8HA;;EACA,uBAAA;AD3HA;AC8HA;;EACA,aAAA;AD3HA;AC+HA;EACA,iBAAA;AD7HA;ACgIA;EACA,kBAAA;AD9HA;ACmIA;EACA,YAAA;ADjIA;ACoIA;;EAEA,aAAA;ADlIA;ACqIA;EACA,uBAAA;EACA,gBAAA;ADnIA;;AAEA,2CAA2C","file":"TfDatepicker.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/* stylelint-disable selector-max-compound-selectors */\n/* stylelint-disable max-nesting-depth  */\n.tf-datepicker-container.vdp-datepicker__calendar {\n  flex-direction: row;\n  justify-content: center;\n  box-shadow: none;\n  border-color: #c1c1c1;\n  z-index: 2001;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .custom-day {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  border: 1px solid transparent;\n  border-radius: 100%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .custom-day:hover {\n  border-color: #009;\n  background: #fff;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell {\n  position: relative;\n  font-size: 12px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.day-header {\n  color: #c1c1c1;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.disabled {\n  color: #c1c1c1;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.disabled > .custom-day:hover {\n  border: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end {\n  background-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end .custom-day {\n  /* stylelint-disable declaration-no-important */\n  background-color: #009 !important;\n  color: #fff !important;\n  /* stylelint-enable declaration-no-important */\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted {\n  background-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted:after {\n  position: absolute;\n  height: 27px;\n  top: calc(50% - 18px);\n  left: -1px;\n  right: -1px;\n  background-color: #eff3fd;\n  content: \"\";\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted.highlight-end:after {\n  right: 50%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted.highlight-start:after {\n  left: 50%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.month {\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  width: 166px;\n  height: inherit;\n  margin: 6px 10px;\n  padding: 4px 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #009;\n  line-height: inherit;\n  border-color: #009;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.muted:not(.disabled):hover {\n  border-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .day:not(.muted):not(.disabled):hover {\n  border-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div:not(.muted):not(.disabled) .month:hover,\n.tf-datepicker-container.vdp-datepicker__calendar div:not(.muted):not(.disabled) .year:hover {\n  /* stylelint-disable declaration-no-important  */\n  border-color: #006 !important;\n  /* stylelint-enable declaration-no-important  */\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view > div {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  width: 100%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 10px 0;\n  line-height: 1;\n  color: #006;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header span {\n  display: flex;\n  float: none;\n  width: auto;\n}\n.is-month-only .tf-datepicker-container.vdp-datepicker__calendar .picker-view header,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .month__year_btn {\n  justify-content: center;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .day__month_btn {\n  flex: 2;\n  margin: auto;\n  justify-content: center;\n  font-weight: 700;\n  color: #009;\n}\n.is-day-only .tf-datepicker-container.vdp-datepicker__calendar .picker-view header {\n  justify-content: space-between;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .month__year_btn {\n  margin: 0 10px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next:not(.disabled):hover,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev:not(.disabled):hover {\n  background: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next:after,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev:after {\n  display: none;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next .tf-button {\n  margin-left: auto;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev .tf-button {\n  margin-right: auto;\n}\n.is-month-only .tf-datepicker-container.vdp-datepicker__calendar {\n  width: 380px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar,\n.tf-datepicker-container.vdp-datepicker__calendar header {\n  display: flex;\n}\n.tf-datepicker-container.vdp-datepicker__calendar span.today {\n  background: transparent;\n  font-weight: 700;\n}\n\n/*# sourceMappingURL=TfDatepicker.vue.map */","<template>\n  <datepicker\n    v-bind=\"{\n      ...$attrs,\n      ...$props,\n      minimumView: viewType,\n      maximumView: viewType,\n      wrapperClass,\n    }\"\n    calendar-class=\"tf-datepicker-container\"\n    v-on=\"$listeners\"\n  >\n    <span\n      slot=\"dayCellContent\"\n      slot-scope=\"{ cell }\"\n      :data-test=\"`datepicker day ${cell.date}`\"\n      class=\"custom-day\"\n      v-text=\"cell.date || ''\"\n    />\n    <TfButton\n      slot=\"prevIntervalBtn\"\n      data-test=\"datepicker previous\"\n      icon=\"angle-left\"\n      size=\"icon-no-fill\"\n      type=\"primary\"\n      no-border\n    />\n    <TfButton\n      slot=\"nextIntervalBtn\"\n      data-test=\"datepicker next\"\n      icon=\"angle-right\"\n      size=\"icon-no-fill\"\n      type=\"primary\"\n      no-border\n    />\n  </datepicker>\n</template>\n<script>\n  import Datepicker from '@sum.cumo/vue-datepicker/dist/Datepicker';\n\n  export default {\n    name: 'TfDatepicker',\n    components: { Datepicker },\n    inheritAttrs: false,\n    props: {\n      format: {\n        type: String,\n        default: 'MM/dd/yy',\n      },\n      value: {\n        type: [String, Date],\n        default: '',\n      },\n      viewType: {\n        type: String,\n        default: 'day',\n        validator: (value) => ['day', 'month'].includes(value),\n      },\n    },\n    computed: {\n      /**\n       * Set individual class names for styling purposes.\n       *\n       * @returns {object}\n       */\n      wrapperClass() {\n        return {\n          'tf-datepicker': true,\n          'is-month-only': this.viewType === 'month',\n          'is-day-only': this.viewType === 'day',\n        };\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  ::v-deep {\n    input {\n      height: 30px;\n      border: 1px solid $tf-light-gray;\n      border-radius: 2px;\n      color: $tf-dark-gray;\n      padding: 0 10px;\n    }\n  }\n</style>\n\n<style lang=\"scss\">\n  // This is an unscoped style block to account for appendToBody:true for <TfDatepicker />\n  @import 'src/assets/styles/variables';\n\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-disable max-nesting-depth  */\n  .tf-datepicker-container.vdp-datepicker__calendar {\n    flex-direction: row;\n    justify-content: center;\n    box-shadow: none;\n    border-color: $tf-light-gray;\n    z-index: 2001;\n\n    .custom-day {\n      position: relative;\n      z-index: 2;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 31px;\n      height: 31px;\n      border: 1px solid transparent;\n      border-radius: 100%;\n\n      &:hover {\n        border-color: $tf-blue;\n        background: $tf-white;\n      }\n    }\n\n    div {\n      // Override all the cell data styles\n      .cell {\n        position: relative;\n        font-size: 12px;\n\n        &.day-header {\n          color: $tf-light-gray;\n        }\n\n        &.disabled {\n          color: $tf-light-gray;\n\n          >.custom-day:hover {\n            border: transparent;\n          }\n        }\n\n        &.selected,\n        &.selected:hover,\n        &.selected.highlighted,\n        &.highlight-start,\n        &.highlight-end {\n          background-color: transparent;\n\n          &.month,\n          .custom-day {\n            /* stylelint-disable declaration-no-important */\n            background-color: $tf-blue !important;\n            color: $tf-white !important;\n            /* stylelint-enable declaration-no-important */\n          }\n        }\n\n        &.highlighted {\n          background-color: transparent;\n\n          &:after {\n            position: absolute;\n            height: 27px;\n            top: calc(50% - 18px);\n            left: -1px;\n            right: -1px;\n            background-color: $tf-light-blue;\n            content: '';\n          }\n\n          &.highlight-end:after {\n            right: 50%;\n          }\n\n          &.highlight-start:after {\n            left: 50%;\n          }\n        }\n\n        &.month {\n          display: flex;\n          align-content: center;\n          justify-content: center;\n          width: 166px;\n          height: inherit;\n          margin: 6px 10px;\n          padding: 4px 0;\n\n          font: {\n            size: 14px;\n            weight: 700;\n          }\n\n          color: $tf-blue;\n          line-height: inherit;\n          border-color: $tf-blue;\n        }\n\n        &.muted:not(.disabled):hover {\n          border-color: transparent;\n        }\n      }\n\n      .day:not(.muted):not(.disabled):hover {\n        border-color: transparent;\n      }\n\n      &:not(.muted):not(.disabled) {\n        .month:hover,\n        .year:hover {\n          /* stylelint-disable declaration-no-important  */\n          border-color: $tf-dark-blue !important;\n          /* stylelint-enable declaration-no-important  */\n        }\n      }\n    }\n\n    .picker-view {\n      > div {\n        display: flex;\n        flex-flow: row wrap;\n        justify-content: space-between;\n        width: 100%;\n      }\n\n      header {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding: 10px 0;\n        line-height: 1;\n        color: $tf-dark-blue;\n\n        span {\n          display: flex;\n          float: none;\n          width: auto;\n        }\n\n        .is-month-only &,\n        .month__year_btn {\n          justify-content: center;\n        }\n\n        .day__month_btn {\n          flex: 2;\n          margin: auto;\n          justify-content: center;\n          font-weight: 700;\n          color: $tf-blue;\n        }\n\n        .is-day-only & {\n          justify-content: space-between;\n        }\n\n        .month__year_btn {\n          margin: 0 10px;\n        }\n\n        .next,\n        .prev {\n          &:not(.disabled):hover {\n            background: transparent;\n          }\n\n          &:after {\n            display: none;\n          }\n        }\n\n        .next .tf-button {\n          margin-left: auto;\n        }\n\n        .prev .tf-button {\n          margin-right: auto;\n        }\n      }\n    }\n\n    .is-month-only & {\n      width: 380px;\n    }\n\n    &,\n    header {\n      display: flex;\n    }\n\n    span.today {\n      background: transparent;\n      font-weight: 700;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$q = "data-v-52556c65";
  /* module identifier */
  const __vue_module_identifier__$q = undefined;
  /* functional template */
  const __vue_is_functional_template__$q = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$q = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$p, staticRenderFns: __vue_staticRenderFns__$p },
    __vue_inject_styles__$q,
    __vue_script__$q,
    __vue_scope_id__$q,
    __vue_is_functional_template__$q,
    __vue_module_identifier__$q,
    false,
    browser,
    undefined,
    undefined
  );

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

var $find$1 = _arrayMethods(6);
var KEY$1 = 'findIndex';
var forced$1 = true;
// Shouldn't skip holes
if (KEY$1 in []) Array(1)[KEY$1](function () { forced$1 = false; });
_export(_export.P + _export.F * forced$1, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY$1);

function _arrayWithHoles(arr) {
  if (isArray$2(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof symbol$1 !== "undefined" && arr[iterator$1] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var script$r = {
  name: 'TfFilterDateRange',
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      datepickerOptions: {
        inline: true,
        maximumView: 'day',
        minimumView: 'day'
      },
      localSelectedDate: {
        end: '',
        start: ''
      },
      openDate: null,
      selectedValueType: 'from'
    };
  },
  computed: {
    /**
     * Create an object with 'from' and 'to' based on the model value.
     * 'from' and 'to' should be dates or empty strings.
     *
     * @returns {object}
     */
    highlighted: function highlighted() {
      var _ref = this.value || ['', ''],
        _ref2 = _slicedToArray(_ref, 2),
        from = _ref2[0],
        to = _ref2[1];
      var resetTime = function resetTime(value) {
        // when dates come through as strings we convert back to date or setHours doesnt exist
        var validatedDate = value instanceof Date ? value : new Date(value);
        return new Date(validatedDate.setHours(0, 0, 0, 0));
      };
      return {
        from: from ? resetTime(from) : '',
        to: to ? resetTime(to) : ''
      };
    },
    /**
     * Format 'from' and 'to' from this.highlighted into date strings for the input values.
     * 'from' and 'to' should be formatted strings or empty strings.
     *
     * @returns {object}
     */
    inputValues: function inputValues() {
      var _this = this;
      var _this$highlighted = this.highlighted,
        from = _this$highlighted.from,
        to = _this$highlighted.to;
      var format = function format(value) {
        return _this.$TF.DatesUtils.formatSimpleDate(value, 'MM/DD/YY');
      };
      return {
        from: from ? format(from) : '',
        to: to ? format(to) : ''
      };
    },
    /**
     * Add one month to this.openDate and format it to a string.
     *
     * @returns {string}
     */
    openToDate: function openToDate() {
      return new Date(moment(this.openDate).add(1, 'months'));
    }
  },
  created: function created() {
    var openDate = this.highlighted.from ? new Date(this.highlighted.from) : new Date();
    this.openDate = openDate;
  },
  methods: {
    /**
     * Subtract or add 2 months to this.openDate based on the passed param.
     *
     * @param {string} calendarType
     */
    changeMonth: function changeMonth(calendarType) {
      var openDate = moment(this.openDate);
      if (calendarType === 'start') {
        openDate = openDate.subtract(2, 'months');
      } else if (calendarType === 'end') {
        openDate = openDate.add(2, 'months');
      }
      this.openDate = new Date(openDate);
    },
    /**
     * Changes the open date and to today's date, sets the 'from' value to today's date, and focuses on the 'to' input.
     */
    changeToToday: function changeToToday() {
      var openDate = new Date();
      this.openDate = openDate;
      this.selectedValueType = 'to';
      this.localSelectedDate.start = openDate;
      this.localSelectedDate.end = '';
      this.$emit('input', [openDate, '']);
    },
    /**
     * Focus on the first checkbox.
     *
     * @param {string} value
     */
    focusInput: function focusInput(value) {
      this.selectedValueType = value;
      this.$refs["input-".concat(value)][0].$el.querySelector('input').blur();
    },
    /**
     * $emit 'input' with new "from" and "to" dates.
     * Update this.selectedValueType based on different scenarios.
     * Clear the localSelectedDate start and end values as well,
     * followed by setting the selected value for that calendar appropriately.
     * This is to hack some of the logic for the datepicker component.
     *
     * @param {object} value
     * @param {string} calendarType
     */
    selectDate: function selectDate(value, calendarType) {
      var _this$highlighted2 = this.highlighted,
        from = _this$highlighted2.from,
        to = _this$highlighted2.to;
      var selectedValueType;
      this.localSelectedDate.start = '';
      this.localSelectedDate.end = '';
      if (this.selectedValueType === 'from') {
        from = value;
        selectedValueType = 'to';
        if (to && moment(value).isSameOrAfter(to)) {
          to = value;
        }
      } else if (this.selectedValueType === 'to') {
        selectedValueType = 'from';
        to = value;
        if (from && moment(value).isSameOrBefore(from)) {
          from = value;
          selectedValueType = 'to';
        }
      }
      this.localSelectedDate[calendarType] = value;
      this.$emit('input', [from, to]);
      this.selectedValueType = selectedValueType;
    }
  }
};

/* script */
const __vue_script__$r = script$r;

/* template */
var __vue_render__$q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "filter-date-range-container" },
    [
      _c(
        "ElForm",
        { attrs: { "label-position": "top" } },
        _vm._l(["from", "to"], function (input) {
          return _c(
            "ElFormItem",
            { key: input, attrs: { for: input, label: input } },
            [
              _c(
                "ElInput",
                {
                  ref: "input-" + input,
                  refInFor: true,
                  class: { "is-active": _vm.selectedValueType === input },
                  attrs: {
                    "data-test": "filter date range edit " + input,
                    value: _vm.inputValues[input],
                    readonly: "",
                    placeholder: "Select Date",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.focusInput(input)
                    },
                  },
                },
                [
                  _c("icon", {
                    attrs: { slot: "prefix", name: "regular/calendar-alt" },
                    slot: "prefix",
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm._l(["start", "end"], function (calendarType) {
        return _c(
          "div",
          { key: calendarType, class: "calendar-" + calendarType },
          [
            _c(
              "TfDatepicker",
              _vm._b(
                {
                  attrs: {
                    "data-test":
                      "filter date range " + calendarType + " calendar",
                  },
                  on: {
                    "changed-decade": function ($event) {
                      return _vm.changeMonth(calendarType)
                    },
                    "changed-month": function ($event) {
                      return _vm.changeMonth(calendarType)
                    },
                    selected: function ($event) {
                      return _vm.selectDate($event, calendarType)
                    },
                  },
                },
                "TfDatepicker",
                Object.assign({}, _vm.datepickerOptions, {
                  highlighted: _vm.highlighted,
                  openDate:
                    calendarType === "start" ? _vm.openDate : _vm.openToDate,
                  value: _vm.localSelectedDate[calendarType],
                  showEdgeDates: false,
                }),
                false
              )
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("TfButton", {
        staticClass: "btn-to-current",
        attrs: {
          type: "primary",
          size: "text-small",
          "data-test": "filter date range select to today",
        },
        domProps: { textContent: _vm._s("Back to Today") },
        on: { click: _vm.changeToToday },
      }),
    ],
    2
  )
};
var __vue_staticRenderFns__$q = [];
__vue_render__$q._withStripped = true;

  /* style */
  const __vue_inject_styles__$r = function (inject) {
    if (!inject) return
    inject("data-v-1ee01348_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.btn-to-current[data-v-1ee01348] {\n  margin: 10px 0 20px;\n}\n\n/* stylelint-disable selector-max-compound-selectors */\n.calendar-start[data-v-1ee01348] {\n  margin-right: 75px;\n}\n.calendar-start[data-v-1ee01348]  header .next {\n  display: none !important;\n}\n.calendar-start[data-v-1ee01348]  header .prev {\n  flex: 1;\n}\n.calendar-start[data-v-1ee01348]  header:after {\n  flex: 1;\n  content: \"\";\n}\n.calendar-end[data-v-1ee01348]  header .next {\n  flex: 1;\n}\n.calendar-end[data-v-1ee01348]  header .prev {\n  display: none !important;\n}\n.calendar-end[data-v-1ee01348]  header:before {\n  flex: 1;\n  content: \"\";\n}\n\n/* stylelint-enable selector-max-compound-selectors */\nform[data-v-1ee01348],\n.el-input[data-v-1ee01348] {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n.el-form-item[data-v-1ee01348] {\n  margin-bottom: 10px;\n}\n[data-v-1ee01348] .el-form-item__label {\n  text-transform: capitalize;\n  font-weight: 600;\n  line-height: inherit;\n}\n.filter-date-range-container[data-v-1ee01348] {\n  display: flex;\n  flex-flow: wrap;\n  width: 675px;\n  padding: 10px 20px;\n}\n[data-v-1ee01348] .el-input {\n  width: 120px;\n  margin-right: 20px;\n}\n[data-v-1ee01348] .el-input__prefix {\n  top: 6px;\n}\n[data-v-1ee01348] .el-input__inner:focus {\n  border-color: inherit;\n}\n\n/*# sourceMappingURL=DateRange.vue.map */", map: {"version":3,"sources":["DateRange.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfFilter/DateRange.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACkNlC;EACA,mBAAA;ADhNA;;ACmNA,sDAAA;AACA;EACA,kBAAA;ADhNA;ACmNA;EACA,wBAAA;ADjNA;ACoNA;EACA,OAAA;ADlNA;ACqNA;EACA,OAAA;EACA,WAAA;ADnNA;AC0NA;EACA,OAAA;ADvNA;AC0NA;EACA,wBAAA;ADxNA;AC2NA;EACA,OAAA;EACA,WAAA;ADzNA;;AC6NA,qDAAA;AACA;;EAEA,aAAA;EACA,mBAAA;EACA,WAAA;AD1NA;AC6NA;EACA,mBAAA;AD1NA;AC4NA;EACA,0BAAA;EACA,gBAAA;EACA,oBAAA;AD1NA;AC8NA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AD3NA;AC8NA;EACA,YAAA;EACA,kBAAA;AD3NA;AC6NA;EACA,QAAA;AD3NA;AC8NA;EACA,qBAAA;AD5NA;;AAEA,wCAAwC","file":"DateRange.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.btn-to-current {\n  margin: 10px 0 20px;\n}\n\n/* stylelint-disable selector-max-compound-selectors */\n.calendar-start {\n  margin-right: 75px;\n}\n.calendar-start ::v-deep header .next {\n  display: none !important;\n}\n.calendar-start ::v-deep header .prev {\n  flex: 1;\n}\n.calendar-start ::v-deep header:after {\n  flex: 1;\n  content: \"\";\n}\n\n.calendar-end ::v-deep header .next {\n  flex: 1;\n}\n.calendar-end ::v-deep header .prev {\n  display: none !important;\n}\n.calendar-end ::v-deep header:before {\n  flex: 1;\n  content: \"\";\n}\n\n/* stylelint-enable selector-max-compound-selectors */\nform,\n.el-input {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.el-form-item {\n  margin-bottom: 10px;\n}\n::v-deep .el-form-item__label {\n  text-transform: capitalize;\n  font-weight: 600;\n  line-height: inherit;\n}\n\n.filter-date-range-container {\n  display: flex;\n  flex-flow: wrap;\n  width: 675px;\n  padding: 10px 20px;\n}\n\n::v-deep .el-input {\n  width: 120px;\n  margin-right: 20px;\n}\n::v-deep .el-input__prefix {\n  top: 6px;\n}\n::v-deep .el-input__inner:focus {\n  border-color: inherit;\n}\n\n/*# sourceMappingURL=DateRange.vue.map */","<template>\n  <div class=\"filter-date-range-container\">\n    <ElForm label-position=\"top\">\n      <ElFormItem\n        v-for=\"input in [ 'from', 'to' ]\"\n        :key=\"input\"\n        :for=\"input\"\n        :label=\"input\"\n      >\n        <ElInput\n          :ref=\"`input-${input}`\"\n          :class=\"{ 'is-active': selectedValueType === input }\"\n          :data-test=\"`filter date range edit ${input}`\"\n          :value=\"inputValues[input]\"\n          readonly\n          placeholder=\"Select Date\"\n          @focus=\"focusInput(input)\"\n        >\n          <icon\n            slot=\"prefix\"\n            name=\"regular/calendar-alt\"\n          />\n        </ElInput>\n      </ElFormItem>\n    </ElForm>\n    <div\n      v-for=\"calendarType in [ 'start', 'end' ]\"\n      :key=\"calendarType\"\n      :class=\"`calendar-${calendarType}`\"\n    >\n      <!-- Temporarily watching the @changed-decade event because of a Datepicker bug -->\n      <!-- Follow bug at: https://github.com/sumcumo/vue-datepicker/issues/121 -->\n      <TfDatepicker\n        v-bind=\"{\n          ...datepickerOptions,\n          highlighted,\n          openDate: calendarType === 'start' ? openDate : openToDate,\n          value: localSelectedDate[calendarType],\n          showEdgeDates: false,\n        }\"\n        :data-test=\"`filter date range ${calendarType} calendar`\"\n        @changed-decade=\"changeMonth(calendarType)\"\n        @changed-month=\"changeMonth(calendarType)\"\n        @selected=\"selectDate($event, calendarType)\"\n      />\n    </div>\n    <TfButton\n      class=\"btn-to-current\"\n      type=\"primary\"\n      size=\"text-small\"\n      :data-test=\"`filter date range select to today`\"\n      @click=\"changeToToday\"\n      v-text=\"'Back to Today'\"\n    />\n  </div>\n</template>\n<script>\n  import moment from 'moment';\n\n  export default {\n    name: 'TfFilterDateRange',\n    props: {\n      value: {\n        type: Array,\n        required: true,\n      },\n    },\n    data: () => ({\n      datepickerOptions: {\n        inline: true,\n        maximumView: 'day',\n        minimumView: 'day',\n      },\n      localSelectedDate: {\n        end: '',\n        start: '',\n      },\n      openDate: null,\n      selectedValueType: 'from',\n    }),\n    computed: {\n      /**\n       * Create an object with 'from' and 'to' based on the model value.\n       * 'from' and 'to' should be dates or empty strings.\n       *\n       * @returns {object}\n       */\n      highlighted() {\n        const [from, to] = this.value || ['', ''];\n        const resetTime = (value) => {\n          // when dates come through as strings we convert back to date or setHours doesnt exist\n          const validatedDate = value instanceof Date ? value : new Date(value);\n          return new Date(validatedDate.setHours(0, 0, 0, 0));\n        };\n\n        return {\n          from: from ? resetTime(from) : '',\n          to: to ? resetTime(to) : '',\n        };\n      },\n      /**\n       * Format 'from' and 'to' from this.highlighted into date strings for the input values.\n       * 'from' and 'to' should be formatted strings or empty strings.\n       *\n       * @returns {object}\n       */\n      inputValues() {\n        const { from, to } = this.highlighted;\n        const format = (value) => this.$TF.DatesUtils.formatSimpleDate(value, 'MM/DD/YY');\n\n        return {\n          from: from ? format(from) : '',\n          to: to ? format(to) : '',\n        };\n      },\n      /**\n       * Add one month to this.openDate and format it to a string.\n       *\n       * @returns {string}\n       */\n      openToDate() {\n        return new Date(moment(this.openDate).add(1, 'months'));\n      },\n    },\n    created() {\n      const openDate = this.highlighted.from ? new Date(this.highlighted.from) : new Date();\n\n      this.openDate = openDate;\n    },\n    methods: {\n      /**\n       * Subtract or add 2 months to this.openDate based on the passed param.\n       *\n       * @param {string} calendarType\n       */\n      changeMonth(calendarType) {\n        let openDate = moment(this.openDate);\n\n        if (calendarType === 'start') {\n          openDate = openDate.subtract(2, 'months');\n        } else if (calendarType === 'end') {\n          openDate = openDate.add(2, 'months');\n        }\n\n        this.openDate = new Date(openDate);\n      },\n      /**\n       * Changes the open date and to today's date, sets the 'from' value to today's date, and focuses on the 'to' input.\n       */\n      changeToToday() {\n        const openDate = new Date();\n\n        this.openDate = openDate;\n        this.selectedValueType = 'to';\n        this.localSelectedDate.start = openDate;\n        this.localSelectedDate.end = '';\n        this.$emit('input', [openDate, '']);\n      },\n      /**\n       * Focus on the first checkbox.\n       *\n       * @param {string} value\n       */\n      focusInput(value) {\n        this.selectedValueType = value;\n        this.$refs[`input-${value}`][0].$el.querySelector('input').blur();\n      },\n      /**\n       * $emit 'input' with new \"from\" and \"to\" dates.\n       * Update this.selectedValueType based on different scenarios.\n       * Clear the localSelectedDate start and end values as well,\n       * followed by setting the selected value for that calendar appropriately.\n       * This is to hack some of the logic for the datepicker component.\n       *\n       * @param {object} value\n       * @param {string} calendarType\n       */\n      selectDate(value, calendarType) {\n        let { from, to } = this.highlighted;\n        let selectedValueType;\n\n        this.localSelectedDate.start = '';\n        this.localSelectedDate.end = '';\n\n        if (this.selectedValueType === 'from') {\n          from = value;\n          selectedValueType = 'to';\n\n          if (to && moment(value).isSameOrAfter(to)) {\n            to = value;\n          }\n        } else if (this.selectedValueType === 'to') {\n          selectedValueType = 'from';\n          to = value;\n\n          if (from && moment(value).isSameOrBefore(from)) {\n            from = value;\n            selectedValueType = 'to';\n          }\n        }\n\n        this.localSelectedDate[calendarType] = value;\n        this.$emit('input', [from, to]);\n        this.selectedValueType = selectedValueType;\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .btn-to-current {\n    margin: 10px 0 20px;\n  }\n\n  /* stylelint-disable selector-max-compound-selectors */\n  .calendar-start {\n    margin-right: 75px;\n\n    ::v-deep header {\n      .next {\n        display: none !important; // stylelint-disable-line\n      }\n\n      .prev {\n        flex: 1;\n      }\n\n      &:after {\n        flex: 1;\n        content: '';\n      }\n    }\n  }\n\n  .calendar-end {\n    ::v-deep header {\n      .next {\n        flex: 1;\n      }\n\n      .prev {\n        display: none !important; // stylelint-disable-line\n      }\n\n      &:before {\n        flex: 1;\n        content: '';\n      }\n    }\n  }\n  /* stylelint-enable selector-max-compound-selectors */\n  form,\n  .el-input {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n  }\n\n  .el-form-item {\n    margin-bottom: 10px;\n\n    ::v-deep &__label {\n      text-transform: capitalize;\n      font-weight: 600;\n      line-height: inherit;\n    }\n  }\n\n  .filter-date-range-container {\n    display: flex;\n    flex-flow: wrap;\n    width: 675px;\n    padding: 10px 20px;\n  }\n\n  ::v-deep .el-input {\n    width: 120px;\n    margin-right: 20px;\n\n    &__prefix {\n      top: 6px;\n    }\n\n    &__inner:focus {\n      border-color: inherit;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$r = "data-v-1ee01348";
  /* module identifier */
  const __vue_module_identifier__$r = undefined;
  /* functional template */
  const __vue_is_functional_template__$r = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$r = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$q, staticRenderFns: __vue_staticRenderFns__$q },
    __vue_inject_styles__$r,
    __vue_script__$r,
    __vue_scope_id__$r,
    __vue_is_functional_template__$r,
    __vue_module_identifier__$r,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * A filter component using the [v-calendar]{@link https://vcalendar.io/} plugin to display a "from" and "to" typeable text input above by a [date-range calendar]{@link https://vcalendar.io/examples/datepickers.html#date-range}. The value is required be an empty array or [start, end].
 *
 * @vuedoc
 * @exports TfFilterDateRangeInput
 * @category Components
 */

var script$s = {
  name: 'TfFilterDateRangeInput',
  props: {
    value: {
      type: Array,
      required: true,
      validator: function validator(value) {
        return !value.length || value.length === 2;
      }
    }
  },
  methods: {
    /**
     * Move the calendar to the date parameter and emit the a new value to the parent.
     *
     * @param {string} date
     * @param {boolean} isStart
     */
    selectDate: function selectDate(date) {
      var isStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.$refs.calendar.move(date);
      this.$emit('input', isStart ? [date, this.value[1]] : [this.value[0], date]);
    },
    /**
     * Update calendar when user types.
     *
     * @param {string} event
     */
    move: function move(event) {
      if (event.target.value) {
        this.$refs.calendar.move(event.target.value);
      }
    }
  }
};

/* script */
const __vue_script__$s = script$s;

/* template */
var __vue_render__$r = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "date-range-container" },
    [
      _c("div", { staticClass: "date-selectors" }, [
        _c(
          "div",
          [
            _c("label", [_vm._v("From")]),
            _vm._v(" "),
            _c(
              "v-date-picker",
              _vm._b(
                {
                  key: _vm.value[0] ? _vm.value[0].value : "startDate",
                  attrs: { "is-required": "" },
                  on: {
                    input: function ($event) {
                      return _vm.selectDate($event, true)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var inputValue = ref.inputValue;
                        var inputEvents = ref.inputEvents;
                        return [
                          _c(
                            "input",
                            _vm._g(
                              {
                                attrs: {
                                  "data-test": "select filter start date",
                                  placeholder: "mm/dd/yy",
                                },
                                domProps: { value: inputValue },
                                on: {
                                  input: function ($event) {
                                    return _vm.move($event)
                                  },
                                },
                              },
                              inputEvents
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                },
                "v-date-picker",
                {
                  popover: {
                    visibility: "hidden",
                  },
                  updateOnInput: false,
                  value: _vm.value[0],
                },
                false
              )
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("label", [_vm._v("To")]),
            _vm._v(" "),
            _c(
              "v-date-picker",
              _vm._b(
                {
                  key: _vm.value[1] ? _vm.value[1].value : "endDate",
                  attrs: { "is-required": "" },
                  on: { input: _vm.selectDate },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var inputValue = ref.inputValue;
                        var inputEvents = ref.inputEvents;
                        return [
                          _c(
                            "input",
                            _vm._g(
                              {
                                attrs: {
                                  "data-test": "select filter end date",
                                  placeholder: "mm/dd/yy",
                                },
                                domProps: { value: inputValue },
                                on: {
                                  input: function ($event) {
                                    return _vm.move($event)
                                  },
                                },
                              },
                              inputEvents
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                },
                "v-date-picker",
                {
                  popover: {
                    visibility: "hidden",
                  },
                  updateOnInput: false,
                  value: _vm.value[1],
                },
                false
              )
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-date-picker",
        _vm._b(
          {
            ref: "calendar",
            attrs: { "is-range": "", "trim-weeks": "" },
            on: {
              input: function ($event) {
                return _vm.$emit(
                  "input",
                  $event ? [$event.start, $event.end] : []
                )
              },
            },
          },
          "v-date-picker",
          {
            value: {
              start: _vm.value[0],
              end: _vm.value[1],
            },
          },
          false
        )
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$r = [];
__vue_render__$r._withStripped = true;

  /* style */
  const __vue_inject_styles__$s = function (inject) {
    if (!inject) return
    inject("data-v-2818b6fd_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\ninput[data-v-2818b6fd] {\n  padding: 0 10px;\n  box-sizing: border-box;\n  border-radius: 2px;\n  border: solid 1px #c1c1c1;\n  height: 30px;\n  line-height: 30px;\n}\n.date-range-container[data-v-2818b6fd] {\n  padding: 20px;\n}\n.date-selectors[data-v-2818b6fd] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.date-selectors label[data-v-2818b6fd] {\n  display: block;\n  font-weight: 700;\n}\n.date-selectors[data-v-2818b6fd]  input {\n  width: 100px;\n}\n\n/*# sourceMappingURL=DateRangeInput.vue.map */", map: {"version":3,"sources":["DateRangeInput.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfFilter/DateRangeInput.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACiHlC;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;AD/GA;ACkHA;EACA,aAAA;AD/GA;ACkHA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AD/GA;ACiHA;EACA,cAAA;EACA,gBAAA;AD/GA;ACkHA;EACA,YAAA;ADhHA;;AAEA,6CAA6C","file":"DateRangeInput.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\ninput {\n  padding: 0 10px;\n  box-sizing: border-box;\n  border-radius: 2px;\n  border: solid 1px #c1c1c1;\n  height: 30px;\n  line-height: 30px;\n}\n\n.date-range-container {\n  padding: 20px;\n}\n\n.date-selectors {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.date-selectors label {\n  display: block;\n  font-weight: 700;\n}\n.date-selectors ::v-deep input {\n  width: 100px;\n}\n\n/*# sourceMappingURL=DateRangeInput.vue.map */","<template>\n  <div class=\"date-range-container\">\n    <div class=\"date-selectors\">\n      <div>\n        <label>From</label>\n        <v-date-picker\n          :key=\"value[0] ? value[0].value : 'startDate'\"\n          is-required\n          v-bind=\"{\n            popover: {\n              visibility: 'hidden',\n            },\n            updateOnInput: false,\n            value: value[0],\n          }\"\n          @input=\"selectDate($event, true)\"\n        >\n          <template #default=\"{ inputValue, inputEvents }\">\n            <input\n              :value=\"inputValue\"\n              data-test=\"select filter start date\"\n              placeholder=\"mm/dd/yy\"\n              v-on=\"inputEvents\"\n              @input=\"move($event)\"\n            >\n          </template>\n        </v-date-picker>\n      </div>\n      <div>\n        <label>To</label>\n        <v-date-picker\n          :key=\"value[1] ? value[1].value : 'endDate'\"\n          is-required\n          v-bind=\"{\n            popover: {\n              visibility: 'hidden',\n            },\n            updateOnInput: false,\n            value: value[1],\n          }\"\n          @input=\"selectDate\"\n        >\n          <template #default=\"{ inputValue, inputEvents }\">\n            <input\n              :value=\"inputValue\"\n              data-test=\"select filter end date\"\n              placeholder=\"mm/dd/yy\"\n              v-on=\"inputEvents\"\n              @input=\"move($event)\"\n            >\n          </template>\n        </v-date-picker>\n      </div>\n    </div>\n    <v-date-picker\n      ref=\"calendar\"\n      is-range\n      trim-weeks\n      v-bind=\"{\n        value: {\n          start: value[0],\n          end: value[1],\n        },\n      }\"\n      @input=\"$emit('input', $event ? [$event.start, $event.end] : [])\"\n    />\n  </div>\n</template>\n\n<script>\n  /**\n   * A filter component using the [v-calendar]{@link https://vcalendar.io/} plugin to display a \"from\" and \"to\" typeable text input above by a [date-range calendar]{@link https://vcalendar.io/examples/datepickers.html#date-range}. The value is required be an empty array or [start, end].\n   *\n   * @vuedoc\n   * @exports TfFilterDateRangeInput\n   * @category Components\n   */\n\n  export default {\n    name: 'TfFilterDateRangeInput',\n    props: {\n      value: {\n        type: Array,\n        required: true,\n        validator: (value) => !value.length || value.length === 2,\n      },\n    },\n    methods: {\n      /**\n       * Move the calendar to the date parameter and emit the a new value to the parent.\n       *\n       * @param {string} date\n       * @param {boolean} isStart\n       */\n      selectDate(date, isStart = false) {\n        this.$refs.calendar.move(date);\n        this.$emit('input', isStart ? [date, this.value[1]] : [this.value[0], date]);\n      },\n      /**\n       * Update calendar when user types.\n       *\n       * @param {string} event\n       */\n      move(event) {\n        if (event.target.value) {\n          this.$refs.calendar.move(event.target.value);\n        }\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  input {\n    padding: 0 10px;\n    box-sizing: border-box;\n    border-radius: 2px;\n    border: solid 1px $tf-light-gray;\n    height: 30px;\n    line-height: 30px;\n  }\n\n  .date-range-container {\n    padding: 20px;\n  }\n\n  .date-selectors {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: 10px;\n\n    label {\n      display: block;\n      font-weight: 700;\n    }\n\n    ::v-deep input {\n      width: 100px;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$s = "data-v-2818b6fd";
  /* module identifier */
  const __vue_module_identifier__$s = undefined;
  /* functional template */
  const __vue_is_functional_template__$s = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$s = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$r, staticRenderFns: __vue_staticRenderFns__$r },
    __vue_inject_styles__$s,
    __vue_script__$s,
    __vue_scope_id__$s,
    __vue_is_functional_template__$s,
    __vue_module_identifier__$s,
    false,
    browser,
    undefined,
    undefined
  );

//
var script$t = {
  name: 'TfFilterDate',
  components: {
    TfFilterDateRange: __vue_component__$r,
    TfFilterDateRangeInput: __vue_component__$s
  },
  props: {
    dateType: {
      type: String,
      required: true
    },
    filter: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      dateOptions: [{
        text: 'Month',
        value: 'month'
      }, {
        text: 'Choose Range',
        value: 'date-range'
      }],
      openDate: new Date()
    };
  },
  computed: {
    /**
     * get: The first value of the model array if the dateType is month,
     * otherwise get the first array in the model or an empty array.
     * set: $emit the value wrapped in an array.
     */
    localValue: {
      get: function get() {
        return this.dateType === 'month' ? this.value[0] : this.value[0] || [];
      },
      set: function set(value) {
        this.$emit('input', [value]);
      }
    }
  },
  methods: {
    /**
     * Sets the open Date to today's date and emits "input" with that same value.
     */
    changeToCurrentMonth: function changeToCurrentMonth() {
      this.openDate = new Date();
      this.$emit('input', [this.openDate]);
    }
  }
};

/* script */
const __vue_script__$t = script$t;

/* template */
var __vue_render__$s = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _vm.filter.type === "month-and-date-range"
        ? _c(
            "header",
            [
              _c(
                "div",
                { staticClass: "btn-group" },
                _vm._l(_vm.dateOptions, function (option) {
                  return _c("TfButton", {
                    key: option.value,
                    staticClass: "btn-type-selector",
                    attrs: {
                      disabled: _vm.dateType === option.value,
                      "data-test": "filter date " + option.value,
                      type: "primary",
                      size: "text-small",
                    },
                    domProps: { textContent: _vm._s(option.text) },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("changeDateFilterType", option.value)
                      },
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("TfButton", {
                attrs: {
                  type: "secondary",
                  icon: "times",
                  size: "icon-no-fill",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("closePopover", true)
                  },
                },
              }),
            ],
            1
          )
        : _vm.filter.type !== "date-range-input"
        ? _c("TfButton", {
            class: [
              "btn-close-popover",
              { "btn-close-month": _vm.filter.type === "month" },
            ],
            attrs: {
              "data-test": "close popover",
              type: "secondary",
              icon: "times",
              size: "icon-no-fill",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("closePopover", true)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dateType === "month"
        ? [
            _c(
              "TfDatepicker",
              _vm._b(
                {
                  attrs: { "data-test": "filter date month" },
                  model: {
                    value: _vm.localValue,
                    callback: function ($$v) {
                      _vm.localValue = $$v;
                    },
                    expression: "localValue",
                  },
                },
                "TfDatepicker",
                {
                  inline: true,
                  viewType: "month",
                  openDate: _vm.openDate,
                },
                false
              )
            ),
            _vm._v(" "),
            _c("TfButton", {
              staticClass: "btn-to-current",
              attrs: {
                "data-test": "filter date to current",
                type: "primary",
                size: "text-small",
              },
              domProps: { textContent: _vm._s("Back to Current Month") },
              on: { click: _vm.changeToCurrentMonth },
            }),
          ]
        : _vm.dateType === "date-range-input"
        ? _c("TfFilterDateRangeInput", {
            attrs: { "data-test": "filter date range input" },
            model: {
              value: _vm.localValue,
              callback: function ($$v) {
                _vm.localValue = $$v;
              },
              expression: "localValue",
            },
          })
        : _vm.dateType === "date-range"
        ? _c("TfFilterDateRange", {
            attrs: { "data-test": "filter date range" },
            model: {
              value: _vm.localValue,
              callback: function ($$v) {
                _vm.localValue = $$v;
              },
              expression: "localValue",
            },
          })
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$s = [];
__vue_render__$s._withStripped = true;

  /* style */
  const __vue_inject_styles__$t = function (inject) {
    if (!inject) return
    inject("data-v-08d8ff0a_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n[data-v-08d8ff0a] .vdp-datepicker__calendar {\n  position: relative;\n}\nheader[data-v-08d8ff0a] {\n  display: flex;\n  height: 42px;\n  padding: 0 20px;\n  border-bottom: 1px solid #999;\n}\nheader .tf-button--icon-no-fill[data-v-08d8ff0a] {\n  margin-left: auto;\n}\n.btn-close-popover[data-v-08d8ff0a] {\n  position: absolute;\n  z-index: 101;\n  top: 15px;\n  right: 15px;\n}\n.btn-close-popover.btn-close-month[data-v-08d8ff0a] {\n  z-index: 10001;\n  top: 10px;\n  right: 10px;\n}\n.btn-type-selector[data-v-08d8ff0a] {\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.btn-type-selector.is-disabled[data-v-08d8ff0a] {\n  font-weight: 600;\n}\n.btn-to-current[data-v-08d8ff0a] {\n  margin: 15px 0 30px 18px;\n}\n\n/*# sourceMappingURL=Date.vue.map */", map: {"version":3,"sources":["Date.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfFilter/Date.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC6HlC;EACA,kBAAA;AD3HA;AC8HA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;AD3HA;AC6HA;EACA,iBAAA;AD3HA;ACgIA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AD7HA;AC+HA;EACA,cAAA;EACA,SAAA;EACA,WAAA;AD7HA;ACiIA;EACA,gBAAA;EACA,yBAAA;AD/HA;ACiIA;EACA,gBAAA;AD/HA;ACmIA;EACA,wBAAA;ADjIA;;AAEA,mCAAmC","file":"Date.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n::v-deep .vdp-datepicker__calendar {\n  position: relative;\n}\n\nheader {\n  display: flex;\n  height: 42px;\n  padding: 0 20px;\n  border-bottom: 1px solid #999;\n}\nheader .tf-button--icon-no-fill {\n  margin-left: auto;\n}\n\n.btn-close-popover {\n  position: absolute;\n  z-index: 101;\n  top: 15px;\n  right: 15px;\n}\n.btn-close-popover.btn-close-month {\n  z-index: 10001;\n  top: 10px;\n  right: 10px;\n}\n.btn-type-selector {\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.btn-type-selector.is-disabled {\n  font-weight: 600;\n}\n.btn-to-current {\n  margin: 15px 0 30px 18px;\n}\n\n/*# sourceMappingURL=Date.vue.map */","<template>\n  <div>\n    <header v-if=\"filter.type === 'month-and-date-range'\">\n      <div class=\"btn-group\">\n        <TfButton\n          v-for=\"option in dateOptions\"\n          :key=\"option.value\"\n          :disabled=\"dateType === option.value\"\n          :data-test=\"`filter date ${option.value}`\"\n          type=\"primary\"\n          class=\"btn-type-selector\"\n          size=\"text-small\"\n          @click=\"$emit('changeDateFilterType', option.value)\"\n          v-text=\"option.text\"\n        />\n      </div>\n      <TfButton\n        type=\"secondary\"\n        icon=\"times\"\n        size=\"icon-no-fill\"\n        @click=\"$emit('closePopover', true)\"\n      />\n    </header>\n    <TfButton\n      v-else-if=\"filter.type !== 'date-range-input'\"\n      :class=\"[\n        'btn-close-popover',\n        { 'btn-close-month': filter.type === 'month' }\n      ]\"\n      data-test=\"close popover\"\n      type=\"secondary\"\n      icon=\"times\"\n      size=\"icon-no-fill\"\n      @click=\"$emit('closePopover', true)\"\n    />\n    <template v-if=\"dateType === 'month'\">\n      <TfDatepicker\n        v-model=\"localValue\"\n        v-bind=\"{\n          inline: true,\n          viewType: 'month',\n          openDate\n        }\"\n        data-test=\"filter date month\"\n      />\n      <TfButton\n        class=\"btn-to-current\"\n        data-test=\"filter date to current\"\n        type=\"primary\"\n        size=\"text-small\"\n        @click=\"changeToCurrentMonth\"\n        v-text=\"'Back to Current Month'\"\n      />\n    </template>\n    <TfFilterDateRangeInput\n      v-else-if=\"dateType === 'date-range-input'\"\n      v-model=\"localValue\"\n      data-test=\"filter date range input\"\n    />\n    <TfFilterDateRange\n      v-else-if=\"dateType === 'date-range'\"\n      v-model=\"localValue\"\n      data-test=\"filter date range\"\n    />\n  </div>\n</template>\n<script>\n  import TfFilterDateRange from './DateRange';\n  import TfFilterDateRangeInput from './DateRangeInput';\n\n  export default {\n    name: 'TfFilterDate',\n    components: { TfFilterDateRange, TfFilterDateRangeInput },\n    props: {\n      dateType: {\n        type: String,\n        required: true,\n      },\n      filter: {\n        type: Object,\n        required: true,\n      },\n      value: {\n        type: Array,\n        required: true,\n      },\n    },\n    data: () => ({\n      dateOptions: [\n        { text: 'Month', value: 'month' },\n        { text: 'Choose Range', value: 'date-range' },\n      ],\n      openDate: new Date(),\n    }),\n    computed: {\n      /**\n       * get: The first value of the model array if the dateType is month,\n       * otherwise get the first array in the model or an empty array.\n       * set: $emit the value wrapped in an array.\n       */\n      localValue: {\n        get() {\n          return this.dateType === 'month'\n            ? this.value[0]\n            : this.value[0] || [];\n        },\n        set(value) {\n          this.$emit('input', [value]);\n        },\n      },\n    },\n    methods: {\n      /**\n       * Sets the open Date to today's date and emits \"input\" with that same value.\n       */\n      changeToCurrentMonth() {\n        this.openDate = new Date();\n        this.$emit('input', [this.openDate]);\n      },\n    },\n  };\n\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  ::v-deep .vdp-datepicker__calendar {\n    position: relative;\n  }\n\n  header {\n    display: flex;\n    height: 42px;\n    padding: 0 20px;\n    border-bottom: 1px solid $tf-medium-gray;\n\n    .tf-button--icon-no-fill {\n      margin-left: auto;\n    }\n  }\n\n  .btn {\n    &-close-popover {\n      position: absolute;\n      z-index: 101;\n      top: 15px;\n      right: 15px;\n\n      &.btn-close-month {\n        z-index: 10001; // .vdp-datepicker__calendar has a z-index:10000\n        top: 10px;\n        right: 10px;\n      }\n    }\n\n    &-type-selector {\n      font-weight: 700;\n      text-transform: uppercase;\n\n      &.is-disabled {\n        font-weight: 600;\n      }\n    }\n\n    &-to-current {\n      margin: 15px 0 30px 18px;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$t = "data-v-08d8ff0a";
  /* module identifier */
  const __vue_module_identifier__$t = undefined;
  /* functional template */
  const __vue_is_functional_template__$t = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$t = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$s, staticRenderFns: __vue_staticRenderFns__$s },
    __vue_inject_styles__$t,
    __vue_script__$t,
    __vue_scope_id__$t,
    __vue_is_functional_template__$t,
    __vue_module_identifier__$t,
    false,
    browser,
    undefined,
    undefined
  );

var script$u = {
  components: {
    TfFilterDate: __vue_component__$t
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Object,
      required: true
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    valueKey: {
      type: String,
      default: 'value'
    }
  },
  data: function data(vm) {
    return {
      dateType: null,
      localValue: _toConsumableArray(vm.value),
      localOptions: [],
      searchValue: '',
      showPopover: false,
      timer: 0
    };
  },
  computed: {
    /**
     * If the filter is a 'date-range', 'date-range-input', or 'month' dateType, then test for all values.
     *
     * @returns {Array}
     */
    disableBtns: function disableBtns() {
      var disableBtns = false;
      if (['date-range-input', 'date-range'].includes(this.dateType)) {
        disableBtns = this.localValue[0] ? this.localValue[0].includes('') : true;
      } else if (this.dateType === 'month') {
        disableBtns = !this.localValue[0];
      }
      return disableBtns;
    },
    /**
     * Map this.value to either the value or the appropriate label.
     * For filter types that are a range, we want to create this list
     * from this.filter.options since that has the appropriate order.
     *
     * @returns {Array}
     */
    displayOptions: function displayOptions() {
      var _this = this;
      var values = this.value.map(function (id) {
        var formatDate = function formatDate(dateValue) {
          var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM/DD/YY';
          return _this.$TF.DatesUtils.formatSimpleDate(dateValue, format);
        };
        var text;
        if (_this.filter.type === 'range') {
          var _this$filter$options$ = _this.filter.options.find(function (_ref) {
            var localValue = _ref[_this.valueKey];
            return localValue === id;
          });
          text = _this$filter$options$[_this.labelKey];
        } else if (_this.filter.type === 'string' || _this.filter.type === 'array') {
          text = id;
        } else if (_this.filter.dateType === 'month') {
          text = formatDate(id, 'MMMM YYYY');
        } else if (['date-range', 'date-range-input'].includes(_this.filter.dateType)) {
          var _id = _slicedToArray(id, 2),
            from = _id[0],
            to = _id[1];
          text = "".concat(formatDate(from), "-").concat(formatDate(to));
        }
        return {
          id: id,
          text: text
        };
      });
      var displayOptions;
      if (this.filter.type === 'range') {
        displayOptions = [];
        this.filter.options.forEach(function (option) {
          if (_this.value.includes(option[_this.valueKey])) {
            displayOptions.push({
              id: option[_this.valueKey],
              text: option[_this.labelKey]
            });
          }
        });
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        displayOptions = this.$TF.Formatting.sortObjects(values, 'text');
      }
      return displayOptions;
    },
    /**
     * Cache a string based on the filter's prop to be used throughout the template.
     *
     * @returns {string}
     */
    filterPropName: function filterPropName() {
      return "filter-".concat(this.filter.prop);
    }
  },
  watch: {
    /**
     * The reset button is controlled in the parent so we want to watch
     * for when the model is emptied from the parent to reset the local filter values.
     */
    value: function value() {
      if (!this.value.length) {
        this.resetFilters();
      }
    },
    searchValue: {
      /**
       * Debounce the search value to filter the options.
       *
       * @param {string} val
       */
      handler: function handler(val) {
        var _this2 = this;
        if (!['range', 'string', 'array'].includes(this.filter.type)) {
          this.localOptions = this.filter.options;
          return;
        }
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          var filteredResults = [];
          var maxResults = 0;
          var i = 0;
          while (maxResults < 30 && i < _this2.filter.options.length) {
            if (!val || _this2.filter.options[i][_this2.labelKey].toLowerCase().includes(val.toLowerCase())) {
              filteredResults.push(_this2.filter.options[i]);
              maxResults += 1;
            }
            i += 1;
          }
          _this2.localOptions = filteredResults;
        }, 200);
      },
      immediate: true
    }
  },
  created: function created() {
    this.changeDateType();
  },
  methods: {
    /**
     * Close the popover and if there is a change in filter values,
     * $emit the localValue to the parent.
     */
    applyFilter: function applyFilter() {
      var _this3 = this;
      if (this.value.length === this.localValue.length && this.localValue.every(function (value) {
        return _this3.value.includes(value);
      })) {
        this.closePopover();
        return;
      }
      if (this.dateType) {
        this.$emit('changeDateFilterType', this.dateType);
      }
      this.$emit('input', this.localValue);
      this.closePopover();
    },
    /**
     * Clear or reset the localValue based on the passed param.
     * $emit the localValue to the parent.
     *
     * @param {string} dateFilterType
     */
    changeDateFilterType: function changeDateFilterType(dateFilterType) {
      var newLocalValue = this.filter.dateType === dateFilterType ? this.value : [];
      this.dateType = dateFilterType;
      this.$set(this, 'localValue', newLocalValue);

      /* Changing the filter type will change the content of the
       * popover but not inform the underlying Popover component
       * that it has been updated. Calling updatePopper explicitly
       * on tf-tooltip will schedule a re-render / repositioning */
      if (this.$refs['tf-tooltip'].updatePopper) {
        this.$refs['tf-tooltip'].updatePopper();
      }
    },
    /**
     * Clear or reset the localValue based on the passed param.
     * $emit the localValue to the parent.
     */
    changeDateType: function changeDateType() {
      if (!this.filter.dateType) {
        return;
      }
      var dateType = this.filter.dateType || this.filter.type;
      if (this.filter.type === 'month-and-date-range') {
        dateType = this.value[0] && Array.isArray(this.value[0]) ? 'date-range' : 'month';
      }
      this.dateType = dateType;
    },
    /**
     * Clear the search value, closes the popover.
     * Clear the localValue if desired.
     *
     * @param {boolean} resetValue
     */
    closePopover: function closePopover() {
      var resetValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.showPopover) {
        return;
      }
      this.showPopover = false;
      this.searchValue = '';
      if (resetValue) {
        this.$set(this, 'localValue', _toConsumableArray(this.value));
        this.changeDateType();
      }

      // I'm wrapping this due a test failure that
      // I'm not sure of a way around right now.
      // TypeError: this.$refs.tf-tooltip.doClose is not a function
      if (this.$refs['tf-tooltip'].doClose) {
        this.$refs['tf-tooltip'].doClose();
      }
    },
    /**
     * If the user hits tab while focused on the main input,
     * we move the user to the next checkbox. Element does something odd
     * so this needs to be done on nextTick().
     *
     * @param {object} $event
     * @param {string} $event.shiftKey
     */
    focusOnCheckbox: function focusOnCheckbox(_ref2) {
      var _this4 = this;
      var shiftKey = _ref2.shiftKey;
      if (!shiftKey) {
        this.$nextTick(function () {
          _this4.$refs.checkbox[0].$el.querySelector('input').focus();
        });
      }
    },
    /**
     * Evaluate the the clicked element's name to close the popover and reset the values.
     *
     * @param {object} event
     */
    onClickOutside: function onClickOutside(event) {
      if ((event.target.name || event.target.getAttribute('data-prop-name')) === "".concat(this.filterPropName)) {
        return;
      }
      this.closePopover(true);
    },
    /**
     * Close popover with caret
     *
     */
    toggleIcon: function toggleIcon() {
      var _this5 = this;
      if (this.showPopover) {
        // delay close of popover as multiple popovers may exist and conflict with onClickOutside
        this.$forceNextTick(function () {
          _this5.closePopover(true);
        });
      }
    },
    /**
     * Remove the value from the localValue and $emit to the parent.
     *
     * @param {string | Array} value
     */
    removeValue: function removeValue(value) {
      var index = this.localValue.findIndex(function (localValue) {
        return localValue === value;
      });
      this.localValue.splice(index, 1);
      this.$emit('input', this.localValue);
    },
    /**
     * Reset the localValue and create a random ID for the calendars.
     */
    resetFilters: function resetFilters() {
      this.$set(this, 'localValue', []);
    }
  }
};

/* script */
const __vue_script__$u = script$u;

/* template */
var __vue_render__$t = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c(
        "popper",
        _vm._b(
          {
            ref: "tf-tooltip",
            attrs: { trigger: "clickToToggle" },
            on: {
              show: function ($event) {
                _vm.showPopover = true;
              },
            },
          },
          "popper",
          {
            appendToBody: true,
            disabled: _vm.disabled,
            forceShow: _vm.showPopover,
            options: {
              placement: "bottom-start",
              modifiers: {
                flip: {
                  // disabling to force popper to stay below
                  // input regardless of viewport height
                  enabled: false,
                },
              },
            },
            visibleArrow: false,
          },
          false
        ),
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.onClickOutside,
                  expression: "onClickOutside",
                },
              ],
              class: [
                "tf-popper tf-filter-type-" + _vm.filter.type,
                ((_obj = {}),
                (_obj["tf-filter-type-" + _vm.dateType] = _vm.dateType),
                _obj),
              ],
              style: {
                width: _vm.filter.popoverWidth,
                minWidth: _vm.filter.width,
              },
            },
            [
              _vm.showPopover
                ? [
                    ["string", "range", "array"].includes(_vm.filter.type)
                      ? [
                          !_vm.localOptions.length && _vm.searchValue
                            ? _c("span", { staticClass: "empty-search" }, [
                                _vm._v(
                                  "\n            No results found\n          "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "ElCheckboxGroup",
                            {
                              model: {
                                value: _vm.localValue,
                                callback: function ($$v) {
                                  _vm.localValue = $$v;
                                },
                                expression: "localValue",
                              },
                            },
                            _vm._l(_vm.localOptions, function (option) {
                              return _c(
                                "TfCheckbox",
                                {
                                  key: option[_vm.valueKey],
                                  ref: "checkbox",
                                  refInFor: true,
                                  attrs: {
                                    "data-test":
                                      "select " + _vm.filter.prop + " filter",
                                    disabled: option.disabled,
                                    label: option[_vm.valueKey],
                                  },
                                  nativeOn: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return $event.target.click()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      option[_vm.labelKey]
                                        ? [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(option[_vm.labelKey]) +
                                                "\n                "
                                            ),
                                          ]
                                        : _vm._t("noValue", function () {
                                            return [
                                              _vm._v(
                                                "\n                  —\n                "
                                              ),
                                            ]
                                          }),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ]
                      : _c("TfFilterDate", {
                          attrs: {
                            "date-type": _vm.dateType,
                            filter: _vm.filter,
                          },
                          on: {
                            changeDateFilterType: _vm.changeDateFilterType,
                            closePopover: _vm.closePopover,
                          },
                          model: {
                            value: _vm.localValue,
                            callback: function ($$v) {
                              _vm.localValue = $$v;
                            },
                            expression: "localValue",
                          },
                        }),
                    _vm._v(" "),
                    _c("footer", [
                      _c(
                        "div",
                        { staticClass: "btn-group" },
                        [
                          _c("TfButton", {
                            attrs: {
                              disabled: _vm.disableBtns,
                              "data-test":
                                "reset " + _vm.filter.prop + " filter",
                              size: "medium",
                              type: "secondary",
                            },
                            domProps: { textContent: _vm._s("Reset") },
                            on: { click: _vm.resetFilters },
                          }),
                          _vm._v(" "),
                          _c("TfButton", {
                            attrs: {
                              disabled: _vm.disableBtns,
                              "data-test":
                                "apply " + _vm.filter.prop + " filter",
                              size: "medium",
                            },
                            domProps: { textContent: _vm._s("Done") },
                            on: { click: _vm.applyFilter },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ElInput",
            _vm._b(
              {
                attrs: {
                  slot: "reference",
                  "data-test": "edit " + _vm.filter.prop + " filter",
                },
                nativeOn: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    ) {
                      return null
                    }
                    return _vm.focusOnCheckbox.apply(null, arguments)
                  },
                },
                slot: "reference",
                model: {
                  value: _vm.searchValue,
                  callback: function ($$v) {
                    _vm.searchValue = $$v;
                  },
                  expression: "searchValue",
                },
              },
              "ElInput",
              {
                class: [
                  { "is-active": _vm.showPopover && !_vm.disabled },
                  "input-filter",
                ],
                disabled: _vm.disabled,
                name: _vm.filterPropName,
                placeholder: _vm.filter.label,
                readonly: !["string", "range", "array"].includes(
                  _vm.filter.type
                ),
              },
              false
            ),
            [
              _c("icon", {
                attrs: {
                  slot: "suffix",
                  name: "caret-down",
                  "data-prop-name": _vm.filterPropName,
                },
                on: { click: _vm.toggleIcon },
                slot: "suffix",
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.value.length
        ? _c(
            "div",
            { staticClass: "tf-filter-values-container" },
            _vm._l(_vm.displayOptions, function (option) {
              return _c(
                "span",
                { key: option.text, staticClass: "tf-filter-value" },
                [
                  option.text
                    ? [_vm._v("\n        " + _vm._s(option.text) + "\n      ")]
                    : _vm._t("noValue", function () {
                        return [_vm._v("\n        —\n      ")]
                      }),
                  _vm._v(" "),
                  _c("TfButton", {
                    staticClass: "btn-remove-filter-value",
                    attrs: {
                      "no-padding": "",
                      type: "primary",
                      icon: "times",
                      size: "icon-no-fill",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.removeValue(option.id)
                      },
                    },
                  }),
                ],
                2
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$t = [];
__vue_render__$t._withStripped = true;

  /* style */
  const __vue_inject_styles__$u = function (inject) {
    if (!inject) return
    inject("data-v-278d1cb3_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nfooter[data-v-278d1cb3] {\n  padding: 10px 0;\n  border-top: 1px solid #999;\n}\n.tf-button.btn-remove-filter-value[data-v-278d1cb3] {\n  margin-top: 2px;\n}\n.tf-button.tf-button--secondary[data-v-278d1cb3] {\n  border-color: #fff;\n}\n.tf-popper[data-v-278d1cb3] {\n  padding: 0;\n  box-sizing: border-box;\n  background: #fff;\n  border: 1px solid #009;\n  border-radius: 2px;\n  text-align: left;\n}\n.tf-filter-value[data-v-278d1cb3] {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 5px 7px 5px 15px;\n  font-size: 14px;\n}\n.tf-filter-value > span[data-v-278d1cb3] {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.tf-filter-values-container[data-v-278d1cb3] {\n  background: #fafafa;\n  border: 1px solid #c1c1c1;\n  border-top: 0;\n  border-radius: 0 0 2px 2px;\n}\n[data-v-278d1cb3] .el {\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-disable max-nesting-depth  */\n  /* stylelint-enable selector-max-compound-selectors */\n  /* stylelint-enable max-nesting-depth  */\n}\n[data-v-278d1cb3] .el-checkbox {\n  display: flex;\n  padding: 12px 10px;\n  cursor: pointer;\n}\n[data-v-278d1cb3] .el-checkbox:not(:last-child) {\n  border-bottom: 1px #efefef solid;\n}\n[data-v-278d1cb3] .el-checkbox-group {\n  box-sizing: border-box;\n  max-height: 300px;\n  width: auto;\n  min-width: 200px;\n  overflow-y: auto;\n  position: relative;\n}\n[data-v-278d1cb3] .el-checkbox__inner {\n  margin-top: 2px;\n}\n[data-v-278d1cb3] .el-checkbox__label {\n  line-height: 20px;\n}\n[data-v-278d1cb3] .el-checkbox + .el-checkbox {\n  margin-left: 0;\n}\n[data-v-278d1cb3] .el-checkbox:hover {\n  background: #eff3fd;\n  color: #009;\n}\n[data-v-278d1cb3] .el-input__suffix {\n  display: flex;\n  align-items: center;\n  margin-right: 6px;\n  cursor: pointer;\n}\n[data-v-278d1cb3] .el-input__suffix svg {\n  height: 22px;\n  width: 14px;\n}\n[data-v-278d1cb3] .el-input__suffix svg path {\n  pointer-events: none;\n}\n[data-v-278d1cb3] .el-input__suffix-inner {\n  padding-top: 3px;\n}\n[data-v-278d1cb3] .el-input.input-filter.is-active svg {\n  fill: #009;\n  transform: rotate(180deg);\n}\n[data-v-278d1cb3] .el-input input {\n  height: 30px;\n  line-height: 30px;\n}\n[data-v-278d1cb3] .el-input input::placeholder {\n  opacity: 1;\n  color: #999;\n}\n[data-v-278d1cb3] .el-input svg {\n  transition: transform 0.2s ease-out;\n  transform-origin: center;\n  transform: rotate(0deg);\n}\n.empty-search[data-v-278d1cb3] {\n  display: block;\n  padding: 10px 15px;\n  color: #999;\n  font-style: italic;\n}\n\n/*# sourceMappingURL=index.vue.map */", map: {"version":3,"sources":["index.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfFilter/index.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACidlC;EACA,eAAA;EACA,0BAAA;AD/cA;ACmdA;EACA,eAAA;ADhdA;ACmdA;EACA,kBAAA;ADjdA;ACqdA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;ADldA;ACsdA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;ADndA;ACqdA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;ADndA;ACudA;EACA,mBAAA;EACA,yBAAA;EAEA,aAAA;EACA,0BAAA;ADtdA;AC2dA;EAqCA,sDAAA;EACA,yCAAA;EA6CA,qDAAA;EACA,wCAAA;ADxiBA;ACqdA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;ADndA;ACqdA;EACA,gCAAA;ADndA;ACsdA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;ADpdA;ACudA;EACA,eAAA;ADrdA;ACwdA;EACA,iBAAA;ADtdA;ACydA;EACA,cAAA;ADvdA;AC0dA;EACA,mBAAA;EACA,WAAA;ADxdA;AC+dA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AD7dA;AC+dA;EACA,YAAA;EACA,WAAA;AD7dA;AC+dA;EACA,oBAAA;AD7dA;ACkeA;EACA,gBAAA;ADheA;ACoeA;EACA,UAAA;EACA,yBAAA;ADleA;ACseA;EACA,YAAA;EACA,iBAAA;ADpeA;ACseA;EACA,UAAA;EACA,WAAA;ADpeA;ACweA;EACA,mCAAA;EACA,wBAAA;EACA,uBAAA;ADteA;AC6eA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AD1eA;;AAEA,oCAAoC","file":"index.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nfooter {\n  padding: 10px 0;\n  border-top: 1px solid #999;\n}\n\n.tf-button.btn-remove-filter-value {\n  margin-top: 2px;\n}\n.tf-button.tf-button--secondary {\n  border-color: #fff;\n}\n\n.tf-popper {\n  padding: 0;\n  box-sizing: border-box;\n  background: #fff;\n  border: 1px solid #009;\n  border-radius: 2px;\n  text-align: left;\n}\n\n.tf-filter-value {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 5px 7px 5px 15px;\n  font-size: 14px;\n}\n.tf-filter-value > span {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.tf-filter-values-container {\n  background: #fafafa;\n  border: 1px solid #c1c1c1;\n  border-top: 0;\n  border-radius: 0 0 2px 2px;\n}\n\n::v-deep .el {\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-disable max-nesting-depth  */\n  /* stylelint-enable selector-max-compound-selectors */\n  /* stylelint-enable max-nesting-depth  */\n}\n::v-deep .el-checkbox {\n  display: flex;\n  padding: 12px 10px;\n  cursor: pointer;\n}\n::v-deep .el-checkbox:not(:last-child) {\n  border-bottom: 1px #efefef solid;\n}\n::v-deep .el-checkbox-group {\n  box-sizing: border-box;\n  max-height: 300px;\n  width: auto;\n  min-width: 200px;\n  overflow-y: auto;\n  position: relative;\n}\n::v-deep .el-checkbox__inner {\n  margin-top: 2px;\n}\n::v-deep .el-checkbox__label {\n  line-height: 20px;\n}\n::v-deep .el-checkbox + .el-checkbox {\n  margin-left: 0;\n}\n::v-deep .el-checkbox:hover {\n  background: #eff3fd;\n  color: #009;\n}\n::v-deep .el-input__suffix {\n  display: flex;\n  align-items: center;\n  margin-right: 6px;\n  cursor: pointer;\n}\n::v-deep .el-input__suffix svg {\n  height: 22px;\n  width: 14px;\n}\n::v-deep .el-input__suffix svg path {\n  pointer-events: none;\n}\n::v-deep .el-input__suffix-inner {\n  padding-top: 3px;\n}\n::v-deep .el-input.input-filter.is-active svg {\n  fill: #009;\n  transform: rotate(180deg);\n}\n::v-deep .el-input input {\n  height: 30px;\n  line-height: 30px;\n}\n::v-deep .el-input input::placeholder {\n  opacity: 1;\n  color: #999;\n}\n::v-deep .el-input svg {\n  transition: transform 0.2s ease-out;\n  transform-origin: center;\n  transform: rotate(0deg);\n}\n\n.empty-search {\n  display: block;\n  padding: 10px 15px;\n  color: #999;\n  font-style: italic;\n}\n\n/*# sourceMappingURL=index.vue.map */","<template>\n  <div>\n    <popper\n      ref=\"tf-tooltip\"\n      v-bind=\"{\n        appendToBody: true,\n        disabled,\n        forceShow: showPopover,\n        options: {\n          placement: 'bottom-start',\n          modifiers: {\n            flip: {\n              // disabling to force popper to stay below\n              // input regardless of viewport height\n              enabled: false,\n            },\n          },\n        },\n        visibleArrow: false\n      }\"\n      trigger=\"clickToToggle\"\n      @show=\"showPopover = true\"\n    >\n      <!--\n        Due to a bug in vue-popper, the content should be the first element:\n        https://github.com/RobinCK/vue-popper/issues/71\n      -->\n      <div\n        v-click-outside=\"onClickOutside\"\n        :class=\"[\n          `tf-popper tf-filter-type-${filter.type}`,\n          { [`tf-filter-type-${dateType}`]: dateType },\n        ]\"\n        :style=\"{ width: filter.popoverWidth, minWidth: filter.width }\"\n      >\n        <!-- Wrap the content in v-if to prevent contents from loading. -->\n        <template v-if=\"showPopover\">\n          <template v-if=\"['string', 'range', 'array'].includes(filter.type)\">\n            <span\n              v-if=\"!localOptions.length && searchValue\"\n              class=\"empty-search\"\n            >\n              No results found\n            </span>\n            <ElCheckboxGroup v-model=\"localValue\">\n              <TfCheckbox\n                v-for=\"option in localOptions\"\n                ref=\"checkbox\"\n                :key=\"option[valueKey]\"\n                :data-test=\"`select ${filter.prop} filter`\"\n                :disabled=\"option.disabled\"\n                :label=\"option[valueKey]\"\n                @keydown.native.enter=\"$event.target.click()\"\n              >\n                <span>\n                  <template v-if=\"option[labelKey]\">\n                    {{ option[labelKey] }}\n                  </template>\n                  <slot\n                    v-else\n                    name=\"noValue\"\n                  >\n                    &mdash;\n                  </slot>\n                </span>\n              </TfCheckbox>\n            </ElCheckboxGroup>\n          </template>\n          <TfFilterDate\n            v-else\n            v-model=\"localValue\"\n            :date-type=\"dateType\"\n            :filter=\"filter\"\n            @changeDateFilterType=\"changeDateFilterType\"\n            @closePopover=\"closePopover\"\n          />\n          <footer>\n            <div class=\"btn-group\">\n              <TfButton\n                :disabled=\"disableBtns\"\n                :data-test=\"`reset ${filter.prop} filter`\"\n                size=\"medium\"\n                type=\"secondary\"\n                @click=\"resetFilters\"\n                v-text=\"'Reset'\"\n              />\n              <TfButton\n                :disabled=\"disableBtns\"\n                :data-test=\"`apply ${filter.prop} filter`\"\n                size=\"medium\"\n                @click=\"applyFilter\"\n                v-text=\"'Done'\"\n              />\n            </div>\n          </footer>\n        </template>\n      </div>\n      <ElInput\n        slot=\"reference\"\n        v-bind=\"{\n          class: [{ 'is-active': showPopover && !disabled }, 'input-filter'],\n          disabled,\n          name: filterPropName,\n          placeholder: filter.label,\n          readonly: !['string', 'range', 'array'].includes(filter.type),\n        }\"\n        v-model=\"searchValue\"\n        :data-test=\"`edit ${filter.prop} filter`\"\n        @keydown.native.tab=\"focusOnCheckbox\"\n      >\n        <icon\n          slot=\"suffix\"\n          name=\"caret-down\"\n          :data-prop-name=\"filterPropName\"\n          @click=\"toggleIcon\"\n        />\n      </ElInput>\n    undefined>\n    <div\n      v-if=\"value.length\"\n      class=\"tf-filter-values-container\"\n    >\n      <span\n        v-for=\"option in displayOptions\"\n        :key=\"option.text\"\n        class=\"tf-filter-value\"\n      >\n        <template v-if=\"option.text\">\n          {{ option.text }}\n        </template>\n        <slot\n          v-else\n          name=\"noValue\"\n        >\n          &mdash;\n        </slot>\n        <TfButton\n          no-padding\n          class=\"btn-remove-filter-value\"\n          type=\"primary\"\n          icon=\"times\"\n          size=\"icon-no-fill\"\n          @click=\"removeValue(option.id)\"\n        />\n      </span>\n    </div>\n  </div>\n</template>\n\n<script>\n  import TfFilterDate from './Date';\n\n  export default {\n    components: { TfFilterDate },\n    props: {\n      disabled: {\n        type: Boolean,\n        default: false,\n      },\n      filter: {\n        type: Object,\n        required: true,\n      },\n      labelKey: {\n        type: String,\n        default: 'label',\n      },\n      value: {\n        type: Array,\n        default: () => [],\n      },\n      valueKey: {\n        type: String,\n        default: 'value',\n      },\n    },\n    data: (vm) => ({\n      dateType: null,\n      localValue: [...vm.value],\n      localOptions: [],\n      searchValue: '',\n      showPopover: false,\n      timer: 0,\n    }),\n    computed: {\n      /**\n       * If the filter is a 'date-range', 'date-range-input', or 'month' dateType, then test for all values.\n       *\n       * @returns {Array}\n       */\n      disableBtns() {\n        let disableBtns = false;\n\n        if (['date-range-input', 'date-range'].includes(this.dateType)) {\n          disableBtns = this.localValue[0]\n            ? this.localValue[0].includes('')\n            : true;\n        } else if (this.dateType === 'month') {\n          disableBtns = !this.localValue[0];\n        }\n\n        return disableBtns;\n      },\n      /**\n       * Map this.value to either the value or the appropriate label.\n       * For filter types that are a range, we want to create this list\n       * from this.filter.options since that has the appropriate order.\n       *\n       * @returns {Array}\n       */\n      displayOptions() {\n        const values = this.value.map((id) => {\n          const formatDate = (dateValue, format = 'MM/DD/YY') => this.$TF.DatesUtils.formatSimpleDate(dateValue, format);\n          let text;\n\n          if (this.filter.type === 'range') {\n            ({ [this.labelKey]: text } = this.filter.options.find(\n              ({ [this.valueKey]: localValue }) => localValue === id,\n            ));\n          } else if (this.filter.type === 'string' || this.filter.type === 'array') {\n            text = id;\n          } else if (this.filter.dateType === 'month') {\n            text = formatDate(id, 'MMMM YYYY');\n          } else if (['date-range', 'date-range-input'].includes(this.filter.dateType)) {\n            const [from, to] = id;\n\n            text = `${formatDate(from)}-${formatDate(to)}`;\n          }\n\n          return { id, text };\n        });\n        let displayOptions;\n\n        if (this.filter.type === 'range') {\n          displayOptions = [];\n\n          this.filter.options.forEach((option) => {\n            if (this.value.includes(option[this.valueKey])) {\n              displayOptions.push({\n                id: option[this.valueKey],\n                text: option[this.labelKey],\n              });\n            }\n          });\n        } else {\n          // eslint-disable-next-line vue/no-side-effects-in-computed-properties\n          displayOptions = this.$TF.Formatting.sortObjects(values, 'text');\n        }\n\n        return displayOptions;\n      },\n      /**\n       * Cache a string based on the filter's prop to be used throughout the template.\n       *\n       * @returns {string}\n       */\n      filterPropName() {\n        return `filter-${this.filter.prop}`;\n      },\n    },\n    watch: {\n      /**\n       * The reset button is controlled in the parent so we want to watch\n       * for when the model is emptied from the parent to reset the local filter values.\n       */\n      value() {\n        if (!this.value.length) {\n          this.resetFilters();\n        }\n      },\n      searchValue: {\n        /**\n         * Debounce the search value to filter the options.\n         *\n         * @param {string} val\n         */\n        handler(val) {\n          if (!['range', 'string', 'array'].includes(this.filter.type)) {\n            this.localOptions = this.filter.options;\n            return;\n          }\n\n          clearTimeout(this.timer);\n\n          this.timer = setTimeout(() => {\n            const filteredResults = [];\n            let maxResults = 0;\n            let i = 0;\n\n            while (maxResults < 30 && i < this.filter.options.length) {\n              if (\n                !val\n                || this.filter.options[i][this.labelKey].toLowerCase().includes(val.toLowerCase())\n              ) {\n                filteredResults.push(this.filter.options[i]);\n                maxResults += 1;\n              }\n              i += 1;\n            }\n\n            this.localOptions = filteredResults;\n          }, 200);\n        },\n        immediate: true,\n      },\n    },\n    created() {\n      this.changeDateType();\n    },\n    methods: {\n      /**\n       * Close the popover and if there is a change in filter values,\n       * $emit the localValue to the parent.\n       */\n      applyFilter() {\n        if (\n          this.value.length === this.localValue.length\n          && this.localValue.every((value) => this.value.includes(value))\n        ) {\n          this.closePopover();\n          return;\n        }\n\n        if (this.dateType) {\n          this.$emit('changeDateFilterType', this.dateType);\n        }\n\n        this.$emit('input', this.localValue);\n        this.closePopover();\n      },\n\n      /**\n       * Clear or reset the localValue based on the passed param.\n       * $emit the localValue to the parent.\n       *\n       * @param {string} dateFilterType\n       */\n      changeDateFilterType(dateFilterType) {\n        const newLocalValue = this.filter.dateType === dateFilterType\n          ? this.value\n          : [];\n\n        this.dateType = dateFilterType;\n        this.$set(this, 'localValue', newLocalValue);\n\n        /* Changing the filter type will change the content of the\n         * popover but not inform the underlying Popover component\n         * that it has been updated. Calling updatePopper explicitly\n         * on tf-tooltip will schedule a re-render / repositioning */\n        if (this.$refs['tf-tooltip'].updatePopper) {\n          this.$refs['tf-tooltip'].updatePopper();\n        }\n      },\n\n      /**\n       * Clear or reset the localValue based on the passed param.\n       * $emit the localValue to the parent.\n       */\n      changeDateType() {\n        if (!this.filter.dateType) {\n          return;\n        }\n\n        let dateType = this.filter.dateType || this.filter.type;\n\n        if (this.filter.type === 'month-and-date-range') {\n          dateType = this.value[0] && Array.isArray(this.value[0])\n            ? 'date-range'\n            : 'month';\n        }\n\n        this.dateType = dateType;\n      },\n\n      /**\n       * Clear the search value, closes the popover.\n       * Clear the localValue if desired.\n       *\n       * @param {boolean} resetValue\n       */\n      closePopover(resetValue = false) {\n        if (!this.showPopover) {\n          return;\n        }\n        this.showPopover = false;\n        this.searchValue = '';\n\n        if (resetValue) {\n          this.$set(this, 'localValue', [...this.value]);\n          this.changeDateType();\n        }\n\n        // I'm wrapping this due a test failure that\n        // I'm not sure of a way around right now.\n        // TypeError: this.$refs.tf-tooltip.doClose is not a function\n        if (this.$refs['tf-tooltip'].doClose) {\n          this.$refs['tf-tooltip'].doClose();\n        }\n      },\n\n      /**\n       * If the user hits tab while focused on the main input,\n       * we move the user to the next checkbox. Element does something odd\n       * so this needs to be done on nextTick().\n       *\n       * @param {object} $event\n       * @param {string} $event.shiftKey\n       */\n      focusOnCheckbox({ shiftKey }) {\n        if (!shiftKey) {\n          this.$nextTick(() => {\n            this.$refs.checkbox[0].$el.querySelector('input').focus();\n          });\n        }\n      },\n\n      /**\n       * Evaluate the the clicked element's name to close the popover and reset the values.\n       *\n       * @param {object} event\n       */\n      onClickOutside(event) {\n        if ((event.target.name\n          || event.target.getAttribute('data-prop-name'))\n          === `${this.filterPropName}`) {\n          return;\n        }\n        this.closePopover(true);\n      },\n\n      /**\n       * Close popover with caret\n       *\n       */\n      toggleIcon() {\n        if (this.showPopover) {\n          // delay close of popover as multiple popovers may exist and conflict with onClickOutside\n          this.$forceNextTick(() => {\n            this.closePopover(true);\n          });\n        }\n      },\n\n      /**\n       * Remove the value from the localValue and $emit to the parent.\n       *\n       * @param {string | Array} value\n       */\n      removeValue(value) {\n        const index = this.localValue.findIndex((localValue) => localValue === value);\n\n        this.localValue.splice(index, 1);\n        this.$emit('input', this.localValue);\n      },\n      /**\n       * Reset the localValue and create a random ID for the calendars.\n       */\n      resetFilters() {\n        this.$set(this, 'localValue', []);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  footer {\n    padding: 10px 0;\n    border-top: 1px solid $tf-medium-gray;\n  }\n\n  .tf-button {\n    &.btn-remove-filter-value {\n      margin-top: 2px;\n    }\n\n    &.tf-button--secondary {\n      border-color: $tf-white;\n    }\n  }\n\n  .tf-popper {\n    padding: 0;\n    box-sizing: border-box;\n    background: $tf-white;\n    border: 1px solid $tf-blue;\n    border-radius: 2px;\n    text-align: left;\n  }\n\n  .tf-filter {\n    &-value {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      padding: 5px 7px 5px 15px;\n      font-size: 14px;\n\n      > span {\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n      }\n    }\n\n    &-values-container {\n      background: $tf-extra-light-gray-2;\n      border: 1px solid $tf-light-gray;\n      border: {\n        top: 0;\n        radius: 0 0 2px 2px;\n      }\n    }\n  }\n\n  ::v-deep .el {\n    &-checkbox {\n      display: flex;\n      padding: 12px 10px;\n      cursor: pointer;\n\n      &:not(:last-child) {\n        border-bottom: 1px $tf-extra-light-gray-1 solid;\n      }\n\n      &-group {\n        box-sizing: border-box;\n        max-height: 300px;\n        width: auto;\n        min-width: 200px;\n        overflow-y: auto;\n        position: relative;\n      }\n\n      &__inner {\n        margin-top: 2px;\n      }\n\n      &__label {\n        line-height: 20px;\n      }\n\n      + .el-checkbox {\n        margin-left: 0;\n      }\n\n      &:hover {\n        background: $tf-light-blue;\n        color: $tf-blue;\n      }\n    }\n\n    /* stylelint-disable selector-max-compound-selectors */\n    /* stylelint-disable max-nesting-depth  */\n    &-input {\n      &__suffix {\n        display: flex;\n        align-items: center;\n        margin-right: 6px;\n        cursor: pointer;\n\n        svg {\n          height: 22px;\n          width: 14px;\n\n          path {\n            pointer-events: none;\n          }\n        }\n      }\n\n      &__suffix-inner {\n        padding-top: 3px;\n      }\n\n      &.input-filter.is-active {\n        svg {\n          fill: $tf-blue;\n          transform: rotate(180deg);\n        }\n      }\n\n      input {\n        height: 30px;\n        line-height: 30px;\n\n        &::placeholder {\n          opacity: 1;\n          color: $tf-medium-gray;\n        }\n      }\n\n      svg {\n        transition: transform .2s ease-out;\n        transform-origin: center;\n        transform: rotate(0deg);\n      }\n    }\n    /* stylelint-enable selector-max-compound-selectors */\n    /* stylelint-enable max-nesting-depth  */\n  }\n\n  .empty-search {\n    display: block;\n    padding: 10px 15px;\n    color: $tf-medium-gray;\n    font-style: italic;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$u = "data-v-278d1cb3";
  /* module identifier */
  const __vue_module_identifier__$u = undefined;
  /* functional template */
  const __vue_is_functional_template__$u = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$u = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$t, staticRenderFns: __vue_staticRenderFns__$t },
    __vue_inject_styles__$u,
    __vue_script__$u,
    __vue_scope_id__$u,
    __vue_is_functional_template__$u,
    __vue_module_identifier__$u,
    false,
    browser,
    undefined,
    undefined
  );

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfFormBuilder is a component that is fed a nested array of form items and an object model. The form items array should be arranged in a format of `{Array<Array<Object>>}`. Where each first level of the index is a row in the template and each object is a column in that row. The form items should also contain any rules that are validated on blur.
 *
 * @vuedoc
 * @exports TfForm/TfFormBuilder
 * @category components
 */
var script$v = {
  name: 'TfFormBuilder',
  props: {
    formItems: {
      type: Array,
      required: true
    },
    isLoaded: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    /**
     * Validate the field and emit $blur, which should include the prop and its validity.
     *
     * @param {string} prop
     */
    onBlur: function onBlur(prop) {
      var isValid = true;
      this.$refs.form.validateField(prop, function (error) {
        isValid = !error;
      });
      this.$emit('blur', {
        isValid: isValid,
        prop: prop
      });
    },
    /**
     * Clone the model, mutate the appropriate prop, $emit and clear any validation.
     *
     * @param {string} prop
     * @param {number | string} value
     */
    onInput: function onInput(prop, value) {
      var newValue = _objectSpread$2(_objectSpread$2({}, this.value), {}, _defineProperty({}, prop, value));
      this.$emit('input', newValue);
      this.$refs.form.clearValidate(prop);
    },
    /**
     * Validate the form and $emit 'submit' to the parent if passing when a user hits the ENTER key on an input. The parent component handles the logic for validating and submitting each of the detail sections holistically.
     */
    onSubmit: function onSubmit() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          return;
        }
        _this.$emit('submit');
      });
    }
  }
};

/* script */
const __vue_script__$v = script$v;

/* template */
var __vue_render__$u = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ElForm",
    _vm._b(
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: !_vm.isLoaded,
            expression: "!isLoaded",
          },
        ],
        ref: "form",
        attrs: { "label-position": "top" },
      },
      "ElForm",
      { model: _vm.value },
      false
    ),
    _vm._l(_vm.formItems, function (formItemRow, index) {
      return _c(
        "div",
        { key: index, staticClass: "form-group" },
        _vm._l(formItemRow, function (formItem) {
          return _c(
            "ElFormItem",
            _vm._b(
              {
                key: formItem.props.prop,
                style: { width: formItem.width },
                attrs: { size: "medium", "data-test": "form item " + index },
              },
              "ElFormItem",
              Object.assign({}, formItem.props, { rules: formItem.rules }),
              false
            ),
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _vm._t(
                    "label",
                    function () {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(formItem.props.label) +
                            "\n        "
                        ),
                      ]
                    },
                    null,
                    { prop: formItem.props.prop }
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _vm._t(
                "formElement",
                function () {
                  return [
                    ["text", "number", "textarea"].includes(formItem.props.type)
                      ? _c(
                          "ElInput",
                          _vm._b(
                            {
                              attrs: {
                                "data-test": "edit " + formItem.props.prop,
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.onBlur(formItem.props.prop)
                                },
                                input: function ($event) {
                                  return _vm.onInput(
                                    formItem.props.prop,
                                    $event
                                  )
                                },
                              },
                              nativeOn: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.onSubmit.apply(null, arguments)
                                },
                              },
                            },
                            "ElInput",
                            Object.assign({}, formItem.props, {
                              disabled: _vm.isSaving || formItem.props.disabled,
                              value: _vm.value[formItem.props.prop],
                            }),
                            false
                          )
                        )
                      : formItem.props.type === "date"
                      ? _c(
                          "TfDatepicker",
                          _vm._b(
                            {
                              attrs: {
                                "data-test": "edit " + formItem.props.prop,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.onInput(
                                    formItem.props.prop,
                                    $event
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.onBlur(formItem.props.prop)
                                },
                              },
                            },
                            "TfDatepicker",
                            Object.assign({}, formItem.props, {
                              disabled: _vm.isSaving || formItem.props.disabled,
                              value: _vm.value[formItem.props.prop],
                            }),
                            false
                          )
                        )
                      : formItem.props.type === "select"
                      ? _c(
                          "TfInputWithOptions",
                          _vm._b(
                            {
                              attrs: {
                                "data-test": "edit " + formItem.props.prop,
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.onBlur(formItem.props.prop)
                                },
                                input: function ($event) {
                                  return _vm.onInput(
                                    formItem.props.prop,
                                    $event
                                  )
                                },
                              },
                            },
                            "TfInputWithOptions",
                            Object.assign({}, formItem.props, {
                              disabled: _vm.isSaving || formItem.props.disabled,
                              value: _vm.value[formItem.props.prop],
                            }),
                            false
                          )
                        )
                      : formItem.props.type === "switch"
                      ? _c(
                          "ElSwitch",
                          _vm._b(
                            {
                              class: { "is-inline": formItem.isInline },
                              attrs: {
                                "data-test": "edit " + formItem.props.prop,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("switchChange", {
                                    prop: formItem.props.prop,
                                    value: $event,
                                  })
                                },
                                input: function ($event) {
                                  return _vm.onInput(
                                    formItem.props.prop,
                                    $event
                                  )
                                },
                              },
                            },
                            "ElSwitch",
                            Object.assign({}, formItem.props, {
                              disabled: _vm.isSaving || formItem.props.disabled,
                              value: _vm.value[formItem.props.prop],
                            }),
                            false
                          )
                        )
                      : _vm._e(),
                  ]
                },
                null,
                { formItem: formItem }
              ),
            ],
            2
          )
        }),
        1
      )
    }),
    0
  )
};
var __vue_staticRenderFns__$u = [];
__vue_render__$u._withStripped = true;

  /* style */
  const __vue_inject_styles__$v = function (inject) {
    if (!inject) return
    inject("data-v-039b507b_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.form-group[data-v-039b507b] {\n  display: flex;\n  margin: 0 -12px;\n}\n[data-v-039b507b] .el-form,[data-v-039b507b] .el-form-item {\n  width: 100%;\n}\n[data-v-039b507b] .el-form-item {\n  margin-left: 12px;\n  margin-right: 12px;\n}\n[data-v-039b507b] .el-form-item__error {\n  position: relative;\n}\n[data-v-039b507b] .el-form-item > .el-form-item__label {\n  line-height: 40px;\n}\n[data-v-039b507b] .el-select {\n  display: inline-block;\n}\n[data-v-039b507b] .el-switch.is-inline {\n  height: 40px;\n}\n[data-v-039b507b] .el-switch:not(.is-inline) {\n  width: 100%;\n}\n[data-v-039b507b] .el-textarea__inner {\n  resize: none;\n}\n[data-v-039b507b] .vdp-datepicker {\n  display: block;\n  z-index: 100;\n}\n[data-v-039b507b] .vdp-datepicker,[data-v-039b507b] .vdp-datepicker input {\n  width: 100%;\n}\n\n/*# sourceMappingURL=TfFormBuilder.vue.map */", map: {"version":3,"sources":["TfFormBuilder.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfForm/TfFormBuilder.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACqKlC;EACA,aAAA;EACA,eAAA;ADnKA;ACwKA;EAEA,WAAA;ADtKA;ACyKA;EAEA,iBAAA;EACA,kBAAA;ADxKA;AC2KA;EACA,kBAAA;ADzKA;AC4KA;EACA,iBAAA;AD1KA;AC+KA;EACA,qBAAA;AD7KA;ACiLA;EACA,YAAA;AD/KA;ACkLA;EACA,WAAA;ADhLA;ACoLA;EACA,YAAA;ADlLA;ACqLA;EACA,cAAA;EACA,YAAA;ADnLA;ACqLA;EAEA,WAAA;ADnLA;;AAEA,4CAA4C","file":"TfFormBuilder.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.form-group {\n  display: flex;\n  margin: 0 -12px;\n}\n\n::v-deep .el-form, ::v-deep .el-form-item {\n  width: 100%;\n}\n::v-deep .el-form-item {\n  margin-left: 12px;\n  margin-right: 12px;\n}\n::v-deep .el-form-item__error {\n  position: relative;\n}\n::v-deep .el-form-item > .el-form-item__label {\n  line-height: 40px;\n}\n::v-deep .el-select {\n  display: inline-block;\n}\n::v-deep .el-switch.is-inline {\n  height: 40px;\n}\n::v-deep .el-switch:not(.is-inline) {\n  width: 100%;\n}\n::v-deep .el-textarea__inner {\n  resize: none;\n}\n::v-deep .vdp-datepicker {\n  display: block;\n  z-index: 100;\n}\n::v-deep .vdp-datepicker,\n::v-deep .vdp-datepicker input {\n  width: 100%;\n}\n\n/*# sourceMappingURL=TfFormBuilder.vue.map */","<template>\n  <ElForm\n    ref=\"form\"\n    v-bind=\"{ model: value }\"\n    v-loading=\"!isLoaded\"\n    label-position=\"top\"\n  >\n    <div\n      v-for=\"(formItemRow, index) in formItems\"\n      :key=\"index\"\n      class=\"form-group\"\n    >\n      <ElFormItem\n        v-for=\"formItem in formItemRow\"\n        :key=\"formItem.props.prop\"\n        v-bind=\"{\n          ...formItem.props,\n          rules: formItem.rules,\n        }\"\n        :style=\"{ width: formItem.width }\"\n        size=\"medium\"\n        :data-test=\"`form item ${index}`\"\n      >\n        <template slot=\"label\">\n          <slot\n            name=\"label\"\n            v-bind=\"{ prop: formItem.props.prop }\"\n          >\n            {{ formItem.props.label }}\n          </slot>\n        </template>\n        <slot\n          name=\"formElement\"\n          v-bind=\"{ formItem }\"\n        >\n          <ElInput\n            v-if=\"[\n              'text',\n              'number',\n              'textarea',\n            ].includes(formItem.props.type)\"\n            v-bind=\"{\n              ...formItem.props,\n              disabled: isSaving || formItem.props.disabled,\n              value: value[formItem.props.prop],\n            }\"\n            :data-test=\"`edit ${formItem.props.prop}`\"\n            @blur=\"onBlur(formItem.props.prop)\"\n            @input=\"onInput(formItem.props.prop, $event)\"\n            @keydown.native.enter=\"onSubmit\"\n          />\n          <TfDatepicker\n            v-else-if=\"formItem.props.type === 'date'\"\n            v-bind=\"{\n              ...formItem.props,\n              disabled: isSaving || formItem.props.disabled,\n              value: value[formItem.props.prop],\n            }\"\n            :data-test=\"`edit ${formItem.props.prop}`\"\n            @input=\"onInput(formItem.props.prop, $event)\"\n            @blur=\"onBlur(formItem.props.prop)\"\n          />\n          <TfInputWithOptions\n            v-else-if=\"formItem.props.type === 'select'\"\n            v-bind=\"{\n              ...formItem.props,\n              disabled: isSaving || formItem.props.disabled,\n              value: value[formItem.props.prop],\n            }\"\n            :data-test=\"`edit ${formItem.props.prop}`\"\n            @blur=\"onBlur(formItem.props.prop)\"\n            @input=\"onInput(formItem.props.prop, $event)\"\n          />\n          <ElSwitch\n            v-else-if=\"formItem.props.type === 'switch'\"\n            v-bind=\"{\n              ...formItem.props,\n              disabled: isSaving || formItem.props.disabled,\n              value: value[formItem.props.prop],\n            }\"\n            :class=\"{ 'is-inline': formItem.isInline }\"\n            :data-test=\"`edit ${formItem.props.prop}`\"\n            @change=\"$emit('switchChange', { prop: formItem.props.prop, value: $event })\"\n            @input=\"onInput(formItem.props.prop, $event)\"\n          />\n        </slot>\n      </ElFormItem>\n    </div>\n  </ElForm>\n</template>\n\n<script>\n  /**\n   * TfFormBuilder is a component that is fed a nested array of form items and an object model. The form items array should be arranged in a format of `{Array<Array<Object>>}`. Where each first level of the index is a row in the template and each object is a column in that row. The form items should also contain any rules that are validated on blur.\n   *\n   * @vuedoc\n   * @exports TfForm/TfFormBuilder\n   * @category components\n   */\n  export default {\n    name: 'TfFormBuilder',\n    props: {\n      formItems: {\n        type: Array,\n        required: true,\n      },\n      isLoaded: {\n        type: Boolean,\n        default: false,\n      },\n      isSaving: {\n        type: Boolean,\n        default: false,\n      },\n      value: {\n        type: Object,\n        required: true,\n      },\n    },\n    methods: {\n      /**\n       * Validate the field and emit $blur, which should include the prop and its validity.\n       *\n       * @param {string} prop\n       */\n      onBlur(prop) {\n        let isValid = true;\n\n        this.$refs.form.validateField(prop, (error) => {\n          isValid = !error;\n        });\n\n        this.$emit('blur', { isValid, prop });\n      },\n      /**\n       * Clone the model, mutate the appropriate prop, $emit and clear any validation.\n       *\n       * @param {string} prop\n       * @param {number | string} value\n       */\n      onInput(prop, value) {\n        const newValue = {\n          ...this.value,\n          [prop]: value,\n        };\n        this.$emit('input', newValue);\n        this.$refs.form.clearValidate(prop);\n      },\n      /**\n       * Validate the form and $emit 'submit' to the parent if passing when a user hits the ENTER key on an input. The parent component handles the logic for validating and submitting each of the detail sections holistically.\n       */\n      onSubmit() {\n        this.$refs.form.validate((valid) => {\n          if (!valid) {\n            return;\n          }\n\n          this.$emit('submit');\n        });\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  .form-group {\n    display: flex;\n    margin: 0 (-$tf-form-half-gutter);\n  }\n\n  ::v-deep {\n    .el-form {\n      &,\n      &-item {\n        width: 100%;\n      }\n\n      &-item {\n        margin: {\n          left: $tf-form-half-gutter;\n          right: $tf-form-half-gutter;\n        }\n\n        &__error {\n          position: relative;\n        }\n\n        > .el-form-item__label {\n          line-height: 40px;\n        }\n      }\n    }\n\n    .el-select {\n      display: inline-block;\n    }\n\n    .el-switch {\n      &.is-inline {\n        height: 40px;\n      }\n\n      &:not(.is-inline) {\n        width: 100%;\n      }\n    }\n\n    .el-textarea__inner {\n      resize: none;\n    }\n\n    .vdp-datepicker {\n      display: block;\n      z-index: 100;\n\n      &,\n      input {\n        width: 100%;\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$v = "data-v-039b507b";
  /* module identifier */
  const __vue_module_identifier__$v = undefined;
  /* functional template */
  const __vue_is_functional_template__$v = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$v = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$u, staticRenderFns: __vue_staticRenderFns__$u },
    __vue_inject_styles__$v,
    __vue_script__$v,
    __vue_scope_id__$v,
    __vue_is_functional_template__$v,
    __vue_module_identifier__$v,
    false,
    browser,
    undefined,
    undefined
  );

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * A component made to build out a list of the TfInputWithOptions component. The options are required to be in a [{ label, value }] format and the model is a flat array of strings/numbers, both of which are provided as props from the parent.
 * This component will also validate the inputs based on the rules that are passed and clear validation on @input. If the on blur on TfInputWithOptions has a violation, $emit('blur') will not happen.
 *
 * @vuedoc
 * @exports TfForm/FormList
 * @category components
 */
var script$w = {
  name: 'TfFormList',
  props: {
    /**
     * Render the "Add another" CTA in the template.
     */
    allowAddAnother: {
      type: Boolean,
      default: true
    },
    /**
     * Allow all form items to be deleted even if it's the last one left
     */
    allowDeleteFirst: {
      type: Boolean,
      default: false
    },
    /**
     * Allow multiple options to be the value. ['option 1', 'option 1']
     */
    allowDuplicates: {
      type: Boolean,
      default: false
    },
    /**
     * If there is only one form item left, disable the delete button
     */
    disableDeleteFirst: {
      type: Boolean,
      default: false
    },
    /**
     * Pass "groupDisabled" as true to group any option that has `isDisabled: true` to a "disabledOptions" array.
     * This combined with `showUsedAsDisabled: true` will group any used values to a "disabledOptions" array.
     */
    groupDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * "groupedDisabledOptionsTitle" will render a title above the list of disabled values in the tfInputWithOptions component.
     */
    groupedDisabledOptionsTitle: {
      type: String,
      default: 'Used values'
    },
    /**
     * An array of values that the Delete CTA should be hidden for
     */
    hideDeleteForValues: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * Disable all interactions in the template.
     */
    isDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Render only the first label in the template.
     */
    isSingleLabel: {
      type: Boolean,
      default: true
    },
    /**
     * Render custom label string in the template.
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Render no branding colors template.
     */
    noBranding: {
      type: Boolean,
      default: false
    },
    /**
     * Render the options to choose from in the template.
     */
    options: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(options) {
        return options.every(function (_ref) {
          var label = _ref.label,
            value = _ref.value;
          return value && label;
        });
      }
    },
    /**
     * Render custom placeholder string in the template.
     */
    placeholder: {
      type: String,
      default: 'Select from list or start typing'
    },
    /**
     * An array of values that should not be editable
     */
    readonlyValues: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * Form rules applied to the form items in the template.
     */
    rules: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },
    /**
     * Pass "showUsedAsDisabled" as true to render a list of the used values in the tfInputWithOptions component.
     */
    showUsedAsDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Model
     */
    value: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      invalidIndexes: [],
      replacementArray: []
    };
  },
  computed: {
    /**
     * Evalutate the "groupDisabled", "showUsedAsDisabled", and "options" props to group any disabled options or any used values if "showUsedAsDisabled" is `true`.
     * By default ("groupDisabled" is `false`), this will return an empty array.
     *
     * @returns {Array}
     */
    groupedDisabledOptions: function groupedDisabledOptions() {
      var _this = this;
      if (!this.groupDisabled) {
        return [];
      }

      // Push the option if isDisabled or if the value is included && showUsedAsDisabled is true.
      return this.options.reduce(function (options, option) {
        return option.isDisabled || _this.showUsedAsDisabled && _this.value.includes(option.value) ? options.concat(option) : options;
      }, []);
    },
    /**
     * Evaluate the "allowDuplicates", "showUsedAsDisabled", and "groupDisabled" props to determine if the options should include all or filtered values based on different criteria.
     * "allowDuplicates" will return all options
     * "showUsedAsDisabled" will create a new options array that includes used values in a disabled state, unless "groupDisabled" is `true`, to which they are then excluded.
     * "groupDisabled" will create a new options array that excludes any options with `isDisabled: true` or any used values if "showUsedAsDisabled" is `true`.
     *
     * @returns {Array}
     */
    formListOptions: function formListOptions() {
      var _this2 = this;
      if (this.allowDuplicates) {
        return this.options;
      }
      if (this.showUsedAsDisabled || this.groupDisabled) {
        return this.options.reduce(function (options, option) {
          // Ignore any included or disabled if groupDisabled.
          if (_this2.groupDisabled && (_this2.value.includes(option.value) || option.isDisabled)) {
            return options;
          }
          return options.concat(_objectSpread$3(_objectSpread$3({}, option), {}, {
            isDisabled: _this2.value.includes(option.value) || option.isDisabled || false
          }));
        }, []);
      }
      return this.options.filter(function (_ref2) {
        var value = _ref2.value;
        return !_this2.value.includes(value);
      });
    }
  },
  watch: {
    /**
     * Watch for changes in "disabledOptions" to emit any synced data.
     *
     * @param {Array} newValue
     */
    disabledOptions: function disabledOptions(newValue) {
      this.$emit('update:disabledOptions', newValue);
    },
    /**
     * Watch for changes in "formListOptions" to emit any synced data.
     *
     * @param {Array} newValue
     */
    formListOptions: function formListOptions(newValue) {
      this.$emit('update:formListOptions', newValue);
    }
  },
  created: function created() {
    if (!this.value.length) {
      this.addFormItem();
      return;
    }
    this.$set(this, 'replacementArray', _toConsumableArray(this.value));
  },
  methods: {
    /**
     * Add an empty string to the value and emit to the parent.
     */
    addFormItem: function addFormItem() {
      this.$emit('input', [].concat(_toConsumableArray(this.value), ['']));
      this.replacementArray.push('');
    },
    /**
     * Clear any validation and $emit the new model along with what was deleted.
     *
     * @param {number} index
     */
    deleteInput: function deleteInput(index) {
      var deletedValue = this.value[index];
      var newValue = _toConsumableArray(this.value);
      this.$refs.form.clearValidate("listItems.".concat(index));
      newValue.splice(index, 1);
      this.$emit('deleted', {
        index: index,
        value: deletedValue
      });
      this.$emit('input', newValue);
    },
    /**
     * Validate the form input and $emit 'blur' with the appropriate data for the parent.
     *
     * @param {number} index
     */
    onBlur: function onBlur(index) {
      var isValid = true;
      this.$refs.form.validateField("listItems.".concat(index), function (error) {
        isValid = !error;
      });
      var value = this.value[index];
      var replacementValue = this.replacementArray[index];
      this.$set(this, 'replacementArray', this.value);
      this.$emit('blur', {
        index: index,
        isValid: isValid,
        replaced: replacementValue !== '' && replacementValue !== value ? replacementValue : null,
        value: value
      });
    },
    /**
     * Clone the value prop and $emit new value to parent.
     *
     * @param {number} index
     * @param {number} value
     */
    onInput: function onInput(index, value) {
      this.$refs.form.clearValidate("listItems.".concat(index));
      var newValue = _toConsumableArray(this.value);
      newValue[index] = value;
      this.$emit('input', newValue);
    }
  }
};

/* script */
const __vue_script__$w = script$w;

/* template */
var __vue_render__$v = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    [
      _c(
        "ElForm",
        { ref: "form", attrs: { model: { listItems: _vm.value } } },
        [
          !_vm.value.length
            ? _c(
                "ElFormItem",
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _vm._t("label", function () {
                        return [
                          _vm._v(
                            "\n          " + _vm._s(_vm.label) + "\n        "
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "TransitionGroup",
            { attrs: { name: "slide-in-fade" } },
            _vm._l(_vm.value, function (formItem, index) {
              return _c(
                "div",
                {
                  key: "form-" + index,
                  class: [
                    { "is-hidden-label": _vm.isSingleLabel && index },
                    "form-list-item",
                  ],
                },
                [
                  _c(
                    "ElFormItem",
                    _vm._b(
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "error",
                              fn: function (ref) {
                                var error = ref.error;
                                return _c(
                                  "div",
                                  {
                                    staticClass: "el-form-item__error",
                                    attrs: {
                                      "data-test":
                                        "error message for listItem_" + index,
                                    },
                                  },
                                  [
                                    _vm._t(
                                      "error",
                                      function () {
                                        return [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(error) +
                                              "\n            "
                                          ),
                                        ]
                                      },
                                      null,
                                      { error: error }
                                    ),
                                  ],
                                  2
                                )
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      "ElFormItem",
                      {
                        prop: "listItems." + index,
                        rules: _vm.rules,
                      },
                      false
                    ),
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _vm._t(
                            "label",
                            function () {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.label) +
                                    "\n            "
                                ),
                              ]
                            },
                            null,
                            { index: index }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._v(" "),
                      _c(
                        "TfInputWithOptions",
                        _vm._b(
                          {
                            attrs: { "data-test": "list items " + index },
                            on: {
                              blur: function ($event) {
                                return _vm.onBlur(index)
                              },
                              input: function ($event) {
                                return _vm.onInput(index, $event)
                              },
                            },
                          },
                          "TfInputWithOptions",
                          {
                            allowEnter: false,
                            disabled:
                              _vm.isDisabled ||
                              (_vm.readonlyValues.length > 0 &&
                                _vm.readonlyValues.includes(formItem)),
                            groupedDisabledOptions: _vm.groupedDisabledOptions,
                            groupedDisabledOptionsTitle:
                              _vm.groupedDisabledOptionsTitle,
                            optionKey: "value",
                            optionLabel: "label",
                            options: _vm.formListOptions,
                            placeholder: _vm.placeholder,
                            prop: "listItems." + index,
                            value: _vm.value[index],
                          },
                          false
                        )
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  (!_vm.hideDeleteForValues.length &&
                    (_vm.allowDeleteFirst || _vm.value.length > 1)) ||
                  (_vm.hideDeleteForValues.length &&
                    !_vm.hideDeleteForValues.includes(formItem))
                    ? _c(
                        "div",
                        { staticClass: "container-btn-group" },
                        [
                          _c(
                            "AppButton",
                            _vm._b(
                              {
                                attrs: {
                                  "data-test": "delete form list item",
                                  icon: "fa-solid fa-trash-can",
                                  size: "icon",
                                  type: "decline",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteInput(index)
                                  },
                                },
                              },
                              "AppButton",
                              {
                                isDisabled:
                                  _vm.isDisabled ||
                                  (_vm.disableDeleteFirst &&
                                    _vm.value.length === 1),
                                noBranding: _vm.noBranding,
                              },
                              false
                            )
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.allowAddAnother
        ? _c(
            "AppButton",
            _vm._b(
              {
                attrs: {
                  "data-test": "add form list item",
                  type: "primary",
                  size: "text",
                },
                on: { click: _vm.addFormItem },
              },
              "AppButton",
              {
                isDisabled: _vm.isDisabled,
                noBranding: _vm.noBranding,
              },
              false
            ),
            [
              _vm._t("addAnother", function () {
                return [_vm._v("\n      Add another\n    ")]
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$v = [];
__vue_render__$v._withStripped = true;

  /* style */
  const __vue_inject_styles__$w = function (inject) {
    if (!inject) return
    inject("data-v-a9b5d3c4_0", { source: ".form-list-item[data-v-a9b5d3c4] {\n  display: flex;\n}\n.form-list-item[data-v-a9b5d3c4]  > .el-form-item {\n  flex: 1;\n}\n.form-list-item[data-v-a9b5d3c4]  .el-select {\n  width: 100%;\n}\n.form-list-item[data-v-a9b5d3c4]  .el-form-item__label:before {\n  display: none;\n}\n.form-list-item[data-v-a9b5d3c4]  .el-form-item__error {\n  position: relative;\n}\n.is-hidden-label[data-v-a9b5d3c4]  .el-form-item__label {\n  display: none;\n}\n.container-btn-group[data-v-a9b5d3c4] {\n  padding: 38px 0 0 3px;\n}\n.is-hidden-label .container-btn-group[data-v-a9b5d3c4] {\n  padding-top: 0;\n}\n.plan-design-dropdown-container[data-v-a9b5d3c4] {\n  width: 100%;\n}\n\n/*\n  I'm commenting this out for now b/c there is a timing issue when deleting a value.\n  There's a fix on https://vuejs.org/v2/guide/transitions.html#List-Move-Transitions,\n  but we don't have the time for that for now.\n*/\n\n/*# sourceMappingURL=TfFormList.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfForm/TfFormList.vue","TfFormList.vue"],"names":[],"mappings":"AAuYA;EACA,aAAA;ACtYA;ADyYA;EACA,OAAA;ACvYA;AD0YA;EACA,WAAA;ACxYA;AD4YA;EACA,aAAA;AC1YA;AD6YA;EACA,kBAAA;AC3YA;ADkZA;EACA,aAAA;AC/YA;ADmZA;EACA,qBAAA;AChZA;ADkZA;EACA,cAAA;AChZA;ADoZA;EACA,WAAA;ACjZA;;ADoZA;;;;CAAA;;AC5YA,yCAAyC","file":"TfFormList.vue","sourcesContent":["<template>\n  <section>\n    <ElForm\n      ref=\"form\"\n      :model=\"{ listItems: value }\"\n    >\n      <!--Still display the label if all form items in the list have been deleted-->\n      <ElFormItem v-if=\"!value.length\">\n        <template slot=\"label\">\n          <slot name=\"label\">\n            {{ label }}\n          </slot>\n        </template>\n      </ElFormItem>\n      <!--Render form items normally if there are any present-->\n      <TransitionGroup name=\"slide-in-fade\">\n        <div\n          v-for=\"(formItem, index) in value\"\n          :key=\"`form-${index}`\"\n          :class=\"[\n            { 'is-hidden-label': isSingleLabel && index },\n            'form-list-item'\n          ]\"\n        >\n          <ElFormItem\n            v-bind=\"{\n              prop: `listItems.${index}`,\n              rules,\n            }\"\n          >\n            <template slot=\"label\">\n              <slot\n                name=\"label\"\n                v-bind=\"{ index }\"\n              >\n                {{ label }}\n              </slot>\n            </template>\n            <!-- Class is required for element's styles -->\n            <div\n              slot=\"error\"\n              slot-scope=\"{ error }\"\n              class=\"el-form-item__error\"\n              :data-test=\"`error message for listItem_${index}`\"\n            >\n              <slot\n                name=\"error\"\n                v-bind=\"{ error }\"\n              >\n                {{ error }}\n              </slot>\n            </div>\n            <TfInputWithOptions\n              v-bind=\"{\n                allowEnter: false,\n                disabled: isDisabled ||\n                  (readonlyValues.length > 0 && readonlyValues.includes(formItem)),\n                groupedDisabledOptions,\n                groupedDisabledOptionsTitle,\n                optionKey: 'value',\n                optionLabel: 'label',\n                options: formListOptions,\n                placeholder,\n                prop: `listItems.${index}`,\n                value: value[index],\n              }\"\n              :data-test=\"`list items ${index}`\"\n              @blur=\"onBlur(index)\"\n              @input=\"onInput(index, $event)\"\n            />\n          </ElFormItem>\n          <div\n            v-if=\"\n              !hideDeleteForValues.length && (allowDeleteFirst || value.length > 1)\n                || hideDeleteForValues.length && !hideDeleteForValues.includes(formItem)\"\n            class=\"container-btn-group\"\n          >\n            <AppButton\n              data-test=\"delete form list item\"\n              v-bind=\"{\n                isDisabled: isDisabled || (disableDeleteFirst && value.length === 1),\n                noBranding,\n              }\"\n              icon=\"fa-solid fa-trash-can\"\n              size=\"icon\"\n              type=\"decline\"\n              @click=\"deleteInput(index)\"\n            />\n          </div>\n        </div>\n      </TransitionGroup>\n    </ElForm>\n    <AppButton\n      v-if=\"allowAddAnother\"\n      data-test=\"add form list item\"\n      v-bind=\"{\n        isDisabled,\n        noBranding,\n      }\"\n      type=\"primary\"\n      size=\"text\"\n      @click=\"addFormItem\"\n    >\n      <slot name=\"addAnother\">\n        Add another\n      </slot>\n    </AppButton>\n  </section>\n</template>\n<script>\n  /**\n   * A component made to build out a list of the TfInputWithOptions component. The options are required to be in a [{ label, value }] format and the model is a flat array of strings/numbers, both of which are provided as props from the parent.\n   * This component will also validate the inputs based on the rules that are passed and clear validation on @input. If the on blur on TfInputWithOptions has a violation, $emit('blur') will not happen.\n   *\n   * @vuedoc\n   * @exports TfForm/FormList\n   * @category components\n   */\n  export default {\n    name: 'TfFormList',\n    props: {\n      /**\n       * Render the \"Add another\" CTA in the template.\n       */\n      allowAddAnother: {\n        type: Boolean,\n        default: true,\n      },\n      /**\n       * Allow all form items to be deleted even if it's the last one left\n       */\n      allowDeleteFirst: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Allow multiple options to be the value. ['option 1', 'option 1']\n       */\n      allowDuplicates: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * If there is only one form item left, disable the delete button\n       */\n      disableDeleteFirst: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Pass \"groupDisabled\" as true to group any option that has `isDisabled: true` to a \"disabledOptions\" array.\n       * This combined with `showUsedAsDisabled: true` will group any used values to a \"disabledOptions\" array.\n       */\n      groupDisabled: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * \"groupedDisabledOptionsTitle\" will render a title above the list of disabled values in the tfInputWithOptions component.\n       */\n      groupedDisabledOptionsTitle: {\n        type: String,\n        default: 'Used values',\n      },\n      /**\n       * An array of values that the Delete CTA should be hidden for\n       */\n      hideDeleteForValues: {\n        type: Array,\n        default: () => [],\n      },\n      /**\n       * Disable all interactions in the template.\n       */\n      isDisabled: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Render only the first label in the template.\n       */\n      isSingleLabel: {\n        type: Boolean,\n        default: true,\n      },\n      /**\n       * Render custom label string in the template.\n       */\n      label: {\n        type: String,\n        default: '',\n      },\n      /**\n       * Render no branding colors template.\n       */\n      noBranding: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Render the options to choose from in the template.\n       */\n      options: {\n        type: Array,\n        default: () => [],\n        validator: (options) => options.every(({ label, value }) => value && label),\n      },\n      /**\n       * Render custom placeholder string in the template.\n       */\n      placeholder: {\n        type: String,\n        default: 'Select from list or start typing',\n      },\n      /**\n       * An array of values that should not be editable\n       */\n      readonlyValues: {\n        type: Array,\n        default: () => [],\n      },\n      /**\n       * Form rules applied to the form items in the template.\n       */\n      rules: {\n        type: [Array, Object],\n        default: () => [],\n      },\n      /**\n       * Pass \"showUsedAsDisabled\" as true to render a list of the used values in the tfInputWithOptions component.\n       */\n      showUsedAsDisabled: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Model\n       */\n      value: {\n        type: Array,\n        required: true,\n      },\n    },\n    data: () => ({\n      invalidIndexes: [],\n      replacementArray: [],\n    }),\n    computed: {\n      /**\n       * Evalutate the \"groupDisabled\", \"showUsedAsDisabled\", and \"options\" props to group any disabled options or any used values if \"showUsedAsDisabled\" is `true`.\n       * By default (\"groupDisabled\" is `false`), this will return an empty array.\n       *\n       * @returns {Array}\n       */\n      groupedDisabledOptions() {\n        if (!this.groupDisabled) {\n          return [];\n        }\n\n        // Push the option if isDisabled or if the value is included && showUsedAsDisabled is true.\n        return this.options.reduce((options, option) => (\n          option.isDisabled || (this.showUsedAsDisabled && this.value.includes(option.value))\n            ? options.concat(option)\n            : options\n        ), []);\n      },\n      /**\n       * Evaluate the \"allowDuplicates\", \"showUsedAsDisabled\", and \"groupDisabled\" props to determine if the options should include all or filtered values based on different criteria.\n       * \"allowDuplicates\" will return all options\n       * \"showUsedAsDisabled\" will create a new options array that includes used values in a disabled state, unless \"groupDisabled\" is `true`, to which they are then excluded.\n       * \"groupDisabled\" will create a new options array that excludes any options with `isDisabled: true` or any used values if \"showUsedAsDisabled\" is `true`.\n       *\n       * @returns {Array}\n       */\n      formListOptions() {\n        if (this.allowDuplicates) {\n          return this.options;\n        }\n\n        if (this.showUsedAsDisabled || this.groupDisabled) {\n          return this.options.reduce((options, option) => {\n            // Ignore any included or disabled if groupDisabled.\n            if (this.groupDisabled && (this.value.includes(option.value) || option.isDisabled)) {\n              return options;\n            }\n\n            return options.concat({\n              ...option,\n              isDisabled: this.value.includes(option.value) || option.isDisabled || false,\n            });\n          }, []);\n        }\n\n        return this.options.filter(({ value }) => !this.value.includes(value));\n      },\n    },\n    watch: {\n      /**\n       * Watch for changes in \"disabledOptions\" to emit any synced data.\n       *\n       * @param {Array} newValue\n       */\n      disabledOptions(newValue) {\n        this.$emit('update:disabledOptions', newValue);\n      },\n      /**\n       * Watch for changes in \"formListOptions\" to emit any synced data.\n       *\n       * @param {Array} newValue\n       */\n      formListOptions(newValue) {\n        this.$emit('update:formListOptions', newValue);\n      },\n    },\n    created() {\n      if (!this.value.length) {\n        this.addFormItem();\n        return;\n      }\n\n      this.$set(this, 'replacementArray', [...this.value]);\n    },\n    methods: {\n      /**\n       * Add an empty string to the value and emit to the parent.\n       */\n      addFormItem() {\n        this.$emit('input', [...this.value, '']);\n        this.replacementArray.push('');\n      },\n      /**\n       * Clear any validation and $emit the new model along with what was deleted.\n       *\n       * @param {number} index\n       */\n      deleteInput(index) {\n        const deletedValue = this.value[index];\n        const newValue = [...this.value];\n\n        this.$refs.form.clearValidate(`listItems.${index}`);\n\n        newValue.splice(index, 1);\n\n        this.$emit('deleted', { index, value: deletedValue });\n        this.$emit('input', newValue);\n      },\n      /**\n       * Validate the form input and $emit 'blur' with the appropriate data for the parent.\n       *\n       * @param {number} index\n       */\n      onBlur(index) {\n        let isValid = true;\n\n        this.$refs.form.validateField(`listItems.${index}`, (error) => {\n          isValid = !error;\n        });\n\n        const value = this.value[index];\n        const replacementValue = this.replacementArray[index];\n\n        this.$set(this, 'replacementArray', this.value);\n        this.$emit('blur', {\n          index,\n          isValid,\n          replaced: replacementValue !== '' && (replacementValue !== value)\n            ? replacementValue\n            : null,\n          value,\n        });\n      },\n      /**\n       * Clone the value prop and $emit new value to parent.\n       *\n       * @param {number} index\n       * @param {number} value\n       */\n      onInput(index, value) {\n        this.$refs.form.clearValidate(`listItems.${index}`);\n\n        const newValue = [...this.value];\n\n        newValue[index] = value;\n\n        this.$emit('input', newValue);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .form-list-item {\n    display: flex;\n\n    ::v-deep {\n      > .el-form-item {\n        flex: 1;\n      }\n\n      .el-select {\n        width: 100%;\n      }\n\n      .el-form-item {\n        &__label:before {\n          display: none;\n        }\n\n        &__error {\n          position: relative;\n        }\n      }\n    }\n  }\n\n  .is-hidden-label {\n    ::v-deep .el-form-item__label {\n      display: none;\n    }\n  }\n\n  .container-btn-group {\n    padding: 38px 0 0 3px;\n\n    .is-hidden-label & {\n      padding-top: 0;\n    }\n  }\n\n  .plan-design-dropdown-container {\n    width: 100%;\n  }\n\n  /*\n    I'm commenting this out for now b/c there is a timing issue when deleting a value.\n    There's a fix on https://vuejs.org/v2/guide/transitions.html#List-Move-Transitions,\n    but we don't have the time for that for now.\n  */\n\n  .slide-in-fade {\n    // &-enter-active,\n    // &-leave-active {\n    //   max-height: 0;\n    //   opacity: 0;\n    //   transition: all .25s ease-in;\n    // }\n\n    // &-enter-to,\n    // &-leave {\n    //   opacity: 1;\n    //   overflow: hidden;\n    //   max-height: 150px;\n    // }\n  }\n</style>\n",".form-list-item {\n  display: flex;\n}\n.form-list-item ::v-deep > .el-form-item {\n  flex: 1;\n}\n.form-list-item ::v-deep .el-select {\n  width: 100%;\n}\n.form-list-item ::v-deep .el-form-item__label:before {\n  display: none;\n}\n.form-list-item ::v-deep .el-form-item__error {\n  position: relative;\n}\n\n.is-hidden-label ::v-deep .el-form-item__label {\n  display: none;\n}\n\n.container-btn-group {\n  padding: 38px 0 0 3px;\n}\n.is-hidden-label .container-btn-group {\n  padding-top: 0;\n}\n\n.plan-design-dropdown-container {\n  width: 100%;\n}\n\n/*\n  I'm commenting this out for now b/c there is a timing issue when deleting a value.\n  There's a fix on https://vuejs.org/v2/guide/transitions.html#List-Move-Transitions,\n  but we don't have the time for that for now.\n*/\n\n/*# sourceMappingURL=TfFormList.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$w = "data-v-a9b5d3c4";
  /* module identifier */
  const __vue_module_identifier__$w = undefined;
  /* functional template */
  const __vue_is_functional_template__$w = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$w = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$v, staticRenderFns: __vue_staticRenderFns__$v },
    __vue_inject_styles__$w,
    __vue_script__$w,
    __vue_scope_id__$w,
    __vue_is_functional_template__$w,
    __vue_module_identifier__$w,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$x = {
  name: 'TfHamburgerMenu',
  props: {
    badgeCount: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      default: 'carrier'
    }
  },
  mounted: function mounted() {
    var _this = this;
    // Adding key listeners to the hamburger menu and menu items so that we can tab to them and hit enter
    this.$refs['hamburger-menu'].$el.addEventListener('keydown', this.checkHamburgerKeyEvent);

    // TODO RI 2021-02-03 can we do this with a nexttick?
    window.setTimeout(function () {
      var menuItems = _this.$el.querySelectorAll('.tf-hamburger-popper .el-menu-item');
      if (menuItems.length) {
        for (var i = 0; i < menuItems.length; i += 1) {
          menuItems[i].addEventListener('keydown', _this.clickMenuItem);
        }
      }
    }, 500);
  },
  beforeDestroy: function beforeDestroy() {
    // Removing previously added key listeners
    this.$refs['hamburger-menu'].$el.removeEventListener('keydown', this.checkHamburgerKeyEvent);
    var menuItems = this.$el.querySelectorAll('.el-menu-item');
    if (menuItems.length) {
      for (var i = 0; i < menuItems.length; i += 1) {
        menuItems[i].removeEventListener('keydown', this.clickMenuItem);
      }
    }
  },
  methods: {
    /**
     * Click the hamburger menu if a user hits enter while focused on it
     */
    hideSubmenu: function hideSubmenu() {
      this.$emit('hide');
    },
    /**
     * Click the hamburger menu if a user hits enter while focused on it
     *
     * @param {event} e
     */
    checkHamburgerKeyEvent: function checkHamburgerKeyEvent(e) {
      var key = e.which || e.keyCode;
      if (key === 13) {
        // 13 is enter
        this.$refs['hamburger-menu'].$el.querySelector('.el-submenu__title').click();
      }
    },
    /**
     * Click the menu item if a user hits enter while focused on it
     *
     * @param {event} e
     */
    clickMenuItem: function clickMenuItem(e) {
      var key = e.which || e.keyCode;
      if (key === 13) {
        // 13 is enter
        e.target.click();
      } else if (key === 27) {
        // if they hit escape close the menu
        this.$refs['hamburger-menu'].$el.querySelector('.el-submenu__title').click();
      }
    }
  }
};

/* script */
const __vue_script__$x = script$x;

/* template */
var __vue_render__$w = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "TfSubmenu",
    {
      ref: "hamburger-menu",
      class: ["tf-hamburger wt-hamburger", _vm.mode],
      attrs: {
        "popper-append-to-body": false,
        "close-on-outside-click": true,
        index: "1",
        "popper-class": "tf-hamburger-popper",
      },
      on: { hide: _vm.hideSubmenu },
    },
    [
      _c(
        "template",
        { slot: "title" },
        [
          _c("span", [_vm._v("Menu")]),
          _vm._v(" "),
          _vm.badgeCount > 0
            ? _c("TfBadge", {
                attrs: {
                  value: _vm.badgeCount,
                  status: "error",
                  "is-counter": "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
};
var __vue_staticRenderFns__$w = [];
__vue_render__$w._withStripped = true;

  /* style */
  const __vue_inject_styles__$x = function (inject) {
    if (!inject) return
    inject("data-v-4c0af885_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/* stylelint-disable selector-max-compound-selectors  */\n.el-menu--horizontal > .el-submenu.tf-hamburger,\n.el-menu--horizontal > .el-submenu.wt-hamburger {\n  float: right;\n  width: fit-content;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title {\n  /* stylelint-disable declaration-no-important  */\n  border: 1px transparent solid !important;\n  /* stylelint-enable declaration-no-important  */\n  height: 53px;\n  line-height: 53px;\n  width: 73px;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n  background-color: #fff;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23009' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n  background-size: 25px 18px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title:hover {\n  /* stylelint-disable declaration-no-important  */\n  border: 1px #009 solid !important;\n  /* stylelint-enable declaration-no-important  */\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title span:not(.tf-badge),\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title span:not(.tf-badge) {\n  position: absolute;\n  left: -100px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title .tf-badge,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title .tf-badge {\n  position: absolute;\n  right: 37px;\n  top: 5px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger i,\n.el-menu--horizontal > .el-submenu.wt-hamburger i {\n  display: none;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.tf-hamburger.is-opened .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.is-opened .el-submenu__title {\n  background-color: #009;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy {\n  /* stylelint-disable max-nesting-depth  */\n  /* stylelint-enable max-nesting-depth  */\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy .el-submenu__title {\n  background-color: #009;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy .el-submenu__title:hover {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23c1c1c1' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy.is-opened .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy.is-opened .el-submenu__title {\n  background-color: #006;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n\n/* stylelint-enable selector-max-compound-selectors  */\n.el-menu--horizontal.tf-hamburger-popper,\n.el-menu--horizontal.wt-hamburger-popper {\n  /* stylelint-disable declaration-no-important  */\n  top: 55px !important;\n  left: auto !important;\n  /* stylelint-enable declaration-no-important  */\n  border-radius: 3px;\n  right: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup-bottom-start,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup-bottom-start {\n  margin-top: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup {\n  border-radius: 3px;\n  border: 1px #009 solid;\n  padding: 0;\n  left: auto;\n  right: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item {\n  font-size: 16px;\n  font-weight: 600;\n  color: #42474c;\n  height: 39px;\n  line-height: 39px;\n  border-top: 1px #c1c1c1 solid;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:focus,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:focus {\n  color: #009;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:first-of-type, .el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.sub-page,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:first-of-type,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.sub-page {\n  border-top: 1px #fff solid;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.sub-page,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.sub-page {\n  font-weight: normal;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:hover,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:hover {\n  background: rgba(0, 0, 153, 0.1);\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.is-active,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.is-active {\n  color: #009;\n  background: rgba(0, 0, 153, 0.2);\n}\n\n/*# sourceMappingURL=index.vue.map */", map: {"version":3,"sources":["index.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/HamburgerMenu/index.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;kCAEkC;AC8FlC,uDAAA;AAEA;;EAEA,YAAA;EACA,kBAAA;AD7FA;AC+FA;;EAEA,gDAAA;EACA,wCAAA;EACA,+CAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;ED7FE,2TAA2T;EC+F7T,0BAAA;AD7FA;AC+FA;;EACA,gDAAA;EACA,iCAAA;EACA,+CAAA;AD5FA;AC+FA;;EACA,kBAAA;EACA,YAAA;AD5FA;AC+FA;;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AD5FA;ACgGA;;EACA,aAAA;AD7FA;ACiGA;;;;EAEA,sBAAA;ED7FE,2TAA2T;AAC7T;ACiGA;;EACA,yCAAA;EAiBA,wCAAA;AD9GA;AC8FA;;EACA,sBAAA;ED3FE,2TAA2T;AAC7T;AC6FA;;ED1FE,8TAA8T;AAChU;AC+FA;;;;EAEA,sBAAA;ED3FE,2TAA2T;AAC7T;;ACmGA,sDAAA;AACA;;EAEA,gDAAA;EACA,oBAAA;EACA,qBAAA;EACA,+CAAA;EACA,kBAAA;EACA,QAAA;ADhGA;ACkGA;;EACA,aAAA;AD/FA;ACkGA;;EACA,kBAAA;EACA,sBAAA;EAEA,UAAA;EACA,UAAA;EACA,QAAA;ADhGA;ACkGA;;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;AD/FA;ACiGA;;EACA,WAAA;AD9FA;ACiGA;;;EAEA,0BAAA;AD9FA;ACkGA;;EACA,mBAAA;AD/FA;ACkGA;;EACA,gCAAA;AD/FA;ACkGA;;EACA,WAAA;EACA,gCAAA;AD/FA;;AAEA,oCAAoC","file":"index.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/* stylelint-disable selector-max-compound-selectors  */\n.el-menu--horizontal > .el-submenu.tf-hamburger,\n.el-menu--horizontal > .el-submenu.wt-hamburger {\n  float: right;\n  width: fit-content;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title {\n  /* stylelint-disable declaration-no-important  */\n  border: 1px transparent solid !important;\n  /* stylelint-enable declaration-no-important  */\n  height: 53px;\n  line-height: 53px;\n  width: 73px;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n  background-color: #fff;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23009' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n  background-size: 25px 18px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title:hover {\n  /* stylelint-disable declaration-no-important  */\n  border: 1px #009 solid !important;\n  /* stylelint-enable declaration-no-important  */\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title span:not(.tf-badge),\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title span:not(.tf-badge) {\n  position: absolute;\n  left: -100px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title .tf-badge,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title .tf-badge {\n  position: absolute;\n  right: 37px;\n  top: 5px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger i,\n.el-menu--horizontal > .el-submenu.wt-hamburger i {\n  display: none;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.tf-hamburger.is-opened .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.is-opened .el-submenu__title {\n  background-color: #009;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy {\n  /* stylelint-disable max-nesting-depth  */\n  /* stylelint-enable max-nesting-depth  */\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy .el-submenu__title {\n  background-color: #009;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy .el-submenu__title:hover {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23c1c1c1' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy.is-opened .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy.is-opened .el-submenu__title {\n  background-color: #006;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n\n/* stylelint-enable selector-max-compound-selectors  */\n.el-menu--horizontal.tf-hamburger-popper,\n.el-menu--horizontal.wt-hamburger-popper {\n  /* stylelint-disable declaration-no-important  */\n  top: 55px !important;\n  left: auto !important;\n  /* stylelint-enable declaration-no-important  */\n  border-radius: 3px;\n  right: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup-bottom-start,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup-bottom-start {\n  margin-top: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup {\n  border-radius: 3px;\n  border: 1px #009 solid;\n  padding: 0;\n  left: auto;\n  right: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item {\n  font-size: 16px;\n  font-weight: 600;\n  color: #42474c;\n  height: 39px;\n  line-height: 39px;\n  border-top: 1px #c1c1c1 solid;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:focus,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:focus {\n  color: #009;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:first-of-type, .el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.sub-page,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:first-of-type,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.sub-page {\n  border-top: 1px #fff solid;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.sub-page,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.sub-page {\n  font-weight: normal;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:hover,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:hover {\n  background: rgba(0, 0, 153, 0.1);\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.is-active,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.is-active {\n  color: #009;\n  background: rgba(0, 0, 153, 0.2);\n}\n\n/*# sourceMappingURL=index.vue.map */","<template>\n  <TfSubmenu\n    ref=\"hamburger-menu\"\n    :popper-append-to-body=\"false\"\n    :close-on-outside-click=\"true\"\n    index=\"1\"\n    popper-class=\"tf-hamburger-popper\"\n    :class=\"['tf-hamburger wt-hamburger', mode]\"\n    @hide=\"hideSubmenu\"\n  >\n    <template slot=\"title\">\n      <span>Menu</span>\n      <TfBadge\n        v-if=\"badgeCount > 0\"\n        :value=\"badgeCount\"\n        status=\"error\"\n        is-counter\n      />\n    </template>\n    <slot />\n  </TfSubmenu>\n</template>\n<script>\n  export default {\n    name: 'TfHamburgerMenu',\n    props: {\n      badgeCount: {\n        type: Number,\n        default: 0,\n      },\n      mode: {\n        type: String,\n        default: 'carrier',\n      },\n    },\n    mounted() {\n      // Adding key listeners to the hamburger menu and menu items so that we can tab to them and hit enter\n      this.$refs['hamburger-menu'].$el.addEventListener('keydown', this.checkHamburgerKeyEvent);\n\n      // TODO RI 2021-02-03 can we do this with a nexttick?\n      window.setTimeout(() => {\n        const menuItems = this.$el.querySelectorAll('.tf-hamburger-popper .el-menu-item');\n        if (menuItems.length) {\n          for (let i = 0; i < menuItems.length; i += 1) {\n            menuItems[i].addEventListener('keydown', this.clickMenuItem);\n          }\n        }\n      }, 500);\n    },\n    beforeDestroy() {\n      // Removing previously added key listeners\n      this.$refs['hamburger-menu'].$el.removeEventListener('keydown', this.checkHamburgerKeyEvent);\n\n      const menuItems = this.$el.querySelectorAll('.el-menu-item');\n      if (menuItems.length) {\n        for (let i = 0; i < menuItems.length; i += 1) {\n          menuItems[i].removeEventListener('keydown', this.clickMenuItem);\n        }\n      }\n    },\n    methods: {\n      /**\n       * Click the hamburger menu if a user hits enter while focused on it\n       */\n      hideSubmenu() {\n        this.$emit('hide');\n      },\n      /**\n       * Click the hamburger menu if a user hits enter while focused on it\n       *\n       * @param {event} e\n       */\n      checkHamburgerKeyEvent(e) {\n        const key = e.which || e.keyCode;\n        if (key === 13) { // 13 is enter\n          this.$refs['hamburger-menu'].$el.querySelector('.el-submenu__title').click();\n        }\n      },\n      /**\n       * Click the menu item if a user hits enter while focused on it\n       *\n       * @param {event} e\n       */\n      clickMenuItem(e) {\n        const key = e.which || e.keyCode;\n        if (key === 13) { // 13 is enter\n          e.target.click();\n        } else if (key === 27) { // if they hit escape close the menu\n          this.$refs['hamburger-menu'].$el.querySelector('.el-submenu__title').click();\n        }\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\">\n  @import 'src/assets/styles/variables';\n  @import 'src/assets/styles/mixins';\n\n  /* stylelint-disable selector-max-compound-selectors  */\n  .el-menu--horizontal {\n    > .el-submenu.tf-hamburger,\n    > .el-submenu.wt-hamburger {\n      float: right;\n      width: fit-content; // fix for safari, will not affect other browser (i.e. IE)\n\n      .el-submenu__title {\n        // neccessary because of scoped styles in element overriding these\n        /* stylelint-disable declaration-no-important  */\n        border: 1px transparent solid !important;\n        /* stylelint-enable declaration-no-important  */\n        height: 53px;\n        line-height: 53px;\n        width: 73px;\n        padding: 0;\n        position: relative;\n        overflow: hidden;\n        background-color: $tf-white;\n        background-position: center center;\n        background-repeat: no-repeat;\n        @include hamburger-image($tf-blue);\n        background-size: 25px 18px;\n\n        &:hover {\n          /* stylelint-disable declaration-no-important  */\n          border: 1px $tf-blue solid !important;\n          /* stylelint-enable declaration-no-important  */\n        }\n\n        span:not(.tf-badge) {\n          position: absolute;\n          left: -100px;\n        }\n\n        .tf-badge {\n          position: absolute;\n          right: 37px;\n          top: 5px;\n        }\n      }\n\n      i {\n        display: none;\n      }\n\n      &.is-opened {\n        .el-submenu__title:hover,\n        .el-submenu__title {\n          background-color: $tf-blue;\n          @include hamburger-image($tf-white);\n        }\n      }\n\n      &.legacy {\n        /* stylelint-disable max-nesting-depth  */\n        .el-submenu__title {\n          background-color: $tf-blue;\n          @include hamburger-image($tf-white);\n\n          &:hover {\n            @include hamburger-image($tf-light-gray);\n          }\n        }\n\n        &.is-opened {\n          .el-submenu__title:hover,\n          .el-submenu__title {\n            background-color: $tf-dark-blue;\n            @include hamburger-image($tf-white);\n          }\n        }\n        /* stylelint-enable max-nesting-depth  */\n      }\n    }\n  }\n\n  /* stylelint-enable selector-max-compound-selectors  */\n  .el-menu--horizontal.tf-hamburger-popper,\n  .el-menu--horizontal.wt-hamburger-popper {\n    /* stylelint-disable declaration-no-important  */\n    top: 55px !important;\n    left: auto !important;\n    /* stylelint-enable declaration-no-important  */\n    border-radius: 3px;\n    right: 0;\n\n    .el-menu--popup-bottom-start {\n      margin-top: 0;\n    }\n\n    .el-menu--popup {\n      border-radius: 3px;\n      border: 1px $tf-blue solid;\n\n      padding: 0;\n      left: auto;\n      right: 0;\n\n      .el-menu-item {\n        font-size: 16px;\n        font-weight: 600;\n        color: $tf-dark-gray;\n        height: 39px;\n        line-height: 39px;\n        border-top: 1px $tf-light-gray solid;\n\n        &:focus {\n          color: $tf-blue;\n        }\n\n        &:first-of-type,\n        &.sub-page {\n          border-top: 1px $tf-white solid;\n        }\n      }\n\n      .el-menu-item.sub-page {\n        font-weight: normal;\n      }\n\n      .el-menu-item:hover {\n        background: rgba($tf-blue, .1);\n      }\n\n      .el-menu-item.is-active {\n        color: $tf-blue;\n        background: rgba($tf-blue, .2);\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$x = undefined;
  /* module identifier */
  const __vue_module_identifier__$x = undefined;
  /* functional template */
  const __vue_is_functional_template__$x = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$x = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$w, staticRenderFns: __vue_staticRenderFns__$w },
    __vue_inject_styles__$x,
    __vue_script__$x,
    __vue_scope_id__$x,
    __vue_is_functional_template__$x,
    __vue_module_identifier__$x,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Hamburger Menu Toggle
 *
 * @vuedoc
 * @exports MenuToggle
 * @category Components
 */
var script$y = {
  name: 'MenuBarItem',
  inject: {
    menu: {
      default: {
        /**
         * Dummy method in case nothing is provided
         */
        closeHamburgerMenu: function closeHamburgerMenu() {}
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'grandchild'
    },
    to: {
      type: [Object, String],
      default: function _default() {
        return {};
      }
    },
    isToggle: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    badgeCount: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      localIsOpen: false,
      activeNames: [],
      hover: false
    };
  },
  created: function created() {
    this.localIsOpen = this.isOpen;
    if (this.isOpen) {
      this.$set(this, 'activeNames', ['item']);
    }
  },
  methods: {
    /**
     * Track open/closed state locally to show correct toggle chevron
     */
    onToggle: function onToggle() {
      this.localIsOpen = !this.localIsOpen;
    },
    /**
     * Close the parent menu and then route to the required path as defined in the to object that was passed as a prop.
     */
    closeHamburgerMenu: function closeHamburgerMenu() {
      if (this.disabled) {
        return;
      }
      this.menu.closeHamburgerMenu();
      this.$router.push(this.to);
    }
  }
};

/* script */
const __vue_script__$y = script$y;

/* template */
var __vue_render__$x = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "menu-item" },
    [
      _vm.isToggle
        ? _c(
            "ElCollapse",
            {
              on: { change: _vm.onToggle },
              model: {
                value: _vm.activeNames,
                callback: function ($$v) {
                  _vm.activeNames = $$v;
                },
                expression: "activeNames",
              },
            },
            [
              _c("ElCollapseItem", { attrs: { name: "item" } }, [
                _c(
                  "div",
                  {
                    class: [
                      "inner",
                      _vm.type,
                      { "is-toggle": _vm.isToggle },
                      { disabled: _vm.disabled },
                    ],
                    attrs: { slot: "title" },
                    on: {
                      mouseover: function ($event) {
                        _vm.hover = true;
                      },
                      mouseleave: function ($event) {
                        _vm.hover = false;
                      },
                    },
                    slot: "title",
                  },
                  [
                    _c("div", {
                      staticClass: "title",
                      domProps: { textContent: _vm._s(_vm.title) },
                    }),
                    _vm._v(" "),
                    _c("icon", {
                      class: ["chevron-down", { open: _vm.localIsOpen }],
                      attrs: { name: "chevron-down" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "contents" }, [_vm._t("default")], 2),
              ]),
            ],
            1
          )
        : _c(
            "RouterLink",
            _vm._b(
              {
                attrs: { "data-test": "hamburger menu navigation" },
                nativeOn: {
                  click: function ($event) {
                    return _vm.closeHamburgerMenu.apply(null, arguments)
                  },
                },
              },
              "RouterLink",
              {
                class: [
                  "inner",
                  _vm.type,
                  { link: !_vm.disabled },
                  { "is-toggle": _vm.isToggle },
                  { disabled: _vm.disabled },
                  { hover: _vm.hover },
                ],
                disabled: _vm.disabled,
                event: "", // disabling this to move logic to closeHamburgerMenu
                to: _vm.to,
              },
              false
            ),
            [
              _c("div", {
                staticClass: "title",
                domProps: { textContent: _vm._s(_vm.title) },
              }),
              _vm._v(" "),
              _vm.icon
                ? _c("icon", { class: _vm.icon, attrs: { name: _vm.icon } })
                : _vm._e(),
              _vm._v(" "),
              _vm.badgeCount
                ? _c("TfBadge", {
                    attrs: {
                      value: _vm.badgeCount,
                      status: "error",
                      "is-counter": "",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
};
var __vue_staticRenderFns__$x = [];
__vue_render__$x._withStripped = true;

  /* style */
  const __vue_inject_styles__$y = function (inject) {
    if (!inject) return
    inject("data-v-06ff6c22_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.inner[data-v-06ff6c22] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 40px;\n  padding: 0 15px 0 30px;\n  line-height: 40px;\n  font-size: 14px;\n  box-shadow: inset 0 -1px 0 0 #efefef;\n}\n.inner.link[data-v-06ff6c22] {\n  color: #42474c;\n  font-weight: 400;\n}\n.inner.parent[data-v-06ff6c22] {\n  padding-left: 15px;\n  font-size: 16px;\n  font-weight: 700;\n}\n.inner.child[data-v-06ff6c22] {\n  padding-left: 20px;\n  font-weight: 600;\n}\n.inner.grandchild[data-v-06ff6c22] {\n  padding-left: 30px;\n  background: #fafafa;\n}\n.inner.parent[data-v-06ff6c22]:focus, .inner.parent.router-link-exact-active[data-v-06ff6c22]:not(.disabled), .inner.child[data-v-06ff6c22]:focus, .inner.child.router-link-exact-active[data-v-06ff6c22]:not(.disabled), .inner.grandchild[data-v-06ff6c22]:focus, .inner.grandchild.router-link-exact-active[data-v-06ff6c22]:not(.disabled) {\n  background: #009;\n  color: #fff;\n}\n.inner.parent:focus svg[data-v-06ff6c22], .inner.parent.router-link-exact-active:not(.disabled) svg[data-v-06ff6c22], .inner.child:focus svg[data-v-06ff6c22], .inner.child.router-link-exact-active:not(.disabled) svg[data-v-06ff6c22], .inner.grandchild:focus svg[data-v-06ff6c22], .inner.grandchild.router-link-exact-active:not(.disabled) svg[data-v-06ff6c22] {\n  fill: #fff;\n}\n.inner.is-toggle[data-v-06ff6c22] {\n  cursor: pointer;\n}\n.inner.disabled[data-v-06ff6c22] {\n  color: #999;\n  cursor: not-allowed;\n}\n.inner.disabled.grandchild[data-v-06ff6c22] {\n  background-color: #fafafa;\n}\n.inner.disabled[data-v-06ff6c22]:hover, .inner.disabled[data-v-06ff6c22]:active, .inner.disabled[data-v-06ff6c22]:focus {\n  background-color: #fff;\n  box-shadow: inset 0 -1px 0 0 #efefef;\n  color: #999;\n}\n.inner.disabled:hover.grandchild[data-v-06ff6c22], .inner.disabled:active.grandchild[data-v-06ff6c22], .inner.disabled:focus.grandchild[data-v-06ff6c22] {\n  background-color: #fafafa;\n}\n.inner .title[data-v-06ff6c22] {\n  flex-grow: 1;\n}\n.inner .fa-icon[data-v-06ff6c22] {\n  fill: #42474c;\n}\n.inner .exclamation-triangle[data-v-06ff6c22] {\n  fill: #f7912a;\n}\n.inner .chevron-down[data-v-06ff6c22] {\n  transition: transform 0.5s, color 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transform-origin: center;\n  transform: rotate(0deg);\n}\n.inner .chevron-down.open[data-v-06ff6c22] {\n  transform: rotate(180deg);\n}\n.el-collapse[data-v-06ff6c22] {\n  box-shadow: inset 0 -1px 0 0 #efefef;\n}\n.el-collapse-item__header.is-active:not(:focus) > .parent[data-v-06ff6c22],\n.el-collapse-item__header.is-active:not(:focus) > .child[data-v-06ff6c22] {\n  color: #009;\n}\n.el-collapse-item__header.is-active:not(:focus) .chevron-down[data-v-06ff6c22] {\n  fill: #009;\n}\n\n/*# sourceMappingURL=MenuItem.vue.map */", map: {"version":3,"sources":["MenuItem.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/HamburgerMenu/MenuItem.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACmLlC;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,oCAAA;ADjLA;ACmLA;EACA,cAAA;EACA,gBAAA;ADjLA;ACoLA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ADlLA;ACqLA;EACA,kBAAA;EACA,gBAAA;ADnLA;ACsLA;EACA,kBAAA;EACA,mBAAA;ADpLA;AC0LA;EACA,gBAAA;EACA,WAAA;ADxLA;AC0LA;EACA,UAAA;ADxLA;AC6LA;EACA,eAAA;AD3LA;AC8LA;EACA,WAAA;EACA,mBAAA;AD5LA;AC8LA;EACA,yBAAA;AD5LA;AC+LA;EACA,sBAAA;EACA,oCAAA;EACA,WAAA;AD7LA;AC+LA;EACA,yBAAA;AD7LA;ACkMA;EACA,YAAA;ADhMA;ACmMA;EACA,aAAA;ADjMA;ACoMA;EACA,aAAA;ADlMA;ACqMA;EACA,2EAAA;EACA,wBAAA;EACA,uBAAA;ADnMA;ACqMA;EACA,yBAAA;ADnMA;ACwMA;EACA,oCAAA;ADrMA;AC0MA;;EAEA,WAAA;ADvMA;AC0MA;EACA,UAAA;ADxMA;;AAEA,uCAAuC","file":"MenuItem.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.inner {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 40px;\n  padding: 0 15px 0 30px;\n  line-height: 40px;\n  font-size: 14px;\n  box-shadow: inset 0 -1px 0 0 #efefef;\n}\n.inner.link {\n  color: #42474c;\n  font-weight: 400;\n}\n.inner.parent {\n  padding-left: 15px;\n  font-size: 16px;\n  font-weight: 700;\n}\n.inner.child {\n  padding-left: 20px;\n  font-weight: 600;\n}\n.inner.grandchild {\n  padding-left: 30px;\n  background: #fafafa;\n}\n.inner.parent:focus, .inner.parent.router-link-exact-active:not(.disabled), .inner.child:focus, .inner.child.router-link-exact-active:not(.disabled), .inner.grandchild:focus, .inner.grandchild.router-link-exact-active:not(.disabled) {\n  background: #009;\n  color: #fff;\n}\n.inner.parent:focus svg, .inner.parent.router-link-exact-active:not(.disabled) svg, .inner.child:focus svg, .inner.child.router-link-exact-active:not(.disabled) svg, .inner.grandchild:focus svg, .inner.grandchild.router-link-exact-active:not(.disabled) svg {\n  fill: #fff;\n}\n.inner.is-toggle {\n  cursor: pointer;\n}\n.inner.disabled {\n  color: #999;\n  cursor: not-allowed;\n}\n.inner.disabled.grandchild {\n  background-color: #fafafa;\n}\n.inner.disabled:hover, .inner.disabled:active, .inner.disabled:focus {\n  background-color: #fff;\n  box-shadow: inset 0 -1px 0 0 #efefef;\n  color: #999;\n}\n.inner.disabled:hover.grandchild, .inner.disabled:active.grandchild, .inner.disabled:focus.grandchild {\n  background-color: #fafafa;\n}\n.inner .title {\n  flex-grow: 1;\n}\n.inner .fa-icon {\n  fill: #42474c;\n}\n.inner .exclamation-triangle {\n  fill: #f7912a;\n}\n.inner .chevron-down {\n  transition: transform 0.5s, color 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transform-origin: center;\n  transform: rotate(0deg);\n}\n.inner .chevron-down.open {\n  transform: rotate(180deg);\n}\n\n.el-collapse {\n  box-shadow: inset 0 -1px 0 0 #efefef;\n}\n\n.el-collapse-item__header.is-active:not(:focus) > .parent,\n.el-collapse-item__header.is-active:not(:focus) > .child {\n  color: #009;\n}\n.el-collapse-item__header.is-active:not(:focus) .chevron-down {\n  fill: #009;\n}\n\n/*# sourceMappingURL=MenuItem.vue.map */","<template>\n  <div class=\"menu-item\">\n    <ElCollapse\n      v-if=\"isToggle\"\n      v-model=\"activeNames\"\n      @change=\"onToggle\"\n    >\n      <ElCollapseItem\n        name=\"item\"\n      >\n        <div\n          slot=\"title\"\n          :class=\"[\n            'inner',\n            type,\n            { 'is-toggle' : isToggle },\n            { 'disabled' : disabled }\n          ]\"\n          @mouseover=\"hover = true\"\n          @mouseleave=\"hover = false\"\n        >\n          <div\n            class=\"title\"\n            v-text=\"title\"\n          />\n\n          <icon\n            name=\"chevron-down\"\n            :class=\"[\n              'chevron-down',\n              { 'open': localIsOpen }\n            ]\"\n          />\n        </div>\n        <div class=\"contents\">\n          <slot />\n        </div>\n      </ElCollapseItem>\n    </ElCollapse>\n\n    <RouterLink\n      v-else\n      data-test=\"hamburger menu navigation\"\n      v-bind=\"{\n        class: [\n          'inner',\n          type,\n          { 'link': !disabled },\n          { 'is-toggle': isToggle },\n          { 'disabled': disabled },\n          { 'hover': hover },\n        ],\n        disabled,\n        event: '', // disabling this to move logic to closeHamburgerMenu\n        to,\n      }\"\n      @click.native=\"closeHamburgerMenu\"\n    >\n      <div\n        class=\"title\"\n        v-text=\"title\"\n      />\n\n      <icon\n        v-if=\"icon\"\n        :name=\"icon\"\n        :class=\"icon\"\n      />\n\n      <TfBadge\n        v-if=\"badgeCount\"\n        :value=\"badgeCount\"\n        status=\"error\"\n        is-counter\n      />\n    </RouterLink>\n  </div>\n</template>\n\n<script>\n  /**\n   * Hamburger Menu Toggle\n   *\n   * @vuedoc\n   * @exports MenuToggle\n   * @category Components\n   */\n  export default {\n    name: 'MenuBarItem',\n\n    inject: {\n      menu: {\n        default: {\n          /**\n           * Dummy method in case nothing is provided\n           */\n          closeHamburgerMenu() { },\n        },\n      },\n    },\n\n    props: {\n      title: {\n        type: String,\n        required: true,\n      },\n\n      type: {\n        type: String,\n        default: 'grandchild',\n      },\n\n      to: {\n        type: [Object, String],\n        default: () => ({}),\n      },\n\n      isToggle: {\n        type: Boolean,\n        default: false,\n      },\n\n      disabled: {\n        type: Boolean,\n        default: false,\n      },\n\n      isOpen: {\n        type: Boolean,\n        default: false,\n      },\n\n      badgeCount: {\n        type: Number,\n        default: 0,\n      },\n      icon: {\n        type: String,\n        default: '',\n      },\n    },\n\n    data: () => ({\n      localIsOpen: false,\n      activeNames: [],\n      hover: false,\n    }),\n\n    created() {\n      this.localIsOpen = this.isOpen;\n\n      if (this.isOpen) {\n        this.$set(this, 'activeNames', ['item']);\n      }\n    },\n\n    methods: {\n      /**\n       * Track open/closed state locally to show correct toggle chevron\n       */\n      onToggle() {\n        this.localIsOpen = !this.localIsOpen;\n      },\n\n      /**\n       * Close the parent menu and then route to the required path as defined in the to object that was passed as a prop.\n       */\n      closeHamburgerMenu() {\n        if (this.disabled) {\n          return;\n        }\n        this.menu.closeHamburgerMenu();\n        this.$router.push(this.to);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .inner {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: 40px;\n    padding: 0 15px 0 30px;\n    line-height: 40px;\n    font-size: 14px;\n    box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n\n    &.link {\n      color: $tf-dark-gray;\n      font-weight: 400;\n    }\n\n    &.parent {\n      padding-left: 15px;\n      font-size: 16px;\n      font-weight: 700;\n    }\n\n    &.child {\n      padding-left: 20px;\n      font-weight: 600;\n    }\n\n    &.grandchild {\n      padding-left: 30px;\n      background: $tf-extra-light-gray-2;\n    }\n\n    &.parent,\n    &.child,\n    &.grandchild {\n      &:focus, &.router-link-exact-active:not(.disabled) {\n        background: $tf-blue;\n        color: $tf-white;\n\n        svg {\n          fill: $tf-white;\n        }\n      }\n    }\n\n    &.is-toggle {\n      cursor: pointer;\n    }\n\n    &.disabled {\n      color: $tf-medium-gray;\n      cursor: not-allowed;\n\n      &.grandchild {\n        background-color: $tf-extra-light-gray-2;\n      }\n\n      &:hover, &:active, &:focus {\n        background-color: $tf-white;\n        box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n        color: $tf-medium-gray;\n\n        &.grandchild {\n          background-color: $tf-extra-light-gray-2;\n        }\n      }\n    }\n\n    .title {\n      flex-grow: 1;\n    }\n\n    .fa-icon {\n      fill: $tf-dark-gray;\n    }\n\n    .exclamation-triangle {\n      fill: $tf-orange;\n    }\n\n    .chevron-down {\n      transition: transform .5s, color .5s cubic-bezier(.645, .045, .355, 1);\n      transform-origin: center;\n      transform: rotate(0deg);\n\n      &.open {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  .el-collapse {\n    box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n  }\n\n  .el-collapse-item__header {\n    &.is-active:not(:focus) {\n      > .parent,\n      > .child {\n        color: $tf-blue;\n      }\n\n      .chevron-down {\n        fill: $tf-blue;\n      }\n    }\n  }\n</style>\n\n<style lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  .menu-item .el-collapse-item__header:focus,\n  .menu-item .link:focus {\n    outline: none;\n    box-shadow: inset 0 -1px 0 0 $tf-blue, inset 0 1px 0 0 $tf-blue;\n    background: $tf-blue;\n    color: $tf-white;\n\n    svg {\n      fill: $tf-white;\n    }\n  }\n\n  .menu-item .el-collapse-item__header:hover:not(:focus):not(.router-link-exact-active),\n  .menu-item .link:hover:not(:focus):not(.router-link-exact-active) {\n    background: $tf-light-blue;\n  }\n</style>\n"]}, media: undefined })
,inject("data-v-06ff6c22_1", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.menu-item .el-collapse-item__header:focus,\n.menu-item .link:focus {\n  outline: none;\n  box-shadow: inset 0 -1px 0 0 #009, inset 0 1px 0 0 #009;\n  background: #009;\n  color: #fff;\n}\n.menu-item .el-collapse-item__header:focus svg,\n.menu-item .link:focus svg {\n  fill: #fff;\n}\n.menu-item .el-collapse-item__header:hover:not(:focus):not(.router-link-exact-active),\n.menu-item .link:hover:not(:focus):not(.router-link-exact-active) {\n  background: #eff3fd;\n}\n\n/*# sourceMappingURL=MenuItem.vue.map */", map: {"version":3,"sources":["MenuItem.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/HamburgerMenu/MenuItem.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACkSlC;;EAEA,aAAA;EACA,uDAAA;EACA,gBAAA;EACA,WAAA;ADhSA;ACkSA;;EACA,UAAA;AD/RA;ACmSA;;EAEA,mBAAA;ADhSA;;AAEA,uCAAuC","file":"MenuItem.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.menu-item .el-collapse-item__header:focus,\n.menu-item .link:focus {\n  outline: none;\n  box-shadow: inset 0 -1px 0 0 #009, inset 0 1px 0 0 #009;\n  background: #009;\n  color: #fff;\n}\n.menu-item .el-collapse-item__header:focus svg,\n.menu-item .link:focus svg {\n  fill: #fff;\n}\n\n.menu-item .el-collapse-item__header:hover:not(:focus):not(.router-link-exact-active),\n.menu-item .link:hover:not(:focus):not(.router-link-exact-active) {\n  background: #eff3fd;\n}\n\n/*# sourceMappingURL=MenuItem.vue.map */","<template>\n  <div class=\"menu-item\">\n    <ElCollapse\n      v-if=\"isToggle\"\n      v-model=\"activeNames\"\n      @change=\"onToggle\"\n    >\n      <ElCollapseItem\n        name=\"item\"\n      >\n        <div\n          slot=\"title\"\n          :class=\"[\n            'inner',\n            type,\n            { 'is-toggle' : isToggle },\n            { 'disabled' : disabled }\n          ]\"\n          @mouseover=\"hover = true\"\n          @mouseleave=\"hover = false\"\n        >\n          <div\n            class=\"title\"\n            v-text=\"title\"\n          />\n\n          <icon\n            name=\"chevron-down\"\n            :class=\"[\n              'chevron-down',\n              { 'open': localIsOpen }\n            ]\"\n          />\n        </div>\n        <div class=\"contents\">\n          <slot />\n        </div>\n      </ElCollapseItem>\n    </ElCollapse>\n\n    <RouterLink\n      v-else\n      data-test=\"hamburger menu navigation\"\n      v-bind=\"{\n        class: [\n          'inner',\n          type,\n          { 'link': !disabled },\n          { 'is-toggle': isToggle },\n          { 'disabled': disabled },\n          { 'hover': hover },\n        ],\n        disabled,\n        event: '', // disabling this to move logic to closeHamburgerMenu\n        to,\n      }\"\n      @click.native=\"closeHamburgerMenu\"\n    >\n      <div\n        class=\"title\"\n        v-text=\"title\"\n      />\n\n      <icon\n        v-if=\"icon\"\n        :name=\"icon\"\n        :class=\"icon\"\n      />\n\n      <TfBadge\n        v-if=\"badgeCount\"\n        :value=\"badgeCount\"\n        status=\"error\"\n        is-counter\n      />\n    </RouterLink>\n  </div>\n</template>\n\n<script>\n  /**\n   * Hamburger Menu Toggle\n   *\n   * @vuedoc\n   * @exports MenuToggle\n   * @category Components\n   */\n  export default {\n    name: 'MenuBarItem',\n\n    inject: {\n      menu: {\n        default: {\n          /**\n           * Dummy method in case nothing is provided\n           */\n          closeHamburgerMenu() { },\n        },\n      },\n    },\n\n    props: {\n      title: {\n        type: String,\n        required: true,\n      },\n\n      type: {\n        type: String,\n        default: 'grandchild',\n      },\n\n      to: {\n        type: [Object, String],\n        default: () => ({}),\n      },\n\n      isToggle: {\n        type: Boolean,\n        default: false,\n      },\n\n      disabled: {\n        type: Boolean,\n        default: false,\n      },\n\n      isOpen: {\n        type: Boolean,\n        default: false,\n      },\n\n      badgeCount: {\n        type: Number,\n        default: 0,\n      },\n      icon: {\n        type: String,\n        default: '',\n      },\n    },\n\n    data: () => ({\n      localIsOpen: false,\n      activeNames: [],\n      hover: false,\n    }),\n\n    created() {\n      this.localIsOpen = this.isOpen;\n\n      if (this.isOpen) {\n        this.$set(this, 'activeNames', ['item']);\n      }\n    },\n\n    methods: {\n      /**\n       * Track open/closed state locally to show correct toggle chevron\n       */\n      onToggle() {\n        this.localIsOpen = !this.localIsOpen;\n      },\n\n      /**\n       * Close the parent menu and then route to the required path as defined in the to object that was passed as a prop.\n       */\n      closeHamburgerMenu() {\n        if (this.disabled) {\n          return;\n        }\n        this.menu.closeHamburgerMenu();\n        this.$router.push(this.to);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .inner {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: 40px;\n    padding: 0 15px 0 30px;\n    line-height: 40px;\n    font-size: 14px;\n    box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n\n    &.link {\n      color: $tf-dark-gray;\n      font-weight: 400;\n    }\n\n    &.parent {\n      padding-left: 15px;\n      font-size: 16px;\n      font-weight: 700;\n    }\n\n    &.child {\n      padding-left: 20px;\n      font-weight: 600;\n    }\n\n    &.grandchild {\n      padding-left: 30px;\n      background: $tf-extra-light-gray-2;\n    }\n\n    &.parent,\n    &.child,\n    &.grandchild {\n      &:focus, &.router-link-exact-active:not(.disabled) {\n        background: $tf-blue;\n        color: $tf-white;\n\n        svg {\n          fill: $tf-white;\n        }\n      }\n    }\n\n    &.is-toggle {\n      cursor: pointer;\n    }\n\n    &.disabled {\n      color: $tf-medium-gray;\n      cursor: not-allowed;\n\n      &.grandchild {\n        background-color: $tf-extra-light-gray-2;\n      }\n\n      &:hover, &:active, &:focus {\n        background-color: $tf-white;\n        box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n        color: $tf-medium-gray;\n\n        &.grandchild {\n          background-color: $tf-extra-light-gray-2;\n        }\n      }\n    }\n\n    .title {\n      flex-grow: 1;\n    }\n\n    .fa-icon {\n      fill: $tf-dark-gray;\n    }\n\n    .exclamation-triangle {\n      fill: $tf-orange;\n    }\n\n    .chevron-down {\n      transition: transform .5s, color .5s cubic-bezier(.645, .045, .355, 1);\n      transform-origin: center;\n      transform: rotate(0deg);\n\n      &.open {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  .el-collapse {\n    box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n  }\n\n  .el-collapse-item__header {\n    &.is-active:not(:focus) {\n      > .parent,\n      > .child {\n        color: $tf-blue;\n      }\n\n      .chevron-down {\n        fill: $tf-blue;\n      }\n    }\n  }\n</style>\n\n<style lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  .menu-item .el-collapse-item__header:focus,\n  .menu-item .link:focus {\n    outline: none;\n    box-shadow: inset 0 -1px 0 0 $tf-blue, inset 0 1px 0 0 $tf-blue;\n    background: $tf-blue;\n    color: $tf-white;\n\n    svg {\n      fill: $tf-white;\n    }\n  }\n\n  .menu-item .el-collapse-item__header:hover:not(:focus):not(.router-link-exact-active),\n  .menu-item .link:hover:not(:focus):not(.router-link-exact-active) {\n    background: $tf-light-blue;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$y = "data-v-06ff6c22";
  /* module identifier */
  const __vue_module_identifier__$y = undefined;
  /* functional template */
  const __vue_is_functional_template__$y = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$y = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$x, staticRenderFns: __vue_staticRenderFns__$x },
    __vue_inject_styles__$y,
    __vue_script__$y,
    __vue_scope_id__$y,
    __vue_is_functional_template__$y,
    __vue_module_identifier__$y,
    false,
    browser,
    undefined,
    undefined
  );

var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

_export(_export.P + _export.F * (NEGATIVE_ZERO || !_strictMethod($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = _toIobject(this);
    var length = _toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, _toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This is an input used when there are "readonly" and "edit" modes. The "readonly" will render out text that on hover (or parental hover) will look like an input. The "edit" mode by default will show an  input > cancel button > save button" design pattern is required. The parent should handle the readonly state along with the API's success/failure returns.
 *
 * @vuedoc
 * @exports TfForm/TfInlineFormField
 * @category Components
 */
var script$z = {
  name: 'TfInlineFormField',
  props: {
    deleteType: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isEditing: {
      type: Boolean,
      required: true
    },
    isHovering: {
      type: Boolean,
      default: false
    },
    isDeleting: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Enter value'
    },
    prop: {
      type: String,
      required: true
    },
    showBtnDelete: {
      type: Boolean,
      default: true
    },
    showBtnEdit: {
      type: Boolean,
      default: true
    },
    showBtnActions: {
      type: Boolean,
      default: true
    },
    showExtension: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      required: true
    }
  },
  data: function data(vm) {
    return {
      originalValue: vm.value
    };
  },
  computed: {
    /**
     * Evaluate different states to disable all the buttons in the template.
     *
     * @returns {boolean}
     */
    btnsDisabled: function btnsDisabled() {
      return this.isDeleting || this.isSaving || this.isDisabled;
    },
    /**
     * Evaluate different states to disable all the save in the template and prevent the form from submitting on enter.
     *
     * @returns {boolean}
     */
    btnSaveDisabled: function btnSaveDisabled() {
      return this.isRequired && !this.localValue;
    },
    /**
     * Evaluate the props to get the extension if necessessary.
     *
     * @returns {string}
     */
    extension: function extension() {
      return this.showExtension ? this.value.substr(this.value.lastIndexOf('.') + 1) : '';
    },
    /**
     * Get the local value for the input with/without the extension.
     * Emit the new value with/without the extension.
     *
     * @returns {string}
     */
    localValue: {
      get: function get() {
        return this.showExtension && this.isEditing ? this.value.replace(".".concat(this.extension), '') : this.value;
      },
      set: function set(value) {
        var newValue = this.extension ? "".concat(value, ".").concat(this.extension) : value;
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    /**
     * Emit "cancel" and "edit" correctly to reset the state in the parent.
     */
    onCancel: function onCancel() {
      this.$emit('cancel', this.originalValue);
      this.$emit('edit', false);
    },
    /**
     * Set btnsDisable to `true` and emit "delete" to the parent.
     */
    onDelete: function onDelete() {
      this.$emit('delete');
    },
    /**
     * Emit up to the parent and wait for the prop to change. If the default slot for the edit mode is being used, we focus on the input.
     */
    onEdit: function onEdit() {
      var _this = this;
      this.$emit('edit', true);
      this.$nextTick(function () {
        // need to test b/c of jest timing issues I can't pinpoint as well.
        if (_this.$slots.default || !_this.$refs.input) {
          return;
        }
        _this.$refs.input.$el.querySelector('input').focus();
      });
    },
    /**
     * Emit "save" with the correct value/extension only if any of the disabled states aren't true. We also want to update "originalValue" since this component is not destroyed.
     */
    onSave: function onSave() {
      if (this.btnsDisabled || this.btnSaveDisabled) {
        return;
      }
      var newValue = this.showExtension && this.isEditing ? "".concat(this.localValue, ".").concat(this.extension) : this.localValue;
      this.originalValue = newValue;
      this.$emit('save', newValue);
    }
  }
};

/* script */
const __vue_script__$z = script$z;

/* template */
var __vue_render__$y = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "tf-inline-form-field wt-inline-form-field" },
    [
      _vm.isEditing
        ? _c(
            "div",
            { staticClass: "container-editing" },
            [
              _c(
                "ElForm",
                {
                  attrs: {
                    model:
                      ((_obj = {}), (_obj[_vm.prop] = _vm.localValue), _obj),
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault();
                    },
                  },
                },
                [
                  _c(
                    "ElFormItem",
                    { attrs: { prop: _vm.prop, size: "medium" } },
                    [
                      _vm._t("default", function () {
                        return [
                          _c(
                            "ElInput",
                            _vm._b(
                              {
                                ref: "input",
                                nativeOn: {
                                  keyup: [
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSave.apply(null, arguments)
                                    },
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "escape",
                                          undefined,
                                          $event.key,
                                          undefined
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onCancel.apply(null, arguments)
                                    },
                                  ],
                                },
                                model: {
                                  value: _vm.localValue,
                                  callback: function ($$v) {
                                    _vm.localValue = $$v;
                                  },
                                  expression: "localValue",
                                },
                              },
                              "ElInput",
                              {
                                disabled: _vm.btnsDisabled,
                                placeholder: _vm.placeholder,
                              },
                              false
                            ),
                            [
                              _vm.showExtension
                                ? _c(
                                    "template",
                                    {
                                      attrs: {
                                        "data-test":
                                          "inline form field " +
                                          _vm.prop +
                                          " extension",
                                      },
                                      slot: "append",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.extension) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      }),
                      _vm._v(" "),
                      _vm.showBtnActions
                        ? _c(
                            "div",
                            { staticClass: "btn-group align-end" },
                            [
                              _c("AppButton", {
                                attrs: {
                                  "is-disabled": _vm.btnsDisabled,
                                  "data-test": "cancel inline form field edit",
                                  icon: "fa-solid fa-xmark",
                                  size: "icon",
                                  title: "Cancel edit",
                                  type: "decline",
                                },
                                on: { click: _vm.onCancel },
                              }),
                              _vm._v(" "),
                              _c("AppButton", {
                                attrs: {
                                  "is-disabled":
                                    _vm.btnsDisabled || _vm.btnSaveDisabled,
                                  "is-loading": _vm.isSaving,
                                  "data-test": "confirm inline form field edit",
                                  icon: "fa-solid fa-check",
                                  size: "icon",
                                  title: "Confirm edit",
                                  type: "affirm",
                                },
                                on: { click: _vm.onSave },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-group align-start" },
                [
                  _vm.showBtnDelete
                    ? _c("AppButton", {
                        staticClass: "btn-delete",
                        attrs: {
                          "is-disabled": _vm.btnsDisabled,
                          text:
                            "Delete" +
                            (_vm.deleteType ? " " + _vm.deleteType : ""),
                          "data-test": "delete inline form field",
                          size: "text-small",
                          type: "decline",
                        },
                        on: { click: _vm.onDelete },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            {
              class: [{ "is-hovering": _vm.isHovering }, "container-readonly"],
            },
            [
              _c(
                "span",
                { staticClass: "faux-input", on: { click: _vm.onEdit } },
                [_c("span", [_vm._v(_vm._s(_vm.value))])]
              ),
              _vm._v(" "),
              _vm.showBtnEdit
                ? _c("AppButton", {
                    staticClass: "btn-edit",
                    attrs: {
                      "data-test": "edit inline form field",
                      icon: "fa-solid fa-pencil",
                      title: "Edit field",
                      type: "primary",
                      size: "icon",
                    },
                    on: { click: _vm.onEdit },
                  })
                : _vm._e(),
            ],
            1
          ),
    ]
  )
};
var __vue_staticRenderFns__$y = [];
__vue_render__$y._withStripped = true;

  /* style */
  const __vue_inject_styles__$z = function (inject) {
    if (!inject) return
    inject("data-v-fd38e7fe_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.el-form-item[data-v-fd38e7fe] {\n  margin: 0;\n}\n[data-v-fd38e7fe] .el-form-item__content {\n  display: flex;\n  align-items: center;\n}\n[data-v-fd38e7fe] .el-input-group__append {\n  background-color: #fafafa;\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n.btn-group.align-end[data-v-fd38e7fe] {\n  margin-left: 15px;\n}\n.btn-group.align-end .tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill[data-v-fd38e7fe],\n.btn-group.align-end .wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill[data-v-fd38e7fe] {\n  margin-left: 4px;\n}\nspan[data-v-fd38e7fe] {\n  box-sizing: border-box;\n  display: flex;\n  flex: 1;\n  align-items: center;\n  transition: all 0.5s;\n  min-height: 30px;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  line-height: 26px;\n}\n.tf-button.btn-delete[data-v-fd38e7fe],\n.wt-button.btn-delete[data-v-fd38e7fe] {\n  margin-top: 3px;\n}\n.btn-edit[data-v-fd38e7fe] {\n  opacity: 0;\n  transition: all 0.5s;\n}\n.container-editing[data-v-fd38e7fe] {\n  display: flex;\n  flex-direction: column;\n}\n.container-readonly[data-v-fd38e7fe] {\n  display: flex;\n}\n.container-readonly:hover .btn-edit[data-v-fd38e7fe], .container-readonly.is-hovering .btn-edit[data-v-fd38e7fe] {\n  opacity: 1;\n}\n.container-readonly:hover .faux-input[data-v-fd38e7fe], .container-readonly.is-hovering .faux-input[data-v-fd38e7fe] {\n  padding: 0 15px;\n  border-color: #c1c1c1;\n  background: #fff;\n}\n.faux-input[data-v-fd38e7fe] {\n  border: 1px solid transparent;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.faux-input > span[data-v-fd38e7fe] {\n  display: block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.tf-inline-form-field[data-v-fd38e7fe],\n.wt-inline-form-field[data-v-fd38e7fe] {\n  width: 100%;\n}\n\n/*# sourceMappingURL=TfInlineFormField.vue.map */", map: {"version":3,"sources":["TfInlineFormField.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfForm/TfInlineFormField.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC8QlC;EACA,SAAA;AD5QA;ACgRA;EACA,aAAA;EACA,mBAAA;AD7QA;ACgRA;EACA,yBAAA;EAEA,4BAAA;EACA,+BAAA;AD/QA;ACoRA;EACA,iBAAA;ADjRA;ACoRA;;EAEA,gBAAA;ADlRA;ACsRA;EACA,sBAAA;EACA,aAAA;EACA,OAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;ADnRA;ACsRA;;EAEA,eAAA;ADnRA;ACsRA;EACA,UAAA;EACA,oBAAA;ADnRA;ACuRA;EACA,aAAA;EACA,sBAAA;ADpRA;ACuRA;EACA,aAAA;ADrRA;ACyRA;EACA,UAAA;ADvRA;AC0RA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;ADxRA;AC8RA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AD3RA;AC6RA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AD3RA;AC+RA;;EAEA,WAAA;AD5RA;;AAEA,gDAAgD","file":"TfInlineFormField.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.el-form-item {\n  margin: 0;\n}\n\n::v-deep .el-form-item__content {\n  display: flex;\n  align-items: center;\n}\n::v-deep .el-input-group__append {\n  background-color: #fafafa;\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n\n.btn-group.align-end {\n  margin-left: 15px;\n}\n.btn-group.align-end .tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill,\n.btn-group.align-end .wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill {\n  margin-left: 4px;\n}\n\nspan {\n  box-sizing: border-box;\n  display: flex;\n  flex: 1;\n  align-items: center;\n  transition: all 0.5s;\n  min-height: 30px;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  line-height: 26px;\n}\n\n.tf-button.btn-delete,\n.wt-button.btn-delete {\n  margin-top: 3px;\n}\n\n.btn-edit {\n  opacity: 0;\n  transition: all 0.5s;\n}\n\n.container-editing {\n  display: flex;\n  flex-direction: column;\n}\n.container-readonly {\n  display: flex;\n}\n.container-readonly:hover .btn-edit, .container-readonly.is-hovering .btn-edit {\n  opacity: 1;\n}\n.container-readonly:hover .faux-input, .container-readonly.is-hovering .faux-input {\n  padding: 0 15px;\n  border-color: #c1c1c1;\n  background: #fff;\n}\n\n.faux-input {\n  border: 1px solid transparent;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.faux-input > span {\n  display: block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.tf-inline-form-field,\n.wt-inline-form-field {\n  width: 100%;\n}\n\n/*# sourceMappingURL=TfInlineFormField.vue.map */","<template>\n  <div class=\"tf-inline-form-field wt-inline-form-field\">\n    <div\n      v-if=\"isEditing\"\n      class=\"container-editing\"\n    >\n      <ElForm\n        :model=\"{ [prop]: localValue }\"\n        @submit.native.prevent\n      >\n        <ElFormItem\n          :prop=\"prop\"\n          size=\"medium\"\n        >\n          <slot>\n            <ElInput\n              ref=\"input\"\n              v-bind=\"{\n                disabled: btnsDisabled,\n                placeholder\n              }\"\n              v-model=\"localValue\"\n              @keyup.native.enter=\"onSave\"\n              @keyup.native.escape=\"onCancel\"\n            >\n              <template\n                v-if=\"showExtension\"\n                slot=\"append\"\n                :data-test=\"`inline form field ${prop} extension`\"\n              >\n                {{ extension }}\n              </template>\n            </ElInput>\n          </slot>\n          <div\n            v-if=\"showBtnActions\"\n            class=\"btn-group align-end\"\n          >\n            <!-- btn: cancel edit -->\n            <AppButton\n              :is-disabled=\"btnsDisabled\"\n              data-test=\"cancel inline form field edit\"\n              icon=\"fa-solid fa-xmark\"\n              size=\"icon\"\n              title=\"Cancel edit\"\n              type=\"decline\"\n              @click=\"onCancel\"\n            />\n            <!-- btn: save product -->\n            <AppButton\n              :is-disabled=\"btnsDisabled || btnSaveDisabled\"\n              :is-loading=\"isSaving\"\n              data-test=\"confirm inline form field edit\"\n              icon=\"fa-solid fa-check\"\n              size=\"icon\"\n              title=\"Confirm edit\"\n              type=\"affirm\"\n              @click=\"onSave\"\n            />\n          </div>\n        </ElFormItem>\n      </ElForm>\n      <div class=\"btn-group align-start\">\n        <AppButton\n          v-if=\"showBtnDelete\"\n          :is-disabled=\"btnsDisabled\"\n          :text=\"`Delete${deleteType ? ` ${deleteType}` : ''}`\"\n          class=\"btn-delete\"\n          data-test=\"delete inline form field\"\n          size=\"text-small\"\n          type=\"decline\"\n          @click=\"onDelete\"\n        />\n      </div>\n    </div>\n    <div\n      v-else\n      :class=\"[\n        { 'is-hovering': isHovering },\n        'container-readonly'\n      ]\"\n    >\n      <span\n        class=\"faux-input\"\n        @click=\"onEdit\"\n      >\n        <span>{{ value }}</span>\n      </span>\n      <AppButton\n        v-if=\"showBtnEdit\"\n        data-test=\"edit inline form field\"\n        class=\"btn-edit\"\n        icon=\"fa-solid fa-pencil\"\n        title=\"Edit field\"\n        type=\"primary\"\n        size=\"icon\"\n        @click=\"onEdit\"\n      />\n    </div>\n  </div>\n</template>\n\n<script>\n  /**\n   * This is an input used when there are \"readonly\" and \"edit\" modes. The \"readonly\" will render out text that on hover (or parental hover) will look like an input. The \"edit\" mode by default will show an  input > cancel button > save button\" design pattern is required. The parent should handle the readonly state along with the API's success/failure returns.\n   *\n   * @vuedoc\n   * @exports TfForm/TfInlineFormField\n   * @category Components\n   */\n  export default {\n    name: 'TfInlineFormField',\n    props: {\n      deleteType: {\n        type: String,\n        default: '',\n      },\n      isDisabled: {\n        type: Boolean,\n        default: false,\n      },\n      isEditing: {\n        type: Boolean,\n        required: true,\n      },\n      isHovering: {\n        type: Boolean,\n        default: false,\n      },\n      isDeleting: {\n        type: Boolean,\n        default: false,\n      },\n      isSaving: {\n        type: Boolean,\n        required: true,\n      },\n      isRequired: {\n        type: Boolean,\n        default: true,\n      },\n      placeholder: {\n        type: String,\n        default: 'Enter value',\n      },\n      prop: {\n        type: String,\n        required: true,\n      },\n      showBtnDelete: {\n        type: Boolean,\n        default: true,\n      },\n      showBtnEdit: {\n        type: Boolean,\n        default: true,\n      },\n      showBtnActions: {\n        type: Boolean,\n        default: true,\n      },\n      showExtension: {\n        type: Boolean,\n        default: true,\n      },\n      value: {\n        type: String,\n        required: true,\n      },\n    },\n    data: (vm) => ({\n      originalValue: vm.value,\n    }),\n    computed: {\n      /**\n       * Evaluate different states to disable all the buttons in the template.\n       *\n       * @returns {boolean}\n       */\n      btnsDisabled() {\n        return this.isDeleting || this.isSaving || this.isDisabled;\n      },\n      /**\n       * Evaluate different states to disable all the save in the template and prevent the form from submitting on enter.\n       *\n       * @returns {boolean}\n       */\n      btnSaveDisabled() {\n        return this.isRequired && !this.localValue;\n      },\n      /**\n       * Evaluate the props to get the extension if necessessary.\n       *\n       * @returns {string}\n       */\n      extension() {\n        return this.showExtension\n          ? this.value.substr(this.value.lastIndexOf('.') + 1)\n          : '';\n      },\n      /**\n       * Get the local value for the input with/without the extension.\n       * Emit the new value with/without the extension.\n       *\n       * @returns {string}\n       */\n      localValue: {\n        get() {\n          return this.showExtension && this.isEditing\n            ? this.value.replace(`.${this.extension}`, '')\n            : this.value;\n        },\n        set(value) {\n          const newValue = this.extension\n            ? `${value}.${this.extension}`\n            : value;\n\n          this.$emit('input', newValue);\n        },\n      },\n    },\n    methods: {\n      /**\n       * Emit \"cancel\" and \"edit\" correctly to reset the state in the parent.\n       */\n      onCancel() {\n        this.$emit('cancel', this.originalValue);\n        this.$emit('edit', false);\n      },\n      /**\n       * Set btnsDisable to `true` and emit \"delete\" to the parent.\n       */\n      onDelete() {\n        this.$emit('delete');\n      },\n      /**\n       * Emit up to the parent and wait for the prop to change. If the default slot for the edit mode is being used, we focus on the input.\n       */\n      onEdit() {\n        this.$emit('edit', true);\n\n        this.$nextTick(() => {\n          // need to test b/c of jest timing issues I can't pinpoint as well.\n          if (this.$slots.default || !this.$refs.input) {\n            return;\n          }\n\n          this.$refs.input.$el.querySelector('input').focus();\n        });\n      },\n      /**\n       * Emit \"save\" with the correct value/extension only if any of the disabled states aren't true. We also want to update \"originalValue\" since this component is not destroyed.\n       */\n      onSave() {\n        if (this.btnsDisabled || this.btnSaveDisabled) {\n          return;\n        }\n\n        const newValue = this.showExtension && this.isEditing\n          ? `${this.localValue}.${this.extension}`\n          : this.localValue;\n        this.originalValue = newValue;\n\n        this.$emit('save', newValue);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .el-form-item {\n    margin: 0;\n  }\n\n  ::v-deep {\n    .el-form-item__content {\n      display: flex;\n      align-items: center;\n    }\n\n    .el-input-group__append {\n      background-color: $tf-extra-light-gray-2;\n      border: {\n        top-right-radius: 2px;\n        bottom-right-radius: 2px;\n      }\n    }\n  }\n\n  .btn-group.align-end {\n    margin-left: 15px;\n\n    // Long term, this should be replaced in the button component scoped styles.\n    .tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill,\n    .wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill {\n      margin-left: 4px;\n    }\n  }\n\n  span {\n    box-sizing: border-box;\n    display: flex;\n    flex: 1;\n    align-items: center;\n    transition: all .5s;\n    min-height: 30px;\n    border: 1px solid transparent;\n    border-radius: 2px;\n    line-height: 26px;\n  }\n\n  .tf-button.btn-delete,\n  .wt-button.btn-delete {\n    margin-top: 3px;\n  }\n\n  .btn-edit {\n    opacity: 0;\n    transition: all .5s;\n  }\n\n  .container {\n    &-editing {\n      display: flex;\n      flex-direction: column;\n    }\n\n    &-readonly {\n      display: flex;\n\n      &:hover,\n      &.is-hovering {\n        .btn-edit {\n          opacity: 1;\n        }\n\n        .faux-input {\n          padding: 0 15px;\n          border-color: $tf-light-gray;\n          background: $tf-white;\n        }\n      }\n    }\n  }\n\n  .faux-input {\n    border: 1px solid transparent;\n    cursor: pointer;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    > span {\n      display: block;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n  }\n\n  .tf-inline-form-field,\n  .wt-inline-form-field {\n    width: 100%;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$z = "data-v-fd38e7fe";
  /* module identifier */
  const __vue_module_identifier__$z = undefined;
  /* functional template */
  const __vue_is_functional_template__$z = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$z = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$y, staticRenderFns: __vue_staticRenderFns__$y },
    __vue_inject_styles__$z,
    __vue_script__$z,
    __vue_scope_id__$z,
    __vue_is_functional_template__$z,
    __vue_module_identifier__$z,
    false,
    browser,
    undefined,
    undefined
  );

var script$A = {
  props: {
    allowEnter: {
      type: Boolean,
      default: true
    },
    appendValidationType: {
      type: Boolean,
      default: false
    },
    autoCollapse: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * "groupedDisabledOptions" provides a list of disabled options that appear below the options in the dropdown.
     */
    groupedDisabledOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * "groupedDisabledOptionsTitle" provides a title for the list of disabled options.
     */
    groupedDisabledOptionsTitle: {
      type: String,
      default: 'Used values'
    },
    optionKey: {
      type: String,
      default: 'normalized_value'
    },
    // Pass this if any objects in the options array has a label that doesn't match the value
    // Example: { normalized_value: '10%', normalized_label: 'Match in-force'}
    optionLabel: {
      type: String,
      default: 'normalized_label'
    },
    /* An array of objects. Each object contains a single option and may optionally contain an
    isDisabled prop that will determine if a specific dropdown item is disabled */
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: 'Enter value'
    },
    prependValidationType: {
      type: Boolean,
      default: false
    },
    prop: {
      type: String,
      default: ''
    },
    saving: {
      type: Boolean,
      default: false
    },
    suffixClickable: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: null
    },
    validationType: {
      type: String,
      default: 'string'
    },
    value: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 'auto'
    }
  },
  data: function data(vm) {
    return {
      debounceChangeEvent: debounce$1(vm.sendChangeEvent, 500),
      selectedValue: '',
      showAutocomplete: false,
      showTooltip: false,
      initialValueSet: false,
      autoWidth: null,
      userEdited: false,
      hasFocus: false
    };
  },
  computed: {
    /**
     * get the correct width for the popover
     *
     * @returns {string}
     */
    popoverWidth: function popoverWidth() {
      return this.width === 'auto' ? this.autoWidth : this.width;
    },
    /**
     * get the correct text for the prepend/append divs
     *
     * @returns {string}
     */
    validationTypeText: function validationTypeText() {
      var text;
      if (this.validationType === 'dollar') {
        text = '$';
      } else if (this.validationType === 'percentage-whole-number') {
        text = '%';
      }
      return text;
    },
    /**
     * If the user has edited the value of the input,
     * filter options based on what was entered.
     * There is a potential edge case where `options` MIGHT
     * be passed as `null` so we're covering that just in case.
     *
     * @returns {Array}
     */
    filteredOptions: function filteredOptions() {
      var _this = this;
      var options = this.options || [];

      // user hasn't edited, there's no value—show all options, or user has hit "enter" w/o a value.
      if (!this.userEdited || !this.selectedValue) {
        return options;
      }
      return options.filter(function (option) {
        /*
          Not all objects in the options array need to have a label
          so we filter by optionLabel first and use the optionKeys as the backup testValue.
        */
        var testValue = option[_this.optionLabel] || option[_this.optionKey];
        return testValue.toLowerCase().includes(_this.selectedValue.toLowerCase());
      });
    }
  },
  watch: {
    /**
     * Everytime the value changes we need parse the value based on its validation type and update the selectedValue.
     */
    value: function value() {
      this.selectedValue = this.parseValue(this.value);
    },
    /**
     * Emit the change up when the selectedValue changes
     */
    selectedValue: function selectedValue() {
      this.$emit('input', this.selectedValue);
      if (this.initialValueSet) {
        this.debounceChangeEvent();
      }
      this.initialValueSet = true;
    },
    /**
     * Set the correct auto width for the popover when it is shown
     *
     * @param {boolean} showAutocomplete
     */
    showAutocomplete: function showAutocomplete(_showAutocomplete) {
      if (_showAutocomplete && this.width === 'auto') {
        this.autoWidth = this.$el.clientWidth;
      }
    },
    /**
     * Show/hide the autocomplete popover if there are options/no options and the user has edited the input
     * (overrides existing behavior only for the userEdited autocomplete behavior)
     *
     * @param {Array} newOptions
     */
    filteredOptions: function filteredOptions(newOptions) {
      if (this.userEdited && this.hasFocus) {
        this.showAutocomplete = !!newOptions.length;
      }
    }
  },
  created: function created() {
    if (this.value) {
      this.selectedValue = this.parseValue(this.value);
    } else {
      this.initialValueSet = true;
    }
  },
  methods: {
    /**
     * Fires When a user clicks on a list item in the popover we hide
     * We updated the 'selectedValue' as well as close the dropdown and focus on the textarea
     *
     * @param {string} value
     * @param {boolean} [isDisabled] - If the item is disabled, do nothing when it is clicked or the enter key is hit
     */
    autoCompleteClick: function autoCompleteClick(value, isDisabled) {
      var _this2 = this;
      if (isDisabled) {
        return;
      }
      this.selectedValue = this.parseValue(value);
      this.$nextTick(function () {
        _this2.$el.querySelector('textarea').focus();
        _this2.showAutocomplete = false;
      });
    },
    /**
     * Handle keydown events
     *
     * @param {object} event
     */
    onKeydown: function onKeydown(event) {
      var charCode = event.which ? event.which : event.keyCode;
      // Conditions
      var isNumpad = charCode >= 96 && charCode <= 105;
      var isTopNumbers = charCode >= 48 && charCode <= 57;
      var isNumericKey = isNumpad || isTopNumbers;

      // Allow for 'selecting all', 'copy', and 'paste'
      var isCopyPaste = event.metaKey && ['a', 'c', 'v'].includes(event.key);
      var isModifier = event.shiftKey;
      var isArrowKey = [37, 38, 39, 40].includes(charCode);
      if (!isArrowKey) {
        // at this point, we're saying that the user has edited the field, because they pushed a key
        this.userEdited = true;
      }

      // prevent keydown and emit to the parent if key is Enter and !allowEnter
      if (!this.allowEnter && charCode === 13) {
        event.preventDefault();
        this.$emit('keydownEnter');
      }

      // Allow if user is copy/pasting
      var numericValidationTypes = ['percentage-whole-number', 'whole-number'];
      if (!isCopyPaste) {
        if (numericValidationTypes.includes(this.validationType) && charCode > 31) {
          if (!isNumericKey || isModifier) {
            event.preventDefault();
          }
        }
      }
    },
    /**
     * When a user clicks in the text area we open the dropdown
     */
    onInputClick: function onInputClick() {
      this.showAutocomplete = true;
    },
    /**
     * When the text area gets focus we open the dropdown
     */
    onInputFocus: function onInputFocus() {
      this.$emit('focus');
      // reset if the user left
      this.userEdited = false;
      if (this.options.length) {
        this.showAutocomplete = true;
      }
      this.hasFocus = true;
      if (this.tooltip) {
        this.showTooltip = true;
      }
      var self = this;
      window.setTimeout(function () {
        var autocomplete = self.$el.querySelector('.auto-complete-textarea');
        autocomplete.removeAttribute('tabindex');
      }, 100);
    },
    /**
     * When the text area loses we check if the focus is in the dropdown, if it's not we close the dropdown
     *
     * @param {object} event
     */
    onInputBlur: function onInputBlur(event) {
      if (!event) {
        return;
      }
      this.hasFocus = false;
      var relatedTarget = event.relatedTarget;
      var popover = this.$refs.popoverContainer;
      var isInPopover = this.isChildOf(relatedTarget, popover);
      if (!isInPopover) {
        if (this.tooltip) {
          this.showTooltip = false;
        }
        this.showAutocomplete = false;
        this.$emit('blur', event);
      }
      this.debounceChangeEvent.flush();
    },
    /**
     * If the user presses down while in the text area we focus on the first list item
     */
    handleTextAreaArrowDown: function handleTextAreaArrowDown() {
      if (this.filteredOptions.length) {
        this.$refs.popoverContainer.querySelector('li:first-child').focus();
      }
    },
    /**
     * If the user presses up on a list item we focus on the one above it (or on the text area)
     *
     * @param {object} event
     */
    handleListItemArrowUp: function handleListItemArrowUp(event) {
      event.preventDefault();
      var previousSibling = event.target.previousSibling;
      if (previousSibling) {
        previousSibling.focus();
      } else {
        this.$el.querySelector('textarea').focus();
      }
    },
    /**
     * If the user presses down on a list item we focus on the next item
     *
     * @param {object} event
     */
    handleListItemArrowDown: function handleListItemArrowDown(event) {
      event.preventDefault();
      var nextSibling = event.target.nextSibling;
      if (nextSibling) {
        nextSibling.focus();
      }
    },
    /**
     * If the user presses esc, we close the dropdown and focus on the textarea
     */
    handleEscKey: function handleEscKey() {
      this.showAutocomplete = false;
      this.$el.querySelector('textarea').focus();
    },
    /**
     * Parse the passed value based on what the validation type is.
     *
     * @param {string} value
     * @returns {string}
     */
    parseValue: function parseValue(value) {
      var parsedValue;
      switch (this.validationType) {
        case 'percentage-whole-number':
          parsedValue = value.replace('%', '');
          break;
        default:
          parsedValue = value;
      }
      return parsedValue;
    },
    /**
     * Let's emit a change event up when the value changes
     */
    sendChangeEvent: function sendChangeEvent() {
      var parsedValue;
      switch (this.validationType) {
        case 'percentage-whole-number':
          parsedValue = "".concat(this.selectedValue, "%");
          break;
        default:
          parsedValue = this.selectedValue;
      }
      this.$emit('change', parsedValue);
    },
    /**
     * Is the first element a child of the second
     * We use to decide to if the user is still in the dropdown
     *
     * @param {object} child
     * @param {object} parent
     * @returns {boolean}
     */
    isChildOf: function isChildOf(child, parent) {
      if (!child) {
        return false;
      }
      if (child.parentNode === parent) {
        return true;
      }
      if (child.parentNode === null) {
        return false;
      }
      return this.isChildOf(child.parentNode, parent);
    }
  }
};

/* script */
const __vue_script__$A = script$A;

/* template */
var __vue_render__$z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: [
        { "with-suffix-icon": _vm.suffixClickable },
        { "with-text-addition": _vm.validationType !== "string" },
      ],
    },
    [
      _vm.tooltip
        ? _c(
            "TfTooltip",
            {
              attrs: {
                options: {
                  placement: "top",
                },
                "force-show": _vm.showTooltip,
                trigger: "click",
              },
            },
            [
              _c("div", { attrs: { slot: "reference" }, slot: "reference" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "tooltip-inner",
                style: "width: " + (_vm.popoverWidth - 22) + "px",
                domProps: { textContent: _vm._s(_vm.tooltip) },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.prependValidationType
        ? _c("span", {
            staticClass: "prepend-input text-addition",
            domProps: { textContent: _vm._s(_vm.validationTypeText) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.options.length
        ? _c(
            "ElPopover",
            _vm._b(
              {
                attrs: { placement: "bottom-start", trigger: "manual" },
                model: {
                  value: _vm.showAutocomplete,
                  callback: function ($$v) {
                    _vm.showAutocomplete = $$v;
                  },
                  expression: "showAutocomplete",
                },
              },
              "ElPopover",
              {
                disabled: _vm.disabled || _vm.saving,
                width: _vm.popoverWidth,
                popperOptions: {
                  boundariesElement: "body",
                  gpuAcceleration: true,
                  positionFixed: false,
                  preventOverflow: false,
                },
                popperClass: "el-select-dropdown autocomplete",
              },
              false
            ),
            [
              _c(
                "div",
                {
                  ref: "popoverContainer",
                  staticClass:
                    "el-select-dropdown__wrap el-scrollbar__wrap el-scrollbar__wrap--hidden-default",
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "el-scrollbar__view el-select-dropdown__list",
                      attrs: { "data-test": "dropdown list" },
                    },
                    [
                      _vm._l(_vm.filteredOptions, function (option, index) {
                        return _c("li", {
                          key: index,
                          staticClass: "el-select-dropdown__item",
                          class: { "is-disabled": option.isDisabled },
                          attrs: {
                            "data-test": "select " + option[_vm.optionKey],
                            tabindex: "0",
                          },
                          domProps: {
                            textContent: _vm._s(
                              option[_vm.optionLabel] || option[_vm.optionKey]
                            ),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.autoCompleteClick(
                                option[_vm.optionKey],
                                option.isDisabled
                              )
                            },
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault();
                                return _vm.autoCompleteClick(
                                  option[_vm.optionKey],
                                  option.isDisabled
                                )
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k($event.keyCode, "up", 38, $event.key, [
                                    "Up",
                                    "ArrowUp",
                                  ])
                                ) {
                                  return null
                                }
                                return _vm.handleListItemArrowUp.apply(
                                  null,
                                  arguments
                                )
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "down",
                                    40,
                                    $event.key,
                                    ["Down", "ArrowDown"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleListItemArrowDown.apply(
                                  null,
                                  arguments
                                )
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "tab",
                                    9,
                                    $event.key,
                                    "Tab"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.autoCompleteClick(
                                  option[_vm.optionKey]
                                )
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "esc",
                                    27,
                                    $event.key,
                                    ["Esc", "Escape"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleEscKey.apply(null, arguments)
                              },
                            ],
                          },
                        })
                      }),
                      _vm._v(" "),
                      _vm.groupedDisabledOptions.length
                        ? [
                            _c("li", {
                              staticClass: "el-select-group__title",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.groupedDisabledOptionsTitle
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.groupedDisabledOptions,
                              function (option, index) {
                                return _c("li", {
                                  key: "disabled-" + index,
                                  staticClass:
                                    "el-select-dropdown__item is-disabled",
                                  domProps: {
                                    textContent: _vm._s(
                                      option[_vm.optionLabel] ||
                                        option[_vm.optionKey]
                                    ),
                                  },
                                })
                              }
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c("ElInput", {
                ref: "auto-complete-textarea",
                staticClass: "auto-complete-textarea",
                class: _vm.autoCollapse ? "auto-collapse" : "",
                attrs: {
                  slot: "reference",
                  "data-test": "edit " + _vm.prop,
                  disabled: _vm.disabled || _vm.saving,
                  placeholder: _vm.placeholder,
                  autosize: "",
                  size: "mini",
                  type: "textarea",
                },
                on: { focus: _vm.onInputFocus, blur: _vm.onInputBlur },
                nativeOn: {
                  keydown: [
                    function ($event) {
                      return _vm.onKeydown.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown",
                        ])
                      ) {
                        return null
                      }
                      return _vm.handleTextAreaArrowDown.apply(null, arguments)
                    },
                  ],
                  click: function ($event) {
                    return _vm.onInputClick()
                  },
                },
                slot: "reference",
                model: {
                  value: _vm.selectedValue,
                  callback: function ($$v) {
                    _vm.selectedValue = $$v;
                  },
                  expression: "selectedValue",
                },
              }),
            ],
            1
          )
        : _c(
            "ElInput",
            _vm._b(
              {
                staticClass: "auto-complete-textarea",
                class: { "auto-collapse": _vm.autoCollapse },
                attrs: {
                  "data-test": "edit " + _vm.prop,
                  autosize: "",
                  size: "mini",
                  type: "textarea",
                },
                on: { focus: _vm.onInputFocus, blur: _vm.onInputBlur },
                nativeOn: {
                  keydown: function ($event) {
                    return _vm.onKeydown.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.selectedValue,
                  callback: function ($$v) {
                    _vm.selectedValue = $$v;
                  },
                  expression: "selectedValue",
                },
              },
              "ElInput",
              {
                disabled: _vm.disabled || _vm.saving,
                placeholder: _vm.placeholder,
                prop: _vm.prop,
              },
              false
            )
          ),
      _vm._v(" "),
      _vm.appendValidationType
        ? _c("span", {
            staticClass: "append-input text-addition",
            domProps: { textContent: _vm._s(_vm.validationTypeText) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.suffixClickable
        ? _c("TfButton", {
            class: [{ "is-focused": _vm.showAutocomplete }, "button-suffix"],
            attrs: {
              disabled: _vm.disabled,
              icon: _vm.suffixClickable,
              loading: _vm.saving,
              type: "secondary",
              size: "icon-no-fill",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("suffixClick")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$z = [];
__vue_render__$z._withStripped = true;

  /* style */
  const __vue_inject_styles__$A = function (inject) {
    if (!inject) return
    inject("data-v-bf5c8368_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tooltip-inner[data-v-bf5c8368] {\n  text-align: left;\n}\n.button-suffix.tf-button--icon-no-fill.has-icon[data-v-bf5c8368],\n.button-suffix.wt-button--icon-no-fill.has-icon[data-v-bf5c8368] {\n  position: absolute;\n  top: 0;\n  right: 5px;\n  bottom: 0;\n  padding: 0 5px;\n  color: #999;\n}\n.button-suffix.tf-button--icon-no-fill.has-icon svg[data-v-bf5c8368],\n.button-suffix.wt-button--icon-no-fill.has-icon svg[data-v-bf5c8368] {\n  fill: #c1c1c1;\n}\n.text-addition[data-v-bf5c8368] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  color: #999;\n  background: #fafafa;\n  border: 1px solid #c1c1c1;\n}\n.text-addition.append-input[data-v-bf5c8368] {\n  border-left: none;\n}\n.text-addition.prepend-input[data-v-bf5c8368] {\n  border-right: none;\n}\n.with-suffix-icon[data-v-bf5c8368] {\n  position: relative;\n}\n.with-suffix-icon .auto-complete-textarea .el-textarea__inner[data-v-bf5c8368] {\n  padding-right: 30px;\n}\n.with-text-addition[data-v-bf5c8368] {\n  display: flex;\n}\n.with-text-addition > span[data-v-bf5c8368]:not(.text-addition) {\n  flex-grow: 1;\n}\n.el-select-dropdown.autocomplete li[data-v-bf5c8368]:focus {\n  background-color: #efefef;\n  outline: 0;\n}\n.el-select-dropdown__item[data-v-bf5c8368] {\n  overflow: inherit;\n  height: auto;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  text-overflow: inherit;\n  line-height: inherit;\n  white-space: inherit;\n}\n.el-select-dropdown__item.is-disabled[data-v-bf5c8368] {\n  pointer-events: none;\n}\n.el-select-dropdown__list .is-disabled[data-v-bf5c8368], .el-select-dropdown__list .is-disabled[data-v-bf5c8368]:hover {\n  /* stylelint-disable declaration-no-important */\n  color: #999 !important;\n  background: #efefef !important;\n  /* stylelint-enable declaration-no-important */\n  font-style: italic;\n}\n\n/*# sourceMappingURL=TfInputWithOptions.vue.map */", map: {"version":3,"sources":["TfInputWithOptions.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfForm/TfInputWithOptions.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACgkBlC;EACA,gBAAA;AD9jBA;ACikBA;;EAEA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;AD9jBA;ACgkBA;;EACA,aAAA;AD7jBA;ACikBA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AD9jBA;ACgkBA;EACA,iBAAA;AD9jBA;ACikBA;EACA,kBAAA;AD/jBA;ACmkBA;EACA,kBAAA;ADhkBA;ACkkBA;EACA,mBAAA;ADhkBA;ACokBA;EACA,aAAA;ADjkBA;ACokBA;EACA,YAAA;ADlkBA;ACukBA;EACA,yBAAA;EACA,UAAA;ADpkBA;ACwkBA;EACA,iBAAA;EACA,YAAA;EAEA,gBAAA;EACA,mBAAA;EAEA,sBAAA;EACA,oBAAA;EACA,oBAAA;ADvkBA;ACykBA;EACA,oBAAA;ADvkBA;AC6kBA;EAGA,+CAAA;EACA,sBAAA;EACA,8BAAA;EACA,8CAAA;EACA,kBAAA;AD5kBA;;AAEA,iDAAiD","file":"TfInputWithOptions.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tooltip-inner {\n  text-align: left;\n}\n\n.button-suffix.tf-button--icon-no-fill.has-icon,\n.button-suffix.wt-button--icon-no-fill.has-icon {\n  position: absolute;\n  top: 0;\n  right: 5px;\n  bottom: 0;\n  padding: 0 5px;\n  color: #999;\n}\n.button-suffix.tf-button--icon-no-fill.has-icon svg,\n.button-suffix.wt-button--icon-no-fill.has-icon svg {\n  fill: #c1c1c1;\n}\n\n.text-addition {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  color: #999;\n  background: #fafafa;\n  border: 1px solid #c1c1c1;\n}\n.text-addition.append-input {\n  border-left: none;\n}\n.text-addition.prepend-input {\n  border-right: none;\n}\n\n.with-suffix-icon {\n  position: relative;\n}\n.with-suffix-icon .auto-complete-textarea .el-textarea__inner {\n  padding-right: 30px;\n}\n\n.with-text-addition {\n  display: flex;\n}\n.with-text-addition > span:not(.text-addition) {\n  flex-grow: 1;\n}\n\n.el-select-dropdown.autocomplete li:focus {\n  background-color: #efefef;\n  outline: 0;\n}\n\n.el-select-dropdown__item {\n  overflow: inherit;\n  height: auto;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  text-overflow: inherit;\n  line-height: inherit;\n  white-space: inherit;\n}\n.el-select-dropdown__item.is-disabled {\n  pointer-events: none;\n}\n\n.el-select-dropdown__list .is-disabled, .el-select-dropdown__list .is-disabled:hover {\n  /* stylelint-disable declaration-no-important */\n  color: #999 !important;\n  background: #efefef !important;\n  /* stylelint-enable declaration-no-important */\n  font-style: italic;\n}\n\n/*# sourceMappingURL=TfInputWithOptions.vue.map */","<template>\n  <div\n    :class=\"[\n      { 'with-suffix-icon' : suffixClickable },\n      { 'with-text-addition' : validationType !== 'string' },\n    ]\"\n  >\n    <TfTooltip\n      v-if=\"tooltip\"\n      :options=\"{\n        placement: 'top',\n      }\"\n      :force-show=\"showTooltip\"\n      trigger=\"click\"\n    >\n      <!-- we need a blank element to act as a reference -->\n      <div slot=\"reference\" />\n      <div\n        class=\"tooltip-inner\"\n        :style=\"`width: ${popoverWidth - 22}px`\"\n        v-text=\"tooltip\"\n      />\n    </TfTooltip>\n\n    <span\n      v-if=\"prependValidationType\"\n      class=\"prepend-input text-addition\"\n      v-text=\"validationTypeText\"\n    />\n    <!-- eslint-disable max-len -->\n    <!-- To do: We should replace this with the base <popper /> when we can.-->\n    <ElPopover\n      v-if=\"options.length\"\n      v-model=\"showAutocomplete\"\n      v-bind=\"{\n        disabled: disabled || saving,\n        width: popoverWidth,\n        popperOptions: {\n          boundariesElement: 'body',\n          gpuAcceleration: true,\n          positionFixed: false,\n          preventOverflow: false\n        },\n        popperClass: 'el-select-dropdown autocomplete',\n      }\"\n      placement=\"bottom-start\"\n      trigger=\"manual\"\n    >\n      <div\n        ref=\"popoverContainer\"\n        class=\"el-select-dropdown__wrap el-scrollbar__wrap el-scrollbar__wrap--hidden-default\"\n      >\n        <ul\n          class=\"el-scrollbar__view el-select-dropdown__list\"\n          data-test=\"dropdown list\"\n        >\n          <li\n            v-for=\"(option, index) in filteredOptions\"\n            :key=\"index\"\n            :data-test=\"`select ${option[optionKey]}`\"\n            class=\"el-select-dropdown__item\"\n            :class=\"{ 'is-disabled': option.isDisabled }\"\n            tabindex=\"0\"\n            @click=\"autoCompleteClick(option[optionKey], option.isDisabled)\"\n            @keydown.enter.prevent=\"autoCompleteClick(option[optionKey], option.isDisabled)\"\n            @keydown.up=\"handleListItemArrowUp\"\n            @keydown.down=\"handleListItemArrowDown\"\n            @keydown.tab=\"autoCompleteClick(option[optionKey])\"\n            @keydown.esc=\"handleEscKey\"\n            v-text=\"option[optionLabel] || option[optionKey]\"\n          />\n          <template v-if=\"groupedDisabledOptions.length\">\n            <li\n              class=\"el-select-group__title\"\n              v-text=\"groupedDisabledOptionsTitle\"\n            />\n            <li\n              v-for=\"(option, index) in groupedDisabledOptions\"\n              :key=\"`disabled-${index}`\"\n              class=\"el-select-dropdown__item is-disabled\"\n              v-text=\"option[optionLabel] || option[optionKey]\"\n            />\n          </template>\n        </ul>\n      </div>\n      <ElInput\n        slot=\"reference\"\n        ref=\"auto-complete-textarea\"\n        v-model=\"selectedValue\"\n        :data-test=\"`edit ${prop}`\"\n        :class=\"autoCollapse ? 'auto-collapse' : ''\"\n        :disabled=\"disabled || saving\"\n        :placeholder=\"placeholder\"\n        class=\"auto-complete-textarea\"\n        autosize\n        size=\"mini\"\n        type=\"textarea\"\n        @keydown.native=\"onKeydown\"\n        @keydown.native.down=\"handleTextAreaArrowDown\"\n        @click.native=\"onInputClick()\"\n        @focus=\"onInputFocus\"\n        @blur=\"onInputBlur\"\n      />\n    </ElPopover>\n    <ElInput\n      v-else\n      v-model=\"selectedValue\"\n      v-bind=\"{\n        disabled: disabled || saving,\n        placeholder,\n        prop,\n      }\"\n      :class=\"{ 'auto-collapse' : autoCollapse }\"\n      :data-test=\"`edit ${prop}`\"\n      class=\"auto-complete-textarea\"\n      autosize\n      size=\"mini\"\n      type=\"textarea\"\n      @keydown.native=\"onKeydown\"\n      @focus=\"onInputFocus\"\n      @blur=\"onInputBlur\"\n    />\n    <span\n      v-if=\"appendValidationType\"\n      class=\"append-input text-addition\"\n      v-text=\"validationTypeText\"\n    />\n    <TfButton\n      v-if=\"suffixClickable\"\n      :disabled=\"disabled\"\n      :icon=\"suffixClickable\"\n      :loading=\"saving\"\n      type=\"secondary\"\n      size=\"icon-no-fill\"\n      :class=\"[\n        { 'is-focused' : showAutocomplete, },\n        'button-suffix'\n      ]\"\n      @click=\"$emit('suffixClick')\"\n    />\n  </div>\n</template>\n\n<script>\n  import { debounce } from 'lodash';\n\n  export default {\n    props: {\n      allowEnter: {\n        type: Boolean,\n        default: true,\n      },\n      appendValidationType: {\n        type: Boolean,\n        default: false,\n      },\n      autoCollapse: {\n        type: Boolean,\n        default: true,\n      },\n      disabled: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * \"groupedDisabledOptions\" provides a list of disabled options that appear below the options in the dropdown.\n       */\n      groupedDisabledOptions: {\n        type: Array,\n        default: () => [],\n      },\n      /**\n       * \"groupedDisabledOptionsTitle\" provides a title for the list of disabled options.\n       */\n      groupedDisabledOptionsTitle: {\n        type: String,\n        default: 'Used values',\n      },\n      optionKey: {\n        type: String,\n        default: 'normalized_value',\n      },\n      // Pass this if any objects in the options array has a label that doesn't match the value\n      // Example: { normalized_value: '10%', normalized_label: 'Match in-force'}\n      optionLabel: {\n        type: String,\n        default: 'normalized_label',\n      },\n      /* An array of objects. Each object contains a single option and may optionally contain an\n      isDisabled prop that will determine if a specific dropdown item is disabled */\n      options: {\n        type: Array,\n        default: () => [],\n      },\n      placeholder: {\n        type: String,\n        default: 'Enter value',\n      },\n      prependValidationType: {\n        type: Boolean,\n        default: false,\n      },\n      prop: {\n        type: String,\n        default: '',\n      },\n      saving: {\n        type: Boolean,\n        default: false,\n      },\n      suffixClickable: {\n        type: String,\n        default: '',\n      },\n      tooltip: {\n        type: String,\n        default: null,\n      },\n      validationType: {\n        type: String,\n        default: 'string',\n      },\n      value: {\n        type: String,\n        default: '',\n      },\n      width: {\n        type: [Number, String],\n        default: 'auto',\n      },\n    },\n    data: (vm) => ({\n      debounceChangeEvent: debounce(vm.sendChangeEvent, 500),\n      selectedValue: '',\n      showAutocomplete: false,\n      showTooltip: false,\n      initialValueSet: false,\n      autoWidth: null,\n      userEdited: false,\n      hasFocus: false,\n    }),\n    computed: {\n      /**\n       * get the correct width for the popover\n       *\n       * @returns {string}\n       */\n      popoverWidth() {\n        return this.width === 'auto'\n          ? this.autoWidth\n          : this.width;\n      },\n\n      /**\n       * get the correct text for the prepend/append divs\n       *\n       * @returns {string}\n       */\n      validationTypeText() {\n        let text;\n\n        if (this.validationType === 'dollar') {\n          text = '$';\n        } else if (this.validationType === 'percentage-whole-number') {\n          text = '%';\n        }\n\n        return text;\n      },\n\n      /**\n       * If the user has edited the value of the input,\n       * filter options based on what was entered.\n       * There is a potential edge case where `options` MIGHT\n       * be passed as `null` so we're covering that just in case.\n       *\n       * @returns {Array}\n       */\n      filteredOptions() {\n        const options = this.options || [];\n\n        // user hasn't edited, there's no value—show all options, or user has hit \"enter\" w/o a value.\n        if (!this.userEdited || !this.selectedValue) {\n          return options;\n        }\n\n        return options.filter((option) => {\n          /*\n            Not all objects in the options array need to have a label\n            so we filter by optionLabel first and use the optionKeys as the backup testValue.\n          */\n          const testValue = option[this.optionLabel] || option[this.optionKey];\n\n          return testValue.toLowerCase().includes(this.selectedValue.toLowerCase());\n        });\n      },\n    },\n    watch: {\n      /**\n       * Everytime the value changes we need parse the value based on its validation type and update the selectedValue.\n       */\n      value() {\n        this.selectedValue = this.parseValue(this.value);\n      },\n\n      /**\n       * Emit the change up when the selectedValue changes\n       */\n      selectedValue() {\n        this.$emit('input', this.selectedValue);\n\n        if (this.initialValueSet) {\n          this.debounceChangeEvent();\n        }\n\n        this.initialValueSet = true;\n      },\n\n      /**\n       * Set the correct auto width for the popover when it is shown\n       *\n       * @param {boolean} showAutocomplete\n       */\n      showAutocomplete(showAutocomplete) {\n        if (showAutocomplete && this.width === 'auto') {\n          this.autoWidth = this.$el.clientWidth;\n        }\n      },\n\n      /**\n       * Show/hide the autocomplete popover if there are options/no options and the user has edited the input\n       * (overrides existing behavior only for the userEdited autocomplete behavior)\n       *\n       * @param {Array} newOptions\n       */\n      filteredOptions(newOptions) {\n        if (this.userEdited && this.hasFocus) {\n          this.showAutocomplete = !!newOptions.length;\n        }\n      },\n    },\n\n    created() {\n      if (this.value) {\n        this.selectedValue = this.parseValue(this.value);\n      } else {\n        this.initialValueSet = true;\n      }\n    },\n\n    methods: {\n      /**\n       * Fires When a user clicks on a list item in the popover we hide\n       * We updated the 'selectedValue' as well as close the dropdown and focus on the textarea\n       *\n       * @param {string} value\n       * @param {boolean} [isDisabled] - If the item is disabled, do nothing when it is clicked or the enter key is hit\n       */\n      autoCompleteClick(value, isDisabled) {\n        if (isDisabled) {\n          return;\n        }\n\n        this.selectedValue = this.parseValue(value);\n\n        this.$nextTick(() => {\n          this.$el.querySelector('textarea').focus();\n          this.showAutocomplete = false;\n        });\n      },\n\n      /**\n       * Handle keydown events\n       *\n       * @param {object} event\n       */\n      onKeydown(event) {\n        const charCode = event.which ? event.which : event.keyCode;\n        // Conditions\n        const isNumpad = charCode >= 96 && charCode <= 105;\n        const isTopNumbers = charCode >= 48 && charCode <= 57;\n        const isNumericKey = isNumpad || isTopNumbers;\n\n        // Allow for 'selecting all', 'copy', and 'paste'\n        const isCopyPaste = event.metaKey\n          && ['a', 'c', 'v'].includes(event.key);\n        const isModifier = event.shiftKey;\n        const isArrowKey = [37, 38, 39, 40].includes(charCode);\n\n        if (!isArrowKey) {\n          // at this point, we're saying that the user has edited the field, because they pushed a key\n          this.userEdited = true;\n        }\n\n        // prevent keydown and emit to the parent if key is Enter and !allowEnter\n        if (!this.allowEnter && charCode === 13) {\n          event.preventDefault();\n          this.$emit('keydownEnter');\n        }\n\n        // Allow if user is copy/pasting\n        const numericValidationTypes = [\n          'percentage-whole-number',\n          'whole-number',\n        ];\n        if (!isCopyPaste) {\n          if (numericValidationTypes.includes(this.validationType) && charCode > 31) {\n            if (!isNumericKey || isModifier) {\n              event.preventDefault();\n            }\n          }\n        }\n      },\n\n      /**\n       * When a user clicks in the text area we open the dropdown\n       */\n      onInputClick() {\n        this.showAutocomplete = true;\n      },\n      /**\n       * When the text area gets focus we open the dropdown\n       */\n      onInputFocus() {\n        this.$emit('focus');\n        // reset if the user left\n        this.userEdited = false;\n\n        if (this.options.length) {\n          this.showAutocomplete = true;\n        }\n        this.hasFocus = true;\n        if (this.tooltip) {\n          this.showTooltip = true;\n        }\n        const self = this;\n        window.setTimeout(() => {\n          const autocomplete = self.$el.querySelector('.auto-complete-textarea');\n          autocomplete.removeAttribute('tabindex');\n        }, 100);\n      },\n      /**\n       * When the text area loses we check if the focus is in the dropdown, if it's not we close the dropdown\n       *\n       * @param {object} event\n       */\n      onInputBlur(event) {\n        if (!event) {\n          return;\n        }\n\n        this.hasFocus = false;\n\n        const { relatedTarget } = event;\n        const popover = this.$refs.popoverContainer;\n        const isInPopover = this.isChildOf(relatedTarget, popover);\n\n        if (!isInPopover) {\n          if (this.tooltip) {\n            this.showTooltip = false;\n          }\n\n          this.showAutocomplete = false;\n          this.$emit('blur', event);\n        }\n\n        this.debounceChangeEvent.flush();\n      },\n\n      /**\n       * If the user presses down while in the text area we focus on the first list item\n       */\n      handleTextAreaArrowDown() {\n        if (this.filteredOptions.length) {\n          this.$refs.popoverContainer.querySelector('li:first-child').focus();\n        }\n      },\n\n      /**\n       * If the user presses up on a list item we focus on the one above it (or on the text area)\n       *\n       * @param {object} event\n       */\n      handleListItemArrowUp(event) {\n        event.preventDefault();\n        const { previousSibling } = event.target;\n\n        if (previousSibling) {\n          previousSibling.focus();\n        } else {\n          this.$el.querySelector('textarea').focus();\n        }\n      },\n\n      /**\n       * If the user presses down on a list item we focus on the next item\n       *\n       * @param {object} event\n       */\n      handleListItemArrowDown(event) {\n        event.preventDefault();\n        const { nextSibling } = event.target;\n\n        if (nextSibling) {\n          nextSibling.focus();\n        }\n      },\n\n      /**\n       * If the user presses esc, we close the dropdown and focus on the textarea\n       */\n      handleEscKey() {\n        this.showAutocomplete = false;\n        this.$el.querySelector('textarea').focus();\n      },\n\n      /**\n       * Parse the passed value based on what the validation type is.\n       *\n       * @param {string} value\n       * @returns {string}\n       */\n      parseValue(value) {\n        let parsedValue;\n\n        switch (this.validationType) {\n        case 'percentage-whole-number':\n          parsedValue = value.replace('%', '');\n          break;\n        default:\n          parsedValue = value;\n        }\n        return parsedValue;\n      },\n\n      /**\n       * Let's emit a change event up when the value changes\n       */\n      sendChangeEvent() {\n        let parsedValue;\n\n        switch (this.validationType) {\n        case 'percentage-whole-number':\n          parsedValue = `${this.selectedValue}%`;\n          break;\n        default:\n          parsedValue = this.selectedValue;\n        }\n\n        this.$emit('change', parsedValue);\n      },\n\n      /**\n       * Is the first element a child of the second\n       * We use to decide to if the user is still in the dropdown\n       *\n       * @param {object} child\n       * @param {object} parent\n       * @returns {boolean}\n       */\n      isChildOf(child, parent) {\n        if (!child) {\n          return false;\n        }\n        if (child.parentNode === parent) {\n          return true;\n        } if (child.parentNode === null) {\n          return false;\n        }\n        return this.isChildOf(child.parentNode, parent);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .tooltip-inner {\n    text-align: left;\n  }\n\n  .button-suffix.tf-button--icon-no-fill.has-icon,\n  .button-suffix.wt-button--icon-no-fill.has-icon {\n    position: absolute;\n    top: 0;\n    right: 5px;\n    bottom: 0;\n    padding: 0 5px;\n    color: $tf-medium-gray;\n\n    svg {\n      fill: $tf-light-gray;\n    }\n  }\n\n  .text-addition {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 8px;\n    color: $tf-medium-gray;\n    background: $tf-extra-light-gray-2;\n    border: 1px solid $tf-light-gray;\n\n    &.append-input {\n      border-left: none;\n    }\n\n    &.prepend-input {\n      border-right: none;\n    }\n  }\n\n  .with-suffix-icon {\n    position: relative;\n\n    .auto-complete-textarea .el-textarea__inner {\n      padding-right: 30px;\n    }\n  }\n\n  .with-text-addition {\n    display: flex;\n\n    > span {\n      &:not(.text-addition) {\n        flex-grow: 1;\n      }\n    }\n  }\n\n  .el-select-dropdown.autocomplete li:focus {\n    background-color: $tf-extra-light-gray-1;\n    outline: 0;\n  }\n\n  // Override the dropdown items to show full text.\n  .el-select-dropdown__item {\n    overflow: inherit;\n    height: auto;\n    padding: {\n      top: 5px;\n      bottom: 5px;\n    }\n    text-overflow: inherit;\n    line-height: inherit;\n    white-space: inherit;\n\n    &.is-disabled {\n      pointer-events: none;\n    }\n  }\n\n  .el-select-dropdown__list {\n    .is-disabled {\n      &,\n      &:hover {\n        // I'm having to use important to override Elements native styles ):\n        /* stylelint-disable declaration-no-important */\n        color: $tf-medium-gray !important;\n        background: $tf-extra-light-gray-1 !important;\n        /* stylelint-enable declaration-no-important */\n        font-style: italic;\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$A = "data-v-bf5c8368";
  /* module identifier */
  const __vue_module_identifier__$A = undefined;
  /* functional template */
  const __vue_is_functional_template__$A = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$A = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$z, staticRenderFns: __vue_staticRenderFns__$z },
    __vue_inject_styles__$A,
    __vue_script__$A,
    __vue_scope_id__$A,
    __vue_is_functional_template__$A,
    __vue_module_identifier__$A,
    false,
    browser,
    undefined,
    undefined
  );

// 20.1.2.4 Number.isNaN(number)


_export(_export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

var $indexOf = _arrayIncludes(false);
var $native$1 = [].indexOf;
var NEGATIVE_ZERO$1 = !!$native$1 && 1 / [1].indexOf(1, -0) < 0;

_export(_export.P + _export.F * (NEGATIVE_ZERO$1 || !_strictMethod($native$1)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO$1
      // convert -0 to +0
      ? $native$1.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

var script$B = {
  props: {
    disableClick: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: null
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: String,
      default: 'value'
    },
    concatenateLabels: {
      type: Boolean,
      default: false
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    emptyText: {
      type: String,
      default: 'No Options Available'
    },
    forceDisableCheckboxClick: {
      type: Boolean,
      default: false
    },
    totalOptionsAvailable: {
      type: Number,
      default: 0
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    popperClass: {
      type: String,
      default: 'multi-select-popover'
    },
    popoverTrigger: {
      type: String,
      default: 'click'
    },
    searchableParent: {
      type: String,
      default: null
    },
    nextTabbableElement: {
      type: String,
      default: null
    },
    width: {
      type: [Number, String],
      default: 'auto'
    }
  },
  data: function data(vm) {
    return {
      checkAll: false,
      clonedValue: vm.value.slice(0),
      initialValues: null,
      showPopover: false,
      popoverVisible: false
    };
  },
  computed: {
    /**
     * If there is only one option we disabled the checkboxes
     *
     * @returns {boolean}
     */
    disabledCheckBoxes: function disabledCheckBoxes() {
      return this.totalOptionsAvailable.length === 1;
    },
    /**
     * What value we display when in the main multi select "label"
     *
     * @returns {string}
     */
    displayValue: function displayValue() {
      var _this = this;
      var labels = [];

      // populate labels array
      this.options.forEach(function (option) {
        if (_this.value.indexOf(option[_this.valueKey]) > -1) {
          labels.push(option[_this.label]);
        }
      });
      // If all the options are selected
      if (this.options.length && Number(this.totalOptionsAvailable) === labels.length) {
        return 'All';
      }
      if (!labels.some(function (label) {
        return Number.isNaN(label);
      })) {
        // this is array of only numbers so lets roll them up
        return this.$TF.Formatting.getRanges(labels).join(', ');
      }
      if (this.concatenateLabels || labels.length === 1) {
        return labels.join(', ');
      }
      return '(Multi)';
    },
    /**
     * get the correct width for the popover
     *
     * @returns {string}
     */
    popoverWidth: function popoverWidth() {
      return this.popoverVisible && this.width === 'auto' ? this.$el.offsetWidth : this.width;
    }
  },
  watch: {
    /**
     * When the value changes we need to check if we should mark the 'checkall' checkbox
     *
     * @param {Array} currentValue
     * @param {Array} oldValue
     */
    value: function value(currentValue, oldValue) {
      this.clonedValue = this.value.slice(0);
      var checkedCount = this.value.length;
      this.checkAll = checkedCount === this.options.length;
      var containersEqual = isEqual(oldValue, this.value);
      if (containersEqual) {
        return;
      }
      this.$emit('input', this.value);
      this.$emit('change', {
        value: this.value,
        oldValue: oldValue
      });
    }
  },
  created: function created() {
    var checkedCount = this.value.length;
    this.checkAll = checkedCount === this.options.length;
    if (this.totalOptionsAvailable === 1) {
      this.handleCheckAllChange(true);
    }
  },
  methods: {
    /**
     * Change the popoverVisible to true and
     * set the initial values to the value prop.
     */
    onShow: function onShow() {
      this.popoverVisible = true;
      this.initialValues = this.value;
    },
    /**
     * We store the popoverVisible on show/hide
     * so we know if we have to close the select once the user tabs off.
     */
    onHide: function onHide() {
      this.popoverVisible = false;
      this.$emit('hide', {
        value: this.value,
        initialValues: this.initialValues
      });
      this.initialValues = null;
    },
    /**
     * If the popover trigger is manual,
     * we use the 'showPopover' variable to control it and we toggle it on focus.
     */
    focus: function focus() {
      this.showPopover = true;
    },
    /**
     * If the popover trigger is manual,
     * we use the 'showPopover' variable to control it and toggle it on blur.
     */
    blur: function blur() {
      this.showPopover = false;
    },
    /**
     * Click on the checkbox when a checkbox is in focus the user hits enter.
     *
     * @param {event} event
     */
    onCheckBoxEnter: function onCheckBoxEnter(event) {
      var checkbox = event.target;
      checkbox.click();
    },
    /**
     * Toggle popover if the user hits enter when on the main input.
     */
    onInputEnter: function onInputEnter() {
      if (this.popoverTrigger === 'manual') {
        this.showPopover = !this.showPopover;
      } else {
        this.$refs['multi-select-input'].$el.click();
      }
    },
    /**
     * If the user hits tab while focused on the main input,
     * we move the user to the next checkbox.
     * For some reason Element puts everything in a strange order.
     *
     * @param {event} event
     */
    handleInputTab: function handleInputTab(event) {
      if (!event.shiftKey && this.popoverVisible) {
        var checkall = this.$refs['check-all'];
        var inputs = this.$refs.checkbox;
        if (checkall) {
          window.setTimeout(function () {
            checkall.$el.querySelector('input').focus();
          }, 100);
        } else if (inputs.length) {
          window.setTimeout(function () {
            inputs[0].$el.querySelector('input').focus();
          }, 100);
        }
      }
    },
    /**
     * If the user hits tab while focused on checkbox
     * or if the user was on the last checkbox,
     * we hide the popover and focus on the next elment outside of it
     *
     * @param {event} event
     * @param {number} index
     */
    handleCheckboxTab: function handleCheckboxTab(event, index) {
      if (index === this.options.length - 1 && this.nextTabbableElement && this.searchableParent) {
        event.preventDefault();
        if (this.popoverTrigger === 'manual') {
          this.showPopover = !this.showPopover;
        } else {
          this.$refs['multi-select-input'].$el.click();
        }
        this.$el.closest(this.searchableParent).querySelector(this.nextTabbableElement).focus();
      }
    },
    /**
     * Manually toggle the popover
     */
    togglePopover: function togglePopover() {
      if (this.popoverTrigger === 'manual') {
        this.showPopover = !this.showPopover;
      }
    },
    /**
     * Handle the click of single checkbox
     *
     * @param {Array} value
     */
    handleMultiSelectChange: function handleMultiSelectChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.options.length;
      this.$emit('input', value);
    },
    /**
     * Handle the click of check all checkbox
     *
     * @param {boolean} checkAll
     */
    handleCheckAllChange: function handleCheckAllChange(checkAll) {
      var _this2 = this;
      if (checkAll) {
        var values = [];
        this.options.forEach(function (option) {
          values.push(option[_this2.valueKey]);
        });
        this.$emit('input', values);
        this.$emit('update');
      } else {
        this.$emit('input', []);
      }
    }
  }
};

/* script */
const __vue_script__$B = script$B;

/* template */
var __vue_render__$A = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ElPopover",
    {
      attrs: {
        "append-to-body": _vm.appendToBody,
        disabled: _vm.disableClick,
        "popper-class": _vm.popperClass,
        trigger: _vm.popoverTrigger,
        value: _vm.showPopover,
        "visible-arrow": false,
        placement: "bottom",
        width: _vm.popoverWidth,
      },
      on: { show: _vm.onShow, hide: _vm.onHide },
    },
    [
      _c("ElInput", {
        ref: "multi-select-input",
        staticClass: "multi-select-dropdown",
        attrs: {
          slot: "reference",
          disabled: _vm.disableClick,
          value: _vm.displayValue,
          size: "large",
          placeholder: "Select",
          readonly: "",
        },
        nativeOn: {
          keydown: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onInputEnter.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
              ) {
                return null
              }
              return _vm.handleInputTab.apply(null, arguments)
            },
          ],
          click: function ($event) {
            return _vm.togglePopover.apply(null, arguments)
          },
        },
        slot: "reference",
      }),
      _vm._v(" "),
      _vm.options.length === 0
        ? _c("label", { staticClass: "empty-text" }, [
            _vm._v(_vm._s(_vm.emptyText)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.options.length > 1
        ? _c(
            "TfCheckbox",
            {
              ref: "check-all",
              attrs: {
                indeterminate: false,
                disabled:
                  _vm.disabledCheckBoxes || _vm.forceDisableCheckboxClick,
                "data-test": "select all options",
              },
              on: { change: _vm.handleCheckAllChange },
              nativeOn: {
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleCheckAllChange(!_vm.checkAll)
                },
              },
              model: {
                value: _vm.checkAll,
                callback: function ($$v) {
                  _vm.checkAll = $$v;
                },
                expression: "checkAll",
              },
            },
            [_vm._v("\n    Select all\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ElCheckboxGroup",
        {
          on: { change: _vm.handleMultiSelectChange },
          model: {
            value: _vm.clonedValue,
            callback: function ($$v) {
              _vm.clonedValue = $$v;
            },
            expression: "clonedValue",
          },
        },
        _vm._l(_vm.options, function (option, index) {
          return _c(
            "TfCheckbox",
            {
              key: option.id,
              ref: "checkbox",
              refInFor: true,
              attrs: {
                "data-test": "toggle comments for " + option[_vm.label],
                disabled:
                  _vm.disabledCheckBoxes || _vm.forceDisableCheckboxClick,
                label: option[_vm.valueKey],
              },
              nativeOn: {
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onCheckBoxEnter.apply(null, arguments)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    ) {
                      return null
                    }
                    return _vm.handleCheckboxTab($event, index)
                  },
                ],
              },
            },
            [_vm._v("\n      " + _vm._s(option[_vm.label]) + "\n    ")]
          )
        }),
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$A = [];
__vue_render__$A._withStripped = true;

  /* style */
  const __vue_inject_styles__$B = undefined;
  /* scoped */
  const __vue_scope_id__$B = undefined;
  /* module identifier */
  const __vue_module_identifier__$B = undefined;
  /* functional template */
  const __vue_is_functional_template__$B = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$B = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$A, staticRenderFns: __vue_staticRenderFns__$A },
    __vue_inject_styles__$B,
    __vue_script__$B,
    __vue_scope_id__$B,
    __vue_is_functional_template__$B,
    __vue_module_identifier__$B,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfPagination is a component used to render a button for each of the pages of the totalPages that is passed down.
 * It uses the v-model/:value from the parent and $emits the model changes to the parent.
 *
 * @vuedoc
 * @exports TfPagination
 * @category Components
 */
var script$C = {
  name: 'TfPagination',
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    totalPages: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    truncatedPageRange: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return Boolean(value % 2 || value === 0);
      }
    }
  },
  computed: {
    /**
     * Returns an array or page numbers based on the total pages.
     *
     * @returns {Array}
     */
    pages: function pages() {
      var pages = _toConsumableArray(Array(this.totalPages).keys()).map(function (i) {
        return i + 1;
      });
      if (!this.truncatedPageRange || this.totalPages <= this.truncatedPageRange) {
        return pages;
      }
      var activePage = this.value;

      // Half Range is the amount of pages on either side of the current page
      var halfRange = Math.floor(this.truncatedPageRange / 2);

      /**
       * truncated pages should always be half the desired range on the right and left of the active page if there are enough pages on either side.
       * if one side cannot show up to desired pages, display more pages on the other side i.e. range = 5 pages, active page = 2, can only
       * show 1 page to the left so show 3 more pages to the right to fulfill the 5 page range desired (1 [2] 3 4 5)
       */

      // Find the end of the page range
      var end = activePage + halfRange;

      // store excess indices in remainder if end exceeds total pages
      var remainder = Math.max(end - this.totalPages, 0);

      // Find the starting index of page range, which is the active page minus halfRange, minus the remainder if any, minus 1 (0 index)
      var start = activePage - halfRange - remainder - 1;

      // If start is negative we know it should just start at 0 and the end will be the length of the range.
      if (start < 0) {
        start = 0;
        end = this.truncatedPageRange;
      }
      return pages.slice(start, end);
    }
  }
};

/* script */
const __vue_script__$C = script$C;

/* template */
var __vue_render__$B = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: [
        { "is-disabled": _vm.isDisabled },
        "pagination-container btn-group",
      ],
    },
    [
      _c("TfButton", {
        attrs: {
          disabled: _vm.value === 1 || _vm.isDisabled,
          "data-test": "select previous page",
          type: "secondary",
          size: "text-icon",
          icon: "angle-left",
        },
        on: {
          mousedown: function ($event) {
            return $event.preventDefault()
          },
          click: function ($event) {
            return _vm.$emit("input", _vm.value - 1)
          },
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.pages, function (page) {
        return _c("TfButton", {
          key: page,
          class: { active: page === _vm.value },
          attrs: {
            "data-test": "select page " + page,
            disabled: page === _vm.value || _vm.isDisabled,
            size: "text",
            type: "secondary",
          },
          domProps: { textContent: _vm._s(page) },
          on: {
            mousedown: function ($event) {
              return $event.preventDefault()
            },
            click: function ($event) {
              return _vm.$emit("input", page)
            },
          },
        })
      }),
      _vm._v(" "),
      _c("TfButton", {
        attrs: {
          disabled: _vm.value === _vm.totalPages || _vm.isDisabled,
          "data-test": "select next page",
          type: "secondary",
          size: "text-icon",
          icon: "angle-right",
        },
        on: {
          mousedown: function ($event) {
            return $event.preventDefault()
          },
          click: function ($event) {
            return _vm.$emit("input", _vm.value + 1)
          },
        },
      }),
    ],
    2
  )
};
var __vue_staticRenderFns__$B = [];
__vue_render__$B._withStripped = true;

  /* style */
  const __vue_inject_styles__$C = function (inject) {
    if (!inject) return
    inject("data-v-56431964_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tf-button.tf-button--secondary[data-v-56431964] {\n  padding: 6px 10px;\n  line-height: 14px;\n  border-radius: 2px;\n}\n.tf-button.tf-button--secondary[data-v-56431964]:not(.is-disabled) {\n  color: #006;\n}\n.tf-button.tf-button--secondary.active[data-v-56431964] {\n  cursor: default;\n}\n.pagination-container:not(.is-disabled) .tf-button.tf-button--secondary.active[data-v-56431964] {\n  color: #009;\n  background: #eff3fd;\n}\n.tf-button.tf-button--secondary[data-v-56431964]:focus {\n  outline: -webkit-focus-ring-color auto 1px;\n}\n.tf-button.tf-button--secondary + .tf-button[data-v-56431964] {\n  margin-left: 4px;\n}\n\n/*# sourceMappingURL=TfPagination.vue.map */", map: {"version":3,"sources":["TfPagination.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfPagination.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACkHlC;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;ADhHA;ACkHA;EACA,WAAA;ADhHA;ACmHA;EACA,eAAA;ADjHA;ACmHA;EACA,WAAA;EACA,mBAAA;ADjHA;ACqHA;EACA,0CAAA;ADnHA;ACsHA;EACA,gBAAA;ADpHA;;AAEA,2CAA2C","file":"TfPagination.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tf-button.tf-button--secondary {\n  padding: 6px 10px;\n  line-height: 14px;\n  border-radius: 2px;\n}\n.tf-button.tf-button--secondary:not(.is-disabled) {\n  color: #006;\n}\n.tf-button.tf-button--secondary.active {\n  cursor: default;\n}\n.pagination-container:not(.is-disabled) .tf-button.tf-button--secondary.active {\n  color: #009;\n  background: #eff3fd;\n}\n.tf-button.tf-button--secondary:focus {\n  outline: -webkit-focus-ring-color auto 1px;\n}\n.tf-button.tf-button--secondary + .tf-button {\n  margin-left: 4px;\n}\n\n/*# sourceMappingURL=TfPagination.vue.map */","<template>\n  <div\n    :class=\"[\n      { 'is-disabled': isDisabled },\n      'pagination-container btn-group'\n    ]\"\n  >\n    <TfButton\n      :disabled=\"value === 1 || isDisabled\"\n      data-test=\"select previous page\"\n      type=\"secondary\"\n      size=\"text-icon\"\n      icon=\"angle-left\"\n      @mousedown=\"$event.preventDefault()\"\n      @click=\"$emit('input', value - 1)\"\n    />\n    <TfButton\n      v-for=\"page in pages\"\n      :key=\"page\"\n      :class=\"{ active: page === value }\"\n      :data-test=\"`select page ${page}`\"\n      :disabled=\"page === value || isDisabled\"\n      size=\"text\"\n      type=\"secondary\"\n      @mousedown=\"$event.preventDefault()\"\n      @click=\"$emit('input', page)\"\n      v-text=\"page\"\n    />\n    <TfButton\n      :disabled=\"value === totalPages || isDisabled\"\n      data-test=\"select next page\"\n      type=\"secondary\"\n      size=\"text-icon\"\n      icon=\"angle-right\"\n      @mousedown=\"$event.preventDefault()\"\n      @click=\"$emit('input', value + 1)\"\n    />\n  </div>\n</template>\n<script>\n  /**\n   * TfPagination is a component used to render a button for each of the pages of the totalPages that is passed down.\n   * It uses the v-model/:value from the parent and $emits the model changes to the parent.\n   *\n   * @vuedoc\n   * @exports TfPagination\n   * @category Components\n   */\n  export default {\n    name: 'TfPagination',\n    props: {\n      isDisabled: {\n        type: Boolean,\n        default: false,\n      },\n      totalPages: {\n        type: Number,\n        required: true,\n      },\n      value: {\n        type: Number,\n        required: true,\n      },\n      truncatedPageRange: {\n        type: Number,\n        default: 0,\n        validator: (value) => Boolean(value % 2 || value === 0),\n      },\n    },\n    computed: {\n      /**\n       * Returns an array or page numbers based on the total pages.\n       *\n       * @returns {Array}\n       */\n      pages() {\n        const pages = [...Array(this.totalPages).keys()].map((i) => i + 1);\n\n        if (!this.truncatedPageRange || this.totalPages <= this.truncatedPageRange) {\n          return pages;\n        }\n        const activePage = this.value;\n\n        // Half Range is the amount of pages on either side of the current page\n        const halfRange = Math.floor(this.truncatedPageRange / 2);\n\n        /**\n         * truncated pages should always be half the desired range on the right and left of the active page if there are enough pages on either side.\n         * if one side cannot show up to desired pages, display more pages on the other side i.e. range = 5 pages, active page = 2, can only\n         * show 1 page to the left so show 3 more pages to the right to fulfill the 5 page range desired (1 [2] 3 4 5)\n         */\n\n        // Find the end of the page range\n        let end = activePage + halfRange;\n\n        // store excess indices in remainder if end exceeds total pages\n        const remainder = Math.max(end - this.totalPages, 0);\n\n        // Find the starting index of page range, which is the active page minus halfRange, minus the remainder if any, minus 1 (0 index)\n        let start = activePage - halfRange - remainder - 1;\n\n        // If start is negative we know it should just start at 0 and the end will be the length of the range.\n        if (start < 0) {\n          start = 0;\n          end = this.truncatedPageRange;\n        }\n\n        return pages.slice(start, end);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .tf-button.tf-button--secondary {\n    padding: 6px 10px;\n    line-height: 14px;\n    border-radius: 2px;\n\n    &:not(.is-disabled) {\n      color: $tf-dark-blue;\n    }\n\n    &.active {\n      cursor: default;\n\n      .pagination-container:not(.is-disabled) & {\n        color: $tf-blue;\n        background: $tf-light-blue;\n      }\n    }\n\n    &:focus {\n      outline: -webkit-focus-ring-color auto 1px;\n    }\n\n    + .tf-button {\n      margin-left: 4px;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$C = "data-v-56431964";
  /* module identifier */
  const __vue_module_identifier__$C = undefined;
  /* functional template */
  const __vue_is_functional_template__$C = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$C = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$B, staticRenderFns: __vue_staticRenderFns__$B },
    __vue_inject_styles__$C,
    __vue_script__$C,
    __vue_scope_id__$C,
    __vue_is_functional_template__$C,
    __vue_module_identifier__$C,
    false,
    browser,
    undefined,
    undefined
  );

// 21.2.5.3 get RegExp.prototype.flags()
if (_descriptors && /./g.flags != 'g') _objectDp.f(RegExp.prototype, 'flags', {
  configurable: true,
  get: _flags
});

var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  _redefine(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (_fails(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = _anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !_descriptors && R instanceof RegExp ? _flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING$1 = 'toString';
var $toString$1 = DateProto[TO_STRING$1];
var getTime$1 = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  _redefine(DateProto, TO_STRING$1, function toString() {
    var value = getTime$1.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString$1.call(this) : INVALID_DATE;
  });
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$D = {
  name: 'TfPanel',
  props: {
    backUrl: {
      type: String,
      // this is the url that we look for to trigger this panel
      default: null
    },
    open: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: null
    }
  },
  created: function created() {
    document.addEventListener('keyup', this.escapeKeyListener);
    document.addEventListener('click', this.outsidePanelListener);
  },
  destroyed: function destroyed() {
    document.removeEventListener('keyup', this.escapeKeyListener);
    document.removeEventListener('click', this.outsidePanelListener);
  },
  methods: {
    /**
     * Close the panel if the user hits the esc key.
     *
     * @param {event} event
     * @param {number} event.keyCode
     */
    escapeKeyListener: function escapeKeyListener(_ref) {
      var keyCode = _ref.keyCode;
      if (keyCode === 27) {
        this.closePanel();
      }
    },
    /**
     * Close the panel when when someone clicks outside the panel.
     *
     * @param {event} event
     * @param {object} event.target
     */
    outsidePanelListener: function outsidePanelListener(_ref2) {
      var target = _ref2.target;
      var panel = this.$el;
      var isInPanel = panel === target || panel.contains(target);
      var dontClosePanel = this.shouldNotClosePanel(target);
      var hasTextSelection = getSelection() && getSelection().toString().length > 0;
      if (!isInPanel && !dontClosePanel && !hasTextSelection && this.open) {
        this.closePanel();
      }
    },
    /**
     * Close the panel.
     * Replacing the route would throw an error since it's a duplicate identical route
     * If this happens, we are probably opening the panel via a dispatch
     * and should close it the same way.
     */
    closePanel: function closePanel() {
      if (this.backUrl === this.$route.path) {
        this.$store.dispatch(this.action, false);
      } else {
        this.$router.replace(this.backUrl);
      }
    },
    /**
     * Check if the user clicked on something that should not close the panel.
     * This include even if it's outside the panel.
     *
     * @param {object} element
     * @returns {boolean}
     */
    shouldNotClosePanel: function shouldNotClosePanel(element) {
      if (element.hasAttribute && (element.hasAttribute('data-dont-close-panel') || element.hasAttribute('data-do-not-close-panel'))) {
        return true;
      }
      return element.parentNode && this.shouldNotClosePanel(element.parentNode);
    }
  }
};

/* script */
const __vue_script__$D = script$D;

/* template */
var __vue_render__$C = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: ["panel", { open: _vm.open }] },
    [
      _c(
        "TfButton",
        {
          staticClass: "close-btn",
          attrs: {
            type: "primary",
            icon: "times",
            size: "icon-no-fill",
            "no-border": "",
          },
          on: { click: _vm.closePanel },
        },
        [_vm._v("\n    Close Panel\n  ")]
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
};
var __vue_staticRenderFns__$C = [];
__vue_render__$C._withStripped = true;

  /* style */
  const __vue_inject_styles__$D = function (inject) {
    if (!inject) return
    inject("data-v-4c371dde_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.panel[data-v-4c371dde] {\n  position: fixed;\n  right: 0;\n  z-index: 100;\n  height: 100%;\n  width: 0;\n  transition: width 0.5s;\n  max-width: 557px;\n  box-sizing: border-box;\n  background: #fff;\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04), 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  border: solid 1px #efefef;\n  color: #000;\n  text-align: center;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.panel.open[data-v-4c371dde] {\n  width: 100%;\n}\n.panel .close-btn[data-v-4c371dde] {\n  position: absolute;\n  right: 9px;\n  top: 9px;\n}\n\n/*# sourceMappingURL=TfPanel1.vue.map */", map: {"version":3,"sources":["TfPanel1.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfPanel1.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC4GlC;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,0EAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;AD1GA;AC4GA;EACA,WAAA;AD1GA;AC6GA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AD3GA;;AAEA,uCAAuC","file":"TfPanel1.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.panel {\n  position: fixed;\n  right: 0;\n  z-index: 100;\n  height: 100%;\n  width: 0;\n  transition: width 0.5s;\n  max-width: 557px;\n  box-sizing: border-box;\n  background: #fff;\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04), 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  border: solid 1px #efefef;\n  color: #000;\n  text-align: center;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.panel.open {\n  width: 100%;\n}\n.panel .close-btn {\n  position: absolute;\n  right: 9px;\n  top: 9px;\n}\n\n/*# sourceMappingURL=TfPanel1.vue.map */","<template>\n  <div :class=\"['panel', { open: open }]\">\n    <TfButton\n      class=\"close-btn\"\n      type=\"primary\"\n      icon=\"times\"\n      size=\"icon-no-fill\"\n      no-border\n      @click=\"closePanel\"\n    >\n      Close Panel\n    </TfButton>\n    <slot />\n  </div>\n</template>\n\n<script>\n  export default {\n    name: 'TfPanel',\n    props: {\n      backUrl: {\n        type: String, // this is the url that we look for to trigger this panel\n        default: null,\n      },\n      open: {\n        type: Boolean,\n        default: false,\n      },\n      action: {\n        type: String,\n        default: null,\n      },\n    },\n    created() {\n      document.addEventListener('keyup', this.escapeKeyListener);\n      document.addEventListener('click', this.outsidePanelListener);\n    },\n    destroyed() {\n      document.removeEventListener('keyup', this.escapeKeyListener);\n      document.removeEventListener('click', this.outsidePanelListener);\n    },\n    methods: {\n      /**\n       * Close the panel if the user hits the esc key.\n       *\n       * @param {event} event\n       * @param {number} event.keyCode\n       */\n      escapeKeyListener({ keyCode }) {\n        if (keyCode === 27) {\n          this.closePanel();\n        }\n      },\n\n      /**\n       * Close the panel when when someone clicks outside the panel.\n       *\n       * @param {event} event\n       * @param {object} event.target\n       */\n      outsidePanelListener({ target }) {\n        const panel = this.$el;\n        const isInPanel = panel === target || panel.contains(target);\n        const dontClosePanel = this.shouldNotClosePanel(target);\n        const hasTextSelection = getSelection() && getSelection().toString().length > 0;\n\n        if (!isInPanel && !dontClosePanel && !hasTextSelection && this.open) {\n          this.closePanel();\n        }\n      },\n\n      /**\n       * Close the panel.\n       * Replacing the route would throw an error since it's a duplicate identical route\n       * If this happens, we are probably opening the panel via a dispatch\n       * and should close it the same way.\n       */\n      closePanel() {\n        if (this.backUrl === this.$route.path) {\n          this.$store.dispatch(this.action, false);\n        } else {\n          this.$router.replace(this.backUrl);\n        }\n      },\n\n      /**\n       * Check if the user clicked on something that should not close the panel.\n       * This include even if it's outside the panel.\n       *\n       * @param {object} element\n       * @returns {boolean}\n       */\n      shouldNotClosePanel(element) {\n        if (\n          element.hasAttribute\n          && (\n            element.hasAttribute('data-dont-close-panel')\n            || element.hasAttribute('data-do-not-close-panel')\n          )\n        ) {\n          return true;\n        }\n        return element.parentNode && this.shouldNotClosePanel(element.parentNode);\n      },\n    },\n  };\n</script>\n<style lang=\"scss\" scoped>\n@import 'src/assets/styles/mixins';\n\n.panel {\n  position: fixed;\n  right: 0;\n  z-index: 100;\n  height: 100%;\n  width: 0;\n  transition: width .5s;\n  max-width: 557px;\n  box-sizing: border-box;\n  background: $tf-white;\n  box-shadow: 0 0 6px 0 rgba($tf-black, .04), 0 2px 4px 0 rgba($tf-black, .12);\n  border: solid 1px $tf-extra-light-gray-1;\n  color: $tf-black;\n  text-align: center;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n\n  &.open {\n    width: 100%;\n  }\n\n  .close-btn {\n    position: absolute;\n    right: 9px;\n    top: 9px;\n  }\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$D = "data-v-4c371dde";
  /* module identifier */
  const __vue_module_identifier__$D = undefined;
  /* functional template */
  const __vue_is_functional_template__$D = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$D = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$C, staticRenderFns: __vue_staticRenderFns__$C },
    __vue_inject_styles__$D,
    __vue_script__$D,
    __vue_scope_id__$D,
    __vue_is_functional_template__$D,
    __vue_module_identifier__$D,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$E = {
  name: 'TfPanel2',
  props: {
    title: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    handle: {
      type: Boolean,
      default: false
    },
    // handle alias; TODO deprecate/remove at shared 3.0
    statusBar: {
      type: Boolean,
      default: false
    },
    animate: {
      type: Boolean,
      default: true
    },
    trigger: {
      type: String,
      default: null
    },
    closeOnEscape: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'right'
    },
    fixedPosition: {
      type: Boolean,
      default: true
    },
    top: {
      type: [String, Number],
      default: '0px'
    },
    maxWidth: {
      type: String,
      default: '557px'
    },
    minWidth: {
      type: String,
      default: '0px'
    }
  },
  data: function data() {
    return {
      handleLeftPosition: null,
      handleRightPosition: null
    };
  },
  computed: {
    /**
     * Normalize top position to a string with `px` if needed
     * (Let's standardize on strings with units,
     * since the width props are strings,
     * but still backwards support number positions)
     *
     * @returns {string}
     */
    normalizedTop: function normalizedTop() {
      return typeof this.top === 'number' ? "".concat(this.top, "px") : this.top;
    },
    /**
     * Get the classes for the panel
     *
     * @returns {Array}
     */
    panelClass: function panelClass() {
      return ['panel', this.position, {
        open: this.open,
        animate: this.animate,
        'has-handle': this.handle,
        fixed: this.fixedPosition
      }];
    },
    /**
     * Get the inline styles for the panel
     *
     * @returns {object}
     */
    panelStyle: function panelStyle() {
      return {
        width: this.maxWidth,
        minWidth: this.open ? this.minWidth : 0,
        top: this.normalizedTop,
        height: "calc(100% - ".concat(this.normalizedTop, ")")
      };
    },
    /**
     * Get the inline styles for the handle
     *
     * @returns {object}
     */
    handleStyle: function handleStyle() {
      return {
        left: this.handleLeftPosition,
        right: this.handleRightPosition,
        height: "calc(100% - ".concat(this.top, "px)")
      };
    },
    /**
     * Get right direction for carets
     *
     * @returns {string}
     */
    statusIconDirection: function statusIconDirection() {
      if (!this.open && this.position === 'left' || this.open && this.position === 'right') {
        return 'caret-down';
      }
      return 'caret-up';
    },
    /**
     * Get handle boolean (backwards compatibility with old "status bar" boolean)
     *
     * @returns {boolean}
     */
    localHandle: function localHandle() {
      return this.statusBar || this.handle;
    }
  },
  watch: {
    /**
     * When the panel is opened we need to set the position of the 'handle'
     */
    open: function open() {
      this.setHandlePosition();
    }
  },
  created: function created() {
    if (this.closable) {
      if (this.closeOnEscape) {
        document.addEventListener('keyup', this.escapeKeyListener);
      }
      if (this.closeOnOutsideClick) {
        document.addEventListener('click', this.outsidePanelListener);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (this.localHandle) {
      window.addEventListener('resize', function () {
        _this.setHandlePosition();
      });
      this.setHandlePosition();
    }
  },
  destroyed: function destroyed() {
    var _this2 = this;
    if (this.closable) {
      if (this.closeOnEscape) {
        document.removeEventListener('keyup', this.escapeKeyListener);
      }
      if (this.closeOnOutsideClick) {
        document.removeEventListener('click', this.outsidePanelListener);
      }
    }
    if (this.localHandle) {
      window.removeEventListener('resize', function () {
        _this2.setHandlePosition();
      });
    }
  },
  methods: {
    /**
     * set the position of the handle
     */
    setHandlePosition: function setHandlePosition() {
      var windowWidth = window.innerWidth;
      var maxWidthHasPercentage = this.maxWidth.indexOf('%') > -1;
      var minWidth = this.minWidth.replace('px', '');
      var maxPixelWidth;
      if (maxWidthHasPercentage) {
        maxPixelWidth = this.maxWidth.replace('%', '') / 100 * windowWidth;
      } else {
        maxPixelWidth = this.maxWidth.replace('px', '');
      }
      if (this.position === 'right') {
        if (this.open) {
          this.handleLeftPosition = 'auto';
          if (minWidth && maxPixelWidth < minWidth) {
            this.handleRightPosition = this.minWidth;
          } else {
            this.handleRightPosition = windowWidth - 10 < this.maxWidth.replace('px', '') ? "".concat(windowWidth - 10, "px") : this.maxWidth;
          }
        } else {
          this.handleLeftPosition = 'auto';
          this.handleRightPosition = '0px';
        }
      } else if (this.open) {
        if (minWidth && maxPixelWidth < minWidth) {
          this.handleLeftPosition = this.minWidth;
        } else {
          this.handleLeftPosition = windowWidth - 10 < this.maxWidth.replace('px', '') ? "".concat(windowWidth - 10, "px") : this.maxWidth;
        }
        this.handleRightPosition = 'auto';
      } else {
        this.handleLeftPosition = '0px';
        this.handleRightPosition = 'auto';
      }
    },
    /**
     * Close the panel
     */
    closePanel: function closePanel() {
      this.$emit('togglePanel', false);
    },
    /**
     * Toggle the panel
     */
    togglePanel: function togglePanel() {
      this.$emit('togglePanel', !this.open);
    },
    /**
     * Close panel on escape key
     *
     * @param {object} event
     */
    escapeKeyListener: function escapeKeyListener(event) {
      if (event.keyCode === 27) {
        this.closePanel();
      }
    },
    /**
     * Return color value as reactive value
     *
     * @param {object} event
     */
    outsidePanelListener: function outsidePanelListener(event) {
      var target = event.target;
      var panel = this.$el;
      var isInPanel = this.isChildOf(target, panel);
      if (!isInPanel && this.closable) {
        this.closePanel();
      }
    },
    /**
     * Check if element is child of another element
     *
     * @param {object} child
     * @param {object} parent
     * @returns {boolean}
     */
    isChildOf: function isChildOf(child, parent) {
      if (child.parentNode === parent) {
        return true;
      }
      if (child.parentNode === null) {
        return false;
      }
      return this.isChildOf(child.parentNode, parent);
    }
  }
};

/* script */
const __vue_script__$E = script$E;

/* template */
var __vue_render__$D = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "panel", class: _vm.panelClass, style: _vm.panelStyle },
    [
      _vm.localHandle
        ? _c(
            "button",
            {
              staticClass: "handle",
              style: _vm.handleStyle,
              on: {
                click: function ($event) {
                  return _vm.togglePanel()
                },
              },
            },
            [
              _c(
                "span",
                [
                  _c("icon", { attrs: { name: _vm.statusIconDirection } }),
                  _vm._v(" "),
                  _c("icon", { attrs: { name: _vm.statusIconDirection } }),
                  _vm._v(" "),
                  _c("icon", { attrs: { name: _vm.statusIconDirection } }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.title || _vm.closable
        ? _c(
            "header",
            [
              _vm.title
                ? _c("h3", { domProps: { textContent: _vm._s(_vm.title) } })
                : _vm._e(),
              _vm._v(" "),
              _vm.closable
                ? _c("TfButton", {
                    staticClass: "close",
                    attrs: {
                      type: "primary",
                      icon: "times",
                      size: "icon-no-fill",
                      "no-border": "",
                      "data-test": "close tactic panel",
                    },
                    on: { click: _vm.closePanel },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("main", { staticClass: "panel-content" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("footer", { attrs: { slot: "footer" }, slot: "footer" }),
    ]
  )
};
var __vue_staticRenderFns__$D = [];
__vue_render__$D._withStripped = true;

  /* style */
  const __vue_inject_styles__$E = function (inject) {
    if (!inject) return
    inject("data-v-195a981c_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.panel[data-v-195a981c] {\n  display: flex;\n  flex-direction: column;\n  right: 0;\n  z-index: 100;\n  max-width: 0;\n  box-sizing: border-box;\n  background: #fff;\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04), 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  border: solid 1px #c1c1c1;\n  color: #000;\n  text-align: center;\n  overflow: hidden;\n  position: relative;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.panel.fixed[data-v-195a981c] {\n  position: fixed;\n}\n.panel:not(.fixed).has-handle[data-v-195a981c] {\n  margin-left: 8px;\n}\n.panel.animate[data-v-195a981c] {\n  transition: width 0.5s;\n}\n.panel.left[data-v-195a981c] {\n  right: auto;\n  left: 0;\n}\n.panel.open[data-v-195a981c] {\n  max-width: 100%;\n  overflow-y: auto;\n}\n.panel-content[data-v-195a981c] {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-y: auto;\n}\n.handle[data-v-195a981c] {\n  background: #eff3fd;\n  border: 0;\n  border-left: 1px solid #c1c1c1;\n  border-right: 1px solid #c1c1c1;\n  overflow: hidden;\n  cursor: pointer;\n  height: calc(100% + 1px);\n  margin-top: -1px;\n  position: fixed;\n  z-index: 10;\n  width: 14px;\n  padding: 0;\n}\n.handle[data-v-195a981c]:focus {\n  border-color: #999;\n  outline: none;\n}\n.handle span[data-v-195a981c] {\n  position: relative;\n  left: -4px;\n}\n.handle svg[data-v-195a981c] {\n  color: #c1c1c1;\n  transform: rotate(-90deg);\n  transform-origin: left top 0;\n}\n.left .handle[data-v-195a981c] {\n  box-shadow: 4px 0 5px 0 rgba(0, 0, 0, 0.25);\n}\n.right .handle[data-v-195a981c] {\n  box-shadow: -4px 0 5px 0 rgba(0, 0, 0, 0.25);\n}\nheader[data-v-195a981c] {\n  margin: 0;\n  padding: 4px 4px 4px 12px;\n  background: #fafafa;\n  border-bottom: 1px solid #c1c1c1;\n  display: flex;\n  align-items: flex-start;\n}\nh3[data-v-195a981c] {\n  margin: 0;\n  padding: 6px;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  text-align: left;\n  flex-grow: 1;\n}\n\n/*# sourceMappingURL=TfPanel2.vue.map */", map: {"version":3,"sources":["TfPanel2.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfPanel2.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;kCAEkC;ACmWlC;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,0EAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;ADjWA;ACmWA;EACA,eAAA;ADjWA;ACoWA;EACA,gBAAA;ADlWA;ACqWA;EACA,sBAAA;ADnWA;ACsWA;EACA,WAAA;EACA,OAAA;ADpWA;ACuWA;EACA,eAAA;EACA,gBAAA;ADrWA;ACyWA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,gBAAA;ADtWA;ACyWA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;ADtWA;ACwWA;EACA,kBAAA;EACA,aAAA;ADtWA;ACyWA;EACA,kBAAA;EACA,UAAA;ADvWA;AC0WA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;ADxWA;AC2WA;EACA,2CAAA;ADzWA;AC4WA;EACA,4CAAA;AD1WA;AC8WA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;AD3WA;AC8WA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AD3WA;;AAEA,uCAAuC","file":"TfPanel2.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.panel {\n  display: flex;\n  flex-direction: column;\n  right: 0;\n  z-index: 100;\n  max-width: 0;\n  box-sizing: border-box;\n  background: #fff;\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04), 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  border: solid 1px #c1c1c1;\n  color: #000;\n  text-align: center;\n  overflow: hidden;\n  position: relative;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.panel.fixed {\n  position: fixed;\n}\n.panel:not(.fixed).has-handle {\n  margin-left: 8px;\n}\n.panel.animate {\n  transition: width 0.5s;\n}\n.panel.left {\n  right: auto;\n  left: 0;\n}\n.panel.open {\n  max-width: 100%;\n  overflow-y: auto;\n}\n\n.panel-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.handle {\n  background: #eff3fd;\n  border: 0;\n  border-left: 1px solid #c1c1c1;\n  border-right: 1px solid #c1c1c1;\n  overflow: hidden;\n  cursor: pointer;\n  height: calc(100% + 1px);\n  margin-top: -1px;\n  position: fixed;\n  z-index: 10;\n  width: 14px;\n  padding: 0;\n}\n.handle:focus {\n  border-color: #999;\n  outline: none;\n}\n.handle span {\n  position: relative;\n  left: -4px;\n}\n.handle svg {\n  color: #c1c1c1;\n  transform: rotate(-90deg);\n  transform-origin: left top 0;\n}\n.left .handle {\n  box-shadow: 4px 0 5px 0 rgba(0, 0, 0, 0.25);\n}\n.right .handle {\n  box-shadow: -4px 0 5px 0 rgba(0, 0, 0, 0.25);\n}\n\nheader {\n  margin: 0;\n  padding: 4px 4px 4px 12px;\n  background: #fafafa;\n  border-bottom: 1px solid #c1c1c1;\n  display: flex;\n  align-items: flex-start;\n}\n\nh3 {\n  margin: 0;\n  padding: 6px;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  text-align: left;\n  flex-grow: 1;\n}\n\n/*# sourceMappingURL=TfPanel2.vue.map */","<template>\n  <div\n    ref=\"panel\"\n    :class=\"panelClass\"\n    :style=\"panelStyle\"\n  >\n    <button\n      v-if=\"localHandle\"\n      :style=\"handleStyle\"\n      class=\"handle\"\n      @click=\"togglePanel()\"\n    >\n      <span>\n        <icon :name=\"statusIconDirection\" />\n        <icon :name=\"statusIconDirection\" />\n        <icon :name=\"statusIconDirection\" />\n      </span>\n    </button>\n\n    <header\n      v-if=\"title || closable\"\n    >\n      <h3\n        v-if=\"title\"\n        v-text=\"title\"\n      />\n\n      <TfButton\n        v-if=\"closable\"\n        class=\"close\"\n        type=\"primary\"\n        icon=\"times\"\n        size=\"icon-no-fill\"\n        no-border\n        data-test=\"close tactic panel\"\n        @click=\"closePanel\"\n      />\n    </header>\n\n    <main\n      class=\"panel-content\"\n    >\n      <slot />\n    </main>\n\n    <footer\n      slot=\"footer\"\n    />\n  </div>\n</template>\n\n<script>\n  export default {\n    name: 'TfPanel2',\n\n    props: {\n      title: {\n        type: String,\n        default: '',\n      },\n\n      open: {\n        type: Boolean,\n        default: false,\n      },\n\n      closable: {\n        type: Boolean,\n        default: true,\n      },\n\n      handle: {\n        type: Boolean,\n        default: false,\n      },\n\n      // handle alias; TODO deprecate/remove at shared 3.0\n      statusBar: {\n        type: Boolean,\n        default: false,\n      },\n\n      animate: {\n        type: Boolean,\n        default: true,\n      },\n\n      trigger: {\n        type: String,\n        default: null,\n      },\n\n      closeOnEscape: {\n        type: Boolean,\n        default: false,\n      },\n\n      position: {\n        type: String,\n        default: 'right',\n      },\n\n      fixedPosition: {\n        type: Boolean,\n        default: true,\n      },\n\n      top: {\n        type: [String, Number],\n        default: '0px',\n      },\n\n      maxWidth: {\n        type: String,\n        default: '557px',\n      },\n\n      minWidth: {\n        type: String,\n        default: '0px',\n      },\n    },\n    data: () => ({\n      handleLeftPosition: null,\n      handleRightPosition: null,\n    }),\n\n    computed: {\n      /**\n       * Normalize top position to a string with `px` if needed\n       * (Let's standardize on strings with units,\n       * since the width props are strings,\n       * but still backwards support number positions)\n       *\n       * @returns {string}\n       */\n      normalizedTop() {\n        return typeof this.top === 'number'\n          ? `${this.top}px`\n          : this.top;\n      },\n\n      /**\n       * Get the classes for the panel\n       *\n       * @returns {Array}\n       */\n      panelClass() {\n        return [\n          'panel',\n          this.position,\n          {\n            open: this.open,\n            animate: this.animate,\n            'has-handle': this.handle,\n            fixed: this.fixedPosition,\n          },\n        ];\n      },\n\n      /**\n       * Get the inline styles for the panel\n       *\n       * @returns {object}\n       */\n      panelStyle() {\n        return {\n          width: this.maxWidth,\n          minWidth: this.open ? this.minWidth : 0,\n          top: this.normalizedTop,\n          height: `calc(100% - ${this.normalizedTop})`,\n        };\n      },\n\n      /**\n       * Get the inline styles for the handle\n       *\n       * @returns {object}\n       */\n      handleStyle() {\n        return {\n          left: this.handleLeftPosition,\n          right: this.handleRightPosition,\n          height: `calc(100% - ${this.top}px)`,\n        };\n      },\n\n      /**\n       * Get right direction for carets\n       *\n       * @returns {string}\n       */\n      statusIconDirection() {\n        if (\n          (!this.open && this.position === 'left')\n          || (this.open && this.position === 'right')\n        ) {\n          return 'caret-down';\n        }\n        return 'caret-up';\n      },\n\n      /**\n       * Get handle boolean (backwards compatibility with old \"status bar\" boolean)\n       *\n       * @returns {boolean}\n       */\n      localHandle() {\n        return this.statusBar || this.handle;\n      },\n    },\n\n    watch: {\n      /**\n       * When the panel is opened we need to set the position of the 'handle'\n       */\n      open() {\n        this.setHandlePosition();\n      },\n    },\n\n    created() {\n      if (this.closable) {\n        if (this.closeOnEscape) {\n          document.addEventListener('keyup', this.escapeKeyListener);\n        }\n        if (this.closeOnOutsideClick) {\n          document.addEventListener('click', this.outsidePanelListener);\n        }\n      }\n    },\n\n    mounted() {\n      if (this.localHandle) {\n        window.addEventListener('resize', () => {\n          this.setHandlePosition();\n        });\n        this.setHandlePosition();\n      }\n    },\n\n    destroyed() {\n      if (this.closable) {\n        if (this.closeOnEscape) {\n          document.removeEventListener('keyup', this.escapeKeyListener);\n        }\n        if (this.closeOnOutsideClick) {\n          document.removeEventListener('click', this.outsidePanelListener);\n        }\n      }\n      if (this.localHandle) {\n        window.removeEventListener('resize', () => {\n          this.setHandlePosition();\n        });\n      }\n    },\n\n    methods: {\n      /**\n       * set the position of the handle\n       */\n      setHandlePosition() {\n        const windowWidth = window.innerWidth;\n        const maxWidthHasPercentage = this.maxWidth.indexOf('%') > -1;\n        const minWidth = this.minWidth.replace('px', '');\n        let maxPixelWidth;\n\n        if (maxWidthHasPercentage) {\n          maxPixelWidth = (this.maxWidth.replace('%', '') / 100) * windowWidth;\n        } else {\n          maxPixelWidth = this.maxWidth.replace('px', '');\n        }\n\n        if (this.position === 'right') {\n          if (this.open) {\n            this.handleLeftPosition = 'auto';\n\n            if (minWidth && maxPixelWidth < minWidth) {\n              this.handleRightPosition = this.minWidth;\n            } else {\n              this.handleRightPosition = windowWidth - 10 < this.maxWidth.replace('px', '') ? `${windowWidth - 10}px` : this.maxWidth;\n            }\n          } else {\n            this.handleLeftPosition = 'auto';\n            this.handleRightPosition = '0px';\n          }\n        } else if (this.open) {\n          if (minWidth && maxPixelWidth < minWidth) {\n            this.handleLeftPosition = this.minWidth;\n          } else {\n            this.handleLeftPosition = windowWidth - 10 < this.maxWidth.replace('px', '') ? `${windowWidth - 10}px` : this.maxWidth;\n          }\n          this.handleRightPosition = 'auto';\n        } else {\n          this.handleLeftPosition = '0px';\n          this.handleRightPosition = 'auto';\n        }\n      },\n\n      /**\n       * Close the panel\n       */\n      closePanel() {\n        this.$emit('togglePanel', false);\n      },\n\n      /**\n       * Toggle the panel\n       */\n      togglePanel() {\n        this.$emit('togglePanel', !this.open);\n      },\n\n      /**\n       * Close panel on escape key\n       *\n       * @param {object} event\n       */\n      escapeKeyListener(event) {\n        if (event.keyCode === 27) {\n          this.closePanel();\n        }\n      },\n\n      /**\n       * Return color value as reactive value\n       *\n       * @param {object} event\n       */\n      outsidePanelListener(event) {\n        const { target } = event;\n        const panel = this.$el;\n        const isInPanel = this.isChildOf(target, panel);\n        if (!isInPanel && this.closable) {\n          this.closePanel();\n        }\n      },\n\n      /**\n       * Check if element is child of another element\n       *\n       * @param {object} child\n       * @param {object} parent\n       * @returns {boolean}\n       */\n      isChildOf(child, parent) {\n        if (child.parentNode === parent) {\n          return true;\n        } if (child.parentNode === null) {\n          return false;\n        }\n        return this.isChildOf(child.parentNode, parent);\n      },\n    },\n  };\n</script>\n<style lang=\"scss\" scoped>\n@import 'src/assets/styles/mixins';\n@import 'src/assets/styles/variables';\n\n.panel {\n  display: flex;\n  flex-direction: column;\n  right: 0;\n  z-index: 100;\n  max-width: 0;\n  box-sizing: border-box;\n  background: $tf-white;\n  box-shadow: 0 0 6px 0 rgba($tf-black, .04), 0 2px 4px 0 rgba($tf-black, .12);\n  border: solid 1px $tf-light-gray;\n  color: $tf-black;\n  text-align: center;\n  overflow: hidden;\n  position: relative;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n\n  &.fixed {\n    position: fixed;\n  }\n\n  &:not(.fixed).has-handle {\n    margin-left: 8px;\n  }\n\n  &.animate {\n    transition: width .5s;\n  }\n\n  &.left {\n    right: auto;\n    left: 0;\n  }\n\n  &.open {\n    max-width: 100%;\n    overflow-y: auto;\n  }\n}\n\n.panel-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.handle {\n  background: $tf-light-blue;\n  border: 0;\n  border-left: 1px solid $tf-light-gray;\n  border-right: 1px solid $tf-light-gray;\n  overflow: hidden;\n  cursor: pointer;\n  height: calc(100% + 1px);\n  margin-top: -1px;\n  position: fixed;\n  z-index: 10;\n  width: 14px;\n  padding: 0;\n\n  &:focus {\n    border-color: $tf-medium-gray;\n    outline: none;\n  }\n\n  span {\n    position: relative;\n    left: -4px;\n  }\n\n  svg {\n    color: $tf-light-gray;\n    transform: rotate(-90deg);\n    transform-origin: left top 0;\n  }\n\n  .left & {\n    box-shadow: 4px 0 5px 0 rgba($tf-black, .25);\n  }\n\n  .right & {\n    box-shadow: -4px 0 5px 0 rgba($tf-black, .25);\n  }\n}\n\nheader {\n  margin: 0;\n  padding: 4px 4px 4px 12px;\n  background: $tf-extra-light-gray-2;\n  border-bottom: 1px solid $tf-light-gray;\n  display: flex;\n  align-items: flex-start;\n}\n\nh3 {\n  margin: 0;\n  padding: 6px;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  text-align: left;\n  flex-grow: 1;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$E = "data-v-195a981c";
  /* module identifier */
  const __vue_module_identifier__$E = undefined;
  /* functional template */
  const __vue_is_functional_template__$E = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$E = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$D, staticRenderFns: __vue_staticRenderFns__$D },
    __vue_inject_styles__$E,
    __vue_script__$E,
    __vue_scope_id__$E,
    __vue_is_functional_template__$E,
    __vue_module_identifier__$E,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Password field with validations and confirm password field
 * Acts like a standard ElForm component so must be supplied a v-model
 *
 * example usage:
 * ```
 * <ElForm>
 *   <TfPasswordField v-model="passwordProp"/>
 * </ElForm>
 * ```
 *
 * @vuedoc
 * @exports Forms/PasswordField
 * @category Components
 */
var script$F = {
  name: 'TfPasswordField',
  props: {
    value: {
      type: String,
      required: true
    },
    passwordRequirementsError: {
      type: String,
      default: 'Password does not meet requirements.'
    },
    confirmPasswordError: {
      type: String,
      default: 'Passwords must match.'
    },
    label: {
      type: String,
      default: 'Create your password'
    },
    requirements: {
      type: Array,
      validator: function validator(value) {
        return value.every(function (v) {
          var validRules = v.rules ? v.rules.every(function (rule) {
            return rule.label && rule.isValid && typeof rule.isValid === 'function';
          }) : true;
          return v.label && v.isValid && typeof v.isValid === 'function' && validRules;
        });
      },
      default: function _default() {
        return [{
          label: 'Password must be at least 10 characters',
          /**
           * Password length rule
           *
           * @param {string} value
           * @returns {boolean}
           */
          isValid: function isValid(value) {
            return value ? value.length > 9 : false;
          }
        }, {
          label: 'Password must contain 3 of the following:',
          /**
           * Password complexity rules
           *
           * @param {string} value
           * @returns {boolean}
           */
          isValid: function isValid(value) {
            return this.rules.filter(function (_ref) {
              var isValid = _ref.isValid;
              return isValid(value);
            }).length >= 3;
          },
          rules: [{
            label: 'at least 1 uppercase character (A-Z)',
            /**
             * Password complexity - uppercase letter
             *
             * @param {string} value
             * @returns {boolean}
             */
            isValid: function isValid(value) {
              return /[A-Z]/.test(value);
            }
          }, {
            label: 'at least 1 lowercase character (a-z)',
            /**
             * Password complexity - lowercase letter
             *
             * @param {string} value
             * @returns {boolean}
             */
            isValid: function isValid(value) {
              return /[a-z]/.test(value);
            }
          }, {
            label: 'at least 1 digit (0-9)',
            /**
             * Password complexity - digit
             *
             * @param {string} value
             * @returns {boolean}
             */
            isValid: function isValid(value) {
              return /[0-9]/.test(value);
            }
          }, {
            label: 'at least 1 special character ($)',
            /**
             * Password complexity - special characters
             *
             * @param {string} value
             * @returns {boolean}
             */
            isValid: function isValid(value) {
              return /[!@#$%^&*)(+=._-]/.test(value);
            }
          }]
        }];
      }
    },
    /* Adding this prop for completeness' sake (we are passing it as
     a :sync prop on the component when it is used); the value is not
     consumed by the component, but this way the fact that it IS to
     be passed as a :sync prop is documented. */
    isValidPassword: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showPassword: false,
      showConfirmPassword: false,
      isDirty: false,
      confirmValue: ''
    };
  },
  computed: {
    /**
     * Is the password valid:
     * - Do all the requirements pass
     * - Do the password and confirm passwords match
     *
     * @returns {boolean}
     */
    isValid: function isValid() {
      var _this = this;
      return this.requirements.every(function (req) {
        return req.isValid(_this.passwordValue);
      }) && this.passwordValue === this.confirmValue;
    },
    /**
     * Getter/setter for password value
     *
     * @returns {string}
     */
    passwordValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {
    /**
     * Emit password value to the parent when the validity changes
     *
     * @param {object} newValue
     */
    isValid: function isValid(newValue) {
      this.$emit('update:isValidPassword', newValue);
    }
  },
  methods: {
    /**
     * Show error state on password field if it doesn't meet the requirements
     *
     * @param {object} rule
     * @param {string} value
     * @param {Function} callback
     */
    passwordValidator: function passwordValidator(rule, value, callback) {
      var _this2 = this;
      var isValid = this.requirements.every(function (req) {
        return req.isValid(_this2.passwordValue);
      });
      if (!isValid) {
        callback(new Error(this.passwordRequirementsError));
      } else {
        callback();
      }
    },
    /**
     * Validation rule for confirming the passwords match
     *
     * @param {object} rule
     * @param {string} value
     * @param {Function} callback
     */
    confirmPasswordValidator: function confirmPasswordValidator(rule, value, callback) {
      if (rule.confirmValue && rule.confirmValue !== this.passwordValue) {
        callback(new Error(this.confirmPasswordError));
      } else {
        callback();
      }
    },
    /**
     * Run the confirm password matches validator
     */
    validatePassword: function validatePassword() {
      this.$refs.passwordField.clearValidate();
      this.$refs.passwordField.validate('blur');
    },
    /**
     * Run the confirm password matches validator
     * Use $nextTick to avoid a race condition where the passwordValue isn't updated before the validator runs.
     */
    validateConfirmPassword: function validateConfirmPassword() {
      var _this3 = this;
      this.$refs.passwordField.clearValidate();
      this.$nextTick(function () {
        return _this3.$refs.confirmPasswordField.validate('blur');
      });
    },
    /**
     * Mark fields as invalid if:
     * 1. the password field has a value
     * 2. the user has tabbed/clicked away from the field
     * 3. the requirements have not been met
     *
     * @param {object} requirement
     * @returns {boolean}
     */
    isInvalidRequirement: function isInvalidRequirement(requirement) {
      return this.isDirty && !requirement.isValid(this.passwordValue);
    },
    /**
     * Clear validation state
     */
    clearValidate: function clearValidate() {
      this.$refs.confirmPasswordField.clearValidate();
    }
  }
};

/* script */
const __vue_script__$F = script$F;

/* template */
var __vue_render__$E = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c(
        "ElFormItem",
        {
          ref: "passwordField",
          staticClass: "password-field",
          attrs: {
            label: _vm.label,
            rules: {
              validator: _vm.passwordValidator,
              trigger: "blur",
              passwordValue: _vm.passwordValue,
            },
            "data-test": "new password form item",
          },
        },
        [
          _c(
            "ElInput",
            {
              attrs: {
                "data-test": "edit new password",
                type: _vm.showPassword ? "text" : "password",
                placeholder: "Enter password",
              },
              on: {
                input: _vm.validateConfirmPassword,
                blur: _vm.validatePassword,
              },
              model: {
                value: _vm.passwordValue,
                callback: function ($$v) {
                  _vm.passwordValue = $$v;
                },
                expression: "passwordValue",
              },
            },
            [
              _c("TfButton", {
                attrs: {
                  slot: "append",
                  icon: "eye",
                  type: "primary",
                  size: "icon-no-fill",
                },
                on: {
                  click: function ($event) {
                    _vm.showPassword = !_vm.showPassword;
                  },
                },
                slot: "append",
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        { attrs: { "data-test": "password rules" } },
        _vm._l(_vm.requirements, function (req, index) {
          return _c(
            "li",
            {
              key: index,
              class: {
                valid: req.isValid(_vm.passwordValue),
                invalid: _vm.isInvalidRequirement(req),
              },
              attrs: { "data-test": "password rule " + index },
            },
            [
              _vm._t("icon", function () {
                return [_c("icon", { attrs: { name: "check" } })]
              }),
              _vm._v("\n      " + _vm._s(req.label) + "\n      "),
              req.rules
                ? _c(
                    "ul",
                    {
                      staticClass: "rules",
                      attrs: { "data-test": "password subrules" },
                    },
                    _vm._l(req.rules, function (rule, ruleIndex) {
                      return _c(
                        "li",
                        {
                          key: ruleIndex,
                          class: { valid: rule.isValid(_vm.passwordValue) },
                          attrs: {
                            "data-test": "password subrule " + ruleIndex,
                          },
                        },
                        [
                          _vm._t("icon", function () {
                            return [_c("icon", { attrs: { name: "check" } })]
                          }),
                          _vm._v(
                            "\n          " + _vm._s(rule.label) + "\n        "
                          ),
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "ElFormItem",
        {
          ref: "confirmPasswordField",
          attrs: {
            label: "Confirm password",
            prop: "confirmValue",
            rules: {
              validator: _vm.confirmPasswordValidator,
              trigger: "blur",
              confirmValue: _vm.confirmValue,
            },
            "data-test": "confirm password form item",
          },
        },
        [
          _c(
            "ElInput",
            {
              attrs: {
                "data-test": "edit confirm password",
                placeholder: "Retype password",
                type: _vm.showConfirmPassword ? "text" : "password",
              },
              on: { input: _vm.clearValidate },
              model: {
                value: _vm.confirmValue,
                callback: function ($$v) {
                  _vm.confirmValue = $$v;
                },
                expression: "confirmValue",
              },
            },
            [
              _c("TfButton", {
                attrs: {
                  slot: "append",
                  icon: "eye",
                  type: "primary",
                  size: "icon-no-fill",
                },
                on: {
                  click: function ($event) {
                    _vm.showConfirmPassword = !_vm.showConfirmPassword;
                  },
                },
                slot: "append",
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$E = [];
__vue_render__$E._withStripped = true;

  /* style */
  const __vue_inject_styles__$F = function (inject) {
    if (!inject) return
    inject("data-v-e3e97d4e_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tf-button--icon-no-fill.icon-eye[data-v-e3e97d4e] {\n  padding: 2px 0;\n}\n.el-form-item[data-v-e3e97d4e] {\n  margin-left: 0;\n}\n.el-form-item.password-field[data-v-e3e97d4e] {\n  margin-bottom: 24px;\n}\n.invalid[data-v-e3e97d4e] {\n  color: #f92f37;\n}\nli[data-v-e3e97d4e], .rules li[data-v-e3e97d4e] {\n  margin: 10px 0;\n  color: #c1c1c1;\n  font-weight: 600;\n}\n.rules li[data-v-e3e97d4e] {\n  padding-left: 20px;\n}\n.fa-icon[data-v-e3e97d4e] {\n  height: 12px;\n  width: auto;\n}\n.valid[data-v-e3e97d4e], .rules li.valid[data-v-e3e97d4e] {\n  color: #00b980;\n}\n\n/*# sourceMappingURL=TfPasswordField.vue.map */", map: {"version":3,"sources":["TfPasswordField.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfForm/TfPasswordField.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACkUlC;EACA,cAAA;ADhUA;ACmUA;EACA,cAAA;ADhUA;ACkUA;EACA,mBAAA;ADhUA;ACoUA;EACA,cAAA;ADjUA;ACoUA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;ADjUA;ACoUA;EACA,kBAAA;ADjUA;ACoUA;EACA,YAAA;EACA,WAAA;ADjUA;ACoUA;EACA,cAAA;ADjUA;;AAEA,8CAA8C","file":"TfPasswordField.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tf-button--icon-no-fill.icon-eye {\n  padding: 2px 0;\n}\n\n.el-form-item {\n  margin-left: 0;\n}\n.el-form-item.password-field {\n  margin-bottom: 24px;\n}\n\n.invalid {\n  color: #f92f37;\n}\n\nli, .rules li {\n  margin: 10px 0;\n  color: #c1c1c1;\n  font-weight: 600;\n}\n\n.rules li {\n  padding-left: 20px;\n}\n\n.fa-icon {\n  height: 12px;\n  width: auto;\n}\n\n.valid, .rules li.valid {\n  color: #00b980;\n}\n\n/*# sourceMappingURL=TfPasswordField.vue.map */","<template>\n  <div>\n    <ElFormItem\n      ref=\"passwordField\"\n      class=\"password-field\"\n      :label=\"label\"\n      :rules=\"{ validator: passwordValidator, trigger: 'blur', passwordValue }\"\n      data-test=\"new password form item\"\n    >\n      <ElInput\n        v-model=\"passwordValue\"\n        data-test=\"edit new password\"\n        :type=\"showPassword ? 'text' : 'password'\"\n        placeholder=\"Enter password\"\n        @input=\"validateConfirmPassword\"\n        @blur=\"validatePassword\"\n      >\n        <TfButton\n          slot=\"append\"\n          icon=\"eye\"\n          type=\"primary\"\n          size=\"icon-no-fill\"\n          @click=\"showPassword = !showPassword\"\n        />\n      </ElInput>\n    </ElFormItem>\n    <ul data-test=\"password rules\">\n      <li\n        v-for=\"(req, index) in requirements\"\n        :key=\"index\"\n        :class=\"{ 'valid': req.isValid(passwordValue), 'invalid': isInvalidRequirement(req) }\"\n        :data-test=\"`password rule ${index}`\"\n      >\n        <slot name=\"icon\">\n          <icon name=\"check\" />\n        </slot>\n        {{ req.label }}\n        <ul\n          v-if=\"req.rules\"\n          class=\"rules\"\n          data-test=\"password subrules\"\n        >\n          <li\n            v-for=\"(rule, ruleIndex) in req.rules\"\n            :key=\"ruleIndex\"\n            :class=\"{ 'valid': rule.isValid(passwordValue) }\"\n            :data-test=\"`password subrule ${ruleIndex}`\"\n          >\n            <slot name=\"icon\">\n              <icon name=\"check\" />\n            </slot>\n            {{ rule.label }}\n          </li>\n        </ul>\n      </li>\n    </ul>\n    <ElFormItem\n      ref=\"confirmPasswordField\"\n      label=\"Confirm password\"\n      prop=\"confirmValue\"\n      :rules=\"{ validator: confirmPasswordValidator, trigger: 'blur', confirmValue }\"\n      data-test=\"confirm password form item\"\n    >\n      <ElInput\n        v-model=\"confirmValue\"\n        data-test=\"edit confirm password\"\n        placeholder=\"Retype password\"\n        :type=\"showConfirmPassword ? 'text' : 'password'\"\n        @input=\"clearValidate\"\n      >\n        <TfButton\n          slot=\"append\"\n          icon=\"eye\"\n          type=\"primary\"\n          size=\"icon-no-fill\"\n          @click=\"showConfirmPassword = !showConfirmPassword\"\n        />\n      </ElInput>\n    </ElFormItem>\n  </div>\n</template>\n\n<script>\n  /**\n   * Password field with validations and confirm password field\n   * Acts like a standard ElForm component so must be supplied a v-model\n   *\n   * example usage:\n   * ```\n   * <ElForm>\n   *   <TfPasswordField v-model=\"passwordProp\"/>\n   * </ElForm>\n   * ```\n   *\n   * @vuedoc\n   * @exports Forms/PasswordField\n   * @category Components\n   */\n  export default {\n    name: 'TfPasswordField',\n    props: {\n      value: {\n        type: String,\n        required: true,\n      },\n      passwordRequirementsError: {\n        type: String,\n        default: 'Password does not meet requirements.',\n      },\n      confirmPasswordError: {\n        type: String,\n        default: 'Passwords must match.',\n      },\n      label: {\n        type: String,\n        default: 'Create your password',\n      },\n      requirements: {\n        type: Array,\n        validator: (value) => value.every((v) => {\n          const validRules = v.rules\n            ? v.rules.every((rule) => rule.label && rule.isValid && typeof rule.isValid === 'function')\n            : true;\n          return v.label\n            && v.isValid && typeof v.isValid === 'function'\n            && validRules;\n        }),\n        default: () => [\n          {\n            label: 'Password must be at least 10 characters',\n            /**\n             * Password length rule\n             *\n             * @param {string} value\n             * @returns {boolean}\n             */\n            isValid(value) { return value ? value.length > 9 : false; },\n          },\n          {\n            label: 'Password must contain 3 of the following:',\n            /**\n             * Password complexity rules\n             *\n             * @param {string} value\n             * @returns {boolean}\n             */\n            isValid(value) {\n              return this.rules.filter(({ isValid }) => isValid(value)).length >= 3;\n            },\n            rules: [\n              {\n                label: 'at least 1 uppercase character (A-Z)',\n                /**\n                 * Password complexity - uppercase letter\n                 *\n                 * @param {string} value\n                 * @returns {boolean}\n                 */\n                isValid(value) { return /[A-Z]/.test(value); },\n              },\n              {\n                label: 'at least 1 lowercase character (a-z)',\n                /**\n                 * Password complexity - lowercase letter\n                 *\n                 * @param {string} value\n                 * @returns {boolean}\n                 */\n                isValid(value) { return /[a-z]/.test(value); },\n              },\n              {\n                label: 'at least 1 digit (0-9)',\n                /**\n                 * Password complexity - digit\n                 *\n                 * @param {string} value\n                 * @returns {boolean}\n                 */\n                isValid(value) { return /[0-9]/.test(value); },\n              },\n              {\n                label: 'at least 1 special character ($)',\n                /**\n                 * Password complexity - special characters\n                 *\n                 * @param {string} value\n                 * @returns {boolean}\n                 */\n                isValid(value) { return /[!@#$%^&*)(+=._-]/.test(value); },\n              },\n            ],\n          },\n        ],\n      },\n      /* Adding this prop for completeness' sake (we are passing it as\n       a :sync prop on the component when it is used); the value is not\n       consumed by the component, but this way the fact that it IS to\n       be passed as a :sync prop is documented. */\n      isValidPassword: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: () => ({\n      showPassword: false,\n      showConfirmPassword: false,\n      isDirty: false,\n      confirmValue: '',\n    }),\n    computed: {\n      /**\n       * Is the password valid:\n       * - Do all the requirements pass\n       * - Do the password and confirm passwords match\n       *\n       * @returns {boolean}\n       */\n      isValid() {\n        return this.requirements.every(\n          (req) => req.isValid(this.passwordValue),\n        ) && this.passwordValue === this.confirmValue;\n      },\n      /**\n       * Getter/setter for password value\n       *\n       * @returns {string}\n       */\n      passwordValue: {\n        get() {\n          return this.value;\n        },\n        set(value) {\n          this.$emit('input', value);\n        },\n      },\n    },\n    watch: {\n      /**\n       * Emit password value to the parent when the validity changes\n       *\n       * @param {object} newValue\n       */\n      isValid(newValue) {\n        this.$emit('update:isValidPassword', newValue);\n      },\n    },\n    methods: {\n      /**\n       * Show error state on password field if it doesn't meet the requirements\n       *\n       * @param {object} rule\n       * @param {string} value\n       * @param {Function} callback\n       */\n      passwordValidator(rule, value, callback) {\n        const isValid = this.requirements.every(\n          (req) => req.isValid(this.passwordValue),\n        );\n\n        if (!isValid) {\n          callback(new Error(this.passwordRequirementsError));\n        } else {\n          callback();\n        }\n      },\n      /**\n       * Validation rule for confirming the passwords match\n       *\n       * @param {object} rule\n       * @param {string} value\n       * @param {Function} callback\n       */\n      confirmPasswordValidator(rule, value, callback) {\n        if (rule.confirmValue && rule.confirmValue !== this.passwordValue) {\n          callback(new Error(this.confirmPasswordError));\n        } else {\n          callback();\n        }\n      },\n\n      /**\n       * Run the confirm password matches validator\n       */\n      validatePassword() {\n        this.$refs.passwordField.clearValidate();\n        this.$refs.passwordField.validate('blur');\n      },\n\n      /**\n       * Run the confirm password matches validator\n       * Use $nextTick to avoid a race condition where the passwordValue isn't updated before the validator runs.\n       */\n      validateConfirmPassword() {\n        this.$refs.passwordField.clearValidate();\n        this.$nextTick(() => this.$refs.confirmPasswordField.validate('blur'));\n      },\n\n      /**\n       * Mark fields as invalid if:\n       * 1. the password field has a value\n       * 2. the user has tabbed/clicked away from the field\n       * 3. the requirements have not been met\n       *\n       * @param {object} requirement\n       * @returns {boolean}\n       */\n      isInvalidRequirement(requirement) {\n        return this.isDirty\n          && !requirement.isValid(this.passwordValue);\n      },\n\n      /**\n       * Clear validation state\n       */\n      clearValidate() {\n        this.$refs.confirmPasswordField.clearValidate();\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .tf-button--icon-no-fill.icon-eye {\n    padding: 2px 0;\n  }\n\n  .el-form-item {\n    margin-left: 0;\n\n    &.password-field {\n      margin-bottom: 24px;\n    }\n  }\n\n  .invalid {\n    color: $tf-red;\n  }\n\n  li, .rules li {\n    margin: 10px 0;\n    color: $tf-light-gray;\n    font-weight: 600;\n  }\n\n  .rules li {\n    padding-left: 20px;\n  }\n\n  .fa-icon {\n    height: 12px;\n    width: auto;\n  }\n\n  .valid, .rules li.valid {\n    color: $tf-green;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$F = "data-v-e3e97d4e";
  /* module identifier */
  const __vue_module_identifier__$F = undefined;
  /* functional template */
  const __vue_is_functional_template__$F = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$F = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$E, staticRenderFns: __vue_staticRenderFns__$E },
    __vue_inject_styles__$F,
    __vue_script__$F,
    __vue_scope_id__$F,
    __vue_is_functional_template__$F,
    __vue_module_identifier__$F,
    false,
    browser,
    undefined,
    undefined
  );

var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof(o) {
    "@babel/helpers - typeof";

    return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
  }
  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var t = unwrapExports(_typeof_1);

// DEFLATE is a complex format; to read this code, you should probably check the RFC first:

// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */ 0, 0, /* impossible */ 0]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */ 0, 0]);
// code length index map
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
// get base, reverse index map from extra bits
var freb = function (eb, start) {
    var b = new u16(31);
    for (var i = 0; i < 31; ++i) {
        b[i] = start += 1 << eb[i - 1];
    }
    // numbers here are at max 18 bits
    var r = new u32(b[30]);
    for (var i = 1; i < 30; ++i) {
        for (var j = b[i]; j < b[i + 1]; ++j) {
            r[j] = ((j - b[i]) << 5) | i;
        }
    }
    return [b, r];
};
var _a = freb(fleb, 2), fl = _a[0], revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0], revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for (var i$2 = 0; i$2 < 32768; ++i$2) {
    // reverse table algorithm from SO
    var x = ((i$2 & 0xAAAA) >>> 1) | ((i$2 & 0x5555) << 1);
    x = ((x & 0xCCCC) >>> 2) | ((x & 0x3333) << 2);
    x = ((x & 0xF0F0) >>> 4) | ((x & 0x0F0F) << 4);
    rev[i$2] = (((x & 0xFF00) >>> 8) | ((x & 0x00FF) << 8)) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = (function (cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for (; i < s; ++i)
        ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for (i = 0; i < mb; ++i) {
        le[i] = (le[i - 1] + l[i - 1]) << 1;
    }
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for (i = 0; i < s; ++i) {
            // ignore 0 lengths
            if (cd[i]) {
                // num encoding both symbol and bits read
                var sv = (i << 4) | cd[i];
                // free bits
                var r_1 = mb - cd[i];
                // start value
                var v = le[cd[i] - 1]++ << r_1;
                // m is end value
                for (var m = v | ((1 << r_1) - 1); v <= m; ++v) {
                    // every 16 bit value starting with the code yields the same result
                    co[rev[v] >>> rvb] = sv;
                }
            }
        }
    }
    else {
        co = new u16(s);
        for (i = 0; i < s; ++i)
            co[i] = rev[le[cd[i] - 1]++] >>> (15 - cd[i]);
    }
    return co;
});
// fixed length tree
var flt = new u8(288);
for (var i$2 = 0; i$2 < 144; ++i$2)
    flt[i$2] = 8;
for (var i$2 = 144; i$2 < 256; ++i$2)
    flt[i$2] = 9;
for (var i$2 = 256; i$2 < 280; ++i$2)
    flt[i$2] = 7;
for (var i$2 = 280; i$2 < 288; ++i$2)
    flt[i$2] = 8;
// fixed distance tree
var fdt = new u8(32);
for (var i$2 = 0; i$2 < 32; ++i$2)
    fdt[i$2] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max$3 = function (a) {
    var m = a[0];
    for (var i = 1; i < a.length; ++i) {
        if (a[i] > m)
            m = a[i];
    }
    return m;
};
// read d, starting at bit p and mask with m
var bits = function (d, p, m) {
    var o = (p / 8) >> 0;
    return ((d[o] | (d[o + 1] << 8)) >>> (p & 7)) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function (d, p) {
    var o = (p / 8) >> 0;
    return ((d[o] | (d[o + 1] << 8) | (d[o + 2] << 16)) >>> (p & 7));
};
// get end of byte
var shft = function (p) { return ((p / 8) >> 0) + (p & 7 && 1); };
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function (v, s, e) {
    if (s == null || s < 0)
        s = 0;
    if (e == null || e > v.length)
        e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
// expands raw DEFLATE data
var inflt = function (dat, buf, st) {
    // source length
    var sl = dat.length;
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st)
        st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf)
        buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function (l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | (dat[s - 3] << 8), t = s + l;
                if (t > sl) {
                    if (noSt)
                        throw 'unexpected EOF';
                    break;
                }
                // ensure size
                if (noBuf)
                    cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            }
            else if (type == 1)
                lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for (var i = 0; i < hcLen; ++i) {
                    // use index map to get real code
                    clt[clim[i]] = bits(dat, pos + i * 3, 7);
                }
                pos += hcLen * 3;
                // code lengths bits
                var clb = max$3(clt), clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts)
                    break;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for (var i = 0; i < tl;) {
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) {
                        ldt[i++] = s;
                    }
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16)
                            n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17)
                            n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18)
                            n = 11 + bits(dat, pos, 127), pos += 7;
                        while (n--)
                            ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max$3(lt);
                // max dist bits
                dbt = max$3(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            }
            else
                throw 'invalid block type';
            if (pos > tbts)
                throw 'unexpected EOF';
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf)
            cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var mxa = lbt + dbt + 18;
        while (noSt || pos + mxa < tbts) {
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts)
                throw 'unexpected EOF';
            if (!c)
                throw 'invalid length/literal';
            if (sym < 256)
                buf[bt++] = sym;
            else if (sym == 256) {
                lm = null;
                break;
            }
            else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d)
                    throw 'invalid distance';
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & ((1 << b) - 1), pos += b;
                }
                if (pos > tbts)
                    throw 'unexpected EOF';
                if (noBuf)
                    cbuf(bt + 131072);
                var end = bt + add;
                for (; bt < end; bt += 4) {
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = pos, st.b = bt;
        if (lm)
            final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    } while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function (d, mb) {
    // Need extra info to make a tree
    var t = [];
    for (var i = 0; i < d.length; ++i) {
        if (d[i])
            t.push({ s: i, f: d[i] });
    }
    var s = t.length;
    var t2 = t.slice();
    if (!s)
        return [new u8(0), 0];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [v, 1];
    }
    t.sort(function (a, b) { return a.f - b.f; });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({ s: -1, f: 25001 });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = { s: -1, f: l.f + r.f, l: l, r: r };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while (i1 != s - 1) {
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = { s: -1, f: l.f + r.f, l: l, r: r };
    }
    var maxSym = t2[0].s;
    for (var i = 1; i < s; ++i) {
        if (t2[i].s > maxSym)
            maxSym = t2[i].s;
    }
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function (a, b) { return tr[b.s] - tr[a.s] || a.f - b.f; });
        for (; i < s; ++i) {
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << (mbt - tr[i2_1]));
                tr[i2_1] = mb;
            }
            else
                break;
        }
        dt >>>= lft;
        while (dt > 0) {
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb)
                dt -= 1 << (mb - tr[i2_2]++ - 1);
            else
                ++i;
        }
        for (; i >= 0 && dt; --i) {
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [new u8(tr), mbt];
};
// get the max length and assign length codes
var ln = function (n, l, d) {
    return n.s == -1
        ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1))
        : (l[n.s] = d);
};
// length codes generation
var lc = function (c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while (s && !c[--s])
        ;
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function (v) { cl[cli++] = v; };
    for (var i = 1; i <= s; ++i) {
        if (c[i] == cln && i != s)
            ++cls;
        else {
            if (!cln && cls > 2) {
                for (; cls > 138; cls -= 138)
                    w(32754);
                if (cls > 2) {
                    w(cls > 10 ? ((cls - 11) << 5) | 28690 : ((cls - 3) << 5) | 12305);
                    cls = 0;
                }
            }
            else if (cls > 3) {
                w(cln), --cls;
                for (; cls > 6; cls -= 6)
                    w(8304);
                if (cls > 2)
                    w(((cls - 3) << 5) | 8208), cls = 0;
            }
            while (cls--)
                w(cln);
            cls = 1;
            cln = c[i];
        }
    }
    return [cl.subarray(0, cli), s];
};
// calculate the length of output from tree, code lengths
var clen = function (cf, cl) {
    var l = 0;
    for (var i = 0; i < cl.length; ++i)
        l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function (out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for (var i = 0; i < s; ++i)
        out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function (dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new u16(19);
    for (var i = 0; i < lclt.length; ++i)
        lcfreq[lclt[i] & 31]++;
    for (var i = 0; i < lcdt.length; ++i)
        lcfreq[lcdt[i] & 31]++;
    var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc)
        ;
    var flen = (bl + 5) << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen)
        return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for (var i = 0; i < nlcc; ++i)
            wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [lclt, lcdt];
        for (var it = 0; it < 2; ++it) {
            var clct = lcts[it];
            for (var i = 0; i < clct.length; ++i) {
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15)
                    wbits(out, p, (clct[i] >>> 5) & 127), p += clct[i] >>> 12;
            }
        }
    }
    else {
        lm = flm, ll = flt, dm = fdm, dl = fdt;
    }
    for (var i = 0; i < li; ++i) {
        if (syms[i] > 255) {
            var len = (syms[i] >>> 18) & 31;
            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7)
                wbits(out, p, (syms[i] >>> 23) & 31), p += fleb[len];
            var dst = syms[i] & 31;
            wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3)
                wbits16(out, p, (syms[i] >>> 5) & 8191), p += fdeb[dst];
        }
        else {
            wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
        }
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new u32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function (dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.floor(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) {
        for (var i = 0; i <= s; i += 65535) {
            // end
            var e = i + 65535;
            if (e < s) {
                // write full block
                pos = wfblk(w, pos, dat.subarray(i, e));
            }
            else {
                // write final block
                w[i] = lst;
                pos = wfblk(w, pos, dat.subarray(i, s));
            }
        }
    }
    else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new u16(32768), head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function (i) { return (dat[i] ^ (dat[i + 1] << bs1_1) ^ (dat[i + 2] << bs2_1)) & msk_1; };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new u32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for (; i < s; ++i) {
            // hash value
            var hv = hsh(i);
            // index mod 32768
            var imod = i & 32767;
            // previous index with this value
            var pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for (var j = 0; j < 286; ++j)
                        lf[j] = 0;
                    for (var j = 0; j < 30; ++j)
                        df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = (imod - pimod) & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while (dif <= maxd && --ch_1 && imod != pimod) {
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl)
                                ;
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn)
                                    break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for (var j = 0; j < mmd; ++j) {
                                    var ti = (i - dif + j + 32768) & 32767;
                                    var pti = prev[ti];
                                    var cd = (ti - pti + 32768) & 32767;
                                    if (cd > md)
                                        md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += (imod - pimod + 32768) & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | (revfl[l] << 18) | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                }
                else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst)
            pos = wfblk(w, pos, et);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// Alder32
var adler = function () {
    var a = 1, b = 0;
    return {
        p: function (d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length;
            for (var i = 0; i != l;) {
                var e = Math.min(i + 5552, l);
                for (; i < e; ++i)
                    n += d[i], m += n;
                n %= 65521, m %= 65521;
            }
            a = n, b = m;
        },
        d: function () { return ((a >>> 8) << 16 | (b & 255) << 8 | (b >>> 8)) + ((a & 255) << 23) * 2; }
    };
};
// deflate with opts
var dopt = function (dat, opt, pre, post, st) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : (12 + opt.mem), pre, post, !st);
};
// write bytes
var wbytes = function (d, b, v) {
    for (; v; ++b)
        d[b] = v, v >>>= 8;
};
// zlib header
var zlh = function (c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = (fl << 6) | (fl ? (32 - 2 * fl) : 1);
};
// zlib valid
var zlv = function (d) {
    if ((d[0] & 15) != 8 || (d[0] >>> 4) > 7 || ((d[0] << 8 | d[1]) % 31))
        throw 'invalid zlib data';
    if (d[1] & 32)
        throw 'invalid zlib data: preset dictionaries not supported';
};
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */
function zlibSync(data, opts) {
    if (opts === void 0) { opts = {}; }
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}

/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.1 Built on 2022-01-28T15:37:57.791Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */
var n=function(){return "undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this}();function i$3(){n.console&&"function"==typeof n.console.log&&n.console.log.apply(n.console,arguments);}var a={log:i$3,warn:function(t){n.console&&("function"==typeof n.console.warn?n.console.warn.apply(n.console,arguments):i$3.call(null,arguments));},error:function(t){n.console&&("function"==typeof n.console.error?n.console.error.apply(n.console,arguments):i$3(t));}};function o(t,e,r){var n=new XMLHttpRequest;n.open("GET",t),n.responseType="blob",n.onload=function(){l(n.response,e,r);},n.onerror=function(){a.error("could not download file");},n.send();}function s(t){var e=new XMLHttpRequest;e.open("HEAD",t,!1);try{e.send();}catch(t){}return e.status>=200&&e.status<=299}function c(t){try{t.dispatchEvent(new MouseEvent("click"));}catch(r){var e=document.createEvent("MouseEvents");e.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),t.dispatchEvent(e);}}var u,h,l=n.saveAs||("object"!==("undefined"==typeof window?"undefined":t(window))||window!==n?function(){}:"undefined"!=typeof HTMLAnchorElement&&"download"in HTMLAnchorElement.prototype?function(t,e,r){var i=n.URL||n.webkitURL,a=document.createElement("a");e=e||t.name||"download",a.download=e,a.rel="noopener","string"==typeof t?(a.href=t,a.origin!==location.origin?s(a.href)?o(t,e,r):c(a,a.target="_blank"):c(a)):(a.href=i.createObjectURL(t),setTimeout((function(){i.revokeObjectURL(a.href);}),4e4),setTimeout((function(){c(a);}),0));}:"msSaveOrOpenBlob"in navigator?function(e,r,n){if(r=r||e.name||"download","string"==typeof e)if(s(e))o(e,r,n);else{var i=document.createElement("a");i.href=e,i.target="_blank",setTimeout((function(){c(i);}));}else navigator.msSaveOrOpenBlob(function(e,r){return void 0===r?r={autoBom:!1}:"object"!==t(r)&&(a.warn("Deprecated: Expected third argument to be a object"),r={autoBom:!r}),r.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)?new Blob([String.fromCharCode(65279),e],{type:e.type}):e}(e,n),r);}:function(e,r,i,a){if((a=a||open("","_blank"))&&(a.document.title=a.document.body.innerText="downloading..."),"string"==typeof e)return o(e,r,i);var s="application/octet-stream"===e.type,c=/constructor/i.test(n.HTMLElement)||n.safari,u=/CriOS\/[\d]+/.test(navigator.userAgent);if((u||s&&c)&&"object"===("undefined"==typeof FileReader?"undefined":t(FileReader))){var h=new FileReader;h.onloadend=function(){var t=h.result;t=u?t:t.replace(/^data:[^;]*;/,"data:attachment/file;"),a?a.location.href=t:location=t,a=null;},h.readAsDataURL(e);}else{var l=n.URL||n.webkitURL,f=l.createObjectURL(e);a?a.location=f:location.href=f,a=null,setTimeout((function(){l.revokeObjectURL(f);}),4e4);}});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */function f$c(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6));t={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"}[t=(t=t.replace(/ /g,"")).toLowerCase()]||t;for(var r=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return [parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return [parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return [parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],n=0;n<r.length;n++){var i=r[n].re,a=r[n].process,o=i.exec(t);o&&(e=a(o),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0);}this.r=this.r<0||isNaN(this.r)?0:this.r>255?255:this.r,this.g=this.g<0||isNaN(this.g)?0:this.g>255?255:this.g,this.b=this.b<0||isNaN(this.b)?0:this.b>255?255:this.b,this.toRGB=function(){return "rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),r=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==r.length&&(r="0"+r),"#"+t+e+r};}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
function d(t,e){var r=t[0],n=t[1],i=t[2],a=t[3];r=g(r,n,i,a,e[0],7,-680876936),a=g(a,r,n,i,e[1],12,-389564586),i=g(i,a,r,n,e[2],17,606105819),n=g(n,i,a,r,e[3],22,-1044525330),r=g(r,n,i,a,e[4],7,-176418897),a=g(a,r,n,i,e[5],12,1200080426),i=g(i,a,r,n,e[6],17,-1473231341),n=g(n,i,a,r,e[7],22,-45705983),r=g(r,n,i,a,e[8],7,1770035416),a=g(a,r,n,i,e[9],12,-1958414417),i=g(i,a,r,n,e[10],17,-42063),n=g(n,i,a,r,e[11],22,-1990404162),r=g(r,n,i,a,e[12],7,1804603682),a=g(a,r,n,i,e[13],12,-40341101),i=g(i,a,r,n,e[14],17,-1502002290),r=m(r,n=g(n,i,a,r,e[15],22,1236535329),i,a,e[1],5,-165796510),a=m(a,r,n,i,e[6],9,-1069501632),i=m(i,a,r,n,e[11],14,643717713),n=m(n,i,a,r,e[0],20,-373897302),r=m(r,n,i,a,e[5],5,-701558691),a=m(a,r,n,i,e[10],9,38016083),i=m(i,a,r,n,e[15],14,-660478335),n=m(n,i,a,r,e[4],20,-405537848),r=m(r,n,i,a,e[9],5,568446438),a=m(a,r,n,i,e[14],9,-1019803690),i=m(i,a,r,n,e[3],14,-187363961),n=m(n,i,a,r,e[8],20,1163531501),r=m(r,n,i,a,e[13],5,-1444681467),a=m(a,r,n,i,e[2],9,-51403784),i=m(i,a,r,n,e[7],14,1735328473),r=v(r,n=m(n,i,a,r,e[12],20,-1926607734),i,a,e[5],4,-378558),a=v(a,r,n,i,e[8],11,-2022574463),i=v(i,a,r,n,e[11],16,1839030562),n=v(n,i,a,r,e[14],23,-35309556),r=v(r,n,i,a,e[1],4,-1530992060),a=v(a,r,n,i,e[4],11,1272893353),i=v(i,a,r,n,e[7],16,-155497632),n=v(n,i,a,r,e[10],23,-1094730640),r=v(r,n,i,a,e[13],4,681279174),a=v(a,r,n,i,e[0],11,-358537222),i=v(i,a,r,n,e[3],16,-722521979),n=v(n,i,a,r,e[6],23,76029189),r=v(r,n,i,a,e[9],4,-640364487),a=v(a,r,n,i,e[12],11,-421815835),i=v(i,a,r,n,e[15],16,530742520),r=b(r,n=v(n,i,a,r,e[2],23,-995338651),i,a,e[0],6,-198630844),a=b(a,r,n,i,e[7],10,1126891415),i=b(i,a,r,n,e[14],15,-1416354905),n=b(n,i,a,r,e[5],21,-57434055),r=b(r,n,i,a,e[12],6,1700485571),a=b(a,r,n,i,e[3],10,-1894986606),i=b(i,a,r,n,e[10],15,-1051523),n=b(n,i,a,r,e[1],21,-2054922799),r=b(r,n,i,a,e[8],6,1873313359),a=b(a,r,n,i,e[15],10,-30611744),i=b(i,a,r,n,e[6],15,-1560198380),n=b(n,i,a,r,e[13],21,1309151649),r=b(r,n,i,a,e[4],6,-145523070),a=b(a,r,n,i,e[11],10,-1120210379),i=b(i,a,r,n,e[2],15,718787259),n=b(n,i,a,r,e[9],21,-343485551),t[0]=_(r,t[0]),t[1]=_(n,t[1]),t[2]=_(i,t[2]),t[3]=_(a,t[3]);}function p(t,e,r,n,i,a){return e=_(_(e,t),_(n,a)),_(e<<i|e>>>32-i,r)}function g(t,e,r,n,i,a,o){return p(e&r|~e&n,t,e,i,a,o)}function m(t,e,r,n,i,a,o){return p(e&n|r&~n,t,e,i,a,o)}function v(t,e,r,n,i,a,o){return p(e^r^n,t,e,i,a,o)}function b(t,e,r,n,i,a,o){return p(r^(e|~n),t,e,i,a,o)}function y(t){var e,r=t.length,n=[1732584193,-271733879,-1732584194,271733878];for(e=64;e<=t.length;e+=64)d(n,w(t.substring(e-64,e)));t=t.substring(e-64);var i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<t.length;e++)i[e>>2]|=t.charCodeAt(e)<<(e%4<<3);if(i[e>>2]|=128<<(e%4<<3),e>55)for(d(n,i),e=0;e<16;e++)i[e]=0;return i[14]=8*r,d(n,i),n}function w(t){var e,r=[];for(e=0;e<64;e+=4)r[e>>2]=t.charCodeAt(e)+(t.charCodeAt(e+1)<<8)+(t.charCodeAt(e+2)<<16)+(t.charCodeAt(e+3)<<24);return r}u=n.atob.bind(n),h=n.btoa.bind(n);var N="0123456789abcdef".split("");function L(t){for(var e="",r=0;r<4;r++)e+=N[t>>8*r+4&15]+N[t>>8*r&15];return e}function A(t){return String.fromCharCode((255&t)>>0,(65280&t)>>8,(16711680&t)>>16,(4278190080&t)>>24)}function x$1(t){return y(t).map(A).join("")}var S="5d41402abc4b2a76b9719d911017c592"!=function(t){for(var e=0;e<t.length;e++)t[e]=L(t[e]);return t.join("")}(y("hello"));function _(t,e){if(S){var r=(65535&t)+(65535&e);return (t>>16)+(e>>16)+(r>>16)<<16|65535&r}return t+e&4294967295}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */function P(t,e){var r,n,i,a;if(t!==r){for(var o=(i=t,a=1+(256/t.length>>0),new Array(a+1).join(i)),s=[],c=0;c<256;c++)s[c]=c;var u=0;for(c=0;c<256;c++){var h=s[c];u=(u+h+o.charCodeAt(c))%256,s[c]=s[u],s[u]=h;}r=t,n=s;}else s=n;var l=e.length,f=0,d=0,p="";for(c=0;c<l;c++)d=(d+(h=s[f=(f+1)%256]))%256,s[f]=s[d],s[d]=h,o=s[(s[f]+s[d])%256],p+=String.fromCharCode(e.charCodeAt(c)^o);return p}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */var k$1={print:4,modify:8,copy:16,"annot-forms":32};function I(t,e,r,n){this.v=1,this.r=2;var i=192;t.forEach((function(t){i+=k$1[t];})),this.padding="(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";var a=(e+this.padding).substr(0,32),o=(r+this.padding).substr(0,32);this.O=this.processOwnerPassword(a,o),this.P=-(1+(255^i)),this.encryptionKey=x$1(a+this.O+this.lsbFirstWord(this.P)+this.hexToBytes(n)).substr(0,5),this.U=P(this.encryptionKey,this.padding);}function F(t){if(/[^\u0000-\u00ff]/.test(t))throw new Error("Invalid PDF Name Object: "+t+", Only accept ASCII characters.");for(var e="",r=t.length,n=0;n<r;n++){var i=t.charCodeAt(n);if(i<33||35===i||37===i||40===i||41===i||47===i||60===i||62===i||91===i||93===i||123===i||125===i||i>126)e+="#"+("0"+i.toString(16)).slice(-2);else e+=t[n];}return e}function C(e){if("object"!==t(e))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var r={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");r.hasOwnProperty(t)||(r[t]={});var i=Math.random().toString(35);return r[t][i]=[e,!!n],i},this.unsubscribe=function(t){for(var e in r)if(r[e][t])return delete r[e][t],0===Object.keys(r[e]).length&&delete r[e],!0;return !1},this.publish=function(t){if(r.hasOwnProperty(t)){var i=Array.prototype.slice.call(arguments,1),o=[];for(var s in r[t]){var c=r[t][s];try{c[0].apply(e,i);}catch(t){n.console&&a.error("jsPDF PubSub Error",t.message,t);}c[1]&&o.push(s);}o.length&&o.forEach(this.unsubscribe);}},this.getTopics=function(){return r};}function j$2(t){if(!(this instanceof j$2))return new j$2(t);var e="opacity,stroke-opacity".split(",");for(var r in t)t.hasOwnProperty(r)&&e.indexOf(r)>=0&&(this[r]=t[r]);this.id="",this.objectNumber=-1;}function O(t,e){this.gState=t,this.matrix=e,this.id="",this.objectNumber=-1;}function B(t,e,r,n,i){if(!(this instanceof B))return new B(t,e,r,n,i);this.type="axial"===t?2:3,this.coords=e,this.colors=r,O.call(this,n,i);}function M(t,e,r,n,i){if(!(this instanceof M))return new M(t,e,r,n,i);this.boundingBox=t,this.xStep=e,this.yStep=r,this.stream="",this.cloneIndex=0,O.call(this,n,i);}function E(e){var r,i="string"==typeof arguments[0]?arguments[0]:"p",o=arguments[1],s=arguments[2],c=arguments[3],u=[],d=1,p=16,g="S",m=null;"object"===t(e=e||{})&&(i=e.orientation,o=e.unit||o,s=e.format||s,c=e.compress||e.compressPdf||c,null!==(m=e.encryption||null)&&(m.userPassword=m.userPassword||"",m.ownerPassword=m.ownerPassword||"",m.userPermissions=m.userPermissions||[]),d="number"==typeof e.userUnit?Math.abs(e.userUnit):1,void 0!==e.precision&&(r=e.precision),void 0!==e.floatPrecision&&(p=e.floatPrecision),g=e.defaultPathOperation||"S"),u=e.filters||(!0===c?["FlateEncode"]:u),o=o||"mm",i=(""+(i||"P")).toLowerCase();var v=e.putOnlyUsedFonts||!1,b={},y={internal:{},__private__:{}};y.__private__.PubSub=C;var w="1.3",N=y.__private__.getPdfVersion=function(){return w};y.__private__.setPdfVersion=function(t){w=t;};var L={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};y.__private__.getPageFormats=function(){return L};var A=y.__private__.getPageFormat=function(t){return L[t]};s=s||"a4";var x={COMPAT:"compat",ADVANCED:"advanced"},S=x.COMPAT;function _(){this.saveGraphicsState(),lt(new Vt(_t,0,0,-_t,0,Rr()*_t).toString()+" cm"),this.setFontSize(this.getFontSize()/_t),g="n",S=x.ADVANCED;}function P(){this.restoreGraphicsState(),g="S",S=x.COMPAT;}var k=y.__private__.combineFontStyleAndFontWeight=function(t,e){if("bold"==t&&"normal"==e||"bold"==t&&400==e||"normal"==t&&"italic"==e||"bold"==t&&"italic"==e)throw new Error("Invalid Combination of fontweight and fontstyle");return e&&(t=400==e||"normal"===e?"italic"===t?"italic":"normal":700!=e&&"bold"!==e||"normal"!==t?(700==e?"bold":e)+""+t:"bold"),t};y.advancedAPI=function(t){var e=S===x.COMPAT;return e&&_.call(this),"function"!=typeof t||(t(this),e&&P.call(this)),this},y.compatAPI=function(t){var e=S===x.ADVANCED;return e&&P.call(this),"function"!=typeof t||(t(this),e&&_.call(this)),this},y.isAdvancedAPI=function(){return S===x.ADVANCED};var O,q=function(t){if(S!==x.ADVANCED)throw new Error(t+" is only available in 'advanced' API mode. You need to call advancedAPI() first.")},D=y.roundToPrecision=y.__private__.roundToPrecision=function(t,e){var n=r||e;if(isNaN(t)||isNaN(n))throw new Error("Invalid argument passed to jsPDF.roundToPrecision");return t.toFixed(n).replace(/0+$/,"")};O=y.hpf=y.__private__.hpf="number"==typeof p?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,p)}:"smart"===p?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,t>-1&&t<1?16:5)}:function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,16)};var R=y.f2=y.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return D(t,2)},T=y.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return D(t,3)},U=y.scale=y.__private__.scale=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.scale");return S===x.COMPAT?t*_t:S===x.ADVANCED?t:void 0},z=function(t){return S===x.COMPAT?Rr()-t:S===x.ADVANCED?t:void 0},H=function(t){return U(z(t))};y.__private__.setPrecision=y.setPrecision=function(t){"number"==typeof parseInt(t,10)&&(r=parseInt(t,10));};var W,V="00000000000000000000000000000000",G=y.__private__.getFileId=function(){return V},Y=y.__private__.setFileId=function(t){return V=void 0!==t&&/^[a-fA-F0-9]{32}$/.test(t)?t.toUpperCase():V.split("").map((function(){return "ABCDEF0123456789".charAt(Math.floor(16*Math.random()))})).join(""),null!==m&&(Ye=new I(m.userPermissions,m.userPassword,m.ownerPassword,V)),V};y.setFileId=function(t){return Y(t),this},y.getFileId=function(){return G()};var J=y.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),r=e<0?"+":"-",n=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),a=[r,Q(n),"'",Q(i),"'"].join("");return ["D:",t.getFullYear(),Q(t.getMonth()+1),Q(t.getDate()),Q(t.getHours()),Q(t.getMinutes()),Q(t.getSeconds()),a].join("")},X=y.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),r=parseInt(t.substr(6,2),10)-1,n=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),a=parseInt(t.substr(12,2),10),o=parseInt(t.substr(14,2),10);return new Date(e,r,n,i,a,o,0)},K=y.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),t instanceof Date)e=J(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t;}return W=e},Z=y.__private__.getCreationDate=function(t){var e=W;return "jsDate"===t&&(e=X(W)),e};y.setCreationDate=function(t){return K(t),this},y.getCreationDate=function(t){return Z(t)};var $,Q=y.__private__.padd2=function(t){return ("0"+parseInt(t)).slice(-2)},tt=y.__private__.padd2Hex=function(t){return ("00"+(t=t.toString())).substr(t.length)},et=0,rt=[],nt=[],it=0,at=[],ot=[],st=!1,ct=nt,ut=function(){et=0,it=0,nt=[],rt=[],at=[],Qt=Kt(),te=Kt();};y.__private__.setCustomOutputDestination=function(t){st=!0,ct=t;};var ht=function(t){st||(ct=t);};y.__private__.resetCustomOutputDestination=function(){st=!1,ct=nt;};var lt=y.__private__.out=function(t){return t=t.toString(),it+=t.length+1,ct.push(t),ct},ft=y.__private__.write=function(t){return lt(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},dt=y.__private__.getArrayBuffer=function(t){for(var e=t.length,r=new ArrayBuffer(e),n=new Uint8Array(r);e--;)n[e]=t.charCodeAt(e);return r},pt=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]];y.__private__.getStandardFonts=function(){return pt};var gt=e.fontSize||16;y.__private__.setFontSize=y.setFontSize=function(t){return gt=S===x.ADVANCED?t/_t:t,this};var mt,vt=y.__private__.getFontSize=y.getFontSize=function(){return S===x.COMPAT?gt:gt*_t},bt=e.R2L||!1;y.__private__.setR2L=y.setR2L=function(t){return bt=t,this},y.__private__.getR2L=y.getR2L=function(){return bt};var yt,wt=y.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t))mt=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');mt=t;}else mt=parseInt(t,10);};y.__private__.getZoomMode=function(){return mt};var Nt,Lt=y.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');yt=t;};y.__private__.getPageMode=function(){return yt};var At=y.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');Nt=t;};y.__private__.getLayoutMode=function(){return Nt},y.__private__.setDisplayMode=y.setDisplayMode=function(t,e,r){return wt(t),At(e),Lt(r),this};var xt={title:"",subject:"",author:"",keywords:"",creator:""};y.__private__.getDocumentProperty=function(t){if(-1===Object.keys(xt).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return xt[t]},y.__private__.getDocumentProperties=function(){return xt},y.__private__.setDocumentProperties=y.setProperties=y.setDocumentProperties=function(t){for(var e in xt)xt.hasOwnProperty(e)&&t[e]&&(xt[e]=t[e]);return this},y.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(xt).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return xt[t]=e};var St,_t,Pt,kt,It,Ft={},Ct={},jt=[],Ot={},Bt={},Mt={},Et={},qt=null,Dt=0,Rt=[],Tt=new C(y),Ut=e.hotfixes||[],zt={},Ht={},Wt=[],Vt=function t(e,r,n,i,a,o){if(!(this instanceof t))return new t(e,r,n,i,a,o);isNaN(e)&&(e=1),isNaN(r)&&(r=0),isNaN(n)&&(n=0),isNaN(i)&&(i=1),isNaN(a)&&(a=0),isNaN(o)&&(o=0),this._matrix=[e,r,n,i,a,o];};Object.defineProperty(Vt.prototype,"sx",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t;}}),Object.defineProperty(Vt.prototype,"shy",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t;}}),Object.defineProperty(Vt.prototype,"shx",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t;}}),Object.defineProperty(Vt.prototype,"sy",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t;}}),Object.defineProperty(Vt.prototype,"tx",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t;}}),Object.defineProperty(Vt.prototype,"ty",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t;}}),Object.defineProperty(Vt.prototype,"a",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t;}}),Object.defineProperty(Vt.prototype,"b",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t;}}),Object.defineProperty(Vt.prototype,"c",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t;}}),Object.defineProperty(Vt.prototype,"d",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t;}}),Object.defineProperty(Vt.prototype,"e",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t;}}),Object.defineProperty(Vt.prototype,"f",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t;}}),Object.defineProperty(Vt.prototype,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(Vt.prototype,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(Vt.prototype,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(Vt.prototype,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),Vt.prototype.join=function(t){return [this.sx,this.shy,this.shx,this.sy,this.tx,this.ty].map(O).join(t)},Vt.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,r=t.sx*this.shy+t.shy*this.sy,n=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,a=t.tx*this.sx+t.ty*this.shx+this.tx,o=t.tx*this.shy+t.ty*this.sy+this.ty;return new Vt(e,r,n,i,a,o)},Vt.prototype.decompose=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=Math.sqrt(t*t+e*e),s=(t/=o)*r+(e/=o)*n;r-=t*s,n-=e*s;var c=Math.sqrt(r*r+n*n);return s/=c,t*(n/=c)<e*(r/=c)&&(t=-t,e=-e,s=-s,o=-o),{scale:new Vt(o,0,0,c,0,0),translate:new Vt(1,0,0,1,i,a),rotate:new Vt(t,e,-e,t,0,0),skew:new Vt(1,0,s,1,0,0)}},Vt.prototype.toString=function(t){return this.join(" ")},Vt.prototype.inversed=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=1/(t*n-e*r),s=n*o,c=-e*o,u=-r*o,h=t*o;return new Vt(s,c,u,h,-s*i-u*a,-c*i-h*a)},Vt.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,r=t.x*this.shy+t.y*this.sy+this.ty;return new Cr(e,r)},Vt.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),r=this.applyToPoint(new Cr(t.x+t.w,t.y+t.h));return new jr(e.x,e.y,r.x-e.x,r.y-e.y)},Vt.prototype.clone=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty;return new Vt(t,e,r,n,i,a)},y.Matrix=Vt;var Gt=y.matrixMult=function(t,e){return e.multiply(t)},Yt=new Vt(1,0,0,1,0,0);y.unitMatrix=y.identityMatrix=Yt;var Jt=function(t,e){if(!Bt[t]){var r=(e instanceof B?"Sh":"P")+(Object.keys(Ot).length+1).toString(10);e.id=r,Bt[t]=r,Ot[r]=e,Tt.publish("addPattern",e);}};y.ShadingPattern=B,y.TilingPattern=M,y.addShadingPattern=function(t,e){return q("addShadingPattern()"),Jt(t,e),this},y.beginTilingPattern=function(t){q("beginTilingPattern()"),Br(t.boundingBox[0],t.boundingBox[1],t.boundingBox[2]-t.boundingBox[0],t.boundingBox[3]-t.boundingBox[1],t.matrix);},y.endTilingPattern=function(t,e){q("endTilingPattern()"),e.stream=ot[$].join("\n"),Jt(t,e),Tt.publish("endTilingPattern",e),Wt.pop().restore();};var Xt=y.__private__.newObject=function(){var t=Kt();return Zt(t,!0),t},Kt=y.__private__.newObjectDeferred=function(){return et++,rt[et]=function(){return it},et},Zt=function(t,e){return e="boolean"==typeof e&&e,rt[t]=it,e&&lt(t+" 0 obj"),t},$t=y.__private__.newAdditionalObject=function(){var t={objId:Kt(),content:""};return at.push(t),t},Qt=Kt(),te=Kt(),ee=y.__private__.decodeColorString=function(t){var e=t.split(" ");if(2!==e.length||"g"!==e[1]&&"G"!==e[1]){if(5===e.length&&("k"===e[4]||"K"===e[4])){e=[(1-e[0])*(1-e[3]),(1-e[1])*(1-e[3]),(1-e[2])*(1-e[3]),"r"];}}else{var r=parseFloat(e[0]);e=[r,r,r,"r"];}for(var n="#",i=0;i<3;i++)n+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return n},re=y.__private__.encodeColorString=function(e){var r;"string"==typeof e&&(e={ch1:e});var n=e.ch1,i=e.ch2,a=e.ch3,o=e.ch4,s="draw"===e.pdfColorType?["G","RG","K"]:["g","rg","k"];if("string"==typeof n&&"#"!==n.charAt(0)){var c=new f$c(n);if(c.ok)n=c.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var u=parseInt(n.substr(1),16);n=u>>16&255,i=u>>8&255,a=255&u;}if(void 0===i||void 0===o&&n===i&&i===a)if("string"==typeof n)r=n+" "+s[0];else switch(e.precision){case 2:r=R(n/255)+" "+s[0];break;case 3:default:r=T(n/255)+" "+s[0];}else if(void 0===o||"object"===t(o)){if(o&&!isNaN(o.a)&&0===o.a)return r=["1.","1.","1.",s[1]].join(" ");if("string"==typeof n)r=[n,i,a,s[1]].join(" ");else switch(e.precision){case 2:r=[R(n/255),R(i/255),R(a/255),s[1]].join(" ");break;default:case 3:r=[T(n/255),T(i/255),T(a/255),s[1]].join(" ");}}else if("string"==typeof n)r=[n,i,a,o,s[2]].join(" ");else switch(e.precision){case 2:r=[R(n),R(i),R(a),R(o),s[2]].join(" ");break;case 3:default:r=[T(n),T(i),T(a),T(o),s[2]].join(" ");}return r},ne=y.__private__.getFilters=function(){return u},ie=y.__private__.putStream=function(t){var e=(t=t||{}).data||"",r=t.filters||ne(),n=t.alreadyAppliedFilters||[],i=t.addLength1||!1,a=e.length,o=t.objectId,s=function(t){return t};if(null!==m&&void 0===o)throw new Error("ObjectId must be passed to putStream for file encryption");null!==m&&(s=Ye.encryptor(o,0));var c={};!0===r&&(r=["FlateEncode"]);var u=t.additionalKeyValues||[],h=(c=void 0!==E.API.processDataByFilters?E.API.processDataByFilters(e,r):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(n)?n.join(" "):n.toString());if(0!==c.data.length&&(u.push({key:"Length",value:c.data.length}),!0===i&&u.push({key:"Length1",value:a})),0!=h.length)if(h.split("/").length-1==1)u.push({key:"Filter",value:h});else{u.push({key:"Filter",value:"["+h+"]"});for(var l=0;l<u.length;l+=1)if("DecodeParms"===u[l].key){for(var f=[],d=0;d<c.reverseChain.split("/").length-1;d+=1)f.push("null");f.push(u[l].value),u[l].value="["+f.join(" ")+"]";}}lt("<<");for(var p=0;p<u.length;p++)lt("/"+u[p].key+" "+u[p].value);lt(">>"),0!==c.data.length&&(lt("stream"),lt(s(c.data)),lt("endstream"));},ae=y.__private__.putPage=function(t){var e=t.number,r=t.data,n=t.objId,i=t.contentsObjId;Zt(n,!0),lt("<</Type /Page"),lt("/Parent "+t.rootDictionaryObjId+" 0 R"),lt("/Resources "+t.resourceDictionaryObjId+" 0 R"),lt("/MediaBox ["+parseFloat(O(t.mediaBox.bottomLeftX))+" "+parseFloat(O(t.mediaBox.bottomLeftY))+" "+O(t.mediaBox.topRightX)+" "+O(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&lt("/CropBox ["+O(t.cropBox.bottomLeftX)+" "+O(t.cropBox.bottomLeftY)+" "+O(t.cropBox.topRightX)+" "+O(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&lt("/BleedBox ["+O(t.bleedBox.bottomLeftX)+" "+O(t.bleedBox.bottomLeftY)+" "+O(t.bleedBox.topRightX)+" "+O(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&lt("/TrimBox ["+O(t.trimBox.bottomLeftX)+" "+O(t.trimBox.bottomLeftY)+" "+O(t.trimBox.topRightX)+" "+O(t.trimBox.topRightY)+"]"),null!==t.artBox&&lt("/ArtBox ["+O(t.artBox.bottomLeftX)+" "+O(t.artBox.bottomLeftY)+" "+O(t.artBox.topRightX)+" "+O(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&lt("/UserUnit "+t.userUnit),Tt.publish("putPage",{objId:n,pageContext:Rt[e],pageNumber:e,page:r}),lt("/Contents "+i+" 0 R"),lt(">>"),lt("endobj");var a=r.join("\n");return S===x.ADVANCED&&(a+="\nQ"),Zt(i,!0),ie({data:a,filters:ne(),objectId:i}),lt("endobj"),n},oe=y.__private__.putPages=function(){var t,e,r=[];for(t=1;t<=Dt;t++)Rt[t].objId=Kt(),Rt[t].contentsObjId=Kt();for(t=1;t<=Dt;t++)r.push(ae({number:t,data:ot[t],objId:Rt[t].objId,contentsObjId:Rt[t].contentsObjId,mediaBox:Rt[t].mediaBox,cropBox:Rt[t].cropBox,bleedBox:Rt[t].bleedBox,trimBox:Rt[t].trimBox,artBox:Rt[t].artBox,userUnit:Rt[t].userUnit,rootDictionaryObjId:Qt,resourceDictionaryObjId:te}));Zt(Qt,!0),lt("<</Type /Pages");var n="/Kids [";for(e=0;e<Dt;e++)n+=r[e]+" 0 R ";lt(n+"]"),lt("/Count "+Dt),lt(">>"),lt("endobj"),Tt.publish("postPutPages");},se=function(t){Tt.publish("putFont",{font:t,out:lt,newObject:Xt,putStream:ie}),!0!==t.isAlreadyPutted&&(t.objectNumber=Xt(),lt("<<"),lt("/Type /Font"),lt("/BaseFont /"+F(t.postScriptName)),lt("/Subtype /Type1"),"string"==typeof t.encoding&&lt("/Encoding /"+t.encoding),lt("/FirstChar 32"),lt("/LastChar 255"),lt(">>"),lt("endobj"));},ce=function(){for(var t in Ft)Ft.hasOwnProperty(t)&&(!1===v||!0===v&&b.hasOwnProperty(t))&&se(Ft[t]);},ue=function(t){t.objectNumber=Xt();var e=[];e.push({key:"Type",value:"/XObject"}),e.push({key:"Subtype",value:"/Form"}),e.push({key:"BBox",value:"["+[O(t.x),O(t.y),O(t.x+t.width),O(t.y+t.height)].join(" ")+"]"}),e.push({key:"Matrix",value:"["+t.matrix.toString()+"]"});var r=t.pages[1].join("\n");ie({data:r,additionalKeyValues:e,objectId:t.objectNumber}),lt("endobj");},he=function(){for(var t in zt)zt.hasOwnProperty(t)&&ue(zt[t]);},le=function(t,e){var r,n=[],i=1/(e-1);for(r=0;r<1;r+=i)n.push(r);if(n.push(1),0!=t[0].offset){var a={offset:0,color:t[0].color};t.unshift(a);}if(1!=t[t.length-1].offset){var o={offset:1,color:t[t.length-1].color};t.push(o);}for(var s="",c=0,u=0;u<n.length;u++){for(r=n[u];r>t[c+1].offset;)c++;var h=t[c].offset,l=(r-h)/(t[c+1].offset-h),f=t[c].color,d=t[c+1].color;s+=tt(Math.round((1-l)*f[0]+l*d[0]).toString(16))+tt(Math.round((1-l)*f[1]+l*d[1]).toString(16))+tt(Math.round((1-l)*f[2]+l*d[2]).toString(16));}return s.trim()},fe=function(t,e){e||(e=21);var r=Xt(),n=le(t.colors,e),i=[];i.push({key:"FunctionType",value:"0"}),i.push({key:"Domain",value:"[0.0 1.0]"}),i.push({key:"Size",value:"["+e+"]"}),i.push({key:"BitsPerSample",value:"8"}),i.push({key:"Range",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),i.push({key:"Decode",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),ie({data:n,additionalKeyValues:i,alreadyAppliedFilters:["/ASCIIHexDecode"],objectId:r}),lt("endobj"),t.objectNumber=Xt(),lt("<< /ShadingType "+t.type),lt("/ColorSpace /DeviceRGB");var a="/Coords ["+O(parseFloat(t.coords[0]))+" "+O(parseFloat(t.coords[1]))+" ";2===t.type?a+=O(parseFloat(t.coords[2]))+" "+O(parseFloat(t.coords[3])):a+=O(parseFloat(t.coords[2]))+" "+O(parseFloat(t.coords[3]))+" "+O(parseFloat(t.coords[4]))+" "+O(parseFloat(t.coords[5])),lt(a+="]"),t.matrix&&lt("/Matrix ["+t.matrix.toString()+"]"),lt("/Function "+r+" 0 R"),lt("/Extend [true true]"),lt(">>"),lt("endobj");},de=function(t,e){var r=Kt(),n=Xt();e.push({resourcesOid:r,objectOid:n}),t.objectNumber=n;var i=[];i.push({key:"Type",value:"/Pattern"}),i.push({key:"PatternType",value:"1"}),i.push({key:"PaintType",value:"1"}),i.push({key:"TilingType",value:"1"}),i.push({key:"BBox",value:"["+t.boundingBox.map(O).join(" ")+"]"}),i.push({key:"XStep",value:O(t.xStep)}),i.push({key:"YStep",value:O(t.yStep)}),i.push({key:"Resources",value:r+" 0 R"}),t.matrix&&i.push({key:"Matrix",value:"["+t.matrix.toString()+"]"}),ie({data:t.stream,additionalKeyValues:i,objectId:t.objectNumber}),lt("endobj");},pe=function(t){var e;for(e in Ot)Ot.hasOwnProperty(e)&&(Ot[e]instanceof B?fe(Ot[e]):Ot[e]instanceof M&&de(Ot[e],t));},ge=function(t){for(var e in t.objectNumber=Xt(),lt("<<"),t)switch(e){case"opacity":lt("/ca "+R(t[e]));break;case"stroke-opacity":lt("/CA "+R(t[e]));}lt(">>"),lt("endobj");},me=function(){var t;for(t in Mt)Mt.hasOwnProperty(t)&&ge(Mt[t]);},ve=function(){for(var t in lt("/XObject <<"),zt)zt.hasOwnProperty(t)&&zt[t].objectNumber>=0&&lt("/"+t+" "+zt[t].objectNumber+" 0 R");Tt.publish("putXobjectDict"),lt(">>");},be=function(){Ye.oid=Xt(),lt("<<"),lt("/Filter /Standard"),lt("/V "+Ye.v),lt("/R "+Ye.r),lt("/U <"+Ye.toHexString(Ye.U)+">"),lt("/O <"+Ye.toHexString(Ye.O)+">"),lt("/P "+Ye.P),lt(">>"),lt("endobj");},ye=function(){for(var t in lt("/Font <<"),Ft)Ft.hasOwnProperty(t)&&(!1===v||!0===v&&b.hasOwnProperty(t))&&lt("/"+t+" "+Ft[t].objectNumber+" 0 R");lt(">>");},we=function(){if(Object.keys(Ot).length>0){for(var t in lt("/Shading <<"),Ot)Ot.hasOwnProperty(t)&&Ot[t]instanceof B&&Ot[t].objectNumber>=0&&lt("/"+t+" "+Ot[t].objectNumber+" 0 R");Tt.publish("putShadingPatternDict"),lt(">>");}},Ne=function(t){if(Object.keys(Ot).length>0){for(var e in lt("/Pattern <<"),Ot)Ot.hasOwnProperty(e)&&Ot[e]instanceof y.TilingPattern&&Ot[e].objectNumber>=0&&Ot[e].objectNumber<t&&lt("/"+e+" "+Ot[e].objectNumber+" 0 R");Tt.publish("putTilingPatternDict"),lt(">>");}},Le=function(){if(Object.keys(Mt).length>0){var t;for(t in lt("/ExtGState <<"),Mt)Mt.hasOwnProperty(t)&&Mt[t].objectNumber>=0&&lt("/"+t+" "+Mt[t].objectNumber+" 0 R");Tt.publish("putGStateDict"),lt(">>");}},Ae=function(t){Zt(t.resourcesOid,!0),lt("<<"),lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),ye(),we(),Ne(t.objectOid),Le(),ve(),lt(">>"),lt("endobj");},xe=function(){var t=[];ce(),me(),he(),pe(t),Tt.publish("putResources"),t.forEach(Ae),Ae({resourcesOid:te,objectOid:Number.MAX_SAFE_INTEGER}),Tt.publish("postPutResources");},Se=function(){Tt.publish("putAdditionalObjects");for(var t=0;t<at.length;t++){var e=at[t];Zt(e.objId,!0),lt(e.content),lt("endobj");}Tt.publish("postPutAdditionalObjects");},_e=function(t){Ct[t.fontName]=Ct[t.fontName]||{},Ct[t.fontName][t.fontStyle]=t.id;},Pe=function(t,e,r,n,i){var a={id:"F"+(Object.keys(Ft).length+1).toString(10),postScriptName:t,fontName:e,fontStyle:r,encoding:n,isStandardFont:i||!1,metadata:{}};return Tt.publish("addFont",{font:a,instance:this}),Ft[a.id]=a,_e(a),a.id},ke=function(t){for(var e=0,r=pt.length;e<r;e++){var n=Pe.call(this,t[e][0],t[e][1],t[e][2],pt[e][3],!0);!1===v&&(b[n]=!0);var i=t[e][0].split("-");_e({id:n,fontName:i[0],fontStyle:i[1]||""});}Tt.publish("addFonts",{fonts:Ft,dictionary:Ct});},Ie=function(t){return t.foo=function(){try{return t.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var r="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!n.console)throw new Error(r);n.console.error(r,t),n.alert&&alert(r);}},t.foo.bar=t,t.foo},Fe=function(t,e){var r,n,i,a,o,s,c,u,h;if(i=(e=e||{}).sourceEncoding||"Unicode",o=e.outputEncoding,(e.autoencode||o)&&Ft[St].metadata&&Ft[St].metadata[i]&&Ft[St].metadata[i].encoding&&(a=Ft[St].metadata[i].encoding,!o&&Ft[St].encoding&&(o=Ft[St].encoding),!o&&a.codePages&&(o=a.codePages[0]),"string"==typeof o&&(o=a[o]),o)){for(c=!1,s=[],r=0,n=t.length;r<n;r++)(u=o[t.charCodeAt(r)])?s.push(String.fromCharCode(u)):s.push(t[r]),s[r].charCodeAt(0)>>8&&(c=!0);t=s.join("");}for(r=t.length;void 0===c&&0!==r;)t.charCodeAt(r-1)>>8&&(c=!0),r--;if(!c)return t;for(s=e.noBOM?[]:[254,255],r=0,n=t.length;r<n;r++){if((h=(u=t.charCodeAt(r))>>8)>>8)throw new Error("Character at position "+r+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(h),s.push(u-(h<<8));}return String.fromCharCode.apply(void 0,s)},Ce=y.__private__.pdfEscape=y.pdfEscape=function(t,e){return Fe(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},je=y.__private__.beginPage=function(t){ot[++Dt]=[],Rt[Dt]={objId:0,contentsObjId:0,userUnit:Number(d),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t[0]),topRightY:Number(t[1])}},Me(Dt),ht(ot[$]);},Oe=function(t,e){var r,n,o;switch(i=e||i,"string"==typeof t&&(r=A(t.toLowerCase()),Array.isArray(r)&&(n=r[0],o=r[1])),Array.isArray(t)&&(n=t[0]*_t,o=t[1]*_t),isNaN(n)&&(n=s[0],o=s[1]),(n>14400||o>14400)&&(a.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),n=Math.min(14400,n),o=Math.min(14400,o)),s=[n,o],i.substr(0,1)){case"l":o>n&&(s=[o,n]);break;case"p":n>o&&(s=[o,n]);}je(s),pr(fr),lt(Lr),0!==kr&&lt(kr+" J"),0!==Ir&&lt(Ir+" j"),Tt.publish("addPage",{pageNumber:Dt});},Be=function(t){t>0&&t<=Dt&&(ot.splice(t,1),Rt.splice(t,1),Dt--,$>Dt&&($=Dt),this.setPage($));},Me=function(t){t>0&&t<=Dt&&($=t);},Ee=y.__private__.getNumberOfPages=y.getNumberOfPages=function(){return ot.length-1},qe=function(t,e,r){var n,i=void 0;return r=r||{},t=void 0!==t?t:Ft[St].fontName,e=void 0!==e?e:Ft[St].fontStyle,n=t.toLowerCase(),void 0!==Ct[n]&&void 0!==Ct[n][e]?i=Ct[n][e]:void 0!==Ct[t]&&void 0!==Ct[t][e]?i=Ct[t][e]:!1===r.disableWarning&&a.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||r.noFallback||null==(i=Ct.times[e])&&(i=Ct.times.normal),i},De=y.__private__.putInfo=function(){var t=Xt(),e=function(t){return t};for(var r in null!==m&&(e=Ye.encryptor(t,0)),lt("<<"),lt("/Producer ("+Ce(e("jsPDF "+E.version))+")"),xt)xt.hasOwnProperty(r)&&xt[r]&&lt("/"+r.substr(0,1).toUpperCase()+r.substr(1)+" ("+Ce(e(xt[r]))+")");lt("/CreationDate ("+Ce(e(W))+")"),lt(">>"),lt("endobj");},Re=y.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||Qt;switch(Xt(),lt("<<"),lt("/Type /Catalog"),lt("/Pages "+e+" 0 R"),mt||(mt="fullwidth"),mt){case"fullwidth":lt("/OpenAction [3 0 R /FitH null]");break;case"fullheight":lt("/OpenAction [3 0 R /FitV null]");break;case"fullpage":lt("/OpenAction [3 0 R /Fit]");break;case"original":lt("/OpenAction [3 0 R /XYZ null null 1]");break;default:var r=""+mt;"%"===r.substr(r.length-1)&&(mt=parseInt(mt)/100),"number"==typeof mt&&lt("/OpenAction [3 0 R /XYZ null null "+R(mt)+"]");}switch(Nt||(Nt="continuous"),Nt){case"continuous":lt("/PageLayout /OneColumn");break;case"single":lt("/PageLayout /SinglePage");break;case"two":case"twoleft":lt("/PageLayout /TwoColumnLeft");break;case"tworight":lt("/PageLayout /TwoColumnRight");}yt&&lt("/PageMode /"+yt),Tt.publish("putCatalog"),lt(">>"),lt("endobj");},Te=y.__private__.putTrailer=function(){lt("trailer"),lt("<<"),lt("/Size "+(et+1)),lt("/Root "+et+" 0 R"),lt("/Info "+(et-1)+" 0 R"),null!==m&&lt("/Encrypt "+Ye.oid+" 0 R"),lt("/ID [ <"+V+"> <"+V+"> ]"),lt(">>");},Ue=y.__private__.putHeader=function(){lt("%PDF-"+w),lt("%ºß¬à");},ze=y.__private__.putXRef=function(){var t="0000000000";lt("xref"),lt("0 "+(et+1)),lt("0000000000 65535 f ");for(var e=1;e<=et;e++){"function"==typeof rt[e]?lt((t+rt[e]()).slice(-10)+" 00000 n "):void 0!==rt[e]?lt((t+rt[e]).slice(-10)+" 00000 n "):lt("0000000000 00000 n ");}},He=y.__private__.buildDocument=function(){ut(),ht(nt),Tt.publish("buildDocument"),Ue(),oe(),Se(),xe(),null!==m&&be(),De(),Re();var t=it;return ze(),Te(),lt("startxref"),lt(""+t),lt("%%EOF"),ht(ot[$]),nt.join("\n")},We=y.__private__.getBlob=function(t){return new Blob([dt(t)],{type:"application/pdf"})},Ve=y.output=y.__private__.output=Ie((function(t,e){switch("string"==typeof(e=e||{})?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return He();case"save":y.save(e.filename);break;case"arraybuffer":return dt(He());case"blob":return We(He());case"bloburi":case"bloburl":if(void 0!==n.URL&&"function"==typeof n.URL.createObjectURL)return n.URL&&n.URL.createObjectURL(We(He()))||void 0;a.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":var r="",i=He();try{r=h(i);}catch(t){r=h(unescape(encodeURIComponent(i)));}return "data:application/pdf;filename="+e.filename+";base64,"+r;case"pdfobjectnewwindow":if("[object Window]"===Object.prototype.toString.call(n)){var o="https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js",s=' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';e.pdfObjectUrl&&(o=e.pdfObjectUrl,s="");var c='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="'+o+'"'+s+'><\/script><script >PDFObject.embed("'+this.output("dataurlstring")+'", '+JSON.stringify(e)+");<\/script></body></html>",u=n.open();return null!==u&&u.document.write(c),u}throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");case"pdfjsnewwindow":if("[object Window]"===Object.prototype.toString.call(n)){var l='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="'+(e.pdfJsUrl||"examples/PDF.js/web/viewer.html")+"?file=&downloadName="+e.filename+'" width="500px" height="400px" /></body></html>',f=n.open();if(null!==f){f.document.write(l);var d=this;f.document.documentElement.querySelector("#pdfViewer").onload=function(){f.document.title=e.filename,f.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(d.output("bloburl"));};}return f}throw new Error("The option pdfjsnewwindow just works in a browser-environment.");case"dataurlnewwindow":if("[object Window]"!==Object.prototype.toString.call(n))throw new Error("The option dataurlnewwindow just works in a browser-environment.");var p='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring",e)+'"></iframe></body></html>',g=n.open();if(null!==g&&(g.document.write(p),g.document.title=e.filename),g||"undefined"==typeof safari)return g;break;case"datauri":case"dataurl":return n.document.location.href=this.output("datauristring",e);default:return null}})),Ge=function(t){return !0===Array.isArray(Ut)&&Ut.indexOf(t)>-1};switch(o){case"pt":_t=1;break;case"mm":_t=72/25.4;break;case"cm":_t=72/2.54;break;case"in":_t=72;break;case"px":_t=1==Ge("px_scaling")?.75:96/72;break;case"pc":case"em":_t=12;break;case"ex":_t=6;break;default:if("number"!=typeof o)throw new Error("Invalid unit: "+o);_t=o;}var Ye=null;K(),Y();var Je=function(t){return null!==m?Ye.encryptor(t,0):function(t){return t}},Xe=y.__private__.getPageInfo=y.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return {objId:Rt[t].objId,pageNumber:t,pageContext:Rt[t]}},Ke=y.__private__.getPageInfoByObjId=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");for(var e in Rt)if(Rt[e].objId===t)break;return Xe(e)},Ze=y.__private__.getCurrentPageInfo=y.getCurrentPageInfo=function(){return {objId:Rt[$].objId,pageNumber:$,pageContext:Rt[$]}};y.addPage=function(){return Oe.apply(this,arguments),this},y.setPage=function(){return Me.apply(this,arguments),ht.call(this,ot[$]),this},y.insertPage=function(t){return this.addPage(),this.movePage($,t),this},y.movePage=function(t,e){var r,n;if(t>e){r=ot[t],n=Rt[t];for(var i=t;i>e;i--)ot[i]=ot[i-1],Rt[i]=Rt[i-1];ot[e]=r,Rt[e]=n,this.setPage(e);}else if(t<e){r=ot[t],n=Rt[t];for(var a=t;a<e;a++)ot[a]=ot[a+1],Rt[a]=Rt[a+1];ot[e]=r,Rt[e]=n,this.setPage(e);}return this},y.deletePage=function(){return Be.apply(this,arguments),this},y.__private__.text=y.text=function(e,r,n,i,a){var o,s,c,u,h,l,f,d,p,g=(i=i||{}).scope||this;if("number"==typeof e&&"number"==typeof r&&("string"==typeof n||Array.isArray(n))){var m=n;n=r,r=e,e=m;}if(arguments[3]instanceof Vt==!1?(c=arguments[4],u=arguments[5],"object"===t(f=arguments[3])&&null!==f||("string"==typeof c&&(u=c,c=null),"string"==typeof f&&(u=f,f=null),"number"==typeof f&&(c=f,f=null),i={flags:f,angle:c,align:u})):(q("The transform parameter of text() with a Matrix value"),p=a),isNaN(r)||isNaN(n)||null==e)throw new Error("Invalid arguments passed to jsPDF.text");if(0===e.length)return g;var v="",y=!1,w="number"==typeof i.lineHeightFactor?i.lineHeightFactor:lr,N=g.internal.scaleFactor;function L(t){return t=t.split("\t").join(Array(i.TabLen||9).join(" ")),Ce(t,f)}function A(t){for(var e,r=t.concat(),n=[],i=r.length;i--;)"string"==typeof(e=r.shift())?n.push(e):Array.isArray(t)&&(1===e.length||void 0===e[1]&&void 0===e[2])?n.push(e[0]):n.push([e[0],e[1],e[2]]);return n}function _(t,e){var r;if("string"==typeof t)r=e(t)[0];else if(Array.isArray(t)){for(var n,i,a=t.concat(),o=[],s=a.length;s--;)"string"==typeof(n=a.shift())?o.push(e(n)[0]):Array.isArray(n)&&"string"==typeof n[0]&&(i=e(n[0],n[1],n[2]),o.push([i[0],i[1],i[2]]));r=o;}return r}var P=!1,k=!0;if("string"==typeof e)P=!0;else if(Array.isArray(e)){var I=e.concat();s=[];for(var F,C=I.length;C--;)("string"!=typeof(F=I.shift())||Array.isArray(F)&&"string"!=typeof F[0])&&(k=!1);P=k;}if(!1===P)throw new Error('Type of text must be string or Array. "'+e+'" is not recognized.');"string"==typeof e&&(e=e.match(/[\r?\n]/)?e.split(/\r\n|\r|\n/g):[e]);var j=gt/g.internal.scaleFactor,B=j*(w-1);switch(i.baseline){case"bottom":n-=B;break;case"top":n+=j-B;break;case"hanging":n+=j-2*B;break;case"middle":n+=j/2-B;}if((l=i.maxWidth||0)>0&&("string"==typeof e?e=g.splitTextToSize(e,l):"[object Array]"===Object.prototype.toString.call(e)&&(e=e.reduce((function(t,e){return t.concat(g.splitTextToSize(e,l))}),[]))),o={text:e,x:r,y:n,options:i,mutex:{pdfEscape:Ce,activeFontKey:St,fonts:Ft,activeFontSize:gt}},Tt.publish("preProcessText",o),e=o.text,c=(i=o.options).angle,p instanceof Vt==!1&&c&&"number"==typeof c){c*=Math.PI/180,0===i.rotationDirection&&(c=-c),S===x.ADVANCED&&(c=-c);var M=Math.cos(c),E=Math.sin(c);p=new Vt(M,E,-E,M,0,0);}else c&&c instanceof Vt&&(p=c);S!==x.ADVANCED||p||(p=Yt),void 0!==(h=i.charSpace||_r)&&(v+=O(U(h))+" Tc\n",this.setCharSpace(this.getCharSpace()||0)),void 0!==(d=i.horizontalScale)&&(v+=O(100*d)+" Tz\n");i.lang;var D=-1,R=void 0!==i.renderingMode?i.renderingMode:i.stroke,T=g.internal.getCurrentPageInfo().pageContext;switch(R){case 0:case!1:case"fill":D=0;break;case 1:case!0:case"stroke":D=1;break;case 2:case"fillThenStroke":D=2;break;case 3:case"invisible":D=3;break;case 4:case"fillAndAddForClipping":D=4;break;case 5:case"strokeAndAddPathForClipping":D=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":D=6;break;case 7:case"addToPathForClipping":D=7;}var z=void 0!==T.usedRenderingMode?T.usedRenderingMode:-1;-1!==D?v+=D+" Tr\n":-1!==z&&(v+="0 Tr\n"),-1!==D&&(T.usedRenderingMode=D),u=i.align||"left";var H,W=gt*w,V=g.internal.pageSize.getWidth(),G=Ft[St];h=i.charSpace||_r,l=i.maxWidth||0,f=Object.assign({autoencode:!0,noBOM:!0},i.flags);var Y=[];if("[object Array]"===Object.prototype.toString.call(e)){var J;s=A(e),"left"!==u&&(H=s.map((function(t){return g.getStringUnitWidth(t,{font:G,charSpace:h,fontSize:gt,doKerning:!1})*gt/N})));var X,K=0;if("right"===u){r-=H[0],e=[],C=s.length;for(var Z=0;Z<C;Z++)0===Z?(X=br(r),J=yr(n)):(X=U(K-H[Z]),J=-W),e.push([s[Z],X,J]),K=H[Z];}else if("center"===u){r-=H[0]/2,e=[],C=s.length;for(var $=0;$<C;$++)0===$?(X=br(r),J=yr(n)):(X=U((K-H[$])/2),J=-W),e.push([s[$],X,J]),K=H[$];}else if("left"===u){e=[],C=s.length;for(var Q=0;Q<C;Q++)e.push(s[Q]);}else{if("justify"!==u)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');e=[],C=s.length,l=0!==l?l:V;for(var tt=0;tt<C;tt++)J=0===tt?yr(n):-W,X=0===tt?br(r):0,tt<C-1?Y.push(O(U((l-H[tt])/(s[tt].split(" ").length-1)))):Y.push(0),e.push([s[tt],X,J]);}}var et="boolean"==typeof i.R2L?i.R2L:bt;!0===et&&(e=_(e,(function(t,e,r){return [t.split("").reverse().join(""),e,r]}))),o={text:e,x:r,y:n,options:i,mutex:{pdfEscape:Ce,activeFontKey:St,fonts:Ft,activeFontSize:gt}},Tt.publish("postProcessText",o),e=o.text,y=o.mutex.isHex||!1;var rt=Ft[St].encoding;"WinAnsiEncoding"!==rt&&"StandardEncoding"!==rt||(e=_(e,(function(t,e,r){return [L(t),e,r]}))),s=A(e),e=[];for(var nt,it,at,ot=0,st=1,ct=Array.isArray(s[0])?st:ot,ut="",ht=function(t,e,r){var n="";return r instanceof Vt?(r="number"==typeof i.angle?Gt(r,new Vt(1,0,0,1,t,e)):Gt(new Vt(1,0,0,1,t,e),r),S===x.ADVANCED&&(r=Gt(new Vt(1,0,0,-1,0,0),r)),n=r.join(" ")+" Tm\n"):n=O(t)+" "+O(e)+" Td\n",n},ft=0;ft<s.length;ft++){switch(ut="",ct){case st:at=(y?"<":"(")+s[ft][0]+(y?">":")"),nt=parseFloat(s[ft][1]),it=parseFloat(s[ft][2]);break;case ot:at=(y?"<":"(")+s[ft]+(y?">":")"),nt=br(r),it=yr(n);}void 0!==Y&&void 0!==Y[ft]&&(ut=Y[ft]+" Tw\n"),0===ft?e.push(ut+ht(nt,it,p)+at):ct===ot?e.push(ut+at):ct===st&&e.push(ut+ht(nt,it,p)+at);}e=ct===ot?e.join(" Tj\nT* "):e.join(" Tj\n"),e+=" Tj\n";var dt="BT\n/";return dt+=St+" "+gt+" Tf\n",dt+=O(gt*w)+" TL\n",dt+=xr+"\n",dt+=v,dt+=e,lt(dt+="ET"),b[St]=!0,g};var $e=y.__private__.clip=y.clip=function(t){return lt("evenodd"===t?"W*":"W"),this};y.clipEvenOdd=function(){return $e("evenodd")},y.__private__.discardPath=y.discardPath=function(){return lt("n"),this};var Qe=y.__private__.isValidStyle=function(t){var e=!1;return -1!==[void 0,null,"S","D","F","DF","FD","f","f*","B","B*","n"].indexOf(t)&&(e=!0),e};y.__private__.setDefaultPathOperation=y.setDefaultPathOperation=function(t){return Qe(t)&&(g=t),this};var tr=y.__private__.getStyle=y.getStyle=function(t){var e=g;switch(t){case"D":case"S":e="S";break;case"F":e="f";break;case"FD":case"DF":e="B";break;case"f":case"f*":case"B":case"B*":e=t;}return e},er=y.close=function(){return lt("h"),this};y.stroke=function(){return lt("S"),this},y.fill=function(t){return rr("f",t),this},y.fillEvenOdd=function(t){return rr("f*",t),this},y.fillStroke=function(t){return rr("B",t),this},y.fillStrokeEvenOdd=function(t){return rr("B*",t),this};var rr=function(e,r){"object"===t(r)?ar(r,e):lt(e);},nr=function(t){null===t||S===x.ADVANCED&&void 0===t||(t=tr(t),lt(t));};function ir(t,e,r,n,i){var a=new M(e||this.boundingBox,r||this.xStep,n||this.yStep,this.gState,i||this.matrix);a.stream=this.stream;var o=t+"$$"+this.cloneIndex+++"$$";return Jt(o,a),a}var ar=function(t,e){var r=Bt[t.key],n=Ot[r];if(n instanceof B)lt("q"),lt(or(e)),n.gState&&y.setGState(n.gState),lt(t.matrix.toString()+" cm"),lt("/"+r+" sh"),lt("Q");else if(n instanceof M){var i=new Vt(1,0,0,-1,0,Rr());t.matrix&&(i=i.multiply(t.matrix||Yt),r=ir.call(n,t.key,t.boundingBox,t.xStep,t.yStep,i).id),lt("q"),lt("/Pattern cs"),lt("/"+r+" scn"),n.gState&&y.setGState(n.gState),lt(e),lt("Q");}},or=function(t){switch(t){case"f":case"F":return "W n";case"f*":return "W* n";case"B":return "W S";case"B*":return "W* S";case"S":return "W S";case"n":return "W n"}},sr=y.moveTo=function(t,e){return lt(O(U(t))+" "+O(H(e))+" m"),this},cr=y.lineTo=function(t,e){return lt(O(U(t))+" "+O(H(e))+" l"),this},ur=y.curveTo=function(t,e,r,n,i,a){return lt([O(U(t)),O(H(e)),O(U(r)),O(H(n)),O(U(i)),O(H(a)),"c"].join(" ")),this};y.__private__.line=y.line=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.line");return S===x.COMPAT?this.lines([[r-t,n-e]],t,e,[1,1],i||"S"):this.lines([[r-t,n-e]],t,e,[1,1]).stroke()},y.__private__.lines=y.lines=function(t,e,r,n,i,a){var o,s,c,u,h,l,f,d,p,g,m,v;if("number"==typeof t&&(v=r,r=e,e=t,t=v),n=n||[1,1],a=a||!1,isNaN(e)||isNaN(r)||!Array.isArray(t)||!Array.isArray(n)||!Qe(i)||"boolean"!=typeof a)throw new Error("Invalid arguments passed to jsPDF.lines");for(sr(e,r),o=n[0],s=n[1],u=t.length,g=e,m=r,c=0;c<u;c++)2===(h=t[c]).length?(g=h[0]*o+g,m=h[1]*s+m,cr(g,m)):(l=h[0]*o+g,f=h[1]*s+m,d=h[2]*o+g,p=h[3]*s+m,g=h[4]*o+g,m=h[5]*s+m,ur(l,f,d,p,g,m));return a&&er(),nr(i),this},y.path=function(t){for(var e=0;e<t.length;e++){var r=t[e],n=r.c;switch(r.op){case"m":sr(n[0],n[1]);break;case"l":cr(n[0],n[1]);break;case"c":ur.apply(this,n);break;case"h":er();}}return this},y.__private__.rect=y.rect=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.rect");return S===x.COMPAT&&(n=-n),lt([O(U(t)),O(H(e)),O(U(r)),O(U(n)),"re"].join(" ")),nr(i),this},y.__private__.triangle=y.triangle=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Qe(o))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[r-t,n-e],[i-r,a-n],[t-i,e-a]],t,e,[1,1],o,!0),this},y.__private__.roundedRect=y.roundedRect=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Qe(o))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return i=Math.min(i,.5*r),a=Math.min(a,.5*n),this.lines([[r-2*i,0],[i*s,0,i,a-a*s,i,a],[0,n-2*a],[0,a*s,-i*s,a,-i,a],[2*i-r,0],[-i*s,0,-i,-a*s,-i,-a],[0,2*a-n],[0,-a*s,i*s,-a,i,-a]],t+i,e,[1,1],o,!0),this},y.__private__.ellipse=y.ellipse=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var a=4/3*(Math.SQRT2-1)*r,o=4/3*(Math.SQRT2-1)*n;return sr(t+r,e),ur(t+r,e-o,t+a,e-n,t,e-n),ur(t-a,e-n,t-r,e-o,t-r,e),ur(t-r,e+o,t-a,e+n,t,e+n),ur(t+a,e+n,t+r,e+o,t+r,e),nr(i),this},y.__private__.circle=y.circle=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||!Qe(n))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,r,r,n)},y.setFont=function(t,e,r){return r&&(e=k(e,r)),St=qe(t,e,{disableWarning:!1}),this};var hr=y.__private__.getFont=y.getFont=function(){return Ft[qe.apply(y,arguments)]};y.__private__.getFontList=y.getFontList=function(){var t,e,r={};for(t in Ct)if(Ct.hasOwnProperty(t))for(e in r[t]=[],Ct[t])Ct[t].hasOwnProperty(e)&&r[t].push(e);return r},y.addFont=function(t,e,r,n,i){var a=["StandardEncoding","MacRomanEncoding","Identity-H","WinAnsiEncoding"];return arguments[3]&&-1!==a.indexOf(arguments[3])?i=arguments[3]:arguments[3]&&-1==a.indexOf(arguments[3])&&(r=k(r,n)),i=i||"Identity-H",Pe.call(this,t,e,r,i)};var lr,fr=e.lineWidth||.200025,dr=y.__private__.getLineWidth=y.getLineWidth=function(){return fr},pr=y.__private__.setLineWidth=y.setLineWidth=function(t){return fr=t,lt(O(U(t))+" w"),this};y.__private__.setLineDash=E.API.setLineDash=E.API.setLineDashPattern=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map((function(t){return O(U(t))})).join(" "),e=O(U(e)),lt("["+t+"] "+e+" d"),this};var gr=y.__private__.getLineHeight=y.getLineHeight=function(){return gt*lr};y.__private__.getLineHeight=y.getLineHeight=function(){return gt*lr};var mr=y.__private__.setLineHeightFactor=y.setLineHeightFactor=function(t){return "number"==typeof(t=t||1.15)&&(lr=t),this},vr=y.__private__.getLineHeightFactor=y.getLineHeightFactor=function(){return lr};mr(e.lineHeight);var br=y.__private__.getHorizontalCoordinate=function(t){return U(t)},yr=y.__private__.getVerticalCoordinate=function(t){return S===x.ADVANCED?t:Rt[$].mediaBox.topRightY-Rt[$].mediaBox.bottomLeftY-U(t)},wr=y.__private__.getHorizontalCoordinateString=y.getHorizontalCoordinateString=function(t){return O(br(t))},Nr=y.__private__.getVerticalCoordinateString=y.getVerticalCoordinateString=function(t){return O(yr(t))},Lr=e.strokeColor||"0 G";y.__private__.getStrokeColor=y.getDrawColor=function(){return ee(Lr)},y.__private__.setStrokeColor=y.setDrawColor=function(t,e,r,n){return Lr=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"draw",precision:2}),lt(Lr),this};var Ar=e.fillColor||"0 g";y.__private__.getFillColor=y.getFillColor=function(){return ee(Ar)},y.__private__.setFillColor=y.setFillColor=function(t,e,r,n){return Ar=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"fill",precision:2}),lt(Ar),this};var xr=e.textColor||"0 g",Sr=y.__private__.getTextColor=y.getTextColor=function(){return ee(xr)};y.__private__.setTextColor=y.setTextColor=function(t,e,r,n){return xr=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"text",precision:3}),this};var _r=e.charSpace,Pr=y.__private__.getCharSpace=y.getCharSpace=function(){return parseFloat(_r||0)};y.__private__.setCharSpace=y.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return _r=t,this};var kr=0;y.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},y.__private__.setLineCap=y.setLineCap=function(t){var e=y.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return kr=e,lt(e+" J"),this};var Ir=0;y.__private__.setLineJoin=y.setLineJoin=function(t){var e=y.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return Ir=e,lt(e+" j"),this},y.__private__.setLineMiterLimit=y.__private__.setMiterLimit=y.setLineMiterLimit=y.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");return lt(O(U(t))+" M"),this},y.GState=j$2,y.setGState=function(t){(t="string"==typeof t?Mt[Et[t]]:Fr(null,t)).equals(qt)||(lt("/"+t.id+" gs"),qt=t);};var Fr=function(t,e){if(!t||!Et[t]){var r=!1;for(var n in Mt)if(Mt.hasOwnProperty(n)&&Mt[n].equals(e)){r=!0;break}if(r)e=Mt[n];else{var i="GS"+(Object.keys(Mt).length+1).toString(10);Mt[i]=e,e.id=i;}return t&&(Et[t]=e.id),Tt.publish("addGState",e),e}};y.addGState=function(t,e){return Fr(t,e),this},y.saveGraphicsState=function(){return lt("q"),jt.push({key:St,size:gt,color:xr}),this},y.restoreGraphicsState=function(){lt("Q");var t=jt.pop();return St=t.key,gt=t.size,xr=t.color,qt=null,this},y.setCurrentTransformationMatrix=function(t){return lt(t.toString()+" cm"),this},y.comment=function(t){return lt("#"+t),this};var Cr=function(t,e){var r=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t));}});var n=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t));}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString();}}),this},jr=function(t,e,r,n){Cr.call(this,t,e),this.type="rect";var i=r||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t));}});var a=n||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return a},set:function(t){isNaN(t)||(a=parseFloat(t));}}),this},Or=function(){this.page=Dt,this.currentPage=$,this.pages=ot.slice(0),this.pagesContext=Rt.slice(0),this.x=Pt,this.y=kt,this.matrix=It,this.width=qr($),this.height=Rr($),this.outputDestination=ct,this.id="",this.objectNumber=-1;};Or.prototype.restore=function(){Dt=this.page,$=this.currentPage,Rt=this.pagesContext,ot=this.pages,Pt=this.x,kt=this.y,It=this.matrix,Dr($,this.width),Tr($,this.height),ct=this.outputDestination;};var Br=function(t,e,r,n,i){Wt.push(new Or),Dt=$=0,ot=[],Pt=t,kt=e,It=i,je([r,n]);},Mr=function(t){if(Ht[t])Wt.pop().restore();else{var e=new Or,r="Xo"+(Object.keys(zt).length+1).toString(10);e.id=r,Ht[t]=r,zt[r]=e,Tt.publish("addFormObject",e),Wt.pop().restore();}};for(var Er in y.beginFormObject=function(t,e,r,n,i){return Br(t,e,r,n,i),this},y.endFormObject=function(t){return Mr(t),this},y.doFormObject=function(t,e){var r=zt[Ht[t]];return lt("q"),lt(e.toString()+" cm"),lt("/"+r.id+" Do"),lt("Q"),this},y.getFormObject=function(t){var e=zt[Ht[t]];return {x:e.x,y:e.y,width:e.width,height:e.height,matrix:e.matrix}},y.save=function(t,e){return t=t||"generated.pdf",(e=e||{}).returnPromise=e.returnPromise||!1,!1===e.returnPromise?(l(We(He()),t),"function"==typeof l.unload&&n.setTimeout&&setTimeout(l.unload,911),this):new Promise((function(e,r){try{var i=l(We(He()),t);"function"==typeof l.unload&&n.setTimeout&&setTimeout(l.unload,911),e(i);}catch(t){r(t.message);}}))},E.API)E.API.hasOwnProperty(Er)&&("events"===Er&&E.API.events.length?function(t,e){var r,n,i;for(i=e.length-1;-1!==i;i--)r=e[i][0],n=e[i][1],t.subscribe.apply(t,[r].concat("function"==typeof n?[n]:n));}(Tt,E.API.events):y[Er]=E.API[Er]);var qr=y.getPageWidth=function(t){return (Rt[t=t||$].mediaBox.topRightX-Rt[t].mediaBox.bottomLeftX)/_t},Dr=y.setPageWidth=function(t,e){Rt[t].mediaBox.topRightX=e*_t+Rt[t].mediaBox.bottomLeftX;},Rr=y.getPageHeight=function(t){return (Rt[t=t||$].mediaBox.topRightY-Rt[t].mediaBox.bottomLeftY)/_t},Tr=y.setPageHeight=function(t,e){Rt[t].mediaBox.topRightY=e*_t+Rt[t].mediaBox.bottomLeftY;};return y.internal={pdfEscape:Ce,getStyle:tr,getFont:hr,getFontSize:vt,getCharSpace:Pr,getTextColor:Sr,getLineHeight:gr,getLineHeightFactor:vr,getLineWidth:dr,write:ft,getHorizontalCoordinate:br,getVerticalCoordinate:yr,getCoordinateString:wr,getVerticalCoordinateString:Nr,collections:{},newObject:Xt,newAdditionalObject:$t,newObjectDeferred:Kt,newObjectDeferredBegin:Zt,getFilters:ne,putStream:ie,events:Tt,scaleFactor:_t,pageSize:{getWidth:function(){return qr($)},setWidth:function(t){Dr($,t);},getHeight:function(){return Rr($)},setHeight:function(t){Tr($,t);}},encryptionOptions:m,encryption:Ye,getEncryptor:Je,output:Ve,getNumberOfPages:Ee,pages:ot,out:lt,f2:R,f3:T,getPageInfo:Xe,getPageInfoByObjId:Ke,getCurrentPageInfo:Ze,getPDFVersion:N,Point:Cr,Rectangle:jr,Matrix:Vt,hasHotfix:Ge},Object.defineProperty(y.internal.pageSize,"width",{get:function(){return qr($)},set:function(t){Dr($,t);},enumerable:!0,configurable:!0}),Object.defineProperty(y.internal.pageSize,"height",{get:function(){return Rr($)},set:function(t){Tr($,t);},enumerable:!0,configurable:!0}),ke.call(y,pt),St="F1",Oe(s,i),Tt.publish("initialized"),y}I.prototype.lsbFirstWord=function(t){return String.fromCharCode(t>>0&255,t>>8&255,t>>16&255,t>>24&255)},I.prototype.toHexString=function(t){return t.split("").map((function(t){return ("0"+(255&t.charCodeAt(0)).toString(16)).slice(-2)})).join("")},I.prototype.hexToBytes=function(t){for(var e=[],r=0;r<t.length;r+=2)e.push(String.fromCharCode(parseInt(t.substr(r,2),16)));return e.join("")},I.prototype.processOwnerPassword=function(t,e){return P(x$1(e).substr(0,5),t)},I.prototype.encryptor=function(t,e){var r=x$1(this.encryptionKey+String.fromCharCode(255&t,t>>8&255,t>>16&255,255&e,e>>8&255)).substr(0,10);return function(t){return P(r,t)}},j$2.prototype.equals=function(e){var r,n="id,objectNumber,equals";if(!e||t(e)!==t(this))return !1;var i=0;for(r in this)if(!(n.indexOf(r)>=0)){if(this.hasOwnProperty(r)&&!e.hasOwnProperty(r))return !1;if(this[r]!==e[r])return !1;i++;}for(r in e)e.hasOwnProperty(r)&&n.indexOf(r)<0&&i--;return 0===i},E.API={events:[]},E.version="2.5.1";var q=E.API,D=1,R=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},T=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},U=function(t){return t.toFixed(2)},z=function(t){return t.toFixed(5)};q.__acroform__={};var H=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t;},W=function(t){return t*D},V=function(t){var e=new ut,r=At.internal.getHeight(t)||0,n=At.internal.getWidth(t)||0;return e.BBox=[0,0,Number(U(n)),Number(U(r))],e},G=q.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},Y=q.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},J=q.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},X=q.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return J(t,e-1)},K=q.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return G(t,e-1)},Z=q.__acroform__.clearBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return Y(t,e-1)},$=q.__acroform__.calculateCoordinates=function(t,e){var r=e.internal.getHorizontalCoordinate,n=e.internal.getVerticalCoordinate,i=t[0],a=t[1],o=t[2],s=t[3],c={};return c.lowerLeft_X=r(i)||0,c.lowerLeft_Y=n(a+s)||0,c.upperRight_X=r(i+o)||0,c.upperRight_Y=n(a)||0,[Number(U(c.lowerLeft_X)),Number(U(c.lowerLeft_Y)),Number(U(c.upperRight_X)),Number(U(c.upperRight_Y))]},Q=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],r=t._V||t.DV,n=tt(t,r),i=t.scope.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(t.scope.__private__.encodeColorString(t.color)),e.push("/"+i+" "+U(n.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(n.text),e.push("ET"),e.push("Q"),e.push("EMC");var a=V(t);return a.scope=t.scope,a.stream=e.join("\n"),a}},tt=function(t,e){var r=0===t.fontSize?t.maxFontSize:t.fontSize,n={text:"",fontSize:""},i=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" ");i=t.multiline?i.map((function(t){return t.split("\n")})):i.map((function(t){return [t]}));var a=r,o=At.internal.getHeight(t)||0;o=o<0?-o:o;var s=At.internal.getWidth(t)||0;s=s<0?-s:s;var c=function(e,r,n){if(e+1<i.length){var a=r+" "+i[e+1][0];return et$1(a,t,n).width<=s-4}return !1};a++;t:for(;a>0;){e="",a--;var u,h,l=et$1("3",t,a).height,f=t.multiline?o-a:(o-l)/2,d=f+=2,p=0,g=0,m=0;if(a<=0){e="(...) Tj\n",e+="% Width of Text: "+et$1(e,t,a=12).width+", FieldWidth:"+s+"\n";break}for(var v="",b=0,y=0;y<i.length;y++)if(i.hasOwnProperty(y)){var w=!1;if(1!==i[y].length&&m!==i[y].length-1){if((l+2)*(b+2)+2>o)continue t;v+=i[y][m],w=!0,g=y,y--;}else{v=" "==(v+=i[y][m]+" ").substr(v.length-1)?v.substr(0,v.length-1):v;var N=parseInt(y),L=c(N,v,a),A=y>=i.length-1;if(L&&!A){v+=" ",m=0;continue}if(L||A){if(A)g=N;else if(t.multiline&&(l+2)*(b+2)+2>o)continue t}else{if(!t.multiline)continue t;if((l+2)*(b+2)+2>o)continue t;g=N;}}for(var x="",S=p;S<=g;S++){var _=i[S];if(t.multiline){if(S===g){x+=_[m]+" ",m=(m+1)%_.length;continue}if(S===p){x+=_[_.length-1]+" ";continue}}x+=_[0]+" ";}switch(x=" "==x.substr(x.length-1)?x.substr(0,x.length-1):x,h=et$1(x,t,a).width,t.textAlign){case"right":u=s-h-2;break;case"center":u=(s-h)/2;break;case"left":default:u=2;}e+=U(u)+" "+U(d)+" Td\n",e+="("+R(x)+") Tj\n",e+=-U(u)+" 0 Td\n",d=-(a+2),h=0,p=w?g:g+1,b++,v="";}break}return n.text=e,n.fontSize=a,n},et$1=function(t,e,r){var n=e.scope.internal.getFont(e.fontName,e.fontStyle),i=e.scope.getStringUnitWidth(t,{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r);return {height:e.scope.getStringUnitWidth("3",{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r)*1.5,width:i}},rt={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},nt=function(t,e){var r={type:"reference",object:t};void 0===e.internal.getPageInfo(t.page).pageContext.annotations.find((function(t){return t.type===r.type&&t.object===r.object}))&&e.internal.getPageInfo(t.page).pageContext.annotations.push(r);},it=function(e,r){for(var n in e)if(e.hasOwnProperty(n)){var i=n,a=e[n];r.internal.newObjectDeferredBegin(a.objId,!0),"object"===t(a)&&"function"==typeof a.putStream&&a.putStream(),delete e[i];}},at$1=function(e,r){if(r.scope=e,void 0!==e.internal&&(void 0===e.internal.acroformPlugin||!1===e.internal.acroformPlugin.isInitialized)){if(lt.FieldNum=0,e.internal.acroformPlugin=JSON.parse(JSON.stringify(rt)),e.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");D=e.internal.scaleFactor,e.internal.acroformPlugin.acroFormDictionaryRoot=new ht,e.internal.acroformPlugin.acroFormDictionaryRoot.scope=e,e.internal.acroformPlugin.acroFormDictionaryRoot._eventID=e.internal.events.subscribe("postPutResources",(function(){!function(t){t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID,t.internal.acroformPlugin.printedOut=!0;}(e);})),e.internal.events.subscribe("buildDocument",(function(){!function(t){t.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var e=t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var r in e)if(e.hasOwnProperty(r)){var n=e[r];n.objId=void 0,n.hasAnnotation&&nt(n,t);}}(e);})),e.internal.events.subscribe("putCatalog",(function(){!function(t){if(void 0===t.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");t.internal.write("/AcroForm "+t.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R");}(e);})),e.internal.events.subscribe("postPutPages",(function(r){!function(e,r){var n=!e;for(var i in e||(r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()),e=e||r.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if(e.hasOwnProperty(i)){var a=e[i],o=[],s=a.Rect;if(a.Rect&&(a.Rect=$(a.Rect,r)),r.internal.newObjectDeferredBegin(a.objId,!0),a.DA=At.createDefaultAppearanceStream(a),"object"===t(a)&&"function"==typeof a.getKeyValueListForStream&&(o=a.getKeyValueListForStream()),a.Rect=s,a.hasAppearanceStream&&!a.appearanceStreamContent){var c=Q(a);o.push({key:"AP",value:"<</N "+c+">>"}),r.internal.acroformPlugin.xForms.push(c);}if(a.appearanceStreamContent){var u="";for(var h in a.appearanceStreamContent)if(a.appearanceStreamContent.hasOwnProperty(h)){var l=a.appearanceStreamContent[h];if(u+="/"+h+" ",u+="<<",Object.keys(l).length>=1||Array.isArray(l)){for(var i in l)if(l.hasOwnProperty(i)){var f=l[i];"function"==typeof f&&(f=f.call(r,a)),u+="/"+i+" "+f+" ",r.internal.acroformPlugin.xForms.indexOf(f)>=0||r.internal.acroformPlugin.xForms.push(f);}}else"function"==typeof(f=l)&&(f=f.call(r,a)),u+="/"+i+" "+f,r.internal.acroformPlugin.xForms.indexOf(f)>=0||r.internal.acroformPlugin.xForms.push(f);u+=">>";}o.push({key:"AP",value:"<<\n"+u+">>"});}r.internal.putStream({additionalKeyValues:o,objectId:a.objId}),r.internal.out("endobj");}n&&it(r.internal.acroformPlugin.xForms,r);}(r,e);})),e.internal.acroformPlugin.isInitialized=!0;}},ot=q.__acroform__.arrayToPdfArray=function(e,r,n){var i=function(t){return t};if(Array.isArray(e)){for(var a="[",o=0;o<e.length;o++)switch(0!==o&&(a+=" "),t(e[o])){case"boolean":case"number":case"object":a+=e[o].toString();break;case"string":"/"!==e[o].substr(0,1)?(void 0!==r&&n&&(i=n.internal.getEncryptor(r)),a+="("+R(i(e[o].toString()))+")"):a+=e[o].toString();}return a+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var st=function(t,e,r){var n=function(t){return t};return void 0!==e&&r&&(n=r.internal.getEncryptor(e)),(t=t||"").toString(),t="("+R(n(t))+")"},ct=function(){this._objId=void 0,this._scope=void 0,Object.defineProperty(this,"objId",{get:function(){if(void 0===this._objId){if(void 0===this.scope)return;this._objId=this.scope.internal.newObjectDeferred();}return this._objId},set:function(t){this._objId=t;}}),Object.defineProperty(this,"scope",{value:this._scope,writable:!0});};ct.prototype.toString=function(){return this.objId+" 0 R"},ct.prototype.putStream=function(){var t=this.getKeyValueListForStream();this.scope.internal.putStream({data:this.stream,additionalKeyValues:t,objectId:this.objId}),this.scope.internal.out("endobj");},ct.prototype.getKeyValueListForStream=function(){var t=[],e=Object.getOwnPropertyNames(this).filter((function(t){return "content"!=t&&"appearanceStreamContent"!=t&&"scope"!=t&&"objId"!=t&&"_"!=t.substring(0,1)}));for(var r in e)if(!1===Object.getOwnPropertyDescriptor(this,e[r]).configurable){var n=e[r],i=this[n];i&&(Array.isArray(i)?t.push({key:n,value:ot(i,this.objId,this.scope)}):i instanceof ct?(i.scope=this.scope,t.push({key:n,value:i.objId+" 0 R"})):"function"!=typeof i&&t.push({key:n,value:i}));}return t};var ut=function(){ct.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writable:!0});var t,e=[];Object.defineProperty(this,"BBox",{configurable:!1,get:function(){return e},set:function(t){e=t;}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(e){t=e.trim();},get:function(){return t||null}});};H(ut,ct);var ht=function(){ct.call(this);var t,e=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return e.length>0?e:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return e}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(t){var e=function(t){return t};return this.scope&&(e=this.scope.internal.getEncryptor(this.objId)),"("+R(e(t))+")"}},set:function(e){t=e;}});};H(ht,ct);var lt=function t(){ct.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t;}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(e,3))},set:function(t){!0===Boolean(t)?this.F=K(e,3):this.F=Z(e,3);}});var r=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');r=t;}});var n=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==n.length)return n},set:function(t){n=void 0!==t?t:[];}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return !n||isNaN(n[0])?0:n[0]},set:function(t){n[0]=t;}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return !n||isNaN(n[1])?0:n[1]},set:function(t){n[1]=t;}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return !n||isNaN(n[2])?0:n[2]},set:function(t){n[2]=t;}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return !n||isNaN(n[3])?0:n[3]},set:function(t){n[3]=t;}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var a=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!a||a.length<1){if(this instanceof yt)return;a="FieldObject"+t.FieldNum++;}var e=function(t){return t};return this.scope&&(e=this.scope.internal.getEncryptor(this.objId)),"("+R(e(a))+")"},set:function(t){a=t.toString();}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return a},set:function(t){a=t;}});var o="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return o},set:function(t){o=t;}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t;}});var c=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return c},set:function(t){c=t;}});var u=void 0;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return void 0===u?50/D:u},set:function(t){u=t;}});var h="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return h},set:function(t){h=t;}});var l="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!l||this instanceof yt||this instanceof Nt))return st(l,this.objId,this.scope)},set:function(t){t=t.toString(),l=t;}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof mt==!1?st(f,this.objId,this.scope):f},set:function(t){t=t.toString(),f=this instanceof mt==!1?"("===t.substr(0,1)?T(t.substr(1,t.length-2)):T(t):t;}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof mt==!0?T(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof mt==!0?"/"+t:t;}});var d=null;Object.defineProperty(this,"_V",{enumerable:!1,configurable:!1,get:function(){if(d)return d},set:function(t){this.V=t;}}),Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(d)return this instanceof mt==!1?st(d,this.objId,this.scope):d},set:function(t){t=t.toString(),d=this instanceof mt==!1?"("===t.substr(0,1)?T(t.substr(1,t.length-2)):T(t):t;}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof mt==!0?T(d.substr(1,d.length-1)):d},set:function(t){t=t.toString(),d=this instanceof mt==!0?"/"+t:t;}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var p,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t;}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,get:function(){if(p)return p},set:function(t){p=t;}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,1):this.Ff=Z(this.Ff,1);}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,2):this.Ff=Z(this.Ff,2);}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,3):this.Ff=Z(this.Ff,3);}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t;}}),Object.defineProperty(this,"textAlign",{get:function(){var t;switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right";}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0;}}});};H(lt,ct);var ft=function(){lt.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var t=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e;}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){t=e;}});var e=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return ot(e,this.objId,this.scope)},set:function(t){var r,n;n=[],"string"==typeof(r=t)&&(n=function(t,e,r){r||(r=1);for(var n,i=[];n=e.exec(t);)i.push(n[r]);return i}(r,/\((.*?)\)/g)),e=n;}}),this.getOptions=function(){return e},this.setOptions=function(t){e=t,this.sort&&e.sort();},this.addOption=function(t){t=(t=t||"").toString(),e.push(t),this.sort&&e.sort();},this.removeOption=function(t,r){for(r=r||!1,t=(t=t||"").toString();-1!==e.indexOf(t)&&(e.splice(e.indexOf(t),1),!1!==r););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,18):this.Ff=Z(this.Ff,18);}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=K(this.Ff,19):this.Ff=Z(this.Ff,19));}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=K(this.Ff,20),e.sort()):this.Ff=Z(this.Ff,20);}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,22):this.Ff=Z(this.Ff,22);}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,23):this.Ff=Z(this.Ff,23);}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,27):this.Ff=Z(this.Ff,27);}}),this.hasAppearanceStream=!1;};H(ft,lt);var dt=function(){ft.call(this),this.fontName="helvetica",this.combo=!1;};H(dt,ft);var pt=function(){dt.call(this),this.combo=!0;};H(pt,dt);var gt=function(){pt.call(this),this.edit=!0;};H(gt,pt);var mt=function(){lt.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,15):this.Ff=Z(this.Ff,15);}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,16):this.Ff=Z(this.Ff,16);}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,17):this.Ff=Z(this.Ff,17);}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,26):this.Ff=Z(this.Ff,26);}});var e,r={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};if(this.scope&&(t=this.scope.internal.getEncryptor(this.objId)),0!==Object.keys(r).length){var e,n=[];for(e in n.push("<<"),r)n.push("/"+e+" ("+R(t(r[e]))+")");return n.push(">>"),n.join("\n")}},set:function(e){"object"===t(e)&&(r=e);}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return r.CA||""},set:function(t){"string"==typeof t&&(r.CA=t);}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t;}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t;}});};H(mt,lt);var vt=function(){mt.call(this),this.pushButton=!0;};H(vt,mt);var bt=function(){mt.call(this),this.radio=!0,this.pushButton=!1;var t=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=void 0!==e?e:[];}});};H(bt,mt);var yt=function(){var e,r;lt.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t;}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return r},set:function(t){r=t;}});var n,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};this.scope&&(t=this.scope.internal.getEncryptor(this.objId));var e,r=[];for(e in r.push("<<"),i)r.push("/"+e+" ("+R(t(i[e]))+")");return r.push(">>"),r.join("\n")},set:function(e){"object"===t(e)&&(i=e);}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t);}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){n=t;}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return n.substr(1,n.length-1)},set:function(t){n="/"+t;}}),this.caption="l",this.appearanceState="Off",this._AppearanceType=At.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(this.optionName);};H(yt,lt),bt.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t)||!("getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var r=this.Kids[e];r.appearanceStreamContent=t.createAppearanceStream(r.optionName),r.caption=t.getCA();}},bt.prototype.createOption=function(t){var e=new yt;return e.Parent=this,e.optionName=t,this.Kids.push(e),xt.call(this.scope,e),e};var wt=function(){mt.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=At.CheckBox.createAppearanceStream();};H(wt,mt);var Nt=function(){lt.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,13):this.Ff=Z(this.Ff,13);}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,21):this.Ff=Z(this.Ff,21);}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,23):this.Ff=Z(this.Ff,23);}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,24):this.Ff=Z(this.Ff,24);}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,25):this.Ff=Z(this.Ff,25);}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,26):this.Ff=Z(this.Ff,26);}});var t=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e;}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){Number.isInteger(e)&&(t=e);}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}});};H(Nt,lt);var Lt=function(){Nt.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,14):this.Ff=Z(this.Ff,14);}}),this.password=!0;};H(Lt,Nt);var At={CheckBox:{createAppearanceStream:function(){return {N:{On:At.CheckBox.YesNormal},D:{On:At.CheckBox.YesPushDown,Off:At.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=t.scope.internal.getFont(t.fontName,t.fontStyle).id,i=t.scope.__private__.encodeColorString(t.color),a=tt(t,t.caption);return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),r.push("BMC"),r.push("q"),r.push("0 0 1 rg"),r.push("/"+n+" "+U(a.fontSize)+" Tf "+i),r.push("BT"),r.push(a.text),r.push("ET"),r.push("Q"),r.push("EMC"),e.stream=r.join("\n"),e},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=t.scope.internal.getFont(t.fontName,t.fontStyle).id,n=t.scope.__private__.encodeColorString(t.color),i=[],a=At.internal.getHeight(t),o=At.internal.getWidth(t),s=tt(t,t.caption);return i.push("1 g"),i.push("0 0 "+U(o)+" "+U(a)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+U(o-1)+" "+U(a-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+r+" "+U(s.fontSize)+" Tf "+n),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:At.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=At.RadioButton.Circle.YesNormal,e.D[t]=At.RadioButton.Circle.YesPushDown,e},getCA:function(){return "l"},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=At.internal.Bezier_C,a=Number((n*i).toFixed(5));return r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+a+" "+a+" "+n+" 0 "+n+" c"),r.push("-"+a+" "+n+" -"+n+" "+a+" -"+n+" 0 c"),r.push("-"+n+" -"+a+" -"+a+" -"+n+" 0 -"+n+" c"),r.push(a+" -"+n+" "+n+" -"+a+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*At.internal.Bezier_C).toFixed(5)),o=Number((n*At.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),r.push("0 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+o+" "+o+" "+n+" 0 "+n+" c"),r.push("-"+o+" "+n+" -"+n+" "+o+" -"+n+" 0 c"),r.push("-"+n+" -"+o+" -"+o+" -"+n+" 0 -"+n+" c"),r.push(o+" -"+n+" "+n+" -"+o+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*At.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:At.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=At.RadioButton.Cross.YesNormal,e.D[t]=At.RadioButton.Cross.YesPushDown,e},getCA:function(){return "8"},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.calculateCross(t);return r.push("q"),r.push("1 1 "+U(At.internal.getWidth(t)-2)+" "+U(At.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(U(n.x1.x)+" "+U(n.x1.y)+" m"),r.push(U(n.x2.x)+" "+U(n.x2.y)+" l"),r.push(U(n.x4.x)+" "+U(n.x4.y)+" m"),r.push(U(n.x3.x)+" "+U(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=At.internal.calculateCross(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),n.push("f"),n.push("q"),n.push("1 1 "+U(At.internal.getWidth(t)-2)+" "+U(At.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(U(r.x1.x)+" "+U(r.x1.y)+" m"),n.push(U(r.x2.x)+" "+U(r.x2.y)+" l"),n.push(U(r.x4.x)+" "+U(r.x4.y)+" m"),n.push(U(r.x3.x)+" "+U(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=t.scope.internal.getFont(t.fontName,t.fontStyle).id,r=t.scope.__private__.encodeColorString(t.color);return "/"+e+" "+t.fontSize+" Tf "+r}};At.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=At.internal.getWidth(t),r=At.internal.getHeight(t),n=Math.min(e,r);return {x1:{x:(e-n)/2,y:(r-n)/2+n},x2:{x:(e-n)/2+n,y:(r-n)/2},x3:{x:(e-n)/2,y:(r-n)/2},x4:{x:(e-n)/2+n,y:(r-n)/2+n}}}},At.internal.getWidth=function(e){var r=0;return "object"===t(e)&&(r=W(e.Rect[2])),r},At.internal.getHeight=function(e){var r=0;return "object"===t(e)&&(r=W(e.Rect[3])),r};var xt=q.addField=function(t){if(at$1(this,t),!(t instanceof lt))throw new Error("Invalid argument passed to jsPDF.addField.");var e;return (e=t).scope.internal.acroformPlugin.printedOut&&(e.scope.internal.acroformPlugin.printedOut=!1,e.scope.internal.acroformPlugin.acroFormDictionaryRoot=null),e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e),t.page=t.scope.internal.getCurrentPageInfo().pageNumber,this};q.AcroFormChoiceField=ft,q.AcroFormListBox=dt,q.AcroFormComboBox=pt,q.AcroFormEditBox=gt,q.AcroFormButton=mt,q.AcroFormPushButton=vt,q.AcroFormRadioButton=bt,q.AcroFormCheckBox=wt,q.AcroFormTextField=Nt,q.AcroFormPasswordField=Lt,q.AcroFormAppearance=At,q.AcroForm={ChoiceField:ft,ListBox:dt,ComboBox:pt,EditBox:gt,Button:mt,PushButton:vt,RadioButton:bt,CheckBox:wt,TextField:Nt,PasswordField:Lt,Appearance:At},E.AcroForm={ChoiceField:ft,ListBox:dt,ComboBox:pt,EditBox:gt,Button:mt,PushButton:vt,RadioButton:bt,CheckBox:wt,TextField:Nt,PasswordField:Lt,Appearance:At};function _t(t){return t.reduce((function(t,e,r){return t[e]=r,t}),{})}!function(e){e.__addimage__={};var r="UNKNOWN",n={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0],[255,216,255,219],[255,216,255,238]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],WEBP:[[82,73,70,70,void 0,void 0,void 0,void 0,87,69,66,80]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},i=e.__addimage__.getImageFileTypeByImageData=function(t,e){var i,a,o,s,c,u=r;if("RGBA"===(e=e||r)||void 0!==t.data&&t.data instanceof Uint8ClampedArray&&"height"in t&&"width"in t)return "RGBA";if(x(t))for(c in n)for(o=n[c],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t[a]){s=!1;break}if(!0===s){u=c;break}}else for(c in n)for(o=n[c],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t.charCodeAt(a)){s=!1;break}if(!0===s){u=c;break}}return u===r&&e!==r&&(u=e),u},a=function t(e){for(var r=this.internal.write,n=this.internal.putStream,i=(0, this.internal.getFilters)();-1!==i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"),1);e.objectId=this.internal.newObject();var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.width}),a.push({key:"Height",value:e.height}),e.colorSpace===b.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.palette.length/3-1)+" "+("sMask"in e&&void 0!==e.sMask?e.objectId+2:e.objectId+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.colorSpace}),e.colorSpace===b.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bitsPerComponent}),"decodeParameters"in e&&void 0!==e.decodeParameters&&a.push({key:"DecodeParms",value:"<<"+e.decodeParameters+">>"}),"transparency"in e&&Array.isArray(e.transparency)){for(var o="",s=0,c=e.transparency.length;s<c;s++)o+=e.transparency[s]+" "+e.transparency[s]+" ";a.push({key:"Mask",value:"["+o+"]"});}void 0!==e.sMask&&a.push({key:"SMask",value:e.objectId+1+" 0 R"});var u=void 0!==e.filter?["/"+e.filter]:void 0;if(n({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u,objectId:e.objectId}),r("endobj"),"sMask"in e&&void 0!==e.sMask){var h="/Predictor "+e.predictor+" /Colors 1 /BitsPerComponent "+e.bitsPerComponent+" /Columns "+e.width,l={width:e.width,height:e.height,colorSpace:"DeviceGray",bitsPerComponent:e.bitsPerComponent,decodeParameters:h,data:e.sMask};"filter"in e&&(l.filter=e.filter),t.call(this,l);}if(e.colorSpace===b.INDEXED){var f=this.internal.newObject();n({data:_(new Uint8Array(e.palette)),objectId:f}),r("endobj");}},o=function(){var t=this.internal.collections.addImage_images;for(var e in t)a.call(this,t[e]);},s=function(){var t,e=this.internal.collections.addImage_images,r=this.internal.write;for(var n in e)r("/I"+(t=e[n]).index,t.objectId,"0","R");},c=function(){this.internal.collections.addImage_images||(this.internal.collections.addImage_images={},this.internal.events.subscribe("putResources",o),this.internal.events.subscribe("putXobjectDict",s));},h=function(){var t=this.internal.collections.addImage_images;return c.call(this),t},l=function(){return Object.keys(this.internal.collections.addImage_images).length},f=function(t){return "function"==typeof e["process"+t.toUpperCase()]},d=function(e){return "object"===t(e)&&1===e.nodeType},p=function(t,r){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return u(unescape(n).split("base64,").pop());var i=e.loadFile(n,!0);if(void 0!==i)return i}if("CANVAS"===t.nodeName){if(0===t.width||0===t.height)throw new Error("Given canvas must have data. Canvas width: "+t.width+", height: "+t.height);var a;switch(r){case"PNG":a="image/png";break;case"WEBP":a="image/webp";break;case"JPEG":case"JPG":default:a="image/jpeg";}return u(t.toDataURL(a,1).split("base64,").pop())}},g=function(t){var e=this.internal.collections.addImage_images;if(e)for(var r in e)if(t===e[r].alias)return e[r]},m=function(t,e,r){return t||e||(t=-96,e=-96),t<0&&(t=-1*r.width*72/t/this.internal.scaleFactor),e<0&&(e=-1*r.height*72/e/this.internal.scaleFactor),0===t&&(t=e*r.width/r.height),0===e&&(e=t*r.height/r.width),[t,e]},v=function(t,e,r,n,i,a){var o=m.call(this,r,n,i),s=this.internal.getCoordinateString,c=this.internal.getVerticalCoordinateString,u=h.call(this);if(r=o[0],n=o[1],u[i.index]=i,a){a*=Math.PI/180;var l=Math.cos(a),f=Math.sin(a),d=function(t){return t.toFixed(4)},p=[d(l),d(f),d(-1*f),d(l),0,0,"cm"];}this.internal.write("q"),a?(this.internal.write([1,"0","0",1,s(t),c(e+n),"cm"].join(" ")),this.internal.write(p.join(" ")),this.internal.write([s(r),"0","0",s(n),"0","0","cm"].join(" "))):this.internal.write([s(r),"0","0",s(n),s(t),c(e+n),"cm"].join(" ")),this.isAdvancedAPI()&&this.internal.write([1,0,0,-1,0,0,"cm"].join(" ")),this.internal.write("/I"+i.index+" Do"),this.internal.write("Q");},b=e.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"};e.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"};var y=e.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},w=e.__addimage__.sHashCode=function(t){var e,r,n=0;if("string"==typeof t)for(r=t.length,e=0;e<r;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;else if(x(t))for(r=t.byteLength/2,e=0;e<r;e++)n=(n<<5)-n+t[e],n|=0;return n},N=e.__addimage__.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2))&&(e=!1),e},L=e.__addimage__.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),r=null;if(2===e.length){var n=/^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(e[0]);Array.isArray(n)&&(r={mimeType:n[1],charset:n[2],data:e[1]});}return r},A=e.__addimage__.supportsArrayBuffer=function(){return "undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array};e.__addimage__.isArrayBuffer=function(t){return A()&&t instanceof ArrayBuffer};var x=e.__addimage__.isArrayBufferView=function(t){return A()&&"undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array)},S=e.__addimage__.binaryStringToUint8Array=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r},_=e.__addimage__.arrayBufferToBinaryString=function(t){for(var e="",r=x(t)?t:new Uint8Array(t),n=0;n<r.length;n+=8192)e+=String.fromCharCode.apply(null,r.subarray(n,n+8192));return e};e.addImage=function(){var e,n,i,a,o,s,u,h,l;if("number"==typeof arguments[1]?(n=r,i=arguments[1],a=arguments[2],o=arguments[3],s=arguments[4],u=arguments[5],h=arguments[6],l=arguments[7]):(n=arguments[1],i=arguments[2],a=arguments[3],o=arguments[4],s=arguments[5],u=arguments[6],h=arguments[7],l=arguments[8]),"object"===t(e=arguments[0])&&!d(e)&&"imageData"in e){var f=e;e=f.imageData,n=f.format||n||r,i=f.x||i||0,a=f.y||a||0,o=f.w||f.width||o,s=f.h||f.height||s,u=f.alias||u,h=f.compression||h,l=f.rotation||f.angle||l;}var p=this.internal.getFilters();if(void 0===h&&-1!==p.indexOf("FlateEncode")&&(h="SLOW"),isNaN(i)||isNaN(a))throw new Error("Invalid coordinates passed to jsPDF.addImage");c.call(this);var g=P.call(this,e,n,u,h);return v.call(this,i,a,o,s,g,l),this};var P=function(t,n,a,o){var s,c,u;if("string"==typeof t&&i(t)===r){t=unescape(t);var h=k(t,!1);(""!==h||void 0!==(h=e.loadFile(t,!0)))&&(t=h);}if(d(t)&&(t=p(t,n)),n=i(t,n),!f(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if((null==(u=a)||0===u.length)&&(a=function(t){return "string"==typeof t||x(t)?w(t):x(t.data)?w(t.data):null}(t)),(s=g.call(this,a))||(A()&&(t instanceof Uint8Array||"RGBA"===n||(c=t,t=S(t))),s=this["process"+n.toUpperCase()](t,l.call(this),a,function(t){return t&&"string"==typeof t&&(t=t.toUpperCase()),t in e.image_compression?t:y.NONE}(o),c)),!s)throw new Error("An unknown error occurred whilst processing the image.");return s},k=e.__addimage__.convertBase64ToBinaryString=function(t,e){var r;e="boolean"!=typeof e||e;var n,i="";if("string"==typeof t){n=null!==(r=L(t))?r.data:t;try{i=u(n);}catch(t){if(e)throw N(n)?new Error("atob-Error in jsPDF.convertBase64ToBinaryString "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ")}}return i};e.getImageProperties=function(t){var n,a,o="";if(d(t)&&(t=p(t)),"string"==typeof t&&i(t)===r&&(""===(o=k(t,!1))&&(o=e.loadFile(t)||""),t=o),a=i(t),!f(a))throw new Error("addImage does not support files of type '"+a+"', please ensure that a plugin for '"+a+"' support is added.");if(!A()||t instanceof Uint8Array||(t=S(t)),!(n=this["process"+a.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return n.fileType=a,n};}(E.API),
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(t){if(void 0!==t&&""!=t)return !0};E.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[];}]),t.events.push(["putPage",function(t){for(var r,n,i,a=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,s=this.internal.getPageInfoByObjId(t.objId),c=t.pageContext.annotations,u=!1,h=0;h<c.length&&!u;h++)switch((r=c[h]).type){case"link":(e(r.options.url)||e(r.options.pageNumber))&&(u=!0);break;case"reference":case"text":case"freetext":u=!0;}if(0!=u){this.internal.write("/Annots [");for(var l=0;l<c.length;l++){r=c[l];var f=this.internal.pdfEscape,d=this.internal.getEncryptor(t.objId);switch(r.type){case"reference":this.internal.write(" "+r.object.objId+" 0 R ");break;case"text":var p=this.internal.newAdditionalObject(),g=this.internal.newAdditionalObject(),m=this.internal.getEncryptor(p.objId),v=r.title||"Note";i="<</Type /Annot /Subtype /Text "+(n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y)+"] ")+"/Contents ("+f(m(r.contents))+")",i+=" /Popup "+g.objId+" 0 R",i+=" /P "+s.objId+" 0 R",i+=" /T ("+f(m(v))+") >>",p.content=i;var b=p.objId+" 0 R";i="<</Type /Annot /Subtype /Popup "+(n="/Rect ["+a(r.bounds.x+30)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w+30)+" "+o(r.bounds.y)+"] ")+" /Parent "+b,r.open&&(i+=" /Open true"),i+=" >>",g.content=i,this.internal.write(p.objId,"0 R",g.objId,"0 R");break;case"freetext":n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y+r.bounds.h)+"] ";var y=r.color||"#000000";i="<</Type /Annot /Subtype /FreeText "+n+"/Contents ("+f(d(r.contents))+")",i+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+y+")",i+=" /Border [0 0 0]",i+=" >>",this.internal.write(i);break;case"link":if(r.options.name){var w=this.annotations._nameMap[r.options.name];r.options.pageNumber=w.page,r.options.top=w.y;}else r.options.top||(r.options.top=0);if(n="/Rect ["+r.finalBounds.x+" "+r.finalBounds.y+" "+r.finalBounds.w+" "+r.finalBounds.h+"] ",i="",r.options.url)i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /A <</S /URI /URI ("+f(d(r.options.url))+") >>";else if(r.options.pageNumber){switch(i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(r.options.pageNumber).objId+" 0 R",r.options.magFactor=r.options.magFactor||"XYZ",r.options.magFactor){case"Fit":i+=" /Fit]";break;case"FitH":i+=" /FitH "+r.options.top+"]";break;case"FitV":r.options.left=r.options.left||0,i+=" /FitV "+r.options.left+"]";break;case"XYZ":default:var N=o(r.options.top);r.options.left=r.options.left||0,void 0===r.options.zoom&&(r.options.zoom=0),i+=" /XYZ "+r.options.left+" "+N+" "+r.options.zoom+"]";}}""!=i&&(i+=" >>",this.internal.write(i));}}this.internal.write("]");}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t);}},t.link=function(t,e,r,n,i){var a=this.internal.getCurrentPageInfo(),o=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;a.pageContext.annotations.push({finalBounds:{x:o(t),y:s(e),w:o(t+r),h:s(e+n)},options:i,type:"link"});},t.textWithLink=function(t,e,r,n){var i,a,o=this.getTextWidth(t),s=this.internal.getLineHeight()/this.internal.scaleFactor;if(void 0!==n.maxWidth){a=n.maxWidth;var c=this.splitTextToSize(t,a).length;i=Math.ceil(s*c);}else a=o,i=s;return this.text(t,e,r,n),r+=.2*s,"center"===n.align&&(e-=o/2),"right"===n.align&&(e-=o),this.link(e,r-s,a,i,n),o},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor};}(E.API),
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},r={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},n={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},i=[1570,1571,1573,1575];t.__arabicParser__={};var a=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==e[t.charCodeAt(0)]},o=t.__arabicParser__.isArabicLetter=function(t){return "string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},s=t.__arabicParser__.isArabicEndLetter=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length<=2},c=t.__arabicParser__.isArabicAlfLetter=function(t){return o(t)&&i.indexOf(t.charCodeAt(0))>=0};t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=1};var u=t.__arabicParser__.arabicLetterHasFinalForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=2};t.__arabicParser__.arabicLetterHasInitialForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=3};var h=t.__arabicParser__.arabicLetterHasMedialForm=function(t){return o(t)&&a(t)&&4==e[t.charCodeAt(0)].length},l=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=r,i="",a=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(a++,"number"==typeof(n=n[t.charCodeAt(e)])&&(i+=String.fromCharCode(n),n=r,a=0),e===t.length-1&&(n=r,i+=t.charAt(e-(a-1)),e-=a-1,a=0)):(n=r,i+=t.charAt(e-a),e-=a,a=0);return i};t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==n[t.charCodeAt(0)]};var f=t.__arabicParser__.getCorrectForm=function(t,e,r){return o(t)?!1===a(t)?-1:!u(t)||!o(e)&&!o(r)||!o(r)&&s(e)||s(t)&&!o(e)||s(t)&&c(e)||s(t)&&s(e)?0:h(t)&&o(e)&&!s(e)&&o(r)&&u(r)?3:s(t)||!o(r)?1:2:-1},d=function(t){var r=0,n=0,i=0,a="",s="",c="",u=(t=t||"").split("\\s+"),h=[];for(r=0;r<u.length;r+=1){for(h.push(""),n=0;n<u[r].length;n+=1)a=u[r][n],s=u[r][n-1],c=u[r][n+1],o(a)?(i=f(a,s,c),h[r]+=-1!==i?String.fromCharCode(e[a.charCodeAt(0)][i]):a):h[r]+=a;h[r]=l(h[r]);}return h.join(" ")},p=t.__arabicParser__.processArabic=t.processArabic=function(){var t,e="string"==typeof arguments[0]?arguments[0]:arguments[0].text,r=[];if(Array.isArray(e)){var n=0;for(r=[],n=0;n<e.length;n+=1)Array.isArray(e[n])?r.push([d(e[n][0]),e[n][1],e[n][2]]):r.push([d(e[n])]);t=r;}else t=d(e);return "string"==typeof arguments[0]?t:(arguments[0].text=t,arguments[0])};t.events.push(["preProcessText",p]);}(E.API),E.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",(function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj");})),this.internal.events.subscribe("putCatalog",(function(){this.internal.out("/OpenAction "+e+" 0 R");}));}return this},
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(){var t=void 0;Object.defineProperty(this,"pdf",{get:function(){return t},set:function(e){t=e;}});var e=150;Object.defineProperty(this,"width",{get:function(){return e},set:function(t){e=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=e+1);}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1);}});var n=[];Object.defineProperty(this,"childNodes",{get:function(){return n},set:function(t){n=t;}});var i={};Object.defineProperty(this,"style",{get:function(){return i},set:function(t){i=t;}}),Object.defineProperty(this,"parentNode",{});};e.prototype.getContext=function(t,e){var r;if("2d"!==(t=t||"2d"))return null;for(r in e)this.pdf.context2d.hasOwnProperty(r)&&(this.pdf.context2d[r]=e[r]);return this.pdf.context2d._canvas=this,this.pdf.context2d},e.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},t.events.push(["initialized",function(){this.canvas=new e,this.canvas.pdf=this;}]);}(E.API),function(e){var r={left:0,top:0,bottom:0,right:0},n=!1,i=function(){void 0===this.internal.__cell__&&(this.internal.__cell__={},this.internal.__cell__.padding=3,this.internal.__cell__.headerFunction=void 0,this.internal.__cell__.margins=Object.assign({},r),this.internal.__cell__.margins.width=this.getPageWidth(),a.call(this));},a=function(){this.internal.__cell__.lastCell=new o,this.internal.__cell__.pages=1;},o=function(){var t=arguments[0];Object.defineProperty(this,"x",{enumerable:!0,get:function(){return t},set:function(e){t=e;}});var e=arguments[1];Object.defineProperty(this,"y",{enumerable:!0,get:function(){return e},set:function(t){e=t;}});var r=arguments[2];Object.defineProperty(this,"width",{enumerable:!0,get:function(){return r},set:function(t){r=t;}});var n=arguments[3];Object.defineProperty(this,"height",{enumerable:!0,get:function(){return n},set:function(t){n=t;}});var i=arguments[4];Object.defineProperty(this,"text",{enumerable:!0,get:function(){return i},set:function(t){i=t;}});var a=arguments[5];Object.defineProperty(this,"lineNumber",{enumerable:!0,get:function(){return a},set:function(t){a=t;}});var o=arguments[6];return Object.defineProperty(this,"align",{enumerable:!0,get:function(){return o},set:function(t){o=t;}}),this};o.prototype.clone=function(){return new o(this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align)},o.prototype.toArray=function(){return [this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align]},e.setHeaderFunction=function(t){return i.call(this),this.internal.__cell__.headerFunction="function"==typeof t?t:void 0,this},e.getTextDimensions=function(t,e){i.call(this);var r=(e=e||{}).fontSize||this.getFontSize(),n=e.font||this.getFont(),a=e.scaleFactor||this.internal.scaleFactor,o=0,s=0,c=0,u=this;if(!Array.isArray(t)&&"string"!=typeof t){if("number"!=typeof t)throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");t=String(t);}var h=e.maxWidth;h>0?"string"==typeof t?t=this.splitTextToSize(t,h):"[object Array]"===Object.prototype.toString.call(t)&&(t=t.reduce((function(t,e){return t.concat(u.splitTextToSize(e,h))}),[])):t=Array.isArray(t)?t:[t];for(var l=0;l<t.length;l++)o<(c=this.getStringUnitWidth(t[l],{font:n})*r)&&(o=c);return 0!==o&&(s=t.length),{w:o/=a,h:Math.max((s*r*this.getLineHeightFactor()-r*(this.getLineHeightFactor()-1))/a,0)}},e.cellAddPage=function(){i.call(this),this.addPage();var t=this.internal.__cell__.margins||r;return this.internal.__cell__.lastCell=new o(t.left,t.top,void 0,void 0),this.internal.__cell__.pages+=1,this};var s=e.cell=function(){var t;t=arguments[0]instanceof o?arguments[0]:new o(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]),i.call(this);var e=this.internal.__cell__.lastCell,a=this.internal.__cell__.padding,s=this.internal.__cell__.margins||r,c=this.internal.__cell__.tableHeaderRow,u=this.internal.__cell__.printHeaders;return void 0!==e.lineNumber&&(e.lineNumber===t.lineNumber?(t.x=(e.x||0)+(e.width||0),t.y=e.y||0):e.y+e.height+t.height+s.bottom>this.getPageHeight()?(this.cellAddPage(),t.y=s.top,u&&c&&(this.printHeaderRow(t.lineNumber,!0),t.y+=c[0].height)):t.y=e.y+e.height||t.y),void 0!==t.text[0]&&(this.rect(t.x,t.y,t.width,t.height,!0===n?"FD":void 0),"right"===t.align?this.text(t.text,t.x+t.width-a,t.y+a,{align:"right",baseline:"top"}):"center"===t.align?this.text(t.text,t.x+t.width/2,t.y+a,{align:"center",baseline:"top",maxWidth:t.width-a-a}):this.text(t.text,t.x+a,t.y+a,{align:"left",baseline:"top",maxWidth:t.width-a-a})),this.internal.__cell__.lastCell=t,this};e.table=function(e,n,u,h,l){if(i.call(this),!u)throw new Error("No data for PDF table.");var f,d,p,g,m=[],v=[],b=[],y={},w={},N=[],L=[],A=(l=l||{}).autoSize||!1,x=!1!==l.printHeaders,S=l.css&&void 0!==l.css["font-size"]?16*l.css["font-size"]:l.fontSize||12,_=l.margins||Object.assign({width:this.getPageWidth()},r),P="number"==typeof l.padding?l.padding:3,k=l.headerBackgroundColor||"#c8c8c8",I=l.headerTextColor||"#000";if(a.call(this),this.internal.__cell__.printHeaders=x,this.internal.__cell__.margins=_,this.internal.__cell__.table_font_size=S,this.internal.__cell__.padding=P,this.internal.__cell__.headerBackgroundColor=k,this.internal.__cell__.headerTextColor=I,this.setFontSize(S),null==h)v=m=Object.keys(u[0]),b=m.map((function(){return "left"}));else if(Array.isArray(h)&&"object"===t(h[0]))for(m=h.map((function(t){return t.name})),v=h.map((function(t){return t.prompt||t.name||""})),b=h.map((function(t){return t.align||"left"})),f=0;f<h.length;f+=1)w[h[f].name]=h[f].width*(19.049976/25.4);else Array.isArray(h)&&"string"==typeof h[0]&&(v=m=h,b=m.map((function(){return "left"})));if(A||Array.isArray(h)&&"string"==typeof h[0])for(f=0;f<m.length;f+=1){for(y[g=m[f]]=u.map((function(t){return t[g]})),this.setFont(void 0,"bold"),N.push(this.getTextDimensions(v[f],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w),d=y[g],this.setFont(void 0,"normal"),p=0;p<d.length;p+=1)N.push(this.getTextDimensions(d[p],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w);w[g]=Math.max.apply(null,N)+P+P,N=[];}if(x){var F={};for(f=0;f<m.length;f+=1)F[m[f]]={},F[m[f]].text=v[f],F[m[f]].align=b[f];var C=c.call(this,F,w);L=m.map((function(t){return new o(e,n,w[t],C,F[t].text,void 0,F[t].align)})),this.setTableHeaderRow(L),this.printHeaderRow(1,!1);}var j=h.reduce((function(t,e){return t[e.name]=e.align,t}),{});for(f=0;f<u.length;f+=1){"rowStart"in l&&l.rowStart instanceof Function&&l.rowStart({row:f,data:u[f]},this);var O=c.call(this,u[f],w);for(p=0;p<m.length;p+=1){var B=u[f][m[p]];"cellStart"in l&&l.cellStart instanceof Function&&l.cellStart({row:f,col:p,data:B},this),s.call(this,new o(e,n,w[m[p]],O,B,f+2,j[m[p]]));}}return this.internal.__cell__.table_x=e,this.internal.__cell__.table_y=n,this};var c=function(t,e){var r=this.internal.__cell__.padding,n=this.internal.__cell__.table_font_size,i=this.internal.scaleFactor;return Object.keys(t).map((function(n){var i=t[n];return this.splitTextToSize(i.hasOwnProperty("text")?i.text:i,e[n]-r-r)}),this).map((function(t){return this.getLineHeightFactor()*t.length*n/i+r+r}),this).reduce((function(t,e){return Math.max(t,e)}),0)};e.setTableHeaderRow=function(t){i.call(this),this.internal.__cell__.tableHeaderRow=t;},e.printHeaderRow=function(t,e){if(i.call(this),!this.internal.__cell__.tableHeaderRow)throw new Error("Property tableHeaderRow does not exist.");var r;if(n=!0,"function"==typeof this.internal.__cell__.headerFunction){var a=this.internal.__cell__.headerFunction(this,this.internal.__cell__.pages);this.internal.__cell__.lastCell=new o(a[0],a[1],a[2],a[3],void 0,-1);}this.setFont(void 0,"bold");for(var c=[],u=0;u<this.internal.__cell__.tableHeaderRow.length;u+=1){r=this.internal.__cell__.tableHeaderRow[u].clone(),e&&(r.y=this.internal.__cell__.margins.top||0,c.push(r)),r.lineNumber=t;var h=this.getTextColor();this.setTextColor(this.internal.__cell__.headerTextColor),this.setFillColor(this.internal.__cell__.headerBackgroundColor),s.call(this,r),this.setTextColor(h);}c.length>0&&this.setTableHeaderRow(c),this.setFont(void 0,"normal"),n=!1;};}(E.API);var Pt={italic:["italic","oblique","normal"],oblique:["oblique","italic","normal"],normal:["normal","oblique","italic"]},kt=["ultra-condensed","extra-condensed","condensed","semi-condensed","normal","semi-expanded","expanded","extra-expanded","ultra-expanded"],It=_t(kt),Ft=[100,200,300,400,500,600,700,800,900],Ct=_t(Ft);function jt(t){var e=t.family.replace(/"|'/g,"").toLowerCase(),r=function(t){return Pt[t=t||"normal"]?t:"normal"}(t.style),n=function(t){if(!t)return 400;if("number"==typeof t)return t>=100&&t<=900&&t%100==0?t:400;if(/^\d00$/.test(t))return parseInt(t);switch(t){case"bold":return 700;case"normal":default:return 400}}(t.weight),i=function(t){return "number"==typeof It[t=t||"normal"]?t:"normal"}(t.stretch);return {family:e,style:r,weight:n,stretch:i,src:t.src||[],ref:t.ref||{name:e,style:[i,r,n].join(" ")}}}function Ot(t,e,r,n){var i;for(i=r;i>=0&&i<e.length;i+=n)if(t[e[i]])return t[e[i]];for(i=r;i>=0&&i<e.length;i-=n)if(t[e[i]])return t[e[i]]}var Bt={"sans-serif":"helvetica",fixed:"courier",monospace:"courier",terminal:"courier",cursive:"times",fantasy:"times",serif:"times"},Mt={caption:"times",icon:"times",menu:"times","message-box":"times","small-caption":"times","status-bar":"times"};function Et(t){return [t.stretch,t.style,t.weight,t.family].join(" ")}function qt(t,e,r){for(var n=(r=r||{}).defaultFontFamily||"times",i=Object.assign({},Bt,r.genericFontFamilies||{}),a=null,o=null,s=0;s<e.length;++s)if(i[(a=jt(e[s])).family]&&(a.family=i[a.family]),t.hasOwnProperty(a.family)){o=t[a.family];break}if(!(o=o||t[n]))throw new Error("Could not find a font-family for the rule '"+Et(a)+"' and default family '"+n+"'.");if(o=function(t,e){if(e[t])return e[t];var r=It[t],n=r<=It.normal?-1:1,i=Ot(e,kt,r,n);if(!i)throw new Error("Could not find a matching font-stretch value for "+t);return i}(a.stretch,o),o=function(t,e){if(e[t])return e[t];for(var r=Pt[t],n=0;n<r.length;++n)if(e[r[n]])return e[r[n]];throw new Error("Could not find a matching font-style for "+t)}(a.style,o),!(o=function(t,e){if(e[t])return e[t];if(400===t&&e[500])return e[500];if(500===t&&e[400])return e[400];var r=Ct[t],n=Ot(e,Ft,r,t<400?-1:1);if(!n)throw new Error("Could not find a matching font-weight for value "+t);return n}(a.weight,o)))throw new Error("Failed to resolve a font for the rule '"+Et(a)+"'.");return o}function Dt(t){return t.trimLeft()}function Rt(t,e){for(var r=0;r<t.length;){if(t.charAt(r)===e)return [t.substring(0,r),t.substring(r+1)];r+=1;}return null}function Tt(t){var e=t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);return null===e?null:[e[0],t.substring(e[0].length)]}var Ut,zt,Ht,Wt=["times"];!function(e){var r,n,i,o,s,c,u,h,l,d=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new h,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new c,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new c,this.lineDashOffset=t.lineDashOffset||0,this.lineDash=t.lineDash||[],this.margin=t.margin||[0,0,0,0],this.prevPageLastElemOffset=t.prevPageLastElemOffset||0,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};e.events.push(["initialized",function(){this.context2d=new p(this),r=this.internal.f2,n=this.internal.getCoordinateString,i=this.internal.getVerticalCoordinateString,o=this.internal.getHorizontalCoordinate,s=this.internal.getVerticalCoordinate,c=this.internal.Point,u=this.internal.Rectangle,h=this.internal.Matrix,l=new d;}]);var p=function(t){Object.defineProperty(this,"canvas",{get:function(){return {parentNode:!1,style:!1}}});var e=t;Object.defineProperty(this,"pdf",{get:function(){return e}});var r=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return r},set:function(t){r=Boolean(t);}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t);}});var i=0;Object.defineProperty(this,"posX",{get:function(){return i},set:function(t){isNaN(t)||(i=t);}});var a=0;Object.defineProperty(this,"posY",{get:function(){return a},set:function(t){isNaN(t)||(a=t);}}),Object.defineProperty(this,"margin",{get:function(){return l.margin},set:function(t){var e;"number"==typeof t?e=[t,t,t,t]:((e=new Array(4))[0]=t[0],e[1]=t.length>=2?t[1]:e[0],e[2]=t.length>=3?t[2]:e[0],e[3]=t.length>=4?t[3]:e[1]),l.margin=e;}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=t;}});var s=0;Object.defineProperty(this,"lastBreak",{get:function(){return s},set:function(t){s=t;}});var c=[];Object.defineProperty(this,"pageBreaks",{get:function(){return c},set:function(t){c=t;}}),Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof d&&(l=t);}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t;}});var u=[];Object.defineProperty(this,"ctxStack",{get:function(){return u},set:function(t){u=t;}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=g(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a});}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=g(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b));}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t));}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t));}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t));}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t));}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t;}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t);}});var h=null;function f(t,e){if(null===h){var r=function(t){var e=[];return Object.keys(t).forEach((function(r){t[r].forEach((function(t){var n=null;switch(t){case"bold":n={family:r,weight:"bold"};break;case"italic":n={family:r,style:"italic"};break;case"bolditalic":n={family:r,weight:"bold",style:"italic"};break;case"":case"normal":n={family:r};}null!==n&&(n.ref={name:r,style:t},e.push(n));}));})),e}(t.getFontList());h=function(t){for(var e={},r=0;r<t.length;++r){var n=jt(t[r]),i=n.family,a=n.stretch,o=n.style,s=n.weight;e[i]=e[i]||{},e[i][a]=e[i][a]||{},e[i][a][o]=e[i][a][o]||{},e[i][a][o][s]=n;}return e}(r.concat(e));}return h}var p=null;Object.defineProperty(this,"fontFaces",{get:function(){return p},set:function(t){h=null,p=t;}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var r=e[1],n=(e[2],e[3]),i=e[4],a=(e[5],e[6]),o=/^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];i="px"===o?Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor),this.pdf.setFontSize(i);var s=function(t){var e,r,n=[],i=t.trim();if(""===i)return Wt;if(i in Mt)return [Mt[i]];for(;""!==i;){switch(r=null,e=(i=Dt(i)).charAt(0)){case'"':case"'":r=Rt(i.substring(1),e);break;default:r=Tt(i);}if(null===r)return Wt;if(n.push(r[0]),""!==(i=Dt(r[1]))&&","!==i.charAt(0))return Wt;i=i.replace(/^,/,"");}return n}(a);if(this.fontFaces){var c=qt(f(this.pdf,this.fontFaces),s.map((function(t){return {family:t,stretch:"normal",weight:n,style:r}})));this.pdf.setFont(c.ref.name,c.ref.style);}else{var u="";("bold"===n||parseInt(n,10)>=700||"bold"===r)&&(u="bold"),"italic"===r&&(u+="italic"),0===u.length&&(u="normal");for(var h="",l={arial:"Helvetica",Arial:"Helvetica",verdana:"Helvetica",Verdana:"Helvetica",helvetica:"Helvetica",Helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",cursive:"Times",fantasy:"Times",serif:"Times"},d=0;d<s.length;d++){if(void 0!==this.pdf.internal.getFont(s[d],u,{noFallback:!0,disableWarning:!0})){h=s[d];break}if("bolditalic"===u&&void 0!==this.pdf.internal.getFont(s[d],"bold",{noFallback:!0,disableWarning:!0}))h=s[d],u="bold";else if(void 0!==this.pdf.internal.getFont(s[d],"normal",{noFallback:!0,disableWarning:!0})){h=s[d],u="normal";break}}if(""===h)for(var p=0;p<s.length;p++)if(l[s[p]]){h=l[s[p]];break}h=""===h?"Times":h,this.pdf.setFont(h,u);}}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t;}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t;}}),Object.defineProperty(this,"lineDashOffset",{get:function(){return this.ctx.lineDashOffset},set:function(t){this.ctx.lineDashOffset=t,T.call(this);}}),Object.defineProperty(this,"lineDash",{get:function(){return this.ctx.lineDash},set:function(t){this.ctx.lineDash=t,T.call(this);}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t);}});};p.prototype.setLineDash=function(t){this.lineDash=t;},p.prototype.getLineDash=function(){return this.lineDash.length%2?this.lineDash.concat(this.lineDash):this.lineDash.slice()},p.prototype.fill=function(){A.call(this,"fill",!1);},p.prototype.stroke=function(){A.call(this,"stroke",!1);},p.prototype.beginPath=function(){this.path=[{type:"begin"}];},p.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var r=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"mt",x:r.x,y:r.y}),this.ctx.lastPoint=new c(t,e);},p.prototype.closePath=function(){var e=new c(0,0),r=0;for(r=this.path.length-1;-1!==r;r--)if("begin"===this.path[r].type&&"object"===t(this.path[r+1])&&"number"==typeof this.path[r+1].x){e=new c(this.path[r+1].x,this.path[r+1].y);break}this.path.push({type:"close"}),this.ctx.lastPoint=new c(e.x,e.y);},p.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var r=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"lt",x:r.x,y:r.y}),this.ctx.lastPoint=new c(r.x,r.y);},p.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),A.call(this,null,!0);},p.prototype.quadraticCurveTo=function(t,e,r,n){if(isNaN(r)||isNaN(n)||isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new c(r,n)),o=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:i.x,y:i.y}),this.ctx.lastPoint=new c(i.x,i.y);},p.prototype.bezierCurveTo=function(t,e,r,n,i,o){if(isNaN(i)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var s=this.ctx.transform.applyToPoint(new c(i,o)),u=this.ctx.transform.applyToPoint(new c(t,e)),h=this.ctx.transform.applyToPoint(new c(r,n));this.path.push({type:"bct",x1:u.x,y1:u.y,x2:h.x,y2:h.y,x:s.x,y:s.y}),this.ctx.lastPoint=new c(s.x,s.y);},p.prototype.arc=function(t,e,r,n,i,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i))throw a.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var s=this.ctx.transform.applyToPoint(new c(t,e));t=s.x,e=s.y;var u=this.ctx.transform.applyToPoint(new c(0,r)),h=this.ctx.transform.applyToPoint(new c(0,0));r=Math.sqrt(Math.pow(u.x-h.x,2)+Math.pow(u.y-h.y,2));}Math.abs(i-n)>=2*Math.PI&&(n=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:r,startAngle:n,endAngle:i,counterclockwise:o});},p.prototype.arcTo=function(t,e,r,n,i){throw new Error("arcTo not implemented.")},p.prototype.rect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+r,e),this.lineTo(t+r,e+n),this.lineTo(t,e+n),this.lineTo(t,e),this.lineTo(t+r,e),this.lineTo(t,e);},p.prototype.fillRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!m.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,r,n),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin);}},p.prototype.strokeRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");v.call(this)||(this.beginPath(),this.rect(t,e,r,n),this.stroke());},p.prototype.clearRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,r,n));},p.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var n=new d(this.ctx);this.ctxStack.push(this.ctx),this.ctx=n;}},p.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin,this.lineDash=this.ctx.lineDash,this.lineDashOffset=this.ctx.lineDashOffset);},p.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var g=function(t){var e,r,n,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return {r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))e=0,r=0,n=0,i=0;else{var a=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==a)e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=1;else if(null!==(a=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t)))e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=parseFloat(a[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var o=new f$c(t);t=o.ok?o.toHex():"#000000";}4===t.length?(e=t.substring(1,2),e+=e,r=t.substring(2,3),r+=r,n=t.substring(3,4),n+=n):(e=t.substring(1,3),r=t.substring(3,5),n=t.substring(5,7)),e=parseInt(e,16),r=parseInt(r,16),n=parseInt(n,16);}}return {r:e,g:r,b:n,a:i,style:t}},m=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},v=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};p.prototype.fillText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw a.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(n=isNaN(n)?void 0:n,!m.call(this)){var i=q(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;C.call(this,{text:t,x:e,y:r,scale:o,angle:i,align:this.textAlign,maxWidth:n});}},p.prototype.strokeText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw a.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!v.call(this)){n=isNaN(n)?void 0:n;var i=q(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;C.call(this,{text:t,x:e,y:r,scale:o,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:n});}},p.prototype.measureText=function(t){if("string"!=typeof t)throw a.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,r=this.pdf.internal.scaleFactor,n=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*n/e.internal.scaleFactor,o=function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this};return new o({width:i*=Math.round(96*r/72*1e4)/1e4})},p.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var r=new h(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(r);},p.prototype.rotate=function(t){if(isNaN(t))throw a.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new h(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e);},p.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var r=new h(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(r);},p.prototype.transform=function(t,e,r,n,i,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(o))throw a.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var s=new h(t,e,r,n,i,o);this.ctx.transform=this.ctx.transform.multiply(s);},p.prototype.setTransform=function(t,e,r,n,i,a){t=isNaN(t)?1:t,e=isNaN(e)?0:e,r=isNaN(r)?0:r,n=isNaN(n)?1:n,i=isNaN(i)?0:i,a=isNaN(a)?0:a,this.ctx.transform=new h(t,e,r,n,i,a);};var b=function(){return this.margin[0]>0||this.margin[1]>0||this.margin[2]>0||this.margin[3]>0};p.prototype.drawImage=function(t,e,r,n,i,a,o,s,c){var l=this.pdf.getImageProperties(t),f=1,d=1,p=1,g=1;void 0!==n&&void 0!==s&&(p=s/n,g=c/i,f=l.width/n*s/n,d=l.height/i*c/i),void 0===a&&(a=e,o=r,e=0,r=0),void 0!==n&&void 0===s&&(s=n,c=i),void 0===n&&void 0===s&&(s=l.width,c=l.height);for(var m,v=this.ctx.transform.decompose(),w=q(v.rotate.shx),A=new h,S=(A=(A=(A=A.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new u(a-e*p,o-r*g,n*f,i*d)),_=y.call(this,S),P=[],k=0;k<_.length;k+=1)-1===P.indexOf(_[k])&&P.push(_[k]);if(L(P),this.autoPaging)for(var I=P[0],F=P[P.length-1],C=I;C<F+1;C++){this.pdf.setPage(C);var j=this.pdf.internal.pageSize.width-this.margin[3]-this.margin[1],O=1===C?this.posY+this.margin[0]:this.margin[0],B=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],M=this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2],E=1===C?0:B+(C-2)*M;if(0!==this.ctx.clip_path.length){var D=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(m,this.posX+this.margin[3],-E+O+this.ctx.prevPageLastElemOffset),x.call(this,"fill",!0),this.path=D;}var R=JSON.parse(JSON.stringify(S));R=N([R],this.posX+this.margin[3],-E+O+this.ctx.prevPageLastElemOffset)[0];var T=(C>I||C<F)&&b.call(this);T&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],j,M,null).clip().discardPath()),this.pdf.addImage(t,"JPEG",R.x,R.y,R.w,R.h,null,null,w),T&&this.pdf.restoreGraphicsState();}else this.pdf.addImage(t,"JPEG",S.x,S.y,S.w,S.h,null,null,w);};var y=function(t,e,r){var n=[];e=e||this.pdf.internal.pageSize.width,r=r||this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2];var i=this.posY+this.ctx.prevPageLastElemOffset;switch(t.type){default:case"mt":case"lt":n.push(Math.floor((t.y+i)/r)+1);break;case"arc":n.push(Math.floor((t.y+i-t.radius)/r)+1),n.push(Math.floor((t.y+i+t.radius)/r)+1);break;case"qct":var a=D(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);n.push(Math.floor((a.y+i)/r)+1),n.push(Math.floor((a.y+a.h+i)/r)+1);break;case"bct":var o=R(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);n.push(Math.floor((o.y+i)/r)+1),n.push(Math.floor((o.y+o.h+i)/r)+1);break;case"rect":n.push(Math.floor((t.y+i)/r)+1),n.push(Math.floor((t.y+t.h+i)/r)+1);}for(var s=0;s<n.length;s+=1)for(;this.pdf.internal.getNumberOfPages()<n[s];)w.call(this);return n},w=function(){var t=this.fillStyle,e=this.strokeStyle,r=this.font,n=this.lineCap,i=this.lineWidth,a=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=r,this.lineCap=n,this.lineWidth=i,this.lineJoin=a;},N=function(t,e,r){for(var n=0;n<t.length;n++)switch(t[n].type){case"bct":t[n].x2+=e,t[n].y2+=r;case"qct":t[n].x1+=e,t[n].y1+=r;case"mt":case"lt":case"arc":default:t[n].x+=e,t[n].y+=r;}return t},L=function(t){return t.sort((function(t,e){return t-e}))},A=function(t,e){for(var r,n,i=this.fillStyle,a=this.strokeStyle,o=this.lineCap,s=this.lineWidth,c=Math.abs(s*this.ctx.transform.scaleX),u=this.lineJoin,h=JSON.parse(JSON.stringify(this.path)),l=JSON.parse(JSON.stringify(this.path)),f=[],d=0;d<l.length;d++)if(void 0!==l[d].x)for(var p=y.call(this,l[d]),g=0;g<p.length;g+=1)-1===f.indexOf(p[g])&&f.push(p[g]);for(var m=0;m<f.length;m++)for(;this.pdf.internal.getNumberOfPages()<f[m];)w.call(this);if(L(f),this.autoPaging)for(var v=f[0],A=f[f.length-1],S=v;S<A+1;S++){this.pdf.setPage(S),this.fillStyle=i,this.strokeStyle=a,this.lineCap=o,this.lineWidth=c,this.lineJoin=u;var _=this.pdf.internal.pageSize.width-this.margin[3]-this.margin[1],P=1===S?this.posY+this.margin[0]:this.margin[0],k=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],I=this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2],F=1===S?0:k+(S-2)*I;if(0!==this.ctx.clip_path.length){var C=this.path;r=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(r,this.posX+this.margin[3],-F+P+this.ctx.prevPageLastElemOffset),x.call(this,t,!0),this.path=C;}if(n=JSON.parse(JSON.stringify(h)),this.path=N(n,this.posX+this.margin[3],-F+P+this.ctx.prevPageLastElemOffset),!1===e||0===S){var j=(S>v||S<A)&&b.call(this);j&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],_,I,null).clip().discardPath()),x.call(this,t,e),j&&this.pdf.restoreGraphicsState();}this.lineWidth=s;}else this.lineWidth=c,x.call(this,t,e),this.lineWidth=s;this.path=h;},x=function(t,e){if(("stroke"!==t||e||!v.call(this))&&("stroke"===t||e||!m.call(this))){for(var r,n,i=[],a=this.path,o=0;o<a.length;o++){var s=a[o];switch(s.type){case"begin":i.push({begin:!0});break;case"close":i.push({close:!0});break;case"mt":i.push({start:s,deltas:[],abs:[]});break;case"lt":var c=i.length;if(a[o-1]&&!isNaN(a[o-1].x)&&(r=[s.x-a[o-1].x,s.y-a[o-1].y],c>0))for(;c>=0;c--)if(!0!==i[c-1].close&&!0!==i[c-1].begin){i[c-1].deltas.push(r),i[c-1].abs.push(s);break}break;case"bct":r=[s.x1-a[o-1].x,s.y1-a[o-1].y,s.x2-a[o-1].x,s.y2-a[o-1].y,s.x-a[o-1].x,s.y-a[o-1].y],i[i.length-1].deltas.push(r);break;case"qct":var u=a[o-1].x+2/3*(s.x1-a[o-1].x),h=a[o-1].y+2/3*(s.y1-a[o-1].y),l=s.x+2/3*(s.x1-s.x),f=s.y+2/3*(s.y1-s.y),d=s.x,p=s.y;r=[u-a[o-1].x,h-a[o-1].y,l-a[o-1].x,f-a[o-1].y,d-a[o-1].x,p-a[o-1].y],i[i.length-1].deltas.push(r);break;case"arc":i.push({deltas:[],abs:[],arc:!0}),Array.isArray(i[i.length-1].abs)&&i[i.length-1].abs.push(s);}}n=e?null:"stroke"===t?"stroke":"fill";for(var g=!1,b=0;b<i.length;b++)if(i[b].arc)for(var y=i[b].abs,w=0;w<y.length;w++){var N=y[w];"arc"===N.type?P.call(this,N.x,N.y,N.radius,N.startAngle,N.endAngle,N.counterclockwise,void 0,e,!g):j.call(this,N.x,N.y),g=!0;}else if(!0===i[b].close)this.pdf.internal.out("h"),g=!1;else if(!0!==i[b].begin){var L=i[b].start.x,A=i[b].start.y;O.call(this,i[b].deltas,L,A),g=!0;}n&&k.call(this,n),e&&I.call(this);}},S=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,r=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-r;case"top":return t+e-r;case"hanging":return t+e-2*r;case"middle":return t+e/2-r;case"ideographic":return t;case"alphabetic":default:return t}},_=function(t){return t+this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor*(this.pdf.internal.getLineHeightFactor()-1)};p.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e]);},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},p.prototype.createPattern=function(){return this.createLinearGradient()},p.prototype.createRadialGradient=function(){return this.createLinearGradient()};var P=function(t,e,r,n,i,a,o,s,c){for(var u=M.call(this,r,n,i,a),h=0;h<u.length;h++){var l=u[h];0===h&&(c?F.call(this,l.x1+t,l.y1+e):j.call(this,l.x1+t,l.y1+e)),B.call(this,t,e,l.x2,l.y2,l.x3,l.y3,l.x4,l.y4);}s?I.call(this):k.call(this,o);},k=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f");}},I=function(){this.pdf.clip(),this.pdf.discardPath();},F=function(t,e){this.pdf.internal.out(n(t)+" "+i(e)+" m");},C=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left";}var r=this.pdf.getTextDimensions(t.text),n=S.call(this,t.y),i=_.call(this,n)-r.h,a=this.ctx.transform.applyToPoint(new c(t.x,n)),o=this.ctx.transform.decompose(),s=new h;s=(s=(s=s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);for(var l,f,d,p=this.ctx.transform.applyToRectangle(new u(t.x,n,r.w,r.h)),g=s.applyToRectangle(new u(t.x,i,r.w,r.h)),m=y.call(this,g),v=[],w=0;w<m.length;w+=1)-1===v.indexOf(m[w])&&v.push(m[w]);if(L(v),this.autoPaging)for(var A=v[0],P=v[v.length-1],k=A;k<P+1;k++){this.pdf.setPage(k);var I=1===k?this.posY+this.margin[0]:this.margin[0],F=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],C=this.pdf.internal.pageSize.height-this.margin[2],j=C-this.margin[0],O=this.pdf.internal.pageSize.width-this.margin[1],B=O-this.margin[3],M=1===k?0:F+(k-2)*j;if(0!==this.ctx.clip_path.length){var E=this.path;l=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(l,this.posX+this.margin[3],-1*M+I),x.call(this,"fill",!0),this.path=E;}var q=N([JSON.parse(JSON.stringify(g))],this.posX+this.margin[3],-M+I+this.ctx.prevPageLastElemOffset)[0];t.scale>=.01&&(f=this.pdf.internal.getFontSize(),this.pdf.setFontSize(f*t.scale),d=this.lineWidth,this.lineWidth=d*t.scale);var D="text"!==this.autoPaging;if(D||q.y+q.h<=C){if(D||q.y>=I&&q.x<=O){var R=D?t.text:this.pdf.splitTextToSize(t.text,t.maxWidth||O-q.x)[0],T=N([JSON.parse(JSON.stringify(p))],this.posX+this.margin[3],-M+I+this.ctx.prevPageLastElemOffset)[0],U=D&&(k>A||k<P)&&b.call(this);U&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],B,j,null).clip().discardPath()),this.pdf.text(R,T.x,T.y,{angle:t.angle,align:e,renderingMode:t.renderingMode}),U&&this.pdf.restoreGraphicsState();}}else q.y<C&&(this.ctx.prevPageLastElemOffset+=C-q.y);t.scale>=.01&&(this.pdf.setFontSize(f),this.lineWidth=d);}else t.scale>=.01&&(f=this.pdf.internal.getFontSize(),this.pdf.setFontSize(f*t.scale),d=this.lineWidth,this.lineWidth=d*t.scale),this.pdf.text(t.text,a.x+this.posX,a.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),t.scale>=.01&&(this.pdf.setFontSize(f),this.lineWidth=d);},j=function(t,e,r,a){r=r||0,a=a||0,this.pdf.internal.out(n(t+r)+" "+i(e+a)+" l");},O=function(t,e,r){return this.pdf.lines(t,e,r,null,null)},B=function(t,e,n,i,a,c,u,h){this.pdf.internal.out([r(o(n+t)),r(s(i+e)),r(o(a+t)),r(s(c+e)),r(o(u+t)),r(s(h+e)),"c"].join(" "));},M=function(t,e,r,n){for(var i=2*Math.PI,a=Math.PI/2;e>r;)e-=i;var o=Math.abs(r-e);o<i&&n&&(o=i-o);for(var s=[],c=n?-1:1,u=e;o>1e-5;){var h=u+c*Math.min(o,a);s.push(E.call(this,t,u,h)),o-=Math.abs(h-u),u=h;}return s},E=function(t,e,r){var n=(r-e)/2,i=t*Math.cos(n),a=t*Math.sin(n),o=i,s=-a,c=o*o+s*s,u=c+o*i+s*a,h=4/3*(Math.sqrt(2*c*u)-u)/(o*a-s*i),l=o-h*s,f=s+h*o,d=l,p=-f,g=n+e,m=Math.cos(g),v=Math.sin(g);return {x1:t*Math.cos(e),y1:t*Math.sin(e),x2:l*m-f*v,y2:l*v+f*m,x3:d*m-p*v,y3:d*v+p*m,x4:t*Math.cos(r),y4:t*Math.sin(r)}},q=function(t){return 180*t/Math.PI},D=function(t,e,r,n,i,a){var o=t+.5*(r-t),s=e+.5*(n-e),c=i+.5*(r-i),h=a+.5*(n-a),l=Math.min(t,i,o,c),f=Math.max(t,i,o,c),d=Math.min(e,a,s,h),p=Math.max(e,a,s,h);return new u(l,d,f-l,p-d)},R=function(t,e,r,n,i,a,o,s){var c,h,l,f,d,p,g,m,v,b,y,w,N,L,A=r-t,x=n-e,S=i-r,_=a-n,P=o-i,k=s-a;for(h=0;h<41;h++)v=(g=(l=t+(c=h/40)*A)+c*((d=r+c*S)-l))+c*(d+c*(i+c*P-d)-g),b=(m=(f=e+c*x)+c*((p=n+c*_)-f))+c*(p+c*(a+c*k-p)-m),0==h?(y=v,w=b,N=v,L=b):(y=Math.min(y,v),w=Math.min(w,b),N=Math.max(N,v),L=Math.max(L,b));return new u(Math.round(y),Math.round(w),Math.round(N-y),Math.round(L-w))},T=function(){if(this.prevLineDash||this.ctx.lineDash.length||this.ctx.lineDashOffset){var t,e,r=(t=this.ctx.lineDash,e=this.ctx.lineDashOffset,JSON.stringify({lineDash:t,lineDashOffset:e}));this.prevLineDash!==r&&(this.pdf.setLineDash(this.ctx.lineDash,this.ctx.lineDashOffset),this.prevLineDash=r);}};}(E.API),
/**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var r=function(t){var e,r,n,i,a,o,s,c,u,h;for(/[^\x00-\xFF]/.test(t),r=[],n=0,i=(t+=e="\0\0\0\0".slice(t.length%4||4)).length;i>n;n+=4)0!==(a=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(o=(a=((a=((a=((a=(a-(h=a%85))/85)-(u=a%85))/85)-(c=a%85))/85)-(s=a%85))/85)%85,r.push(o+33,s+33,c+33,u+33,h+33)):r.push(122);return function(t,e){for(var r=e;r>0;r--)t.pop();}(r,e.length),String.fromCharCode.apply(String,r)+"~>"},n=function(t){var e,r,n,i,a,o=String,s="length",c=255,u="charCodeAt",h="slice",l="replace";for(t[h](-2),t=t[h](0,-2)[l](/\s/g,"")[l]("z","!!!!!"),n=[],i=0,a=(t+=e="uuuuu"[h](t[s]%5||5))[s];a>i;i+=5)r=52200625*(t[u](i)-33)+614125*(t[u](i+1)-33)+7225*(t[u](i+2)-33)+85*(t[u](i+3)-33)+(t[u](i+4)-33),n.push(c&r>>24,c&r>>16,c&r>>8,c&r);return function(t,e){for(var r=e;r>0;r--)t.pop();}(n,e[s]),o.fromCharCode.apply(o,n)},i=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return "";for(var r="",n=0;n<t.length;n+=2)r+=String.fromCharCode("0x"+(t[n]+t[n+1]));return r},a=function(t){for(var r=new Uint8Array(t.length),n=t.length;n--;)r[n]=t.charCodeAt(n);return t=(r=zlibSync(r)).reduce((function(t,e){return t+String.fromCharCode(e)}),"")};t.processDataByFilters=function(t,e){var o=0,s=t||"",c=[];for("string"==typeof(e=e||[])&&(e=[e]),o=0;o<e.length;o+=1)switch(e[o]){case"ASCII85Decode":case"/ASCII85Decode":s=n(s),c.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":s=r(s),c.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":s=i(s),c.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":s=s.split("").map((function(t){return ("0"+t.charCodeAt().toString(16)).slice(-2)})).join("")+">",c.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":s=a(s),c.push("/FlateDecode");break;default:throw new Error('The filter: "'+e[o]+'" is not implemented')}return {data:s,reverseChain:c.reverse().join(" ")}};}(E.API),
/**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.loadFile=function(t,e,r){return function(t,e,r){e=!1!==e,r="function"==typeof r?r:function(){};var n=void 0;try{n=function(t,e,r){var n=new XMLHttpRequest,i=0,a=function(t){var e=t.length,r=[],n=String.fromCharCode;for(i=0;i<e;i+=1)r.push(n(255&t.charCodeAt(i)));return r.join("")};if(n.open("GET",t,!e),n.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(n.onload=function(){200===n.status?r(a(this.responseText)):r(void 0);}),n.send(null),e&&200===n.status)return a(n.responseText)}(t,e,r);}catch(t){}return n}(t,e,r)},t.loadImageFile=t.loadFile;}(E.API),function(e){function r(){return (n.html2canvas?Promise.resolve(n.html2canvas):Promise.resolve().then(function () { return html2canvas$1; })).catch((function(t){return Promise.reject(new Error("Could not load html2canvas: "+t))})).then((function(t){return t.default?t.default:t}))}function i(){return (n.DOMPurify?Promise.resolve(n.DOMPurify):Promise.resolve().then(function () { return purify$1; })).catch((function(t){return Promise.reject(new Error("Could not load dompurify: "+t))})).then((function(t){return t.default?t.default:t}))}var a=function(e){var r=t(e);return "undefined"===r?"undefined":"string"===r||e instanceof String?"string":"number"===r||e instanceof Number?"number":"function"===r||e instanceof Function?"function":e&&e.constructor===Array?"array":e&&1===e.nodeType?"element":"object"===r?"object":"unknown"},o=function(t,e){var r=document.createElement(t);for(var n in e.className&&(r.className=e.className),e.innerHTML&&e.dompurify&&(r.innerHTML=e.dompurify.sanitize(e.innerHTML)),e.style)r.style[n]=e.style[n];return r},s=function t(e){var r=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),n=t.convert(Promise.resolve(),r);return n=(n=n.setProgress(1,t,1,[t])).set(e)};(s.prototype=Object.create(Promise.prototype)).constructor=s,s.convert=function(t,e){return t.__proto__=e||s.prototype,t},s.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{},backgroundColor:"transparent"}},s.prototype.from=function(t,e){return this.then((function(){switch(e=e||function(t){switch(a(t)){case"string":return "string";case"element":return "canvas"===t.nodeName.toLowerCase()?"canvas":"element";default:return "unknown"}}(t)){case"string":return this.then(i).then((function(e){return this.set({src:o("div",{innerHTML:t,dompurify:e})})}));case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}}))},s.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},s.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then((function(){var t={position:"relative",display:"inline-block",width:("number"!=typeof this.opt.width||isNaN(this.opt.width)||"number"!=typeof this.opt.windowWidth||isNaN(this.opt.windowWidth)?Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth):this.opt.windowWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:this.opt.backgroundColor},e=function t(e,r){for(var n=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==r&&1===i.nodeType&&"SCRIPT"===i.nodeName||n.appendChild(t(i,r));return 1===e.nodeType&&("CANVAS"===e.nodeName?(n.width=e.width,n.height=e.height,n.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(n.value=e.value),n.addEventListener("load",(function(){n.scrollTop=e.scrollTop,n.scrollLeft=e.scrollLeft;}),!0)),n}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=o("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=o("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(o("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px";}))},s.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(r).then((function(t){var e=Object.assign({},this.opt.html2canvas);return delete e.onrendered,t(this.prop.container,e)})).then((function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay);}))},s.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(r).then((function(t){var e=this.opt.jsPDF,r=this.opt.fontFaces,n="number"!=typeof this.opt.width||isNaN(this.opt.width)||"number"!=typeof this.opt.windowWidth||isNaN(this.opt.windowWidth)?1:this.opt.width/this.opt.windowWidth,i=Object.assign({async:!0,allowTaint:!0,scale:n,scrollX:this.opt.scrollX||0,scrollY:this.opt.scrollY||0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete i.onrendered,e.context2d.autoPaging=void 0===this.opt.autoPaging||this.opt.autoPaging,e.context2d.posX=this.opt.x,e.context2d.posY=this.opt.y,e.context2d.margin=this.opt.margin,e.context2d.fontFaces=r,r)for(var a=0;a<r.length;++a){var o=r[a],s=o.src.find((function(t){return "truetype"===t.format}));s&&e.addFont(s.url,o.ref.name,o.ref.style);}return i.windowHeight=i.windowHeight||0,i.windowHeight=0==i.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):i.windowHeight,e.context2d.save(!0),t(this.prop.container,i)})).then((function(t){this.opt.jsPDF.context2d.restore(!0),(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay);}))},s.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then((function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t;}))},s.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then((function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF;}))},s.prototype.output=function(t,e,r){return "img"===(r=r||"pdf").toLowerCase()||"image"===r.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},s.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){return this.prop.pdf.output(t,e)}))},s.prototype.outputImg=function(t){return this.thenList([function(){return this.prop.img||this.toImg()}]).then((function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}}))},s.prototype.save=function(t){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then((function(){this.prop.pdf.save(this.opt.filename);}))},s.prototype.doCallback=function(){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){this.prop.callback(this.prop.pdf);}))},s.prototype.set=function(t){if("object"!==a(t))return this;var e=Object.keys(t||{}).map((function(e){if(e in s.template.prop)return function(){this.prop[e]=t[e];};switch(e){case"margin":return this.setMargin.bind(this,t.margin);case"jsPDF":return function(){return this.opt.jsPDF=t.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,t.pageSize);default:return function(){this.opt[e]=t[e];}}}),this);return this.then((function(){return this.thenList(e)}))},s.prototype.get=function(t,e){return this.then((function(){var r=t in s.template.prop?this.prop[t]:this.opt[t];return e?e(r):r}))},s.prototype.setMargin=function(t){return this.then((function(){switch(a(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t;})).then(this.setPageSize)},s.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then((function(){(t=t||E.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t;}))},s.prototype.setProgress=function(t,e,r,n){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=r&&(this.progress.n=r),null!=n&&(this.progress.stack=n),this.progress.ratio=this.progress.val/this.progress.state,this},s.prototype.updateProgress=function(t,e,r,n){return this.setProgress(t?this.progress.val+t:null,e||null,r?this.progress.n+r:null,n?this.progress.stack.concat(n):null)},s.prototype.then=function(t,e){var r=this;return this.thenCore(t,e,(function(t,e){return r.updateProgress(null,null,1,[t]),Promise.prototype.then.call(this,(function(e){return r.updateProgress(null,t),e})).then(t,e).then((function(t){return r.updateProgress(1),t}))}))},s.prototype.thenCore=function(t,e,r){r=r||Promise.prototype.then;t&&(t=t.bind(this)),e&&(e=e.bind(this));var n=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?this:s.convert(Object.assign({},this),Promise.prototype),i=r.call(n,t,e);return s.convert(i,this.__proto__)},s.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},s.prototype.thenList=function(t){var e=this;return t.forEach((function(t){e=e.thenCore(t);})),e},s.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return s.convert(e,this)},s.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},s.prototype.error=function(t){return this.then((function(){throw new Error(t)}))},s.prototype.using=s.prototype.set,s.prototype.saveAs=s.prototype.save,s.prototype.export=s.prototype.output,s.prototype.run=s.prototype.then,E.getPageSize=function(e,r,n){if("object"===t(e)){var i=e;e=i.orientation,r=i.unit||r,n=i.format||n;}r=r||"mm",n=n||"a4",e=(""+(e||"P")).toLowerCase();var a,o=(""+n).toLowerCase(),s={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(r){case"pt":a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw"Invalid unit: "+r}var c,u=0,h=0;if(s.hasOwnProperty(o))u=s[o][1]/a,h=s[o][0]/a;else try{u=n[1],h=n[0];}catch(t){throw new Error("Invalid format: "+n)}if("p"===e||"portrait"===e)e="p",h>u&&(c=h,h=u,u=c);else{if("l"!==e&&"landscape"!==e)throw"Invalid orientation: "+e;e="l",u>h&&(c=h,h=u,u=c);}return {width:h,height:u,unit:r,k:a,orientation:e}},e.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.fontFaces=e.fontFaces?e.fontFaces.map(jt):null;var r=new s(e);return e.worker?r:r.from(t).doCallback()};}(E.API),E.API.addJS=function(t){return Ht=t,this.internal.events.subscribe("postPutResources",(function(){Ut=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(Ut+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),zt=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+Ht+")"),this.internal.out(">>"),this.internal.out("endobj");})),this.internal.events.subscribe("putCatalog",(function(){void 0!==Ut&&void 0!==zt&&this.internal.out("/Names <</JavaScript "+Ut+" 0 R>>");})),this},
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e;t.events.push(["postPutResources",function(){var t=this,r=/^(\d+) 0 obj$/;if(this.outline.root.children.length>0)for(var n=t.outline.render().split(/\r\n/),i=0;i<n.length;i++){var a=n[i],o=r.exec(a);if(null!=o){var s=o[1];t.internal.newObjectDeferredBegin(s,!1);}t.internal.write(a);}if(this.outline.createNamedDestinations){var c=this.internal.pages.length,u=[];for(i=0;i<c;i++){var h=t.internal.newObject();u.push(h);var l=t.internal.getPageInfo(i+1);t.internal.write("<< /D["+l.objId+" 0 R /XYZ null null null]>> endobj");}var f=t.internal.newObject();t.internal.write("<< /Names [ ");for(i=0;i<u.length;i++)t.internal.write("(page_"+(i+1)+")"+u[i]+" 0 R");t.internal.write(" ] >>","endobj"),e=t.internal.newObject(),t.internal.write("<< /Dests "+f+" 0 R"),t.internal.write(">>","endobj");}}]),t.events.push(["putCatalog",function(){this.outline.root.children.length>0&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+e+" 0 R"));}]),t.events.push(["initialized",function(){var t=this;t.outline={createNamedDestinations:!1,root:{children:[]}},t.outline.add=function(t,e,r){var n={title:e,options:r,children:[]};return null==t&&(t=this.root),t.children.push(n),n},t.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=t,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},t.outline.genIds_r=function(e){e.id=t.internal.newObjectDeferred();for(var r=0;r<e.children.length;r++)this.genIds_r(e.children[r]);},t.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),t.children.length>0&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd();},t.outline.renderItems=function(e){for(var r=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<e.children.length;n++){var i=e.children[n];this.objStart(i),this.line("/Title "+this.makeString(i.title)),this.line("/Parent "+this.makeRef(e)),n>0&&this.line("/Prev "+this.makeRef(e.children[n-1])),n<e.children.length-1&&this.line("/Next "+this.makeRef(e.children[n+1])),i.children.length>0&&(this.line("/First "+this.makeRef(i.children[0])),this.line("/Last "+this.makeRef(i.children[i.children.length-1])));var a=this.count=this.count_r({count:0},i);if(a>0&&this.line("/Count "+a),i.options&&i.options.pageNumber){var o=t.internal.getPageInfo(i.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+r(0)+" 0]");}this.objEnd();}for(var s=0;s<e.children.length;s++)this.renderItems(e.children[s]);},t.outline.line=function(t){this.ctx.val+=t+"\r\n";},t.outline.makeRef=function(t){return t.id+" 0 R"},t.outline.makeString=function(e){return "("+t.internal.pdfEscape(e)+")"},t.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n";},t.outline.objEnd=function(){this.ctx.val+=">> \r\nendobj\r\n";},t.outline.count_r=function(t,e){for(var r=0;r<e.children.length;r++)t.count++,this.count_r(t,e.children[r]);return t.count};}]);}(E.API),
/**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=[192,193,194,195,196,197,198,199];t.processJPEG=function(t,r,n,i,a,o){var s,c=this.decode.DCT_DECODE,u=null;if("string"==typeof t||this.__addimage__.isArrayBuffer(t)||this.__addimage__.isArrayBufferView(t)){switch(t=a||t,t=this.__addimage__.isArrayBuffer(t)?new Uint8Array(t):t,(s=function(t){for(var r,n=256*t.charCodeAt(4)+t.charCodeAt(5),i=t.length,a={width:0,height:0,numcomponents:1},o=4;o<i;o+=2){if(o+=n,-1!==e.indexOf(t.charCodeAt(o+1))){r=256*t.charCodeAt(o+5)+t.charCodeAt(o+6),a={width:256*t.charCodeAt(o+7)+t.charCodeAt(o+8),height:r,numcomponents:t.charCodeAt(o+9)};break}n=256*t.charCodeAt(o+2)+t.charCodeAt(o+3);}return a}(t=this.__addimage__.isArrayBufferView(t)?this.__addimage__.arrayBufferToBinaryString(t):t)).numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;case 3:o=this.color_spaces.DEVICE_RGB;}u={data:t,width:s.width,height:s.height,colorSpace:o,bitsPerComponent:8,filter:c,index:r,alias:n};}return u};}(E.API);var Vt,Gt,Yt,Jt,Xt,Kt=function(){var t,e,i;function a(t){var e,r,n,i,a,o,s,c,u,h,l,f,d,p;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},o=null;;){switch(e=this.readUInt32(),u=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":o&&this.animation.frames.push(o),this.pos+=4,o={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},a=this.readUInt16(),i=this.readUInt16()||100,o.delay=1e3*a/i,o.disposeOp=this.data[this.pos++],o.blendOp=this.data[this.pos++],o.data=[];break;case"IDAT":case"fdAT":for("fdAT"===u&&(this.pos+=4,e-=4),t=(null!=o?o.data:void 0)||this.imgData,f=0;0<=e?f<e:f>e;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(n=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>n)throw new Error("More transparent colors than palette size");if((h=n-this.transparency.indexed.length)>0)for(d=0;0<=h?d<h:d>h;0<=h?++d:--d)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e);}break;case"tEXt":s=(l=this.read(e)).indexOf(0),c=String.fromCharCode.apply(String,l.slice(0,s)),this.text[c]=String.fromCharCode.apply(String,l.slice(s+1));break;case"IEND":return o&&this.animation.frames.push(o),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(p=this.colorType)||6===p,r=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*r,this.colorSpace=function(){switch(this.colors){case 1:return "DeviceGray";case 3:return "DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e;}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}a.prototype.read=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;0<=t?++e:--e)r.push(this.data[this.pos++]);return r},a.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},a.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},a.prototype.decodePixels=function(t){var e=this.pixelBitlength/8,n=new Uint8Array(this.width*this.height*e),i=0,a=this;if(null==t&&(t=this.imgData),0===t.length)return new Uint8Array(0);function o(r,o,s,c){var u,h,l,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,I,F=Math.ceil((a.width-r)/s),C=Math.ceil((a.height-o)/c),j=a.width==F&&a.height==C;for(L=e*F,w=j?n:new Uint8Array(L*C),p=t.length,N=0,h=0;N<C&&i<p;){switch(t[i++]){case 0:for(f=S=0;S<L;f=S+=1)w[h++]=t[i++];break;case 1:for(f=_=0;_<L;f=_+=1)u=t[i++],d=f<e?0:w[h-e],w[h++]=(u+d)%256;break;case 2:for(f=P=0;P<L;f=P+=1)u=t[i++],l=(f-f%e)/e,A=N&&w[(N-1)*L+l*e+f%e],w[h++]=(A+u)%256;break;case 3:for(f=k=0;k<L;f=k+=1)u=t[i++],l=(f-f%e)/e,d=f<e?0:w[h-e],A=N&&w[(N-1)*L+l*e+f%e],w[h++]=(u+Math.floor((d+A)/2))%256;break;case 4:for(f=I=0;I<L;f=I+=1)u=t[i++],l=(f-f%e)/e,d=f<e?0:w[h-e],0===N?A=x=0:(A=w[(N-1)*L+l*e+f%e],x=l&&w[(N-1)*L+(l-1)*e+f%e]),g=d+A-x,m=Math.abs(g-d),b=Math.abs(g-A),y=Math.abs(g-x),v=m<=b&&m<=y?d:b<=y?A:x,w[h++]=(u+v)%256;break;default:throw new Error("Invalid filter algorithm: "+t[i-1])}if(!j){var O=((o+N*c)*a.width+r)*e,B=N*L;for(f=0;f<F;f+=1){for(var M=0;M<e;M+=1)n[O++]=w[B++];O+=(s-1)*e;}}N++;}}return t=unzlibSync(t),1==a.interlaceMethod?(o(0,0,8,8),o(4,0,8,8),o(0,4,4,8),o(2,0,4,4),o(0,2,2,4),o(1,0,2,2),o(0,1,1,2)):o(0,0,1,1),n},a.prototype.decodePalette=function(){var t,e,r,n,i,a,o,s,c;for(r=this.palette,a=this.transparency.indexed||[],i=new Uint8Array((a.length||0)+r.length),n=0,t=0,e=o=0,s=r.length;o<s;e=o+=3)i[n++]=r[e],i[n++]=r[e+1],i[n++]=r[e+2],i[n++]=null!=(c=a[t++])?c:255;return i},a.prototype.copyToImageData=function(t,e){var r,n,i,a,o,s,c,u,h,l,f;if(n=this.colors,h=null,r=this.hasAlphaChannel,this.palette.length&&(h=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),n=4,r=!0),u=(i=t.data||t).length,o=h||e,a=s=0,1===n)for(;a<u;)c=h?4*e[a/4]:s,l=o[c++],i[a++]=l,i[a++]=l,i[a++]=l,i[a++]=r?o[c++]:255,s=c;else for(;a<u;)c=h?4*e[a/4]:s,i[a++]=o[c++],i[a++]=o[c++],i[a++]=o[c++],i[a++]=r?o[c++]:255,s=c;},a.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};var o=function(){if("[object Window]"===Object.prototype.toString.call(n)){try{e=n.document.createElement("canvas"),i=e.getContext("2d");}catch(t){return !1}return !0}return !1};return o(),t=function(t){var r;if(!0===o())return i.width=t.width,i.height=t.height,i.clearRect(0,0,t.width,t.height),i.putImageData(t,0,0),(r=new Image).src=e.toDataURL(),r;throw new Error("This method requires a Browser with Canvas-capability.")},a.prototype.decodeFrames=function(e){var r,n,i,a,o,s,c,u;if(this.animation){for(u=[],n=o=0,s=(c=this.animation.frames).length;o<s;n=++o)r=c[n],i=e.createImageData(r.width,r.height),a=this.decodePixels(new Uint8Array(r.data)),this.copyToImageData(i,a),r.imageData=i,u.push(r.image=t(i));return u}},a.prototype.renderFrame=function(t,e){var r,n,i;return r=(n=this.animation.frames)[e],i=n[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===r.blendOp&&t.clearRect(r.xOffset,r.yOffset,r.width,r.height),t.drawImage(r.image,r.xOffset,r.yOffset)},a.prototype.animate=function(t){var e,r,n,i,a,o,s=this;return r=0,o=this.animation,i=o.numFrames,n=o.frames,a=o.numPlays,(e=function(){var o,c;if(o=r++%i,c=n[o],s.renderFrame(t,o),i>1&&r/i<a)return s.animation._timeout=setTimeout(e,c.delay)})()},a.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},a.prototype.render=function(t){var e,r;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(r=e.createImageData(this.width,this.height),this.copyToImageData(r,this.decodePixels()),e.putImageData(r,0,0))},a}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */
function Zt(t){var e=0;if(71!==t[e++]||73!==t[e++]||70!==t[e++]||56!==t[e++]||56!=(t[e++]+1&253)||97!==t[e++])throw new Error("Invalid GIF 87a/89a header.");var r=t[e++]|t[e++]<<8,n=t[e++]|t[e++]<<8,i=t[e++],a=i>>7,o=1<<(7&i)+1;t[e++];t[e++];var s=null,c=null;a&&(s=e,c=o,e+=3*o);var u=!0,h=[],l=0,f=null,d=0,p=null;for(this.width=r,this.height=n;u&&e<t.length;)switch(t[e++]){case 33:switch(t[e++]){case 255:if(11!==t[e]||78==t[e+1]&&69==t[e+2]&&84==t[e+3]&&83==t[e+4]&&67==t[e+5]&&65==t[e+6]&&80==t[e+7]&&69==t[e+8]&&50==t[e+9]&&46==t[e+10]&&48==t[e+11]&&3==t[e+12]&&1==t[e+13]&&0==t[e+16])e+=14,p=t[e++]|t[e++]<<8,e++;else for(e+=12;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P;}break;case 249:if(4!==t[e++]||0!==t[e+4])throw new Error("Invalid graphics extension block.");var g=t[e++];l=t[e++]|t[e++]<<8,f=t[e++],0==(1&g)&&(f=null),d=g>>2&7,e++;break;case 254:for(;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P;}break;default:throw new Error("Unknown graphic control label: 0x"+t[e-1].toString(16))}break;case 44:var m=t[e++]|t[e++]<<8,v=t[e++]|t[e++]<<8,b=t[e++]|t[e++]<<8,y=t[e++]|t[e++]<<8,w=t[e++],N=w>>6&1,L=1<<(7&w)+1,A=s,x=c,S=!1;if(w>>7){S=!0;A=e,x=L,e+=3*L;}var _=e;for(e++;;){var P;if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P;}h.push({x:m,y:v,width:b,height:y,has_local_palette:S,palette_offset:A,palette_size:x,data_offset:_,data_length:e-_,transparent_index:f,interlaced:!!N,delay:l,disposal:d});break;case 59:u=!1;break;default:throw new Error("Unknown gif block: 0x"+t[e-1].toString(16))}this.numFrames=function(){return h.length},this.loopCount=function(){return p},this.frameInfo=function(t){if(t<0||t>=h.length)throw new Error("Frame index out of range.");return h[t]},this.decodeAndBlitFrameBGRA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);$t(t,i.data_offset,o,a);var s=i.palette_offset,c=i.transparent_index;null===c&&(c=256);var u=i.width,h=r-u,l=u,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*h;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===l&&(l=u,(p+=g)>=d&&(g=4*h+4*r*(m-1),p=f+(u+h)*(m<<1),m>>=1)),y===c)p+=4;else{var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=L,n[p++]=N,n[p++]=w,n[p++]=255;}--l;}},this.decodeAndBlitFrameRGBA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);$t(t,i.data_offset,o,a);var s=i.palette_offset,c=i.transparent_index;null===c&&(c=256);var u=i.width,h=r-u,l=u,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*h;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===l&&(l=u,(p+=g)>=d&&(g=4*h+4*r*(m-1),p=f+(u+h)*(m<<1),m>>=1)),y===c)p+=4;else{var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=w,n[p++]=N,n[p++]=L,n[p++]=255;}--l;}};}function $t(t,e,r,n){for(var i=t[e++],o=1<<i,s=o+1,c=s+1,u=i+1,h=(1<<u)-1,l=0,f=0,d=0,p=t[e++],g=new Int32Array(4096),m=null;;){for(;l<16&&0!==p;)f|=t[e++]<<l,l+=8,1===p?p=t[e++]:--p;if(l<u)break;var v=f&h;if(f>>=u,l-=u,v!==o){if(v===s)break;for(var b=v<c?v:m,y=0,w=b;w>o;)w=g[w]>>8,++y;var N=w;if(d+y+(b!==v?1:0)>n)return void a.log("Warning, gif stream longer than expected.");r[d++]=N;var L=d+=y;for(b!==v&&(r[d++]=N),w=b;y--;)w=g[w],r[--L]=255&w,w>>=8;null!==m&&c<4096&&(g[c++]=m<<8|N,c>=h+1&&u<12&&(++u,h=h<<1|1)),m=v;}else c=s+1,h=(1<<(u=i+1))-1,m=null;}return d!==n&&a.log("Warning, gif stream shorter than expected."),r}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/function Qt(t){var e,r,n,i,a,o=Math.floor,s=new Array(64),c=new Array(64),u=new Array(64),h=new Array(64),l=new Array(65535),f=new Array(65535),d=new Array(64),p=new Array(64),g=[],m=0,v=7,b=new Array(64),y=new Array(64),w=new Array(64),N=new Array(256),L=new Array(2048),A=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],x=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],S=[0,1,2,3,4,5,6,7,8,9,10,11],_=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],P=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],k=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],I=[0,1,2,3,4,5,6,7,8,9,10,11],F=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],C=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function j(t,e){for(var r=0,n=0,i=new Array,a=1;a<=16;a++){for(var o=1;o<=t[a];o++)i[e[n]]=[],i[e[n]][0]=r,i[e[n]][1]=a,n++,r++;r*=2;}return i}function O(t){for(var e=t[0],r=t[1]-1;r>=0;)e&1<<r&&(m|=1<<v),r--,--v<0&&(255==m?(B(255),B(0)):B(m),v=7,m=0);}function B(t){g.push(t);}function M(t){B(t>>8&255),B(255&t);}function E(t,e,r,n,i){for(var a,o=i[0],s=i[240],c=function(t,e){var r,n,i,a,o,s,c,u,h,l,f=0;for(h=0;h<8;++h){r=t[f],n=t[f+1],i=t[f+2],a=t[f+3],o=t[f+4],s=t[f+5],c=t[f+6];var p=r+(u=t[f+7]),g=r-u,m=n+c,v=n-c,b=i+s,y=i-s,w=a+o,N=a-o,L=p+w,A=p-w,x=m+b,S=m-b;t[f]=L+x,t[f+4]=L-x;var _=.707106781*(S+A);t[f+2]=A+_,t[f+6]=A-_;var P=.382683433*((L=N+y)-(S=v+g)),k=.5411961*L+P,I=1.306562965*S+P,F=.707106781*(x=y+v),C=g+F,j=g-F;t[f+5]=j+k,t[f+3]=j-k,t[f+1]=C+I,t[f+7]=C-I,f+=8;}for(f=0,h=0;h<8;++h){r=t[f],n=t[f+8],i=t[f+16],a=t[f+24],o=t[f+32],s=t[f+40],c=t[f+48];var O=r+(u=t[f+56]),B=r-u,M=n+c,E=n-c,q=i+s,D=i-s,R=a+o,T=a-o,U=O+R,z=O-R,H=M+q,W=M-q;t[f]=U+H,t[f+32]=U-H;var V=.707106781*(W+z);t[f+16]=z+V,t[f+48]=z-V;var G=.382683433*((U=T+D)-(W=E+B)),Y=.5411961*U+G,J=1.306562965*W+G,X=.707106781*(H=D+E),K=B+X,Z=B-X;t[f+40]=Z+Y,t[f+24]=Z-Y,t[f+8]=K+J,t[f+56]=K-J,f++;}for(h=0;h<64;++h)l=t[h]*e[h],d[h]=l>0?l+.5|0:l-.5|0;return d}(t,e),u=0;u<64;++u)p[A[u]]=c[u];var h=p[0]-r;r=p[0],0==h?O(n[0]):(O(n[f[a=32767+h]]),O(l[a]));for(var g=63;g>0&&0==p[g];)g--;if(0==g)return O(o),r;for(var m,v=1;v<=g;){for(var b=v;0==p[v]&&v<=g;)++v;var y=v-b;if(y>=16){m=y>>4;for(var w=1;w<=m;++w)O(s);y&=15;}a=32767+p[v],O(i[(y<<4)+f[a]]),O(l[a]),v++;}return 63!=g&&O(o),r}function q(t){(t=Math.min(Math.max(t,1),100),a!=t)&&(!function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],r=0;r<64;r++){var n=o((e[r]*t+50)/100);n=Math.min(Math.max(n,1),255),s[A[r]]=n;}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],a=0;a<64;a++){var l=o((i[a]*t+50)/100);l=Math.min(Math.max(l,1),255),c[A[a]]=l;}for(var f=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],d=0,p=0;p<8;p++)for(var g=0;g<8;g++)u[d]=1/(s[A[d]]*f[p]*f[g]*8),h[d]=1/(c[A[d]]*f[p]*f[g]*8),d++;}(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),a=t);}this.encode=function(t,a){a&&q(a),g=new Array,m=0,v=7,M(65496),M(65504),M(16),B(74),B(70),B(73),B(70),B(0),B(1),B(1),B(0),M(1),M(1),B(0),B(0),function(){M(65499),M(132),B(0);for(var t=0;t<64;t++)B(s[t]);B(1);for(var e=0;e<64;e++)B(c[e]);}(),function(t,e){M(65472),M(17),B(8),M(e),M(t),B(3),B(1),B(17),B(0),B(2),B(17),B(1),B(3),B(17),B(1);}(t.width,t.height),function(){M(65476),M(418),B(0);for(var t=0;t<16;t++)B(x[t+1]);for(var e=0;e<=11;e++)B(S[e]);B(16);for(var r=0;r<16;r++)B(_[r+1]);for(var n=0;n<=161;n++)B(P[n]);B(1);for(var i=0;i<16;i++)B(k[i+1]);for(var a=0;a<=11;a++)B(I[a]);B(17);for(var o=0;o<16;o++)B(F[o+1]);for(var s=0;s<=161;s++)B(C[s]);}(),M(65498),M(12),B(3),B(1),B(0),B(2),B(17),B(3),B(17),B(0),B(63),B(0);var o=0,l=0,f=0;m=0,v=7,this.encode.displayName="_encode_";for(var d,p,N,A,j,D,R,T,U,z=t.data,H=t.width,W=t.height,V=4*H,G=0;G<W;){for(d=0;d<V;){for(j=V*G+d,R=-1,T=0,U=0;U<64;U++)D=j+(T=U>>3)*V+(R=4*(7&U)),G+T>=W&&(D-=V*(G+1+T-W)),d+R>=V&&(D-=d+R-V+4),p=z[D++],N=z[D++],A=z[D++],b[U]=(L[p]+L[N+256>>0]+L[A+512>>0]>>16)-128,y[U]=(L[p+768>>0]+L[N+1024>>0]+L[A+1280>>0]>>16)-128,w[U]=(L[p+1280>>0]+L[N+1536>>0]+L[A+1792>>0]>>16)-128;o=E(b,u,o,e,n),l=E(y,h,l,r,i),f=E(w,h,f,r,i),d+=32;}G+=8;}if(v>=0){var Y=[];Y[1]=v+1,Y[0]=(1<<v+1)-1,O(Y);}return M(65497),new Uint8Array(g)},t=t||50,function(){for(var t=String.fromCharCode,e=0;e<256;e++)N[e]=t(e);}(),e=j(x,S),r=j(k,I),n=j(_,P),i=j(F,C),function(){for(var t=1,e=2,r=1;r<=15;r++){for(var n=t;n<e;n++)f[32767+n]=r,l[32767+n]=[],l[32767+n][1]=r,l[32767+n][0]=n;for(var i=-(e-1);i<=-t;i++)f[32767+i]=r,l[32767+i]=[],l[32767+i][1]=r,l[32767+i][0]=e-1+i;t<<=1,e<<=1;}}(),function(){for(var t=0;t<256;t++)L[t]=19595*t,L[t+256>>0]=38470*t,L[t+512>>0]=7471*t+32768,L[t+768>>0]=-11059*t,L[t+1024>>0]=-21709*t,L[t+1280>>0]=32768*t+8421375,L[t+1536>>0]=-27439*t,L[t+1792>>0]=-5329*t;}(),q(t);}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */function te(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR();}function ee(t){function e(t){if(!t)throw Error("assert :P")}function r(t,e,r){for(var n=0;4>n;n++)if(t[e+n]!=r.charCodeAt(n))return !0;return !1}function n(t,e,r,n,i){for(var a=0;a<i;a++)t[e+a]=r[n+a];}function i(t,e,r,n){for(var i=0;i<n;i++)t[e+i]=r;}function a(t){return new Int32Array(t)}function o(t,e){for(var r=[],n=0;n<t;n++)r.push(new e);return r}function s(t,e){var r=[];return function t(r,n,i){for(var a=i[n],o=0;o<a&&(r.push(i.length>n+1?[]:new e),!(i.length<n+1));o++)t(r[o],n+1,i);}(r,0,t),r}var c=function(){var t=this;function c(t,e){for(var r=1<<e-1>>>0;t&r;)r>>>=1;return r?(t&r-1)+r:t}function u(t,r,n,i,a){e(!(i%n));do{t[r+(i-=n)]=a;}while(0<i)}function h(t,r,n,i,o){if(e(2328>=o),512>=o)var s=a(512);else if(null==(s=a(o)))return 0;return function(t,r,n,i,o,s){var h,f,d=r,p=1<<n,g=a(16),m=a(16);for(e(0!=o),e(null!=i),e(null!=t),e(0<n),f=0;f<o;++f){if(15<i[f])return 0;++g[i[f]];}if(g[0]==o)return 0;for(m[1]=0,h=1;15>h;++h){if(g[h]>1<<h)return 0;m[h+1]=m[h]+g[h];}for(f=0;f<o;++f)h=i[f],0<i[f]&&(s[m[h]++]=f);if(1==m[15])return (i=new l).g=0,i.value=s[0],u(t,d,1,p,i),p;var v,b=-1,y=p-1,w=0,N=1,L=1,A=1<<n;for(f=0,h=1,o=2;h<=n;++h,o<<=1){if(N+=L<<=1,0>(L-=g[h]))return 0;for(;0<g[h];--g[h])(i=new l).g=h,i.value=s[f++],u(t,d+w,o,A,i),w=c(w,h);}for(h=n+1,o=2;15>=h;++h,o<<=1){if(N+=L<<=1,0>(L-=g[h]))return 0;for(;0<g[h];--g[h]){if(i=new l,(w&y)!=b){for(d+=A,v=1<<(b=h)-n;15>b&&!(0>=(v-=g[b]));)++b,v<<=1;p+=A=1<<(v=b-n),t[r+(b=w&y)].g=v+n,t[r+b].value=d-r-b;}i.g=h-n,i.value=s[f++],u(t,d+(w>>n),o,A,i),w=c(w,h);}}return N!=2*m[15]-1?0:p}(t,r,n,i,o,s)}function l(){this.value=this.g=0;}function f(){this.value=this.g=0;}function d(){this.G=o(5,l),this.H=a(5),this.jc=this.Qb=this.qb=this.nd=0,this.pd=o(Dr,f);}function p(t,r,n,i){e(null!=t),e(null!=r),e(2147483648>i),t.Ca=254,t.I=0,t.b=-8,t.Ka=0,t.oa=r,t.pa=n,t.Jd=r,t.Yc=n+i,t.Zc=4<=i?n+i-4+1:n,_(t);}function g(t,e){for(var r=0;0<e--;)r|=k(t,128)<<e;return r}function m(t,e){var r=g(t,e);return P(t)?-r:r}function v(t,r,n,i){var a,o=0;for(e(null!=t),e(null!=r),e(4294967288>i),t.Sb=i,t.Ra=0,t.u=0,t.h=0,4<i&&(i=4),a=0;a<i;++a)o+=r[n+a]<<8*a;t.Ra=o,t.bb=i,t.oa=r,t.pa=n;}function b(t){for(;8<=t.u&&t.bb<t.Sb;)t.Ra>>>=8,t.Ra+=t.oa[t.pa+t.bb]<<Ur-8>>>0,++t.bb,t.u-=8;A(t)&&(t.h=1,t.u=0);}function y(t,r){if(e(0<=r),!t.h&&r<=Tr){var n=L(t)&Rr[r];return t.u+=r,b(t),n}return t.h=1,t.u=0}function w(){this.b=this.Ca=this.I=0,this.oa=[],this.pa=0,this.Jd=[],this.Yc=0,this.Zc=[],this.Ka=0;}function N(){this.Ra=0,this.oa=[],this.h=this.u=this.bb=this.Sb=this.pa=0;}function L(t){return t.Ra>>>(t.u&Ur-1)>>>0}function A(t){return e(t.bb<=t.Sb),t.h||t.bb==t.Sb&&t.u>Ur}function x(t,e){t.u=e,t.h=A(t);}function S(t){t.u>=zr&&(e(t.u>=zr),b(t));}function _(t){e(null!=t&&null!=t.oa),t.pa<t.Zc?(t.I=(t.oa[t.pa++]|t.I<<8)>>>0,t.b+=8):(e(null!=t&&null!=t.oa),t.pa<t.Yc?(t.b+=8,t.I=t.oa[t.pa++]|t.I<<8):t.Ka?t.b=0:(t.I<<=8,t.b+=8,t.Ka=1));}function P(t){return g(t,1)}function k(t,e){var r=t.Ca;0>t.b&&_(t);var n=t.b,i=r*e>>>8,a=(t.I>>>n>i)+0;for(a?(r-=i,t.I-=i+1<<n>>>0):r=i+1,n=r,i=0;256<=n;)i+=8,n>>=8;return n=7^i+Hr[n],t.b-=n,t.Ca=(r<<n)-1,a}function I(t,e,r){t[e+0]=r>>24&255,t[e+1]=r>>16&255,t[e+2]=r>>8&255,t[e+3]=r>>0&255;}function F(t,e){return t[e+0]<<0|t[e+1]<<8}function C(t,e){return F(t,e)|t[e+2]<<16}function j(t,e){return F(t,e)|F(t,e+2)<<16}function O(t,r){var n=1<<r;return e(null!=t),e(0<r),t.X=a(n),null==t.X?0:(t.Mb=32-r,t.Xa=r,1)}function B(t,r){e(null!=t),e(null!=r),e(t.Xa==r.Xa),n(r.X,0,t.X,0,1<<r.Xa);}function M(){this.X=[],this.Xa=this.Mb=0;}function E(t,r,n,i){e(null!=n),e(null!=i);var a=n[0],o=i[0];return 0==a&&(a=(t*o+r/2)/r),0==o&&(o=(r*a+t/2)/t),0>=a||0>=o?0:(n[0]=a,i[0]=o,1)}function q(t,e){return t+(1<<e)-1>>>e}function D(t,e){return ((4278255360&t)+(4278255360&e)>>>0&4278255360)+((16711935&t)+(16711935&e)>>>0&16711935)>>>0}function R(e,r){t[r]=function(r,n,i,a,o,s,c){var u;for(u=0;u<o;++u){var h=t[e](s[c+u-1],i,a+u);s[c+u]=D(r[n+u],h);}};}function T(){this.ud=this.hd=this.jd=0;}function U(t,e){return ((4278124286&(t^e))>>>1)+(t&e)>>>0}function z(t){return 0<=t&&256>t?t:0>t?0:255<t?255:void 0}function H(t,e){return z(t+(t-e+.5>>1))}function W(t,e,r){return Math.abs(e-r)-Math.abs(t-r)}function V(t,e,r,n,i,a,o){for(n=a[o-1],r=0;r<i;++r)a[o+r]=n=D(t[e+r],n);}function G(t,e,r,n,i){var a;for(a=0;a<r;++a){var o=t[e+a],s=o>>8&255,c=16711935&(c=(c=16711935&o)+((s<<16)+s));n[i+a]=(4278255360&o)+c>>>0;}}function Y(t,e){e.jd=t>>0&255,e.hd=t>>8&255,e.ud=t>>16&255;}function J(t,e,r,n,i,a){var o;for(o=0;o<n;++o){var s=e[r+o],c=s>>>8,u=s,h=255&(h=(h=s>>>16)+((t.jd<<24>>24)*(c<<24>>24)>>>5));u=255&(u=(u=u+((t.hd<<24>>24)*(c<<24>>24)>>>5))+((t.ud<<24>>24)*(h<<24>>24)>>>5));i[a+o]=(4278255360&s)+(h<<16)+u;}}function X(e,r,n,i,a){t[r]=function(t,e,r,n,o,s,c,u,h){for(n=c;n<u;++n)for(c=0;c<h;++c)o[s++]=a(r[i(t[e++])]);},t[e]=function(e,r,o,s,c,u,h){var l=8>>e.b,f=e.Ea,d=e.K[0],p=e.w;if(8>l)for(e=(1<<e.b)-1,p=(1<<l)-1;r<o;++r){var g,m=0;for(g=0;g<f;++g)g&e||(m=i(s[c++])),u[h++]=a(d[m&p]),m>>=l;}else t["VP8LMapColor"+n](s,c,d,p,u,h,r,o,f);};}function K(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255;}}function Z(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255,n[i++]=a>>24&255;}}function $(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&240|o>>12&15,o=o>>0&240|o>>28&15;n[i++]=a,n[i++]=o;}}function Q(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&248|o>>13&7,o=o>>5&224|o>>3&31;n[i++]=a,n[i++]=o;}}function tt(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>0&255,n[i++]=a>>8&255,n[i++]=a>>16&255;}}function et(t,e,r,i,a,o){if(0==o)for(r=e+r;e<r;)I(i,((o=t[e++])[0]>>24|o[1]>>8&65280|o[2]<<8&16711680|o[3]<<24)>>>0),a+=32;else n(i,a,t,e,r);}function rt(e,r){t[r][0]=t[e+"0"],t[r][1]=t[e+"1"],t[r][2]=t[e+"2"],t[r][3]=t[e+"3"],t[r][4]=t[e+"4"],t[r][5]=t[e+"5"],t[r][6]=t[e+"6"],t[r][7]=t[e+"7"],t[r][8]=t[e+"8"],t[r][9]=t[e+"9"],t[r][10]=t[e+"10"],t[r][11]=t[e+"11"],t[r][12]=t[e+"12"],t[r][13]=t[e+"13"],t[r][14]=t[e+"0"],t[r][15]=t[e+"0"];}function nt(t){return t==Hn||t==Wn||t==Vn||t==Gn}function it(){this.eb=[],this.size=this.A=this.fb=0;}function at(){this.y=[],this.f=[],this.ea=[],this.F=[],this.Tc=this.Ed=this.Cd=this.Fd=this.lb=this.Db=this.Ab=this.fa=this.J=this.W=this.N=this.O=0;}function ot(){this.Rd=this.height=this.width=this.S=0,this.f={},this.f.RGBA=new it,this.f.kb=new at,this.sd=null;}function st(){this.width=[0],this.height=[0],this.Pd=[0],this.Qd=[0],this.format=[0];}function ct(){this.Id=this.fd=this.Md=this.hb=this.ib=this.da=this.bd=this.cd=this.j=this.v=this.Da=this.Sd=this.ob=0;}function ut(t){return alert("todo:WebPSamplerProcessPlane"),t.T}function ht(t,e){var r=t.T,i=e.ba.f.RGBA,a=i.eb,o=i.fb+t.ka*i.A,s=vi[e.ba.S],c=t.y,u=t.O,h=t.f,l=t.N,f=t.ea,d=t.W,p=e.cc,g=e.dc,m=e.Mc,v=e.Nc,b=t.ka,y=t.ka+t.T,w=t.U,N=w+1>>1;for(0==b?s(c,u,null,null,h,l,f,d,h,l,f,d,a,o,null,null,w):(s(e.ec,e.fc,c,u,p,g,m,v,h,l,f,d,a,o-i.A,a,o,w),++r);b+2<y;b+=2)p=h,g=l,m=f,v=d,l+=t.Rc,d+=t.Rc,o+=2*i.A,s(c,(u+=2*t.fa)-t.fa,c,u,p,g,m,v,h,l,f,d,a,o-i.A,a,o,w);return u+=t.fa,t.j+y<t.o?(n(e.ec,e.fc,c,u,w),n(e.cc,e.dc,h,l,N),n(e.Mc,e.Nc,f,d,N),r--):1&y||s(c,u,null,null,h,l,f,d,h,l,f,d,a,o+i.A,null,null,w),r}function lt(t,r,n){var i=t.F,a=[t.J];if(null!=i){var o=t.U,s=r.ba.S,c=s==Tn||s==Vn;r=r.ba.f.RGBA;var u=[0],h=t.ka;u[0]=t.T,t.Kb&&(0==h?--u[0]:(--h,a[0]-=t.width),t.j+t.ka+t.T==t.o&&(u[0]=t.o-t.j-h));var l=r.eb;h=r.fb+h*r.A;t=Sn(i,a[0],t.width,o,u,l,h+(c?0:3),r.A),e(n==u),t&&nt(s)&&An(l,h,c,o,u,r.A);}return 0}function ft(t){var e=t.ma,r=e.ba.S,n=11>r,i=r==qn||r==Rn||r==Tn||r==Un||12==r||nt(r);if(e.memory=null,e.Ib=null,e.Jb=null,e.Nd=null,!Mr(e.Oa,t,i?11:12))return 0;if(i&&nt(r)&&br(),t.da)alert("todo:use_scaling");else{if(n){if(e.Ib=ut,t.Kb){if(r=t.U+1>>1,e.memory=a(t.U+2*r),null==e.memory)return 0;e.ec=e.memory,e.fc=0,e.cc=e.ec,e.dc=e.fc+t.U,e.Mc=e.cc,e.Nc=e.dc+r,e.Ib=ht,br();}}else alert("todo:EmitYUV");i&&(e.Jb=lt,n&&mr());}if(n&&!Ci){for(t=0;256>t;++t)ji[t]=89858*(t-128)+_i>>Si,Mi[t]=-22014*(t-128)+_i,Bi[t]=-45773*(t-128),Oi[t]=113618*(t-128)+_i>>Si;for(t=Pi;t<ki;++t)e=76283*(t-16)+_i>>Si,Ei[t-Pi]=Vt(e,255),qi[t-Pi]=Vt(e+8>>4,15);Ci=1;}return 1}function dt(t){var r=t.ma,n=t.U,i=t.T;return e(!(1&t.ka)),0>=n||0>=i?0:(n=r.Ib(t,r),null!=r.Jb&&r.Jb(t,r,n),r.Dc+=n,1)}function pt(t){t.ma.memory=null;}function gt(t,e,r,n){return 47!=y(t,8)?0:(e[0]=y(t,14)+1,r[0]=y(t,14)+1,n[0]=y(t,1),0!=y(t,3)?0:!t.h)}function mt(t,e){if(4>t)return t+1;var r=t-2>>1;return (2+(1&t)<<r)+y(e,r)+1}function vt(t,e){return 120<e?e-120:1<=(r=((r=$n[e-1])>>4)*t+(8-(15&r)))?r:1;var r;}function bt(t,e,r){var n=L(r),i=t[e+=255&n].g-8;return 0<i&&(x(r,r.u+8),n=L(r),e+=t[e].value,e+=n&(1<<i)-1),x(r,r.u+t[e].g),t[e].value}function yt(t,r,n){return n.g+=t.g,n.value+=t.value<<r>>>0,e(8>=n.g),t.g}function wt(t,r,n){var i=t.xc;return e((r=0==i?0:t.vc[t.md*(n>>i)+(r>>i)])<t.Wb),t.Ya[r]}function Nt(t,r,i,a){var o=t.ab,s=t.c*r,c=t.C;r=c+r;var u=i,h=a;for(a=t.Ta,i=t.Ua;0<o--;){var l=t.gc[o],f=c,d=r,p=u,g=h,m=(h=a,u=i,l.Ea);switch(e(f<d),e(d<=l.nc),l.hc){case 2:Gr(p,g,(d-f)*m,h,u);break;case 0:var v=f,b=d,y=h,w=u,N=(_=l).Ea;0==v&&(Wr(p,g,null,null,1,y,w),V(p,g+1,0,0,N-1,y,w+1),g+=N,w+=N,++v);for(var L=1<<_.b,A=L-1,x=q(N,_.b),S=_.K,_=_.w+(v>>_.b)*x;v<b;){var P=S,k=_,I=1;for(Vr(p,g,y,w-N,1,y,w);I<N;){var F=(I&~A)+L;F>N&&(F=N),(0, Zr[P[k++]>>8&15])(p,g+ +I,y,w+I-N,F-I,y,w+I),I=F;}g+=N,w+=N,++v&A||(_+=x);}d!=l.nc&&n(h,u-m,h,u+(d-f-1)*m,m);break;case 1:for(m=p,b=g,N=(p=l.Ea)-(w=p&~(y=(g=1<<l.b)-1)),v=q(p,l.b),L=l.K,l=l.w+(f>>l.b)*v;f<d;){for(A=L,x=l,S=new T,_=b+w,P=b+p;b<_;)Y(A[x++],S),$r(S,m,b,g,h,u),b+=g,u+=g;b<P&&(Y(A[x++],S),$r(S,m,b,N,h,u),b+=N,u+=N),++f&y||(l+=v);}break;case 3:if(p==h&&g==u&&0<l.b){for(b=h,p=m=u+(d-f)*m-(w=(d-f)*q(l.Ea,l.b)),g=h,y=u,v=[],w=(N=w)-1;0<=w;--w)v[w]=g[y+w];for(w=N-1;0<=w;--w)b[p+w]=v[w];Yr(l,f,d,h,m,h,u);}else Yr(l,f,d,p,g,h,u);}u=a,h=i;}h!=i&&n(a,i,u,h,s);}function Lt(t,r){var n=t.V,i=t.Ba+t.c*t.C,a=r-t.C;if(e(r<=t.l.o),e(16>=a),0<a){var o=t.l,s=t.Ta,c=t.Ua,u=o.width;if(Nt(t,a,n,i),a=c=[c],e((n=t.C)<(i=r)),e(o.v<o.va),i>o.o&&(i=o.o),n<o.j){var h=o.j-n;n=o.j;a[0]+=h*u;}if(n>=i?n=0:(a[0]+=4*o.v,o.ka=n-o.j,o.U=o.va-o.v,o.T=i-n,n=1),n){if(c=c[0],11>(n=t.ca).S){var l=n.f.RGBA,f=(i=n.S,a=o.U,o=o.T,h=l.eb,l.A),d=o;for(l=l.fb+t.Ma*l.A;0<d--;){var p=s,g=c,m=a,v=h,b=l;switch(i){case En:Qr(p,g,m,v,b);break;case qn:tn(p,g,m,v,b);break;case Hn:tn(p,g,m,v,b),An(v,b,0,m,1,0);break;case Dn:nn(p,g,m,v,b);break;case Rn:et(p,g,m,v,b,1);break;case Wn:et(p,g,m,v,b,1),An(v,b,0,m,1,0);break;case Tn:et(p,g,m,v,b,0);break;case Vn:et(p,g,m,v,b,0),An(v,b,1,m,1,0);break;case Un:en(p,g,m,v,b);break;case Gn:en(p,g,m,v,b),xn(v,b,m,1,0);break;case zn:rn(p,g,m,v,b);break;default:e(0);}c+=u,l+=f;}t.Ma+=o;}else alert("todo:EmitRescaledRowsYUVA");e(t.Ma<=n.height);}}t.C=r,e(t.C<=t.i);}function At(t){var e;if(0<t.ua)return 0;for(e=0;e<t.Wb;++e){var r=t.Ya[e].G,n=t.Ya[e].H;if(0<r[1][n[1]+0].g||0<r[2][n[2]+0].g||0<r[3][n[3]+0].g)return 0}return 1}function xt(t,r,n,i,a,o){if(0!=t.Z){var s=t.qd,c=t.rd;for(e(null!=mi[t.Z]);r<n;++r)mi[t.Z](s,c,i,a,i,a,o),s=i,c=a,a+=o;t.qd=s,t.rd=c;}}function St(t,r){var n=t.l.ma,i=0==n.Z||1==n.Z?t.l.j:t.C;i=t.C<i?i:t.C;if(e(r<=t.l.o),r>i){var a=t.l.width,o=n.ca,s=n.tb+a*i,c=t.V,u=t.Ba+t.c*i,h=t.gc;e(1==t.ab),e(3==h[0].hc),Xr(h[0],i,r,c,u,o,s),xt(n,i,r,o,s,a);}t.C=t.Ma=r;}function _t(t,r,n,i,a,o,s){var c=t.$/i,u=t.$%i,h=t.m,l=t.s,f=n+t.$,d=f;a=n+i*a;var p=n+i*o,g=280+l.ua,m=t.Pb?c:16777216,v=0<l.ua?l.Wa:null,b=l.wc,y=f<p?wt(l,u,c):null;e(t.C<o),e(p<=a);var w=!1;t:for(;;){for(;w||f<p;){var N=0;if(c>=m){var _=f-n;e((m=t).Pb),m.wd=m.m,m.xd=_,0<m.s.ua&&B(m.s.Wa,m.s.vb),m=c+ti;}if(u&b||(y=wt(l,u,c)),e(null!=y),y.Qb&&(r[f]=y.qb,w=!0),!w)if(S(h),y.jc){N=h,_=r;var P=f,k=y.pd[L(N)&Dr-1];e(y.jc),256>k.g?(x(N,N.u+k.g),_[P]=k.value,N=0):(x(N,N.u+k.g-256),e(256<=k.value),N=k.value),0==N&&(w=!0);}else N=bt(y.G[0],y.H[0],h);if(h.h)break;if(w||256>N){if(!w)if(y.nd)r[f]=(y.qb|N<<8)>>>0;else{if(S(h),w=bt(y.G[1],y.H[1],h),S(h),_=bt(y.G[2],y.H[2],h),P=bt(y.G[3],y.H[3],h),h.h)break;r[f]=(P<<24|w<<16|N<<8|_)>>>0;}if(w=!1,++f,++u>=i&&(u=0,++c,null!=s&&c<=o&&!(c%16)&&s(t,c),null!=v))for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N;}else if(280>N){if(N=mt(N-256,h),_=bt(y.G[4],y.H[4],h),S(h),_=vt(i,_=mt(_,h)),h.h)break;if(f-n<_||a-f<N)break t;for(P=0;P<N;++P)r[f+P]=r[f+P-_];for(f+=N,u+=N;u>=i;)u-=i,++c,null!=s&&c<=o&&!(c%16)&&s(t,c);if(e(f<=a),u&b&&(y=wt(l,u,c)),null!=v)for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N;}else{if(!(N<g))break t;for(w=N-280,e(null!=v);d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N;N=f,e(!(w>>>(_=v).Xa)),r[N]=_.X[w],w=!0;}w||e(h.h==A(h));}if(t.Pb&&h.h&&f<a)e(t.m.h),t.a=5,t.m=t.wd,t.$=t.xd,0<t.s.ua&&B(t.s.vb,t.s.Wa);else{if(h.h)break t;null!=s&&s(t,c>o?o:c),t.a=0,t.$=f-n;}return 1}return t.a=3,0}function Pt(t){e(null!=t),t.vc=null,t.yc=null,t.Ya=null;var r=t.Wa;null!=r&&(r.X=null),t.vb=null,e(null!=t);}function kt(){var e=new or;return null==e?null:(e.a=0,e.xb=gi,rt("Predictor","VP8LPredictors"),rt("Predictor","VP8LPredictors_C"),rt("PredictorAdd","VP8LPredictorsAdd"),rt("PredictorAdd","VP8LPredictorsAdd_C"),Gr=G,$r=J,Qr=K,tn=Z,en=$,rn=Q,nn=tt,t.VP8LMapColor32b=Jr,t.VP8LMapColor8b=Kr,e)}function It(t,r,n,s,c){var u=1,f=[t],p=[r],g=s.m,m=s.s,v=null,b=0;t:for(;;){if(n)for(;u&&y(g,1);){var w=f,N=p,A=s,_=1,P=A.m,k=A.gc[A.ab],I=y(P,2);if(A.Oc&1<<I)u=0;else{switch(A.Oc|=1<<I,k.hc=I,k.Ea=w[0],k.nc=N[0],k.K=[null],++A.ab,e(4>=A.ab),I){case 0:case 1:k.b=y(P,3)+2,_=It(q(k.Ea,k.b),q(k.nc,k.b),0,A,k.K),k.K=k.K[0];break;case 3:var F,C=y(P,8)+1,j=16<C?0:4<C?1:2<C?2:3;if(w[0]=q(k.Ea,j),k.b=j,F=_=It(C,1,0,A,k.K)){var B,M=C,E=k,R=1<<(8>>E.b),T=a(R);if(null==T)F=0;else{var U=E.K[0],z=E.w;for(T[0]=E.K[0][0],B=1;B<1*M;++B)T[B]=D(U[z+B],T[B-1]);for(;B<4*R;++B)T[B]=0;E.K[0]=null,E.K[0]=T,F=1;}}_=F;break;case 2:break;default:e(0);}u=_;}}if(f=f[0],p=p[0],u&&y(g,1)&&!(u=1<=(b=y(g,4))&&11>=b)){s.a=3;break t}var H;if(H=u)e:{var W,V,G,Y=s,J=f,X=p,K=b,Z=n,$=Y.m,Q=Y.s,tt=[null],et=1,rt=0,nt=Qn[K];r:for(;;){if(Z&&y($,1)){var it=y($,3)+2,at=q(J,it),ot=q(X,it),st=at*ot;if(!It(at,ot,0,Y,tt))break r;for(tt=tt[0],Q.xc=it,W=0;W<st;++W){var ct=tt[W]>>8&65535;tt[W]=ct,ct>=et&&(et=ct+1);}}if($.h)break r;for(V=0;5>V;++V){var ut=Xn[V];!V&&0<K&&(ut+=1<<K),rt<ut&&(rt=ut);}var ht=o(et*nt,l),lt=et,ft=o(lt,d);if(null==ft)var dt=null;else e(65536>=lt),dt=ft;var pt=a(rt);if(null==dt||null==pt||null==ht){Y.a=1;break r}var gt=ht;for(W=G=0;W<et;++W){var mt=dt[W],vt=mt.G,bt=mt.H,wt=0,Nt=1,Lt=0;for(V=0;5>V;++V){ut=Xn[V],vt[V]=gt,bt[V]=G,!V&&0<K&&(ut+=1<<K);n:{var At,xt=ut,St=Y,kt=pt,Ft=gt,Ct=G,jt=0,Ot=St.m,Bt=y(Ot,1);if(i(kt,0,0,xt),Bt){var Mt=y(Ot,1)+1,Et=y(Ot,1),qt=y(Ot,0==Et?1:8);kt[qt]=1,2==Mt&&(kt[qt=y(Ot,8)]=1);var Dt=1;}else{var Rt=a(19),Tt=y(Ot,4)+4;if(19<Tt){St.a=3;var Ut=0;break n}for(At=0;At<Tt;++At)Rt[Zn[At]]=y(Ot,3);var zt=void 0,Ht=void 0,Wt=St,Vt=Rt,Gt=xt,Yt=kt,Jt=0,Xt=Wt.m,Kt=8,Zt=o(128,l);i:for(;h(Zt,0,7,Vt,19);){if(y(Xt,1)){var $t=2+2*y(Xt,3);if((zt=2+y(Xt,$t))>Gt)break i}else zt=Gt;for(Ht=0;Ht<Gt&&zt--;){S(Xt);var Qt=Zt[0+(127&L(Xt))];x(Xt,Xt.u+Qt.g);var te=Qt.value;if(16>te)Yt[Ht++]=te,0!=te&&(Kt=te);else{var ee=16==te,re=te-16,ne=Jn[re],ie=y(Xt,Yn[re])+ne;if(Ht+ie>Gt)break i;for(var ae=ee?Kt:0;0<ie--;)Yt[Ht++]=ae;}}Jt=1;break i}Jt||(Wt.a=3),Dt=Jt;}(Dt=Dt&&!Ot.h)&&(jt=h(Ft,Ct,8,kt,xt)),Dt&&0!=jt?Ut=jt:(St.a=3,Ut=0);}if(0==Ut)break r;if(Nt&&1==Kn[V]&&(Nt=0==gt[G].g),wt+=gt[G].g,G+=Ut,3>=V){var oe,se=pt[0];for(oe=1;oe<ut;++oe)pt[oe]>se&&(se=pt[oe]);Lt+=se;}}if(mt.nd=Nt,mt.Qb=0,Nt&&(mt.qb=(vt[3][bt[3]+0].value<<24|vt[1][bt[1]+0].value<<16|vt[2][bt[2]+0].value)>>>0,0==wt&&256>vt[0][bt[0]+0].value&&(mt.Qb=1,mt.qb+=vt[0][bt[0]+0].value<<8)),mt.jc=!mt.Qb&&6>Lt,mt.jc){var ce,ue=mt;for(ce=0;ce<Dr;++ce){var he=ce,le=ue.pd[he],fe=ue.G[0][ue.H[0]+he];256<=fe.value?(le.g=fe.g+256,le.value=fe.value):(le.g=0,le.value=0,he>>=yt(fe,8,le),he>>=yt(ue.G[1][ue.H[1]+he],16,le),he>>=yt(ue.G[2][ue.H[2]+he],0,le),yt(ue.G[3][ue.H[3]+he],24,le));}}}Q.vc=tt,Q.Wb=et,Q.Ya=dt,Q.yc=ht,H=1;break e}H=0;}if(!(u=H)){s.a=3;break t}if(0<b){if(m.ua=1<<b,!O(m.Wa,b)){s.a=1,u=0;break t}}else m.ua=0;var de=s,pe=f,ge=p,me=de.s,ve=me.xc;if(de.c=pe,de.i=ge,me.md=q(pe,ve),me.wc=0==ve?-1:(1<<ve)-1,n){s.xb=pi;break t}if(null==(v=a(f*p))){s.a=1,u=0;break t}u=(u=_t(s,v,0,f,p,p,null))&&!g.h;break t}return u?(null!=c?c[0]=v:(e(null==v),e(n)),s.$=0,n||Pt(m)):Pt(m),u}function Ft(t,r){var n=t.c*t.i,i=n+r+16*r;return e(t.c<=r),t.V=a(i),null==t.V?(t.Ta=null,t.Ua=0,t.a=1,0):(t.Ta=t.V,t.Ua=t.Ba+n+r,1)}function Ct(t,r){var n=t.C,i=r-n,a=t.V,o=t.Ba+t.c*n;for(e(r<=t.l.o);0<i;){var s=16<i?16:i,c=t.l.ma,u=t.l.width,h=u*s,l=c.ca,f=c.tb+u*n,d=t.Ta,p=t.Ua;Nt(t,s,a,o),_n(d,p,l,f,h),xt(c,n,n+s,l,f,u),i-=s,a+=s*t.c,n+=s;}e(n==r),t.C=t.Ma=r;}function jt(){this.ub=this.yd=this.td=this.Rb=0;}function Ot(){this.Kd=this.Ld=this.Ud=this.Td=this.i=this.c=0;}function Bt(){this.Fb=this.Bb=this.Cb=0,this.Zb=a(4),this.Lb=a(4);}function Mt(){this.Yb=function(){var t=[];return function t(e,r,n){for(var i=n[r],a=0;a<i&&(e.push(n.length>r+1?[]:0),!(n.length<r+1));a++)t(e[a],r+1,n);}(t,0,[3,11]),t}();}function Et(){this.jb=a(3),this.Wc=s([4,8],Mt),this.Xc=s([4,17],Mt);}function qt(){this.Pc=this.wb=this.Tb=this.zd=0,this.vd=new a(4),this.od=new a(4);}function Dt(){this.ld=this.La=this.dd=this.tc=0;}function Rt(){this.Na=this.la=0;}function Tt(){this.Sc=[0,0],this.Eb=[0,0],this.Qc=[0,0],this.ia=this.lc=0;}function Ut(){this.ad=a(384),this.Za=0,this.Ob=a(16),this.$b=this.Ad=this.ia=this.Gc=this.Hc=this.Dd=0;}function zt(){this.uc=this.M=this.Nb=0,this.wa=Array(new Dt),this.Y=0,this.ya=Array(new Ut),this.aa=0,this.l=new Gt;}function Ht(){this.y=a(16),this.f=a(8),this.ea=a(8);}function Wt(){this.cb=this.a=0,this.sc="",this.m=new w,this.Od=new jt,this.Kc=new Ot,this.ed=new qt,this.Qa=new Bt,this.Ic=this.$c=this.Aa=0,this.D=new zt,this.Xb=this.Va=this.Hb=this.zb=this.yb=this.Ub=this.za=0,this.Jc=o(8,w),this.ia=0,this.pb=o(4,Tt),this.Pa=new Et,this.Bd=this.kc=0,this.Ac=[],this.Bc=0,this.zc=[0,0,0,0],this.Gd=Array(new Ht),this.Hd=0,this.rb=Array(new Rt),this.sb=0,this.wa=Array(new Dt),this.Y=0,this.oc=[],this.pc=0,this.sa=[],this.ta=0,this.qa=[],this.ra=0,this.Ha=[],this.B=this.R=this.Ia=0,this.Ec=[],this.M=this.ja=this.Vb=this.Fc=0,this.ya=Array(new Ut),this.L=this.aa=0,this.gd=s([4,2],Dt),this.ga=null,this.Fa=[],this.Cc=this.qc=this.P=0,this.Gb=[],this.Uc=0,this.mb=[],this.nb=0,this.rc=[],this.Ga=this.Vc=0;}function Vt(t,e){return 0>t?0:t>e?e:t}function Gt(){this.T=this.U=this.ka=this.height=this.width=0,this.y=[],this.f=[],this.ea=[],this.Rc=this.fa=this.W=this.N=this.O=0,this.ma="void",this.put="VP8IoPutHook",this.ac="VP8IoSetupHook",this.bc="VP8IoTeardownHook",this.ha=this.Kb=0,this.data=[],this.hb=this.ib=this.da=this.o=this.j=this.va=this.v=this.Da=this.ob=this.w=0,this.F=[],this.J=0;}function Yt(){var t=new Wt;return null!=t&&(t.a=0,t.sc="OK",t.cb=0,t.Xb=0,ni||(ni=Zt)),t}function Jt(t,e,r){return 0==t.a&&(t.a=e,t.sc=r,t.cb=0),0}function Xt(t,e,r){return 3<=r&&157==t[e+0]&&1==t[e+1]&&42==t[e+2]}function Kt(t,r){if(null==t)return 0;if(t.a=0,t.sc="OK",null==r)return Jt(t,2,"null VP8Io passed to VP8GetHeaders()");var n=r.data,a=r.w,o=r.ha;if(4>o)return Jt(t,7,"Truncated header.");var s=n[a+0]|n[a+1]<<8|n[a+2]<<16,c=t.Od;if(c.Rb=!(1&s),c.td=s>>1&7,c.yd=s>>4&1,c.ub=s>>5,3<c.td)return Jt(t,3,"Incorrect keyframe parameters.");if(!c.yd)return Jt(t,4,"Frame not displayable.");a+=3,o-=3;var u=t.Kc;if(c.Rb){if(7>o)return Jt(t,7,"cannot parse picture header");if(!Xt(n,a,o))return Jt(t,3,"Bad code word");u.c=16383&(n[a+4]<<8|n[a+3]),u.Td=n[a+4]>>6,u.i=16383&(n[a+6]<<8|n[a+5]),u.Ud=n[a+6]>>6,a+=7,o-=7,t.za=u.c+15>>4,t.Ub=u.i+15>>4,r.width=u.c,r.height=u.i,r.Da=0,r.j=0,r.v=0,r.va=r.width,r.o=r.height,r.da=0,r.ib=r.width,r.hb=r.height,r.U=r.width,r.T=r.height,i((s=t.Pa).jb,0,255,s.jb.length),e(null!=(s=t.Qa)),s.Cb=0,s.Bb=0,s.Fb=1,i(s.Zb,0,0,s.Zb.length),i(s.Lb,0,0,s.Lb);}if(c.ub>o)return Jt(t,7,"bad partition length");p(s=t.m,n,a,c.ub),a+=c.ub,o-=c.ub,c.Rb&&(u.Ld=P(s),u.Kd=P(s)),u=t.Qa;var h,l=t.Pa;if(e(null!=s),e(null!=u),u.Cb=P(s),u.Cb){if(u.Bb=P(s),P(s)){for(u.Fb=P(s),h=0;4>h;++h)u.Zb[h]=P(s)?m(s,7):0;for(h=0;4>h;++h)u.Lb[h]=P(s)?m(s,6):0;}if(u.Bb)for(h=0;3>h;++h)l.jb[h]=P(s)?g(s,8):255;}else u.Bb=0;if(s.Ka)return Jt(t,3,"cannot parse segment header");if((u=t.ed).zd=P(s),u.Tb=g(s,6),u.wb=g(s,3),u.Pc=P(s),u.Pc&&P(s)){for(l=0;4>l;++l)P(s)&&(u.vd[l]=m(s,6));for(l=0;4>l;++l)P(s)&&(u.od[l]=m(s,6));}if(t.L=0==u.Tb?0:u.zd?1:2,s.Ka)return Jt(t,3,"cannot parse filter header");var f=o;if(o=h=a,a=h+f,u=f,t.Xb=(1<<g(t.m,2))-1,f<3*(l=t.Xb))n=7;else{for(h+=3*l,u-=3*l,f=0;f<l;++f){var d=n[o+0]|n[o+1]<<8|n[o+2]<<16;d>u&&(d=u),p(t.Jc[+f],n,h,d),h+=d,u-=d,o+=3;}p(t.Jc[+l],n,h,u),n=h<a?0:5;}if(0!=n)return Jt(t,n,"cannot parse partitions");for(n=g(h=t.m,7),o=P(h)?m(h,4):0,a=P(h)?m(h,4):0,u=P(h)?m(h,4):0,l=P(h)?m(h,4):0,h=P(h)?m(h,4):0,f=t.Qa,d=0;4>d;++d){if(f.Cb){var v=f.Zb[d];f.Fb||(v+=n);}else{if(0<d){t.pb[d]=t.pb[0];continue}v=n;}var b=t.pb[d];b.Sc[0]=ei[Vt(v+o,127)],b.Sc[1]=ri[Vt(v+0,127)],b.Eb[0]=2*ei[Vt(v+a,127)],b.Eb[1]=101581*ri[Vt(v+u,127)]>>16,8>b.Eb[1]&&(b.Eb[1]=8),b.Qc[0]=ei[Vt(v+l,117)],b.Qc[1]=ri[Vt(v+h,127)],b.lc=v+h;}if(!c.Rb)return Jt(t,4,"Not a key frame.");for(P(s),c=t.Pa,n=0;4>n;++n){for(o=0;8>o;++o)for(a=0;3>a;++a)for(u=0;11>u;++u)l=k(s,ui[n][o][a][u])?g(s,8):si[n][o][a][u],c.Wc[n][o].Yb[a][u]=l;for(o=0;17>o;++o)c.Xc[n][o]=c.Wc[n][hi[o]];}return t.kc=P(s),t.kc&&(t.Bd=g(s,8)),t.cb=1}function Zt(t,e,r,n,i,a,o){var s=e[i].Yb[r];for(r=0;16>i;++i){if(!k(t,s[r+0]))return i;for(;!k(t,s[r+1]);)if(s=e[++i].Yb[0],r=0,16==i)return 16;var c=e[i+1].Yb;if(k(t,s[r+2])){var u=t,h=0;if(k(u,(f=s)[(l=r)+3]))if(k(u,f[l+6])){for(s=0,l=2*(h=k(u,f[l+8]))+(f=k(u,f[l+9+h])),h=0,f=ii[l];f[s];++s)h+=h+k(u,f[s]);h+=3+(8<<l);}else k(u,f[l+7])?(h=7+2*k(u,165),h+=k(u,145)):h=5+k(u,159);else h=k(u,f[l+4])?3+k(u,f[l+5]):2;s=c[2];}else h=1,s=c[1];c=o+ai[i],0>(u=t).b&&_(u);var l,f=u.b,d=(l=u.Ca>>1)-(u.I>>f)>>31;--u.b,u.Ca+=d,u.Ca|=1,u.I-=(l+1&d)<<f,a[c]=((h^d)-d)*n[(0<i)+0];}return 16}function $t(t){var e=t.rb[t.sb-1];e.la=0,e.Na=0,i(t.zc,0,0,t.zc.length),t.ja=0;}function Qt(t,r){if(null==t)return 0;if(null==r)return Jt(t,2,"NULL VP8Io parameter in VP8Decode().");if(!t.cb&&!Kt(t,r))return 0;if(e(t.cb),null==r.ac||r.ac(r)){r.ob&&(t.L=0);var s=Ri[t.L];if(2==t.L?(t.yb=0,t.zb=0):(t.yb=r.v-s>>4,t.zb=r.j-s>>4,0>t.yb&&(t.yb=0),0>t.zb&&(t.zb=0)),t.Va=r.o+15+s>>4,t.Hb=r.va+15+s>>4,t.Hb>t.za&&(t.Hb=t.za),t.Va>t.Ub&&(t.Va=t.Ub),0<t.L){var c=t.ed;for(s=0;4>s;++s){var u;if(t.Qa.Cb){var h=t.Qa.Lb[s];t.Qa.Fb||(h+=c.Tb);}else h=c.Tb;for(u=0;1>=u;++u){var l=t.gd[s][u],f=h;if(c.Pc&&(f+=c.vd[0],u&&(f+=c.od[0])),0<(f=0>f?0:63<f?63:f)){var d=f;0<c.wb&&((d=4<c.wb?d>>2:d>>1)>9-c.wb&&(d=9-c.wb)),1>d&&(d=1),l.dd=d,l.tc=2*f+d,l.ld=40<=f?2:15<=f?1:0;}else l.tc=0;l.La=u;}}}s=0;}else Jt(t,6,"Frame setup failed"),s=t.a;if(s=0==s){if(s){t.$c=0,0<t.Aa||(t.Ic=Ui);t:{s=t.Ic;c=4*(d=t.za);var p=32*d,g=d+1,m=0<t.L?d*(0<t.Aa?2:1):0,v=(2==t.Aa?2:1)*d;if((l=c+832+(u=3*(16*s+Ri[t.L])/2*p)+(h=null!=t.Fa&&0<t.Fa.length?t.Kc.c*t.Kc.i:0))!=l)s=0;else{if(l>t.Vb){if(t.Vb=0,t.Ec=a(l),t.Fc=0,null==t.Ec){s=Jt(t,1,"no memory during frame initialization.");break t}t.Vb=l;}l=t.Ec,f=t.Fc,t.Ac=l,t.Bc=f,f+=c,t.Gd=o(p,Ht),t.Hd=0,t.rb=o(g+1,Rt),t.sb=1,t.wa=m?o(m,Dt):null,t.Y=0,t.D.Nb=0,t.D.wa=t.wa,t.D.Y=t.Y,0<t.Aa&&(t.D.Y+=d),e(!0),t.oc=l,t.pc=f,f+=832,t.ya=o(v,Ut),t.aa=0,t.D.ya=t.ya,t.D.aa=t.aa,2==t.Aa&&(t.D.aa+=d),t.R=16*d,t.B=8*d,d=(p=Ri[t.L])*t.R,p=p/2*t.B,t.sa=l,t.ta=f+d,t.qa=t.sa,t.ra=t.ta+16*s*t.R+p,t.Ha=t.qa,t.Ia=t.ra+8*s*t.B+p,t.$c=0,f+=u,t.mb=h?l:null,t.nb=h?f:null,e(f+h<=t.Fc+t.Vb),$t(t),i(t.Ac,t.Bc,0,c),s=1;}}if(s){if(r.ka=0,r.y=t.sa,r.O=t.ta,r.f=t.qa,r.N=t.ra,r.ea=t.Ha,r.Vd=t.Ia,r.fa=t.R,r.Rc=t.B,r.F=null,r.J=0,!Cn){for(s=-255;255>=s;++s)Pn[255+s]=0>s?-s:s;for(s=-1020;1020>=s;++s)kn[1020+s]=-128>s?-128:127<s?127:s;for(s=-112;112>=s;++s)In[112+s]=-16>s?-16:15<s?15:s;for(s=-255;510>=s;++s)Fn[255+s]=0>s?0:255<s?255:s;Cn=1;}an=ue,on=ae,cn=oe,un=se,hn=ce,sn=ie,ln=Je,fn=Xe,dn=$e,pn=Qe,gn=Ke,mn=Ze,vn=tr,bn=er,yn=ze,wn=He,Nn=We,Ln=Ve,fi[0]=xe,fi[1]=le,fi[2]=Le,fi[3]=Ae,fi[4]=Se,fi[5]=Pe,fi[6]=_e,fi[7]=ke,fi[8]=Fe,fi[9]=Ie,li[0]=ve,li[1]=de,li[2]=pe,li[3]=ge,li[4]=be,li[5]=ye,li[6]=we,di[0]=Be,di[1]=fe,di[2]=Ce,di[3]=je,di[4]=Ee,di[5]=Me,di[6]=qe,s=1;}else s=0;}s&&(s=function(t,r){for(t.M=0;t.M<t.Va;++t.M){var o,s=t.Jc[t.M&t.Xb],c=t.m,u=t;for(o=0;o<u.za;++o){var h=c,l=u,f=l.Ac,d=l.Bc+4*o,p=l.zc,g=l.ya[l.aa+o];if(l.Qa.Bb?g.$b=k(h,l.Pa.jb[0])?2+k(h,l.Pa.jb[2]):k(h,l.Pa.jb[1]):g.$b=0,l.kc&&(g.Ad=k(h,l.Bd)),g.Za=!k(h,145)+0,g.Za){var m=g.Ob,v=0;for(l=0;4>l;++l){var b,y=p[0+l];for(b=0;4>b;++b){y=ci[f[d+b]][y];for(var w=oi[k(h,y[0])];0<w;)w=oi[2*w+k(h,y[w])];y=-w,f[d+b]=y;}n(m,v,f,d,4),v+=4,p[0+l]=y;}}else y=k(h,156)?k(h,128)?1:3:k(h,163)?2:0,g.Ob[0]=y,i(f,d,y,4),i(p,0,y,4);g.Dd=k(h,142)?k(h,114)?k(h,183)?1:3:2:0;}if(u.m.Ka)return Jt(t,7,"Premature end-of-partition0 encountered.");for(;t.ja<t.za;++t.ja){if(u=s,h=(c=t).rb[c.sb-1],f=c.rb[c.sb+c.ja],o=c.ya[c.aa+c.ja],d=c.kc?o.Ad:0)h.la=f.la=0,o.Za||(h.Na=f.Na=0),o.Hc=0,o.Gc=0,o.ia=0;else{var N,L;h=f,f=u,d=c.Pa.Xc,p=c.ya[c.aa+c.ja],g=c.pb[p.$b];if(l=p.ad,m=0,v=c.rb[c.sb-1],y=b=0,i(l,m,0,384),p.Za)var A=0,x=d[3];else{w=a(16);var S=h.Na+v.Na;if(S=ni(f,d[1],S,g.Eb,0,w,0),h.Na=v.Na=(0<S)+0,1<S)an(w,0,l,m);else{var _=w[0]+3>>3;for(w=0;256>w;w+=16)l[m+w]=_;}A=1,x=d[0];}var P=15&h.la,I=15&v.la;for(w=0;4>w;++w){var F=1&I;for(_=L=0;4>_;++_)P=P>>1|(F=(S=ni(f,x,S=F+(1&P),g.Sc,A,l,m))>A)<<7,L=L<<2|(3<S?3:1<S?2:0!=l[m+0]),m+=16;P>>=4,I=I>>1|F<<7,b=(b<<8|L)>>>0;}for(x=P,A=I>>4,N=0;4>N;N+=2){for(L=0,P=h.la>>4+N,I=v.la>>4+N,w=0;2>w;++w){for(F=1&I,_=0;2>_;++_)S=F+(1&P),P=P>>1|(F=0<(S=ni(f,d[2],S,g.Qc,0,l,m)))<<3,L=L<<2|(3<S?3:1<S?2:0!=l[m+0]),m+=16;P>>=2,I=I>>1|F<<5;}y|=L<<4*N,x|=P<<4<<N,A|=(240&I)<<N;}h.la=x,v.la=A,p.Hc=b,p.Gc=y,p.ia=43690&y?0:g.ia,d=!(b|y);}if(0<c.L&&(c.wa[c.Y+c.ja]=c.gd[o.$b][o.Za],c.wa[c.Y+c.ja].La|=!d),u.Ka)return Jt(t,7,"Premature end-of-file encountered.")}if($t(t),c=r,u=1,o=(s=t).D,h=0<s.L&&s.M>=s.zb&&s.M<=s.Va,0==s.Aa)t:{if(o.M=s.M,o.uc=h,Or(s,o),u=1,o=(L=s.D).Nb,h=(y=Ri[s.L])*s.R,f=y/2*s.B,w=16*o*s.R,_=8*o*s.B,d=s.sa,p=s.ta-h+w,g=s.qa,l=s.ra-f+_,m=s.Ha,v=s.Ia-f+_,I=0==(P=L.M),b=P>=s.Va-1,2==s.Aa&&Or(s,L),L.uc)for(F=(S=s).D.M,e(S.D.uc),L=S.yb;L<S.Hb;++L){A=L,x=F;var C=(j=(U=S).D).Nb;N=U.R;var j=j.wa[j.Y+A],O=U.sa,B=U.ta+16*C*N+16*A,M=j.dd,E=j.tc;if(0!=E)if(e(3<=E),1==U.L)0<A&&wn(O,B,N,E+4),j.La&&Ln(O,B,N,E),0<x&&yn(O,B,N,E+4),j.La&&Nn(O,B,N,E);else{var q=U.B,D=U.qa,R=U.ra+8*C*q+8*A,T=U.Ha,U=U.Ia+8*C*q+8*A;C=j.ld;0<A&&(fn(O,B,N,E+4,M,C),pn(D,R,T,U,q,E+4,M,C)),j.La&&(mn(O,B,N,E,M,C),bn(D,R,T,U,q,E,M,C)),0<x&&(ln(O,B,N,E+4,M,C),dn(D,R,T,U,q,E+4,M,C)),j.La&&(gn(O,B,N,E,M,C),vn(D,R,T,U,q,E,M,C));}}if(s.ia&&alert("todo:DitherRow"),null!=c.put){if(L=16*P,P=16*(P+1),I?(c.y=s.sa,c.O=s.ta+w,c.f=s.qa,c.N=s.ra+_,c.ea=s.Ha,c.W=s.Ia+_):(L-=y,c.y=d,c.O=p,c.f=g,c.N=l,c.ea=m,c.W=v),b||(P-=y),P>c.o&&(P=c.o),c.F=null,c.J=null,null!=s.Fa&&0<s.Fa.length&&L<P&&(c.J=lr(s,c,L,P-L),c.F=s.mb,null==c.F&&0==c.F.length)){u=Jt(s,3,"Could not decode alpha data.");break t}L<c.j&&(y=c.j-L,L=c.j,e(!(1&y)),c.O+=s.R*y,c.N+=s.B*(y>>1),c.W+=s.B*(y>>1),null!=c.F&&(c.J+=c.width*y)),L<P&&(c.O+=c.v,c.N+=c.v>>1,c.W+=c.v>>1,null!=c.F&&(c.J+=c.v),c.ka=L-c.j,c.U=c.va-c.v,c.T=P-L,u=c.put(c));}o+1!=s.Ic||b||(n(s.sa,s.ta-h,d,p+16*s.R,h),n(s.qa,s.ra-f,g,l+8*s.B,f),n(s.Ha,s.Ia-f,m,v+8*s.B,f));}if(!u)return Jt(t,6,"Output aborted.")}return 1}(t,r)),null!=r.bc&&r.bc(r),s&=1;}return s?(t.cb=0,s):0}function te(t,e,r,n,i){i=t[e+r+32*n]+(i>>3),t[e+r+32*n]=-256&i?0>i?0:255:i;}function ee(t,e,r,n,i,a){te(t,e,0,r,n+i),te(t,e,1,r,n+a),te(t,e,2,r,n-a),te(t,e,3,r,n-i);}function re(t){return (20091*t>>16)+t}function ne(t,e,r,n){var i,o=0,s=a(16);for(i=0;4>i;++i){var c=t[e+0]+t[e+8],u=t[e+0]-t[e+8],h=(35468*t[e+4]>>16)-re(t[e+12]),l=re(t[e+4])+(35468*t[e+12]>>16);s[o+0]=c+l,s[o+1]=u+h,s[o+2]=u-h,s[o+3]=c-l,o+=4,e++;}for(i=o=0;4>i;++i)c=(t=s[o+0]+4)+s[o+8],u=t-s[o+8],h=(35468*s[o+4]>>16)-re(s[o+12]),te(r,n,0,0,c+(l=re(s[o+4])+(35468*s[o+12]>>16))),te(r,n,1,0,u+h),te(r,n,2,0,u-h),te(r,n,3,0,c-l),o++,n+=32;}function ie(t,e,r,n){var i=t[e+0]+4,a=35468*t[e+4]>>16,o=re(t[e+4]),s=35468*t[e+1]>>16;ee(r,n,0,i+o,t=re(t[e+1]),s),ee(r,n,1,i+a,t,s),ee(r,n,2,i-a,t,s),ee(r,n,3,i-o,t,s);}function ae(t,e,r,n,i){ne(t,e,r,n),i&&ne(t,e+16,r,n+4);}function oe(t,e,r,n){on(t,e+0,r,n,1),on(t,e+32,r,n+128,1);}function se(t,e,r,n){var i;for(t=t[e+0]+4,i=0;4>i;++i)for(e=0;4>e;++e)te(r,n,e,i,t);}function ce(t,e,r,n){t[e+0]&&un(t,e+0,r,n),t[e+16]&&un(t,e+16,r,n+4),t[e+32]&&un(t,e+32,r,n+128),t[e+48]&&un(t,e+48,r,n+128+4);}function ue(t,e,r,n){var i,o=a(16);for(i=0;4>i;++i){var s=t[e+0+i]+t[e+12+i],c=t[e+4+i]+t[e+8+i],u=t[e+4+i]-t[e+8+i],h=t[e+0+i]-t[e+12+i];o[0+i]=s+c,o[8+i]=s-c,o[4+i]=h+u,o[12+i]=h-u;}for(i=0;4>i;++i)s=(t=o[0+4*i]+3)+o[3+4*i],c=o[1+4*i]+o[2+4*i],u=o[1+4*i]-o[2+4*i],h=t-o[3+4*i],r[n+0]=s+c>>3,r[n+16]=h+u>>3,r[n+32]=s-c>>3,r[n+48]=h-u>>3,n+=64;}function he(t,e,r){var n,i=e-32,a=Bn,o=255-t[i-1];for(n=0;n<r;++n){var s,c=a,u=o+t[e-1];for(s=0;s<r;++s)t[e+s]=c[u+t[i+s]];e+=32;}}function le(t,e){he(t,e,4);}function fe(t,e){he(t,e,8);}function de(t,e){he(t,e,16);}function pe(t,e){var r;for(r=0;16>r;++r)n(t,e+32*r,t,e-32,16);}function ge(t,e){var r;for(r=16;0<r;--r)i(t,e,t[e-1],16),e+=32;}function me(t,e,r){var n;for(n=0;16>n;++n)i(e,r+32*n,t,16);}function ve(t,e){var r,n=16;for(r=0;16>r;++r)n+=t[e-1+32*r]+t[e+r-32];me(n>>5,t,e);}function be(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e-1+32*r];me(n>>4,t,e);}function ye(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e+r-32];me(n>>4,t,e);}function we(t,e){me(128,t,e);}function Ne(t,e,r){return t+2*e+r+2>>2}function Le(t,e){var r,i=e-32;i=new Uint8Array([Ne(t[i-1],t[i+0],t[i+1]),Ne(t[i+0],t[i+1],t[i+2]),Ne(t[i+1],t[i+2],t[i+3]),Ne(t[i+2],t[i+3],t[i+4])]);for(r=0;4>r;++r)n(t,e+32*r,i,0,i.length);}function Ae(t,e){var r=t[e-1],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];I(t,e+0,16843009*Ne(t[e-1-32],r,n)),I(t,e+32,16843009*Ne(r,n,i)),I(t,e+64,16843009*Ne(n,i,a)),I(t,e+96,16843009*Ne(i,a,a));}function xe(t,e){var r,n=4;for(r=0;4>r;++r)n+=t[e+r-32]+t[e-1+32*r];for(n>>=3,r=0;4>r;++r)i(t,e+32*r,n,4);}function Se(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],c=t[e+2-32],u=t[e+3-32];t[e+0+96]=Ne(n,i,t[e-1+96]),t[e+1+96]=t[e+0+64]=Ne(r,n,i),t[e+2+96]=t[e+1+64]=t[e+0+32]=Ne(a,r,n),t[e+3+96]=t[e+2+64]=t[e+1+32]=t[e+0+0]=Ne(o,a,r),t[e+3+64]=t[e+2+32]=t[e+1+0]=Ne(s,o,a),t[e+3+32]=t[e+2+0]=Ne(c,s,o),t[e+3+0]=Ne(u,c,s);}function _e(t,e){var r=t[e+1-32],n=t[e+2-32],i=t[e+3-32],a=t[e+4-32],o=t[e+5-32],s=t[e+6-32],c=t[e+7-32];t[e+0+0]=Ne(t[e+0-32],r,n),t[e+1+0]=t[e+0+32]=Ne(r,n,i),t[e+2+0]=t[e+1+32]=t[e+0+64]=Ne(n,i,a),t[e+3+0]=t[e+2+32]=t[e+1+64]=t[e+0+96]=Ne(i,a,o),t[e+3+32]=t[e+2+64]=t[e+1+96]=Ne(a,o,s),t[e+3+64]=t[e+2+96]=Ne(o,s,c),t[e+3+96]=Ne(s,c,c);}function Pe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],c=t[e+2-32],u=t[e+3-32];t[e+0+0]=t[e+1+64]=a+o+1>>1,t[e+1+0]=t[e+2+64]=o+s+1>>1,t[e+2+0]=t[e+3+64]=s+c+1>>1,t[e+3+0]=c+u+1>>1,t[e+0+96]=Ne(i,n,r),t[e+0+64]=Ne(n,r,a),t[e+0+32]=t[e+1+96]=Ne(r,a,o),t[e+1+32]=t[e+2+96]=Ne(a,o,s),t[e+2+32]=t[e+3+96]=Ne(o,s,c),t[e+3+32]=Ne(s,c,u);}function ke(t,e){var r=t[e+0-32],n=t[e+1-32],i=t[e+2-32],a=t[e+3-32],o=t[e+4-32],s=t[e+5-32],c=t[e+6-32],u=t[e+7-32];t[e+0+0]=r+n+1>>1,t[e+1+0]=t[e+0+64]=n+i+1>>1,t[e+2+0]=t[e+1+64]=i+a+1>>1,t[e+3+0]=t[e+2+64]=a+o+1>>1,t[e+0+32]=Ne(r,n,i),t[e+1+32]=t[e+0+96]=Ne(n,i,a),t[e+2+32]=t[e+1+96]=Ne(i,a,o),t[e+3+32]=t[e+2+96]=Ne(a,o,s),t[e+3+64]=Ne(o,s,c),t[e+3+96]=Ne(s,c,u);}function Ie(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];t[e+0+0]=r+n+1>>1,t[e+2+0]=t[e+0+32]=n+i+1>>1,t[e+2+32]=t[e+0+64]=i+a+1>>1,t[e+1+0]=Ne(r,n,i),t[e+3+0]=t[e+1+32]=Ne(n,i,a),t[e+3+32]=t[e+1+64]=Ne(i,a,a),t[e+3+64]=t[e+2+64]=t[e+0+96]=t[e+1+96]=t[e+2+96]=t[e+3+96]=a;}function Fe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96],o=t[e-1-32],s=t[e+0-32],c=t[e+1-32],u=t[e+2-32];t[e+0+0]=t[e+2+32]=r+o+1>>1,t[e+0+32]=t[e+2+64]=n+r+1>>1,t[e+0+64]=t[e+2+96]=i+n+1>>1,t[e+0+96]=a+i+1>>1,t[e+3+0]=Ne(s,c,u),t[e+2+0]=Ne(o,s,c),t[e+1+0]=t[e+3+32]=Ne(r,o,s),t[e+1+32]=t[e+3+64]=Ne(n,r,o),t[e+1+64]=t[e+3+96]=Ne(i,n,r),t[e+1+96]=Ne(a,i,n);}function Ce(t,e){var r;for(r=0;8>r;++r)n(t,e+32*r,t,e-32,8);}function je(t,e){var r;for(r=0;8>r;++r)i(t,e,t[e-1],8),e+=32;}function Oe(t,e,r){var n;for(n=0;8>n;++n)i(e,r+32*n,t,8);}function Be(t,e){var r,n=8;for(r=0;8>r;++r)n+=t[e+r-32]+t[e-1+32*r];Oe(n>>4,t,e);}function Me(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e+r-32];Oe(n>>3,t,e);}function Ee(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e-1+32*r];Oe(n>>3,t,e);}function qe(t,e){Oe(128,t,e);}function De(t,e,r){var n=t[e-r],i=t[e+0],a=3*(i-n)+jn[1020+t[e-2*r]-t[e+r]],o=On[112+(a+4>>3)];t[e-r]=Bn[255+n+On[112+(a+3>>3)]],t[e+0]=Bn[255+i-o];}function Re(t,e,r,n){var i=t[e+0],a=t[e+r];return Mn[255+t[e-2*r]-t[e-r]]>n||Mn[255+a-i]>n}function Te(t,e,r,n){return 4*Mn[255+t[e-r]-t[e+0]]+Mn[255+t[e-2*r]-t[e+r]]<=n}function Ue(t,e,r,n,i){var a=t[e-3*r],o=t[e-2*r],s=t[e-r],c=t[e+0],u=t[e+r],h=t[e+2*r],l=t[e+3*r];return 4*Mn[255+s-c]+Mn[255+o-u]>n?0:Mn[255+t[e-4*r]-a]<=i&&Mn[255+a-o]<=i&&Mn[255+o-s]<=i&&Mn[255+l-h]<=i&&Mn[255+h-u]<=i&&Mn[255+u-c]<=i}function ze(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)Te(t,e+n,r,i)&&De(t,e+n,r);}function He(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)Te(t,e+n*r,1,i)&&De(t,e+n*r,1);}function We(t,e,r,n){var i;for(i=3;0<i;--i)ze(t,e+=4*r,r,n);}function Ve(t,e,r,n){var i;for(i=3;0<i;--i)He(t,e+=4,r,n);}function Ge(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Re(t,e,r,s))De(t,e,r);else{var c=t,u=e,h=r,l=c[u-2*h],f=c[u-h],d=c[u+0],p=c[u+h],g=c[u+2*h],m=27*(b=jn[1020+3*(d-f)+jn[1020+l-p]])+63>>7,v=18*b+63>>7,b=9*b+63>>7;c[u-3*h]=Bn[255+c[u-3*h]+b],c[u-2*h]=Bn[255+l+v],c[u-h]=Bn[255+f+m],c[u+0]=Bn[255+d-m],c[u+h]=Bn[255+p-v],c[u+2*h]=Bn[255+g-b];}e+=n;}}function Ye(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Re(t,e,r,s))De(t,e,r);else{var c=t,u=e,h=r,l=c[u-h],f=c[u+0],d=c[u+h],p=On[112+((g=3*(f-l))+4>>3)],g=On[112+(g+3>>3)],m=p+1>>1;c[u-2*h]=Bn[255+c[u-2*h]+m],c[u-h]=Bn[255+l+g],c[u+0]=Bn[255+f-p],c[u+h]=Bn[255+d-m];}e+=n;}}function Je(t,e,r,n,i,a){Ge(t,e,r,1,16,n,i,a);}function Xe(t,e,r,n,i,a){Ge(t,e,1,r,16,n,i,a);}function Ke(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4*r,r,1,16,n,i,a);}function Ze(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4,1,r,16,n,i,a);}function $e(t,e,r,n,i,a,o,s){Ge(t,e,i,1,8,a,o,s),Ge(r,n,i,1,8,a,o,s);}function Qe(t,e,r,n,i,a,o,s){Ge(t,e,1,i,8,a,o,s),Ge(r,n,1,i,8,a,o,s);}function tr(t,e,r,n,i,a,o,s){Ye(t,e+4*i,i,1,8,a,o,s),Ye(r,n+4*i,i,1,8,a,o,s);}function er(t,e,r,n,i,a,o,s){Ye(t,e+4,1,i,8,a,o,s),Ye(r,n+4,1,i,8,a,o,s);}function rr(){this.ba=new ot,this.ec=[],this.cc=[],this.Mc=[],this.Dc=this.Nc=this.dc=this.fc=0,this.Oa=new ct,this.memory=0,this.Ib="OutputFunc",this.Jb="OutputAlphaFunc",this.Nd="OutputRowFunc";}function nr(){this.data=[],this.offset=this.kd=this.ha=this.w=0,this.na=[],this.xa=this.gb=this.Ja=this.Sa=this.P=0;}function ir(){this.nc=this.Ea=this.b=this.hc=0,this.K=[],this.w=0;}function ar(){this.ua=0,this.Wa=new M,this.vb=new M,this.md=this.xc=this.wc=0,this.vc=[],this.Wb=0,this.Ya=new d,this.yc=new l;}function or(){this.xb=this.a=0,this.l=new Gt,this.ca=new ot,this.V=[],this.Ba=0,this.Ta=[],this.Ua=0,this.m=new N,this.Pb=0,this.wd=new N,this.Ma=this.$=this.C=this.i=this.c=this.xd=0,this.s=new ar,this.ab=0,this.gc=o(4,ir),this.Oc=0;}function sr(){this.Lc=this.Z=this.$a=this.i=this.c=0,this.l=new Gt,this.ic=0,this.ca=[],this.tb=0,this.qd=null,this.rd=0;}function cr(t,e,r,n,i,a,o){for(t=null==t?0:t[e+0],e=0;e<o;++e)i[a+e]=t+r[n+e]&255,t=i[a+e];}function ur(t,e,r,n,i,a,o){var s;if(null==t)cr(null,null,r,n,i,a,o);else for(s=0;s<o;++s)i[a+s]=t[e+s]+r[n+s]&255;}function hr(t,e,r,n,i,a,o){if(null==t)cr(null,null,r,n,i,a,o);else{var s,c=t[e+0],u=c,h=c;for(s=0;s<o;++s)u=h+(c=t[e+s])-u,h=r[n+s]+(-256&u?0>u?0:255:u)&255,u=c,i[a+s]=h;}}function lr(t,r,i,o){var s=r.width,c=r.o;if(e(null!=t&&null!=r),0>i||0>=o||i+o>c)return null;if(!t.Cc){if(null==t.ga){var u;if(t.ga=new sr,(u=null==t.ga)||(u=r.width*r.o,e(0==t.Gb.length),t.Gb=a(u),t.Uc=0,null==t.Gb?u=0:(t.mb=t.Gb,t.nb=t.Uc,t.rc=null,u=1),u=!u),!u){u=t.ga;var h=t.Fa,l=t.P,f=t.qc,d=t.mb,p=t.nb,g=l+1,m=f-1,b=u.l;if(e(null!=h&&null!=d&&null!=r),mi[0]=null,mi[1]=cr,mi[2]=ur,mi[3]=hr,u.ca=d,u.tb=p,u.c=r.width,u.i=r.height,e(0<u.c&&0<u.i),1>=f)r=0;else if(u.$a=h[l+0]>>0&3,u.Z=h[l+0]>>2&3,u.Lc=h[l+0]>>4&3,l=h[l+0]>>6&3,0>u.$a||1<u.$a||4<=u.Z||1<u.Lc||l)r=0;else if(b.put=dt,b.ac=ft,b.bc=pt,b.ma=u,b.width=r.width,b.height=r.height,b.Da=r.Da,b.v=r.v,b.va=r.va,b.j=r.j,b.o=r.o,u.$a)t:{e(1==u.$a),r=kt();e:for(;;){if(null==r){r=0;break t}if(e(null!=u),u.mc=r,r.c=u.c,r.i=u.i,r.l=u.l,r.l.ma=u,r.l.width=u.c,r.l.height=u.i,r.a=0,v(r.m,h,g,m),!It(u.c,u.i,1,r,null))break e;if(1==r.ab&&3==r.gc[0].hc&&At(r.s)?(u.ic=1,h=r.c*r.i,r.Ta=null,r.Ua=0,r.V=a(h),r.Ba=0,null==r.V?(r.a=1,r=0):r=1):(u.ic=0,r=Ft(r,u.c)),!r)break e;r=1;break t}u.mc=null,r=0;}else r=m>=u.c*u.i;u=!r;}if(u)return null;1!=t.ga.Lc?t.Ga=0:o=c-i;}e(null!=t.ga),e(i+o<=c);t:{if(r=(h=t.ga).c,c=h.l.o,0==h.$a){if(g=t.rc,m=t.Vc,b=t.Fa,l=t.P+1+i*r,f=t.mb,d=t.nb+i*r,e(l<=t.P+t.qc),0!=h.Z)for(e(null!=mi[h.Z]),u=0;u<o;++u)mi[h.Z](g,m,b,l,f,d,r),g=f,m=d,d+=r,l+=r;else for(u=0;u<o;++u)n(f,d,b,l,r),g=f,m=d,d+=r,l+=r;t.rc=g,t.Vc=m;}else{if(e(null!=h.mc),r=i+o,e(null!=(u=h.mc)),e(r<=u.i),u.C>=r)r=1;else if(h.ic||mr(),h.ic){h=u.V,g=u.Ba,m=u.c;var y=u.i,w=(b=1,l=u.$/m,f=u.$%m,d=u.m,p=u.s,u.$),N=m*y,L=m*r,x=p.wc,_=w<L?wt(p,f,l):null;e(w<=N),e(r<=y),e(At(p));e:for(;;){for(;!d.h&&w<L;){if(f&x||(_=wt(p,f,l)),e(null!=_),S(d),256>(y=bt(_.G[0],_.H[0],d)))h[g+w]=y,++w,++f>=m&&(f=0,++l<=r&&!(l%16)&&St(u,l));else{if(!(280>y)){b=0;break e}y=mt(y-256,d);var P,k=bt(_.G[4],_.H[4],d);if(S(d),!(w>=(k=vt(m,k=mt(k,d)))&&N-w>=y)){b=0;break e}for(P=0;P<y;++P)h[g+w+P]=h[g+w+P-k];for(w+=y,f+=y;f>=m;)f-=m,++l<=r&&!(l%16)&&St(u,l);w<L&&f&x&&(_=wt(p,f,l));}e(d.h==A(d));}St(u,l>r?r:l);break e}!b||d.h&&w<N?(b=0,u.a=d.h?5:3):u.$=w,r=b;}else r=_t(u,u.V,u.Ba,u.c,u.i,r,Ct);if(!r){o=0;break t}}i+o>=c&&(t.Cc=1),o=1;}if(!o)return null;if(t.Cc&&(null!=(o=t.ga)&&(o.mc=null),t.ga=null,0<t.Ga))return alert("todo:WebPDequantizeLevels"),null}return t.nb+i*s}function fr(t,e,r,n,i,a){for(;0<i--;){var o,s=t,c=e+(r?1:0),u=t,h=e+(r?0:3);for(o=0;o<n;++o){var l=u[h+4*o];255!=l&&(l*=32897,s[c+4*o+0]=s[c+4*o+0]*l>>23,s[c+4*o+1]=s[c+4*o+1]*l>>23,s[c+4*o+2]=s[c+4*o+2]*l>>23);}e+=a;}}function dr(t,e,r,n,i){for(;0<n--;){var a;for(a=0;a<r;++a){var o=t[e+2*a+0],s=15&(u=t[e+2*a+1]),c=4369*s,u=(240&u|u>>4)*c>>16;t[e+2*a+0]=(240&o|o>>4)*c>>16&240|(15&o|o<<4)*c>>16>>4&15,t[e+2*a+1]=240&u|s;}e+=i;}}function pr(t,e,r,n,i,a,o,s){var c,u,h=255;for(u=0;u<i;++u){for(c=0;c<n;++c){var l=t[e+c];a[o+4*c]=l,h&=l;}e+=r,o+=s;}return 255!=h}function gr(t,e,r,n,i){var a;for(a=0;a<i;++a)r[n+a]=t[e+a]>>8;}function mr(){An=fr,xn=dr,Sn=pr,_n=gr;}function vr(r,n,i){t[r]=function(t,r,a,o,s,c,u,h,l,f,d,p,g,m,v,b,y){var w,N=y-1>>1,L=s[c+0]|u[h+0]<<16,A=l[f+0]|d[p+0]<<16;e(null!=t);var x=3*L+A+131074>>2;for(n(t[r+0],255&x,x>>16,g,m),null!=a&&(x=3*A+L+131074>>2,n(a[o+0],255&x,x>>16,v,b)),w=1;w<=N;++w){var S=s[c+w]|u[h+w]<<16,_=l[f+w]|d[p+w]<<16,P=L+S+A+_+524296,k=P+2*(S+A)>>3;x=k+L>>1,L=(P=P+2*(L+_)>>3)+S>>1,n(t[r+2*w-1],255&x,x>>16,g,m+(2*w-1)*i),n(t[r+2*w-0],255&L,L>>16,g,m+(2*w-0)*i),null!=a&&(x=P+A>>1,L=k+_>>1,n(a[o+2*w-1],255&x,x>>16,v,b+(2*w-1)*i),n(a[o+2*w+0],255&L,L>>16,v,b+(2*w+0)*i)),L=S,A=_;}1&y||(x=3*L+A+131074>>2,n(t[r+y-1],255&x,x>>16,g,m+(y-1)*i),null!=a&&(x=3*A+L+131074>>2,n(a[o+y-1],255&x,x>>16,v,b+(y-1)*i)));};}function br(){vi[En]=bi,vi[qn]=wi,vi[Dn]=yi,vi[Rn]=Ni,vi[Tn]=Li,vi[Un]=Ai,vi[zn]=xi,vi[Hn]=wi,vi[Wn]=Ni,vi[Vn]=Li,vi[Gn]=Ai;}function yr(t){return t&~Fi?0>t?0:255:t>>Ii}function wr(t,e){return yr((19077*t>>8)+(26149*e>>8)-14234)}function Nr(t,e,r){return yr((19077*t>>8)-(6419*e>>8)-(13320*r>>8)+8708)}function Lr(t,e){return yr((19077*t>>8)+(33050*e>>8)-17685)}function Ar(t,e,r,n,i){n[i+0]=wr(t,r),n[i+1]=Nr(t,e,r),n[i+2]=Lr(t,e);}function xr(t,e,r,n,i){n[i+0]=Lr(t,e),n[i+1]=Nr(t,e,r),n[i+2]=wr(t,r);}function Sr(t,e,r,n,i){var a=Nr(t,e,r);e=a<<3&224|Lr(t,e)>>3,n[i+0]=248&wr(t,r)|a>>5,n[i+1]=e;}function _r(t,e,r,n,i){var a=240&Lr(t,e)|15;n[i+0]=240&wr(t,r)|Nr(t,e,r)>>4,n[i+1]=a;}function Pr(t,e,r,n,i){n[i+0]=255,Ar(t,e,r,n,i+1);}function kr(t,e,r,n,i){xr(t,e,r,n,i),n[i+3]=255;}function Ir(t,e,r,n,i){Ar(t,e,r,n,i),n[i+3]=255;}function Vt(t,e){return 0>t?0:t>e?e:t}function Fr(e,r,n){t[e]=function(t,e,i,a,o,s,c,u,h){for(var l=u+(-2&h)*n;u!=l;)r(t[e+0],i[a+0],o[s+0],c,u),r(t[e+1],i[a+0],o[s+0],c,u+n),e+=2,++a,++s,u+=2*n;1&h&&r(t[e+0],i[a+0],o[s+0],c,u);};}function Cr(t,e,r){return 0==r?0==t?0==e?6:5:0==e?4:0:r}function jr(t,e,r,n,i){switch(t>>>30){case 3:on(e,r,n,i,0);break;case 2:sn(e,r,n,i);break;case 1:un(e,r,n,i);}}function Or(t,e){var r,a,o=e.M,s=e.Nb,c=t.oc,u=t.pc+40,h=t.oc,l=t.pc+584,f=t.oc,d=t.pc+600;for(r=0;16>r;++r)c[u+32*r-1]=129;for(r=0;8>r;++r)h[l+32*r-1]=129,f[d+32*r-1]=129;for(0<o?c[u-1-32]=h[l-1-32]=f[d-1-32]=129:(i(c,u-32-1,127,21),i(h,l-32-1,127,9),i(f,d-32-1,127,9)),a=0;a<t.za;++a){var p=e.ya[e.aa+a];if(0<a){for(r=-1;16>r;++r)n(c,u+32*r-4,c,u+32*r+12,4);for(r=-1;8>r;++r)n(h,l+32*r-4,h,l+32*r+4,4),n(f,d+32*r-4,f,d+32*r+4,4);}var g=t.Gd,m=t.Hd+a,v=p.ad,b=p.Hc;if(0<o&&(n(c,u-32,g[m].y,0,16),n(h,l-32,g[m].f,0,8),n(f,d-32,g[m].ea,0,8)),p.Za){var y=c,w=u-32+16;for(0<o&&(a>=t.za-1?i(y,w,g[m].y[15],4):n(y,w,g[m+1].y,0,4)),r=0;4>r;r++)y[w+128+r]=y[w+256+r]=y[w+384+r]=y[w+0+r];for(r=0;16>r;++r,b<<=2)y=c,w=u+Di[r],fi[p.Ob[r]](y,w),jr(b,v,16*+r,y,w);}else if(y=Cr(a,o,p.Ob[0]),li[y](c,u),0!=b)for(r=0;16>r;++r,b<<=2)jr(b,v,16*+r,c,u+Di[r]);for(r=p.Gc,y=Cr(a,o,p.Dd),di[y](h,l),di[y](f,d),b=v,y=h,w=l,255&(p=r>>0)&&(170&p?cn(b,256,y,w):hn(b,256,y,w)),p=f,b=d,255&(r>>=8)&&(170&r?cn(v,320,p,b):hn(v,320,p,b)),o<t.Ub-1&&(n(g[m].y,0,c,u+480,16),n(g[m].f,0,h,l+224,8),n(g[m].ea,0,f,d+224,8)),r=8*s*t.B,g=t.sa,m=t.ta+16*a+16*s*t.R,v=t.qa,p=t.ra+8*a+r,b=t.Ha,y=t.Ia+8*a+r,r=0;16>r;++r)n(g,m+r*t.R,c,u+32*r,16);for(r=0;8>r;++r)n(v,p+r*t.B,h,l+32*r,8),n(b,y+r*t.B,f,d+32*r,8);}}function Br(t,n,i,a,o,s,c,u,h){var l=[0],f=[0],d=0,p=null!=h?h.kd:0,g=null!=h?h:new nr;if(null==t||12>i)return 7;g.data=t,g.w=n,g.ha=i,n=[n],i=[i],g.gb=[g.gb];t:{var m=n,b=i,y=g.gb;if(e(null!=t),e(null!=b),e(null!=y),y[0]=0,12<=b[0]&&!r(t,m[0],"RIFF")){if(r(t,m[0]+8,"WEBP")){y=3;break t}var w=j(t,m[0]+4);if(12>w||4294967286<w){y=3;break t}if(p&&w>b[0]-8){y=7;break t}y[0]=w,m[0]+=12,b[0]-=12;}y=0;}if(0!=y)return y;for(w=0<g.gb[0],i=i[0];;){t:{var L=t;b=n,y=i;var A=l,x=f,S=m=[0];if((k=d=[d])[0]=0,8>y[0])y=7;else{if(!r(L,b[0],"VP8X")){if(10!=j(L,b[0]+4)){y=3;break t}if(18>y[0]){y=7;break t}var _=j(L,b[0]+8),P=1+C(L,b[0]+12);if(2147483648<=P*(L=1+C(L,b[0]+15))){y=3;break t}null!=S&&(S[0]=_),null!=A&&(A[0]=P),null!=x&&(x[0]=L),b[0]+=18,y[0]-=18,k[0]=1;}y=0;}}if(d=d[0],m=m[0],0!=y)return y;if(b=!!(2&m),!w&&d)return 3;if(null!=s&&(s[0]=!!(16&m)),null!=c&&(c[0]=b),null!=u&&(u[0]=0),c=l[0],m=f[0],d&&b&&null==h){y=0;break}if(4>i){y=7;break}if(w&&d||!w&&!d&&!r(t,n[0],"ALPH")){i=[i],g.na=[g.na],g.P=[g.P],g.Sa=[g.Sa];t:{_=t,y=n,w=i;var k=g.gb;A=g.na,x=g.P,S=g.Sa;P=22,e(null!=_),e(null!=w),L=y[0];var I=w[0];for(e(null!=A),e(null!=S),A[0]=null,x[0]=null,S[0]=0;;){if(y[0]=L,w[0]=I,8>I){y=7;break t}var F=j(_,L+4);if(4294967286<F){y=3;break t}var O=8+F+1&-2;if(P+=O,0<k&&P>k){y=3;break t}if(!r(_,L,"VP8 ")||!r(_,L,"VP8L")){y=0;break t}if(I[0]<O){y=7;break t}r(_,L,"ALPH")||(A[0]=_,x[0]=L+8,S[0]=F),L+=O,I-=O;}}if(i=i[0],g.na=g.na[0],g.P=g.P[0],g.Sa=g.Sa[0],0!=y)break}i=[i],g.Ja=[g.Ja],g.xa=[g.xa];t:if(k=t,y=n,w=i,A=g.gb[0],x=g.Ja,S=g.xa,_=y[0],L=!r(k,_,"VP8 "),P=!r(k,_,"VP8L"),e(null!=k),e(null!=w),e(null!=x),e(null!=S),8>w[0])y=7;else{if(L||P){if(k=j(k,_+4),12<=A&&k>A-12){y=3;break t}if(p&&k>w[0]-8){y=7;break t}x[0]=k,y[0]+=8,w[0]-=8,S[0]=P;}else S[0]=5<=w[0]&&47==k[_+0]&&!(k[_+4]>>5),x[0]=w[0];y=0;}if(i=i[0],g.Ja=g.Ja[0],g.xa=g.xa[0],n=n[0],0!=y)break;if(4294967286<g.Ja)return 3;if(null==u||b||(u[0]=g.xa?2:1),c=[c],m=[m],g.xa){if(5>i){y=7;break}u=c,p=m,b=s,null==t||5>i?t=0:5<=i&&47==t[n+0]&&!(t[n+4]>>5)?(w=[0],k=[0],A=[0],v(x=new N,t,n,i),gt(x,w,k,A)?(null!=u&&(u[0]=w[0]),null!=p&&(p[0]=k[0]),null!=b&&(b[0]=A[0]),t=1):t=0):t=0;}else{if(10>i){y=7;break}u=m,null==t||10>i||!Xt(t,n+3,i-3)?t=0:(p=t[n+0]|t[n+1]<<8|t[n+2]<<16,b=16383&(t[n+7]<<8|t[n+6]),t=16383&(t[n+9]<<8|t[n+8]),1&p||3<(p>>1&7)||!(p>>4&1)||p>>5>=g.Ja||!b||!t?t=0:(c&&(c[0]=b),u&&(u[0]=t),t=1));}if(!t)return 3;if(c=c[0],m=m[0],d&&(l[0]!=c||f[0]!=m))return 3;null!=h&&(h[0]=g,h.offset=n-h.w,e(4294967286>n-h.w),e(h.offset==h.ha-i));break}return 0==y||7==y&&d&&null==h?(null!=s&&(s[0]|=null!=g.na&&0<g.na.length),null!=a&&(a[0]=c),null!=o&&(o[0]=m),0):y}function Mr(t,e,r){var n=e.width,i=e.height,a=0,o=0,s=n,c=i;if(e.Da=null!=t&&0<t.Da,e.Da&&(s=t.cd,c=t.bd,a=t.v,o=t.j,11>r||(a&=-2,o&=-2),0>a||0>o||0>=s||0>=c||a+s>n||o+c>i))return 0;if(e.v=a,e.j=o,e.va=a+s,e.o=o+c,e.U=s,e.T=c,e.da=null!=t&&0<t.da,e.da){if(!E(s,c,r=[t.ib],a=[t.hb]))return 0;e.ib=r[0],e.hb=a[0];}return e.ob=null!=t&&t.ob,e.Kb=null==t||!t.Sd,e.da&&(e.ob=e.ib<3*n/4&&e.hb<3*i/4,e.Kb=0),1}function Er(t){if(null==t)return 2;if(11>t.S){var e=t.f.RGBA;e.fb+=(t.height-1)*e.A,e.A=-e.A;}else e=t.f.kb,t=t.height,e.O+=(t-1)*e.fa,e.fa=-e.fa,e.N+=(t-1>>1)*e.Ab,e.Ab=-e.Ab,e.W+=(t-1>>1)*e.Db,e.Db=-e.Db,null!=e.F&&(e.J+=(t-1)*e.lb,e.lb=-e.lb);return 0}function qr(t,e,r,n){if(null==n||0>=t||0>=e)return 2;if(null!=r){if(r.Da){var i=r.cd,o=r.bd,s=-2&r.v,c=-2&r.j;if(0>s||0>c||0>=i||0>=o||s+i>t||c+o>e)return 2;t=i,e=o;}if(r.da){if(!E(t,e,i=[r.ib],o=[r.hb]))return 2;t=i[0],e=o[0];}}n.width=t,n.height=e;t:{var u=n.width,h=n.height;if(t=n.S,0>=u||0>=h||!(t>=En&&13>t))t=2;else{if(0>=n.Rd&&null==n.sd){s=o=i=e=0;var l=(c=u*zi[t])*h;if(11>t||(o=(h+1)/2*(e=(u+1)/2),12==t&&(s=(i=u)*h)),null==(h=a(l+2*o+s))){t=1;break t}n.sd=h,11>t?((u=n.f.RGBA).eb=h,u.fb=0,u.A=c,u.size=l):((u=n.f.kb).y=h,u.O=0,u.fa=c,u.Fd=l,u.f=h,u.N=0+l,u.Ab=e,u.Cd=o,u.ea=h,u.W=0+l+o,u.Db=e,u.Ed=o,12==t&&(u.F=h,u.J=0+l+2*o),u.Tc=s,u.lb=i);}if(e=1,i=n.S,o=n.width,s=n.height,i>=En&&13>i)if(11>i)t=n.f.RGBA,e&=(c=Math.abs(t.A))*(s-1)+o<=t.size,e&=c>=o*zi[i],e&=null!=t.eb;else{t=n.f.kb,c=(o+1)/2,l=(s+1)/2,u=Math.abs(t.fa);h=Math.abs(t.Ab);var f=Math.abs(t.Db),d=Math.abs(t.lb),p=d*(s-1)+o;e&=u*(s-1)+o<=t.Fd,e&=h*(l-1)+c<=t.Cd,e=(e&=f*(l-1)+c<=t.Ed)&u>=o&h>=c&f>=c,e&=null!=t.y,e&=null!=t.f,e&=null!=t.ea,12==i&&(e&=d>=o,e&=p<=t.Tc,e&=null!=t.F);}else e=0;t=e?0:2;}}return 0!=t||null!=r&&r.fd&&(t=Er(n)),t}var Dr=64,Rr=[0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535,131071,262143,524287,1048575,2097151,4194303,8388607,16777215],Tr=24,Ur=32,zr=8,Hr=[0,0,1,1,2,2,2,2,3,3,3,3,3,3,3,3,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7];R("Predictor0","PredictorAdd0"),t.Predictor0=function(){return 4278190080},t.Predictor1=function(t){return t},t.Predictor2=function(t,e,r){return e[r+0]},t.Predictor3=function(t,e,r){return e[r+1]},t.Predictor4=function(t,e,r){return e[r-1]},t.Predictor5=function(t,e,r){return U(U(t,e[r+1]),e[r+0])},t.Predictor6=function(t,e,r){return U(t,e[r-1])},t.Predictor7=function(t,e,r){return U(t,e[r+0])},t.Predictor8=function(t,e,r){return U(e[r-1],e[r+0])},t.Predictor9=function(t,e,r){return U(e[r+0],e[r+1])},t.Predictor10=function(t,e,r){return U(U(t,e[r-1]),U(e[r+0],e[r+1]))},t.Predictor11=function(t,e,r){var n=e[r+0];return 0>=W(n>>24&255,t>>24&255,(e=e[r-1])>>24&255)+W(n>>16&255,t>>16&255,e>>16&255)+W(n>>8&255,t>>8&255,e>>8&255)+W(255&n,255&t,255&e)?n:t},t.Predictor12=function(t,e,r){var n=e[r+0];return (z((t>>24&255)+(n>>24&255)-((e=e[r-1])>>24&255))<<24|z((t>>16&255)+(n>>16&255)-(e>>16&255))<<16|z((t>>8&255)+(n>>8&255)-(e>>8&255))<<8|z((255&t)+(255&n)-(255&e)))>>>0},t.Predictor13=function(t,e,r){var n=e[r-1];return (H((t=U(t,e[r+0]))>>24&255,n>>24&255)<<24|H(t>>16&255,n>>16&255)<<16|H(t>>8&255,n>>8&255)<<8|H(t>>0&255,n>>0&255))>>>0};var Wr=t.PredictorAdd0;t.PredictorAdd1=V,R("Predictor2","PredictorAdd2"),R("Predictor3","PredictorAdd3"),R("Predictor4","PredictorAdd4"),R("Predictor5","PredictorAdd5"),R("Predictor6","PredictorAdd6"),R("Predictor7","PredictorAdd7"),R("Predictor8","PredictorAdd8"),R("Predictor9","PredictorAdd9"),R("Predictor10","PredictorAdd10"),R("Predictor11","PredictorAdd11"),R("Predictor12","PredictorAdd12"),R("Predictor13","PredictorAdd13");var Vr=t.PredictorAdd2;X("ColorIndexInverseTransform","MapARGB","32b",(function(t){return t>>8&255}),(function(t){return t})),X("VP8LColorIndexInverseTransformAlpha","MapAlpha","8b",(function(t){return t}),(function(t){return t>>8&255}));var Gr,Yr=t.ColorIndexInverseTransform,Jr=t.MapARGB,Xr=t.VP8LColorIndexInverseTransformAlpha,Kr=t.MapAlpha,Zr=t.VP8LPredictorsAdd=[];Zr.length=16,(t.VP8LPredictors=[]).length=16,(t.VP8LPredictorsAdd_C=[]).length=16,(t.VP8LPredictors_C=[]).length=16;var $r,Qr,tn,en,rn,nn,an,on,sn,cn,un,hn,ln,fn,dn,pn,gn,mn,vn,bn,yn,wn,Nn,Ln,An,xn,Sn,_n,Pn=a(511),kn=a(2041),In=a(225),Fn=a(767),Cn=0,jn=kn,On=In,Bn=Fn,Mn=Pn,En=0,qn=1,Dn=2,Rn=3,Tn=4,Un=5,zn=6,Hn=7,Wn=8,Vn=9,Gn=10,Yn=[2,3,7],Jn=[3,3,11],Xn=[280,256,256,256,40],Kn=[0,1,1,1,0],Zn=[17,18,0,1,2,3,4,5,16,6,7,8,9,10,11,12,13,14,15],$n=[24,7,23,25,40,6,39,41,22,26,38,42,56,5,55,57,21,27,54,58,37,43,72,4,71,73,20,28,53,59,70,74,36,44,88,69,75,52,60,3,87,89,19,29,86,90,35,45,68,76,85,91,51,61,104,2,103,105,18,30,102,106,34,46,84,92,67,77,101,107,50,62,120,1,119,121,83,93,17,31,100,108,66,78,118,122,33,47,117,123,49,63,99,109,82,94,0,116,124,65,79,16,32,98,110,48,115,125,81,95,64,114,126,97,111,80,113,127,96,112],Qn=[2954,2956,2958,2962,2970,2986,3018,3082,3212,3468,3980,5004],ti=8,ei=[4,5,6,7,8,9,10,10,11,12,13,14,15,16,17,17,18,19,20,20,21,21,22,22,23,23,24,25,25,26,27,28,29,30,31,32,33,34,35,36,37,37,38,39,40,41,42,43,44,45,46,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,76,77,78,79,80,81,82,83,84,85,86,87,88,89,91,93,95,96,98,100,101,102,104,106,108,110,112,114,116,118,122,124,126,128,130,132,134,136,138,140,143,145,148,151,154,157],ri=[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,119,122,125,128,131,134,137,140,143,146,149,152,155,158,161,164,167,170,173,177,181,185,189,193,197,201,205,209,213,217,221,225,229,234,239,245,249,254,259,264,269,274,279,284],ni=null,ii=[[173,148,140,0],[176,155,140,135,0],[180,157,141,134,130,0],[254,254,243,230,196,177,153,140,133,130,129,0]],ai=[0,1,4,8,5,2,3,6,9,12,13,10,7,11,14,15],oi=[-0,1,-1,2,-2,3,4,6,-3,5,-4,-5,-6,7,-7,8,-8,-9],si=[[[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]],[[253,136,254,255,228,219,128,128,128,128,128],[189,129,242,255,227,213,255,219,128,128,128],[106,126,227,252,214,209,255,255,128,128,128]],[[1,98,248,255,236,226,255,255,128,128,128],[181,133,238,254,221,234,255,154,128,128,128],[78,134,202,247,198,180,255,219,128,128,128]],[[1,185,249,255,243,255,128,128,128,128,128],[184,150,247,255,236,224,128,128,128,128,128],[77,110,216,255,236,230,128,128,128,128,128]],[[1,101,251,255,241,255,128,128,128,128,128],[170,139,241,252,236,209,255,255,128,128,128],[37,116,196,243,228,255,255,255,128,128,128]],[[1,204,254,255,245,255,128,128,128,128,128],[207,160,250,255,238,128,128,128,128,128,128],[102,103,231,255,211,171,128,128,128,128,128]],[[1,152,252,255,240,255,128,128,128,128,128],[177,135,243,255,234,225,128,128,128,128,128],[80,129,211,255,194,224,128,128,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[246,1,255,128,128,128,128,128,128,128,128],[255,128,128,128,128,128,128,128,128,128,128]]],[[[198,35,237,223,193,187,162,160,145,155,62],[131,45,198,221,172,176,220,157,252,221,1],[68,47,146,208,149,167,221,162,255,223,128]],[[1,149,241,255,221,224,255,255,128,128,128],[184,141,234,253,222,220,255,199,128,128,128],[81,99,181,242,176,190,249,202,255,255,128]],[[1,129,232,253,214,197,242,196,255,255,128],[99,121,210,250,201,198,255,202,128,128,128],[23,91,163,242,170,187,247,210,255,255,128]],[[1,200,246,255,234,255,128,128,128,128,128],[109,178,241,255,231,245,255,255,128,128,128],[44,130,201,253,205,192,255,255,128,128,128]],[[1,132,239,251,219,209,255,165,128,128,128],[94,136,225,251,218,190,255,255,128,128,128],[22,100,174,245,186,161,255,199,128,128,128]],[[1,182,249,255,232,235,128,128,128,128,128],[124,143,241,255,227,234,128,128,128,128,128],[35,77,181,251,193,211,255,205,128,128,128]],[[1,157,247,255,236,231,255,255,128,128,128],[121,141,235,255,225,227,255,255,128,128,128],[45,99,188,251,195,217,255,224,128,128,128]],[[1,1,251,255,213,255,128,128,128,128,128],[203,1,248,255,255,128,128,128,128,128,128],[137,1,177,255,224,255,128,128,128,128,128]]],[[[253,9,248,251,207,208,255,192,128,128,128],[175,13,224,243,193,185,249,198,255,255,128],[73,17,171,221,161,179,236,167,255,234,128]],[[1,95,247,253,212,183,255,255,128,128,128],[239,90,244,250,211,209,255,255,128,128,128],[155,77,195,248,188,195,255,255,128,128,128]],[[1,24,239,251,218,219,255,205,128,128,128],[201,51,219,255,196,186,128,128,128,128,128],[69,46,190,239,201,218,255,228,128,128,128]],[[1,191,251,255,255,128,128,128,128,128,128],[223,165,249,255,213,255,128,128,128,128,128],[141,124,248,255,255,128,128,128,128,128,128]],[[1,16,248,255,255,128,128,128,128,128,128],[190,36,230,255,236,255,128,128,128,128,128],[149,1,255,128,128,128,128,128,128,128,128]],[[1,226,255,128,128,128,128,128,128,128,128],[247,192,255,128,128,128,128,128,128,128,128],[240,128,255,128,128,128,128,128,128,128,128]],[[1,134,252,255,255,128,128,128,128,128,128],[213,62,250,255,255,128,128,128,128,128,128],[55,93,255,128,128,128,128,128,128,128,128]],[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]]],[[[202,24,213,235,186,191,220,160,240,175,255],[126,38,182,232,169,184,228,174,255,187,128],[61,46,138,219,151,178,240,170,255,216,128]],[[1,112,230,250,199,191,247,159,255,255,128],[166,109,228,252,211,215,255,174,128,128,128],[39,77,162,232,172,180,245,178,255,255,128]],[[1,52,220,246,198,199,249,220,255,255,128],[124,74,191,243,183,193,250,221,255,255,128],[24,71,130,219,154,170,243,182,255,255,128]],[[1,182,225,249,219,240,255,224,128,128,128],[149,150,226,252,216,205,255,171,128,128,128],[28,108,170,242,183,194,254,223,255,255,128]],[[1,81,230,252,204,203,255,192,128,128,128],[123,102,209,247,188,196,255,233,128,128,128],[20,95,153,243,164,173,255,203,128,128,128]],[[1,222,248,255,216,213,128,128,128,128,128],[168,175,246,252,235,205,255,255,128,128,128],[47,116,215,255,211,212,255,255,128,128,128]],[[1,121,236,253,212,214,255,255,128,128,128],[141,84,213,252,201,202,255,219,128,128,128],[42,80,160,240,162,185,255,205,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[244,1,255,128,128,128,128,128,128,128,128],[238,1,255,128,128,128,128,128,128,128,128]]]],ci=[[[231,120,48,89,115,113,120,152,112],[152,179,64,126,170,118,46,70,95],[175,69,143,80,85,82,72,155,103],[56,58,10,171,218,189,17,13,152],[114,26,17,163,44,195,21,10,173],[121,24,80,195,26,62,44,64,85],[144,71,10,38,171,213,144,34,26],[170,46,55,19,136,160,33,206,71],[63,20,8,114,114,208,12,9,226],[81,40,11,96,182,84,29,16,36]],[[134,183,89,137,98,101,106,165,148],[72,187,100,130,157,111,32,75,80],[66,102,167,99,74,62,40,234,128],[41,53,9,178,241,141,26,8,107],[74,43,26,146,73,166,49,23,157],[65,38,105,160,51,52,31,115,128],[104,79,12,27,217,255,87,17,7],[87,68,71,44,114,51,15,186,23],[47,41,14,110,182,183,21,17,194],[66,45,25,102,197,189,23,18,22]],[[88,88,147,150,42,46,45,196,205],[43,97,183,117,85,38,35,179,61],[39,53,200,87,26,21,43,232,171],[56,34,51,104,114,102,29,93,77],[39,28,85,171,58,165,90,98,64],[34,22,116,206,23,34,43,166,73],[107,54,32,26,51,1,81,43,31],[68,25,106,22,64,171,36,225,114],[34,19,21,102,132,188,16,76,124],[62,18,78,95,85,57,50,48,51]],[[193,101,35,159,215,111,89,46,111],[60,148,31,172,219,228,21,18,111],[112,113,77,85,179,255,38,120,114],[40,42,1,196,245,209,10,25,109],[88,43,29,140,166,213,37,43,154],[61,63,30,155,67,45,68,1,209],[100,80,8,43,154,1,51,26,71],[142,78,78,16,255,128,34,197,171],[41,40,5,102,211,183,4,1,221],[51,50,17,168,209,192,23,25,82]],[[138,31,36,171,27,166,38,44,229],[67,87,58,169,82,115,26,59,179],[63,59,90,180,59,166,93,73,154],[40,40,21,116,143,209,34,39,175],[47,15,16,183,34,223,49,45,183],[46,17,33,183,6,98,15,32,183],[57,46,22,24,128,1,54,17,37],[65,32,73,115,28,128,23,128,205],[40,3,9,115,51,192,18,6,223],[87,37,9,115,59,77,64,21,47]],[[104,55,44,218,9,54,53,130,226],[64,90,70,205,40,41,23,26,57],[54,57,112,184,5,41,38,166,213],[30,34,26,133,152,116,10,32,134],[39,19,53,221,26,114,32,73,255],[31,9,65,234,2,15,1,118,73],[75,32,12,51,192,255,160,43,51],[88,31,35,67,102,85,55,186,85],[56,21,23,111,59,205,45,37,192],[55,38,70,124,73,102,1,34,98]],[[125,98,42,88,104,85,117,175,82],[95,84,53,89,128,100,113,101,45],[75,79,123,47,51,128,81,171,1],[57,17,5,71,102,57,53,41,49],[38,33,13,121,57,73,26,1,85],[41,10,67,138,77,110,90,47,114],[115,21,2,10,102,255,166,23,6],[101,29,16,10,85,128,101,196,26],[57,18,10,102,102,213,34,20,43],[117,20,15,36,163,128,68,1,26]],[[102,61,71,37,34,53,31,243,192],[69,60,71,38,73,119,28,222,37],[68,45,128,34,1,47,11,245,171],[62,17,19,70,146,85,55,62,70],[37,43,37,154,100,163,85,160,1],[63,9,92,136,28,64,32,201,85],[75,15,9,9,64,255,184,119,16],[86,6,28,5,64,255,25,248,1],[56,8,17,132,137,255,55,116,128],[58,15,20,82,135,57,26,121,40]],[[164,50,31,137,154,133,25,35,218],[51,103,44,131,131,123,31,6,158],[86,40,64,135,148,224,45,183,128],[22,26,17,131,240,154,14,1,209],[45,16,21,91,64,222,7,1,197],[56,21,39,155,60,138,23,102,213],[83,12,13,54,192,255,68,47,28],[85,26,85,85,128,128,32,146,171],[18,11,7,63,144,171,4,4,246],[35,27,10,146,174,171,12,26,128]],[[190,80,35,99,180,80,126,54,45],[85,126,47,87,176,51,41,20,32],[101,75,128,139,118,146,116,128,85],[56,41,15,176,236,85,37,9,62],[71,30,17,119,118,255,17,18,138],[101,38,60,138,55,70,43,26,142],[146,36,19,30,171,255,97,27,20],[138,45,61,62,219,1,81,188,64],[32,41,20,117,151,142,20,21,163],[112,19,12,61,195,128,48,4,24]]],ui=[[[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[176,246,255,255,255,255,255,255,255,255,255],[223,241,252,255,255,255,255,255,255,255,255],[249,253,253,255,255,255,255,255,255,255,255]],[[255,244,252,255,255,255,255,255,255,255,255],[234,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255]],[[255,246,254,255,255,255,255,255,255,255,255],[239,253,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[251,255,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[251,254,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,254,253,255,254,255,255,255,255,255,255],[250,255,254,255,254,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[217,255,255,255,255,255,255,255,255,255,255],[225,252,241,253,255,255,254,255,255,255,255],[234,250,241,250,253,255,253,254,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[223,254,254,255,255,255,255,255,255,255,255],[238,253,254,254,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[249,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,255,255,255,255,255,255,255,255,255],[247,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[252,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[186,251,250,255,255,255,255,255,255,255,255],[234,251,244,254,255,255,255,255,255,255,255],[251,251,243,253,254,255,254,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[236,253,254,255,255,255,255,255,255,255,255],[251,253,253,254,254,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[254,254,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[254,254,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[248,255,255,255,255,255,255,255,255,255,255],[250,254,252,254,255,255,255,255,255,255,255],[248,254,249,253,255,255,255,255,255,255,255]],[[255,253,253,255,255,255,255,255,255,255,255],[246,253,253,255,255,255,255,255,255,255,255],[252,254,251,254,254,255,255,255,255,255,255]],[[255,254,252,255,255,255,255,255,255,255,255],[248,254,253,255,255,255,255,255,255,255,255],[253,255,254,254,255,255,255,255,255,255,255]],[[255,251,254,255,255,255,255,255,255,255,255],[245,251,254,255,255,255,255,255,255,255,255],[253,253,254,255,255,255,255,255,255,255,255]],[[255,251,253,255,255,255,255,255,255,255,255],[252,253,254,255,255,255,255,255,255,255,255],[255,254,255,255,255,255,255,255,255,255,255]],[[255,252,255,255,255,255,255,255,255,255,255],[249,255,254,255,255,255,255,255,255,255,255],[255,255,254,255,255,255,255,255,255,255,255]],[[255,255,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]]],hi=[0,1,2,3,6,4,5,6,6,6,6,6,6,6,6,7,0],li=[],fi=[],di=[],pi=1,gi=2,mi=[],vi=[];vr("UpsampleRgbLinePair",Ar,3),vr("UpsampleBgrLinePair",xr,3),vr("UpsampleRgbaLinePair",Ir,4),vr("UpsampleBgraLinePair",kr,4),vr("UpsampleArgbLinePair",Pr,4),vr("UpsampleRgba4444LinePair",_r,2),vr("UpsampleRgb565LinePair",Sr,2);var bi=t.UpsampleRgbLinePair,yi=t.UpsampleBgrLinePair,wi=t.UpsampleRgbaLinePair,Ni=t.UpsampleBgraLinePair,Li=t.UpsampleArgbLinePair,Ai=t.UpsampleRgba4444LinePair,xi=t.UpsampleRgb565LinePair,Si=16,_i=1<<Si-1,Pi=-227,ki=482,Ii=6,Fi=(256<<Ii)-1,Ci=0,ji=a(256),Oi=a(256),Bi=a(256),Mi=a(256),Ei=a(ki-Pi),qi=a(ki-Pi);Fr("YuvToRgbRow",Ar,3),Fr("YuvToBgrRow",xr,3),Fr("YuvToRgbaRow",Ir,4),Fr("YuvToBgraRow",kr,4),Fr("YuvToArgbRow",Pr,4),Fr("YuvToRgba4444Row",_r,2),Fr("YuvToRgb565Row",Sr,2);var Di=[0,4,8,12,128,132,136,140,256,260,264,268,384,388,392,396],Ri=[0,2,8],Ti=[8,7,6,4,4,2,2,2,1,1,1,1],Ui=1;this.WebPDecodeRGBA=function(t,r,n,i,a){var o=qn,s=new rr,c=new ot;s.ba=c,c.S=o,c.width=[c.width],c.height=[c.height];var u=c.width,h=c.height,l=new st;if(null==l||null==t)var f=2;else e(null!=l),f=Br(t,r,n,l.width,l.height,l.Pd,l.Qd,l.format,null);if(0!=f?u=0:(null!=u&&(u[0]=l.width[0]),null!=h&&(h[0]=l.height[0]),u=1),u){c.width=c.width[0],c.height=c.height[0],null!=i&&(i[0]=c.width),null!=a&&(a[0]=c.height);t:{if(i=new Gt,(a=new nr).data=t,a.w=r,a.ha=n,a.kd=1,r=[0],e(null!=a),(0==(t=Br(a.data,a.w,a.ha,null,null,null,r,null,a))||7==t)&&r[0]&&(t=4),0==(r=t)){if(e(null!=s),i.data=a.data,i.w=a.w+a.offset,i.ha=a.ha-a.offset,i.put=dt,i.ac=ft,i.bc=pt,i.ma=s,a.xa){if(null==(t=kt())){s=1;break t}if(function(t,r){var n=[0],i=[0],a=[0];e:for(;;){if(null==t)return 0;if(null==r)return t.a=2,0;if(t.l=r,t.a=0,v(t.m,r.data,r.w,r.ha),!gt(t.m,n,i,a)){t.a=3;break e}if(t.xb=gi,r.width=n[0],r.height=i[0],!It(n[0],i[0],1,t,null))break e;return 1}return e(0!=t.a),0}(t,i)){if(i=0==(r=qr(i.width,i.height,s.Oa,s.ba))){e:{i=t;r:for(;;){if(null==i){i=0;break e}if(e(null!=i.s.yc),e(null!=i.s.Ya),e(0<i.s.Wb),e(null!=(n=i.l)),e(null!=(a=n.ma)),0!=i.xb){if(i.ca=a.ba,i.tb=a.tb,e(null!=i.ca),!Mr(a.Oa,n,Rn)){i.a=2;break r}if(!Ft(i,n.width))break r;if(n.da)break r;if((n.da||nt(i.ca.S))&&mr(),11>i.ca.S||(alert("todo:WebPInitConvertARGBToYUV"),null!=i.ca.f.kb.F&&mr()),i.Pb&&0<i.s.ua&&null==i.s.vb.X&&!O(i.s.vb,i.s.Wa.Xa)){i.a=1;break r}i.xb=0;}if(!_t(i,i.V,i.Ba,i.c,i.i,n.o,Lt))break r;a.Dc=i.Ma,i=1;break e}e(0!=i.a),i=0;}i=!i;}i&&(r=t.a);}else r=t.a;}else{if(null==(t=new Yt)){s=1;break t}if(t.Fa=a.na,t.P=a.P,t.qc=a.Sa,Kt(t,i)){if(0==(r=qr(i.width,i.height,s.Oa,s.ba))){if(t.Aa=0,n=s.Oa,e(null!=(a=t)),null!=n){if(0<(u=0>(u=n.Md)?0:100<u?255:255*u/100)){for(h=l=0;4>h;++h)12>(f=a.pb[h]).lc&&(f.ia=u*Ti[0>f.lc?0:f.lc]>>3),l|=f.ia;l&&(alert("todo:VP8InitRandom"),a.ia=1);}a.Ga=n.Id,100<a.Ga?a.Ga=100:0>a.Ga&&(a.Ga=0);}Qt(t,i)||(r=t.a);}}else r=t.a;}0==r&&null!=s.Oa&&s.Oa.fd&&(r=Er(s.ba));}s=r;}o=0!=s?null:11>o?c.f.RGBA.eb:c.f.kb.y;}else o=null;return o};var zi=[3,4,3,4,4,2,2,4,4,4,2,1,1];};function u(t,e){for(var r="",n=0;n<4;n++)r+=String.fromCharCode(t[e++]);return r}function h(t,e){return (t[e+0]<<0|t[e+1]<<8|t[e+2]<<16)>>>0}function l(t,e){return (t[e+0]<<0|t[e+1]<<8|t[e+2]<<16|t[e+3]<<24)>>>0}new c;var f=[0],d=[0],p=[],g=new c,m=t,v=function(t,e){var r={},n=0,i=!1,a=0,o=0;if(r.frames=[],!
/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */
function(t,e,r,n){for(var i=0;i<n;i++)if(t[e+i]!=r.charCodeAt(i))return !0;return !1}(t,e,"RIFF",4)){var s,c;l(t,e+=4);for(e+=8;e<t.length;){var f=u(t,e),d=l(t,e+=4);e+=4;var p=d+(1&d);switch(f){case"VP8 ":case"VP8L":void 0===r.frames[n]&&(r.frames[n]={});(v=r.frames[n]).src_off=i?o:e-8,v.src_size=a+d+8,n++,i&&(i=!1,a=0,o=0);break;case"VP8X":(v=r.header={}).feature_flags=t[e];var g=e+4;v.canvas_width=1+h(t,g);g+=3;v.canvas_height=1+h(t,g);g+=3;break;case"ALPH":i=!0,a=p+8,o=e-8;break;case"ANIM":(v=r.header).bgcolor=l(t,e);g=e+4;v.loop_count=(s=t)[(c=g)+0]<<0|s[c+1]<<8;g+=2;break;case"ANMF":var m,v;(v=r.frames[n]={}).offset_x=2*h(t,e),e+=3,v.offset_y=2*h(t,e),e+=3,v.width=1+h(t,e),e+=3,v.height=1+h(t,e),e+=3,v.duration=h(t,e),e+=3,m=t[e++],v.dispose=1&m,v.blend=m>>1&1;}"ANMF"!=f&&(e+=p);}return r}}(m,0);v.response=m,v.rgbaoutput=!0,v.dataurl=!1;var b=v.header?v.header:null,y=v.frames?v.frames:null;if(b){b.loop_counter=b.loop_count,f=[b.canvas_height],d=[b.canvas_width];for(var w=0;w<y.length&&0!=y[w].blend;w++);}var N=y[0],L=g.WebPDecodeRGBA(m,N.src_off,N.src_size,d,f);N.rgba=L,N.imgwidth=d[0],N.imgheight=f[0];for(var A=0;A<d[0]*f[0]*4;A++)p[A]=L[A];return this.width=d,this.height=f,this.data=p,this}!function(t){var r=function(){return "function"==typeof zlibSync},n=function(r,n,a,h){var l=4,f=s;switch(h){case t.image_compression.FAST:l=1,f=o;break;case t.image_compression.MEDIUM:l=6,f=c;break;case t.image_compression.SLOW:l=9,f=u;}r=i(r,n,a,f);var d=zlibSync(r,{level:l});return t.__addimage__.arrayBufferToBinaryString(d)},i=function(t,e,r,n){for(var i,a,o,s=t.length/e,c=new Uint8Array(t.length+s),u=l(),h=0;h<s;h+=1){if(o=h*e,i=t.subarray(o,o+e),n)c.set(n(i,r,a),o+h);else{for(var d,p=u.length,g=[];d<p;d+=1)g[d]=u[d](i,r,a);var m=f(g.concat());c.set(g[m],o+h);}a=i;}return c},a=function(t){var e=Array.apply([],t);return e.unshift(0),e},o=function(t,e){var r,n=[],i=t.length;n[0]=1;for(var a=0;a<i;a+=1)r=t[a-e]||0,n[a+1]=t[a]-r+256&255;return n},s=function(t,e,r){var n,i=[],a=t.length;i[0]=2;for(var o=0;o<a;o+=1)n=r&&r[o]||0,i[o+1]=t[o]-n+256&255;return i},c=function(t,e,r){var n,i,a=[],o=t.length;a[0]=3;for(var s=0;s<o;s+=1)n=t[s-e]||0,i=r&&r[s]||0,a[s+1]=t[s]+256-(n+i>>>1)&255;return a},u=function(t,e,r){var n,i,a,o,s=[],c=t.length;s[0]=4;for(var u=0;u<c;u+=1)n=t[u-e]||0,i=r&&r[u]||0,a=r&&r[u-e]||0,o=h(n,i,a),s[u+1]=t[u]-o+256&255;return s},h=function(t,e,r){if(t===e&&e===r)return t;var n=Math.abs(e-r),i=Math.abs(t-r),a=Math.abs(t+e-r-r);return n<=i&&n<=a?t:i<=a?e:r},l=function(){return [a,o,s,c,u]},f=function(t){var e=t.map((function(t){return t.reduce((function(t,e){return t+Math.abs(e)}),0)}));return e.indexOf(Math.min.apply(null,e))};t.processPNG=function(e,i,a,o){var s,c,u,h,l,f,d,p,g,m,v,b,y,w,N,L=this.decode.FLATE_DECODE,A="";if(this.__addimage__.isArrayBuffer(e)&&(e=new Uint8Array(e)),this.__addimage__.isArrayBufferView(e)){if(e=(u=new Kt(e)).imgData,c=u.bits,s=u.colorSpace,l=u.colors,-1!==[4,6].indexOf(u.colorType)){if(8===u.bits){g=(p=32==u.pixelBitlength?new Uint32Array(u.decodePixels().buffer):16==u.pixelBitlength?new Uint16Array(u.decodePixels().buffer):new Uint8Array(u.decodePixels().buffer)).length,v=new Uint8Array(g*u.colors),m=new Uint8Array(g);var x,S=u.pixelBitlength-u.bits;for(w=0,N=0;w<g;w++){for(y=p[w],x=0;x<S;)v[N++]=y>>>x&255,x+=u.bits;m[w]=y>>>x&255;}}if(16===u.bits){g=(p=new Uint32Array(u.decodePixels().buffer)).length,v=new Uint8Array(g*(32/u.pixelBitlength)*u.colors),m=new Uint8Array(g*(32/u.pixelBitlength)),b=u.colors>1,w=0,N=0;for(var _=0;w<g;)y=p[w++],v[N++]=y>>>0&255,b&&(v[N++]=y>>>16&255,y=p[w++],v[N++]=y>>>0&255),m[_++]=y>>>16&255;c=8;}o!==t.image_compression.NONE&&r()?(e=n(v,u.width*u.colors,u.colors,o),d=n(m,u.width,1,o)):(e=v,d=m,L=void 0);}if(3===u.colorType&&(s=this.color_spaces.INDEXED,f=u.palette,u.transparency.indexed)){var P=u.transparency.indexed,k=0;for(w=0,g=P.length;w<g;++w)k+=P[w];if((k/=255)===g-1&&-1!==P.indexOf(0))h=[P.indexOf(0)];else if(k!==g){for(p=u.decodePixels(),m=new Uint8Array(p.length),w=0,g=p.length;w<g;w++)m[w]=P[p[w]];d=n(m,u.width,1);}}var I=function(e){var r;switch(e){case t.image_compression.FAST:r=11;break;case t.image_compression.MEDIUM:r=13;break;case t.image_compression.SLOW:r=14;break;default:r=12;}return r}(o);return L===this.decode.FLATE_DECODE&&(A="/Predictor "+I+" "),A+="/Colors "+l+" /BitsPerComponent "+c+" /Columns "+u.width,(this.__addimage__.isArrayBuffer(e)||this.__addimage__.isArrayBufferView(e))&&(e=this.__addimage__.arrayBufferToBinaryString(e)),(d&&this.__addimage__.isArrayBuffer(d)||this.__addimage__.isArrayBufferView(d))&&(d=this.__addimage__.arrayBufferToBinaryString(d)),{alias:a,data:e,index:i,filter:L,decodeParameters:A,transparency:h,palette:f,sMask:d,predictor:I,width:u.width,height:u.height,bitsPerComponent:c,colorSpace:s}}};}(E.API),function(t){t.processGIF89A=function(e,r,n,i){var a=new Zt(e),o=a.width,s=a.height,c=[];a.decodeAndBlitFrameRGBA(0,c);var u={data:c,width:o,height:s},h=new Qt(100).encode(u,100);return t.processJPEG.call(this,h,r,n,i)},t.processGIF87A=t.processGIF89A;}(E.API),te.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var r=this.datav.getUint8(this.pos++,!0),n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:n,blue:r,quad:a};}}this.height<0&&(this.height*=-1,this.bottom_up=!1);},te.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]();}catch(t){a.log("bit decode error:"+t);}},te.prototype.bit1=function(){var t,e=Math.ceil(this.width/8),r=e%4;for(t=this.height-1;t>=0;t--){for(var n=this.bottom_up?t:this.height-1-t,i=0;i<e;i++)for(var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var c=this.palette[a>>7-s&1];this.data[o+4*s]=c.blue,this.data[o+4*s+1]=c.green,this.data[o+4*s+2]=c.red,this.data[o+4*s+3]=255;}0!==r&&(this.pos+=4-r);}},te.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<t;i++){var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+2*i*4,s=a>>4,c=15&a,u=this.palette[s];if(this.data[o]=u.blue,this.data[o+1]=u.green,this.data[o+2]=u.red,this.data[o+3]=255,2*i+1>=this.width)break;u=this.palette[c],this.data[o+4]=u.blue,this.data[o+4+1]=u.green,this.data[o+4+2]=u.red,this.data[o+4+3]=255;}0!==e&&(this.pos+=4-e);}},te.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;e>=0;e--){for(var r=this.bottom_up?e:this.height-1-e,n=0;n<this.width;n++){var i=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+4*n;if(i<this.palette.length){var o=this.palette[i];this.data[a]=o.red,this.data[a+1]=o.green,this.data[a+2]=o.blue,this.data[a+3]=255;}else this.data[a]=255,this.data[a+1]=255,this.data[a+2]=255,this.data[a+3]=255;}0!==t&&(this.pos+=4-t);}},te.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<this.width;i++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var o=(a&e)/e*255|0,s=(a>>5&e)/e*255|0,c=(a>>10&e)/e*255|0,u=a>>15?255:0,h=n*this.width*4+4*i;this.data[h]=c,this.data[h+1]=s,this.data[h+2]=o,this.data[h+3]=u;}this.pos+=t;}},te.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),r=parseInt("111111",2),n=this.height-1;n>=0;n--){for(var i=this.bottom_up?n:this.height-1-n,a=0;a<this.width;a++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(o&e)/e*255|0,c=(o>>5&r)/r*255|0,u=(o>>11)/e*255|0,h=i*this.width*4+4*a;this.data[h]=u,this.data[h+1]=c,this.data[h+2]=s,this.data[h+3]=255;}this.pos+=t;}},te.prototype.bit24=function(){for(var t=this.height-1;t>=0;t--){for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=e*this.width*4+4*r;this.data[o]=a,this.data[o+1]=i,this.data[o+2]=n,this.data[o+3]=255;}this.pos+=this.width%4;}},te.prototype.bit32=function(){for(var t=this.height-1;t>=0;t--)for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*r;this.data[s]=a,this.data[s+1]=i,this.data[s+2]=n,this.data[s+3]=o;}},te.prototype.getData=function(){return this.data},
/**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.processBMP=function(e,r,n,i){var a=new te(e,!1),o=a.width,s=a.height,c={data:a.getData(),width:o,height:s},u=new Qt(100).encode(c,100);return t.processJPEG.call(this,u,r,n,i)};}(E.API),ee.prototype.getData=function(){return this.data},
/**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.processWEBP=function(e,r,n,i){var a=new ee(e,!1),o=a.width,s=a.height,c={data:a.getData(),width:o,height:s},u=new Qt(100).encode(c,100);return t.processJPEG.call(this,u,r,n,i)};}(E.API),E.API.processRGBA=function(t,e,r){for(var n=t.data,i=n.length,a=new Uint8Array(i/4*3),o=new Uint8Array(i/4),s=0,c=0,u=0;u<i;u+=4){var h=n[u],l=n[u+1],f=n[u+2],d=n[u+3];a[s++]=h,a[s++]=l,a[s++]=f,o[c++]=d;}var p=this.__addimage__.arrayBufferToBinaryString(a);return {alpha:this.__addimage__.arrayBufferToBinaryString(o),data:p,index:e,alias:r,colorSpace:"DeviceRGB",bitsPerComponent:8,width:t.width,height:t.height}},E.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"North Macedonia",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")");})),this.internal.languageSettings.isSubscribed=!0)),this},Vt=E.API,Gt=Vt.getCharWidthsArray=function(e,r){var n,i,a=(r=r||{}).font||this.internal.getFont(),o=r.fontSize||this.internal.getFontSize(),s=r.charSpace||this.internal.getCharSpace(),c=r.widths?r.widths:a.metadata.Unicode.widths,u=c.fof?c.fof:1,h=r.kerning?r.kerning:a.metadata.Unicode.kerning,l=h.fof?h.fof:1,f=!1!==r.doKerning,d=0,p=e.length,g=0,m=c[0]||u,v=[];for(n=0;n<p;n++)i=e.charCodeAt(n),"function"==typeof a.metadata.widthOfString?v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i))+s*(1e3/o)||0)/1e3):(d=f&&"object"===t(h[i])&&!isNaN(parseInt(h[i][g],10))?h[i][g]/l:0,v.push((c[i]||m)/u+d)),g=i;return v},Yt=Vt.getStringUnitWidth=function(t,e){var r=(e=e||{}).fontSize||this.internal.getFontSize(),n=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return Vt.processArabic&&(t=Vt.processArabic(t)),"function"==typeof n.metadata.widthOfString?n.metadata.widthOfString(t,r,i)/r:Gt.apply(this,arguments).reduce((function(t,e){return t+e}),0)},Jt=function(t,e,r,n){for(var i=[],a=0,o=t.length,s=0;a!==o&&s+e[a]<r;)s+=e[a],a++;i.push(t.slice(0,a));var c=a;for(s=0;a!==o;)s+e[a]>n&&(i.push(t.slice(c,a)),s=0,c=a),s+=e[a],a++;return c!==a&&i.push(t.slice(c,a)),i},Xt=function(t,e,r){r||(r={});var n,i,a,o,s,c,u,h=[],l=[h],f=r.textIndent||0,d=0,p=0,g=t.split(" "),m=Gt.apply(this,[" ",r])[0];if(c=-1===r.lineIndent?g[0].length+2:r.lineIndent||0){var v=Array(c).join(" "),b=[];g.map((function(t){(t=t.split(/\s*\n/)).length>1?b=b.concat(t.map((function(t,e){return (e&&t.length?"\n":"")+t}))):b.push(t[0]);})),g=b,c=Yt.apply(this,[v,r]);}for(a=0,o=g.length;a<o;a++){var y=0;if(n=g[a],c&&"\n"==n[0]&&(n=n.substr(1),y=1),f+d+(p=(i=Gt.apply(this,[n,r])).reduce((function(t,e){return t+e}),0))>e||y){if(p>e){for(s=Jt.apply(this,[n,i,e-(f+d),e]),h.push(s.shift()),h=[s.pop()];s.length;)l.push([s.shift()]);p=i.slice(n.length-(h[0]?h[0].length:0)).reduce((function(t,e){return t+e}),0);}else h=[n];l.push(h),f=p+c,d=m;}else h.push(n),f+=d+p,d=m;}return u=c?function(t,e){return (e?v:"")+t.join(" ")}:function(t){return t.join(" ")},l.map(u)},Vt.splitTextToSize=function(t,e,r){var n,i=(r=r||{}).fontSize||this.internal.getFontSize(),a=function(t){if(t.widths&&t.kerning)return {widths:t.widths,kerning:t.kerning};var e=this.internal.getFont(t.fontName,t.fontStyle);return e.metadata.Unicode?{widths:e.metadata.Unicode.widths||{0:1},kerning:e.metadata.Unicode.kerning||{}}:{font:e.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,r);n=Array.isArray(t)?t:String(t).split(/\r?\n/);var o=1*this.internal.scaleFactor*e/i;a.textIndent=r.textIndent?1*r.textIndent*this.internal.scaleFactor/i:0,a.lineIndent=r.lineIndent;var s,c,u=[];for(s=0,c=n.length;s<c;s++)u=u.concat(Xt.apply(this,[n[s],o,a]));return u},function(e){e.__fontmetrics__=e.__fontmetrics__||{};for(var r="klmnopqrstuvwxyz",n={},i={},a=0;a<r.length;a++)n[r[a]]="0123456789abcdef"[a],i["0123456789abcdef"[a]]=r[a];var o=function(t){return "0x"+parseInt(t,10).toString(16)},s=e.__fontmetrics__.compress=function(e){var r,n,a,c,u=["{"];for(var h in e){if(r=e[h],isNaN(parseInt(h,10))?n="'"+h+"'":(h=parseInt(h,10),n=(n=o(h).slice(2)).slice(0,-1)+i[n.slice(-1)]),"number"==typeof r)r<0?(a=o(r).slice(3),c="-"):(a=o(r).slice(2),c=""),a=c+a.slice(0,-1)+i[a.slice(-1)];else{if("object"!==t(r))throw new Error("Don't know what to do with value type "+t(r)+".");a=s(r);}u.push(n+a);}return u.push("}"),u.join("")},c=e.__fontmetrics__.uncompress=function(t){if("string"!=typeof t)throw new Error("Invalid argument passed to uncompress.");for(var e,r,i,a,o={},s=1,c=o,u=[],h="",l="",f=t.length-1,d=1;d<f;d+=1)"'"==(a=t[d])?e?(i=e.join(""),e=void 0):e=[]:e?e.push(a):"{"==a?(u.push([c,i]),c={},i=void 0):"}"==a?((r=u.pop())[0][r[1]]=c,i=void 0,c=r[0]):"-"==a?s=-1:void 0===i?n.hasOwnProperty(a)?(h+=n[a],i=parseInt(h,16)*s,s=1,h=""):h+=a:n.hasOwnProperty(a)?(l+=n[a],c[i]=parseInt(l,16)*s,s=1,i=void 0,l=""):l+=a;return o},u={codePages:["WinAnsiEncoding"],WinAnsiEncoding:c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},h={Unicode:{Courier:u,"Courier-Bold":u,"Courier-BoldOblique":u,"Courier-Oblique":u,Helvetica:u,"Helvetica-Bold":u,"Helvetica-BoldOblique":u,"Helvetica-Oblique":u,"Times-Roman":u,"Times-Bold":u,"Times-BoldItalic":u,"Times-Italic":u}},l={Unicode:{"Courier-Oblique":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}};e.events.push(["addFont",function(t){var e=t.font,r=l.Unicode[e.postScriptName];r&&(e.metadata.Unicode={},e.metadata.Unicode.widths=r.widths,e.metadata.Unicode.kerning=r.kerning);var n=h.Unicode[e.postScriptName];n&&(e.metadata.Unicode.encoding=n,e.encoding=n.codePages[0]);}]);}(E.API),
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r};t.API.events.push(["addFont",function(r){var n=void 0,i=r.font,a=r.instance;if(!i.isStandardFont){if(void 0===a)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");if("string"!=typeof(n=!1===a.existsFileInVFS(i.postScriptName)?a.loadFile(i.postScriptName):a.getFileFromVFS(i.postScriptName)))throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");!function(r,n){n=/^\x00\x01\x00\x00/.test(n)?e(n):e(u(n)),r.metadata=t.API.TTFFont.open(n),r.metadata.Unicode=r.metadata.Unicode||{encoding:{},kerning:{},widths:[]},r.metadata.glyIdsUsed=[0];}(i,n);}}]);}(E),
/** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){function e(){return (n.canvg?Promise.resolve(n.canvg):Promise.resolve().then(function () { return index_es; })).catch((function(t){return Promise.reject(new Error("Could not load canvg: "+t))})).then((function(t){return t.default?t.default:t}))}E.API.addSvgAsImage=function(t,r,n,i,o,s,c,u){if(isNaN(r)||isNaN(n))throw a.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(i)||isNaN(o))throw a.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var h=document.createElement("canvas");h.width=i,h.height=o;var l=h.getContext("2d");l.fillStyle="#fff",l.fillRect(0,0,h.width,h.height);var f={ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0},d=this;return e().then((function(e){return e.fromString(l,t,f)}),(function(){return Promise.reject(new Error("Could not load canvg."))})).then((function(t){return t.render(f)})).then((function(){d.addImage(h.toDataURL("image/jpeg",1),r,n,i,o,c,u);}))};}(),E.API.putTotalPages=function(t){var e,r=0;parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),r=this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),r=this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var n=1;n<=this.internal.getNumberOfPages();n++)for(var i=0;i<this.internal.pages[n].length;i++)this.internal.pages[n][i]=this.internal.pages[n][i].replace(e,r);return this},E.API.viewerPreferences=function(e,r){var n;e=e||{},r=r||!1;var i,a,o,s={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},c=Object.keys(s),u=[],h=0,l=0,f=0;function d(t,e){var r,n=!1;for(r=0;r<t.length;r+=1)t[r]===e&&(n=!0);return n}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(s)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===e||!0===r){var p=c.length;for(f=0;f<p;f+=1)n[c[f]].value=n[c[f]].defaultValue,n[c[f]].explicitSet=!1;}if("object"===t(e))for(a in e)if(o=e[a],d(c,a)&&void 0!==o){if("boolean"===n[a].type&&"boolean"==typeof o)n[a].value=o;else if("name"===n[a].type&&d(n[a].valueSet,o))n[a].value=o;else if("integer"===n[a].type&&Number.isInteger(o))n[a].value=o;else if("array"===n[a].type){for(h=0;h<o.length;h+=1)if(i=!0,1===o[h].length&&"number"==typeof o[h][0])u.push(String(o[h]-1));else if(o[h].length>1){for(l=0;l<o[h].length;l+=1)"number"!=typeof o[h][l]&&(i=!1);!0===i&&u.push([o[h][0]-1,o[h][1]-1].join(" "));}n[a].value="["+u.join(" ")+"]";}else n[a].value=n[a].defaultValue;n[a].explicitSet=!0;}return !1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>");})),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){var e=function(){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+this.internal.__metadata__.namespaceuri+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),r=unescape(encodeURIComponent(t)),n=unescape(encodeURIComponent(this.internal.__metadata__.metadata)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),a=unescape(encodeURIComponent("</x:xmpmeta>")),o=r.length+n.length+i.length+e.length+a.length;this.internal.__metadata__.metadata_object_number=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+o+" >>"),this.internal.write("stream"),this.internal.write(e+r+n+i+a),this.internal.write("endstream"),this.internal.write("endobj");},r=function(){this.internal.__metadata__.metadata_object_number&&this.internal.write("/Metadata "+this.internal.__metadata__.metadata_object_number+" 0 R");};t.addMetadata=function(t,n){return void 0===this.internal.__metadata__&&(this.internal.__metadata__={metadata:t,namespaceuri:n||"http://jspdf.default.namespaceuri/"},this.internal.events.subscribe("putCatalog",r),this.internal.events.subscribe("postPutResources",e)),this};}(E.API),function(t){var e=t.API,r=e.pdfEscape16=function(t,e){for(var r,n=e.metadata.Unicode.widths,i=["","0","00","000","0000"],a=[""],o=0,s=t.length;o<s;++o){if(r=e.metadata.characterToGlyph(t.charCodeAt(o)),e.metadata.glyIdsUsed.push(r),e.metadata.toUnicode[r]=t.charCodeAt(o),-1==n.indexOf(r)&&(n.push(r),n.push([parseInt(e.metadata.widthOfGlyph(r),10)])),"0"==r)return a.join("");r=r.toString(16),a.push(i[4-r.length],r);}return a.join("")},n=function(t){var e,r,n,i,a,o,s;for(a="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",n=[],o=0,s=(r=Object.keys(t).sort((function(t,e){return t-e}))).length;o<s;o++)e=r[o],n.length>=100&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar",n=[]),void 0!==t[e]&&null!==t[e]&&"function"==typeof t[e].toString&&(i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),n.push("<"+e+"><"+i+">"));return n.length&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar\n"),a+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream;if(r.metadata instanceof t.API.TTFFont&&"Identity-H"===r.encoding){for(var s=r.metadata.Unicode.widths,c=r.metadata.subset.encode(r.metadata.glyIdsUsed,1),u="",h=0;h<c.length;h++)u+=String.fromCharCode(c[h]);var l=a();o({data:u,addLength1:!0,objectId:l}),i("endobj");var f=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:f}),i("endobj");var d=a();i("<<"),i("/Type /FontDescriptor"),i("/FontName /"+F(r.fontName)),i("/FontFile2 "+l+" 0 R"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/Flags "+r.metadata.flags),i("/StemV "+r.metadata.stemV),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i(">>"),i("endobj");var p=a();i("<<"),i("/Type /Font"),i("/BaseFont /"+F(r.fontName)),i("/FontDescriptor "+d+" 0 R"),i("/W "+t.API.PDFObject.convert(s)),i("/CIDToGIDMap /Identity"),i("/DW 1000"),i("/Subtype /CIDFontType2"),i("/CIDSystemInfo"),i("<<"),i("/Supplement 0"),i("/Registry (Adobe)"),i("/Ordering ("+r.encoding+")"),i(">>"),i(">>"),i("endobj"),r.objectNumber=a(),i("<<"),i("/Type /Font"),i("/Subtype /Type0"),i("/ToUnicode "+f+" 0 R"),i("/BaseFont /"+F(r.fontName)),i("/Encoding /"+r.encoding),i("/DescendantFonts ["+p+" 0 R]"),i(">>"),i("endobj"),r.isAlreadyPutted=!0;}}(e);}]);e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream;if(r.metadata instanceof t.API.TTFFont&&"WinAnsiEncoding"===r.encoding){for(var s=r.metadata.rawData,c="",u=0;u<s.length;u++)c+=String.fromCharCode(s[u]);var h=a();o({data:c,addLength1:!0,objectId:h}),i("endobj");var l=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:l}),i("endobj");var f=a();i("<<"),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i("/StemV "+r.metadata.stemV),i("/Type /FontDescriptor"),i("/FontFile2 "+h+" 0 R"),i("/Flags 96"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/FontName /"+F(r.fontName)),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i(">>"),i("endobj"),r.objectNumber=a();for(var d=0;d<r.metadata.hmtx.widths.length;d++)r.metadata.hmtx.widths[d]=parseInt(r.metadata.hmtx.widths[d]*(1e3/r.metadata.head.unitsPerEm));i("<</Subtype/TrueType/Type/Font/ToUnicode "+l+" 0 R/BaseFont/"+F(r.fontName)+"/FontDescriptor "+f+" 0 R/Encoding/"+r.encoding+" /FirstChar 29 /LastChar 255 /Widths "+t.API.PDFObject.convert(r.metadata.hmtx.widths)+">>"),i("endobj"),r.isAlreadyPutted=!0;}}(e);}]);var i=function(t){var e,n=t.text||"",i=t.x,a=t.y,o=t.options||{},s=t.mutex||{},c=s.pdfEscape,u=s.activeFontKey,h=s.fonts,l=u,f="",d=0,p="",g=h[l].encoding;if("Identity-H"!==h[l].encoding)return {text:n,x:i,y:a,options:o,mutex:s};for(p=n,l=u,Array.isArray(n)&&(p=n[0]),d=0;d<p.length;d+=1)h[l].metadata.hasOwnProperty("cmap")&&(e=h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]),e||p[d].charCodeAt(0)<256&&h[l].metadata.hasOwnProperty("Unicode")?f+=p[d]:f+="";var m="";return parseInt(l.slice(1))<14||"WinAnsiEncoding"===g?m=c(f,l).split("").map((function(t){return t.charCodeAt(0).toString(16)})).join(""):"Identity-H"===g&&(m=r(f,h[l])),s.isHex=!0,{text:m,x:i,y:a,options:o,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",r=[],n={text:e,x:t.x,y:t.y,options:t.options,mutex:t.mutex};if(Array.isArray(e)){var a=0;for(a=0;a<e.length;a+=1)Array.isArray(e[a])&&3===e[a].length?r.push([i(Object.assign({},n,{text:e[a][0]})).text,e[a][1],e[a][2]]):r.push(i(Object.assign({},n,{text:e[a]})).text);t.text=r;}else t.text=i(Object.assign({},n,{text:e})).text;}]);}(E),
/**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(){return void 0===this.internal.vFS&&(this.internal.vFS={}),!0};t.existsFileInVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]},t.addFileToVFS=function(t,r){return e.call(this),this.internal.vFS[t]=r,this},t.getFileFromVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null};}(E.API),
/**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var r,n,i,a,o,s,c,u=e,h=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],l=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],f={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},d={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},p=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],g=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),m=!1,v=0;this.__bidiEngine__={};var b=function(t){var e=t.charCodeAt(),r=e>>8,n=d[r];return void 0!==n?u[256*n+(255&e)]:252===r||253===r?"AL":g.test(r)?"L":8===r?"R":"N"},y=function(t){for(var e,r=0;r<t.length;r++){if("L"===(e=b(t.charAt(r))))return !1;if("R"===e)return !0}return !1},w=function(t,e,o,s){var c,u,h,l,f=e[s];switch(f){case"L":case"R":m=!1;break;case"N":case"AN":break;case"EN":m&&(f="AN");break;case"AL":m=!0,f="R";break;case"WS":f="N";break;case"CS":s<1||s+1>=e.length||"EN"!==(c=o[s-1])&&"AN"!==c||"EN"!==(u=e[s+1])&&"AN"!==u?f="N":m&&(u="AN"),f=u===c?u:"N";break;case"ES":f="EN"===(c=s>0?o[s-1]:"B")&&s+1<e.length&&"EN"===e[s+1]?"EN":"N";break;case"ET":if(s>0&&"EN"===o[s-1]){f="EN";break}if(m){f="N";break}for(h=s+1,l=e.length;h<l&&"ET"===e[h];)h++;f=h<l&&"EN"===e[h]?"EN":"N";break;case"NSM":if(i&&!a){for(l=e.length,h=s+1;h<l&&"NSM"===e[h];)h++;if(h<l){var d=t[s],p=d>=1425&&d<=2303||64286===d;if(c=e[h],p&&("R"===c||"AL"===c)){f="R";break}}}f=s<1||"B"===(c=e[s-1])?"N":o[s-1];break;case"B":m=!1,r=!0,f=v;break;case"S":n=!0,f="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":m=!1;break;case"BN":f="N";}return f},N=function(t,e,r){var n=t.split("");return r&&L(n,r,{hiLevel:v}),n.reverse(),e&&e.reverse(),n.join("")},L=function(t,e,i){var a,o,s,c,u,d=-1,p=t.length,g=0,y=[],N=v?l:h,L=[];for(m=!1,r=!1,n=!1,o=0;o<p;o++)L[o]=b(t[o]);for(s=0;s<p;s++){if(u=g,y[s]=w(t,L,y,s),a=240&(g=N[u][f[y[s]]]),g&=15,e[s]=c=N[g][5],a>0)if(16===a){for(o=d;o<s;o++)e[o]=1;d=-1;}else d=-1;if(N[g][6])-1===d&&(d=s);else if(d>-1){for(o=d;o<s;o++)e[o]=c;d=-1;}"B"===L[s]&&(e[s]=0),i.hiLevel|=c;}n&&function(t,e,r){for(var n=0;n<r;n++)if("S"===t[n]){e[n]=v;for(var i=n-1;i>=0&&"WS"===t[i];i--)e[i]=v;}}(L,e,p);},A=function(t,e,n,i,a){if(!(a.hiLevel<t)){if(1===t&&1===v&&!r)return e.reverse(),void(n&&n.reverse());for(var o,s,c,u,h=e.length,l=0;l<h;){if(i[l]>=t){for(c=l+1;c<h&&i[c]>=t;)c++;for(u=l,s=c-1;u<s;u++,s--)o=e[u],e[u]=e[s],e[s]=o,n&&(o=n[u],n[u]=n[s],n[s]=o);l=c;}l++;}}},x=function(t,e,r){var n=t.split(""),i={hiLevel:v};return r||(r=[]),L(n,r,i),function(t,e,r){if(0!==r.hiLevel&&c)for(var n,i=0;i<t.length;i++)1===e[i]&&(n=p.indexOf(t[i]))>=0&&(t[i]=p[n+1]);}(n,r,i),A(2,n,e,r,i),A(1,n,e,r,i),n.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,r){if(function(t,e){if(e)for(var r=0;r<t.length;r++)e[r]=r;void 0===a&&(a=y(t)),void 0===s&&(s=y(t));}(t,e),i||!o||s)if(i&&o&&a^s)v=a?1:0,t=N(t,e,r);else if(!i&&o&&s)v=a?1:0,t=x(t,e,r),t=N(t,e);else if(!i||a||o||s){if(i&&!o&&a^s)t=N(t,e),a?(v=0,t=x(t,e,r)):(v=1,t=x(t,e,r),t=N(t,e));else if(i&&a&&!o&&s)v=1,t=x(t,e,r),t=N(t,e);else if(!i&&!o&&a^s){var n=c;a?(v=1,t=x(t,e,r),v=0,c=!1,t=x(t,e,r),c=n):(v=0,t=x(t,e,r),t=N(t,e),v=1,c=!1,t=x(t,e,r),c=n,t=N(t,e));}}else v=0,t=x(t,e,r);else v=a?1:0,t=x(t,e,r);return t},this.__bidiEngine__.setOptions=function(t){t&&(i=t.isInputVisual,o=t.isOutputVisual,a=t.isInputRtl,s=t.isOutputRtl,c=t.isSymmetricSwapping);},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],r=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),i=(t.mutex,n.lang,[]);if(n.isInputVisual="boolean"!=typeof n.isInputVisual||n.isInputVisual,r.setOptions(n),"[object Array]"===Object.prototype.toString.call(e)){var a=0;for(i=[],a=0;a<e.length;a+=1)"[object Array]"===Object.prototype.toString.call(e[a])?i.push([r.doBidiReorder(e[a][0]),e[a][1],e[a][2]]):i.push([r.doBidiReorder(e[a])]);t.text=i;}else t.text=r.doBidiReorder(e);r.setOptions({isInputVisual:!0});}]);}(E),E.API.TTFFont=function(){function t(t){var e;if(this.rawData=t,e=this.contents=new ne(t),this.contents.pos=4,"ttcf"===e.readString(4))throw new Error("TTCF not supported.");e.pos=0,this.parse(),this.subset=new Le(this),this.registerTTF();}return t.open=function(e){return new t(e)},t.prototype.parse=function(){return this.directory=new ie(this.contents),this.head=new se(this),this.name=new pe(this),this.cmap=new ue(this),this.toUnicode={},this.hhea=new he(this),this.maxp=new ge(this),this.hmtx=new me(this),this.post=new fe(this),this.os2=new le(this),this.loca=new Ne(this),this.glyf=new be(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},t.prototype.registerTTF=function(){var t,e,r,n,i;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var e,r,n,i;for(i=[],e=0,r=(n=this.bbox).length;e<r;e++)t=n[e],i.push(Math.round(t*this.scaleFactor));return i}.call(this),this.stemV=0,this.post.exists?(r=255&(n=this.post.italic_angle),0!=(32768&(e=n>>16))&&(e=-(1+(65535^e))),this.italicAngle=+(e+"."+r)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(i=this.familyClass)||2===i||3===i||4===i||5===i||7===i,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},t.prototype.characterToGlyph=function(t){var e;return (null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},t.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},t.prototype.widthOfString=function(t,e,r){var n,i,a,o;for(a=0,i=0,o=(t=""+t).length;0<=o?i<o:i>o;i=0<=o?++i:--i)n=t.charCodeAt(i),a+=this.widthOfGlyph(this.characterToGlyph(n))+r*(1e3/e)||0;return a*(e/1e3)},t.prototype.lineHeight=function(t,e){var r;return null==e&&(e=!1),r=e?this.lineGap:0,(this.ascender+r-this.decender)/1e3*t},t}();var re,ne=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length;}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return (t=this.readUInt32())>=2147483648?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return (t=this.readUInt16())>=32768?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;e=0<=t?++e:--e)r[e]=String.fromCharCode(this.readByte());return r.join("")},t.prototype.writeString=function(t){var e,r,n;for(n=[],e=0,r=t.length;0<=r?e<r:e>r;e=0<=r?++e:--e)n.push(this.writeByte(t.charCodeAt(e)));return n},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,r,n,i,a,o,s;return t=this.readByte(),e=this.readByte(),r=this.readByte(),n=this.readByte(),i=this.readByte(),a=this.readByte(),o=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^r)+4294967296*(255^n)+16777216*(255^i)+65536*(255^a)+256*(255^o)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*r+4294967296*n+16777216*i+65536*a+256*o+s},t.prototype.writeLongLong=function(t){var e,r;return e=Math.floor(t/4294967296),r=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(r>>24&255),this.writeByte(r>>16&255),this.writeByte(r>>8&255),this.writeByte(255&r)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,r;for(e=[],r=0;0<=t?r<t:r>t;r=0<=t?++r:--r)e.push(this.readByte());return e},t.prototype.write=function(t){var e,r,n,i;for(i=[],r=0,n=t.length;r<n;r++)e=t[r],i.push(this.writeByte(e));return i},t}(),ie=function(){var t;function e(t){var e,r,n;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},r=0,n=this.tableCount;0<=n?r<n:r>n;r=0<=n?++r:--r)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e;}return e.prototype.encode=function(e){var r,n,i,a,o,s,c,u,h,l,f,d,p;for(p in f=Object.keys(e).length,s=Math.log(2),h=16*Math.floor(Math.log(f)/s),a=Math.floor(h/s),u=16*f-h,(n=new ne).writeInt(this.scalarType),n.writeShort(f),n.writeShort(h),n.writeShort(a),n.writeShort(u),i=16*f,c=n.pos+i,o=null,d=[],e)for(l=e[p],n.writeString(p),n.writeInt(t(l)),n.writeInt(c),n.writeInt(l.length),d=d.concat(l),"head"===p&&(o=c),c+=l.length;c%4;)d.push(0),c++;return n.write(d),r=2981146554-t(n.data),n.pos=o+8,n.writeUInt32(r),n.data},t=function(t){var e,r,n,i;for(t=ve.call(t);t.length%4;)t.push(0);for(n=new ne(t),r=0,e=0,i=t.length;e<i;e=e+=4)r+=n.readUInt32();return 4294967295&r},e}(),ae={}.hasOwnProperty,oe=function(t,e){for(var r in e)ae.call(e,r)&&(t[r]=e[r]);function n(){this.constructor=t;}return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t};re=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents));}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var se=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return (e=new ne).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),ce=function(){function t(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m,v,b;switch(this.platformID=t.readUInt16(),this.encodingID=t.readShort(),this.offset=e+t.readInt(),h=t.pos,t.pos=this.offset,this.format=t.readUInt16(),this.length=t.readUInt16(),this.language=t.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=0;s<256;++s)this.codeMap[s]=t.readByte();break;case 4:for(f=t.readUInt16(),l=f/2,t.pos+=6,i=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),t.pos+=2,p=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),c=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),u=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),n=(this.length-t.pos+this.offset)/2,o=function(){var e,r;for(r=[],s=e=0;0<=n?e<n:e>n;s=0<=n?++e:--e)r.push(t.readUInt16());return r}(),s=m=0,b=i.length;m<b;s=++m)for(g=i[s],r=v=d=p[s];d<=g?v<=g:v>=g;r=d<=g?++v:--v)0===u[s]?a=r+c[s]:0!==(a=o[u[s]/2+(r-d)-(l-s)]||0)&&(a+=c[s]),this.codeMap[r]=65535&a;}t.pos=h;}return t.encode=function(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,I,F,C,j,O,B,M,E,q,D,R,T,U,z,H,W,V,G,Y;switch(I=new ne,a=Object.keys(t).sort((function(t,e){return t-e})),e){case"macroman":for(p=0,g=function(){var t=[];for(d=0;d<256;++d)t.push(0);return t}(),v={0:0},i={},F=0,B=a.length;F<B;F++)null==v[W=t[n=a[F]]]&&(v[W]=++p),i[n]={old:t[n],new:v[t[n]]},g[n]=v[t[n]];return I.writeUInt16(1),I.writeUInt16(0),I.writeUInt32(12),I.writeUInt16(0),I.writeUInt16(262),I.writeUInt16(0),I.write(g),{charMap:i,subtable:I.data,maxGlyphID:p+1};case"unicode":for(P=[],h=[],b=0,v={},r={},m=c=null,C=0,M=a.length;C<M;C++)null==v[w=t[n=a[C]]]&&(v[w]=++b),r[n]={old:w,new:v[w]},o=v[w]-n,null!=m&&o===c||(m&&h.push(m),P.push(n),c=o),m=n;for(m&&h.push(m),h.push(65535),P.push(65535),S=2*(x=P.length),A=2*Math.pow(Math.log(x)/Math.LN2,2),l=Math.log(A/2)/Math.LN2,L=2*x-A,s=[],N=[],f=[],d=j=0,E=P.length;j<E;d=++j){if(_=P[d],u=h[d],65535===_){s.push(0),N.push(0);break}if(_-(k=r[_].new)>=32768)for(s.push(0),N.push(2*(f.length+x-d)),n=O=_;_<=u?O<=u:O>=u;n=_<=u?++O:--O)f.push(r[n].new);else s.push(k-_),N.push(0);}for(I.writeUInt16(3),I.writeUInt16(1),I.writeUInt32(12),I.writeUInt16(4),I.writeUInt16(16+8*x+2*f.length),I.writeUInt16(0),I.writeUInt16(S),I.writeUInt16(A),I.writeUInt16(l),I.writeUInt16(L),z=0,q=h.length;z<q;z++)n=h[z],I.writeUInt16(n);for(I.writeUInt16(0),H=0,D=P.length;H<D;H++)n=P[H],I.writeUInt16(n);for(V=0,R=s.length;V<R;V++)o=s[V],I.writeUInt16(o);for(G=0,T=N.length;G<T;G++)y=N[G],I.writeUInt16(y);for(Y=0,U=f.length;Y<U;Y++)p=f[Y],I.writeUInt16(p);return {charMap:r,subtable:I.data,maxGlyphID:b+1}}},t}(),ue=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,r,n;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:r>n;r=0<=n?++r:--r)e=new ce(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return !0},e.encode=function(t,e){var r,n;return null==e&&(e="macroman"),r=ce.encode(t,e),(n=new ne).writeUInt16(0),n.writeUInt16(1),r.table=n.data.concat(r.subtable),r},e}(),he=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),le=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="OS/2",e.prototype.parse=function(t){if(t.pos=this.offset,this.version=t.readUInt16(),this.averageCharWidth=t.readShort(),this.weightClass=t.readUInt16(),this.widthClass=t.readUInt16(),this.type=t.readShort(),this.ySubscriptXSize=t.readShort(),this.ySubscriptYSize=t.readShort(),this.ySubscriptXOffset=t.readShort(),this.ySubscriptYOffset=t.readShort(),this.ySuperscriptXSize=t.readShort(),this.ySuperscriptYSize=t.readShort(),this.ySuperscriptXOffset=t.readShort(),this.ySuperscriptYOffset=t.readShort(),this.yStrikeoutSize=t.readShort(),this.yStrikeoutPosition=t.readShort(),this.familyClass=t.readShort(),this.panose=function(){var e,r;for(r=[],e=0;e<10;++e)r.push(t.readByte());return r}(),this.charRange=function(){var e,r;for(r=[],e=0;e<4;++e)r.push(t.readInt());return r}(),this.vendorID=t.readString(4),this.selection=t.readShort(),this.firstCharIndex=t.readShort(),this.lastCharIndex=t.readShort(),this.version>0&&(this.ascent=t.readShort(),this.descent=t.readShort(),this.lineGap=t.readShort(),this.winAscent=t.readShort(),this.winDescent=t.readShort(),this.codePageRange=function(){var e,r;for(r=[],e=0;e<2;e=++e)r.push(t.readInt());return r}(),this.version>1))return this.xHeight=t.readShort(),this.capHeight=t.readShort(),this.defaultChar=t.readShort(),this.breakChar=t.readShort(),this.maxContext=t.readShort()},e}(),fe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="post",e.prototype.parse=function(t){var e,r,n;switch(t.pos=this.offset,this.format=t.readInt(),this.italicAngle=t.readInt(),this.underlinePosition=t.readShort(),this.underlineThickness=t.readShort(),this.isFixedPitch=t.readInt(),this.minMemType42=t.readInt(),this.maxMemType42=t.readInt(),this.minMemType1=t.readInt(),this.maxMemType1=t.readInt(),this.format){case 65536:break;case 131072:var i;for(r=t.readUInt16(),this.glyphNameIndex=[],i=0;0<=r?i<r:i>r;i=0<=r?++i:--i)this.glyphNameIndex.push(t.readUInt16());for(this.names=[],n=[];t.pos<this.offset+this.length;)e=t.readByte(),n.push(this.names.push(t.readString(e)));return n;case 151552:return r=t.readUInt16(),this.offsets=t.read(r);case 196608:break;case 262144:return this.map=function(){var e,r,n;for(n=[],i=e=0,r=this.file.maxp.numGlyphs;0<=r?e<r:e>r;i=0<=r?++e:--e)n.push(t.readUInt32());return n}.call(this)}},e}(),de=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID;},pe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="name",e.prototype.parse=function(t){var e,r,n,i,a,o,s,c,u,h,l;for(t.pos=this.offset,t.readShort(),e=t.readShort(),o=t.readShort(),r=[],i=0;0<=e?i<e:i>e;i=0<=e?++i:--i)r.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+o+t.readShort()});for(s={},i=u=0,h=r.length;u<h;i=++u)n=r[i],t.pos=n.offset,c=t.readString(n.length),a=new de(c,n),null==s[l=n.nameID]&&(s[l]=[]),s[n.nameID].push(a);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"");}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"");}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),ge=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),me=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="hmtx",e.prototype.parse=function(t){var e,r,n,i,a,o,s;for(t.pos=this.offset,this.metrics=[],e=0,o=this.file.hhea.numberOfMetrics;0<=o?e<o:e>o;e=0<=o?++e:--e)this.metrics.push({advance:t.readUInt16(),lsb:t.readInt16()});for(n=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var r,i;for(i=[],e=r=0;0<=n?r<n:r>n;e=0<=n?++r:--r)i.push(t.readInt16());return i}(),this.widths=function(){var t,e,r,n;for(n=[],t=0,e=(r=this.metrics).length;t<e;t++)i=r[t],n.push(i.advance);return n}.call(this),r=this.widths[this.widths.length-1],s=[],e=a=0;0<=n?a<n:a>n;e=0<=n?++a:--a)s.push(this.widths.push(r));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),ve=[].slice,be=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="glyf",e.prototype.parse=function(){return this.cache={}},e.prototype.glyphFor=function(t){var e,r,n,i,a,o,s,c,u,h;return t in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,r=i.indexOf(t),0===(n=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+r,a=(o=new ne(e.read(n))).readShort(),c=o.readShort(),h=o.readShort(),s=o.readShort(),u=o.readShort(),this.cache[t]=-1===a?new we(o,c,h,s,u):new ye(o,a,c,h,s,u),this.cache[t]))},e.prototype.encode=function(t,e,r){var n,i,a,o,s;for(a=[],i=[],o=0,s=e.length;o<s;o++)n=t[e[o]],i.push(a.length),n&&(a=a.concat(n.encode(r)));return i.push(a.length),{table:a,offsets:i}},e}(),ye=function(){function t(t,e,r,n,i,a){this.raw=t,this.numberOfContours=e,this.xMin=r,this.yMin=n,this.xMax=i,this.yMax=a,this.compound=!1;}return t.prototype.encode=function(){return this.raw.data},t}(),we=function(){function t(t,e,r,n,i){var a,o;for(this.raw=t,this.xMin=e,this.yMin=r,this.xMax=n,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],a=this.raw;o=a.readShort(),this.glyphOffsets.push(a.pos),this.glyphIDs.push(a.readUInt16()),32&o;)a.pos+=1&o?4:2,128&o?a.pos+=8:64&o?a.pos+=4:8&o&&(a.pos+=2);}return t.prototype.encode=function(){var t,e,r;for(e=new ne(ve.call(this.raw.data)),t=0,r=this.glyphIDs.length;t<r;++t)e.pos=this.glyphOffsets[t];return e.data},t}(),Ne=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="loca",e.prototype.parse=function(t){var e,r;return t.pos=this.offset,e=this.file.head.indexToLocFormat,this.offsets=0===e?function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=2)n.push(2*t.readUInt16());return n}.call(this):function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=4)n.push(t.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var r=new Uint32Array(this.offsets.length),n=0,i=0,a=0;a<r.length;++a)if(r[a]=n,i<e.length&&e[i]==a){++i,r[a]=n;var o=this.offsets[a],s=this.offsets[a+1]-o;s>0&&(n+=s);}for(var c=new Array(4*r.length),u=0;u<r.length;++u)c[4*u+3]=255&r[u],c[4*u+2]=(65280&r[u])>>8,c[4*u+1]=(16711680&r[u])>>16,c[4*u]=(4278190080&r[u])>>24;return c},e}(),Le=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33;}return t.prototype.generateCmap=function(){var t,e,r,n,i;for(e in n=this.font.cmap.tables[0].codeMap,t={},i=this.subset)r=i[e],t[e]=n[r];return t},t.prototype.glyphsFor=function(t){var e,r,n,i,a,o,s;for(n={},a=0,o=t.length;a<o;a++)n[i=t[a]]=this.font.glyf.glyphFor(i);for(i in e=[],n)(null!=(r=n[i])?r.compound:void 0)&&e.push.apply(e,r.glyphIDs);if(e.length>0)for(i in s=this.glyphsFor(e))r=s[i],n[i]=r;return n},t.prototype.encode=function(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m;for(n in r=ue.encode(this.generateCmap(),"unicode"),a=this.glyphsFor(t),f={0:0},m=r.charMap)f[(s=m[n]).old]=s.new;for(d in l=r.maxGlyphID,a)d in f||(f[d]=l++);return u=function(t){var e,r;for(e in r={},t)r[t[e]]=e;return r}(f),h=Object.keys(u).sort((function(t,e){return t-e})),p=function(){var t,e,r;for(r=[],t=0,e=h.length;t<e;t++)o=h[t],r.push(u[o]);return r}(),i=this.font.glyf.encode(a,p,f),c=this.font.loca.encode(i.offsets,p),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:c,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();E.API.PDFObject=function(){var t;function e(){}return t=function(t,e){return (Array(e+1).join("0")+t).slice(-e)},e.convert=function(r){var n,i,a,o;if(Array.isArray(r))return "["+function(){var t,i,a;for(a=[],t=0,i=r.length;t<i;t++)n=r[t],a.push(e.convert(n));return a}().join(" ")+"]";if("string"==typeof r)return "/"+r;if(null!=r?r.isString:void 0)return "("+r+")";if(r instanceof Date)return "(D:"+t(r.getUTCFullYear(),4)+t(r.getUTCMonth(),2)+t(r.getUTCDate(),2)+t(r.getUTCHours(),2)+t(r.getUTCMinutes(),2)+t(r.getUTCSeconds(),2)+"Z)";if("[object Object]"==={}.toString.call(r)){for(i in a=["<<"],r)o=r[i],a.push("/"+i+" "+e.convert(o));return a.push(">>"),a.join("\n")}return ""+r},e}();

var html2canvas = createCommonjsModule(function (module, exports) {
/*!
 * html2canvas 1.1.5 <https://html2canvas.hertzen.com>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     module.exports = factory() ;
}(commonjsGlobal, (function () {
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(x, y, w, h) {
            this.left = x;
            this.top = y;
            this.width = w;
            this.height = h;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (clientRect) {
            return new Bounds(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
        };
        return Bounds;
    }());
    var parseBounds = function (node) {
        return Bounds.fromClientRect(node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.0.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup[base64.charCodeAt(i)];
            encoded2 = lookup[base64.charCodeAt(i + 1)];
            encoded3 = lookup[base64.charCodeAt(i + 2)];
            encoded4 = lookup[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    var base64 = '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';

    /* @flow */
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR = 2; //  Cause a line break (after), except between CR and LF
    var LF = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var UnicodeTrie = createTrieFromBase64(base64);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR, LF, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ) {
            return BREAK_NOT_ALLOWED;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie.get(codePoints[afterIndex]) === ZWJ) {
            return BREAK_NOT_ALLOWED;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI && next === RI) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED) { }
                if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var TokenType;
    (function (TokenType) {
        TokenType[TokenType["STRING_TOKEN"] = 0] = "STRING_TOKEN";
        TokenType[TokenType["BAD_STRING_TOKEN"] = 1] = "BAD_STRING_TOKEN";
        TokenType[TokenType["LEFT_PARENTHESIS_TOKEN"] = 2] = "LEFT_PARENTHESIS_TOKEN";
        TokenType[TokenType["RIGHT_PARENTHESIS_TOKEN"] = 3] = "RIGHT_PARENTHESIS_TOKEN";
        TokenType[TokenType["COMMA_TOKEN"] = 4] = "COMMA_TOKEN";
        TokenType[TokenType["HASH_TOKEN"] = 5] = "HASH_TOKEN";
        TokenType[TokenType["DELIM_TOKEN"] = 6] = "DELIM_TOKEN";
        TokenType[TokenType["AT_KEYWORD_TOKEN"] = 7] = "AT_KEYWORD_TOKEN";
        TokenType[TokenType["PREFIX_MATCH_TOKEN"] = 8] = "PREFIX_MATCH_TOKEN";
        TokenType[TokenType["DASH_MATCH_TOKEN"] = 9] = "DASH_MATCH_TOKEN";
        TokenType[TokenType["INCLUDE_MATCH_TOKEN"] = 10] = "INCLUDE_MATCH_TOKEN";
        TokenType[TokenType["LEFT_CURLY_BRACKET_TOKEN"] = 11] = "LEFT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_CURLY_BRACKET_TOKEN"] = 12] = "RIGHT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["SUFFIX_MATCH_TOKEN"] = 13] = "SUFFIX_MATCH_TOKEN";
        TokenType[TokenType["SUBSTRING_MATCH_TOKEN"] = 14] = "SUBSTRING_MATCH_TOKEN";
        TokenType[TokenType["DIMENSION_TOKEN"] = 15] = "DIMENSION_TOKEN";
        TokenType[TokenType["PERCENTAGE_TOKEN"] = 16] = "PERCENTAGE_TOKEN";
        TokenType[TokenType["NUMBER_TOKEN"] = 17] = "NUMBER_TOKEN";
        TokenType[TokenType["FUNCTION"] = 18] = "FUNCTION";
        TokenType[TokenType["FUNCTION_TOKEN"] = 19] = "FUNCTION_TOKEN";
        TokenType[TokenType["IDENT_TOKEN"] = 20] = "IDENT_TOKEN";
        TokenType[TokenType["COLUMN_TOKEN"] = 21] = "COLUMN_TOKEN";
        TokenType[TokenType["URL_TOKEN"] = 22] = "URL_TOKEN";
        TokenType[TokenType["BAD_URL_TOKEN"] = 23] = "BAD_URL_TOKEN";
        TokenType[TokenType["CDC_TOKEN"] = 24] = "CDC_TOKEN";
        TokenType[TokenType["CDO_TOKEN"] = 25] = "CDO_TOKEN";
        TokenType[TokenType["COLON_TOKEN"] = 26] = "COLON_TOKEN";
        TokenType[TokenType["SEMICOLON_TOKEN"] = 27] = "SEMICOLON_TOKEN";
        TokenType[TokenType["LEFT_SQUARE_BRACKET_TOKEN"] = 28] = "LEFT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_SQUARE_BRACKET_TOKEN"] = 29] = "RIGHT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["UNICODE_RANGE_TOKEN"] = 30] = "UNICODE_RANGE_TOKEN";
        TokenType[TokenType["WHITESPACE_TOKEN"] = 31] = "WHITESPACE_TOKEN";
        TokenType[TokenType["EOF_TOKEN"] = 32] = "EOF_TOKEN";
    })(TokenType || (TokenType = {}));
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: TokenType.LEFT_PARENTHESIS_TOKEN
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: TokenType.RIGHT_PARENTHESIS_TOKEN
    };
    var COMMA_TOKEN = { type: TokenType.COMMA_TOKEN };
    var SUFFIX_MATCH_TOKEN = { type: TokenType.SUFFIX_MATCH_TOKEN };
    var PREFIX_MATCH_TOKEN = { type: TokenType.PREFIX_MATCH_TOKEN };
    var COLUMN_TOKEN = { type: TokenType.COLUMN_TOKEN };
    var DASH_MATCH_TOKEN = { type: TokenType.DASH_MATCH_TOKEN };
    var INCLUDE_MATCH_TOKEN = { type: TokenType.INCLUDE_MATCH_TOKEN };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: TokenType.LEFT_CURLY_BRACKET_TOKEN
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: TokenType.RIGHT_CURLY_BRACKET_TOKEN
    };
    var SUBSTRING_MATCH_TOKEN = { type: TokenType.SUBSTRING_MATCH_TOKEN };
    var BAD_URL_TOKEN = { type: TokenType.BAD_URL_TOKEN };
    var BAD_STRING_TOKEN = { type: TokenType.BAD_STRING_TOKEN };
    var CDO_TOKEN = { type: TokenType.CDO_TOKEN };
    var CDC_TOKEN = { type: TokenType.CDC_TOKEN };
    var COLON_TOKEN = { type: TokenType.COLON_TOKEN };
    var SEMICOLON_TOKEN = { type: TokenType.SEMICOLON_TOKEN };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.LEFT_SQUARE_BRACKET_TOKEN
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.RIGHT_SQUARE_BRACKET_TOKEN
    };
    var WHITESPACE_TOKEN = { type: TokenType.WHITESPACE_TOKEN };
    var EOF_TOKEN = { type: TokenType.EOF_TOKEN };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: TokenType.HASH_TOKEN, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: TokenType.AT_KEYWORD_TOKEN, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: TokenType.DELIM_TOKEN, value: fromCodePoint(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint.apply(void 0, endDigits), 16);
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: end };
            }
            else {
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: TokenType.FUNCTION_TOKEN, value: value };
            }
            return { type: TokenType.IDENT_TOKEN, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: TokenType.URL_TOKEN, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === TokenType.STRING_TOKEN) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: TokenType.URL_TOKEN, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 60000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: TokenType.STRING_TOKEN, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: TokenType.DIMENSION_TOKEN, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: TokenType.PERCENTAGE_TOKEN, number: number, flags: flags };
            }
            return { type: TokenType.NUMBER_TOKEN, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === TokenType.WHITESPACE_TOKEN) {
                token = this.consumeToken();
            }
            if (token.type === TokenType.EOF_TOKEN) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === TokenType.WHITESPACE_TOKEN);
            if (token.type === TokenType.EOF_TOKEN) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === TokenType.EOF_TOKEN) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case TokenType.LEFT_CURLY_BRACKET_TOKEN:
                case TokenType.LEFT_SQUARE_BRACKET_TOKEN:
                case TokenType.LEFT_PARENTHESIS_TOKEN:
                    return this.consumeSimpleBlock(token.type);
                case TokenType.FUNCTION_TOKEN:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === TokenType.EOF_TOKEN || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: TokenType.FUNCTION
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === TokenType.EOF_TOKEN || token.type === TokenType.RIGHT_PARENTHESIS_TOKEN) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === TokenType.DIMENSION_TOKEN; };
    var isNumberToken = function (token) { return token.type === TokenType.NUMBER_TOKEN; };
    var isIdentToken = function (token) { return token.type === TokenType.IDENT_TOKEN; };
    var isStringToken = function (token) { return token.type === TokenType.STRING_TOKEN; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== TokenType.WHITESPACE_TOKEN; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== TokenType.WHITESPACE_TOKEN && token.type !== TokenType.COMMA_TOKEN;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === TokenType.COMMA_TOKEN) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== TokenType.WHITESPACE_TOKEN) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === TokenType.LEFT_CURLY_BRACKET_TOKEN && token.type === TokenType.RIGHT_CURLY_BRACKET_TOKEN) {
            return true;
        }
        if (type === TokenType.LEFT_SQUARE_BRACKET_TOKEN && token.type === TokenType.RIGHT_SQUARE_BRACKET_TOKEN) {
            return true;
        }
        return type === TokenType.LEFT_PARENTHESIS_TOKEN && token.type === TokenType.RIGHT_PARENTHESIS_TOKEN;
    };

    var isLength = function (token) {
        return token.type === TokenType.NUMBER_TOKEN || token.type === TokenType.DIMENSION_TOKEN;
    };

    var isLengthPercentage = function (token) {
        return token.type === TokenType.PERCENTAGE_TOKEN || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: TokenType.NUMBER_TOKEN,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === TokenType.PERCENTAGE_TOKEN) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (value) {
            if (value.type === TokenType.DIMENSION_TOKEN) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === TokenType.DIMENSION_TOKEN) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (value) {
            if (value.type === TokenType.FUNCTION) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(value.values);
            }
            if (value.type === TokenType.HASH_TOKEN) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === TokenType.IDENT_TOKEN) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === TokenType.NUMBER_TOKEN) {
            return token.number;
        }
        if (token.type === TokenType.PERCENTAGE_TOKEN) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === TokenType.NUMBER_TOKEN ? deg(hue.number) : angle.parse(hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var PropertyDescriptorParsingType;
    (function (PropertyDescriptorParsingType) {
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["VALUE"] = 0] = "VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["LIST"] = 1] = "LIST";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["IDENT_VALUE"] = 2] = "IDENT_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TYPE_VALUE"] = 3] = "TYPE_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TOKEN_VALUE"] = 4] = "TOKEN_VALUE";
    })(PropertyDescriptorParsingType || (PropertyDescriptorParsingType = {}));

    var BACKGROUND_CLIP;
    (function (BACKGROUND_CLIP) {
        BACKGROUND_CLIP[BACKGROUND_CLIP["BORDER_BOX"] = 0] = "BORDER_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["PADDING_BOX"] = 1] = "PADDING_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["CONTENT_BOX"] = 2] = "CONTENT_BOX";
    })(BACKGROUND_CLIP || (BACKGROUND_CLIP = {}));
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return BACKGROUND_CLIP.PADDING_BOX;
                        case 'content-box':
                            return BACKGROUND_CLIP.CONTENT_BOX;
                    }
                }
                return BACKGROUND_CLIP.BORDER_BOX;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var parseColorStop = function (args) {
        var color = color$1.parse(args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case CSSRadialExtent.CLOSEST_SIDE:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.CLOSEST_CORNER:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case CSSRadialExtent.FARTHEST_SIDE:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.FARTHEST_CORNER:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: CSSImageType.LINEAR_GRADIENT };
    };

    var prefixLinearGradient = function (tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: CSSImageType.LINEAR_GRADIENT
        };
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        }
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        Logger.create = function (options) {
            Logger.instances[options.id] = new Logger(options);
        };
        Logger.destroy = function (id) {
            delete Logger.instances[id];
        };
        Logger.getInstance = function (id) {
            var instance = Logger.instances[id];
            if (typeof instance === 'undefined') {
                throw new Error("No logger instance found with id " + id);
            }
            return instance;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.create = function (name, options) {
            return (CacheStorage._caches[name] = new Cache(name, options));
        };
        CacheStorage.destroy = function (name) {
            delete CacheStorage._caches[name];
        };
        CacheStorage.open = function (name) {
            var cache = CacheStorage._caches[name];
            if (typeof cache !== 'undefined') {
                return cache;
            }
            throw new Error("Cache with key \"" + name + "\" not found");
        };
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage.getInstance = function () {
            var current = CacheStorage._current;
            if (current === null) {
                throw new Error("No cache instance attached");
            }
            return current;
        };
        CacheStorage.attachInstance = function (cache) {
            CacheStorage._current = cache;
        };
        CacheStorage.detachInstance = function () {
            CacheStorage._current = null;
        };
        CacheStorage._caches = {};
        CacheStorage._origin = 'about:blank';
        CacheStorage._current = null;
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(id, options) {
            this.id = id;
            this._options = options;
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            Logger.getInstance(this.id).debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var webkitGradient = function (tokens) {
        var angle = deg(180);
        var stops = [];
        var type = CSSImageType.LINEAR_GRADIENT;
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = CSSImageType.LINEAR_GRADIENT;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = CSSImageType.RADIAL_GRADIENT;
                    return;
                }
            }
            if (firstToken.type === TokenType.FUNCTION) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: TokenType.PERCENTAGE_TOKEN, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === CSSImageType.LINEAR_GRADIENT
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = CSSRadialShape.CIRCLE;
                                return false;
                            case ELLIPSE:
                                shape = CSSRadialShape.ELLIPSE;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = CSSRadialExtent.CLOSEST_SIDE;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = CSSRadialExtent.FARTHEST_SIDE;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = CSSRadialExtent.CLOSEST_CORNER;
                                return false;
                            case FARTHEST_CORNER:
                                size = CSSRadialExtent.FARTHEST_CORNER;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
    };

    var prefixRadialGradient = function (tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = CSSRadialShape.CIRCLE;
                                return false;
                            case ELLIPSE:
                                shape = CSSRadialShape.ELLIPSE;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = CSSRadialExtent.CLOSEST_SIDE;
                                return false;
                            case FARTHEST_SIDE:
                                size = CSSRadialExtent.FARTHEST_SIDE;
                                return false;
                            case CLOSEST_CORNER:
                                size = CSSRadialExtent.CLOSEST_CORNER;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = CSSRadialExtent.FARTHEST_CORNER;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
    };

    var CSSImageType;
    (function (CSSImageType) {
        CSSImageType[CSSImageType["URL"] = 0] = "URL";
        CSSImageType[CSSImageType["LINEAR_GRADIENT"] = 1] = "LINEAR_GRADIENT";
        CSSImageType[CSSImageType["RADIAL_GRADIENT"] = 2] = "RADIAL_GRADIENT";
    })(CSSImageType || (CSSImageType = {}));
    var isLinearGradient = function (background) {
        return background.type === CSSImageType.LINEAR_GRADIENT;
    };
    var isRadialGradient = function (background) {
        return background.type === CSSImageType.RADIAL_GRADIENT;
    };
    var CSSRadialShape;
    (function (CSSRadialShape) {
        CSSRadialShape[CSSRadialShape["CIRCLE"] = 0] = "CIRCLE";
        CSSRadialShape[CSSRadialShape["ELLIPSE"] = 1] = "ELLIPSE";
    })(CSSRadialShape || (CSSRadialShape = {}));
    var CSSRadialExtent;
    (function (CSSRadialExtent) {
        CSSRadialExtent[CSSRadialExtent["CLOSEST_SIDE"] = 0] = "CLOSEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_SIDE"] = 1] = "FARTHEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["CLOSEST_CORNER"] = 2] = "CLOSEST_CORNER";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_CORNER"] = 3] = "FARTHEST_CORNER";
    })(CSSRadialExtent || (CSSRadialExtent = {}));
    var image = {
        name: 'image',
        parse: function (value) {
            if (value.type === TokenType.URL_TOKEN) {
                var image_1 = { url: value.value, type: CSSImageType.URL };
                CacheStorage.getInstance().addImage(value.value);
                return image_1;
            }
            if (value.type === TokenType.FUNCTION) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(value.values);
            }
            throw new Error("Unsupported image type");
        }
    };
    function isSupportedImage(value) {
        return value.type !== TokenType.FUNCTION || !!SUPPORTED_IMAGE_FUNCTIONS[value.name];
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return [];
            }
            return tokens.filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); }).map(image.parse);
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var BACKGROUND_REPEAT;
    (function (BACKGROUND_REPEAT) {
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT"] = 0] = "REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["NO_REPEAT"] = 1] = "NO_REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_X"] = 2] = "REPEAT_X";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_Y"] = 3] = "REPEAT_Y";
    })(BACKGROUND_REPEAT || (BACKGROUND_REPEAT = {}));
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return BACKGROUND_REPEAT.NO_REPEAT;
            case 'repeat-x':
            case 'repeat no-repeat':
                return BACKGROUND_REPEAT.REPEAT_X;
            case 'repeat-y':
            case 'no-repeat repeat':
                return BACKGROUND_REPEAT.REPEAT_Y;
            case 'repeat':
            default:
                return BACKGROUND_REPEAT.REPEAT;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) { return parseLengthPercentageTuple(tokens.filter(isLengthPercentage)); }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var BORDER_STYLE;
    (function (BORDER_STYLE) {
        BORDER_STYLE[BORDER_STYLE["NONE"] = 0] = "NONE";
        BORDER_STYLE[BORDER_STYLE["SOLID"] = 1] = "SOLID";
        BORDER_STYLE[BORDER_STYLE["DASHED"] = 2] = "DASHED";
        BORDER_STYLE[BORDER_STYLE["DOTTED"] = 3] = "DOTTED";
        BORDER_STYLE[BORDER_STYLE["DOUBLE"] = 4] = "DOUBLE";
    })(BORDER_STYLE || (BORDER_STYLE = {}));
    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (style) {
            switch (style) {
                case 'none':
                    return BORDER_STYLE.NONE;
                case 'dashed':
                    return BORDER_STYLE.DASHED;
                case 'dotted':
                    return BORDER_STYLE.DOTTED;
                case 'double':
                    return BORDER_STYLE.DOUBLE;
            }
            return BORDER_STYLE.SOLID;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var FLOAT;
    (function (FLOAT) {
        FLOAT[FLOAT["NONE"] = 0] = "NONE";
        FLOAT[FLOAT["LEFT"] = 1] = "LEFT";
        FLOAT[FLOAT["RIGHT"] = 2] = "RIGHT";
        FLOAT[FLOAT["INLINE_START"] = 3] = "INLINE_START";
        FLOAT[FLOAT["INLINE_END"] = 4] = "INLINE_END";
    })(FLOAT || (FLOAT = {}));
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (float) {
            switch (float) {
                case 'left':
                    return FLOAT.LEFT;
                case 'right':
                    return FLOAT.RIGHT;
                case 'inline-start':
                    return FLOAT.INLINE_START;
                case 'inline-end':
                    return FLOAT.INLINE_END;
            }
            return FLOAT.NONE;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'normal') {
                return 0;
            }
            if (token.type === TokenType.NUMBER_TOKEN) {
                return token.number;
            }
            if (token.type === TokenType.DIMENSION_TOKEN) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.TOKEN_VALUE
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === TokenType.NUMBER_TOKEN) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
                return null;
            }
            return image.parse(token);
        }
    };

    var LIST_STYLE_POSITION;
    (function (LIST_STYLE_POSITION) {
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["INSIDE"] = 0] = "INSIDE";
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["OUTSIDE"] = 1] = "OUTSIDE";
    })(LIST_STYLE_POSITION || (LIST_STYLE_POSITION = {}));
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (position) {
            switch (position) {
                case 'inside':
                    return LIST_STYLE_POSITION.INSIDE;
                case 'outside':
                default:
                    return LIST_STYLE_POSITION.OUTSIDE;
            }
        }
    };

    var LIST_STYLE_TYPE;
    (function (LIST_STYLE_TYPE) {
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["NONE"] = -1] = "NONE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISC"] = 0] = "DISC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CIRCLE"] = 1] = "CIRCLE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SQUARE"] = 2] = "SQUARE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL"] = 3] = "DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_DECIMAL"] = 4] = "CJK_DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL_LEADING_ZERO"] = 5] = "DECIMAL_LEADING_ZERO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ROMAN"] = 6] = "LOWER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ROMAN"] = 7] = "UPPER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_GREEK"] = 8] = "LOWER_GREEK";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ALPHA"] = 9] = "LOWER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ALPHA"] = 10] = "UPPER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARABIC_INDIC"] = 11] = "ARABIC_INDIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARMENIAN"] = 12] = "ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["BENGALI"] = 13] = "BENGALI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CAMBODIAN"] = 14] = "CAMBODIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_EARTHLY_BRANCH"] = 15] = "CJK_EARTHLY_BRANCH";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_HEAVENLY_STEM"] = 16] = "CJK_HEAVENLY_STEM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_IDEOGRAPHIC"] = 17] = "CJK_IDEOGRAPHIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DEVANAGARI"] = 18] = "DEVANAGARI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ETHIOPIC_NUMERIC"] = 19] = "ETHIOPIC_NUMERIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GEORGIAN"] = 20] = "GEORGIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GUJARATI"] = 21] = "GUJARATI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GURMUKHI"] = 22] = "GURMUKHI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HEBREW"] = 22] = "HEBREW";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA"] = 23] = "HIRAGANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA_IROHA"] = 24] = "HIRAGANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_FORMAL"] = 25] = "JAPANESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_INFORMAL"] = 26] = "JAPANESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KANNADA"] = 27] = "KANNADA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA"] = 28] = "KATAKANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA_IROHA"] = 29] = "KATAKANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KHMER"] = 30] = "KHMER";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANGUL_FORMAL"] = 31] = "KOREAN_HANGUL_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_FORMAL"] = 32] = "KOREAN_HANJA_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_INFORMAL"] = 33] = "KOREAN_HANJA_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LAO"] = 34] = "LAO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ARMENIAN"] = 35] = "LOWER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MALAYALAM"] = 36] = "MALAYALAM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MONGOLIAN"] = 37] = "MONGOLIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MYANMAR"] = 38] = "MYANMAR";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ORIYA"] = 39] = "ORIYA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["PERSIAN"] = 40] = "PERSIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_FORMAL"] = 41] = "SIMP_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_INFORMAL"] = 42] = "SIMP_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TAMIL"] = 43] = "TAMIL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TELUGU"] = 44] = "TELUGU";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["THAI"] = 45] = "THAI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TIBETAN"] = 46] = "TIBETAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_FORMAL"] = 47] = "TRAD_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_INFORMAL"] = 48] = "TRAD_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ARMENIAN"] = 49] = "UPPER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_OPEN"] = 50] = "DISCLOSURE_OPEN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_CLOSED"] = 51] = "DISCLOSURE_CLOSED";
    })(LIST_STYLE_TYPE || (LIST_STYLE_TYPE = {}));
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (type) {
            switch (type) {
                case 'disc':
                    return LIST_STYLE_TYPE.DISC;
                case 'circle':
                    return LIST_STYLE_TYPE.CIRCLE;
                case 'square':
                    return LIST_STYLE_TYPE.SQUARE;
                case 'decimal':
                    return LIST_STYLE_TYPE.DECIMAL;
                case 'cjk-decimal':
                    return LIST_STYLE_TYPE.CJK_DECIMAL;
                case 'decimal-leading-zero':
                    return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
                case 'lower-roman':
                    return LIST_STYLE_TYPE.LOWER_ROMAN;
                case 'upper-roman':
                    return LIST_STYLE_TYPE.UPPER_ROMAN;
                case 'lower-greek':
                    return LIST_STYLE_TYPE.LOWER_GREEK;
                case 'lower-alpha':
                    return LIST_STYLE_TYPE.LOWER_ALPHA;
                case 'upper-alpha':
                    return LIST_STYLE_TYPE.UPPER_ALPHA;
                case 'arabic-indic':
                    return LIST_STYLE_TYPE.ARABIC_INDIC;
                case 'armenian':
                    return LIST_STYLE_TYPE.ARMENIAN;
                case 'bengali':
                    return LIST_STYLE_TYPE.BENGALI;
                case 'cambodian':
                    return LIST_STYLE_TYPE.CAMBODIAN;
                case 'cjk-earthly-branch':
                    return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
                case 'cjk-heavenly-stem':
                    return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
                case 'cjk-ideographic':
                    return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
                case 'devanagari':
                    return LIST_STYLE_TYPE.DEVANAGARI;
                case 'ethiopic-numeric':
                    return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
                case 'georgian':
                    return LIST_STYLE_TYPE.GEORGIAN;
                case 'gujarati':
                    return LIST_STYLE_TYPE.GUJARATI;
                case 'gurmukhi':
                    return LIST_STYLE_TYPE.GURMUKHI;
                case 'hebrew':
                    return LIST_STYLE_TYPE.HEBREW;
                case 'hiragana':
                    return LIST_STYLE_TYPE.HIRAGANA;
                case 'hiragana-iroha':
                    return LIST_STYLE_TYPE.HIRAGANA_IROHA;
                case 'japanese-formal':
                    return LIST_STYLE_TYPE.JAPANESE_FORMAL;
                case 'japanese-informal':
                    return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
                case 'kannada':
                    return LIST_STYLE_TYPE.KANNADA;
                case 'katakana':
                    return LIST_STYLE_TYPE.KATAKANA;
                case 'katakana-iroha':
                    return LIST_STYLE_TYPE.KATAKANA_IROHA;
                case 'khmer':
                    return LIST_STYLE_TYPE.KHMER;
                case 'korean-hangul-formal':
                    return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
                case 'korean-hanja-formal':
                    return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
                case 'korean-hanja-informal':
                    return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
                case 'lao':
                    return LIST_STYLE_TYPE.LAO;
                case 'lower-armenian':
                    return LIST_STYLE_TYPE.LOWER_ARMENIAN;
                case 'malayalam':
                    return LIST_STYLE_TYPE.MALAYALAM;
                case 'mongolian':
                    return LIST_STYLE_TYPE.MONGOLIAN;
                case 'myanmar':
                    return LIST_STYLE_TYPE.MYANMAR;
                case 'oriya':
                    return LIST_STYLE_TYPE.ORIYA;
                case 'persian':
                    return LIST_STYLE_TYPE.PERSIAN;
                case 'simp-chinese-formal':
                    return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
                case 'simp-chinese-informal':
                    return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
                case 'tamil':
                    return LIST_STYLE_TYPE.TAMIL;
                case 'telugu':
                    return LIST_STYLE_TYPE.TELUGU;
                case 'thai':
                    return LIST_STYLE_TYPE.THAI;
                case 'tibetan':
                    return LIST_STYLE_TYPE.TIBETAN;
                case 'trad-chinese-formal':
                    return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
                case 'trad-chinese-informal':
                    return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
                case 'upper-armenian':
                    return LIST_STYLE_TYPE.UPPER_ARMENIAN;
                case 'disclosure-open':
                    return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
                case 'disclosure-closed':
                    return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
                case 'none':
                default:
                    return LIST_STYLE_TYPE.NONE;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TOKEN_VALUE
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var OVERFLOW;
    (function (OVERFLOW) {
        OVERFLOW[OVERFLOW["VISIBLE"] = 0] = "VISIBLE";
        OVERFLOW[OVERFLOW["HIDDEN"] = 1] = "HIDDEN";
        OVERFLOW[OVERFLOW["SCROLL"] = 2] = "SCROLL";
        OVERFLOW[OVERFLOW["AUTO"] = 3] = "AUTO";
    })(OVERFLOW || (OVERFLOW = {}));
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return OVERFLOW.HIDDEN;
                    case 'scroll':
                        return OVERFLOW.SCROLL;
                    case 'auto':
                        return OVERFLOW.AUTO;
                    case 'visible':
                    default:
                        return OVERFLOW.VISIBLE;
                }
            });
        }
    };

    var OVERFLOW_WRAP;
    (function (OVERFLOW_WRAP) {
        OVERFLOW_WRAP["NORMAL"] = "normal";
        OVERFLOW_WRAP["BREAK_WORD"] = "break-word";
    })(OVERFLOW_WRAP || (OVERFLOW_WRAP = {}));
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (overflow) {
            switch (overflow) {
                case 'break-word':
                    return OVERFLOW_WRAP.BREAK_WORD;
                case 'normal':
                default:
                    return OVERFLOW_WRAP.NORMAL;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var TEXT_ALIGN;
    (function (TEXT_ALIGN) {
        TEXT_ALIGN[TEXT_ALIGN["LEFT"] = 0] = "LEFT";
        TEXT_ALIGN[TEXT_ALIGN["CENTER"] = 1] = "CENTER";
        TEXT_ALIGN[TEXT_ALIGN["RIGHT"] = 2] = "RIGHT";
    })(TEXT_ALIGN || (TEXT_ALIGN = {}));
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (textAlign) {
            switch (textAlign) {
                case 'right':
                    return TEXT_ALIGN.RIGHT;
                case 'center':
                case 'justify':
                    return TEXT_ALIGN.CENTER;
                case 'left':
                default:
                    return TEXT_ALIGN.LEFT;
            }
        }
    };

    var POSITION;
    (function (POSITION) {
        POSITION[POSITION["STATIC"] = 0] = "STATIC";
        POSITION[POSITION["RELATIVE"] = 1] = "RELATIVE";
        POSITION[POSITION["ABSOLUTE"] = 2] = "ABSOLUTE";
        POSITION[POSITION["FIXED"] = 3] = "FIXED";
        POSITION[POSITION["STICKY"] = 4] = "STICKY";
    })(POSITION || (POSITION = {}));
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (position) {
            switch (position) {
                case 'relative':
                    return POSITION.RELATIVE;
                case 'absolute':
                    return POSITION.ABSOLUTE;
                case 'fixed':
                    return POSITION.FIXED;
                case 'sticky':
                    return POSITION.STICKY;
            }
            return POSITION.STATIC;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(token);
                    }
                }
                return shadow;
            });
        }
    };

    var TEXT_TRANSFORM;
    (function (TEXT_TRANSFORM) {
        TEXT_TRANSFORM[TEXT_TRANSFORM["NONE"] = 0] = "NONE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["LOWERCASE"] = 1] = "LOWERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["UPPERCASE"] = 2] = "UPPERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["CAPITALIZE"] = 3] = "CAPITALIZE";
    })(TEXT_TRANSFORM || (TEXT_TRANSFORM = {}));
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return TEXT_TRANSFORM.UPPERCASE;
                case 'lowercase':
                    return TEXT_TRANSFORM.LOWERCASE;
                case 'capitalize':
                    return TEXT_TRANSFORM.CAPITALIZE;
            }
            return TEXT_TRANSFORM.NONE;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
                return null;
            }
            if (token.type === TokenType.FUNCTION) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var VISIBILITY;
    (function (VISIBILITY) {
        VISIBILITY[VISIBILITY["VISIBLE"] = 0] = "VISIBLE";
        VISIBILITY[VISIBILITY["HIDDEN"] = 1] = "HIDDEN";
        VISIBILITY[VISIBILITY["COLLAPSE"] = 2] = "COLLAPSE";
    })(VISIBILITY || (VISIBILITY = {}));
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (visibility) {
            switch (visibility) {
                case 'hidden':
                    return VISIBILITY.HIDDEN;
                case 'collapse':
                    return VISIBILITY.COLLAPSE;
                case 'visible':
                default:
                    return VISIBILITY.VISIBLE;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case TokenType.IDENT_TOKEN:
                    case TokenType.STRING_TOKEN:
                        accumulator.push(token.value);
                        break;
                    case TokenType.NUMBER_TOKEN:
                        accumulator.push(token.number.toString());
                        break;
                    case TokenType.COMMA_TOKEN:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var FONT_STYLE;
    (function (FONT_STYLE) {
        FONT_STYLE["NORMAL"] = "normal";
        FONT_STYLE["ITALIC"] = "italic";
        FONT_STYLE["OBLIQUE"] = "oblique";
    })(FONT_STYLE || (FONT_STYLE = {}));
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (overflow) {
            switch (overflow) {
                case 'oblique':
                    return FONT_STYLE.OBLIQUE;
                case 'italic':
                    return FONT_STYLE.ITALIC;
                case 'normal':
                default:
                    return FONT_STYLE.NORMAL;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === TokenType.IDENT_TOKEN) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(token);
                    }
                }
                return shadow;
            });
        }
    };

    var PAINT_ORDER_LAYER;
    (function (PAINT_ORDER_LAYER) {
        PAINT_ORDER_LAYER[PAINT_ORDER_LAYER["FILL"] = 0] = "FILL";
        PAINT_ORDER_LAYER[PAINT_ORDER_LAYER["STROKE"] = 1] = "STROKE";
        PAINT_ORDER_LAYER[PAINT_ORDER_LAYER["MARKERS"] = 2] = "MARKERS";
    })(PAINT_ORDER_LAYER || (PAINT_ORDER_LAYER = {}));
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            var DEFAULT_VALUE = [PAINT_ORDER_LAYER.FILL, PAINT_ORDER_LAYER.STROKE, PAINT_ORDER_LAYER.MARKERS];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(PAINT_ORDER_LAYER.STROKE);
                        break;
                    case 'fill':
                        layers.push(PAINT_ORDER_LAYER.FILL);
                        break;
                    case 'markers':
                        layers.push(PAINT_ORDER_LAYER.MARKERS);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(declaration) {
            var _a, _b;
            this.backgroundClip = parse(backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(boxShadow, declaration.boxShadow);
            this.color = parse(color, declaration.color);
            this.display = parse(display, declaration.display);
            this.float = parse(float, declaration.cssFloat);
            this.fontFamily = parse(fontFamily, declaration.fontFamily);
            this.fontSize = parse(fontSize, declaration.fontSize);
            this.fontStyle = parse(fontStyle, declaration.fontStyle);
            this.fontVariant = parse(fontVariant, declaration.fontVariant);
            this.fontWeight = parse(fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(lineBreak, declaration.lineBreak);
            this.lineHeight = parse(lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(listStyleType, declaration.listStyleType);
            this.marginTop = parse(marginTop, declaration.marginTop);
            this.marginRight = parse(marginRight, declaration.marginRight);
            this.marginBottom = parse(marginBottom, declaration.marginBottom);
            this.marginLeft = parse(marginLeft, declaration.marginLeft);
            this.opacity = parse(opacity, declaration.opacity);
            var overflowTuple = parse(overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(paddingTop, declaration.paddingTop);
            this.paddingRight = parse(paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(paintOrder, declaration.paintOrder);
            this.position = parse(position, declaration.position);
            this.textAlign = parse(textAlign, declaration.textAlign);
            this.textDecorationColor = parse(textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(textShadow, declaration.textShadow);
            this.textTransform = parse(textTransform, declaration.textTransform);
            this.transform = parse(transform$1, declaration.transform);
            this.transformOrigin = parse(transformOrigin, declaration.transformOrigin);
            this.visibility = parse(visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(wordBreak, declaration.wordBreak);
            this.zIndex = parse(zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === VISIBILITY.VISIBLE;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== POSITION.STATIC;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== FLOAT.NONE;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(declaration) {
            this.content = parse(content, declaration.content);
            this.quotes = parse(quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(declaration) {
            this.counterIncrement = parse(counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case PropertyDescriptorParsingType.IDENT_VALUE:
                var token = parser.parseComponentValue();
                return descriptor.parse(isIdentToken(token) ? token.value : descriptor.initialValue);
            case PropertyDescriptorParsingType.VALUE:
                return descriptor.parse(parser.parseComponentValue());
            case PropertyDescriptorParsingType.LIST:
                return descriptor.parse(parser.parseComponentValues());
            case PropertyDescriptorParsingType.TOKEN_VALUE:
                return parser.parseComponentValue();
            case PropertyDescriptorParsingType.TYPE_VALUE:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(parser.parseComponentValue());
                    case 'image':
                        return image.parse(parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                }
                break;
        }
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(element) {
            this.styles = new CSSParsedDeclaration(window.getComputedStyle(element, null));
            this.textNodes = [];
            this.elements = [];
            if (this.styles.transform !== null && isHTMLElementNode(element)) {
                // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(element);
            this.flags = 0;
        }
        return ElementContainer;
    }());

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length)));
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return new Bounds(0, 0, 0, 0);
    };
    var getRangeBounds = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return Bounds.fromClientRect(range.getBoundingClientRect());
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? toCodePoints(value).map(function (i) { return fromCodePoint(i); }) : breakWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case TEXT_TRANSFORM.LOWERCASE:
                return text.toLowerCase();
            case TEXT_TRANSFORM.CAPITALIZE:
                return text.replace(CAPITALIZE, capitalize);
            case TEXT_TRANSFORM.UPPERCASE:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(img) {
            var _this = _super.call(this, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            CacheStorage.getInstance().addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(canvas) {
            var _this = _super.call(this, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(img) {
            var _this = _super.call(this, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            CacheStorage.getInstance().addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: TokenType.DIMENSION_TOKEN,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: TokenType.PERCENTAGE_TOKEN,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(input) {
            var _this = _super.call(this, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                BORDER_STYLE.SOLID;
                _this.styles.backgroundClip = [BACKGROUND_CLIP.BORDER_BOX];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(element) {
            var _this = _super.call(this, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var parseColor$1 = function (value) { return color$1.parse(Parser.create(value).parseComponentValue()); };
    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(iframe) {
            var _this = _super.call(this, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor$1(getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor$1(getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(childNode, parent, root); });
                }
                else {
                    var container = createContainer(childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(element);
        }
        return new ElementContainer(element);
    };
    var parseTree = function (element) {
        var container = createContainer(element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case LIST_STYLE_TYPE.DISC:
                return '•' + spaceSuffix;
            case LIST_STYLE_TYPE.CIRCLE:
                return '◦' + spaceSuffix;
            case LIST_STYLE_TYPE.SQUARE:
                return '◾' + spaceSuffix;
            case LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case LIST_STYLE_TYPE.CJK_DECIMAL:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case LIST_STYLE_TYPE.LOWER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.UPPER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_GREEK:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ALPHA:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case LIST_STYLE_TYPE.UPPER_ALPHA:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case LIST_STYLE_TYPE.ARABIC_INDIC:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case LIST_STYLE_TYPE.ARMENIAN:
            case LIST_STYLE_TYPE.UPPER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.BENGALI:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case LIST_STYLE_TYPE.CAMBODIAN:
            case LIST_STYLE_TYPE.KHMER:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
            case LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.JAPANESE_INFORMAL:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case LIST_STYLE_TYPE.JAPANESE_FORMAL:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.DEVANAGARI:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case LIST_STYLE_TYPE.GEORGIAN:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.GUJARATI:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case LIST_STYLE_TYPE.GURMUKHI:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.HEBREW:
                return createAdditiveCounter(value, 1, 10999, HEBREW, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.HIRAGANA:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case LIST_STYLE_TYPE.HIRAGANA_IROHA:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case LIST_STYLE_TYPE.KANNADA:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case LIST_STYLE_TYPE.KATAKANA:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case LIST_STYLE_TYPE.KATAKANA_IROHA:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case LIST_STYLE_TYPE.LAO:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case LIST_STYLE_TYPE.MONGOLIAN:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case LIST_STYLE_TYPE.MYANMAR:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case LIST_STYLE_TYPE.ORIYA:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.PERSIAN:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case LIST_STYLE_TYPE.TAMIL:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case LIST_STYLE_TYPE.TELUGU:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.THAI:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case LIST_STYLE_TYPE.TIBETAN:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case LIST_STYLE_TYPE.DECIMAL:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(element, options) {
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    documentClone.documentElement.style.top = -windowSize.top + 'px';
                                    documentClone.documentElement.style.left = -windowSize.left + 'px';
                                    documentClone.documentElement.style.position = 'absolute';
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                Logger.getInstance(this.options.id).error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    Logger.getInstance(this.options.id).info("Unable to clone canvas contents, canvas is tainted");
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) { }
            return clonedCanvas;
        };
        DocumentCloner.prototype.cloneNode = function (node) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                for (var child = node.firstChild; child; child = child.nextSibling) {
                    if (!isElementNode(child) ||
                        (!isScriptElement(child) &&
                            !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                            (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                        if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                            clone.appendChild(this.cloneNode(child));
                        }
                    }
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(style));
            var declaration = new CSSParsedPseudoDeclaration(style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === TokenType.STRING_TOKEN) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === TokenType.URL_TOKEN) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === TokenType.FUNCTION) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(counterStyle.value)
                                : LIST_STYLE_TYPE.DECIMAL;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(counterStyle.value)
                                : LIST_STYLE_TYPE.DECIMAL;
                            var separator = delim && delim.type === TokenType.STRING_TOKEN ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                }
                else if (token.type === TokenType.IDENT_TOKEN) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var PathType;
    (function (PathType) {
        PathType[PathType["VECTOR"] = 0] = "VECTOR";
        PathType[PathType["BEZIER_CURVE"] = 1] = "BEZIER_CURVE";
    })(PathType || (PathType = {}));
    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = PathType.VECTOR;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = PathType.BEZIER_CURVE;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === PathType.BEZIER_CURVE; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.type = 1 /* CLIP */;
            this.target = target;
            this.path = path;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
            this.opacity = opacity;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(element, parentStack) {
            this.container = element;
            this.effects = parentStack.slice(0);
            this.curves = new BoundCurves(element);
            if (element.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(element.styles.opacity));
            }
            if (element.styles.transform !== null) {
                var offsetX = element.bounds.left + element.styles.transformOrigin[0].number;
                var offsetY = element.bounds.top + element.styles.transformOrigin[1].number;
                var matrix = element.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (element.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getParentEffects = function () {
            var effects = this.effects.slice(0);
            if (this.container.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (!equalPath(borderBox, paddingBox)) {
                    effects.push(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
            }
            return effects;
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent.getParentEffects());
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, []);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === BACKGROUND_CLIP.BORDER_BOX) {
            return element.bounds;
        }
        if (backgroundClip === BACKGROUND_CLIP.CONTENT_BOX) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case BACKGROUND_REPEAT.REPEAT_X:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case BACKGROUND_REPEAT.REPEAT_Y:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case BACKGROUND_REPEAT.NO_REPEAT:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function () {
        function CanvasRenderer(options) {
            this._activeEffects = [];
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            if (!options.canvas) {
                this.canvas.width = Math.floor(options.width * options.scale);
                this.canvas.height = Math.floor(options.height * options.scale);
                this.canvas.style.width = options.width + "px";
                this.canvas.style.height = options.height + "px";
            }
            this.fontMetrics = new FontMetrics(document);
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            this.ctx.textBaseline = 'bottom';
            this._activeEffects = [];
            Logger.getInstance(options.id).debug("Canvas renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        CanvasRenderer.prototype.applyEffects = function (effects, target) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.filter(function (effect) { return contains(effect.target, target); }).forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = toCodePoints(text.text).map(function (i) { return fromCodePoint(i); });
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = styles.fontFamily.join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case PAINT_ORDER_LAYER.FILL:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case PAINT_ORDER_LAYER.STROKE:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.effects, 4 /* CONTENT */);
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.options.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            Logger.getInstance(this.options.id).error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.options.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            Logger.getInstance(this.options.id).error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer({
                                id: this.options.id,
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                scrollX: 0,
                                scrollY: 0,
                                width: container.width,
                                height: container.height,
                                cache: this.options.cache,
                                windowWidth: container.width,
                                windowHeight: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case TEXT_ALIGN.CENTER:
                                        x += bounds.width / 2;
                                        break;
                                    case TEXT_ALIGN.RIGHT:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === CSSImageType.URL)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.options.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            Logger.getInstance(this.options.id).error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== LIST_STYLE_TYPE.NONE) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0: 
                        // https://www.w3.org/TR/css-position-3/#painting-order
                        // 1. the background and borders of the element forming the stacking context.
                        return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === CSSImageType.URL)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.options.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            Logger.getInstance(this_1.options.id).error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && rx > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.effects, 2 /* BACKGROUND_BORDERS */);
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== BORDER_STYLE.NONE && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === BORDER_STYLE.DASHED)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, BORDER_STYLE.DASHED)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === BORDER_STYLE.DOTTED)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, BORDER_STYLE.DOTTED)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === BORDER_STYLE.DOUBLE)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === BORDER_STYLE.DASHED) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === BORDER_STYLE.DOTTED) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === BORDER_STYLE.DOTTED) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === BORDER_STYLE.DOTTED) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === BORDER_STYLE.DOTTED) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === BORDER_STYLE.DASHED) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x - this.options.scrollX, this.options.y - this.options.scrollY, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([], 2 /* BACKGROUND_BORDERS */);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }());
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case BACKGROUND_CLIP.BORDER_BOX:
                return calculateBorderBoxPath(curves);
            case BACKGROUND_CLIP.CONTENT_BOX:
                return calculateContentBoxPath(curves);
            case BACKGROUND_CLIP.PADDING_BOX:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case TEXT_ALIGN.CENTER:
                return 'center';
            case TEXT_ALIGN.RIGHT:
                return 'right';
            case TEXT_ALIGN.LEFT:
            default:
                return 'left';
        }
    };

    var ForeignObjectRenderer = /** @class */ (function () {
        function ForeignObjectRenderer(options) {
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            this.canvas.width = Math.floor(options.width * options.scale);
            this.canvas.height = Math.floor(options.height * options.scale);
            this.canvas.style.width = options.width + "px";
            this.canvas.style.height = options.height + "px";
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            Logger.getInstance(options.id).debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(Math.max(this.options.windowWidth, this.options.width) * this.options.scale, Math.max(this.options.windowHeight, this.options.height) * this.options.scale, this.options.scrollX * this.options.scale, this.options.scrollY * this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }());
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var parseColor = function (value) { return color$1.parse(Parser.create(value).parseComponentValue()); };
    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var instanceCount = 1;
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, instanceName, _a, width, height, left, top, defaultResourceOptions, resourceOptions, defaultOptions, options, windowBounds, documentCloner, clonedElement, container, documentBackgroundColor, bodyBackgroundColor, bgColor, defaultBackgroundColor, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    instanceName = "#" + instanceCount++;
                    _a = isBodyElement(element) || isHTMLElement(element) ? parseDocumentSize(ownerDocument) : parseBounds(element), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    defaultResourceOptions = {
                        allowTaint: false,
                        imageTimeout: 15000,
                        proxy: undefined,
                        useCORS: false
                    };
                    resourceOptions = __assign(__assign({}, defaultResourceOptions), opts);
                    defaultOptions = {
                        backgroundColor: '#ffffff',
                        cache: opts.cache ? opts.cache : CacheStorage.create(instanceName, resourceOptions),
                        logging: true,
                        removeContainer: true,
                        foreignObjectRendering: false,
                        scale: defaultView.devicePixelRatio || 1,
                        windowWidth: defaultView.innerWidth,
                        windowHeight: defaultView.innerHeight,
                        scrollX: defaultView.pageXOffset,
                        scrollY: defaultView.pageYOffset,
                        x: left,
                        y: top,
                        width: Math.ceil(width),
                        height: Math.ceil(height),
                        id: instanceName
                    };
                    options = __assign(__assign(__assign({}, defaultOptions), resourceOptions), opts);
                    windowBounds = new Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);
                    Logger.create({ id: instanceName, enabled: options.logging });
                    Logger.getInstance(instanceName).debug("Starting document clone");
                    documentCloner = new DocumentCloner(element, {
                        id: instanceName,
                        onclone: options.onclone,
                        ignoreElements: options.ignoreElements,
                        inlineImages: options.foreignObjectRendering,
                        copyStyles: options.foreignObjectRendering
                    });
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _b.sent();
                    documentBackgroundColor = ownerDocument.documentElement
                        ? parseColor(getComputedStyle(ownerDocument.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    bodyBackgroundColor = ownerDocument.body
                        ? parseColor(getComputedStyle(ownerDocument.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    bgColor = opts.backgroundColor;
                    defaultBackgroundColor = typeof bgColor === 'string' ? parseColor(bgColor) : bgColor === null ? COLORS.TRANSPARENT : 0xffffffff;
                    backgroundColor = element === ownerDocument.documentElement
                        ? isTransparent(documentBackgroundColor)
                            ? isTransparent(bodyBackgroundColor)
                                ? defaultBackgroundColor
                                : bodyBackgroundColor
                            : documentBackgroundColor
                        : defaultBackgroundColor;
                    renderOptions = {
                        id: instanceName,
                        cache: options.cache,
                        canvas: options.canvas,
                        backgroundColor: backgroundColor,
                        scale: options.scale,
                        x: options.x,
                        y: options.y,
                        scrollX: options.scrollX,
                        scrollY: options.scrollY,
                        width: options.width,
                        height: options.height,
                        windowWidth: options.windowWidth,
                        windowHeight: options.windowHeight
                    };
                    if (!options.foreignObjectRendering) return [3 /*break*/, 3];
                    Logger.getInstance(instanceName).debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    Logger.getInstance(instanceName).debug("Document cloned, using computed rendering");
                    CacheStorage.attachInstance(options.cache);
                    Logger.getInstance(instanceName).debug("Starting DOM parsing");
                    root = parseTree(clonedElement);
                    CacheStorage.detachInstance();
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    Logger.getInstance(instanceName).debug("Starting renderer");
                    renderer = new CanvasRenderer(renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _b.sent();
                    _b.label = 5;
                case 5:
                    if (options.removeContainer === true) {
                        if (!DocumentCloner.destroy(container)) {
                            Logger.getInstance(instanceName).error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    Logger.getInstance(instanceName).debug("Finished rendering");
                    Logger.destroy(instanceName);
                    CacheStorage.destroy(instanceName);
                    return [2 /*return*/, canvas];
            }
        });
    }); };

    return html2canvas;

})));

});

var html2canvas$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': html2canvas,
	__moduleExports: html2canvas
});

/**
 * PDF Export
 *
 * @vuedoc
 * @exports TfPdfExport
 * @category components
 */
var script$G = {
  name: 'TfPdfExport',
  props: {
    filename: {
      type: String,
      default: 'export.pdf'
    }
  },
  data: function data() {
    return {
      pages: []
    };
  },
  mounted: function mounted() {
    this.exportPdf();
  },
  methods: {
    /**
     * Get element height including margin and padding
     *
     * @param {object} element
     * @returns {number}
     */
    getHeight: function getHeight(element) {
      return ['height', 'margin-top', 'margin-bottom', 'padding-top', 'padding-bottom'].reduce(function (height, propertyName) {
        return height + Number(document.defaultView.getComputedStyle(element, '').getPropertyValue(propertyName).replace(/px$/, ''));
      }, 0);
    },
    /**
     * Create new DIV element
     *
     * @param {string} className
     * @returns {object}
     */
    generateDiv: function generateDiv(className) {
      var div = document.createElement('div');
      if (className) {
        div.className = className;
      }
      return div;
    },
    /**
     * Generate PDF via JsPDF
     *
     * @returns {object}
     */
    generatePdf: function generatePdf() {
      var _this = this;
      var pdfDocument = document.implementation.createHTMLDocument('pdf-export');
      pdfDocument.className = 'pdf-export-document';

      // page 1
      var pdfPage = this.generateDiv('pdf-export-page');
      var pageHeight = 40; // design has 40px margin all around
      var blocksInDocument = 0;
      var lastBlockOnPage = 0;
      var blocks = [];
      this.$el.querySelectorAll('.pdf-export-block').forEach(function (block) {
        var cloneBlock = block;
        // this is the only point at which the height value reflects reality, so we need to store it
        cloneBlock.setAttribute('block-height', _this.getHeight(block));
        blocks.push(cloneBlock);
      });
      while (blocks.length > 0) {
        var block = blocks.splice(0, 1)[0];
        var blockHeight = Number(block.getAttribute('block-height'));
        if (pageHeight + blockHeight > 730) {
          // we need to add another page
          lastBlockOnPage = blocksInDocument;
          this.pages.push(pdfPage);
          pdfPage = this.generateDiv('pdf-export-page');
          pageHeight = 40;
        }
        block.style.position = 'absolute';
        block.style.left = '40px';
        block.style.top = "".concat(pageHeight, "px");
        pdfPage.appendChild(block);
        pageHeight += blockHeight;
        blocksInDocument += 1;
      }
      if (blocksInDocument > lastBlockOnPage + 1) {
        // one or more elements were added to a pdfPage but the page wasn't added to the pages array yet
        this.pages.push(pdfPage);
      }

      // insert pagination div
      this.pages.forEach(function (page, index) {
        var pagination = _this.generateDiv('pagination');
        pagination.innerHTML = "Page ".concat(index + 1, " of ").concat(_this.pages.length);
        page.appendChild(pagination);
        pdfDocument.body.appendChild(page);
      });
      return pdfDocument.body;
    },
    /**
     * Export PDF via JsPDF.
     * jest/mocha (well, node) can't deal with this version of jsPDF at this time so we're cheating here and using require.
     * TODO:
     * - conditionally load node version here; note that that library does not expose a save() method because Node is expected to handle it's own file saving
     * - if we want to test the result, we'd have to account for that some other way
     */
    exportPdf: function exportPdf() {
      var _this2 = this;
      var pdfFile = new E('p', 'pt', 'letter');

      // needed for the .html() method on jsPDF (but is somehow not a requirement for jsPDF)
      if (!window.html2canvas) {
        window.html2canvas = html2canvas;
      }
      pdfFile.html(this.generatePdf(), {
        callback: function callback() {
          // occasionally when window page height is larger or equal to 730px blank page(s) will be added
          // to end of pdf document. these need to be checked after generation and be will deleted before save
          var pdfPages = pdfFile.internal.getNumberOfPages();
          if (pdfPages > _this2.pages.length) {
            for (pdfPages; pdfPages > _this2.pages.length; pdfPages -= 1) {
              pdfFile.deletePage(pdfPages);
            }
          }
          pdfFile.save(_this2.filename);
          _this2.$emit('save');
        },
        html2canvas: {
          scale: 1,
          logging: false // this was spitting out console logs
        }
      });
    }
  }
};

/* script */
const __vue_script__$G = script$G;

/* template */
var __vue_render__$F = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "pdf-export-markup" }, [_vm._t("default")], 2)
};
var __vue_staticRenderFns__$F = [];
__vue_render__$F._withStripped = true;

  /* style */
  const __vue_inject_styles__$G = function (inject) {
    if (!inject) return
    inject("data-v-2c0c7340_0", { source: "/**\n* This file is intentially unscoped since there are divs being created in the methods.\n*/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.pdf-export-document {\n  width: 610px;\n}\n.pdf-export-markup {\n  position: fixed;\n  top: -1000em;\n  left: -1000em;\n  width: 630px;\n}\n.pdf-export-page {\n  position: relative;\n  width: 610px;\n  height: 792px;\n  padding: 0;\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n.pagination {\n  position: absolute;\n  bottom: 30px;\n  right: 40px;\n  font-size: 10px;\n  color: #42474c;\n}\n\n/*# sourceMappingURL=ExportFile.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfPdfExport/ExportFile.vue","ExportFile.vue"],"names":[],"mappings":"AAyKA;;CAAA;ACtKA;;kCAEkC;ADyKlC;EACA,YAAA;ACvKA;AD0KA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;ACvKA;AD0KA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;ACvKA;AD0KA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;ACvKA;;AAEA,yCAAyC","file":"ExportFile.vue","sourcesContent":["<template>\n  <div class=\"pdf-export-markup\">\n    <slot />\n  </div>\n</template>\n\n<script>\n  import JsPDF from 'jspdf';\n  import html2canvas from 'html2canvas';\n\n  /**\n   * PDF Export\n   *\n   * @vuedoc\n   * @exports TfPdfExport\n   * @category components\n   */\n  export default {\n    name: 'TfPdfExport',\n    props: {\n      filename: {\n        type: String,\n        default: 'export.pdf',\n      },\n    },\n    data() {\n      return { pages: [] };\n    },\n    mounted() {\n      this.exportPdf();\n    },\n    methods: {\n      /**\n       * Get element height including margin and padding\n       *\n       * @param {object} element\n       * @returns {number}\n       */\n      getHeight(element) {\n        return [\n          'height',\n          'margin-top',\n          'margin-bottom',\n          'padding-top',\n          'padding-bottom',\n        ].reduce(\n          (height, propertyName) => height + Number(\n            document\n              .defaultView\n              .getComputedStyle(element, '')\n              .getPropertyValue(propertyName)\n              .replace(/px$/, ''),\n          ),\n          0,\n        );\n      },\n      /**\n       * Create new DIV element\n       *\n       * @param {string} className\n       * @returns {object}\n       */\n      generateDiv(className) {\n        const div = document.createElement('div');\n        if (className) {\n          div.className = className;\n        }\n        return div;\n      },\n      /**\n       * Generate PDF via JsPDF\n       *\n       * @returns {object}\n       */\n      generatePdf() {\n        const pdfDocument = document.implementation.createHTMLDocument('pdf-export');\n        pdfDocument.className = 'pdf-export-document';\n\n        // page 1\n        let pdfPage = this.generateDiv('pdf-export-page');\n        let pageHeight = 40; // design has 40px margin all around\n        let blocksInDocument = 0;\n        let lastBlockOnPage = 0;\n        const blocks = [];\n\n        this.$el.querySelectorAll('.pdf-export-block').forEach((block) => {\n          const cloneBlock = block;\n          // this is the only point at which the height value reflects reality, so we need to store it\n          cloneBlock.setAttribute('block-height', this.getHeight(block));\n          blocks.push(cloneBlock);\n        });\n\n        while (blocks.length > 0) {\n          const block = blocks.splice(0, 1)[0];\n          const blockHeight = Number(block.getAttribute('block-height'));\n          if (pageHeight + blockHeight > 730) {\n            // we need to add another page\n            lastBlockOnPage = blocksInDocument;\n            this.pages.push(pdfPage);\n            pdfPage = this.generateDiv('pdf-export-page');\n            pageHeight = 40;\n          }\n\n          block.style.position = 'absolute';\n          block.style.left = '40px';\n          block.style.top = `${pageHeight}px`;\n          pdfPage.appendChild(block);\n          pageHeight += blockHeight;\n          blocksInDocument += 1;\n        }\n\n        if (blocksInDocument > lastBlockOnPage + 1) {\n          // one or more elements were added to a pdfPage but the page wasn't added to the pages array yet\n          this.pages.push(pdfPage);\n        }\n\n        // insert pagination div\n        this.pages.forEach((page, index) => {\n          const pagination = this.generateDiv('pagination');\n          pagination.innerHTML = `Page ${index + 1} of ${this.pages.length}`;\n          page.appendChild(pagination);\n          pdfDocument.body.appendChild(page);\n        });\n\n        return pdfDocument.body;\n      },\n      /**\n       * Export PDF via JsPDF.\n       * jest/mocha (well, node) can't deal with this version of jsPDF at this time so we're cheating here and using require.\n       * TODO:\n       * - conditionally load node version here; note that that library does not expose a save() method because Node is expected to handle it's own file saving\n       * - if we want to test the result, we'd have to account for that some other way\n       */\n      exportPdf() {\n        const pdfFile = new JsPDF('p', 'pt', 'letter');\n\n        // needed for the .html() method on jsPDF (but is somehow not a requirement for jsPDF)\n        if (!window.html2canvas) {\n          window.html2canvas = html2canvas;\n        }\n\n        pdfFile.html(\n          this.generatePdf(),\n          {\n            callback: () => {\n              // occasionally when window page height is larger or equal to 730px blank page(s) will be added\n              // to end of pdf document. these need to be checked after generation and be will deleted before save\n              let pdfPages = pdfFile.internal.getNumberOfPages();\n\n              if (pdfPages > this.pages.length) {\n                for (pdfPages; pdfPages > this.pages.length; pdfPages -= 1) {\n                  pdfFile.deletePage(pdfPages);\n                }\n              }\n              pdfFile.save(this.filename);\n              this.$emit('save');\n            },\n            html2canvas: {\n              scale: 1,\n              logging: false, // this was spitting out console logs\n            },\n          },\n        );\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\">\n  /**\n  * This file is intentially unscoped since there are divs being created in the methods.\n  */\n  @import 'src/assets/styles/variables';\n\n  .pdf-export-document {\n    width: 610px;\n  }\n\n  .pdf-export-markup {\n    position: fixed;\n    top: -1000em;\n    left: -1000em;\n    width: 630px;\n  }\n\n  .pdf-export-page {\n    position: relative;\n    width: 610px;\n    height: 792px;\n    padding: 0;\n    margin: 0;\n    font-family: Arial, sans-serif;\n  }\n\n  .pagination {\n    position: absolute;\n    bottom: 30px;\n    right: 40px;\n    font-size: 10px;\n    color: $tf-dark-gray;\n  }\n</style>\n","/**\n* This file is intentially unscoped since there are divs being created in the methods.\n*/\n/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.pdf-export-document {\n  width: 610px;\n}\n\n.pdf-export-markup {\n  position: fixed;\n  top: -1000em;\n  left: -1000em;\n  width: 630px;\n}\n\n.pdf-export-page {\n  position: relative;\n  width: 610px;\n  height: 792px;\n  padding: 0;\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\n.pagination {\n  position: absolute;\n  bottom: 30px;\n  right: 40px;\n  font-size: 10px;\n  color: #42474c;\n}\n\n/*# sourceMappingURL=ExportFile.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$G = undefined;
  /* module identifier */
  const __vue_module_identifier__$G = undefined;
  /* functional template */
  const __vue_is_functional_template__$G = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$G = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$F, staticRenderFns: __vue_staticRenderFns__$F },
    __vue_inject_styles__$G,
    __vue_script__$G,
    __vue_scope_id__$G,
    __vue_is_functional_template__$G,
    __vue_module_identifier__$G,
    false,
    browser,
    undefined,
    undefined
  );

//

/**
 * PDF Export
 *
 * @vuedoc
 * @exports TfPdfExport
 * @category components
 */
var script$H = {
  name: 'TfPdfExport',
  components: {
    ExportFile: __vue_component__$G
  },
  props: {
    buttonSize: {
      type: String,
      default: 'text-icon'
    },
    buttonTitle: {
      type: String,
      default: 'export'
    },
    filename: {
      type: String,
      default: 'export.pdf'
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      render: false,
      renderingPdf: false
    };
  },
  methods: {
    /**
     * Starts the render process.
     */
    startRender: function startRender() {
      this.renderingPdf = true;
      this.render = true;
    },
    /**
     * Stops the render process.
     */
    stopRender: function stopRender() {
      this.render = false;
      this.renderingPdf = false;
    }
  }
};

/* script */
const __vue_script__$H = script$H;

/* template */
var __vue_render__$G = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "pdf-export-generator" },
    [
      _c(
        "TfButton",
        {
          attrs: {
            disabled: _vm.isDisabled,
            loading: _vm.renderingPdf,
            size: _vm.buttonSize,
            "data-test": "export pdf",
            type: "primary",
            icon: "file-download",
          },
          on: { click: _vm.startRender },
        },
        [_vm._v("\n    " + _vm._s(_vm.buttonTitle) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.render
        ? _c(
            "ExportFile",
            { attrs: { filename: _vm.filename }, on: { save: _vm.stopRender } },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$G = [];
__vue_render__$G._withStripped = true;

  /* style */
  const __vue_inject_styles__$H = undefined;
  /* scoped */
  const __vue_scope_id__$H = undefined;
  /* module identifier */
  const __vue_module_identifier__$H = undefined;
  /* functional template */
  const __vue_is_functional_template__$H = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$H = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$G, staticRenderFns: __vue_staticRenderFns__$G },
    __vue_inject_styles__$H,
    __vue_script__$H,
    __vue_scope_id__$H,
    __vue_is_functional_template__$H,
    __vue_module_identifier__$H,
    false,
    undefined,
    undefined,
    undefined
  );

var script$I = {
  name: 'TfPopover',
  extends: Popover,
  props: {
    borderColor: {
      type: String,
      default: null
    },
    closeOnOutsideClick: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      element: null
    };
  },
  watch: {
    /**
     * Add/remove event listeners depending on the state of the popper
     *
     * @param {boolean} newVal
     * @param {boolean} oldVal
     */
    showPopper: function showPopper(newVal, oldVal) {
      var _this = this;
      // store popper DOM element reference
      if (!this.element) {
        this.element = this.$refs.popper;
      }
      if (this.closeOnOutsideClick) {
        if (newVal) {
          document.addEventListener('click', this.outsideClickListener);
        } else {
          this.removeClickListener();
        }
      }
      if (this.borderColor) {
        this.element.style.borderColor = newVal ? this.borderColor : null;
      }

      // Focus on the tool when opening the popover.
      if (!oldVal) {
        this.$nextTick(function () {
          _this.element.focus();
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeClickListener();
  },
  methods: {
    /**
     * close the popover if someone clicks outside of it
     *
     * @param {event} event
     */
    outsideClickListener: function outsideClickListener(event) {
      if (!this.element.contains(event.target) && this.showPopper) {
        this.removeClickListener();
        this.doClose();
      }
    },
    /**
     * remove the click listener when this is destroyed
     */
    removeClickListener: function removeClickListener() {
      document.removeEventListener('click', this.outsideClickListener);
    }
  }
};

/* script */
const __vue_script__$I = script$I;

/* template */

  /* style */
  const __vue_inject_styles__$I = undefined;
  /* scoped */
  const __vue_scope_id__$I = undefined;
  /* module identifier */
  const __vue_module_identifier__$I = undefined;
  /* functional template */
  const __vue_is_functional_template__$I = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$I = /*#__PURE__*/normalizeComponent_1(
    {},
    __vue_inject_styles__$I,
    __vue_script__$I,
    __vue_scope_id__$I,
    __vue_is_functional_template__$I,
    __vue_module_identifier__$I,
    false,
    undefined,
    undefined,
    undefined
  );

var $at$1 = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at$1(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _redefineAll = function (target, src, safe) {
  for (var key in src) _redefine(target, key, src[key], safe);
  return target;
};

var _anInstance = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

// call something on iterator step with safe closing on error

var _iterCall$1 = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$6 = _wks('iterator');
var ArrayProto$2 = Array.prototype;

var _isArrayIter$1 = function (it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto$2[ITERATOR$6] === it);
};

var ITERATOR$7 = _wks('iterator');

var core_getIteratorMethod$1 = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$7]
    || it['@@iterator']
    || _iterators[_classof(it)];
};

var _forOf = createCommonjsModule(function (module) {
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod$1(iterable);
  var f = _ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (_isArrayIter$1(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
    result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = _iterCall$1(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;
});

var SPECIES$3 = _wks('species');

var _setSpecies = function (KEY) {
  var C = _global[KEY];
  if (_descriptors && C && !C[SPECIES$3]) _objectDp.f(C, SPECIES$3, {
    configurable: true,
    get: function () { return this; }
  });
};

var _meta$1 = createCommonjsModule(function (module) {
var META = _uid('meta');


var setDesc = _objectDp.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1$1 = _meta$1.KEY;
var _meta_2$1 = _meta$1.NEED;
var _meta_3$1 = _meta$1.fastKey;
var _meta_4$1 = _meta$1.getWeak;
var _meta_5$1 = _meta$1.onFreeze;

var _validateCollection = function (it, TYPE) {
  if (!_isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

var dP$5 = _objectDp.f;









var fastKey = _meta$1.fastKey;

var SIZE = _descriptors ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

var _collectionStrong = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      _anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = _objectCreate(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
    });
    _redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = _validateCollection(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = _validateCollection(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        _validateCollection(this, NAME);
        var f = _ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(_validateCollection(this, NAME), key);
      }
    });
    if (_descriptors) dP$5(C.prototype, 'size', {
      get: function () {
        return _validateCollection(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    _iterDefine(C, NAME, function (iterated, kind) {
      this._t = _validateCollection(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return _iterStep(1);
      }
      // return step by kind
      if (kind == 'keys') return _iterStep(0, entry.k);
      if (kind == 'values') return _iterStep(0, entry.v);
      return _iterStep(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    _setSpecies(NAME);
  }
};

var ITERATOR$8 = _wks('iterator');
var SAFE_CLOSING$1 = false;

try {
  var riter$1 = [7][ITERATOR$8]();
  riter$1['return'] = function () { SAFE_CLOSING$1 = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter$1, function () { throw 2; });
} catch (e) { /* empty */ }

var _iterDetect$1 = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING$1) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$8]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$8] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

var _collection = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = _global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    _redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !_isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !_fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    _redefineAll(C.prototype, methods);
    _meta$1.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = _fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = _iterDetect$1(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && _fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        _anInstance(target, C, NAME);
        var that = _inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  _setToStringTag(C, NAME);

  O[NAME] = C;
  _export(_export.G + _export.W + _export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

var SET = 'Set';

// 23.2 Set Objects
var es6_set = _collection(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return _collectionStrong.def(_validateCollection(this, SET), value = value === 0 ? 0 : value, value);
  }
}, _collectionStrong);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The "Product Options" for the Project Product Product selector.
 *
 * @vuedoc
 * @exports ProductSelector/ProductOption
 * @category Components
 */
var script$J = {
  name: 'TfProductOption',
  inject: ['TfProductSelector', 'productType'],
  props: {
    isParentLevel: {
      type: Boolean,
      default: true
    },
    product: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      hover: false
    };
  },
  computed: {
    /**
     * Determines if the product options is selected.
     *
     * @returns {boolean}
     */
    isActive: function isActive() {
      return this.TfProductSelector.value.includes(this.product.id);
    },
    /**
     * If productSelector is themed, set corresponding CSS colors
     *
     * @returns {object }
     */
    inlineStyle: function inlineStyle() {
      var style = {};
      if (this.TfProductSelector.themePrimaryColor) {
        if (this.isActive) {
          style.backgroundColor = this.TfProductSelector.themePrimaryColor;
        }
      }
      if (this.TfProductSelector.themeHoverColor && !this.isActive && this.hover) {
        style.backgroundColor = this.TfProductSelector.themeHoverColor;
        style.color = this.TfProductSelector.themePrimaryColor;
      }
      return style;
    },
    /**
     * Determines if the product options is disabled.
     *
     * @returns {boolean}
     */
    isDisabled: function isDisabled() {
      return this.TfProductSelector.disabledProducts.includes(this.product.id);
    }
  },
  methods: {
    /**
     * Emits the appropriate inject/emit types and payload.
     *
     * @param {string} type
     * @param {string} emit
     * @param {object} payload
     */
    emitPayload: function emitPayload(type, emit, payload) {
      this[type].$emit(emit, payload);
    },
    /**
     * Adds or removed the product ID and emits from the root TfProductSelector component.
     *
     */
    onClick: function onClick() {
      var _this = this;
      if (this.isDisabled) {
        return;
      }
      if (!this.TfProductSelector.allowMultiple && this.isActive) {
        this.emitPayload('productType', 'hidePopover');
        return;
      }
      var oldValue = _toConsumableArray(this.TfProductSelector.value);
      var productId = this.product.id;
      var action;
      var selectedProductIds = this.TfProductSelector.allowMultiple ? this.TfProductSelector.value : [];
      if (selectedProductIds.includes(productId)) {
        this.$delete(selectedProductIds, selectedProductIds.findIndex(function (id) {
          return id === productId;
        }));
        action = 'deleted';
      } else {
        action = this.TfProductSelector.allowMultiple ? 'added' : 'changed';
        selectedProductIds.push(productId);
      }
      selectedProductIds = this.$TF.Formatting.sortObjects(selectedProductIds.map(function (id) {
        return _this.TfProductSelector.products.find(function (product) {
          return product.id === id;
        });
      }), 'position').map(function (product) {
        return product.id;
      });

      // Emits for all the changes
      this.emitPayload('TfProductSelector', 'input', selectedProductIds);
      this.emitPayload('TfProductSelector', 'change', {
        oldValue: oldValue,
        value: selectedProductIds
      });
      this.emitPayload('TfProductSelector', 'selectProductOption', {
        action: action,
        productId: productId,
        selectedProductIds: selectedProductIds
      });
      if (!this.TfProductSelector.allowMultiple) {
        this.emitPayload('productType', 'hidePopover');
      }
    }
  }
};

/* script */
const __vue_script__$J = script$J;

/* template */
var __vue_render__$H = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      class: [
        { "is-multiple": _vm.TfProductSelector.allowMultiple },
        { "is-active": _vm.isActive },
        { "is-disabled": _vm.isDisabled },
        { "is-parent-level": _vm.isParentLevel },
        "btn-product-option",
      ],
      style: _vm.inlineStyle,
      attrs: { "data-test": "select " + _vm.product.label },
      on: {
        mouseover: function ($event) {
          _vm.hover = true;
        },
        mouseout: function ($event) {
          _vm.hover = false;
        },
        click: _vm.onClick,
      },
    },
    [
      _vm._v("\n  " + _vm._s(_vm.product.label) + "\n  "),
      _vm._t("productOptionAppend", null, { product: _vm.product }),
    ],
    2
  )
};
var __vue_staticRenderFns__$H = [];
__vue_render__$H._withStripped = true;

  /* style */
  const __vue_inject_styles__$J = function (inject) {
    if (!inject) return
    inject("data-v-5d16f47c_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.btn-product-option[data-v-5d16f47c] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 10px 15px 10px 30px;\n  font-size: 14px;\n  border: none;\n  border-bottom: 1px solid #efefef;\n  background: #fafafa;\n  cursor: pointer;\n}\n.btn-product-option.is-active[data-v-5d16f47c] {\n  color: #fff;\n  background: #009;\n}\n.btn-product-option.is-active[data-v-5d16f47c], .btn-product-option.is-active[data-v-5d16f47c]:not(.is-disabled) {\n  cursor: default;\n}\n.btn-product-option.is-active.is-multiple[data-v-5d16f47c] {\n  cursor: pointer;\n}\n.btn-product-option.is-disabled[data-v-5d16f47c] {\n  color: #c1c1c1;\n  cursor: not-allowed;\n}\n.btn-product-option[data-v-5d16f47c]:not(.is-parent-level) {\n  padding-left: 30px;\n}\n\n/*# sourceMappingURL=ProductOption.vue.map */", map: {"version":3,"sources":["ProductOption.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfProductSelector/ProductOption.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC+KlC;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,4BAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;AD7KA;AC+KA;EACA,WAAA;EACA,gBAAA;AD7KA;AC+KA;EAEA,eAAA;AD9KA;ACiLA;EACA,eAAA;AD/KA;ACmLA;EACA,cAAA;EACA,mBAAA;ADjLA;ACoLA;EACA,kBAAA;ADlLA;;AAEA,4CAA4C","file":"ProductOption.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.btn-product-option {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 10px 15px 10px 30px;\n  font-size: 14px;\n  border: none;\n  border-bottom: 1px solid #efefef;\n  background: #fafafa;\n  cursor: pointer;\n}\n.btn-product-option.is-active {\n  color: #fff;\n  background: #009;\n}\n.btn-product-option.is-active, .btn-product-option.is-active:not(.is-disabled) {\n  cursor: default;\n}\n.btn-product-option.is-active.is-multiple {\n  cursor: pointer;\n}\n.btn-product-option.is-disabled {\n  color: #c1c1c1;\n  cursor: not-allowed;\n}\n.btn-product-option:not(.is-parent-level) {\n  padding-left: 30px;\n}\n\n/*# sourceMappingURL=ProductOption.vue.map */","<template>\n  <button\n    :class=\"[\n      { 'is-multiple': TfProductSelector.allowMultiple },\n      { 'is-active': isActive },\n      { 'is-disabled': isDisabled },\n      { 'is-parent-level': isParentLevel },\n      'btn-product-option'\n    ]\"\n    :data-test=\"`select ${product.label}`\"\n    :style=\"inlineStyle\"\n    @mouseover=\"hover = true\"\n    @mouseout=\"hover = false\"\n    @click=\"onClick\"\n  >\n    {{ product.label }}\n    <slot\n      name=\"productOptionAppend\"\n      :product=\"product\"\n    />\n  </button>\n</template>\n\n<script>\n/**\n * The \"Product Options\" for the Project Product Product selector.\n *\n * @vuedoc\n * @exports ProductSelector/ProductOption\n * @category Components\n */\n  export default {\n    name: 'TfProductOption',\n    inject: [\n      'TfProductSelector',\n      'productType',\n    ],\n    props: {\n      isParentLevel: {\n        type: Boolean,\n        default: true,\n      },\n      product: {\n        type: Object,\n        required: true,\n        default: () => ({}),\n      },\n    },\n    data: () => ({\n      hover: false,\n    }),\n    computed: {\n      /**\n       * Determines if the product options is selected.\n       *\n       * @returns {boolean}\n       */\n      isActive() {\n        return this.TfProductSelector.value.includes(this.product.id);\n      },\n      /**\n       * If productSelector is themed, set corresponding CSS colors\n       *\n       * @returns {object }\n       */\n      inlineStyle() {\n        const style = {};\n\n        if (this.TfProductSelector.themePrimaryColor) {\n          if (this.isActive) {\n            style.backgroundColor = this.TfProductSelector.themePrimaryColor;\n          }\n        }\n\n        if (this.TfProductSelector.themeHoverColor && !this.isActive && this.hover) {\n          style.backgroundColor = this.TfProductSelector.themeHoverColor;\n          style.color = this.TfProductSelector.themePrimaryColor;\n        }\n\n        return style;\n      },\n      /**\n       * Determines if the product options is disabled.\n       *\n       * @returns {boolean}\n       */\n      isDisabled() {\n        return this.TfProductSelector.disabledProducts.includes(this.product.id);\n      },\n    },\n    methods: {\n      /**\n       * Emits the appropriate inject/emit types and payload.\n       *\n       * @param {string} type\n       * @param {string} emit\n       * @param {object} payload\n       */\n      emitPayload(type, emit, payload) {\n        this[type].$emit(emit, payload);\n      },\n      /**\n       * Adds or removed the product ID and emits from the root TfProductSelector component.\n       *\n       */\n      onClick() {\n        if (this.isDisabled) {\n          return;\n        }\n\n        if (!this.TfProductSelector.allowMultiple && this.isActive) {\n          this.emitPayload('productType', 'hidePopover');\n          return;\n        }\n\n        const oldValue = [...this.TfProductSelector.value];\n        const productId = this.product.id;\n        let action;\n        let selectedProductIds = this.TfProductSelector.allowMultiple\n          ? this.TfProductSelector.value\n          : [];\n\n        if (selectedProductIds.includes(productId)) {\n          this.$delete(\n            selectedProductIds,\n            selectedProductIds.findIndex((id) => id === productId),\n          );\n          action = 'deleted';\n        } else {\n          action = this.TfProductSelector.allowMultiple ? 'added' : 'changed';\n          selectedProductIds.push(productId);\n        }\n\n        selectedProductIds = this.$TF.Formatting\n          .sortObjects(\n            selectedProductIds.map(\n              (id) => this.TfProductSelector.products.find((product) => product.id === id),\n            ),\n            'position',\n          )\n          .map((product) => product.id);\n\n        // Emits for all the changes\n        this.emitPayload(\n          'TfProductSelector',\n          'input',\n          selectedProductIds,\n        );\n        this.emitPayload(\n          'TfProductSelector',\n          'change',\n          {\n            oldValue,\n            value: selectedProductIds,\n          },\n        );\n        this.emitPayload(\n          'TfProductSelector',\n          'selectProductOption',\n          {\n            action,\n            productId,\n            selectedProductIds,\n          },\n        );\n\n        if (!this.TfProductSelector.allowMultiple) {\n          this.emitPayload('productType', 'hidePopover');\n        }\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .btn-product-option {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 10px 15px 10px 30px;\n    font-size: 14px;\n    border: none;\n    border-bottom: 1px solid $tf-extra-light-gray-1;\n    background: $tf-extra-light-gray-2;\n    cursor: pointer;\n\n    &.is-active {\n      color: $tf-white;\n      background: $tf-blue;\n\n      &,\n      &:not(.is-disabled) {\n        cursor: default;\n      }\n\n      &.is-multiple {\n        cursor: pointer;\n      }\n    }\n\n    &.is-disabled {\n      color: $tf-light-gray;\n      cursor: not-allowed;\n    }\n\n    &:not(.is-parent-level) {\n      padding-left: 30px;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$J = "data-v-5d16f47c";
  /* module identifier */
  const __vue_module_identifier__$J = undefined;
  /* functional template */
  const __vue_is_functional_template__$J = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$J = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$H, staticRenderFns: __vue_staticRenderFns__$H },
    __vue_inject_styles__$J,
    __vue_script__$J,
    __vue_scope_id__$J,
    __vue_is_functional_template__$J,
    __vue_module_identifier__$J,
    false,
    browser,
    undefined,
    undefined
  );

/**
 * The "Product Types" for the Project Product Product selector.
 *
 * @vuedoc
 * @exports ProductSelector/TfProductType
 * @category Components
 */
var script$K = {
  name: 'TfProductType',
  components: {
    ProductOption: __vue_component__$J
  },
  inject: ['TfProductSelector'],
  provide: function provide() {
    return {
      productType: this
    };
  },
  props: {
    productType: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          id: 0,
          name: null,
          products: []
        };
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data(vm) {
    return {
      hover: false,
      openProductTypeIds: vm.value
    };
  },
  computed: {
    /**
     * Determines if the product type is expanded.
     *
     * @returns {boolean}
     */
    isActive: function isActive() {
      return this.openProductTypeIds.includes(this.productType.id);
    },
    /**
     * Determine if the product should be in a child of a product type
     * based on the product label and product count.
     *
     * @returns {boolean}
     */
    isParentLevel: function isParentLevel() {
      var firstProduct = this.productType.products[0];
      return this.productType.products.length === 1 && firstProduct.label === firstProduct.product_type_name;
    }
  },
  methods: {
    /**
     * Emits the updated model and emits "toggleProductType" from the TfProductSelector component.
     *
     */
    toggleProductType: function toggleProductType() {
      this.$emit('input', this.openProductTypeIds);
      this.TfProductSelector.$emit('toggleProductType', {
        action: this.openProductTypeIds.includes(this.productType.id) ? 'expand' : 'collapse',
        productTypeId: this.productType.id,
        openProductTypeIds: this.openProductTypeIds
      });
    }
  }
};

/* script */
const __vue_script__$K = script$K;

/* template */
var __vue_render__$I = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ElCollapse",
    {
      on: { change: _vm.toggleProductType },
      model: {
        value: _vm.openProductTypeIds,
        callback: function ($$v) {
          _vm.openProductTypeIds = $$v;
        },
        expression: "openProductTypeIds",
      },
    },
    [
      !_vm.isParentLevel
        ? _c(
            "ElCollapseItem",
            {
              staticClass: "product-type-container",
              attrs: { name: _vm.productType.id },
            },
            [
              _c(
                "span",
                {
                  staticClass: "product-type-title-container",
                  style: {
                    backgroundColor:
                      _vm.TfProductSelector.themeHoverColor && _vm.hover
                        ? _vm.TfProductSelector.themeHoverColor
                        : null,
                  },
                  attrs: {
                    slot: "title",
                    "data-test":
                      "expand " +
                      (_vm.productType.name ? _vm.productType.name + " " : "") +
                      "products",
                  },
                  on: {
                    mouseover: function ($event) {
                      _vm.hover = true;
                    },
                    mouseout: function ($event) {
                      _vm.hover = false;
                    },
                  },
                  slot: "title",
                },
                [
                  _c(
                    "span",
                    { staticClass: "product-type-title" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.productType.name) +
                          "\n        "
                      ),
                      _vm._t("productTypeAppend", null, {
                        productType: _vm.productType,
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("icon", {
                    class: [
                      { "is-active": _vm.isActive },
                      "product-type-toggle",
                    ],
                    style: {
                      fill:
                        _vm.isActive && _vm.TfProductSelector.themePrimaryColor
                          ? _vm.TfProductSelector.themePrimaryColor
                          : null,
                    },
                    attrs: { name: "chevron-down" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.productType.products, function (productObj, index) {
                return _c("ProductOption", {
                  key: "product-" + productObj.label,
                  attrs: {
                    product: productObj,
                    "is-disabled": index
                      ? _vm.productType.products[0].state !== "complete"
                      : false,
                    "is-parent-level": false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "productOptionAppend",
                        fn: function (optionAppendProps) {
                          return [
                            _vm._t(
                              "productOptionAppend",
                              null,
                              null,
                              optionAppendProps
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          )
        : _c("ProductOption", {
            attrs: {
              product: _vm.productType.products[0],
              "is-parent-level": true,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "productOptionAppend",
                  fn: function (optionAppendProps) {
                    return [
                      _vm._t(
                        "productOptionAppend",
                        null,
                        null,
                        optionAppendProps
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
    ],
    1
  )
};
var __vue_staticRenderFns__$I = [];
__vue_render__$I._withStripped = true;

  /* style */
  const __vue_inject_styles__$K = function (inject) {
    if (!inject) return
    inject("data-v-5575f766_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.product-type-title[data-v-5575f766] {\n  display: flex;\n  font-weight: 600;\n}\n.product-type-title-container[data-v-5575f766] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 8px 15px;\n  font-size: 16px;\n  border-bottom: 1px solid #efefef;\n  cursor: pointer;\n}\n.product-type-title-container[data-v-5575f766]:hover {\n  background: #eff3fd;\n}\n.product-type-toggle[data-v-5575f766] {\n  height: 18px;\n  width: 16px;\n  margin-top: 3px;\n  fill: #42474c;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n}\n.product-type-toggle.is-active[data-v-5575f766] {\n  fill: #009;\n  transform: rotateZ(180deg);\n}\n\n/*# sourceMappingURL=ProductType.vue.map */", map: {"version":3,"sources":["ProductType.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfProductSelector/ProductType.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACoKlC;EACA,aAAA;EACA,gBAAA;ADlKA;ACqKA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;ADnKA;ACqKA;EACA,mBAAA;ADnKA;ACuKA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,0BAAA;EACA,qBAAA;ADrKA;ACuKA;EACA,UAAA;EACA,0BAAA;ADrKA;;AAEA,0CAA0C","file":"ProductType.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.product-type-title {\n  display: flex;\n  font-weight: 600;\n}\n.product-type-title-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 8px 15px;\n  font-size: 16px;\n  border-bottom: 1px solid #efefef;\n  cursor: pointer;\n}\n.product-type-title-container:hover {\n  background: #eff3fd;\n}\n.product-type-toggle {\n  height: 18px;\n  width: 16px;\n  margin-top: 3px;\n  fill: #42474c;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n}\n.product-type-toggle.is-active {\n  fill: #009;\n  transform: rotateZ(180deg);\n}\n\n/*# sourceMappingURL=ProductType.vue.map */","<template>\n  <ElCollapse\n    v-model=\"openProductTypeIds\"\n    @change=\"toggleProductType\"\n  >\n    <ElCollapseItem\n      v-if=\"!isParentLevel\"\n      class=\"product-type-container\"\n      :name=\"productType.id\"\n    >\n      <span\n        slot=\"title\"\n        class=\"product-type-title-container\"\n        :style=\"{\n          backgroundColor: TfProductSelector.themeHoverColor\n            && hover\n            ? TfProductSelector.themeHoverColor\n            : null\n        }\"\n        :data-test=\"`expand ${productType.name ? `${productType.name} ` : ''}products`\"\n        @mouseover=\"hover = true\"\n        @mouseout=\"hover = false\"\n      >\n        <span class=\"product-type-title\">\n          {{ productType.name }}\n          <slot\n            name=\"productTypeAppend\"\n            :product-type=\"productType\"\n          />\n        </span>\n        <icon\n          :class=\"[\n            { 'is-active': isActive },\n            'product-type-toggle'\n          ]\"\n          :style=\"{\n            fill: isActive && TfProductSelector.themePrimaryColor\n              ? TfProductSelector.themePrimaryColor\n              : null\n          }\"\n          name=\"chevron-down\"\n        />\n      </span>\n      <ProductOption\n        v-for=\"(productObj, index) in productType.products\"\n        :key=\"`product-${productObj.label}`\"\n        :product=\"productObj\"\n        :is-disabled=\"index ? productType.products[0].state !== 'complete' : false\"\n        :is-parent-level=\"false\"\n      >\n        <!-- Used to control appended icons in component using <TfProductSelector /> -->\n        <template\n          slot=\"productOptionAppend\"\n          slot-scope=\"optionAppendProps\"\n        >\n          <slot\n            name=\"productOptionAppend\"\n            v-bind=\"optionAppendProps\"\n          />\n        </template>\n      </ProductOption>\n    </ElCollapseItem>\n    <ProductOption\n      v-else\n      :product=\"productType.products[0]\"\n      :is-parent-level=\"true\"\n    >\n      <!-- Used to control appended icons in component using <TfProductSelector /> -->\n      <template\n        slot=\"productOptionAppend\"\n        slot-scope=\"optionAppendProps\"\n      >\n        <slot\n          name=\"productOptionAppend\"\n          v-bind=\"optionAppendProps\"\n        />\n      </template>\n    </ProductOption>\n  </ElCollapse>\n</template>\n\n<script>\n  import ProductOption from './ProductOption';\n\n  /**\n   * The \"Product Types\" for the Project Product Product selector.\n   *\n   * @vuedoc\n   * @exports ProductSelector/TfProductType\n   * @category Components\n   */\n  export default {\n    name: 'TfProductType',\n    components: { ProductOption },\n    inject: [\n      'TfProductSelector',\n    ],\n    provide() {\n      return {\n        productType: this,\n      };\n    },\n    props: {\n      productType: {\n        type: Object,\n        required: true,\n        default: () => ({\n          id: 0,\n          name: null,\n          products: [],\n        }),\n      },\n      value: {\n        type: Array,\n        default: () => ([]),\n      },\n    },\n    data: (vm) => ({\n      hover: false,\n      openProductTypeIds: vm.value,\n    }),\n    computed: {\n      /**\n       * Determines if the product type is expanded.\n       *\n       * @returns {boolean}\n       */\n      isActive() {\n        return this.openProductTypeIds.includes(this.productType.id);\n      },\n      /**\n       * Determine if the product should be in a child of a product type\n       * based on the product label and product count.\n       *\n       * @returns {boolean}\n       */\n      isParentLevel() {\n        const firstProduct = this.productType.products[0];\n\n        return this.productType.products.length === 1\n          && firstProduct.label === firstProduct.product_type_name;\n      },\n    },\n    methods: {\n      /**\n       * Emits the updated model and emits \"toggleProductType\" from the TfProductSelector component.\n       *\n       */\n      toggleProductType() {\n        this.$emit('input', this.openProductTypeIds);\n        this.TfProductSelector.$emit('toggleProductType', {\n          action: this.openProductTypeIds.includes(this.productType.id)\n            ? 'expand'\n            : 'collapse',\n          productTypeId: this.productType.id,\n          openProductTypeIds: this.openProductTypeIds,\n        });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .product-type {\n    &-title {\n      display: flex;\n      font-weight: 600;\n    }\n\n    &-title-container {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      padding: 8px 15px;\n      font-size: 16px;\n      border-bottom: 1px solid $tf-extra-light-gray-1;\n      cursor: pointer;\n\n      &:hover {\n        background: $tf-light-blue;\n      }\n    }\n\n    &-toggle {\n      height: 18px;\n      width: 16px;\n      margin-top: 3px;\n      fill: $tf-dark-gray;\n      transition: transform .3s;\n      transform: rotateZ(0);\n\n      &.is-active {\n        fill: $tf-blue;\n        transform: rotateZ(180deg);\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$K = "data-v-5575f766";
  /* module identifier */
  const __vue_module_identifier__$K = undefined;
  /* functional template */
  const __vue_is_functional_template__$K = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$K = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$I, staticRenderFns: __vue_staticRenderFns__$I },
    __vue_inject_styles__$K,
    __vue_script__$K,
    __vue_scope_id__$K,
    __vue_is_functional_template__$K,
    __vue_module_identifier__$K,
    false,
    browser,
    undefined,
    undefined
  );

/**
 * The Project Product Product selector for passed products.
 *
 * @vuedoc
 * @exports ProductSelector/index
 * @category Components
 */
var script$L = {
  name: 'TfProductSelector',
  components: {
    ProductType: __vue_component__$K
  },
  provide: function provide() {
    return {
      TfProductSelector: this
    };
  },
  props: {
    allowMultiple: {
      type: Boolean,
      default: false
    },
    categories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    collapsedCategories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    collapsedProductTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabledProducts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fixedToggle: {
      type: Boolean,
      default: true
    },
    inputBorderColor: {
      type: String,
      default: null
    },
    keepOpen: {
      type: Boolean,
      default: false
    },
    products: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    showCategoryTitles: {
      type: Boolean,
      default: true
    },
    showSelectedCount: {
      type: Boolean,
      default: false
    },
    themePrimaryColor: {
      type: String,
      default: null
    },
    themeHoverColor: {
      type: String,
      default: null
    },
    value: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    width: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      hoverIndex: null,
      isActive: false,
      openCategoryIds: [],
      openProductTypeIds: [],
      popperWidth: null
    };
  },
  computed: {
    /**
     * Creates an array of all the product labels or "placeholder" if nothing is selected.
     *
     * @returns {Array}
     */
    label: function label() {
      var _this = this;
      return this.value.length && this.products.length ? this.value.map(function (productId) {
        var selectedProduct = _this.products.find(function (product) {
          return product.id === productId;
        });
        if (!selectedProduct) {
          return ['No product found'];
        }
        var typeIsNotLabel = selectedProduct.product_type_name !== selectedProduct.label;
        return selectedProduct.alternative || typeIsNotLabel ? "".concat(selectedProduct.product_type_name, ", ").concat(selectedProduct.label) : selectedProduct.label;
      }) : ['Select a Product'];
    },
    /**
     * Creates an object of all the products types with their products as children.
     *
     * @returns {object}
     */
    productsByTypeTree: function productsByTypeTree() {
      var productTypes = {};
      var productTypeId = 'product_type_id';
      this.products.forEach(function (product) {
        if (!productTypes[product[productTypeId]]) {
          productTypes[product[productTypeId]] = {
            id: product[productTypeId],
            name: product.product_type_name,
            products: []
          };
        }
        productTypes[product[productTypeId]].products.push(product);
      });
      return productTypes;
    },
    /**
     * Creates an array of categories if no category is provided.
     *
     * @returns {Array}
     */
    productTypesByCategory: function productTypesByCategory() {
      return this.categories.length ? this.categories : [{
        id: 1,
        label: 'All Products',
        productTypeIds: _toConsumableArray(new Set(this.products.map(function (product) {
          return product.product_type_id;
        }).reduce(function (array, value) {
          return array.concat(value);
        }, [])))
      }];
    }
  },
  watch: {
    /**
     * Watch changes on productsByTypeTree and call expandAll
     */
    productsByTypeTree: function productsByTypeTree() {
      this.expandAll();
    }
  },
  mounted: function mounted() {
    this.popperWidth = (this.width || this.$refs.productSelectorContainer.clientWidth) - 2;
    this.expandAll();
  },
  methods: {
    /**
     * Go through all of the product types by category and the child product type IDs.
     * Push to the respective "openCategoryIds" and "openProductTypeIds" arrays
     * depending if the are included in
     * the "collapsedCategories" and "collapsedProductTypes" props .
     */
    expandAll: function expandAll() {
      var _this2 = this;
      this.productTypesByCategory.forEach(function (category, index) {
        if (!_this2.collapsedCategories.includes(index)) {
          _this2.openCategoryIds.push(index);
        }
        category.productTypeIds.forEach(function (productTypeId) {
          if (!_this2.collapsedProductTypes.includes(productTypeId)) {
            _this2.openProductTypeIds.push(productTypeId);
          }
        });
      });
    },
    /**
     * Hiding the popover when clicking outside <TfPopover>
     */
    hidePopover: function hidePopover() {
      if (this.keepOpen) {
        return;
      }
      this.isActive = false;
    },
    /**
     * Emits the category ID and the openCategoryIds array.
     *
     * @param {number} categoryIndex
     */
    toggleCategory: function toggleCategory(categoryIndex) {
      this.$emit('toggleCategory', {
        action: this.openCategoryIds.includes(categoryIndex) ? 'expand' : 'collapse',
        categoryIndex: categoryIndex,
        openCategoryIds: this.openCategoryIds
      });
    }
  }
};

/* script */
const __vue_script__$L = script$L;

/* template */
var __vue_render__$J = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "productSelectorContainer" },
    [
      _c(
        "TfPopover",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.hidePopover,
              expression: "hidePopover",
            },
          ],
          attrs: {
            width: _vm.popperWidth,
            "visible-arrow": false,
            "border-color": _vm.themePrimaryColor || null,
            "popper-class": "product-select-popover",
            placement: "bottom-start",
            trigger: "manual",
          },
          model: {
            value: _vm.isActive,
            callback: function ($$v) {
              _vm.isActive = $$v;
            },
            expression: "isActive",
          },
        },
        [
          _c(
            "span",
            {
              class: [{ "is-active": _vm.isActive }, "product-selector-input"],
              style: { borderColor: _vm.inputBorderColor || null },
              attrs: { slot: "reference" },
              on: {
                click: function ($event) {
                  _vm.isActive = !_vm.isActive;
                },
              },
              slot: "reference",
            },
            [
              _c("span", {
                staticClass: "product-selector-label",
                attrs: { "data-test": "selected product" },
                domProps: { textContent: _vm._s(_vm.label.join("; ")) },
              }),
              _vm._v(" "),
              _vm.showSelectedCount
                ? _c("span", {
                    staticClass: "product-selector-counter",
                    domProps: {
                      textContent: _vm._s("(" + _vm.value.length + ")"),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  class: [
                    { "is-fixed": _vm.fixedToggle },
                    "product-selector-toggle",
                  ],
                },
                [
                  _c("icon", {
                    class: { "is-active": _vm.isActive },
                    style: {
                      fill: _vm.isActive ? _vm.themePrimaryColor : null,
                    },
                    attrs: { name: "caret-down" },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.productTypesByCategory, function (category, index) {
            return _c(
              "ElCollapse",
              {
                key: "category-" + index,
                on: {
                  change: function ($event) {
                    return _vm.toggleCategory(index)
                  },
                },
                model: {
                  value: _vm.openCategoryIds,
                  callback: function ($$v) {
                    _vm.openCategoryIds = $$v;
                  },
                  expression: "openCategoryIds",
                },
              },
              [
                _c(
                  "ElCollapseItem",
                  { staticClass: "container-category", attrs: { name: index } },
                  [
                    _vm.showCategoryTitles
                      ? _c(
                          "span",
                          {
                            staticClass: "title-category",
                            style: {
                              color:
                                _vm.openCategoryIds.includes(index) &&
                                _vm.themePrimaryColor
                                  ? _vm.themePrimaryColor
                                  : null,
                              backgroundColor:
                                _vm.hoverIndex === index && _vm.themeHoverColor
                                  ? _vm.themeHoverColor
                                  : null,
                            },
                            attrs: { slot: "title" },
                            on: {
                              mouseover: function ($event) {
                                _vm.hoverIndex = index;
                              },
                              mouseout: function ($event) {
                                _vm.hoverIndex = null;
                              },
                            },
                            slot: "title",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(category.label) +
                                "\n          "
                            ),
                            _c("icon", {
                              class: [
                                {
                                  "is-active":
                                    _vm.openCategoryIds.includes(index),
                                },
                                "category-toggle",
                              ],
                              style: {
                                fill:
                                  _vm.openCategoryIds.includes(index) &&
                                  _vm.themePrimaryColor
                                    ? _vm.themePrimaryColor
                                    : null,
                              },
                              attrs: { name: "chevron-down" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(category.productTypeIds, function (productTypeId) {
                      return _c("ProductType", {
                        key: "product-type-" + productTypeId,
                        attrs: {
                          "product-type": _vm.productsByTypeTree[productTypeId],
                        },
                        on: { hidePopover: _vm.hidePopover },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "productOptionAppend",
                              fn: function (product) {
                                return [
                                  _vm._t("productOptionAppend", null, {
                                    product: product.product,
                                  }),
                                ]
                              },
                            },
                            {
                              key: "productTypeAppend",
                              fn: function (productTypeData) {
                                return [
                                  _vm._t("productTypeAppend", null, {
                                    productType: productTypeData.productType,
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.openProductTypeIds,
                          callback: function ($$v) {
                            _vm.openProductTypeIds = $$v;
                          },
                          expression: "openProductTypeIds",
                        },
                      })
                    }),
                  ],
                  2
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$J = [];
__vue_render__$J._withStripped = true;

  /* style */
  const __vue_inject_styles__$L = function (inject) {
    if (!inject) return
    inject("data-v-04439132_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.category-toggle[data-v-04439132] {\n  height: 18px;\n  width: 16px;\n  margin-top: 3px;\n  fill: #42474c;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n}\n.category-toggle.is-active[data-v-04439132] {\n  fill: #009;\n  transform: rotateZ(180deg);\n}\n.el-collapse-item__header.is-active .title-category[data-v-04439132] {\n  color: #009;\n}\n.title-category[data-v-04439132] {\n  display: flex;\n  justify-content: space-between;\n  padding: 9px 15px;\n  border-bottom: 1px solid #efefef;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.title-category svg[data-v-04439132] {\n  transform: rotateZ(0);\n}\n.container-category.is-active .title-category svg[data-v-04439132] {\n  transition: transform 0.3s;\n  transform: rotateZ(180deg);\n}\n.product-selector-counter[data-v-04439132] {\n  margin: 0 5px;\n}\n.product-selector-toggle[data-v-04439132] {\n  display: flex;\n  flex-basis: 18px;\n  flex-shrink: 0;\n  justify-content: flex-end;\n}\n.product-selector-toggle svg[data-v-04439132] {\n  fill: #999;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n  height: 20px;\n  width: 12px;\n}\n.product-selector-toggle svg.is-active[data-v-04439132] {\n  fill: #009;\n  transform: rotateZ(180deg);\n}\n.product-selector-toggle.is-fixed[data-v-04439132] {\n  margin-left: auto;\n}\n.product-selector-input[data-v-04439132] {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 5px 10px;\n  font-size: 14px;\n  border: 1px solid #c1c1c1;\n  border-radius: 4px;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n.product-selector-input.is-active[data-v-04439132] {\n  border-color: #009;\n}\n.product-selector-input[data-v-04439132]:focus {\n  outline: none;\n}\n.product-selector-label[data-v-04439132] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.el-collapse-item__wrap[data-v-04439132] {\n  padding-left: 15px;\n}\n\n/*# sourceMappingURL=index.vue.map */", map: {"version":3,"sources":["index.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfProductSelector/index.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACsUlC;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,0BAAA;EACA,qBAAA;ADpUA;ACsUA;EACA,UAAA;EACA,0BAAA;ADpUA;ACyUA;EACA,WAAA;ADtUA;AC0UA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,gCAAA;EAGA,eAAA;EACA,gBAAA;EAGA,eAAA;AD3UA;AC6UA;EAMA,qBAAA;ADhVA;AC2UA;EACA,0BAAA;EACA,0BAAA;ADzUA;ACiVA;EACA,aAAA;AD9UA;ACiVA;EACA,aAAA;EAEA,gBAAA;EACA,cAAA;EAEA,yBAAA;ADjVA;ACmVA;EACA,UAAA;EACA,0BAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;ADjVA;ACmVA;EACA,UAAA;EACA,0BAAA;ADjVA;ACqVA;EACA,iBAAA;ADnVA;ACuVA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;ADrVA;ACuVA;EACA,kBAAA;ADrVA;ACwVA;EACA,aAAA;ADtVA;AC0VA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ADxVA;AC4VA;EACA,kBAAA;ADzVA;;AAEA,oCAAoC","file":"index.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.category-toggle {\n  height: 18px;\n  width: 16px;\n  margin-top: 3px;\n  fill: #42474c;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n}\n.category-toggle.is-active {\n  fill: #009;\n  transform: rotateZ(180deg);\n}\n\n.el-collapse-item__header.is-active .title-category {\n  color: #009;\n}\n\n.title-category {\n  display: flex;\n  justify-content: space-between;\n  padding: 9px 15px;\n  border-bottom: 1px solid #efefef;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.title-category svg {\n  transform: rotateZ(0);\n}\n.container-category.is-active .title-category svg {\n  transition: transform 0.3s;\n  transform: rotateZ(180deg);\n}\n\n.product-selector-counter {\n  margin: 0 5px;\n}\n.product-selector-toggle {\n  display: flex;\n  flex-basis: 18px;\n  flex-shrink: 0;\n  justify-content: flex-end;\n}\n.product-selector-toggle svg {\n  fill: #999;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n  height: 20px;\n  width: 12px;\n}\n.product-selector-toggle svg.is-active {\n  fill: #009;\n  transform: rotateZ(180deg);\n}\n.product-selector-toggle.is-fixed {\n  margin-left: auto;\n}\n.product-selector-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 5px 10px;\n  font-size: 14px;\n  border: 1px solid #c1c1c1;\n  border-radius: 4px;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n.product-selector-input.is-active {\n  border-color: #009;\n}\n.product-selector-input:focus {\n  outline: none;\n}\n.product-selector-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.el-collapse-item__wrap {\n  padding-left: 15px;\n}\n\n/*# sourceMappingURL=index.vue.map */","<template>\n  <div ref=\"productSelectorContainer\">\n    <TfPopover\n      v-model=\"isActive\"\n      v-click-outside=\"hidePopover\"\n      :width=\"popperWidth\"\n      :visible-arrow=\"false\"\n      :border-color=\"themePrimaryColor || null\"\n      popper-class=\"product-select-popover\"\n      placement=\"bottom-start\"\n      trigger=\"manual\"\n    >\n      <span\n        slot=\"reference\"\n        :class=\"[{ 'is-active': isActive }, 'product-selector-input']\"\n        :style=\"{ borderColor: inputBorderColor || null }\"\n        @click=\"isActive = !isActive\"\n      >\n        <span\n          class=\"product-selector-label\"\n          data-test=\"selected product\"\n          v-text=\"label.join('; ')\"\n        />\n        <span\n          v-if=\"showSelectedCount\"\n          class=\"product-selector-counter\"\n          v-text=\"`(${value.length})`\"\n        />\n        <span\n          :class=\"[\n            { 'is-fixed': fixedToggle },\n            'product-selector-toggle',\n          ]\"\n        >\n          <icon\n            :class=\"{ 'is-active': isActive }\"\n            :style=\"{ fill: isActive ? themePrimaryColor : null }\"\n            name=\"caret-down\"\n          />\n        </span>\n      </span>\n      <ElCollapse\n        v-for=\"(category, index) in productTypesByCategory\"\n        :key=\"`category-${index}`\"\n        v-model=\"openCategoryIds\"\n        @change=\"toggleCategory(index)\"\n      >\n        <ElCollapseItem\n          class=\"container-category\"\n          :name=\"index\"\n        >\n          <span\n            v-if=\"showCategoryTitles\"\n            slot=\"title\"\n            class=\"title-category\"\n            :style=\"{\n              color: openCategoryIds.includes(index) && themePrimaryColor\n                ? themePrimaryColor\n                : null,\n              backgroundColor: hoverIndex === index && themeHoverColor\n                ? themeHoverColor\n                : null,\n            }\"\n            @mouseover=\"hoverIndex = index\"\n            @mouseout=\"hoverIndex = null\"\n          >\n            {{ category.label }}\n            <icon\n              :style=\"{\n                fill: openCategoryIds.includes(index) && themePrimaryColor\n                  ? themePrimaryColor\n                  : null,\n              }\"\n              :class=\"[\n                { 'is-active': openCategoryIds.includes(index) },\n                'category-toggle',\n              ]\"\n              name=\"chevron-down\"\n            />\n          </span>\n          <ProductType\n            v-for=\"productTypeId in category.productTypeIds\"\n            :key=\"`product-type-${productTypeId}`\"\n            v-model=\"openProductTypeIds\"\n            :product-type=\"productsByTypeTree[productTypeId]\"\n            @hidePopover=\"hidePopover\"\n          >\n            <!-- Used to control appended icons in component using <TfProductSelector /> -->\n            <template\n              slot=\"productOptionAppend\"\n              slot-scope=\"product\"\n            >\n              <slot\n                name=\"productOptionAppend\"\n                :product=\"product.product\"\n              />\n            </template>\n            <template\n              slot=\"productTypeAppend\"\n              slot-scope=\"productTypeData\"\n            >\n              <slot\n                name=\"productTypeAppend\"\n                :product-type=\"productTypeData.productType\"\n              />\n            </template>\n          </ProductType>\n        </ElCollapseItem>\n      </ElCollapse>\n    </TfPopover>\n  </div>\n</template>\n\n<script>\n  import ProductType from './ProductType';\n  /**\n   * The Project Product Product selector for passed products.\n   *\n   * @vuedoc\n   * @exports ProductSelector/index\n   * @category Components\n   */\n  export default {\n    name: 'TfProductSelector',\n    components: { ProductType },\n    provide() {\n      return {\n        TfProductSelector: this,\n      };\n    },\n    props: {\n      allowMultiple: {\n        type: Boolean,\n        default: false,\n      },\n      categories: {\n        type: Array,\n        default: () => ([]),\n      },\n      collapsedCategories: {\n        type: Array,\n        default: () => ([]),\n      },\n      collapsedProductTypes: {\n        type: Array,\n        default: () => ([]),\n      },\n      disabledProducts: {\n        type: Array,\n        default: () => ([]),\n      },\n      fixedToggle: {\n        type: Boolean,\n        default: true,\n      },\n      inputBorderColor: {\n        type: String,\n        default: null,\n      },\n      keepOpen: {\n        type: Boolean,\n        default: false,\n      },\n      products: {\n        type: Array,\n        required: true,\n        default: () => ([]),\n      },\n      showCategoryTitles: {\n        type: Boolean,\n        default: true,\n      },\n      showSelectedCount: {\n        type: Boolean,\n        default: false,\n      },\n      themePrimaryColor: {\n        type: String,\n        default: null,\n      },\n      themeHoverColor: {\n        type: String,\n        default: null,\n      },\n      value: {\n        type: Array,\n        required: true,\n        default: () => ([]),\n      },\n      width: {\n        type: Number,\n        default: null,\n      },\n    },\n    data: () => ({\n      hoverIndex: null,\n      isActive: false,\n      openCategoryIds: [],\n      openProductTypeIds: [],\n      popperWidth: null,\n    }),\n    computed: {\n      /**\n       * Creates an array of all the product labels or \"placeholder\" if nothing is selected.\n       *\n       * @returns {Array}\n       */\n      label() {\n        return this.value.length && this.products.length\n          ? this.value.map((productId) => {\n            const selectedProduct = this.products.find((product) => product.id === productId);\n\n            if (!selectedProduct) {\n              return ['No product found'];\n            }\n\n            const typeIsNotLabel = selectedProduct.product_type_name !== selectedProduct.label;\n\n            return selectedProduct.alternative || typeIsNotLabel\n              ? `${selectedProduct.product_type_name}, ${selectedProduct.label}`\n              : selectedProduct.label;\n          })\n          : ['Select a Product'];\n      },\n      /**\n       * Creates an object of all the products types with their products as children.\n       *\n       * @returns {object}\n       */\n      productsByTypeTree() {\n        const productTypes = {};\n        const productTypeId = 'product_type_id';\n\n        this.products.forEach((product) => {\n          if (!productTypes[product[productTypeId]]) {\n            productTypes[product[productTypeId]] = {\n              id: product[productTypeId],\n              name: product.product_type_name,\n              products: [],\n            };\n          }\n\n          productTypes[product[productTypeId]].products.push(product);\n        });\n\n        return productTypes;\n      },\n      /**\n       * Creates an array of categories if no category is provided.\n       *\n       * @returns {Array}\n       */\n      productTypesByCategory() {\n        return this.categories.length\n          ? this.categories\n          : [{\n            id: 1,\n            label: 'All Products',\n            productTypeIds: [...new Set(this.products\n              .map((product) => product.product_type_id)\n              .reduce((array, value) => array.concat(value), []))],\n          }];\n      },\n    },\n    watch: {\n      /**\n       * Watch changes on productsByTypeTree and call expandAll\n       */\n      productsByTypeTree() {\n        this.expandAll();\n      },\n    },\n    mounted() {\n      this.popperWidth = (this.width || this.$refs.productSelectorContainer.clientWidth) - 2;\n\n      this.expandAll();\n    },\n    methods: {\n      /**\n       * Go through all of the product types by category and the child product type IDs.\n       * Push to the respective \"openCategoryIds\" and \"openProductTypeIds\" arrays\n       * depending if the are included in\n       * the \"collapsedCategories\" and \"collapsedProductTypes\" props .\n       */\n      expandAll() {\n        this.productTypesByCategory.forEach((category, index) => {\n          if (!this.collapsedCategories.includes(index)) {\n            this.openCategoryIds.push(index);\n          }\n\n          category.productTypeIds.forEach((productTypeId) => {\n            if (!this.collapsedProductTypes.includes(productTypeId)) {\n              this.openProductTypeIds.push(productTypeId);\n            }\n          });\n        });\n      },\n      /**\n       * Hiding the popover when clicking outside <TfPopover>\n       */\n      hidePopover() {\n        if (this.keepOpen) {\n          return;\n        }\n\n        this.isActive = false;\n      },\n      /**\n       * Emits the category ID and the openCategoryIds array.\n       *\n       * @param {number} categoryIndex\n       */\n      toggleCategory(categoryIndex) {\n        this.$emit('toggleCategory', {\n          action: this.openCategoryIds.includes(categoryIndex)\n            ? 'expand'\n            : 'collapse',\n          categoryIndex,\n          openCategoryIds: this.openCategoryIds,\n        });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .category-toggle {\n    height: 18px;\n    width: 16px;\n    margin-top: 3px;\n    fill: $tf-dark-gray;\n    transition: transform .3s;\n    transform: rotateZ(0);\n\n    &.is-active {\n      fill: $tf-blue;\n      transform: rotateZ(180deg);\n    }\n  }\n\n  .el-collapse-item__header.is-active {\n    .title-category {\n      color: $tf-blue;\n    }\n  }\n\n  .title-category {\n    display: flex;\n    justify-content: space-between;\n    padding: 9px 15px;\n    border-bottom: 1px solid $tf-extra-light-gray-1;\n\n    font: {\n      size: 16px;\n      weight: 700;\n    }\n\n    cursor: pointer;\n\n    svg {\n      .container-category.is-active & {\n        transition: transform .3s;\n        transform: rotateZ(180deg);\n      }\n\n      transform: rotateZ(0);\n    }\n  }\n\n  .product-selector {\n    &-counter {\n      margin: 0 5px;\n    }\n\n    &-toggle {\n      display: flex;\n      flex: {\n        basis: 18px;\n        shrink: 0;\n      }\n      justify-content: flex-end;\n\n      svg {\n        fill: $tf-medium-gray;\n        transition: transform .3s;\n        transform: rotateZ(0);\n        height: 20px;\n        width: 12px;\n\n        &.is-active {\n          fill: $tf-blue;\n          transform: rotateZ(180deg);\n        }\n      }\n\n      &.is-fixed {\n        margin-left: auto;\n      }\n    }\n\n    &-input {\n      position: relative;\n      display: flex;\n      align-items: center;\n      width: 100%;\n      padding: 5px 10px;\n      font-size: 14px;\n      border: 1px solid $tf-light-gray;\n      border-radius: 4px;\n      box-sizing: border-box;\n      cursor: pointer;\n\n      &.is-active {\n        border-color: $tf-blue;\n      }\n\n      &:focus {\n        outline: none;\n      }\n    }\n\n    &-label {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .el-collapse-item__wrap {\n    padding-left: 15px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$L = "data-v-04439132";
  /* module identifier */
  const __vue_module_identifier__$L = undefined;
  /* functional template */
  const __vue_is_functional_template__$L = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$L = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$J, staticRenderFns: __vue_staticRenderFns__$J },
    __vue_inject_styles__$L,
    __vue_script__$L,
    __vue_scope_id__$L,
    __vue_is_functional_template__$L,
    __vue_module_identifier__$L,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The Progress icon based on progressState prop.
 *
 * @vuedoc
 * @exports ProjectProductSelector/TfProgressIcon
 * @category Components
 */
var script$M = {
  name: 'TfProgressIcon',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    progressState: {
      type: String,
      default: null
    }
  }
};

/* script */
const __vue_script__$M = script$M;

/* template */
var __vue_render__$K = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.progressState === "full"
    ? _c("icon", {
        class: [{ "is-active": _vm.isActive }, _vm.progressState],
        attrs: { name: "check-circle" },
      })
    : _c("span", {
        class: [
          { "is-active": _vm.isActive },
          _vm.progressState,
          "progress-icon",
        ],
      })
};
var __vue_staticRenderFns__$K = [];
__vue_render__$K._withStripped = true;

  /* style */
  const __vue_inject_styles__$M = function (inject) {
    if (!inject) return
    inject("data-v-58b6d697_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nsvg[data-v-58b6d697] {\n  width: 16px;\n  height: 16px;\n}\nsvg.full[data-v-58b6d697] {\n  fill: #00b980;\n}\nsvg.active[data-v-58b6d697] {\n  fill: #009;\n}\nsvg.is-active[data-v-58b6d697] {\n  fill: #fff;\n}\n.progress-icon[data-v-58b6d697] {\n  display: block;\n  width: 16px;\n  height: 16px;\n  overflow: hidden;\n  border: 2px solid #c1c1c1;\n  border-radius: 100%;\n  box-sizing: border-box;\n}\n.progress-icon.is-active[data-v-58b6d697] {\n  border-color: #fff;\n}\n.progress-icon.half[data-v-58b6d697]:after {\n  display: block;\n  margin-left: 6px;\n  background: #f7912a;\n  width: 14px;\n  height: 14px;\n  content: \"\";\n}\n.progress-icon.half.is-active[data-v-58b6d697]:after {\n  background-color: #fff;\n}\n\n/*# sourceMappingURL=TfProgressIcon.vue.map */", map: {"version":3,"sources":["TfProgressIcon.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfProductSelector/TfProgressIcon.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC2ClC;EACA,WAAA;EACA,YAAA;ADzCA;AC2CA;EACA,aAAA;ADzCA;AC4CA;EACA,UAAA;AD1CA;AC6CA;EACA,UAAA;AD3CA;AC+CA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AD5CA;AC8CA;EACA,kBAAA;AD5CA;ACgDA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AD9CA;ACiDA;EACA,sBAAA;AD/CA;;AAEA,6CAA6C","file":"TfProgressIcon.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nsvg {\n  width: 16px;\n  height: 16px;\n}\nsvg.full {\n  fill: #00b980;\n}\nsvg.active {\n  fill: #009;\n}\nsvg.is-active {\n  fill: #fff;\n}\n\n.progress-icon {\n  display: block;\n  width: 16px;\n  height: 16px;\n  overflow: hidden;\n  border: 2px solid #c1c1c1;\n  border-radius: 100%;\n  box-sizing: border-box;\n}\n.progress-icon.is-active {\n  border-color: #fff;\n}\n.progress-icon.half:after {\n  display: block;\n  margin-left: 6px;\n  background: #f7912a;\n  width: 14px;\n  height: 14px;\n  content: \"\";\n}\n.progress-icon.half.is-active:after {\n  background-color: #fff;\n}\n\n/*# sourceMappingURL=TfProgressIcon.vue.map */","<template>\n  <icon\n    v-if=\"progressState === 'full'\"\n    :class=\"[\n      { 'is-active' : isActive, },\n      progressState,\n    ]\"\n    name=\"check-circle\"\n  />\n  <span\n    v-else\n    :class=\"[\n      { 'is-active': isActive, },\n      progressState,\n      'progress-icon',\n    ]\"\n  />\n</template>\n\n<script>\n/**\n * The Progress icon based on progressState prop.\n *\n * @vuedoc\n * @exports ProjectProductSelector/TfProgressIcon\n * @category Components\n */\n  export default {\n    name: 'TfProgressIcon',\n    props: {\n      isActive: {\n        type: Boolean,\n        default: false,\n      },\n      progressState: {\n        type: String,\n        default: null,\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  svg {\n    width: 16px;\n    height: 16px;\n\n    &.full {\n      fill: $tf-green;\n    }\n\n    &.active {\n      fill: $tf-blue;\n    }\n\n    &.is-active {\n      fill: $tf-white;\n    }\n  }\n\n  .progress-icon {\n    display: block;\n    width: 16px;\n    height: 16px;\n    overflow: hidden;\n    border: 2px solid $tf-light-gray;\n    border-radius: 100%;\n    box-sizing: border-box;\n\n    &.is-active {\n      border-color: $tf-white;\n    }\n\n    &.half {\n      &:after {\n        display: block;\n        margin-left: 6px;\n        background: $tf-orange;\n        width: 14px;\n        height: 14px;\n        content: '';\n      }\n\n      &.is-active:after {\n        background-color: $tf-white;\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$M = "data-v-58b6d697";
  /* module identifier */
  const __vue_module_identifier__$M = undefined;
  /* functional template */
  const __vue_is_functional_template__$M = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$M = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$K, staticRenderFns: __vue_staticRenderFns__$K },
    __vue_inject_styles__$M,
    __vue_script__$M,
    __vue_scope_id__$M,
    __vue_is_functional_template__$M,
    __vue_module_identifier__$M,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Quote Edits Export Row
 *
 * @vuedoc
 * @exports components/TfPdfExport/QuoteEdits/Row
 * @category Components
 */
var script$N = {
  name: 'QuoteEditsExportRow',
  props: {
    leftEdit: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    rightEdit: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};

/* script */
const __vue_script__$N = script$N;

/* template */
var __vue_render__$L = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "quote-edit-row pdf-export-block" }, [
    _c(
      "div",
      { staticClass: "left" },
      [
        _vm.leftEdit.created_at
          ? _c("AppQuoteEditItem", {
              attrs: {
                item: _vm.leftEdit,
                "data-test": "left edit",
                tag: "div",
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "right" },
      [
        _vm.rightEdit.created_at
          ? _c("AppQuoteEditItem", {
              attrs: {
                item: _vm.rightEdit,
                "data-test": "right edit",
                tag: "div",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
};
var __vue_staticRenderFns__$L = [];
__vue_render__$L._withStripped = true;

  /* style */
  const __vue_inject_styles__$N = function (inject) {
    if (!inject) return
    inject("data-v-7ec2730f_0", { source: ".quote-edit-item[data-v-7ec2730f] {\n  padding: 0;\n  text-align: left;\n  border: 0;\n}\n.quote-edit-item[data-v-7ec2730f] p,\n.quote-edit-item[data-v-7ec2730f] .time {\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--tf-black);\n}\n.quote-edit-row[data-v-7ec2730f] {\n  display: flex;\n  width: 504px;\n}\n.quote-edit-row div[data-v-7ec2730f] {\n  flex: 1 0;\n  width: 220px;\n  padding-right: 32px;\n  padding-bottom: 20px;\n}\n.quote-edit-row div[data-v-7ec2730f]:nth-child(2) {\n  padding-left: 32px;\n  padding-right: 0;\n}\n\n/*# sourceMappingURL=Row.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfPdfExport/QuoteEdits/Row.vue","Row.vue"],"names":[],"mappings":"AA6CA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;AC5CA;AD8CA;;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;AC5CA;ADgDA;EACA,aAAA;EACA,YAAA;AC7CA;AD+CA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AC7CA;ADgDA;EACA,kBAAA;EACA,gBAAA;AC9CA;;AAEA,kCAAkC","file":"Row.vue","sourcesContent":["<template>\n  <div class=\"quote-edit-row pdf-export-block\">\n    <div class=\"left\">\n      <AppQuoteEditItem\n        v-if=\"leftEdit.created_at\"\n        :item=\"leftEdit\"\n        data-test=\"left edit\"\n        tag=\"div\"\n      />\n    </div>\n    <div class=\"right\">\n      <AppQuoteEditItem\n        v-if=\"rightEdit.created_at\"\n        :item=\"rightEdit\"\n        data-test=\"right edit\"\n        tag=\"div\"\n      />\n    </div>\n  </div>\n</template>\n\n<script>\n/**\n * Quote Edits Export Row\n *\n * @vuedoc\n * @exports components/TfPdfExport/QuoteEdits/Row\n * @category Components\n */\n  export default {\n    name: 'QuoteEditsExportRow',\n    props: {\n      leftEdit: {\n        type: Object,\n        default: () => ({}),\n      },\n      rightEdit: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .quote-edit-item::v-deep {\n    padding: 0;\n    text-align: left;\n    border: 0;\n\n    p,\n    .time {\n      font-size: 12px;\n      line-height: 16px;\n      color: var(--tf-black);\n    }\n  }\n\n  .quote-edit-row {\n    display: flex;\n    width: 504px;\n\n    div {\n      flex: 1 0;\n      width: 220px;\n      padding-right: 32px;\n      padding-bottom: 20px;\n    }\n\n    div:nth-child(2) {\n      padding-left: 32px;\n      padding-right: 0;\n    }\n  }\n</style>\n",".quote-edit-item::v-deep {\n  padding: 0;\n  text-align: left;\n  border: 0;\n}\n.quote-edit-item::v-deep p,\n.quote-edit-item::v-deep .time {\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--tf-black);\n}\n\n.quote-edit-row {\n  display: flex;\n  width: 504px;\n}\n.quote-edit-row div {\n  flex: 1 0;\n  width: 220px;\n  padding-right: 32px;\n  padding-bottom: 20px;\n}\n.quote-edit-row div:nth-child(2) {\n  padding-left: 32px;\n  padding-right: 0;\n}\n\n/*# sourceMappingURL=Row.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$N = "data-v-7ec2730f";
  /* module identifier */
  const __vue_module_identifier__$N = undefined;
  /* functional template */
  const __vue_is_functional_template__$N = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$N = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$L, staticRenderFns: __vue_staticRenderFns__$L },
    __vue_inject_styles__$N,
    __vue_script__$N,
    __vue_scope_id__$N,
    __vue_is_functional_template__$N,
    __vue_module_identifier__$N,
    false,
    browser,
    undefined,
    undefined
  );

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Quote Edits Export
 *
 * @vuedoc
 * @exports components/TfPdfExport/QuoteEdits/index
 * @category Components
 */
var script$O = {
  name: 'TfQuoteEditsExport',
  components: {
    QuoteEditsExportRow: __vue_component__$N,
    ExportHeader: __vue_component__$o
  },
  props: {
    buttonSize: {
      type: String,
      default: 'text-icon'
    },
    buttonTitle: {
      type: String,
      default: 'export'
    },
    dates: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    employerName: {
      type: String,
      default: null
    },
    filters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    projectId: {
      type: Number,
      default: null
    }
  },
  computed: {
    /**
     * Returns a version of the quote edits structure split across columns
     *
     * @returns {Array}
     */
    edits: function edits() {
      var columnEdits = {
        left: [],
        right: []
      };
      this.dates.reduce(function (edits, date) {
        return edits.concat(date);
      }, []).forEach(function (edit, index) {
        columnEdits[index % 2 ? 'right' : 'left'].push(_objectSpread$4(_objectSpread$4({}, edit), {}, {
          position: index
        }));
      });
      return columnEdits;
    }
  }
};

/* script */
const __vue_script__$O = script$O;

/* template */
var __vue_render__$M = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    [
      _c(
        "TfPdfExport",
        {
          attrs: {
            "button-size": _vm.buttonSize,
            "button-title": _vm.buttonTitle,
            "is-disabled": !_vm.dates.length,
            filename: "quote-edits_" + _vm.projectId + ".pdf",
          },
        },
        [
          _c("ExportHeader", {
            attrs: {
              "employer-name": _vm.employerName,
              filters: _vm.filters,
              title: "Quote Edits History",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.edits.left, function (left, index) {
            return _c("QuoteEditsExportRow", {
              key: index,
              attrs: {
                "left-edit": left,
                "right-edit": _vm.edits.right[index],
              },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$M = [];
__vue_render__$M._withStripped = true;

  /* style */
  const __vue_inject_styles__$O = undefined;
  /* scoped */
  const __vue_scope_id__$O = undefined;
  /* module identifier */
  const __vue_module_identifier__$O = undefined;
  /* functional template */
  const __vue_is_functional_template__$O = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$O = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$M, staticRenderFns: __vue_staticRenderFns__$M },
    __vue_inject_styles__$O,
    __vue_script__$O,
    __vue_scope_id__$O,
    __vue_is_functional_template__$O,
    __vue_module_identifier__$O,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfSelectText popover compononent
 *
 * @vuedoc
 * @exports TfPopover/TfSelectText
 * @category Components
 */

var script$P = {
  name: 'TfSelectText',
  props: {
    noMatchText: {
      type: String,
      default: 'Option not found'
    },
    options: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    optionText: {
      type: String,
      default: 'name'
    },
    optionValue: {
      type: String,
      default: 'id'
    },
    placeholder: {
      type: String,
      default: 'n/a'
    },
    title: {
      type: String,
      required: true,
      default: 'Select option'
    },
    value: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      selected: null
    };
  },
  created: function created() {
    this.selected = this.value;
  }
};

/* script */
const __vue_script__$P = script$P;

/* template */
var __vue_render__$N = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ElSelect",
    {
      staticClass: "tf-select-text wt-select-text",
      attrs: {
        "no-match-text": _vm.noMatchText,
        placeholder: _vm.placeholder,
        filterable: "",
      },
      on: {
        change: function ($event) {
          return _vm.$emit("change", $event)
        },
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
        blur: function ($event) {
          return _vm.$emit("blur")
        },
        focus: function ($event) {
          return _vm.$emit("focus")
        },
      },
      model: {
        value: _vm.selected,
        callback: function ($$v) {
          _vm.selected = $$v;
        },
        expression: "selected",
      },
    },
    [
      _c(
        "ElOptionGroup",
        { attrs: { label: _vm.title } },
        _vm._l(_vm.options, function (option) {
          return _c("ElOption", {
            key: option[_vm.optionValue],
            attrs: {
              value: option[_vm.optionValue],
              label: option[_vm.optionText],
            },
          })
        }),
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$N = [];
__vue_render__$N._withStripped = true;

  /* style */
  const __vue_inject_styles__$P = function (inject) {
    if (!inject) return
    inject("data-v-03910a69_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.el-select[data-v-03910a69] {\n  width: 100%;\n}\n.el-select[data-v-03910a69] .el-input__inner {\n  border-color: transparent;\n}\n.el-select[data-v-03910a69] .el-input__inner, .el-select[data-v-03910a69] .el-input__inner::placeholder {\n  /* stylelint-disable-next-line declaration-no-important */\n  color: #006 !important;\n}\n.el-select[data-v-03910a69] .el-input__suffix {\n  display: none;\n}\n.el-select[data-v-03910a69]:hover .el-input:not(.is-focus) .el-input__inner {\n  border-color: #c1c1c1;\n}\n.el-select-group .el-select-dropdown__item[data-v-03910a69] {\n  padding-left: 10px;\n}\n[data-v-03910a69] .el-select-group__title {\n  padding-left: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #006;\n  border-bottom: 1px solid #efefef;\n}\n\n/*# sourceMappingURL=TfSelectText.vue.map */", map: {"version":3,"sources":["TfSelectText.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfForm/TfSelectText.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACgFlC;EACA,WAAA;AD9EA;ACiFA;EACA,yBAAA;AD/EA;ACiFA;EAEA,yDAAA;EACA,sBAAA;ADhFA;ACoFA;EACA,aAAA;ADlFA;ACwFA;EACA,qBAAA;ADtFA;AC4FA;EACA,kBAAA;ADzFA;AC4FA;EACA,kBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,WAAA;EACA,gCAAA;AD3FA;;AAEA,2CAA2C","file":"TfSelectText.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.el-select {\n  width: 100%;\n}\n.el-select ::v-deep.el-input__inner {\n  border-color: transparent;\n}\n.el-select ::v-deep.el-input__inner, .el-select ::v-deep.el-input__inner::placeholder {\n  /* stylelint-disable-next-line declaration-no-important */\n  color: #006 !important;\n}\n.el-select ::v-deep.el-input__suffix {\n  display: none;\n}\n.el-select:hover ::v-deep.el-input:not(.is-focus) .el-input__inner {\n  border-color: #c1c1c1;\n}\n\n.el-select-group .el-select-dropdown__item {\n  padding-left: 10px;\n}\n\n::v-deep .el-select-group__title {\n  padding-left: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #006;\n  border-bottom: 1px solid #efefef;\n}\n\n/*# sourceMappingURL=TfSelectText.vue.map */","<template>\n  <ElSelect\n    v-model=\"selected\"\n    :no-match-text=\"noMatchText\"\n    :placeholder=\"placeholder\"\n    class=\"tf-select-text wt-select-text\"\n    filterable\n    @change=\"$emit('change', $event)\"\n    @input=\"$emit('input', $event)\"\n    @blur=\"$emit('blur')\"\n    @focus=\"$emit('focus')\"\n  >\n    <ElOptionGroup\n      :label=\"title\"\n    >\n      <ElOption\n        v-for=\"option in options\"\n        :key=\"option[optionValue]\"\n        :value=\"option[optionValue]\"\n        :label=\"option[optionText]\"\n      />\n    </ElOptionGroup>\n  </ElSelect>\n</template>\n\n<script>\n/**\n * TfSelectText popover compononent\n *\n * @vuedoc\n * @exports TfPopover/TfSelectText\n * @category Components\n */\n\n  export default {\n    name: 'TfSelectText',\n    props: {\n      noMatchText: {\n        type: String,\n        default: 'Option not found',\n      },\n      options: {\n        type: Array,\n        required: true,\n        default: () => [],\n      },\n      optionText: {\n        type: String,\n        default: 'name',\n      },\n      optionValue: {\n        type: String,\n        default: 'id',\n      },\n      placeholder: {\n        type: String,\n        default: 'n/a',\n      },\n      title: {\n        type: String,\n        required: true,\n        default: 'Select option',\n      },\n      value: {\n        type: [Number, String],\n        default: null,\n      },\n    },\n\n    data: () => ({\n      selected: null,\n    }),\n\n    created() {\n      this.selected = this.value;\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .el-select {\n    width: 100%;\n\n    ::v-deep.el-input {\n      &__inner {\n        border-color: transparent;\n\n        &,\n        &::placeholder {\n          /* stylelint-disable-next-line declaration-no-important */\n          color: $tf-dark-blue !important;\n        }\n      }\n\n      &__suffix {\n        display: none;\n      }\n    }\n\n    &:hover {\n      ::v-deep.el-input:not(.is-focus) {\n        .el-input__inner {\n          border-color: $tf-light-gray;\n        }\n      }\n    }\n  }\n\n  .el-select-group .el-select-dropdown__item {\n    padding-left: 10px;\n  }\n\n  ::v-deep .el-select-group__title {\n    padding-left: 10px;\n    font: {\n      size: 14px;\n      weight: 700;\n    }\n    color: $tf-dark-blue;\n    border-bottom: 1px solid $tf-extra-light-gray-1;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$P = "data-v-03910a69";
  /* module identifier */
  const __vue_module_identifier__$P = undefined;
  /* functional template */
  const __vue_is_functional_template__$P = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$P = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$N, staticRenderFns: __vue_staticRenderFns__$N },
    __vue_inject_styles__$P,
    __vue_script__$P,
    __vue_scope_id__$P,
    __vue_is_functional_template__$P,
    __vue_module_identifier__$P,
    false,
    browser,
    undefined,
    undefined
  );

var script$Q = {
  name: 'TfSubmenu',
  extends: Submenu,
  props: {
    closeOnOutsideClick: {
      type: Boolean,
      default: false
    },
    popperClassName: {
      type: String,
      default: 'tf-hamburger-popper'
    }
  },
  data: function data() {
    return {
      element: null
    };
  },
  watch: {
    /**
     * Watch when the menu opens/closes
     *
     * @param {boolean} newVal
     */
    opened: function opened(newVal) {
      var _this = this;
      if (newVal && this.closeOnOutsideClick) {
        var _document$getElements = document.getElementsByClassName(this.popperClassName),
          _document$getElements2 = _slicedToArray(_document$getElements, 1),
          element = _document$getElements2[0];
        this.element = element;
        // Add a little delay for this
        // There's an issue on carrier that is emitting on initial trigger
        setTimeout(function () {
          document.addEventListener('click', _this.outsideClickListener);
        }, 10);
      } else {
        this.removeClickListener();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeClickListener();
  },
  methods: {
    /**
     * If a user clicks outside the menu we want to hide it
     *
     * @param {event} event
     */
    outsideClickListener: function outsideClickListener(event) {
      if (this.opened && !this.element.contains(event.target)) {
        this.removeClickListener();
        this.$emit('hide');
      }
    },
    /**
     * We want to remove our listener when the component is destroyed
     */
    removeClickListener: function removeClickListener() {
      document.removeEventListener('click', this.outsideClickListener);
    }
  }
};

/* script */
const __vue_script__$Q = script$Q;

/* template */

  /* style */
  const __vue_inject_styles__$Q = undefined;
  /* scoped */
  const __vue_scope_id__$Q = undefined;
  /* module identifier */
  const __vue_module_identifier__$Q = undefined;
  /* functional template */
  const __vue_is_functional_template__$Q = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Q = /*#__PURE__*/normalizeComponent_1(
    {},
    __vue_inject_styles__$Q,
    __vue_script__$Q,
    __vue_scope_id__$Q,
    __vue_is_functional_template__$Q,
    __vue_module_identifier__$Q,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * WatchTower Tag
 *
 * @vuedoc
 * @exports TfTag
 * @category Components
 */

var script$R = {
  name: 'TfTag',
  props: {
    text: {
      type: String,
      required: true
    },
    closable: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * Emit a close event on click
     */
    onClose: function onClose() {
      this.$emit('close');
    }
  }
};

/* script */
const __vue_script__$R = script$R;

/* template */
var __vue_render__$O = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    { class: ["tag", _vm.type] },
    [
      _c("span", {
        staticClass: "text",
        domProps: { textContent: _vm._s(_vm.text) },
      }),
      _vm._v(" "),
      _vm.closable
        ? _c("TfButton", {
            staticClass: "close-btn",
            attrs: { type: "secondary", icon: "times", size: "icon-no-fill" },
            on: { click: _vm.onClose },
          })
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$O = [];
__vue_render__$O._withStripped = true;

  /* style */
  const __vue_inject_styles__$R = function (inject) {
    if (!inject) return
    inject("data-v-bcfdb490_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tag[data-v-bcfdb490] {\n  display: flex;\n  min-width: 80px;\n  padding: 0 10px;\n  background: #efefef;\n  margin: 0 20px 20px 0;\n}\n.text[data-v-bcfdb490] {\n  flex-grow: 1;\n  color: #000;\n  font-size: 14px;\n  line-height: 29px;\n}\n.wt-button--icon-no-fill.has-icon[data-v-bcfdb490],\n.tf-button--icon-no-fill.has-icon[data-v-bcfdb490] {\n  flex-grow: 0;\n}\n.wt-button--icon-no-fill.has-icon[data-v-bcfdb490] svg,\n.tf-button--icon-no-fill.has-icon[data-v-bcfdb490] svg {\n  fill: #42474c;\n}\n\n/*# sourceMappingURL=TfTag.vue.map */", map: {"version":3,"sources":["TfTag.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfForm/TfTag.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC8DlC;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AD5DA;AC+DA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AD5DA;AC+DA;;EAEA,YAAA;AD5DA;AC8DA;;EACA,aAAA;AD3DA;;AAEA,oCAAoC","file":"TfTag.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tag {\n  display: flex;\n  min-width: 80px;\n  padding: 0 10px;\n  background: #efefef;\n  margin: 0 20px 20px 0;\n}\n\n.text {\n  flex-grow: 1;\n  color: #000;\n  font-size: 14px;\n  line-height: 29px;\n}\n\n.wt-button--icon-no-fill.has-icon::v-deep,\n.tf-button--icon-no-fill.has-icon::v-deep {\n  flex-grow: 0;\n}\n.wt-button--icon-no-fill.has-icon::v-deep svg,\n.tf-button--icon-no-fill.has-icon::v-deep svg {\n  fill: #42474c;\n}\n\n/*# sourceMappingURL=TfTag.vue.map */","<template>\n  <span\n    :class=\"[\n      'tag',\n      type\n    ]\"\n  >\n    <span\n      class=\"text\"\n      v-text=\"text\"\n    />\n\n    <TfButton\n      v-if=\"closable\"\n      class=\"close-btn\"\n      type=\"secondary\"\n      icon=\"times\"\n      size=\"icon-no-fill\"\n      @click=\"onClose\"\n    />\n  </span>\n</template>\n\n<script>\n/**\n * WatchTower Tag\n *\n * @vuedoc\n * @exports TfTag\n * @category Components\n */\n\n  export default {\n    name: 'TfTag',\n\n    props: {\n      text: {\n        type: String,\n        required: true,\n      },\n      closable: {\n        type: Boolean,\n        default: false,\n      },\n      type: {\n        type: String,\n        default: '',\n      },\n    },\n\n    methods: {\n      /**\n       * Emit a close event on click\n       */\n      onClose() {\n        this.$emit('close');\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .tag {\n    display: flex;\n    min-width: 80px;\n    padding: 0 10px;\n    background: $tf-extra-light-gray-1;\n    margin: 0 20px 20px 0;\n  }\n\n  .text {\n    flex-grow: 1;\n    color: $tf-black;\n    font-size: 14px;\n    line-height: 29px;\n  }\n\n  .wt-button--icon-no-fill.has-icon::v-deep,\n  .tf-button--icon-no-fill.has-icon::v-deep {\n    flex-grow: 0;\n\n    svg {\n      fill: $tf-dark-gray;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$R = "data-v-bcfdb490";
  /* module identifier */
  const __vue_module_identifier__$R = undefined;
  /* functional template */
  const __vue_is_functional_template__$R = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$R = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$O, staticRenderFns: __vue_staticRenderFns__$O },
    __vue_inject_styles__$R,
    __vue_script__$R,
    __vue_scope_id__$R,
    __vue_is_functional_template__$R,
    __vue_module_identifier__$R,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * WatchTower Tag Field
 *
 * @vuedoc
 * @exports TfForm/TfTagField
 * @category Components
 */

var script$S = {
  name: 'TfTagField',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    /**
     * When a tag is close, remove it and emit an "input" event, per the v-model…model.
     *
     * @param {number} index
     */
    onClose: function onClose(index) {
      var value = _toConsumableArray(this.value);
      value.splice(index, 1);
      this.$emit('input', value);
    }
  }
};

/* script */
const __vue_script__$S = script$S;

/* template */
var __vue_render__$P = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "tag-field" },
    [
      _vm._l(_vm.value, function (tag, tagIndex) {
        return _c("TfTag", {
          key: tagIndex,
          attrs: { text: tag.text, closable: tag.closable || _vm.closable },
          on: {
            close: function ($event) {
              return _vm.onClose(tagIndex)
            },
          },
        })
      }),
      _vm._v(" "),
      _vm.placeholder && !_vm.value.length
        ? _c("span", {
            staticClass: "placeholder",
            domProps: { textContent: _vm._s(_vm.placeholder) },
          })
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$P = [];
__vue_render__$P._withStripped = true;

  /* style */
  const __vue_inject_styles__$S = function (inject) {
    if (!inject) return
    inject("data-v-5e627025_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tag-field[data-v-5e627025] {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 20px 0 0 20px;\n  border: 1px #c1c1c1 solid;\n  border-radius: 2px;\n  min-height: 49px;\n}\n.placeholder[data-v-5e627025] {\n  display: inline-block;\n  font-size: 14px;\n  line-height: 16px;\n  margin-bottom: 20px;\n  color: #999;\n}\n\n/*# sourceMappingURL=TfTagField.vue.map */", map: {"version":3,"sources":["TfTagField.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfForm/TfTagField.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACiElC;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AD/DA;ACkEA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AD/DA;;AAEA,yCAAyC","file":"TfTagField.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tag-field {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 20px 0 0 20px;\n  border: 1px #c1c1c1 solid;\n  border-radius: 2px;\n  min-height: 49px;\n}\n\n.placeholder {\n  display: inline-block;\n  font-size: 14px;\n  line-height: 16px;\n  margin-bottom: 20px;\n  color: #999;\n}\n\n/*# sourceMappingURL=TfTagField.vue.map */","<template>\n  <div class=\"tag-field\">\n    <TfTag\n      v-for=\"(tag, tagIndex) of value\"\n      :key=\"tagIndex\"\n      :text=\"tag.text\"\n      :closable=\"tag.closable || closable\"\n      @close=\"onClose(tagIndex)\"\n    />\n    <span\n      v-if=\"placeholder && !value.length\"\n      class=\"placeholder\"\n      v-text=\"placeholder\"\n    />\n  </div>\n</template>\n\n<script>\n/**\n * WatchTower Tag Field\n *\n * @vuedoc\n * @exports TfForm/TfTagField\n * @category Components\n */\n\n  export default {\n    name: 'TfTagField',\n\n    props: {\n      placeholder: {\n        type: String,\n        default: '',\n      },\n      type: {\n        type: String,\n        default: '',\n      },\n      closable: {\n        type: Boolean,\n        default: false,\n      },\n      value: {\n        type: Array,\n        default: () => [],\n      },\n    },\n    methods: {\n      /**\n       * When a tag is close, remove it and emit an \"input\" event, per the v-model…model.\n       *\n       * @param {number} index\n       */\n      onClose(index) {\n        const value = [...this.value];\n\n        value.splice(index, 1);\n\n        this.$emit('input', value);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .tag-field {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 20px 0 0 20px;\n    border: 1px $tf-light-gray solid;\n    border-radius: 2px;\n    min-height: 49px;\n  }\n\n  .placeholder {\n    display: inline-block;\n    font-size: 14px;\n    line-height: 16px;\n    margin-bottom: 20px;\n    color: $tf-medium-gray;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$S = "data-v-5e627025";
  /* module identifier */
  const __vue_module_identifier__$S = undefined;
  /* functional template */
  const __vue_is_functional_template__$S = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$S = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$P, staticRenderFns: __vue_staticRenderFns__$P },
    __vue_inject_styles__$S,
    __vue_script__$S,
    __vue_scope_id__$S,
    __vue_is_functional_template__$S,
    __vue_module_identifier__$S,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * "TfTabs" is a wrapper component of el-tabs that will, time permitting,
 * be replaced with our own component that is prop/emit compatible with
 * the Element one. https://element.eleme.io/#/en-US/component/dialog#dialog
 *
 * @vuedoc
 * @exports TfTabs
 * @category components
 */
var script$T = {
  name: 'TfTabs',
  inheritAttrs: false,
  props: {
    /**
     * Currently only used by the `file` type, locked: true makes the
     * unselected tabs look disabled. Switching has to be disabled in
     * the implementation by reacting to @tab-click events.
     */
    locked: {
      type: Boolean,
      default: false
    },
    /**
     * The type of tab design that we're rendering.
     * Currently supporting `large` (default), `small`, `text`, and `file`
     */
    type: {
      type: String,
      default: 'large',
      validator: function validator(value) {
        return ['large', 'small', 'text', 'file'].includes(value);
      }
    }
  },
  computed: {
    /**
     * Apply an class based on the `type` prop. The default tab type, large, require no class.
     *
     * @returns {string}
     */
    tabClass: function tabClass() {
      var classes = this.locked ? ['locked'] : [];
      if (!['', 'large'].includes(this.type)) {
        classes.push("".concat(this.type, "-tabs"));
      }
      return classes;
    }
  }
};

/* script */
const __vue_script__$T = script$T;

/* template */
var __vue_render__$Q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ElTabs",
    _vm._g(
      _vm._b(
        { class: _vm.tabClass },
        "ElTabs",
        Object.assign({}, _vm.$attrs, _vm.$props, { type: _vm.type }),
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$Q = [];
__vue_render__$Q._withStripped = true;

  /* style */
  const __vue_inject_styles__$T = undefined;
  /* scoped */
  const __vue_scope_id__$T = undefined;
  /* module identifier */
  const __vue_module_identifier__$T = undefined;
  /* functional template */
  const __vue_is_functional_template__$T = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$T = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$Q, staticRenderFns: __vue_staticRenderFns__$Q },
    __vue_inject_styles__$T,
    __vue_script__$T,
    __vue_scope_id__$T,
    __vue_is_functional_template__$T,
    __vue_module_identifier__$T,
    false,
    undefined,
    undefined,
    undefined
  );

var $sort = [].sort;
var test = [1, 2, 3];

_export(_export.P + _export.F * (_fails(function () {
  // IE8-
  test.sort(undefined);
}) || !_fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !_strictMethod($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(_toObject(this))
      : $sort.call(_toObject(this), _aFunction(comparefn));
  }
});

// https://github.com/tc39/proposal-object-values-entries

var $entries = _objectToArray(true);

_export(_export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$U = {
  name: 'TfTableChildRow',
  props: {
    childRowData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    childColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
};

/* script */
const __vue_script__$U = script$U;

/* template */
var __vue_render__$R = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tr",
    _vm._l(_vm.childColumns, function (column) {
      return _c("td", {
        key: column.label,
        domProps: {
          innerHTML: _vm._s(
            column.formatMethod
              ? column.formatMethod(_vm.childRowData[column.prop])
              : _vm.childRowData[column.prop]
          ),
        },
      })
    }),
    0
  )
};
var __vue_staticRenderFns__$R = [];
__vue_render__$R._withStripped = true;

  /* style */
  const __vue_inject_styles__$U = undefined;
  /* scoped */
  const __vue_scope_id__$U = undefined;
  /* module identifier */
  const __vue_module_identifier__$U = undefined;
  /* functional template */
  const __vue_is_functional_template__$U = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$U = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$R, staticRenderFns: __vue_staticRenderFns__$R },
    __vue_inject_styles__$U,
    __vue_script__$U,
    __vue_scope_id__$U,
    __vue_is_functional_template__$U,
    __vue_module_identifier__$U,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$V = {
  name: 'TfTableChildTable',
  props: {
    childData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    childColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    colspan: {
      type: Number,
      default: 1
    }
  }
};

/* script */
const __vue_script__$V = script$V;

/* template */
var __vue_render__$S = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("tr", { staticClass: "row row-parent is-expanded" }, [
    _c(
      "td",
      { staticClass: "cell-child-table", attrs: { colspan: _vm.colspan } },
      [
        _vm._t("childTable", null, {
          data: _vm.childData,
          columns: _vm.childColumns,
        }),
      ],
      2
    ),
  ])
};
var __vue_staticRenderFns__$S = [];
__vue_render__$S._withStripped = true;

  /* style */
  const __vue_inject_styles__$V = undefined;
  /* scoped */
  const __vue_scope_id__$V = undefined;
  /* module identifier */
  const __vue_module_identifier__$V = undefined;
  /* functional template */
  const __vue_is_functional_template__$V = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$V = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$S, staticRenderFns: __vue_staticRenderFns__$S },
    __vue_inject_styles__$V,
    __vue_script__$V,
    __vue_scope_id__$V,
    __vue_is_functional_template__$V,
    __vue_module_identifier__$V,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfTableFilters is a component that is used as a child of the TfTable component and controls the filters using the TfFilter component.
 *
 * @vuedoc
 * @exports TfTable/Filters
 * @category Components
 */
var script$W = {
  name: 'TfTableFilters',
  inject: ['TfTable'],
  computed: {
    /**
     * Evaluate the TfTable table data and sorting to return boolean for the template.
     *
     * @returns {boolean}
     */
    disableFilters: function disableFilters() {
      return !this.TfTable.tableData.length || this.TfTable.isSorting;
    },
    /**
     * Evaulate the TfTable localFilterValues values to see if there are any values.
     *
     * @returns {boolean}
     */
    hasFilterValues: function hasFilterValues() {
      return Object.values(this.TfTable.localFilterValues).some(function (value) {
        return value.length;
      });
    }
  }
};

/* script */
const __vue_script__$W = script$W;

/* template */
var __vue_render__$T = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: {
        "label-visible":
          _vm.TfTable.$slots.filterLabel || _vm.TfTable.showFilterLabel,
      },
    },
    [
      _vm.TfTable.$slots.filterLabel || _vm.TfTable.showFilterLabel
        ? _c(
            "h3",
            [
              _vm._t("filterLabel", function () {
                return [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$slots.filterLabel || "Filters:") +
                      "\n    "
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _vm._l(_vm.TfTable.filters, function (filter) {
            return _c(
              "div",
              {
                key: filter.prop,
                staticClass: "filter-column",
                style: { width: "" + filter.width },
              },
              [
                _c(
                  "TfFilter",
                  _vm._b(
                    {
                      on: {
                        changeDateFilterType: function ($event) {
                          return _vm.TfTable.onChangeDateFilterType(
                            filter.prop,
                            $event
                          )
                        },
                        input: function ($event) {
                          return _vm.TfTable.onChangeFilterValue({
                            prop: filter.prop,
                            value: $event,
                          })
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "noValue",
                            fn: function () {
                              return [
                                _vm._t("emptyCell", function () {
                                  return [_vm._v("\n            —\n          ")]
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    "TfFilter",
                    {
                      disabled: _vm.disableFilters,
                      filter: filter,
                      value: _vm.TfTable.localFilterValues[filter.prop],
                    },
                    false
                  )
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("TfButton", {
            attrs: {
              disabled: _vm.disableFilters || !_vm.hasFilterValues,
              "data-test": "reset filters",
              size: "text",
              type: "primary",
            },
            domProps: { textContent: _vm._s("Reset All") },
            on: { click: _vm.TfTable.onResetFilters },
          }),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$T = [];
__vue_render__$T._withStripped = true;

  /* style */
  const __vue_inject_styles__$W = function (inject) {
    if (!inject) return
    inject("data-v-bfd7ea58_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nh3[data-v-bfd7ea58] {\n  padding-top: 20px;\n}\n.filter-container[data-v-bfd7ea58] {\n  display: flex;\n  align-items: baseline;\n  margin: 20px 0 35px;\n}\n.label-visible .filter-container[data-v-bfd7ea58] {\n  margin-top: 0;\n}\n.filter-column[data-v-bfd7ea58] {\n  margin-right: 13px;\n}\n\n/*# sourceMappingURL=Filters.vue.map */", map: {"version":3,"sources":["Filters.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfTable/Filters.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC6ElC;EACA,iBAAA;AD3EA;AC+EA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AD5EA;AC8EA;EACA,aAAA;AD5EA;ACgFA;EACA,kBAAA;AD9EA;;AAEA,sCAAsC","file":"Filters.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\nh3 {\n  padding-top: 20px;\n}\n\n.filter-container {\n  display: flex;\n  align-items: baseline;\n  margin: 20px 0 35px;\n}\n.label-visible .filter-container {\n  margin-top: 0;\n}\n.filter-column {\n  margin-right: 13px;\n}\n\n/*# sourceMappingURL=Filters.vue.map */","<template>\n  <div :class=\"{ 'label-visible': TfTable.$slots.filterLabel || TfTable.showFilterLabel }\">\n    <h3 v-if=\"TfTable.$slots.filterLabel || TfTable.showFilterLabel\">\n      <slot name=\"filterLabel\">\n        {{ $slots.filterLabel || 'Filters:' }}\n      </slot>\n    </h3>\n    <div class=\"filter-container\">\n      <div\n        v-for=\"filter in TfTable.filters\"\n        :key=\"filter.prop\"\n        :style=\"{ width: `${filter.width}` }\"\n        class=\"filter-column\"\n      >\n        <TfFilter\n          v-bind=\"{\n            disabled: disableFilters,\n            filter,\n            value: TfTable.localFilterValues[filter.prop]\n          }\"\n          @changeDateFilterType=\"TfTable.onChangeDateFilterType(filter.prop, $event)\"\n          @input=\"TfTable.onChangeFilterValue({\n            prop: filter.prop,\n            value: $event\n          })\"\n        >\n          <template #noValue>\n            <slot name=\"emptyCell\">\n              &mdash;\n            </slot>\n          </template>\n        </TfFilter>\n      </div>\n      <TfButton\n        :disabled=\"disableFilters || !hasFilterValues\"\n        data-test=\"reset filters\"\n        size=\"text\"\n        type=\"primary\"\n        @click=\"TfTable.onResetFilters\"\n        v-text=\"'Reset All'\"\n      />\n    </div>\n  </div>\n</template>\n<script>\n  /**\n   * TfTableFilters is a component that is used as a child of the TfTable component and controls the filters using the TfFilter component.\n   *\n   * @vuedoc\n   * @exports TfTable/Filters\n   * @category Components\n   */\n  export default {\n    name: 'TfTableFilters',\n    inject: ['TfTable'],\n    computed: {\n      /**\n       * Evaluate the TfTable table data and sorting to return boolean for the template.\n       *\n       * @returns {boolean}\n       */\n      disableFilters() {\n        return !this.TfTable.tableData.length || this.TfTable.isSorting;\n      },\n      /**\n       * Evaulate the TfTable localFilterValues values to see if there are any values.\n       *\n       * @returns {boolean}\n       */\n      hasFilterValues() {\n        return Object.values(this.TfTable.localFilterValues).some((value) => value.length);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  h3 {\n    padding-top: 20px;\n  }\n\n  .filter {\n    &-container {\n      display: flex;\n      align-items: baseline;\n      margin: 20px 0 35px;\n\n      .label-visible & {\n        margin-top: 0;\n      }\n    }\n\n    &-column {\n      margin-right: 13px;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$W = "data-v-bfd7ea58";
  /* module identifier */
  const __vue_module_identifier__$W = undefined;
  /* functional template */
  const __vue_is_functional_template__$W = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$W = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$T, staticRenderFns: __vue_staticRenderFns__$T },
    __vue_inject_styles__$W,
    __vue_script__$W,
    __vue_scope_id__$W,
    __vue_is_functional_template__$W,
    __vue_module_identifier__$W,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfTableHead is a component that is used within the TfTable component and controls the th columns and its sorting logic.
 *
 * @vuedoc
 * @exports TfTable/Head
 * @category Components
 */
var script$X = {
  name: 'TfTableHead',
  inject: ['TfTable']
};

/* script */
const __vue_script__$X = script$X;

/* template */
var __vue_render__$U = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.TfTable.tableData.length
    ? _c("thead", [
        _c(
          "tr",
          [
            _vm._l(_vm.TfTable.tableMeta.columns, function (column) {
              return [
                !column.hidden
                  ? _c(
                      "th",
                      {
                        key: column.label,
                        attrs: { width: column.width || "auto" },
                      },
                      [
                        column.sortable
                          ? _c(
                              "TfButton",
                              {
                                class: {
                                  "is-active":
                                    _vm.TfTable.sortColumn === column.prop,
                                },
                                attrs: {
                                  direction: _vm.TfTable.sortDirection,
                                  selected:
                                    _vm.TfTable.sortColumn === column.prop,
                                  "data-test": "sort " + column.prop,
                                  type: "table-sort",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.TfTable.changeSortCriteria(
                                      column
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(column.label) +
                                    "\n        "
                                ),
                              ]
                            )
                          : _c("span", {
                              attrs: {
                                "data-test":
                                  "header " +
                                  (column && column.label
                                    ? column.label
                                    : "label"),
                              },
                              domProps: { textContent: _vm._s(column.label) },
                            }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            }),
            _vm._v(" "),
            _vm.TfTable.hasChildren
              ? _c("th", {
                  staticClass: "child-toggle",
                  attrs: { width: "51" },
                })
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
};
var __vue_staticRenderFns__$U = [];
__vue_render__$U._withStripped = true;

  /* style */
  const __vue_inject_styles__$X = function (inject) {
    if (!inject) return
    inject("data-v-c30d9c88_0", { source: "th.child-toggle[data-v-c30d9c88] {\n  padding: 0;\n}\nth .tf-button[data-v-c30d9c88] {\n  font-weight: 700;\n}\n\n/*# sourceMappingURL=Head.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfTable/Head.vue","Head.vue"],"names":[],"mappings":"AAoDA;EACA,UAAA;ACnDA;ADsDA;EACA,gBAAA;ACpDA;;AAEA,mCAAmC","file":"Head.vue","sourcesContent":["<template>\n  <thead v-if=\"TfTable.tableData.length\">\n    <tr>\n      <template v-for=\"column in TfTable.tableMeta.columns\">\n        <th\n          v-if=\"!column.hidden\"\n          :key=\"column.label\"\n          :width=\"column.width || 'auto'\"\n        >\n          <TfButton\n            v-if=\"column.sortable\"\n            :class=\"{ 'is-active': TfTable.sortColumn === column.prop }\"\n            :direction=\"TfTable.sortDirection\"\n            :selected=\"TfTable.sortColumn === column.prop\"\n            :data-test=\"`sort ${column.prop}`\"\n            type=\"table-sort\"\n            @click=\"TfTable.changeSortCriteria(column)\"\n          >\n            {{ column.label }}\n          </TfButton>\n          <span\n            v-else\n            :data-test=\"`header ${column && column.label ? column.label : 'label'}`\"\n            v-text=\"column.label\"\n          />\n        </th>\n      </template>\n      <th\n        v-if=\"TfTable.hasChildren\"\n        class=\"child-toggle\"\n        width=\"51\"\n      />\n    </tr>\n  </thead>\n</template>\n\n<script>\n  /**\n   * TfTableHead is a component that is used within the TfTable component and controls the th columns and its sorting logic.\n   *\n   * @vuedoc\n   * @exports TfTable/Head\n   * @category Components\n   */\n  export default {\n    name: 'TfTableHead',\n    inject: ['TfTable'],\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  th {\n    &.child-toggle {\n      padding: 0;\n    }\n\n    .tf-button {\n      font-weight: 700;\n    }\n  }\n</style>\n","th.child-toggle {\n  padding: 0;\n}\nth .tf-button {\n  font-weight: 700;\n}\n\n/*# sourceMappingURL=Head.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$X = "data-v-c30d9c88";
  /* module identifier */
  const __vue_module_identifier__$X = undefined;
  /* functional template */
  const __vue_is_functional_template__$X = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$X = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$U, staticRenderFns: __vue_staticRenderFns__$U },
    __vue_inject_styles__$X,
    __vue_script__$X,
    __vue_scope_id__$X,
    __vue_is_functional_template__$X,
    __vue_module_identifier__$X,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfTablePagination is a component that is used within the TfTable component and controls the template and logic for the table pagingation.
 *
 * @vuedoc
 * @exports TfTable/Pagination
 * @category Components
 */
var script$Y = {
  name: 'TfTablePagination',
  inject: ['TfTable'],
  computed: {
    /**
     * Evaluate the page limit and localPageSelected to show the first result count in the template.
     *
     * @returns {number}
     */
    countStart: function countStart() {
      return this.TfTable.localPageSelected * this.TfTable.pageLimit - this.TfTable.pageLimit + 1;
    },
    /**
     * Evaluate the page limit and countStart to show the final result count in the template.
     *
     * @returns {number}
     */
    countEnd: function countEnd() {
      var countEnd = this.countStart + this.TfTable.pageLimit;
      return countEnd > this.totalLength ? this.totalLength : countEnd - 1;
    },
    /**
     * Cache the filteredTableDataIndexes from the parent to be used through the template and logic.
     *
     * @returns {number}
     */
    totalLength: function totalLength() {
      return this.TfTable.filteredTableDataIndexes.length;
    }
  }
};

/* script */
const __vue_script__$Y = script$Y;

/* template */
var __vue_render__$V = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "container-pagination" },
    [
      _vm.TfTable.showPageResults
        ? _c("p", [
            _vm._v(
              "\n    Showing " +
                _vm._s(_vm.countStart) +
                "-" +
                _vm._s(_vm.countEnd) +
                " of " +
                _vm._s(_vm.totalLength) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.TfTable.tableRowIndexes.length
        ? _c(
            "TfPagination",
            _vm._b(
              { on: { input: _vm.TfTable.onPageSelected } },
              "TfPagination",
              {
                isDisabled: !_vm.TfTable.isLoaded || _vm.TfTable.isSorting,
                totalPages: _vm.TfTable.totalPages,
                value: _vm.TfTable.localPageSelected,
                truncatedPageRange: _vm.TfTable.truncatedPageRange,
              },
              false
            )
          )
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$V = [];
__vue_render__$V._withStripped = true;

  /* style */
  const __vue_inject_styles__$Y = function (inject) {
    if (!inject) return
    inject("data-v-07668192_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.container-pagination[data-v-07668192] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n.table + .container-pagination[data-v-07668192], .tf-table-footer + .container-pagination[data-v-07668192] {\n  margin-top: 15px;\n  margin-bottom: 0;\n}\n.pagination-container[data-v-07668192] {\n  margin-left: auto;\n}\np[data-v-07668192] {\n  margin-bottom: 0;\n  color: #999;\n}\n\n/*# sourceMappingURL=Pagination.vue.map */", map: {"version":3,"sources":["Pagination.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfTable/Pagination.vue"],"names":[],"mappings":"AAAA;;kCAEkC;ACgElC;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AD9DA;ACgEA;EAGA,gBAAA;EACA,gBAAA;ADhEA;ACqEA;EACA,iBAAA;ADlEA;ACqEA;EACA,gBAAA;EACA,WAAA;ADlEA;;AAEA,yCAAyC","file":"Pagination.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.container-pagination {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n.table + .container-pagination, .tf-table-footer + .container-pagination {\n  margin-top: 15px;\n  margin-bottom: 0;\n}\n\n.pagination-container {\n  margin-left: auto;\n}\n\np {\n  margin-bottom: 0;\n  color: #999;\n}\n\n/*# sourceMappingURL=Pagination.vue.map */","<template>\n  <div class=\"container-pagination\">\n    <p v-if=\"TfTable.showPageResults\">\n      Showing {{ countStart }}-{{ countEnd }} of {{ totalLength }}\n    </p>\n    <TfPagination\n      v-if=\"TfTable.tableRowIndexes.length\"\n      v-bind=\"{\n        isDisabled: !TfTable.isLoaded || TfTable.isSorting,\n        totalPages: TfTable.totalPages,\n        value: TfTable.localPageSelected,\n        truncatedPageRange: TfTable.truncatedPageRange,\n      }\"\n      @input=\"TfTable.onPageSelected\"\n    />\n  </div>\n</template>\n<script>\n  /**\n   * TfTablePagination is a component that is used within the TfTable component and controls the template and logic for the table pagingation.\n   *\n   * @vuedoc\n   * @exports TfTable/Pagination\n   * @category Components\n   */\n  export default {\n    name: 'TfTablePagination',\n    inject: ['TfTable'],\n    computed: {\n      /**\n       * Evaluate the page limit and localPageSelected to show the first result count in the template.\n       *\n       * @returns {number}\n       */\n      countStart() {\n        return (\n          (this.TfTable.localPageSelected * this.TfTable.pageLimit) - this.TfTable.pageLimit\n        ) + 1;\n      },\n      /**\n       * Evaluate the page limit and countStart to show the final result count in the template.\n       *\n       * @returns {number}\n       */\n      countEnd() {\n        const countEnd = this.countStart + this.TfTable.pageLimit;\n\n        return countEnd > this.totalLength\n          ? this.totalLength\n          : countEnd - 1;\n      },\n      /**\n       * Cache the filteredTableDataIndexes from the parent to be used through the template and logic.\n       *\n       * @returns {number}\n       */\n      totalLength() {\n        return this.TfTable.filteredTableDataIndexes.length;\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .container-pagination {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n\n    .table + &,\n    .tf-table-footer + & {\n      margin: {\n        top: 15px;\n        bottom: 0;\n      }\n    }\n  }\n\n  .pagination-container {\n    margin-left: auto;\n  }\n\n  p {\n    margin-bottom: 0;\n    color: $tf-medium-gray;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$Y = "data-v-07668192";
  /* module identifier */
  const __vue_module_identifier__$Y = undefined;
  /* functional template */
  const __vue_is_functional_template__$Y = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Y = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$V, staticRenderFns: __vue_staticRenderFns__$V },
    __vue_inject_styles__$Y,
    __vue_script__$Y,
    __vue_scope_id__$Y,
    __vue_is_functional_template__$Y,
    __vue_module_identifier__$Y,
    false,
    browser,
    undefined,
    undefined
  );

var script$Z = {
  name: 'TfTable',
  components: {
    TfChildRow: __vue_component__$U,
    TfChildTable: __vue_component__$V,
    TfTableFilters: __vue_component__$W,
    TfTableHead: __vue_component__$X,
    TfTablePagination: __vue_component__$Y
  },
  provide: function provide() {
    return {
      TfTable: this
    };
  },
  props: {
    /**
     * When provided, the table will run this function instead of the default sortObjects function.
     * This function will be passed the same arguments as the default sortObjects function.
     */
    customSort: {
      type: Function,
      default: null
    },
    /**
     * filterValues should be a URL encoded string if ever used.
     * required if `parentalControls` is true.
     */
    filterValues: {
      type: String,
      default: ''
    },
    /**
     * findIndexBy is a unique id for various logic to point to the original data.
     * Most data has an 'id' key so that's the default.
     */
    findIndexBy: {
      type: String,
      default: 'id'
    },
    /**
     * pageLimit sets the number of rows to show per page.
     */
    pageLimit: {
      type: Number,
      default: 50
    },
    /**
     * truncatedPageRange sets the max number of pages that can be displayed at once. Set to 0 to show all pages.
     * Number also needs to be odd in order to have the active page in the middle.
     */
    truncatedPageRange: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return Boolean(value % 2 || value === 0);
      }
    },
    /**
     * pageSelected dictates what page to show for paginated data.
     * required if `parentalControls` is true.
     */
    pageSelected: {
      type: Number,
      default: 1
    },
    /**
     * Setting `pagination` to `true` will evaluate various data/props and render a tfPagination component at the bottom and top of the table.
     */
    pagination: {
      type: Boolean,
      default: false
    },
    /**
     * `parentalControls` is really just the way to control the table via a route string.
     * Setting this to `true` will control filters updates, the selected page, and the sorting order.
     */
    parentalControls: {
      type: Boolean,
      default: false
    },
    /**
     * `showPageResults` will determine if the page results should be shown in the table pagination component.
     */
    showPageResults: {
      type: Boolean,
      default: false
    },
    /**
     * `showFilterLabel` will determine if the table filter component should render the default label.
     */
    showFilterLabel: {
      type: Boolean,
      default: false
    },
    /**
     * `tableData` is an array of objects to be evaluated and rendered in the table.
     */
    tableData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * `tableMeta` contains each column's metaData (like the `prop`, `label`, `sortable`, etc) and the table sort order and prop.
     */
    tableMeta: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data(vm) {
    return {
      expandedChildren: [],
      isSorting: false,
      isLoaded: false,
      filters: [],
      filteredTableDataIndexes: [],
      localPageSelected: vm.pageSelected,
      localFilterValues: {},
      sortColumn: null,
      sortDirection: null,
      sortProp: null,
      tableRows: [],
      tableRowIndexes: [],
      totalPages: 0
    };
  },
  computed: {
    /**
     * Evaulates the table data to see if any of the rows have children with length.
     *
     * @returns {boolean}
     */
    hasChildren: function hasChildren() {
      return this.tableData.some(function (rowData) {
        return rowData.children;
      });
    }
  },
  watch: {
    /**
     * Watch the filterValues prop to apply new values from the parent.
     */
    filterValues: function filterValues() {
      var filterValues = {};
      if (this.filterValues) {
        filterValues = JSON.parse(decodeURI(this.filterValues));
        Object.entries(filterValues).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          filterValues[key] = value;
        });
      }
      this.$set(this, 'localFilterValues', filterValues);
      this.sortData({
        updateData: true
      });
    },
    /**
     * Watcher for pageSelected from parent when using routes.
     *
     * @param {string} newPage
     */
    pageSelected: function pageSelected(newPage) {
      this.localPageSelected = newPage;
      this.setTableRows();
    },
    /**
     * Watch the tableData prop to sort any new data from the parent.
     */
    tableData: function tableData() {
      this.sortData({
        updateData: true
      });
    },
    /**
     * Update sortColumn, sortDirection, sortProp when using parental controls.
     * Then emit pageSelected and sort based on conditions.
     * Notes: When using $router.push({ params: pageSelected })
     * The sort can potentially be flagged as new as well
     * so we need to test the old/new props to prevent the sort from firing.
     *
     * @param {object} newValue
     * @param {string} newValue.direction
     * @param {string} newValue.prop
     * @param {object} oldValue
     * @param {string} oldValue.direction
     * @param {string} oldValue.prop
     *
     * @returns {void}
     */
    'tableMeta.sort': function tableMetaSort(_ref3, _ref4) {
      var direction = _ref3.direction,
        prop = _ref3.prop;
      var oldDirection = _ref4.direction,
        oldProp = _ref4.prop;
      if (oldDirection === direction && oldProp === prop) {
        return;
      }
      var reverseDirection = oldProp === prop;
      this.sortColumn = prop;
      this.sortDirection = direction;
      this.sortProp = prop;

      // If we need to reset the page here, we emit up pageSelected with 1.
      // The watcher for pageSelected will then sort the data.
      // If we don't need to reset the pageSelected, we sort the data.
      if (this.localPageSelected !== 1) {
        this.$emit('pageSelected', 1);
        this.sortData({
          updateData: !reverseDirection,
          reverseDirection: reverseDirection
        });
        return;
      }
      this.sortData({
        updateData: !reverseDirection,
        reverseDirection: reverseDirection
      });
    }
  },
  /**
   * On created, we want to set up the local sort and filter data appropriately.
   * Once all of that is taken care of, we wait for forceNextTick to sort all the data and loaded states.
   * the $nextTick() isn't working correctly and there's more info on https://github.com/vuejs/vue/issues/9200.
   */
  created: function created() {
    var _this = this;
    if (this.tableMeta.sort) {
      var _this$tableMeta$colum = this.tableMeta.columns.find(function (columnObj) {
          return (
            // If targeted sorting, we need to return the column where 'sortable' matches the sort prop.
            // Otherwise find column where the prop is is the sort prop.
            columnObj.sortable === _this.tableMeta.sort.prop || columnObj.prop === _this.tableMeta.sort.prop
          );
        }),
        prop = _this$tableMeta$colum.prop,
        sortable = _this$tableMeta$colum.sortable;
      var sortColumn = prop;
      var sortProp = prop;
      if (sortable && typeof sortable === 'string') {
        sortProp = sortable;
      }
      this.sortColumn = sortColumn;
      this.sortDirection = this.tableMeta.sort.direction;
      this.sortProp = sortProp;
    }

    // Check to see if any filters exist and create this.localFilterValues and this.filters
    var filters = this.tableMeta.columns.filter(function (_ref5) {
      var filter = _ref5.filter;
      return filter;
    });
    if (filters.length || this.filterValues) {
      // Create the localFilterValues
      var filterValues = Object.assign.apply(Object, [{}].concat(_toConsumableArray(filters.map(function (_ref6) {
        var prop = _ref6.prop;
        return _defineProperty({}, prop, []);
      }))));
      var existingFilters = {};

      // Override any empty values with filterValues prop.
      if (this.parentalControls && this.filterValues) {
        existingFilters = JSON.parse(decodeURI(this.filterValues));
        Object.entries(existingFilters).forEach(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
            key = _ref9[0],
            value = _ref9[1];
          filterValues[key] = value;
        });
      }
      this.$set(this, 'localFilterValues', filterValues);

      // Create the filters array
      filters = filters.map(function (_ref10, filterIndex) {
        var filter = _ref10.filter,
          label = _ref10.label,
          prop = _ref10.prop;
        // If no order is provided, the index will be applied
        // to the filter hierarchy
        var order = Number.isNaN(filter.order) ? filterIndex : filter.order;
        var type = filter.type;
        var options = filter.options;
        var dateType;

        // If no options are provided and the prop isn't string/range,
        // create an array of unique IDs and map with label/value
        if (!options && ['string', 'range'].includes(type)) {
          var uniqOptions = _toConsumableArray(new Set(_this.tableData.map(function (dataObj) {
            return dataObj[prop];
          }))).map(function (id) {
            var value = id || '';
            return {
              label: value,
              value: value
            };
          });
          options = _this.$TF.Formatting.sortObjects(uniqOptions, 'value');
        }
        if (['month', 'date-range', 'date-range-input'].includes(type)) {
          dateType = type;
        }
        if (type === 'month-and-date-range') {
          dateType = existingFilters[prop] && Array.isArray(existingFilters[prop][0]) ? 'date-range' : 'month';
        }
        return {
          dateType: dateType,
          label: label,
          options: options,
          order: order,
          popoverWidth: filter.popoverWidth,
          prop: prop,
          type: type,
          width: filter.width
        };
      });
      var sortedFilters = this.$TF.Formatting.sortObjects(filters, 'filterOrder');
      this.$set(this, 'filters', sortedFilters);
    }
    this.$forceNextTick(function () {
      _this.isLoaded = true;
      _this.sortData({
        updateData: true
      });
    });
  },
  methods: {
    /**
     * Change the sort criteria based on what was clicked.
     * This is a method that is triggered directly in the TfTableHead child component.
     *
     * @param {object} column
     */
    changeSortCriteria: function changeSortCriteria(column) {
      var sortColumn = column.prop;
      var reverseDirection = sortColumn === this.sortProp;
      var sortDirection = 'asc';
      var sortProp = sortColumn;
      if (column.sortable && typeof column.sortable === 'string') {
        sortProp = column.sortable;
      }
      if (sortProp === this.sortProp && this.sortDirection === 'asc') {
        sortDirection = 'desc';
      }
      this.$emit('changeSortCriteria', {
        sortDirection: sortDirection,
        sortProp: sortProp
      });

      // Escape if controlled by parent b/c watcher will handle updating the local props and sort.
      if (this.parentalControls) {
        return;
      }
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
      this.sortProp = sortProp;
      if (this.localPageSelected !== 1) {
        this.localPageSelected = 1;
      }
      this.sortData({
        updateData: !reverseDirection,
        reverseDirection: reverseDirection
      });
    },
    /**
     * Find the dateType key in the appropriate filter and change the passed param.
     * This is a method that is triggered directly in the TfTableFilters child component.
     *
     * @param {string} filterProp
     * @param {string} dateFilterType
     */
    onChangeDateFilterType: function onChangeDateFilterType(filterProp, dateFilterType) {
      var index = this.filters.findIndex(function (_ref11) {
        var prop = _ref11.prop;
        return prop === filterProp;
      });
      this.filters[index].dateType = dateFilterType;
    },
    /**
     * Change the values of the appropriate filter based on the passed params
     * and emits an encoded URI to the parent.
     * This is a method that is triggered directly in the TfTableFilters child component.
     *
     * @param {object} $event
     * @param {string} $event.prop
     * @param {string} $event.value
     */
    onChangeFilterValue: function onChangeFilterValue(_ref12) {
      var prop = _ref12.prop,
        _ref12$value = _ref12.value,
        value = _ref12$value === void 0 ? [] : _ref12$value;
      if (this.localPageSelected !== 1) {
        this.onPageSelected();
      }
      var filterValues = decodeURI(this.filterValues || '');
      var filters = filterValues ? JSON.parse(filterValues) : JSON.parse("{".concat(filterValues, "}"));
      filters[prop] = value;
      this.$emit('changeFilter', JSON.stringify(filters));

      /*
        Escape if controlled by parent.
        Watcher will handle updating the localFilter and sort.
      */
      if (this.parentalControls) {
        return;
      }
      this.$set(this.localFilterValues, [prop], value);
      this.sortData({
        updateData: true
      });
    },
    /**
     * Change the selected page and shows/hide the loader appropriately.
     * This is a method that is triggered directly in the TfTablePagination child component as well as throughout the component.
     *
     * @param {number} newPage
     */
    onPageSelected: function onPageSelected() {
      var newPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.$emit('pageSelected', newPage);

      /*
        Escape if controlled by parent.
        Watcher will handle updating the local page select and sort.
      */
      if (this.parentalControls) {
        return;
      }
      this.localPageSelected = newPage;
      this.setTableRows();
    },
    /**
     * Clears out each of the localFilterValues keys and emits to the parent.
     * This is a method that is triggered directly in the TfTableFilters child component.
     */
    onResetFilters: function onResetFilters() {
      var _this2 = this;
      Object.entries(this.localFilterValues).forEach(function (_ref13) {
        var _ref14 = _slicedToArray(_ref13, 1),
          key = _ref14[0];
        _this2.$set(_this2.localFilterValues, [key], []);
      });
      if (this.localPageSelected !== 1) {
        this.onPageSelected();
      }
      this.$emit('changeFilter');
      this.sortData({
        updateData: true
      });
    },
    /**
     * Pushes or removes the parent row ID from expandedChildren.
     * This is a method that is triggered directly in the TfTableParentRow child component.
     *
     * @param {number} parentRowId
     */
    toggleChildRow: function toggleChildRow(parentRowId) {
      if (this.expandedChildren.includes(parentRowId)) {
        this.$delete(this.expandedChildren, this.expandedChildren.findIndex(function (id) {
          return id === parentRowId;
        }));
        return;
      }
      this.expandedChildren.push(parentRowId);
    },
    /**
     * Set the tableRows according to the pagination.
     */
    setTableRows: function setTableRows() {
      var _this3 = this;
      this.isSorting = true;
      this.$forceNextTick(function () {
        var tableRowIndexes = !_this3.pagination ? _this3.filteredTableDataIndexes : _this3.filteredTableDataIndexes.slice((_this3.localPageSelected - 1) * _this3.pageLimit, _this3.localPageSelected * _this3.pageLimit);
        var totalPages = _this3.pagination ? Math.ceil(_this3.filteredTableDataIndexes.length / _this3.pageLimit) : null;
        _this3.$set(_this3, 'tableRowIndexes', tableRowIndexes);
        _this3.totalPages = totalPages;
        _this3.isSorting = false;
      });
    },
    /**
     * Sort the table data by appropriate filters and sorts.
     * If updateData is passed (usually on fresh load or if changing filters), we want to filter through the localFilterValues
     *
     * @param {boolean} updateData
     */
    sortData: function sortData(_ref15) {
      var _this4 = this;
      var _ref15$reverseDirecti = _ref15.reverseDirection,
        reverseDirection = _ref15$reverseDirecti === void 0 ? false : _ref15$reverseDirecti,
        _ref15$updateData = _ref15.updateData,
        updateData = _ref15$updateData === void 0 ? false : _ref15$updateData;
      this.isSorting = true;
      this.$forceNextTick(function () {
        var useFilteredIndex = reverseDirection && !updateData;
        var filteredTableData = useFilteredIndex ? _this4.filteredTableDataIndexes : _this4.tableData;
        if (updateData && Object.values(_this4.localFilterValues).length) {
          // 1. iterate through each filter
          _this4.filters.forEach(function (_ref16) {
            var dateType = _ref16.dateType,
              prop = _ref16.prop,
              type = _ref16.type;
            var values = _this4.localFilterValues[prop];
            if (values && values.length) {
              // 2. filter filteredTableData by prop
              filteredTableData = filteredTableData.filter(function (_ref17) {
                var dataValue = _ref17[prop];
                // 3. test the value to see if it is included
                var isIncluded;
                if (dataValue === null) {
                  isIncluded = false;
                } else if (type === 'string') {
                  isIncluded = values.includes(dataValue);
                } else if (type === 'array') {
                  isIncluded = values.every(function (val) {
                    return dataValue.includes(val);
                  });
                } else if (type === 'range') {
                  values.forEach(function (value) {
                    var _value$split$map = value.split(',').map(function (n) {
                        return Number(n);
                      }),
                      _value$split$map2 = _slicedToArray(_value$split$map, 2),
                      min = _value$split$map2[0],
                      max = _value$split$map2[1];
                    var isWithinRange = max && dataValue >= min && dataValue <= max;
                    var isOverMin = !max && dataValue >= min;
                    if (isWithinRange || isOverMin) {
                      isIncluded = true;
                    }
                  });
                } else if (dateType === 'month') {
                  var value = moment(values[0]);
                  var filterDate = moment(dataValue);
                  isIncluded = value.isSame(filterDate, 'month');
                } else if (['date-range-input', 'date-range'].includes(dateType)) {
                  var _value = moment(dataValue);
                  var _values$ = _slicedToArray(values[0], 2),
                    startDate = _values$[0],
                    endDate = _values$[1];
                  startDate = moment(startDate);
                  endDate = moment(endDate);

                  // https://momentjscom.readthedocs.io/en/latest/moment/05-query/06-is-between/
                  // moment().isBetween(moment-like, moment-like, String, String);
                  // where moment-like is Moment|String|Number|Date|Array
                  isIncluded = _value.isBetween(startDate, endDate, undefined, '[]');
                }
                return isIncluded;
              });
            }
          });
        }

        // use custom sort function if prop supplied or default sortObjects
        var sortFunction = _this4.customSort || _this4.$TF.Formatting.sortObjects;

        // 4. Sort the filtered table data by the correct prop/direction and map its
        // associated table data index.
        var filteredTableDataIndexes = useFilteredIndex ? filteredTableData.reverse() : sortFunction(filteredTableData, _this4.sortProp, _this4.sortDirection).map(function (row) {
          return _this4.tableData.findIndex(function (obj) {
            return obj[_this4.findIndexBy] === row[_this4.findIndexBy];
          });
        });
        _this4.$set(_this4, 'filteredTableDataIndexes', filteredTableDataIndexes);
        _this4.setTableRows();
      });
    }
  }
};

/* script */
const __vue_script__$Z = script$Z;

/* template */
var __vue_render__$W = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _vm.filters.length
        ? _c("TfTableFilters", {
            scopedSlots: _vm._u(
              [
                {
                  key: "emptyCell",
                  fn: function () {
                    return [
                      _vm._t("emptyCell", function () {
                        return [_vm._v("\n        —\n      ")]
                      }),
                    ]
                  },
                  proxy: true,
                },
                _vm.$slots.filterLabel || _vm.showFilterLabel
                  ? {
                      key: "filterLabel",
                      fn: function () {
                        return [
                          _vm._t("filterLabel", function () {
                            return [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.$slots.filterLabel || "Filters:") +
                                  "\n      "
                              ),
                            ]
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.tableData.length && (_vm.showPageResults || _vm.pagination)
        ? _c("TfTablePagination")
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.title || _vm.$slots.ctaHeader || _vm.$slots.header
        ? _c(
            "div",
            {
              staticClass: "tf-table-header",
              class: { "cta-only": !_vm.$slots.title && !_vm.$slots.header },
              attrs: { "data-test": "table header" },
            },
            [
              _vm._t("header", function () {
                return [
                  _vm.$slots.title ? _c("h2", [_vm._t("title")], 2) : _vm._e(),
                  _vm._v(" "),
                  _vm.$slots.ctaHeader
                    ? _c(
                        "div",
                        { staticClass: "btn-group" },
                        [_vm._t("ctaHeader")],
                        2
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "table table-parent" },
        [
          _c("TfTableHead"),
          _vm._v(" "),
          _c(
            "tbody",
            [
              !_vm.$slots.error && _vm.isLoaded && _vm.tableRowIndexes.length
                ? [
                    _vm._l(_vm.tableRowIndexes, function (tableDataIdx) {
                      return [
                        _vm.tableData[tableDataIdx]
                          ? [
                              _vm._t(
                                "parentRow",
                                function () {
                                  return [
                                    _c(
                                      "TfTableParentRow",
                                      _vm._b(
                                        {
                                          key: tableDataIdx,
                                          attrs: { "data-test": "table row" },
                                        },
                                        "TfTableParentRow",
                                        {
                                          rowData: _vm.tableData[tableDataIdx],
                                        },
                                        false
                                      ),
                                      _vm._l(
                                        _vm.tableMeta.columns,
                                        function (column) {
                                          return _c(
                                            "TfTableTd",
                                            _vm._b(
                                              {
                                                key: column.prop,
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "emptyCell",
                                                      fn: function () {
                                                        return [
                                                          _vm._t(
                                                            "emptyCell",
                                                            function () {
                                                              return [
                                                                _vm._v(
                                                                  "\n                      —\n                    "
                                                                ),
                                                              ]
                                                            }
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              "TfTableTd",
                                              {
                                                column: column,
                                                rowData:
                                                  _vm.tableData[tableDataIdx],
                                              },
                                              false
                                            )
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                },
                                null,
                                {
                                  columns: _vm.tableMeta.columns,
                                  isExpanded: _vm.expandedChildren.includes(
                                    _vm.tableData[tableDataIdx][_vm.findIndexBy]
                                  ),
                                  rowData: _vm.tableData[tableDataIdx],
                                }
                              ),
                              _vm._v(" "),
                              _vm.expandedChildren.includes(
                                _vm.tableData[tableDataIdx][_vm.findIndexBy]
                              ) &&
                              _vm.tableData[tableDataIdx].children &&
                              _vm.tableData[tableDataIdx].children.length
                                ? _vm._l(
                                    _vm.tableData[tableDataIdx].children,
                                    function (child) {
                                      return _c("TfChildTable", {
                                        key:
                                          child.columnKey + "-" + tableDataIdx,
                                        attrs: {
                                          colspan:
                                            _vm.tableMeta.columns.length + 1,
                                          "child-data": child,
                                          "child-columns":
                                            _vm.tableMeta.childColumns[
                                              child.columnKey
                                            ],
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "childTable",
                                              fn: function (ref) {
                                                var columns = ref.columns;
                                                var data = ref.data;
                                                return [
                                                  _vm._t(
                                                    "childTable",
                                                    function () {
                                                      return [
                                                        _c(
                                                          "table",
                                                          {
                                                            staticClass:
                                                              "table table-child",
                                                          },
                                                          [
                                                            _c("thead", [
                                                              _c(
                                                                "tr",
                                                                _vm._l(
                                                                  columns,
                                                                  function (
                                                                    column
                                                                  ) {
                                                                    return _c(
                                                                      "th",
                                                                      {
                                                                        key: column.label,
                                                                        attrs: {
                                                                          width:
                                                                            column.width,
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            textContent:
                                                                              _vm._s(
                                                                                column.label
                                                                              ),
                                                                          },
                                                                      }
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "tbody",
                                                              _vm._l(
                                                                child.data,
                                                                function (
                                                                  childRowData,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "TfChildRow",
                                                                    {
                                                                      key:
                                                                        child.columnKey +
                                                                        "-" +
                                                                        index,
                                                                      attrs: {
                                                                        "child-row-data":
                                                                          childRowData,
                                                                        "child-columns":
                                                                          _vm
                                                                            .tableMeta
                                                                            .childColumns[
                                                                            child
                                                                              .columnKey
                                                                          ],
                                                                      },
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    {
                                                      data: data,
                                                      columns: columns,
                                                    }
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    }
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ]
                    }),
                  ]
                : _c("tr", { staticClass: "is-empty" }, [
                    _c(
                      "td",
                      {
                        attrs: {
                          colspan: _vm.hasChildren
                            ? _vm.tableMeta.columns.length + 1
                            : _vm.tableMeta.columns.length,
                        },
                      },
                      [
                        !_vm.isLoaded || _vm.isSorting
                          ? _c("div", {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: true,
                                  expression: "true",
                                },
                              ],
                            })
                          : [
                              _vm.$slots.error
                                ? _c(
                                    "ElAlert",
                                    {
                                      attrs: {
                                        closable: false,
                                        "show-icon": "",
                                        type: "error",
                                      },
                                    },
                                    [_vm._t("error")],
                                    2
                                  )
                                : !_vm.tableData.length
                                ? _vm._t("empty", function () {
                                    return [
                                      _vm._v(
                                        "\n              There doesn't appear to be any data for this table.\n            "
                                      ),
                                    ]
                                  })
                                : _vm._t("noFilteredResults", function () {
                                    return [
                                      _vm._v(
                                        "\n              There doesn't appear to be any data that matches the selected filters.\n            "
                                      ),
                                    ]
                                  }),
                            ],
                      ],
                      2
                    ),
                  ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$slots.footer
        ? _c("div", { staticClass: "tf-table-footer" }, [_vm._t("footer")], 2)
        : _vm._e(),
      _vm._v(" "),
      _vm.tableData.length && (_vm.showPageResults || _vm.pagination)
        ? _c("TfTablePagination")
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$W = [];
__vue_render__$W._withStripped = true;

  /* style */
  const __vue_inject_styles__$Z = function (inject) {
    if (!inject) return
    inject("data-v-cf0a3b68_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tf-table-footer[data-v-cf0a3b68] {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 13px 20px;\n  border: 1px solid #c1c1c1;\n  border-top: 0;\n}\n.tf-table-header[data-v-cf0a3b68] {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 67px;\n  padding: 18px 20px;\n  border: 1px solid #c1c1c1;\n  border-bottom: 0;\n  border-radius: 6px 6px 0 0;\n}\n.tf-table-header.cta-only[data-v-cf0a3b68] {\n  justify-content: flex-end;\n}\ndiv[data-v-cf0a3b68] {\n  position: relative;\n}\nh2[data-v-cf0a3b68] {\n  margin-bottom: 0;\n}\n\n/*# sourceMappingURL=index.vue.map */", map: {"version":3,"sources":["index.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfTable/index.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC6uBlC;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;AD3uBA;AC8uBA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,gBAAA;EACA,0BAAA;AD7uBA;ACgvBA;EACA,yBAAA;AD9uBA;ACmvBA;EACA,kBAAA;ADhvBA;ACmvBA;EACA,gBAAA;ADhvBA;;AAEA,oCAAoC","file":"index.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\n.tf-table-footer {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 13px 20px;\n  border: 1px solid #c1c1c1;\n  border-top: 0;\n}\n.tf-table-header {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 67px;\n  padding: 18px 20px;\n  border: 1px solid #c1c1c1;\n  border-bottom: 0;\n  border-radius: 6px 6px 0 0;\n}\n.tf-table-header.cta-only {\n  justify-content: flex-end;\n}\n\ndiv {\n  position: relative;\n}\n\nh2 {\n  margin-bottom: 0;\n}\n\n/*# sourceMappingURL=index.vue.map */","<template>\n  <div>\n    <TfTableFilters v-if=\"filters.length\">\n      <template #emptyCell>\n        <slot name=\"emptyCell\">\n          &mdash;\n        </slot>\n      </template>\n      <template\n        v-if=\"$slots.filterLabel || showFilterLabel\"\n        #filterLabel\n      >\n        <slot name=\"filterLabel\">\n          {{ $slots.filterLabel || 'Filters:' }}\n        </slot>\n      </template>\n    </TfTableFilters>\n    <TfTablePagination v-if=\"tableData.length && (showPageResults || pagination)\" />\n    <div\n      v-if=\"$slots.title || $slots.ctaHeader || $slots.header\"\n      :class=\"{ 'cta-only' : (!$slots.title && !$slots.header) }\"\n      data-test=\"table header\"\n      class=\"tf-table-header\"\n    >\n      <slot name=\"header\">\n        <h2 v-if=\"$slots.title\">\n          <slot name=\"title\" />\n        </h2>\n        <div\n          v-if=\"$slots.ctaHeader\"\n          class=\"btn-group\"\n        >\n          <slot name=\"ctaHeader\" />\n        </div>\n      </slot>\n    </div>\n    <table class=\"table table-parent\">\n      <TfTableHead />\n      <tbody>\n        <template v-if=\"!$slots.error && isLoaded && tableRowIndexes.length\">\n          <template v-for=\"tableDataIdx in tableRowIndexes\">\n            <!--\n              Wrap b/c tableData[tableDataIdx] won't exist if data has been deleted from the parent.\n            -->\n            <template v-if=\"tableData[tableDataIdx]\">\n              <slot\n                name=\"parentRow\"\n                v-bind=\"{\n                  columns: tableMeta.columns,\n                  isExpanded: expandedChildren.includes(tableData[tableDataIdx][findIndexBy]),\n                  rowData: tableData[tableDataIdx],\n                }\"\n              >\n                <TfTableParentRow\n                  :key=\"tableDataIdx\"\n                  data-test=\"table row\"\n                  v-bind=\"{\n                    rowData: tableData[tableDataIdx],\n                  }\"\n                >\n                  <TfTableTd\n                    v-for=\"column in tableMeta.columns\"\n                    :key=\"column.prop\"\n                    v-bind=\"{\n                      column,\n                      rowData: tableData[tableDataIdx],\n                    }\"\n                  >\n                    <template #emptyCell>\n                      <slot name=\"emptyCell\">\n                        &mdash;\n                      </slot>\n                    </template>\n                  </TfTableTd>\n                </TfTableParentRow>\n              </slot>\n              <template\n                v-if=\"expandedChildren.includes(tableData[tableDataIdx][findIndexBy]) &&\n                  tableData[tableDataIdx].children &&\n                  tableData[tableDataIdx].children.length\"\n              >\n                <TfChildTable\n                  v-for=\"child in tableData[tableDataIdx].children\"\n                  :key=\"`${child.columnKey}-${tableDataIdx}`\"\n                  :colspan=\"tableMeta.columns.length + 1\"\n                  :child-data=\"child\"\n                  :child-columns=\"tableMeta.childColumns[child.columnKey]\"\n                >\n                  <template\n                    slot=\"childTable\"\n                    slot-scope=\"{ columns, data }\"\n                  >\n                    <slot\n                      name=\"childTable\"\n                      :data=\"data\"\n                      :columns=\"columns\"\n                    >\n                      <table class=\"table table-child\">\n                        <thead>\n                          <tr>\n                            <th\n                              v-for=\"column in columns\"\n                              :key=\"column.label\"\n                              :width=\"column.width\"\n                              v-text=\"column.label\"\n                            />\n                          </tr>\n                        </thead>\n                        <tbody>\n                          <TfChildRow\n                            v-for=\"(childRowData, index) in child.data\"\n                            :key=\"`${child.columnKey}-${index}`\"\n                            :child-row-data=\"childRowData\"\n                            :child-columns=\"tableMeta.childColumns[child.columnKey]\"\n                          />\n                        </tbody>\n                      </table>\n                    </slot>\n                  </template>\n                </TfChildTable>\n              </template>\n            </template>\n          </template>\n        </template>\n        <tr\n          v-else\n          class=\"is-empty\"\n        >\n          <td :colspan=\"hasChildren ? tableMeta.columns.length + 1 : tableMeta.columns.length\">\n            <div\n              v-if=\"!isLoaded || isSorting\"\n              v-loading=\"true\"\n            />\n            <template v-else>\n              <ElAlert\n                v-if=\"$slots.error\"\n                :closable=\"false\"\n                show-icon\n                type=\"error\"\n              >\n                <slot name=\"error\" />\n              </ElAlert>\n              <slot\n                v-else-if=\"!tableData.length\"\n                name=\"empty\"\n              >\n                There doesn't appear to be any data for this table.\n              </slot>\n              <slot\n                v-else\n                name=\"noFilteredResults\"\n              >\n                There doesn't appear to be any data that matches the selected filters.\n              </slot>\n            </template>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <div\n      v-if=\"$slots.footer\"\n      class=\"tf-table-footer\"\n    >\n      <slot name=\"footer\" />\n    </div>\n    <TfTablePagination v-if=\"tableData.length && (showPageResults || pagination)\" />\n  </div>\n</template>\n\n<script>\n  // components\n  import moment from 'moment';\n  import TfChildRow from './ChildRow';\n  import TfChildTable from './ChildTable';\n  import TfTableFilters from './Filters';\n  import TfTableHead from './Head';\n  import TfTablePagination from './Pagination';\n\n  export default {\n    name: 'TfTable',\n    components: {\n      TfChildRow,\n      TfChildTable,\n      TfTableFilters,\n      TfTableHead,\n      TfTablePagination,\n    },\n    provide() {\n      return {\n        TfTable: this,\n      };\n    },\n    props: {\n      /**\n       * When provided, the table will run this function instead of the default sortObjects function.\n       * This function will be passed the same arguments as the default sortObjects function.\n       */\n      customSort: {\n        type: Function,\n        default: null,\n      },\n      /**\n       * filterValues should be a URL encoded string if ever used.\n       * required if `parentalControls` is true.\n       */\n      filterValues: {\n        type: String,\n        default: '',\n      },\n      /**\n       * findIndexBy is a unique id for various logic to point to the original data.\n       * Most data has an 'id' key so that's the default.\n       */\n      findIndexBy: {\n        type: String,\n        default: 'id',\n      },\n      /**\n       * pageLimit sets the number of rows to show per page.\n       */\n      pageLimit: {\n        type: Number,\n        default: 50,\n      },\n      /**\n       * truncatedPageRange sets the max number of pages that can be displayed at once. Set to 0 to show all pages.\n       * Number also needs to be odd in order to have the active page in the middle.\n       */\n      truncatedPageRange: {\n        type: Number,\n        default: 0,\n        validator: (value) => Boolean(value % 2 || value === 0),\n      },\n      /**\n       * pageSelected dictates what page to show for paginated data.\n       * required if `parentalControls` is true.\n       */\n      pageSelected: {\n        type: Number,\n        default: 1,\n      },\n      /**\n       * Setting `pagination` to `true` will evaluate various data/props and render a tfPagination component at the bottom and top of the table.\n       */\n      pagination: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * `parentalControls` is really just the way to control the table via a route string.\n       * Setting this to `true` will control filters updates, the selected page, and the sorting order.\n       */\n      parentalControls: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * `showPageResults` will determine if the page results should be shown in the table pagination component.\n       */\n      showPageResults: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * `showFilterLabel` will determine if the table filter component should render the default label.\n       */\n      showFilterLabel: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * `tableData` is an array of objects to be evaluated and rendered in the table.\n       */\n      tableData: {\n        type: Array,\n        default: () => [],\n      },\n      /**\n       * `tableMeta` contains each column's metaData (like the `prop`, `label`, `sortable`, etc) and the table sort order and prop.\n       */\n      tableMeta: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n    data: (vm) => ({\n      expandedChildren: [],\n      isSorting: false,\n      isLoaded: false,\n      filters: [],\n      filteredTableDataIndexes: [],\n      localPageSelected: vm.pageSelected,\n      localFilterValues: {},\n      sortColumn: null,\n      sortDirection: null,\n      sortProp: null,\n      tableRows: [],\n      tableRowIndexes: [],\n      totalPages: 0,\n    }),\n    computed: {\n      /**\n       * Evaulates the table data to see if any of the rows have children with length.\n       *\n       * @returns {boolean}\n       */\n      hasChildren() {\n        return this.tableData.some((rowData) => rowData.children);\n      },\n    },\n    watch: {\n      /**\n       * Watch the filterValues prop to apply new values from the parent.\n       */\n      filterValues() {\n        let filterValues = {};\n\n        if (this.filterValues) {\n          filterValues = JSON.parse(decodeURI(this.filterValues));\n\n          Object.entries(filterValues).forEach(([key, value]) => {\n            filterValues[key] = value;\n          });\n        }\n\n        this.$set(this, 'localFilterValues', filterValues);\n        this.sortData({ updateData: true });\n      },\n      /**\n       * Watcher for pageSelected from parent when using routes.\n       *\n       * @param {string} newPage\n       */\n      pageSelected(newPage) {\n        this.localPageSelected = newPage;\n        this.setTableRows();\n      },\n      /**\n       * Watch the tableData prop to sort any new data from the parent.\n       */\n      tableData() {\n        this.sortData({ updateData: true });\n      },\n      /**\n       * Update sortColumn, sortDirection, sortProp when using parental controls.\n       * Then emit pageSelected and sort based on conditions.\n       * Notes: When using $router.push({ params: pageSelected })\n       * The sort can potentially be flagged as new as well\n       * so we need to test the old/new props to prevent the sort from firing.\n       *\n       * @param {object} newValue\n       * @param {string} newValue.direction\n       * @param {string} newValue.prop\n       * @param {object} oldValue\n       * @param {string} oldValue.direction\n       * @param {string} oldValue.prop\n       *\n       * @returns {void}\n       */\n      'tableMeta.sort': function (\n        { direction, prop },\n        { direction: oldDirection, prop: oldProp },\n      ) {\n        if (\n          oldDirection === direction\n          && oldProp === prop\n        ) {\n          return;\n        }\n\n        const reverseDirection = oldProp === prop;\n\n        this.sortColumn = prop;\n        this.sortDirection = direction;\n        this.sortProp = prop;\n\n        // If we need to reset the page here, we emit up pageSelected with 1.\n        // The watcher for pageSelected will then sort the data.\n        // If we don't need to reset the pageSelected, we sort the data.\n        if (this.localPageSelected !== 1) {\n          this.$emit('pageSelected', 1);\n          this.sortData({ updateData: !reverseDirection, reverseDirection });\n\n          return;\n        }\n\n        this.sortData({ updateData: !reverseDirection, reverseDirection });\n      },\n    },\n    /**\n     * On created, we want to set up the local sort and filter data appropriately.\n     * Once all of that is taken care of, we wait for forceNextTick to sort all the data and loaded states.\n     * the $nextTick() isn't working correctly and there's more info on https://github.com/vuejs/vue/issues/9200.\n     */\n    created() {\n      if (this.tableMeta.sort) {\n        const { prop, sortable } = this.tableMeta.columns.find((columnObj) => (\n          // If targeted sorting, we need to return the column where 'sortable' matches the sort prop.\n          // Otherwise find column where the prop is is the sort prop.\n          columnObj.sortable === this.tableMeta.sort.prop\n          || columnObj.prop === this.tableMeta.sort.prop\n        ));\n        const sortColumn = prop;\n        let sortProp = prop;\n\n        if (sortable && typeof sortable === 'string') {\n          sortProp = sortable;\n        }\n\n        this.sortColumn = sortColumn;\n        this.sortDirection = this.tableMeta.sort.direction;\n        this.sortProp = sortProp;\n      }\n\n      // Check to see if any filters exist and create this.localFilterValues and this.filters\n      let filters = this.tableMeta.columns.filter(({ filter }) => filter);\n\n      if (filters.length || this.filterValues) {\n        // Create the localFilterValues\n        const filterValues = Object.assign(\n          {},\n          ...filters.map(({ prop }) => ({ [prop]: [] })),\n        );\n        let existingFilters = {};\n\n        // Override any empty values with filterValues prop.\n        if (this.parentalControls && this.filterValues) {\n          existingFilters = JSON.parse(decodeURI(this.filterValues));\n\n          Object.entries(existingFilters).forEach(([key, value]) => {\n            filterValues[key] = value;\n          });\n        }\n        this.$set(this, 'localFilterValues', filterValues);\n\n        // Create the filters array\n        filters = filters.map(({ filter, label, prop }, filterIndex) => {\n          // If no order is provided, the index will be applied\n          // to the filter hierarchy\n          const order = Number.isNaN(filter.order)\n            ? filterIndex\n            : filter.order;\n          const { type } = filter;\n          let { options } = filter;\n          let dateType;\n\n          // If no options are provided and the prop isn't string/range,\n          // create an array of unique IDs and map with label/value\n          if (!options && ['string', 'range'].includes(type)) {\n            const uniqOptions = [\n              ...new Set(this.tableData.map((dataObj) => dataObj[prop])),\n            ].map((id) => {\n              const value = id || '';\n\n              return {\n                label: value,\n                value,\n              };\n            });\n\n            options = this.$TF.Formatting.sortObjects(uniqOptions, 'value');\n          }\n\n          if (['month', 'date-range', 'date-range-input'].includes(type)) {\n            dateType = type;\n          }\n\n          if (type === 'month-and-date-range') {\n            dateType = existingFilters[prop] && Array.isArray(existingFilters[prop][0])\n              ? 'date-range'\n              : 'month';\n          }\n\n          return {\n            dateType,\n            label,\n            options,\n            order,\n            popoverWidth: filter.popoverWidth,\n            prop,\n            type,\n            width: filter.width,\n          };\n        });\n\n        const sortedFilters = this.$TF.Formatting.sortObjects(filters, 'filterOrder');\n\n        this.$set(this, 'filters', sortedFilters);\n      }\n\n      this.$forceNextTick(() => {\n        this.isLoaded = true;\n        this.sortData({ updateData: true });\n      });\n    },\n    methods: {\n      /**\n       * Change the sort criteria based on what was clicked.\n       * This is a method that is triggered directly in the TfTableHead child component.\n       *\n       * @param {object} column\n       */\n      changeSortCriteria(column) {\n        const sortColumn = column.prop;\n        const reverseDirection = sortColumn === this.sortProp;\n        let sortDirection = 'asc';\n        let sortProp = sortColumn;\n\n        if (column.sortable && typeof column.sortable === 'string') {\n          sortProp = column.sortable;\n        }\n\n        if (sortProp === this.sortProp && this.sortDirection === 'asc') {\n          sortDirection = 'desc';\n        }\n\n        this.$emit('changeSortCriteria', {\n          sortDirection,\n          sortProp,\n        });\n\n        // Escape if controlled by parent b/c watcher will handle updating the local props and sort.\n        if (this.parentalControls) {\n          return;\n        }\n\n        this.sortColumn = sortColumn;\n        this.sortDirection = sortDirection;\n        this.sortProp = sortProp;\n\n        if (this.localPageSelected !== 1) {\n          this.localPageSelected = 1;\n        }\n\n        this.sortData({ updateData: !reverseDirection, reverseDirection });\n      },\n      /**\n       * Find the dateType key in the appropriate filter and change the passed param.\n       * This is a method that is triggered directly in the TfTableFilters child component.\n       *\n       * @param {string} filterProp\n       * @param {string} dateFilterType\n       */\n      onChangeDateFilterType(filterProp, dateFilterType) {\n        const index = this.filters.findIndex(({ prop }) => prop === filterProp);\n\n        this.filters[index].dateType = dateFilterType;\n      },\n      /**\n       * Change the values of the appropriate filter based on the passed params\n       * and emits an encoded URI to the parent.\n       * This is a method that is triggered directly in the TfTableFilters child component.\n       *\n       * @param {object} $event\n       * @param {string} $event.prop\n       * @param {string} $event.value\n       */\n      onChangeFilterValue({ prop, value = [] }) {\n        if (this.localPageSelected !== 1) {\n          this.onPageSelected();\n        }\n\n        const filterValues = decodeURI(this.filterValues || '');\n        const filters = filterValues\n          ? JSON.parse(filterValues)\n          : JSON.parse(`{${filterValues}}`);\n\n        filters[prop] = value;\n\n        this.$emit('changeFilter', JSON.stringify(filters));\n\n        /*\n          Escape if controlled by parent.\n          Watcher will handle updating the localFilter and sort.\n        */\n        if (this.parentalControls) {\n          return;\n        }\n\n        this.$set(this.localFilterValues, [prop], value);\n        this.sortData({ updateData: true });\n      },\n      /**\n       * Change the selected page and shows/hide the loader appropriately.\n       * This is a method that is triggered directly in the TfTablePagination child component as well as throughout the component.\n       *\n       * @param {number} newPage\n       */\n      onPageSelected(newPage = 1) {\n        this.$emit('pageSelected', newPage);\n\n        /*\n          Escape if controlled by parent.\n          Watcher will handle updating the local page select and sort.\n        */\n        if (this.parentalControls) {\n          return;\n        }\n\n        this.localPageSelected = newPage;\n        this.setTableRows();\n      },\n      /**\n       * Clears out each of the localFilterValues keys and emits to the parent.\n       * This is a method that is triggered directly in the TfTableFilters child component.\n       */\n      onResetFilters() {\n        Object.entries(this.localFilterValues).forEach(([key]) => {\n          this.$set(this.localFilterValues, [key], []);\n        });\n\n        if (this.localPageSelected !== 1) {\n          this.onPageSelected();\n        }\n\n        this.$emit('changeFilter');\n        this.sortData({ updateData: true });\n      },\n      /**\n       * Pushes or removes the parent row ID from expandedChildren.\n       * This is a method that is triggered directly in the TfTableParentRow child component.\n       *\n       * @param {number} parentRowId\n       */\n      toggleChildRow(parentRowId) {\n        if (this.expandedChildren.includes(parentRowId)) {\n          this.$delete(\n            this.expandedChildren,\n            this.expandedChildren.findIndex((id) => id === parentRowId),\n          );\n          return;\n        }\n\n        this.expandedChildren.push(parentRowId);\n      },\n      /**\n       * Set the tableRows according to the pagination.\n       */\n      setTableRows() {\n        this.isSorting = true;\n\n        this.$forceNextTick(() => {\n          const tableRowIndexes = !this.pagination\n            ? this.filteredTableDataIndexes\n            : this.filteredTableDataIndexes.slice(\n              (this.localPageSelected - 1) * this.pageLimit,\n              this.localPageSelected * this.pageLimit,\n            );\n          const totalPages = this.pagination\n            ? Math.ceil(this.filteredTableDataIndexes.length / this.pageLimit)\n            : null;\n\n          this.$set(this, 'tableRowIndexes', tableRowIndexes);\n          this.totalPages = totalPages;\n          this.isSorting = false;\n        });\n      },\n      /**\n       * Sort the table data by appropriate filters and sorts.\n       * If updateData is passed (usually on fresh load or if changing filters), we want to filter through the localFilterValues\n       *\n       * @param {boolean} updateData\n       */\n      sortData({\n        reverseDirection = false,\n        updateData = false,\n      }) {\n        this.isSorting = true;\n\n        this.$forceNextTick(() => {\n          const useFilteredIndex = reverseDirection && !updateData;\n          let filteredTableData = useFilteredIndex\n            ? this.filteredTableDataIndexes\n            : this.tableData;\n\n          if (updateData && Object.values(this.localFilterValues).length) {\n            // 1. iterate through each filter\n            this.filters.forEach(({ dateType, prop, type }) => {\n              const values = this.localFilterValues[prop];\n\n              if (values && values.length) {\n                // 2. filter filteredTableData by prop\n                filteredTableData = filteredTableData.filter(({ [prop]: dataValue }) => {\n                  // 3. test the value to see if it is included\n                  let isIncluded;\n\n                  if (dataValue === null) {\n                    isIncluded = false;\n                  } else if (type === 'string') {\n                    isIncluded = values.includes(dataValue);\n                  } else if (type === 'array') {\n                    isIncluded = values.every((val) => dataValue.includes(val));\n                  } else if (type === 'range') {\n                    values.forEach((value) => {\n                      const [min, max] = value.split(',').map((n) => Number(n));\n                      const isWithinRange = max && dataValue >= min && dataValue <= max;\n                      const isOverMin = !max && dataValue >= min;\n\n                      if (isWithinRange || isOverMin) {\n                        isIncluded = true;\n                      }\n                    });\n                  } else if (dateType === 'month') {\n                    const value = moment(values[0]);\n                    const filterDate = moment(dataValue);\n\n                    isIncluded = value.isSame(filterDate, 'month');\n                  } else if (['date-range-input', 'date-range'].includes(dateType)) {\n                    const value = moment(dataValue);\n                    let [startDate, endDate] = values[0];\n\n                    startDate = moment(startDate);\n                    endDate = moment(endDate);\n\n                    // https://momentjscom.readthedocs.io/en/latest/moment/05-query/06-is-between/\n                    // moment().isBetween(moment-like, moment-like, String, String);\n                    // where moment-like is Moment|String|Number|Date|Array\n                    isIncluded = value.isBetween(startDate, endDate, undefined, '[]');\n                  }\n\n                  return isIncluded;\n                });\n              }\n            });\n          }\n\n          // use custom sort function if prop supplied or default sortObjects\n          const sortFunction = this.customSort || this.$TF.Formatting.sortObjects;\n\n          // 4. Sort the filtered table data by the correct prop/direction and map its\n          // associated table data index.\n          const filteredTableDataIndexes = useFilteredIndex\n            ? filteredTableData.reverse()\n            : sortFunction(filteredTableData, this.sortProp, this.sortDirection)\n              .map((row) => (\n                this.tableData.findIndex((obj) => obj[this.findIndexBy] === row[this.findIndexBy])\n              ));\n\n          this.$set(this, 'filteredTableDataIndexes', filteredTableDataIndexes);\n\n          this.setTableRows();\n        });\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  .tf-table {\n    &-footer {\n      box-sizing: border-box;\n      display: flex;\n      justify-content: center;\n      width: 100%;\n      padding: 13px 20px;\n      border: 1px solid $tf-light-gray;\n      border-top: 0;\n    }\n\n    &-header {\n      box-sizing: border-box;\n      display: flex;\n      justify-content: space-between;\n      width: 100%;\n      min-height: 67px;\n      padding: 18px 20px;\n      border: 1px solid $tf-light-gray;\n      border: {\n        bottom: 0;\n        radius: 6px 6px 0 0;\n      }\n\n      &.cta-only {\n        justify-content: flex-end;\n      }\n    }\n  }\n\n  div {\n    position: relative;\n  }\n\n  h2 {\n    margin-bottom: 0;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$Z = "data-v-cf0a3b68";
  /* module identifier */
  const __vue_module_identifier__$Z = undefined;
  /* functional template */
  const __vue_is_functional_template__$Z = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Z = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$W, staticRenderFns: __vue_staticRenderFns__$W },
    __vue_inject_styles__$Z,
    __vue_script__$Z,
    __vue_scope_id__$Z,
    __vue_is_functional_template__$Z,
    __vue_module_identifier__$Z,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfTableParentRow is a component that is used as a child of the TfTable component. It will render a TfTableTd for each column by default.
 * It also controls the expansion logic for the row. If using #parentRow slot, the parent needs to account for showing an additional td when there are no children for the row but some data in the table does.
 *
 * @vuedoc
 * @exports TfTable/ParentRow
 * @category Components
 */
var script$_ = {
  name: 'TfTableParentRow',
  inject: ['TfTable'],
  props: {
    rowData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    /**
     * Evaluates the tables expanded children for this row's id.
     *
     * @returns {boolean}
     */
    isExpanded: function isExpanded() {
      return this.TfTable.expandedChildren.includes(this.rowData.id);
    },
    /**
     * Evaluates if the row has children.
     *
     * @returns {boolean}
     */
    rowHasChildren: function rowHasChildren() {
      return this.rowData.children && this.rowData.children.length;
    }
  }
};

/* script */
const __vue_script__$_ = script$_;

/* template */
var __vue_render__$X = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tr",
    { class: { "is-loading": _vm.TfTable.isSorting } },
    [
      _vm._t("default", function () {
        return _vm._l(_vm.TfTable.tableMeta.columns, function (column) {
          return _c(
            "TfTableTd",
            _vm._b(
              {
                key: column.prop,
                scopedSlots: _vm._u(
                  [
                    {
                      key: "emptyCell",
                      fn: function () {
                        return [
                          _vm._t("emptyCell", function () {
                            return [_vm._v("\n          —\n        ")]
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              },
              "TfTableTd",
              { column: column, rowData: _vm.rowData },
              false
            )
          )
        })
      }),
      _vm._v(" "),
      _vm.TfTable.hasChildren || _vm.rowHasChildren
        ? _c(
            "td",
            {
              staticClass: "cell-prop-toggle",
              class: { "show-toggle": _vm.rowHasChildren },
              attrs: { width: "50" },
            },
            [
              _vm.rowHasChildren
                ? _c("TfButton", {
                    class: [
                      "btn-toggle-row",
                      { "is-expanded": _vm.isExpanded },
                    ],
                    attrs: {
                      type: _vm.isExpanded ? "primary" : "secondary",
                      "no-border": true,
                      icon: "angle-up",
                      size: "icon-no-fill",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.TfTable.toggleChildRow(_vm.rowData.id)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$X = [];
__vue_render__$X._withStripped = true;

  /* style */
  const __vue_inject_styles__$_ = function (inject) {
    if (!inject) return
    inject("data-v-51eb5ec4_0", { source: "/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\ntr.is-loading[data-v-51eb5ec4] {\n  opacity: 0.5;\n}\n.cell-prop-toggle[data-v-51eb5ec4] {\n  position: relative;\n}\n.cell-prop-toggle.show-toggle[data-v-51eb5ec4] {\n  border-left: 1px solid #efefef;\n}\n.table-parent .cell-prop-toggle[data-v-51eb5ec4] {\n  padding: 0;\n}\n[data-v-51eb5ec4].tf-button.btn-toggle-row {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 50px;\n  min-height: 50px;\n  color: #42474c;\n}\n[data-v-51eb5ec4].tf-button.btn-toggle-row:hover {\n  border: none;\n}\n[data-v-51eb5ec4].tf-button.btn-toggle-row svg {\n  width: 22px;\n  height: 22px;\n  transition: transform 0.3s;\n}\n[data-v-51eb5ec4].tf-button.btn-toggle-row:not(.is-expanded) {\n  color: #009;\n}\n[data-v-51eb5ec4].tf-button.btn-toggle-row:not(.is-expanded) svg {\n  transform: rotateZ(180deg);\n}\n\n/*# sourceMappingURL=ParentRow.vue.map */", map: {"version":3,"sources":["ParentRow.vue","/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfTable/ParentRow.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC2ElC;EACA,YAAA;ADzEA;AC6EA;EACA,kBAAA;AD1EA;AC4EA;EACA,8BAAA;AD1EA;AC6EA;EACA,UAAA;AD3EA;AC+EA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EAGA,gBAAA;EACA,cAAA;AD9EA;ACgFA;EACA,YAAA;AD9EA;ACiFA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;AD/EA;ACkFA;EACA,WAAA;ADhFA;ACkFA;EACA,0BAAA;ADhFA;;AAEA,wCAAwC","file":"ParentRow.vue","sourcesContent":["/*********************************\n*    ThreeFlow Color Variables   *\n**********************************/\ntr.is-loading {\n  opacity: 0.5;\n}\n\n.cell-prop-toggle {\n  position: relative;\n}\n.cell-prop-toggle.show-toggle {\n  border-left: 1px solid #efefef;\n}\n.table-parent .cell-prop-toggle {\n  padding: 0;\n}\n\n::v-deep.tf-button.btn-toggle-row {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 50px;\n  min-height: 50px;\n  color: #42474c;\n}\n::v-deep.tf-button.btn-toggle-row:hover {\n  border: none;\n}\n::v-deep.tf-button.btn-toggle-row svg {\n  width: 22px;\n  height: 22px;\n  transition: transform 0.3s;\n}\n::v-deep.tf-button.btn-toggle-row:not(.is-expanded) {\n  color: #009;\n}\n::v-deep.tf-button.btn-toggle-row:not(.is-expanded) svg {\n  transform: rotateZ(180deg);\n}\n\n/*# sourceMappingURL=ParentRow.vue.map */","<template>\n  <tr :class=\"{ 'is-loading': TfTable.isSorting }\">\n    <slot>\n      <TfTableTd\n        v-for=\"column in TfTable.tableMeta.columns\"\n        :key=\"column.prop\"\n        v-bind=\"{ column, rowData }\"\n      >\n        <template #emptyCell>\n          <slot name=\"emptyCell\">\n            &mdash;\n          </slot>\n        </template>\n      </TfTableTd>\n    </slot>\n    <td\n      v-if=\"TfTable.hasChildren || rowHasChildren\"\n      width=\"50\"\n      class=\"cell-prop-toggle\"\n      :class=\"{ 'show-toggle': rowHasChildren }\"\n    >\n      <TfButton\n        v-if=\"rowHasChildren\"\n        :class=\"['btn-toggle-row', { 'is-expanded' : isExpanded }]\"\n        :type=\"isExpanded ? 'primary' : 'secondary'\"\n        :no-border=\"true\"\n        icon=\"angle-up\"\n        size=\"icon-no-fill\"\n        @click=\"TfTable.toggleChildRow(rowData.id)\"\n      />\n    </td>\n  </tr>\n</template>\n\n<script>\n  /**\n   * TfTableParentRow is a component that is used as a child of the TfTable component. It will render a TfTableTd for each column by default.\n   * It also controls the expansion logic for the row. If using #parentRow slot, the parent needs to account for showing an additional td when there are no children for the row but some data in the table does.\n   *\n   * @vuedoc\n   * @exports TfTable/ParentRow\n   * @category Components\n   */\n  export default {\n    name: 'TfTableParentRow',\n    inject: ['TfTable'],\n    props: {\n      rowData: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n    computed: {\n      /**\n       * Evaluates the tables expanded children for this row's id.\n       *\n       * @returns {boolean}\n       */\n      isExpanded() {\n        return this.TfTable.expandedChildren.includes(this.rowData.id);\n      },\n      /**\n       * Evaluates if the row has children.\n       *\n       * @returns {boolean}\n       */\n      rowHasChildren() {\n        return this.rowData.children && this.rowData.children.length;\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  tr {\n    &.is-loading {\n      opacity: .5;\n    }\n  }\n\n  .cell-prop-toggle {\n    position: relative;\n\n    &.show-toggle {\n      border-left: 1px solid $tf-extra-light-gray-1;\n    }\n\n    .table-parent & {\n      padding: 0;\n    }\n  }\n\n  ::v-deep.tf-button.btn-toggle-row {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 50px;\n    // min-height is here to fix an IE11 issue but since\n    // we only use the toggle on the admin site AND chrome, we don't need to fully fix this yet.\n    min-height: 50px;\n    color: $tf-dark-gray;\n\n    &:hover {\n      border: none;\n    }\n\n    svg {\n      width: 22px;\n      height: 22px;\n      transition: transform .3s;\n    }\n\n    &:not(.is-expanded) {\n      color: $tf-blue;\n\n      svg {\n        transform: rotateZ(180deg);\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$_ = "data-v-51eb5ec4";
  /* module identifier */
  const __vue_module_identifier__$_ = undefined;
  /* functional template */
  const __vue_is_functional_template__$_ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$_ = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$X, staticRenderFns: __vue_staticRenderFns__$X },
    __vue_inject_styles__$_,
    __vue_script__$_,
    __vue_scope_id__$_,
    __vue_is_functional_template__$_,
    __vue_module_identifier__$_,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfTableTd is a component that is used within the TfTable component and controls the template for the individual table data cell.
 *
 * @vuedoc
 * @exports TfTable/Td
 * @category Components
 */
var script$$ = {
  name: 'TfTableTd',
  props: {
    column: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    rowData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};

/* script */
const __vue_script__$$ = script$$;

/* template */
var __vue_render__$Y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "td",
    {
      class:
        "tf-table-td " +
        (_vm.column.prop ? "cell-prop-" + _vm.column.prop : ""),
    },
    [
      _vm._t("default", function () {
        return [
          _vm.rowData[_vm.column.prop]
            ? [
                _vm._v(
                  "\n      " + _vm._s(_vm.rowData[_vm.column.prop]) + "\n    "
                ),
              ]
            : _vm._t("emptyCell", function () {
                return [_vm._v("\n      —\n    ")]
              }),
        ]
      }),
    ],
    2
  )
};
var __vue_staticRenderFns__$Y = [];
__vue_render__$Y._withStripped = true;

  /* style */
  const __vue_inject_styles__$$ = undefined;
  /* scoped */
  const __vue_scope_id__$$ = undefined;
  /* module identifier */
  const __vue_module_identifier__$$ = undefined;
  /* functional template */
  const __vue_is_functional_template__$$ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$$ = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$Y, staticRenderFns: __vue_staticRenderFns__$Y },
    __vue_inject_styles__$$,
    __vue_script__$$,
    __vue_scope_id__$$,
    __vue_is_functional_template__$$,
    __vue_module_identifier__$$,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$10 = {
  name: 'TfTooltip',
  inheritAttrs: false,
  props: {
    appendToBody: {
      type: Boolean,
      default: false
    },
    closePosition: {
      type: Object,
      default: function _default() {
        return {
          top: 4,
          right: 4
        };
      }
    },
    customClass: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    forceShow: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showClose: {
      type: Boolean,
      default: false
    },
    transition: {
      type: String,
      default: 'tf-fade-in-linear'
    },
    trigger: {
      type: String,
      default: 'hover'
    }
  },
  data: function data() {
    return {
      showTooltip: false
    };
  },
  watch: {
    /**
     * Close the tooltip if showClose is changed from the parent.
     */
    showClose: function showClose() {
      if (!this.showClose) {
        this.$refs['tf-tooltip'].doClose();
      }
    }
  }
};

/* script */
const __vue_script__$10 = script$10;

/* template */
var __vue_render__$Z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "transition",
    { attrs: { name: _vm.transition } },
    [
      _c(
        "popper",
        _vm._g(
          _vm._b(
            {
              ref: "tf-tooltip",
              class: { "with-close": _vm.showClose },
              on: {
                show: function ($event) {
                  _vm.showTooltip = _vm.showClose;
                },
              },
            },
            "popper",
            Object.assign({}, _vm.$attrs, _vm.$props, {
              forceShow: _vm.forceShow || _vm.showTooltip,
            }),
            false
          ),
          _vm.$listeners
        ),
        [
          _c(
            "div",
            {
              staticClass: "tf-popper tf-tooltip wt-popper wt-tooltip",
              class: _vm.customClass,
            },
            [
              _c("div", [_vm._t("default")], 2),
              _vm._v(" "),
              _vm.showClose
                ? _c("TfButton", {
                    staticClass: "btn-popper-close",
                    style: {
                      top: _vm.closePosition.top + "px",
                      right: _vm.closePosition.right + "px",
                    },
                    attrs: {
                      icon: "times",
                      size: "icon-no-fill",
                      type: "primary",
                      "no-padding": "",
                      "data-test": "close tooltip",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$refs["tf-tooltip"].doClose()
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "reference" }, [_vm._t("reference")], 2),
        ],
        2
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$Z = [];
__vue_render__$Z._withStripped = true;

  /* style */
  const __vue_inject_styles__$10 = function (inject) {
    if (!inject) return
    inject("data-v-745c2484_0", { source: ".tf-popper.tf-tooltip,\n.wt-popper.wt-tooltip {\n  box-sizing: border-box;\n  padding: 10px;\n  font-size: 12px;\n  border-radius: 3px;\n}\n.btn-popper-close {\n  position: absolute;\n}\n\n/*# sourceMappingURL=TfTooltip.vue.map */", map: {"version":3,"sources":["/home/runner/work/ui/ui/vue2-packages/shared_ui/src/components/TfTooltip.vue","TfTooltip.vue"],"names":[],"mappings":"AA4GA;;EAEA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AC3GA;AD8GA;EACA,kBAAA;AC3GA;;AAEA,wCAAwC","file":"TfTooltip.vue","sourcesContent":["<template>\n  <transition :name=\"transition\">\n    <!--\n      v-on=\"$listeners\" is getting depricated in vue 3 so this will need to updated as well.\n      https://v3.vuejs.org/guide/migration/listeners-removed.html#listeners-removed\n    -->\n    <popper\n      ref=\"tf-tooltip\"\n      :class=\"{ 'with-close': showClose }\"\n      v-bind=\"{\n        ...$attrs,\n        ...$props,\n        forceShow: forceShow || showTooltip\n      }\"\n      v-on=\"$listeners\"\n      @show=\"showTooltip = showClose\"\n    >\n      <div\n        class=\"tf-popper tf-tooltip wt-popper wt-tooltip\"\n        :class=\"customClass\"\n      >\n        <div>\n          <slot />\n        </div>\n\n        <TfButton\n          v-if=\"showClose\"\n          :style=\"{\n            top: `${closePosition.top}px`,\n            right: `${closePosition.right}px`\n          }\"\n          class=\"btn-popper-close\"\n          icon=\"times\"\n          size=\"icon-no-fill\"\n          type=\"primary\"\n          no-padding\n          data-test=\"close tooltip\"\n          @click=\"$refs['tf-tooltip'].doClose()\"\n        />\n      </div>\n\n      <template slot=\"reference\">\n        <slot name=\"reference\" />\n      </template>\n    undefined>\n  </transition>\n</template>\n\n<script>\n  export default {\n    name: 'TfTooltip',\n    inheritAttrs: false,\n    props: {\n      appendToBody: {\n        type: Boolean,\n        default: false,\n      },\n      closePosition: {\n        type: Object,\n        default: () => ({\n          top: 4,\n          right: 4,\n        }),\n      },\n      customClass: {\n        type: Object,\n        default: () => ({}),\n      },\n      forceShow: {\n        type: Boolean,\n        default: false,\n      },\n      options: {\n        type: Object,\n        default: () => ({}),\n      },\n      showClose: {\n        type: Boolean,\n        default: false,\n      },\n      transition: {\n        type: String,\n        default: 'tf-fade-in-linear',\n      },\n      trigger: {\n        type: String,\n        default: 'hover',\n      },\n    },\n\n    data: () => ({\n      showTooltip: false,\n    }),\n\n    watch: {\n      /**\n       * Close the tooltip if showClose is changed from the parent.\n       */\n      showClose() {\n        if (!this.showClose) {\n          this.$refs['tf-tooltip'].doClose();\n        }\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\">\n  .tf-popper.tf-tooltip,\n  .wt-popper.wt-tooltip {\n    box-sizing: border-box;\n    padding: 10px;\n    font-size: 12px;\n    border-radius: 3px;\n  }\n\n  .btn-popper-close {\n    position: absolute;\n  }\n</style>\n",".tf-popper.tf-tooltip,\n.wt-popper.wt-tooltip {\n  box-sizing: border-box;\n  padding: 10px;\n  font-size: 12px;\n  border-radius: 3px;\n}\n\n.btn-popper-close {\n  position: absolute;\n}\n\n/*# sourceMappingURL=TfTooltip.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$10 = undefined;
  /* module identifier */
  const __vue_module_identifier__$10 = undefined;
  /* functional template */
  const __vue_is_functional_template__$10 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$10 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$Z, staticRenderFns: __vue_staticRenderFns__$Z },
    __vue_inject_styles__$10,
    __vue_script__$10,
    __vue_scope_id__$10,
    __vue_is_functional_template__$10,
    __vue_module_identifier__$10,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$11 = {
  name: 'ThreeflowWordmark',
  props: {
    fillColor: {
      type: String,
      default: '#00b980'
    }
  }
};

/* script */
const __vue_script__$11 = script$11;

/* template */
var __vue_render__$_ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 450 100",
        width: "306",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("title", [_vm._v("Threeflow")]),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M405.1,49.85c-3.3,0-4,3.6-4,8.69,0,6.69,1.3,12.49,3.8,17.48,2.8-5,4.1-11.49,4.1-17.68,0-4.5-.5-8.49-3.9-8.49Zm-104.3-28.57c0-4.1,2.3-7.39,6.19-7.39,2.9,0,4.6,1.8,4.6,4.3,0,3.5-2.7,5.39-7.39,5.39h-7.79l-4.4-.1h-48.15V98.9h16.08v-28.57h19.28v-14.69h-19.28v-17.98h30.67l3.3-.1h7.79c13.09,0,24.08-5.69,24.08-18.68,0-10.69-7.39-17.88-18.98-17.88-13.59,0-21.98,10.49-21.98,23.28V98.9h15.98V21.28Zm136.86,18.38c4,9.29,6.09,18.48,6.09,28.17,0,18.58-7.59,32.07-24.38,32.07-5.39,0-10.29-1.6-14.69-4.8-4.4,3.2-9.49,4.8-15.09,4.8-16.58,0-23.28-12.89-23.28-31.77,0-9.69,2-18.68,6.09-28.47h15.78c-3.9,10.19-6.19,17.48-6.19,27.57s2.2,18.28,10.09,18.28c1.3,0,2.6-.2,3.7-.6-4.2-7.59-6.29-16.58-6.29-25.47,0-14.19,5.19-21.28,15.58-21.28,11.09,0,15.48,8.29,15.48,21.18,0,9.09-2.2,17.98-6.79,25.67,1.3,.4,2.6,.5,3.6,.5,8.09,0,10.69-8.39,10.69-19.08,0-9.39-2.2-16.48-6.19-26.77h15.78Zm-103.8,12.89c-7.09,0-10.59,5.49-10.59,16.38s3.5,16.18,10.49,16.18,10.59-5.49,10.59-16.38-3.5-16.18-10.49-16.18Zm-.1,47.35c-17.58,0-26.57-11.29-26.57-30.27s8.49-31.67,26.87-31.67,26.37,11.59,26.37,30.27-8.19,31.67-26.67,31.67Zm-129.57-28.77c.9,9.59,5.19,14.49,14.89,14.49,6.49,0,12.49-2.1,17.98-6.39v14.89c-5.29,3.8-13.49,5.79-20.48,5.79-18.28,0-28.57-11.09-28.57-30.67,0-17.88,8.59-31.27,25.37-31.27,15.78,0,23.88,11.59,23.88,29.37,0,1.7-.1,3.9-.3,6.49h-34.17v-11.49h18.98c-.4-6.49-2.7-10.99-8.29-10.99s-8.69,4.2-9.29,13.09v6.69Zm-54.85,0c.9,9.59,5.19,14.49,14.89,14.49,6.49,0,12.49-2.1,17.98-6.39v14.89c-5.29,3.8-13.49,5.79-20.48,5.79-18.28,0-28.57-11.09-28.57-30.67,0-17.88,8.59-31.27,25.37-31.27,15.78,0,23.88,11.59,23.88,29.37,0,1.7-.1,3.9-.3,6.49h-34.17v-11.49h18.98c-.4-6.49-2.7-10.99-8.29-10.99s-8.69,4.2-9.29,13.09v6.69Zm-17.88-16.38c-5.19,.2-10.09,.8-14.49,3.1v40.96l-15.98,.1V39.66h15.68v8.49c3.4-4.8,8.69-8.59,14.79-9.59v16.18ZM16.88,36.66v62.24h16.18V36.66h21.98l3.1-.1h4.3c13.09,0,24.08-5.69,24.08-18.68,0-10.69-7.39-17.88-18.98-17.88-13.59,0-21.98,10.49-21.98,23.28l-.1,75.63h15.98V58.34c2.2-2.8,5.89-4.6,9.39-4.6,5.19,0,6.79,3,6.79,7.89v37.26h15.98V58.74c0-11.69-5.99-19.28-16.48-19.28-6.09,0-12.29,2.8-15.68,6.59l.1-25.77c0-4.1,2.3-7.39,6.19-7.39,2.9,0,4.6,1.8,4.6,4.3,0,3.5-2.7,5.39-7.39,5.39h-7.39l-2.2-.1H0v14.19H16.88Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M437.42,28.97c0-3.58,2.63-6.28,6.38-6.28s6.55,2.7,6.55,6.22-2.7,6.32-6.55,6.32-6.38-2.63-6.38-6.25Zm11.38,0c0-2.89-2.11-4.97-5-4.97s-4.84,2.07-4.84,4.97,2.04,5,4.84,5,5-2.01,5-5Zm-4.64-3.55c1.35,0,2.2,.66,2.2,1.84,0,1.02-.53,1.61-1.15,1.88,.23,.1,.36,.33,.43,.49l1.25,2.73h-1.48l-1.05-2.3c-.13-.36-.26-.46-.53-.46h-.95v2.76h-1.28v-6.94h2.57Zm.79,1.97c0-.82-.56-.92-1.35-.92h-.72v2.04h.89c.79,0,1.18-.39,1.18-1.12Z",
          fill: _vm.fillColor,
        },
      }),
    ]
  )
};
var __vue_staticRenderFns__$_ = [];
__vue_render__$_._withStripped = true;

  /* style */
  const __vue_inject_styles__$11 = undefined;
  /* scoped */
  const __vue_scope_id__$11 = undefined;
  /* module identifier */
  const __vue_module_identifier__$11 = undefined;
  /* functional template */
  const __vue_is_functional_template__$11 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$11 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$_, staticRenderFns: __vue_staticRenderFns__$_ },
    __vue_inject_styles__$11,
    __vue_script__$11,
    __vue_scope_id__$11,
    __vue_is_functional_template__$11,
    __vue_module_identifier__$11,
    false,
    undefined,
    undefined,
    undefined
  );

// Solution for https://github.com/vuejs/vue/issues/9200
/* eslint-disable consistent-return */
var doubleRequestAnimationFrame = function doubleRequestAnimationFrame(callback) {
  requestAnimationFrame(function () {
    requestAnimationFrame(callback);
  });
};
var forceNextTick = function forceNextTick(callback) {
  if (callback && typeof callback === 'function') {
    doubleRequestAnimationFrame(callback);
  } else {
    return new Promise(function (resolve) {
      doubleRequestAnimationFrame(resolve);
    });
  }
};
/* eslint-enable consistent-return */

var VueForceNextTick = {
  /**
   * Expose $forceNextTick to be used.
   *
   * @param {object} Vue
   */
  install: function install(Vue) {
    /* eslint-disable no-param-reassign */
    Vue.$forceNextTick = forceNextTick;
    Vue.prototype.$forceNextTick = forceNextTick;
    /* eslint-enable no-param-reassign */
  }
};

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Analytics = {
  /**
   * Initalize Segment/ Analytics.js, and store the 'messageId' that comes from each page call that we make
   *
   * @deprecated use initializeSegment named export instead
   * @param {string} segmentToken
   */
  initalizeSegment: function initalizeSegment(segmentToken) {
    /* eslint-disable */
    // The following block was taken from segments website: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/
    var analytics = window.analytics = window.analytics || [];
    if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice.");else {
      analytics.invoked = !0;
      analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on", "addSourceMiddleware", "addIntegrationMiddleware", "setAnonymousId", "addDestinationMiddleware"];
      analytics.factory = function (e) {
        return function () {
          var t = Array.prototype.slice.call(arguments);
          t.unshift(e);
          analytics.push(t);
          return analytics;
        };
      };
      for (var e = 0; e < analytics.methods.length; e++) {
        var key = analytics.methods[e];
        analytics[key] = analytics.factory(key);
      }
      analytics.load = function (key, e) {
        var t = document.createElement("script");
        t.type = "text/javascript";
        t.async = !0;
        t.src = "https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
        var n = document.getElementsByTagName("script")[0];
        n.parentNode.insertBefore(t, n);
        analytics._loadOptions = e;
      };
      analytics._writeKey = segmentToken;
      analytics.SNIPPET_VERSION = "4.15.3";
      analytics.load(segmentToken);
      analytics.page();
    }
    /* eslint-enable */

    // Analytics Middleware Documenation: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/middleware/
    analytics.addSourceMiddleware(function (_ref2) {
      var payload = _ref2.payload,
        next = _ref2.next;
      if (payload.obj.type === 'page') {
        // everytime a "trackPage" call is made, we want to store the messageId that is returned (we'll use this to link "page"" events to "track" events)
        window.sessionStorage.setItem('segmentPageMessageId', payload.obj.messageId);
      }
      next(payload);
    });
  },
  /**
   * When windows.analytics is available, collect various user properties to be
   * delivered for threeflow analytics (Intercom, log rocket, etc).
   *
   * @param {object} userInfo
   */
  identify: function identify() {
    var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (window.analytics) {
      var orgName;
      if (userInfo.broker) {
        orgName = userInfo.broker.name;
      } else if (userInfo.carrier) {
        orgName = userInfo.carrier.name;
      }
      var payload = _objectSpread$5(_objectSpread$5({}, userInfo), {}, {
        org_name: orgName,
        roles: userInfo.roles ? userInfo.roles.map(function (_ref3) {
          var name = _ref3.name;
          return name;
        }).join(', ') : '',
        Site: window.location.hostname.match(/^[a-z0-9]+/i)[0].toLowerCase()
      });
      window.analytics.identify(userInfo.id, payload);
    }
  },
  /**
   * Track page view
   *
   * @param {string} route
   * @param {object} payload
   */
  trackPage: function trackPage(route, payload) {
    if (window.analytics) {
      window.analytics.page(route, payload);
    }
  },
  /**
   * Track custom event
   *
   * @param {string} eventName
   * @param {object} payload
   */
  trackEvent: function trackEvent(eventName, payload) {
    if (window.analytics) {
      window.analytics.track(eventName, _objectSpread$5(_objectSpread$5({
        broker_id: null,
        employer_id: null,
        project_id: null,
        project_product_id: null,
        product_type_id: null,
        product_id: null,
        carrier_id: null,
        document_id: null,
        project_products_container_id: null,
        rate_attribute_id: null,
        rate_value_id: null,
        plan_design_attribute_id: null,
        plan_design_value_id: null,
        user_broker_id: null,
        user_carrier_id: null,
        target_carrier_id: null,
        target_broker_id: null,
        target_user_id: null,
        target_email: null
      }, payload), {}, {
        page_message_id: window.sessionStorage.getItem('segmentPageMessageId') // add the stored "segmentPageMessageId" to each payload for every tracked event
      }));
    }
  }
};

var Cookies = {
  /**
   * Look a cookie and return results
   *
   * @param {string} cname
   * @returns {string}
   */
  getCookie: function getCookie(cname) {
    var name = "".concat(cname, "=");
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i += 1) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  },
  /**
   * Delete a specfic cookie
   *
   * @param {string} name
   */
  deleteCookie: function deleteCookie(name) {
    var domain = '';
    if (process.env.NODE_ENV !== 'development') {
      domain = "domain=".concat(window.location.href.replace(/^(?:https?:\/\/)?(?:[^/]+\.)?([^./]+\.[^./]+).*$/, '$1'), ";");
    }
    document.cookie = "".concat(name, "=; ").concat(domain, " path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;");

    /*
      TODO: REMOVE THIS NEXT SNIPPET
      We want this in place to remove any "old" cookies,
      but we really only need it until they expire (every 24 hours)
      so by the time *you* read this, you can remove it
    */
    if (process.env.NODE_ENV !== 'development') {
      document.cookie = "".concat(name, "=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;");
    }
  },
  /**
   * Set a cookie
   *
   * @param {string} name
   * @param {string} value
   * @param {Date} expirationDate
   */
  setCookie: function setCookie(name, value) {
    var expirationDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    var domain = process.env.NODE_ENV !== 'testing' ? window.location.hostname : 'localhost';
    var cookie = "".concat(name, "=").concat(value, "; expires=").concat(expirationDate.toUTCString(), "; path=/; secure;");
    if (process.env.NODE_ENV !== 'development') {
      cookie += " domain=".concat(domain);
    }
    document.cookie = cookie;
  }
};

var AxiosConfig = {
  /**
   * Get the configuration to pass to an axios call (really just adding the auth token)
   *
   * @param {string} cookieNameSpace
   * @returns {object}
   */
  getConfig: function getConfig(cookieNameSpace) {
    var authToken;
    if (cookieNameSpace) {
      authToken = Cookies.getCookie("".concat(cookieNameSpace, "-auth-token"));
    } else {
      authToken = Cookies.getCookie('auth-token');
    }
    return {
      headers: {
        'X-API-AUTHTOKEN': "".concat(authToken)
      }
    };
  }
};

var BrowserUtils = {
  /**
   * Is the user using internet exploer
   *
   * @returns {boolean}
   */
  isIE: function isIE() {
    return !Vue.prototype.$isServer && !Number.isNaN(Number(document.documentMode));
  },
  /**
   * Is the user using edge
   *
   * @returns {boolean}
   */
  isEdge: function isEdge() {
    return !Vue.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
  }
};

moment.locale('us');
var DatesUtils = {
  /**
   * Check if this a valid date in the format of MM/DD/YYYY
   *
   * @param {string} dateString
   * @returns {boolean}
   */
  isDateValid: function isDateValid(dateString) {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
      return false;
    }

    // Parse the date parts to integers
    var parts = dateString.split('/');
    var day = Number(parts[1]);
    var month = Number(parts[0]);
    var year = Number(parts[2]);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month === 0 || month > 12) {
      return false;
    }
    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || year % 100 !== 0 && year % 4 === 0) {
      monthLength[1] = 29;
    }

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  },
  /**
   * Convert a UTC javascript date to the local timezone
   * All dates from the server are in UTC format,
   * however they are not all being sent that way so we need to check.
   *
   * @param {string} dateString
   * @returns {Date}
   */
  convertUTCDateToLocalDate: function convertUTCDateToLocalDate(dateString) {
    var isUTCFormat = dateString.charAt(dateString.length - 1) === 'Z';
    var UTCDateString = isUTCFormat ? dateString : "".concat(dateString, "Z");
    var newDate = new Date(UTCDateString);
    return newDate;
  },
  /**
   * Format the ISO date to be human readable time
   *
   * @param {string} dateString
   * @returns {string}
   */
  formatDateAndTime: function formatDateAndTime(dateString) {
    if (!dateString) {
      return '';
    }
    var date = this.convertUTCDateToLocalDate(dateString);
    return moment(date).format('MM/DD/YY h:mma');
  },
  /**
   * Format the ISO date to be human readable dates. If the date string that is passed is NOT in the "YYYY-MM-DD" format, we convert it the local date. RFP Table is one instance has logic for this.
   *
   * @param {string} dateString
   * @param {string} outputFormat
   * @returns {string}
   */
  formatSimpleDate: function formatSimpleDate() {
    var dateString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var outputFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MMMM Do, YYYY';
    if (!dateString) {
      return '';
    }
    var isDateTime = !moment(dateString, 'YYYY-MM-DD', true).isValid();
    var date = isDateTime ? this.convertUTCDateToLocalDate(dateString) : dateString;
    return moment(date).format(outputFormat);
  }
};

// 20.1.2.3 Number.isInteger(number)

var floor$3 = Math.floor;
var _isInteger = function isInteger(it) {
  return !_isObject(it) && isFinite(it) && floor$3(it) === it;
};

// 20.1.2.3 Number.isInteger(number)


_export(_export.S, 'Number', { isInteger: _isInteger });

var Formatting = {
  /**
   * Create an object of an array.
   *
   * @param {Array} array - The array to sort.
   * @param {string} key - The name of the key that will be used as the root parent key
   * @returns {object}
   */
  arrayToObject: function arrayToObject(array) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(array.map(function (obj) {
      return _defineProperty({}, obj[key], obj);
    }))));
  },
  /**
   * Rollup Values
   *
   * @param {Array} array
   * @returns {Array} ranges
   */
  getRanges: function getRanges(array) {
    var ranges = [];
    var rstart;
    var rend;
    for (var i = 0; i < array.length; i += 1) {
      rstart = array[i];
      rend = rstart;
      while (array[i + 1] - array[i] === 1) {
        rend = array[i + 1]; // increment the index if the numbers sequential
        i += 1;
      }
      ranges.push(rstart === rend ? "".concat(rstart) : "".concat(rstart, "-").concat(rend));
    }
    return ranges;
  },
  /**
   * Format a number with a bunch of options
   *
   * @param {number} amount
   * @param {string} prepend
   * @param {string} append
   * @param {number} decimalCountParam
   * @param {boolean} showZeroes
   * @param {string} decimalParam
   * @param {string} thousands
   * @returns {string}
   */
  formatNumber: function formatNumber(amount) {
    var prepend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var append = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var decimalCountParam = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
    var showZeroes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var decimalParam = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '.';
    var thousands = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ',';
    try {
      var absDecimalCount = Math.abs(decimalCountParam);
      var decimalCount = Number.isNaN(absDecimalCount) ? 2 : absDecimalCount;
      var integers = parseInt(Math.abs(Number(amount) || 0).toFixed(decimalCount), 10).toString();
      var integersSplit = integers.length > 3 ? integers.length % 3 : 0;
      var negativeSign = amount < 0 ? '-' : '';
      var decimals = decimalCount ? decimalParam + Math.abs(amount - integers).toFixed(decimalCount).slice(-decimalCount) : '';
      if (!showZeroes) {
        // trim zeroes
        decimals = decimals.replace(/0+$/, '');
        if (decimals.length === 1) {
          // if there's only a period left
          decimals = '';
        }
      }
      return negativeSign + prepend + (integersSplit ? integers.substr(0, integersSplit) + thousands : '') + integers.substr(integersSplit).replace(/(\d{3})(?=\d)/g, "$1".concat(thousands)) + decimals + append;
    } catch (error) {
      return amount;
    }
  },
  /**
   * Sort an array of objects
   *
   * @param {Array} array - The array to sort.
   * @param {string} sortKey - The name of the key that will be used to sort.
   * @param {string} sortDirection - 'asc' || 'desc'
   * I looked into adding an `isDate` here but looking through
   * https://stackoverflow.com/questions/10123953/how-to-sort-an-array-by-a-date-property,
   * using `dateA - dateB` is more of a memory hog.
   * @returns {Array}
   */
  sortObjects: function sortObjects(array) {
    var sortKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'name';
    var sortDirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'asc';
    return _toConsumableArray(array).sort(function (a, b) {
      var keyA = a[sortKey];
      var keyB = b[sortKey];
      if (sortDirection === 'desc') {
        keyA = b[sortKey];
        keyB = a[sortKey];
      }

      // The the value to sort by is an integer, subtract.
      if (Number.isInteger(keyA) && Number.isInteger(keyB)) {
        return keyA - keyB;
      }

      // The the value exists (not undefined, null, etc, uppercase strings to test.
      if (typeof keyA === 'string' && typeof keyB === 'string') {
        keyA = keyA.toUpperCase();
        keyB = keyB.toUpperCase();
      }
      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
  }
};

/**
 * Product Utility File
 *
 * @exports utils/product
 * @category Utils
 */

/**
 * Evaluate the product object and key that is passed to determine if the object passed is a stop loss product.
 *
 * @param {object} product
 * @param {string} key
 * @returns {boolean}
 */
var isStopLoss = function isStopLoss(product) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'product_type_name';
  return product[key].toLowerCase() === 'stop loss';
};
var Product = {
  isStopLoss: isStopLoss
};

/**
 * The human readable references to the type values we get from our API
 */
var projectTypes = {
  initialBuild: 'Projects::InitialEmployerBuild',
  coverageBuild: 'Projects::CoverageBuild',
  policyAudit: 'Projects::PolicyAudit',
  goToMarket: 'Projects::RfpPlacementEvent',
  renewal: 'Projects::RenewalPlacementEvent',
  isBuildType: function isBuildType(type) {
    return [projectTypes.initialBuild, projectTypes.coverageBuild].includes(type);
  }
};

/**
 * Reusable Data Utils
 *
 * @vuedoc
 * @exports ReusableData
 * @category Utils
 */
var ReusableData = {
  /**
   * Return a list of Months
   *
   * @returns {Array}
   */
  getMonths: function getMonths() {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months;
  },
  /**
   * Whether a subtype should default to compund
   *
   * @param {string} subtypeLabel
   * @returns {string}
   */
  getCompoundBySubtype: function getCompoundBySubtype(subtypeLabel) {
    var compound = null;
    switch (subtypeLabel) {
      case 'spouse':
      case 'child':
      case 'core':
      case 'buyup':
      case 'male':
      case 'female':
      case 'employee':
      case 'family':
        compound = true;
        break;
      case 'non_smoker':
      case 'smoker':
        compound = false;
        break;
      default:
        break;
    }
    return compound;
  },
  /**
   * What subtypes to show based on a products name
   *
   * @param {string} productTypeName
   * @returns {Array}
   */
  getSubtypeLabels: function getSubtypeLabels(productTypeName) {
    var smokerNonSmoker = {
      label: 'Non-Smoker/Smoker',
      subtypes: ['non_smoker', 'smoker']
    };
    var spouseChild = {
      label: 'Spouse/Child',
      subtypes: ['spouse', 'child']
    };
    var employeeFamily = {
      label: 'Employee/Family',
      subtypes: ['employee', 'family']
    };
    var coreBuyup = {
      label: 'Core/Buy-Up',
      subtypes: ['core', 'buyup']
    };
    var maleFemale = {
      label: 'Male/Female',
      subtypes: ['male', 'female']
    };
    var subtypesByProduct = {
      'Basic Life / AD&D': [],
      'Basic Dependent Life': [spouseChild],
      'Optional Life': [employeeFamily, smokerNonSmoker, maleFemale],
      'Optional AD&D': [employeeFamily, smokerNonSmoker],
      'Advice To Pay': [],
      'Statutory Plan - CA,HI,NJ,PR,RI': [coreBuyup, maleFemale],
      'Short Term Disability': [coreBuyup, maleFemale],
      'NY DBL': [maleFemale],
      'Long Term Disability': [coreBuyup]
    };
    return subtypesByProduct[productTypeName];
  },
  /**
   * What rate basis options to show based on a products int
   *
   * @param {number} productTypeId
   * @returns {Array}
   */
  getRateBasisOptions: function getRateBasisOptions(productTypeId) {
    var per10 = {
      label: 'Per $10',
      value: 10
    };
    var per25 = {
      label: 'Per $25',
      value: 25
    };
    var per50 = {
      label: 'Per $50',
      value: 50
    };
    var per75 = {
      label: 'Per $75',
      value: 75
    };
    var per100 = {
      label: 'Per $100',
      value: 100
    };
    var per1000 = {
      label: 'Per $1,000',
      value: 1000
    };
    var per2000 = {
      label: 'Per $2,000',
      value: 2000
    };
    var per5000 = {
      label: 'Per $5,000',
      value: 5000
    };
    var per10000 = {
      label: 'Per $10,000',
      value: 10000
    };
    var per15000 = {
      label: 'Per $15,000',
      value: 15000
    };
    var per20000 = {
      label: 'Per $20,000',
      value: 20000
    };
    var per30000 = {
      label: 'Per $30,000',
      value: 30000
    };
    var perUnit = {
      label: 'Per Unit',
      value: 1
    };
    var perEmployeeMonth = {
      label: 'Per Employee Per Month',
      value: 1
    };
    // This is an array of the objects below so the product types using this in the rateBasisOptionsByProductTypeId object should not be in an array or they should use a spread operator to join them to another array.
    var criticalAccidentAndHospital = [perEmployeeMonth, per25, per50, per75, per1000, per2000, per5000, per10000];
    var rateBasisOptionsByProductTypeId = {
      1: [per10, per100, perEmployeeMonth],
      // short term disability
      2: [per1000, perEmployeeMonth],
      // basic life/AD&D
      3: [per1000, perUnit],
      // Basic Dependent Life
      4: [per1000, per2000, per5000, per10000, perUnit],
      // Voluntary Life
      5: [per1000, per2000, per5000, per10000, perUnit],
      // Optional AD&D
      7: [per100, perEmployeeMonth],
      // Long Term Disability
      8: [perEmployeeMonth],
      // Advice To Pay
      9: [per10, per100, perEmployeeMonth],
      // NY DBL
      11: [per10, per100, perEmployeeMonth],
      // NJ TDB,
      12: [perEmployeeMonth],
      // absence management
      13: [per10, per100, perEmployeeMonth],
      // HI TDI
      14: [perEmployeeMonth],
      // Dental
      15: [perEmployeeMonth],
      // Vision
      16: [].concat(criticalAccidentAndHospital, [per15000, per20000, per30000]),
      // Critical Illness
      17: criticalAccidentAndHospital,
      // Accident
      18: criticalAccidentAndHospital,
      // Hospital Indemnity
      19: [perEmployeeMonth],
      // Stop Loss
      21: [per1000, per2000, per5000, per10000, perUnit] // Voluntary Life / AD&D
    };
    return rateBasisOptionsByProductTypeId[productTypeId];
  },
  /**
   * labels to show for age banded values
   *
   * @returns {Array}
   */
  getAgeBandedValues: function getAgeBandedValues() {
    var labels = ['age_0_19', 'age_20_24', 'age_25_29', 'age_30_34', 'age_35_39', 'age_40_44', 'age_45_49', 'age_50_54', 'age_55_59', 'age_60_64', 'age_65_69', 'age_70_74', 'age_75_79', 'age_80_plus'];
    return labels;
  },
  /**
   * An array of file types we allow to be uploaded
   *
   * @returns {Array}
   */
  getAcceptableUploadFileTypes: function getAcceptableUploadFileTypes() {
    return ['application/pdf', 'application/msword', 'application/rtf', 'application/vnd.ms-excel', 'application/vnd.ms-excel.sheet.binary.macroEnabled.12', 'application/vnd.ms-excel.sheet.macroEnabled.12', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/rtf'];
  },
  /**
   * An array of file extensions we allow to be uploaded
   *
   * @returns {Array}
   */
  getAcceptableUploadFileExtensions: function getAcceptableUploadFileExtensions() {
    return ['.doc', '.docx', '.pdf', '.rtf', '.txt', '.xls', '.xlsb', '.xlsm', '.xlsx'];
  },
  projectTypes: projectTypes
};

var dP$6 = _objectDp.f;
var gOPN$3 = _objectGopn.f;


var $RegExp = _global.RegExp;
var Base$1 = $RegExp;
var proto$3 = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (_descriptors && (!CORRECT_NEW || _fails(function () {
  re2[_wks('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = _isRegexp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : _inheritIfRequired(CORRECT_NEW
        ? new Base$1(piRE && !fiU ? p.source : p, f)
        : Base$1((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? _flags.call(p) : f)
      , tiRE ? this : proto$3, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP$6($RegExp, key, {
      configurable: true,
      get: function () { return Base$1[key]; },
      set: function (it) { Base$1[key] = it; }
    });
  };
  for (var keys$1 = gOPN$3(Base$1), i$4 = 0; keys$1.length > i$4;) proxy(keys$1[i$4++]);
  proto$3.constructor = $RegExp;
  $RegExp.prototype = proto$3;
  _redefine(_global, 'RegExp', $RegExp);
}

_setSpecies('RegExp');

/**
 * Validation Utility File
 *
 * @exports utils/validation
 * @category Utils
 */

/**
 * Evaluate the passed domain value and confirm if it is a valid domain.
 *
 * @param {string} value
 * @returns {boolean}
 */
var validateDomain = function validateDomain(value) {
  var expression = new RegExp(/^((?=[a-z0-9-]{1,63}\.)[a-z0-9-]+(-[a-z0-9-]+)*\.)+[a-z]{2,63}$/);
  return value.match(expression);
};
/**
 * Evaluate the passed value and domains to confirm if it is a valid email domain name. The domains that are passed should not include the @ symbol (Ex: ['acme.com', 'unum.com']).
 *
 * @param {string} value
 * @param {Array} domains
 * @returns {boolean}
 */
var validateEmailDomain = function validateEmailDomain(value) {
  var domains = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var extension = value && value.includes('@') ? value.split('@')[1].toLowerCase() : null;
  return domains.find(function (domain) {
    return domain.toLowerCase() === extension;
  }) !== undefined;
};
var Validation = {
  validateDomain: validateDomain,
  validateEmailDomain: validateEmailDomain
};

var apiUrl = process.env.VUE_APP_API_URL;
var CommentService = {
  /**
   * GET all quote level comments by document ID.
   *
   * @param {number} documentId
   * @param {string} applicationNamespace
   * @param {object} config
   * @param {string} config.baseUrl
   * @param {string} config.cookieNamespace
   * @returns {Promise}
   */
  getComments: function getComments(documentId, applicationNamespace) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      baseUrl = _ref.baseUrl,
      cookieNamespace = _ref.cookieNamespace;
    var namespace = cookieNamespace || process.env.VUE_APP_COOKIE_NAMESPACE;
    var axiosConfig = AxiosConfig.getConfig(namespace);
    var endpoint = baseUrl || apiUrl;
    var url = "".concat(endpoint, "/v1/").concat(applicationNamespace, "/comments/document/").concat(documentId);
    return new Promise(function (resolve, reject) {
      axios$1.get(url, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  },
  /**
   * POST a new comment.
   *
   * @param {object} param
   * @param {string} param.applicationNamespace
   * @param {number | Array} param.commentableIds
   * @param {string} param.content
   * @param {number} param.parentId
   * @param {object} config
   * @param {string} config.baseUrl
   * @param {string} config.cookieNamespace
   * @returns {Promise}
   */
  postComment: function postComment(_ref2) {
    var applicationNamespace = _ref2.applicationNamespace,
      commentableIds = _ref2.commentableIds,
      content = _ref2.content,
      parentId = _ref2.parentId;
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      baseUrl = _ref3.baseUrl,
      cookieNamespace = _ref3.cookieNamespace;
    var namespace = cookieNamespace || process.env.VUE_APP_COOKIE_NAMESPACE;
    var axiosConfig = AxiosConfig.getConfig(namespace);
    var endpoint = baseUrl || apiUrl;
    var url = "".concat(endpoint, "/v1/").concat(applicationNamespace, "/comments");
    return new Promise(function (resolve, reject) {
      var data = {
        commentable_type: 'Document',
        content: content,
        parent_id: parentId
      };
      if (applicationNamespace === 'broker_portal') {
        data.commentable_ids = Array.isArray(commentableIds) ? commentableIds : [commentableIds];
      }
      if (applicationNamespace === 'carrier_portal') {
        data.commentable_id = commentableIds;
      }
      axios$1.post(url, data, axiosConfig).then(function (response) {
        return resolve(response.data);
      }).catch(function (e) {
        return reject(e);
      });
    });
  },
  /**
   * GET all comments by project ID and application namespace.
   *
   * @param {string} projectId
   * @param {string} applicationNamespace
   * @param {object} config
   * @param {string} config.baseUrl
   * @param {string} config.cookieNamespace
   * @returns {Promise}
   */
  getCommentsByProject: function getCommentsByProject(projectId, applicationNamespace) {
    var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      baseUrl = _ref4.baseUrl,
      cookieNamespace = _ref4.cookieNamespace;
    var namespace = cookieNamespace || process.env.VUE_APP_COOKIE_NAMESPACE;
    var axiosConfig = AxiosConfig.getConfig(namespace);
    var endpoint = baseUrl || apiUrl;
    var url = "".concat(endpoint, "/v1/").concat(applicationNamespace, "/comments/project/").concat(projectId);
    return new Promise(function (resolve, reject) {
      axios$1.get(url, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  }
};

var apiUrl$1 = process.env.VUE_APP_API_URL;
var NotificationsService = {
  /**
   * See if there are any notifications for unread comments
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @param {object} config
   * @param {string} config.baseUrl
   * @param {string} config.cookieNamespace
   * @returns {Promise}
   */
  getCommentsNotifications: function getCommentsNotifications(projectId, applicationNamespace) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      baseUrl = _ref.baseUrl,
      cookieNamespace = _ref.cookieNamespace;
    var endpoint = baseUrl || apiUrl$1;
    var prefix = "".concat(endpoint, "/v1/").concat(applicationNamespace);
    var namespace = cookieNamespace || process.env.VUE_APP_COOKIE_NAMESPACE;
    var axiosConfig = AxiosConfig.getConfig(namespace);
    var url = "".concat(prefix, "/notifications/unread_comments/").concat(projectId);
    return new Promise(function (resolve, reject) {
      axios$1.get(url, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  },
  /**
   * get notifications for unread quote edits
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @param {object} config
   * @param {string} config.baseUrl
   * @param {string} config.cookieNamespace
   * @returns {Promise}
   */
  getEditsNotifications: function getEditsNotifications(projectId, applicationNamespace) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      baseUrl = _ref2.baseUrl,
      cookieNamespace = _ref2.cookieNamespace;
    var endpoint = baseUrl || apiUrl$1;
    var prefix = "".concat(endpoint, "/v1/").concat(applicationNamespace);
    var namespace = cookieNamespace || process.env.VUE_APP_COOKIE_NAMESPACE;
    var axiosConfig = AxiosConfig.getConfig(namespace);
    var url = "".concat(prefix, "/notifications/unread_edits/").concat(projectId);
    return new Promise(function (resolve, reject) {
      axios$1.get(url, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  },
  /**
   * Clear out the notifications for unread comments
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @param {object} config
   * @param {string} config.baseUrl
   * @param {string} config.cookieNamespace
   * @returns {Promise}
   */
  clearCommentNotifications: function clearCommentNotifications(projectId, applicationNamespace) {
    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      baseUrl = _ref3.baseUrl,
      cookieNamespace = _ref3.cookieNamespace;
    var endpoint = baseUrl || apiUrl$1;
    var prefix = "".concat(endpoint, "/v1/").concat(applicationNamespace);
    var namespace = cookieNamespace || process.env.VUE_APP_COOKIE_NAMESPACE;
    var axiosConfig = AxiosConfig.getConfig(namespace);
    var url = "".concat(prefix, "/notifications/mark_all_comments_as_read");
    return new Promise(function (resolve, reject) {
      var data = {
        project_id: projectId
      };
      axios$1.post(url, data, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  },
  /**
   * Clear out the notifications for unread quote edits
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @param {object} config
   * @param {string} config.baseUrl
   * @param {string} config.cookieNamespace
   * @returns {Promise}
   */
  clearEditNotifications: function clearEditNotifications(projectId, applicationNamespace) {
    var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      baseUrl = _ref4.baseUrl,
      cookieNamespace = _ref4.cookieNamespace;
    var endpoint = baseUrl || apiUrl$1;
    var prefix = "".concat(endpoint, "/v1/").concat(applicationNamespace);
    var namespace = cookieNamespace || process.env.VUE_APP_COOKIE_NAMESPACE;
    var axiosConfig = AxiosConfig.getConfig(namespace);
    var url = "".concat(prefix, "/notifications/mark_all_edits_as_read");
    return new Promise(function (resolve, reject) {
      var data = {
        project_id: projectId
      };
      axios$1.post(url, data, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  }
};

var apiUrl$2 = process.env.VUE_APP_API_URL;
var SourceService = {
  /**
   * Delete source
   *
   * @param {number} sourceId
   * @param {string} applicationNamespace
   * @param {object} config
   * @param {string} config.baseUrl
   * @param {string} config.cookieNamespace
   * @returns {Promise}
   */
  deleteSource: function deleteSource(sourceId, applicationNamespace) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      baseUrl = _ref.baseUrl,
      cookieNamespace = _ref.cookieNamespace;
    var namespace = cookieNamespace || process.env.VUE_APP_COOKIE_NAMESPACE;
    var endpoint = baseUrl || apiUrl$2;
    var url = "".concat(endpoint, "/v1/").concat(applicationNamespace, "/sources/").concat(sourceId);
    return new Promise(function (resolve, reject) {
      axios$1.delete(url, AxiosConfig.getConfig(namespace)).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  },
  /**
   * Get the encoded data for a specfic pdf to show in the fileviewer
   *
   * @param {number} sourceId
   * @param {string} applicationNamespace
   * @param {object} config
   * @param {string} config.baseUrl
   * @param {string} config.cookieNamespace
   * @returns {Promise}
   */
  getSource: function getSource(sourceId, applicationNamespace) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      baseUrl = _ref2.baseUrl,
      cookieNamespace = _ref2.cookieNamespace;
    var namespace = cookieNamespace || process.env.VUE_APP_COOKIE_NAMESPACE;
    var endpoint = baseUrl || apiUrl$2;
    var url = "".concat(endpoint, "/v1/").concat(applicationNamespace, "/sources/").concat(sourceId);
    return new Promise(function (resolve, reject) {
      axios$1.get(url, AxiosConfig.getConfig(namespace)).then(function (response) {
        resolve(response);
      }).catch(function (e) {
        reject(e);
      });
    });
  }
};

// third party libraries

/**
 * Every component that gets installed when someone calls Vue.use for our component
 *
 * @param {object} Vue
 */
var loadThreeflowComponents = function loadThreeflowComponents(Vue) {
  // Element components
  Vue.use(Alert);
  Vue.use(Checkbox);
  Vue.use(CheckboxButton);
  Vue.use(CheckboxGroup);
  Vue.use(Collapse);
  Vue.use(CollapseItem);
  Vue.use(Dialog);
  Vue.use(Dropdown);
  Vue.use(DropdownItem);
  Vue.use(DropdownMenu);
  Vue.use(Form);
  Vue.use(FormItem);
  Vue.use(Input);
  Vue.use(Loading.directive);
  Vue.use(Menu);
  Vue.use(MenuItem);
  Vue.use(MenuItemGroup);
  Vue.use(Option);
  Vue.use(OptionGroup);
  Vue.use(Popover);
  Vue.use(Progress);
  Vue.use(Radio);
  Vue.use(RadioButton);
  Vue.use(RadioGroup);
  Vue.use(Scrollbar);
  Vue.use(Select);
  Vue.use(Spinner);
  Vue.use(Step);
  Vue.use(Submenu);
  Vue.use(Switch);
  Vue.use(TabPane);
  Vue.use(Tabs);
  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(Tooltip);
  Vue.use(Upload);

  // Third party libraries
  Vue.component('Popper', vuePopper_min);
  Vue.use(VueForceNextTick);

  // custom components
  Vue.component('AppAlert', __vue_component__);
  Vue.component('AppButton', __vue_component__$1);
  Vue.component('AppConfirmEmail', __vue_component__$2);
  Vue.component('AppForgotPasswordForm', __vue_component__$3);
  Vue.component('AppIcon', __vue_component__$4);
  Vue.component('AppLanding', __vue_component__$5);
  Vue.component('AppRegisterConfirmation', __vue_component__$7);
  Vue.component('AppRegisterForm', __vue_component__$8);
  Vue.component('AppResendConfirmation', __vue_component__$9);
  Vue.component('AppResetPasswordForm', __vue_component__$a);
  Vue.component('AppSignIn', __vue_component__$b);
  Vue.component('AppTermsOfUse', __vue_component__$c);
  Vue.component('AuthPageFooter', __vue_component__$d);
  Vue.component('AuthPageHeader', __vue_component__$e);
  Vue.component('AppQuoteEditItem', __vue_component__$6);
  Vue.component('Comment', __vue_component__$f);
  Vue.component('CommentInput', __vue_component__$g);
  Vue.component('CpCallout', __vue_component__$h);
  Vue.component('CopyLinkContainer', __vue_component__$i);
  Vue.component('Datepicker', Datepicker);
  Vue.component('RfpTable', __vue_component__$j);
  Vue.component('TfBadge', __vue_component__$k);
  Vue.component('TfButton', __vue_component__$l);
  Vue.component('TfCheckbox', __vue_component__$m);
  Vue.component('TfCtaEmailSupport', __vue_component__$n);
  Vue.component('TfCommentsExport', __vue_component__$p);
  Vue.component('TfDatepicker', __vue_component__$q);
  Vue.component('TfFilter', __vue_component__$u);
  Vue.component('TfFilterDateRangeInput', __vue_component__$s);
  Vue.component('TfFormBuilder', __vue_component__$v);
  Vue.component('TfFormList', __vue_component__$w);
  Vue.component('TfHamburgerMenu', __vue_component__$x);
  Vue.component('TfHamburgerMenuItem', __vue_component__$y);
  Vue.component('TfInlineFormField', __vue_component__$z);
  Vue.component('TfInputWithOptions', __vue_component__$A);
  Vue.component('TfMultiSelect', __vue_component__$B);
  Vue.component('TfPanel', __vue_component__$D);
  Vue.component('TfPanel2', __vue_component__$E);
  Vue.component('TfPasswordField', __vue_component__$F);
  Vue.component('TfPdfExport', __vue_component__$H);
  Vue.component('TfPdfExportHeader', __vue_component__$o);
  Vue.component('TfPlanDesignDropdown', __vue_component__$A);
  Vue.component('TfPopover', __vue_component__$I);
  Vue.component('TfProductSelector', __vue_component__$L);
  Vue.component('TfProgressIcon', __vue_component__$M);
  Vue.component('TfPagination', __vue_component__$C);
  Vue.component('TfQuoteEditsExport', __vue_component__$O);
  Vue.component('TfSelectText', __vue_component__$P);
  Vue.component('TfSubmenu', __vue_component__$Q);
  Vue.component('TfTable', __vue_component__$Z);
  Vue.component('TfTableChildRow', __vue_component__$U);
  Vue.component('TfTableChildTable', __vue_component__$V);
  Vue.component('TfTableParentRow', __vue_component__$_);
  Vue.component('TfTableTd', __vue_component__$$);
  Vue.component('TfTabs', __vue_component__$T);
  Vue.component('TfTag', __vue_component__$R);
  Vue.component('TfTagField', __vue_component__$S);
  Vue.component('TfTooltip', __vue_component__$10);
  Vue.component('ThreeflowWordmark', __vue_component__$11);
  Vue.use(VCalendar);

  // element magic
  /* eslint-disable no-param-reassign */
  Vue.prototype.$loading = Loading.service;
  Vue.prototype.$message = Message;
  /* eslint-enable no-param-reassign */

  // plugins
  Vue.use(vClickOutside_umd);
};
var threeflowObject = {
  Analytics: Analytics,
  AxiosConfig: AxiosConfig,
  BrowserUtils: BrowserUtils,
  CommentService: CommentService,
  Cookies: Cookies,
  DatesUtils: DatesUtils,
  Formatting: Formatting,
  NotificationsService: NotificationsService,
  Product: Product,
  ReusableData: ReusableData,
  SourceService: SourceService,
  Validation: Validation
};

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

var isBuffer$1 = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
};

var toString$4 = Object.prototype.toString;

// < 0.13.0 will not have default headers set on a custom instance
var rejectWithError = !!axios$1.create().defaults.headers;

function find$1(array, predicate) {
  var length = array.length;
  for (var i = 0; i < length; i++) {
    var value = array[i];
    if (predicate(value)) return value;
  }
}

function isFunction$2(val) {
  return toString$4.call(val) === "[object Function]";
}

function isObjectOrArray(val) {
  return val !== null && typeof val === "object";
}

function isStream$1(val) {
  return isObjectOrArray(val) && isFunction$2(val.pipe);
}

function isArrayBuffer$1(val) {
  return toString$4.call(val) === "[object ArrayBuffer]";
}

function combineUrls(baseURL, url) {
  if (baseURL) {
    return baseURL.replace(/\/+$/, "") + "/" + url.replace(/^\/+/, "");
  }

  return url;
}

function findHandler(
  handlers,
  method,
  url,
  body,
  parameters,
  headers,
  baseURL
) {
  return find$1(handlers[method.toLowerCase()], function (handler) {
    if (typeof handler[0] === "string") {
      return (
        (isUrlMatching(url, handler[0]) ||
          isUrlMatching(combineUrls(baseURL, url), handler[0])) &&
        isBodyOrParametersMatching(method, body, parameters, handler[1]) &&
        isObjectMatching(headers, handler[2])
      );
    } else if (handler[0] instanceof RegExp) {
      return (
        (handler[0].test(url) || handler[0].test(combineUrls(baseURL, url))) &&
        isBodyOrParametersMatching(method, body, parameters, handler[1]) &&
        isObjectMatching(headers, handler[2])
      );
    }
  });
}

function isUrlMatching(url, required) {
  var noSlashUrl = url[0] === "/" ? url.substr(1) : url;
  var noSlashRequired = required[0] === "/" ? required.substr(1) : required;
  return noSlashUrl === noSlashRequired;
}

function isBodyOrParametersMatching(method, body, parameters, required) {
  var allowedParamsMethods = ["delete", "get", "head", "options"];
  if (allowedParamsMethods.indexOf(method.toLowerCase()) >= 0) {
    var params = required ? required.params : undefined;
    return isObjectMatching(parameters, params);
  } else {
    return isBodyMatching(body, required);
  }
}

function isObjectMatching(actual, expected) {
  if (expected === undefined) return true;
  if (typeof expected.asymmetricMatch === "function") {
    return expected.asymmetricMatch(actual);
  }
  return fastDeepEqual(actual, expected);
}

function isBodyMatching(body, requiredBody) {
  if (requiredBody === undefined) {
    return true;
  }
  var parsedBody;
  try {
    parsedBody = JSON.parse(body);
  } catch (e) {}

  return isObjectMatching(parsedBody ? parsedBody : body, requiredBody);
}

function purgeIfReplyOnce(mock, handler) {
  Object.keys(mock.handlers).forEach(function (key) {
    var index = mock.handlers[key].indexOf(handler);
    if (index > -1) {
      mock.handlers[key].splice(index, 1);
    }
  });
}

function settle$1(resolve, reject, response, delay) {
  if (delay > 0) {
    setTimeout(function () {
      settle$1(resolve, reject, response);
    }, delay);
    return;
  }

  if (response.config && response.config.validateStatus) {
    response.config.validateStatus(response.status)
      ? resolve(response)
      : reject(
          createAxiosError(
            "Request failed with status code " + response.status,
            response.config,
            response
          )
        );
    return;
  }

  // Support for axios < 0.11
  if (response.status >= 200 && response.status < 300) {
    resolve(response);
  } else {
    reject(response);
  }
}

function createAxiosError(message, config, response, code) {
  // Support for axios < 0.13.0
  if (!rejectWithError) return response;

  var error = new Error(message);
  error.isAxiosError = true;
  error.config = config;
  if (response !== undefined) {
    error.response = response;
  }
  if (code !== undefined) {
    error.code = code;
  }

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
    };
  };
  return error;
}

function createCouldNotFindMockError(config) {
  var message =
    "Could not find mock for: \n" +
    JSON.stringify(config, ["method", "url"], 2);
  var error = new Error(message);
  error.isCouldNotFindMockError = true;
  error.url = config.url;
  error.method = config.method;
  return error;
}

var utils$2 = {
  find: find$1,
  findHandler: findHandler,
  purgeIfReplyOnce: purgeIfReplyOnce,
  settle: settle$1,
  isStream: isStream$1,
  isArrayBuffer: isArrayBuffer$1,
  isFunction: isFunction$2,
  isObjectOrArray: isObjectOrArray,
  isBuffer: isBuffer$1,
  isEqual: fastDeepEqual,
  createAxiosError: createAxiosError,
  createCouldNotFindMockError: createCouldNotFindMockError,
};

function transformRequest(data) {
  if (
    utils$2.isArrayBuffer(data) ||
    utils$2.isBuffer(data) ||
    utils$2.isStream(data)
  ) {
    return data;
  }

  // Object and Array: returns a deep copy
  if (utils$2.isObjectOrArray(data)) {
    return JSON.parse(JSON.stringify(data));
  }

  // for primitives like string, undefined, null, number
  return data;
}

function makeResponse(result, config) {
  return {
    status: result[0],
    data: transformRequest(result[1]),
    headers: result[2],
    config: config,
    request: {
      responseURL: config.url,
    },
  };
}

function handleRequest(mockAdapter, resolve, reject, config) {
  var url = config.url || "";
  // TODO we're not hitting this `if` in any of the tests, investigate
  if (
    config.baseURL &&
    url.substr(0, config.baseURL.length) === config.baseURL
  ) {
    url = url.slice(config.baseURL.length);
  }

  delete config.adapter;
  mockAdapter.history[config.method].push(config);

  var handler = utils$2.findHandler(
    mockAdapter.handlers,
    config.method,
    url,
    config.data,
    config.params,
    config.headers,
    config.baseURL
  );

  if (handler) {
    if (handler.length === 7) {
      utils$2.purgeIfReplyOnce(mockAdapter, handler);
    }

    if (handler.length === 2) {
      // passThrough handler
      mockAdapter.originalAdapter(config).then(resolve, reject);
    } else if (typeof handler[3] !== "function") {
      utils$2.settle(
        resolve,
        reject,
        makeResponse(handler.slice(3), config),
        mockAdapter.delayResponse
      );
    } else {
      var result = handler[3](config);
      // TODO throw a sane exception when return value is incorrect
      if (typeof result.then !== "function") {
        utils$2.settle(
          resolve,
          reject,
          makeResponse(result, config),
          mockAdapter.delayResponse
        );
      } else {
        result.then(
          function (result) {
            if (result.config && result.status) {
              utils$2.settle(
                resolve,
                reject,
                makeResponse(
                  [result.status, result.data, result.headers],
                  result.config
                ),
                0
              );
            } else {
              utils$2.settle(
                resolve,
                reject,
                makeResponse(result, config),
                mockAdapter.delayResponse
              );
            }
          },
          function (error) {
            if (mockAdapter.delayResponse > 0) {
              setTimeout(function () {
                reject(error);
              }, mockAdapter.delayResponse);
            } else {
              reject(error);
            }
          }
        );
      }
    }
  } else {
    // handler not found
    switch (mockAdapter.onNoMatch) {
      case "passthrough":
        mockAdapter.originalAdapter(config).then(resolve, reject);
        break;
      case "throwException":
        throw utils$2.createCouldNotFindMockError(config);
      default:
        utils$2.settle(
          resolve,
          reject,
          {
            status: 404,
            config: config,
          },
          mockAdapter.delayResponse
        );
    }
  }
}

var handle_request = handleRequest;

var VERBS = [
  "get",
  "post",
  "head",
  "delete",
  "patch",
  "put",
  "options",
  "list",
];

function adapter() {
  return function (config) {
    var mockAdapter = this;
    // axios >= 0.13.0 only passes the config and expects a promise to be
    // returned. axios < 0.13.0 passes (config, resolve, reject).
    if (arguments.length === 3) {
      handle_request(mockAdapter, arguments[0], arguments[1], arguments[2]);
    } else {
      return new Promise(function (resolve, reject) {
        handle_request(mockAdapter, resolve, reject, config);
      });
    }
  }.bind(this);
}

function getVerbObject() {
  return VERBS.reduce(function (accumulator, verb) {
    accumulator[verb] = [];
    return accumulator;
  }, {});
}

function reset() {
  resetHandlers.call(this);
  resetHistory.call(this);
}

function resetHandlers() {
  this.handlers = getVerbObject();
}

function resetHistory() {
  this.history = getVerbObject();
}

function MockAdapter(axiosInstance, options) {
  reset.call(this);

  // TODO throw error instead when no axios instance is provided
  if (axiosInstance) {
    this.axiosInstance = axiosInstance;
    this.originalAdapter = axiosInstance.defaults.adapter;
    this.delayResponse =
      options && options.delayResponse > 0 ? options.delayResponse : null;
    this.onNoMatch = (options && options.onNoMatch) || null;
    axiosInstance.defaults.adapter = this.adapter.call(this);
  }
}

MockAdapter.prototype.adapter = adapter;

MockAdapter.prototype.restore = function restore() {
  if (this.axiosInstance) {
    this.axiosInstance.defaults.adapter = this.originalAdapter;
    this.axiosInstance = undefined;
  }
};

MockAdapter.prototype.reset = reset;
MockAdapter.prototype.resetHandlers = resetHandlers;
MockAdapter.prototype.resetHistory = resetHistory;

VERBS.concat("any").forEach(function (method) {
  var methodName = "on" + method.charAt(0).toUpperCase() + method.slice(1);
  MockAdapter.prototype[methodName] = function (matcher, body, requestHeaders) {
    var _this = this;
    var matcher = matcher === undefined ? /.*/ : matcher;

    function reply(code, response, headers) {
      var handler = [matcher, body, requestHeaders, code, response, headers];
      addHandler(method, _this.handlers, handler);
      return _this;
    }

    function replyOnce(code, response, headers) {
      var handler = [
        matcher,
        body,
        requestHeaders,
        code,
        response,
        headers,
        true,
      ];
      addHandler(method, _this.handlers, handler);
      return _this;
    }

    return {
      reply: reply,

      replyOnce: replyOnce,

      passThrough: function passThrough() {
        var handler = [matcher, body];
        addHandler(method, _this.handlers, handler);
        return _this;
      },

      abortRequest: function () {
        return reply(function (config) {
          var error = utils$2.createAxiosError(
            "Request aborted",
            config,
            undefined,
            "ECONNABORTED"
          );
          return Promise.reject(error);
        });
      },

      abortRequestOnce: function () {
        return replyOnce(function (config) {
          var error = utils$2.createAxiosError(
            "Request aborted",
            config,
            undefined,
            "ECONNABORTED"
          );
          return Promise.reject(error);
        });
      },

      networkError: function () {
        return reply(function (config) {
          var error = utils$2.createAxiosError("Network Error", config);
          return Promise.reject(error);
        });
      },

      networkErrorOnce: function () {
        return replyOnce(function (config) {
          var error = utils$2.createAxiosError("Network Error", config);
          return Promise.reject(error);
        });
      },

      timeout: function () {
        return reply(function (config) {
          var error = utils$2.createAxiosError(
            config.timeoutErrorMessage ||
              "timeout of " + config.timeout + "ms exceeded",
            config,
            undefined,
            "ECONNABORTED"
          );
          return Promise.reject(error);
        });
      },

      timeoutOnce: function () {
        return replyOnce(function (config) {
          var error = utils$2.createAxiosError(
            config.timeoutErrorMessage ||
              "timeout of " + config.timeout + "ms exceeded",
            config,
            undefined,
            "ECONNABORTED"
          );
          return Promise.reject(error);
        });
      },
    };
  };
});

function findInHandlers(method, handlers, handler) {
  var index = -1;
  for (var i = 0; i < handlers[method].length; i += 1) {
    var item = handlers[method][i];
    var isReplyOnce = item.length === 7;
    var comparePaths =
      item[0] instanceof RegExp && handler[0] instanceof RegExp
        ? String(item[0]) === String(handler[0])
        : item[0] === handler[0];
    var isSame =
      comparePaths &&
      utils$2.isEqual(item[1], handler[1]) &&
      utils$2.isEqual(item[2], handler[2]);
    if (isSame && !isReplyOnce) {
      index = i;
    }
  }
  return index;
}

function addHandler(method, handlers, handler) {
  if (method === "any") {
    VERBS.forEach(function (verb) {
      handlers[verb].push(handler);
    });
  } else {
    var indexOfExistingHandler = findInHandlers(method, handlers, handler);
    if (indexOfExistingHandler > -1 && handler.length < 7) {
      handlers[method].splice(indexOfExistingHandler, 1, handler);
    } else {
      handlers[method].push(handler);
    }
  }
}

var src = MockAdapter;
var default_1$1 = MockAdapter;
src.default = default_1$1;

var apiUrl$3 = process.env.VUE_APP_API_URL;
var Interceptor = {
  /**
   * load mocks and monitor api calls for 4012/403s
   *
   * @param {object} applicationOptions
   * @param {object} config
   * @param {string} config.baseUrl
   */
  activate: function activate() {
    var applicationOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      baseUrl = _ref.baseUrl;
    // create a list of api calls that we need to mock and the responses we want
    var environment = process.env.NODE_ENV;
    var endpoint = baseUrl || apiUrl$3;
    if (environment === 'testing') {
      var v1 = "".concat(endpoint, "/v1");
      var mock = new src(axios$1);
      mock.onDelete("".concat(v1, "/sources/3021")).reply(200, {});
      mock.onPost("".concat(v1, "/notifications/unread_edits/999")).reply(200, {});
      mock.onGet("".concat(v1, "/notifications/unread_edits/999")).reply(200, {
        unread_notifications: 0
      });

      // Comments
      var replyComment = {
        comment: {
          id: 208,
          commentable_id: 1508,
          commentable_type: 'Document',
          content: 'test',
          parent_id: null,
          user_id: 80,
          created_at: '2018-02-26T21: 11:14.187508',
          updated_at: '2018-02-26T21: 11:14.187508',
          replies: [],
          user: {
            id: 80,
            email: 'droti@watchtowerbenefits.com',
            first_name: 'Domenic',
            last_name: 'Roti',
            carrier: {
              id: 9,
              name: 'Guardian',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
            },
            broker: {}
          }
        }
      };
      var carrierComments = {
        comments: [{
          id: 62,
          commentable_id: 1508,
          commentable_type: 'Document',
          content: 'test',
          parent_id: null,
          user_id: 80,
          created_at: '2018-02-19T17: 29:38.741478',
          updated_at: '2018-02-19T17: 29:38.741478',
          replies: [{
            id: 67,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'reply',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T22:00:47.00357',
            updated_at: '2018-02-19T22:00:47.00357',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }, {
            id: 68,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'reply 2',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T22:25:16.885177',
            updated_at: '2018-02-19T22:25:16.885177',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }, {
            id: 69,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'reply 3',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T22:29:54.553554',
            updated_at: '2018-02-19T22:29:54.553554',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }, {
            id: 70,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'reply 4',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T22:31:33.176935',
            updated_at: '2018-02-19T22:31:33.176935',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }, {
            id: 71,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'new reply',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T23:00:46.547529',
            updated_at: '2018-02-19T23:00:46.547529',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }, {
            id: 72,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'test reply',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T23:01:50.28123',
            updated_at: '2018-02-19T23:01:50.28123',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }],
          user: {
            id: 80,
            email: 'droti@watchtowerbenefits.com',
            first_name: 'Domenic',
            last_name: 'Roti',
            carrier: {
              id: 9,
              name: 'Guardian',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
            },
            broker: {}
          }
        }]
      };
      var brokerComments = {
        comments: [{
          id: 119,
          commentable_id: 2749,
          commentable_type: 'Document',
          content: 'Comment to broker',
          parent_id: null,
          user_id: 107,
          created_at: '2018-03-26T21: 04: 37.493686',
          updated_at: '2018-03-26T21: 04: 37.493686',
          replies: [{
            id: 120,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'Reply from broker',
            parent_id: '119',
            user_id: 150,
            created_at: '2018-03-26T21: 10: 27.405564',
            updated_at: '2018-03-26T21: 10: 27.405564',
            user: {
              id: 150,
              email: 'broker@watchtowerbenefits.com',
              first_name: 'Watch',
              last_name: 'Tower',
              carrier: {},
              broker: {
                id: 6,
                name: 'Watchtower Demo Broker',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png'
              }
            },
            is_new: false
          }, {
            id: 121,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'Reply from carrier',
            parent_id: '119',
            user_id: 107,
            created_at: '2018-03-26T21: 10: 46.942491',
            updated_at: '2018-03-26T21: 10: 46.942491',
            user: {
              id: 107,
              email: 'guardian@watchtowerbenefits.com',
              first_name: 'Guardian ',
              last_name: 'User',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            },
            is_new: false
          }, {
            id: 122,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'reply from broker',
            parent_id: '119',
            user_id: 150,
            created_at: '2018-03-26T21: 11: 33.467593',
            updated_at: '2018-03-26T21: 11: 33.467593',
            user: {
              id: 150,
              email: 'broker@watchtowerbenefits.com',
              first_name: 'Watch',
              last_name: 'Tower',
              carrier: {},
              broker: {
                id: 6,
                name: 'Watchtower Demo Broker',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png'
              }
            },
            is_new: false
          }, {
            id: 123,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'test',
            parent_id: '119',
            user_id: 107,
            created_at: '2018-03-26T21: 12: 53.267896',
            updated_at: '2018-03-26T21: 12: 53.267896',
            user: {
              id: 107,
              email: 'guardian@watchtowerbenefits.com',
              first_name: 'Guardian ',
              last_name: 'User',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            },
            is_new: false
          }, {
            id: 125,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'test',
            parent_id: '119',
            user_id: 150,
            created_at: '2018-03-26T21: 15: 13.582766',
            updated_at: '2018-03-26T21: 15: 13.582766',
            user: {
              id: 150,
              email: 'broker@watchtowerbenefits.com',
              first_name: 'Watch',
              last_name: 'Tower',
              carrier: {},
              broker: {
                id: 6,
                name: 'Watchtower Demo Broker',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png'
              }
            },
            is_new: false
          }, {
            id: 127,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'test',
            parent_id: '119',
            user_id: 107,
            created_at: '2018-03-26T21: 16: 55.036569',
            updated_at: '2018-03-26T21: 16: 55.036569',
            user: {
              id: 107,
              email: 'guardian@watchtowerbenefits.com',
              first_name: 'Guardian ',
              last_name: 'User',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            },
            is_new: false
          }],
          user: {
            id: 107,
            email: 'guardian@watchtowerbenefits.com',
            first_name: 'Guardian ',
            last_name: 'User',
            carrier: {
              id: 9,
              name: 'Guardian',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
            },
            broker: {}
          },
          is_new: false
        }, {
          id: 124,
          commentable_id: 2749,
          commentable_type: 'Document',
          content: 'test',
          parent_id: null,
          user_id: 107,
          created_at: '2018-03-26T21: 15: 00.193088',
          updated_at: '2018-03-26T21: 15: 00.193088',
          replies: [],
          user: {
            id: 107,
            email: 'guardian@watchtowerbenefits.com',
            first_name: 'Guardian ',
            last_name: 'User',
            carrier: {
              id: 9,
              name: 'Guardian',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
            },
            broker: {}
          },
          is_new: false
        }, {
          id: 126,
          commentable_id: 2749,
          commentable_type: 'Document',
          content: 'test',
          parent_id: null,
          user_id: 107,
          created_at: '2018-03-26T21: 16: 44.809758',
          updated_at: '2018-03-26T21: 16: 44.809758',
          replies: [],
          user: {
            id: 107,
            email: 'guardian@watchtowerbenefits.com',
            first_name: 'Guardian ',
            last_name: 'User',
            carrier: {
              id: 9,
              name: 'Guardian',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
            },
            broker: {}
          },
          is_new: false
        }, {
          id: 128,
          commentable_id: 2749,
          commentable_type: 'Document',
          content: 'testest',
          parent_id: null,
          user_id: 150,
          created_at: '2018-03-26T21: 17: 08.283382',
          updated_at: '2018-03-26T21: 17: 08.283382',
          replies: [{
            id: 129,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'test',
            parent_id: '128',
            user_id: 150,
            created_at: '2018-03-26T21: 17: 17.246196',
            updated_at: '2018-03-26T21: 17: 17.246196',
            user: {
              id: 150,
              email: 'broker@watchtowerbenefits.com',
              first_name: 'Watch',
              last_name: 'Tower',
              carrier: {},
              broker: {
                id: 6,
                name: 'Watchtower Demo Broker',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png'
              }
            },
            is_new: true
          }],
          user: {
            id: 150,
            email: 'broker@watchtowerbenefits.com',
            first_name: 'Watch',
            last_name: 'Tower',
            carrier: {},
            broker: {
              id: 6,
              name: 'Watchtower Demo Broker',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png'
            }
          },
          is_new: true
        }]
      };
      mock.onPost("".concat(v1, "/carrier_portal/comments")).reply(200, replyComment);
      mock.onPost("".concat(v1, "/broker_portal/comments")).reply(200, replyComment);
      // this needs to be updated with a namespaced one at some point
      mock.onPost("".concat(v1, "/notifications/mark_all_comments_as_read")).reply(200, {});
      mock.onGet("".concat(v1, "/carrier_portal/comments/document/1508")).reply(200, carrierComments);
      mock.onGet("".concat(v1, "/broker_portal/comments/project/999")).reply(200, brokerComments);
      mock.onGet("".concat(v1, "/notifications/unread_comments/999")).reply(200, {
        unread_notifications: 0
      });
    }
    axios$1.interceptors.response.use(undefined, function (err) {
      var res = err.response;
      if ((!res || res.status === 401 || res.status === 403) && applicationOptions.inactiveLogout) {
        applicationOptions.inactiveLogout();
      }
      return Promise.reject(err);
    });
  }
};

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var _anInstance$1 = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

var _forOf$1 = createCommonjsModule(function (module) {
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
  var f = _ctx$1(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (_isArrayIter(iterFn)) for (length = _toLength$1(iterable.length); length > index; index++) {
    result = entries ? f(_anObject$1(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = _iterCall(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;
});

// 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES$4 = _wks$1('species');
var _speciesConstructor$1 = function (O, D) {
  var C = _anObject$1(O).constructor;
  var S;
  return C === undefined || (S = _anObject$1(C)[SPECIES$4]) == undefined ? D : _aFunction$1(S);
};

// fast apply, http://jsperf.lnkit.com/fast-apply/5
var _invoke = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

var process$1 = _global$1.process;
var setTask = _global$1.setImmediate;
var clearTask = _global$1.clearImmediate;
var MessageChannel = _global$1.MessageChannel;
var Dispatch = _global$1.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      _invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (_cof$1(process$1) == 'process') {
    defer = function (id) {
      process$1.nextTick(_ctx$1(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(_ctx$1(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = _ctx$1(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (_global$1.addEventListener && typeof postMessage == 'function' && !_global$1.importScripts) {
    defer = function (id) {
      _global$1.postMessage(id + '', '*');
    };
    _global$1.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in _domCreate$1('script')) {
    defer = function (id) {
      _html$1.appendChild(_domCreate$1('script'))[ONREADYSTATECHANGE] = function () {
        _html$1.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(_ctx$1(run, id, 1), 0);
    };
  }
}
var _task = {
  set: setTask,
  clear: clearTask
};

var macrotask = _task.set;
var Observer = _global$1.MutationObserver || _global$1.WebKitMutationObserver;
var process$2 = _global$1.process;
var Promise$1 = _global$1.Promise;
var isNode = _cof$1(process$2) == 'process';

var _microtask = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process$2.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process$2.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(_global$1.navigator && _global$1.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise$1.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(_global$1, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

// 25.4.1.5 NewPromiseCapability(C)


function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = _aFunction$1(resolve);
  this.reject = _aFunction$1(reject);
}

var f$d = function (C) {
  return new PromiseCapability(C);
};

var _newPromiseCapability = {
	f: f$d
};

var _perform = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

var navigator$1 = _global$1.navigator;

var _userAgent = navigator$1 && navigator$1.userAgent || '';

var _promiseResolve = function (C, x) {
  _anObject$1(C);
  if (_isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = _newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var _redefineAll$1 = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else _hide$1(target, key, src[key]);
  } return target;
};

var SPECIES$5 = _wks$1('species');

var _setSpecies$1 = function (KEY) {
  var C = typeof _core$1[KEY] == 'function' ? _core$1[KEY] : _global$1[KEY];
  if (_descriptors$1 && C && !C[SPECIES$5]) _objectDp$1.f(C, SPECIES$5, {
    configurable: true,
    get: function () { return this; }
  });
};

var task = _task.set;
var microtask = _microtask();




var PROMISE = 'Promise';
var TypeError$1 = _global$1.TypeError;
var process$3 = _global$1.process;
var versions = process$3 && process$3.versions;
var v8 = versions && versions.v8 || '';
var $Promise = _global$1[PROMISE];
var isNode$1 = _classof$1(process$3) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

var USE_NATIVE$1 = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[_wks$1('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode$1 || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && _userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return _isObject$1(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(_global$1, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = _perform(function () {
        if (isNode$1) {
          process$3.emit('unhandledRejection', value, promise);
        } else if (handler = _global$1.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = _global$1.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(_global$1, function () {
    var handler;
    if (isNode$1) {
      process$3.emit('rejectionHandled', promise);
    } else if (handler = _global$1.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, _ctx$1($resolve, wrapper, 1), _ctx$1($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE$1) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    _anInstance$1(this, $Promise, PROMISE, '_h');
    _aFunction$1(executor);
    Internal.call(this);
    try {
      executor(_ctx$1($resolve, this, 1), _ctx$1($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = _redefineAll$1($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(_speciesConstructor$1(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode$1 ? process$3.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = _ctx$1($resolve, promise, 1);
    this.reject = _ctx$1($reject, promise, 1);
  };
  _newPromiseCapability.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

_export$1(_export$1.G + _export$1.W + _export$1.F * !USE_NATIVE$1, { Promise: $Promise });
_setToStringTag$1($Promise, PROMISE);
_setSpecies$1(PROMISE);
Wrapper = _core$1[PROMISE];

// statics
_export$1(_export$1.S + _export$1.F * !USE_NATIVE$1, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
_export$1(_export$1.S + _export$1.F * (_library ), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return _promiseResolve( this === Wrapper ? $Promise : this, x);
  }
});
_export$1(_export$1.S + _export$1.F * !(USE_NATIVE$1 && _iterDetect(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = _perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      _forOf$1(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = _perform(function () {
      _forOf$1(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

_export$1(_export$1.P + _export$1.R, 'Promise', { 'finally': function (onFinally) {
  var C = _speciesConstructor$1(this, _core$1.Promise || _global$1.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return _promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return _promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

// https://github.com/tc39/proposal-promise-try




_export$1(_export$1.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = _newPromiseCapability.f(this);
  var result = _perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

var promise = _core$1.Promise;

var promise$1 = promise;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    promise$1.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new promise$1(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var axiosConfig = function axiosConfig(cookieNamespace) {
  if (cookieNamespace) {
    return AxiosConfig.getConfig(cookieNamespace);
  }
  return AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
};
var normalizedEndpoint = function normalizedEndpoint(_ref) {
  var apiNamespace = _ref.apiNamespace,
    baseUrl = _ref.baseUrl;
  var namespace = apiNamespace || process.env.VUE_APP_API_NAMESPACE;
  var endpoint = baseUrl || process.env.VUE_APP_API_URL;
  return "".concat(endpoint, "/v1/").concat(namespace);
};

/**
 * Retrieve all call outs from a given product using productId. Destructure the data from the response
 * which is a single property called callout that is an array of callouts.
 *
 * @param {number} productId
 * @param {object} config
 * @param {string} config.baseUrl
 * @param {string} config.cookieNamespace
 * @param {string} config.apiNamespace
 * @returns {Promise}
 */
var readCallouts = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(productId) {
    var _ref3,
      baseUrl,
      cookieNamespace,
      apiNamespace,
      endpoint,
      url,
      _yield$axios$get,
      _yield$axios$get$data,
      callouts,
      callout,
      _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref3 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, baseUrl = _ref3.baseUrl, cookieNamespace = _ref3.cookieNamespace, apiNamespace = _ref3.apiNamespace;
            endpoint = normalizedEndpoint({
              baseUrl: baseUrl,
              apiNamespace: apiNamespace
            });
            url = "".concat(endpoint, "/products/").concat(productId, "/callouts");
            _context.next = 5;
            return axios$1.get(url, axiosConfig(cookieNamespace));
          case 5:
            _yield$axios$get = _context.sent;
            _yield$axios$get$data = _yield$axios$get.data;
            callouts = _yield$axios$get$data.callouts;
            callout = _yield$axios$get$data.callout;
            return _context.abrupt("return", callouts || callout);
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function readCallouts(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * create a single callout with provided note onto specific plan design value. Destructure the data from the response
 * which is a single property called callout that is the newly created callout.
 *
 * @param {number} productId
 * @param {number} planDesignValueId
 * @param {string} note
 * @param {object} config
 * @param {string} config.baseUrl
 * @param {string} config.cookieNamespace
 * @param {string} config.apiNamespace
 * @returns {Promise}
 */
var createCallout = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(productId, planDesignValueId, note) {
    var _ref5,
      apiNamespace,
      baseUrl,
      cookieNamespace,
      endpoint,
      url,
      body,
      _yield$axios$post,
      callout,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref5 = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {}, apiNamespace = _ref5.apiNamespace, baseUrl = _ref5.baseUrl, cookieNamespace = _ref5.cookieNamespace;
            endpoint = normalizedEndpoint({
              baseUrl: baseUrl,
              apiNamespace: apiNamespace,
              cookieNamespace: cookieNamespace
            });
            url = "".concat(endpoint, "/products/").concat(productId, "/callouts");
            body = {
              plan_design_value_id: planDesignValueId,
              note: note
            };
            _context2.next = 6;
            return axios$1.post(url, body, axiosConfig(cookieNamespace));
          case 6:
            _yield$axios$post = _context2.sent;
            callout = _yield$axios$post.data.callout;
            return _context2.abrupt("return", callout);
          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function createCallout(_x2, _x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * update a single callout. Destructure the data from the response
 * which is a single property called callout that is the updated callout.
 *
 * @param {number} productId
 * @param {number} calloutId
 * @param {string} note
 * @param {object} config
 * @param {string} config.baseUrl
 * @param {string} config.cookieNamespace
 * @param {string} config.apiNamespace
 * @returns {Promise}
 */
var updateCallout = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(productId, calloutId, note) {
    var _ref7,
      apiNamespace,
      baseUrl,
      cookieNamespace,
      endpoint,
      url,
      body,
      _yield$axios$patch,
      callout,
      _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _ref7 = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {}, apiNamespace = _ref7.apiNamespace, baseUrl = _ref7.baseUrl, cookieNamespace = _ref7.cookieNamespace;
            endpoint = normalizedEndpoint({
              baseUrl: baseUrl,
              apiNamespace: apiNamespace,
              cookieNamespace: cookieNamespace
            });
            url = "".concat(endpoint, "/products/").concat(productId, "/callouts/").concat(calloutId);
            body = {
              note: note
            };
            _context3.next = 6;
            return axios$1.patch(url, body, axiosConfig(cookieNamespace));
          case 6:
            _yield$axios$patch = _context3.sent;
            callout = _yield$axios$patch.data.callout;
            return _context3.abrupt("return", callout);
          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function updateCallout(_x5, _x6, _x7) {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * Updates the callout's read property to true.
 *
 * @param {number} calloutId
 * @param {object} config
 * @param {string} config.baseUrl
 * @param {string} config.cookieNamespace
 * @param {string} config.apiNamespace
 * @returns {Promise} resolves to the callout that was updated
 */
var patchCalloutRead = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(calloutId) {
    var _ref9,
      apiNamespace,
      baseUrl,
      cookieNamespace,
      endpoint,
      url,
      _yield$axios$patch2,
      callout,
      _args4 = arguments;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ref9 = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {}, apiNamespace = _ref9.apiNamespace, baseUrl = _ref9.baseUrl, cookieNamespace = _ref9.cookieNamespace;
            endpoint = normalizedEndpoint({
              baseUrl: baseUrl,
              apiNamespace: apiNamespace,
              cookieNamespace: cookieNamespace
            });
            url = "".concat(endpoint, "/callouts/").concat(calloutId, "/read");
            _context4.next = 5;
            return axios$1.patch(url, {}, axiosConfig(cookieNamespace));
          case 5:
            _yield$axios$patch2 = _context4.sent;
            callout = _yield$axios$patch2.data.callout;
            return _context4.abrupt("return", callout);
          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function patchCalloutRead(_x8) {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * Delete a single callout and return the response.
 *
 * @param {number} productId
 * @param {number} calloutId
 * @param {object} config
 * @param {string} config.cookieNamespace
 * @param {string} config.apiNamespace
 * @param {string} config.baseUrl
 * @returns {Promise}
 */
var deleteCallout = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(productId, calloutId) {
    var _ref11,
      apiNamespace,
      baseUrl,
      cookieNamespace,
      endpoint,
      url,
      response,
      _args5 = arguments;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _ref11 = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {}, apiNamespace = _ref11.apiNamespace, baseUrl = _ref11.baseUrl, cookieNamespace = _ref11.cookieNamespace;
            endpoint = normalizedEndpoint({
              baseUrl: baseUrl,
              apiNamespace: apiNamespace,
              cookieNamespace: cookieNamespace
            });
            url = "".concat(endpoint, "/products/").concat(productId, "/callouts/").concat(calloutId);
            _context5.next = 5;
            return axios$1.delete(url, axiosConfig(cookieNamespace));
          case 5:
            response = _context5.sent;
            return _context5.abrupt("return", response);
          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function deleteCallout(_x9, _x10) {
    return _ref10.apply(this, arguments);
  };
}();

var callouts = /*#__PURE__*/Object.freeze({
	__proto__: null,
	readCallouts: readCallouts,
	createCallout: createCallout,
	updateCallout: updateCallout,
	patchCalloutRead: patchCalloutRead,
	deleteCallout: deleteCallout
});

var Threeflow = {
  /**
   * Install our component
   *
   * @param {object} Vue
   * @param {object} options
   */
  install: function install(Vue, options) {
    Object.defineProperty(Vue.prototype, '$TF', {
      value: threeflowObject
    });
    Interceptor.activate(options);
    loadThreeflowComponents(Vue);
    locale$1.use(lang);
  }
};

var purify = createCommonjsModule(function (module, exports) {
/*! @license DOMPurify 2.4.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.0/LICENSE */

(function (global, factory) {
   module.exports = factory() ;
})(commonjsGlobal, (function () {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property])) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */


  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */


    DOMPurify.version = '2.4.0';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */


      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */


      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? function (x) {
        return x;
      } : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */


      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */


      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */


      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: HTML_NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG or MathML). Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */


    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */


    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */


    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml') {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */


      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? '' : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */


      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */


    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */


    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */


    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */


    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */


    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */


      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */


      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */


      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */


      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */


      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */


      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */


        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */


      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */


      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */


      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */

      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */


    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */


    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */


        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */


        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */


        if (regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */


        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */


        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */


        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */


        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                value = trustedTypesPolicy.createHTML(value);
                break;

              case 'TrustedScriptURL':
                value = trustedTypesPolicy.createScriptURL(value);
                break;
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */


        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */


    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */


      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */


        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */


        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */


      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }
      /* Check we can run. Otherwise fall back or ignore */


      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */


      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */


      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */


        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */


      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */


      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */


      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */


        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */


        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */


      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */


      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */


    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */


    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */


    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */


    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */


    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */


    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */


    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));

});

var purify$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': purify,
	__moduleExports: purify
});

var check$1 = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check$1(typeof globalThis == 'object' && globalThis) ||
  check$1(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check$1(typeof self == 'object' && self) ||
  check$1(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors$1 = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var functionBindNative = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var call = Function.prototype.call;

var functionCall = functionBindNative ? call.bind(call) : function () {
  return call.apply(call, arguments);
};

var $propertyIsEnumerable$1 = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable$1.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f$e = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$1;

var objectPropertyIsEnumerable = {
	f: f$e
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var FunctionPrototype = Function.prototype;
var call$1 = FunctionPrototype.call;
var uncurryThisWithBind = functionBindNative && FunctionPrototype.bind.bind(call$1, call$1);

var functionUncurryThisRaw = function (fn) {
  return functionBindNative ? uncurryThisWithBind(fn) : function () {
    return call$1.apply(fn, arguments);
  };
};

var toString$5 = functionUncurryThisRaw({}.toString);
var stringSlice = functionUncurryThisRaw(''.slice);

var classofRaw = function (it) {
  return stringSlice(toString$5(it), 8, -1);
};

var functionUncurryThis = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return functionUncurryThisRaw(fn);
};

var $Object$1 = Object;
var split = functionUncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$1('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split(it, '') : $Object$1(it);
} : $Object$1;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined = function (it) {
  return it === null || it === undefined;
};

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

var documentAll_1 = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};

var documentAll$1 = documentAll_1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable = documentAll_1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var documentAll$2 = documentAll_1.all;

var isObject$1 = documentAll_1.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll$2;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global_1[namespace]) : global_1[namespace] && global_1[namespace][method];
};

var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

var process$4 = global_1.process;
var Deno$1 = global_1.Deno;
var versions$1 = process$4 && process$4.versions || Deno$1 && Deno$1.version;
var v8$1 = versions$1 && versions$1.v8;
var match, version;

if (v8$1) {
  match = v8$1.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */



// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && engineV8Version && engineV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */


var useSymbolAsUid = symbolConstructorDetection
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var $Object$2 = Object;

var isSymbol$1 = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$2(it));
};

var $String = String;

var tryToString = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$1 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError$1(tryToString(argument) + ' is not a function');
};

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var $TypeError$2 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject$1(val = functionCall(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject$1(val = functionCall(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject$1(val = functionCall(fn, input))) return val;
  throw $TypeError$2("Can't convert object to primitive value");
};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;

var defineGlobalProperty = function (key, value) {
  try {
    defineProperty$4(global_1, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || defineGlobalProperty(SHARED, {});

var sharedStore = store;

var shared$2 = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.25.5',
  mode:  'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});
});

var $Object$3 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return $Object$3(requireObjectCoercible(argument));
};

var hasOwnProperty$2 = functionUncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$2(toObject(it), key);
};

var id$2 = 0;
var postfix = Math.random();
var toString$6 = functionUncurryThis(1.0.toString);

var uid = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$6(++id$2 + postfix, 36);
};

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global_1.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!hasOwnProperty_1(WellKnownSymbolsStore, name) || !(symbolConstructorDetection || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (useSymbolAsUid && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var $TypeError$3 = TypeError;
var TO_PRIMITIVE$1 = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive = function (input, pref) {
  if (!isObject$1(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE$1);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall(exoticToPrim, input, pref);
    if (!isObject$1(result) || isSymbol$1(result)) return result;
    throw $TypeError$3("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol$1(key) ? key : key + '';
};

var document$5 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$1(document$5) && isObject$1(document$5.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$5.createElement(it) : {};
};

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !descriptors$1 && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$f = descriptors$1 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$f
};

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = descriptors$1 && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var $String$1 = String;
var $TypeError$4 = TypeError;

// `Assert: Type(argument) is Object`
var anObject = function (argument) {
  if (isObject$1(argument)) return argument;
  throw $TypeError$4($String$1(argument) + ' is not an object');
};

var $TypeError$5 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty$1 = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$g = descriptors$1 ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$2(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty$1(O, P, Attributes);
} : $defineProperty$1 : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty$1(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$5('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f$g
};

var createNonEnumerableProperty = descriptors$1 ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = descriptors$1 && Object.getOwnPropertyDescriptor;

var EXISTS$1 = hasOwnProperty_1(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS$1 && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE$1 = EXISTS$1 && (!descriptors$1 || (descriptors$1 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS$1,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE$1
};

var functionToString = functionUncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(sharedStore.inspectSource)) {
  sharedStore.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap));

var keys$2 = shared$2('keys');

var sharedKey = function (key) {
  return keys$2[key] || (keys$2[key] = uid(key));
};

var hiddenKeys$2 = {};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global_1.TypeError;
var WeakMap$1 = global_1.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$1(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (weakMapBasicDetection || sharedStore.state) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store$1.get = store$1.get;
  store$1.has = store$1.has;
  store$1.set = store$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store$1.has(it)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store$1.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store$1.get(it) || {};
  };
  has = function (it) {
    return store$1.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    if (hasOwnProperty_1(it, STATE)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwnProperty_1(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var makeBuiltIn_1 = createCommonjsModule(function (module) {
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;



var enforceInternalState = internalState.enforce;
var getInternalState = internalState.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = descriptors$1 && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwnProperty_1(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (descriptors$1) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
      if (descriptors$1) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwnProperty_1(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');
});

var defineBuiltIn = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn_1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else objectDefineProperty.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var ceil$2 = Math.ceil;
var floor$4 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$4 : ceil$2)(n);
};

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : mathTrunc(number);
};

var max$4 = Math.max;
var min$5 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max$4(integer + length, 0) : min$5(integer, length);
};

var min$6 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min$6(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike = function (obj) {
  return toLength(obj.length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var push = functionUncurryThis([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwnProperty_1(hiddenKeys$2, key) && hasOwnProperty_1(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys$3 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$h = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$3);
};

var objectGetOwnPropertyNames = {
	f: f$h
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$i = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$i
};

var concat = functionUncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$6 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source, exceptions) {
  var keys = ownKeys$6(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data$1[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data$1 = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export$2 = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

var engineIsNode = classofRaw(global_1.process) == 'process';

var $String$2 = String;
var $TypeError$6 = TypeError;

var aPossiblePrototype = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError$6("Can't set " + $String$2(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */




// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = functionUncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$5 = objectDefineProperty.f;



var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

var setToStringTag = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwnProperty_1(target, TO_STRING_TAG$2)) {
    defineProperty$5(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var SPECIES$6 = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty.f;

  if (descriptors$1 && Constructor && !Constructor[SPECIES$6]) {
    defineProperty(Constructor, SPECIES$6, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var $TypeError$7 = TypeError;

var anInstance = function (it, Prototype) {
  if (objectIsPrototypeOf(Prototype, it)) return it;
  throw $TypeError$7('Incorrect invocation');
};

var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test$1) === '[object z]';

var TO_STRING_TAG$4 = wellKnownSymbol('toStringTag');
var $Object$4 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet$2 = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet$2(O = $Object$4(it), TO_STRING_TAG$4)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var noop = function () { /* empty */ };
var empty$1 = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = functionUncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty$1, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var $TypeError$8 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError$8(tryToString(argument) + ' is not a constructor');
};

var SPECIES$7 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES$7]) ? defaultConstructor : aConstructor(S);
};

var FunctionPrototype$2 = Function.prototype;
var apply = FunctionPrototype$2.apply;
var call$2 = FunctionPrototype$2.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call$2.bind(apply) : function () {
  return call$2.apply(apply, arguments);
});

var bind$1 = functionUncurryThis(functionUncurryThis.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : functionBindNative ? bind$1(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var html = getBuiltIn('document', 'documentElement');

var arraySlice = functionUncurryThis([].slice);

var $TypeError$9 = TypeError;

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw $TypeError$9('Not enough arguments');
  return passed;
};

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(engineUserAgent);

var set$1 = global_1.setImmediate;
var clear = global_1.clearImmediate;
var process$5 = global_1.process;
var Dispatch$1 = global_1.Dispatch;
var Function$1 = global_1.Function;
var MessageChannel$1 = global_1.MessageChannel;
var String$1 = global_1.String;
var counter$1 = 0;
var queue$1 = {};
var ONREADYSTATECHANGE$1 = 'onreadystatechange';
var $location, defer$1, channel$1, port$1;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global_1.location;
} catch (error) { /* empty */ }

var run$1 = function (id) {
  if (hasOwnProperty_1(queue$1, id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run$1(id);
  };
};

var listener$1 = function (event) {
  run$1(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global_1.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$1[++counter$1] = function () {
      functionApply(fn, undefined, args);
    };
    defer$1(counter$1);
    return counter$1;
  };
  clear = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (engineIsNode) {
    defer$1 = function (id) {
      process$5.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch$1 && Dispatch$1.now) {
    defer$1 = function (id) {
      Dispatch$1.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel$1 && !engineIsIos) {
    channel$1 = new MessageChannel$1();
    port$1 = channel$1.port2;
    channel$1.port1.onmessage = listener$1;
    defer$1 = functionBindContext(port$1.postMessage, port$1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global_1.addEventListener &&
    isCallable(global_1.postMessage) &&
    !global_1.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer$1 = post;
    global_1.addEventListener('message', listener$1, false);
  // IE8-
  } else if (ONREADYSTATECHANGE$1 in documentCreateElement('script')) {
    defer$1 = function (id) {
      html.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE$1] = function () {
        html.removeChild(this);
        run$1(id);
      };
    };
  // Rest old browsers
  } else {
    defer$1 = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set$1,
  clear: clear
};

var engineIsIosPebble = /ipad|iphone|ipod/i.test(engineUserAgent) && global_1.Pebble !== undefined;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(engineUserAgent);

var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var macrotask$1 = task$1.set;





var MutationObserver = global_1.MutationObserver || global_1.WebKitMutationObserver;
var document$6 = global_1.document;
var process$6 = global_1.process;
var Promise$2 = global_1.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$2(global_1, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise$2, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (engineIsNode && (parent = process$6.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!engineIsIos && !engineIsNode && !engineIsWebosWebkit && MutationObserver && document$6) {
    toggle = true;
    node = document$6.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!engineIsIosPebble && Promise$2 && Promise$2.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise$2 = Promise$2.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise$2.constructor = Promise$2;
    then = functionBindContext(promise$2.then, promise$2);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (engineIsNode) {
    notify$1 = function () {
      process$6.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask$1 = functionBindContext(macrotask$1, global_1);
    notify$1 = function () {
      macrotask$1(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var hostReportErrors = function (a, b) {
  var console = global_1.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

var queue$2 = Queue;

var promiseNativeConstructor = global_1.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var engineIsBrowser = !engineIsDeno && !engineIsNode
  && typeof window == 'object'
  && typeof document == 'object';

var NativePromisePrototype = promiseNativeConstructor && promiseNativeConstructor.prototype;
var SPECIES$8 = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global_1.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced_1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(promiseNativeConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(promiseNativeConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && engineV8Version === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!engineV8Version || engineV8Version < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new promiseNativeConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$8] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (engineIsBrowser || engineIsDeno) && !NATIVE_PROMISE_REJECTION_EVENT;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};

var $TypeError$a = TypeError;

var PromiseCapability$1 = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$a('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var f$j = function (C) {
  return new PromiseCapability$1(C);
};

var newPromiseCapability$1 = {
	f: f$j
};

var task$2 = task$1.set;









var PROMISE$1 = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT$1 = promiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = promiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = internalState.getterFor(PROMISE$1);
var setInternalState = internalState.set;
var NativePromisePrototype$1 = promiseNativeConstructor && promiseNativeConstructor.prototype;
var PromiseConstructor = promiseNativeConstructor;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$3 = global_1.TypeError;
var document$7 = global_1.document;
var process$7 = global_1.process;
var newPromiseCapability$2 = newPromiseCapability$1.f;
var newGenericPromiseCapability$1 = newPromiseCapability$2;

var DISPATCH_EVENT = !!(document$7 && document$7.createEvent && global_1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal$1, OwnPromiseCapability$1, PromiseWrapper, nativeThen;

// helpers
var isThenable$1 = function (it) {
  var then;
  return isObject$1(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled$1(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$3('Promise-chain cycle'));
      } else if (then = isThenable$1(result)) {
        functionCall(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify$2 = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask$1(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled$1(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$7.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT$1 && (handler = global_1['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled$1 = function (state) {
  functionCall(task$2, global_1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled$1(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (engineIsNode) {
          process$7.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = engineIsNode || isUnhandled$1(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled$1 = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled$1 = function (state) {
  functionCall(task$2, global_1, function () {
    var promise = state.facade;
    if (engineIsNode) {
      process$7.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$2 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify$2(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$3("Promise can't be resolved itself");
    var then = isThenable$1(value);
    if (then) {
      microtask$1(function () {
        var wrapper = { done: false };
        try {
          functionCall(then, value,
            bind$2(internalResolve, wrapper, state),
            bind$2(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify$2(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$1) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    functionCall(Internal$1, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$2(internalResolve, state), bind$2(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal$1 = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE$1,
      done: false,
      notified: false,
      parent: false,
      reactions: new queue$2(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal$1.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$2(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = engineIsNode ? process$7.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask$1(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability$1 = function () {
    var promise = new Internal$1();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$2(internalResolve, state);
    this.reject = bind$2(internalReject, state);
  };

  newPromiseCapability$1.f = newPromiseCapability$2 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability$1(C)
      : newGenericPromiseCapability$1(C);
  };

  if ( isCallable(promiseNativeConstructor) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          functionCall(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (objectSetPrototypeOf) {
      objectSetPrototypeOf(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

_export$2({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE$1, false);
setSpecies(PROMISE$1);

var iterators = {};

var ITERATOR$9 = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype[ITERATOR$9] === it);
};

var ITERATOR$a = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR$a)
    || getMethod(it, '@@iterator')
    || iterators[classof(it)];
};

var $TypeError$b = TypeError;

var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw $TypeError$b(tryToString(argument) + ' is not iterable');
};

var iteratorClose = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = functionCall(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

var $TypeError$c = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError$c(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = functionCall(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var ITERATOR$b = wellKnownSymbol('iterator');
var SAFE_CLOSING$2 = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING$2 = true;
    }
  };
  iteratorWithReturn[ITERATOR$b] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING$2) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$b] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$2 || !checkCorrectnessOfIteration(function (iterable) {
  promiseNativeConstructor.all(iterable).then(undefined, function () { /* empty */ });
});

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
_export$2({ target: 'Promise', stat: true, forced: promiseStaticsIncorrectIteration }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$1.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        functionCall($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;





var NativePromisePrototype$2 = promiseNativeConstructor && promiseNativeConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
_export$2({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$3, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ( isCallable(promiseNativeConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype$2['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype$2, 'catch', method, { unsafe: true });
  }
}

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
_export$2({ target: 'Promise', stat: true, forced: promiseStaticsIncorrectIteration }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        functionCall($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$4 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
_export$2({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  reject: function reject(r) {
    var capability = newPromiseCapability$1.f(this);
    functionCall(capability.reject, undefined, r);
    return capability.promise;
  }
});

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var FORCED_PROMISE_CONSTRUCTOR$5 = promiseConstructorDetection.CONSTRUCTOR;


var PromiseConstructorWrapper = getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
_export$2({ target: 'Promise', stat: true, forced:  FORCED_PROMISE_CONSTRUCTOR$5 }, {
  resolve: function resolve(x) {
    return promiseResolve( this, x);
  }
});

var asyncToGenerator = createCommonjsModule(function (module) {
  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(undefined);
      });
    };
  }
  module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _asyncToGenerator$1 = unwrapExports(asyncToGenerator);

var $String$3 = String;

var toString_1 = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$3(argument);
};

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$1 = global_1.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp$1('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp$1('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$1('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var f$k = descriptors$1 && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
  return O;
};

var objectDefineProperties = {
	f: f$k
};

/* global ActiveXObject -- old IE, WSH */








var GT = '>';
var LT = '<';
var PROTOTYPE$5 = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$6 = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE$5][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$6] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$5] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$5] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$6] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
};

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$2 = global_1.RegExp;

var regexpUnsupportedDotAll = fails(function () {
  var re = $RegExp$2('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp$3 = global_1.RegExp;

var regexpUnsupportedNcg = fails(function () {
  var re = $RegExp$3('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */







var getInternalState = internalState.get;



var nativeReplace$1 = shared$2('native-string-replace', String.prototype.replace);
var nativeExec$1 = RegExp.prototype.exec;
var patchedExec$1 = nativeExec$1;
var charAt = functionUncurryThis(''.charAt);
var indexOf$1 = functionUncurryThis(''.indexOf);
var replace = functionUncurryThis(''.replace);
var stringSlice$1 = functionUncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG$1 = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  functionCall(nativeExec$1, re1, 'a');
  functionCall(nativeExec$1, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED$1 = /()??/.exec('')[1] !== undefined;

var PATCH$1 = UPDATES_LAST_INDEX_WRONG$1 || NPCG_INCLUDED$1 || UNSUPPORTED_Y$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg;

if (PATCH$1) {
  patchedExec$1 = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString_1(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = functionCall(patchedExec$1, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = functionCall(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf$1(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$1(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED$1) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG$1) lastIndex = re.lastIndex;

    match = functionCall(nativeExec$1, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$1(match.input, charsAdded);
        match[0] = stringSlice$1(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG$1 && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED$1 && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      functionCall(nativeReplace$1, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = objectCreate(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec = patchedExec$1;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
_export$2({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

// TODO: Remove from `core-js@4` since it's moved to entry points








var SPECIES$9 = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$9] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = functionUncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = functionUncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var charAt$1 = functionUncurryThis(''.charAt);
var charCodeAt = functionUncurryThis(''.charCodeAt);
var stringSlice$2 = functionUncurryThis(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString_1(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$1(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt$2 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt$2(S, index).length : 1);
};

var $TypeError$d = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = functionCall(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classofRaw(R) === 'RegExp') return functionCall(regexpExec, R, S);
  throw $TypeError$d('RegExp#exec called on incompatible receiver');
};

// @@match logic
fixRegexpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? functionCall(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString_1(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString_1(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regexpExecAbstract(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regexpExecAbstract(rx, S)) !== null) {
        var matchStr = toString_1(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var floor$5 = Math.floor;
var charAt$3 = functionUncurryThis(''.charAt);
var replace$1 = functionUncurryThis(''.replace);
var stringSlice$3 = functionUncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS$1 = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED$1 = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED$1;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS$1;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$3(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$3(str, 0, position);
      case "'": return stringSlice$3(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$3(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$5(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$3(ch, 1) : captures[f - 1] + charAt$3(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var REPLACE = wellKnownSymbol('replace');
var max$5 = Math.max;
var min$7 = Math.min;
var concat$1 = functionUncurryThis([].concat);
var push$1 = functionUncurryThis([].push);
var stringIndexOf = functionUncurryThis(''.indexOf);
var stringSlice$4 = functionUncurryThis(''.slice);

var maybeToString$1 = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS$1 = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? functionCall(replacer, searchValue, O, replaceValue)
        : functionCall(nativeReplace, toString_1(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString_1(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString_1(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract(rx, S);
        if (result === null) break;

        push$1(results, result);
        if (!global) break;

        var matchStr = toString_1(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString_1(result[0]);
        var position = max$5(min$7(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$1(captures, maybeToString$1(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat$1([matched], captures, position, S);
          if (namedCaptures !== undefined) push$1(replacerArgs, namedCaptures);
          var replacement = toString_1(functionApply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$4(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice$4(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS$1 || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var MATCH$2 = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$1(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var $TypeError$e = TypeError;

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw $TypeError$e("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$3 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$3] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;







// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = functionUncurryThis(''.startsWith);
var stringSlice$5 = functionUncurryThis(''.slice);
var min$8 = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegexpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG =  !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor$3(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
_export$2({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString_1(requireObjectCoercible(this));
    notARegexp(searchString);
    var index = toLength(min$8(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString_1(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice$5(that, index, index + search.length) === search;
  }
});

var defineProperty$6 = objectDefineProperty.f;

var UNSCOPABLES$1 = wellKnownSymbol('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES$1] == undefined) {
  defineProperty$6(ArrayPrototype$1, UNSCOPABLES$1, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype$1[UNSCOPABLES$1][key] = true;
};

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$7 = sharedKey('IE_PROTO');
var $Object$5 = Object;
var ObjectPrototype = $Object$5.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? $Object$5.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwnProperty_1(object, IE_PROTO$7)) return object[IE_PROTO$7];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$5 ? ObjectPrototype : null;
};

var ITERATOR$c = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$1(IteratorPrototype$2) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$c].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype$2[ITERATOR$c])) {
  defineBuiltIn(IteratorPrototype$2, ITERATOR$c, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var IteratorPrototype$3 = iteratorsCore.IteratorPrototype;





var returnThis$2 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$3, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis$2;
  return IteratorConstructor;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var IteratorPrototype$4 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$d = wellKnownSymbol('iterator');
var KEYS$2 = 'keys';
var VALUES$2 = 'values';
var ENTRIES = 'entries';

var returnThis$3 = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  iteratorCreateConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS$2: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES$2: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$d]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if ( objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$4) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$4);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR$d])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR$d, returnThis$3);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES$2 && nativeIterator && nativeIterator.name !== VALUES$2) {
    if ( CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES$2);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return functionCall(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES$2),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS$2),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export$2({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ( IterablePrototype[ITERATOR$d] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR$d, defaultIterator, { name: DEFAULT });
  }
  iterators[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject = function (value, done) {
  return { value: value, done: done };
};

var defineProperty$7 = objectDefineProperty.f;





var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = internalState.set;
var getInternalState$1 = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = iteratorDefine(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = iterators.Arguments = iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if ( descriptors$1 && values.name !== 'values') try {
  defineProperty$7(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`


var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

var ITERATOR$e = wellKnownSymbol('iterator');
var TO_STRING_TAG$5 = wellKnownSymbol('toStringTag');
var ArrayValues$1 = es_array_iterator.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$e] !== ArrayValues$1) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$e, ArrayValues$1);
    } catch (error) {
      CollectionPrototype[ITERATOR$e] = ArrayValues$1;
    }
    if (!CollectionPrototype[TO_STRING_TAG$5]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$5, COLLECTION_NAME);
    }
    if (domIterables[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, es_array_iterator[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in domIterables) {
  handlePrototype(global_1[COLLECTION_NAME] && global_1[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(domTokenListPrototype, 'DOMTokenList');

var toPrimitive_1 = createCommonjsModule(function (module) {
  var _typeof = _typeof_1["default"];
  function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != _typeof(i)) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(toPrimitive_1);

var toPropertyKey_1 = createCommonjsModule(function (module) {
  var _typeof = _typeof_1["default"];
  function toPropertyKey(t) {
    var i = toPrimitive_1(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
  }
  module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
unwrapExports(toPropertyKey_1);

var defineProperty$8 = createCommonjsModule(function (module) {
  function _defineProperty(obj, key, value) {
    key = toPropertyKey_1(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _defineProperty$1 = unwrapExports(defineProperty$8);

var $TypeError$f = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = indexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError$f('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$2(true)
};

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var $reduce = arrayReduce.left;




var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
_export$2({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;







// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var nativeEndsWith = functionUncurryThis(''.endsWith);
var slice = functionUncurryThis(''.slice);
var min$9 = Math.min;

var CORRECT_IS_REGEXP_LOGIC$1 = correctIsRegexpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG$1 =  !CORRECT_IS_REGEXP_LOGIC$1 && !!function () {
  var descriptor = getOwnPropertyDescriptor$4(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
_export$2({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG$1 && !CORRECT_IS_REGEXP_LOGIC$1 }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString_1(requireObjectCoercible(this));
    notARegexp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min$9(toLength(endPosition), len);
    var search = toString_1(searchString);
    return nativeEndsWith
      ? nativeEndsWith(that, search, end)
      : slice(that, end - search.length, end) === search;
  }
});

var createProperty = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var $Array = Array;
var max$6 = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max$6(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

var UNSUPPORTED_Y$2 = regexpStickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32$1 = 0xFFFFFFFF;
var min$a = Math.min;
var $push$1 = [].push;
var exec$1 = functionUncurryThis(/./.exec);
var push$2 = functionUncurryThis($push$1);
var stringSlice$6 = functionUncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC$1 = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegexpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString_1(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32$1 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegexp(separator)) {
        return functionCall(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = functionCall(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push$2(output, stringSlice$6(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) functionApply($push$1, output, arraySliceSimple(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec$1(separatorCopy, '')) push$2(output, '');
      } else push$2(output, stringSlice$6(string, lastLastIndex));
      return output.length > lim ? arraySliceSimple(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : functionCall(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? functionCall(splitter, separator, O, limit)
        : functionCall(internalSplit, toString_1(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString_1(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y$2 ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y$2 ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32$1 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y$2 ? 0 : q;
        var z = regexpExecAbstract(splitter, UNSUPPORTED_Y$2 ? stringSlice$6(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min$a(toLength(splitter.lastIndex + (UNSUPPORTED_Y$2 ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push$2(A, stringSlice$6(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push$2(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push$2(A, stringSlice$6(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC$1, UNSUPPORTED_Y$2);

var performanceNow = createCommonjsModule(function (module) {
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(commonjsGlobal);


});

var root = typeof window === 'undefined' ? commonjsGlobal : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

for(var i$5 = 0; !raf && i$5 < vendors.length; i$5++) {
  raf = root[vendors[i$5] + 'Request' + suffix];
  caf = root[vendors[i$5] + 'Cancel' + suffix]
      || root[vendors[i$5] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last$1 = 0
    , id$3 = 0
    , queue$3 = []
    , frameDuration = 1000 / 60;

  raf = function(callback) {
    if(queue$3.length === 0) {
      var _now = performanceNow()
        , next = Math.max(0, frameDuration - (_now - last$1));
      last$1 = next + _now;
      setTimeout(function() {
        var cp = queue$3.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue$3.length = 0;
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last$1);
            } catch(e) {
              setTimeout(function() { throw e }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue$3.push({
      handle: ++id$3,
      callback: callback,
      cancelled: false
    });
    return id$3
  };

  caf = function(handle) {
    for(var i = 0; i < queue$3.length; i++) {
      if(queue$3[i].handle === handle) {
        queue$3[i].cancelled = true;
      }
    }
  };
}

var raf_1 = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
};
var cancel = function() {
  caf.apply(root, arguments);
};
var polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
raf_1.cancel = cancel;
raf_1.polyfill = polyfill;

// a string of all valid unicode whitespaces
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var replace$2 = functionUncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim$1 = RegExp('^' + whitespace + whitespace + '*');
var rtrim$1 = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$3 = function (TYPE) {
  return function ($this) {
    var string = toString_1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace$2(string, ltrim$1, '');
    if (TYPE & 2) string = replace$2(string, rtrim$1, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$3(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$3(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$3(3)
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;



var non$1 = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non$1[METHOD_NAME]() !== non$1
      || (PROPER_FUNCTION_NAME$1 && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $trim$1 = stringTrim.trim;


// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
_export$2({ target: 'String', proto: true, forced: stringTrimForced('trim') }, {
  trim: function trim() {
    return $trim$1(this);
  }
});

/*
	Based on rgbcolor.js by Stoyan Stefanov <sstoo@gmail.com>
	http://www.phpied.com/rgb-color-parser-in-javascript/
*/

var rgbcolor = function(color_string) {
    this.ok = false;
    this.alpha = 1.0;

    // strip any leading #
    if (color_string.charAt(0) == '#') { // remove # if any
        color_string = color_string.substr(1,6);
    }

    color_string = color_string.replace(/ /g,'');
    color_string = color_string.toLowerCase();

    // before getting into regexps, try simple matches
    // and overwrite the input
    var simple_colors = {
        aliceblue: 'f0f8ff',
        antiquewhite: 'faebd7',
        aqua: '00ffff',
        aquamarine: '7fffd4',
        azure: 'f0ffff',
        beige: 'f5f5dc',
        bisque: 'ffe4c4',
        black: '000000',
        blanchedalmond: 'ffebcd',
        blue: '0000ff',
        blueviolet: '8a2be2',
        brown: 'a52a2a',
        burlywood: 'deb887',
        cadetblue: '5f9ea0',
        chartreuse: '7fff00',
        chocolate: 'd2691e',
        coral: 'ff7f50',
        cornflowerblue: '6495ed',
        cornsilk: 'fff8dc',
        crimson: 'dc143c',
        cyan: '00ffff',
        darkblue: '00008b',
        darkcyan: '008b8b',
        darkgoldenrod: 'b8860b',
        darkgray: 'a9a9a9',
        darkgreen: '006400',
        darkkhaki: 'bdb76b',
        darkmagenta: '8b008b',
        darkolivegreen: '556b2f',
        darkorange: 'ff8c00',
        darkorchid: '9932cc',
        darkred: '8b0000',
        darksalmon: 'e9967a',
        darkseagreen: '8fbc8f',
        darkslateblue: '483d8b',
        darkslategray: '2f4f4f',
        darkturquoise: '00ced1',
        darkviolet: '9400d3',
        deeppink: 'ff1493',
        deepskyblue: '00bfff',
        dimgray: '696969',
        dodgerblue: '1e90ff',
        feldspar: 'd19275',
        firebrick: 'b22222',
        floralwhite: 'fffaf0',
        forestgreen: '228b22',
        fuchsia: 'ff00ff',
        gainsboro: 'dcdcdc',
        ghostwhite: 'f8f8ff',
        gold: 'ffd700',
        goldenrod: 'daa520',
        gray: '808080',
        green: '008000',
        greenyellow: 'adff2f',
        honeydew: 'f0fff0',
        hotpink: 'ff69b4',
        indianred : 'cd5c5c',
        indigo : '4b0082',
        ivory: 'fffff0',
        khaki: 'f0e68c',
        lavender: 'e6e6fa',
        lavenderblush: 'fff0f5',
        lawngreen: '7cfc00',
        lemonchiffon: 'fffacd',
        lightblue: 'add8e6',
        lightcoral: 'f08080',
        lightcyan: 'e0ffff',
        lightgoldenrodyellow: 'fafad2',
        lightgrey: 'd3d3d3',
        lightgreen: '90ee90',
        lightpink: 'ffb6c1',
        lightsalmon: 'ffa07a',
        lightseagreen: '20b2aa',
        lightskyblue: '87cefa',
        lightslateblue: '8470ff',
        lightslategray: '778899',
        lightsteelblue: 'b0c4de',
        lightyellow: 'ffffe0',
        lime: '00ff00',
        limegreen: '32cd32',
        linen: 'faf0e6',
        magenta: 'ff00ff',
        maroon: '800000',
        mediumaquamarine: '66cdaa',
        mediumblue: '0000cd',
        mediumorchid: 'ba55d3',
        mediumpurple: '9370d8',
        mediumseagreen: '3cb371',
        mediumslateblue: '7b68ee',
        mediumspringgreen: '00fa9a',
        mediumturquoise: '48d1cc',
        mediumvioletred: 'c71585',
        midnightblue: '191970',
        mintcream: 'f5fffa',
        mistyrose: 'ffe4e1',
        moccasin: 'ffe4b5',
        navajowhite: 'ffdead',
        navy: '000080',
        oldlace: 'fdf5e6',
        olive: '808000',
        olivedrab: '6b8e23',
        orange: 'ffa500',
        orangered: 'ff4500',
        orchid: 'da70d6',
        palegoldenrod: 'eee8aa',
        palegreen: '98fb98',
        paleturquoise: 'afeeee',
        palevioletred: 'd87093',
        papayawhip: 'ffefd5',
        peachpuff: 'ffdab9',
        peru: 'cd853f',
        pink: 'ffc0cb',
        plum: 'dda0dd',
        powderblue: 'b0e0e6',
        purple: '800080',
        rebeccapurple: '663399',
        red: 'ff0000',
        rosybrown: 'bc8f8f',
        royalblue: '4169e1',
        saddlebrown: '8b4513',
        salmon: 'fa8072',
        sandybrown: 'f4a460',
        seagreen: '2e8b57',
        seashell: 'fff5ee',
        sienna: 'a0522d',
        silver: 'c0c0c0',
        skyblue: '87ceeb',
        slateblue: '6a5acd',
        slategray: '708090',
        snow: 'fffafa',
        springgreen: '00ff7f',
        steelblue: '4682b4',
        tan: 'd2b48c',
        teal: '008080',
        thistle: 'd8bfd8',
        tomato: 'ff6347',
        turquoise: '40e0d0',
        violet: 'ee82ee',
        violetred: 'd02090',
        wheat: 'f5deb3',
        white: 'ffffff',
        whitesmoke: 'f5f5f5',
        yellow: 'ffff00',
        yellowgreen: '9acd32'
    };
    color_string = simple_colors[color_string] || color_string;
    // emd of simple type-in colors

    // array of color definition objects
    var color_defs = [
        {
            re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
            example: ['rgba(123, 234, 45, 0.8)', 'rgba(255,234,245,1.0)'],
            process: function (bits){
                return [
                    parseInt(bits[1]),
                    parseInt(bits[2]),
                    parseInt(bits[3]),
                    parseFloat(bits[4])
                ];
            }
        },
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: ['rgb(123, 234, 45)', 'rgb(255,234,245)'],
            process: function (bits){
                return [
                    parseInt(bits[1]),
                    parseInt(bits[2]),
                    parseInt(bits[3])
                ];
            }
        },
        {
            re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            example: ['#00ff00', '336699'],
            process: function (bits){
                return [
                    parseInt(bits[1], 16),
                    parseInt(bits[2], 16),
                    parseInt(bits[3], 16)
                ];
            }
        },
        {
            re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            example: ['#fb0', 'f0f'],
            process: function (bits){
                return [
                    parseInt(bits[1] + bits[1], 16),
                    parseInt(bits[2] + bits[2], 16),
                    parseInt(bits[3] + bits[3], 16)
                ];
            }
        }
    ];

    // search through the definitions to find a match
    for (var i = 0; i < color_defs.length; i++) {
        var re = color_defs[i].re;
        var processor = color_defs[i].process;
        var bits = re.exec(color_string);
        if (bits) {
            var channels = processor(bits);
            this.r = channels[0];
            this.g = channels[1];
            this.b = channels[2];
            if (channels.length > 3) {
                this.alpha = channels[3];
            }
            this.ok = true;
        }

    }

    // validate/cleanup values
    this.r = (this.r < 0 || isNaN(this.r)) ? 0 : ((this.r > 255) ? 255 : this.r);
    this.g = (this.g < 0 || isNaN(this.g)) ? 0 : ((this.g > 255) ? 255 : this.g);
    this.b = (this.b < 0 || isNaN(this.b)) ? 0 : ((this.b > 255) ? 255 : this.b);
    this.alpha = (this.alpha < 0) ? 0 : ((this.alpha > 1.0 || isNaN(this.alpha)) ? 1.0 : this.alpha);

    // some getters
    this.toRGB = function () {
        return 'rgb(' + this.r + ', ' + this.g + ', ' + this.b + ')';
    };
    this.toRGBA = function () {
        return 'rgba(' + this.r + ', ' + this.g + ', ' + this.b + ', ' + this.alpha + ')';
    };
    this.toHex = function () {
        var r = this.r.toString(16);
        var g = this.g.toString(16);
        var b = this.b.toString(16);
        if (r.length == 1) r = '0' + r;
        if (g.length == 1) g = '0' + g;
        if (b.length == 1) b = '0' + b;
        return '#' + r + g + b;
    };

    // help
    this.getHelpXML = function () {

        var examples = new Array();
        // add regexps
        for (var i = 0; i < color_defs.length; i++) {
            var example = color_defs[i].example;
            for (var j = 0; j < example.length; j++) {
                examples[examples.length] = example[j];
            }
        }
        // add type-in colors
        for (var sc in simple_colors) {
            examples[examples.length] = sc;
        }

        var xml = document.createElement('ul');
        xml.setAttribute('id', 'rgbcolor-examples');
        for (var i = 0; i < examples.length; i++) {
            try {
                var list_item = document.createElement('li');
                var list_color = new RGBColor(examples[i]);
                var example_div = document.createElement('div');
                example_div.style.cssText =
                        'margin: 3px; '
                        + 'border: 1px solid black; '
                        + 'background:' + list_color.toHex() + '; '
                        + 'color:' + list_color.toHex()
                ;
                example_div.appendChild(document.createTextNode('test'));
                var list_item_value = document.createTextNode(
                    ' ' + examples[i] + ' -> ' + list_color.toRGB() + ' -> ' + list_color.toHex()
                );
                list_item.appendChild(example_div);
                list_item.appendChild(list_item_value);
                xml.appendChild(list_item);

            } catch(e){}
        }
        return xml;

    };

};

/* eslint-disable es/no-array-prototype-indexof -- required for testing */


var $indexOf$1 = arrayIncludes.indexOf;


var nativeIndexOf = functionUncurryThis([].indexOf);

var NEGATIVE_ZERO$2 = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
var STRICT_METHOD$1 = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
_export$2({ target: 'Array', proto: true, forced: NEGATIVE_ZERO$2 || !STRICT_METHOD$1 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO$2
      // convert -0 to +0
      ? nativeIndexOf(this, searchElement, fromIndex) || 0
      : $indexOf$1(this, searchElement, fromIndex);
  }
});

var stringIndexOf$1 = functionUncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
_export$2({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(
      toString_1(requireObjectCoercible(this)),
      toString_1(notARegexp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$3 = Array.isArray || function isArray(argument) {
  return classofRaw(argument) == 'Array';
};

var nativeReverse = functionUncurryThis([].reverse);
var test$2 = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
_export$2({ target: 'Array', proto: true, forced: String(test$2) === String(test$2.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray$3(this)) this.length = this.length;
    return nativeReverse(this);
  }
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var t$1=function(r,e){return (t$1=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,r){t.__proto__=r;}||function(t,r){for(var e in r)Object.prototype.hasOwnProperty.call(r,e)&&(t[e]=r[e]);})(r,e)};function r(r,e){if("function"!=typeof e&&null!==e)throw new TypeError("Class extends value "+String(e)+" is not a constructor or null");function i(){this.constructor=r;}t$1(r,e),r.prototype=null===e?Object.create(e):(i.prototype=e.prototype,new i);}function e(t){var r="";Array.isArray(t)||(t=[t]);for(var e=0;e<t.length;e++){var i=t[e];if(i.type===_$1.CLOSE_PATH)r+="z";else if(i.type===_$1.HORIZ_LINE_TO)r+=(i.relative?"h":"H")+i.x;else if(i.type===_$1.VERT_LINE_TO)r+=(i.relative?"v":"V")+i.y;else if(i.type===_$1.MOVE_TO)r+=(i.relative?"m":"M")+i.x+" "+i.y;else if(i.type===_$1.LINE_TO)r+=(i.relative?"l":"L")+i.x+" "+i.y;else if(i.type===_$1.CURVE_TO)r+=(i.relative?"c":"C")+i.x1+" "+i.y1+" "+i.x2+" "+i.y2+" "+i.x+" "+i.y;else if(i.type===_$1.SMOOTH_CURVE_TO)r+=(i.relative?"s":"S")+i.x2+" "+i.y2+" "+i.x+" "+i.y;else if(i.type===_$1.QUAD_TO)r+=(i.relative?"q":"Q")+i.x1+" "+i.y1+" "+i.x+" "+i.y;else if(i.type===_$1.SMOOTH_QUAD_TO)r+=(i.relative?"t":"T")+i.x+" "+i.y;else{if(i.type!==_$1.ARC)throw new Error('Unexpected command type "'+i.type+'" at index '+e+".");r+=(i.relative?"a":"A")+i.rX+" "+i.rY+" "+i.xRot+" "+ +i.lArcFlag+" "+ +i.sweepFlag+" "+i.x+" "+i.y;}}return r}function i$6(t,r){var e=t[0],i=t[1];return [e*Math.cos(r)-i*Math.sin(r),e*Math.sin(r)+i*Math.cos(r)]}function a$1(){for(var t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];for(var e=0;e<t.length;e++)if("number"!=typeof t[e])throw new Error("assertNumbers arguments["+e+"] is not a number. "+typeof t[e]+" == typeof "+t[e]);return !0}var n$1=Math.PI;function o$1(t,r,e){t.lArcFlag=0===t.lArcFlag?0:1,t.sweepFlag=0===t.sweepFlag?0:1;var a=t.rX,o=t.rY,s=t.x,u=t.y;a=Math.abs(t.rX),o=Math.abs(t.rY);var h=i$6([(r-s)/2,(e-u)/2],-t.xRot/180*n$1),c=h[0],y=h[1],p=Math.pow(c,2)/Math.pow(a,2)+Math.pow(y,2)/Math.pow(o,2);1<p&&(a*=Math.sqrt(p),o*=Math.sqrt(p)),t.rX=a,t.rY=o;var m=Math.pow(a,2)*Math.pow(y,2)+Math.pow(o,2)*Math.pow(c,2),O=(t.lArcFlag!==t.sweepFlag?1:-1)*Math.sqrt(Math.max(0,(Math.pow(a,2)*Math.pow(o,2)-m)/m)),l=a*y/o*O,T=-o*c/a*O,v=i$6([l,T],t.xRot/180*n$1);t.cX=v[0]+(r+s)/2,t.cY=v[1]+(e+u)/2,t.phi1=Math.atan2((y-T)/o,(c-l)/a),t.phi2=Math.atan2((-y-T)/o,(-c-l)/a),0===t.sweepFlag&&t.phi2>t.phi1&&(t.phi2-=2*n$1),1===t.sweepFlag&&t.phi2<t.phi1&&(t.phi2+=2*n$1),t.phi1*=180/n$1,t.phi2*=180/n$1;}function s$1(t,r,e){a$1(t,r,e);var i=t*t+r*r-e*e;if(0>i)return [];if(0===i)return [[t*e/(t*t+r*r),r*e/(t*t+r*r)]];var n=Math.sqrt(i);return [[(t*e+r*n)/(t*t+r*r),(r*e-t*n)/(t*t+r*r)],[(t*e-r*n)/(t*t+r*r),(r*e+t*n)/(t*t+r*r)]]}var u$1,h$1=Math.PI/180;function c$1(t,r,e){return (1-e)*t+e*r}function y$1(t,r,e,i){return t+Math.cos(i/180*n$1)*r+Math.sin(i/180*n$1)*e}function p$1(t,r,e,i){var a=1e-6,n=r-t,o=e-r,s=3*n+3*(i-e)-6*o,u=6*(o-n),h=3*n;return Math.abs(s)<a?[-h/u]:function(t,r,e){void 0===e&&(e=1e-6);var i=t*t/4-r;if(i<-e)return [];if(i<=e)return [-t/2];var a=Math.sqrt(i);return [-t/2-a,-t/2+a]}(u/s,h/s,a)}function m$1(t,r,e,i,a){var n=1-a;return t*(n*n*n)+r*(3*n*n*a)+e*(3*n*a*a)+i*(a*a*a)}!function(t){function r(){return u((function(t,r,e){return t.relative&&(void 0!==t.x1&&(t.x1+=r),void 0!==t.y1&&(t.y1+=e),void 0!==t.x2&&(t.x2+=r),void 0!==t.y2&&(t.y2+=e),void 0!==t.x&&(t.x+=r),void 0!==t.y&&(t.y+=e),t.relative=!1),t}))}function e(){var t=NaN,r=NaN,e=NaN,i=NaN;return u((function(a,n,o){return a.type&_$1.SMOOTH_CURVE_TO&&(a.type=_$1.CURVE_TO,t=isNaN(t)?n:t,r=isNaN(r)?o:r,a.x1=a.relative?n-t:2*n-t,a.y1=a.relative?o-r:2*o-r),a.type&_$1.CURVE_TO?(t=a.relative?n+a.x2:a.x2,r=a.relative?o+a.y2:a.y2):(t=NaN,r=NaN),a.type&_$1.SMOOTH_QUAD_TO&&(a.type=_$1.QUAD_TO,e=isNaN(e)?n:e,i=isNaN(i)?o:i,a.x1=a.relative?n-e:2*n-e,a.y1=a.relative?o-i:2*o-i),a.type&_$1.QUAD_TO?(e=a.relative?n+a.x1:a.x1,i=a.relative?o+a.y1:a.y1):(e=NaN,i=NaN),a}))}function n(){var t=NaN,r=NaN;return u((function(e,i,a){if(e.type&_$1.SMOOTH_QUAD_TO&&(e.type=_$1.QUAD_TO,t=isNaN(t)?i:t,r=isNaN(r)?a:r,e.x1=e.relative?i-t:2*i-t,e.y1=e.relative?a-r:2*a-r),e.type&_$1.QUAD_TO){t=e.relative?i+e.x1:e.x1,r=e.relative?a+e.y1:e.y1;var n=e.x1,o=e.y1;e.type=_$1.CURVE_TO,e.x1=((e.relative?0:i)+2*n)/3,e.y1=((e.relative?0:a)+2*o)/3,e.x2=(e.x+2*n)/3,e.y2=(e.y+2*o)/3;}else t=NaN,r=NaN;return e}))}function u(t){var r=0,e=0,i=NaN,a=NaN;return function(n){if(isNaN(i)&&!(n.type&_$1.MOVE_TO))throw new Error("path must start with moveto");var o=t(n,r,e,i,a);return n.type&_$1.CLOSE_PATH&&(r=i,e=a),void 0!==n.x&&(r=n.relative?r+n.x:n.x),void 0!==n.y&&(e=n.relative?e+n.y:n.y),n.type&_$1.MOVE_TO&&(i=r,a=e),o}}function O(t,r,e,i,n,o){return a$1(t,r,e,i,n,o),u((function(a,s,u,h){var c=a.x1,y=a.x2,p=a.relative&&!isNaN(h),m=void 0!==a.x?a.x:p?0:s,O=void 0!==a.y?a.y:p?0:u;function l(t){return t*t}a.type&_$1.HORIZ_LINE_TO&&0!==r&&(a.type=_$1.LINE_TO,a.y=a.relative?0:u),a.type&_$1.VERT_LINE_TO&&0!==e&&(a.type=_$1.LINE_TO,a.x=a.relative?0:s),void 0!==a.x&&(a.x=a.x*t+O*e+(p?0:n)),void 0!==a.y&&(a.y=m*r+a.y*i+(p?0:o)),void 0!==a.x1&&(a.x1=a.x1*t+a.y1*e+(p?0:n)),void 0!==a.y1&&(a.y1=c*r+a.y1*i+(p?0:o)),void 0!==a.x2&&(a.x2=a.x2*t+a.y2*e+(p?0:n)),void 0!==a.y2&&(a.y2=y*r+a.y2*i+(p?0:o));var T=t*i-r*e;if(void 0!==a.xRot&&(1!==t||0!==r||0!==e||1!==i))if(0===T)delete a.rX,delete a.rY,delete a.xRot,delete a.lArcFlag,delete a.sweepFlag,a.type=_$1.LINE_TO;else{var v=a.xRot*Math.PI/180,f=Math.sin(v),N=Math.cos(v),x=1/l(a.rX),d=1/l(a.rY),E=l(N)*x+l(f)*d,A=2*f*N*(x-d),C=l(f)*x+l(N)*d,M=E*i*i-A*r*i+C*r*r,R=A*(t*i+r*e)-2*(E*e*i+C*t*r),g=E*e*e-A*t*e+C*t*t,I=(Math.atan2(R,M-g)+Math.PI)%Math.PI/2,S=Math.sin(I),L=Math.cos(I);a.rX=Math.abs(T)/Math.sqrt(M*l(L)+R*S*L+g*l(S)),a.rY=Math.abs(T)/Math.sqrt(M*l(S)-R*S*L+g*l(L)),a.xRot=180*I/Math.PI;}return void 0!==a.sweepFlag&&0>T&&(a.sweepFlag=+!a.sweepFlag),a}))}function l(){return function(t){var r={};for(var e in t)r[e]=t[e];return r}}t.ROUND=function(t){function r(r){return Math.round(r*t)/t}return void 0===t&&(t=1e13),a$1(t),function(t){return void 0!==t.x1&&(t.x1=r(t.x1)),void 0!==t.y1&&(t.y1=r(t.y1)),void 0!==t.x2&&(t.x2=r(t.x2)),void 0!==t.y2&&(t.y2=r(t.y2)),void 0!==t.x&&(t.x=r(t.x)),void 0!==t.y&&(t.y=r(t.y)),void 0!==t.rX&&(t.rX=r(t.rX)),void 0!==t.rY&&(t.rY=r(t.rY)),t}},t.TO_ABS=r,t.TO_REL=function(){return u((function(t,r,e){return t.relative||(void 0!==t.x1&&(t.x1-=r),void 0!==t.y1&&(t.y1-=e),void 0!==t.x2&&(t.x2-=r),void 0!==t.y2&&(t.y2-=e),void 0!==t.x&&(t.x-=r),void 0!==t.y&&(t.y-=e),t.relative=!0),t}))},t.NORMALIZE_HVZ=function(t,r,e){return void 0===t&&(t=!0),void 0===r&&(r=!0),void 0===e&&(e=!0),u((function(i,a,n,o,s){if(isNaN(o)&&!(i.type&_$1.MOVE_TO))throw new Error("path must start with moveto");return r&&i.type&_$1.HORIZ_LINE_TO&&(i.type=_$1.LINE_TO,i.y=i.relative?0:n),e&&i.type&_$1.VERT_LINE_TO&&(i.type=_$1.LINE_TO,i.x=i.relative?0:a),t&&i.type&_$1.CLOSE_PATH&&(i.type=_$1.LINE_TO,i.x=i.relative?o-a:o,i.y=i.relative?s-n:s),i.type&_$1.ARC&&(0===i.rX||0===i.rY)&&(i.type=_$1.LINE_TO,delete i.rX,delete i.rY,delete i.xRot,delete i.lArcFlag,delete i.sweepFlag),i}))},t.NORMALIZE_ST=e,t.QT_TO_C=n,t.INFO=u,t.SANITIZE=function(t){void 0===t&&(t=0),a$1(t);var r=NaN,e=NaN,i=NaN,n=NaN;return u((function(a,o,s,u,h){var c=Math.abs,y=!1,p=0,m=0;if(a.type&_$1.SMOOTH_CURVE_TO&&(p=isNaN(r)?0:o-r,m=isNaN(e)?0:s-e),a.type&(_$1.CURVE_TO|_$1.SMOOTH_CURVE_TO)?(r=a.relative?o+a.x2:a.x2,e=a.relative?s+a.y2:a.y2):(r=NaN,e=NaN),a.type&_$1.SMOOTH_QUAD_TO?(i=isNaN(i)?o:2*o-i,n=isNaN(n)?s:2*s-n):a.type&_$1.QUAD_TO?(i=a.relative?o+a.x1:a.x1,n=a.relative?s+a.y1:a.y2):(i=NaN,n=NaN),a.type&_$1.LINE_COMMANDS||a.type&_$1.ARC&&(0===a.rX||0===a.rY||!a.lArcFlag)||a.type&_$1.CURVE_TO||a.type&_$1.SMOOTH_CURVE_TO||a.type&_$1.QUAD_TO||a.type&_$1.SMOOTH_QUAD_TO){var O=void 0===a.x?0:a.relative?a.x:a.x-o,l=void 0===a.y?0:a.relative?a.y:a.y-s;p=isNaN(i)?void 0===a.x1?p:a.relative?a.x:a.x1-o:i-o,m=isNaN(n)?void 0===a.y1?m:a.relative?a.y:a.y1-s:n-s;var T=void 0===a.x2?0:a.relative?a.x:a.x2-o,v=void 0===a.y2?0:a.relative?a.y:a.y2-s;c(O)<=t&&c(l)<=t&&c(p)<=t&&c(m)<=t&&c(T)<=t&&c(v)<=t&&(y=!0);}return a.type&_$1.CLOSE_PATH&&c(o-u)<=t&&c(s-h)<=t&&(y=!0),y?[]:a}))},t.MATRIX=O,t.ROTATE=function(t,r,e){void 0===r&&(r=0),void 0===e&&(e=0),a$1(t,r,e);var i=Math.sin(t),n=Math.cos(t);return O(n,i,-i,n,r-r*n+e*i,e-r*i-e*n)},t.TRANSLATE=function(t,r){return void 0===r&&(r=0),a$1(t,r),O(1,0,0,1,t,r)},t.SCALE=function(t,r){return void 0===r&&(r=t),a$1(t,r),O(t,0,0,r,0,0)},t.SKEW_X=function(t){return a$1(t),O(1,0,Math.atan(t),1,0,0)},t.SKEW_Y=function(t){return a$1(t),O(1,Math.atan(t),0,1,0,0)},t.X_AXIS_SYMMETRY=function(t){return void 0===t&&(t=0),a$1(t),O(-1,0,0,1,t,0)},t.Y_AXIS_SYMMETRY=function(t){return void 0===t&&(t=0),a$1(t),O(1,0,0,-1,0,t)},t.A_TO_C=function(){return u((function(t,r,e){return _$1.ARC===t.type?function(t,r,e){var a,n,s,u;t.cX||o$1(t,r,e);for(var y=Math.min(t.phi1,t.phi2),p=Math.max(t.phi1,t.phi2)-y,m=Math.ceil(p/90),O=new Array(m),l=r,T=e,v=0;v<m;v++){var f=c$1(t.phi1,t.phi2,v/m),N=c$1(t.phi1,t.phi2,(v+1)/m),x=N-f,d=4/3*Math.tan(x*h$1/4),E=[Math.cos(f*h$1)-d*Math.sin(f*h$1),Math.sin(f*h$1)+d*Math.cos(f*h$1)],A=E[0],C=E[1],M=[Math.cos(N*h$1),Math.sin(N*h$1)],R=M[0],g=M[1],I=[R+d*Math.sin(N*h$1),g-d*Math.cos(N*h$1)],S=I[0],L=I[1];O[v]={relative:t.relative,type:_$1.CURVE_TO};var H=function(r,e){var a=i$6([r*t.rX,e*t.rY],t.xRot),n=a[0],o=a[1];return [t.cX+n,t.cY+o]};a=H(A,C),O[v].x1=a[0],O[v].y1=a[1],n=H(S,L),O[v].x2=n[0],O[v].y2=n[1],s=H(R,g),O[v].x=s[0],O[v].y=s[1],t.relative&&(O[v].x1-=l,O[v].y1-=T,O[v].x2-=l,O[v].y2-=T,O[v].x-=l,O[v].y-=T),l=(u=[O[v].x,O[v].y])[0],T=u[1];}return O}(t,t.relative?0:r,t.relative?0:e):t}))},t.ANNOTATE_ARCS=function(){return u((function(t,r,e){return t.relative&&(r=0,e=0),_$1.ARC===t.type&&o$1(t,r,e),t}))},t.CLONE=l,t.CALCULATE_BOUNDS=function(){var t=function(t){var r={};for(var e in t)r[e]=t[e];return r},i=r(),a=n(),h=e(),c=u((function(r,e,n){var u=h(a(i(t(r))));function O(t){t>c.maxX&&(c.maxX=t),t<c.minX&&(c.minX=t);}function l(t){t>c.maxY&&(c.maxY=t),t<c.minY&&(c.minY=t);}if(u.type&_$1.DRAWING_COMMANDS&&(O(e),l(n)),u.type&_$1.HORIZ_LINE_TO&&O(u.x),u.type&_$1.VERT_LINE_TO&&l(u.y),u.type&_$1.LINE_TO&&(O(u.x),l(u.y)),u.type&_$1.CURVE_TO){O(u.x),l(u.y);for(var T=0,v=p$1(e,u.x1,u.x2,u.x);T<v.length;T++){0<(w=v[T])&&1>w&&O(m$1(e,u.x1,u.x2,u.x,w));}for(var f=0,N=p$1(n,u.y1,u.y2,u.y);f<N.length;f++){0<(w=N[f])&&1>w&&l(m$1(n,u.y1,u.y2,u.y,w));}}if(u.type&_$1.ARC){O(u.x),l(u.y),o$1(u,e,n);for(var x=u.xRot/180*Math.PI,d=Math.cos(x)*u.rX,E=Math.sin(x)*u.rX,A=-Math.sin(x)*u.rY,C=Math.cos(x)*u.rY,M=u.phi1<u.phi2?[u.phi1,u.phi2]:-180>u.phi2?[u.phi2+360,u.phi1+360]:[u.phi2,u.phi1],R=M[0],g=M[1],I=function(t){var r=t[0],e=t[1],i=180*Math.atan2(e,r)/Math.PI;return i<R?i+360:i},S=0,L=s$1(A,-d,0).map(I);S<L.length;S++){(w=L[S])>R&&w<g&&O(y$1(u.cX,d,A,w));}for(var H=0,U=s$1(C,-E,0).map(I);H<U.length;H++){var w;(w=U[H])>R&&w<g&&l(y$1(u.cY,E,C,w));}}return r}));return c.minX=1/0,c.maxX=-1/0,c.minY=1/0,c.maxY=-1/0,c};}(u$1||(u$1={}));var O$1,l$1=function(){function t(){}return t.prototype.round=function(t){return this.transform(u$1.ROUND(t))},t.prototype.toAbs=function(){return this.transform(u$1.TO_ABS())},t.prototype.toRel=function(){return this.transform(u$1.TO_REL())},t.prototype.normalizeHVZ=function(t,r,e){return this.transform(u$1.NORMALIZE_HVZ(t,r,e))},t.prototype.normalizeST=function(){return this.transform(u$1.NORMALIZE_ST())},t.prototype.qtToC=function(){return this.transform(u$1.QT_TO_C())},t.prototype.aToC=function(){return this.transform(u$1.A_TO_C())},t.prototype.sanitize=function(t){return this.transform(u$1.SANITIZE(t))},t.prototype.translate=function(t,r){return this.transform(u$1.TRANSLATE(t,r))},t.prototype.scale=function(t,r){return this.transform(u$1.SCALE(t,r))},t.prototype.rotate=function(t,r,e){return this.transform(u$1.ROTATE(t,r,e))},t.prototype.matrix=function(t,r,e,i,a,n){return this.transform(u$1.MATRIX(t,r,e,i,a,n))},t.prototype.skewX=function(t){return this.transform(u$1.SKEW_X(t))},t.prototype.skewY=function(t){return this.transform(u$1.SKEW_Y(t))},t.prototype.xSymmetry=function(t){return this.transform(u$1.X_AXIS_SYMMETRY(t))},t.prototype.ySymmetry=function(t){return this.transform(u$1.Y_AXIS_SYMMETRY(t))},t.prototype.annotateArcs=function(){return this.transform(u$1.ANNOTATE_ARCS())},t}(),T$1=function(t){return " "===t||"\t"===t||"\r"===t||"\n"===t},v$1=function(t){return "0".charCodeAt(0)<=t.charCodeAt(0)&&t.charCodeAt(0)<="9".charCodeAt(0)},f$l=function(t){function e(){var r=t.call(this)||this;return r.curNumber="",r.curCommandType=-1,r.curCommandRelative=!1,r.canParseCommandOrComma=!0,r.curNumberHasExp=!1,r.curNumberHasExpDigits=!1,r.curNumberHasDecimal=!1,r.curArgs=[],r}return r(e,t),e.prototype.finish=function(t){if(void 0===t&&(t=[]),this.parse(" ",t),0!==this.curArgs.length||!this.canParseCommandOrComma)throw new SyntaxError("Unterminated command at the path end.");return t},e.prototype.parse=function(t,r){var e=this;void 0===r&&(r=[]);for(var i=function(t){r.push(t),e.curArgs.length=0,e.canParseCommandOrComma=!0;},a=0;a<t.length;a++){var n=t[a],o=!(this.curCommandType!==_$1.ARC||3!==this.curArgs.length&&4!==this.curArgs.length||1!==this.curNumber.length||"0"!==this.curNumber&&"1"!==this.curNumber),s=v$1(n)&&("0"===this.curNumber&&"0"===n||o);if(!v$1(n)||s)if("e"!==n&&"E"!==n)if("-"!==n&&"+"!==n||!this.curNumberHasExp||this.curNumberHasExpDigits)if("."!==n||this.curNumberHasExp||this.curNumberHasDecimal||o){if(this.curNumber&&-1!==this.curCommandType){var u=Number(this.curNumber);if(isNaN(u))throw new SyntaxError("Invalid number ending at "+a);if(this.curCommandType===_$1.ARC)if(0===this.curArgs.length||1===this.curArgs.length){if(0>u)throw new SyntaxError('Expected positive number, got "'+u+'" at index "'+a+'"')}else if((3===this.curArgs.length||4===this.curArgs.length)&&"0"!==this.curNumber&&"1"!==this.curNumber)throw new SyntaxError('Expected a flag, got "'+this.curNumber+'" at index "'+a+'"');this.curArgs.push(u),this.curArgs.length===N$1[this.curCommandType]&&(_$1.HORIZ_LINE_TO===this.curCommandType?i({type:_$1.HORIZ_LINE_TO,relative:this.curCommandRelative,x:u}):_$1.VERT_LINE_TO===this.curCommandType?i({type:_$1.VERT_LINE_TO,relative:this.curCommandRelative,y:u}):this.curCommandType===_$1.MOVE_TO||this.curCommandType===_$1.LINE_TO||this.curCommandType===_$1.SMOOTH_QUAD_TO?(i({type:this.curCommandType,relative:this.curCommandRelative,x:this.curArgs[0],y:this.curArgs[1]}),_$1.MOVE_TO===this.curCommandType&&(this.curCommandType=_$1.LINE_TO)):this.curCommandType===_$1.CURVE_TO?i({type:_$1.CURVE_TO,relative:this.curCommandRelative,x1:this.curArgs[0],y1:this.curArgs[1],x2:this.curArgs[2],y2:this.curArgs[3],x:this.curArgs[4],y:this.curArgs[5]}):this.curCommandType===_$1.SMOOTH_CURVE_TO?i({type:_$1.SMOOTH_CURVE_TO,relative:this.curCommandRelative,x2:this.curArgs[0],y2:this.curArgs[1],x:this.curArgs[2],y:this.curArgs[3]}):this.curCommandType===_$1.QUAD_TO?i({type:_$1.QUAD_TO,relative:this.curCommandRelative,x1:this.curArgs[0],y1:this.curArgs[1],x:this.curArgs[2],y:this.curArgs[3]}):this.curCommandType===_$1.ARC&&i({type:_$1.ARC,relative:this.curCommandRelative,rX:this.curArgs[0],rY:this.curArgs[1],xRot:this.curArgs[2],lArcFlag:this.curArgs[3],sweepFlag:this.curArgs[4],x:this.curArgs[5],y:this.curArgs[6]})),this.curNumber="",this.curNumberHasExpDigits=!1,this.curNumberHasExp=!1,this.curNumberHasDecimal=!1,this.canParseCommandOrComma=!0;}if(!T$1(n))if(","===n&&this.canParseCommandOrComma)this.canParseCommandOrComma=!1;else if("+"!==n&&"-"!==n&&"."!==n)if(s)this.curNumber=n,this.curNumberHasDecimal=!1;else{if(0!==this.curArgs.length)throw new SyntaxError("Unterminated command at index "+a+".");if(!this.canParseCommandOrComma)throw new SyntaxError('Unexpected character "'+n+'" at index '+a+". Command cannot follow comma");if(this.canParseCommandOrComma=!1,"z"!==n&&"Z"!==n)if("h"===n||"H"===n)this.curCommandType=_$1.HORIZ_LINE_TO,this.curCommandRelative="h"===n;else if("v"===n||"V"===n)this.curCommandType=_$1.VERT_LINE_TO,this.curCommandRelative="v"===n;else if("m"===n||"M"===n)this.curCommandType=_$1.MOVE_TO,this.curCommandRelative="m"===n;else if("l"===n||"L"===n)this.curCommandType=_$1.LINE_TO,this.curCommandRelative="l"===n;else if("c"===n||"C"===n)this.curCommandType=_$1.CURVE_TO,this.curCommandRelative="c"===n;else if("s"===n||"S"===n)this.curCommandType=_$1.SMOOTH_CURVE_TO,this.curCommandRelative="s"===n;else if("q"===n||"Q"===n)this.curCommandType=_$1.QUAD_TO,this.curCommandRelative="q"===n;else if("t"===n||"T"===n)this.curCommandType=_$1.SMOOTH_QUAD_TO,this.curCommandRelative="t"===n;else{if("a"!==n&&"A"!==n)throw new SyntaxError('Unexpected character "'+n+'" at index '+a+".");this.curCommandType=_$1.ARC,this.curCommandRelative="a"===n;}else r.push({type:_$1.CLOSE_PATH}),this.canParseCommandOrComma=!0,this.curCommandType=-1;}else this.curNumber=n,this.curNumberHasDecimal="."===n;}else this.curNumber+=n,this.curNumberHasDecimal=!0;else this.curNumber+=n;else this.curNumber+=n,this.curNumberHasExp=!0;else this.curNumber+=n,this.curNumberHasExpDigits=this.curNumberHasExp;}return r},e.prototype.transform=function(t){return Object.create(this,{parse:{value:function(r,e){void 0===e&&(e=[]);for(var i=0,a=Object.getPrototypeOf(this).parse.call(this,r);i<a.length;i++){var n=a[i],o=t(n);Array.isArray(o)?e.push.apply(e,o):e.push(o);}return e}}})},e}(l$1),_$1=function(t){function i(r){var e=t.call(this)||this;return e.commands="string"==typeof r?i.parse(r):r,e}return r(i,t),i.prototype.encode=function(){return i.encode(this.commands)},i.prototype.getBounds=function(){var t=u$1.CALCULATE_BOUNDS();return this.transform(t),t},i.prototype.transform=function(t){for(var r=[],e=0,i=this.commands;e<i.length;e++){var a=t(i[e]);Array.isArray(a)?r.push.apply(r,a):r.push(a);}return this.commands=r,this},i.encode=function(t){return e(t)},i.parse=function(t){var r=new f$l,e=[];return r.parse(t,e),r.finish(e),e},i.CLOSE_PATH=1,i.MOVE_TO=2,i.HORIZ_LINE_TO=4,i.VERT_LINE_TO=8,i.LINE_TO=16,i.CURVE_TO=32,i.SMOOTH_CURVE_TO=64,i.QUAD_TO=128,i.SMOOTH_QUAD_TO=256,i.ARC=512,i.LINE_COMMANDS=i.LINE_TO|i.HORIZ_LINE_TO|i.VERT_LINE_TO,i.DRAWING_COMMANDS=i.HORIZ_LINE_TO|i.VERT_LINE_TO|i.LINE_TO|i.CURVE_TO|i.SMOOTH_CURVE_TO|i.QUAD_TO|i.SMOOTH_QUAD_TO|i.ARC,i}(l$1),N$1=((O$1={})[_$1.MOVE_TO]=2,O$1[_$1.LINE_TO]=2,O$1[_$1.HORIZ_LINE_TO]=1,O$1[_$1.VERT_LINE_TO]=1,O$1[_$1.CLOSE_PATH]=0,O$1[_$1.QUAD_TO]=4,O$1[_$1.SMOOTH_QUAD_TO]=2,O$1[_$1.CURVE_TO]=6,O$1[_$1.SMOOTH_CURVE_TO]=4,O$1[_$1.ARC]=7,O$1);

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwnProperty_1(R, 'flags') && objectIsPrototypeOf(RegExpPrototype$1, R)
    ? functionCall(regexpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME$2 = functionName.PROPER;






var TO_STRING$2 = 'toString';
var RegExpPrototype$2 = RegExp.prototype;
var nativeToString = RegExpPrototype$2[TO_STRING$2];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$2 && nativeToString.name != TO_STRING$2;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING$2, function toString() {
    var R = anObject(this);
    var pattern = toString_1(R.source);
    var flags = toString_1(regexpGetFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/* eslint-disable no-bitwise -- used for calculations */

/* eslint-disable unicorn/prefer-query-selector -- aiming at
  backward-compatibility */

/**
* StackBlur - a fast almost Gaussian Blur For Canvas
*
* In case you find this class useful - especially in commercial projects -
* I am not totally unhappy for a small donation to my PayPal account
* mario@quasimondo.de
*
* Or support me on flattr:
* {@link https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript}.
*
* @module StackBlur
* @author Mario Klingemann
* Contact: mario@quasimondo.com
* Website: {@link http://www.quasimondo.com/StackBlurForCanvas/StackBlurDemo.html}
* Twitter: @quasimondo
*
* @copyright (c) 2010 Mario Klingemann
*
* Permission is hereby granted, free of charge, to any person
* obtaining a copy of this software and associated documentation
* files (the "Software"), to deal in the Software without
* restriction, including without limitation the rights to use,
* copy, modify, merge, publish, distribute, sublicense, and/or sell
* copies of the Software, and to permit persons to whom the
* Software is furnished to do so, subject to the following
* conditions:
*
* The above copyright notice and this permission notice shall be
* included in all copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
* EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
* OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
* NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
* HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
* FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
* OTHER DEALINGS IN THE SOFTWARE.
*/
var mulTable = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259];
var shgTable = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
/**
 * @param {string|HTMLCanvasElement} canvas
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @throws {Error|TypeError}
 * @returns {ImageData} See {@link https://html.spec.whatwg.org/multipage/canvas.html#imagedata}
 */


function getImageDataFromCanvas(canvas, topX, topY, width, height) {
  if (typeof canvas === 'string') {
    canvas = document.getElementById(canvas);
  }

  if (!canvas || _typeof(canvas) !== 'object' || !('getContext' in canvas)) {
    throw new TypeError('Expecting canvas with `getContext` method ' + 'in processCanvasRGB(A) calls!');
  }

  var context = canvas.getContext('2d');

  try {
    return context.getImageData(topX, topY, width, height);
  } catch (e) {
    throw new Error('unable to access image data: ' + e);
  }
}
/**
 * @param {HTMLCanvasElement} canvas
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {undefined}
 */


function processCanvasRGBA(canvas, topX, topY, width, height, radius) {
  if (isNaN(radius) || radius < 1) {
    return;
  }

  radius |= 0;
  var imageData = getImageDataFromCanvas(canvas, topX, topY, width, height);
  imageData = processImageDataRGBA(imageData, topX, topY, width, height, radius);
  canvas.getContext('2d').putImageData(imageData, topX, topY);
}
/**
 * @param {ImageData} imageData
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {ImageData}
 */


function processImageDataRGBA(imageData, topX, topY, width, height, radius) {
  var pixels = imageData.data;
  var div = 2 * radius + 1; // const w4 = width << 2;

  var widthMinus1 = width - 1;
  var heightMinus1 = height - 1;
  var radiusPlus1 = radius + 1;
  var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;
  var stackStart = new BlurStack();
  var stack = stackStart;
  var stackEnd;

  for (var i = 1; i < div; i++) {
    stack = stack.next = new BlurStack();

    if (i === radiusPlus1) {
      stackEnd = stack;
    }
  }

  stack.next = stackStart;
  var stackIn = null,
      stackOut = null,
      yw = 0,
      yi = 0;
  var mulSum = mulTable[radius];
  var shgSum = shgTable[radius];

  for (var y = 0; y < height; y++) {
    stack = stackStart;
    var pr = pixels[yi],
        pg = pixels[yi + 1],
        pb = pixels[yi + 2],
        pa = pixels[yi + 3];

    for (var _i = 0; _i < radiusPlus1; _i++) {
      stack.r = pr;
      stack.g = pg;
      stack.b = pb;
      stack.a = pa;
      stack = stack.next;
    }

    var rInSum = 0,
        gInSum = 0,
        bInSum = 0,
        aInSum = 0,
        rOutSum = radiusPlus1 * pr,
        gOutSum = radiusPlus1 * pg,
        bOutSum = radiusPlus1 * pb,
        aOutSum = radiusPlus1 * pa,
        rSum = sumFactor * pr,
        gSum = sumFactor * pg,
        bSum = sumFactor * pb,
        aSum = sumFactor * pa;

    for (var _i2 = 1; _i2 < radiusPlus1; _i2++) {
      var p = yi + ((widthMinus1 < _i2 ? widthMinus1 : _i2) << 2);
      var r = pixels[p],
          g = pixels[p + 1],
          b = pixels[p + 2],
          a = pixels[p + 3];
      var rbs = radiusPlus1 - _i2;
      rSum += (stack.r = r) * rbs;
      gSum += (stack.g = g) * rbs;
      bSum += (stack.b = b) * rbs;
      aSum += (stack.a = a) * rbs;
      rInSum += r;
      gInSum += g;
      bInSum += b;
      aInSum += a;
      stack = stack.next;
    }

    stackIn = stackStart;
    stackOut = stackEnd;

    for (var x = 0; x < width; x++) {
      var paInitial = aSum * mulSum >> shgSum;
      pixels[yi + 3] = paInitial;

      if (paInitial !== 0) {
        var _a2 = 255 / paInitial;

        pixels[yi] = (rSum * mulSum >> shgSum) * _a2;
        pixels[yi + 1] = (gSum * mulSum >> shgSum) * _a2;
        pixels[yi + 2] = (bSum * mulSum >> shgSum) * _a2;
      } else {
        pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
      }

      rSum -= rOutSum;
      gSum -= gOutSum;
      bSum -= bOutSum;
      aSum -= aOutSum;
      rOutSum -= stackIn.r;
      gOutSum -= stackIn.g;
      bOutSum -= stackIn.b;
      aOutSum -= stackIn.a;

      var _p = x + radius + 1;

      _p = yw + (_p < widthMinus1 ? _p : widthMinus1) << 2;
      rInSum += stackIn.r = pixels[_p];
      gInSum += stackIn.g = pixels[_p + 1];
      bInSum += stackIn.b = pixels[_p + 2];
      aInSum += stackIn.a = pixels[_p + 3];
      rSum += rInSum;
      gSum += gInSum;
      bSum += bInSum;
      aSum += aInSum;
      stackIn = stackIn.next;
      var _stackOut = stackOut,
          _r = _stackOut.r,
          _g = _stackOut.g,
          _b = _stackOut.b,
          _a = _stackOut.a;
      rOutSum += _r;
      gOutSum += _g;
      bOutSum += _b;
      aOutSum += _a;
      rInSum -= _r;
      gInSum -= _g;
      bInSum -= _b;
      aInSum -= _a;
      stackOut = stackOut.next;
      yi += 4;
    }

    yw += width;
  }

  for (var _x = 0; _x < width; _x++) {
    yi = _x << 2;

    var _pr = pixels[yi],
        _pg = pixels[yi + 1],
        _pb = pixels[yi + 2],
        _pa = pixels[yi + 3],
        _rOutSum = radiusPlus1 * _pr,
        _gOutSum = radiusPlus1 * _pg,
        _bOutSum = radiusPlus1 * _pb,
        _aOutSum = radiusPlus1 * _pa,
        _rSum = sumFactor * _pr,
        _gSum = sumFactor * _pg,
        _bSum = sumFactor * _pb,
        _aSum = sumFactor * _pa;

    stack = stackStart;

    for (var _i3 = 0; _i3 < radiusPlus1; _i3++) {
      stack.r = _pr;
      stack.g = _pg;
      stack.b = _pb;
      stack.a = _pa;
      stack = stack.next;
    }

    var yp = width;
    var _gInSum = 0,
        _bInSum = 0,
        _aInSum = 0,
        _rInSum = 0;

    for (var _i4 = 1; _i4 <= radius; _i4++) {
      yi = yp + _x << 2;

      var _rbs = radiusPlus1 - _i4;

      _rSum += (stack.r = _pr = pixels[yi]) * _rbs;
      _gSum += (stack.g = _pg = pixels[yi + 1]) * _rbs;
      _bSum += (stack.b = _pb = pixels[yi + 2]) * _rbs;
      _aSum += (stack.a = _pa = pixels[yi + 3]) * _rbs;
      _rInSum += _pr;
      _gInSum += _pg;
      _bInSum += _pb;
      _aInSum += _pa;
      stack = stack.next;

      if (_i4 < heightMinus1) {
        yp += width;
      }
    }

    yi = _x;
    stackIn = stackStart;
    stackOut = stackEnd;

    for (var _y = 0; _y < height; _y++) {
      var _p2 = yi << 2;

      pixels[_p2 + 3] = _pa = _aSum * mulSum >> shgSum;

      if (_pa > 0) {
        _pa = 255 / _pa;
        pixels[_p2] = (_rSum * mulSum >> shgSum) * _pa;
        pixels[_p2 + 1] = (_gSum * mulSum >> shgSum) * _pa;
        pixels[_p2 + 2] = (_bSum * mulSum >> shgSum) * _pa;
      } else {
        pixels[_p2] = pixels[_p2 + 1] = pixels[_p2 + 2] = 0;
      }

      _rSum -= _rOutSum;
      _gSum -= _gOutSum;
      _bSum -= _bOutSum;
      _aSum -= _aOutSum;
      _rOutSum -= stackIn.r;
      _gOutSum -= stackIn.g;
      _bOutSum -= stackIn.b;
      _aOutSum -= stackIn.a;
      _p2 = _x + ((_p2 = _y + radiusPlus1) < heightMinus1 ? _p2 : heightMinus1) * width << 2;
      _rSum += _rInSum += stackIn.r = pixels[_p2];
      _gSum += _gInSum += stackIn.g = pixels[_p2 + 1];
      _bSum += _bInSum += stackIn.b = pixels[_p2 + 2];
      _aSum += _aInSum += stackIn.a = pixels[_p2 + 3];
      stackIn = stackIn.next;
      _rOutSum += _pr = stackOut.r;
      _gOutSum += _pg = stackOut.g;
      _bOutSum += _pb = stackOut.b;
      _aOutSum += _pa = stackOut.a;
      _rInSum -= _pr;
      _gInSum -= _pg;
      _bInSum -= _pb;
      _aInSum -= _pa;
      stackOut = stackOut.next;
      yi += width;
    }
  }

  return imageData;
}
/**
 *
 */


var BlurStack =
/**
 * Set properties.
 */
function BlurStack() {
  _classCallCheck(this, BlurStack);

  this.r = 0;
  this.g = 0;
  this.b = 0;
  this.a = 0;
  this.next = null;
};

/**
 * Options preset for `OffscreenCanvas`.
 * @param config - Preset requirements.
 * @param config.DOMParser - XML/HTML parser from string into DOM Document.
 * @returns Preset object.
 */
function offscreen() {
  var {
    DOMParser: DOMParserFallback
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var preset = {
    window: null,
    ignoreAnimation: true,
    ignoreMouse: true,
    DOMParser: DOMParserFallback,

    createCanvas(width, height) {
      return new OffscreenCanvas(width, height);
    },

    createImage(url) {
      return _asyncToGenerator$1(function* () {
        var response = yield fetch(url);
        var blob = yield response.blob();
        var img = yield createImageBitmap(blob);
        return img;
      })();
    }

  };

  if (typeof DOMParser !== 'undefined' || typeof DOMParserFallback === 'undefined') {
    Reflect.deleteProperty(preset, 'DOMParser');
  }

  return preset;
}

/**
 * Options preset for `node-canvas`.
 * @param config - Preset requirements.
 * @param config.DOMParser - XML/HTML parser from string into DOM Document.
 * @param config.canvas - `node-canvas` exports.
 * @param config.fetch - WHATWG-compatible `fetch` function.
 * @returns Preset object.
 */
function node$1(_ref) {
  var {
    DOMParser,
    canvas,
    fetch
  } = _ref;
  return {
    window: null,
    ignoreAnimation: true,
    ignoreMouse: true,
    DOMParser,
    fetch,
    createCanvas: canvas.createCanvas,
    createImage: canvas.loadImage
  };
}

var index = /*#__PURE__*/Object.freeze({
	__proto__: null,
	offscreen: offscreen,
	node: node$1
});

/**
 * HTML-safe compress white-spaces.
 * @param str - String to compress.
 * @returns String.
 */
function compressSpaces(str) {
  return str.replace(/(?!\u3000)\s+/gm, ' ');
}
/**
 * HTML-safe left trim.
 * @param str - String to trim.
 * @returns String.
 */

function trimLeft(str) {
  return str.replace(/^[\n \t]+/, '');
}
/**
 * HTML-safe right trim.
 * @param str - String to trim.
 * @returns String.
 */

function trimRight(str) {
  return str.replace(/[\n \t]+$/, '');
}
/**
 * String to numbers array.
 * @param str - Numbers string.
 * @returns Numbers array.
 */

function toNumbers(str) {
  var matches = (str || '').match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [];
  return matches.map(parseFloat);
} // Microsoft Edge fix

var allUppercase = /^[A-Z-]+$/;
/**
 * Normalize attribute name.
 * @param name - Attribute name.
 * @returns Normalized attribute name.
 */

function normalizeAttributeName(name) {
  if (allUppercase.test(name)) {
    return name.toLowerCase();
  }

  return name;
}
/**
 * Parse external URL.
 * @param url - CSS url string.
 * @returns Parsed URL.
 */

function parseExternalUrl(url) {
  //                      single quotes [2]
  //                      v         double quotes [3]
  //                      v         v         no quotes [4]
  //                      v         v         v
  var urlMatch = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(url) || [];
  return urlMatch[2] || urlMatch[3] || urlMatch[4];
}
/**
 * Transform floats to integers in rgb colors.
 * @param color - Color to normalize.
 * @returns Normalized color.
 */

function normalizeColor(color) {
  if (!color.startsWith('rgb')) {
    return color;
  }

  var rgbParts = 3;
  var normalizedColor = color.replace(/\d+(\.\d+)?/g, (num, isFloat) => rgbParts-- && isFloat ? String(Math.round(parseFloat(num))) : num);
  return normalizedColor;
}

// slightly modified version of https://github.com/keeganstreet/specificity/blob/master/specificity.js
var attributeRegex = /(\[[^\]]+\])/g;
var idRegex = /(#[^\s+>~.[:]+)/g;
var classRegex = /(\.[^\s+>~.[:]+)/g;
var pseudoElementRegex = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi;
var pseudoClassWithBracketsRegex = /(:[\w-]+\([^)]*\))/gi;
var pseudoClassRegex = /(:[^\s+>~.[:]+)/g;
var elementRegex = /([^\s+>~.[:]+)/g;

function findSelectorMatch(selector, regex) {
  var matches = regex.exec(selector);

  if (!matches) {
    return [selector, 0];
  }

  return [selector.replace(regex, ' '), matches.length];
}
/**
 * Measure selector specificity.
 * @param selector - Selector to measure.
 * @returns Specificity.
 */


function getSelectorSpecificity(selector) {
  var specificity = [0, 0, 0];
  var currentSelector = selector.replace(/:not\(([^)]*)\)/g, '     $1 ').replace(/{[\s\S]*/gm, ' ');
  var delta = 0;
  [currentSelector, delta] = findSelectorMatch(currentSelector, attributeRegex);
  specificity[1] += delta;
  [currentSelector, delta] = findSelectorMatch(currentSelector, idRegex);
  specificity[0] += delta;
  [currentSelector, delta] = findSelectorMatch(currentSelector, classRegex);
  specificity[1] += delta;
  [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoElementRegex);
  specificity[2] += delta;
  [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoClassWithBracketsRegex);
  specificity[1] += delta;
  [currentSelector, delta] = findSelectorMatch(currentSelector, pseudoClassRegex);
  specificity[1] += delta;
  currentSelector = currentSelector.replace(/[*\s+>~]/g, ' ').replace(/[#.]/g, ' ');
  [currentSelector, delta] = findSelectorMatch(currentSelector, elementRegex); // lgtm [js/useless-assignment-to-local]

  specificity[2] += delta;
  return specificity.join('');
}

var PSEUDO_ZERO = .00000001;
/**
 * Vector magnitude.
 * @param v
 * @returns Number result.
 */

function vectorMagnitude(v) {
  return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2));
}
/**
 * Ratio between two vectors.
 * @param u
 * @param v
 * @returns Number result.
 */

function vectorsRatio(u, v) {
  return (u[0] * v[0] + u[1] * v[1]) / (vectorMagnitude(u) * vectorMagnitude(v));
}
/**
 * Angle between two vectors.
 * @param u
 * @param v
 * @returns Number result.
 */

function vectorsAngle(u, v) {
  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vectorsRatio(u, v));
}
function CB1(t) {
  return t * t * t;
}
function CB2(t) {
  return 3 * t * t * (1 - t);
}
function CB3(t) {
  return 3 * t * (1 - t) * (1 - t);
}
function CB4(t) {
  return (1 - t) * (1 - t) * (1 - t);
}
function QB1(t) {
  return t * t;
}
function QB2(t) {
  return 2 * t * (1 - t);
}
function QB3(t) {
  return (1 - t) * (1 - t);
}

class Property {
  constructor(document, name, value) {
    this.document = document;
    this.name = name;
    this.value = value;
    this.isNormalizedColor = false;
  }

  static empty(document) {
    return new Property(document, 'EMPTY', '');
  }

  split() {
    var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ' ';
    var {
      document,
      name
    } = this;
    return compressSpaces(this.getString()).trim().split(separator).map(value => new Property(document, name, value));
  }

  hasValue(zeroIsValue) {
    var {
      value
    } = this;
    return value !== null && value !== '' && (zeroIsValue || value !== 0) && typeof value !== 'undefined';
  }

  isString(regexp) {
    var {
      value
    } = this;
    var result = typeof value === 'string';

    if (!result || !regexp) {
      return result;
    }

    return regexp.test(value);
  }

  isUrlDefinition() {
    return this.isString(/^url\(/);
  }

  isPixels() {
    if (!this.hasValue()) {
      return false;
    }

    var asString = this.getString();

    switch (true) {
      case asString.endsWith('px'):
      case /^[0-9]+$/.test(asString):
        return true;

      default:
        return false;
    }
  }

  setValue(value) {
    this.value = value;
    return this;
  }

  getValue(def) {
    if (typeof def === 'undefined' || this.hasValue()) {
      return this.value;
    }

    return def;
  }

  getNumber(def) {
    if (!this.hasValue()) {
      if (typeof def === 'undefined') {
        return 0;
      }

      return parseFloat(def);
    }

    var {
      value
    } = this;
    var n = parseFloat(value);

    if (this.isString(/%$/)) {
      n /= 100.0;
    }

    return n;
  }

  getString(def) {
    if (typeof def === 'undefined' || this.hasValue()) {
      return typeof this.value === 'undefined' ? '' : String(this.value);
    }

    return String(def);
  }

  getColor(def) {
    var color = this.getString(def);

    if (this.isNormalizedColor) {
      return color;
    }

    this.isNormalizedColor = true;
    color = normalizeColor(color);
    this.value = color;
    return color;
  }

  getDpi() {
    return 96.0; // TODO: compute?
  }

  getRem() {
    return this.document.rootEmSize;
  }

  getEm() {
    return this.document.emSize;
  }

  getUnits() {
    return this.getString().replace(/[0-9.-]/g, '');
  }

  getPixels(axisOrIsFontSize) {
    var processPercent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!this.hasValue()) {
      return 0;
    }

    var [axis, isFontSize] = typeof axisOrIsFontSize === 'boolean' ? [undefined, axisOrIsFontSize] : [axisOrIsFontSize];
    var {
      viewPort
    } = this.document.screen;

    switch (true) {
      case this.isString(/vmin$/):
        return this.getNumber() / 100.0 * Math.min(viewPort.computeSize('x'), viewPort.computeSize('y'));

      case this.isString(/vmax$/):
        return this.getNumber() / 100.0 * Math.max(viewPort.computeSize('x'), viewPort.computeSize('y'));

      case this.isString(/vw$/):
        return this.getNumber() / 100.0 * viewPort.computeSize('x');

      case this.isString(/vh$/):
        return this.getNumber() / 100.0 * viewPort.computeSize('y');

      case this.isString(/rem$/):
        return this.getNumber() * this.getRem();

      case this.isString(/em$/):
        return this.getNumber() * this.getEm();

      case this.isString(/ex$/):
        return this.getNumber() * this.getEm() / 2.0;

      case this.isString(/px$/):
        return this.getNumber();

      case this.isString(/pt$/):
        return this.getNumber() * this.getDpi() * (1.0 / 72.0);

      case this.isString(/pc$/):
        return this.getNumber() * 15;

      case this.isString(/cm$/):
        return this.getNumber() * this.getDpi() / 2.54;

      case this.isString(/mm$/):
        return this.getNumber() * this.getDpi() / 25.4;

      case this.isString(/in$/):
        return this.getNumber() * this.getDpi();

      case this.isString(/%$/) && isFontSize:
        return this.getNumber() * this.getEm();

      case this.isString(/%$/):
        return this.getNumber() * viewPort.computeSize(axis);

      default:
        {
          var n = this.getNumber();

          if (processPercent && n < 1.0) {
            return n * viewPort.computeSize(axis);
          }

          return n;
        }
    }
  }

  getMilliseconds() {
    if (!this.hasValue()) {
      return 0;
    }

    if (this.isString(/ms$/)) {
      return this.getNumber();
    }

    return this.getNumber() * 1000;
  }

  getRadians() {
    if (!this.hasValue()) {
      return 0;
    }

    switch (true) {
      case this.isString(/deg$/):
        return this.getNumber() * (Math.PI / 180.0);

      case this.isString(/grad$/):
        return this.getNumber() * (Math.PI / 200.0);

      case this.isString(/rad$/):
        return this.getNumber();

      default:
        return this.getNumber() * (Math.PI / 180.0);
    }
  }

  getDefinition() {
    var asString = this.getString();
    var name = /#([^)'"]+)/.exec(asString);

    if (name) {
      name = name[1];
    }

    if (!name) {
      name = asString;
    }

    return this.document.definitions[name];
  }

  getFillStyleDefinition(element, opacity) {
    var def = this.getDefinition();

    if (!def) {
      return null;
    } // gradient


    if (typeof def.createGradient === 'function') {
      return def.createGradient(this.document.ctx, element, opacity);
    } // pattern


    if (typeof def.createPattern === 'function') {
      if (def.getHrefAttribute().hasValue()) {
        var patternTransform = def.getAttribute('patternTransform');
        def = def.getHrefAttribute().getDefinition();

        if (patternTransform.hasValue()) {
          def.getAttribute('patternTransform', true).setValue(patternTransform.value);
        }
      }

      return def.createPattern(this.document.ctx, element, opacity);
    }

    return null;
  }

  getTextBaseline() {
    if (!this.hasValue()) {
      return null;
    }

    return Property.textBaselineMapping[this.getString()];
  }

  addOpacity(opacity) {
    var value = this.getColor();
    var len = value.length;
    var commas = 0; // Simulate old RGBColor version, which can't parse rgba.

    for (var i = 0; i < len; i++) {
      if (value[i] === ',') {
        commas++;
      }

      if (commas === 3) {
        break;
      }
    }

    if (opacity.hasValue() && this.isString() && commas !== 3) {
      var color = new rgbcolor(value);

      if (color.ok) {
        color.alpha = opacity.getNumber();
        value = color.toRGBA();
      }
    }

    return new Property(this.document, this.name, value);
  }

}
Property.textBaselineMapping = {
  'baseline': 'alphabetic',
  'before-edge': 'top',
  'text-before-edge': 'top',
  'middle': 'middle',
  'central': 'middle',
  'after-edge': 'bottom',
  'text-after-edge': 'bottom',
  'ideographic': 'ideographic',
  'alphabetic': 'alphabetic',
  'hanging': 'hanging',
  'mathematical': 'alphabetic'
};

class ViewPort {
  constructor() {
    this.viewPorts = [];
  }

  clear() {
    this.viewPorts = [];
  }

  setCurrent(width, height) {
    this.viewPorts.push({
      width,
      height
    });
  }

  removeCurrent() {
    this.viewPorts.pop();
  }

  getCurrent() {
    var {
      viewPorts
    } = this;
    return viewPorts[viewPorts.length - 1];
  }

  get width() {
    return this.getCurrent().width;
  }

  get height() {
    return this.getCurrent().height;
  }

  computeSize(d) {
    if (typeof d === 'number') {
      return d;
    }

    if (d === 'x') {
      return this.width;
    }

    if (d === 'y') {
      return this.height;
    }

    return Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
  }

}

class Point {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }

  static parse(point) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var [x = defaultValue, y = defaultValue] = toNumbers(point);
    return new Point(x, y);
  }

  static parseScale(scale) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var [x = defaultValue, y = x] = toNumbers(scale);
    return new Point(x, y);
  }

  static parsePath(path) {
    var points = toNumbers(path);
    var len = points.length;
    var pathPoints = [];

    for (var i = 0; i < len; i += 2) {
      pathPoints.push(new Point(points[i], points[i + 1]));
    }

    return pathPoints;
  }

  angleTo(point) {
    return Math.atan2(point.y - this.y, point.x - this.x);
  }

  applyTransform(transform) {
    var {
      x,
      y
    } = this;
    var xp = x * transform[0] + y * transform[2] + transform[4];
    var yp = x * transform[1] + y * transform[3] + transform[5];
    this.x = xp;
    this.y = yp;
  }

}

class Mouse {
  constructor(screen) {
    this.screen = screen;
    this.working = false;
    this.events = [];
    this.eventElements = []; // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment

    this.onClick = this.onClick.bind(this); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment

    this.onMouseMove = this.onMouseMove.bind(this);
  }

  isWorking() {
    return this.working;
  }

  start() {
    if (this.working) {
      return;
    }

    var {
      screen,
      onClick,
      onMouseMove
    } = this;
    var canvas = screen.ctx.canvas;
    canvas.onclick = onClick;
    canvas.onmousemove = onMouseMove;
    this.working = true;
  }

  stop() {
    if (!this.working) {
      return;
    }

    var canvas = this.screen.ctx.canvas;
    this.working = false;
    canvas.onclick = null;
    canvas.onmousemove = null;
  }

  hasEvents() {
    return this.working && this.events.length > 0;
  }

  runEvents() {
    if (!this.working) {
      return;
    }

    var {
      screen: document,
      events,
      eventElements
    } = this;
    var {
      style
    } = document.ctx.canvas;

    if (style) {
      style.cursor = '';
    }

    events.forEach((_ref, i) => {
      var {
        run
      } = _ref;
      var element = eventElements[i];

      while (element) {
        run(element);
        element = element.parent;
      }
    }); // done running, clear

    this.events = [];
    this.eventElements = [];
  }

  checkPath(element, ctx) {
    if (!this.working || !ctx) {
      return;
    }

    var {
      events,
      eventElements
    } = this;
    events.forEach((_ref2, i) => {
      var {
        x,
        y
      } = _ref2;

      if (!eventElements[i] && ctx.isPointInPath && ctx.isPointInPath(x, y)) {
        eventElements[i] = element;
      }
    });
  }

  checkBoundingBox(element, boundingBox) {
    if (!this.working || !boundingBox) {
      return;
    }

    var {
      events,
      eventElements
    } = this;
    events.forEach((_ref3, i) => {
      var {
        x,
        y
      } = _ref3;

      if (!eventElements[i] && boundingBox.isPointInBox(x, y)) {
        eventElements[i] = element;
      }
    });
  }

  mapXY(x, y) {
    var {
      window,
      ctx
    } = this.screen;
    var point = new Point(x, y);
    var element = ctx.canvas;

    while (element) {
      point.x -= element.offsetLeft;
      point.y -= element.offsetTop;
      element = element.offsetParent;
    }

    if (window.scrollX) {
      point.x += window.scrollX;
    }

    if (window.scrollY) {
      point.y += window.scrollY;
    }

    return point;
  }

  onClick(event) {
    var {
      x,
      y
    } = this.mapXY(event.clientX, event.clientY);
    this.events.push({
      type: 'onclick',
      x,
      y,

      run(eventTarget) {
        if (eventTarget.onClick) {
          eventTarget.onClick();
        }
      }

    });
  }

  onMouseMove(event) {
    var {
      x,
      y
    } = this.mapXY(event.clientX, event.clientY);
    this.events.push({
      type: 'onmousemove',
      x,
      y,

      run(eventTarget) {
        if (eventTarget.onMouseMove) {
          eventTarget.onMouseMove();
        }
      }

    });
  }

}

var defaultWindow = typeof window !== 'undefined' ? window : null;
var defaultFetch$1 = typeof fetch !== 'undefined' ? fetch.bind(undefined) // `fetch` depends on context: `someObject.fetch(...)` will throw error.
: null;
class Screen {
  constructor(ctx) {
    var {
      fetch = defaultFetch$1,
      window = defaultWindow
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.ctx = ctx;
    this.FRAMERATE = 30;
    this.MAX_VIRTUAL_PIXELS = 30000;
    this.CLIENT_WIDTH = 800;
    this.CLIENT_HEIGHT = 600;
    this.viewPort = new ViewPort();
    this.mouse = new Mouse(this);
    this.animations = [];
    this.waits = [];
    this.frameDuration = 0;
    this.isReadyLock = false;
    this.isFirstRender = true;
    this.intervalId = null;
    this.window = window;
    this.fetch = fetch;
  }

  wait(checker) {
    this.waits.push(checker);
  }

  ready() {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    if (!this.readyPromise) {
      return Promise.resolve();
    }

    return this.readyPromise;
  }

  isReady() {
    if (this.isReadyLock) {
      return true;
    }

    var isReadyLock = this.waits.every(_ => _());

    if (isReadyLock) {
      this.waits = [];

      if (this.resolveReady) {
        this.resolveReady();
      }
    }

    this.isReadyLock = isReadyLock;
    return isReadyLock;
  }

  setDefaults(ctx) {
    // initial values and defaults
    ctx.strokeStyle = 'rgba(0,0,0,0)';
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.miterLimit = 4;
  }

  setViewBox(_ref) {
    var {
      document,
      ctx,
      aspectRatio,
      width,
      desiredWidth,
      height,
      desiredHeight,
      minX = 0,
      minY = 0,
      refX,
      refY,
      clip = false,
      clipX = 0,
      clipY = 0
    } = _ref;
    // aspect ratio - http://www.w3.org/TR/SVG/coords.html#PreserveAspectRatioAttribute
    var cleanAspectRatio = compressSpaces(aspectRatio).replace(/^defer\s/, ''); // ignore defer

    var [aspectRatioAlign, aspectRatioMeetOrSlice] = cleanAspectRatio.split(' ');
    var align = aspectRatioAlign || 'xMidYMid';
    var meetOrSlice = aspectRatioMeetOrSlice || 'meet'; // calculate scale

    var scaleX = width / desiredWidth;
    var scaleY = height / desiredHeight;
    var scaleMin = Math.min(scaleX, scaleY);
    var scaleMax = Math.max(scaleX, scaleY);
    var finalDesiredWidth = desiredWidth;
    var finalDesiredHeight = desiredHeight;

    if (meetOrSlice === 'meet') {
      finalDesiredWidth *= scaleMin;
      finalDesiredHeight *= scaleMin;
    }

    if (meetOrSlice === 'slice') {
      finalDesiredWidth *= scaleMax;
      finalDesiredHeight *= scaleMax;
    }

    var refXProp = new Property(document, 'refX', refX);
    var refYProp = new Property(document, 'refY', refY);
    var hasRefs = refXProp.hasValue() && refYProp.hasValue();

    if (hasRefs) {
      ctx.translate(-scaleMin * refXProp.getPixels('x'), -scaleMin * refYProp.getPixels('y'));
    }

    if (clip) {
      var scaledClipX = scaleMin * clipX;
      var scaledClipY = scaleMin * clipY;
      ctx.beginPath();
      ctx.moveTo(scaledClipX, scaledClipY);
      ctx.lineTo(width, scaledClipY);
      ctx.lineTo(width, height);
      ctx.lineTo(scaledClipX, height);
      ctx.closePath();
      ctx.clip();
    }

    if (!hasRefs) {
      var isMeetMinY = meetOrSlice === 'meet' && scaleMin === scaleY;
      var isSliceMaxY = meetOrSlice === 'slice' && scaleMax === scaleY;
      var isMeetMinX = meetOrSlice === 'meet' && scaleMin === scaleX;
      var isSliceMaxX = meetOrSlice === 'slice' && scaleMax === scaleX;

      if (align.startsWith('xMid') && (isMeetMinY || isSliceMaxY)) {
        ctx.translate(width / 2.0 - finalDesiredWidth / 2.0, 0);
      }

      if (align.endsWith('YMid') && (isMeetMinX || isSliceMaxX)) {
        ctx.translate(0, height / 2.0 - finalDesiredHeight / 2.0);
      }

      if (align.startsWith('xMax') && (isMeetMinY || isSliceMaxY)) {
        ctx.translate(width - finalDesiredWidth, 0);
      }

      if (align.endsWith('YMax') && (isMeetMinX || isSliceMaxX)) {
        ctx.translate(0, height - finalDesiredHeight);
      }
    } // scale


    switch (true) {
      case align === 'none':
        ctx.scale(scaleX, scaleY);
        break;

      case meetOrSlice === 'meet':
        ctx.scale(scaleMin, scaleMin);
        break;

      case meetOrSlice === 'slice':
        ctx.scale(scaleMax, scaleMax);
        break;
    } // translate


    ctx.translate(-minX, -minY);
  }

  start(element) {
    var {
      enableRedraw = false,
      ignoreMouse = false,
      ignoreAnimation = false,
      ignoreDimensions = false,
      ignoreClear = false,
      forceRedraw,
      scaleWidth,
      scaleHeight,
      offsetX,
      offsetY
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      FRAMERATE,
      mouse
    } = this;
    var frameDuration = 1000 / FRAMERATE;
    this.frameDuration = frameDuration;
    this.readyPromise = new Promise(resolve => {
      this.resolveReady = resolve;
    });

    if (this.isReady()) {
      this.render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);
    }

    if (!enableRedraw) {
      return;
    }

    var now = Date.now();
    var then = now;
    var delta = 0;

    var tick = () => {
      now = Date.now();
      delta = now - then;

      if (delta >= frameDuration) {
        then = now - delta % frameDuration;

        if (this.shouldUpdate(ignoreAnimation, forceRedraw)) {
          this.render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);
          mouse.runEvents();
        }
      }

      this.intervalId = raf_1(tick);
    };

    if (!ignoreMouse) {
      mouse.start();
    }

    this.intervalId = raf_1(tick);
  }

  stop() {
    if (this.intervalId) {
      raf_1.cancel(this.intervalId);
      this.intervalId = null;
    }

    this.mouse.stop();
  }

  shouldUpdate(ignoreAnimation, forceRedraw) {
    // need update from animations?
    if (!ignoreAnimation) {
      var {
        frameDuration
      } = this;
      var shouldUpdate = this.animations.reduce((shouldUpdate, animation) => animation.update(frameDuration) || shouldUpdate, false);

      if (shouldUpdate) {
        return true;
      }
    } // need update from redraw?


    if (typeof forceRedraw === 'function' && forceRedraw()) {
      return true;
    }

    if (!this.isReadyLock && this.isReady()) {
      return true;
    } // need update from mouse events?


    if (this.mouse.hasEvents()) {
      return true;
    }

    return false;
  }

  render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY) {
    var {
      CLIENT_WIDTH,
      CLIENT_HEIGHT,
      viewPort,
      ctx,
      isFirstRender
    } = this;
    var canvas = ctx.canvas;
    viewPort.clear();

    if (canvas.width && canvas.height) {
      viewPort.setCurrent(canvas.width, canvas.height);
    } else {
      viewPort.setCurrent(CLIENT_WIDTH, CLIENT_HEIGHT);
    }

    var widthStyle = element.getStyle('width');
    var heightStyle = element.getStyle('height');

    if (!ignoreDimensions && (isFirstRender || typeof scaleWidth !== 'number' && typeof scaleHeight !== 'number')) {
      // set canvas size
      if (widthStyle.hasValue()) {
        canvas.width = widthStyle.getPixels('x');

        if (canvas.style) {
          canvas.style.width = "".concat(canvas.width, "px");
        }
      }

      if (heightStyle.hasValue()) {
        canvas.height = heightStyle.getPixels('y');

        if (canvas.style) {
          canvas.style.height = "".concat(canvas.height, "px");
        }
      }
    }

    var cWidth = canvas.clientWidth || canvas.width;
    var cHeight = canvas.clientHeight || canvas.height;

    if (ignoreDimensions && widthStyle.hasValue() && heightStyle.hasValue()) {
      cWidth = widthStyle.getPixels('x');
      cHeight = heightStyle.getPixels('y');
    }

    viewPort.setCurrent(cWidth, cHeight);

    if (typeof offsetX === 'number') {
      element.getAttribute('x', true).setValue(offsetX);
    }

    if (typeof offsetY === 'number') {
      element.getAttribute('y', true).setValue(offsetY);
    }

    if (typeof scaleWidth === 'number' || typeof scaleHeight === 'number') {
      var viewBox = toNumbers(element.getAttribute('viewBox').getString());
      var xRatio = 0;
      var yRatio = 0;

      if (typeof scaleWidth === 'number') {
        var _widthStyle = element.getStyle('width');

        if (_widthStyle.hasValue()) {
          xRatio = _widthStyle.getPixels('x') / scaleWidth;
        } else if (!isNaN(viewBox[2])) {
          xRatio = viewBox[2] / scaleWidth;
        }
      }

      if (typeof scaleHeight === 'number') {
        var _heightStyle = element.getStyle('height');

        if (_heightStyle.hasValue()) {
          yRatio = _heightStyle.getPixels('y') / scaleHeight;
        } else if (!isNaN(viewBox[3])) {
          yRatio = viewBox[3] / scaleHeight;
        }
      }

      if (!xRatio) {
        xRatio = yRatio;
      }

      if (!yRatio) {
        yRatio = xRatio;
      }

      element.getAttribute('width', true).setValue(scaleWidth);
      element.getAttribute('height', true).setValue(scaleHeight);
      var transformStyle = element.getStyle('transform', true, true);
      transformStyle.setValue("".concat(transformStyle.getString(), " scale(").concat(1.0 / xRatio, ", ").concat(1.0 / yRatio, ")"));
    } // clear and render


    if (!ignoreClear) {
      ctx.clearRect(0, 0, cWidth, cHeight);
    }

    element.render(ctx);

    if (isFirstRender) {
      this.isFirstRender = false;
    }
  }

}
Screen.defaultWindow = defaultWindow;
Screen.defaultFetch = defaultFetch$1;

var {
  defaultFetch
} = Screen;
var DefaultDOMParser = typeof DOMParser !== 'undefined' ? DOMParser : null;
class Parser {
  constructor() {
    var {
      fetch = defaultFetch,
      DOMParser = DefaultDOMParser
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.fetch = fetch;
    this.DOMParser = DOMParser;
  }

  parse(resource) {
    var _this = this;

    return _asyncToGenerator$1(function* () {
      if (resource.startsWith('<')) {
        return _this.parseFromString(resource);
      }

      return _this.load(resource);
    })();
  }

  parseFromString(xml) {
    var parser = new this.DOMParser();

    try {
      return this.checkDocument(parser.parseFromString(xml, 'image/svg+xml'));
    } catch (err) {
      return this.checkDocument(parser.parseFromString(xml, 'text/xml'));
    }
  }

  checkDocument(document) {
    var parserError = document.getElementsByTagName('parsererror')[0];

    if (parserError) {
      throw new Error(parserError.textContent);
    }

    return document;
  }

  load(url) {
    var _this2 = this;

    return _asyncToGenerator$1(function* () {
      var response = yield _this2.fetch(url);
      var xml = yield response.text();
      return _this2.parseFromString(xml);
    })();
  }

}

class Translate {
  constructor(_, point) {
    this.type = 'translate';
    this.point = null;
    this.point = Point.parse(point);
  }

  apply(ctx) {
    var {
      x,
      y
    } = this.point;
    ctx.translate(x || 0.0, y || 0.0);
  }

  unapply(ctx) {
    var {
      x,
      y
    } = this.point;
    ctx.translate(-1.0 * x || 0.0, -1.0 * y || 0.0);
  }

  applyToPoint(point) {
    var {
      x,
      y
    } = this.point;
    point.applyTransform([1, 0, 0, 1, x || 0.0, y || 0.0]);
  }

}

class Rotate {
  constructor(document, rotate, transformOrigin) {
    this.type = 'rotate';
    this.angle = null;
    this.originX = null;
    this.originY = null;
    this.cx = 0;
    this.cy = 0;
    var numbers = toNumbers(rotate);
    this.angle = new Property(document, 'angle', numbers[0]);
    this.originX = transformOrigin[0];
    this.originY = transformOrigin[1];
    this.cx = numbers[1] || 0;
    this.cy = numbers[2] || 0;
  }

  apply(ctx) {
    var {
      cx,
      cy,
      originX,
      originY,
      angle
    } = this;
    var tx = cx + originX.getPixels('x');
    var ty = cy + originY.getPixels('y');
    ctx.translate(tx, ty);
    ctx.rotate(angle.getRadians());
    ctx.translate(-tx, -ty);
  }

  unapply(ctx) {
    var {
      cx,
      cy,
      originX,
      originY,
      angle
    } = this;
    var tx = cx + originX.getPixels('x');
    var ty = cy + originY.getPixels('y');
    ctx.translate(tx, ty);
    ctx.rotate(-1.0 * angle.getRadians());
    ctx.translate(-tx, -ty);
  }

  applyToPoint(point) {
    var {
      cx,
      cy,
      angle
    } = this;
    var rad = angle.getRadians();
    point.applyTransform([1, 0, 0, 1, cx || 0.0, cy || 0.0 // this.p.y
    ]);
    point.applyTransform([Math.cos(rad), Math.sin(rad), -Math.sin(rad), Math.cos(rad), 0, 0]);
    point.applyTransform([1, 0, 0, 1, -cx || 0.0, -cy || 0.0 // -this.p.y
    ]);
  }

}

class Scale {
  constructor(_, scale, transformOrigin) {
    this.type = 'scale';
    this.scale = null;
    this.originX = null;
    this.originY = null;
    var scaleSize = Point.parseScale(scale); // Workaround for node-canvas

    if (scaleSize.x === 0 || scaleSize.y === 0) {
      scaleSize.x = PSEUDO_ZERO;
      scaleSize.y = PSEUDO_ZERO;
    }

    this.scale = scaleSize;
    this.originX = transformOrigin[0];
    this.originY = transformOrigin[1];
  }

  apply(ctx) {
    var {
      scale: {
        x,
        y
      },
      originX,
      originY
    } = this;
    var tx = originX.getPixels('x');
    var ty = originY.getPixels('y');
    ctx.translate(tx, ty);
    ctx.scale(x, y || x);
    ctx.translate(-tx, -ty);
  }

  unapply(ctx) {
    var {
      scale: {
        x,
        y
      },
      originX,
      originY
    } = this;
    var tx = originX.getPixels('x');
    var ty = originY.getPixels('y');
    ctx.translate(tx, ty);
    ctx.scale(1.0 / x, 1.0 / y || x);
    ctx.translate(-tx, -ty);
  }

  applyToPoint(point) {
    var {
      x,
      y
    } = this.scale;
    point.applyTransform([x || 0.0, 0, 0, y || 0.0, 0, 0]);
  }

}

class Matrix {
  constructor(_, matrix, transformOrigin) {
    this.type = 'matrix';
    this.matrix = [];
    this.originX = null;
    this.originY = null;
    this.matrix = toNumbers(matrix);
    this.originX = transformOrigin[0];
    this.originY = transformOrigin[1];
  }

  apply(ctx) {
    var {
      originX,
      originY,
      matrix
    } = this;
    var tx = originX.getPixels('x');
    var ty = originY.getPixels('y');
    ctx.translate(tx, ty);
    ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
    ctx.translate(-tx, -ty);
  }

  unapply(ctx) {
    var {
      originX,
      originY,
      matrix
    } = this;
    var a = matrix[0];
    var b = matrix[2];
    var c = matrix[4];
    var d = matrix[1];
    var e = matrix[3];
    var f = matrix[5];
    var g = 0.0;
    var h = 0.0;
    var i = 1.0;
    var det = 1 / (a * (e * i - f * h) - b * (d * i - f * g) + c * (d * h - e * g));
    var tx = originX.getPixels('x');
    var ty = originY.getPixels('y');
    ctx.translate(tx, ty);
    ctx.transform(det * (e * i - f * h), det * (f * g - d * i), det * (c * h - b * i), det * (a * i - c * g), det * (b * f - c * e), det * (c * d - a * f));
    ctx.translate(-tx, -ty);
  }

  applyToPoint(point) {
    point.applyTransform(this.matrix);
  }

}

class Skew extends Matrix {
  constructor(document, skew, transformOrigin) {
    super(document, skew, transformOrigin);
    this.type = 'skew';
    this.angle = null;
    this.angle = new Property(document, 'angle', skew);
  }

}

class SkewX extends Skew {
  constructor(document, skew, transformOrigin) {
    super(document, skew, transformOrigin);
    this.type = 'skewX';
    this.matrix = [1, 0, Math.tan(this.angle.getRadians()), 1, 0, 0];
  }

}

class SkewY extends Skew {
  constructor(document, skew, transformOrigin) {
    super(document, skew, transformOrigin);
    this.type = 'skewY';
    this.matrix = [1, Math.tan(this.angle.getRadians()), 0, 1, 0, 0];
  }

}

function parseTransforms(transform) {
  return compressSpaces(transform).trim().replace(/\)([a-zA-Z])/g, ') $1').replace(/\)(\s?,\s?)/g, ') ').split(/\s(?=[a-z])/);
}

function parseTransform(transform) {
  var [type, value] = transform.split('(');
  return [type.trim(), value.trim().replace(')', '')];
}

class Transform {
  constructor(document, transform, transformOrigin) {
    this.document = document;
    this.transforms = [];
    var data = parseTransforms(transform);
    data.forEach(transform => {
      if (transform === 'none') {
        return;
      }

      var [type, value] = parseTransform(transform);
      var TransformType = Transform.transformTypes[type];

      if (typeof TransformType !== 'undefined') {
        this.transforms.push(new TransformType(this.document, value, transformOrigin));
      }
    });
  }

  static fromElement(document, element) {
    var transformStyle = element.getStyle('transform', false, true);
    var [transformOriginXProperty, transformOriginYProperty = transformOriginXProperty] = element.getStyle('transform-origin', false, true).split();
    var transformOrigin = [transformOriginXProperty, transformOriginYProperty];

    if (transformStyle.hasValue()) {
      return new Transform(document, transformStyle.getString(), transformOrigin);
    }

    return null;
  }

  apply(ctx) {
    var {
      transforms
    } = this;
    var len = transforms.length;

    for (var i = 0; i < len; i++) {
      transforms[i].apply(ctx);
    }
  }

  unapply(ctx) {
    var {
      transforms
    } = this;
    var len = transforms.length;

    for (var i = len - 1; i >= 0; i--) {
      transforms[i].unapply(ctx);
    }
  } // TODO: applyToPoint unused ... remove?


  applyToPoint(point) {
    var {
      transforms
    } = this;
    var len = transforms.length;

    for (var i = 0; i < len; i++) {
      transforms[i].applyToPoint(point);
    }
  }

}
Transform.transformTypes = {
  translate: Translate,
  rotate: Rotate,
  scale: Scale,
  matrix: Matrix,
  skewX: SkewX,
  skewY: SkewY
};

class Element$1 {
  constructor(document, node) {
    var captureTextNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    this.document = document;
    this.node = node;
    this.captureTextNodes = captureTextNodes;
    this.attributes = {};
    this.styles = {};
    this.stylesSpecificity = {};
    this.animationFrozen = false;
    this.animationFrozenValue = '';
    this.parent = null;
    this.children = [];

    if (!node || node.nodeType !== 1) {
      // ELEMENT_NODE
      return;
    } // add attributes


    Array.from(node.attributes).forEach(attribute => {
      var nodeName = normalizeAttributeName(attribute.nodeName);
      this.attributes[nodeName] = new Property(document, nodeName, attribute.value);
    });
    this.addStylesFromStyleDefinition(); // add inline styles

    if (this.getAttribute('style').hasValue()) {
      var styles = this.getAttribute('style').getString().split(';').map(_ => _.trim());
      styles.forEach(style => {
        if (!style) {
          return;
        }

        var [name, value] = style.split(':').map(_ => _.trim());
        this.styles[name] = new Property(document, name, value);
      });
    }

    var {
      definitions
    } = document;
    var id = this.getAttribute('id'); // add id

    if (id.hasValue()) {
      if (!definitions[id.getString()]) {
        definitions[id.getString()] = this;
      }
    }

    Array.from(node.childNodes).forEach(childNode => {
      if (childNode.nodeType === 1) {
        this.addChild(childNode); // ELEMENT_NODE
      } else if (captureTextNodes && (childNode.nodeType === 3 || childNode.nodeType === 4)) {
        var textNode = document.createTextNode(childNode);

        if (textNode.getText().length > 0) {
          this.addChild(textNode); // TEXT_NODE
        }
      }
    });
  }

  getAttribute(name) {
    var createIfNotExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var attr = this.attributes[name];

    if (!attr && createIfNotExists) {
      var _attr = new Property(this.document, name, '');

      this.attributes[name] = _attr;
      return _attr;
    }

    return attr || Property.empty(this.document);
  }

  getHrefAttribute() {
    for (var key in this.attributes) {
      if (key === 'href' || key.endsWith(':href')) {
        return this.attributes[key];
      }
    }

    return Property.empty(this.document);
  }

  getStyle(name) {
    var createIfNotExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var skipAncestors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var style = this.styles[name];

    if (style) {
      return style;
    }

    var attr = this.getAttribute(name);

    if (attr !== null && attr !== void 0 && attr.hasValue()) {
      this.styles[name] = attr; // move up to me to cache

      return attr;
    }

    if (!skipAncestors) {
      var {
        parent
      } = this;

      if (parent) {
        var parentStyle = parent.getStyle(name);

        if (parentStyle !== null && parentStyle !== void 0 && parentStyle.hasValue()) {
          return parentStyle;
        }
      }
    }

    if (createIfNotExists) {
      var _style = new Property(this.document, name, '');

      this.styles[name] = _style;
      return _style;
    }

    return style || Property.empty(this.document);
  }

  render(ctx) {
    // don't render display=none
    // don't render visibility=hidden
    if (this.getStyle('display').getString() === 'none' || this.getStyle('visibility').getString() === 'hidden') {
      return;
    }

    ctx.save();

    if (this.getStyle('mask').hasValue()) {
      // mask
      var mask = this.getStyle('mask').getDefinition();

      if (mask) {
        this.applyEffects(ctx);
        mask.apply(ctx, this);
      }
    } else if (this.getStyle('filter').getValue('none') !== 'none') {
      // filter
      var filter = this.getStyle('filter').getDefinition();

      if (filter) {
        this.applyEffects(ctx);
        filter.apply(ctx, this);
      }
    } else {
      this.setContext(ctx);
      this.renderChildren(ctx);
      this.clearContext(ctx);
    }

    ctx.restore();
  }

  setContext(_) {// NO RENDER
  }

  applyEffects(ctx) {
    // transform
    var transform = Transform.fromElement(this.document, this);

    if (transform) {
      transform.apply(ctx);
    } // clip


    var clipPathStyleProp = this.getStyle('clip-path', false, true);

    if (clipPathStyleProp.hasValue()) {
      var clip = clipPathStyleProp.getDefinition();

      if (clip) {
        clip.apply(ctx);
      }
    }
  }

  clearContext(_) {// NO RENDER
  }

  renderChildren(ctx) {
    this.children.forEach(child => {
      child.render(ctx);
    });
  }

  addChild(childNode) {
    var child = childNode instanceof Element$1 ? childNode : this.document.createElement(childNode);
    child.parent = this;

    if (!Element$1.ignoreChildTypes.includes(child.type)) {
      this.children.push(child);
    }
  }

  matchesSelector(selector) {
    var _node$getAttribute;

    var {
      node
    } = this;

    if (typeof node.matches === 'function') {
      return node.matches(selector);
    }

    var styleClasses = (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'class');

    if (!styleClasses || styleClasses === '') {
      return false;
    }

    return styleClasses.split(' ').some(styleClass => ".".concat(styleClass) === selector);
  }

  addStylesFromStyleDefinition() {
    var {
      styles,
      stylesSpecificity
    } = this.document;

    for (var selector in styles) {
      if (!selector.startsWith('@') && this.matchesSelector(selector)) {
        var style = styles[selector];
        var specificity = stylesSpecificity[selector];

        if (style) {
          for (var name in style) {
            var existingSpecificity = this.stylesSpecificity[name];

            if (typeof existingSpecificity === 'undefined') {
              existingSpecificity = '000';
            }

            if (specificity >= existingSpecificity) {
              this.styles[name] = style[name];
              this.stylesSpecificity[name] = specificity;
            }
          }
        }
      }
    }
  }

  removeStyles(element, ignoreStyles) {
    var toRestore = ignoreStyles.reduce((toRestore, name) => {
      var styleProp = element.getStyle(name);

      if (!styleProp.hasValue()) {
        return toRestore;
      }

      var value = styleProp.getString();
      styleProp.setValue('');
      return [...toRestore, [name, value]];
    }, []);
    return toRestore;
  }

  restoreStyles(element, styles) {
    styles.forEach(_ref => {
      var [name, value] = _ref;
      element.getStyle(name, true).setValue(value);
    });
  }

  isFirstChild() {
    var _this$parent;

    return ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.children.indexOf(this)) === 0;
  }

}
Element$1.ignoreChildTypes = ['title'];

class UnknownElement extends Element$1 {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
  }

}

function wrapFontFamily(fontFamily) {
  var trimmed = fontFamily.trim();
  return /^('|")/.test(trimmed) ? trimmed : "\"".concat(trimmed, "\"");
}

function prepareFontFamily(fontFamily) {
  return typeof process === 'undefined' ? fontFamily : fontFamily.trim().split(',').map(wrapFontFamily).join(',');
}
/**
 * https://developer.mozilla.org/en-US/docs/Web/CSS/font-style
 * @param fontStyle
 * @returns CSS font style.
 */


function prepareFontStyle(fontStyle) {
  if (!fontStyle) {
    return '';
  }

  var targetFontStyle = fontStyle.trim().toLowerCase();

  switch (targetFontStyle) {
    case 'normal':
    case 'italic':
    case 'oblique':
    case 'inherit':
    case 'initial':
    case 'unset':
      return targetFontStyle;

    default:
      if (/^oblique\s+(-|)\d+deg$/.test(targetFontStyle)) {
        return targetFontStyle;
      }

      return '';
  }
}
/**
 * https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
 * @param fontWeight
 * @returns CSS font weight.
 */


function prepareFontWeight(fontWeight) {
  if (!fontWeight) {
    return '';
  }

  var targetFontWeight = fontWeight.trim().toLowerCase();

  switch (targetFontWeight) {
    case 'normal':
    case 'bold':
    case 'lighter':
    case 'bolder':
    case 'inherit':
    case 'initial':
    case 'unset':
      return targetFontWeight;

    default:
      if (/^[\d.]+$/.test(targetFontWeight)) {
        return targetFontWeight;
      }

      return '';
  }
}

class Font {
  constructor(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit) {
    var inheritFont = inherit ? typeof inherit === 'string' ? Font.parse(inherit) : inherit : {};
    this.fontFamily = fontFamily || inheritFont.fontFamily;
    this.fontSize = fontSize || inheritFont.fontSize;
    this.fontStyle = fontStyle || inheritFont.fontStyle;
    this.fontWeight = fontWeight || inheritFont.fontWeight;
    this.fontVariant = fontVariant || inheritFont.fontVariant;
  }

  static parse() {
    var font = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var inherit = arguments.length > 1 ? arguments[1] : undefined;
    var fontStyle = '';
    var fontVariant = '';
    var fontWeight = '';
    var fontSize = '';
    var fontFamily = '';
    var parts = compressSpaces(font).trim().split(' ');
    var set = {
      fontSize: false,
      fontStyle: false,
      fontWeight: false,
      fontVariant: false
    };
    parts.forEach(part => {
      switch (true) {
        case !set.fontStyle && Font.styles.includes(part):
          if (part !== 'inherit') {
            fontStyle = part;
          }

          set.fontStyle = true;
          break;

        case !set.fontVariant && Font.variants.includes(part):
          if (part !== 'inherit') {
            fontVariant = part;
          }

          set.fontStyle = true;
          set.fontVariant = true;
          break;

        case !set.fontWeight && Font.weights.includes(part):
          if (part !== 'inherit') {
            fontWeight = part;
          }

          set.fontStyle = true;
          set.fontVariant = true;
          set.fontWeight = true;
          break;

        case !set.fontSize:
          if (part !== 'inherit') {
            [fontSize] = part.split('/');
          }

          set.fontStyle = true;
          set.fontVariant = true;
          set.fontWeight = true;
          set.fontSize = true;
          break;

        default:
          if (part !== 'inherit') {
            fontFamily += part;
          }

      }
    });
    return new Font(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit);
  }

  toString() {
    return [prepareFontStyle(this.fontStyle), this.fontVariant, prepareFontWeight(this.fontWeight), this.fontSize, // Wrap fontFamily only on nodejs and only for canvas.ctx
    prepareFontFamily(this.fontFamily)].join(' ').trim();
  }

}
Font.styles = 'normal|italic|oblique|inherit';
Font.variants = 'normal|small-caps|inherit';
Font.weights = 'normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit';

class BoundingBox {
  constructor() {
    var x1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.NaN;
    var y1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.NaN;
    var x2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Number.NaN;
    var y2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Number.NaN;
    this.x1 = x1;
    this.y1 = y1;
    this.x2 = x2;
    this.y2 = y2;
    this.addPoint(x1, y1);
    this.addPoint(x2, y2);
  }

  get x() {
    return this.x1;
  }

  get y() {
    return this.y1;
  }

  get width() {
    return this.x2 - this.x1;
  }

  get height() {
    return this.y2 - this.y1;
  }

  addPoint(x, y) {
    if (typeof x !== 'undefined') {
      if (isNaN(this.x1) || isNaN(this.x2)) {
        this.x1 = x;
        this.x2 = x;
      }

      if (x < this.x1) {
        this.x1 = x;
      }

      if (x > this.x2) {
        this.x2 = x;
      }
    }

    if (typeof y !== 'undefined') {
      if (isNaN(this.y1) || isNaN(this.y2)) {
        this.y1 = y;
        this.y2 = y;
      }

      if (y < this.y1) {
        this.y1 = y;
      }

      if (y > this.y2) {
        this.y2 = y;
      }
    }
  }

  addX(x) {
    this.addPoint(x, null);
  }

  addY(y) {
    this.addPoint(null, y);
  }

  addBoundingBox(boundingBox) {
    if (!boundingBox) {
      return;
    }

    var {
      x1,
      y1,
      x2,
      y2
    } = boundingBox;
    this.addPoint(x1, y1);
    this.addPoint(x2, y2);
  }

  sumCubic(t, p0, p1, p2, p3) {
    return Math.pow(1 - t, 3) * p0 + 3 * Math.pow(1 - t, 2) * t * p1 + 3 * (1 - t) * Math.pow(t, 2) * p2 + Math.pow(t, 3) * p3;
  }

  bezierCurveAdd(forX, p0, p1, p2, p3) {
    var b = 6 * p0 - 12 * p1 + 6 * p2;
    var a = -3 * p0 + 9 * p1 - 9 * p2 + 3 * p3;
    var c = 3 * p1 - 3 * p0;

    if (a === 0) {
      if (b === 0) {
        return;
      }

      var t = -c / b;

      if (0 < t && t < 1) {
        if (forX) {
          this.addX(this.sumCubic(t, p0, p1, p2, p3));
        } else {
          this.addY(this.sumCubic(t, p0, p1, p2, p3));
        }
      }

      return;
    }

    var b2ac = Math.pow(b, 2) - 4 * c * a;

    if (b2ac < 0) {
      return;
    }

    var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);

    if (0 < t1 && t1 < 1) {
      if (forX) {
        this.addX(this.sumCubic(t1, p0, p1, p2, p3));
      } else {
        this.addY(this.sumCubic(t1, p0, p1, p2, p3));
      }
    }

    var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);

    if (0 < t2 && t2 < 1) {
      if (forX) {
        this.addX(this.sumCubic(t2, p0, p1, p2, p3));
      } else {
        this.addY(this.sumCubic(t2, p0, p1, p2, p3));
      }
    }
  } // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html


  addBezierCurve(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
    this.addPoint(p0x, p0y);
    this.addPoint(p3x, p3y);
    this.bezierCurveAdd(true, p0x, p1x, p2x, p3x);
    this.bezierCurveAdd(false, p0y, p1y, p2y, p3y);
  }

  addQuadraticCurve(p0x, p0y, p1x, p1y, p2x, p2y) {
    var cp1x = p0x + 2 / 3 * (p1x - p0x); // CP1 = QP0 + 2/3 *(QP1-QP0)

    var cp1y = p0y + 2 / 3 * (p1y - p0y); // CP1 = QP0 + 2/3 *(QP1-QP0)

    var cp2x = cp1x + 1 / 3 * (p2x - p0x); // CP2 = CP1 + 1/3 *(QP2-QP0)

    var cp2y = cp1y + 1 / 3 * (p2y - p0y); // CP2 = CP1 + 1/3 *(QP2-QP0)

    this.addBezierCurve(p0x, p0y, cp1x, cp2x, cp1y, cp2y, p2x, p2y);
  }

  isPointInBox(x, y) {
    var {
      x1,
      y1,
      x2,
      y2
    } = this;
    return x1 <= x && x <= x2 && y1 <= y && y <= y2;
  }

}

class PathParser extends _$1 {
  constructor(path) {
    super(path // Fix spaces after signs.
    .replace(/([+\-.])\s+/gm, '$1') // Remove invalid part.
    .replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, ''));
    this.control = null;
    this.start = null;
    this.current = null;
    this.command = null;
    this.commands = this.commands;
    this.i = -1;
    this.previousCommand = null;
    this.points = [];
    this.angles = [];
  }

  reset() {
    this.i = -1;
    this.command = null;
    this.previousCommand = null;
    this.start = new Point(0, 0);
    this.control = new Point(0, 0);
    this.current = new Point(0, 0);
    this.points = [];
    this.angles = [];
  }

  isEnd() {
    var {
      i,
      commands
    } = this;
    return i >= commands.length - 1;
  }

  next() {
    var command = this.commands[++this.i];
    this.previousCommand = this.command;
    this.command = command;
    return command;
  }

  getPoint() {
    var xProp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'x';
    var yProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'y';
    var point = new Point(this.command[xProp], this.command[yProp]);
    return this.makeAbsolute(point);
  }

  getAsControlPoint(xProp, yProp) {
    var point = this.getPoint(xProp, yProp);
    this.control = point;
    return point;
  }

  getAsCurrentPoint(xProp, yProp) {
    var point = this.getPoint(xProp, yProp);
    this.current = point;
    return point;
  }

  getReflectedControlPoint() {
    var previousCommand = this.previousCommand.type;

    if (previousCommand !== _$1.CURVE_TO && previousCommand !== _$1.SMOOTH_CURVE_TO && previousCommand !== _$1.QUAD_TO && previousCommand !== _$1.SMOOTH_QUAD_TO) {
      return this.current;
    } // reflect point


    var {
      current: {
        x: cx,
        y: cy
      },
      control: {
        x: ox,
        y: oy
      }
    } = this;
    var point = new Point(2 * cx - ox, 2 * cy - oy);
    return point;
  }

  makeAbsolute(point) {
    if (this.command.relative) {
      var {
        x,
        y
      } = this.current;
      point.x += x;
      point.y += y;
    }

    return point;
  }

  addMarker(point, from, priorTo) {
    var {
      points,
      angles
    } = this; // if the last angle isn't filled in because we didn't have this point yet ...

    if (priorTo && angles.length > 0 && !angles[angles.length - 1]) {
      angles[angles.length - 1] = points[points.length - 1].angleTo(priorTo);
    }

    this.addMarkerAngle(point, from ? from.angleTo(point) : null);
  }

  addMarkerAngle(point, angle) {
    this.points.push(point);
    this.angles.push(angle);
  }

  getMarkerPoints() {
    return this.points;
  }

  getMarkerAngles() {
    var {
      angles
    } = this;
    var len = angles.length;

    for (var i = 0; i < len; i++) {
      if (!angles[i]) {
        for (var j = i + 1; j < len; j++) {
          if (angles[j]) {
            angles[i] = angles[j];
            break;
          }
        }
      }
    }

    return angles;
  }

}

class RenderedElement extends Element$1 {
  constructor() {
    super(...arguments);
    this.modifiedEmSizeStack = false;
  }

  calculateOpacity() {
    var opacity = 1.0; // eslint-disable-next-line @typescript-eslint/no-this-alias, consistent-this

    var element = this;

    while (element) {
      var opacityStyle = element.getStyle('opacity', false, true); // no ancestors on style call

      if (opacityStyle.hasValue(true)) {
        opacity *= opacityStyle.getNumber();
      }

      element = element.parent;
    }

    return opacity;
  }

  setContext(ctx) {
    var fromMeasure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!fromMeasure) {
      // causes stack overflow when measuring text with gradients
      // fill
      var fillStyleProp = this.getStyle('fill');
      var fillOpacityStyleProp = this.getStyle('fill-opacity');
      var strokeStyleProp = this.getStyle('stroke');
      var strokeOpacityProp = this.getStyle('stroke-opacity');

      if (fillStyleProp.isUrlDefinition()) {
        var fillStyle = fillStyleProp.getFillStyleDefinition(this, fillOpacityStyleProp);

        if (fillStyle) {
          ctx.fillStyle = fillStyle;
        }
      } else if (fillStyleProp.hasValue()) {
        if (fillStyleProp.getString() === 'currentColor') {
          fillStyleProp.setValue(this.getStyle('color').getColor());
        }

        var _fillStyle = fillStyleProp.getColor();

        if (_fillStyle !== 'inherit') {
          ctx.fillStyle = _fillStyle === 'none' ? 'rgba(0,0,0,0)' : _fillStyle;
        }
      }

      if (fillOpacityStyleProp.hasValue()) {
        var _fillStyle2 = new Property(this.document, 'fill', ctx.fillStyle).addOpacity(fillOpacityStyleProp).getColor();

        ctx.fillStyle = _fillStyle2;
      } // stroke


      if (strokeStyleProp.isUrlDefinition()) {
        var strokeStyle = strokeStyleProp.getFillStyleDefinition(this, strokeOpacityProp);

        if (strokeStyle) {
          ctx.strokeStyle = strokeStyle;
        }
      } else if (strokeStyleProp.hasValue()) {
        if (strokeStyleProp.getString() === 'currentColor') {
          strokeStyleProp.setValue(this.getStyle('color').getColor());
        }

        var _strokeStyle = strokeStyleProp.getString();

        if (_strokeStyle !== 'inherit') {
          ctx.strokeStyle = _strokeStyle === 'none' ? 'rgba(0,0,0,0)' : _strokeStyle;
        }
      }

      if (strokeOpacityProp.hasValue()) {
        var _strokeStyle2 = new Property(this.document, 'stroke', ctx.strokeStyle).addOpacity(strokeOpacityProp).getString();

        ctx.strokeStyle = _strokeStyle2;
      }

      var strokeWidthStyleProp = this.getStyle('stroke-width');

      if (strokeWidthStyleProp.hasValue()) {
        var newLineWidth = strokeWidthStyleProp.getPixels();
        ctx.lineWidth = !newLineWidth ? PSEUDO_ZERO // browsers don't respect 0 (or node-canvas? :-)
        : newLineWidth;
      }

      var strokeLinecapStyleProp = this.getStyle('stroke-linecap');
      var strokeLinejoinStyleProp = this.getStyle('stroke-linejoin');
      var strokeMiterlimitProp = this.getStyle('stroke-miterlimit'); // NEED TEST
      // const pointOrderStyleProp = this.getStyle('paint-order');

      var strokeDasharrayStyleProp = this.getStyle('stroke-dasharray');
      var strokeDashoffsetProp = this.getStyle('stroke-dashoffset');

      if (strokeLinecapStyleProp.hasValue()) {
        ctx.lineCap = strokeLinecapStyleProp.getString();
      }

      if (strokeLinejoinStyleProp.hasValue()) {
        ctx.lineJoin = strokeLinejoinStyleProp.getString();
      }

      if (strokeMiterlimitProp.hasValue()) {
        ctx.miterLimit = strokeMiterlimitProp.getNumber();
      } // NEED TEST
      // if (pointOrderStyleProp.hasValue()) {
      // 	// ?
      // 	ctx.paintOrder = pointOrderStyleProp.getValue();
      // }


      if (strokeDasharrayStyleProp.hasValue() && strokeDasharrayStyleProp.getString() !== 'none') {
        var gaps = toNumbers(strokeDasharrayStyleProp.getString());

        if (typeof ctx.setLineDash !== 'undefined') {
          ctx.setLineDash(gaps);
        } else // @ts-expect-error Handle browser prefix.
          if (typeof ctx.webkitLineDash !== 'undefined') {
            // @ts-expect-error Handle browser prefix.
            ctx.webkitLineDash = gaps;
          } else // @ts-expect-error Handle browser prefix.
            if (typeof ctx.mozDash !== 'undefined' && !(gaps.length === 1 && gaps[0] === 0)) {
              // @ts-expect-error Handle browser prefix.
              ctx.mozDash = gaps;
            }

        var offset = strokeDashoffsetProp.getPixels();

        if (typeof ctx.lineDashOffset !== 'undefined') {
          ctx.lineDashOffset = offset;
        } else // @ts-expect-error Handle browser prefix.
          if (typeof ctx.webkitLineDashOffset !== 'undefined') {
            // @ts-expect-error Handle browser prefix.
            ctx.webkitLineDashOffset = offset;
          } else // @ts-expect-error Handle browser prefix.
            if (typeof ctx.mozDashOffset !== 'undefined') {
              // @ts-expect-error Handle browser prefix.
              ctx.mozDashOffset = offset;
            }
      }
    } // font


    this.modifiedEmSizeStack = false;

    if (typeof ctx.font !== 'undefined') {
      var fontStyleProp = this.getStyle('font');
      var fontStyleStyleProp = this.getStyle('font-style');
      var fontVariantStyleProp = this.getStyle('font-variant');
      var fontWeightStyleProp = this.getStyle('font-weight');
      var fontSizeStyleProp = this.getStyle('font-size');
      var fontFamilyStyleProp = this.getStyle('font-family');
      var font = new Font(fontStyleStyleProp.getString(), fontVariantStyleProp.getString(), fontWeightStyleProp.getString(), fontSizeStyleProp.hasValue() ? "".concat(fontSizeStyleProp.getPixels(true), "px") : '', fontFamilyStyleProp.getString(), Font.parse(fontStyleProp.getString(), ctx.font));
      fontStyleStyleProp.setValue(font.fontStyle);
      fontVariantStyleProp.setValue(font.fontVariant);
      fontWeightStyleProp.setValue(font.fontWeight);
      fontSizeStyleProp.setValue(font.fontSize);
      fontFamilyStyleProp.setValue(font.fontFamily);
      ctx.font = font.toString();

      if (fontSizeStyleProp.isPixels()) {
        this.document.emSize = fontSizeStyleProp.getPixels();
        this.modifiedEmSizeStack = true;
      }
    }

    if (!fromMeasure) {
      // effects
      this.applyEffects(ctx); // opacity

      ctx.globalAlpha = this.calculateOpacity();
    }
  }

  clearContext(ctx) {
    super.clearContext(ctx);

    if (this.modifiedEmSizeStack) {
      this.document.popEmSize();
    }
  }

}

class PathElement extends RenderedElement {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'path';
    this.pathParser = null;
    this.pathParser = new PathParser(this.getAttribute('d').getString());
  }

  path(ctx) {
    var {
      pathParser
    } = this;
    var boundingBox = new BoundingBox();
    pathParser.reset();

    if (ctx) {
      ctx.beginPath();
    }

    while (!pathParser.isEnd()) {
      switch (pathParser.next().type) {
        case PathParser.MOVE_TO:
          this.pathM(ctx, boundingBox);
          break;

        case PathParser.LINE_TO:
          this.pathL(ctx, boundingBox);
          break;

        case PathParser.HORIZ_LINE_TO:
          this.pathH(ctx, boundingBox);
          break;

        case PathParser.VERT_LINE_TO:
          this.pathV(ctx, boundingBox);
          break;

        case PathParser.CURVE_TO:
          this.pathC(ctx, boundingBox);
          break;

        case PathParser.SMOOTH_CURVE_TO:
          this.pathS(ctx, boundingBox);
          break;

        case PathParser.QUAD_TO:
          this.pathQ(ctx, boundingBox);
          break;

        case PathParser.SMOOTH_QUAD_TO:
          this.pathT(ctx, boundingBox);
          break;

        case PathParser.ARC:
          this.pathA(ctx, boundingBox);
          break;

        case PathParser.CLOSE_PATH:
          this.pathZ(ctx, boundingBox);
          break;
      }
    }

    return boundingBox;
  }

  getBoundingBox(_) {
    return this.path();
  }

  getMarkers() {
    var {
      pathParser
    } = this;
    var points = pathParser.getMarkerPoints();
    var angles = pathParser.getMarkerAngles();
    var markers = points.map((point, i) => [point, angles[i]]);
    return markers;
  }

  renderChildren(ctx) {
    this.path(ctx);
    this.document.screen.mouse.checkPath(this, ctx);
    var fillRuleStyleProp = this.getStyle('fill-rule');

    if (ctx.fillStyle !== '') {
      if (fillRuleStyleProp.getString('inherit') !== 'inherit') {
        ctx.fill(fillRuleStyleProp.getString());
      } else {
        ctx.fill();
      }
    }

    if (ctx.strokeStyle !== '') {
      if (this.getAttribute('vector-effect').getString() === 'non-scaling-stroke') {
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.stroke();
        ctx.restore();
      } else {
        ctx.stroke();
      }
    }

    var markers = this.getMarkers();

    if (markers) {
      var markersLastIndex = markers.length - 1;
      var markerStartStyleProp = this.getStyle('marker-start');
      var markerMidStyleProp = this.getStyle('marker-mid');
      var markerEndStyleProp = this.getStyle('marker-end');

      if (markerStartStyleProp.isUrlDefinition()) {
        var marker = markerStartStyleProp.getDefinition();
        var [point, angle] = markers[0];
        marker.render(ctx, point, angle);
      }

      if (markerMidStyleProp.isUrlDefinition()) {
        var _marker = markerMidStyleProp.getDefinition();

        for (var i = 1; i < markersLastIndex; i++) {
          var [_point, _angle] = markers[i];

          _marker.render(ctx, _point, _angle);
        }
      }

      if (markerEndStyleProp.isUrlDefinition()) {
        var _marker2 = markerEndStyleProp.getDefinition();

        var [_point2, _angle2] = markers[markersLastIndex];

        _marker2.render(ctx, _point2, _angle2);
      }
    }
  }

  static pathM(pathParser) {
    var point = pathParser.getAsCurrentPoint();
    pathParser.start = pathParser.current;
    return {
      point
    };
  }

  pathM(ctx, boundingBox) {
    var {
      pathParser
    } = this;
    var {
      point
    } = PathElement.pathM(pathParser);
    var {
      x,
      y
    } = point;
    pathParser.addMarker(point);
    boundingBox.addPoint(x, y);

    if (ctx) {
      ctx.moveTo(x, y);
    }
  }

  static pathL(pathParser) {
    var {
      current
    } = pathParser;
    var point = pathParser.getAsCurrentPoint();
    return {
      current,
      point
    };
  }

  pathL(ctx, boundingBox) {
    var {
      pathParser
    } = this;
    var {
      current,
      point
    } = PathElement.pathL(pathParser);
    var {
      x,
      y
    } = point;
    pathParser.addMarker(point, current);
    boundingBox.addPoint(x, y);

    if (ctx) {
      ctx.lineTo(x, y);
    }
  }

  static pathH(pathParser) {
    var {
      current,
      command
    } = pathParser;
    var point = new Point((command.relative ? current.x : 0) + command.x, current.y);
    pathParser.current = point;
    return {
      current,
      point
    };
  }

  pathH(ctx, boundingBox) {
    var {
      pathParser
    } = this;
    var {
      current,
      point
    } = PathElement.pathH(pathParser);
    var {
      x,
      y
    } = point;
    pathParser.addMarker(point, current);
    boundingBox.addPoint(x, y);

    if (ctx) {
      ctx.lineTo(x, y);
    }
  }

  static pathV(pathParser) {
    var {
      current,
      command
    } = pathParser;
    var point = new Point(current.x, (command.relative ? current.y : 0) + command.y);
    pathParser.current = point;
    return {
      current,
      point
    };
  }

  pathV(ctx, boundingBox) {
    var {
      pathParser
    } = this;
    var {
      current,
      point
    } = PathElement.pathV(pathParser);
    var {
      x,
      y
    } = point;
    pathParser.addMarker(point, current);
    boundingBox.addPoint(x, y);

    if (ctx) {
      ctx.lineTo(x, y);
    }
  }

  static pathC(pathParser) {
    var {
      current
    } = pathParser;
    var point = pathParser.getPoint('x1', 'y1');
    var controlPoint = pathParser.getAsControlPoint('x2', 'y2');
    var currentPoint = pathParser.getAsCurrentPoint();
    return {
      current,
      point,
      controlPoint,
      currentPoint
    };
  }

  pathC(ctx, boundingBox) {
    var {
      pathParser
    } = this;
    var {
      current,
      point,
      controlPoint,
      currentPoint
    } = PathElement.pathC(pathParser);
    pathParser.addMarker(currentPoint, controlPoint, point);
    boundingBox.addBezierCurve(current.x, current.y, point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);

    if (ctx) {
      ctx.bezierCurveTo(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
  }

  static pathS(pathParser) {
    var {
      current
    } = pathParser;
    var point = pathParser.getReflectedControlPoint();
    var controlPoint = pathParser.getAsControlPoint('x2', 'y2');
    var currentPoint = pathParser.getAsCurrentPoint();
    return {
      current,
      point,
      controlPoint,
      currentPoint
    };
  }

  pathS(ctx, boundingBox) {
    var {
      pathParser
    } = this;
    var {
      current,
      point,
      controlPoint,
      currentPoint
    } = PathElement.pathS(pathParser);
    pathParser.addMarker(currentPoint, controlPoint, point);
    boundingBox.addBezierCurve(current.x, current.y, point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);

    if (ctx) {
      ctx.bezierCurveTo(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
  }

  static pathQ(pathParser) {
    var {
      current
    } = pathParser;
    var controlPoint = pathParser.getAsControlPoint('x1', 'y1');
    var currentPoint = pathParser.getAsCurrentPoint();
    return {
      current,
      controlPoint,
      currentPoint
    };
  }

  pathQ(ctx, boundingBox) {
    var {
      pathParser
    } = this;
    var {
      current,
      controlPoint,
      currentPoint
    } = PathElement.pathQ(pathParser);
    pathParser.addMarker(currentPoint, controlPoint, controlPoint);
    boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);

    if (ctx) {
      ctx.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
  }

  static pathT(pathParser) {
    var {
      current
    } = pathParser;
    var controlPoint = pathParser.getReflectedControlPoint();
    pathParser.control = controlPoint;
    var currentPoint = pathParser.getAsCurrentPoint();
    return {
      current,
      controlPoint,
      currentPoint
    };
  }

  pathT(ctx, boundingBox) {
    var {
      pathParser
    } = this;
    var {
      current,
      controlPoint,
      currentPoint
    } = PathElement.pathT(pathParser);
    pathParser.addMarker(currentPoint, controlPoint, controlPoint);
    boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);

    if (ctx) {
      ctx.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
  }

  static pathA(pathParser) {
    var {
      current,
      command
    } = pathParser;
    var {
      rX,
      rY,
      xRot,
      lArcFlag,
      sweepFlag
    } = command;
    var xAxisRotation = xRot * (Math.PI / 180.0);
    var currentPoint = pathParser.getAsCurrentPoint(); // Conversion from endpoint to center parameterization
    // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
    // x1', y1'

    var currp = new Point(Math.cos(xAxisRotation) * (current.x - currentPoint.x) / 2.0 + Math.sin(xAxisRotation) * (current.y - currentPoint.y) / 2.0, -Math.sin(xAxisRotation) * (current.x - currentPoint.x) / 2.0 + Math.cos(xAxisRotation) * (current.y - currentPoint.y) / 2.0); // adjust radii

    var l = Math.pow(currp.x, 2) / Math.pow(rX, 2) + Math.pow(currp.y, 2) / Math.pow(rY, 2);

    if (l > 1) {
      rX *= Math.sqrt(l);
      rY *= Math.sqrt(l);
    } // cx', cy'


    var s = (lArcFlag === sweepFlag ? -1 : 1) * Math.sqrt((Math.pow(rX, 2) * Math.pow(rY, 2) - Math.pow(rX, 2) * Math.pow(currp.y, 2) - Math.pow(rY, 2) * Math.pow(currp.x, 2)) / (Math.pow(rX, 2) * Math.pow(currp.y, 2) + Math.pow(rY, 2) * Math.pow(currp.x, 2)));

    if (isNaN(s)) {
      s = 0;
    }

    var cpp = new Point(s * rX * currp.y / rY, s * -rY * currp.x / rX); // cx, cy

    var centp = new Point((current.x + currentPoint.x) / 2.0 + Math.cos(xAxisRotation) * cpp.x - Math.sin(xAxisRotation) * cpp.y, (current.y + currentPoint.y) / 2.0 + Math.sin(xAxisRotation) * cpp.x + Math.cos(xAxisRotation) * cpp.y); // initial angle

    var a1 = vectorsAngle([1, 0], [(currp.x - cpp.x) / rX, (currp.y - cpp.y) / rY]); // θ1
    // angle delta

    var u = [(currp.x - cpp.x) / rX, (currp.y - cpp.y) / rY];
    var v = [(-currp.x - cpp.x) / rX, (-currp.y - cpp.y) / rY];
    var ad = vectorsAngle(u, v); // Δθ

    if (vectorsRatio(u, v) <= -1) {
      ad = Math.PI;
    }

    if (vectorsRatio(u, v) >= 1) {
      ad = 0;
    }

    return {
      currentPoint,
      rX,
      rY,
      sweepFlag,
      xAxisRotation,
      centp,
      a1,
      ad
    };
  }

  pathA(ctx, boundingBox) {
    var {
      pathParser
    } = this;
    var {
      currentPoint,
      rX,
      rY,
      sweepFlag,
      xAxisRotation,
      centp,
      a1,
      ad
    } = PathElement.pathA(pathParser); // for markers

    var dir = 1 - sweepFlag ? 1.0 : -1.0;
    var ah = a1 + dir * (ad / 2.0);
    var halfWay = new Point(centp.x + rX * Math.cos(ah), centp.y + rY * Math.sin(ah));
    pathParser.addMarkerAngle(halfWay, ah - dir * Math.PI / 2);
    pathParser.addMarkerAngle(currentPoint, ah - dir * Math.PI);
    boundingBox.addPoint(currentPoint.x, currentPoint.y); // TODO: this is too naive, make it better

    if (ctx && !isNaN(a1) && !isNaN(ad)) {
      var r = rX > rY ? rX : rY;
      var sx = rX > rY ? 1 : rX / rY;
      var sy = rX > rY ? rY / rX : 1;
      ctx.translate(centp.x, centp.y);
      ctx.rotate(xAxisRotation);
      ctx.scale(sx, sy);
      ctx.arc(0, 0, r, a1, a1 + ad, Boolean(1 - sweepFlag));
      ctx.scale(1 / sx, 1 / sy);
      ctx.rotate(-xAxisRotation);
      ctx.translate(-centp.x, -centp.y);
    }
  }

  static pathZ(pathParser) {
    pathParser.current = pathParser.start;
  }

  pathZ(ctx, boundingBox) {
    PathElement.pathZ(this.pathParser);

    if (ctx) {
      // only close path if it is not a straight line
      if (boundingBox.x1 !== boundingBox.x2 && boundingBox.y1 !== boundingBox.y2) {
        ctx.closePath();
      }
    }
  }

}

class GlyphElement extends PathElement {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'glyph';
    this.horizAdvX = this.getAttribute('horiz-adv-x').getNumber();
    this.unicode = this.getAttribute('unicode').getString();
    this.arabicForm = this.getAttribute('arabic-form').getString();
  }

}

class TextElement extends RenderedElement {
  constructor(document, node, captureTextNodes) {
    super(document, node, new.target === TextElement ? true : captureTextNodes);
    this.type = 'text';
    this.x = 0;
    this.y = 0;
    this.measureCache = -1;
  }

  setContext(ctx) {
    var fromMeasure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    super.setContext(ctx, fromMeasure);
    var textBaseline = this.getStyle('dominant-baseline').getTextBaseline() || this.getStyle('alignment-baseline').getTextBaseline();

    if (textBaseline) {
      ctx.textBaseline = textBaseline;
    }
  }

  initializeCoordinates() {
    this.x = 0;
    this.y = 0;
    this.leafTexts = [];
    this.textChunkStart = 0;
    this.minX = Number.POSITIVE_INFINITY;
    this.maxX = Number.NEGATIVE_INFINITY;
  }

  getBoundingBox(ctx) {
    if (this.type !== 'text') {
      return this.getTElementBoundingBox(ctx);
    } // first, calculate child positions


    this.initializeCoordinates();
    this.adjustChildCoordinatesRecursive(ctx);
    var boundingBox = null; // then calculate bounding box

    this.children.forEach((_, i) => {
      var childBoundingBox = this.getChildBoundingBox(ctx, this, this, i);

      if (!boundingBox) {
        boundingBox = childBoundingBox;
      } else {
        boundingBox.addBoundingBox(childBoundingBox);
      }
    });
    return boundingBox;
  }

  getFontSize() {
    var {
      document,
      parent
    } = this;
    var inheritFontSize = Font.parse(document.ctx.font).fontSize;
    var fontSize = parent.getStyle('font-size').getNumber(inheritFontSize);
    return fontSize;
  }

  getTElementBoundingBox(ctx) {
    var fontSize = this.getFontSize();
    return new BoundingBox(this.x, this.y - fontSize, this.x + this.measureText(ctx), this.y);
  }

  getGlyph(font, text, i) {
    var char = text[i];
    var glyph = null;

    if (font.isArabic) {
      var len = text.length;
      var prevChar = text[i - 1];
      var nextChar = text[i + 1];
      var arabicForm = 'isolated';

      if ((i === 0 || prevChar === ' ') && i < len - 1 && nextChar !== ' ') {
        arabicForm = 'terminal';
      }

      if (i > 0 && prevChar !== ' ' && i < len - 1 && nextChar !== ' ') {
        arabicForm = 'medial';
      }

      if (i > 0 && prevChar !== ' ' && (i === len - 1 || nextChar === ' ')) {
        arabicForm = 'initial';
      }

      if (typeof font.glyphs[char] !== 'undefined') {
        // NEED TEST
        var maybeGlyph = font.glyphs[char];
        glyph = maybeGlyph instanceof GlyphElement ? maybeGlyph : maybeGlyph[arabicForm];
      }
    } else {
      glyph = font.glyphs[char];
    }

    if (!glyph) {
      glyph = font.missingGlyph;
    }

    return glyph;
  }

  getText() {
    return '';
  }

  getTextFromNode(node) {
    var textNode = node || this.node;
    var childNodes = Array.from(textNode.parentNode.childNodes);
    var index = childNodes.indexOf(textNode);
    var lastIndex = childNodes.length - 1;
    var text = compressSpaces( // textNode.value
    // || textNode.text
    textNode.textContent || '');

    if (index === 0) {
      text = trimLeft(text);
    }

    if (index === lastIndex) {
      text = trimRight(text);
    }

    return text;
  }

  renderChildren(ctx) {
    if (this.type !== 'text') {
      this.renderTElementChildren(ctx);
      return;
    } // first, calculate child positions


    this.initializeCoordinates();
    this.adjustChildCoordinatesRecursive(ctx); // then render

    this.children.forEach((_, i) => {
      this.renderChild(ctx, this, this, i);
    });
    var {
      mouse
    } = this.document.screen; // Do not calc bounding box if mouse is not working.

    if (mouse.isWorking()) {
      mouse.checkBoundingBox(this, this.getBoundingBox(ctx));
    }
  }

  renderTElementChildren(ctx) {
    var {
      document,
      parent
    } = this;
    var renderText = this.getText();
    var customFont = parent.getStyle('font-family').getDefinition();

    if (customFont) {
      var {
        unitsPerEm
      } = customFont.fontFace;
      var ctxFont = Font.parse(document.ctx.font);
      var fontSize = parent.getStyle('font-size').getNumber(ctxFont.fontSize);
      var fontStyle = parent.getStyle('font-style').getString(ctxFont.fontStyle);
      var scale = fontSize / unitsPerEm;
      var text = customFont.isRTL ? renderText.split('').reverse().join('') : renderText;
      var dx = toNumbers(parent.getAttribute('dx').getString());
      var len = text.length;

      for (var i = 0; i < len; i++) {
        var glyph = this.getGlyph(customFont, text, i);
        ctx.translate(this.x, this.y);
        ctx.scale(scale, -scale);
        var lw = ctx.lineWidth;
        ctx.lineWidth = ctx.lineWidth * unitsPerEm / fontSize;

        if (fontStyle === 'italic') {
          ctx.transform(1, 0, .4, 1, 0, 0);
        }

        glyph.render(ctx);

        if (fontStyle === 'italic') {
          ctx.transform(1, 0, -.4, 1, 0, 0);
        }

        ctx.lineWidth = lw;
        ctx.scale(1 / scale, -1 / scale);
        ctx.translate(-this.x, -this.y);
        this.x += fontSize * (glyph.horizAdvX || customFont.horizAdvX) / unitsPerEm;

        if (typeof dx[i] !== 'undefined' && !isNaN(dx[i])) {
          this.x += dx[i];
        }
      }

      return;
    }

    var {
      x,
      y
    } = this; // NEED TEST
    // if (ctx.paintOrder === 'stroke') {
    // 	if (ctx.strokeStyle) {
    // 		ctx.strokeText(renderText, x, y);
    // 	}
    // 	if (ctx.fillStyle) {
    // 		ctx.fillText(renderText, x, y);
    // 	}
    // } else {

    if (ctx.fillStyle) {
      ctx.fillText(renderText, x, y);
    }

    if (ctx.strokeStyle) {
      ctx.strokeText(renderText, x, y);
    } // }

  }

  applyAnchoring() {
    if (this.textChunkStart >= this.leafTexts.length) {
      return;
    } // This is basically the "Apply anchoring" part of https://www.w3.org/TR/SVG2/text.html#TextLayoutAlgorithm.
    // The difference is that we apply the anchoring as soon as a chunk is finished. This saves some extra looping.
    // Vertical text is not supported.


    var firstElement = this.leafTexts[this.textChunkStart];
    var textAnchor = firstElement.getStyle('text-anchor').getString('start');
    var isRTL = false; // we treat RTL like LTR

    var shift = 0;

    if (textAnchor === 'start' && !isRTL || textAnchor === 'end' && isRTL) {
      shift = firstElement.x - this.minX;
    } else if (textAnchor === 'end' && !isRTL || textAnchor === 'start' && isRTL) {
      shift = firstElement.x - this.maxX;
    } else {
      shift = firstElement.x - (this.minX + this.maxX) / 2;
    }

    for (var i = this.textChunkStart; i < this.leafTexts.length; i++) {
      this.leafTexts[i].x += shift;
    } // start new chunk


    this.minX = Number.POSITIVE_INFINITY;
    this.maxX = Number.NEGATIVE_INFINITY;
    this.textChunkStart = this.leafTexts.length;
  }

  adjustChildCoordinatesRecursive(ctx) {
    this.children.forEach((_, i) => {
      this.adjustChildCoordinatesRecursiveCore(ctx, this, this, i);
    });
    this.applyAnchoring();
  }

  adjustChildCoordinatesRecursiveCore(ctx, textParent, parent, i) {
    var child = parent.children[i];

    if (child.children.length > 0) {
      child.children.forEach((_, i) => {
        textParent.adjustChildCoordinatesRecursiveCore(ctx, textParent, child, i);
      });
    } else {
      // only leafs are relevant
      this.adjustChildCoordinates(ctx, textParent, parent, i);
    }
  }

  adjustChildCoordinates(ctx, textParent, parent, i) {
    var child = parent.children[i];

    if (typeof child.measureText !== 'function') {
      return child;
    }

    ctx.save();
    child.setContext(ctx, true);
    var xAttr = child.getAttribute('x');
    var yAttr = child.getAttribute('y');
    var dxAttr = child.getAttribute('dx');
    var dyAttr = child.getAttribute('dy');
    var customFont = child.getStyle('font-family').getDefinition();
    var isRTL = Boolean(customFont) && customFont.isRTL;

    if (i === 0) {
      // First children inherit attributes from parent(s). Positional attributes
      // are only inherited from a parent to it's first child.
      if (!xAttr.hasValue()) {
        xAttr.setValue(child.getInheritedAttribute('x'));
      }

      if (!yAttr.hasValue()) {
        yAttr.setValue(child.getInheritedAttribute('y'));
      }

      if (!dxAttr.hasValue()) {
        dxAttr.setValue(child.getInheritedAttribute('dx'));
      }

      if (!dyAttr.hasValue()) {
        dyAttr.setValue(child.getInheritedAttribute('dy'));
      }
    }

    var width = child.measureText(ctx);

    if (isRTL) {
      textParent.x -= width;
    }

    if (xAttr.hasValue()) {
      // an "x" attribute marks the start of a new chunk
      textParent.applyAnchoring();
      child.x = xAttr.getPixels('x');

      if (dxAttr.hasValue()) {
        child.x += dxAttr.getPixels('x');
      }
    } else {
      if (dxAttr.hasValue()) {
        textParent.x += dxAttr.getPixels('x');
      }

      child.x = textParent.x;
    }

    textParent.x = child.x;

    if (!isRTL) {
      textParent.x += width;
    }

    if (yAttr.hasValue()) {
      child.y = yAttr.getPixels('y');

      if (dyAttr.hasValue()) {
        child.y += dyAttr.getPixels('y');
      }
    } else {
      if (dyAttr.hasValue()) {
        textParent.y += dyAttr.getPixels('y');
      }

      child.y = textParent.y;
    }

    textParent.y = child.y; // update the current chunk and it's bounds

    textParent.leafTexts.push(child);
    textParent.minX = Math.min(textParent.minX, child.x, child.x + width);
    textParent.maxX = Math.max(textParent.maxX, child.x, child.x + width);
    child.clearContext(ctx);
    ctx.restore();
    return child;
  }

  getChildBoundingBox(ctx, textParent, parent, i) {
    var child = parent.children[i]; // not a text node?

    if (typeof child.getBoundingBox !== 'function') {
      return null;
    }

    var boundingBox = child.getBoundingBox(ctx);

    if (!boundingBox) {
      return null;
    }

    child.children.forEach((_, i) => {
      var childBoundingBox = textParent.getChildBoundingBox(ctx, textParent, child, i);
      boundingBox.addBoundingBox(childBoundingBox);
    });
    return boundingBox;
  }

  renderChild(ctx, textParent, parent, i) {
    var child = parent.children[i];
    child.render(ctx);
    child.children.forEach((_, i) => {
      textParent.renderChild(ctx, textParent, child, i);
    });
  }

  measureText(ctx) {
    var {
      measureCache
    } = this;

    if (~measureCache) {
      return measureCache;
    }

    var renderText = this.getText();
    var measure = this.measureTargetText(ctx, renderText);
    this.measureCache = measure;
    return measure;
  }

  measureTargetText(ctx, targetText) {
    if (!targetText.length) {
      return 0;
    }

    var {
      parent
    } = this;
    var customFont = parent.getStyle('font-family').getDefinition();

    if (customFont) {
      var fontSize = this.getFontSize();
      var text = customFont.isRTL ? targetText.split('').reverse().join('') : targetText;
      var dx = toNumbers(parent.getAttribute('dx').getString());
      var len = text.length;
      var _measure = 0;

      for (var i = 0; i < len; i++) {
        var glyph = this.getGlyph(customFont, text, i);
        _measure += (glyph.horizAdvX || customFont.horizAdvX) * fontSize / customFont.fontFace.unitsPerEm;

        if (typeof dx[i] !== 'undefined' && !isNaN(dx[i])) {
          _measure += dx[i];
        }
      }

      return _measure;
    }

    if (!ctx.measureText) {
      return targetText.length * 10;
    }

    ctx.save();
    this.setContext(ctx, true);
    var {
      width: measure
    } = ctx.measureText(targetText);
    this.clearContext(ctx);
    ctx.restore();
    return measure;
  }
  /**
   * Inherits positional attributes from {@link TextElement} parent(s). Attributes
   * are only inherited from a parent to its first child.
   * @param name - The attribute name.
   * @returns The attribute value or null.
   */


  getInheritedAttribute(name) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias,consistent-this
    var current = this;

    while (current instanceof TextElement && current.isFirstChild()) {
      var parentAttr = current.parent.getAttribute(name);

      if (parentAttr.hasValue(true)) {
        return parentAttr.getValue('0');
      }

      current = current.parent;
    }

    return null;
  }

}

class TSpanElement extends TextElement {
  constructor(document, node, captureTextNodes) {
    super(document, node, new.target === TSpanElement ? true : captureTextNodes);
    this.type = 'tspan'; // if this node has children, then they own the text

    this.text = this.children.length > 0 ? '' : this.getTextFromNode();
  }

  getText() {
    return this.text;
  }

}

class TextNode extends TSpanElement {
  constructor() {
    super(...arguments);
    this.type = 'textNode';
  }

}

class SVGElement extends RenderedElement {
  constructor() {
    super(...arguments);
    this.type = 'svg';
    this.root = false;
  }

  setContext(ctx) {
    var _this$node$parentNode;

    var {
      document
    } = this;
    var {
      screen,
      window
    } = document;
    var canvas = ctx.canvas;
    screen.setDefaults(ctx);

    if (canvas.style && typeof ctx.font !== 'undefined' && window && typeof window.getComputedStyle !== 'undefined') {
      ctx.font = window.getComputedStyle(canvas).getPropertyValue('font');
      var fontSizeProp = new Property(document, 'fontSize', Font.parse(ctx.font).fontSize);

      if (fontSizeProp.hasValue()) {
        document.rootEmSize = fontSizeProp.getPixels('y');
        document.emSize = document.rootEmSize;
      }
    } // create new view port


    if (!this.getAttribute('x').hasValue()) {
      this.getAttribute('x', true).setValue(0);
    }

    if (!this.getAttribute('y').hasValue()) {
      this.getAttribute('y', true).setValue(0);
    }

    var {
      width,
      height
    } = screen.viewPort;

    if (!this.getStyle('width').hasValue()) {
      this.getStyle('width', true).setValue('100%');
    }

    if (!this.getStyle('height').hasValue()) {
      this.getStyle('height', true).setValue('100%');
    }

    if (!this.getStyle('color').hasValue()) {
      this.getStyle('color', true).setValue('black');
    }

    var refXAttr = this.getAttribute('refX');
    var refYAttr = this.getAttribute('refY');
    var viewBoxAttr = this.getAttribute('viewBox');
    var viewBox = viewBoxAttr.hasValue() ? toNumbers(viewBoxAttr.getString()) : null;
    var clip = !this.root && this.getStyle('overflow').getValue('hidden') !== 'visible';
    var minX = 0;
    var minY = 0;
    var clipX = 0;
    var clipY = 0;

    if (viewBox) {
      minX = viewBox[0];
      minY = viewBox[1];
    }

    if (!this.root) {
      width = this.getStyle('width').getPixels('x');
      height = this.getStyle('height').getPixels('y');

      if (this.type === 'marker') {
        clipX = minX;
        clipY = minY;
        minX = 0;
        minY = 0;
      }
    }

    screen.viewPort.setCurrent(width, height); // Default value of transform-origin is center only for root SVG elements
    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform-origin

    if (this.node // is not temporary SVGElement
    && (!this.parent || ((_this$node$parentNode = this.node.parentNode) === null || _this$node$parentNode === void 0 ? void 0 : _this$node$parentNode.nodeName) === 'foreignObject') && this.getStyle('transform', false, true).hasValue() && !this.getStyle('transform-origin', false, true).hasValue()) {
      this.getStyle('transform-origin', true, true).setValue('50% 50%');
    }

    super.setContext(ctx);
    ctx.translate(this.getAttribute('x').getPixels('x'), this.getAttribute('y').getPixels('y'));

    if (viewBox) {
      width = viewBox[2];
      height = viewBox[3];
    }

    document.setViewBox({
      ctx,
      aspectRatio: this.getAttribute('preserveAspectRatio').getString(),
      width: screen.viewPort.width,
      desiredWidth: width,
      height: screen.viewPort.height,
      desiredHeight: height,
      minX,
      minY,
      refX: refXAttr.getValue(),
      refY: refYAttr.getValue(),
      clip,
      clipX,
      clipY
    });

    if (viewBox) {
      screen.viewPort.removeCurrent();
      screen.viewPort.setCurrent(width, height);
    }
  }

  clearContext(ctx) {
    super.clearContext(ctx);
    this.document.screen.viewPort.removeCurrent();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */


  resize(width) {
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
    var preserveAspectRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var widthAttr = this.getAttribute('width', true);
    var heightAttr = this.getAttribute('height', true);
    var viewBoxAttr = this.getAttribute('viewBox');
    var styleAttr = this.getAttribute('style');
    var originWidth = widthAttr.getNumber(0);
    var originHeight = heightAttr.getNumber(0);

    if (preserveAspectRatio) {
      if (typeof preserveAspectRatio === 'string') {
        this.getAttribute('preserveAspectRatio', true).setValue(preserveAspectRatio);
      } else {
        var preserveAspectRatioAttr = this.getAttribute('preserveAspectRatio');

        if (preserveAspectRatioAttr.hasValue()) {
          preserveAspectRatioAttr.setValue(preserveAspectRatioAttr.getString().replace(/^\s*(\S.*\S)\s*$/, '$1'));
        }
      }
    }

    widthAttr.setValue(width);
    heightAttr.setValue(height);

    if (!viewBoxAttr.hasValue()) {
      viewBoxAttr.setValue("0 0 ".concat(originWidth || width, " ").concat(originHeight || height));
    }

    if (styleAttr.hasValue()) {
      var widthStyle = this.getStyle('width');
      var heightStyle = this.getStyle('height');

      if (widthStyle.hasValue()) {
        widthStyle.setValue("".concat(width, "px"));
      }

      if (heightStyle.hasValue()) {
        heightStyle.setValue("".concat(height, "px"));
      }
    }
  }

}

class RectElement extends PathElement {
  constructor() {
    super(...arguments);
    this.type = 'rect';
  }

  path(ctx) {
    var x = this.getAttribute('x').getPixels('x');
    var y = this.getAttribute('y').getPixels('y');
    var width = this.getStyle('width', false, true).getPixels('x');
    var height = this.getStyle('height', false, true).getPixels('y');
    var rxAttr = this.getAttribute('rx');
    var ryAttr = this.getAttribute('ry');
    var rx = rxAttr.getPixels('x');
    var ry = ryAttr.getPixels('y');

    if (rxAttr.hasValue() && !ryAttr.hasValue()) {
      ry = rx;
    }

    if (ryAttr.hasValue() && !rxAttr.hasValue()) {
      rx = ry;
    }

    rx = Math.min(rx, width / 2.0);
    ry = Math.min(ry, height / 2.0);

    if (ctx) {
      var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
      ctx.beginPath(); // always start the path so we don't fill prior paths

      if (height > 0 && width > 0) {
        ctx.moveTo(x + rx, y);
        ctx.lineTo(x + width - rx, y);
        ctx.bezierCurveTo(x + width - rx + KAPPA * rx, y, x + width, y + ry - KAPPA * ry, x + width, y + ry);
        ctx.lineTo(x + width, y + height - ry);
        ctx.bezierCurveTo(x + width, y + height - ry + KAPPA * ry, x + width - rx + KAPPA * rx, y + height, x + width - rx, y + height);
        ctx.lineTo(x + rx, y + height);
        ctx.bezierCurveTo(x + rx - KAPPA * rx, y + height, x, y + height - ry + KAPPA * ry, x, y + height - ry);
        ctx.lineTo(x, y + ry);
        ctx.bezierCurveTo(x, y + ry - KAPPA * ry, x + rx - KAPPA * rx, y, x + rx, y);
        ctx.closePath();
      }
    }

    return new BoundingBox(x, y, x + width, y + height);
  }

  getMarkers() {
    return null;
  }

}

class CircleElement extends PathElement {
  constructor() {
    super(...arguments);
    this.type = 'circle';
  }

  path(ctx) {
    var cx = this.getAttribute('cx').getPixels('x');
    var cy = this.getAttribute('cy').getPixels('y');
    var r = this.getAttribute('r').getPixels();

    if (ctx && r > 0) {
      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, Math.PI * 2, false);
      ctx.closePath();
    }

    return new BoundingBox(cx - r, cy - r, cx + r, cy + r);
  }

  getMarkers() {
    return null;
  }

}

class EllipseElement extends PathElement {
  constructor() {
    super(...arguments);
    this.type = 'ellipse';
  }

  path(ctx) {
    var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
    var rx = this.getAttribute('rx').getPixels('x');
    var ry = this.getAttribute('ry').getPixels('y');
    var cx = this.getAttribute('cx').getPixels('x');
    var cy = this.getAttribute('cy').getPixels('y');

    if (ctx && rx > 0 && ry > 0) {
      ctx.beginPath();
      ctx.moveTo(cx + rx, cy);
      ctx.bezierCurveTo(cx + rx, cy + KAPPA * ry, cx + KAPPA * rx, cy + ry, cx, cy + ry);
      ctx.bezierCurveTo(cx - KAPPA * rx, cy + ry, cx - rx, cy + KAPPA * ry, cx - rx, cy);
      ctx.bezierCurveTo(cx - rx, cy - KAPPA * ry, cx - KAPPA * rx, cy - ry, cx, cy - ry);
      ctx.bezierCurveTo(cx + KAPPA * rx, cy - ry, cx + rx, cy - KAPPA * ry, cx + rx, cy);
      ctx.closePath();
    }

    return new BoundingBox(cx - rx, cy - ry, cx + rx, cy + ry);
  }

  getMarkers() {
    return null;
  }

}

class LineElement extends PathElement {
  constructor() {
    super(...arguments);
    this.type = 'line';
  }

  getPoints() {
    return [new Point(this.getAttribute('x1').getPixels('x'), this.getAttribute('y1').getPixels('y')), new Point(this.getAttribute('x2').getPixels('x'), this.getAttribute('y2').getPixels('y'))];
  }

  path(ctx) {
    var [{
      x: x0,
      y: y0
    }, {
      x: x1,
      y: y1
    }] = this.getPoints();

    if (ctx) {
      ctx.beginPath();
      ctx.moveTo(x0, y0);
      ctx.lineTo(x1, y1);
    }

    return new BoundingBox(x0, y0, x1, y1);
  }

  getMarkers() {
    var [p0, p1] = this.getPoints();
    var a = p0.angleTo(p1);
    return [[p0, a], [p1, a]];
  }

}

class PolylineElement extends PathElement {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'polyline';
    this.points = [];
    this.points = Point.parsePath(this.getAttribute('points').getString());
  }

  path(ctx) {
    var {
      points
    } = this;
    var [{
      x: x0,
      y: y0
    }] = points;
    var boundingBox = new BoundingBox(x0, y0);

    if (ctx) {
      ctx.beginPath();
      ctx.moveTo(x0, y0);
    }

    points.forEach(_ref => {
      var {
        x,
        y
      } = _ref;
      boundingBox.addPoint(x, y);

      if (ctx) {
        ctx.lineTo(x, y);
      }
    });
    return boundingBox;
  }

  getMarkers() {
    var {
      points
    } = this;
    var lastIndex = points.length - 1;
    var markers = [];
    points.forEach((point, i) => {
      if (i === lastIndex) {
        return;
      }

      markers.push([point, point.angleTo(points[i + 1])]);
    });

    if (markers.length > 0) {
      markers.push([points[points.length - 1], markers[markers.length - 1][1]]);
    }

    return markers;
  }

}

class PolygonElement extends PolylineElement {
  constructor() {
    super(...arguments);
    this.type = 'polygon';
  }

  path(ctx) {
    var boundingBox = super.path(ctx);
    var [{
      x,
      y
    }] = this.points;

    if (ctx) {
      ctx.lineTo(x, y);
      ctx.closePath();
    }

    return boundingBox;
  }

}

class PatternElement extends Element$1 {
  constructor() {
    super(...arguments);
    this.type = 'pattern';
  }

  createPattern(ctx, _, parentOpacityProp) {
    var width = this.getStyle('width').getPixels('x', true);
    var height = this.getStyle('height').getPixels('y', true); // render me using a temporary svg element

    var patternSvg = new SVGElement(this.document, null);
    patternSvg.attributes.viewBox = new Property(this.document, 'viewBox', this.getAttribute('viewBox').getValue());
    patternSvg.attributes.width = new Property(this.document, 'width', "".concat(width, "px"));
    patternSvg.attributes.height = new Property(this.document, 'height', "".concat(height, "px"));
    patternSvg.attributes.transform = new Property(this.document, 'transform', this.getAttribute('patternTransform').getValue());
    patternSvg.children = this.children;
    var patternCanvas = this.document.createCanvas(width, height);
    var patternCtx = patternCanvas.getContext('2d');
    var xAttr = this.getAttribute('x');
    var yAttr = this.getAttribute('y');

    if (xAttr.hasValue() && yAttr.hasValue()) {
      patternCtx.translate(xAttr.getPixels('x', true), yAttr.getPixels('y', true));
    }

    if (parentOpacityProp.hasValue()) {
      this.styles['fill-opacity'] = parentOpacityProp;
    } else {
      Reflect.deleteProperty(this.styles, 'fill-opacity');
    } // render 3x3 grid so when we transform there's no white space on edges


    for (var x = -1; x <= 1; x++) {
      for (var y = -1; y <= 1; y++) {
        patternCtx.save();
        patternSvg.attributes.x = new Property(this.document, 'x', x * patternCanvas.width);
        patternSvg.attributes.y = new Property(this.document, 'y', y * patternCanvas.height);
        patternSvg.render(patternCtx);
        patternCtx.restore();
      }
    }

    var pattern = ctx.createPattern(patternCanvas, 'repeat');
    return pattern;
  }

}

class MarkerElement extends Element$1 {
  constructor() {
    super(...arguments);
    this.type = 'marker';
  }

  render(ctx, point, angle) {
    if (!point) {
      return;
    }

    var {
      x,
      y
    } = point;
    var orient = this.getAttribute('orient').getString('auto');
    var markerUnits = this.getAttribute('markerUnits').getString('strokeWidth');
    ctx.translate(x, y);

    if (orient === 'auto') {
      ctx.rotate(angle);
    }

    if (markerUnits === 'strokeWidth') {
      ctx.scale(ctx.lineWidth, ctx.lineWidth);
    }

    ctx.save(); // render me using a temporary svg element

    var markerSvg = new SVGElement(this.document, null);
    markerSvg.type = this.type;
    markerSvg.attributes.viewBox = new Property(this.document, 'viewBox', this.getAttribute('viewBox').getValue());
    markerSvg.attributes.refX = new Property(this.document, 'refX', this.getAttribute('refX').getValue());
    markerSvg.attributes.refY = new Property(this.document, 'refY', this.getAttribute('refY').getValue());
    markerSvg.attributes.width = new Property(this.document, 'width', this.getAttribute('markerWidth').getValue());
    markerSvg.attributes.height = new Property(this.document, 'height', this.getAttribute('markerHeight').getValue());
    markerSvg.attributes.overflow = new Property(this.document, 'overflow', this.getAttribute('overflow').getValue());
    markerSvg.attributes.fill = new Property(this.document, 'fill', this.getAttribute('fill').getColor('black'));
    markerSvg.attributes.stroke = new Property(this.document, 'stroke', this.getAttribute('stroke').getValue('none'));
    markerSvg.children = this.children;
    markerSvg.render(ctx);
    ctx.restore();

    if (markerUnits === 'strokeWidth') {
      ctx.scale(1 / ctx.lineWidth, 1 / ctx.lineWidth);
    }

    if (orient === 'auto') {
      ctx.rotate(-angle);
    }

    ctx.translate(-x, -y);
  }

}

class DefsElement extends Element$1 {
  constructor() {
    super(...arguments);
    this.type = 'defs';
  }

  render() {// NOOP
  }

}

class GElement extends RenderedElement {
  constructor() {
    super(...arguments);
    this.type = 'g';
  }

  getBoundingBox(ctx) {
    var boundingBox = new BoundingBox();
    this.children.forEach(child => {
      boundingBox.addBoundingBox(child.getBoundingBox(ctx));
    });
    return boundingBox;
  }

}

class GradientElement extends Element$1 {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.attributesToInherit = ['gradientUnits'];
    this.stops = [];
    var {
      stops,
      children
    } = this;
    children.forEach(child => {
      if (child.type === 'stop') {
        stops.push(child);
      }
    });
  }

  getGradientUnits() {
    return this.getAttribute('gradientUnits').getString('objectBoundingBox');
  }

  createGradient(ctx, element, parentOpacityProp) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias, consistent-this
    var stopsContainer = this;

    if (this.getHrefAttribute().hasValue()) {
      stopsContainer = this.getHrefAttribute().getDefinition();
      this.inheritStopContainer(stopsContainer);
    }

    var {
      stops
    } = stopsContainer;
    var gradient = this.getGradient(ctx, element);

    if (!gradient) {
      return this.addParentOpacity(parentOpacityProp, stops[stops.length - 1].color);
    }

    stops.forEach(stop => {
      gradient.addColorStop(stop.offset, this.addParentOpacity(parentOpacityProp, stop.color));
    });

    if (this.getAttribute('gradientTransform').hasValue()) {
      // render as transformed pattern on temporary canvas
      var {
        document
      } = this;
      var {
        MAX_VIRTUAL_PIXELS,
        viewPort
      } = document.screen;
      var [rootView] = viewPort.viewPorts;
      var rect = new RectElement(document, null);
      rect.attributes.x = new Property(document, 'x', -MAX_VIRTUAL_PIXELS / 3.0);
      rect.attributes.y = new Property(document, 'y', -MAX_VIRTUAL_PIXELS / 3.0);
      rect.attributes.width = new Property(document, 'width', MAX_VIRTUAL_PIXELS);
      rect.attributes.height = new Property(document, 'height', MAX_VIRTUAL_PIXELS);
      var group = new GElement(document, null);
      group.attributes.transform = new Property(document, 'transform', this.getAttribute('gradientTransform').getValue());
      group.children = [rect];
      var patternSvg = new SVGElement(document, null);
      patternSvg.attributes.x = new Property(document, 'x', 0);
      patternSvg.attributes.y = new Property(document, 'y', 0);
      patternSvg.attributes.width = new Property(document, 'width', rootView.width);
      patternSvg.attributes.height = new Property(document, 'height', rootView.height);
      patternSvg.children = [group];
      var patternCanvas = document.createCanvas(rootView.width, rootView.height);
      var patternCtx = patternCanvas.getContext('2d');
      patternCtx.fillStyle = gradient;
      patternSvg.render(patternCtx);
      return patternCtx.createPattern(patternCanvas, 'no-repeat');
    }

    return gradient;
  }

  inheritStopContainer(stopsContainer) {
    this.attributesToInherit.forEach(attributeToInherit => {
      if (!this.getAttribute(attributeToInherit).hasValue() && stopsContainer.getAttribute(attributeToInherit).hasValue()) {
        this.getAttribute(attributeToInherit, true).setValue(stopsContainer.getAttribute(attributeToInherit).getValue());
      }
    });
  }

  addParentOpacity(parentOpacityProp, color) {
    if (parentOpacityProp.hasValue()) {
      var colorProp = new Property(this.document, 'color', color);
      return colorProp.addOpacity(parentOpacityProp).getColor();
    }

    return color;
  }

}

class LinearGradientElement extends GradientElement {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'linearGradient';
    this.attributesToInherit.push('x1', 'y1', 'x2', 'y2');
  }

  getGradient(ctx, element) {
    var isBoundingBoxUnits = this.getGradientUnits() === 'objectBoundingBox';
    var boundingBox = isBoundingBoxUnits ? element.getBoundingBox(ctx) : null;

    if (isBoundingBoxUnits && !boundingBox) {
      return null;
    }

    if (!this.getAttribute('x1').hasValue() && !this.getAttribute('y1').hasValue() && !this.getAttribute('x2').hasValue() && !this.getAttribute('y2').hasValue()) {
      this.getAttribute('x1', true).setValue(0);
      this.getAttribute('y1', true).setValue(0);
      this.getAttribute('x2', true).setValue(1);
      this.getAttribute('y2', true).setValue(0);
    }

    var x1 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('x1').getNumber() : this.getAttribute('x1').getPixels('x');
    var y1 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('y1').getNumber() : this.getAttribute('y1').getPixels('y');
    var x2 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('x2').getNumber() : this.getAttribute('x2').getPixels('x');
    var y2 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('y2').getNumber() : this.getAttribute('y2').getPixels('y');

    if (x1 === x2 && y1 === y2) {
      return null;
    }

    return ctx.createLinearGradient(x1, y1, x2, y2);
  }

}

class RadialGradientElement extends GradientElement {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'radialGradient';
    this.attributesToInherit.push('cx', 'cy', 'r', 'fx', 'fy', 'fr');
  }

  getGradient(ctx, element) {
    var isBoundingBoxUnits = this.getGradientUnits() === 'objectBoundingBox';
    var boundingBox = element.getBoundingBox(ctx);

    if (isBoundingBoxUnits && !boundingBox) {
      return null;
    }

    if (!this.getAttribute('cx').hasValue()) {
      this.getAttribute('cx', true).setValue('50%');
    }

    if (!this.getAttribute('cy').hasValue()) {
      this.getAttribute('cy', true).setValue('50%');
    }

    if (!this.getAttribute('r').hasValue()) {
      this.getAttribute('r', true).setValue('50%');
    }

    var cx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('cx').getNumber() : this.getAttribute('cx').getPixels('x');
    var cy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('cy').getNumber() : this.getAttribute('cy').getPixels('y');
    var fx = cx;
    var fy = cy;

    if (this.getAttribute('fx').hasValue()) {
      fx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('fx').getNumber() : this.getAttribute('fx').getPixels('x');
    }

    if (this.getAttribute('fy').hasValue()) {
      fy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('fy').getNumber() : this.getAttribute('fy').getPixels('y');
    }

    var r = isBoundingBoxUnits ? (boundingBox.width + boundingBox.height) / 2.0 * this.getAttribute('r').getNumber() : this.getAttribute('r').getPixels();
    var fr = this.getAttribute('fr').getPixels();
    return ctx.createRadialGradient(fx, fy, fr, cx, cy, r);
  }

}

class StopElement extends Element$1 {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'stop';
    var offset = Math.max(0, Math.min(1, this.getAttribute('offset').getNumber()));
    var stopOpacity = this.getStyle('stop-opacity');
    var stopColor = this.getStyle('stop-color', true);

    if (stopColor.getString() === '') {
      stopColor.setValue('#000');
    }

    if (stopOpacity.hasValue()) {
      stopColor = stopColor.addOpacity(stopOpacity);
    }

    this.offset = offset;
    this.color = stopColor.getColor();
  }

}

class AnimateElement extends Element$1 {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'animate';
    this.duration = 0;
    this.initialValue = null;
    this.initialUnits = '';
    this.removed = false;
    this.frozen = false;
    document.screen.animations.push(this);
    this.begin = this.getAttribute('begin').getMilliseconds();
    this.maxDuration = this.begin + this.getAttribute('dur').getMilliseconds();
    this.from = this.getAttribute('from');
    this.to = this.getAttribute('to');
    this.values = new Property(document, 'values', null);
    var valuesAttr = this.getAttribute('values');

    if (valuesAttr.hasValue()) {
      this.values.setValue(valuesAttr.getString().split(';'));
    }
  }

  getProperty() {
    var attributeType = this.getAttribute('attributeType').getString();
    var attributeName = this.getAttribute('attributeName').getString();

    if (attributeType === 'CSS') {
      return this.parent.getStyle(attributeName, true);
    }

    return this.parent.getAttribute(attributeName, true);
  }

  calcValue() {
    var {
      initialUnits
    } = this;
    var {
      progress,
      from,
      to
    } = this.getProgress(); // tween value linearly

    var newValue = from.getNumber() + (to.getNumber() - from.getNumber()) * progress;

    if (initialUnits === '%') {
      newValue *= 100.0; // numValue() returns 0-1 whereas properties are 0-100
    }

    return "".concat(newValue).concat(initialUnits);
  }

  update(delta) {
    var {
      parent
    } = this;
    var prop = this.getProperty(); // set initial value

    if (!this.initialValue) {
      this.initialValue = prop.getString();
      this.initialUnits = prop.getUnits();
    } // if we're past the end time


    if (this.duration > this.maxDuration) {
      var fill = this.getAttribute('fill').getString('remove'); // loop for indefinitely repeating animations

      if (this.getAttribute('repeatCount').getString() === 'indefinite' || this.getAttribute('repeatDur').getString() === 'indefinite') {
        this.duration = 0;
      } else if (fill === 'freeze' && !this.frozen) {
        this.frozen = true;
        parent.animationFrozen = true;
        parent.animationFrozenValue = prop.getString();
      } else if (fill === 'remove' && !this.removed) {
        this.removed = true;
        prop.setValue(parent.animationFrozen ? parent.animationFrozenValue : this.initialValue);
        return true;
      }

      return false;
    }

    this.duration += delta; // if we're past the begin time

    var updated = false;

    if (this.begin < this.duration) {
      var newValue = this.calcValue(); // tween

      var typeAttr = this.getAttribute('type');

      if (typeAttr.hasValue()) {
        // for transform, etc.
        var type = typeAttr.getString();
        newValue = "".concat(type, "(").concat(newValue, ")");
      }

      prop.setValue(newValue);
      updated = true;
    }

    return updated;
  }

  getProgress() {
    var {
      document,
      values
    } = this;
    var result = {
      progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
    };

    if (values.hasValue()) {
      var p = result.progress * (values.getValue().length - 1);
      var lb = Math.floor(p);
      var ub = Math.ceil(p);
      result.from = new Property(document, 'from', parseFloat(values.getValue()[lb]));
      result.to = new Property(document, 'to', parseFloat(values.getValue()[ub]));
      result.progress = (p - lb) / (ub - lb);
    } else {
      result.from = this.from;
      result.to = this.to;
    }

    return result;
  }

}

class AnimateColorElement extends AnimateElement {
  constructor() {
    super(...arguments);
    this.type = 'animateColor';
  }

  calcValue() {
    var {
      progress,
      from,
      to
    } = this.getProgress();
    var colorFrom = new rgbcolor(from.getColor());
    var colorTo = new rgbcolor(to.getColor());

    if (colorFrom.ok && colorTo.ok) {
      // tween color linearly
      var r = colorFrom.r + (colorTo.r - colorFrom.r) * progress;
      var g = colorFrom.g + (colorTo.g - colorFrom.g) * progress;
      var b = colorFrom.b + (colorTo.b - colorFrom.b) * progress; // ? alpha

      return "rgb(".concat(Math.floor(r), ", ").concat(Math.floor(g), ", ").concat(Math.floor(b), ")");
    }

    return this.getAttribute('from').getColor();
  }

}

class AnimateTransformElement extends AnimateElement {
  constructor() {
    super(...arguments);
    this.type = 'animateTransform';
  }

  calcValue() {
    var {
      progress,
      from,
      to
    } = this.getProgress(); // tween value linearly

    var transformFrom = toNumbers(from.getString());
    var transformTo = toNumbers(to.getString());
    var newValue = transformFrom.map((from, i) => {
      var to = transformTo[i];
      return from + (to - from) * progress;
    }).join(' ');
    return newValue;
  }

}

class FontElement extends Element$1 {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'font';
    this.glyphs = {};
    this.horizAdvX = this.getAttribute('horiz-adv-x').getNumber();
    var {
      definitions
    } = document;
    var {
      children
    } = this;

    for (var child of children) {
      switch (child.type) {
        case 'font-face':
          {
            this.fontFace = child;
            var fontFamilyStyle = child.getStyle('font-family');

            if (fontFamilyStyle.hasValue()) {
              definitions[fontFamilyStyle.getString()] = this;
            }

            break;
          }

        case 'missing-glyph':
          this.missingGlyph = child;
          break;

        case 'glyph':
          {
            var glyph = child;

            if (glyph.arabicForm) {
              this.isRTL = true;
              this.isArabic = true;

              if (typeof this.glyphs[glyph.unicode] === 'undefined') {
                this.glyphs[glyph.unicode] = {};
              }

              this.glyphs[glyph.unicode][glyph.arabicForm] = glyph;
            } else {
              this.glyphs[glyph.unicode] = glyph;
            }

            break;
          }
      }
    }
  }

  render() {// NO RENDER
  }

}

class FontFaceElement extends Element$1 {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'font-face';
    this.ascent = this.getAttribute('ascent').getNumber();
    this.descent = this.getAttribute('descent').getNumber();
    this.unitsPerEm = this.getAttribute('units-per-em').getNumber();
  }

}

class MissingGlyphElement extends PathElement {
  constructor() {
    super(...arguments);
    this.type = 'missing-glyph';
    this.horizAdvX = 0;
  }

}

class TRefElement extends TextElement {
  constructor() {
    super(...arguments);
    this.type = 'tref';
  }

  getText() {
    var element = this.getHrefAttribute().getDefinition();

    if (element) {
      var firstChild = element.children[0];

      if (firstChild) {
        return firstChild.getText();
      }
    }

    return '';
  }

}

class AElement extends TextElement {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'a';
    var {
      childNodes
    } = node;
    var firstChild = childNodes[0];
    var hasText = childNodes.length > 0 && Array.from(childNodes).every(node => node.nodeType === 3);
    this.hasText = hasText;
    this.text = hasText ? this.getTextFromNode(firstChild) : '';
  }

  getText() {
    return this.text;
  }

  renderChildren(ctx) {
    if (this.hasText) {
      // render as text element
      super.renderChildren(ctx);
      var {
        document,
        x,
        y
      } = this;
      var {
        mouse
      } = document.screen;
      var fontSize = new Property(document, 'fontSize', Font.parse(document.ctx.font).fontSize); // Do not calc bounding box if mouse is not working.

      if (mouse.isWorking()) {
        mouse.checkBoundingBox(this, new BoundingBox(x, y - fontSize.getPixels('y'), x + this.measureText(ctx), y));
      }
    } else if (this.children.length > 0) {
      // render as temporary group
      var g = new GElement(this.document, null);
      g.children = this.children;
      g.parent = this;
      g.render(ctx);
    }
  }

  onClick() {
    var {
      window
    } = this.document;

    if (window) {
      window.open(this.getHrefAttribute().getString());
    }
  }

  onMouseMove() {
    var ctx = this.document.ctx;
    ctx.canvas.style.cursor = 'pointer';
  }

}

function ownKeys$2$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
class TextPathElement extends TextElement {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'textPath';
    this.textWidth = 0;
    this.textHeight = 0;
    this.pathLength = -1;
    this.glyphInfo = null;
    this.letterSpacingCache = [];
    this.measuresCache = new Map([['', 0]]);
    var pathElement = this.getHrefAttribute().getDefinition();
    this.text = this.getTextFromNode();
    this.dataArray = this.parsePathData(pathElement);
  }

  getText() {
    return this.text;
  }

  path(ctx) {
    var {
      dataArray
    } = this;

    if (ctx) {
      ctx.beginPath();
    }

    dataArray.forEach(_ref => {
      var {
        type,
        points
      } = _ref;

      switch (type) {
        case PathParser.LINE_TO:
          if (ctx) {
            ctx.lineTo(points[0], points[1]);
          }

          break;

        case PathParser.MOVE_TO:
          if (ctx) {
            ctx.moveTo(points[0], points[1]);
          }

          break;

        case PathParser.CURVE_TO:
          if (ctx) {
            ctx.bezierCurveTo(points[0], points[1], points[2], points[3], points[4], points[5]);
          }

          break;

        case PathParser.QUAD_TO:
          if (ctx) {
            ctx.quadraticCurveTo(points[0], points[1], points[2], points[3]);
          }

          break;

        case PathParser.ARC:
          {
            var [cx, cy, rx, ry, theta, dTheta, psi, fs] = points;
            var r = rx > ry ? rx : ry;
            var scaleX = rx > ry ? 1 : rx / ry;
            var scaleY = rx > ry ? ry / rx : 1;

            if (ctx) {
              ctx.translate(cx, cy);
              ctx.rotate(psi);
              ctx.scale(scaleX, scaleY);
              ctx.arc(0, 0, r, theta, theta + dTheta, Boolean(1 - fs));
              ctx.scale(1 / scaleX, 1 / scaleY);
              ctx.rotate(-psi);
              ctx.translate(-cx, -cy);
            }

            break;
          }

        case PathParser.CLOSE_PATH:
          if (ctx) {
            ctx.closePath();
          }

          break;
      }
    });
  }

  renderChildren(ctx) {
    this.setTextData(ctx);
    ctx.save();
    var textDecoration = this.parent.getStyle('text-decoration').getString();
    var fontSize = this.getFontSize();
    var {
      glyphInfo
    } = this;
    var fill = ctx.fillStyle;

    if (textDecoration === 'underline') {
      ctx.beginPath();
    }

    glyphInfo.forEach((glyph, i) => {
      var {
        p0,
        p1,
        rotation,
        text: partialText
      } = glyph;
      ctx.save();
      ctx.translate(p0.x, p0.y);
      ctx.rotate(rotation);

      if (ctx.fillStyle) {
        ctx.fillText(partialText, 0, 0);
      }

      if (ctx.strokeStyle) {
        ctx.strokeText(partialText, 0, 0);
      }

      ctx.restore();

      if (textDecoration === 'underline') {
        if (i === 0) {
          ctx.moveTo(p0.x, p0.y + fontSize / 8);
        }

        ctx.lineTo(p1.x, p1.y + fontSize / 5);
      } // // To assist with debugging visually, uncomment following
      //
      // ctx.beginPath();
      // if (i % 2)
      // 	ctx.strokeStyle = 'red';
      // else
      // 	ctx.strokeStyle = 'green';
      // ctx.moveTo(p0.x, p0.y);
      // ctx.lineTo(p1.x, p1.y);
      // ctx.stroke();
      // ctx.closePath();

    });

    if (textDecoration === 'underline') {
      ctx.lineWidth = fontSize / 20;
      ctx.strokeStyle = fill;
      ctx.stroke();
      ctx.closePath();
    }

    ctx.restore();
  }

  getLetterSpacingAt() {
    var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return this.letterSpacingCache[idx] || 0;
  }

  findSegmentToFitChar(ctx, anchor, textFullWidth, fullPathWidth, spacesNumber, inputOffset, dy, c, charI) {
    var offset = inputOffset;
    var glyphWidth = this.measureText(ctx, c);

    if (c === ' ' && anchor === 'justify' && textFullWidth < fullPathWidth) {
      glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
    }

    if (charI > -1) {
      offset += this.getLetterSpacingAt(charI);
    }

    var splineStep = this.textHeight / 20;
    var p0 = this.getEquidistantPointOnPath(offset, splineStep, 0);
    var p1 = this.getEquidistantPointOnPath(offset + glyphWidth, splineStep, 0);
    var segment = {
      p0,
      p1
    };
    var rotation = p0 && p1 ? Math.atan2(p1.y - p0.y, p1.x - p0.x) : 0;

    if (dy) {
      var dyX = Math.cos(Math.PI / 2 + rotation) * dy;
      var dyY = Math.cos(-rotation) * dy;
      segment.p0 = _objectSpread$2$1(_objectSpread$2$1({}, p0), {}, {
        x: p0.x + dyX,
        y: p0.y + dyY
      });
      segment.p1 = _objectSpread$2$1(_objectSpread$2$1({}, p1), {}, {
        x: p1.x + dyX,
        y: p1.y + dyY
      });
    }

    offset += glyphWidth;
    return {
      offset,
      segment,
      rotation
    };
  }

  measureText(ctx, text) {
    var {
      measuresCache
    } = this;
    var targetText = text || this.getText();

    if (measuresCache.has(targetText)) {
      return measuresCache.get(targetText);
    }

    var measure = this.measureTargetText(ctx, targetText);
    measuresCache.set(targetText, measure);
    return measure;
  } // This method supposes what all custom fonts already loaded.
  // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
  // You need to call this method manually to update glyphs cache.


  setTextData(ctx) {
    if (this.glyphInfo) {
      return;
    }

    var renderText = this.getText();
    var chars = renderText.split('');
    var spacesNumber = renderText.split(' ').length - 1;
    var dx = this.parent.getAttribute('dx').split().map(_ => _.getPixels('x'));
    var dy = this.parent.getAttribute('dy').getPixels('y');
    var anchor = this.parent.getStyle('text-anchor').getString('start');
    var thisSpacing = this.getStyle('letter-spacing');
    var parentSpacing = this.parent.getStyle('letter-spacing');
    var letterSpacing = 0;

    if (!thisSpacing.hasValue() || thisSpacing.getValue() === 'inherit') {
      letterSpacing = parentSpacing.getPixels();
    } else if (thisSpacing.hasValue()) {
      if (thisSpacing.getValue() !== 'initial' && thisSpacing.getValue() !== 'unset') {
        letterSpacing = thisSpacing.getPixels();
      }
    } // fill letter-spacing cache


    var letterSpacingCache = [];
    var textLen = renderText.length;
    this.letterSpacingCache = letterSpacingCache;

    for (var i = 0; i < textLen; i++) {
      letterSpacingCache.push(typeof dx[i] !== 'undefined' ? dx[i] : letterSpacing);
    }

    var dxSum = letterSpacingCache.reduce((acc, cur, i) => i === 0 ? 0 : acc + cur || 0, 0);
    var textWidth = this.measureText(ctx);
    var textFullWidth = Math.max(textWidth + dxSum, 0);
    this.textWidth = textWidth;
    this.textHeight = this.getFontSize();
    this.glyphInfo = [];
    var fullPathWidth = this.getPathLength();
    var startOffset = this.getStyle('startOffset').getNumber(0) * fullPathWidth;
    var offset = 0;

    if (anchor === 'middle' || anchor === 'center') {
      offset = -textFullWidth / 2;
    }

    if (anchor === 'end' || anchor === 'right') {
      offset = -textFullWidth;
    }

    offset += startOffset;
    chars.forEach((char, i) => {
      // Find such segment what distance between p0 and p1 is approx. width of glyph
      var {
        offset: nextOffset,
        segment,
        rotation
      } = this.findSegmentToFitChar(ctx, anchor, textFullWidth, fullPathWidth, spacesNumber, offset, dy, char, i);
      offset = nextOffset;

      if (!segment.p0 || !segment.p1) {
        return;
      } // const width = this.getLineLength(
      // 	segment.p0.x,
      // 	segment.p0.y,
      // 	segment.p1.x,
      // 	segment.p1.y
      // );
      // Note: Since glyphs are rendered one at a time, any kerning pair data built into the font will not be used.
      // Can foresee having a rough pair table built in that the developer can override as needed.
      // Or use "dx" attribute of the <text> node as a naive replacement
      // const kern = 0;
      // placeholder for future implementation
      // const midpoint = this.getPointOnLine(
      // 	kern + width / 2.0,
      // 	segment.p0.x, segment.p0.y, segment.p1.x, segment.p1.y
      // );


      this.glyphInfo.push({
        // transposeX: midpoint.x,
        // transposeY: midpoint.y,
        text: chars[i],
        p0: segment.p0,
        p1: segment.p1,
        rotation
      });
    });
  }

  parsePathData(path) {
    this.pathLength = -1; // reset path length

    if (!path) {
      return [];
    }

    var pathCommands = [];
    var {
      pathParser
    } = path;
    pathParser.reset(); // convert l, H, h, V, and v to L

    while (!pathParser.isEnd()) {
      var {
        current
      } = pathParser;
      var startX = current ? current.x : 0;
      var startY = current ? current.y : 0;
      var command = pathParser.next();
      var nextCommandType = command.type;
      var points = [];

      switch (command.type) {
        case PathParser.MOVE_TO:
          this.pathM(pathParser, points);
          break;

        case PathParser.LINE_TO:
          nextCommandType = this.pathL(pathParser, points);
          break;

        case PathParser.HORIZ_LINE_TO:
          nextCommandType = this.pathH(pathParser, points);
          break;

        case PathParser.VERT_LINE_TO:
          nextCommandType = this.pathV(pathParser, points);
          break;

        case PathParser.CURVE_TO:
          this.pathC(pathParser, points);
          break;

        case PathParser.SMOOTH_CURVE_TO:
          nextCommandType = this.pathS(pathParser, points);
          break;

        case PathParser.QUAD_TO:
          this.pathQ(pathParser, points);
          break;

        case PathParser.SMOOTH_QUAD_TO:
          nextCommandType = this.pathT(pathParser, points);
          break;

        case PathParser.ARC:
          points = this.pathA(pathParser);
          break;

        case PathParser.CLOSE_PATH:
          PathElement.pathZ(pathParser);
          break;
      }

      if (command.type !== PathParser.CLOSE_PATH) {
        pathCommands.push({
          type: nextCommandType,
          points,
          start: {
            x: startX,
            y: startY
          },
          pathLength: this.calcLength(startX, startY, nextCommandType, points)
        });
      } else {
        pathCommands.push({
          type: PathParser.CLOSE_PATH,
          points: [],
          pathLength: 0
        });
      }
    }

    return pathCommands;
  }

  pathM(pathParser, points) {
    var {
      x,
      y
    } = PathElement.pathM(pathParser).point;
    points.push(x, y);
  }

  pathL(pathParser, points) {
    var {
      x,
      y
    } = PathElement.pathL(pathParser).point;
    points.push(x, y);
    return PathParser.LINE_TO;
  }

  pathH(pathParser, points) {
    var {
      x,
      y
    } = PathElement.pathH(pathParser).point;
    points.push(x, y);
    return PathParser.LINE_TO;
  }

  pathV(pathParser, points) {
    var {
      x,
      y
    } = PathElement.pathV(pathParser).point;
    points.push(x, y);
    return PathParser.LINE_TO;
  }

  pathC(pathParser, points) {
    var {
      point,
      controlPoint,
      currentPoint
    } = PathElement.pathC(pathParser);
    points.push(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
  }

  pathS(pathParser, points) {
    var {
      point,
      controlPoint,
      currentPoint
    } = PathElement.pathS(pathParser);
    points.push(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    return PathParser.CURVE_TO;
  }

  pathQ(pathParser, points) {
    var {
      controlPoint,
      currentPoint
    } = PathElement.pathQ(pathParser);
    points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
  }

  pathT(pathParser, points) {
    var {
      controlPoint,
      currentPoint
    } = PathElement.pathT(pathParser);
    points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    return PathParser.QUAD_TO;
  }

  pathA(pathParser) {
    var {
      rX,
      rY,
      sweepFlag,
      xAxisRotation,
      centp,
      a1,
      ad
    } = PathElement.pathA(pathParser);

    if (sweepFlag === 0 && ad > 0) {
      ad -= 2 * Math.PI;
    }

    if (sweepFlag === 1 && ad < 0) {
      ad += 2 * Math.PI;
    }

    return [centp.x, centp.y, rX, rY, a1, ad, xAxisRotation, sweepFlag];
  }

  calcLength(x, y, commandType, points) {
    var len = 0;
    var p1 = null;
    var p2 = null;
    var t = 0;

    switch (commandType) {
      case PathParser.LINE_TO:
        return this.getLineLength(x, y, points[0], points[1]);

      case PathParser.CURVE_TO:
        // Approximates by breaking curve into 100 line segments
        len = 0.0;
        p1 = this.getPointOnCubicBezier(0, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);

        for (t = 0.01; t <= 1; t += 0.01) {
          p2 = this.getPointOnCubicBezier(t, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
          len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
          p1 = p2;
        }

        return len;

      case PathParser.QUAD_TO:
        // Approximates by breaking curve into 100 line segments
        len = 0.0;
        p1 = this.getPointOnQuadraticBezier(0, x, y, points[0], points[1], points[2], points[3]);

        for (t = 0.01; t <= 1; t += 0.01) {
          p2 = this.getPointOnQuadraticBezier(t, x, y, points[0], points[1], points[2], points[3]);
          len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
          p1 = p2;
        }

        return len;

      case PathParser.ARC:
        {
          // Approximates by breaking curve into line segments
          len = 0.0;
          var start = points[4]; // 4 = theta

          var dTheta = points[5]; // 5 = dTheta

          var end = points[4] + dTheta;
          var inc = Math.PI / 180.0; // 1 degree resolution

          if (Math.abs(start - end) < inc) {
            inc = Math.abs(start - end);
          } // Note: for purpose of calculating arc length, not going to worry about rotating X-axis by angle psi


          p1 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);

          if (dTheta < 0) {
            // clockwise
            for (t = start - inc; t > end; t -= inc) {
              p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
              len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
              p1 = p2;
            }
          } else {
            // counter-clockwise
            for (t = start + inc; t < end; t += inc) {
              p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
              len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
              p1 = p2;
            }
          }

          p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
          len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
          return len;
        }
    }

    return 0;
  }

  getPointOnLine(dist, p1x, p1y, p2x, p2y) {
    var fromX = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : p1x;
    var fromY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : p1y;
    var m = (p2y - p1y) / (p2x - p1x + PSEUDO_ZERO);
    var run = Math.sqrt(dist * dist / (1 + m * m));

    if (p2x < p1x) {
      run *= -1;
    }

    var rise = m * run;
    var pt = null;

    if (p2x === p1x) {
      // vertical line
      pt = {
        x: fromX,
        y: fromY + rise
      };
    } else if ((fromY - p1y) / (fromX - p1x + PSEUDO_ZERO) === m) {
      pt = {
        x: fromX + run,
        y: fromY + rise
      };
    } else {
      var ix = 0;
      var iy = 0;
      var len = this.getLineLength(p1x, p1y, p2x, p2y);

      if (len < PSEUDO_ZERO) {
        return null;
      }

      var u = (fromX - p1x) * (p2x - p1x) + (fromY - p1y) * (p2y - p1y);
      u /= len * len;
      ix = p1x + u * (p2x - p1x);
      iy = p1y + u * (p2y - p1y);
      var pRise = this.getLineLength(fromX, fromY, ix, iy);
      var pRun = Math.sqrt(dist * dist - pRise * pRise);
      run = Math.sqrt(pRun * pRun / (1 + m * m));

      if (p2x < p1x) {
        run *= -1;
      }

      rise = m * run;
      pt = {
        x: ix + run,
        y: iy + rise
      };
    }

    return pt;
  }

  getPointOnPath(distance) {
    var fullLen = this.getPathLength();
    var cumulativePathLength = 0;
    var p = null;

    if (distance < -0.00005 || distance - 0.00005 > fullLen) {
      return null;
    }

    var {
      dataArray
    } = this;

    for (var command of dataArray) {
      if (command && (command.pathLength < 0.00005 || cumulativePathLength + command.pathLength + 0.00005 < distance)) {
        cumulativePathLength += command.pathLength;
        continue;
      }

      var delta = distance - cumulativePathLength;
      var currentT = 0;

      switch (command.type) {
        case PathParser.LINE_TO:
          p = this.getPointOnLine(delta, command.start.x, command.start.y, command.points[0], command.points[1], command.start.x, command.start.y);
          break;

        case PathParser.ARC:
          {
            var start = command.points[4]; // 4 = theta

            var dTheta = command.points[5]; // 5 = dTheta

            var end = command.points[4] + dTheta;
            currentT = start + delta / command.pathLength * dTheta;

            if (dTheta < 0 && currentT < end || dTheta >= 0 && currentT > end) {
              break;
            }

            p = this.getPointOnEllipticalArc(command.points[0], command.points[1], command.points[2], command.points[3], currentT, command.points[6]);
            break;
          }

        case PathParser.CURVE_TO:
          currentT = delta / command.pathLength;

          if (currentT > 1) {
            currentT = 1;
          }

          p = this.getPointOnCubicBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3], command.points[4], command.points[5]);
          break;

        case PathParser.QUAD_TO:
          currentT = delta / command.pathLength;

          if (currentT > 1) {
            currentT = 1;
          }

          p = this.getPointOnQuadraticBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3]);
          break;
      }

      if (p) {
        return p;
      }

      break;
    }

    return null;
  }

  getLineLength(x1, y1, x2, y2) {
    return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
  }

  getPathLength() {
    if (this.pathLength === -1) {
      this.pathLength = this.dataArray.reduce((length, command) => command.pathLength > 0 ? length + command.pathLength : length, 0);
    }

    return this.pathLength;
  }

  getPointOnCubicBezier(pct, p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
    var x = p4x * CB1(pct) + p3x * CB2(pct) + p2x * CB3(pct) + p1x * CB4(pct);
    var y = p4y * CB1(pct) + p3y * CB2(pct) + p2y * CB3(pct) + p1y * CB4(pct);
    return {
      x,
      y
    };
  }

  getPointOnQuadraticBezier(pct, p1x, p1y, p2x, p2y, p3x, p3y) {
    var x = p3x * QB1(pct) + p2x * QB2(pct) + p1x * QB3(pct);
    var y = p3y * QB1(pct) + p2y * QB2(pct) + p1y * QB3(pct);
    return {
      x,
      y
    };
  }

  getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
    var cosPsi = Math.cos(psi);
    var sinPsi = Math.sin(psi);
    var pt = {
      x: rx * Math.cos(theta),
      y: ry * Math.sin(theta)
    };
    return {
      x: cx + (pt.x * cosPsi - pt.y * sinPsi),
      y: cy + (pt.x * sinPsi + pt.y * cosPsi)
    };
  } // TODO need some optimisations. possibly build cache only for curved segments?


  buildEquidistantCache(inputStep, inputPrecision) {
    var fullLen = this.getPathLength();
    var precision = inputPrecision || 0.25; // accuracy vs performance

    var step = inputStep || fullLen / 100;

    if (!this.equidistantCache || this.equidistantCache.step !== step || this.equidistantCache.precision !== precision) {
      // Prepare cache
      this.equidistantCache = {
        step,
        precision,
        points: []
      }; // Calculate points

      var s = 0;

      for (var l = 0; l <= fullLen; l += precision) {
        var p0 = this.getPointOnPath(l);
        var p1 = this.getPointOnPath(l + precision);

        if (!p0 || !p1) {
          continue;
        }

        s += this.getLineLength(p0.x, p0.y, p1.x, p1.y);

        if (s >= step) {
          this.equidistantCache.points.push({
            x: p0.x,
            y: p0.y,
            distance: l
          });
          s -= step;
        }
      }
    }
  }

  getEquidistantPointOnPath(targetDistance, step, precision) {
    this.buildEquidistantCache(step, precision);

    if (targetDistance < 0 || targetDistance - this.getPathLength() > 0.00005) {
      return null;
    }

    var idx = Math.round(targetDistance / this.getPathLength() * (this.equidistantCache.points.length - 1));
    return this.equidistantCache.points[idx] || null;
  }

}

var dataUriRegex = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
class ImageElement extends RenderedElement {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'image';
    this.loaded = false;
    var href = this.getHrefAttribute().getString();

    if (!href) {
      return;
    }

    var isSvg = href.endsWith('.svg') || /^\s*data:image\/svg\+xml/i.test(href);
    document.images.push(this);

    if (!isSvg) {
      void this.loadImage(href);
    } else {
      void this.loadSvg(href);
    }

    this.isSvg = isSvg;
  }

  loadImage(href) {
    var _this = this;

    return _asyncToGenerator$1(function* () {
      try {
        var image = yield _this.document.createImage(href);
        _this.image = image;
      } catch (err) {
        console.error("Error while loading image \"".concat(href, "\":"), err);
      }

      _this.loaded = true;
    })();
  }

  loadSvg(href) {
    var _this2 = this;

    return _asyncToGenerator$1(function* () {
      var match = dataUriRegex.exec(href);

      if (match) {
        var data = match[5];

        if (match[4] === 'base64') {
          _this2.image = atob(data);
        } else {
          _this2.image = decodeURIComponent(data);
        }
      } else {
        try {
          var response = yield _this2.document.fetch(href);
          var svg = yield response.text();
          _this2.image = svg;
        } catch (err) {
          console.error("Error while loading image \"".concat(href, "\":"), err);
        }
      }

      _this2.loaded = true;
    })();
  }

  renderChildren(ctx) {
    var {
      document,
      image,
      loaded
    } = this;
    var x = this.getAttribute('x').getPixels('x');
    var y = this.getAttribute('y').getPixels('y');
    var width = this.getStyle('width').getPixels('x');
    var height = this.getStyle('height').getPixels('y');

    if (!loaded || !image || !width || !height) {
      return;
    }

    ctx.save();
    ctx.translate(x, y);

    if (this.isSvg) {
      var subDocument = document.canvg.forkString(ctx, this.image, {
        ignoreMouse: true,
        ignoreAnimation: true,
        ignoreDimensions: true,
        ignoreClear: true,
        offsetX: 0,
        offsetY: 0,
        scaleWidth: width,
        scaleHeight: height
      });
      subDocument.document.documentElement.parent = this;
      void subDocument.render();
    } else {
      var _image = this.image;
      document.setViewBox({
        ctx,
        aspectRatio: this.getAttribute('preserveAspectRatio').getString(),
        width,
        desiredWidth: _image.width,
        height,
        desiredHeight: _image.height
      });

      if (this.loaded) {
        if (typeof _image.complete === 'undefined' || _image.complete) {
          ctx.drawImage(_image, 0, 0);
        }
      }
    }

    ctx.restore();
  }

  getBoundingBox() {
    var x = this.getAttribute('x').getPixels('x');
    var y = this.getAttribute('y').getPixels('y');
    var width = this.getStyle('width').getPixels('x');
    var height = this.getStyle('height').getPixels('y');
    return new BoundingBox(x, y, x + width, y + height);
  }

}

class SymbolElement extends RenderedElement {
  constructor() {
    super(...arguments);
    this.type = 'symbol';
  }

  render(_) {// NO RENDER
  }

}

class SVGFontLoader {
  constructor(document) {
    this.document = document;
    this.loaded = false;
    document.fonts.push(this);
  }

  load(fontFamily, url) {
    var _this = this;

    return _asyncToGenerator$1(function* () {
      try {
        var {
          document
        } = _this;
        var svgDocument = yield document.canvg.parser.load(url);
        var fonts = svgDocument.getElementsByTagName('font');
        Array.from(fonts).forEach(fontNode => {
          var font = document.createElement(fontNode);
          document.definitions[fontFamily] = font;
        });
      } catch (err) {
        console.error("Error while loading font \"".concat(url, "\":"), err);
      }

      _this.loaded = true;
    })();
  }

}

class StyleElement extends Element$1 {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'style';
    var css = compressSpaces(Array.from(node.childNodes) // NEED TEST
    .map(_ => _.textContent).join('').replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, '') // remove comments
    .replace(/@import.*;/g, '') // remove imports
    );
    var cssDefs = css.split('}');
    cssDefs.forEach(_ => {
      var def = _.trim();

      if (!def) {
        return;
      }

      var cssParts = def.split('{');
      var cssClasses = cssParts[0].split(',');
      var cssProps = cssParts[1].split(';');
      cssClasses.forEach(_ => {
        var cssClass = _.trim();

        if (!cssClass) {
          return;
        }

        var props = document.styles[cssClass] || {};
        cssProps.forEach(cssProp => {
          var prop = cssProp.indexOf(':');
          var name = cssProp.substr(0, prop).trim();
          var value = cssProp.substr(prop + 1, cssProp.length - prop).trim();

          if (name && value) {
            props[name] = new Property(document, name, value);
          }
        });
        document.styles[cssClass] = props;
        document.stylesSpecificity[cssClass] = getSelectorSpecificity(cssClass);

        if (cssClass === '@font-face') {
          //  && !nodeEnv
          var fontFamily = props['font-family'].getString().replace(/"|'/g, '');
          var srcs = props.src.getString().split(',');
          srcs.forEach(src => {
            if (src.indexOf('format("svg")') > 0) {
              var url = parseExternalUrl(src);

              if (url) {
                void new SVGFontLoader(document).load(fontFamily, url);
              }
            }
          });
        }
      });
    });
  }

}
StyleElement.parseExternalUrl = parseExternalUrl;

class UseElement extends RenderedElement {
  constructor() {
    super(...arguments);
    this.type = 'use';
  }

  setContext(ctx) {
    super.setContext(ctx);
    var xAttr = this.getAttribute('x');
    var yAttr = this.getAttribute('y');

    if (xAttr.hasValue()) {
      ctx.translate(xAttr.getPixels('x'), 0);
    }

    if (yAttr.hasValue()) {
      ctx.translate(0, yAttr.getPixels('y'));
    }
  }

  path(ctx) {
    var {
      element
    } = this;

    if (element) {
      element.path(ctx);
    }
  }

  renderChildren(ctx) {
    var {
      document,
      element
    } = this;

    if (element) {
      var tempSvg = element;

      if (element.type === 'symbol') {
        // render me using a temporary svg element in symbol cases (http://www.w3.org/TR/SVG/struct.html#UseElement)
        tempSvg = new SVGElement(document, null);
        tempSvg.attributes.viewBox = new Property(document, 'viewBox', element.getAttribute('viewBox').getString());
        tempSvg.attributes.preserveAspectRatio = new Property(document, 'preserveAspectRatio', element.getAttribute('preserveAspectRatio').getString());
        tempSvg.attributes.overflow = new Property(document, 'overflow', element.getAttribute('overflow').getString());
        tempSvg.children = element.children; // element is still the parent of the children

        element.styles.opacity = new Property(document, 'opacity', this.calculateOpacity());
      }

      if (tempSvg.type === 'svg') {
        var widthStyle = this.getStyle('width', false, true);
        var heightStyle = this.getStyle('height', false, true); // if symbol or svg, inherit width/height from me

        if (widthStyle.hasValue()) {
          tempSvg.attributes.width = new Property(document, 'width', widthStyle.getString());
        }

        if (heightStyle.hasValue()) {
          tempSvg.attributes.height = new Property(document, 'height', heightStyle.getString());
        }
      }

      var oldParent = tempSvg.parent;
      tempSvg.parent = this;
      tempSvg.render(ctx);
      tempSvg.parent = oldParent;
    }
  }

  getBoundingBox(ctx) {
    var {
      element
    } = this;

    if (element) {
      return element.getBoundingBox(ctx);
    }

    return null;
  }

  elementTransform() {
    var {
      document,
      element
    } = this;
    return Transform.fromElement(document, element);
  }

  get element() {
    if (!this.cachedElement) {
      this.cachedElement = this.getHrefAttribute().getDefinition();
    }

    return this.cachedElement;
  }

}

function imGet(img, x, y, width, _height, rgba) {
  return img[y * width * 4 + x * 4 + rgba];
}

function imSet(img, x, y, width, _height, rgba, val) {
  img[y * width * 4 + x * 4 + rgba] = val;
}

function m$2(matrix, i, v) {
  var mi = matrix[i];
  return mi * v;
}

function c$2(a, m1, m2, m3) {
  return m1 + Math.cos(a) * m2 + Math.sin(a) * m3;
}

class FeColorMatrixElement extends Element$1 {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'feColorMatrix';
    var matrix = toNumbers(this.getAttribute('values').getString());

    switch (this.getAttribute('type').getString('matrix')) {
      // http://www.w3.org/TR/SVG/filters.html#feColorMatrixElement
      case 'saturate':
        {
          var s = matrix[0];
          /* eslint-disable array-element-newline */

          matrix = [0.213 + 0.787 * s, 0.715 - 0.715 * s, 0.072 - 0.072 * s, 0, 0, 0.213 - 0.213 * s, 0.715 + 0.285 * s, 0.072 - 0.072 * s, 0, 0, 0.213 - 0.213 * s, 0.715 - 0.715 * s, 0.072 + 0.928 * s, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
          /* eslint-enable array-element-newline */

          break;
        }

      case 'hueRotate':
        {
          var a = matrix[0] * Math.PI / 180.0;
          /* eslint-disable array-element-newline */

          matrix = [c$2(a, 0.213, 0.787, -0.213), c$2(a, 0.715, -0.715, -0.715), c$2(a, 0.072, -0.072, 0.928), 0, 0, c$2(a, 0.213, -0.213, 0.143), c$2(a, 0.715, 0.285, 0.140), c$2(a, 0.072, -0.072, -0.283), 0, 0, c$2(a, 0.213, -0.213, -0.787), c$2(a, 0.715, -0.715, 0.715), c$2(a, 0.072, 0.928, 0.072), 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
          /* eslint-enable array-element-newline */

          break;
        }

      case 'luminanceToAlpha':
        /* eslint-disable array-element-newline */
        matrix = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2125, 0.7154, 0.0721, 0, 0, 0, 0, 0, 0, 1];
        /* eslint-enable array-element-newline */

        break;
    }

    this.matrix = matrix;
    this.includeOpacity = this.getAttribute('includeOpacity').hasValue();
  }

  apply(ctx, _x, _y, width, height) {
    // assuming x==0 && y==0 for now
    var {
      includeOpacity,
      matrix
    } = this;
    var srcData = ctx.getImageData(0, 0, width, height);

    for (var y = 0; y < height; y++) {
      for (var x = 0; x < width; x++) {
        var r = imGet(srcData.data, x, y, width, height, 0);
        var g = imGet(srcData.data, x, y, width, height, 1);
        var b = imGet(srcData.data, x, y, width, height, 2);
        var a = imGet(srcData.data, x, y, width, height, 3);
        var nr = m$2(matrix, 0, r) + m$2(matrix, 1, g) + m$2(matrix, 2, b) + m$2(matrix, 3, a) + m$2(matrix, 4, 1);
        var ng = m$2(matrix, 5, r) + m$2(matrix, 6, g) + m$2(matrix, 7, b) + m$2(matrix, 8, a) + m$2(matrix, 9, 1);
        var nb = m$2(matrix, 10, r) + m$2(matrix, 11, g) + m$2(matrix, 12, b) + m$2(matrix, 13, a) + m$2(matrix, 14, 1);
        var na = m$2(matrix, 15, r) + m$2(matrix, 16, g) + m$2(matrix, 17, b) + m$2(matrix, 18, a) + m$2(matrix, 19, 1);

        if (includeOpacity) {
          nr = 0;
          ng = 0;
          nb = 0;
          na *= a / 255;
        }

        imSet(srcData.data, x, y, width, height, 0, nr);
        imSet(srcData.data, x, y, width, height, 1, ng);
        imSet(srcData.data, x, y, width, height, 2, nb);
        imSet(srcData.data, x, y, width, height, 3, na);
      }
    }

    ctx.clearRect(0, 0, width, height);
    ctx.putImageData(srcData, 0, 0);
  }

}

class MaskElement extends Element$1 {
  constructor() {
    super(...arguments);
    this.type = 'mask';
  }

  apply(ctx, element) {
    var {
      document
    } = this; // render as temp svg

    var x = this.getAttribute('x').getPixels('x');
    var y = this.getAttribute('y').getPixels('y');
    var width = this.getStyle('width').getPixels('x');
    var height = this.getStyle('height').getPixels('y');

    if (!width && !height) {
      var boundingBox = new BoundingBox();
      this.children.forEach(child => {
        boundingBox.addBoundingBox(child.getBoundingBox(ctx));
      });
      x = Math.floor(boundingBox.x1);
      y = Math.floor(boundingBox.y1);
      width = Math.floor(boundingBox.width);
      height = Math.floor(boundingBox.height);
    }

    var ignoredStyles = this.removeStyles(element, MaskElement.ignoreStyles);
    var maskCanvas = document.createCanvas(x + width, y + height);
    var maskCtx = maskCanvas.getContext('2d');
    document.screen.setDefaults(maskCtx);
    this.renderChildren(maskCtx); // convert mask to alpha with a fake node
    // TODO: refactor out apply from feColorMatrix

    new FeColorMatrixElement(document, {
      nodeType: 1,
      childNodes: [],
      attributes: [{
        nodeName: 'type',
        value: 'luminanceToAlpha'
      }, {
        nodeName: 'includeOpacity',
        value: 'true'
      }]
    }).apply(maskCtx, 0, 0, x + width, y + height);
    var tmpCanvas = document.createCanvas(x + width, y + height);
    var tmpCtx = tmpCanvas.getContext('2d');
    document.screen.setDefaults(tmpCtx);
    element.render(tmpCtx);
    tmpCtx.globalCompositeOperation = 'destination-in';
    tmpCtx.fillStyle = maskCtx.createPattern(maskCanvas, 'no-repeat');
    tmpCtx.fillRect(0, 0, x + width, y + height);
    ctx.fillStyle = tmpCtx.createPattern(tmpCanvas, 'no-repeat');
    ctx.fillRect(0, 0, x + width, y + height); // reassign mask

    this.restoreStyles(element, ignoredStyles);
  }

  render(_) {// NO RENDER
  }

}
MaskElement.ignoreStyles = ['mask', 'transform', 'clip-path'];

var noop$1 = () => {// NOOP
};

class ClipPathElement extends Element$1 {
  constructor() {
    super(...arguments);
    this.type = 'clipPath';
  }

  apply(ctx) {
    var {
      document
    } = this;
    var contextProto = Reflect.getPrototypeOf(ctx);
    var {
      beginPath,
      closePath
    } = ctx;

    if (contextProto) {
      contextProto.beginPath = noop$1;
      contextProto.closePath = noop$1;
    }

    Reflect.apply(beginPath, ctx, []);
    this.children.forEach(child => {
      if (typeof child.path === 'undefined') {
        return;
      }

      var transform = typeof child.elementTransform !== 'undefined' ? child.elementTransform() : null; // handle <use />

      if (!transform) {
        transform = Transform.fromElement(document, child);
      }

      if (transform) {
        transform.apply(ctx);
      }

      child.path(ctx);

      if (contextProto) {
        contextProto.closePath = closePath;
      }

      if (transform) {
        transform.unapply(ctx);
      }
    });
    Reflect.apply(closePath, ctx, []);
    ctx.clip();

    if (contextProto) {
      contextProto.beginPath = beginPath;
      contextProto.closePath = closePath;
    }
  }

  render(_) {// NO RENDER
  }

}

class FilterElement extends Element$1 {
  constructor() {
    super(...arguments);
    this.type = 'filter';
  }

  apply(ctx, element) {
    // render as temp svg
    var {
      document,
      children
    } = this;
    var boundingBox = element.getBoundingBox(ctx);

    if (!boundingBox) {
      return;
    }

    var px = 0;
    var py = 0;
    children.forEach(child => {
      var efd = child.extraFilterDistance || 0;
      px = Math.max(px, efd);
      py = Math.max(py, efd);
    });
    var width = Math.floor(boundingBox.width);
    var height = Math.floor(boundingBox.height);
    var tmpCanvasWidth = width + 2 * px;
    var tmpCanvasHeight = height + 2 * py;

    if (tmpCanvasWidth < 1 || tmpCanvasHeight < 1) {
      return;
    }

    var x = Math.floor(boundingBox.x);
    var y = Math.floor(boundingBox.y);
    var ignoredStyles = this.removeStyles(element, FilterElement.ignoreStyles);
    var tmpCanvas = document.createCanvas(tmpCanvasWidth, tmpCanvasHeight);
    var tmpCtx = tmpCanvas.getContext('2d');
    document.screen.setDefaults(tmpCtx);
    tmpCtx.translate(-x + px, -y + py);
    element.render(tmpCtx); // apply filters

    children.forEach(child => {
      if (typeof child.apply === 'function') {
        child.apply(tmpCtx, 0, 0, tmpCanvasWidth, tmpCanvasHeight);
      }
    }); // render on me

    ctx.drawImage(tmpCanvas, 0, 0, tmpCanvasWidth, tmpCanvasHeight, x - px, y - py, tmpCanvasWidth, tmpCanvasHeight);
    this.restoreStyles(element, ignoredStyles);
  }

  render(_) {// NO RENDER
  }

}
FilterElement.ignoreStyles = ['filter', 'transform', 'clip-path'];

class FeDropShadowElement extends Element$1 {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'feDropShadow';
    this.addStylesFromStyleDefinition();
  }

  apply(_, _x, _y, _width, _height) {// TODO: implement
  }

}

class FeMorphologyElement extends Element$1 {
  constructor() {
    super(...arguments);
    this.type = 'feMorphology';
  }

  apply(_, _x, _y, _width, _height) {// TODO: implement
  }

}

class FeCompositeElement extends Element$1 {
  constructor() {
    super(...arguments);
    this.type = 'feComposite';
  }

  apply(_, _x, _y, _width, _height) {// TODO: implement
  }

}

class FeGaussianBlurElement extends Element$1 {
  constructor(document, node, captureTextNodes) {
    super(document, node, captureTextNodes);
    this.type = 'feGaussianBlur';
    this.blurRadius = Math.floor(this.getAttribute('stdDeviation').getNumber());
    this.extraFilterDistance = this.blurRadius;
  }

  apply(ctx, x, y, width, height) {
    var {
      document,
      blurRadius
    } = this;
    var body = document.window ? document.window.document.body : null;
    var canvas = ctx.canvas; // StackBlur requires canvas be on document

    canvas.id = document.getUniqueId();

    if (body) {
      canvas.style.display = 'none';
      body.appendChild(canvas);
    }

    processCanvasRGBA(canvas, x, y, width, height, blurRadius);

    if (body) {
      body.removeChild(canvas);
    }
  }

}

class TitleElement extends Element$1 {
  constructor() {
    super(...arguments);
    this.type = 'title';
  }

}

class DescElement extends Element$1 {
  constructor() {
    super(...arguments);
    this.type = 'desc';
  }

}

var elements = {
  'svg': SVGElement,
  'rect': RectElement,
  'circle': CircleElement,
  'ellipse': EllipseElement,
  'line': LineElement,
  'polyline': PolylineElement,
  'polygon': PolygonElement,
  'path': PathElement,
  'pattern': PatternElement,
  'marker': MarkerElement,
  'defs': DefsElement,
  'linearGradient': LinearGradientElement,
  'radialGradient': RadialGradientElement,
  'stop': StopElement,
  'animate': AnimateElement,
  'animateColor': AnimateColorElement,
  'animateTransform': AnimateTransformElement,
  'font': FontElement,
  'font-face': FontFaceElement,
  'missing-glyph': MissingGlyphElement,
  'glyph': GlyphElement,
  'text': TextElement,
  'tspan': TSpanElement,
  'tref': TRefElement,
  'a': AElement,
  'textPath': TextPathElement,
  'image': ImageElement,
  'g': GElement,
  'symbol': SymbolElement,
  'style': StyleElement,
  'use': UseElement,
  'mask': MaskElement,
  'clipPath': ClipPathElement,
  'filter': FilterElement,
  'feDropShadow': FeDropShadowElement,
  'feMorphology': FeMorphologyElement,
  'feComposite': FeCompositeElement,
  'feColorMatrix': FeColorMatrixElement,
  'feGaussianBlur': FeGaussianBlurElement,
  'title': TitleElement,
  'desc': DescElement
};

function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function createCanvas(width, height) {
  var canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  return canvas;
}

function createImage(_x) {
  return _createImage.apply(this, arguments);
}

function _createImage() {
  _createImage = _asyncToGenerator$1(function* (src) {
    var anonymousCrossOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var image = document.createElement('img');

    if (anonymousCrossOrigin) {
      image.crossOrigin = 'Anonymous';
    }

    return new Promise((resolve, reject) => {
      image.onload = () => {
        resolve(image);
      };

      image.onerror = (_event, _source, _lineno, _colno, error) => {
        reject(error);
      };

      image.src = src;
    });
  });
  return _createImage.apply(this, arguments);
}

class Document {
  constructor(canvg) {
    var {
      rootEmSize = 12,
      emSize = 12,
      createCanvas = Document.createCanvas,
      createImage = Document.createImage,
      anonymousCrossOrigin
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.canvg = canvg;
    this.definitions = {};
    this.styles = {};
    this.stylesSpecificity = {};
    this.images = [];
    this.fonts = [];
    this.emSizeStack = [];
    this.uniqueId = 0;
    this.screen = canvg.screen;
    this.rootEmSize = rootEmSize;
    this.emSize = emSize;
    this.createCanvas = createCanvas;
    this.createImage = this.bindCreateImage(createImage, anonymousCrossOrigin);
    this.screen.wait(this.isImagesLoaded.bind(this));
    this.screen.wait(this.isFontsLoaded.bind(this));
  }

  bindCreateImage(createImage, anonymousCrossOrigin) {
    if (typeof anonymousCrossOrigin === 'boolean') {
      return (source, forceAnonymousCrossOrigin) => createImage(source, typeof forceAnonymousCrossOrigin === 'boolean' ? forceAnonymousCrossOrigin : anonymousCrossOrigin);
    }

    return createImage;
  }

  get window() {
    return this.screen.window;
  }

  get fetch() {
    return this.screen.fetch;
  }

  get ctx() {
    return this.screen.ctx;
  }

  get emSize() {
    var {
      emSizeStack
    } = this;
    return emSizeStack[emSizeStack.length - 1];
  }

  set emSize(value) {
    var {
      emSizeStack
    } = this;
    emSizeStack.push(value);
  }

  popEmSize() {
    var {
      emSizeStack
    } = this;
    emSizeStack.pop();
  }

  getUniqueId() {
    return "canvg".concat(++this.uniqueId);
  }

  isImagesLoaded() {
    return this.images.every(_ => _.loaded);
  }

  isFontsLoaded() {
    return this.fonts.every(_ => _.loaded);
  }

  createDocumentElement(document) {
    var documentElement = this.createElement(document.documentElement);
    documentElement.root = true;
    documentElement.addStylesFromStyleDefinition();
    this.documentElement = documentElement;
    return documentElement;
  }

  createElement(node) {
    var elementType = node.nodeName.replace(/^[^:]+:/, '');
    var ElementType = Document.elementTypes[elementType];

    if (typeof ElementType !== 'undefined') {
      return new ElementType(this, node);
    }

    return new UnknownElement(this, node);
  }

  createTextNode(node) {
    return new TextNode(this, node);
  }

  setViewBox(config) {
    this.screen.setViewBox(_objectSpread$1$1({
      document: this
    }, config));
  }

}
Document.createCanvas = createCanvas;
Document.createImage = createImage;
Document.elementTypes = elements;

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * SVG renderer on canvas.
 */

class Canvg {
  /**
   * Main constructor.
   * @param ctx - Rendering context.
   * @param svg - SVG Document.
   * @param options - Rendering options.
   */
  constructor(ctx, svg) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    this.parser = new Parser(options);
    this.screen = new Screen(ctx, options);
    this.options = options;
    var document = new Document(this, options);
    var documentElement = document.createDocumentElement(svg);
    this.document = document;
    this.documentElement = documentElement;
  }
  /**
   * Create Canvg instance from SVG source string or URL.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */


  static from(ctx, svg) {
    var _arguments = arguments;
    return _asyncToGenerator$1(function* () {
      var options = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};
      var parser = new Parser(options);
      var svgDocument = yield parser.parse(svg);
      return new Canvg(ctx, svgDocument, options);
    })();
  }
  /**
   * Create Canvg instance from SVG source string.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */


  static fromString(ctx, svg) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var parser = new Parser(options);
    var svgDocument = parser.parseFromString(svg);
    return new Canvg(ctx, svgDocument, options);
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */


  fork(ctx, svg) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return Canvg.from(ctx, svg, _objectSpread$6(_objectSpread$6({}, this.options), options));
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */


  forkString(ctx, svg) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return Canvg.fromString(ctx, svg, _objectSpread$6(_objectSpread$6({}, this.options), options));
  }
  /**
   * Document is ready promise.
   * @returns Ready promise.
   */


  ready() {
    return this.screen.ready();
  }
  /**
   * Document is ready value.
   * @returns Is ready or not.
   */


  isReady() {
    return this.screen.isReady();
  }
  /**
   * Render only first frame, ignoring animations and mouse.
   * @param options - Rendering options.
   */


  render() {
    var _arguments2 = arguments,
        _this = this;

    return _asyncToGenerator$1(function* () {
      var options = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};

      _this.start(_objectSpread$6({
        enableRedraw: true,
        ignoreAnimation: true,
        ignoreMouse: true
      }, options));

      yield _this.ready();

      _this.stop();
    })();
  }
  /**
   * Start rendering.
   * @param options - Render options.
   */


  start() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var {
      documentElement,
      screen,
      options: baseOptions
    } = this;
    screen.start(documentElement, _objectSpread$6(_objectSpread$6({
      enableRedraw: true
    }, baseOptions), options));
  }
  /**
   * Stop rendering.
   */


  stop() {
    this.screen.stop();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */


  resize(width) {
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
    var preserveAspectRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    this.documentElement.resize(width, height, preserveAspectRatio);
  }

}

var index_es = /*#__PURE__*/Object.freeze({
	__proto__: null,
	AElement: AElement,
	AnimateColorElement: AnimateColorElement,
	AnimateElement: AnimateElement,
	AnimateTransformElement: AnimateTransformElement,
	BoundingBox: BoundingBox,
	CB1: CB1,
	CB2: CB2,
	CB3: CB3,
	CB4: CB4,
	Canvg: Canvg,
	CircleElement: CircleElement,
	ClipPathElement: ClipPathElement,
	DefsElement: DefsElement,
	DescElement: DescElement,
	Document: Document,
	Element: Element$1,
	EllipseElement: EllipseElement,
	FeColorMatrixElement: FeColorMatrixElement,
	FeCompositeElement: FeCompositeElement,
	FeDropShadowElement: FeDropShadowElement,
	FeGaussianBlurElement: FeGaussianBlurElement,
	FeMorphologyElement: FeMorphologyElement,
	FilterElement: FilterElement,
	Font: Font,
	FontElement: FontElement,
	FontFaceElement: FontFaceElement,
	GElement: GElement,
	GlyphElement: GlyphElement,
	GradientElement: GradientElement,
	ImageElement: ImageElement,
	LineElement: LineElement,
	LinearGradientElement: LinearGradientElement,
	MarkerElement: MarkerElement,
	MaskElement: MaskElement,
	Matrix: Matrix,
	MissingGlyphElement: MissingGlyphElement,
	Mouse: Mouse,
	PSEUDO_ZERO: PSEUDO_ZERO,
	Parser: Parser,
	PathElement: PathElement,
	PathParser: PathParser,
	PatternElement: PatternElement,
	Point: Point,
	PolygonElement: PolygonElement,
	PolylineElement: PolylineElement,
	Property: Property,
	QB1: QB1,
	QB2: QB2,
	QB3: QB3,
	RadialGradientElement: RadialGradientElement,
	RectElement: RectElement,
	RenderedElement: RenderedElement,
	Rotate: Rotate,
	SVGElement: SVGElement,
	SVGFontLoader: SVGFontLoader,
	Scale: Scale,
	Screen: Screen,
	Skew: Skew,
	SkewX: SkewX,
	SkewY: SkewY,
	StopElement: StopElement,
	StyleElement: StyleElement,
	SymbolElement: SymbolElement,
	TRefElement: TRefElement,
	TSpanElement: TSpanElement,
	TextElement: TextElement,
	TextPathElement: TextPathElement,
	TitleElement: TitleElement,
	Transform: Transform,
	Translate: Translate,
	UnknownElement: UnknownElement,
	UseElement: UseElement,
	ViewPort: ViewPort,
	compressSpaces: compressSpaces,
	'default': Canvg,
	getSelectorSpecificity: getSelectorSpecificity,
	normalizeAttributeName: normalizeAttributeName,
	normalizeColor: normalizeColor,
	parseExternalUrl: parseExternalUrl,
	presets: index,
	toNumbers: toNumbers,
	trimLeft: trimLeft,
	trimRight: trimRight,
	vectorMagnitude: vectorMagnitude,
	vectorsAngle: vectorsAngle,
	vectorsRatio: vectorsRatio
});

export { Analytics, AxiosConfig, callouts as CalloutsService, CommentService, Cookies, DatesUtils, Formatting, NotificationsService, Product, ReusableData, SourceService, Threeflow, Threeflow as WatchtowerBenefits };
//# sourceMappingURL=watchtower-shared-components.js.map
